
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire86be"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire86be"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9h2J6", function(module, exports) {
'use strict';

module.exports = (parcelRequire("IpDOK"));

});
parcelRegister("IpDOK", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $0857fffcc6080325$export$ffb0004e005737fa; }, function (v) { return $0857fffcc6080325$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $0857fffcc6080325$export$34b9dba7ce09269b; }, function (v) { return $0857fffcc6080325$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $0857fffcc6080325$export$25062201e9e25d76; }, function (v) { return $0857fffcc6080325$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0857fffcc6080325$export$ffb0004e005737fa;
var $0857fffcc6080325$export$34b9dba7ce09269b;
var $0857fffcc6080325$export$25062201e9e25d76;
'use strict';

var $7RNO0 = parcelRequire("7RNO0");
var $0857fffcc6080325$var$k = Symbol.for("react.element"), $0857fffcc6080325$var$l = Symbol.for("react.fragment"), $0857fffcc6080325$var$m = Object.prototype.hasOwnProperty, $0857fffcc6080325$var$n = $7RNO0.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0857fffcc6080325$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0857fffcc6080325$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0857fffcc6080325$var$m.call(a, b) && !$0857fffcc6080325$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0857fffcc6080325$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0857fffcc6080325$var$n.current
    };
}
$0857fffcc6080325$export$ffb0004e005737fa = $0857fffcc6080325$var$l;
$0857fffcc6080325$export$34b9dba7ce09269b = $0857fffcc6080325$var$q;
$0857fffcc6080325$export$25062201e9e25d76 = $0857fffcc6080325$var$q;

});
parcelRegister("7RNO0", function(module, exports) {
'use strict';

module.exports = (parcelRequire("5KIkg"));

});
parcelRegister("5KIkg", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $4303a1d688c3fca5$export$dca3b0875bd9a954; }, function (v) { return $4303a1d688c3fca5$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $4303a1d688c3fca5$export$16fa2f45be04daa8; }, function (v) { return $4303a1d688c3fca5$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $4303a1d688c3fca5$export$ffb0004e005737fa; }, function (v) { return $4303a1d688c3fca5$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $4303a1d688c3fca5$export$e2c29f18771995cb; }, function (v) { return $4303a1d688c3fca5$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $4303a1d688c3fca5$export$221d75b3f55bb0bd; }, function (v) { return $4303a1d688c3fca5$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $4303a1d688c3fca5$export$5f8d39834fd61797; }, function (v) { return $4303a1d688c3fca5$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $4303a1d688c3fca5$export$74bf444e3cd11ea5; }, function (v) { return $4303a1d688c3fca5$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $4303a1d688c3fca5$export$ae55be85d98224ed; }, function (v) { return $4303a1d688c3fca5$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $4303a1d688c3fca5$export$3ba232387fd5d6dd; }, function (v) { return $4303a1d688c3fca5$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $4303a1d688c3fca5$export$e530037191fcd5d7; }, function (v) { return $4303a1d688c3fca5$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $4303a1d688c3fca5$export$fd42f52fd3ae1109; }, function (v) { return $4303a1d688c3fca5$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $4303a1d688c3fca5$export$c8a8987d4410bf2d; }, function (v) { return $4303a1d688c3fca5$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $4303a1d688c3fca5$export$d38cd72104c1f0e9; }, function (v) { return $4303a1d688c3fca5$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $4303a1d688c3fca5$export$7d1e3a5e95ceca43; }, function (v) { return $4303a1d688c3fca5$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $4303a1d688c3fca5$export$257a8862b851cb5b; }, function (v) { return $4303a1d688c3fca5$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $4303a1d688c3fca5$export$a8257692ac88316c; }, function (v) { return $4303a1d688c3fca5$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $4303a1d688c3fca5$export$488013bae63b21da; }, function (v) { return $4303a1d688c3fca5$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $4303a1d688c3fca5$export$7c73462e0d25e514; }, function (v) { return $4303a1d688c3fca5$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $4303a1d688c3fca5$export$7568632d0d33d16d; }, function (v) { return $4303a1d688c3fca5$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $4303a1d688c3fca5$export$88948ce120ea2619; }, function (v) { return $4303a1d688c3fca5$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $4303a1d688c3fca5$export$35808ee640e87ca7; }, function (v) { return $4303a1d688c3fca5$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $4303a1d688c3fca5$export$fae74005e78b1a27; }, function (v) { return $4303a1d688c3fca5$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $4303a1d688c3fca5$export$dc8fbce3eb94dc1e; }, function (v) { return $4303a1d688c3fca5$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $4303a1d688c3fca5$export$6a7bc4e911dc01cf; }, function (v) { return $4303a1d688c3fca5$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $4303a1d688c3fca5$export$6d9c69b0de29b591; }, function (v) { return $4303a1d688c3fca5$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $4303a1d688c3fca5$export$f680877a34711e37; }, function (v) { return $4303a1d688c3fca5$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $4303a1d688c3fca5$export$d5a552a76deda3c2; }, function (v) { return $4303a1d688c3fca5$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $4303a1d688c3fca5$export$aaabe4eda9ed9969; }, function (v) { return $4303a1d688c3fca5$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $4303a1d688c3fca5$export$e5c5a5f917a5871c; }, function (v) { return $4303a1d688c3fca5$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $4303a1d688c3fca5$export$1538c33de8887b59; }, function (v) { return $4303a1d688c3fca5$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $4303a1d688c3fca5$export$13e3392192263954; }, function (v) { return $4303a1d688c3fca5$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $4303a1d688c3fca5$export$b8f5890fc79d6aca; }, function (v) { return $4303a1d688c3fca5$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $4303a1d688c3fca5$export$60241385465d0a34; }, function (v) { return $4303a1d688c3fca5$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $4303a1d688c3fca5$export$306c0aa65ff9ec16; }, function (v) { return $4303a1d688c3fca5$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $4303a1d688c3fca5$export$7b286972b8d8ccbf; }, function (v) { return $4303a1d688c3fca5$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $4303a1d688c3fca5$export$83d89fbfd8236492; }, function (v) { return $4303a1d688c3fca5$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4303a1d688c3fca5$export$dca3b0875bd9a954;
var $4303a1d688c3fca5$export$16fa2f45be04daa8;
var $4303a1d688c3fca5$export$ffb0004e005737fa;
var $4303a1d688c3fca5$export$e2c29f18771995cb;
var $4303a1d688c3fca5$export$221d75b3f55bb0bd;
var $4303a1d688c3fca5$export$5f8d39834fd61797;
var $4303a1d688c3fca5$export$74bf444e3cd11ea5;
var $4303a1d688c3fca5$export$ae55be85d98224ed;
var $4303a1d688c3fca5$export$3ba232387fd5d6dd;
var $4303a1d688c3fca5$export$e530037191fcd5d7;
var $4303a1d688c3fca5$export$fd42f52fd3ae1109;
var $4303a1d688c3fca5$export$c8a8987d4410bf2d;
var $4303a1d688c3fca5$export$d38cd72104c1f0e9;
var $4303a1d688c3fca5$export$7d1e3a5e95ceca43;
var $4303a1d688c3fca5$export$257a8862b851cb5b;
var $4303a1d688c3fca5$export$a8257692ac88316c;
var $4303a1d688c3fca5$export$488013bae63b21da;
var $4303a1d688c3fca5$export$7c73462e0d25e514;
var $4303a1d688c3fca5$export$7568632d0d33d16d;
var $4303a1d688c3fca5$export$88948ce120ea2619;
var $4303a1d688c3fca5$export$35808ee640e87ca7;
var $4303a1d688c3fca5$export$fae74005e78b1a27;
var $4303a1d688c3fca5$export$dc8fbce3eb94dc1e;
var $4303a1d688c3fca5$export$6a7bc4e911dc01cf;
var $4303a1d688c3fca5$export$6d9c69b0de29b591;
var $4303a1d688c3fca5$export$f680877a34711e37;
var $4303a1d688c3fca5$export$d5a552a76deda3c2;
var $4303a1d688c3fca5$export$aaabe4eda9ed9969;
var $4303a1d688c3fca5$export$e5c5a5f917a5871c;
var $4303a1d688c3fca5$export$1538c33de8887b59;
var $4303a1d688c3fca5$export$13e3392192263954;
var $4303a1d688c3fca5$export$b8f5890fc79d6aca;
var $4303a1d688c3fca5$export$60241385465d0a34;
var $4303a1d688c3fca5$export$306c0aa65ff9ec16;
var $4303a1d688c3fca5$export$7b286972b8d8ccbf;
var $4303a1d688c3fca5$export$83d89fbfd8236492;
'use strict';
var $4303a1d688c3fca5$var$l = Symbol.for("react.element"), $4303a1d688c3fca5$var$n = Symbol.for("react.portal"), $4303a1d688c3fca5$var$p = Symbol.for("react.fragment"), $4303a1d688c3fca5$var$q = Symbol.for("react.strict_mode"), $4303a1d688c3fca5$var$r = Symbol.for("react.profiler"), $4303a1d688c3fca5$var$t = Symbol.for("react.provider"), $4303a1d688c3fca5$var$u = Symbol.for("react.context"), $4303a1d688c3fca5$var$v = Symbol.for("react.forward_ref"), $4303a1d688c3fca5$var$w = Symbol.for("react.suspense"), $4303a1d688c3fca5$var$x = Symbol.for("react.memo"), $4303a1d688c3fca5$var$y = Symbol.for("react.lazy"), $4303a1d688c3fca5$var$z = Symbol.iterator;
function $4303a1d688c3fca5$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $4303a1d688c3fca5$var$z && a[$4303a1d688c3fca5$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $4303a1d688c3fca5$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $4303a1d688c3fca5$var$C = Object.assign, $4303a1d688c3fca5$var$D = {};
function $4303a1d688c3fca5$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $4303a1d688c3fca5$var$D;
    this.updater = e || $4303a1d688c3fca5$var$B;
}
$4303a1d688c3fca5$var$E.prototype.isReactComponent = {};
$4303a1d688c3fca5$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$4303a1d688c3fca5$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $4303a1d688c3fca5$var$F() {}
$4303a1d688c3fca5$var$F.prototype = $4303a1d688c3fca5$var$E.prototype;
function $4303a1d688c3fca5$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $4303a1d688c3fca5$var$D;
    this.updater = e || $4303a1d688c3fca5$var$B;
}
var $4303a1d688c3fca5$var$H = $4303a1d688c3fca5$var$G.prototype = new $4303a1d688c3fca5$var$F;
$4303a1d688c3fca5$var$H.constructor = $4303a1d688c3fca5$var$G;
$4303a1d688c3fca5$var$C($4303a1d688c3fca5$var$H, $4303a1d688c3fca5$var$E.prototype);
$4303a1d688c3fca5$var$H.isPureReactComponent = !0;
var $4303a1d688c3fca5$var$I = Array.isArray, $4303a1d688c3fca5$var$J = Object.prototype.hasOwnProperty, $4303a1d688c3fca5$var$K = {
    current: null
}, $4303a1d688c3fca5$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $4303a1d688c3fca5$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$4303a1d688c3fca5$var$J.call(b, d) && !$4303a1d688c3fca5$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $4303a1d688c3fca5$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $4303a1d688c3fca5$var$K.current
    };
}
function $4303a1d688c3fca5$var$N(a, b) {
    return {
        $$typeof: $4303a1d688c3fca5$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $4303a1d688c3fca5$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $4303a1d688c3fca5$var$l;
}
function $4303a1d688c3fca5$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $4303a1d688c3fca5$var$P = /\/+/g;
function $4303a1d688c3fca5$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $4303a1d688c3fca5$var$escape("" + a.key) : b.toString(36);
}
function $4303a1d688c3fca5$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $4303a1d688c3fca5$var$l:
                case $4303a1d688c3fca5$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $4303a1d688c3fca5$var$Q(h, 0) : d, $4303a1d688c3fca5$var$I(c) ? (e = "", null != a && (e = a.replace($4303a1d688c3fca5$var$P, "$&/") + "/"), $4303a1d688c3fca5$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($4303a1d688c3fca5$var$O(c) && (c = $4303a1d688c3fca5$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($4303a1d688c3fca5$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($4303a1d688c3fca5$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $4303a1d688c3fca5$var$Q(k, g);
        h += $4303a1d688c3fca5$var$R(k, b, e, f, c);
    }
    else if (f = $4303a1d688c3fca5$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $4303a1d688c3fca5$var$Q(k, g++), h += $4303a1d688c3fca5$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $4303a1d688c3fca5$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $4303a1d688c3fca5$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $4303a1d688c3fca5$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $4303a1d688c3fca5$var$U = {
    current: null
}, $4303a1d688c3fca5$var$V = {
    transition: null
}, $4303a1d688c3fca5$var$W = {
    ReactCurrentDispatcher: $4303a1d688c3fca5$var$U,
    ReactCurrentBatchConfig: $4303a1d688c3fca5$var$V,
    ReactCurrentOwner: $4303a1d688c3fca5$var$K
};
function $4303a1d688c3fca5$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$4303a1d688c3fca5$export$dca3b0875bd9a954 = {
    map: $4303a1d688c3fca5$var$S,
    forEach: function(a, b, e) {
        $4303a1d688c3fca5$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $4303a1d688c3fca5$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $4303a1d688c3fca5$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$4303a1d688c3fca5$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$4303a1d688c3fca5$export$16fa2f45be04daa8 = $4303a1d688c3fca5$var$E;
$4303a1d688c3fca5$export$ffb0004e005737fa = $4303a1d688c3fca5$var$p;
$4303a1d688c3fca5$export$e2c29f18771995cb = $4303a1d688c3fca5$var$r;
$4303a1d688c3fca5$export$221d75b3f55bb0bd = $4303a1d688c3fca5$var$G;
$4303a1d688c3fca5$export$5f8d39834fd61797 = $4303a1d688c3fca5$var$q;
$4303a1d688c3fca5$export$74bf444e3cd11ea5 = $4303a1d688c3fca5$var$w;
$4303a1d688c3fca5$export$ae55be85d98224ed = $4303a1d688c3fca5$var$W;
$4303a1d688c3fca5$export$3ba232387fd5d6dd = $4303a1d688c3fca5$var$X;
$4303a1d688c3fca5$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $4303a1d688c3fca5$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $4303a1d688c3fca5$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$4303a1d688c3fca5$var$J.call(b, f) && !$4303a1d688c3fca5$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $4303a1d688c3fca5$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$4303a1d688c3fca5$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $4303a1d688c3fca5$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $4303a1d688c3fca5$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$4303a1d688c3fca5$export$c8a8987d4410bf2d = $4303a1d688c3fca5$var$M;
$4303a1d688c3fca5$export$d38cd72104c1f0e9 = function(a) {
    var b = $4303a1d688c3fca5$var$M.bind(null, a);
    b.type = a;
    return b;
};
$4303a1d688c3fca5$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$4303a1d688c3fca5$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $4303a1d688c3fca5$var$v,
        render: a
    };
};
$4303a1d688c3fca5$export$a8257692ac88316c = $4303a1d688c3fca5$var$O;
$4303a1d688c3fca5$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $4303a1d688c3fca5$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $4303a1d688c3fca5$var$T
    };
};
$4303a1d688c3fca5$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $4303a1d688c3fca5$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$4303a1d688c3fca5$export$7568632d0d33d16d = function(a) {
    var b = $4303a1d688c3fca5$var$V.transition;
    $4303a1d688c3fca5$var$V.transition = {};
    try {
        a();
    } finally{
        $4303a1d688c3fca5$var$V.transition = b;
    }
};
$4303a1d688c3fca5$export$88948ce120ea2619 = $4303a1d688c3fca5$var$X;
$4303a1d688c3fca5$export$35808ee640e87ca7 = function(a, b) {
    return $4303a1d688c3fca5$var$U.current.useCallback(a, b);
};
$4303a1d688c3fca5$export$fae74005e78b1a27 = function(a) {
    return $4303a1d688c3fca5$var$U.current.useContext(a);
};
$4303a1d688c3fca5$export$dc8fbce3eb94dc1e = function() {};
$4303a1d688c3fca5$export$6a7bc4e911dc01cf = function(a) {
    return $4303a1d688c3fca5$var$U.current.useDeferredValue(a);
};
$4303a1d688c3fca5$export$6d9c69b0de29b591 = function(a, b) {
    return $4303a1d688c3fca5$var$U.current.useEffect(a, b);
};
$4303a1d688c3fca5$export$f680877a34711e37 = function() {
    return $4303a1d688c3fca5$var$U.current.useId();
};
$4303a1d688c3fca5$export$d5a552a76deda3c2 = function(a, b, e) {
    return $4303a1d688c3fca5$var$U.current.useImperativeHandle(a, b, e);
};
$4303a1d688c3fca5$export$aaabe4eda9ed9969 = function(a, b) {
    return $4303a1d688c3fca5$var$U.current.useInsertionEffect(a, b);
};
$4303a1d688c3fca5$export$e5c5a5f917a5871c = function(a, b) {
    return $4303a1d688c3fca5$var$U.current.useLayoutEffect(a, b);
};
$4303a1d688c3fca5$export$1538c33de8887b59 = function(a, b) {
    return $4303a1d688c3fca5$var$U.current.useMemo(a, b);
};
$4303a1d688c3fca5$export$13e3392192263954 = function(a, b, e) {
    return $4303a1d688c3fca5$var$U.current.useReducer(a, b, e);
};
$4303a1d688c3fca5$export$b8f5890fc79d6aca = function(a) {
    return $4303a1d688c3fca5$var$U.current.useRef(a);
};
$4303a1d688c3fca5$export$60241385465d0a34 = function(a) {
    return $4303a1d688c3fca5$var$U.current.useState(a);
};
$4303a1d688c3fca5$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $4303a1d688c3fca5$var$U.current.useSyncExternalStore(a, b, e);
};
$4303a1d688c3fca5$export$7b286972b8d8ccbf = function() {
    return $4303a1d688c3fca5$var$U.current.useTransition();
};
$4303a1d688c3fca5$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("lPo4y", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $fe4108adad250e9a$export$ae55be85d98224ed; }, function (v) { return $fe4108adad250e9a$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $fe4108adad250e9a$export$d39a5bbd09211389; }, function (v) { return $fe4108adad250e9a$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $fe4108adad250e9a$export$882461b6382ed46c; }, function (v) { return $fe4108adad250e9a$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $fe4108adad250e9a$export$466bfc07425424d5; }, function (v) { return $fe4108adad250e9a$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $fe4108adad250e9a$export$cd75ccfd720a3cd4; }, function (v) { return $fe4108adad250e9a$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $fe4108adad250e9a$export$fa8d919ba61d84db; }, function (v) { return $fe4108adad250e9a$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $fe4108adad250e9a$export$757ceba2d55c277e; }, function (v) { return $fe4108adad250e9a$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $fe4108adad250e9a$export$b3890eb0ae9dca99; }, function (v) { return $fe4108adad250e9a$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $fe4108adad250e9a$export$502457920280e6be; }, function (v) { return $fe4108adad250e9a$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $fe4108adad250e9a$export$c78a37762a8d58e1; }, function (v) { return $fe4108adad250e9a$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $fe4108adad250e9a$export$dc54d992c10e8a18; }, function (v) { return $fe4108adad250e9a$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $fe4108adad250e9a$export$83d89fbfd8236492; }, function (v) { return $fe4108adad250e9a$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $fe4108adad250e9a$export$ae55be85d98224ed;
var $fe4108adad250e9a$export$d39a5bbd09211389;
var $fe4108adad250e9a$export$882461b6382ed46c;
var $fe4108adad250e9a$export$466bfc07425424d5;
var $fe4108adad250e9a$export$cd75ccfd720a3cd4;
var $fe4108adad250e9a$export$fa8d919ba61d84db;
var $fe4108adad250e9a$export$757ceba2d55c277e;
var $fe4108adad250e9a$export$b3890eb0ae9dca99;
var $fe4108adad250e9a$export$502457920280e6be;
var $fe4108adad250e9a$export$c78a37762a8d58e1;
var $fe4108adad250e9a$export$dc54d992c10e8a18;
var $fe4108adad250e9a$export$83d89fbfd8236492;
'use strict';

var $7RNO0 = parcelRequire("7RNO0");

var $eq2VS = parcelRequire("eq2VS");
function $fe4108adad250e9a$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $fe4108adad250e9a$var$da = new Set, $fe4108adad250e9a$var$ea = {};
function $fe4108adad250e9a$var$fa(a, b) {
    $fe4108adad250e9a$var$ha(a, b);
    $fe4108adad250e9a$var$ha(a + "Capture", b);
}
function $fe4108adad250e9a$var$ha(a, b) {
    $fe4108adad250e9a$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$fe4108adad250e9a$var$da.add(b[a]);
}
var $fe4108adad250e9a$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $fe4108adad250e9a$var$ja = Object.prototype.hasOwnProperty, $fe4108adad250e9a$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $fe4108adad250e9a$var$la = {}, $fe4108adad250e9a$var$ma = {};
function $fe4108adad250e9a$var$oa(a) {
    if ($fe4108adad250e9a$var$ja.call($fe4108adad250e9a$var$ma, a)) return !0;
    if ($fe4108adad250e9a$var$ja.call($fe4108adad250e9a$var$la, a)) return !1;
    if ($fe4108adad250e9a$var$ka.test(a)) return $fe4108adad250e9a$var$ma[a] = !0;
    $fe4108adad250e9a$var$la[a] = !0;
    return !1;
}
function $fe4108adad250e9a$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $fe4108adad250e9a$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $fe4108adad250e9a$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $fe4108adad250e9a$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $fe4108adad250e9a$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $fe4108adad250e9a$var$z[a] = new $fe4108adad250e9a$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $fe4108adad250e9a$var$z[b] = new $fe4108adad250e9a$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $fe4108adad250e9a$var$z[a] = new $fe4108adad250e9a$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $fe4108adad250e9a$var$z[a] = new $fe4108adad250e9a$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $fe4108adad250e9a$var$z[a] = new $fe4108adad250e9a$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $fe4108adad250e9a$var$z[a] = new $fe4108adad250e9a$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $fe4108adad250e9a$var$z[a] = new $fe4108adad250e9a$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $fe4108adad250e9a$var$z[a] = new $fe4108adad250e9a$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $fe4108adad250e9a$var$z[a] = new $fe4108adad250e9a$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $fe4108adad250e9a$var$ra = /[\-:]([a-z])/g;
function $fe4108adad250e9a$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($fe4108adad250e9a$var$ra, $fe4108adad250e9a$var$sa);
    $fe4108adad250e9a$var$z[b] = new $fe4108adad250e9a$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($fe4108adad250e9a$var$ra, $fe4108adad250e9a$var$sa);
    $fe4108adad250e9a$var$z[b] = new $fe4108adad250e9a$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($fe4108adad250e9a$var$ra, $fe4108adad250e9a$var$sa);
    $fe4108adad250e9a$var$z[b] = new $fe4108adad250e9a$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $fe4108adad250e9a$var$z[a] = new $fe4108adad250e9a$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$fe4108adad250e9a$var$z.xlinkHref = new $fe4108adad250e9a$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $fe4108adad250e9a$var$z[a] = new $fe4108adad250e9a$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $fe4108adad250e9a$var$ta(a, b, c, d) {
    var e = $fe4108adad250e9a$var$z.hasOwnProperty(b) ? $fe4108adad250e9a$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $fe4108adad250e9a$var$qa(b, c, e, d) && (c = null), d || null === e ? $fe4108adad250e9a$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $fe4108adad250e9a$var$ua = $7RNO0.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $fe4108adad250e9a$var$va = Symbol.for("react.element"), $fe4108adad250e9a$var$wa = Symbol.for("react.portal"), $fe4108adad250e9a$var$ya = Symbol.for("react.fragment"), $fe4108adad250e9a$var$za = Symbol.for("react.strict_mode"), $fe4108adad250e9a$var$Aa = Symbol.for("react.profiler"), $fe4108adad250e9a$var$Ba = Symbol.for("react.provider"), $fe4108adad250e9a$var$Ca = Symbol.for("react.context"), $fe4108adad250e9a$var$Da = Symbol.for("react.forward_ref"), $fe4108adad250e9a$var$Ea = Symbol.for("react.suspense"), $fe4108adad250e9a$var$Fa = Symbol.for("react.suspense_list"), $fe4108adad250e9a$var$Ga = Symbol.for("react.memo"), $fe4108adad250e9a$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $fe4108adad250e9a$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $fe4108adad250e9a$var$Ja = Symbol.iterator;
function $fe4108adad250e9a$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $fe4108adad250e9a$var$Ja && a[$fe4108adad250e9a$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $fe4108adad250e9a$var$A = Object.assign, $fe4108adad250e9a$var$La;
function $fe4108adad250e9a$var$Ma(a) {
    if (void 0 === $fe4108adad250e9a$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $fe4108adad250e9a$var$La = b && b[1] || "";
    }
    return "\n" + $fe4108adad250e9a$var$La + a;
}
var $fe4108adad250e9a$var$Na = !1;
function $fe4108adad250e9a$var$Oa(a, b) {
    if (!a || $fe4108adad250e9a$var$Na) return "";
    $fe4108adad250e9a$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $fe4108adad250e9a$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $fe4108adad250e9a$var$Ma(a) : "";
}
function $fe4108adad250e9a$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $fe4108adad250e9a$var$Ma(a.type);
        case 16:
            return $fe4108adad250e9a$var$Ma("Lazy");
        case 13:
            return $fe4108adad250e9a$var$Ma("Suspense");
        case 19:
            return $fe4108adad250e9a$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $fe4108adad250e9a$var$Oa(a.type, !1), a;
        case 11:
            return a = $fe4108adad250e9a$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $fe4108adad250e9a$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $fe4108adad250e9a$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $fe4108adad250e9a$var$ya:
            return "Fragment";
        case $fe4108adad250e9a$var$wa:
            return "Portal";
        case $fe4108adad250e9a$var$Aa:
            return "Profiler";
        case $fe4108adad250e9a$var$za:
            return "StrictMode";
        case $fe4108adad250e9a$var$Ea:
            return "Suspense";
        case $fe4108adad250e9a$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $fe4108adad250e9a$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $fe4108adad250e9a$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $fe4108adad250e9a$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $fe4108adad250e9a$var$Ga:
            return b = a.displayName || null, null !== b ? b : $fe4108adad250e9a$var$Qa(a.type) || "Memo";
        case $fe4108adad250e9a$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $fe4108adad250e9a$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $fe4108adad250e9a$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $fe4108adad250e9a$var$Qa(b);
        case 8:
            return b === $fe4108adad250e9a$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $fe4108adad250e9a$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $fe4108adad250e9a$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $fe4108adad250e9a$var$Ua(a) {
    var b = $fe4108adad250e9a$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $fe4108adad250e9a$var$Va(a) {
    a._valueTracker || (a._valueTracker = $fe4108adad250e9a$var$Ua(a));
}
function $fe4108adad250e9a$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $fe4108adad250e9a$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $fe4108adad250e9a$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $fe4108adad250e9a$var$Ya(a, b) {
    var c = b.checked;
    return $fe4108adad250e9a$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $fe4108adad250e9a$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $fe4108adad250e9a$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $fe4108adad250e9a$var$ab(a, b) {
    b = b.checked;
    null != b && $fe4108adad250e9a$var$ta(a, "checked", b, !1);
}
function $fe4108adad250e9a$var$bb(a, b) {
    $fe4108adad250e9a$var$ab(a, b);
    var c = $fe4108adad250e9a$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $fe4108adad250e9a$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $fe4108adad250e9a$var$cb(a, b.type, $fe4108adad250e9a$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $fe4108adad250e9a$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $fe4108adad250e9a$var$cb(a, b, c) {
    if ("number" !== b || $fe4108adad250e9a$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $fe4108adad250e9a$var$eb = Array.isArray;
function $fe4108adad250e9a$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $fe4108adad250e9a$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $fe4108adad250e9a$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($fe4108adad250e9a$var$p(91));
    return $fe4108adad250e9a$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $fe4108adad250e9a$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($fe4108adad250e9a$var$p(92));
            if ($fe4108adad250e9a$var$eb(c)) {
                if (1 < c.length) throw Error($fe4108adad250e9a$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $fe4108adad250e9a$var$Sa(c)
    };
}
function $fe4108adad250e9a$var$ib(a, b) {
    var c = $fe4108adad250e9a$var$Sa(b.value), d = $fe4108adad250e9a$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $fe4108adad250e9a$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $fe4108adad250e9a$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $fe4108adad250e9a$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $fe4108adad250e9a$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $fe4108adad250e9a$var$mb, $fe4108adad250e9a$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $fe4108adad250e9a$var$mb = $fe4108adad250e9a$var$mb || document.createElement("div");
        $fe4108adad250e9a$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $fe4108adad250e9a$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $fe4108adad250e9a$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $fe4108adad250e9a$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $fe4108adad250e9a$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($fe4108adad250e9a$var$pb).forEach(function(a) {
    $fe4108adad250e9a$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $fe4108adad250e9a$var$pb[b] = $fe4108adad250e9a$var$pb[a];
    });
});
function $fe4108adad250e9a$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $fe4108adad250e9a$var$pb.hasOwnProperty(a) && $fe4108adad250e9a$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $fe4108adad250e9a$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $fe4108adad250e9a$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $fe4108adad250e9a$var$tb = $fe4108adad250e9a$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $fe4108adad250e9a$var$ub(a, b) {
    if (b) {
        if ($fe4108adad250e9a$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($fe4108adad250e9a$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($fe4108adad250e9a$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($fe4108adad250e9a$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($fe4108adad250e9a$var$p(62));
    }
}
function $fe4108adad250e9a$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $fe4108adad250e9a$var$wb = null;
function $fe4108adad250e9a$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $fe4108adad250e9a$var$yb = null, $fe4108adad250e9a$var$zb = null, $fe4108adad250e9a$var$Ab = null;
function $fe4108adad250e9a$var$Bb(a) {
    if (a = $fe4108adad250e9a$var$Cb(a)) {
        if ("function" !== typeof $fe4108adad250e9a$var$yb) throw Error($fe4108adad250e9a$var$p(280));
        var b = a.stateNode;
        b && (b = $fe4108adad250e9a$var$Db(b), $fe4108adad250e9a$var$yb(a.stateNode, a.type, b));
    }
}
function $fe4108adad250e9a$var$Eb(a) {
    $fe4108adad250e9a$var$zb ? $fe4108adad250e9a$var$Ab ? $fe4108adad250e9a$var$Ab.push(a) : $fe4108adad250e9a$var$Ab = [
        a
    ] : $fe4108adad250e9a$var$zb = a;
}
function $fe4108adad250e9a$var$Fb() {
    if ($fe4108adad250e9a$var$zb) {
        var a = $fe4108adad250e9a$var$zb, b = $fe4108adad250e9a$var$Ab;
        $fe4108adad250e9a$var$Ab = $fe4108adad250e9a$var$zb = null;
        $fe4108adad250e9a$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$fe4108adad250e9a$var$Bb(b[a]);
    }
}
function $fe4108adad250e9a$var$Gb(a, b) {
    return a(b);
}
function $fe4108adad250e9a$var$Hb() {}
var $fe4108adad250e9a$var$Ib = !1;
function $fe4108adad250e9a$var$Jb(a, b, c) {
    if ($fe4108adad250e9a$var$Ib) return a(b, c);
    $fe4108adad250e9a$var$Ib = !0;
    try {
        return $fe4108adad250e9a$var$Gb(a, b, c);
    } finally{
        if ($fe4108adad250e9a$var$Ib = !1, null !== $fe4108adad250e9a$var$zb || null !== $fe4108adad250e9a$var$Ab) $fe4108adad250e9a$var$Hb(), $fe4108adad250e9a$var$Fb();
    }
}
function $fe4108adad250e9a$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $fe4108adad250e9a$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($fe4108adad250e9a$var$p(231, b, typeof c));
    return c;
}
var $fe4108adad250e9a$var$Lb = !1;
if ($fe4108adad250e9a$var$ia) try {
    var $fe4108adad250e9a$var$Mb = {};
    Object.defineProperty($fe4108adad250e9a$var$Mb, "passive", {
        get: function() {
            $fe4108adad250e9a$var$Lb = !0;
        }
    });
    window.addEventListener("test", $fe4108adad250e9a$var$Mb, $fe4108adad250e9a$var$Mb);
    window.removeEventListener("test", $fe4108adad250e9a$var$Mb, $fe4108adad250e9a$var$Mb);
} catch (a) {
    $fe4108adad250e9a$var$Lb = !1;
}
function $fe4108adad250e9a$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $fe4108adad250e9a$var$Ob = !1, $fe4108adad250e9a$var$Pb = null, $fe4108adad250e9a$var$Qb = !1, $fe4108adad250e9a$var$Rb = null, $fe4108adad250e9a$var$Sb = {
    onError: function(a) {
        $fe4108adad250e9a$var$Ob = !0;
        $fe4108adad250e9a$var$Pb = a;
    }
};
function $fe4108adad250e9a$var$Tb(a, b, c, d, e, f, g, h, k) {
    $fe4108adad250e9a$var$Ob = !1;
    $fe4108adad250e9a$var$Pb = null;
    $fe4108adad250e9a$var$Nb.apply($fe4108adad250e9a$var$Sb, arguments);
}
function $fe4108adad250e9a$var$Ub(a, b, c, d, e, f, g, h, k) {
    $fe4108adad250e9a$var$Tb.apply(this, arguments);
    if ($fe4108adad250e9a$var$Ob) {
        if ($fe4108adad250e9a$var$Ob) {
            var l = $fe4108adad250e9a$var$Pb;
            $fe4108adad250e9a$var$Ob = !1;
            $fe4108adad250e9a$var$Pb = null;
        } else throw Error($fe4108adad250e9a$var$p(198));
        $fe4108adad250e9a$var$Qb || ($fe4108adad250e9a$var$Qb = !0, $fe4108adad250e9a$var$Rb = l);
    }
}
function $fe4108adad250e9a$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $fe4108adad250e9a$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $fe4108adad250e9a$var$Xb(a) {
    if ($fe4108adad250e9a$var$Vb(a) !== a) throw Error($fe4108adad250e9a$var$p(188));
}
function $fe4108adad250e9a$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $fe4108adad250e9a$var$Vb(a);
        if (null === b) throw Error($fe4108adad250e9a$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $fe4108adad250e9a$var$Xb(e), a;
                if (f === d) return $fe4108adad250e9a$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($fe4108adad250e9a$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($fe4108adad250e9a$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($fe4108adad250e9a$var$p(190));
    }
    if (3 !== c.tag) throw Error($fe4108adad250e9a$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $fe4108adad250e9a$var$Zb(a) {
    a = $fe4108adad250e9a$var$Yb(a);
    return null !== a ? $fe4108adad250e9a$var$$b(a) : null;
}
function $fe4108adad250e9a$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $fe4108adad250e9a$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $fe4108adad250e9a$var$ac = $eq2VS.unstable_scheduleCallback, $fe4108adad250e9a$var$bc = $eq2VS.unstable_cancelCallback, $fe4108adad250e9a$var$cc = $eq2VS.unstable_shouldYield, $fe4108adad250e9a$var$dc = $eq2VS.unstable_requestPaint, $fe4108adad250e9a$var$B = $eq2VS.unstable_now, $fe4108adad250e9a$var$ec = $eq2VS.unstable_getCurrentPriorityLevel, $fe4108adad250e9a$var$fc = $eq2VS.unstable_ImmediatePriority, $fe4108adad250e9a$var$gc = $eq2VS.unstable_UserBlockingPriority, $fe4108adad250e9a$var$hc = $eq2VS.unstable_NormalPriority, $fe4108adad250e9a$var$ic = $eq2VS.unstable_LowPriority, $fe4108adad250e9a$var$jc = $eq2VS.unstable_IdlePriority, $fe4108adad250e9a$var$kc = null, $fe4108adad250e9a$var$lc = null;
function $fe4108adad250e9a$var$mc(a) {
    if ($fe4108adad250e9a$var$lc && "function" === typeof $fe4108adad250e9a$var$lc.onCommitFiberRoot) try {
        $fe4108adad250e9a$var$lc.onCommitFiberRoot($fe4108adad250e9a$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $fe4108adad250e9a$var$oc = Math.clz32 ? Math.clz32 : $fe4108adad250e9a$var$nc, $fe4108adad250e9a$var$pc = Math.log, $fe4108adad250e9a$var$qc = Math.LN2;
function $fe4108adad250e9a$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($fe4108adad250e9a$var$pc(a) / $fe4108adad250e9a$var$qc | 0) | 0;
}
var $fe4108adad250e9a$var$rc = 64, $fe4108adad250e9a$var$sc = 4194304;
function $fe4108adad250e9a$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $fe4108adad250e9a$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $fe4108adad250e9a$var$tc(h) : (f &= g, 0 !== f && (d = $fe4108adad250e9a$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $fe4108adad250e9a$var$tc(g) : 0 !== f && (d = $fe4108adad250e9a$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $fe4108adad250e9a$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $fe4108adad250e9a$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $fe4108adad250e9a$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $fe4108adad250e9a$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $fe4108adad250e9a$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $fe4108adad250e9a$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $fe4108adad250e9a$var$yc() {
    var a = $fe4108adad250e9a$var$rc;
    $fe4108adad250e9a$var$rc <<= 1;
    0 === ($fe4108adad250e9a$var$rc & 4194240) && ($fe4108adad250e9a$var$rc = 64);
    return a;
}
function $fe4108adad250e9a$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $fe4108adad250e9a$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $fe4108adad250e9a$var$oc(b);
    a[b] = c;
}
function $fe4108adad250e9a$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $fe4108adad250e9a$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $fe4108adad250e9a$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $fe4108adad250e9a$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $fe4108adad250e9a$var$C = 0;
function $fe4108adad250e9a$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $fe4108adad250e9a$var$Ec, $fe4108adad250e9a$var$Fc, $fe4108adad250e9a$var$Gc, $fe4108adad250e9a$var$Hc, $fe4108adad250e9a$var$Ic, $fe4108adad250e9a$var$Jc = !1, $fe4108adad250e9a$var$Kc = [], $fe4108adad250e9a$var$Lc = null, $fe4108adad250e9a$var$Mc = null, $fe4108adad250e9a$var$Nc = null, $fe4108adad250e9a$var$Oc = new Map, $fe4108adad250e9a$var$Pc = new Map, $fe4108adad250e9a$var$Qc = [], $fe4108adad250e9a$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $fe4108adad250e9a$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $fe4108adad250e9a$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $fe4108adad250e9a$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $fe4108adad250e9a$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $fe4108adad250e9a$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $fe4108adad250e9a$var$Pc.delete(b.pointerId);
    }
}
function $fe4108adad250e9a$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $fe4108adad250e9a$var$Cb(b), null !== b && $fe4108adad250e9a$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $fe4108adad250e9a$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $fe4108adad250e9a$var$Lc = $fe4108adad250e9a$var$Tc($fe4108adad250e9a$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $fe4108adad250e9a$var$Mc = $fe4108adad250e9a$var$Tc($fe4108adad250e9a$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $fe4108adad250e9a$var$Nc = $fe4108adad250e9a$var$Tc($fe4108adad250e9a$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $fe4108adad250e9a$var$Oc.set(f, $fe4108adad250e9a$var$Tc($fe4108adad250e9a$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $fe4108adad250e9a$var$Pc.set(f, $fe4108adad250e9a$var$Tc($fe4108adad250e9a$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $fe4108adad250e9a$var$Vc(a) {
    var b = $fe4108adad250e9a$var$Wc(a.target);
    if (null !== b) {
        var c = $fe4108adad250e9a$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $fe4108adad250e9a$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $fe4108adad250e9a$var$Ic(a.priority, function() {
                        $fe4108adad250e9a$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $fe4108adad250e9a$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $fe4108adad250e9a$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $fe4108adad250e9a$var$wb = d;
            c.target.dispatchEvent(d);
            $fe4108adad250e9a$var$wb = null;
        } else return b = $fe4108adad250e9a$var$Cb(c), null !== b && $fe4108adad250e9a$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $fe4108adad250e9a$var$Zc(a, b, c) {
    $fe4108adad250e9a$var$Xc(a) && c.delete(b);
}
function $fe4108adad250e9a$var$$c() {
    $fe4108adad250e9a$var$Jc = !1;
    null !== $fe4108adad250e9a$var$Lc && $fe4108adad250e9a$var$Xc($fe4108adad250e9a$var$Lc) && ($fe4108adad250e9a$var$Lc = null);
    null !== $fe4108adad250e9a$var$Mc && $fe4108adad250e9a$var$Xc($fe4108adad250e9a$var$Mc) && ($fe4108adad250e9a$var$Mc = null);
    null !== $fe4108adad250e9a$var$Nc && $fe4108adad250e9a$var$Xc($fe4108adad250e9a$var$Nc) && ($fe4108adad250e9a$var$Nc = null);
    $fe4108adad250e9a$var$Oc.forEach($fe4108adad250e9a$var$Zc);
    $fe4108adad250e9a$var$Pc.forEach($fe4108adad250e9a$var$Zc);
}
function $fe4108adad250e9a$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $fe4108adad250e9a$var$Jc || ($fe4108adad250e9a$var$Jc = !0, $eq2VS.unstable_scheduleCallback($eq2VS.unstable_NormalPriority, $fe4108adad250e9a$var$$c)));
}
function $fe4108adad250e9a$var$bd(a) {
    function b(b) {
        return $fe4108adad250e9a$var$ad(b, a);
    }
    if (0 < $fe4108adad250e9a$var$Kc.length) {
        $fe4108adad250e9a$var$ad($fe4108adad250e9a$var$Kc[0], a);
        for(var c = 1; c < $fe4108adad250e9a$var$Kc.length; c++){
            var d = $fe4108adad250e9a$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $fe4108adad250e9a$var$Lc && $fe4108adad250e9a$var$ad($fe4108adad250e9a$var$Lc, a);
    null !== $fe4108adad250e9a$var$Mc && $fe4108adad250e9a$var$ad($fe4108adad250e9a$var$Mc, a);
    null !== $fe4108adad250e9a$var$Nc && $fe4108adad250e9a$var$ad($fe4108adad250e9a$var$Nc, a);
    $fe4108adad250e9a$var$Oc.forEach(b);
    $fe4108adad250e9a$var$Pc.forEach(b);
    for(c = 0; c < $fe4108adad250e9a$var$Qc.length; c++)d = $fe4108adad250e9a$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $fe4108adad250e9a$var$Qc.length && (c = $fe4108adad250e9a$var$Qc[0], null === c.blockedOn);)$fe4108adad250e9a$var$Vc(c), null === c.blockedOn && $fe4108adad250e9a$var$Qc.shift();
}
var $fe4108adad250e9a$var$cd = $fe4108adad250e9a$var$ua.ReactCurrentBatchConfig, $fe4108adad250e9a$var$dd = !0;
function $fe4108adad250e9a$var$ed(a, b, c, d) {
    var e = $fe4108adad250e9a$var$C, f = $fe4108adad250e9a$var$cd.transition;
    $fe4108adad250e9a$var$cd.transition = null;
    try {
        $fe4108adad250e9a$var$C = 1, $fe4108adad250e9a$var$fd(a, b, c, d);
    } finally{
        $fe4108adad250e9a$var$C = e, $fe4108adad250e9a$var$cd.transition = f;
    }
}
function $fe4108adad250e9a$var$gd(a, b, c, d) {
    var e = $fe4108adad250e9a$var$C, f = $fe4108adad250e9a$var$cd.transition;
    $fe4108adad250e9a$var$cd.transition = null;
    try {
        $fe4108adad250e9a$var$C = 4, $fe4108adad250e9a$var$fd(a, b, c, d);
    } finally{
        $fe4108adad250e9a$var$C = e, $fe4108adad250e9a$var$cd.transition = f;
    }
}
function $fe4108adad250e9a$var$fd(a, b, c, d) {
    if ($fe4108adad250e9a$var$dd) {
        var e = $fe4108adad250e9a$var$Yc(a, b, c, d);
        if (null === e) $fe4108adad250e9a$var$hd(a, b, d, $fe4108adad250e9a$var$id, c), $fe4108adad250e9a$var$Sc(a, d);
        else if ($fe4108adad250e9a$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($fe4108adad250e9a$var$Sc(a, d), b & 4 && -1 < $fe4108adad250e9a$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $fe4108adad250e9a$var$Cb(e);
                null !== f && $fe4108adad250e9a$var$Ec(f);
                f = $fe4108adad250e9a$var$Yc(a, b, c, d);
                null === f && $fe4108adad250e9a$var$hd(a, b, d, $fe4108adad250e9a$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $fe4108adad250e9a$var$hd(a, b, d, null, c);
    }
}
var $fe4108adad250e9a$var$id = null;
function $fe4108adad250e9a$var$Yc(a, b, c, d) {
    $fe4108adad250e9a$var$id = null;
    a = $fe4108adad250e9a$var$xb(d);
    a = $fe4108adad250e9a$var$Wc(a);
    if (null !== a) {
        if (b = $fe4108adad250e9a$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $fe4108adad250e9a$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $fe4108adad250e9a$var$id = a;
    return null;
}
function $fe4108adad250e9a$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($fe4108adad250e9a$var$ec()){
                case $fe4108adad250e9a$var$fc:
                    return 1;
                case $fe4108adad250e9a$var$gc:
                    return 4;
                case $fe4108adad250e9a$var$hc:
                case $fe4108adad250e9a$var$ic:
                    return 16;
                case $fe4108adad250e9a$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $fe4108adad250e9a$var$kd = null, $fe4108adad250e9a$var$ld = null, $fe4108adad250e9a$var$md = null;
function $fe4108adad250e9a$var$nd() {
    if ($fe4108adad250e9a$var$md) return $fe4108adad250e9a$var$md;
    var a, b = $fe4108adad250e9a$var$ld, c = b.length, d, e = "value" in $fe4108adad250e9a$var$kd ? $fe4108adad250e9a$var$kd.value : $fe4108adad250e9a$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $fe4108adad250e9a$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $fe4108adad250e9a$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $fe4108adad250e9a$var$pd() {
    return !0;
}
function $fe4108adad250e9a$var$qd() {
    return !1;
}
function $fe4108adad250e9a$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $fe4108adad250e9a$var$pd : $fe4108adad250e9a$var$qd;
        this.isPropagationStopped = $fe4108adad250e9a$var$qd;
        return this;
    }
    $fe4108adad250e9a$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $fe4108adad250e9a$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $fe4108adad250e9a$var$pd);
        },
        persist: function() {},
        isPersistent: $fe4108adad250e9a$var$pd
    });
    return b;
}
var $fe4108adad250e9a$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $fe4108adad250e9a$var$td = $fe4108adad250e9a$var$rd($fe4108adad250e9a$var$sd), $fe4108adad250e9a$var$ud = $fe4108adad250e9a$var$A({}, $fe4108adad250e9a$var$sd, {
    view: 0,
    detail: 0
}), $fe4108adad250e9a$var$vd = $fe4108adad250e9a$var$rd($fe4108adad250e9a$var$ud), $fe4108adad250e9a$var$wd, $fe4108adad250e9a$var$xd, $fe4108adad250e9a$var$yd, $fe4108adad250e9a$var$Ad = $fe4108adad250e9a$var$A({}, $fe4108adad250e9a$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $fe4108adad250e9a$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $fe4108adad250e9a$var$yd && ($fe4108adad250e9a$var$yd && "mousemove" === a.type ? ($fe4108adad250e9a$var$wd = a.screenX - $fe4108adad250e9a$var$yd.screenX, $fe4108adad250e9a$var$xd = a.screenY - $fe4108adad250e9a$var$yd.screenY) : $fe4108adad250e9a$var$xd = $fe4108adad250e9a$var$wd = 0, $fe4108adad250e9a$var$yd = a);
        return $fe4108adad250e9a$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $fe4108adad250e9a$var$xd;
    }
}), $fe4108adad250e9a$var$Bd = $fe4108adad250e9a$var$rd($fe4108adad250e9a$var$Ad), $fe4108adad250e9a$var$Cd = $fe4108adad250e9a$var$A({}, $fe4108adad250e9a$var$Ad, {
    dataTransfer: 0
}), $fe4108adad250e9a$var$Dd = $fe4108adad250e9a$var$rd($fe4108adad250e9a$var$Cd), $fe4108adad250e9a$var$Ed = $fe4108adad250e9a$var$A({}, $fe4108adad250e9a$var$ud, {
    relatedTarget: 0
}), $fe4108adad250e9a$var$Fd = $fe4108adad250e9a$var$rd($fe4108adad250e9a$var$Ed), $fe4108adad250e9a$var$Gd = $fe4108adad250e9a$var$A({}, $fe4108adad250e9a$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $fe4108adad250e9a$var$Hd = $fe4108adad250e9a$var$rd($fe4108adad250e9a$var$Gd), $fe4108adad250e9a$var$Id = $fe4108adad250e9a$var$A({}, $fe4108adad250e9a$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $fe4108adad250e9a$var$Jd = $fe4108adad250e9a$var$rd($fe4108adad250e9a$var$Id), $fe4108adad250e9a$var$Kd = $fe4108adad250e9a$var$A({}, $fe4108adad250e9a$var$sd, {
    data: 0
}), $fe4108adad250e9a$var$Ld = $fe4108adad250e9a$var$rd($fe4108adad250e9a$var$Kd), $fe4108adad250e9a$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $fe4108adad250e9a$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $fe4108adad250e9a$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $fe4108adad250e9a$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $fe4108adad250e9a$var$Od[a]) ? !!b[a] : !1;
}
function $fe4108adad250e9a$var$zd() {
    return $fe4108adad250e9a$var$Pd;
}
var $fe4108adad250e9a$var$Qd = $fe4108adad250e9a$var$A({}, $fe4108adad250e9a$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $fe4108adad250e9a$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $fe4108adad250e9a$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $fe4108adad250e9a$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $fe4108adad250e9a$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $fe4108adad250e9a$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $fe4108adad250e9a$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $fe4108adad250e9a$var$Rd = $fe4108adad250e9a$var$rd($fe4108adad250e9a$var$Qd), $fe4108adad250e9a$var$Sd = $fe4108adad250e9a$var$A({}, $fe4108adad250e9a$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $fe4108adad250e9a$var$Td = $fe4108adad250e9a$var$rd($fe4108adad250e9a$var$Sd), $fe4108adad250e9a$var$Ud = $fe4108adad250e9a$var$A({}, $fe4108adad250e9a$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $fe4108adad250e9a$var$zd
}), $fe4108adad250e9a$var$Vd = $fe4108adad250e9a$var$rd($fe4108adad250e9a$var$Ud), $fe4108adad250e9a$var$Wd = $fe4108adad250e9a$var$A({}, $fe4108adad250e9a$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $fe4108adad250e9a$var$Xd = $fe4108adad250e9a$var$rd($fe4108adad250e9a$var$Wd), $fe4108adad250e9a$var$Yd = $fe4108adad250e9a$var$A({}, $fe4108adad250e9a$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $fe4108adad250e9a$var$Zd = $fe4108adad250e9a$var$rd($fe4108adad250e9a$var$Yd), $fe4108adad250e9a$var$$d = [
    9,
    13,
    27,
    32
], $fe4108adad250e9a$var$ae = $fe4108adad250e9a$var$ia && "CompositionEvent" in window, $fe4108adad250e9a$var$be = null;
$fe4108adad250e9a$var$ia && "documentMode" in document && ($fe4108adad250e9a$var$be = document.documentMode);
var $fe4108adad250e9a$var$ce = $fe4108adad250e9a$var$ia && "TextEvent" in window && !$fe4108adad250e9a$var$be, $fe4108adad250e9a$var$de = $fe4108adad250e9a$var$ia && (!$fe4108adad250e9a$var$ae || $fe4108adad250e9a$var$be && 8 < $fe4108adad250e9a$var$be && 11 >= $fe4108adad250e9a$var$be), $fe4108adad250e9a$var$ee = String.fromCharCode(32), $fe4108adad250e9a$var$fe = !1;
function $fe4108adad250e9a$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $fe4108adad250e9a$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $fe4108adad250e9a$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $fe4108adad250e9a$var$ie = !1;
function $fe4108adad250e9a$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $fe4108adad250e9a$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $fe4108adad250e9a$var$fe = !0;
            return $fe4108adad250e9a$var$ee;
        case "textInput":
            return a = b.data, a === $fe4108adad250e9a$var$ee && $fe4108adad250e9a$var$fe ? null : a;
        default:
            return null;
    }
}
function $fe4108adad250e9a$var$ke(a, b) {
    if ($fe4108adad250e9a$var$ie) return "compositionend" === a || !$fe4108adad250e9a$var$ae && $fe4108adad250e9a$var$ge(a, b) ? (a = $fe4108adad250e9a$var$nd(), $fe4108adad250e9a$var$md = $fe4108adad250e9a$var$ld = $fe4108adad250e9a$var$kd = null, $fe4108adad250e9a$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $fe4108adad250e9a$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $fe4108adad250e9a$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $fe4108adad250e9a$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$fe4108adad250e9a$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $fe4108adad250e9a$var$ne(a, b, c, d) {
    $fe4108adad250e9a$var$Eb(d);
    b = $fe4108adad250e9a$var$oe(b, "onChange");
    0 < b.length && (c = new $fe4108adad250e9a$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $fe4108adad250e9a$var$pe = null, $fe4108adad250e9a$var$qe = null;
function $fe4108adad250e9a$var$re(a) {
    $fe4108adad250e9a$var$se(a, 0);
}
function $fe4108adad250e9a$var$te(a) {
    var b = $fe4108adad250e9a$var$ue(a);
    if ($fe4108adad250e9a$var$Wa(b)) return a;
}
function $fe4108adad250e9a$var$ve(a, b) {
    if ("change" === a) return b;
}
var $fe4108adad250e9a$var$we = !1;
if ($fe4108adad250e9a$var$ia) {
    var $fe4108adad250e9a$var$xe;
    if ($fe4108adad250e9a$var$ia) {
        var $fe4108adad250e9a$var$ye = "oninput" in document;
        if (!$fe4108adad250e9a$var$ye) {
            var $fe4108adad250e9a$var$ze = document.createElement("div");
            $fe4108adad250e9a$var$ze.setAttribute("oninput", "return;");
            $fe4108adad250e9a$var$ye = "function" === typeof $fe4108adad250e9a$var$ze.oninput;
        }
        $fe4108adad250e9a$var$xe = $fe4108adad250e9a$var$ye;
    } else $fe4108adad250e9a$var$xe = !1;
    $fe4108adad250e9a$var$we = $fe4108adad250e9a$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $fe4108adad250e9a$var$Ae() {
    $fe4108adad250e9a$var$pe && ($fe4108adad250e9a$var$pe.detachEvent("onpropertychange", $fe4108adad250e9a$var$Be), $fe4108adad250e9a$var$qe = $fe4108adad250e9a$var$pe = null);
}
function $fe4108adad250e9a$var$Be(a) {
    if ("value" === a.propertyName && $fe4108adad250e9a$var$te($fe4108adad250e9a$var$qe)) {
        var b = [];
        $fe4108adad250e9a$var$ne(b, $fe4108adad250e9a$var$qe, a, $fe4108adad250e9a$var$xb(a));
        $fe4108adad250e9a$var$Jb($fe4108adad250e9a$var$re, b);
    }
}
function $fe4108adad250e9a$var$Ce(a, b, c) {
    "focusin" === a ? ($fe4108adad250e9a$var$Ae(), $fe4108adad250e9a$var$pe = b, $fe4108adad250e9a$var$qe = c, $fe4108adad250e9a$var$pe.attachEvent("onpropertychange", $fe4108adad250e9a$var$Be)) : "focusout" === a && $fe4108adad250e9a$var$Ae();
}
function $fe4108adad250e9a$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $fe4108adad250e9a$var$te($fe4108adad250e9a$var$qe);
}
function $fe4108adad250e9a$var$Ee(a, b) {
    if ("click" === a) return $fe4108adad250e9a$var$te(b);
}
function $fe4108adad250e9a$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $fe4108adad250e9a$var$te(b);
}
function $fe4108adad250e9a$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $fe4108adad250e9a$var$He = "function" === typeof Object.is ? Object.is : $fe4108adad250e9a$var$Ge;
function $fe4108adad250e9a$var$Ie(a, b) {
    if ($fe4108adad250e9a$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$fe4108adad250e9a$var$ja.call(b, e) || !$fe4108adad250e9a$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $fe4108adad250e9a$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $fe4108adad250e9a$var$Ke(a, b) {
    var c = $fe4108adad250e9a$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $fe4108adad250e9a$var$Je(c);
    }
}
function $fe4108adad250e9a$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $fe4108adad250e9a$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $fe4108adad250e9a$var$Me() {
    for(var a = window, b = $fe4108adad250e9a$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $fe4108adad250e9a$var$Xa(a.document);
    }
    return b;
}
function $fe4108adad250e9a$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $fe4108adad250e9a$var$Oe(a) {
    var b = $fe4108adad250e9a$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $fe4108adad250e9a$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $fe4108adad250e9a$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $fe4108adad250e9a$var$Ke(c, f);
                var g = $fe4108adad250e9a$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $fe4108adad250e9a$var$Pe = $fe4108adad250e9a$var$ia && "documentMode" in document && 11 >= document.documentMode, $fe4108adad250e9a$var$Qe = null, $fe4108adad250e9a$var$Re = null, $fe4108adad250e9a$var$Se = null, $fe4108adad250e9a$var$Te = !1;
function $fe4108adad250e9a$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $fe4108adad250e9a$var$Te || null == $fe4108adad250e9a$var$Qe || $fe4108adad250e9a$var$Qe !== $fe4108adad250e9a$var$Xa(d) || (d = $fe4108adad250e9a$var$Qe, "selectionStart" in d && $fe4108adad250e9a$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $fe4108adad250e9a$var$Se && $fe4108adad250e9a$var$Ie($fe4108adad250e9a$var$Se, d) || ($fe4108adad250e9a$var$Se = d, d = $fe4108adad250e9a$var$oe($fe4108adad250e9a$var$Re, "onSelect"), 0 < d.length && (b = new $fe4108adad250e9a$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $fe4108adad250e9a$var$Qe)));
}
function $fe4108adad250e9a$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $fe4108adad250e9a$var$We = {
    animationend: $fe4108adad250e9a$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $fe4108adad250e9a$var$Ve("Animation", "AnimationIteration"),
    animationstart: $fe4108adad250e9a$var$Ve("Animation", "AnimationStart"),
    transitionend: $fe4108adad250e9a$var$Ve("Transition", "TransitionEnd")
}, $fe4108adad250e9a$var$Xe = {}, $fe4108adad250e9a$var$Ye = {};
$fe4108adad250e9a$var$ia && ($fe4108adad250e9a$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $fe4108adad250e9a$var$We.animationend.animation, delete $fe4108adad250e9a$var$We.animationiteration.animation, delete $fe4108adad250e9a$var$We.animationstart.animation), "TransitionEvent" in window || delete $fe4108adad250e9a$var$We.transitionend.transition);
function $fe4108adad250e9a$var$Ze(a) {
    if ($fe4108adad250e9a$var$Xe[a]) return $fe4108adad250e9a$var$Xe[a];
    if (!$fe4108adad250e9a$var$We[a]) return a;
    var b = $fe4108adad250e9a$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $fe4108adad250e9a$var$Ye) return $fe4108adad250e9a$var$Xe[a] = b[c];
    return a;
}
var $fe4108adad250e9a$var$$e = $fe4108adad250e9a$var$Ze("animationend"), $fe4108adad250e9a$var$af = $fe4108adad250e9a$var$Ze("animationiteration"), $fe4108adad250e9a$var$bf = $fe4108adad250e9a$var$Ze("animationstart"), $fe4108adad250e9a$var$cf = $fe4108adad250e9a$var$Ze("transitionend"), $fe4108adad250e9a$var$df = new Map, $fe4108adad250e9a$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $fe4108adad250e9a$var$ff(a, b) {
    $fe4108adad250e9a$var$df.set(a, b);
    $fe4108adad250e9a$var$fa(b, [
        a
    ]);
}
for(var $fe4108adad250e9a$var$gf = 0; $fe4108adad250e9a$var$gf < $fe4108adad250e9a$var$ef.length; $fe4108adad250e9a$var$gf++){
    var $fe4108adad250e9a$var$hf = $fe4108adad250e9a$var$ef[$fe4108adad250e9a$var$gf], $fe4108adad250e9a$var$jf = $fe4108adad250e9a$var$hf.toLowerCase(), $fe4108adad250e9a$var$kf = $fe4108adad250e9a$var$hf[0].toUpperCase() + $fe4108adad250e9a$var$hf.slice(1);
    $fe4108adad250e9a$var$ff($fe4108adad250e9a$var$jf, "on" + $fe4108adad250e9a$var$kf);
}
$fe4108adad250e9a$var$ff($fe4108adad250e9a$var$$e, "onAnimationEnd");
$fe4108adad250e9a$var$ff($fe4108adad250e9a$var$af, "onAnimationIteration");
$fe4108adad250e9a$var$ff($fe4108adad250e9a$var$bf, "onAnimationStart");
$fe4108adad250e9a$var$ff("dblclick", "onDoubleClick");
$fe4108adad250e9a$var$ff("focusin", "onFocus");
$fe4108adad250e9a$var$ff("focusout", "onBlur");
$fe4108adad250e9a$var$ff($fe4108adad250e9a$var$cf, "onTransitionEnd");
$fe4108adad250e9a$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$fe4108adad250e9a$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$fe4108adad250e9a$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$fe4108adad250e9a$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$fe4108adad250e9a$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$fe4108adad250e9a$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$fe4108adad250e9a$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$fe4108adad250e9a$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$fe4108adad250e9a$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$fe4108adad250e9a$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $fe4108adad250e9a$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $fe4108adad250e9a$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($fe4108adad250e9a$var$lf));
function $fe4108adad250e9a$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $fe4108adad250e9a$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $fe4108adad250e9a$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $fe4108adad250e9a$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $fe4108adad250e9a$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($fe4108adad250e9a$var$Qb) throw a = $fe4108adad250e9a$var$Rb, $fe4108adad250e9a$var$Qb = !1, $fe4108adad250e9a$var$Rb = null, a;
}
function $fe4108adad250e9a$var$D(a, b) {
    var c = b[$fe4108adad250e9a$var$of];
    void 0 === c && (c = b[$fe4108adad250e9a$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($fe4108adad250e9a$var$pf(b, a, 2, !1), c.add(d));
}
function $fe4108adad250e9a$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $fe4108adad250e9a$var$pf(c, a, d, b);
}
var $fe4108adad250e9a$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $fe4108adad250e9a$var$sf(a) {
    if (!a[$fe4108adad250e9a$var$rf]) {
        a[$fe4108adad250e9a$var$rf] = !0;
        $fe4108adad250e9a$var$da.forEach(function(b) {
            "selectionchange" !== b && ($fe4108adad250e9a$var$mf.has(b) || $fe4108adad250e9a$var$qf(b, !1, a), $fe4108adad250e9a$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$fe4108adad250e9a$var$rf] || (b[$fe4108adad250e9a$var$rf] = !0, $fe4108adad250e9a$var$qf("selectionchange", !1, b));
    }
}
function $fe4108adad250e9a$var$pf(a, b, c, d) {
    switch($fe4108adad250e9a$var$jd(b)){
        case 1:
            var e = $fe4108adad250e9a$var$ed;
            break;
        case 4:
            e = $fe4108adad250e9a$var$gd;
            break;
        default:
            e = $fe4108adad250e9a$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$fe4108adad250e9a$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $fe4108adad250e9a$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $fe4108adad250e9a$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $fe4108adad250e9a$var$Jb(function() {
        var d = f, e = $fe4108adad250e9a$var$xb(c), g = [];
        a: {
            var h = $fe4108adad250e9a$var$df.get(a);
            if (void 0 !== h) {
                var k = $fe4108adad250e9a$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $fe4108adad250e9a$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $fe4108adad250e9a$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $fe4108adad250e9a$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $fe4108adad250e9a$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $fe4108adad250e9a$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $fe4108adad250e9a$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $fe4108adad250e9a$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $fe4108adad250e9a$var$Vd;
                        break;
                    case $fe4108adad250e9a$var$$e:
                    case $fe4108adad250e9a$var$af:
                    case $fe4108adad250e9a$var$bf:
                        k = $fe4108adad250e9a$var$Hd;
                        break;
                    case $fe4108adad250e9a$var$cf:
                        k = $fe4108adad250e9a$var$Xd;
                        break;
                    case "scroll":
                        k = $fe4108adad250e9a$var$vd;
                        break;
                    case "wheel":
                        k = $fe4108adad250e9a$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $fe4108adad250e9a$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $fe4108adad250e9a$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $fe4108adad250e9a$var$Kb(w, x), null != F && t.push($fe4108adad250e9a$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $fe4108adad250e9a$var$wb && (n = c.relatedTarget || c.fromElement) && ($fe4108adad250e9a$var$Wc(n) || n[$fe4108adad250e9a$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $fe4108adad250e9a$var$Wc(n) : null, null !== n && (J = $fe4108adad250e9a$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $fe4108adad250e9a$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $fe4108adad250e9a$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $fe4108adad250e9a$var$ue(k);
                        u = null == n ? h : $fe4108adad250e9a$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $fe4108adad250e9a$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $fe4108adad250e9a$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $fe4108adad250e9a$var$vf(F))u++;
                            for(; 0 < w - u;)t = $fe4108adad250e9a$var$vf(t), w--;
                            for(; 0 < u - w;)x = $fe4108adad250e9a$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $fe4108adad250e9a$var$vf(t);
                                x = $fe4108adad250e9a$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $fe4108adad250e9a$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $fe4108adad250e9a$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $fe4108adad250e9a$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $fe4108adad250e9a$var$ve;
                else if ($fe4108adad250e9a$var$me(h)) {
                    if ($fe4108adad250e9a$var$we) na = $fe4108adad250e9a$var$Fe;
                    else {
                        na = $fe4108adad250e9a$var$De;
                        var xa = $fe4108adad250e9a$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $fe4108adad250e9a$var$Ee);
                if (na && (na = na(a, d))) {
                    $fe4108adad250e9a$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $fe4108adad250e9a$var$cb(h, "number", h.value);
            }
            xa = d ? $fe4108adad250e9a$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($fe4108adad250e9a$var$me(xa) || "true" === xa.contentEditable) $fe4108adad250e9a$var$Qe = xa, $fe4108adad250e9a$var$Re = d, $fe4108adad250e9a$var$Se = null;
                    break;
                case "focusout":
                    $fe4108adad250e9a$var$Se = $fe4108adad250e9a$var$Re = $fe4108adad250e9a$var$Qe = null;
                    break;
                case "mousedown":
                    $fe4108adad250e9a$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $fe4108adad250e9a$var$Te = !1;
                    $fe4108adad250e9a$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($fe4108adad250e9a$var$Pe) break;
                case "keydown":
                case "keyup":
                    $fe4108adad250e9a$var$Ue(g, c, e);
            }
            var $a;
            if ($fe4108adad250e9a$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $fe4108adad250e9a$var$ie ? $fe4108adad250e9a$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($fe4108adad250e9a$var$de && "ko" !== c.locale && ($fe4108adad250e9a$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $fe4108adad250e9a$var$ie && ($a = $fe4108adad250e9a$var$nd()) : ($fe4108adad250e9a$var$kd = e, $fe4108adad250e9a$var$ld = "value" in $fe4108adad250e9a$var$kd ? $fe4108adad250e9a$var$kd.value : $fe4108adad250e9a$var$kd.textContent, $fe4108adad250e9a$var$ie = !0)), xa = $fe4108adad250e9a$var$oe(d, ba), 0 < xa.length && (ba = new $fe4108adad250e9a$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $fe4108adad250e9a$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $fe4108adad250e9a$var$ce ? $fe4108adad250e9a$var$je(a, c) : $fe4108adad250e9a$var$ke(a, c)) d = $fe4108adad250e9a$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $fe4108adad250e9a$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $fe4108adad250e9a$var$se(g, b);
    });
}
function $fe4108adad250e9a$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $fe4108adad250e9a$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $fe4108adad250e9a$var$Kb(a, c), null != f && d.unshift($fe4108adad250e9a$var$tf(a, f, e)), f = $fe4108adad250e9a$var$Kb(a, b), null != f && d.push($fe4108adad250e9a$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $fe4108adad250e9a$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $fe4108adad250e9a$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $fe4108adad250e9a$var$Kb(c, f), null != k && g.unshift($fe4108adad250e9a$var$tf(c, k, h))) : e || (k = $fe4108adad250e9a$var$Kb(c, f), null != k && g.push($fe4108adad250e9a$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $fe4108adad250e9a$var$xf = /\r\n?/g, $fe4108adad250e9a$var$yf = /\u0000|\uFFFD/g;
function $fe4108adad250e9a$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($fe4108adad250e9a$var$xf, "\n").replace($fe4108adad250e9a$var$yf, "");
}
function $fe4108adad250e9a$var$Af(a, b, c) {
    b = $fe4108adad250e9a$var$zf(b);
    if ($fe4108adad250e9a$var$zf(a) !== b && c) throw Error($fe4108adad250e9a$var$p(425));
}
function $fe4108adad250e9a$var$Bf() {}
var $fe4108adad250e9a$var$Cf = null, $fe4108adad250e9a$var$Df = null;
function $fe4108adad250e9a$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $fe4108adad250e9a$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $fe4108adad250e9a$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $fe4108adad250e9a$var$Hf = "function" === typeof Promise ? Promise : void 0, $fe4108adad250e9a$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $fe4108adad250e9a$var$Hf ? function(a) {
    return $fe4108adad250e9a$var$Hf.resolve(null).then(a).catch($fe4108adad250e9a$var$If);
} : $fe4108adad250e9a$var$Ff;
function $fe4108adad250e9a$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $fe4108adad250e9a$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $fe4108adad250e9a$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $fe4108adad250e9a$var$bd(b);
}
function $fe4108adad250e9a$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $fe4108adad250e9a$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $fe4108adad250e9a$var$Nf = Math.random().toString(36).slice(2), $fe4108adad250e9a$var$Of = "__reactFiber$" + $fe4108adad250e9a$var$Nf, $fe4108adad250e9a$var$Pf = "__reactProps$" + $fe4108adad250e9a$var$Nf, $fe4108adad250e9a$var$uf = "__reactContainer$" + $fe4108adad250e9a$var$Nf, $fe4108adad250e9a$var$of = "__reactEvents$" + $fe4108adad250e9a$var$Nf, $fe4108adad250e9a$var$Qf = "__reactListeners$" + $fe4108adad250e9a$var$Nf, $fe4108adad250e9a$var$Rf = "__reactHandles$" + $fe4108adad250e9a$var$Nf;
function $fe4108adad250e9a$var$Wc(a) {
    var b = a[$fe4108adad250e9a$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$fe4108adad250e9a$var$uf] || c[$fe4108adad250e9a$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $fe4108adad250e9a$var$Mf(a); null !== a;){
                if (c = a[$fe4108adad250e9a$var$Of]) return c;
                a = $fe4108adad250e9a$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $fe4108adad250e9a$var$Cb(a) {
    a = a[$fe4108adad250e9a$var$Of] || a[$fe4108adad250e9a$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $fe4108adad250e9a$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($fe4108adad250e9a$var$p(33));
}
function $fe4108adad250e9a$var$Db(a) {
    return a[$fe4108adad250e9a$var$Pf] || null;
}
var $fe4108adad250e9a$var$Sf = [], $fe4108adad250e9a$var$Tf = -1;
function $fe4108adad250e9a$var$Uf(a) {
    return {
        current: a
    };
}
function $fe4108adad250e9a$var$E(a) {
    0 > $fe4108adad250e9a$var$Tf || (a.current = $fe4108adad250e9a$var$Sf[$fe4108adad250e9a$var$Tf], $fe4108adad250e9a$var$Sf[$fe4108adad250e9a$var$Tf] = null, $fe4108adad250e9a$var$Tf--);
}
function $fe4108adad250e9a$var$G(a, b) {
    $fe4108adad250e9a$var$Tf++;
    $fe4108adad250e9a$var$Sf[$fe4108adad250e9a$var$Tf] = a.current;
    a.current = b;
}
var $fe4108adad250e9a$var$Vf = {}, $fe4108adad250e9a$var$H = $fe4108adad250e9a$var$Uf($fe4108adad250e9a$var$Vf), $fe4108adad250e9a$var$Wf = $fe4108adad250e9a$var$Uf(!1), $fe4108adad250e9a$var$Xf = $fe4108adad250e9a$var$Vf;
function $fe4108adad250e9a$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $fe4108adad250e9a$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $fe4108adad250e9a$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $fe4108adad250e9a$var$$f() {
    $fe4108adad250e9a$var$E($fe4108adad250e9a$var$Wf);
    $fe4108adad250e9a$var$E($fe4108adad250e9a$var$H);
}
function $fe4108adad250e9a$var$ag(a, b, c) {
    if ($fe4108adad250e9a$var$H.current !== $fe4108adad250e9a$var$Vf) throw Error($fe4108adad250e9a$var$p(168));
    $fe4108adad250e9a$var$G($fe4108adad250e9a$var$H, b);
    $fe4108adad250e9a$var$G($fe4108adad250e9a$var$Wf, c);
}
function $fe4108adad250e9a$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($fe4108adad250e9a$var$p(108, $fe4108adad250e9a$var$Ra(a) || "Unknown", e));
    return $fe4108adad250e9a$var$A({}, c, d);
}
function $fe4108adad250e9a$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $fe4108adad250e9a$var$Vf;
    $fe4108adad250e9a$var$Xf = $fe4108adad250e9a$var$H.current;
    $fe4108adad250e9a$var$G($fe4108adad250e9a$var$H, a);
    $fe4108adad250e9a$var$G($fe4108adad250e9a$var$Wf, $fe4108adad250e9a$var$Wf.current);
    return !0;
}
function $fe4108adad250e9a$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($fe4108adad250e9a$var$p(169));
    c ? (a = $fe4108adad250e9a$var$bg(a, b, $fe4108adad250e9a$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $fe4108adad250e9a$var$E($fe4108adad250e9a$var$Wf), $fe4108adad250e9a$var$E($fe4108adad250e9a$var$H), $fe4108adad250e9a$var$G($fe4108adad250e9a$var$H, a)) : $fe4108adad250e9a$var$E($fe4108adad250e9a$var$Wf);
    $fe4108adad250e9a$var$G($fe4108adad250e9a$var$Wf, c);
}
var $fe4108adad250e9a$var$eg = null, $fe4108adad250e9a$var$fg = !1, $fe4108adad250e9a$var$gg = !1;
function $fe4108adad250e9a$var$hg(a) {
    null === $fe4108adad250e9a$var$eg ? $fe4108adad250e9a$var$eg = [
        a
    ] : $fe4108adad250e9a$var$eg.push(a);
}
function $fe4108adad250e9a$var$ig(a) {
    $fe4108adad250e9a$var$fg = !0;
    $fe4108adad250e9a$var$hg(a);
}
function $fe4108adad250e9a$var$jg() {
    if (!$fe4108adad250e9a$var$gg && null !== $fe4108adad250e9a$var$eg) {
        $fe4108adad250e9a$var$gg = !0;
        var a = 0, b = $fe4108adad250e9a$var$C;
        try {
            var c = $fe4108adad250e9a$var$eg;
            for($fe4108adad250e9a$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $fe4108adad250e9a$var$eg = null;
            $fe4108adad250e9a$var$fg = !1;
        } catch (e) {
            throw null !== $fe4108adad250e9a$var$eg && ($fe4108adad250e9a$var$eg = $fe4108adad250e9a$var$eg.slice(a + 1)), $fe4108adad250e9a$var$ac($fe4108adad250e9a$var$fc, $fe4108adad250e9a$var$jg), e;
        } finally{
            $fe4108adad250e9a$var$C = b, $fe4108adad250e9a$var$gg = !1;
        }
    }
    return null;
}
var $fe4108adad250e9a$var$kg = [], $fe4108adad250e9a$var$lg = 0, $fe4108adad250e9a$var$mg = null, $fe4108adad250e9a$var$ng = 0, $fe4108adad250e9a$var$og = [], $fe4108adad250e9a$var$pg = 0, $fe4108adad250e9a$var$qg = null, $fe4108adad250e9a$var$rg = 1, $fe4108adad250e9a$var$sg = "";
function $fe4108adad250e9a$var$tg(a, b) {
    $fe4108adad250e9a$var$kg[$fe4108adad250e9a$var$lg++] = $fe4108adad250e9a$var$ng;
    $fe4108adad250e9a$var$kg[$fe4108adad250e9a$var$lg++] = $fe4108adad250e9a$var$mg;
    $fe4108adad250e9a$var$mg = a;
    $fe4108adad250e9a$var$ng = b;
}
function $fe4108adad250e9a$var$ug(a, b, c) {
    $fe4108adad250e9a$var$og[$fe4108adad250e9a$var$pg++] = $fe4108adad250e9a$var$rg;
    $fe4108adad250e9a$var$og[$fe4108adad250e9a$var$pg++] = $fe4108adad250e9a$var$sg;
    $fe4108adad250e9a$var$og[$fe4108adad250e9a$var$pg++] = $fe4108adad250e9a$var$qg;
    $fe4108adad250e9a$var$qg = a;
    var d = $fe4108adad250e9a$var$rg;
    a = $fe4108adad250e9a$var$sg;
    var e = 32 - $fe4108adad250e9a$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $fe4108adad250e9a$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $fe4108adad250e9a$var$rg = 1 << 32 - $fe4108adad250e9a$var$oc(b) + e | c << e | d;
        $fe4108adad250e9a$var$sg = f + a;
    } else $fe4108adad250e9a$var$rg = 1 << f | c << e | d, $fe4108adad250e9a$var$sg = a;
}
function $fe4108adad250e9a$var$vg(a) {
    null !== a.return && ($fe4108adad250e9a$var$tg(a, 1), $fe4108adad250e9a$var$ug(a, 1, 0));
}
function $fe4108adad250e9a$var$wg(a) {
    for(; a === $fe4108adad250e9a$var$mg;)$fe4108adad250e9a$var$mg = $fe4108adad250e9a$var$kg[--$fe4108adad250e9a$var$lg], $fe4108adad250e9a$var$kg[$fe4108adad250e9a$var$lg] = null, $fe4108adad250e9a$var$ng = $fe4108adad250e9a$var$kg[--$fe4108adad250e9a$var$lg], $fe4108adad250e9a$var$kg[$fe4108adad250e9a$var$lg] = null;
    for(; a === $fe4108adad250e9a$var$qg;)$fe4108adad250e9a$var$qg = $fe4108adad250e9a$var$og[--$fe4108adad250e9a$var$pg], $fe4108adad250e9a$var$og[$fe4108adad250e9a$var$pg] = null, $fe4108adad250e9a$var$sg = $fe4108adad250e9a$var$og[--$fe4108adad250e9a$var$pg], $fe4108adad250e9a$var$og[$fe4108adad250e9a$var$pg] = null, $fe4108adad250e9a$var$rg = $fe4108adad250e9a$var$og[--$fe4108adad250e9a$var$pg], $fe4108adad250e9a$var$og[$fe4108adad250e9a$var$pg] = null;
}
var $fe4108adad250e9a$var$xg = null, $fe4108adad250e9a$var$yg = null, $fe4108adad250e9a$var$I = !1, $fe4108adad250e9a$var$zg = null;
function $fe4108adad250e9a$var$Ag(a, b) {
    var c = $fe4108adad250e9a$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $fe4108adad250e9a$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $fe4108adad250e9a$var$xg = a, $fe4108adad250e9a$var$yg = $fe4108adad250e9a$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $fe4108adad250e9a$var$xg = a, $fe4108adad250e9a$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $fe4108adad250e9a$var$qg ? {
                id: $fe4108adad250e9a$var$rg,
                overflow: $fe4108adad250e9a$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $fe4108adad250e9a$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $fe4108adad250e9a$var$xg = a, $fe4108adad250e9a$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $fe4108adad250e9a$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $fe4108adad250e9a$var$Eg(a) {
    if ($fe4108adad250e9a$var$I) {
        var b = $fe4108adad250e9a$var$yg;
        if (b) {
            var c = b;
            if (!$fe4108adad250e9a$var$Cg(a, b)) {
                if ($fe4108adad250e9a$var$Dg(a)) throw Error($fe4108adad250e9a$var$p(418));
                b = $fe4108adad250e9a$var$Lf(c.nextSibling);
                var d = $fe4108adad250e9a$var$xg;
                b && $fe4108adad250e9a$var$Cg(a, b) ? $fe4108adad250e9a$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $fe4108adad250e9a$var$I = !1, $fe4108adad250e9a$var$xg = a);
            }
        } else {
            if ($fe4108adad250e9a$var$Dg(a)) throw Error($fe4108adad250e9a$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $fe4108adad250e9a$var$I = !1;
            $fe4108adad250e9a$var$xg = a;
        }
    }
}
function $fe4108adad250e9a$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $fe4108adad250e9a$var$xg = a;
}
function $fe4108adad250e9a$var$Gg(a) {
    if (a !== $fe4108adad250e9a$var$xg) return !1;
    if (!$fe4108adad250e9a$var$I) return $fe4108adad250e9a$var$Fg(a), $fe4108adad250e9a$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$fe4108adad250e9a$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $fe4108adad250e9a$var$yg)) {
        if ($fe4108adad250e9a$var$Dg(a)) throw $fe4108adad250e9a$var$Hg(), Error($fe4108adad250e9a$var$p(418));
        for(; b;)$fe4108adad250e9a$var$Ag(a, b), b = $fe4108adad250e9a$var$Lf(b.nextSibling);
    }
    $fe4108adad250e9a$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($fe4108adad250e9a$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $fe4108adad250e9a$var$yg = $fe4108adad250e9a$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $fe4108adad250e9a$var$yg = null;
        }
    } else $fe4108adad250e9a$var$yg = $fe4108adad250e9a$var$xg ? $fe4108adad250e9a$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $fe4108adad250e9a$var$Hg() {
    for(var a = $fe4108adad250e9a$var$yg; a;)a = $fe4108adad250e9a$var$Lf(a.nextSibling);
}
function $fe4108adad250e9a$var$Ig() {
    $fe4108adad250e9a$var$yg = $fe4108adad250e9a$var$xg = null;
    $fe4108adad250e9a$var$I = !1;
}
function $fe4108adad250e9a$var$Jg(a) {
    null === $fe4108adad250e9a$var$zg ? $fe4108adad250e9a$var$zg = [
        a
    ] : $fe4108adad250e9a$var$zg.push(a);
}
var $fe4108adad250e9a$var$Kg = $fe4108adad250e9a$var$ua.ReactCurrentBatchConfig;
function $fe4108adad250e9a$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($fe4108adad250e9a$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($fe4108adad250e9a$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($fe4108adad250e9a$var$p(284));
        if (!c._owner) throw Error($fe4108adad250e9a$var$p(290, a));
    }
    return a;
}
function $fe4108adad250e9a$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($fe4108adad250e9a$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $fe4108adad250e9a$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $fe4108adad250e9a$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $fe4108adad250e9a$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $fe4108adad250e9a$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $fe4108adad250e9a$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $fe4108adad250e9a$var$Ha && $fe4108adad250e9a$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $fe4108adad250e9a$var$Lg(a, b, c), d.return = a, d;
        d = $fe4108adad250e9a$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $fe4108adad250e9a$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $fe4108adad250e9a$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $fe4108adad250e9a$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $fe4108adad250e9a$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $fe4108adad250e9a$var$va:
                    return c = $fe4108adad250e9a$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $fe4108adad250e9a$var$Lg(a, null, b), c.return = a, c;
                case $fe4108adad250e9a$var$wa:
                    return b = $fe4108adad250e9a$var$Sg(b, a.mode, c), b.return = a, b;
                case $fe4108adad250e9a$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($fe4108adad250e9a$var$eb(b) || $fe4108adad250e9a$var$Ka(b)) return b = $fe4108adad250e9a$var$Tg(b, a.mode, c, null), b.return = a, b;
            $fe4108adad250e9a$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $fe4108adad250e9a$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $fe4108adad250e9a$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $fe4108adad250e9a$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($fe4108adad250e9a$var$eb(c) || $fe4108adad250e9a$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $fe4108adad250e9a$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $fe4108adad250e9a$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $fe4108adad250e9a$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $fe4108adad250e9a$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($fe4108adad250e9a$var$eb(d) || $fe4108adad250e9a$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $fe4108adad250e9a$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $fe4108adad250e9a$var$I && $fe4108adad250e9a$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $fe4108adad250e9a$var$I && $fe4108adad250e9a$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $fe4108adad250e9a$var$I && $fe4108adad250e9a$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $fe4108adad250e9a$var$Ka(h);
        if ("function" !== typeof l) throw Error($fe4108adad250e9a$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($fe4108adad250e9a$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $fe4108adad250e9a$var$I && $fe4108adad250e9a$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $fe4108adad250e9a$var$I && $fe4108adad250e9a$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $fe4108adad250e9a$var$I && $fe4108adad250e9a$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $fe4108adad250e9a$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $fe4108adad250e9a$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $fe4108adad250e9a$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $fe4108adad250e9a$var$Ha && $fe4108adad250e9a$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $fe4108adad250e9a$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $fe4108adad250e9a$var$ya ? (d = $fe4108adad250e9a$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $fe4108adad250e9a$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $fe4108adad250e9a$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $fe4108adad250e9a$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $fe4108adad250e9a$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $fe4108adad250e9a$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($fe4108adad250e9a$var$eb(f)) return n(a, d, f, h);
            if ($fe4108adad250e9a$var$Ka(f)) return t(a, d, f, h);
            $fe4108adad250e9a$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $fe4108adad250e9a$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $fe4108adad250e9a$var$Ug = $fe4108adad250e9a$var$Og(!0), $fe4108adad250e9a$var$Vg = $fe4108adad250e9a$var$Og(!1), $fe4108adad250e9a$var$Wg = $fe4108adad250e9a$var$Uf(null), $fe4108adad250e9a$var$Xg = null, $fe4108adad250e9a$var$Yg = null, $fe4108adad250e9a$var$Zg = null;
function $fe4108adad250e9a$var$$g() {
    $fe4108adad250e9a$var$Zg = $fe4108adad250e9a$var$Yg = $fe4108adad250e9a$var$Xg = null;
}
function $fe4108adad250e9a$var$ah(a) {
    var b = $fe4108adad250e9a$var$Wg.current;
    $fe4108adad250e9a$var$E($fe4108adad250e9a$var$Wg);
    a._currentValue = b;
}
function $fe4108adad250e9a$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $fe4108adad250e9a$var$ch(a, b) {
    $fe4108adad250e9a$var$Xg = a;
    $fe4108adad250e9a$var$Zg = $fe4108adad250e9a$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($fe4108adad250e9a$var$dh = !0), a.firstContext = null);
}
function $fe4108adad250e9a$var$eh(a) {
    var b = a._currentValue;
    if ($fe4108adad250e9a$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $fe4108adad250e9a$var$Yg) {
            if (null === $fe4108adad250e9a$var$Xg) throw Error($fe4108adad250e9a$var$p(308));
            $fe4108adad250e9a$var$Yg = a;
            $fe4108adad250e9a$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $fe4108adad250e9a$var$Yg = $fe4108adad250e9a$var$Yg.next = a;
    }
    return b;
}
var $fe4108adad250e9a$var$fh = null;
function $fe4108adad250e9a$var$gh(a) {
    null === $fe4108adad250e9a$var$fh ? $fe4108adad250e9a$var$fh = [
        a
    ] : $fe4108adad250e9a$var$fh.push(a);
}
function $fe4108adad250e9a$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $fe4108adad250e9a$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $fe4108adad250e9a$var$ih(a, d);
}
function $fe4108adad250e9a$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $fe4108adad250e9a$var$jh = !1;
function $fe4108adad250e9a$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $fe4108adad250e9a$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $fe4108adad250e9a$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $fe4108adad250e9a$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($fe4108adad250e9a$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $fe4108adad250e9a$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $fe4108adad250e9a$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $fe4108adad250e9a$var$ih(a, c);
}
function $fe4108adad250e9a$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $fe4108adad250e9a$var$Cc(a, c);
    }
}
function $fe4108adad250e9a$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $fe4108adad250e9a$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $fe4108adad250e9a$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $fe4108adad250e9a$var$A({}, q, r);
                            break a;
                        case 2:
                            $fe4108adad250e9a$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $fe4108adad250e9a$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $fe4108adad250e9a$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($fe4108adad250e9a$var$p(191, e));
            e.call(d);
        }
    }
}
var $fe4108adad250e9a$var$th = {}, $fe4108adad250e9a$var$uh = $fe4108adad250e9a$var$Uf($fe4108adad250e9a$var$th), $fe4108adad250e9a$var$vh = $fe4108adad250e9a$var$Uf($fe4108adad250e9a$var$th), $fe4108adad250e9a$var$wh = $fe4108adad250e9a$var$Uf($fe4108adad250e9a$var$th);
function $fe4108adad250e9a$var$xh(a) {
    if (a === $fe4108adad250e9a$var$th) throw Error($fe4108adad250e9a$var$p(174));
    return a;
}
function $fe4108adad250e9a$var$yh(a, b) {
    $fe4108adad250e9a$var$G($fe4108adad250e9a$var$wh, b);
    $fe4108adad250e9a$var$G($fe4108adad250e9a$var$vh, a);
    $fe4108adad250e9a$var$G($fe4108adad250e9a$var$uh, $fe4108adad250e9a$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $fe4108adad250e9a$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $fe4108adad250e9a$var$lb(b, a);
    }
    $fe4108adad250e9a$var$E($fe4108adad250e9a$var$uh);
    $fe4108adad250e9a$var$G($fe4108adad250e9a$var$uh, b);
}
function $fe4108adad250e9a$var$zh() {
    $fe4108adad250e9a$var$E($fe4108adad250e9a$var$uh);
    $fe4108adad250e9a$var$E($fe4108adad250e9a$var$vh);
    $fe4108adad250e9a$var$E($fe4108adad250e9a$var$wh);
}
function $fe4108adad250e9a$var$Ah(a) {
    $fe4108adad250e9a$var$xh($fe4108adad250e9a$var$wh.current);
    var b = $fe4108adad250e9a$var$xh($fe4108adad250e9a$var$uh.current);
    var c = $fe4108adad250e9a$var$lb(b, a.type);
    b !== c && ($fe4108adad250e9a$var$G($fe4108adad250e9a$var$vh, a), $fe4108adad250e9a$var$G($fe4108adad250e9a$var$uh, c));
}
function $fe4108adad250e9a$var$Bh(a) {
    $fe4108adad250e9a$var$vh.current === a && ($fe4108adad250e9a$var$E($fe4108adad250e9a$var$uh), $fe4108adad250e9a$var$E($fe4108adad250e9a$var$vh));
}
var $fe4108adad250e9a$var$L = $fe4108adad250e9a$var$Uf(0);
function $fe4108adad250e9a$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $fe4108adad250e9a$var$Dh = [];
function $fe4108adad250e9a$var$Eh() {
    for(var a = 0; a < $fe4108adad250e9a$var$Dh.length; a++)$fe4108adad250e9a$var$Dh[a]._workInProgressVersionPrimary = null;
    $fe4108adad250e9a$var$Dh.length = 0;
}
var $fe4108adad250e9a$var$Fh = $fe4108adad250e9a$var$ua.ReactCurrentDispatcher, $fe4108adad250e9a$var$Gh = $fe4108adad250e9a$var$ua.ReactCurrentBatchConfig, $fe4108adad250e9a$var$Hh = 0, $fe4108adad250e9a$var$M = null, $fe4108adad250e9a$var$N = null, $fe4108adad250e9a$var$O = null, $fe4108adad250e9a$var$Ih = !1, $fe4108adad250e9a$var$Jh = !1, $fe4108adad250e9a$var$Kh = 0, $fe4108adad250e9a$var$Lh = 0;
function $fe4108adad250e9a$var$P() {
    throw Error($fe4108adad250e9a$var$p(321));
}
function $fe4108adad250e9a$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$fe4108adad250e9a$var$He(a[c], b[c])) return !1;
    return !0;
}
function $fe4108adad250e9a$var$Nh(a, b, c, d, e, f) {
    $fe4108adad250e9a$var$Hh = f;
    $fe4108adad250e9a$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $fe4108adad250e9a$var$Fh.current = null === a || null === a.memoizedState ? $fe4108adad250e9a$var$Oh : $fe4108adad250e9a$var$Ph;
    a = c(d, e);
    if ($fe4108adad250e9a$var$Jh) {
        f = 0;
        do {
            $fe4108adad250e9a$var$Jh = !1;
            $fe4108adad250e9a$var$Kh = 0;
            if (25 <= f) throw Error($fe4108adad250e9a$var$p(301));
            f += 1;
            $fe4108adad250e9a$var$O = $fe4108adad250e9a$var$N = null;
            b.updateQueue = null;
            $fe4108adad250e9a$var$Fh.current = $fe4108adad250e9a$var$Qh;
            a = c(d, e);
        }while ($fe4108adad250e9a$var$Jh);
    }
    $fe4108adad250e9a$var$Fh.current = $fe4108adad250e9a$var$Rh;
    b = null !== $fe4108adad250e9a$var$N && null !== $fe4108adad250e9a$var$N.next;
    $fe4108adad250e9a$var$Hh = 0;
    $fe4108adad250e9a$var$O = $fe4108adad250e9a$var$N = $fe4108adad250e9a$var$M = null;
    $fe4108adad250e9a$var$Ih = !1;
    if (b) throw Error($fe4108adad250e9a$var$p(300));
    return a;
}
function $fe4108adad250e9a$var$Sh() {
    var a = 0 !== $fe4108adad250e9a$var$Kh;
    $fe4108adad250e9a$var$Kh = 0;
    return a;
}
function $fe4108adad250e9a$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $fe4108adad250e9a$var$O ? $fe4108adad250e9a$var$M.memoizedState = $fe4108adad250e9a$var$O = a : $fe4108adad250e9a$var$O = $fe4108adad250e9a$var$O.next = a;
    return $fe4108adad250e9a$var$O;
}
function $fe4108adad250e9a$var$Uh() {
    if (null === $fe4108adad250e9a$var$N) {
        var a = $fe4108adad250e9a$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $fe4108adad250e9a$var$N.next;
    var b = null === $fe4108adad250e9a$var$O ? $fe4108adad250e9a$var$M.memoizedState : $fe4108adad250e9a$var$O.next;
    if (null !== b) $fe4108adad250e9a$var$O = b, $fe4108adad250e9a$var$N = a;
    else {
        if (null === a) throw Error($fe4108adad250e9a$var$p(310));
        $fe4108adad250e9a$var$N = a;
        a = {
            memoizedState: $fe4108adad250e9a$var$N.memoizedState,
            baseState: $fe4108adad250e9a$var$N.baseState,
            baseQueue: $fe4108adad250e9a$var$N.baseQueue,
            queue: $fe4108adad250e9a$var$N.queue,
            next: null
        };
        null === $fe4108adad250e9a$var$O ? $fe4108adad250e9a$var$M.memoizedState = $fe4108adad250e9a$var$O = a : $fe4108adad250e9a$var$O = $fe4108adad250e9a$var$O.next = a;
    }
    return $fe4108adad250e9a$var$O;
}
function $fe4108adad250e9a$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $fe4108adad250e9a$var$Wh(a) {
    var b = $fe4108adad250e9a$var$Uh(), c = b.queue;
    if (null === c) throw Error($fe4108adad250e9a$var$p(311));
    c.lastRenderedReducer = a;
    var d = $fe4108adad250e9a$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($fe4108adad250e9a$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $fe4108adad250e9a$var$M.lanes |= m;
                $fe4108adad250e9a$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $fe4108adad250e9a$var$He(d, b.memoizedState) || ($fe4108adad250e9a$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $fe4108adad250e9a$var$M.lanes |= f, $fe4108adad250e9a$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $fe4108adad250e9a$var$Xh(a) {
    var b = $fe4108adad250e9a$var$Uh(), c = b.queue;
    if (null === c) throw Error($fe4108adad250e9a$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $fe4108adad250e9a$var$He(f, b.memoizedState) || ($fe4108adad250e9a$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $fe4108adad250e9a$var$Yh() {}
function $fe4108adad250e9a$var$Zh(a, b) {
    var c = $fe4108adad250e9a$var$M, d = $fe4108adad250e9a$var$Uh(), e = b(), f = !$fe4108adad250e9a$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $fe4108adad250e9a$var$dh = !0);
    d = d.queue;
    $fe4108adad250e9a$var$$h($fe4108adad250e9a$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $fe4108adad250e9a$var$O && $fe4108adad250e9a$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $fe4108adad250e9a$var$bi(9, $fe4108adad250e9a$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $fe4108adad250e9a$var$Q) throw Error($fe4108adad250e9a$var$p(349));
        0 !== ($fe4108adad250e9a$var$Hh & 30) || $fe4108adad250e9a$var$di(c, b, e);
    }
    return e;
}
function $fe4108adad250e9a$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $fe4108adad250e9a$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $fe4108adad250e9a$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $fe4108adad250e9a$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $fe4108adad250e9a$var$ei(b) && $fe4108adad250e9a$var$fi(a);
}
function $fe4108adad250e9a$var$ai(a, b, c) {
    return c(function() {
        $fe4108adad250e9a$var$ei(b) && $fe4108adad250e9a$var$fi(a);
    });
}
function $fe4108adad250e9a$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$fe4108adad250e9a$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $fe4108adad250e9a$var$fi(a) {
    var b = $fe4108adad250e9a$var$ih(a, 1);
    null !== b && $fe4108adad250e9a$var$gi(b, a, 1, -1);
}
function $fe4108adad250e9a$var$hi(a) {
    var b = $fe4108adad250e9a$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $fe4108adad250e9a$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $fe4108adad250e9a$var$ii.bind(null, $fe4108adad250e9a$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $fe4108adad250e9a$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $fe4108adad250e9a$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $fe4108adad250e9a$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $fe4108adad250e9a$var$ji() {
    return $fe4108adad250e9a$var$Uh().memoizedState;
}
function $fe4108adad250e9a$var$ki(a, b, c, d) {
    var e = $fe4108adad250e9a$var$Th();
    $fe4108adad250e9a$var$M.flags |= a;
    e.memoizedState = $fe4108adad250e9a$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $fe4108adad250e9a$var$li(a, b, c, d) {
    var e = $fe4108adad250e9a$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $fe4108adad250e9a$var$N) {
        var g = $fe4108adad250e9a$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $fe4108adad250e9a$var$Mh(d, g.deps)) {
            e.memoizedState = $fe4108adad250e9a$var$bi(b, c, f, d);
            return;
        }
    }
    $fe4108adad250e9a$var$M.flags |= a;
    e.memoizedState = $fe4108adad250e9a$var$bi(1 | b, c, f, d);
}
function $fe4108adad250e9a$var$mi(a, b) {
    return $fe4108adad250e9a$var$ki(8390656, 8, a, b);
}
function $fe4108adad250e9a$var$$h(a, b) {
    return $fe4108adad250e9a$var$li(2048, 8, a, b);
}
function $fe4108adad250e9a$var$ni(a, b) {
    return $fe4108adad250e9a$var$li(4, 2, a, b);
}
function $fe4108adad250e9a$var$oi(a, b) {
    return $fe4108adad250e9a$var$li(4, 4, a, b);
}
function $fe4108adad250e9a$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $fe4108adad250e9a$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $fe4108adad250e9a$var$li(4, 4, $fe4108adad250e9a$var$pi.bind(null, b, a), c);
}
function $fe4108adad250e9a$var$ri() {}
function $fe4108adad250e9a$var$si(a, b) {
    var c = $fe4108adad250e9a$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $fe4108adad250e9a$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $fe4108adad250e9a$var$ti(a, b) {
    var c = $fe4108adad250e9a$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $fe4108adad250e9a$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $fe4108adad250e9a$var$ui(a, b, c) {
    if (0 === ($fe4108adad250e9a$var$Hh & 21)) return a.baseState && (a.baseState = !1, $fe4108adad250e9a$var$dh = !0), a.memoizedState = c;
    $fe4108adad250e9a$var$He(c, b) || (c = $fe4108adad250e9a$var$yc(), $fe4108adad250e9a$var$M.lanes |= c, $fe4108adad250e9a$var$rh |= c, a.baseState = !0);
    return b;
}
function $fe4108adad250e9a$var$vi(a, b) {
    var c = $fe4108adad250e9a$var$C;
    $fe4108adad250e9a$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $fe4108adad250e9a$var$Gh.transition;
    $fe4108adad250e9a$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $fe4108adad250e9a$var$C = c, $fe4108adad250e9a$var$Gh.transition = d;
    }
}
function $fe4108adad250e9a$var$wi() {
    return $fe4108adad250e9a$var$Uh().memoizedState;
}
function $fe4108adad250e9a$var$xi(a, b, c) {
    var d = $fe4108adad250e9a$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($fe4108adad250e9a$var$zi(a)) $fe4108adad250e9a$var$Ai(b, c);
    else if (c = $fe4108adad250e9a$var$hh(a, b, c, d), null !== c) {
        var e = $fe4108adad250e9a$var$R();
        $fe4108adad250e9a$var$gi(c, a, d, e);
        $fe4108adad250e9a$var$Bi(c, b, d);
    }
}
function $fe4108adad250e9a$var$ii(a, b, c) {
    var d = $fe4108adad250e9a$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($fe4108adad250e9a$var$zi(a)) $fe4108adad250e9a$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($fe4108adad250e9a$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $fe4108adad250e9a$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $fe4108adad250e9a$var$hh(a, b, e, d);
        null !== c && (e = $fe4108adad250e9a$var$R(), $fe4108adad250e9a$var$gi(c, a, d, e), $fe4108adad250e9a$var$Bi(c, b, d));
    }
}
function $fe4108adad250e9a$var$zi(a) {
    var b = a.alternate;
    return a === $fe4108adad250e9a$var$M || null !== b && b === $fe4108adad250e9a$var$M;
}
function $fe4108adad250e9a$var$Ai(a, b) {
    $fe4108adad250e9a$var$Jh = $fe4108adad250e9a$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $fe4108adad250e9a$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $fe4108adad250e9a$var$Cc(a, c);
    }
}
var $fe4108adad250e9a$var$Rh = {
    readContext: $fe4108adad250e9a$var$eh,
    useCallback: $fe4108adad250e9a$var$P,
    useContext: $fe4108adad250e9a$var$P,
    useEffect: $fe4108adad250e9a$var$P,
    useImperativeHandle: $fe4108adad250e9a$var$P,
    useInsertionEffect: $fe4108adad250e9a$var$P,
    useLayoutEffect: $fe4108adad250e9a$var$P,
    useMemo: $fe4108adad250e9a$var$P,
    useReducer: $fe4108adad250e9a$var$P,
    useRef: $fe4108adad250e9a$var$P,
    useState: $fe4108adad250e9a$var$P,
    useDebugValue: $fe4108adad250e9a$var$P,
    useDeferredValue: $fe4108adad250e9a$var$P,
    useTransition: $fe4108adad250e9a$var$P,
    useMutableSource: $fe4108adad250e9a$var$P,
    useSyncExternalStore: $fe4108adad250e9a$var$P,
    useId: $fe4108adad250e9a$var$P,
    unstable_isNewReconciler: !1
}, $fe4108adad250e9a$var$Oh = {
    readContext: $fe4108adad250e9a$var$eh,
    useCallback: function(a, b) {
        $fe4108adad250e9a$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $fe4108adad250e9a$var$eh,
    useEffect: $fe4108adad250e9a$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $fe4108adad250e9a$var$ki(4194308, 4, $fe4108adad250e9a$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $fe4108adad250e9a$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $fe4108adad250e9a$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $fe4108adad250e9a$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $fe4108adad250e9a$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $fe4108adad250e9a$var$xi.bind(null, $fe4108adad250e9a$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $fe4108adad250e9a$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $fe4108adad250e9a$var$hi,
    useDebugValue: $fe4108adad250e9a$var$ri,
    useDeferredValue: function(a) {
        return $fe4108adad250e9a$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $fe4108adad250e9a$var$hi(!1), b = a[0];
        a = $fe4108adad250e9a$var$vi.bind(null, a[1]);
        $fe4108adad250e9a$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $fe4108adad250e9a$var$M, e = $fe4108adad250e9a$var$Th();
        if ($fe4108adad250e9a$var$I) {
            if (void 0 === c) throw Error($fe4108adad250e9a$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $fe4108adad250e9a$var$Q) throw Error($fe4108adad250e9a$var$p(349));
            0 !== ($fe4108adad250e9a$var$Hh & 30) || $fe4108adad250e9a$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $fe4108adad250e9a$var$mi($fe4108adad250e9a$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $fe4108adad250e9a$var$bi(9, $fe4108adad250e9a$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $fe4108adad250e9a$var$Th(), b = $fe4108adad250e9a$var$Q.identifierPrefix;
        if ($fe4108adad250e9a$var$I) {
            var c = $fe4108adad250e9a$var$sg;
            var d = $fe4108adad250e9a$var$rg;
            c = (d & ~(1 << 32 - $fe4108adad250e9a$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $fe4108adad250e9a$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $fe4108adad250e9a$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $fe4108adad250e9a$var$Ph = {
    readContext: $fe4108adad250e9a$var$eh,
    useCallback: $fe4108adad250e9a$var$si,
    useContext: $fe4108adad250e9a$var$eh,
    useEffect: $fe4108adad250e9a$var$$h,
    useImperativeHandle: $fe4108adad250e9a$var$qi,
    useInsertionEffect: $fe4108adad250e9a$var$ni,
    useLayoutEffect: $fe4108adad250e9a$var$oi,
    useMemo: $fe4108adad250e9a$var$ti,
    useReducer: $fe4108adad250e9a$var$Wh,
    useRef: $fe4108adad250e9a$var$ji,
    useState: function() {
        return $fe4108adad250e9a$var$Wh($fe4108adad250e9a$var$Vh);
    },
    useDebugValue: $fe4108adad250e9a$var$ri,
    useDeferredValue: function(a) {
        var b = $fe4108adad250e9a$var$Uh();
        return $fe4108adad250e9a$var$ui(b, $fe4108adad250e9a$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $fe4108adad250e9a$var$Wh($fe4108adad250e9a$var$Vh)[0], b = $fe4108adad250e9a$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $fe4108adad250e9a$var$Yh,
    useSyncExternalStore: $fe4108adad250e9a$var$Zh,
    useId: $fe4108adad250e9a$var$wi,
    unstable_isNewReconciler: !1
}, $fe4108adad250e9a$var$Qh = {
    readContext: $fe4108adad250e9a$var$eh,
    useCallback: $fe4108adad250e9a$var$si,
    useContext: $fe4108adad250e9a$var$eh,
    useEffect: $fe4108adad250e9a$var$$h,
    useImperativeHandle: $fe4108adad250e9a$var$qi,
    useInsertionEffect: $fe4108adad250e9a$var$ni,
    useLayoutEffect: $fe4108adad250e9a$var$oi,
    useMemo: $fe4108adad250e9a$var$ti,
    useReducer: $fe4108adad250e9a$var$Xh,
    useRef: $fe4108adad250e9a$var$ji,
    useState: function() {
        return $fe4108adad250e9a$var$Xh($fe4108adad250e9a$var$Vh);
    },
    useDebugValue: $fe4108adad250e9a$var$ri,
    useDeferredValue: function(a) {
        var b = $fe4108adad250e9a$var$Uh();
        return null === $fe4108adad250e9a$var$N ? b.memoizedState = a : $fe4108adad250e9a$var$ui(b, $fe4108adad250e9a$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $fe4108adad250e9a$var$Xh($fe4108adad250e9a$var$Vh)[0], b = $fe4108adad250e9a$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $fe4108adad250e9a$var$Yh,
    useSyncExternalStore: $fe4108adad250e9a$var$Zh,
    useId: $fe4108adad250e9a$var$wi,
    unstable_isNewReconciler: !1
};
function $fe4108adad250e9a$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $fe4108adad250e9a$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $fe4108adad250e9a$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $fe4108adad250e9a$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $fe4108adad250e9a$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $fe4108adad250e9a$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $fe4108adad250e9a$var$R(), e = $fe4108adad250e9a$var$yi(a), f = $fe4108adad250e9a$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $fe4108adad250e9a$var$nh(a, f, e);
        null !== b && ($fe4108adad250e9a$var$gi(b, a, e, d), $fe4108adad250e9a$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $fe4108adad250e9a$var$R(), e = $fe4108adad250e9a$var$yi(a), f = $fe4108adad250e9a$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $fe4108adad250e9a$var$nh(a, f, e);
        null !== b && ($fe4108adad250e9a$var$gi(b, a, e, d), $fe4108adad250e9a$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $fe4108adad250e9a$var$R(), d = $fe4108adad250e9a$var$yi(a), e = $fe4108adad250e9a$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $fe4108adad250e9a$var$nh(a, e, d);
        null !== b && ($fe4108adad250e9a$var$gi(b, a, d, c), $fe4108adad250e9a$var$oh(b, a, d));
    }
};
function $fe4108adad250e9a$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$fe4108adad250e9a$var$Ie(c, d) || !$fe4108adad250e9a$var$Ie(e, f) : !0;
}
function $fe4108adad250e9a$var$Gi(a, b, c) {
    var d = !1, e = $fe4108adad250e9a$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $fe4108adad250e9a$var$eh(f) : (e = $fe4108adad250e9a$var$Zf(b) ? $fe4108adad250e9a$var$Xf : $fe4108adad250e9a$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $fe4108adad250e9a$var$Yf(a, e) : $fe4108adad250e9a$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $fe4108adad250e9a$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $fe4108adad250e9a$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $fe4108adad250e9a$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $fe4108adad250e9a$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $fe4108adad250e9a$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $fe4108adad250e9a$var$eh(f) : (f = $fe4108adad250e9a$var$Zf(b) ? $fe4108adad250e9a$var$Xf : $fe4108adad250e9a$var$H.current, e.context = $fe4108adad250e9a$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($fe4108adad250e9a$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $fe4108adad250e9a$var$Ei.enqueueReplaceState(e, e.state, null), $fe4108adad250e9a$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $fe4108adad250e9a$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $fe4108adad250e9a$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $fe4108adad250e9a$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $fe4108adad250e9a$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $fe4108adad250e9a$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $fe4108adad250e9a$var$Ni(a, b, c) {
    c = $fe4108adad250e9a$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $fe4108adad250e9a$var$Oi || ($fe4108adad250e9a$var$Oi = !0, $fe4108adad250e9a$var$Pi = d);
        $fe4108adad250e9a$var$Li(a, b);
    };
    return c;
}
function $fe4108adad250e9a$var$Qi(a, b, c) {
    c = $fe4108adad250e9a$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $fe4108adad250e9a$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $fe4108adad250e9a$var$Li(a, b);
        "function" !== typeof d && (null === $fe4108adad250e9a$var$Ri ? $fe4108adad250e9a$var$Ri = new Set([
            this
        ]) : $fe4108adad250e9a$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $fe4108adad250e9a$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $fe4108adad250e9a$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $fe4108adad250e9a$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $fe4108adad250e9a$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $fe4108adad250e9a$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $fe4108adad250e9a$var$mh(-1, 1), b.tag = 2, $fe4108adad250e9a$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $fe4108adad250e9a$var$Wi = $fe4108adad250e9a$var$ua.ReactCurrentOwner, $fe4108adad250e9a$var$dh = !1;
function $fe4108adad250e9a$var$Xi(a, b, c, d) {
    b.child = null === a ? $fe4108adad250e9a$var$Vg(b, null, c, d) : $fe4108adad250e9a$var$Ug(b, a.child, c, d);
}
function $fe4108adad250e9a$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $fe4108adad250e9a$var$ch(b, e);
    d = $fe4108adad250e9a$var$Nh(a, b, c, d, f, e);
    c = $fe4108adad250e9a$var$Sh();
    if (null !== a && !$fe4108adad250e9a$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $fe4108adad250e9a$var$Zi(a, b, e);
    $fe4108adad250e9a$var$I && c && $fe4108adad250e9a$var$vg(b);
    b.flags |= 1;
    $fe4108adad250e9a$var$Xi(a, b, d, e);
    return b.child;
}
function $fe4108adad250e9a$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$fe4108adad250e9a$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $fe4108adad250e9a$var$bj(a, b, f, d, e);
        a = $fe4108adad250e9a$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $fe4108adad250e9a$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $fe4108adad250e9a$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $fe4108adad250e9a$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $fe4108adad250e9a$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($fe4108adad250e9a$var$Ie(f, d) && a.ref === b.ref) {
            if ($fe4108adad250e9a$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($fe4108adad250e9a$var$dh = !0);
            else return b.lanes = a.lanes, $fe4108adad250e9a$var$Zi(a, b, e);
        }
    }
    return $fe4108adad250e9a$var$cj(a, b, c, d, e);
}
function $fe4108adad250e9a$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $fe4108adad250e9a$var$G($fe4108adad250e9a$var$ej, $fe4108adad250e9a$var$fj), $fe4108adad250e9a$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $fe4108adad250e9a$var$G($fe4108adad250e9a$var$ej, $fe4108adad250e9a$var$fj), $fe4108adad250e9a$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $fe4108adad250e9a$var$G($fe4108adad250e9a$var$ej, $fe4108adad250e9a$var$fj);
            $fe4108adad250e9a$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $fe4108adad250e9a$var$G($fe4108adad250e9a$var$ej, $fe4108adad250e9a$var$fj), $fe4108adad250e9a$var$fj |= d;
    $fe4108adad250e9a$var$Xi(a, b, e, c);
    return b.child;
}
function $fe4108adad250e9a$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $fe4108adad250e9a$var$cj(a, b, c, d, e) {
    var f = $fe4108adad250e9a$var$Zf(c) ? $fe4108adad250e9a$var$Xf : $fe4108adad250e9a$var$H.current;
    f = $fe4108adad250e9a$var$Yf(b, f);
    $fe4108adad250e9a$var$ch(b, e);
    c = $fe4108adad250e9a$var$Nh(a, b, c, d, f, e);
    d = $fe4108adad250e9a$var$Sh();
    if (null !== a && !$fe4108adad250e9a$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $fe4108adad250e9a$var$Zi(a, b, e);
    $fe4108adad250e9a$var$I && d && $fe4108adad250e9a$var$vg(b);
    b.flags |= 1;
    $fe4108adad250e9a$var$Xi(a, b, c, e);
    return b.child;
}
function $fe4108adad250e9a$var$hj(a, b, c, d, e) {
    if ($fe4108adad250e9a$var$Zf(c)) {
        var f = !0;
        $fe4108adad250e9a$var$cg(b);
    } else f = !1;
    $fe4108adad250e9a$var$ch(b, e);
    if (null === b.stateNode) $fe4108adad250e9a$var$ij(a, b), $fe4108adad250e9a$var$Gi(b, c, d), $fe4108adad250e9a$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $fe4108adad250e9a$var$eh(l) : (l = $fe4108adad250e9a$var$Zf(c) ? $fe4108adad250e9a$var$Xf : $fe4108adad250e9a$var$H.current, l = $fe4108adad250e9a$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $fe4108adad250e9a$var$Hi(b, g, d, l);
        $fe4108adad250e9a$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $fe4108adad250e9a$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $fe4108adad250e9a$var$Wf.current || $fe4108adad250e9a$var$jh ? ("function" === typeof m && ($fe4108adad250e9a$var$Di(b, c, m, d), k = b.memoizedState), (h = $fe4108adad250e9a$var$jh || $fe4108adad250e9a$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $fe4108adad250e9a$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $fe4108adad250e9a$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $fe4108adad250e9a$var$eh(k) : (k = $fe4108adad250e9a$var$Zf(c) ? $fe4108adad250e9a$var$Xf : $fe4108adad250e9a$var$H.current, k = $fe4108adad250e9a$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $fe4108adad250e9a$var$Hi(b, g, d, k);
        $fe4108adad250e9a$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $fe4108adad250e9a$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $fe4108adad250e9a$var$Wf.current || $fe4108adad250e9a$var$jh ? ("function" === typeof y && ($fe4108adad250e9a$var$Di(b, c, y, d), n = b.memoizedState), (l = $fe4108adad250e9a$var$jh || $fe4108adad250e9a$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $fe4108adad250e9a$var$jj(a, b, c, d, f, e);
}
function $fe4108adad250e9a$var$jj(a, b, c, d, e, f) {
    $fe4108adad250e9a$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $fe4108adad250e9a$var$dg(b, c, !1), $fe4108adad250e9a$var$Zi(a, b, f);
    d = b.stateNode;
    $fe4108adad250e9a$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $fe4108adad250e9a$var$Ug(b, a.child, null, f), b.child = $fe4108adad250e9a$var$Ug(b, null, h, f)) : $fe4108adad250e9a$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $fe4108adad250e9a$var$dg(b, c, !0);
    return b.child;
}
function $fe4108adad250e9a$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $fe4108adad250e9a$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $fe4108adad250e9a$var$ag(a, b.context, !1);
    $fe4108adad250e9a$var$yh(a, b.containerInfo);
}
function $fe4108adad250e9a$var$lj(a, b, c, d, e) {
    $fe4108adad250e9a$var$Ig();
    $fe4108adad250e9a$var$Jg(e);
    b.flags |= 256;
    $fe4108adad250e9a$var$Xi(a, b, c, d);
    return b.child;
}
var $fe4108adad250e9a$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $fe4108adad250e9a$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $fe4108adad250e9a$var$oj(a, b, c) {
    var d = b.pendingProps, e = $fe4108adad250e9a$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $fe4108adad250e9a$var$G($fe4108adad250e9a$var$L, e & 1);
    if (null === a) {
        $fe4108adad250e9a$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $fe4108adad250e9a$var$pj(g, d, 0, null), a = $fe4108adad250e9a$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $fe4108adad250e9a$var$nj(c), b.memoizedState = $fe4108adad250e9a$var$mj, a) : $fe4108adad250e9a$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $fe4108adad250e9a$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $fe4108adad250e9a$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $fe4108adad250e9a$var$Pg(h, f) : (f = $fe4108adad250e9a$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $fe4108adad250e9a$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $fe4108adad250e9a$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $fe4108adad250e9a$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $fe4108adad250e9a$var$qj(a, b) {
    b = $fe4108adad250e9a$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $fe4108adad250e9a$var$sj(a, b, c, d) {
    null !== d && $fe4108adad250e9a$var$Jg(d);
    $fe4108adad250e9a$var$Ug(b, a.child, null, c);
    a = $fe4108adad250e9a$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $fe4108adad250e9a$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $fe4108adad250e9a$var$Ki(Error($fe4108adad250e9a$var$p(422))), $fe4108adad250e9a$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $fe4108adad250e9a$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $fe4108adad250e9a$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $fe4108adad250e9a$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $fe4108adad250e9a$var$nj(g);
        b.memoizedState = $fe4108adad250e9a$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $fe4108adad250e9a$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($fe4108adad250e9a$var$p(419));
        d = $fe4108adad250e9a$var$Ki(f, d, void 0);
        return $fe4108adad250e9a$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($fe4108adad250e9a$var$dh || h) {
        d = $fe4108adad250e9a$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $fe4108adad250e9a$var$ih(a, e), $fe4108adad250e9a$var$gi(d, a, e, -1));
        }
        $fe4108adad250e9a$var$tj();
        d = $fe4108adad250e9a$var$Ki(Error($fe4108adad250e9a$var$p(421)));
        return $fe4108adad250e9a$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $fe4108adad250e9a$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $fe4108adad250e9a$var$yg = $fe4108adad250e9a$var$Lf(e.nextSibling);
    $fe4108adad250e9a$var$xg = b;
    $fe4108adad250e9a$var$I = !0;
    $fe4108adad250e9a$var$zg = null;
    null !== a && ($fe4108adad250e9a$var$og[$fe4108adad250e9a$var$pg++] = $fe4108adad250e9a$var$rg, $fe4108adad250e9a$var$og[$fe4108adad250e9a$var$pg++] = $fe4108adad250e9a$var$sg, $fe4108adad250e9a$var$og[$fe4108adad250e9a$var$pg++] = $fe4108adad250e9a$var$qg, $fe4108adad250e9a$var$rg = a.id, $fe4108adad250e9a$var$sg = a.overflow, $fe4108adad250e9a$var$qg = b);
    b = $fe4108adad250e9a$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $fe4108adad250e9a$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $fe4108adad250e9a$var$bh(a.return, b, c);
}
function $fe4108adad250e9a$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $fe4108adad250e9a$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $fe4108adad250e9a$var$Xi(a, b, d.children, c);
    d = $fe4108adad250e9a$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $fe4108adad250e9a$var$vj(a, c, b);
            else if (19 === a.tag) $fe4108adad250e9a$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $fe4108adad250e9a$var$G($fe4108adad250e9a$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $fe4108adad250e9a$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $fe4108adad250e9a$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $fe4108adad250e9a$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $fe4108adad250e9a$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $fe4108adad250e9a$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $fe4108adad250e9a$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $fe4108adad250e9a$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $fe4108adad250e9a$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($fe4108adad250e9a$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $fe4108adad250e9a$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $fe4108adad250e9a$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $fe4108adad250e9a$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $fe4108adad250e9a$var$kj(b);
            $fe4108adad250e9a$var$Ig();
            break;
        case 5:
            $fe4108adad250e9a$var$Ah(b);
            break;
        case 1:
            $fe4108adad250e9a$var$Zf(b.type) && $fe4108adad250e9a$var$cg(b);
            break;
        case 4:
            $fe4108adad250e9a$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $fe4108adad250e9a$var$G($fe4108adad250e9a$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $fe4108adad250e9a$var$G($fe4108adad250e9a$var$L, $fe4108adad250e9a$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $fe4108adad250e9a$var$oj(a, b, c);
                $fe4108adad250e9a$var$G($fe4108adad250e9a$var$L, $fe4108adad250e9a$var$L.current & 1);
                a = $fe4108adad250e9a$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $fe4108adad250e9a$var$G($fe4108adad250e9a$var$L, $fe4108adad250e9a$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $fe4108adad250e9a$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $fe4108adad250e9a$var$G($fe4108adad250e9a$var$L, $fe4108adad250e9a$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $fe4108adad250e9a$var$dj(a, b, c);
    }
    return $fe4108adad250e9a$var$Zi(a, b, c);
}
var $fe4108adad250e9a$var$zj, $fe4108adad250e9a$var$Aj, $fe4108adad250e9a$var$Bj, $fe4108adad250e9a$var$Cj;
$fe4108adad250e9a$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$fe4108adad250e9a$var$Aj = function() {};
$fe4108adad250e9a$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $fe4108adad250e9a$var$xh($fe4108adad250e9a$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $fe4108adad250e9a$var$Ya(a, e);
                d = $fe4108adad250e9a$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $fe4108adad250e9a$var$A({}, e, {
                    value: void 0
                });
                d = $fe4108adad250e9a$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $fe4108adad250e9a$var$gb(a, e);
                d = $fe4108adad250e9a$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $fe4108adad250e9a$var$Bf);
        }
        $fe4108adad250e9a$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($fe4108adad250e9a$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($fe4108adad250e9a$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $fe4108adad250e9a$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$fe4108adad250e9a$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $fe4108adad250e9a$var$Dj(a, b) {
    if (!$fe4108adad250e9a$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $fe4108adad250e9a$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $fe4108adad250e9a$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $fe4108adad250e9a$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $fe4108adad250e9a$var$S(b), null;
        case 1:
            return $fe4108adad250e9a$var$Zf(b.type) && $fe4108adad250e9a$var$$f(), $fe4108adad250e9a$var$S(b), null;
        case 3:
            d = b.stateNode;
            $fe4108adad250e9a$var$zh();
            $fe4108adad250e9a$var$E($fe4108adad250e9a$var$Wf);
            $fe4108adad250e9a$var$E($fe4108adad250e9a$var$H);
            $fe4108adad250e9a$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $fe4108adad250e9a$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $fe4108adad250e9a$var$zg && ($fe4108adad250e9a$var$Fj($fe4108adad250e9a$var$zg), $fe4108adad250e9a$var$zg = null));
            $fe4108adad250e9a$var$Aj(a, b);
            $fe4108adad250e9a$var$S(b);
            return null;
        case 5:
            $fe4108adad250e9a$var$Bh(b);
            var e = $fe4108adad250e9a$var$xh($fe4108adad250e9a$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $fe4108adad250e9a$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($fe4108adad250e9a$var$p(166));
                    $fe4108adad250e9a$var$S(b);
                    return null;
                }
                a = $fe4108adad250e9a$var$xh($fe4108adad250e9a$var$uh.current);
                if ($fe4108adad250e9a$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$fe4108adad250e9a$var$Of] = b;
                    d[$fe4108adad250e9a$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $fe4108adad250e9a$var$D("cancel", d);
                            $fe4108adad250e9a$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $fe4108adad250e9a$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $fe4108adad250e9a$var$lf.length; e++)$fe4108adad250e9a$var$D($fe4108adad250e9a$var$lf[e], d);
                            break;
                        case "source":
                            $fe4108adad250e9a$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $fe4108adad250e9a$var$D("error", d);
                            $fe4108adad250e9a$var$D("load", d);
                            break;
                        case "details":
                            $fe4108adad250e9a$var$D("toggle", d);
                            break;
                        case "input":
                            $fe4108adad250e9a$var$Za(d, f);
                            $fe4108adad250e9a$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $fe4108adad250e9a$var$D("invalid", d);
                            break;
                        case "textarea":
                            $fe4108adad250e9a$var$hb(d, f), $fe4108adad250e9a$var$D("invalid", d);
                    }
                    $fe4108adad250e9a$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $fe4108adad250e9a$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $fe4108adad250e9a$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $fe4108adad250e9a$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $fe4108adad250e9a$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $fe4108adad250e9a$var$Va(d);
                            $fe4108adad250e9a$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $fe4108adad250e9a$var$Va(d);
                            $fe4108adad250e9a$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $fe4108adad250e9a$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $fe4108adad250e9a$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$fe4108adad250e9a$var$Of] = b;
                    a[$fe4108adad250e9a$var$Pf] = d;
                    $fe4108adad250e9a$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $fe4108adad250e9a$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $fe4108adad250e9a$var$D("cancel", a);
                                $fe4108adad250e9a$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $fe4108adad250e9a$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $fe4108adad250e9a$var$lf.length; e++)$fe4108adad250e9a$var$D($fe4108adad250e9a$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $fe4108adad250e9a$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $fe4108adad250e9a$var$D("error", a);
                                $fe4108adad250e9a$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $fe4108adad250e9a$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $fe4108adad250e9a$var$Za(a, d);
                                e = $fe4108adad250e9a$var$Ya(a, d);
                                $fe4108adad250e9a$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $fe4108adad250e9a$var$A({}, d, {
                                    value: void 0
                                });
                                $fe4108adad250e9a$var$D("invalid", a);
                                break;
                            case "textarea":
                                $fe4108adad250e9a$var$hb(a, d);
                                e = $fe4108adad250e9a$var$gb(a, d);
                                $fe4108adad250e9a$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $fe4108adad250e9a$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $fe4108adad250e9a$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $fe4108adad250e9a$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $fe4108adad250e9a$var$ob(a, k) : "number" === typeof k && $fe4108adad250e9a$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($fe4108adad250e9a$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $fe4108adad250e9a$var$D("scroll", a) : null != k && $fe4108adad250e9a$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $fe4108adad250e9a$var$Va(a);
                                $fe4108adad250e9a$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $fe4108adad250e9a$var$Va(a);
                                $fe4108adad250e9a$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $fe4108adad250e9a$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $fe4108adad250e9a$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $fe4108adad250e9a$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $fe4108adad250e9a$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $fe4108adad250e9a$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $fe4108adad250e9a$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($fe4108adad250e9a$var$p(166));
                c = $fe4108adad250e9a$var$xh($fe4108adad250e9a$var$wh.current);
                $fe4108adad250e9a$var$xh($fe4108adad250e9a$var$uh.current);
                if ($fe4108adad250e9a$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$fe4108adad250e9a$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $fe4108adad250e9a$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $fe4108adad250e9a$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $fe4108adad250e9a$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$fe4108adad250e9a$var$Of] = b, b.stateNode = d;
            }
            $fe4108adad250e9a$var$S(b);
            return null;
        case 13:
            $fe4108adad250e9a$var$E($fe4108adad250e9a$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($fe4108adad250e9a$var$I && null !== $fe4108adad250e9a$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $fe4108adad250e9a$var$Hg(), $fe4108adad250e9a$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $fe4108adad250e9a$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($fe4108adad250e9a$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($fe4108adad250e9a$var$p(317));
                        f[$fe4108adad250e9a$var$Of] = b;
                    } else $fe4108adad250e9a$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $fe4108adad250e9a$var$S(b);
                    f = !1;
                } else null !== $fe4108adad250e9a$var$zg && ($fe4108adad250e9a$var$Fj($fe4108adad250e9a$var$zg), $fe4108adad250e9a$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($fe4108adad250e9a$var$L.current & 1) ? 0 === $fe4108adad250e9a$var$T && ($fe4108adad250e9a$var$T = 3) : $fe4108adad250e9a$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $fe4108adad250e9a$var$S(b);
            return null;
        case 4:
            return $fe4108adad250e9a$var$zh(), $fe4108adad250e9a$var$Aj(a, b), null === a && $fe4108adad250e9a$var$sf(b.stateNode.containerInfo), $fe4108adad250e9a$var$S(b), null;
        case 10:
            return $fe4108adad250e9a$var$ah(b.type._context), $fe4108adad250e9a$var$S(b), null;
        case 17:
            return $fe4108adad250e9a$var$Zf(b.type) && $fe4108adad250e9a$var$$f(), $fe4108adad250e9a$var$S(b), null;
        case 19:
            $fe4108adad250e9a$var$E($fe4108adad250e9a$var$L);
            f = b.memoizedState;
            if (null === f) return $fe4108adad250e9a$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $fe4108adad250e9a$var$Dj(f, !1);
                else {
                    if (0 !== $fe4108adad250e9a$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $fe4108adad250e9a$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $fe4108adad250e9a$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $fe4108adad250e9a$var$G($fe4108adad250e9a$var$L, $fe4108adad250e9a$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $fe4108adad250e9a$var$B() > $fe4108adad250e9a$var$Gj && (b.flags |= 128, d = !0, $fe4108adad250e9a$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $fe4108adad250e9a$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $fe4108adad250e9a$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$fe4108adad250e9a$var$I) return $fe4108adad250e9a$var$S(b), null;
                    } else 2 * $fe4108adad250e9a$var$B() - f.renderingStartTime > $fe4108adad250e9a$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $fe4108adad250e9a$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $fe4108adad250e9a$var$B(), b.sibling = null, c = $fe4108adad250e9a$var$L.current, $fe4108adad250e9a$var$G($fe4108adad250e9a$var$L, d ? c & 1 | 2 : c & 1), b;
            $fe4108adad250e9a$var$S(b);
            return null;
        case 22:
        case 23:
            return $fe4108adad250e9a$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($fe4108adad250e9a$var$fj & 1073741824) && ($fe4108adad250e9a$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $fe4108adad250e9a$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($fe4108adad250e9a$var$p(156, b.tag));
}
function $fe4108adad250e9a$var$Ij(a, b) {
    $fe4108adad250e9a$var$wg(b);
    switch(b.tag){
        case 1:
            return $fe4108adad250e9a$var$Zf(b.type) && $fe4108adad250e9a$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $fe4108adad250e9a$var$zh(), $fe4108adad250e9a$var$E($fe4108adad250e9a$var$Wf), $fe4108adad250e9a$var$E($fe4108adad250e9a$var$H), $fe4108adad250e9a$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $fe4108adad250e9a$var$Bh(b), null;
        case 13:
            $fe4108adad250e9a$var$E($fe4108adad250e9a$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($fe4108adad250e9a$var$p(340));
                $fe4108adad250e9a$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $fe4108adad250e9a$var$E($fe4108adad250e9a$var$L), null;
        case 4:
            return $fe4108adad250e9a$var$zh(), null;
        case 10:
            return $fe4108adad250e9a$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $fe4108adad250e9a$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $fe4108adad250e9a$var$Jj = !1, $fe4108adad250e9a$var$U = !1, $fe4108adad250e9a$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $fe4108adad250e9a$var$V = null;
function $fe4108adad250e9a$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $fe4108adad250e9a$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $fe4108adad250e9a$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $fe4108adad250e9a$var$W(a, b, d);
    }
}
var $fe4108adad250e9a$var$Nj = !1;
function $fe4108adad250e9a$var$Oj(a, b) {
    $fe4108adad250e9a$var$Cf = $fe4108adad250e9a$var$dd;
    a = $fe4108adad250e9a$var$Me();
    if ($fe4108adad250e9a$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $fe4108adad250e9a$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $fe4108adad250e9a$var$dd = !1;
    for($fe4108adad250e9a$var$V = b; null !== $fe4108adad250e9a$var$V;)if (b = $fe4108adad250e9a$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $fe4108adad250e9a$var$V = a;
    else for(; null !== $fe4108adad250e9a$var$V;){
        b = $fe4108adad250e9a$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $fe4108adad250e9a$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($fe4108adad250e9a$var$p(163));
            }
        } catch (F) {
            $fe4108adad250e9a$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $fe4108adad250e9a$var$V = a;
            break;
        }
        $fe4108adad250e9a$var$V = b.return;
    }
    n = $fe4108adad250e9a$var$Nj;
    $fe4108adad250e9a$var$Nj = !1;
    return n;
}
function $fe4108adad250e9a$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $fe4108adad250e9a$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $fe4108adad250e9a$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $fe4108adad250e9a$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $fe4108adad250e9a$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $fe4108adad250e9a$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$fe4108adad250e9a$var$Of], delete b[$fe4108adad250e9a$var$Pf], delete b[$fe4108adad250e9a$var$of], delete b[$fe4108adad250e9a$var$Qf], delete b[$fe4108adad250e9a$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $fe4108adad250e9a$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $fe4108adad250e9a$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $fe4108adad250e9a$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $fe4108adad250e9a$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $fe4108adad250e9a$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($fe4108adad250e9a$var$Vj(a, b, c), a = a.sibling; null !== a;)$fe4108adad250e9a$var$Vj(a, b, c), a = a.sibling;
}
function $fe4108adad250e9a$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($fe4108adad250e9a$var$Wj(a, b, c), a = a.sibling; null !== a;)$fe4108adad250e9a$var$Wj(a, b, c), a = a.sibling;
}
var $fe4108adad250e9a$var$X = null, $fe4108adad250e9a$var$Xj = !1;
function $fe4108adad250e9a$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$fe4108adad250e9a$var$Zj(a, b, c), c = c.sibling;
}
function $fe4108adad250e9a$var$Zj(a, b, c) {
    if ($fe4108adad250e9a$var$lc && "function" === typeof $fe4108adad250e9a$var$lc.onCommitFiberUnmount) try {
        $fe4108adad250e9a$var$lc.onCommitFiberUnmount($fe4108adad250e9a$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $fe4108adad250e9a$var$U || $fe4108adad250e9a$var$Lj(c, b);
        case 6:
            var d = $fe4108adad250e9a$var$X, e = $fe4108adad250e9a$var$Xj;
            $fe4108adad250e9a$var$X = null;
            $fe4108adad250e9a$var$Yj(a, b, c);
            $fe4108adad250e9a$var$X = d;
            $fe4108adad250e9a$var$Xj = e;
            null !== $fe4108adad250e9a$var$X && ($fe4108adad250e9a$var$Xj ? (a = $fe4108adad250e9a$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $fe4108adad250e9a$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $fe4108adad250e9a$var$X && ($fe4108adad250e9a$var$Xj ? (a = $fe4108adad250e9a$var$X, c = c.stateNode, 8 === a.nodeType ? $fe4108adad250e9a$var$Kf(a.parentNode, c) : 1 === a.nodeType && $fe4108adad250e9a$var$Kf(a, c), $fe4108adad250e9a$var$bd(a)) : $fe4108adad250e9a$var$Kf($fe4108adad250e9a$var$X, c.stateNode));
            break;
        case 4:
            d = $fe4108adad250e9a$var$X;
            e = $fe4108adad250e9a$var$Xj;
            $fe4108adad250e9a$var$X = c.stateNode.containerInfo;
            $fe4108adad250e9a$var$Xj = !0;
            $fe4108adad250e9a$var$Yj(a, b, c);
            $fe4108adad250e9a$var$X = d;
            $fe4108adad250e9a$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$fe4108adad250e9a$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $fe4108adad250e9a$var$Mj(c, b, g) : 0 !== (f & 4) && $fe4108adad250e9a$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $fe4108adad250e9a$var$Yj(a, b, c);
            break;
        case 1:
            if (!$fe4108adad250e9a$var$U && ($fe4108adad250e9a$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $fe4108adad250e9a$var$W(c, b, h);
            }
            $fe4108adad250e9a$var$Yj(a, b, c);
            break;
        case 21:
            $fe4108adad250e9a$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($fe4108adad250e9a$var$U = (d = $fe4108adad250e9a$var$U) || null !== c.memoizedState, $fe4108adad250e9a$var$Yj(a, b, c), $fe4108adad250e9a$var$U = d) : $fe4108adad250e9a$var$Yj(a, b, c);
            break;
        default:
            $fe4108adad250e9a$var$Yj(a, b, c);
    }
}
function $fe4108adad250e9a$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $fe4108adad250e9a$var$Kj);
        b.forEach(function(b) {
            var d = $fe4108adad250e9a$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $fe4108adad250e9a$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $fe4108adad250e9a$var$X = h.stateNode;
                        $fe4108adad250e9a$var$Xj = !1;
                        break a;
                    case 3:
                        $fe4108adad250e9a$var$X = h.stateNode.containerInfo;
                        $fe4108adad250e9a$var$Xj = !0;
                        break a;
                    case 4:
                        $fe4108adad250e9a$var$X = h.stateNode.containerInfo;
                        $fe4108adad250e9a$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $fe4108adad250e9a$var$X) throw Error($fe4108adad250e9a$var$p(160));
            $fe4108adad250e9a$var$Zj(f, g, e);
            $fe4108adad250e9a$var$X = null;
            $fe4108adad250e9a$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $fe4108adad250e9a$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$fe4108adad250e9a$var$dk(b, a), b = b.sibling;
}
function $fe4108adad250e9a$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $fe4108adad250e9a$var$ck(b, a);
            $fe4108adad250e9a$var$ek(a);
            if (d & 4) {
                try {
                    $fe4108adad250e9a$var$Pj(3, a, a.return), $fe4108adad250e9a$var$Qj(3, a);
                } catch (t) {
                    $fe4108adad250e9a$var$W(a, a.return, t);
                }
                try {
                    $fe4108adad250e9a$var$Pj(5, a, a.return);
                } catch (t) {
                    $fe4108adad250e9a$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $fe4108adad250e9a$var$ck(b, a);
            $fe4108adad250e9a$var$ek(a);
            d & 512 && null !== c && $fe4108adad250e9a$var$Lj(c, c.return);
            break;
        case 5:
            $fe4108adad250e9a$var$ck(b, a);
            $fe4108adad250e9a$var$ek(a);
            d & 512 && null !== c && $fe4108adad250e9a$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $fe4108adad250e9a$var$ob(e, "");
                } catch (t) {
                    $fe4108adad250e9a$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $fe4108adad250e9a$var$ab(e, f);
                    $fe4108adad250e9a$var$vb(h, g);
                    var l = $fe4108adad250e9a$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $fe4108adad250e9a$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $fe4108adad250e9a$var$nb(e, q) : "children" === m ? $fe4108adad250e9a$var$ob(e, q) : $fe4108adad250e9a$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $fe4108adad250e9a$var$bb(e, f);
                            break;
                        case "textarea":
                            $fe4108adad250e9a$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $fe4108adad250e9a$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $fe4108adad250e9a$var$fb(e, !!f.multiple, f.defaultValue, !0) : $fe4108adad250e9a$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$fe4108adad250e9a$var$Pf] = f;
                } catch (t) {
                    $fe4108adad250e9a$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $fe4108adad250e9a$var$ck(b, a);
            $fe4108adad250e9a$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($fe4108adad250e9a$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $fe4108adad250e9a$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $fe4108adad250e9a$var$ck(b, a);
            $fe4108adad250e9a$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $fe4108adad250e9a$var$bd(b.containerInfo);
            } catch (t) {
                $fe4108adad250e9a$var$W(a, a.return, t);
            }
            break;
        case 4:
            $fe4108adad250e9a$var$ck(b, a);
            $fe4108adad250e9a$var$ek(a);
            break;
        case 13:
            $fe4108adad250e9a$var$ck(b, a);
            $fe4108adad250e9a$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($fe4108adad250e9a$var$fk = $fe4108adad250e9a$var$B()));
            d & 4 && $fe4108adad250e9a$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($fe4108adad250e9a$var$U = (l = $fe4108adad250e9a$var$U) || m, $fe4108adad250e9a$var$ck(b, a), $fe4108adad250e9a$var$U = l) : $fe4108adad250e9a$var$ck(b, a);
            $fe4108adad250e9a$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($fe4108adad250e9a$var$V = a, m = a.child; null !== m;){
                    for(q = $fe4108adad250e9a$var$V = m; null !== $fe4108adad250e9a$var$V;){
                        r = $fe4108adad250e9a$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $fe4108adad250e9a$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $fe4108adad250e9a$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $fe4108adad250e9a$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $fe4108adad250e9a$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $fe4108adad250e9a$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $fe4108adad250e9a$var$V = y) : $fe4108adad250e9a$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $fe4108adad250e9a$var$rb("display", g));
                            } catch (t) {
                                $fe4108adad250e9a$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $fe4108adad250e9a$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $fe4108adad250e9a$var$ck(b, a);
            $fe4108adad250e9a$var$ek(a);
            d & 4 && $fe4108adad250e9a$var$ak(a);
            break;
        case 21:
            break;
        default:
            $fe4108adad250e9a$var$ck(b, a), $fe4108adad250e9a$var$ek(a);
    }
}
function $fe4108adad250e9a$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($fe4108adad250e9a$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($fe4108adad250e9a$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($fe4108adad250e9a$var$ob(e, ""), d.flags &= -33);
                    var f = $fe4108adad250e9a$var$Uj(a);
                    $fe4108adad250e9a$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $fe4108adad250e9a$var$Uj(a);
                    $fe4108adad250e9a$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($fe4108adad250e9a$var$p(161));
            }
        } catch (k) {
            $fe4108adad250e9a$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $fe4108adad250e9a$var$hk(a, b, c) {
    $fe4108adad250e9a$var$V = a;
    $fe4108adad250e9a$var$ik(a, b, c);
}
function $fe4108adad250e9a$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $fe4108adad250e9a$var$V;){
        var e = $fe4108adad250e9a$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $fe4108adad250e9a$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $fe4108adad250e9a$var$U;
                h = $fe4108adad250e9a$var$Jj;
                var l = $fe4108adad250e9a$var$U;
                $fe4108adad250e9a$var$Jj = g;
                if (($fe4108adad250e9a$var$U = k) && !l) for($fe4108adad250e9a$var$V = e; null !== $fe4108adad250e9a$var$V;)g = $fe4108adad250e9a$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $fe4108adad250e9a$var$jk(e) : null !== k ? (k.return = g, $fe4108adad250e9a$var$V = k) : $fe4108adad250e9a$var$jk(e);
                for(; null !== f;)$fe4108adad250e9a$var$V = f, $fe4108adad250e9a$var$ik(f, b, c), f = f.sibling;
                $fe4108adad250e9a$var$V = e;
                $fe4108adad250e9a$var$Jj = h;
                $fe4108adad250e9a$var$U = l;
            }
            $fe4108adad250e9a$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $fe4108adad250e9a$var$V = f) : $fe4108adad250e9a$var$kk(a, b, c);
    }
}
function $fe4108adad250e9a$var$kk(a) {
    for(; null !== $fe4108adad250e9a$var$V;){
        var b = $fe4108adad250e9a$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $fe4108adad250e9a$var$U || $fe4108adad250e9a$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$fe4108adad250e9a$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $fe4108adad250e9a$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $fe4108adad250e9a$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $fe4108adad250e9a$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $fe4108adad250e9a$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($fe4108adad250e9a$var$p(163));
                }
                $fe4108adad250e9a$var$U || b.flags & 512 && $fe4108adad250e9a$var$Rj(b);
            } catch (r) {
                $fe4108adad250e9a$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $fe4108adad250e9a$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $fe4108adad250e9a$var$V = c;
            break;
        }
        $fe4108adad250e9a$var$V = b.return;
    }
}
function $fe4108adad250e9a$var$gk(a) {
    for(; null !== $fe4108adad250e9a$var$V;){
        var b = $fe4108adad250e9a$var$V;
        if (b === a) {
            $fe4108adad250e9a$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $fe4108adad250e9a$var$V = c;
            break;
        }
        $fe4108adad250e9a$var$V = b.return;
    }
}
function $fe4108adad250e9a$var$jk(a) {
    for(; null !== $fe4108adad250e9a$var$V;){
        var b = $fe4108adad250e9a$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $fe4108adad250e9a$var$Qj(4, b);
                    } catch (k) {
                        $fe4108adad250e9a$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $fe4108adad250e9a$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $fe4108adad250e9a$var$Rj(b);
                    } catch (k) {
                        $fe4108adad250e9a$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $fe4108adad250e9a$var$Rj(b);
                    } catch (k) {
                        $fe4108adad250e9a$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $fe4108adad250e9a$var$W(b, b.return, k);
        }
        if (b === a) {
            $fe4108adad250e9a$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $fe4108adad250e9a$var$V = h;
            break;
        }
        $fe4108adad250e9a$var$V = b.return;
    }
}
var $fe4108adad250e9a$var$lk = Math.ceil, $fe4108adad250e9a$var$mk = $fe4108adad250e9a$var$ua.ReactCurrentDispatcher, $fe4108adad250e9a$var$nk = $fe4108adad250e9a$var$ua.ReactCurrentOwner, $fe4108adad250e9a$var$ok = $fe4108adad250e9a$var$ua.ReactCurrentBatchConfig, $fe4108adad250e9a$var$K = 0, $fe4108adad250e9a$var$Q = null, $fe4108adad250e9a$var$Y = null, $fe4108adad250e9a$var$Z = 0, $fe4108adad250e9a$var$fj = 0, $fe4108adad250e9a$var$ej = $fe4108adad250e9a$var$Uf(0), $fe4108adad250e9a$var$T = 0, $fe4108adad250e9a$var$pk = null, $fe4108adad250e9a$var$rh = 0, $fe4108adad250e9a$var$qk = 0, $fe4108adad250e9a$var$rk = 0, $fe4108adad250e9a$var$sk = null, $fe4108adad250e9a$var$tk = null, $fe4108adad250e9a$var$fk = 0, $fe4108adad250e9a$var$Gj = Infinity, $fe4108adad250e9a$var$uk = null, $fe4108adad250e9a$var$Oi = !1, $fe4108adad250e9a$var$Pi = null, $fe4108adad250e9a$var$Ri = null, $fe4108adad250e9a$var$vk = !1, $fe4108adad250e9a$var$wk = null, $fe4108adad250e9a$var$xk = 0, $fe4108adad250e9a$var$yk = 0, $fe4108adad250e9a$var$zk = null, $fe4108adad250e9a$var$Ak = -1, $fe4108adad250e9a$var$Bk = 0;
function $fe4108adad250e9a$var$R() {
    return 0 !== ($fe4108adad250e9a$var$K & 6) ? $fe4108adad250e9a$var$B() : -1 !== $fe4108adad250e9a$var$Ak ? $fe4108adad250e9a$var$Ak : $fe4108adad250e9a$var$Ak = $fe4108adad250e9a$var$B();
}
function $fe4108adad250e9a$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($fe4108adad250e9a$var$K & 2) && 0 !== $fe4108adad250e9a$var$Z) return $fe4108adad250e9a$var$Z & -$fe4108adad250e9a$var$Z;
    if (null !== $fe4108adad250e9a$var$Kg.transition) return 0 === $fe4108adad250e9a$var$Bk && ($fe4108adad250e9a$var$Bk = $fe4108adad250e9a$var$yc()), $fe4108adad250e9a$var$Bk;
    a = $fe4108adad250e9a$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $fe4108adad250e9a$var$jd(a.type);
    return a;
}
function $fe4108adad250e9a$var$gi(a, b, c, d) {
    if (50 < $fe4108adad250e9a$var$yk) throw $fe4108adad250e9a$var$yk = 0, $fe4108adad250e9a$var$zk = null, Error($fe4108adad250e9a$var$p(185));
    $fe4108adad250e9a$var$Ac(a, c, d);
    if (0 === ($fe4108adad250e9a$var$K & 2) || a !== $fe4108adad250e9a$var$Q) a === $fe4108adad250e9a$var$Q && (0 === ($fe4108adad250e9a$var$K & 2) && ($fe4108adad250e9a$var$qk |= c), 4 === $fe4108adad250e9a$var$T && $fe4108adad250e9a$var$Ck(a, $fe4108adad250e9a$var$Z)), $fe4108adad250e9a$var$Dk(a, d), 1 === c && 0 === $fe4108adad250e9a$var$K && 0 === (b.mode & 1) && ($fe4108adad250e9a$var$Gj = $fe4108adad250e9a$var$B() + 500, $fe4108adad250e9a$var$fg && $fe4108adad250e9a$var$jg());
}
function $fe4108adad250e9a$var$Dk(a, b) {
    var c = a.callbackNode;
    $fe4108adad250e9a$var$wc(a, b);
    var d = $fe4108adad250e9a$var$uc(a, a === $fe4108adad250e9a$var$Q ? $fe4108adad250e9a$var$Z : 0);
    if (0 === d) null !== c && $fe4108adad250e9a$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $fe4108adad250e9a$var$bc(c);
        if (1 === b) 0 === a.tag ? $fe4108adad250e9a$var$ig($fe4108adad250e9a$var$Ek.bind(null, a)) : $fe4108adad250e9a$var$hg($fe4108adad250e9a$var$Ek.bind(null, a)), $fe4108adad250e9a$var$Jf(function() {
            0 === ($fe4108adad250e9a$var$K & 6) && $fe4108adad250e9a$var$jg();
        }), c = null;
        else {
            switch($fe4108adad250e9a$var$Dc(d)){
                case 1:
                    c = $fe4108adad250e9a$var$fc;
                    break;
                case 4:
                    c = $fe4108adad250e9a$var$gc;
                    break;
                case 16:
                    c = $fe4108adad250e9a$var$hc;
                    break;
                case 536870912:
                    c = $fe4108adad250e9a$var$jc;
                    break;
                default:
                    c = $fe4108adad250e9a$var$hc;
            }
            c = $fe4108adad250e9a$var$Fk(c, $fe4108adad250e9a$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $fe4108adad250e9a$var$Gk(a, b) {
    $fe4108adad250e9a$var$Ak = -1;
    $fe4108adad250e9a$var$Bk = 0;
    if (0 !== ($fe4108adad250e9a$var$K & 6)) throw Error($fe4108adad250e9a$var$p(327));
    var c = a.callbackNode;
    if ($fe4108adad250e9a$var$Hk() && a.callbackNode !== c) return null;
    var d = $fe4108adad250e9a$var$uc(a, a === $fe4108adad250e9a$var$Q ? $fe4108adad250e9a$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $fe4108adad250e9a$var$Ik(a, d);
    else {
        b = d;
        var e = $fe4108adad250e9a$var$K;
        $fe4108adad250e9a$var$K |= 2;
        var f = $fe4108adad250e9a$var$Jk();
        if ($fe4108adad250e9a$var$Q !== a || $fe4108adad250e9a$var$Z !== b) $fe4108adad250e9a$var$uk = null, $fe4108adad250e9a$var$Gj = $fe4108adad250e9a$var$B() + 500, $fe4108adad250e9a$var$Kk(a, b);
        for(;;)try {
            $fe4108adad250e9a$var$Lk();
            break;
        } catch (h) {
            $fe4108adad250e9a$var$Mk(a, h);
        }
        $fe4108adad250e9a$var$$g();
        $fe4108adad250e9a$var$mk.current = f;
        $fe4108adad250e9a$var$K = e;
        null !== $fe4108adad250e9a$var$Y ? b = 0 : ($fe4108adad250e9a$var$Q = null, $fe4108adad250e9a$var$Z = 0, b = $fe4108adad250e9a$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $fe4108adad250e9a$var$xc(a), 0 !== e && (d = e, b = $fe4108adad250e9a$var$Nk(a, e)));
        if (1 === b) throw c = $fe4108adad250e9a$var$pk, $fe4108adad250e9a$var$Kk(a, 0), $fe4108adad250e9a$var$Ck(a, d), $fe4108adad250e9a$var$Dk(a, $fe4108adad250e9a$var$B()), c;
        if (6 === b) $fe4108adad250e9a$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$fe4108adad250e9a$var$Ok(e) && (b = $fe4108adad250e9a$var$Ik(a, d), 2 === b && (f = $fe4108adad250e9a$var$xc(a), 0 !== f && (d = f, b = $fe4108adad250e9a$var$Nk(a, f))), 1 === b)) throw c = $fe4108adad250e9a$var$pk, $fe4108adad250e9a$var$Kk(a, 0), $fe4108adad250e9a$var$Ck(a, d), $fe4108adad250e9a$var$Dk(a, $fe4108adad250e9a$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($fe4108adad250e9a$var$p(345));
                case 2:
                    $fe4108adad250e9a$var$Pk(a, $fe4108adad250e9a$var$tk, $fe4108adad250e9a$var$uk);
                    break;
                case 3:
                    $fe4108adad250e9a$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $fe4108adad250e9a$var$fk + 500 - $fe4108adad250e9a$var$B(), 10 < b)) {
                        if (0 !== $fe4108adad250e9a$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $fe4108adad250e9a$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $fe4108adad250e9a$var$Ff($fe4108adad250e9a$var$Pk.bind(null, a, $fe4108adad250e9a$var$tk, $fe4108adad250e9a$var$uk), b);
                        break;
                    }
                    $fe4108adad250e9a$var$Pk(a, $fe4108adad250e9a$var$tk, $fe4108adad250e9a$var$uk);
                    break;
                case 4:
                    $fe4108adad250e9a$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $fe4108adad250e9a$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $fe4108adad250e9a$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $fe4108adad250e9a$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $fe4108adad250e9a$var$Ff($fe4108adad250e9a$var$Pk.bind(null, a, $fe4108adad250e9a$var$tk, $fe4108adad250e9a$var$uk), d);
                        break;
                    }
                    $fe4108adad250e9a$var$Pk(a, $fe4108adad250e9a$var$tk, $fe4108adad250e9a$var$uk);
                    break;
                case 5:
                    $fe4108adad250e9a$var$Pk(a, $fe4108adad250e9a$var$tk, $fe4108adad250e9a$var$uk);
                    break;
                default:
                    throw Error($fe4108adad250e9a$var$p(329));
            }
        }
    }
    $fe4108adad250e9a$var$Dk(a, $fe4108adad250e9a$var$B());
    return a.callbackNode === c ? $fe4108adad250e9a$var$Gk.bind(null, a) : null;
}
function $fe4108adad250e9a$var$Nk(a, b) {
    var c = $fe4108adad250e9a$var$sk;
    a.current.memoizedState.isDehydrated && ($fe4108adad250e9a$var$Kk(a, b).flags |= 256);
    a = $fe4108adad250e9a$var$Ik(a, b);
    2 !== a && (b = $fe4108adad250e9a$var$tk, $fe4108adad250e9a$var$tk = c, null !== b && $fe4108adad250e9a$var$Fj(b));
    return a;
}
function $fe4108adad250e9a$var$Fj(a) {
    null === $fe4108adad250e9a$var$tk ? $fe4108adad250e9a$var$tk = a : $fe4108adad250e9a$var$tk.push.apply($fe4108adad250e9a$var$tk, a);
}
function $fe4108adad250e9a$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$fe4108adad250e9a$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $fe4108adad250e9a$var$Ck(a, b) {
    b &= ~$fe4108adad250e9a$var$rk;
    b &= ~$fe4108adad250e9a$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $fe4108adad250e9a$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $fe4108adad250e9a$var$Ek(a) {
    if (0 !== ($fe4108adad250e9a$var$K & 6)) throw Error($fe4108adad250e9a$var$p(327));
    $fe4108adad250e9a$var$Hk();
    var b = $fe4108adad250e9a$var$uc(a, 0);
    if (0 === (b & 1)) return $fe4108adad250e9a$var$Dk(a, $fe4108adad250e9a$var$B()), null;
    var c = $fe4108adad250e9a$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $fe4108adad250e9a$var$xc(a);
        0 !== d && (b = d, c = $fe4108adad250e9a$var$Nk(a, d));
    }
    if (1 === c) throw c = $fe4108adad250e9a$var$pk, $fe4108adad250e9a$var$Kk(a, 0), $fe4108adad250e9a$var$Ck(a, b), $fe4108adad250e9a$var$Dk(a, $fe4108adad250e9a$var$B()), c;
    if (6 === c) throw Error($fe4108adad250e9a$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $fe4108adad250e9a$var$Pk(a, $fe4108adad250e9a$var$tk, $fe4108adad250e9a$var$uk);
    $fe4108adad250e9a$var$Dk(a, $fe4108adad250e9a$var$B());
    return null;
}
function $fe4108adad250e9a$var$Qk(a, b) {
    var c = $fe4108adad250e9a$var$K;
    $fe4108adad250e9a$var$K |= 1;
    try {
        return a(b);
    } finally{
        $fe4108adad250e9a$var$K = c, 0 === $fe4108adad250e9a$var$K && ($fe4108adad250e9a$var$Gj = $fe4108adad250e9a$var$B() + 500, $fe4108adad250e9a$var$fg && $fe4108adad250e9a$var$jg());
    }
}
function $fe4108adad250e9a$var$Rk(a) {
    null !== $fe4108adad250e9a$var$wk && 0 === $fe4108adad250e9a$var$wk.tag && 0 === ($fe4108adad250e9a$var$K & 6) && $fe4108adad250e9a$var$Hk();
    var b = $fe4108adad250e9a$var$K;
    $fe4108adad250e9a$var$K |= 1;
    var c = $fe4108adad250e9a$var$ok.transition, d = $fe4108adad250e9a$var$C;
    try {
        if ($fe4108adad250e9a$var$ok.transition = null, $fe4108adad250e9a$var$C = 1, a) return a();
    } finally{
        $fe4108adad250e9a$var$C = d, $fe4108adad250e9a$var$ok.transition = c, $fe4108adad250e9a$var$K = b, 0 === ($fe4108adad250e9a$var$K & 6) && $fe4108adad250e9a$var$jg();
    }
}
function $fe4108adad250e9a$var$Hj() {
    $fe4108adad250e9a$var$fj = $fe4108adad250e9a$var$ej.current;
    $fe4108adad250e9a$var$E($fe4108adad250e9a$var$ej);
}
function $fe4108adad250e9a$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $fe4108adad250e9a$var$Gf(c));
    if (null !== $fe4108adad250e9a$var$Y) for(c = $fe4108adad250e9a$var$Y.return; null !== c;){
        var d = c;
        $fe4108adad250e9a$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $fe4108adad250e9a$var$$f();
                break;
            case 3:
                $fe4108adad250e9a$var$zh();
                $fe4108adad250e9a$var$E($fe4108adad250e9a$var$Wf);
                $fe4108adad250e9a$var$E($fe4108adad250e9a$var$H);
                $fe4108adad250e9a$var$Eh();
                break;
            case 5:
                $fe4108adad250e9a$var$Bh(d);
                break;
            case 4:
                $fe4108adad250e9a$var$zh();
                break;
            case 13:
                $fe4108adad250e9a$var$E($fe4108adad250e9a$var$L);
                break;
            case 19:
                $fe4108adad250e9a$var$E($fe4108adad250e9a$var$L);
                break;
            case 10:
                $fe4108adad250e9a$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $fe4108adad250e9a$var$Hj();
        }
        c = c.return;
    }
    $fe4108adad250e9a$var$Q = a;
    $fe4108adad250e9a$var$Y = a = $fe4108adad250e9a$var$Pg(a.current, null);
    $fe4108adad250e9a$var$Z = $fe4108adad250e9a$var$fj = b;
    $fe4108adad250e9a$var$T = 0;
    $fe4108adad250e9a$var$pk = null;
    $fe4108adad250e9a$var$rk = $fe4108adad250e9a$var$qk = $fe4108adad250e9a$var$rh = 0;
    $fe4108adad250e9a$var$tk = $fe4108adad250e9a$var$sk = null;
    if (null !== $fe4108adad250e9a$var$fh) {
        for(b = 0; b < $fe4108adad250e9a$var$fh.length; b++)if (c = $fe4108adad250e9a$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $fe4108adad250e9a$var$fh = null;
    }
    return a;
}
function $fe4108adad250e9a$var$Mk(a, b) {
    do {
        var c = $fe4108adad250e9a$var$Y;
        try {
            $fe4108adad250e9a$var$$g();
            $fe4108adad250e9a$var$Fh.current = $fe4108adad250e9a$var$Rh;
            if ($fe4108adad250e9a$var$Ih) {
                for(var d = $fe4108adad250e9a$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $fe4108adad250e9a$var$Ih = !1;
            }
            $fe4108adad250e9a$var$Hh = 0;
            $fe4108adad250e9a$var$O = $fe4108adad250e9a$var$N = $fe4108adad250e9a$var$M = null;
            $fe4108adad250e9a$var$Jh = !1;
            $fe4108adad250e9a$var$Kh = 0;
            $fe4108adad250e9a$var$nk.current = null;
            if (null === c || null === c.return) {
                $fe4108adad250e9a$var$T = 1;
                $fe4108adad250e9a$var$pk = b;
                $fe4108adad250e9a$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $fe4108adad250e9a$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $fe4108adad250e9a$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $fe4108adad250e9a$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $fe4108adad250e9a$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $fe4108adad250e9a$var$Si(f, l, b);
                            $fe4108adad250e9a$var$tj();
                            break a;
                        }
                        k = Error($fe4108adad250e9a$var$p(426));
                    }
                } else if ($fe4108adad250e9a$var$I && h.mode & 1) {
                    var J = $fe4108adad250e9a$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $fe4108adad250e9a$var$Vi(J, g, h, f, b);
                        $fe4108adad250e9a$var$Jg($fe4108adad250e9a$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $fe4108adad250e9a$var$Ji(k, h);
                4 !== $fe4108adad250e9a$var$T && ($fe4108adad250e9a$var$T = 2);
                null === $fe4108adad250e9a$var$sk ? $fe4108adad250e9a$var$sk = [
                    f
                ] : $fe4108adad250e9a$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $fe4108adad250e9a$var$Ni(f, k, b);
                            $fe4108adad250e9a$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $fe4108adad250e9a$var$Ri || !$fe4108adad250e9a$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $fe4108adad250e9a$var$Qi(f, h, b);
                                $fe4108adad250e9a$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $fe4108adad250e9a$var$Sk(c);
        } catch (na) {
            b = na;
            $fe4108adad250e9a$var$Y === c && null !== c && ($fe4108adad250e9a$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $fe4108adad250e9a$var$Jk() {
    var a = $fe4108adad250e9a$var$mk.current;
    $fe4108adad250e9a$var$mk.current = $fe4108adad250e9a$var$Rh;
    return null === a ? $fe4108adad250e9a$var$Rh : a;
}
function $fe4108adad250e9a$var$tj() {
    if (0 === $fe4108adad250e9a$var$T || 3 === $fe4108adad250e9a$var$T || 2 === $fe4108adad250e9a$var$T) $fe4108adad250e9a$var$T = 4;
    null === $fe4108adad250e9a$var$Q || 0 === ($fe4108adad250e9a$var$rh & 268435455) && 0 === ($fe4108adad250e9a$var$qk & 268435455) || $fe4108adad250e9a$var$Ck($fe4108adad250e9a$var$Q, $fe4108adad250e9a$var$Z);
}
function $fe4108adad250e9a$var$Ik(a, b) {
    var c = $fe4108adad250e9a$var$K;
    $fe4108adad250e9a$var$K |= 2;
    var d = $fe4108adad250e9a$var$Jk();
    if ($fe4108adad250e9a$var$Q !== a || $fe4108adad250e9a$var$Z !== b) $fe4108adad250e9a$var$uk = null, $fe4108adad250e9a$var$Kk(a, b);
    for(;;)try {
        $fe4108adad250e9a$var$Tk();
        break;
    } catch (e) {
        $fe4108adad250e9a$var$Mk(a, e);
    }
    $fe4108adad250e9a$var$$g();
    $fe4108adad250e9a$var$K = c;
    $fe4108adad250e9a$var$mk.current = d;
    if (null !== $fe4108adad250e9a$var$Y) throw Error($fe4108adad250e9a$var$p(261));
    $fe4108adad250e9a$var$Q = null;
    $fe4108adad250e9a$var$Z = 0;
    return $fe4108adad250e9a$var$T;
}
function $fe4108adad250e9a$var$Tk() {
    for(; null !== $fe4108adad250e9a$var$Y;)$fe4108adad250e9a$var$Uk($fe4108adad250e9a$var$Y);
}
function $fe4108adad250e9a$var$Lk() {
    for(; null !== $fe4108adad250e9a$var$Y && !$fe4108adad250e9a$var$cc();)$fe4108adad250e9a$var$Uk($fe4108adad250e9a$var$Y);
}
function $fe4108adad250e9a$var$Uk(a) {
    var b = $fe4108adad250e9a$var$Vk(a.alternate, a, $fe4108adad250e9a$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $fe4108adad250e9a$var$Sk(a) : $fe4108adad250e9a$var$Y = b;
    $fe4108adad250e9a$var$nk.current = null;
}
function $fe4108adad250e9a$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $fe4108adad250e9a$var$Ej(c, b, $fe4108adad250e9a$var$fj), null !== c) {
                $fe4108adad250e9a$var$Y = c;
                return;
            }
        } else {
            c = $fe4108adad250e9a$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $fe4108adad250e9a$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $fe4108adad250e9a$var$T = 6;
                $fe4108adad250e9a$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $fe4108adad250e9a$var$Y = b;
            return;
        }
        $fe4108adad250e9a$var$Y = b = a;
    }while (null !== b);
    0 === $fe4108adad250e9a$var$T && ($fe4108adad250e9a$var$T = 5);
}
function $fe4108adad250e9a$var$Pk(a, b, c) {
    var d = $fe4108adad250e9a$var$C, e = $fe4108adad250e9a$var$ok.transition;
    try {
        $fe4108adad250e9a$var$ok.transition = null, $fe4108adad250e9a$var$C = 1, $fe4108adad250e9a$var$Wk(a, b, c, d);
    } finally{
        $fe4108adad250e9a$var$ok.transition = e, $fe4108adad250e9a$var$C = d;
    }
    return null;
}
function $fe4108adad250e9a$var$Wk(a, b, c, d) {
    do $fe4108adad250e9a$var$Hk();
    while (null !== $fe4108adad250e9a$var$wk);
    if (0 !== ($fe4108adad250e9a$var$K & 6)) throw Error($fe4108adad250e9a$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($fe4108adad250e9a$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $fe4108adad250e9a$var$Bc(a, f);
    a === $fe4108adad250e9a$var$Q && ($fe4108adad250e9a$var$Y = $fe4108adad250e9a$var$Q = null, $fe4108adad250e9a$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $fe4108adad250e9a$var$vk || ($fe4108adad250e9a$var$vk = !0, $fe4108adad250e9a$var$Fk($fe4108adad250e9a$var$hc, function() {
        $fe4108adad250e9a$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $fe4108adad250e9a$var$ok.transition;
        $fe4108adad250e9a$var$ok.transition = null;
        var g = $fe4108adad250e9a$var$C;
        $fe4108adad250e9a$var$C = 1;
        var h = $fe4108adad250e9a$var$K;
        $fe4108adad250e9a$var$K |= 4;
        $fe4108adad250e9a$var$nk.current = null;
        $fe4108adad250e9a$var$Oj(a, c);
        $fe4108adad250e9a$var$dk(c, a);
        $fe4108adad250e9a$var$Oe($fe4108adad250e9a$var$Df);
        $fe4108adad250e9a$var$dd = !!$fe4108adad250e9a$var$Cf;
        $fe4108adad250e9a$var$Df = $fe4108adad250e9a$var$Cf = null;
        a.current = c;
        $fe4108adad250e9a$var$hk(c, a, e);
        $fe4108adad250e9a$var$dc();
        $fe4108adad250e9a$var$K = h;
        $fe4108adad250e9a$var$C = g;
        $fe4108adad250e9a$var$ok.transition = f;
    } else a.current = c;
    $fe4108adad250e9a$var$vk && ($fe4108adad250e9a$var$vk = !1, $fe4108adad250e9a$var$wk = a, $fe4108adad250e9a$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($fe4108adad250e9a$var$Ri = null);
    $fe4108adad250e9a$var$mc(c.stateNode, d);
    $fe4108adad250e9a$var$Dk(a, $fe4108adad250e9a$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($fe4108adad250e9a$var$Oi) throw $fe4108adad250e9a$var$Oi = !1, a = $fe4108adad250e9a$var$Pi, $fe4108adad250e9a$var$Pi = null, a;
    0 !== ($fe4108adad250e9a$var$xk & 1) && 0 !== a.tag && $fe4108adad250e9a$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $fe4108adad250e9a$var$zk ? $fe4108adad250e9a$var$yk++ : ($fe4108adad250e9a$var$yk = 0, $fe4108adad250e9a$var$zk = a) : $fe4108adad250e9a$var$yk = 0;
    $fe4108adad250e9a$var$jg();
    return null;
}
function $fe4108adad250e9a$var$Hk() {
    if (null !== $fe4108adad250e9a$var$wk) {
        var a = $fe4108adad250e9a$var$Dc($fe4108adad250e9a$var$xk), b = $fe4108adad250e9a$var$ok.transition, c = $fe4108adad250e9a$var$C;
        try {
            $fe4108adad250e9a$var$ok.transition = null;
            $fe4108adad250e9a$var$C = 16 > a ? 16 : a;
            if (null === $fe4108adad250e9a$var$wk) var d = !1;
            else {
                a = $fe4108adad250e9a$var$wk;
                $fe4108adad250e9a$var$wk = null;
                $fe4108adad250e9a$var$xk = 0;
                if (0 !== ($fe4108adad250e9a$var$K & 6)) throw Error($fe4108adad250e9a$var$p(331));
                var e = $fe4108adad250e9a$var$K;
                $fe4108adad250e9a$var$K |= 4;
                for($fe4108adad250e9a$var$V = a.current; null !== $fe4108adad250e9a$var$V;){
                    var f = $fe4108adad250e9a$var$V, g = f.child;
                    if (0 !== ($fe4108adad250e9a$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($fe4108adad250e9a$var$V = l; null !== $fe4108adad250e9a$var$V;){
                                    var m = $fe4108adad250e9a$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $fe4108adad250e9a$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $fe4108adad250e9a$var$V = q;
                                    else for(; null !== $fe4108adad250e9a$var$V;){
                                        m = $fe4108adad250e9a$var$V;
                                        var r = m.sibling, y = m.return;
                                        $fe4108adad250e9a$var$Sj(m);
                                        if (m === l) {
                                            $fe4108adad250e9a$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $fe4108adad250e9a$var$V = r;
                                            break;
                                        }
                                        $fe4108adad250e9a$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $fe4108adad250e9a$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $fe4108adad250e9a$var$V = g;
                    else b: for(; null !== $fe4108adad250e9a$var$V;){
                        f = $fe4108adad250e9a$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $fe4108adad250e9a$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $fe4108adad250e9a$var$V = x;
                            break b;
                        }
                        $fe4108adad250e9a$var$V = f.return;
                    }
                }
                var w = a.current;
                for($fe4108adad250e9a$var$V = w; null !== $fe4108adad250e9a$var$V;){
                    g = $fe4108adad250e9a$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $fe4108adad250e9a$var$V = u;
                    else b: for(g = w; null !== $fe4108adad250e9a$var$V;){
                        h = $fe4108adad250e9a$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $fe4108adad250e9a$var$Qj(9, h);
                            }
                        } catch (na) {
                            $fe4108adad250e9a$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $fe4108adad250e9a$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $fe4108adad250e9a$var$V = F;
                            break b;
                        }
                        $fe4108adad250e9a$var$V = h.return;
                    }
                }
                $fe4108adad250e9a$var$K = e;
                $fe4108adad250e9a$var$jg();
                if ($fe4108adad250e9a$var$lc && "function" === typeof $fe4108adad250e9a$var$lc.onPostCommitFiberRoot) try {
                    $fe4108adad250e9a$var$lc.onPostCommitFiberRoot($fe4108adad250e9a$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $fe4108adad250e9a$var$C = c, $fe4108adad250e9a$var$ok.transition = b;
        }
    }
    return !1;
}
function $fe4108adad250e9a$var$Xk(a, b, c) {
    b = $fe4108adad250e9a$var$Ji(c, b);
    b = $fe4108adad250e9a$var$Ni(a, b, 1);
    a = $fe4108adad250e9a$var$nh(a, b, 1);
    b = $fe4108adad250e9a$var$R();
    null !== a && ($fe4108adad250e9a$var$Ac(a, 1, b), $fe4108adad250e9a$var$Dk(a, b));
}
function $fe4108adad250e9a$var$W(a, b, c) {
    if (3 === a.tag) $fe4108adad250e9a$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $fe4108adad250e9a$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $fe4108adad250e9a$var$Ri || !$fe4108adad250e9a$var$Ri.has(d))) {
                a = $fe4108adad250e9a$var$Ji(c, a);
                a = $fe4108adad250e9a$var$Qi(b, a, 1);
                b = $fe4108adad250e9a$var$nh(b, a, 1);
                a = $fe4108adad250e9a$var$R();
                null !== b && ($fe4108adad250e9a$var$Ac(b, 1, a), $fe4108adad250e9a$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $fe4108adad250e9a$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $fe4108adad250e9a$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $fe4108adad250e9a$var$Q === a && ($fe4108adad250e9a$var$Z & c) === c && (4 === $fe4108adad250e9a$var$T || 3 === $fe4108adad250e9a$var$T && ($fe4108adad250e9a$var$Z & 130023424) === $fe4108adad250e9a$var$Z && 500 > $fe4108adad250e9a$var$B() - $fe4108adad250e9a$var$fk ? $fe4108adad250e9a$var$Kk(a, 0) : $fe4108adad250e9a$var$rk |= c);
    $fe4108adad250e9a$var$Dk(a, b);
}
function $fe4108adad250e9a$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $fe4108adad250e9a$var$sc, $fe4108adad250e9a$var$sc <<= 1, 0 === ($fe4108adad250e9a$var$sc & 130023424) && ($fe4108adad250e9a$var$sc = 4194304)));
    var c = $fe4108adad250e9a$var$R();
    a = $fe4108adad250e9a$var$ih(a, b);
    null !== a && ($fe4108adad250e9a$var$Ac(a, b, c), $fe4108adad250e9a$var$Dk(a, c));
}
function $fe4108adad250e9a$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $fe4108adad250e9a$var$Yk(a, c);
}
function $fe4108adad250e9a$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($fe4108adad250e9a$var$p(314));
    }
    null !== d && d.delete(b);
    $fe4108adad250e9a$var$Yk(a, c);
}
var $fe4108adad250e9a$var$Vk;
$fe4108adad250e9a$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $fe4108adad250e9a$var$Wf.current) $fe4108adad250e9a$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $fe4108adad250e9a$var$dh = !1, $fe4108adad250e9a$var$yj(a, b, c);
            $fe4108adad250e9a$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $fe4108adad250e9a$var$dh = !1, $fe4108adad250e9a$var$I && 0 !== (b.flags & 1048576) && $fe4108adad250e9a$var$ug(b, $fe4108adad250e9a$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $fe4108adad250e9a$var$ij(a, b);
            a = b.pendingProps;
            var e = $fe4108adad250e9a$var$Yf(b, $fe4108adad250e9a$var$H.current);
            $fe4108adad250e9a$var$ch(b, c);
            e = $fe4108adad250e9a$var$Nh(null, b, d, a, e, c);
            var f = $fe4108adad250e9a$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $fe4108adad250e9a$var$Zf(d) ? (f = !0, $fe4108adad250e9a$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $fe4108adad250e9a$var$kh(b), e.updater = $fe4108adad250e9a$var$Ei, b.stateNode = e, e._reactInternals = b, $fe4108adad250e9a$var$Ii(b, d, a, c), b = $fe4108adad250e9a$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $fe4108adad250e9a$var$I && f && $fe4108adad250e9a$var$vg(b), $fe4108adad250e9a$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $fe4108adad250e9a$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $fe4108adad250e9a$var$Zk(d);
                a = $fe4108adad250e9a$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $fe4108adad250e9a$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $fe4108adad250e9a$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $fe4108adad250e9a$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $fe4108adad250e9a$var$$i(null, b, d, $fe4108adad250e9a$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($fe4108adad250e9a$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $fe4108adad250e9a$var$Ci(d, e), $fe4108adad250e9a$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $fe4108adad250e9a$var$Ci(d, e), $fe4108adad250e9a$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $fe4108adad250e9a$var$kj(b);
                if (null === a) throw Error($fe4108adad250e9a$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $fe4108adad250e9a$var$lh(a, b);
                $fe4108adad250e9a$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $fe4108adad250e9a$var$Ji(Error($fe4108adad250e9a$var$p(423)), b);
                        b = $fe4108adad250e9a$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $fe4108adad250e9a$var$Ji(Error($fe4108adad250e9a$var$p(424)), b);
                        b = $fe4108adad250e9a$var$lj(a, b, d, c, e);
                        break a;
                    } else for($fe4108adad250e9a$var$yg = $fe4108adad250e9a$var$Lf(b.stateNode.containerInfo.firstChild), $fe4108adad250e9a$var$xg = b, $fe4108adad250e9a$var$I = !0, $fe4108adad250e9a$var$zg = null, c = $fe4108adad250e9a$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $fe4108adad250e9a$var$Ig();
                    if (d === e) {
                        b = $fe4108adad250e9a$var$Zi(a, b, c);
                        break a;
                    }
                    $fe4108adad250e9a$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $fe4108adad250e9a$var$Ah(b), null === a && $fe4108adad250e9a$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $fe4108adad250e9a$var$Ef(d, e) ? g = null : null !== f && $fe4108adad250e9a$var$Ef(d, f) && (b.flags |= 32), $fe4108adad250e9a$var$gj(a, b), $fe4108adad250e9a$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $fe4108adad250e9a$var$Eg(b), null;
        case 13:
            return $fe4108adad250e9a$var$oj(a, b, c);
        case 4:
            return $fe4108adad250e9a$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $fe4108adad250e9a$var$Ug(b, null, d, c) : $fe4108adad250e9a$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $fe4108adad250e9a$var$Ci(d, e), $fe4108adad250e9a$var$Yi(a, b, d, e, c);
        case 7:
            return $fe4108adad250e9a$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $fe4108adad250e9a$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $fe4108adad250e9a$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $fe4108adad250e9a$var$G($fe4108adad250e9a$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($fe4108adad250e9a$var$He(f.value, g)) {
                        if (f.children === e.children && !$fe4108adad250e9a$var$Wf.current) {
                            b = $fe4108adad250e9a$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $fe4108adad250e9a$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $fe4108adad250e9a$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($fe4108adad250e9a$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $fe4108adad250e9a$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $fe4108adad250e9a$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $fe4108adad250e9a$var$ch(b, c), e = $fe4108adad250e9a$var$eh(e), d = d(e), b.flags |= 1, $fe4108adad250e9a$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $fe4108adad250e9a$var$Ci(d, b.pendingProps), e = $fe4108adad250e9a$var$Ci(d.type, e), $fe4108adad250e9a$var$$i(a, b, d, e, c);
        case 15:
            return $fe4108adad250e9a$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $fe4108adad250e9a$var$Ci(d, e), $fe4108adad250e9a$var$ij(a, b), b.tag = 1, $fe4108adad250e9a$var$Zf(d) ? (a = !0, $fe4108adad250e9a$var$cg(b)) : a = !1, $fe4108adad250e9a$var$ch(b, c), $fe4108adad250e9a$var$Gi(b, d, e), $fe4108adad250e9a$var$Ii(b, d, e, c), $fe4108adad250e9a$var$jj(null, b, d, !0, a, c);
        case 19:
            return $fe4108adad250e9a$var$xj(a, b, c);
        case 22:
            return $fe4108adad250e9a$var$dj(a, b, c);
    }
    throw Error($fe4108adad250e9a$var$p(156, b.tag));
};
function $fe4108adad250e9a$var$Fk(a, b) {
    return $fe4108adad250e9a$var$ac(a, b);
}
function $fe4108adad250e9a$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $fe4108adad250e9a$var$Bg(a, b, c, d) {
    return new $fe4108adad250e9a$var$$k(a, b, c, d);
}
function $fe4108adad250e9a$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $fe4108adad250e9a$var$Zk(a) {
    if ("function" === typeof a) return $fe4108adad250e9a$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $fe4108adad250e9a$var$Da) return 11;
        if (a === $fe4108adad250e9a$var$Ga) return 14;
    }
    return 2;
}
function $fe4108adad250e9a$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $fe4108adad250e9a$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $fe4108adad250e9a$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $fe4108adad250e9a$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $fe4108adad250e9a$var$ya:
            return $fe4108adad250e9a$var$Tg(c.children, e, f, b);
        case $fe4108adad250e9a$var$za:
            g = 8;
            e |= 8;
            break;
        case $fe4108adad250e9a$var$Aa:
            return a = $fe4108adad250e9a$var$Bg(12, c, b, e | 2), a.elementType = $fe4108adad250e9a$var$Aa, a.lanes = f, a;
        case $fe4108adad250e9a$var$Ea:
            return a = $fe4108adad250e9a$var$Bg(13, c, b, e), a.elementType = $fe4108adad250e9a$var$Ea, a.lanes = f, a;
        case $fe4108adad250e9a$var$Fa:
            return a = $fe4108adad250e9a$var$Bg(19, c, b, e), a.elementType = $fe4108adad250e9a$var$Fa, a.lanes = f, a;
        case $fe4108adad250e9a$var$Ia:
            return $fe4108adad250e9a$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $fe4108adad250e9a$var$Ba:
                    g = 10;
                    break a;
                case $fe4108adad250e9a$var$Ca:
                    g = 9;
                    break a;
                case $fe4108adad250e9a$var$Da:
                    g = 11;
                    break a;
                case $fe4108adad250e9a$var$Ga:
                    g = 14;
                    break a;
                case $fe4108adad250e9a$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($fe4108adad250e9a$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $fe4108adad250e9a$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $fe4108adad250e9a$var$Tg(a, b, c, d) {
    a = $fe4108adad250e9a$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $fe4108adad250e9a$var$pj(a, b, c, d) {
    a = $fe4108adad250e9a$var$Bg(22, a, d, b);
    a.elementType = $fe4108adad250e9a$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $fe4108adad250e9a$var$Qg(a, b, c) {
    a = $fe4108adad250e9a$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $fe4108adad250e9a$var$Sg(a, b, c) {
    b = $fe4108adad250e9a$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $fe4108adad250e9a$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $fe4108adad250e9a$var$zc(0);
    this.expirationTimes = $fe4108adad250e9a$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $fe4108adad250e9a$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $fe4108adad250e9a$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $fe4108adad250e9a$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $fe4108adad250e9a$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $fe4108adad250e9a$var$kh(f);
    return a;
}
function $fe4108adad250e9a$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $fe4108adad250e9a$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $fe4108adad250e9a$var$dl(a) {
    if (!a) return $fe4108adad250e9a$var$Vf;
    a = a._reactInternals;
    a: {
        if ($fe4108adad250e9a$var$Vb(a) !== a || 1 !== a.tag) throw Error($fe4108adad250e9a$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($fe4108adad250e9a$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($fe4108adad250e9a$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($fe4108adad250e9a$var$Zf(c)) return $fe4108adad250e9a$var$bg(a, c, b);
    }
    return b;
}
function $fe4108adad250e9a$var$el(a, b, c, d, e, f, g, h, k) {
    a = $fe4108adad250e9a$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $fe4108adad250e9a$var$dl(null);
    c = a.current;
    d = $fe4108adad250e9a$var$R();
    e = $fe4108adad250e9a$var$yi(c);
    f = $fe4108adad250e9a$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $fe4108adad250e9a$var$nh(c, f, e);
    a.current.lanes = e;
    $fe4108adad250e9a$var$Ac(a, e, d);
    $fe4108adad250e9a$var$Dk(a, d);
    return a;
}
function $fe4108adad250e9a$var$fl(a, b, c, d) {
    var e = b.current, f = $fe4108adad250e9a$var$R(), g = $fe4108adad250e9a$var$yi(e);
    c = $fe4108adad250e9a$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $fe4108adad250e9a$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $fe4108adad250e9a$var$nh(e, b, g);
    null !== a && ($fe4108adad250e9a$var$gi(a, e, g, f), $fe4108adad250e9a$var$oh(a, e, g));
    return g;
}
function $fe4108adad250e9a$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $fe4108adad250e9a$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $fe4108adad250e9a$var$il(a, b) {
    $fe4108adad250e9a$var$hl(a, b);
    (a = a.alternate) && $fe4108adad250e9a$var$hl(a, b);
}
function $fe4108adad250e9a$var$jl() {
    return null;
}
var $fe4108adad250e9a$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $fe4108adad250e9a$var$ll(a) {
    this._internalRoot = a;
}
$fe4108adad250e9a$var$ml.prototype.render = $fe4108adad250e9a$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($fe4108adad250e9a$var$p(409));
    $fe4108adad250e9a$var$fl(a, b, null, null);
};
$fe4108adad250e9a$var$ml.prototype.unmount = $fe4108adad250e9a$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $fe4108adad250e9a$var$Rk(function() {
            $fe4108adad250e9a$var$fl(null, a, null, null);
        });
        b[$fe4108adad250e9a$var$uf] = null;
    }
};
function $fe4108adad250e9a$var$ml(a) {
    this._internalRoot = a;
}
$fe4108adad250e9a$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $fe4108adad250e9a$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $fe4108adad250e9a$var$Qc.length && 0 !== b && b < $fe4108adad250e9a$var$Qc[c].priority; c++);
        $fe4108adad250e9a$var$Qc.splice(c, 0, a);
        0 === c && $fe4108adad250e9a$var$Vc(a);
    }
};
function $fe4108adad250e9a$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $fe4108adad250e9a$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $fe4108adad250e9a$var$pl() {}
function $fe4108adad250e9a$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $fe4108adad250e9a$var$gl(g);
                f.call(a);
            };
        }
        var g = $fe4108adad250e9a$var$el(b, d, a, 0, null, !1, !1, "", $fe4108adad250e9a$var$pl);
        a._reactRootContainer = g;
        a[$fe4108adad250e9a$var$uf] = g.current;
        $fe4108adad250e9a$var$sf(8 === a.nodeType ? a.parentNode : a);
        $fe4108adad250e9a$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $fe4108adad250e9a$var$gl(k);
            h.call(a);
        };
    }
    var k = $fe4108adad250e9a$var$bl(a, 0, !1, null, null, !1, !1, "", $fe4108adad250e9a$var$pl);
    a._reactRootContainer = k;
    a[$fe4108adad250e9a$var$uf] = k.current;
    $fe4108adad250e9a$var$sf(8 === a.nodeType ? a.parentNode : a);
    $fe4108adad250e9a$var$Rk(function() {
        $fe4108adad250e9a$var$fl(b, k, c, d);
    });
    return k;
}
function $fe4108adad250e9a$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $fe4108adad250e9a$var$gl(g);
                h.call(a);
            };
        }
        $fe4108adad250e9a$var$fl(b, g, a, e);
    } else g = $fe4108adad250e9a$var$ql(c, b, a, e, d);
    return $fe4108adad250e9a$var$gl(g);
}
$fe4108adad250e9a$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $fe4108adad250e9a$var$tc(b.pendingLanes);
                0 !== c && ($fe4108adad250e9a$var$Cc(b, c | 1), $fe4108adad250e9a$var$Dk(b, $fe4108adad250e9a$var$B()), 0 === ($fe4108adad250e9a$var$K & 6) && ($fe4108adad250e9a$var$Gj = $fe4108adad250e9a$var$B() + 500, $fe4108adad250e9a$var$jg()));
            }
            break;
        case 13:
            $fe4108adad250e9a$var$Rk(function() {
                var b = $fe4108adad250e9a$var$ih(a, 1);
                if (null !== b) {
                    var c = $fe4108adad250e9a$var$R();
                    $fe4108adad250e9a$var$gi(b, a, 1, c);
                }
            }), $fe4108adad250e9a$var$il(a, 1);
    }
};
$fe4108adad250e9a$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $fe4108adad250e9a$var$ih(a, 134217728);
        if (null !== b) {
            var c = $fe4108adad250e9a$var$R();
            $fe4108adad250e9a$var$gi(b, a, 134217728, c);
        }
        $fe4108adad250e9a$var$il(a, 134217728);
    }
};
$fe4108adad250e9a$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $fe4108adad250e9a$var$yi(a), c = $fe4108adad250e9a$var$ih(a, b);
        if (null !== c) {
            var d = $fe4108adad250e9a$var$R();
            $fe4108adad250e9a$var$gi(c, a, b, d);
        }
        $fe4108adad250e9a$var$il(a, b);
    }
};
$fe4108adad250e9a$var$Hc = function() {
    return $fe4108adad250e9a$var$C;
};
$fe4108adad250e9a$var$Ic = function(a, b) {
    var c = $fe4108adad250e9a$var$C;
    try {
        return $fe4108adad250e9a$var$C = a, b();
    } finally{
        $fe4108adad250e9a$var$C = c;
    }
};
$fe4108adad250e9a$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $fe4108adad250e9a$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $fe4108adad250e9a$var$Db(d);
                        if (!e) throw Error($fe4108adad250e9a$var$p(90));
                        $fe4108adad250e9a$var$Wa(d);
                        $fe4108adad250e9a$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $fe4108adad250e9a$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $fe4108adad250e9a$var$fb(a, !!c.multiple, b, !1);
    }
};
$fe4108adad250e9a$var$Gb = $fe4108adad250e9a$var$Qk;
$fe4108adad250e9a$var$Hb = $fe4108adad250e9a$var$Rk;
var $fe4108adad250e9a$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $fe4108adad250e9a$var$Cb,
        $fe4108adad250e9a$var$ue,
        $fe4108adad250e9a$var$Db,
        $fe4108adad250e9a$var$Eb,
        $fe4108adad250e9a$var$Fb,
        $fe4108adad250e9a$var$Qk
    ]
}, $fe4108adad250e9a$var$tl = {
    findFiberByHostInstance: $fe4108adad250e9a$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $fe4108adad250e9a$var$ul = {
    bundleType: $fe4108adad250e9a$var$tl.bundleType,
    version: $fe4108adad250e9a$var$tl.version,
    rendererPackageName: $fe4108adad250e9a$var$tl.rendererPackageName,
    rendererConfig: $fe4108adad250e9a$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $fe4108adad250e9a$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $fe4108adad250e9a$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $fe4108adad250e9a$var$tl.findFiberByHostInstance || $fe4108adad250e9a$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $fe4108adad250e9a$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$fe4108adad250e9a$var$vl.isDisabled && $fe4108adad250e9a$var$vl.supportsFiber) try {
        $fe4108adad250e9a$var$kc = $fe4108adad250e9a$var$vl.inject($fe4108adad250e9a$var$ul), $fe4108adad250e9a$var$lc = $fe4108adad250e9a$var$vl;
    } catch (a) {}
}
$fe4108adad250e9a$export$ae55be85d98224ed = $fe4108adad250e9a$var$sl;
$fe4108adad250e9a$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$fe4108adad250e9a$var$nl(b)) throw Error($fe4108adad250e9a$var$p(200));
    return $fe4108adad250e9a$var$cl(a, b, null, c);
};
$fe4108adad250e9a$export$882461b6382ed46c = function(a, b) {
    if (!$fe4108adad250e9a$var$nl(a)) throw Error($fe4108adad250e9a$var$p(299));
    var c = !1, d = "", e = $fe4108adad250e9a$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $fe4108adad250e9a$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$fe4108adad250e9a$var$uf] = b.current;
    $fe4108adad250e9a$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $fe4108adad250e9a$var$ll(b);
};
$fe4108adad250e9a$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($fe4108adad250e9a$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($fe4108adad250e9a$var$p(268, a));
    }
    a = $fe4108adad250e9a$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$fe4108adad250e9a$export$cd75ccfd720a3cd4 = function(a) {
    return $fe4108adad250e9a$var$Rk(a);
};
$fe4108adad250e9a$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$fe4108adad250e9a$var$ol(b)) throw Error($fe4108adad250e9a$var$p(200));
    return $fe4108adad250e9a$var$rl(null, a, b, !0, c);
};
$fe4108adad250e9a$export$757ceba2d55c277e = function(a, b, c) {
    if (!$fe4108adad250e9a$var$nl(a)) throw Error($fe4108adad250e9a$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $fe4108adad250e9a$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $fe4108adad250e9a$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$fe4108adad250e9a$var$uf] = b.current;
    $fe4108adad250e9a$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $fe4108adad250e9a$var$ml(b);
};
$fe4108adad250e9a$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$fe4108adad250e9a$var$ol(b)) throw Error($fe4108adad250e9a$var$p(200));
    return $fe4108adad250e9a$var$rl(null, a, b, !1, c);
};
$fe4108adad250e9a$export$502457920280e6be = function(a) {
    if (!$fe4108adad250e9a$var$ol(a)) throw Error($fe4108adad250e9a$var$p(40));
    return a._reactRootContainer ? ($fe4108adad250e9a$var$Rk(function() {
        $fe4108adad250e9a$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$fe4108adad250e9a$var$uf] = null;
        });
    }), !0) : !1;
};
$fe4108adad250e9a$export$c78a37762a8d58e1 = $fe4108adad250e9a$var$Qk;
$fe4108adad250e9a$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$fe4108adad250e9a$var$ol(c)) throw Error($fe4108adad250e9a$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($fe4108adad250e9a$var$p(38));
    return $fe4108adad250e9a$var$rl(a, b, c, !1, d);
};
$fe4108adad250e9a$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("eq2VS", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9zug1"));

});
parcelRegister("9zug1", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $6f7eda6fdbcdb4e9$export$c4744153514ff05d; }, function (v) { return $6f7eda6fdbcdb4e9$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6f7eda6fdbcdb4e9$export$3e506c1ccc9cc1a7; }, function (v) { return $6f7eda6fdbcdb4e9$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6f7eda6fdbcdb4e9$export$e26fe2ed2fa76875; }, function (v) { return $6f7eda6fdbcdb4e9$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6f7eda6fdbcdb4e9$export$502329bbf4b505b1; }, function (v) { return $6f7eda6fdbcdb4e9$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6f7eda6fdbcdb4e9$export$6e3807111c4874c4; }, function (v) { return $6f7eda6fdbcdb4e9$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6f7eda6fdbcdb4e9$export$c27134553091fb3a; }, function (v) { return $6f7eda6fdbcdb4e9$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6f7eda6fdbcdb4e9$export$33ee1acdc04fd2a2; }, function (v) { return $6f7eda6fdbcdb4e9$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6f7eda6fdbcdb4e9$export$b00a404bbd5edef2; }, function (v) { return $6f7eda6fdbcdb4e9$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $6f7eda6fdbcdb4e9$export$8352ce38b91d0c62; }, function (v) { return $6f7eda6fdbcdb4e9$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6f7eda6fdbcdb4e9$export$d66a1c1c77bd778b; }, function (v) { return $6f7eda6fdbcdb4e9$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6f7eda6fdbcdb4e9$export$d3dfb8e4810cb555; }, function (v) { return $6f7eda6fdbcdb4e9$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $6f7eda6fdbcdb4e9$export$839f9183b0465a69; }, function (v) { return $6f7eda6fdbcdb4e9$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6f7eda6fdbcdb4e9$export$72fdf0e06517287b; }, function (v) { return $6f7eda6fdbcdb4e9$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $6f7eda6fdbcdb4e9$export$4b844e58a3e414b4; }, function (v) { return $6f7eda6fdbcdb4e9$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6f7eda6fdbcdb4e9$export$816d2913ae6b83b1; }, function (v) { return $6f7eda6fdbcdb4e9$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6f7eda6fdbcdb4e9$export$61bcfe829111a1d0; }, function (v) { return $6f7eda6fdbcdb4e9$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6f7eda6fdbcdb4e9$export$7ee8c9beb337bc3f; }, function (v) { return $6f7eda6fdbcdb4e9$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6f7eda6fdbcdb4e9$export$b5836b71941fa3ed; }, function (v) { return $6f7eda6fdbcdb4e9$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6f7eda6fdbcdb4e9$export$cf845f2c119da08a; }, function (v) { return $6f7eda6fdbcdb4e9$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6f7eda6fdbcdb4e9$export$c4744153514ff05d;
var $6f7eda6fdbcdb4e9$export$3e506c1ccc9cc1a7;
var $6f7eda6fdbcdb4e9$export$e26fe2ed2fa76875;
var $6f7eda6fdbcdb4e9$export$502329bbf4b505b1;
var $6f7eda6fdbcdb4e9$export$6e3807111c4874c4;
var $6f7eda6fdbcdb4e9$export$c27134553091fb3a;
var $6f7eda6fdbcdb4e9$export$33ee1acdc04fd2a2;
var $6f7eda6fdbcdb4e9$export$b00a404bbd5edef2;
var $6f7eda6fdbcdb4e9$export$8352ce38b91d0c62;
var $6f7eda6fdbcdb4e9$export$d66a1c1c77bd778b;
var $6f7eda6fdbcdb4e9$export$d3dfb8e4810cb555;
var $6f7eda6fdbcdb4e9$export$839f9183b0465a69;
var $6f7eda6fdbcdb4e9$export$72fdf0e06517287b;
var $6f7eda6fdbcdb4e9$export$4b844e58a3e414b4;
var $6f7eda6fdbcdb4e9$export$816d2913ae6b83b1;
var $6f7eda6fdbcdb4e9$export$61bcfe829111a1d0;
var $6f7eda6fdbcdb4e9$export$7ee8c9beb337bc3f;
var $6f7eda6fdbcdb4e9$export$b5836b71941fa3ed;
var $6f7eda6fdbcdb4e9$export$cf845f2c119da08a;
'use strict';
function $6f7eda6fdbcdb4e9$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $6f7eda6fdbcdb4e9$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $6f7eda6fdbcdb4e9$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $6f7eda6fdbcdb4e9$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $6f7eda6fdbcdb4e9$var$g(C, c)) n < e && 0 > $6f7eda6fdbcdb4e9$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $6f7eda6fdbcdb4e9$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $6f7eda6fdbcdb4e9$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6f7eda6fdbcdb4e9$var$l = performance;
    $6f7eda6fdbcdb4e9$export$c4744153514ff05d = function() {
        return $6f7eda6fdbcdb4e9$var$l.now();
    };
} else {
    var $6f7eda6fdbcdb4e9$var$p = Date, $6f7eda6fdbcdb4e9$var$q = $6f7eda6fdbcdb4e9$var$p.now();
    $6f7eda6fdbcdb4e9$export$c4744153514ff05d = function() {
        return $6f7eda6fdbcdb4e9$var$p.now() - $6f7eda6fdbcdb4e9$var$q;
    };
}
var $6f7eda6fdbcdb4e9$var$r = [], $6f7eda6fdbcdb4e9$var$t = [], $6f7eda6fdbcdb4e9$var$u = 1, $6f7eda6fdbcdb4e9$var$v = null, $6f7eda6fdbcdb4e9$var$y = 3, $6f7eda6fdbcdb4e9$var$z = !1, $6f7eda6fdbcdb4e9$var$A = !1, $6f7eda6fdbcdb4e9$var$B = !1, $6f7eda6fdbcdb4e9$var$D = "function" === typeof setTimeout ? setTimeout : null, $6f7eda6fdbcdb4e9$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $6f7eda6fdbcdb4e9$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $6f7eda6fdbcdb4e9$var$G(a) {
    for(var b = $6f7eda6fdbcdb4e9$var$h($6f7eda6fdbcdb4e9$var$t); null !== b;){
        if (null === b.callback) $6f7eda6fdbcdb4e9$var$k($6f7eda6fdbcdb4e9$var$t);
        else if (b.startTime <= a) $6f7eda6fdbcdb4e9$var$k($6f7eda6fdbcdb4e9$var$t), b.sortIndex = b.expirationTime, $6f7eda6fdbcdb4e9$var$f($6f7eda6fdbcdb4e9$var$r, b);
        else break;
        b = $6f7eda6fdbcdb4e9$var$h($6f7eda6fdbcdb4e9$var$t);
    }
}
function $6f7eda6fdbcdb4e9$var$H(a) {
    $6f7eda6fdbcdb4e9$var$B = !1;
    $6f7eda6fdbcdb4e9$var$G(a);
    if (!$6f7eda6fdbcdb4e9$var$A) {
        if (null !== $6f7eda6fdbcdb4e9$var$h($6f7eda6fdbcdb4e9$var$r)) $6f7eda6fdbcdb4e9$var$A = !0, $6f7eda6fdbcdb4e9$var$I($6f7eda6fdbcdb4e9$var$J);
        else {
            var b = $6f7eda6fdbcdb4e9$var$h($6f7eda6fdbcdb4e9$var$t);
            null !== b && $6f7eda6fdbcdb4e9$var$K($6f7eda6fdbcdb4e9$var$H, b.startTime - a);
        }
    }
}
function $6f7eda6fdbcdb4e9$var$J(a, b) {
    $6f7eda6fdbcdb4e9$var$A = !1;
    $6f7eda6fdbcdb4e9$var$B && ($6f7eda6fdbcdb4e9$var$B = !1, $6f7eda6fdbcdb4e9$var$E($6f7eda6fdbcdb4e9$var$L), $6f7eda6fdbcdb4e9$var$L = -1);
    $6f7eda6fdbcdb4e9$var$z = !0;
    var c = $6f7eda6fdbcdb4e9$var$y;
    try {
        $6f7eda6fdbcdb4e9$var$G(b);
        for($6f7eda6fdbcdb4e9$var$v = $6f7eda6fdbcdb4e9$var$h($6f7eda6fdbcdb4e9$var$r); null !== $6f7eda6fdbcdb4e9$var$v && (!($6f7eda6fdbcdb4e9$var$v.expirationTime > b) || a && !$6f7eda6fdbcdb4e9$var$M());){
            var d = $6f7eda6fdbcdb4e9$var$v.callback;
            if ("function" === typeof d) {
                $6f7eda6fdbcdb4e9$var$v.callback = null;
                $6f7eda6fdbcdb4e9$var$y = $6f7eda6fdbcdb4e9$var$v.priorityLevel;
                var e = d($6f7eda6fdbcdb4e9$var$v.expirationTime <= b);
                b = $6f7eda6fdbcdb4e9$export$c4744153514ff05d();
                "function" === typeof e ? $6f7eda6fdbcdb4e9$var$v.callback = e : $6f7eda6fdbcdb4e9$var$v === $6f7eda6fdbcdb4e9$var$h($6f7eda6fdbcdb4e9$var$r) && $6f7eda6fdbcdb4e9$var$k($6f7eda6fdbcdb4e9$var$r);
                $6f7eda6fdbcdb4e9$var$G(b);
            } else $6f7eda6fdbcdb4e9$var$k($6f7eda6fdbcdb4e9$var$r);
            $6f7eda6fdbcdb4e9$var$v = $6f7eda6fdbcdb4e9$var$h($6f7eda6fdbcdb4e9$var$r);
        }
        if (null !== $6f7eda6fdbcdb4e9$var$v) var w = !0;
        else {
            var m = $6f7eda6fdbcdb4e9$var$h($6f7eda6fdbcdb4e9$var$t);
            null !== m && $6f7eda6fdbcdb4e9$var$K($6f7eda6fdbcdb4e9$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $6f7eda6fdbcdb4e9$var$v = null, $6f7eda6fdbcdb4e9$var$y = c, $6f7eda6fdbcdb4e9$var$z = !1;
    }
}
var $6f7eda6fdbcdb4e9$var$N = !1, $6f7eda6fdbcdb4e9$var$O = null, $6f7eda6fdbcdb4e9$var$L = -1, $6f7eda6fdbcdb4e9$var$P = 5, $6f7eda6fdbcdb4e9$var$Q = -1;
function $6f7eda6fdbcdb4e9$var$M() {
    return $6f7eda6fdbcdb4e9$export$c4744153514ff05d() - $6f7eda6fdbcdb4e9$var$Q < $6f7eda6fdbcdb4e9$var$P ? !1 : !0;
}
function $6f7eda6fdbcdb4e9$var$R() {
    if (null !== $6f7eda6fdbcdb4e9$var$O) {
        var a = $6f7eda6fdbcdb4e9$export$c4744153514ff05d();
        $6f7eda6fdbcdb4e9$var$Q = a;
        var b = !0;
        try {
            b = $6f7eda6fdbcdb4e9$var$O(!0, a);
        } finally{
            b ? $6f7eda6fdbcdb4e9$var$S() : ($6f7eda6fdbcdb4e9$var$N = !1, $6f7eda6fdbcdb4e9$var$O = null);
        }
    } else $6f7eda6fdbcdb4e9$var$N = !1;
}
var $6f7eda6fdbcdb4e9$var$S;
if ("function" === typeof $6f7eda6fdbcdb4e9$var$F) $6f7eda6fdbcdb4e9$var$S = function() {
    $6f7eda6fdbcdb4e9$var$F($6f7eda6fdbcdb4e9$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6f7eda6fdbcdb4e9$var$T = new MessageChannel, $6f7eda6fdbcdb4e9$var$U = $6f7eda6fdbcdb4e9$var$T.port2;
    $6f7eda6fdbcdb4e9$var$T.port1.onmessage = $6f7eda6fdbcdb4e9$var$R;
    $6f7eda6fdbcdb4e9$var$S = function() {
        $6f7eda6fdbcdb4e9$var$U.postMessage(null);
    };
} else $6f7eda6fdbcdb4e9$var$S = function() {
    $6f7eda6fdbcdb4e9$var$D($6f7eda6fdbcdb4e9$var$R, 0);
};
function $6f7eda6fdbcdb4e9$var$I(a) {
    $6f7eda6fdbcdb4e9$var$O = a;
    $6f7eda6fdbcdb4e9$var$N || ($6f7eda6fdbcdb4e9$var$N = !0, $6f7eda6fdbcdb4e9$var$S());
}
function $6f7eda6fdbcdb4e9$var$K(a, b) {
    $6f7eda6fdbcdb4e9$var$L = $6f7eda6fdbcdb4e9$var$D(function() {
        a($6f7eda6fdbcdb4e9$export$c4744153514ff05d());
    }, b);
}
$6f7eda6fdbcdb4e9$export$3e506c1ccc9cc1a7 = 5;
$6f7eda6fdbcdb4e9$export$e26fe2ed2fa76875 = 1;
$6f7eda6fdbcdb4e9$export$502329bbf4b505b1 = 4;
$6f7eda6fdbcdb4e9$export$6e3807111c4874c4 = 3;
$6f7eda6fdbcdb4e9$export$c27134553091fb3a = null;
$6f7eda6fdbcdb4e9$export$33ee1acdc04fd2a2 = 2;
$6f7eda6fdbcdb4e9$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$6f7eda6fdbcdb4e9$export$8352ce38b91d0c62 = function() {
    $6f7eda6fdbcdb4e9$var$A || $6f7eda6fdbcdb4e9$var$z || ($6f7eda6fdbcdb4e9$var$A = !0, $6f7eda6fdbcdb4e9$var$I($6f7eda6fdbcdb4e9$var$J));
};
$6f7eda6fdbcdb4e9$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6f7eda6fdbcdb4e9$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$6f7eda6fdbcdb4e9$export$d3dfb8e4810cb555 = function() {
    return $6f7eda6fdbcdb4e9$var$y;
};
$6f7eda6fdbcdb4e9$export$839f9183b0465a69 = function() {
    return $6f7eda6fdbcdb4e9$var$h($6f7eda6fdbcdb4e9$var$r);
};
$6f7eda6fdbcdb4e9$export$72fdf0e06517287b = function(a) {
    switch($6f7eda6fdbcdb4e9$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $6f7eda6fdbcdb4e9$var$y;
    }
    var c = $6f7eda6fdbcdb4e9$var$y;
    $6f7eda6fdbcdb4e9$var$y = b;
    try {
        return a();
    } finally{
        $6f7eda6fdbcdb4e9$var$y = c;
    }
};
$6f7eda6fdbcdb4e9$export$4b844e58a3e414b4 = function() {};
$6f7eda6fdbcdb4e9$export$816d2913ae6b83b1 = function() {};
$6f7eda6fdbcdb4e9$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $6f7eda6fdbcdb4e9$var$y;
    $6f7eda6fdbcdb4e9$var$y = a;
    try {
        return b();
    } finally{
        $6f7eda6fdbcdb4e9$var$y = c;
    }
};
$6f7eda6fdbcdb4e9$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $6f7eda6fdbcdb4e9$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $6f7eda6fdbcdb4e9$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $6f7eda6fdbcdb4e9$var$f($6f7eda6fdbcdb4e9$var$t, a), null === $6f7eda6fdbcdb4e9$var$h($6f7eda6fdbcdb4e9$var$r) && a === $6f7eda6fdbcdb4e9$var$h($6f7eda6fdbcdb4e9$var$t) && ($6f7eda6fdbcdb4e9$var$B ? ($6f7eda6fdbcdb4e9$var$E($6f7eda6fdbcdb4e9$var$L), $6f7eda6fdbcdb4e9$var$L = -1) : $6f7eda6fdbcdb4e9$var$B = !0, $6f7eda6fdbcdb4e9$var$K($6f7eda6fdbcdb4e9$var$H, c - d))) : (a.sortIndex = e, $6f7eda6fdbcdb4e9$var$f($6f7eda6fdbcdb4e9$var$r, a), $6f7eda6fdbcdb4e9$var$A || $6f7eda6fdbcdb4e9$var$z || ($6f7eda6fdbcdb4e9$var$A = !0, $6f7eda6fdbcdb4e9$var$I($6f7eda6fdbcdb4e9$var$J)));
    return a;
};
$6f7eda6fdbcdb4e9$export$b5836b71941fa3ed = $6f7eda6fdbcdb4e9$var$M;
$6f7eda6fdbcdb4e9$export$cf845f2c119da08a = function(a) {
    var b = $6f7eda6fdbcdb4e9$var$y;
    return function() {
        var c = $6f7eda6fdbcdb4e9$var$y;
        $6f7eda6fdbcdb4e9$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $6f7eda6fdbcdb4e9$var$y = c;
        }
    };
};

});



parcelRegister("6dpjF", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("lmedS", function(module, exports) {

$parcel$export(module.exports, "pathToURL", function () { return $0f5a2494c640a24d$export$730bcc5b37bd203c; });
$parcel$export(module.exports, "parsePayloadURLS", function () { return $0f5a2494c640a24d$export$f1f7f18ce5ce1e90; });

var $cTs7K = parcelRequire("cTs7K");
function $0f5a2494c640a24d$export$730bcc5b37bd203c(path) {
    // if (path?.startsWith('/')) return path; // To allow local paths to work in storybook
    return path && (0, $cTs7K.CDN_HOST) + path;
}
function $0f5a2494c640a24d$export$f1f7f18ce5ce1e90(json) {
    if (!(0, $cTs7K.IS_DISCORD_ACTIVITY)) return json;
    // Ideally we don't do this here, and also not hardcode twd stuff.
    const jsonString = JSON.stringify(json).replaceAll('https://content.ariseworlds.com/ariseware/', '/.proxy/arisecontent/ariseware/').replaceAll('https://cdn.ariseworlds.com/', '/.proxy/cdn/');
    return JSON.parse(jsonString);
}

});
parcelRegister("cTs7K", function(module, exports) {

$parcel$export(module.exports, "IS_DISCORD_ACTIVITY", function () { return $dcaf52292ae5022e$export$dba67fba4aff0023; });
$parcel$export(module.exports, "CDN_HOST", function () { return $dcaf52292ae5022e$export$4e2a8144f21bf311; });
$parcel$export(module.exports, "HOST_PLATFORM", function () { return $dcaf52292ae5022e$export$2b81ddc40117bf14; });
$parcel$export(module.exports, "BP_MOBILE_CHAT", function () { return $dcaf52292ae5022e$export$67bd39600f23cb85; });
$parcel$export(module.exports, "LS_HASSEENWORLDINTRO_KEY", function () { return $dcaf52292ae5022e$export$432b15cee471a58b; });
$parcel$export(module.exports, "LS_HASSEENSHOP_KEY", function () { return $dcaf52292ae5022e$export$325115ee4aff31f9; });
$parcel$export(module.exports, "LS_MANUALLY_MUTED_KEY", function () { return $dcaf52292ae5022e$export$94ba91138d876024; });
$parcel$export(module.exports, "FEED_MESSAGES_TO_LOAD", function () { return $dcaf52292ae5022e$export$890bcb35b2d29224; });
$parcel$export(module.exports, "DEFAULT_LANG", function () { return $dcaf52292ae5022e$export$90898903f0729f34; });
const $dcaf52292ae5022e$export$dba67fba4aff0023 = window.location.hostname.endsWith('discordsays.com');
const $dcaf52292ae5022e$export$7b7c8816e184fa9b = window.location.hostname.endsWith('devvit.net');
const $dcaf52292ae5022e$export$4e2a8144f21bf311 = $dcaf52292ae5022e$export$dba67fba4aff0023 ? '/.proxy/cdn/' : 'https://cdn.ariseworlds.com/';
const $dcaf52292ae5022e$export$2b81ddc40117bf14 = $dcaf52292ae5022e$export$dba67fba4aff0023 ? 'discord' : $dcaf52292ae5022e$export$7b7c8816e184fa9b ? 'reddit' : 'web';
const $dcaf52292ae5022e$export$67bd39600f23cb85 = 992; // Also referenced in globals.scss
const $dcaf52292ae5022e$export$59ef9be27f51566d = 5;
const $dcaf52292ae5022e$export$432b15cee471a58b = 'ARISE_HASSEENWORLDINTRO';
const $dcaf52292ae5022e$export$325115ee4aff31f9 = 'ARISE_HASSEENSHOP';
const $dcaf52292ae5022e$export$514805d75386b7a2 = 'ARISE_NEWSMODAL_LAST_VERSION_SEEN';
const $dcaf52292ae5022e$export$94ba91138d876024 = 'ARISE_MANUALLY_MUTED';
const $dcaf52292ae5022e$export$890bcb35b2d29224 = 20;
const $dcaf52292ae5022e$export$90898903f0729f34 = {
    langISO: 'en-us',
    displayName: 'en-us'
};

});


parcelRegister("i2KZ1", function(module, exports) {

$parcel$export(module.exports, "useAppDispatch", function () { return $bf97389b679d22fa$export$f51d452c10d5b956; });
$parcel$export(module.exports, "useAppSelector", function () { return $bf97389b679d22fa$export$a7347740d65f620b; });
$parcel$export(module.exports, "default", function () { return $bf97389b679d22fa$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Provider", function () { return $bf97389b679d22fa$export$2881499e37b75b9a; });

var $9h2J6 = parcelRequire("9h2J6");
parcelRequire("gvlFs");
var $7sFkD = parcelRequire("7sFkD");
var $k18Dd = parcelRequire("k18Dd");
var $5YtKx = parcelRequire("5YtKx");

var $61p16 = parcelRequire("61p16");

var $6Jwum = parcelRequire("6Jwum");

var $9HMNu = parcelRequire("9HMNu");

var $3yrZE = parcelRequire("3yrZE");

var $6KpYp = parcelRequire("6KpYp");

var $gxeM7 = parcelRequire("gxeM7");
const $bf97389b679d22fa$var$store = (0, $61p16.configureStore)({
    reducer: {
        app: (0, $9HMNu.default),
        auth: (0, $6Jwum.default),
        feed: (0, $3yrZE.feedReducer),
        profile: (0, $6KpYp.default),
        discord: (0, $gxeM7.default)
    }
});
const $bf97389b679d22fa$export$f51d452c10d5b956 = ()=>(0, $k18Dd.useDispatch)();
const $bf97389b679d22fa$export$a7347740d65f620b = (0, $5YtKx.useSelector);
var $bf97389b679d22fa$export$2e2bcd8739ae039 = $bf97389b679d22fa$var$store;
function $bf97389b679d22fa$export$2881499e37b75b9a({ children: children }) {
    return /*#__PURE__*/ (0, $9h2J6.jsx)((0, $7sFkD.default), {
        store: $bf97389b679d22fa$var$store,
        children: children
    });
}

});
parcelRegister("gvlFs", function(module, exports) {
$parcel$export(module.exports, "Provider", function () { return (parcelRequire("7sFkD")).default; });
$parcel$export(module.exports, "useDispatch", function () { return (parcelRequire("k18Dd")).useDispatch; });
$parcel$export(module.exports, "useSelector", function () { return (parcelRequire("5YtKx")).useSelector; });
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $9DtWg = parcelRequire("9DtWg");

var $cUlFZ = parcelRequire("cUlFZ");
parcelRequire("90GPv");
var $7WYFd = parcelRequire("7WYFd");

var $1u1pn = parcelRequire("1u1pn");

var $5YtKx = parcelRequire("5YtKx");

var $bySDn = parcelRequire("bySDn");
parcelRequire("kHDR6");
(0, $5YtKx.initializeUseSelector)((0, $cUlFZ.useSyncExternalStoreWithSelector));
(0, $bySDn.initializeConnect)((0, $9DtWg.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $1u1pn.setBatch)((0, $7WYFd.unstable_batchedUpdates));

});
parcelRegister("9DtWg", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gZKvO"));

});
parcelRegister("gZKvO", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $c5f66c3115fdd1d9$export$306c0aa65ff9ec16; }, function (v) { return $c5f66c3115fdd1d9$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c5f66c3115fdd1d9$export$306c0aa65ff9ec16;
"use strict";

var $7RNO0 = parcelRequire("7RNO0");
function $c5f66c3115fdd1d9$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $c5f66c3115fdd1d9$var$objectIs = "function" === typeof Object.is ? Object.is : $c5f66c3115fdd1d9$var$is, $c5f66c3115fdd1d9$var$useState = $7RNO0.useState, $c5f66c3115fdd1d9$var$useEffect = $7RNO0.useEffect, $c5f66c3115fdd1d9$var$useLayoutEffect = $7RNO0.useLayoutEffect, $c5f66c3115fdd1d9$var$useDebugValue = $7RNO0.useDebugValue;
function $c5f66c3115fdd1d9$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $c5f66c3115fdd1d9$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $c5f66c3115fdd1d9$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $c5f66c3115fdd1d9$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $c5f66c3115fdd1d9$var$useEffect(function() {
        $c5f66c3115fdd1d9$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $c5f66c3115fdd1d9$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $c5f66c3115fdd1d9$var$useDebugValue(value);
    return value;
}
function $c5f66c3115fdd1d9$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$c5f66c3115fdd1d9$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $c5f66c3115fdd1d9$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $c5f66c3115fdd1d9$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $c5f66c3115fdd1d9$var$useSyncExternalStore$1 : $c5f66c3115fdd1d9$var$useSyncExternalStore$2;
$c5f66c3115fdd1d9$export$306c0aa65ff9ec16 = void 0 !== $7RNO0.useSyncExternalStore ? $7RNO0.useSyncExternalStore : $c5f66c3115fdd1d9$var$shim;

});


parcelRegister("cUlFZ", function(module, exports) {
'use strict';

module.exports = (parcelRequire("7iB91"));

});
parcelRegister("7iB91", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $550706fc145d911c$export$bf730a2d8bf68b42; }, function (v) { return $550706fc145d911c$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $550706fc145d911c$export$bf730a2d8bf68b42;
"use strict";

var $7RNO0 = parcelRequire("7RNO0");

var $9DtWg = parcelRequire("9DtWg");
function $550706fc145d911c$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $550706fc145d911c$var$objectIs = "function" === typeof Object.is ? Object.is : $550706fc145d911c$var$is, $550706fc145d911c$var$useSyncExternalStore = $9DtWg.useSyncExternalStore, $550706fc145d911c$var$useRef = $7RNO0.useRef, $550706fc145d911c$var$useEffect = $7RNO0.useEffect, $550706fc145d911c$var$useMemo = $7RNO0.useMemo, $550706fc145d911c$var$useDebugValue = $7RNO0.useDebugValue;
$550706fc145d911c$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $550706fc145d911c$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $550706fc145d911c$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($550706fc145d911c$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $550706fc145d911c$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $550706fc145d911c$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $550706fc145d911c$var$useDebugValue(value);
    return value;
};

});


parcelRegister("90GPv", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", function () { return (parcelRequire("7WYFd")).unstable_batchedUpdates; });

var $7WYFd = parcelRequire("7WYFd");

});
parcelRegister("7WYFd", function(module, exports) {
'use strict';
function $5c9d01bc36c8e3dc$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($5c9d01bc36c8e3dc$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$5c9d01bc36c8e3dc$var$checkDCE();

module.exports = (parcelRequire("lPo4y"));

});


parcelRegister("1u1pn", function(module, exports) {

$parcel$export(module.exports, "setBatch", function () { return $1149af6fa1afbed8$export$4b9874722d0da7bc; });
$parcel$export(module.exports, "getBatch", function () { return $1149af6fa1afbed8$export$fc47d4c0ba3bd2c6; });
// Default to a dummy "batch" implementation that just runs the callback
function $1149af6fa1afbed8$var$defaultNoopBatch(callback) {
    callback();
}
let $1149af6fa1afbed8$var$batch = $1149af6fa1afbed8$var$defaultNoopBatch; // Allow injecting another batching function later
const $1149af6fa1afbed8$export$4b9874722d0da7bc = (newBatch)=>$1149af6fa1afbed8$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $1149af6fa1afbed8$export$fc47d4c0ba3bd2c6 = ()=>$1149af6fa1afbed8$var$batch;

});

parcelRegister("5YtKx", function(module, exports) {

$parcel$export(module.exports, "initializeUseSelector", function () { return $4599a1fe80724327$export$e2e6e3f3f3b782e3; });
$parcel$export(module.exports, "useSelector", function () { return $4599a1fe80724327$export$2105062e25df4afe; });

var $7RNO0 = parcelRequire("7RNO0");

var $aGnTY = parcelRequire("aGnTY");

var $jCBAi = parcelRequire("jCBAi");

var $9tDKR = parcelRequire("9tDKR");
let $4599a1fe80724327$var$useSyncExternalStoreWithSelector = (0, $9tDKR.notInitialized);
const $4599a1fe80724327$export$e2e6e3f3f3b782e3 = (fn)=>{
    $4599a1fe80724327$var$useSyncExternalStoreWithSelector = fn;
};
const $4599a1fe80724327$var$refEquality = (a, b)=>a === b;
function $4599a1fe80724327$export$2b53f90d2bd1cbfb(context = (0, $jCBAi.ReactReduxContext)) {
    const useReduxContext = context === (0, $jCBAi.ReactReduxContext) ? (0, $aGnTY.useReduxContext) : (0, $aGnTY.createReduxContextHook)(context);
    return function useSelector(selector, equalityFnOrOptions = {}) {
        const { equalityFn: equalityFn = $4599a1fe80724327$var$refEquality, stabilityCheck: stabilityCheck, noopCheck: noopCheck } = typeof equalityFnOrOptions === 'function' ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: globalStabilityCheck, noopCheck: globalNoopCheck } = useReduxContext();
        const firstRun = (0, $7RNO0.useRef)(true);
        const wrappedSelector = (0, $7RNO0.useCallback)({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        const selectedState = $4599a1fe80724327$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, $7RNO0.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $4599a1fe80724327$export$2105062e25df4afe = /*#__PURE__*/ $4599a1fe80724327$export$2b53f90d2bd1cbfb();

});
parcelRegister("aGnTY", function(module, exports) {

$parcel$export(module.exports, "createReduxContextHook", function () { return $7c705e0beaa4fb28$export$d4d6226d5fc61558; });
$parcel$export(module.exports, "useReduxContext", function () { return $7c705e0beaa4fb28$export$c1275ca9a6fd3ec5; });

var $7RNO0 = parcelRequire("7RNO0");

var $jCBAi = parcelRequire("jCBAi");
function $7c705e0beaa4fb28$export$d4d6226d5fc61558(context = (0, $jCBAi.ReactReduxContext)) {
    return function useReduxContext() {
        const contextValue = (0, $7RNO0.useContext)(context);
        return contextValue;
    };
}
const $7c705e0beaa4fb28$export$c1275ca9a6fd3ec5 = /*#__PURE__*/ $7c705e0beaa4fb28$export$d4d6226d5fc61558();

});
parcelRegister("jCBAi", function(module, exports) {

$parcel$export(module.exports, "ReactReduxContext", function () { return $e48eb86ef49d5681$export$cc80c08dc91f1c00; });

var $7RNO0 = parcelRequire("7RNO0");
const $e48eb86ef49d5681$var$ContextKey = Symbol.for(`react-redux-context`);
const $e48eb86ef49d5681$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $e48eb86ef49d5681$var$getContext() {
    var _gT$ContextKey;
    if (!$7RNO0.createContext) return {};
    const contextMap = (_gT$ContextKey = $e48eb86ef49d5681$var$gT[$e48eb86ef49d5681$var$ContextKey]) != null ? _gT$ContextKey : $e48eb86ef49d5681$var$gT[$e48eb86ef49d5681$var$ContextKey] = new Map();
    let realContext = contextMap.get($7RNO0.createContext);
    if (!realContext) {
        realContext = $7RNO0.createContext(null);
        contextMap.set($7RNO0.createContext, realContext);
    }
    return realContext;
}
const $e48eb86ef49d5681$export$cc80c08dc91f1c00 = /*#__PURE__*/ $e48eb86ef49d5681$var$getContext();
var $e48eb86ef49d5681$export$2e2bcd8739ae039 = $e48eb86ef49d5681$export$cc80c08dc91f1c00;

});


parcelRegister("9tDKR", function(module, exports) {

$parcel$export(module.exports, "notInitialized", function () { return $6e65a8f403efc530$export$20656a4825650bd0; });
const $6e65a8f403efc530$export$20656a4825650bd0 = ()=>{
    throw new Error('uSES not initialized!');
};

});


parcelRegister("bySDn", function(module, exports) {

$parcel$export(module.exports, "initializeConnect", function () { return $86ad3fdb94ab97ed$export$36d45daa6a4925b8; });

var $d1eVZ = parcelRequire("d1eVZ");

var $jMczY = parcelRequire("jMczY");

var $4n0vC = parcelRequire("4n0vC");

var $7RNO0 = parcelRequire("7RNO0");

var $hhpQV = parcelRequire("hhpQV");

var $lnJlj = parcelRequire("lnJlj");

var $jlBQW = parcelRequire("jlBQW");

var $4SOIn = parcelRequire("4SOIn");

var $c1yJG = parcelRequire("c1yJG");

var $llMOH = parcelRequire("llMOH");

var $7uWZA = parcelRequire("7uWZA");

var $fr3WY = parcelRequire("fr3WY");
parcelRequire("44r0c");

var $jCBAi = parcelRequire("jCBAi");

var $9tDKR = parcelRequire("9tDKR");
const $86ad3fdb94ab97ed$var$_excluded = [
    "reactReduxForwardedRef"
];
let $86ad3fdb94ab97ed$var$useSyncExternalStore = (0, $9tDKR.notInitialized);
const $86ad3fdb94ab97ed$export$36d45daa6a4925b8 = (fn)=>{
    $86ad3fdb94ab97ed$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $86ad3fdb94ab97ed$var$EMPTY_ARRAY = [
    null,
    0
];
const $86ad3fdb94ab97ed$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $86ad3fdb94ab97ed$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $86ad3fdb94ab97ed$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $7uWZA.useIsomorphicLayoutEffect)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $86ad3fdb94ab97ed$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $86ad3fdb94ab97ed$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $86ad3fdb94ab97ed$var$initStateUpdates = ()=>$86ad3fdb94ab97ed$var$EMPTY_ARRAY;
function $86ad3fdb94ab97ed$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $86ad3fdb94ab97ed$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $86ad3fdb94ab97ed$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $86ad3fdb94ab97ed$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $fr3WY.default), areStatePropsEqual: areStatePropsEqual = (0, $fr3WY.default), areMergedPropsEqual: areMergedPropsEqual = (0, $fr3WY.default), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $jCBAi.ReactReduxContext) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $4SOIn.mapStateToPropsFactory)(mapStateToProps);
    const initMapDispatchToProps = (0, $jlBQW.mapDispatchToPropsFactory)(mapDispatchToProps);
    const initMergeProps = (0, $c1yJG.mergePropsFactory)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $7RNO0.useMemo(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $jMczY.default)(props, $86ad3fdb94ab97ed$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = $7RNO0.useMemo(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $hhpQV.isContextConsumer)(/*#__PURE__*/ $7RNO0.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = $7RNO0.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $7RNO0.useMemo(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $lnJlj.default)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $7RNO0.useMemo(()=>{
                if (!shouldHandleStateChanges) return $86ad3fdb94ab97ed$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $llMOH.createSubscription)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = $7RNO0.useMemo(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $d1eVZ.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = $7RNO0.useRef();
            const lastWrapperProps = $7RNO0.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $7RNO0.useRef();
            const renderIsScheduled = $7RNO0.useRef(false);
            const isProcessingDispatch = $7RNO0.useRef(false);
            const isMounted = $7RNO0.useRef(false);
            const latestSubscriptionCallbackError = $7RNO0.useRef();
            (0, $7uWZA.useIsomorphicLayoutEffect)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $7RNO0.useMemo(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = $7RNO0.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $86ad3fdb94ab97ed$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $86ad3fdb94ab97ed$var$useIsomorphicLayoutEffectWithArgs($86ad3fdb94ab97ed$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $86ad3fdb94ab97ed$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $7uWZA.useIsomorphicLayoutEffect)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = $7RNO0.useMemo(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                $7RNO0.createElement(WrappedComponent, (0, $d1eVZ.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = $7RNO0.useMemo(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ $7RNO0.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $7RNO0.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $7RNO0.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ $7RNO0.createElement(Connect, (0, $d1eVZ.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($4n0vC)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($4n0vC)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $86ad3fdb94ab97ed$export$2e2bcd8739ae039 = $86ad3fdb94ab97ed$var$connect;

});
parcelRegister("d1eVZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97a6f406d83bacc3$export$2e2bcd8739ae039; });
function $97a6f406d83bacc3$export$2e2bcd8739ae039() {
    return $97a6f406d83bacc3$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $97a6f406d83bacc3$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("jMczY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e65c4200c08991a2$export$2e2bcd8739ae039; });
function $e65c4200c08991a2$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("4n0vC", function(module, exports) {
'use strict';

var $cOk1c = parcelRequire("cOk1c");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $32e9b47aab52e28a$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $32e9b47aab52e28a$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $32e9b47aab52e28a$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $32e9b47aab52e28a$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $32e9b47aab52e28a$var$TYPE_STATICS = {};
$32e9b47aab52e28a$var$TYPE_STATICS[$cOk1c.ForwardRef] = $32e9b47aab52e28a$var$FORWARD_REF_STATICS;
$32e9b47aab52e28a$var$TYPE_STATICS[$cOk1c.Memo] = $32e9b47aab52e28a$var$MEMO_STATICS;
function $32e9b47aab52e28a$var$getStatics(component) {
    // React v16.11 and below
    if ($cOk1c.isMemo(component)) return $32e9b47aab52e28a$var$MEMO_STATICS;
     // React v16.12 and above
    return $32e9b47aab52e28a$var$TYPE_STATICS[component['$$typeof']] || $32e9b47aab52e28a$var$REACT_STATICS;
}
var $32e9b47aab52e28a$var$defineProperty = Object.defineProperty;
var $32e9b47aab52e28a$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $32e9b47aab52e28a$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $32e9b47aab52e28a$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $32e9b47aab52e28a$var$getPrototypeOf = Object.getPrototypeOf;
var $32e9b47aab52e28a$var$objectPrototype = Object.prototype;
function $32e9b47aab52e28a$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($32e9b47aab52e28a$var$objectPrototype) {
            var inheritedComponent = $32e9b47aab52e28a$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $32e9b47aab52e28a$var$objectPrototype) $32e9b47aab52e28a$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $32e9b47aab52e28a$var$getOwnPropertyNames(sourceComponent);
        if ($32e9b47aab52e28a$var$getOwnPropertySymbols) keys = keys.concat($32e9b47aab52e28a$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $32e9b47aab52e28a$var$getStatics(targetComponent);
        var sourceStatics = $32e9b47aab52e28a$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$32e9b47aab52e28a$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $32e9b47aab52e28a$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $32e9b47aab52e28a$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $32e9b47aab52e28a$var$hoistNonReactStatics;

});
parcelRegister("cOk1c", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hhN5k"));

});
parcelRegister("hhN5k", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $c95a196ff5dcada3$export$2b8d127b894957b9; }, function (v) { return $c95a196ff5dcada3$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $c95a196ff5dcada3$export$cea3a54a6425200c; }, function (v) { return $c95a196ff5dcada3$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $c95a196ff5dcada3$export$a7c73072b1a182ae; }, function (v) { return $c95a196ff5dcada3$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $c95a196ff5dcada3$export$9f27bc3417b4524d; }, function (v) { return $c95a196ff5dcada3$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $c95a196ff5dcada3$export$db77ccec0bb4ccac; }, function (v) { return $c95a196ff5dcada3$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $c95a196ff5dcada3$export$8392c0c9d3dcbd35; }, function (v) { return $c95a196ff5dcada3$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $c95a196ff5dcada3$export$ffb0004e005737fa; }, function (v) { return $c95a196ff5dcada3$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $c95a196ff5dcada3$export$b624eff549462981; }, function (v) { return $c95a196ff5dcada3$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $c95a196ff5dcada3$export$7897aa7841a5380c; }, function (v) { return $c95a196ff5dcada3$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $c95a196ff5dcada3$export$602eac185826482c; }, function (v) { return $c95a196ff5dcada3$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $c95a196ff5dcada3$export$e2c29f18771995cb; }, function (v) { return $c95a196ff5dcada3$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $c95a196ff5dcada3$export$5f8d39834fd61797; }, function (v) { return $c95a196ff5dcada3$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $c95a196ff5dcada3$export$74bf444e3cd11ea5; }, function (v) { return $c95a196ff5dcada3$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $c95a196ff5dcada3$export$92387174baf9b227; }, function (v) { return $c95a196ff5dcada3$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $c95a196ff5dcada3$export$ec112efeb987d9c6; }, function (v) { return $c95a196ff5dcada3$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $c95a196ff5dcada3$export$b706b080d889d2c9; }, function (v) { return $c95a196ff5dcada3$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $c95a196ff5dcada3$export$5be5a87408f70ddc; }, function (v) { return $c95a196ff5dcada3$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $c95a196ff5dcada3$export$45a5e7f76e0caa8d; }, function (v) { return $c95a196ff5dcada3$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $c95a196ff5dcada3$export$455c2e768291efa6; }, function (v) { return $c95a196ff5dcada3$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $c95a196ff5dcada3$export$9522e17588c12572; }, function (v) { return $c95a196ff5dcada3$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $c95a196ff5dcada3$export$2110ac352bb060b9; }, function (v) { return $c95a196ff5dcada3$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $c95a196ff5dcada3$export$56885ab8b9c456ab; }, function (v) { return $c95a196ff5dcada3$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $c95a196ff5dcada3$export$d927fcb6adf8f9de; }, function (v) { return $c95a196ff5dcada3$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $c95a196ff5dcada3$export$b82d16f27459e05a; }, function (v) { return $c95a196ff5dcada3$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $c95a196ff5dcada3$export$522c17b4f5e123e8; }, function (v) { return $c95a196ff5dcada3$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $c95a196ff5dcada3$export$1aabd8a0274ecfd6; }, function (v) { return $c95a196ff5dcada3$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $c95a196ff5dcada3$export$9b621391a187a31a; }, function (v) { return $c95a196ff5dcada3$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $c95a196ff5dcada3$export$f5bbd400c2f4426f; }, function (v) { return $c95a196ff5dcada3$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c95a196ff5dcada3$export$2b8d127b894957b9;
var $c95a196ff5dcada3$export$cea3a54a6425200c;
var $c95a196ff5dcada3$export$a7c73072b1a182ae;
var $c95a196ff5dcada3$export$9f27bc3417b4524d;
var $c95a196ff5dcada3$export$db77ccec0bb4ccac;
var $c95a196ff5dcada3$export$8392c0c9d3dcbd35;
var $c95a196ff5dcada3$export$ffb0004e005737fa;
var $c95a196ff5dcada3$export$b624eff549462981;
var $c95a196ff5dcada3$export$7897aa7841a5380c;
var $c95a196ff5dcada3$export$602eac185826482c;
var $c95a196ff5dcada3$export$e2c29f18771995cb;
var $c95a196ff5dcada3$export$5f8d39834fd61797;
var $c95a196ff5dcada3$export$74bf444e3cd11ea5;
var $c95a196ff5dcada3$export$92387174baf9b227;
var $c95a196ff5dcada3$export$ec112efeb987d9c6;
var $c95a196ff5dcada3$export$b706b080d889d2c9;
var $c95a196ff5dcada3$export$5be5a87408f70ddc;
var $c95a196ff5dcada3$export$45a5e7f76e0caa8d;
var $c95a196ff5dcada3$export$455c2e768291efa6;
var $c95a196ff5dcada3$export$9522e17588c12572;
var $c95a196ff5dcada3$export$2110ac352bb060b9;
var $c95a196ff5dcada3$export$56885ab8b9c456ab;
var $c95a196ff5dcada3$export$d927fcb6adf8f9de;
var $c95a196ff5dcada3$export$b82d16f27459e05a;
var $c95a196ff5dcada3$export$522c17b4f5e123e8;
var $c95a196ff5dcada3$export$1aabd8a0274ecfd6;
var $c95a196ff5dcada3$export$9b621391a187a31a;
var $c95a196ff5dcada3$export$f5bbd400c2f4426f;
'use strict';
var $c95a196ff5dcada3$var$b = "function" === typeof Symbol && Symbol.for, $c95a196ff5dcada3$var$c = $c95a196ff5dcada3$var$b ? Symbol.for("react.element") : 60103, $c95a196ff5dcada3$var$d = $c95a196ff5dcada3$var$b ? Symbol.for("react.portal") : 60106, $c95a196ff5dcada3$var$e = $c95a196ff5dcada3$var$b ? Symbol.for("react.fragment") : 60107, $c95a196ff5dcada3$var$f = $c95a196ff5dcada3$var$b ? Symbol.for("react.strict_mode") : 60108, $c95a196ff5dcada3$var$g = $c95a196ff5dcada3$var$b ? Symbol.for("react.profiler") : 60114, $c95a196ff5dcada3$var$h = $c95a196ff5dcada3$var$b ? Symbol.for("react.provider") : 60109, $c95a196ff5dcada3$var$k = $c95a196ff5dcada3$var$b ? Symbol.for("react.context") : 60110, $c95a196ff5dcada3$var$l = $c95a196ff5dcada3$var$b ? Symbol.for("react.async_mode") : 60111, $c95a196ff5dcada3$var$m = $c95a196ff5dcada3$var$b ? Symbol.for("react.concurrent_mode") : 60111, $c95a196ff5dcada3$var$n = $c95a196ff5dcada3$var$b ? Symbol.for("react.forward_ref") : 60112, $c95a196ff5dcada3$var$p = $c95a196ff5dcada3$var$b ? Symbol.for("react.suspense") : 60113, $c95a196ff5dcada3$var$q = $c95a196ff5dcada3$var$b ? Symbol.for("react.suspense_list") : 60120, $c95a196ff5dcada3$var$r = $c95a196ff5dcada3$var$b ? Symbol.for("react.memo") : 60115, $c95a196ff5dcada3$var$t = $c95a196ff5dcada3$var$b ? Symbol.for("react.lazy") : 60116, $c95a196ff5dcada3$var$v = $c95a196ff5dcada3$var$b ? Symbol.for("react.block") : 60121, $c95a196ff5dcada3$var$w = $c95a196ff5dcada3$var$b ? Symbol.for("react.fundamental") : 60117, $c95a196ff5dcada3$var$x = $c95a196ff5dcada3$var$b ? Symbol.for("react.responder") : 60118, $c95a196ff5dcada3$var$y = $c95a196ff5dcada3$var$b ? Symbol.for("react.scope") : 60119;
function $c95a196ff5dcada3$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $c95a196ff5dcada3$var$c:
                switch(a = a.type, a){
                    case $c95a196ff5dcada3$var$l:
                    case $c95a196ff5dcada3$var$m:
                    case $c95a196ff5dcada3$var$e:
                    case $c95a196ff5dcada3$var$g:
                    case $c95a196ff5dcada3$var$f:
                    case $c95a196ff5dcada3$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $c95a196ff5dcada3$var$k:
                            case $c95a196ff5dcada3$var$n:
                            case $c95a196ff5dcada3$var$t:
                            case $c95a196ff5dcada3$var$r:
                            case $c95a196ff5dcada3$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $c95a196ff5dcada3$var$d:
                return u;
        }
    }
}
function $c95a196ff5dcada3$var$A(a) {
    return $c95a196ff5dcada3$var$z(a) === $c95a196ff5dcada3$var$m;
}
$c95a196ff5dcada3$export$2b8d127b894957b9 = $c95a196ff5dcada3$var$l;
$c95a196ff5dcada3$export$cea3a54a6425200c = $c95a196ff5dcada3$var$m;
$c95a196ff5dcada3$export$a7c73072b1a182ae = $c95a196ff5dcada3$var$k;
$c95a196ff5dcada3$export$9f27bc3417b4524d = $c95a196ff5dcada3$var$h;
$c95a196ff5dcada3$export$db77ccec0bb4ccac = $c95a196ff5dcada3$var$c;
$c95a196ff5dcada3$export$8392c0c9d3dcbd35 = $c95a196ff5dcada3$var$n;
$c95a196ff5dcada3$export$ffb0004e005737fa = $c95a196ff5dcada3$var$e;
$c95a196ff5dcada3$export$b624eff549462981 = $c95a196ff5dcada3$var$t;
$c95a196ff5dcada3$export$7897aa7841a5380c = $c95a196ff5dcada3$var$r;
$c95a196ff5dcada3$export$602eac185826482c = $c95a196ff5dcada3$var$d;
$c95a196ff5dcada3$export$e2c29f18771995cb = $c95a196ff5dcada3$var$g;
$c95a196ff5dcada3$export$5f8d39834fd61797 = $c95a196ff5dcada3$var$f;
$c95a196ff5dcada3$export$74bf444e3cd11ea5 = $c95a196ff5dcada3$var$p;
$c95a196ff5dcada3$export$92387174baf9b227 = function(a) {
    return $c95a196ff5dcada3$var$A(a) || $c95a196ff5dcada3$var$z(a) === $c95a196ff5dcada3$var$l;
};
$c95a196ff5dcada3$export$ec112efeb987d9c6 = $c95a196ff5dcada3$var$A;
$c95a196ff5dcada3$export$b706b080d889d2c9 = function(a) {
    return $c95a196ff5dcada3$var$z(a) === $c95a196ff5dcada3$var$k;
};
$c95a196ff5dcada3$export$5be5a87408f70ddc = function(a) {
    return $c95a196ff5dcada3$var$z(a) === $c95a196ff5dcada3$var$h;
};
$c95a196ff5dcada3$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $c95a196ff5dcada3$var$c;
};
$c95a196ff5dcada3$export$455c2e768291efa6 = function(a) {
    return $c95a196ff5dcada3$var$z(a) === $c95a196ff5dcada3$var$n;
};
$c95a196ff5dcada3$export$9522e17588c12572 = function(a) {
    return $c95a196ff5dcada3$var$z(a) === $c95a196ff5dcada3$var$e;
};
$c95a196ff5dcada3$export$2110ac352bb060b9 = function(a) {
    return $c95a196ff5dcada3$var$z(a) === $c95a196ff5dcada3$var$t;
};
$c95a196ff5dcada3$export$56885ab8b9c456ab = function(a) {
    return $c95a196ff5dcada3$var$z(a) === $c95a196ff5dcada3$var$r;
};
$c95a196ff5dcada3$export$d927fcb6adf8f9de = function(a) {
    return $c95a196ff5dcada3$var$z(a) === $c95a196ff5dcada3$var$d;
};
$c95a196ff5dcada3$export$b82d16f27459e05a = function(a) {
    return $c95a196ff5dcada3$var$z(a) === $c95a196ff5dcada3$var$g;
};
$c95a196ff5dcada3$export$522c17b4f5e123e8 = function(a) {
    return $c95a196ff5dcada3$var$z(a) === $c95a196ff5dcada3$var$f;
};
$c95a196ff5dcada3$export$1aabd8a0274ecfd6 = function(a) {
    return $c95a196ff5dcada3$var$z(a) === $c95a196ff5dcada3$var$p;
};
$c95a196ff5dcada3$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $c95a196ff5dcada3$var$e || a === $c95a196ff5dcada3$var$m || a === $c95a196ff5dcada3$var$g || a === $c95a196ff5dcada3$var$f || a === $c95a196ff5dcada3$var$p || a === $c95a196ff5dcada3$var$q || "object" === typeof a && null !== a && (a.$$typeof === $c95a196ff5dcada3$var$t || a.$$typeof === $c95a196ff5dcada3$var$r || a.$$typeof === $c95a196ff5dcada3$var$h || a.$$typeof === $c95a196ff5dcada3$var$k || a.$$typeof === $c95a196ff5dcada3$var$n || a.$$typeof === $c95a196ff5dcada3$var$w || a.$$typeof === $c95a196ff5dcada3$var$x || a.$$typeof === $c95a196ff5dcada3$var$y || a.$$typeof === $c95a196ff5dcada3$var$v);
};
$c95a196ff5dcada3$export$f5bbd400c2f4426f = $c95a196ff5dcada3$var$z;

});



parcelRegister("hhpQV", function(module, exports) {
'use strict';

module.exports = (parcelRequire("c9wIQ"));

});
parcelRegister("c9wIQ", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $8d8fb5496f22046c$export$a7c73072b1a182ae; }, function (v) { return $8d8fb5496f22046c$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $8d8fb5496f22046c$export$9f27bc3417b4524d; }, function (v) { return $8d8fb5496f22046c$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $8d8fb5496f22046c$export$db77ccec0bb4ccac; }, function (v) { return $8d8fb5496f22046c$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $8d8fb5496f22046c$export$8392c0c9d3dcbd35; }, function (v) { return $8d8fb5496f22046c$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $8d8fb5496f22046c$export$ffb0004e005737fa; }, function (v) { return $8d8fb5496f22046c$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $8d8fb5496f22046c$export$b624eff549462981; }, function (v) { return $8d8fb5496f22046c$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $8d8fb5496f22046c$export$7897aa7841a5380c; }, function (v) { return $8d8fb5496f22046c$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $8d8fb5496f22046c$export$602eac185826482c; }, function (v) { return $8d8fb5496f22046c$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $8d8fb5496f22046c$export$e2c29f18771995cb; }, function (v) { return $8d8fb5496f22046c$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $8d8fb5496f22046c$export$5f8d39834fd61797; }, function (v) { return $8d8fb5496f22046c$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $8d8fb5496f22046c$export$74bf444e3cd11ea5; }, function (v) { return $8d8fb5496f22046c$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $8d8fb5496f22046c$export$998bcd577473dd93; }, function (v) { return $8d8fb5496f22046c$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $8d8fb5496f22046c$export$92387174baf9b227; }, function (v) { return $8d8fb5496f22046c$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $8d8fb5496f22046c$export$ec112efeb987d9c6; }, function (v) { return $8d8fb5496f22046c$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $8d8fb5496f22046c$export$b706b080d889d2c9; }, function (v) { return $8d8fb5496f22046c$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $8d8fb5496f22046c$export$5be5a87408f70ddc; }, function (v) { return $8d8fb5496f22046c$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $8d8fb5496f22046c$export$45a5e7f76e0caa8d; }, function (v) { return $8d8fb5496f22046c$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $8d8fb5496f22046c$export$455c2e768291efa6; }, function (v) { return $8d8fb5496f22046c$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $8d8fb5496f22046c$export$9522e17588c12572; }, function (v) { return $8d8fb5496f22046c$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $8d8fb5496f22046c$export$2110ac352bb060b9; }, function (v) { return $8d8fb5496f22046c$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $8d8fb5496f22046c$export$56885ab8b9c456ab; }, function (v) { return $8d8fb5496f22046c$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $8d8fb5496f22046c$export$d927fcb6adf8f9de; }, function (v) { return $8d8fb5496f22046c$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $8d8fb5496f22046c$export$b82d16f27459e05a; }, function (v) { return $8d8fb5496f22046c$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $8d8fb5496f22046c$export$522c17b4f5e123e8; }, function (v) { return $8d8fb5496f22046c$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $8d8fb5496f22046c$export$1aabd8a0274ecfd6; }, function (v) { return $8d8fb5496f22046c$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $8d8fb5496f22046c$export$3d6c20d97e46b957; }, function (v) { return $8d8fb5496f22046c$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $8d8fb5496f22046c$export$9b621391a187a31a; }, function (v) { return $8d8fb5496f22046c$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $8d8fb5496f22046c$export$f5bbd400c2f4426f; }, function (v) { return $8d8fb5496f22046c$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8d8fb5496f22046c$export$a7c73072b1a182ae;
var $8d8fb5496f22046c$export$9f27bc3417b4524d;
var $8d8fb5496f22046c$export$db77ccec0bb4ccac;
var $8d8fb5496f22046c$export$8392c0c9d3dcbd35;
var $8d8fb5496f22046c$export$ffb0004e005737fa;
var $8d8fb5496f22046c$export$b624eff549462981;
var $8d8fb5496f22046c$export$7897aa7841a5380c;
var $8d8fb5496f22046c$export$602eac185826482c;
var $8d8fb5496f22046c$export$e2c29f18771995cb;
var $8d8fb5496f22046c$export$5f8d39834fd61797;
var $8d8fb5496f22046c$export$74bf444e3cd11ea5;
var $8d8fb5496f22046c$export$998bcd577473dd93;
var $8d8fb5496f22046c$export$92387174baf9b227;
var $8d8fb5496f22046c$export$ec112efeb987d9c6;
var $8d8fb5496f22046c$export$b706b080d889d2c9;
var $8d8fb5496f22046c$export$5be5a87408f70ddc;
var $8d8fb5496f22046c$export$45a5e7f76e0caa8d;
var $8d8fb5496f22046c$export$455c2e768291efa6;
var $8d8fb5496f22046c$export$9522e17588c12572;
var $8d8fb5496f22046c$export$2110ac352bb060b9;
var $8d8fb5496f22046c$export$56885ab8b9c456ab;
var $8d8fb5496f22046c$export$d927fcb6adf8f9de;
var $8d8fb5496f22046c$export$b82d16f27459e05a;
var $8d8fb5496f22046c$export$522c17b4f5e123e8;
var $8d8fb5496f22046c$export$1aabd8a0274ecfd6;
var $8d8fb5496f22046c$export$3d6c20d97e46b957;
var $8d8fb5496f22046c$export$9b621391a187a31a;
var $8d8fb5496f22046c$export$f5bbd400c2f4426f;
'use strict';
var $8d8fb5496f22046c$var$b = Symbol.for("react.element"), $8d8fb5496f22046c$var$c = Symbol.for("react.portal"), $8d8fb5496f22046c$var$d = Symbol.for("react.fragment"), $8d8fb5496f22046c$var$e = Symbol.for("react.strict_mode"), $8d8fb5496f22046c$var$f = Symbol.for("react.profiler"), $8d8fb5496f22046c$var$g = Symbol.for("react.provider"), $8d8fb5496f22046c$var$h = Symbol.for("react.context"), $8d8fb5496f22046c$var$k = Symbol.for("react.server_context"), $8d8fb5496f22046c$var$l = Symbol.for("react.forward_ref"), $8d8fb5496f22046c$var$m = Symbol.for("react.suspense"), $8d8fb5496f22046c$var$n = Symbol.for("react.suspense_list"), $8d8fb5496f22046c$var$p = Symbol.for("react.memo"), $8d8fb5496f22046c$var$q = Symbol.for("react.lazy"), $8d8fb5496f22046c$var$t = Symbol.for("react.offscreen"), $8d8fb5496f22046c$var$u;
$8d8fb5496f22046c$var$u = Symbol.for("react.module.reference");
function $8d8fb5496f22046c$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $8d8fb5496f22046c$var$b:
                switch(a = a.type, a){
                    case $8d8fb5496f22046c$var$d:
                    case $8d8fb5496f22046c$var$f:
                    case $8d8fb5496f22046c$var$e:
                    case $8d8fb5496f22046c$var$m:
                    case $8d8fb5496f22046c$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $8d8fb5496f22046c$var$k:
                            case $8d8fb5496f22046c$var$h:
                            case $8d8fb5496f22046c$var$l:
                            case $8d8fb5496f22046c$var$q:
                            case $8d8fb5496f22046c$var$p:
                            case $8d8fb5496f22046c$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $8d8fb5496f22046c$var$c:
                return r;
        }
    }
}
$8d8fb5496f22046c$export$a7c73072b1a182ae = $8d8fb5496f22046c$var$h;
$8d8fb5496f22046c$export$9f27bc3417b4524d = $8d8fb5496f22046c$var$g;
$8d8fb5496f22046c$export$db77ccec0bb4ccac = $8d8fb5496f22046c$var$b;
$8d8fb5496f22046c$export$8392c0c9d3dcbd35 = $8d8fb5496f22046c$var$l;
$8d8fb5496f22046c$export$ffb0004e005737fa = $8d8fb5496f22046c$var$d;
$8d8fb5496f22046c$export$b624eff549462981 = $8d8fb5496f22046c$var$q;
$8d8fb5496f22046c$export$7897aa7841a5380c = $8d8fb5496f22046c$var$p;
$8d8fb5496f22046c$export$602eac185826482c = $8d8fb5496f22046c$var$c;
$8d8fb5496f22046c$export$e2c29f18771995cb = $8d8fb5496f22046c$var$f;
$8d8fb5496f22046c$export$5f8d39834fd61797 = $8d8fb5496f22046c$var$e;
$8d8fb5496f22046c$export$74bf444e3cd11ea5 = $8d8fb5496f22046c$var$m;
$8d8fb5496f22046c$export$998bcd577473dd93 = $8d8fb5496f22046c$var$n;
$8d8fb5496f22046c$export$92387174baf9b227 = function() {
    return !1;
};
$8d8fb5496f22046c$export$ec112efeb987d9c6 = function() {
    return !1;
};
$8d8fb5496f22046c$export$b706b080d889d2c9 = function(a) {
    return $8d8fb5496f22046c$var$v(a) === $8d8fb5496f22046c$var$h;
};
$8d8fb5496f22046c$export$5be5a87408f70ddc = function(a) {
    return $8d8fb5496f22046c$var$v(a) === $8d8fb5496f22046c$var$g;
};
$8d8fb5496f22046c$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $8d8fb5496f22046c$var$b;
};
$8d8fb5496f22046c$export$455c2e768291efa6 = function(a) {
    return $8d8fb5496f22046c$var$v(a) === $8d8fb5496f22046c$var$l;
};
$8d8fb5496f22046c$export$9522e17588c12572 = function(a) {
    return $8d8fb5496f22046c$var$v(a) === $8d8fb5496f22046c$var$d;
};
$8d8fb5496f22046c$export$2110ac352bb060b9 = function(a) {
    return $8d8fb5496f22046c$var$v(a) === $8d8fb5496f22046c$var$q;
};
$8d8fb5496f22046c$export$56885ab8b9c456ab = function(a) {
    return $8d8fb5496f22046c$var$v(a) === $8d8fb5496f22046c$var$p;
};
$8d8fb5496f22046c$export$d927fcb6adf8f9de = function(a) {
    return $8d8fb5496f22046c$var$v(a) === $8d8fb5496f22046c$var$c;
};
$8d8fb5496f22046c$export$b82d16f27459e05a = function(a) {
    return $8d8fb5496f22046c$var$v(a) === $8d8fb5496f22046c$var$f;
};
$8d8fb5496f22046c$export$522c17b4f5e123e8 = function(a) {
    return $8d8fb5496f22046c$var$v(a) === $8d8fb5496f22046c$var$e;
};
$8d8fb5496f22046c$export$1aabd8a0274ecfd6 = function(a) {
    return $8d8fb5496f22046c$var$v(a) === $8d8fb5496f22046c$var$m;
};
$8d8fb5496f22046c$export$3d6c20d97e46b957 = function(a) {
    return $8d8fb5496f22046c$var$v(a) === $8d8fb5496f22046c$var$n;
};
$8d8fb5496f22046c$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $8d8fb5496f22046c$var$d || a === $8d8fb5496f22046c$var$f || a === $8d8fb5496f22046c$var$e || a === $8d8fb5496f22046c$var$m || a === $8d8fb5496f22046c$var$n || a === $8d8fb5496f22046c$var$t || "object" === typeof a && null !== a && (a.$$typeof === $8d8fb5496f22046c$var$q || a.$$typeof === $8d8fb5496f22046c$var$p || a.$$typeof === $8d8fb5496f22046c$var$g || a.$$typeof === $8d8fb5496f22046c$var$h || a.$$typeof === $8d8fb5496f22046c$var$l || a.$$typeof === $8d8fb5496f22046c$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$8d8fb5496f22046c$export$f5bbd400c2f4426f = $8d8fb5496f22046c$var$v;

});


parcelRegister("lnJlj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f90eeb19a60d7ce9$export$2e2bcd8739ae039; });

var $jMczY = parcelRequire("jMczY");
parcelRequire("tht0g");
const $f90eeb19a60d7ce9$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $f90eeb19a60d7ce9$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $f90eeb19a60d7ce9$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $jMczY.default)(_ref, $f90eeb19a60d7ce9$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $f90eeb19a60d7ce9$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("tht0g", function(module, exports) {

var $44r0c = parcelRequire("44r0c");
function $05804216e7c10de0$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $44r0c.default)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $05804216e7c10de0$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $05804216e7c10de0$var$verify(mapStateToProps, 'mapStateToProps');
    $05804216e7c10de0$var$verify(mapDispatchToProps, 'mapDispatchToProps');
    $05804216e7c10de0$var$verify(mergeProps, 'mergeProps');
}

});
parcelRegister("44r0c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f6c7b35193c0e41$export$2e2bcd8739ae039; });
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $2f6c7b35193c0e41$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});



parcelRegister("jlBQW", function(module, exports) {

$parcel$export(module.exports, "mapDispatchToPropsFactory", function () { return $e15d574eed1f6620$export$b69a785ceac019a6; });

var $cwl14 = parcelRequire("cwl14");

var $9Pa2D = parcelRequire("9Pa2D");

var $4iLOC = parcelRequire("4iLOC");
function $e15d574eed1f6620$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $9Pa2D.wrapMapToPropsConstant)((dispatch)=>(0, $cwl14.default)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $9Pa2D.wrapMapToPropsConstant)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === 'function' ? (0, $9Pa2D.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : (0, $4iLOC.createInvalidArgFactory)(mapDispatchToProps, 'mapDispatchToProps');
}

});
parcelRegister("cwl14", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91d8c696d8f59630$export$2e2bcd8739ae039; });
function $91d8c696d8f59630$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}

});

parcelRegister("9Pa2D", function(module, exports) {

$parcel$export(module.exports, "wrapMapToPropsConstant", function () { return $7270aa8142990f79$export$710f7c60f68acd3e; });
$parcel$export(module.exports, "wrapMapToPropsFunc", function () { return $7270aa8142990f79$export$8d46c7f53c8c602f; });
parcelRequire("axIdE");
function $7270aa8142990f79$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $7270aa8142990f79$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $7270aa8142990f79$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $7270aa8142990f79$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $7270aa8142990f79$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("axIdE", function(module, exports) {

var $46nXM = parcelRequire("46nXM");

var $44r0c = parcelRequire("44r0c");
function $7acf497853082719$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $46nXM.default)(value)) (0, $44r0c.default)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}

});
parcelRegister("46nXM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2fca4f9306ff9339$export$2e2bcd8739ae039; });
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $2fca4f9306ff9339$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});



parcelRegister("4iLOC", function(module, exports) {

$parcel$export(module.exports, "createInvalidArgFactory", function () { return $321def07ee9c3eb2$export$19ef7b929f7e2559; });
function $321def07ee9c3eb2$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}

});


parcelRegister("4SOIn", function(module, exports) {

$parcel$export(module.exports, "mapStateToPropsFactory", function () { return $38e38b775f94c859$export$e00e93951827eda7; });

var $9Pa2D = parcelRequire("9Pa2D");

var $4iLOC = parcelRequire("4iLOC");
function $38e38b775f94c859$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $9Pa2D.wrapMapToPropsConstant)(()=>({})) : typeof mapStateToProps === 'function' ? (0, $9Pa2D.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : (0, $4iLOC.createInvalidArgFactory)(mapStateToProps, 'mapStateToProps');
}

});

parcelRegister("c1yJG", function(module, exports) {

$parcel$export(module.exports, "mergePropsFactory", function () { return $8c1085db4275dd2a$export$17457cf6fa742f84; });

var $d1eVZ = parcelRequire("d1eVZ");
parcelRequire("axIdE");

var $4iLOC = parcelRequire("4iLOC");
function $8c1085db4275dd2a$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $d1eVZ.default)({}, ownProps, stateProps, dispatchProps);
}
function $8c1085db4275dd2a$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $8c1085db4275dd2a$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$8c1085db4275dd2a$export$691c327fc30bc857 : typeof mergeProps === 'function' ? $8c1085db4275dd2a$export$5b105939c84b5234(mergeProps) : (0, $4iLOC.createInvalidArgFactory)(mergeProps, 'mergeProps');
}

});

parcelRegister("llMOH", function(module, exports) {

$parcel$export(module.exports, "createSubscription", function () { return $f8b16d1d26097fc9$export$d567d2b9af322f8f; });

var $1u1pn = parcelRequire("1u1pn");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $f8b16d1d26097fc9$var$createListenerCollection() {
    const batch = (0, $1u1pn.getBatch)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $f8b16d1d26097fc9$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $f8b16d1d26097fc9$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $f8b16d1d26097fc9$var$nullListeners; // Reasons to keep the subscription active
    let subscriptionsAmount = 0; // Is this specific subscription subscribed (or only nested ones?)
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener); // cleanup nested sub
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $f8b16d1d26097fc9$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $f8b16d1d26097fc9$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}

});

parcelRegister("7uWZA", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $5759186484f7cab9$export$700979bc83e7db82; });

var $7RNO0 = parcelRequire("7RNO0");
const $5759186484f7cab9$export$71594e8a50f746f4 = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
const $5759186484f7cab9$export$700979bc83e7db82 = $5759186484f7cab9$export$71594e8a50f746f4 ? $7RNO0.useLayoutEffect : $7RNO0.useEffect;

});

parcelRegister("fr3WY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3cc710ae77bccc8$export$2e2bcd8739ae039; });
function $b3cc710ae77bccc8$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $b3cc710ae77bccc8$export$2e2bcd8739ae039(objA, objB) {
    if ($b3cc710ae77bccc8$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$b3cc710ae77bccc8$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});


parcelRegister("kHDR6", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return (parcelRequire("7sFkD")).default; });
$parcel$export(module.exports, "useDispatch", function () { return (parcelRequire("k18Dd")).useDispatch; });
$parcel$export(module.exports, "useSelector", function () { return (parcelRequire("5YtKx")).useSelector; });

var $7sFkD = parcelRequire("7sFkD");

var $bySDn = parcelRequire("bySDn");

var $jCBAi = parcelRequire("jCBAi");

var $k18Dd = parcelRequire("k18Dd");

var $5YtKx = parcelRequire("5YtKx");

var $56fqj = parcelRequire("56fqj");

var $fr3WY = parcelRequire("fr3WY");
parcelRequire("5Lar5");

});
parcelRegister("7sFkD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56eb358eb0502c56$export$2e2bcd8739ae039; });

var $7RNO0 = parcelRequire("7RNO0");

var $jCBAi = parcelRequire("jCBAi");

var $llMOH = parcelRequire("llMOH");

var $7uWZA = parcelRequire("7uWZA");
function $56eb358eb0502c56$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = 'once', noopCheck: noopCheck = 'once' }) {
    const contextValue = $7RNO0.useMemo(()=>{
        const subscription = (0, $llMOH.createSubscription)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    const previousState = $7RNO0.useMemo(()=>store.getState(), [
        store
    ]);
    (0, $7uWZA.useIsomorphicLayoutEffect)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $jCBAi.ReactReduxContext); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ $7RNO0.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $56eb358eb0502c56$export$2e2bcd8739ae039 = $56eb358eb0502c56$var$Provider;

});

parcelRegister("k18Dd", function(module, exports) {

$parcel$export(module.exports, "useDispatch", function () { return $e92a98aba2cf4e66$export$8ad76b76a4c905f8; });

var $jCBAi = parcelRequire("jCBAi");

var $56fqj = parcelRequire("56fqj");
function $e92a98aba2cf4e66$export$bc9b55530897c558(context = (0, $jCBAi.ReactReduxContext)) {
    const useStore = context === (0, $jCBAi.ReactReduxContext) ? (0, $56fqj.useStore) : (0, $56fqj.createStoreHook)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $e92a98aba2cf4e66$export$8ad76b76a4c905f8 = /*#__PURE__*/ $e92a98aba2cf4e66$export$bc9b55530897c558();

});
parcelRegister("56fqj", function(module, exports) {

$parcel$export(module.exports, "createStoreHook", function () { return $3b697a0b37aea60d$export$671dba69185d0304; });
$parcel$export(module.exports, "useStore", function () { return $3b697a0b37aea60d$export$6ccbb43953eebf8; });

var $jCBAi = parcelRequire("jCBAi");

var $aGnTY = parcelRequire("aGnTY");
function $3b697a0b37aea60d$export$671dba69185d0304(context = (0, $jCBAi.ReactReduxContext)) {
    const useReduxContext = context === (0, $jCBAi.ReactReduxContext) ? (0, $aGnTY.useReduxContext) : (0, $aGnTY.createReduxContextHook)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $3b697a0b37aea60d$export$6ccbb43953eebf8 = /*#__PURE__*/ $3b697a0b37aea60d$export$671dba69185d0304();

});


parcelRegister("5Lar5", function(module, exports) {

});



parcelRegister("61p16", function(module, exports) {

$parcel$export(module.exports, "configureStore", function () { return $46263ddf6cb29d0e$export$7d8a5b498da695ac; });
$parcel$export(module.exports, "createSlice", function () { return $46263ddf6cb29d0e$export$4d8d9bd83c24ae8b; });
$parcel$export(module.exports, "createAsyncThunk", function () { return $46263ddf6cb29d0e$export$6abd22dc03e5063f; });

var $bggQN = parcelRequire("bggQN");

var $jB3tr = parcelRequire("jB3tr");

var $hysZj = parcelRequire("hysZj");

var $b0eAP = parcelRequire("b0eAP");
var $46263ddf6cb29d0e$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $46263ddf6cb29d0e$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $46263ddf6cb29d0e$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $46263ddf6cb29d0e$var$__defProp = Object.defineProperty;
var $46263ddf6cb29d0e$var$__defProps = Object.defineProperties;
var $46263ddf6cb29d0e$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $46263ddf6cb29d0e$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $46263ddf6cb29d0e$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $46263ddf6cb29d0e$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $46263ddf6cb29d0e$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $46263ddf6cb29d0e$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $46263ddf6cb29d0e$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($46263ddf6cb29d0e$var$__hasOwnProp.call(b, prop)) $46263ddf6cb29d0e$var$__defNormalProp(a, prop, b[prop]);
    if ($46263ddf6cb29d0e$var$__getOwnPropSymbols) for(var _i = 0, _c = $46263ddf6cb29d0e$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($46263ddf6cb29d0e$var$__propIsEnum.call(b, prop)) $46263ddf6cb29d0e$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $46263ddf6cb29d0e$var$__spreadProps = function(a, b) {
    return $46263ddf6cb29d0e$var$__defProps(a, $46263ddf6cb29d0e$var$__getOwnPropDescs(b));
};
var $46263ddf6cb29d0e$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $46263ddf6cb29d0e$export$a5d3c27355e35910 = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, $hysZj.createSelector).apply(void 0, args);
    var wrappedSelector = function(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, $46263ddf6cb29d0e$var$__spreadArray([
            (0, $bggQN.isDraft)(value) ? (0, $bggQN.current)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var $46263ddf6cb29d0e$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $jB3tr.compose;
    return (0, $jB3tr.compose).apply(null, arguments);
};
var $46263ddf6cb29d0e$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function $46263ddf6cb29d0e$export$53b83ca8eaab0383(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/tsHelpers.ts
var $46263ddf6cb29d0e$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $46263ddf6cb29d0e$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return $46263ddf6cb29d0e$var$__spreadValues($46263ddf6cb29d0e$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function $46263ddf6cb29d0e$export$b956e38827fca970(action) {
    return $46263ddf6cb29d0e$export$53b83ca8eaab0383(action) && "type" in action;
}
function $46263ddf6cb29d0e$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && $46263ddf6cb29d0e$var$hasMatchFunction(action);
}
function $46263ddf6cb29d0e$export$ebd532f9034651f3(action) {
    return $46263ddf6cb29d0e$export$b956e38827fca970(action) && typeof action.type === "string" && Object.keys(action).every($46263ddf6cb29d0e$var$isValidKey);
}
function $46263ddf6cb29d0e$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function $46263ddf6cb29d0e$export$e2b5c5db9e2009fd(actionCreator) {
    return "" + actionCreator;
}
// src/actionCreatorInvariantMiddleware.ts
function $46263ddf6cb29d0e$var$getMessage(type) {
    var splitType = type ? ("" + type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return "Detected an action creator with type \"" + (type || "unknown") + "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(" + actionName + "())` instead of `dispatch(" + actionName + ")`. This is necessary even if the action has no payload.";
}
function $46263ddf6cb29d0e$export$6a1fcb4ceef578f(options) {
    if (options === void 0) options = {};
    var _c, isActionCreator2;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $46263ddf6cb29d0e$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var $46263ddf6cb29d0e$export$20df1e9bd1a54f25 = /** @class */ function(_super) {
    $46263ddf6cb29d0e$var$__extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, $46263ddf6cb29d0e$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, $46263ddf6cb29d0e$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
var $46263ddf6cb29d0e$export$490d10040a0cbe8a = /** @class */ function(_super) {
    $46263ddf6cb29d0e$var$__extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function() {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (EnhancerArray.bind.apply(EnhancerArray, $46263ddf6cb29d0e$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (EnhancerArray.bind.apply(EnhancerArray, $46263ddf6cb29d0e$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array);
function $46263ddf6cb29d0e$var$freezeDraftable(val) {
    return (0, $bggQN.isDraftable)(val) ? (0, $bggQN.default)(val, function() {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var $46263ddf6cb29d0e$var$isProduction = true;
var $46263ddf6cb29d0e$var$prefix = "Invariant failed";
function $46263ddf6cb29d0e$var$invariant(condition, message) {
    if (condition) return;
    if ($46263ddf6cb29d0e$var$isProduction) throw new Error($46263ddf6cb29d0e$var$prefix);
    throw new Error($46263ddf6cb29d0e$var$prefix + ": " + (message || ""));
}
function $46263ddf6cb29d0e$var$stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, $46263ddf6cb29d0e$var$getSerialize(serializer, decycler), indent);
}
function $46263ddf6cb29d0e$var$getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function $46263ddf6cb29d0e$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $46263ddf6cb29d0e$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $46263ddf6cb29d0e$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $46263ddf6cb29d0e$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $46263ddf6cb29d0e$var$trackProperties(isImmutable, ignorePaths, obj, path, checkedObjects) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    if (checkedObjects === void 0) checkedObjects = new Set();
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $46263ddf6cb29d0e$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $46263ddf6cb29d0e$var$detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) ignoredPaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function(key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $46263ddf6cb29d0e$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return {
            value: result
        };
    };
    for(var key in keysToDetect){
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object") return state_1.value;
    }
    return {
        wasMutated: false
    };
}
function $46263ddf6cb29d0e$export$9181bb1a5474289(options) {
    if (options === void 0) options = {};
    var _c, isImmutable, ignoredPaths, _d, warnAfter, ignore, track;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function $46263ddf6cb29d0e$export$77670485918dab4e(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || $46263ddf6cb29d0e$export$53b83ca8eaab0383(val);
}
function $46263ddf6cb29d0e$export$ada5dca0b571bc7(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = $46263ddf6cb29d0e$export$77670485918dab4e;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function(key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        if (!isSerializable(nestedValue)) return {
            value: {
                keyPath: nestedPath,
                value: nestedValue
            }
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $46263ddf6cb29d0e$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return {
                value: foundNestedSerializable
            };
        }
    };
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object") return state_2.value;
    }
    if (cache && $46263ddf6cb29d0e$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $46263ddf6cb29d0e$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for(var _i = 0, _c = Object.values(value); _i < _c.length; _i++){
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$46263ddf6cb29d0e$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $46263ddf6cb29d0e$export$6dea1aad6dac5ac2(options) {
    if (options === void 0) options = {};
    var _c, isSerializable, getEntries, _d, ignoredActions, _e, ignoredActionPaths, _f, ignoredPaths, _g, warnAfter, _h, ignoreState, _j, ignoreActions, _k, disableCache, cache;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $46263ddf6cb29d0e$var$isBoolean(x) {
    return typeof x === "boolean";
}
function $46263ddf6cb29d0e$var$curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return $46263ddf6cb29d0e$export$36c1185aeee5b0a6(options);
    };
}
function $46263ddf6cb29d0e$export$36c1185aeee5b0a6(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e, _f = options.actionCreatorCheck, actionCreatorCheck = _f === void 0 ? true : _f;
    var middlewareArray = new $46263ddf6cb29d0e$export$20df1e9bd1a54f25();
    if (thunk) {
        if ($46263ddf6cb29d0e$var$isBoolean(thunk)) middlewareArray.push((0, $b0eAP.default));
        else middlewareArray.push((0, $b0eAP.default).withExtraArgument(thunk.extraArgument));
    }
    var immutableOptions, serializableOptions, actionCreatorOptions;
    return middlewareArray;
}
// src/configureStore.ts
var $46263ddf6cb29d0e$var$IS_PRODUCTION = true;
function $46263ddf6cb29d0e$export$7d8a5b498da695ac(options) {
    var curriedGetDefaultMiddleware = $46263ddf6cb29d0e$var$curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ($46263ddf6cb29d0e$export$53b83ca8eaab0383(reducer)) rootReducer = (0, $jB3tr.combineReducers)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!$46263ddf6cb29d0e$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!$46263ddf6cb29d0e$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, $jB3tr.applyMiddleware).apply(void 0, finalMiddleware);
    var finalCompose = (0, $jB3tr.compose);
    if (devTools) finalCompose = $46263ddf6cb29d0e$var$composeWithDevTools($46263ddf6cb29d0e$var$__spreadValues({
        trace: !$46263ddf6cb29d0e$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var defaultEnhancers = new $46263ddf6cb29d0e$export$490d10040a0cbe8a(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) storeEnhancers = $46263ddf6cb29d0e$var$__spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(defaultEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, $jB3tr.createStore)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $46263ddf6cb29d0e$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error("`builder.addCase` cannot be called with an empty action type");
            if (type in actionsMap) throw new Error("`builder.addCase` cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $46263ddf6cb29d0e$var$isStateFunction(x) {
    return typeof x === "function";
}
var $46263ddf6cb29d0e$var$hasWarnedAboutObjectNotation = false;
function $46263ddf6cb29d0e$export$473eb76d322d0290(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) actionMatchers = [];
    var _c = typeof mapOrBuilderCallback === "function" ? $46263ddf6cb29d0e$var$executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if ($46263ddf6cb29d0e$var$isStateFunction(initialState)) getInitialState = function() {
        return $46263ddf6cb29d0e$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState_1 = $46263ddf6cb29d0e$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState_1;
        };
    }
    function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = $46263ddf6cb29d0e$var$__spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $bggQN.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $bggQN.isDraftable)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $bggQN.default)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var $46263ddf6cb29d0e$var$hasWarnedAboutObjectNotation2 = false;
function $46263ddf6cb29d0e$var$getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function $46263ddf6cb29d0e$export$4d8d9bd83c24ae8b(options) {
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    var initialState = typeof options.initialState == "function" ? options.initialState : $46263ddf6cb29d0e$var$freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = $46263ddf6cb29d0e$var$getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? $46263ddf6cb29d0e$export$309c7a02b0b0bc62(type, prepareCallback) : $46263ddf6cb29d0e$export$309c7a02b0b0bc62(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? $46263ddf6cb29d0e$var$executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = $46263ddf6cb29d0e$var$__spreadValues($46263ddf6cb29d0e$var$__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return $46263ddf6cb29d0e$export$473eb76d322d0290(initialState, function(builder) {
            for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
            for(var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++){
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function $46263ddf6cb29d0e$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $46263ddf6cb29d0e$var$createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign($46263ddf6cb29d0e$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $46263ddf6cb29d0e$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = $46263ddf6cb29d0e$export$a5d3c27355e35910(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = $46263ddf6cb29d0e$export$a5d3c27355e35910(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: $46263ddf6cb29d0e$export$a5d3c27355e35910(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = $46263ddf6cb29d0e$export$a5d3c27355e35910(selectState, selectEntities);
        return {
            selectIds: $46263ddf6cb29d0e$export$a5d3c27355e35910(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: $46263ddf6cb29d0e$export$a5d3c27355e35910(selectState, selectAll),
            selectTotal: $46263ddf6cb29d0e$export$a5d3c27355e35910(selectState, selectTotal),
            selectById: $46263ddf6cb29d0e$export$a5d3c27355e35910(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
function $46263ddf6cb29d0e$var$createSingleArgumentStateOperator(mutator) {
    var operator = $46263ddf6cb29d0e$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $46263ddf6cb29d0e$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $46263ddf6cb29d0e$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, $bggQN.isDraft)(state)) {
            runMutator(state);
            return state;
        } else return (0, $bggQN.default)(state, runMutator);
    };
}
// src/entities/utils.ts
function $46263ddf6cb29d0e$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $46263ddf6cb29d0e$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $46263ddf6cb29d0e$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $46263ddf6cb29d0e$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = $46263ddf6cb29d0e$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $46263ddf6cb29d0e$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $46263ddf6cb29d0e$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $46263ddf6cb29d0e$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = $46263ddf6cb29d0e$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $46263ddf6cb29d0e$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $46263ddf6cb29d0e$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = $46263ddf6cb29d0e$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: $46263ddf6cb29d0e$var$__spreadValues($46263ddf6cb29d0e$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.keys(state.entities);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $46263ddf6cb29d0e$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $46263ddf6cb29d0e$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $46263ddf6cb29d0e$var$createStateOperator(addOneMutably),
        addMany: $46263ddf6cb29d0e$var$createStateOperator(addManyMutably),
        setOne: $46263ddf6cb29d0e$var$createStateOperator(setOneMutably),
        setMany: $46263ddf6cb29d0e$var$createStateOperator(setManyMutably),
        setAll: $46263ddf6cb29d0e$var$createStateOperator(setAllMutably),
        updateOne: $46263ddf6cb29d0e$var$createStateOperator(updateOneMutably),
        updateMany: $46263ddf6cb29d0e$var$createStateOperator(updateManyMutably),
        upsertOne: $46263ddf6cb29d0e$var$createStateOperator(upsertOneMutably),
        upsertMany: $46263ddf6cb29d0e$var$createStateOperator(upsertManyMutably),
        removeOne: $46263ddf6cb29d0e$var$createStateOperator(removeOneMutably),
        removeMany: $46263ddf6cb29d0e$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $46263ddf6cb29d0e$var$createSortedStateAdapter(selectId, sort) {
    var _c = $46263ddf6cb29d0e$var$createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $46263ddf6cb29d0e$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($46263ddf6cb29d0e$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $46263ddf6cb29d0e$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $46263ddf6cb29d0e$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for(var _i = 0, updates_1 = updates; _i < updates_1.length; _i++){
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $46263ddf6cb29d0e$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $46263ddf6cb29d0e$var$createStateOperator(addOneMutably),
        updateOne: $46263ddf6cb29d0e$var$createStateOperator(updateOneMutably),
        upsertOne: $46263ddf6cb29d0e$var$createStateOperator(upsertOneMutably),
        setOne: $46263ddf6cb29d0e$var$createStateOperator(setOneMutably),
        setMany: $46263ddf6cb29d0e$var$createStateOperator(setManyMutably),
        setAll: $46263ddf6cb29d0e$var$createStateOperator(setAllMutably),
        addMany: $46263ddf6cb29d0e$var$createStateOperator(addManyMutably),
        updateMany: $46263ddf6cb29d0e$var$createStateOperator(updateManyMutably),
        upsertMany: $46263ddf6cb29d0e$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $46263ddf6cb29d0e$export$abcf4037b41e0df(options) {
    if (options === void 0) options = {};
    var _c = $46263ddf6cb29d0e$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = $46263ddf6cb29d0e$var$createInitialStateFactory();
    var selectorsFactory = $46263ddf6cb29d0e$var$createSelectorsFactory();
    var stateAdapter = sortComparer ? $46263ddf6cb29d0e$var$createSortedStateAdapter(selectId, sortComparer) : $46263ddf6cb29d0e$var$createUnsortedStateAdapter(selectId);
    return $46263ddf6cb29d0e$var$__spreadValues($46263ddf6cb29d0e$var$__spreadValues($46263ddf6cb29d0e$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var $46263ddf6cb29d0e$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $46263ddf6cb29d0e$export$ac4959f4f1338dfc = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += $46263ddf6cb29d0e$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $46263ddf6cb29d0e$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $46263ddf6cb29d0e$var$RejectWithValue = /** @class */ function() {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}();
var $46263ddf6cb29d0e$var$FulfillWithMeta = /** @class */ function() {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}();
var $46263ddf6cb29d0e$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = $46263ddf6cb29d0e$var$commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $46263ddf6cb29d0e$export$6abd22dc03e5063f = function() {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $46263ddf6cb29d0e$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $46263ddf6cb29d0e$var$__spreadProps($46263ddf6cb29d0e$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $46263ddf6cb29d0e$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $46263ddf6cb29d0e$var$__spreadProps($46263ddf6cb29d0e$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $46263ddf6cb29d0e$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $46263ddf6cb29d0e$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $46263ddf6cb29d0e$var$__spreadProps($46263ddf6cb29d0e$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function() {},
                    dispatchEvent: function() {
                        return false;
                    },
                    onabort: function() {},
                    removeEventListener: function() {},
                    reason: void 0,
                    throwIfAborted: function() {}
                };
            }
            class_1.prototype.abort = function() {};
            return class_1;
        }();
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $46263ddf6cb29d0e$export$ac4959f4f1338dfc();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function() {
                    return $46263ddf6cb29d0e$var$__async(this, null, function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return $46263ddf6cb29d0e$var$__generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _c.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!$46263ddf6cb29d0e$var$isThenable(conditionResult)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    started = true;
                                    abortedPromise = new Promise(function(_, reject) {
                                        return abortController.signal.addEventListener("abort", function() {
                                            return reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function(value, meta) {
                                                    return new $46263ddf6cb29d0e$var$RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function(value, meta) {
                                                    return new $46263ddf6cb29d0e$var$FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof $46263ddf6cb29d0e$var$RejectWithValue) throw result;
                                                if (result instanceof $46263ddf6cb29d0e$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof $46263ddf6cb29d0e$var$RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2 /*return*/ ,
                                        finalAction
                                    ];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise2.then($46263ddf6cb29d0e$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $46263ddf6cb29d0e$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $46263ddf6cb29d0e$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/matchers.ts
var $46263ddf6cb29d0e$var$matches = function(matcher, action) {
    if ($46263ddf6cb29d0e$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $46263ddf6cb29d0e$export$2c3435c7647f7b0d() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return $46263ddf6cb29d0e$var$matches(matcher, action);
        });
    };
}
function $46263ddf6cb29d0e$export$9dd1fb32974da385() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return $46263ddf6cb29d0e$var$matches(matcher, action);
        });
    };
}
function $46263ddf6cb29d0e$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $46263ddf6cb29d0e$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $46263ddf6cb29d0e$export$872dec21e9a69476() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $46263ddf6cb29d0e$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$46263ddf6cb29d0e$var$isAsyncThunkArray(asyncThunks)) return $46263ddf6cb29d0e$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $46263ddf6cb29d0e$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $46263ddf6cb29d0e$export$a5c5d27e3994c5be() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $46263ddf6cb29d0e$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$46263ddf6cb29d0e$var$isAsyncThunkArray(asyncThunks)) return $46263ddf6cb29d0e$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $46263ddf6cb29d0e$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $46263ddf6cb29d0e$export$fcc3388fb56de601() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $46263ddf6cb29d0e$export$9dd1fb32974da385($46263ddf6cb29d0e$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$46263ddf6cb29d0e$var$isAsyncThunkArray(asyncThunks)) return $46263ddf6cb29d0e$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $46263ddf6cb29d0e$export$9dd1fb32974da385($46263ddf6cb29d0e$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $46263ddf6cb29d0e$export$1da80a6ef1307441() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $46263ddf6cb29d0e$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$46263ddf6cb29d0e$var$isAsyncThunkArray(asyncThunks)) return $46263ddf6cb29d0e$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $46263ddf6cb29d0e$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $46263ddf6cb29d0e$export$6aa4142d99c1abce() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $46263ddf6cb29d0e$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$46263ddf6cb29d0e$var$isAsyncThunkArray(asyncThunks)) return $46263ddf6cb29d0e$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = $46263ddf6cb29d0e$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var $46263ddf6cb29d0e$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError(expected + " is not a function");
};
var $46263ddf6cb29d0e$var$noop = function() {};
var $46263ddf6cb29d0e$var$catchRejection = function(promise2, onError) {
    if (onError === void 0) onError = $46263ddf6cb29d0e$var$noop;
    promise2.catch(onError);
    return promise2;
};
var $46263ddf6cb29d0e$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $46263ddf6cb29d0e$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var $46263ddf6cb29d0e$var$task = "task";
var $46263ddf6cb29d0e$var$listener = "listener";
var $46263ddf6cb29d0e$var$completed = "completed";
var $46263ddf6cb29d0e$var$cancelled = "cancelled";
var $46263ddf6cb29d0e$var$taskCancelled = "task-" + $46263ddf6cb29d0e$var$cancelled;
var $46263ddf6cb29d0e$var$taskCompleted = "task-" + $46263ddf6cb29d0e$var$completed;
var $46263ddf6cb29d0e$var$listenerCancelled = $46263ddf6cb29d0e$var$listener + "-" + $46263ddf6cb29d0e$var$cancelled;
var $46263ddf6cb29d0e$var$listenerCompleted = $46263ddf6cb29d0e$var$listener + "-" + $46263ddf6cb29d0e$var$completed;
var $46263ddf6cb29d0e$export$cb1bdac908fed7f = /** @class */ function() {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = $46263ddf6cb29d0e$var$task + " " + $46263ddf6cb29d0e$var$cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var $46263ddf6cb29d0e$var$validateActive = function(signal) {
    if (signal.aborted) throw new $46263ddf6cb29d0e$export$cb1bdac908fed7f(signal.reason);
};
function $46263ddf6cb29d0e$var$raceWithSignal(signal, promise2) {
    var cleanup = $46263ddf6cb29d0e$var$noop;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $46263ddf6cb29d0e$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $46263ddf6cb29d0e$var$addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $46263ddf6cb29d0e$var$noop;
    });
}
var $46263ddf6cb29d0e$var$runTask = function(task2, cleanUp) {
    return $46263ddf6cb29d0e$var$__async(void 0, null, function() {
        var value, error_1;
        return $46263ddf6cb29d0e$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    _c.sent();
                    return [
                        4 /*yield*/ ,
                        task2()
                    ];
                case 2:
                    value = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error_1 = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: error_1 instanceof $46263ddf6cb29d0e$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error_1
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $46263ddf6cb29d0e$var$createPause = function(signal) {
    return function(promise2) {
        return $46263ddf6cb29d0e$var$catchRejection($46263ddf6cb29d0e$var$raceWithSignal(signal, promise2).then(function(output) {
            $46263ddf6cb29d0e$var$validateActive(signal);
            return output;
        }));
    };
};
var $46263ddf6cb29d0e$var$createDelay = function(signal) {
    var pause = $46263ddf6cb29d0e$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $46263ddf6cb29d0e$var$assign = Object.assign;
var $46263ddf6cb29d0e$var$INTERNAL_NIL_TOKEN = {};
var $46263ddf6cb29d0e$var$alm = "listenerMiddleware";
var $46263ddf6cb29d0e$var$createFork = function(parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function(controller) {
        return $46263ddf6cb29d0e$var$addAbortSignalListener(parentAbortSignal, function() {
            return $46263ddf6cb29d0e$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor, opts) {
        $46263ddf6cb29d0e$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $46263ddf6cb29d0e$var$runTask(function() {
            return $46263ddf6cb29d0e$var$__async(void 0, null, function() {
                var result2;
                return $46263ddf6cb29d0e$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            $46263ddf6cb29d0e$var$validateActive(parentAbortSignal);
                            $46263ddf6cb29d0e$var$validateActive(childAbortController.signal);
                            return [
                                4 /*yield*/ ,
                                taskExecutor({
                                    pause: $46263ddf6cb29d0e$var$createPause(childAbortController.signal),
                                    delay: $46263ddf6cb29d0e$var$createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _c.sent();
                            $46263ddf6cb29d0e$var$validateActive(childAbortController.signal);
                            return [
                                2 /*return*/ ,
                                result2
                            ];
                    }
                });
            });
        }, function() {
            return $46263ddf6cb29d0e$var$abortControllerWithReason(childAbortController, $46263ddf6cb29d0e$var$taskCompleted);
        });
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result);
        return {
            result: $46263ddf6cb29d0e$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $46263ddf6cb29d0e$var$abortControllerWithReason(childAbortController, $46263ddf6cb29d0e$var$taskCancelled);
            }
        };
    };
};
var $46263ddf6cb29d0e$var$createTakePattern = function(startListening, signal) {
    var take = function(predicate, timeout) {
        return $46263ddf6cb29d0e$var$__async(void 0, null, function() {
            var unsubscribe, tuplePromise, promises, output;
            return $46263ddf6cb29d0e$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $46263ddf6cb29d0e$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            $46263ddf6cb29d0e$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _c.sent();
                        $46263ddf6cb29d0e$var$validateActive(signal);
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return function(predicate, timeout) {
        return $46263ddf6cb29d0e$var$catchRejection(take(predicate, timeout));
    };
};
var $46263ddf6cb29d0e$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $46263ddf6cb29d0e$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    $46263ddf6cb29d0e$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $46263ddf6cb29d0e$var$createListenerEntry = function(options) {
    var _c = $46263ddf6cb29d0e$var$getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = $46263ddf6cb29d0e$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function() {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var $46263ddf6cb29d0e$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $46263ddf6cb29d0e$var$abortControllerWithReason(controller, $46263ddf6cb29d0e$var$listenerCancelled);
    });
};
var $46263ddf6cb29d0e$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($46263ddf6cb29d0e$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $46263ddf6cb29d0e$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $46263ddf6cb29d0e$export$f03a6b845d3fb58b = $46263ddf6cb29d0e$export$309c7a02b0b0bc62($46263ddf6cb29d0e$var$alm + "/add");
var $46263ddf6cb29d0e$export$b1b8022855fb2b71 = $46263ddf6cb29d0e$export$309c7a02b0b0bc62($46263ddf6cb29d0e$var$alm + "/removeAll");
var $46263ddf6cb29d0e$export$b03e9483f936dccb = $46263ddf6cb29d0e$export$309c7a02b0b0bc62($46263ddf6cb29d0e$var$alm + "/remove");
var $46263ddf6cb29d0e$var$defaultErrorHandler = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    console.error.apply(console, $46263ddf6cb29d0e$var$__spreadArray([
        $46263ddf6cb29d0e$var$alm + "/error"
    ], args));
};
function $46263ddf6cb29d0e$export$1228acebbbcb485b(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) middlewareOptions = {};
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? $46263ddf6cb29d0e$var$defaultErrorHandler : _c;
    $46263ddf6cb29d0e$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $46263ddf6cb29d0e$var$cancelActiveListeners(entry);
        };
    };
    var findListenerEntry = function(comparator) {
        for(var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++){
            var entry = _c[_i];
            if (comparator(entry)) return entry;
        }
        return void 0;
    };
    var startListening = function(options) {
        var entry = findListenerEntry(function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $46263ddf6cb29d0e$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function(options) {
        var _c = $46263ddf6cb29d0e$var$getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $46263ddf6cb29d0e$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function(entry, action, api, getOriginalState) {
        return $46263ddf6cb29d0e$var$__async(_this, null, function() {
            var internalTaskController, take, autoJoinPromises, listenerError_1;
            return $46263ddf6cb29d0e$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $46263ddf6cb29d0e$var$createTakePattern(startListening, internalTaskController.signal);
                        autoJoinPromises = [];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            4,
                            6
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(entry.effect(action, $46263ddf6cb29d0e$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $46263ddf6cb29d0e$var$createDelay(internalTaskController.signal),
                                pause: $46263ddf6cb29d0e$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $46263ddf6cb29d0e$var$createFork(internalTaskController.signal, autoJoinPromises),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $46263ddf6cb29d0e$var$abortControllerWithReason(controller, $46263ddf6cb29d0e$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                }
                            })))
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 3:
                        listenerError_1 = _c.sent();
                        if (!(listenerError_1 instanceof $46263ddf6cb29d0e$export$cb1bdac908fed7f)) $46263ddf6cb29d0e$var$safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            Promise.allSettled(autoJoinPromises)
                        ];
                    case 5:
                        _c.sent();
                        $46263ddf6cb29d0e$var$abortControllerWithReason(internalTaskController, $46263ddf6cb29d0e$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clearListenerMiddleware = $46263ddf6cb29d0e$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!$46263ddf6cb29d0e$export$b956e38827fca970(action)) return next(action);
                if ($46263ddf6cb29d0e$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($46263ddf6cb29d0e$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($46263ddf6cb29d0e$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $46263ddf6cb29d0e$var$INTERNAL_NIL_TOKEN) throw new Error($46263ddf6cb29d0e$var$alm + ": getOriginalState can only be called synchronously");
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        for(var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++){
                            var entry = listenerEntries_1[_i];
                            var runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $46263ddf6cb29d0e$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $46263ddf6cb29d0e$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var $46263ddf6cb29d0e$export$8fb31c0f05df007b = "RTK_autoBatch";
var $46263ddf6cb29d0e$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        var _c;
        return {
            payload: payload,
            meta: (_c = {}, _c[$46263ddf6cb29d0e$export$8fb31c0f05df007b] = true, _c)
        };
    };
};
var $46263ddf6cb29d0e$var$promise;
var $46263ddf6cb29d0e$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function(cb) {
    return ($46263ddf6cb29d0e$var$promise || ($46263ddf6cb29d0e$var$promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $46263ddf6cb29d0e$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $46263ddf6cb29d0e$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $46263ddf6cb29d0e$var$createQueueWithTimer(10);
var $46263ddf6cb29d0e$export$676277d7dca0f396 = function(options) {
    if (options === void 0) options = {
        type: "raf"
    };
    return function(next) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var store = next.apply(void 0, args);
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = new Set();
            var queueCallback = options.type === "tick" ? $46263ddf6cb29d0e$var$queueMicrotaskShim : options.type === "raf" ? $46263ddf6cb29d0e$var$rAF : options.type === "callback" ? options.queueNotification : $46263ddf6cb29d0e$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$46263ddf6cb29d0e$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/index.ts
(0, $bggQN.enableES5)();

});
parcelRegister("bggQN", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return r; });
$parcel$export(module.exports, "isDraftable", function () { return t; });
$parcel$export(module.exports, "immerable", function () { return L; });
$parcel$export(module.exports, "original", function () { return e; });
$parcel$export(module.exports, "freeze", function () { return d; });
$parcel$export(module.exports, "nothing", function () { return H; });
$parcel$export(module.exports, "current", function () { return R; });
$parcel$export(module.exports, "enableES5", function () { return F; });
$parcel$export(module.exports, "enablePatches", function () { return T; });
$parcel$export(module.exports, "enableMapSet", function () { return C; });
$parcel$export(module.exports, "enableAllPlugins", function () { return J; });
$parcel$export(module.exports, "castDraft", function () { return K; });
$parcel$export(module.exports, "castImmutable", function () { return $; });
$parcel$export(module.exports, "Immer", function () { return un; });
$parcel$export(module.exports, "produce", function () { return fn; });
$parcel$export(module.exports, "produceWithPatches", function () { return cn; });
$parcel$export(module.exports, "setAutoFreeze", function () { return sn; });
$parcel$export(module.exports, "setUseProxies", function () { return vn; });
$parcel$export(module.exports, "applyPatches", function () { return pn; });
$parcel$export(module.exports, "createDraft", function () { return ln; });
$parcel$export(module.exports, "finishDraft", function () { return dn; });
$parcel$export(module.exports, "default", function () { return $832e42863b85c77c$export$2e2bcd8739ae039; });
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $832e42863b85c77c$export$2e2bcd8739ae039 = fn;

});

parcelRegister("jB3tr", function(module, exports) {

$parcel$export(module.exports, "createStore", function () { return $e4442ad937f8faa3$export$f51a9068ac82ea43; });
$parcel$export(module.exports, "combineReducers", function () { return $e4442ad937f8faa3$export$66e4520cdb265d18; });
$parcel$export(module.exports, "compose", function () { return $e4442ad937f8faa3$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "applyMiddleware", function () { return $e4442ad937f8faa3$export$9ff26e0402cc7b7; });

var $3JHym = parcelRequire("3JHym");
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $e4442ad937f8faa3$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $e4442ad937f8faa3$var$$$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $e4442ad937f8faa3$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $e4442ad937f8faa3$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $e4442ad937f8faa3$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $e4442ad937f8faa3$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $e4442ad937f8faa3$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $e4442ad937f8faa3$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $e4442ad937f8faa3$var$miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if ($e4442ad937f8faa3$var$isDate(val)) return 'date';
    if ($e4442ad937f8faa3$var$isError(val)) return 'error';
    var constructorName = $e4442ad937f8faa3$var$ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function $e4442ad937f8faa3$var$ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function $e4442ad937f8faa3$var$isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function $e4442ad937f8faa3$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function $e4442ad937f8faa3$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $e4442ad937f8faa3$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($e4442ad937f8faa3$var$formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error($e4442ad937f8faa3$var$formatProdErrorMessage(1));
        return enhancer($e4442ad937f8faa3$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error($e4442ad937f8faa3$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($e4442ad937f8faa3$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error($e4442ad937f8faa3$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($e4442ad937f8faa3$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($e4442ad937f8faa3$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$e4442ad937f8faa3$var$isPlainObject(action)) throw new Error($e4442ad937f8faa3$var$formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error($e4442ad937f8faa3$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($e4442ad937f8faa3$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error($e4442ad937f8faa3$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $e4442ad937f8faa3$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error($e4442ad937f8faa3$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$e4442ad937f8faa3$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $e4442ad937f8faa3$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$e4442ad937f8faa3$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $e4442ad937f8faa3$export$8928921ea2d3b126 = $e4442ad937f8faa3$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $e4442ad937f8faa3$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $e4442ad937f8faa3$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $e4442ad937f8faa3$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$e4442ad937f8faa3$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $e4442ad937f8faa3$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $e4442ad937f8faa3$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $e4442ad937f8faa3$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $e4442ad937f8faa3$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error($e4442ad937f8faa3$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $e4442ad937f8faa3$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error($e4442ad937f8faa3$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $e4442ad937f8faa3$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $e4442ad937f8faa3$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error($e4442ad937f8faa3$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $e4442ad937f8faa3$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $e4442ad937f8faa3$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $e4442ad937f8faa3$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($e4442ad937f8faa3$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $e4442ad937f8faa3$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $e4442ad937f8faa3$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $e4442ad937f8faa3$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($e4442ad937f8faa3$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $e4442ad937f8faa3$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $3JHym.default)((0, $3JHym.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRegister("3JHym", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b875bd67e8af8ad$export$2e2bcd8739ae039; });

var $a0rRx = parcelRequire("a0rRx");
function $2b875bd67e8af8ad$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2b875bd67e8af8ad$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2b875bd67e8af8ad$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $a0rRx.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2b875bd67e8af8ad$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});
parcelRegister("a0rRx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $748f845d44e3d947$export$2e2bcd8739ae039; });

var $63t3n = parcelRequire("63t3n");
function $748f845d44e3d947$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $63t3n.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("63t3n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46898f52ec21741a$export$2e2bcd8739ae039; });

var $fOroE = parcelRequire("fOroE");

var $7KyRF = parcelRequire("7KyRF");
function $46898f52ec21741a$export$2e2bcd8739ae039(t) {
    var i = (0, $7KyRF.default)(t, "string");
    return "symbol" == (0, $fOroE.default)(i) ? i : i + "";
}

});
parcelRegister("fOroE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b830c6e90686196c$export$2e2bcd8739ae039; });
function $b830c6e90686196c$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b830c6e90686196c$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b830c6e90686196c$export$2e2bcd8739ae039(o);
}

});

parcelRegister("7KyRF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a47dfaf85677a27$export$2e2bcd8739ae039; });

var $fOroE = parcelRequire("fOroE");
function $5a47dfaf85677a27$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $fOroE.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $fOroE.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});





parcelRegister("hysZj", function(module, exports) {

$parcel$export(module.exports, "createSelector", function () { return $cc7c1909aecfdde7$export$595d22ed68ca2841; });

var $6RiTS = parcelRequire("6RiTS");
function $cc7c1909aecfdde7$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === 'function';
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === 'function' ? "function " + (dep.name || 'unnamed') + "()" : typeof dep;
        }).join(', ');
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $cc7c1909aecfdde7$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === 'object') {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== 'function') throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $cc7c1909aecfdde7$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $cc7c1909aecfdde7$export$595d22ed68ca2841 = /* #__PURE__ */ $cc7c1909aecfdde7$export$5943f4447f6ef248((0, $6RiTS.defaultMemoize));
var $cc7c1909aecfdde7$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $cc7c1909aecfdde7$export$595d22ed68ca2841;
    if (typeof selectors !== 'object') throw new Error('createStructuredSelector expects first argument to be an object ' + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};

});
parcelRegister("6RiTS", function(module, exports) {

$parcel$export(module.exports, "defaultMemoize", function () { return $4fe65a83689565fa$export$281bff7f05488aa2; });
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $4fe65a83689565fa$var$NOT_FOUND = 'NOT_FOUND';
function $4fe65a83689565fa$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $4fe65a83689565fa$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $4fe65a83689565fa$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $4fe65a83689565fa$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $4fe65a83689565fa$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $4fe65a83689565fa$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $4fe65a83689565fa$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $4fe65a83689565fa$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === 'object' ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $4fe65a83689565fa$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $4fe65a83689565fa$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $4fe65a83689565fa$var$createSingletonCache(comparator) : $4fe65a83689565fa$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $4fe65a83689565fa$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}

});


parcelRegister("b0eAP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $802b03aaa4e14ff9$export$2e2bcd8739ae039; });
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $802b03aaa4e14ff9$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === 'function') // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $802b03aaa4e14ff9$var$thunk = $802b03aaa4e14ff9$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$802b03aaa4e14ff9$var$thunk.withExtraArgument = $802b03aaa4e14ff9$var$createThunkMiddleware;
var $802b03aaa4e14ff9$export$2e2bcd8739ae039 = $802b03aaa4e14ff9$var$thunk;

});


parcelRegister("6Jwum", function(module, exports) {

$parcel$export(module.exports, "postLogin", function () { return $16928c35e5ec1735$export$f2b793fb6eff54de; });
$parcel$export(module.exports, "loginAsGuest", function () { return $16928c35e5ec1735$export$cac7a67f197c8403; });
$parcel$export(module.exports, "logout", function () { return $16928c35e5ec1735$export$a0973bcfe11b05c9; });
$parcel$export(module.exports, "initialAuthCheck", function () { return $16928c35e5ec1735$export$77eefe1bac88f916; });
$parcel$export(module.exports, "initialAuthFlow", function () { return $16928c35e5ec1735$export$e3ffc48508b7a7fa; });
$parcel$export(module.exports, "updateIsLoggedIn", function () { return $16928c35e5ec1735$export$9e944975420e1fad; });
$parcel$export(module.exports, "updateUser", function () { return $16928c35e5ec1735$export$e3ac7a5d19605772; });
$parcel$export(module.exports, "default", function () { return $16928c35e5ec1735$export$2e2bcd8739ae039; });

var $61p16 = parcelRequire("61p16");

var $9HMNu = parcelRequire("9HMNu");

var $9K8Jg = parcelRequire("9K8Jg");

var $6KpYp = parcelRequire("6KpYp");

var $ly8fr = parcelRequire("ly8fr");

var $kFQy0 = parcelRequire("kFQy0");

var $f9UtO = parcelRequire("f9UtO");

var $cTs7K = parcelRequire("cTs7K");
const $16928c35e5ec1735$var$initialState = {
    loggedIn: false,
    isLoggingIn: false,
    intialAuthCheckComplete: false,
    isInitialAuthCheckInProgress: false,
    isRegistering: false,
    isRegistrationSuccessful: false
};
const $16928c35e5ec1735$export$a87928eef029cbb4 = $16928c35e5ec1735$var$initialState;
const $16928c35e5ec1735$export$596d806903d1f59e = (0, $61p16.createAsyncThunk)('auth/login', async ([email, password], thunkApi)=>{
    try {
        await $9K8Jg.login(email, password);
        thunkApi.dispatch($16928c35e5ec1735$export$f2b793fb6eff54de());
    } catch (error) {
        return thunkApi.rejectWithValue(error.message || 'UNKNOWN_ERROR');
    }
});
const $16928c35e5ec1735$export$f2b793fb6eff54de = (0, $61p16.createAsyncThunk)('auth/postLogin', async (_, thunkApi)=>{
    const user = await $9K8Jg.me();
    (0, $ly8fr.setUserId)(user.id);
    (0, $kFQy0.sendEvent)('login');
    return user;
});
const $16928c35e5ec1735$export$cac7a67f197c8403 = (0, $61p16.createAsyncThunk)('auth/loginGuest', async (_, thunkApi)=>{
    await $9K8Jg.loginAsGuest();
    thunkApi.dispatch($16928c35e5ec1735$export$f2b793fb6eff54de());
});
const $16928c35e5ec1735$export$a0973bcfe11b05c9 = (0, $61p16.createAsyncThunk)('auth/logout', async (_, t)=>{
    await $9K8Jg.logout();
    t.dispatch((0, $9HMNu.resetAppState)());
    t.dispatch((0, $6KpYp.resetProfileState)());
});
const $16928c35e5ec1735$export$6503ec6e8aabbaf = (0, $61p16.createAsyncThunk)('auth/register', async ([email, password, turnstileToken], thunkApi)=>{
    try {
        const result = await $9K8Jg.register(email, password, turnstileToken);
        return result.success;
    } catch (error) {
        return thunkApi.rejectWithValue(error.message || 'UNKNOWN_ERROR');
    }
});
const $16928c35e5ec1735$export$77eefe1bac88f916 = (0, $61p16.createAsyncThunk)('auth/initialAuthCheck', async (_, thunkApi)=>{
    if (!$9K8Jg.getAuthToken()) return null;
    let user;
    try {
        user = await $9K8Jg.me();
    } catch (error) {
        $9K8Jg.setAuthToken('');
        await thunkApi.dispatch($16928c35e5ec1735$export$cac7a67f197c8403());
        user = await $9K8Jg.me();
    }
    if (user) {
        (0, $ly8fr.setUserId)(user.id);
        (0, $kFQy0.sendEvent)('reopened_app');
        return user;
    }
    return null;
});
const $16928c35e5ec1735$export$e3ffc48508b7a7fa = (0, $61p16.createAsyncThunk)('auth/initialAuthFlow', async (_, thunkApi)=>{
    if (0, $cTs7K.IS_DISCORD_ACTIVITY) return null;
    if (!$9K8Jg.getAuthToken()) await $9K8Jg.loginAsGuest();
    let userId;
    try {
        const token = $9K8Jg.getAuthToken();
        const data = (0, $f9UtO.getTokenPayload)(token);
        userId = data.sub;
        (0, $ly8fr.setUserId)(userId);
        thunkApi.dispatch($16928c35e5ec1735$export$9e944975420e1fad(true));
    } catch (error) {
        console.error('Error decoding token:', error);
    }
    return null;
});
const $16928c35e5ec1735$var$handlePendingLogin = (state)=>{
    state.isLoggingIn = true;
    state.loginError = undefined;
};
const $16928c35e5ec1735$var$handleRejectedLogin = (state, errorMessage)=>{
    // state.loggedIn = false;
    state.isLoggingIn = false;
    state.loginError = errorMessage;
};
const $16928c35e5ec1735$var$auth = (0, $61p16.createSlice)({
    name: 'auth',
    initialState: $16928c35e5ec1735$var$initialState,
    reducers: {
        updateUser (state, action) {
            state.user = action.payload;
        },
        updateIsLoggedIn (state, action) {
            state.loggedIn = action.payload;
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($16928c35e5ec1735$export$596d806903d1f59e.pending, $16928c35e5ec1735$var$handlePendingLogin);
        builder.addCase($16928c35e5ec1735$export$596d806903d1f59e.rejected, (state, action)=>{
            $16928c35e5ec1735$var$handleRejectedLogin(state, action.payload);
        });
        builder.addCase($16928c35e5ec1735$export$cac7a67f197c8403.pending, $16928c35e5ec1735$var$handlePendingLogin);
        builder.addCase($16928c35e5ec1735$export$cac7a67f197c8403.rejected, (state, action)=>{
            $16928c35e5ec1735$var$handleRejectedLogin(state, action.payload);
        });
        builder.addCase($16928c35e5ec1735$export$f2b793fb6eff54de.fulfilled, (state, action)=>{
            state.user = action.payload;
            state.loggedIn = true;
            state.isLoggingIn = false;
            state.loginError = undefined;
        });
        builder.addCase($16928c35e5ec1735$export$f2b793fb6eff54de.rejected, (state, action)=>{
            $16928c35e5ec1735$var$handleRejectedLogin(state, action.payload);
        });
        builder.addCase($16928c35e5ec1735$export$6503ec6e8aabbaf.pending, (state)=>{
            state.isRegistering = true;
            state.registerError = undefined;
            state.isRegistrationSuccessful = false;
        });
        builder.addCase($16928c35e5ec1735$export$6503ec6e8aabbaf.fulfilled, (state)=>{
            state.isRegistering = false;
            state.isRegistrationSuccessful = true;
        });
        builder.addCase($16928c35e5ec1735$export$6503ec6e8aabbaf.rejected, (state, action)=>{
            state.isRegistering = false;
            state.registerError = action.payload;
            state.isRegistrationSuccessful = false;
        });
        builder.addCase($16928c35e5ec1735$export$77eefe1bac88f916.pending, (state)=>{
            state.isInitialAuthCheckInProgress = true;
        });
        builder.addCase($16928c35e5ec1735$export$77eefe1bac88f916.fulfilled, (state, action)=>{
            if (action.payload) {
                state.user = action.payload;
                state.loggedIn = !!action.payload;
            }
            state.isInitialAuthCheckInProgress = false;
            state.intialAuthCheckComplete = true;
        });
        builder.addCase($16928c35e5ec1735$export$77eefe1bac88f916.rejected, (state, action)=>{
            state.isInitialAuthCheckInProgress = false;
            state.intialAuthCheckComplete = true;
        });
        builder.addCase($16928c35e5ec1735$export$a0973bcfe11b05c9.pending, (state)=>{
            state.loggedIn = false;
            state.intialAuthCheckComplete = true;
            state.user = undefined;
            state.isLoggingIn = false;
            state.hasLoggedOut = true;
        });
        builder.addCase($16928c35e5ec1735$export$a0973bcfe11b05c9.rejected, (state, action)=>{
            console.log(action.error);
        });
        builder.addCase($16928c35e5ec1735$export$a0973bcfe11b05c9.fulfilled, (state)=>{
        // ?
        });
    }
});
const { updateUser: $16928c35e5ec1735$export$e3ac7a5d19605772, updateIsLoggedIn: $16928c35e5ec1735$export$9e944975420e1fad } = $16928c35e5ec1735$var$auth.actions;
const { actions: $16928c35e5ec1735$export$2b4c6dd0b4533a88, reducer: $16928c35e5ec1735$export$b3aa4dbb59e7857d } = $16928c35e5ec1735$var$auth;
var $16928c35e5ec1735$export$2e2bcd8739ae039 = $16928c35e5ec1735$export$b3aa4dbb59e7857d;

});
parcelRegister("9HMNu", function(module, exports) {

$parcel$export(module.exports, "loadInstance", function () { return $71a21b0cd9be7df0$export$87e299862ee2a235; });
$parcel$export(module.exports, "loadLocation", function () { return $71a21b0cd9be7df0$export$4297fea210b644d9; });
$parcel$export(module.exports, "failedGame", function () { return $71a21b0cd9be7df0$export$55d755f3fb83609f; });
$parcel$export(module.exports, "submitFeedUpdate", function () { return $71a21b0cd9be7df0$export$e36b950b6d863b55; });
$parcel$export(module.exports, "loadTranslations", function () { return $71a21b0cd9be7df0$export$d0a0663b151c7564; });
$parcel$export(module.exports, "setHasWorldIntroPlayed", function () { return $71a21b0cd9be7df0$export$6f9a7cf27ab4b017; });
$parcel$export(module.exports, "setShouldShowGuestSignUpModal", function () { return $71a21b0cd9be7df0$export$31d571dbf2a7d893; });
$parcel$export(module.exports, "setIsInventoryOpen", function () { return $71a21b0cd9be7df0$export$afcd214d843b4ec0; });
$parcel$export(module.exports, "setIsNewsTickerVisible", function () { return $71a21b0cd9be7df0$export$2f1a15ef644a27f9; });
$parcel$export(module.exports, "setIsLeaderboardOpen", function () { return $71a21b0cd9be7df0$export$c47ad9502cddc183; });
$parcel$export(module.exports, "setIsExitLocationModalOpen", function () { return $71a21b0cd9be7df0$export$863e57c4bfe9488d; });
$parcel$export(module.exports, "openProfile", function () { return $71a21b0cd9be7df0$export$c10e7cabab300b11; });
$parcel$export(module.exports, "closeProfile", function () { return $71a21b0cd9be7df0$export$eec6a89ec39aab8c; });
$parcel$export(module.exports, "setIsInformationOpen", function () { return $71a21b0cd9be7df0$export$d730e57b4ba196e5; });
$parcel$export(module.exports, "setIsMyRewardsOpen", function () { return $71a21b0cd9be7df0$export$56e6602371115dfa; });
$parcel$export(module.exports, "toggleDebugMenu", function () { return $71a21b0cd9be7df0$export$37c982b2c0e2abef; });
$parcel$export(module.exports, "setIsRefreshModalOpen", function () { return $71a21b0cd9be7df0$export$981a50838c546fbc; });
$parcel$export(module.exports, "setAuthModalScreen", function () { return $71a21b0cd9be7df0$export$257f2f650e025aa4; });
$parcel$export(module.exports, "resetAppState", function () { return $71a21b0cd9be7df0$export$10d871c0f32f1a89; });
$parcel$export(module.exports, "selectInventoryItem", function () { return $71a21b0cd9be7df0$export$5ab3b4955234c7ca; });
$parcel$export(module.exports, "queueAchievement", function () { return $71a21b0cd9be7df0$export$b0c9ef114e574e3; });
$parcel$export(module.exports, "removeFirstAchievementFromQueue", function () { return $71a21b0cd9be7df0$export$c749ed39a48316f5; });
$parcel$export(module.exports, "setShareModalOpen", function () { return $71a21b0cd9be7df0$export$15bf4e8c69648d0d; });
$parcel$export(module.exports, "setStartShare", function () { return $71a21b0cd9be7df0$export$d9714b27df2ad16a; });
$parcel$export(module.exports, "setCurrentlyViewingMedia", function () { return $71a21b0cd9be7df0$export$b2c71eabfbfbf430; });
$parcel$export(module.exports, "setCurrentlyViewingReward", function () { return $71a21b0cd9be7df0$export$4a6438081ec44283; });
$parcel$export(module.exports, "setInstanceLoadTimestamp", function () { return $71a21b0cd9be7df0$export$f8be399f744c5165; });
$parcel$export(module.exports, "setShouldHideUI", function () { return $71a21b0cd9be7df0$export$512719d933c74d6; });
$parcel$export(module.exports, "setIsManuallyMuted", function () { return $71a21b0cd9be7df0$export$9524187f451275b; });
$parcel$export(module.exports, "setIsLocalePickerPanelVisible", function () { return $71a21b0cd9be7df0$export$424b67956308f435; });
$parcel$export(module.exports, "incrementIframeReloadCount", function () { return $71a21b0cd9be7df0$export$b8ac918c74b875ef; });
$parcel$export(module.exports, "default", function () { return $71a21b0cd9be7df0$export$2e2bcd8739ae039; });

var $hfW7f = parcelRequire("hfW7f");

var $61p16 = parcelRequire("61p16");

var $9K8Jg = parcelRequire("9K8Jg");

var $6Jwum = parcelRequire("6Jwum");

var $24Y1Y = parcelRequire("24Y1Y");

var $k3RPz = parcelRequire("k3RPz");

var $cTs7K = parcelRequire("cTs7K");

var $b3Ivu = parcelRequire("b3Ivu");

var $4QOJJ = parcelRequire("4QOJJ");
const $71a21b0cd9be7df0$var$instanceToTheme = {
    titan: (0, $hfW7f.TitanTheme),
    phobos: (0, $hfW7f.PhobosTheme),
    hyperion: (0, $hfW7f.HyperionTheme),
    mimas: (0, $hfW7f.MimasTheme),
    rana: (0, $hfW7f.RanaTheme),
    deimos: (0, $hfW7f.DeimosTheme),
    umbra: (0, $hfW7f.UmbraTheme),
    brickhouse: (0, $hfW7f.BrickhouseTheme),
    dakota: (0, $hfW7f.DakotaTheme)
};
const $71a21b0cd9be7df0$var$initialState = {
    instance: '',
    instanceLoaded: false,
    isInstanceLoading: false,
    instanceLoadTimestamp: undefined,
    theme: $71a21b0cd9be7df0$var$instanceToTheme["skyhook"] || (0, $hfW7f.defaultTheme),
    isLocationLoading: false,
    isInventoryOpen: false,
    inventoryToggledAt: Date.now(),
    isInventoryUsingItem: false,
    isProfileOpen: false,
    isMyRewardsOpen: false,
    isInformationOpen: false,
    isShopOpen: false,
    isDebugMenuOpen: false,
    isRefreshModalOpen: false,
    isNewsTickerVisible: false,
    isExitLocationModalOpen: false,
    isSidebarOpen: false,
    isFetchingAreas: false,
    isFetchingLocations: false,
    isFetchingRegions: false,
    // TODO: don't hardcode this
    universeId: window.localStorage.getItem('ARISE_UNIVERSEID') || "9097f2ba-ec9e-48b1-82af-0080acd3924e",
    isSettingsMenuShowing: false,
    isSwitchingWorld: false,
    hasWorldIntroPlayed: false,
    guestModalCount: 0,
    hasSeenShop: !!window.localStorage.getItem((0, $cTs7K.LS_HASSEENSHOP_KEY)),
    isManuallyMuted: window.localStorage.getItem((0, $cTs7K.LS_MANUALLY_MUTED_KEY)) === 'true',
    shouldArisewareBeMuted: window.localStorage.getItem((0, $cTs7K.LS_MANUALLY_MUTED_KEY)) === 'true',
    inventory: [],
    isFetchingInventory: false,
    failedAt: undefined,
    achievementQueue: [],
    shareModalOpen: false,
    shareData: {
        message: '',
        disableAutoLink: false
    },
    translations: {},
    isFetchingTranslations: false,
    translationsLoaded: false,
    langIso: (0, $b3Ivu.getSavedLangIso)() || 'en-us',
    availableLangs: [],
    isLocalePickerPanelVisible: false,
    iframeReloadCount: 0
};
const $71a21b0cd9be7df0$export$3a00184c4304ec2e = $71a21b0cd9be7df0$var$initialState;
const $71a21b0cd9be7df0$export$87e299862ee2a235 = (0, $61p16.createAsyncThunk)('app/loadInstance', async (universeId, thunkApi)=>{
    const state = thunkApi.getState();
    // Prevent multiple concurrent calls
    if (state.app.isInstanceLoading) return thunkApi.rejectWithValue('Instance loading already in progress');
    let theme = (0, $hfW7f.defaultTheme);
    if ($71a21b0cd9be7df0$var$instanceToTheme["skyhook"]) theme = $71a21b0cd9be7df0$var$instanceToTheme["skyhook"];
    // const [res, metadata] = await Promise.all([arise.getMedia(universeId), arise.getUniverseMetadata(universeId)]);
    const metadata = await $9K8Jg.getUniverseMetadata(universeId);
    theme = {
        ...theme,
        loaded: true,
        // customJSON: res.customJSON,
        customJSON: {},
        metadata: metadata
    };
    return {
        name: universeId,
        theme: theme
    };
});
const $71a21b0cd9be7df0$export$4297fea210b644d9 = (0, $61p16.createAsyncThunk)('app/loadLocation', async (locationId, thunkApi)=>{
    let { locations: locations } = thunkApi.getState().app;
    if (!locations) {
        const res = await thunkApi.dispatch($71a21b0cd9be7df0$export$2a5930d51041cae6());
        const loc = res.payload.find((l)=>l.id === locationId);
        if (loc) return loc;
        else throw new Error(locationId);
    }
    const location = locations[locationId];
    if (location) return location;
    const res = await thunkApi.dispatch($71a21b0cd9be7df0$export$2a5930d51041cae6());
    const loc = res.payload.find((l)=>l.id === locationId);
    if (loc) return loc;
    throw new Error(locationId);
});
const $71a21b0cd9be7df0$export$2a5930d51041cae6 = (0, $61p16.createAsyncThunk)('app/loadLocations', async (_, thunkApi)=>{
    const res = await $9K8Jg.getLocations();
    return (0, $4QOJJ.cleanCDNUrls)(res);
});
const $71a21b0cd9be7df0$export$a910cb9907254b94 = (0, $61p16.createAsyncThunk)('app/loadAreas', async (_, thunkApi)=>{
    const res = await $9K8Jg.getAreas();
    return res;
});
const $71a21b0cd9be7df0$export$497a83f5fe7b296b = (0, $61p16.createAsyncThunk)('app/loadRegions', async (_, thunkApi)=>{
    const res = await $9K8Jg.getRegions();
    return res;
});
const $71a21b0cd9be7df0$export$9e85acb980e0a28d = (0, $61p16.createAsyncThunk)('app/loadSceneSelectorData', async (_, thunkApi)=>{
    const res = await $9K8Jg.getSceneSelectorSettings();
    return res;
});
const $71a21b0cd9be7df0$export$6b0a6f944ed084f5 = (0, $61p16.createAsyncThunk)('app/switchWorld', async ([worldId, themeId, navigate], thunkApi)=>{
    thunkApi.dispatch($71a21b0cd9be7df0$var$app.actions.setIsSwitchingWorld(true));
    thunkApi.dispatch($71a21b0cd9be7df0$var$app.actions.setShowingSettingsMenu(false));
    // Waiting 1.5 sec to simulate something
    // TODO
    await new Promise((resolve)=>setTimeout(resolve, 1500));
    thunkApi.dispatch($71a21b0cd9be7df0$var$app.actions.clearData());
    thunkApi.dispatch($71a21b0cd9be7df0$var$app.actions.setUniverseId(worldId));
    thunkApi.dispatch((0, $6Jwum.logout)());
    thunkApi.dispatch($71a21b0cd9be7df0$var$app.actions.setIsSwitchingWorld(false));
// TODO: clear all state (locations, areas, etc)
// thunkApi.dispatch(app.actions.setUniverseId(worldId));
// navigate('/auth/login');
});
const $71a21b0cd9be7df0$export$500419e4e8ac909f = (0, $61p16.createAsyncThunk)('app/loadAllLocationData', async (_, thunkApi)=>{
    const state = thunkApi.getState();
    const uId = state.app.universeId;
    if (!uId) {
        console.error('No universe id set');
        return;
    }
    thunkApi.dispatch($71a21b0cd9be7df0$export$a910cb9907254b94());
    thunkApi.dispatch($71a21b0cd9be7df0$export$2a5930d51041cae6());
    thunkApi.dispatch($71a21b0cd9be7df0$export$497a83f5fe7b296b());
});
const $71a21b0cd9be7df0$export$45aba0c57314d190 = (0, $61p16.createAsyncThunk)('app/loadInventory', async (_, thunkApi)=>{
    const res = await $9K8Jg.getInventory();
    return res;
});
const $71a21b0cd9be7df0$export$55d755f3fb83609f = (0, $61p16.createAsyncThunk)('app/failedGame', async ({ arisewareProjectID: arisewareProjectID }, thunkApi)=>{
    const { dispatch: dispatch } = thunkApi;
    const s = thunkApi.getState();
    dispatch($71a21b0cd9be7df0$var$app.actions.setHasFailed(true));
    dispatch($71a21b0cd9be7df0$var$app.actions.setIsSidebarOpen(true));
    dispatch($71a21b0cd9be7df0$var$app.actions.setIsInventoryOpen(false));
    dispatch($71a21b0cd9be7df0$var$app.actions.setIsExitLocationModalOpen(false));
    await $9K8Jg.failedAriseware(arisewareProjectID);
});
const $71a21b0cd9be7df0$export$de1483e67cebf1c9 = (0, $61p16.createAsyncThunk)('app/clearFailed', async (_, thunkApi)=>{
    const { dispatch: dispatch } = thunkApi;
    dispatch($71a21b0cd9be7df0$var$app.actions.setHasFailed(false));
    if ((0, $24Y1Y.isMobileWidth)()) dispatch($71a21b0cd9be7df0$var$app.actions.setIsSidebarOpen(false));
});
const $71a21b0cd9be7df0$export$e36b950b6d863b55 = (0, $61p16.createAsyncThunk)('app/failedGame', async (type, thunkApi)=>{
    const s = thunkApi.getState();
    if (!s.app?.location?.isFeedOpen) return;
    try {
        await $9K8Jg.submitFeedUpdate(s.app.location.id, type);
    } catch (error) {
        console.error('Failed to submit feed update', error);
    }
});
const $71a21b0cd9be7df0$export$2ffd3871cec7b2d9 = (0, $61p16.createAsyncThunk)('app/submitArisewareScore', async (data, thunkApi)=>{
    try {
        await $9K8Jg.submitArisewareScore(data);
    } catch (error) {
        console.error('Failed to submit arise score', error);
    }
});
const $71a21b0cd9be7df0$export$d0a0663b151c7564 = (0, $61p16.createAsyncThunk)('app/loadTranslations', async (_, thunkApi)=>{
    let lastError;
    for(let attempt = 1; attempt <= 3; attempt++)try {
        const res = await $9K8Jg.getTranslations();
        const { langs: langs, ...translations } = res;
        return {
            translations: translations,
            langs: langs || []
        };
    } catch (error) {
        lastError = error;
        console.error(`Failed to load translations (attempt ${attempt}/3)`, error);
        if (attempt < 3) await new Promise((resolve)=>setTimeout(resolve, 1000 * attempt));
    }
    throw lastError;
});
const $71a21b0cd9be7df0$var$app = (0, $61p16.createSlice)({
    name: 'app',
    initialState: $71a21b0cd9be7df0$var$initialState,
    reducers: {
        toggleInventory (state) {
            state.isInventoryOpen = !state.isInventoryOpen;
        },
        setIsInventoryOpen (state, action) {
            if (Date.now() - state.inventoryToggledAt > 750) {
                state.inventoryToggledAt = Date.now();
                state.isInventoryOpen = action.payload;
            }
        },
        setIsNewsTickerVisible (state, action) {
            state.isNewsTickerVisible = action.payload;
        },
        setIsLeaderboardOpen (state, action) {
            state.isLeaderboardOpen = action.payload;
        },
        setIsExitLocationModalOpen (state, action) {
            state.isExitLocationModalOpen = action.payload;
        },
        toggleSidebarOpen (state) {
            state.isSidebarOpen = !state.isSidebarOpen;
        },
        setIsSidebarOpen (state, action) {
            state.isSidebarOpen = action.payload;
        },
        openProfile (state) {
            // state.currentlyViewingProfile = action.payload;
            state.isSidebarOpen = true;
            state.isProfileOpen = true;
            state.isShopOpen = false;
            state.isMyRewardsOpen = false;
            state.isInformationOpen = false;
        },
        setCurrentlyViewingMedia (state, action) {
            state.currentlyViewingMedia = action.payload;
            state.isLocalePickerPanelVisible = false;
            if (state.currentlyViewingMedia?.resourceType === 'video') state.shouldArisewareBeMuted = true;
            else state.shouldArisewareBeMuted = state.isManuallyMuted ?? false;
        },
        setCurrentlyViewingReward (state, action) {
            state.currentlyViewingReward = action.payload;
        },
        closeProfile (state) {
            state.isProfileOpen = false;
        },
        toggleShopOpen (state) {
            if (!state.isShopOpen) {
                // If shop will become open
                state.isProfileOpen = false;
                state.isSidebarOpen = true;
            }
            state.isShopOpen = !state.isShopOpen;
        },
        setIsShopOpen (state, action) {
            if (action.payload === true) {
                // If shop will become open
                state.isProfileOpen = false;
                state.isSidebarOpen = true;
            }
            state.isShopOpen = action.payload;
        },
        setIsMyRewardsOpen (state, action) {
            if (action.payload === true) {
                state.isProfileOpen = false;
                state.isInformationOpen = false;
            }
            state.isMyRewardsOpen = action.payload;
        },
        setIsInformationOpen (state, action) {
            if (action.payload === true) {
                state.isProfileOpen = false;
                state.isMyRewardsOpen = false;
            }
            state.isInformationOpen = action.payload;
        },
        toggleDebugMenu (state) {
            state.isDebugMenuOpen = !state.isDebugMenuOpen;
        },
        setIsRefreshModalOpen (state, action) {
            state.isRefreshModalOpen = action.payload;
        },
        setAuthModalScreen (state, action) {
            state.authModalScreen = action.payload;
        },
        updateCurrentlyViewingProfileIfMatches (state, action) {
            if (state.currentlyViewingProfile?.id === action.payload?.id) state.currentlyViewingProfile = action.payload;
        },
        setUniverseId (state, action) {
            window.localStorage.setItem('ARISE_UNIVERSEID', action.payload);
            $9K8Jg.setUniverseID(action.payload);
            state.universeId = action.payload;
        },
        toggleShowingSettingsMenu (state) {
            state.isSettingsMenuShowing = !state.isSettingsMenuShowing;
        },
        setShowingSettingsMenu (state, action) {
            state.isSettingsMenuShowing = action.payload;
        },
        setIsSwitchingWorld (state, action) {
            state.isSwitchingWorld = action.payload;
        },
        setHasWorldIntroPlayed (state, action) {
            state.hasWorldIntroPlayed = action.payload;
        },
        setNewsModalLastVersionSeen (state, action) {
            state.newsModalLastVersionSeen = action.payload;
        },
        setShouldShowGuestSignUpModal (state, action) {
            state.shouldShowGuestSignUpModal = action.payload;
            if (action.payload === true) state.guestModalCount = state.guestModalCount + 1;
        },
        setHasSeenShop (state, action) {
            state.hasSeenShop = action.payload;
        },
        clearData (state) {
            state.areas = undefined;
            state.locations = undefined;
            state.regions = undefined;
        },
        updateLocation (state, action) {
            const updatedLocation = (0, $k3RPz.processLocationData)(action.payload);
            if (state.locations) {
                state.locations[updatedLocation.id] = updatedLocation;
                if (state.location?.id === updatedLocation.id) state.location = updatedLocation;
            }
        },
        reevaluateIfFeedsAreOpen (state) {
            for(var locationKey in state.locations)if (state.locations.hasOwnProperty(locationKey)) {
                const location = state.locations[locationKey];
                location.isFeedOpen = (0, $k3RPz.isFeedOpen)(location);
            }
            if (state.location) state.location.isFeedOpen = (0, $k3RPz.isFeedOpen)(state.location);
        },
        setInventory (state, action) {
            state.inventory = action.payload;
        },
        toggleHasFailed (state) {
            // It's oddly difficult to call another reducer from within a reducer,
            // so we duplicate the logic here and in the method below
            if (!state.failedAt) {
                state.isProfileOpen = false;
                state.failedAt = Date.now();
            } else state.failedAt = undefined;
        },
        setHasFailed (state, action) {
            if (action.payload) {
                state.isProfileOpen = false;
                state.failedAt = Date.now();
            } else state.failedAt = undefined;
        },
        incrementIframeReloadCount (state) {
            state.iframeReloadCount += 1;
        },
        resetAppState (state) {
            Object.assign(state, $71a21b0cd9be7df0$var$initialState);
        },
        selectInventoryItem (state) {
            state.isInventoryOpen = true;
            state.isInventoryUsingItem = true;
            state.inventoryToggledAt = Date.now();
        },
        setIsInventoryUsingItem (state, action) {
            state.isInventoryUsingItem = action.payload;
        },
        setIsUnseenItemInInventory (state, action) {
            state.isUnseenItemInInventory = action.payload;
        },
        queueAchievement (state, action) {
            state.achievementQueue.push(action.payload);
        },
        removeFirstAchievementFromQueue (state) {
            state.achievementQueue.shift();
        },
        setStartShare (state, action) {
            state.shareModalOpen = true;
            state.shareData = {
                message: action.payload?.message,
                disableAutoLink: action.payload?.disableAutoLink ?? false
            };
        },
        setShareModalOpen (state, action) {
            state.shareModalOpen = action.payload;
        },
        setIsPurchaseInProgress (state, action) {
            state.isPurchaseInProgress = action.payload;
        },
        setInstanceLoadTimestamp (state) {
            state.instanceLoadTimestamp = Date.now();
        },
        setShouldHideUI (state, action) {
            state.shouldHideUi = action.payload;
        },
        setLangIso (state, action) {
            state.langIso = action.payload?.toLowerCase();
        },
        setShouldArisewareBeMuted (state, action) {
            state.shouldArisewareBeMuted = action.payload;
        },
        setIsManuallyMuted (state, action) {
            state.isManuallyMuted = action.payload;
            state.shouldArisewareBeMuted = action.payload;
            window.localStorage.setItem((0, $cTs7K.LS_MANUALLY_MUTED_KEY), action.payload ? 'true' : 'false');
        },
        setIsLocalePickerPanelVisible (state, action) {
            state.isLocalePickerPanelVisible = action.payload;
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($71a21b0cd9be7df0$export$87e299862ee2a235.pending, (state, action)=>{
            const now = Date.now();
            if (!state.instanceLoadTimestamp || now - state.instanceLoadTimestamp > 5000) {
                state.isInstanceLoading = true;
                state.instanceLoadTimestamp = now;
            }
        });
        builder.addCase($71a21b0cd9be7df0$export$87e299862ee2a235.fulfilled, (state, action)=>{
            state.instance = action.payload.name;
            state.theme = {
                ...action.payload.theme,
                loaded: true
            };
            state.instanceLoaded = true;
            state.isInstanceLoading = false;
        });
        builder.addCase($71a21b0cd9be7df0$export$87e299862ee2a235.rejected, (state, action)=>{
            console.error('Failed to load instance', action.error);
            state.isInstanceLoading = false;
        });
        builder.addCase($71a21b0cd9be7df0$export$4297fea210b644d9.pending, (state, action)=>{
            state.isLocationLoading = true;
            state.locationLoadErrorId = null;
        });
        builder.addCase($71a21b0cd9be7df0$export$4297fea210b644d9.fulfilled, (state, action)=>{
            state.location = action.payload;
            state.isLocationLoading = false;
            state.locationLoadErrorId = null;
        });
        builder.addCase($71a21b0cd9be7df0$export$4297fea210b644d9.rejected, (state, action)=>{
            console.error('Failed to load location', action.error);
            state.locationLoadErrorId = action?.error?.message;
            state.isLocationLoading = false;
        });
        builder.addCase($71a21b0cd9be7df0$export$a910cb9907254b94.pending, (state, action)=>{
            state.isFetchingAreas = true;
        });
        builder.addCase($71a21b0cd9be7df0$export$a910cb9907254b94.fulfilled, (state, action)=>{
            state.areas = {};
            action.payload?.forEach((area)=>{
                state.areas[area.id] = area;
            });
            state.isFetchingAreas = false;
        });
        builder.addCase($71a21b0cd9be7df0$export$a910cb9907254b94.rejected, (state, action)=>{
            console.error('Failed to load areas', action.error);
            state.isFetchingAreas = false;
        });
        builder.addCase($71a21b0cd9be7df0$export$2a5930d51041cae6.pending, (state, action)=>{
            state.isFetchingLocations = true;
        });
        builder.addCase($71a21b0cd9be7df0$export$2a5930d51041cae6.fulfilled, (state, action)=>{
            state.locations = {};
            action.payload?.forEach((location)=>{
                state.locations[location.id] = location;
                if (state.location?.id === location.id) state.location = location;
            });
            state.isFetchingLocations = false;
        });
        builder.addCase($71a21b0cd9be7df0$export$2a5930d51041cae6.rejected, (state, action)=>{
            console.error('Failed to load locations', action.error);
            state.isFetchingLocations = false;
        });
        builder.addCase($71a21b0cd9be7df0$export$497a83f5fe7b296b.pending, (state, action)=>{
            state.isFetchingRegions = true;
        });
        builder.addCase($71a21b0cd9be7df0$export$497a83f5fe7b296b.fulfilled, (state, action)=>{
            state.regions = {};
            action.payload?.forEach((region)=>{
                state.regions[region.id] = region;
            });
            state.isFetchingRegions = false;
        });
        builder.addCase($71a21b0cd9be7df0$export$497a83f5fe7b296b.rejected, (state, action)=>{
            console.error('Failed to load regions', action.error);
            state.isFetchingRegions = false;
        });
        builder.addCase($71a21b0cd9be7df0$export$6b0a6f944ed084f5.pending, (state, action)=>{
            state.isSwitchingWorld = true;
        });
        builder.addCase($71a21b0cd9be7df0$export$6b0a6f944ed084f5.fulfilled, (state, action)=>{
            state.isSwitchingWorld = false;
        });
        builder.addCase($71a21b0cd9be7df0$export$6b0a6f944ed084f5.rejected, (state, action)=>{
            console.error('Failed to switch world', action.error);
            state.isSwitchingWorld = false;
        });
        builder.addCase($71a21b0cd9be7df0$export$45aba0c57314d190.pending, (state, action)=>{
            state.isFetchingInventory = true;
        });
        builder.addCase($71a21b0cd9be7df0$export$45aba0c57314d190.fulfilled, (state, action)=>{
            state.inventory = action.payload;
            state.isFetchingInventory = false;
        });
        builder.addCase($71a21b0cd9be7df0$export$45aba0c57314d190.rejected, (state, action)=>{
            console.error('Failed to load inventory', action.error);
            state.isFetchingInventory = false;
        });
        builder.addCase($71a21b0cd9be7df0$export$9e85acb980e0a28d.fulfilled, (state, action)=>{
            state.sceneSelectorData = action.payload;
        });
        builder.addCase($71a21b0cd9be7df0$export$d0a0663b151c7564.pending, (state)=>{
            state.isFetchingTranslations = true;
        });
        builder.addCase($71a21b0cd9be7df0$export$d0a0663b151c7564.fulfilled, (state, action)=>{
            state.translations = action.payload.translations;
            state.availableLangs = action.payload.langs;
            state.isFetchingTranslations = false;
            state.translationsLoaded = true;
        });
        builder.addCase($71a21b0cd9be7df0$export$d0a0663b151c7564.rejected, (state, action)=>{
            console.error('Failed to load translations', action.error);
            state.isFetchingTranslations = false;
        });
    }
});
const { toggleInventory: $71a21b0cd9be7df0$export$ce18e5b72073dbce, setUniverseId: $71a21b0cd9be7df0$export$50dc8d5390587977, toggleShowingSettingsMenu: $71a21b0cd9be7df0$export$dd2c4aaede92d637, setShowingSettingsMenu: $71a21b0cd9be7df0$export$47784c5e07fa5b05, setHasWorldIntroPlayed: $71a21b0cd9be7df0$export$6f9a7cf27ab4b017, setNewsModalLastVersionSeen: $71a21b0cd9be7df0$export$788d6e8e2edf42f8, setShouldShowGuestSignUpModal: $71a21b0cd9be7df0$export$31d571dbf2a7d893, setHasSeenShop: $71a21b0cd9be7df0$export$efafe52fdfb810ce, setIsInventoryOpen: $71a21b0cd9be7df0$export$afcd214d843b4ec0, setIsNewsTickerVisible: $71a21b0cd9be7df0$export$2f1a15ef644a27f9, setIsLeaderboardOpen: $71a21b0cd9be7df0$export$c47ad9502cddc183, setIsExitLocationModalOpen: $71a21b0cd9be7df0$export$863e57c4bfe9488d, openProfile: $71a21b0cd9be7df0$export$c10e7cabab300b11, closeProfile: $71a21b0cd9be7df0$export$eec6a89ec39aab8c, updateCurrentlyViewingProfileIfMatches: $71a21b0cd9be7df0$export$85ea600332a89f56, toggleSidebarOpen: $71a21b0cd9be7df0$export$1d54456469cf71ed, setIsInformationOpen: $71a21b0cd9be7df0$export$d730e57b4ba196e5, setIsSidebarOpen: $71a21b0cd9be7df0$export$7228de5ae4af2ef0, toggleShopOpen: $71a21b0cd9be7df0$export$9c34bafc33bfcb6e, setIsShopOpen: $71a21b0cd9be7df0$export$abd1221cd0a2b4b6, setIsMyRewardsOpen: $71a21b0cd9be7df0$export$56e6602371115dfa, toggleDebugMenu: $71a21b0cd9be7df0$export$37c982b2c0e2abef, setIsRefreshModalOpen: $71a21b0cd9be7df0$export$981a50838c546fbc, setAuthModalScreen: $71a21b0cd9be7df0$export$257f2f650e025aa4, reevaluateIfFeedsAreOpen: $71a21b0cd9be7df0$export$5c31e51f56cbe8c4, updateLocation: $71a21b0cd9be7df0$export$735c4579e2cd6507, setInventory: $71a21b0cd9be7df0$export$1951e9681e66c182, toggleHasFailed: $71a21b0cd9be7df0$export$d3e8133f89ca00c6, setHasFailed: $71a21b0cd9be7df0$export$e3f584b95020ea06, resetAppState: $71a21b0cd9be7df0$export$10d871c0f32f1a89, selectInventoryItem: $71a21b0cd9be7df0$export$5ab3b4955234c7ca, setIsInventoryUsingItem: $71a21b0cd9be7df0$export$a484e967e6f27430, setIsUnseenItemInInventory: $71a21b0cd9be7df0$export$11201f4135d2107c, queueAchievement: $71a21b0cd9be7df0$export$b0c9ef114e574e3, removeFirstAchievementFromQueue: $71a21b0cd9be7df0$export$c749ed39a48316f5, setShareModalOpen: $71a21b0cd9be7df0$export$15bf4e8c69648d0d, setStartShare: $71a21b0cd9be7df0$export$d9714b27df2ad16a, setIsPurchaseInProgress: $71a21b0cd9be7df0$export$a6b80e802e587e44, setCurrentlyViewingMedia: $71a21b0cd9be7df0$export$b2c71eabfbfbf430, setCurrentlyViewingReward: $71a21b0cd9be7df0$export$4a6438081ec44283, setInstanceLoadTimestamp: $71a21b0cd9be7df0$export$f8be399f744c5165, setShouldHideUI: $71a21b0cd9be7df0$export$512719d933c74d6, setLangIso: $71a21b0cd9be7df0$export$5636fe289543a2cf, setShouldArisewareBeMuted: $71a21b0cd9be7df0$export$e8a120f4c8ccb9a3, setIsManuallyMuted: $71a21b0cd9be7df0$export$9524187f451275b, setIsLocalePickerPanelVisible: $71a21b0cd9be7df0$export$424b67956308f435, incrementIframeReloadCount: $71a21b0cd9be7df0$export$b8ac918c74b875ef } = $71a21b0cd9be7df0$var$app.actions;
const { actions: $71a21b0cd9be7df0$export$cb8424a6e24c1eca, reducer: $71a21b0cd9be7df0$export$23ada22b619801be } = $71a21b0cd9be7df0$var$app;
var $71a21b0cd9be7df0$export$2e2bcd8739ae039 = $71a21b0cd9be7df0$export$23ada22b619801be;

});
parcelRegister("hfW7f", function(module, exports) {

$parcel$export(module.exports, "ThemeIds", function () { return $752dabd2bb034630$export$cd9fd31d4e88d2ee; });
$parcel$export(module.exports, "defaultTheme", function () { return $752dabd2bb034630$export$164de7ab8df77ef0; });
$parcel$export(module.exports, "TitanTheme", function () { return $752dabd2bb034630$export$a53e903714f41d6f; });
$parcel$export(module.exports, "PhobosTheme", function () { return $752dabd2bb034630$export$dc830f52acce79df; });
$parcel$export(module.exports, "HyperionTheme", function () { return $752dabd2bb034630$export$b90c99545b77fd72; });
$parcel$export(module.exports, "MimasTheme", function () { return $752dabd2bb034630$export$82c5380410702a78; });
$parcel$export(module.exports, "RanaTheme", function () { return $752dabd2bb034630$export$619f3429ba3f527d; });
$parcel$export(module.exports, "DeimosTheme", function () { return $752dabd2bb034630$export$51184b5f01eae579; });
$parcel$export(module.exports, "UmbraTheme", function () { return $752dabd2bb034630$export$3e0b756d8b9d706e; });
$parcel$export(module.exports, "BrickhouseTheme", function () { return $752dabd2bb034630$export$2bfc74427d664a08; });
$parcel$export(module.exports, "DakotaTheme", function () { return $752dabd2bb034630$export$b5509123a248d3f3; });
// Temporary place to put themes.
// In the future these should be loaded from a database.
var $752dabd2bb034630$export$cd9fd31d4e88d2ee = /*#__PURE__*/ function(ThemeIds) {
    ThemeIds["default"] = "default";
    ThemeIds["Titan"] = "titan";
    ThemeIds["Phobos"] = "phobos";
    ThemeIds["Hyperion"] = "hyperion";
    ThemeIds["Mimas"] = "mimas";
    ThemeIds["Rana"] = "rana";
    ThemeIds["Deimos"] = "deimos";
    ThemeIds["Umbra"] = "umbra";
    ThemeIds["Brickhouse"] = "brickhouse";
    ThemeIds["Dakota"] = "dakota";
    return ThemeIds;
}({});
const $752dabd2bb034630$var$defaultLight = '#9E9E9E';
const $752dabd2bb034630$var$defaultMid = '#1D1D1D';
const $752dabd2bb034630$var$defaultDark = '#0c0c0cff';
const $752dabd2bb034630$export$164de7ab8df77ef0 = {
    themeId: "default",
    loaded: false,
    fonts: {
        primary: 'ChakraPetchTitle',
        secondary: 'ChakraPetch',
        tertiary: 'ChakraPetch',
        quaternary: 'ChakraPetch'
    },
    files: {},
    tokens: {
        AriseTheme1RarityRarityCommonLight: '#7f8693ff',
        AriseTheme1RarityRarityCommonMid: '#292f3aff',
        AriseTheme1RarityRarityCommonDark: '#1c2129ff',
        AriseTheme1RarityRarityUncommonLight: '#8fff97ff',
        AriseTheme1RarityRarityUncommonMid: '#265d3fff',
        AriseTheme1RarityRarityUncommonDark: '#12251bff',
        AriseTheme1RarityRarityRareLight: '#a7f0feff',
        AriseTheme1RarityRarityRareMid: '#19646fff',
        AriseTheme1RarityRarityRareDark: '#0e2f34ff',
        AriseTheme1RarityRarityEpicLight: '#e569fbff',
        AriseTheme1RarityRarityEpicMid: '#582f59ff',
        AriseTheme1RarityRarityEpicDark: '#3a1f3bff',
        AriseTheme1RarityRarityLegendaryLight: '#fd8917ff',
        AriseTheme1RarityRarityLegendaryMid: '#803e18ff',
        AriseTheme1RarityRarityLegendaryDark: '#40210fff',
        AriseTheme1StateStateErrorLight: $752dabd2bb034630$var$defaultLight,
        AriseTheme1StateStateErrorMid: $752dabd2bb034630$var$defaultMid,
        AriseTheme1StateStateErrorDark: $752dabd2bb034630$var$defaultDark,
        AriseTheme1StateStateSuccessLight: $752dabd2bb034630$var$defaultLight,
        AriseTheme1StateStateSuccessMid: $752dabd2bb034630$var$defaultMid,
        AriseTheme1StateStateSuccessDark: $752dabd2bb034630$var$defaultDark,
        AriseTheme1StateStateDefaultLight: $752dabd2bb034630$var$defaultLight,
        AriseTheme1StateStateDefaultMid: $752dabd2bb034630$var$defaultMid,
        AriseTheme1StateStateDefaultDark: $752dabd2bb034630$var$defaultDark,
        AriseTheme1UpdatesUpdatesPositiveLight: $752dabd2bb034630$var$defaultLight,
        AriseTheme1UpdatesUpdatesPositiveMid: $752dabd2bb034630$var$defaultMid,
        AriseTheme1UpdatesUpdatesPositiveDark: $752dabd2bb034630$var$defaultDark,
        AriseTheme1UpdatesUpdatesGeneralLight: $752dabd2bb034630$var$defaultLight,
        AriseTheme1UpdatesUpdatesGeneralMid: $752dabd2bb034630$var$defaultMid,
        AriseTheme1UpdatesUpdatesGeneralDark: $752dabd2bb034630$var$defaultDark,
        AriseTheme1UpdatesUpdatesAchievementLight: $752dabd2bb034630$var$defaultLight,
        AriseTheme1UpdatesUpdatesAchievementMid: $752dabd2bb034630$var$defaultMid,
        AriseTheme1UpdatesUpdatesAchievementDark: $752dabd2bb034630$var$defaultDark,
        AriseTheme1UpdatesUpdatesNegativeLight: $752dabd2bb034630$var$defaultLight,
        AriseTheme1UpdatesUpdatesNegativeMid: $752dabd2bb034630$var$defaultMid,
        AriseTheme1UpdatesUpdatesNegativeDark: $752dabd2bb034630$var$defaultDark,
        AccentTheme1InterfaceMonoInterfaceMonoWhite: '#ffffffff',
        AccentTheme1InterfaceMonoInterfaceMonoActive: '#bdbdbdff',
        AccentTheme1InterfaceMonoInterfaceMonoForeground: '#797979',
        AccentTheme1InterfaceMonoInterfaceMonoMidground: '#1b1b1bff',
        AccentTheme1InterfaceMonoInterfaceMonoBackground: '#111111',
        AccentTheme1InterfaceMonoInterfaceMonoBlack: '#000000ff',
        AccentTheme1InterfaceBrandInterfaceActive: '#a8a8a8ff',
        AccentTheme1InterfaceBrandInterfaceForeground: '#797979',
        AccentTheme1InterfaceBrandInterfaceMidground: '#313131',
        AccentTheme1InterfaceBrandInterfaceBackground: '#111111',
        AccentTheme1BorderBorderDefault: '#9b9b9bff',
        AccentTheme1BorderBorderHighlight: '#c4c4c4ff',
        AccentTheme1BorderBorderInactive: '#5c5c5cff',
        AccentTheme1BorderBorderActive: '#d8d8d8ff',
        AccentTheme1BrandPaletteBrandAccent1: '#b3b3b3ff',
        AccentTheme1BrandPaletteBrandAccent2: '#262626',
        AccentTheme1BrandPaletteBrandContrast1: '#a0a0a0ff',
        AccentTheme1BrandPaletteBrandContrast2: '#8b8b8bff',
        AccentTheme1BrandPaletteBrandScale1: '#adadadff',
        AccentTheme1BrandPaletteBrandScale2: '#878787ff',
        AccentTheme1BrandPaletteBrandScale3: '#3f3f3fff',
        AccentTheme1BrandPaletteBrandColour: '#262626',
        AccentTheme1BrandPaletteBrandColourContrast: '#ffffffff',
        AccentTheme1ButtonButtonDefault: '#313131',
        AccentTheme1ButtonButtonHighlight: '#565656ff',
        AccentTheme1ButtonButtonActive: '#b7b7b7ff',
        AccentTheme1ButtonButtonInactive: '#545454ff',
        AccentTheme1ButtonButtonSecondaryDefault: '#666666',
        AccentTheme1ButtonButtonSecondaryHighlight: '#b5b5b5ff',
        AccentTheme1ButtonButtonSecondaryActive: '#c4c4c4ff',
        AccentTheme1ButtonButtonSecondaryInactive: '#3f3f3fff',
        AccentTheme1TextTextDefault: '#ffffffff',
        AccentTheme1TextTextInactive: '#797979',
        AccentTheme1TextTextBrand2: '#999999ff',
        AccentTheme1TextTextBrand1: '#9b9b9bff',
        AccentTheme1TextTextContrastDefault: '#151515ff',
        AccentTheme1TextTextLink: '#878787ff',
        // LEGACY
        LEGACYAccentTheme1ButtonButtonSecondary: '#3a3a3aff',
        LEGACYAccentTheme1TextTextActive: '#ffffffff',
        LEGACYAccentTheme1TextTextSecondary: '#9d9d9dff',
        LEGACYAccentTheme1InterfaceInterfaceActive: '#9d9d9dff',
        LEGACYAccentTheme1InterfaceInterfaceForeground: '#2a2a2aff',
        LEGACYAccentTheme1InterfaceInterfaceMidground: '#141414ff',
        LEGACYAccentTheme1InterfaceInterfaceBackground: '#0f0f0fff',
        LEGACYAccentTheme1InterfaceInterfaceWhite: '#ffffffff',
        LEGACYAccentTheme1InterfaceInterfaceGrey: '#828282ff',
        LEGACYAccentTheme1InterfaceInterfaceBlack: '#0b0b0bff',
        LEGACYAccentTheme1BrandColour: '#8c8c8cff',
        LEGACYAccentTheme1BrandColourContrast: '#0b0b0bff'
    },
    customJSON: {}
};
const $752dabd2bb034630$export$a53e903714f41d6f = {
    ...$752dabd2bb034630$export$164de7ab8df77ef0,
    themeId: "titan",
    fonts: {
        primary: 'CheapSignage',
        secondary: 'Alexandria',
        tertiary: 'Inter',
        quaternary: 'Oswald'
    },
    tokens: {
        ...$752dabd2bb034630$export$164de7ab8df77ef0.tokens,
        AccentTheme1InterfaceMonoInterfaceMonoWhite: '#ffffffff',
        AccentTheme1InterfaceMonoInterfaceMonoActive: '#d7d7d7ff',
        AccentTheme1InterfaceMonoInterfaceMonoForeground: '#a5a5a5ff',
        AccentTheme1InterfaceMonoInterfaceMonoMidground: '#2c2c2cff',
        AccentTheme1InterfaceMonoInterfaceMonoBackground: '#1b1b1bff',
        AccentTheme1InterfaceMonoInterfaceMonoBlack: '#000000ff',
        AccentTheme1InterfaceBrandInterfaceActive: '#BCA8A8',
        AccentTheme1InterfaceBrandInterfaceForeground: '#796262',
        AccentTheme1InterfaceBrandInterfaceMidground: '#2A2E36',
        AccentTheme1InterfaceBrandInterfaceBackground: '#0F0F0F',
        AccentTheme1BorderBorderDefault: '#8e1f22ff',
        AccentTheme1BorderBorderHighlight: '#f02d32ff',
        AccentTheme1BorderBorderInactive: '#690508ff',
        AccentTheme1BorderBorderActive: '#fb3b40ff',
        AccentTheme1BrandPaletteBrandAccent1: '#d42126ff',
        AccentTheme1BrandPaletteBrandAccent2: '#d42126ff',
        AccentTheme1BrandPaletteBrandContrast1: '#93b6c6ff',
        AccentTheme1BrandPaletteBrandContrast2: '#57b4ddff',
        AccentTheme1BrandPaletteBrandScale1: '#d4a98aff',
        AccentTheme1BrandPaletteBrandScale2: '#a77e61ff',
        AccentTheme1BrandPaletteBrandScale3: '#3f3128ff',
        AccentTheme1BrandPaletteBrandColour: '#d42126ff',
        AccentTheme1BrandPaletteBrandColourContrast: '#ffffffff',
        AccentTheme1ButtonButtonDefault: '#d42126ff',
        AccentTheme1ButtonButtonHighlight: '#ff604bff',
        AccentTheme1ButtonButtonActive: '#ff2e00ff',
        AccentTheme1ButtonButtonInactive: '#3f1f1fff',
        AccentTheme1ButtonButtonSecondaryDefault: '#a7a7a7ff',
        AccentTheme1ButtonButtonSecondaryHighlight: '#cececeff',
        AccentTheme1ButtonButtonSecondaryActive: '#d8d8d8ff',
        AccentTheme1ButtonButtonSecondaryInactive: '#505050ff',
        AccentTheme1TextTextDefault: '#ffffffff',
        AccentTheme1TextTextInactive: '#505050ff',
        AccentTheme1TextTextBrand2: '#ca8e54ff',
        AccentTheme1TextTextBrand1: '#ff473bff',
        AccentTheme1TextTextContrastDefault: '#151515ff',
        AccentTheme1TextTextLink: '#a5a5a5ff',
        // LEGACY
        LEGACYAccentTheme1ButtonButtonSecondary: '#dcdcdcff',
        LEGACYAccentTheme1TextTextActive: '#ffffffff',
        LEGACYAccentTheme1TextTextSecondary: '#dcdcdcff',
        LEGACYAccentTheme1InterfaceInterfaceActive: '#ffffffff',
        LEGACYAccentTheme1InterfaceInterfaceForeground: '#3d3d3dff',
        LEGACYAccentTheme1InterfaceInterfaceMidground: '#1e1e1eff',
        LEGACYAccentTheme1InterfaceInterfaceBackground: '#151515ff',
        LEGACYAccentTheme1InterfaceInterfaceWhite: '#ffffffff',
        LEGACYAccentTheme1InterfaceInterfaceGrey: '#bdbdbdff',
        LEGACYAccentTheme1InterfaceInterfaceBlack: '#000000ff',
        LEGACYAccentTheme1BrandColour: '#e81f25ff',
        LEGACYAccentTheme1BrandColourContrast: '#ffffffff'
    }
};
const $752dabd2bb034630$export$dc830f52acce79df = {
    ...$752dabd2bb034630$export$164de7ab8df77ef0,
    themeId: "phobos",
    tokens: {
        ...$752dabd2bb034630$export$a53e903714f41d6f.tokens
    }
};
const $752dabd2bb034630$export$b90c99545b77fd72 = {
    ...$752dabd2bb034630$export$164de7ab8df77ef0,
    themeId: "hyperion",
    fonts: {
        ...$752dabd2bb034630$export$164de7ab8df77ef0.fonts,
        quaternary: 'HomePlanetBB'
    },
    tokens: {
        ...$752dabd2bb034630$export$164de7ab8df77ef0.tokens,
        AccentTheme1InterfaceMonoInterfaceMonoWhite: '#ffffffff',
        AccentTheme1InterfaceMonoInterfaceMonoActive: '#d7d7d7ff',
        AccentTheme1InterfaceMonoInterfaceMonoForeground: '#a5a5a5ff',
        AccentTheme1InterfaceMonoInterfaceMonoMidground: '#2c2c2cff',
        AccentTheme1InterfaceMonoInterfaceMonoBackground: '#1b1b1bff',
        AccentTheme1InterfaceMonoInterfaceMonoBlack: '#000000ff',
        AccentTheme1InterfaceBrandInterfaceActive: '#a8b2bcff',
        AccentTheme1InterfaceBrandInterfaceForeground: '#626b79ff',
        AccentTheme1InterfaceBrandInterfaceMidground: '#2a2e36ff',
        AccentTheme1InterfaceBrandInterfaceBackground: '#15191fff',
        AccentTheme1BorderBorderDefault: '#0ab4f3ff',
        AccentTheme1BorderBorderHighlight: '#2fc6ffff',
        AccentTheme1BorderBorderInactive: '#0d8ebfff',
        AccentTheme1BorderBorderActive: '#42c9fcff',
        AccentTheme1BrandPaletteBrandAccent1: '#00a0dcff',
        AccentTheme1BrandPaletteBrandAccent2: '#fbee23ff',
        AccentTheme1BrandPaletteBrandContrast1: '#ffffffff',
        AccentTheme1BrandPaletteBrandContrast2: '#000000ff',
        AccentTheme1BrandPaletteBrandScale1: '#5bd2ffff',
        AccentTheme1BrandPaletteBrandScale2: '#00a0dcff',
        AccentTheme1BrandPaletteBrandScale3: '#0c6485ff',
        AccentTheme1BrandPaletteBrandColour: '#00a0dcff',
        AccentTheme1BrandPaletteBrandColourContrast: '#ffffffff',
        AccentTheme1ButtonButtonDefault: '#00a0dcff',
        AccentTheme1ButtonButtonHighlight: '#0ab4f3ff',
        AccentTheme1ButtonButtonActive: '#00b9ffff',
        AccentTheme1ButtonButtonInactive: '#003447ff',
        AccentTheme1ButtonButtonSecondaryDefault: '#a7a7a7ff',
        AccentTheme1ButtonButtonSecondaryHighlight: '#cececeff',
        AccentTheme1ButtonButtonSecondaryActive: '#d8d8d8ff',
        AccentTheme1ButtonButtonSecondaryInactive: '#505050ff',
        AccentTheme1TextTextDefault: '#ffffffff',
        AccentTheme1TextTextInactive: '#505050ff',
        AccentTheme1TextTextBrand2: '#ca8e54ff',
        AccentTheme1TextTextBrand1: '#00a0dcff',
        AccentTheme1TextTextContrastDefault: '#151515ff',
        AccentTheme1TextTextLink: '#a5a5a5ff'
    }
};
const $752dabd2bb034630$export$82c5380410702a78 = {
    ...$752dabd2bb034630$export$164de7ab8df77ef0,
    themeId: "mimas",
    tokens: {
        ...$752dabd2bb034630$export$164de7ab8df77ef0.tokens,
        AccentTheme1ButtonButtonDefault: '#FF6A00',
        AccentTheme1BrandPaletteBrandColour: '#FF6A00',
        AccentTheme1BrandPaletteBrandAccent1: '#FFAA01',
        AriseTheme1UpdatesUpdatesPositiveLight: '#CCCCCC',
        AriseTheme1UpdatesUpdatesPositiveMid: '#555555',
        AriseTheme1UpdatesUpdatesPositiveDark: '#0E0E0E',
        AriseTheme1UpdatesUpdatesGeneralLight: '#FFFFFF',
        AriseTheme1UpdatesUpdatesGeneralMid: '#909090',
        AriseTheme1UpdatesUpdatesGeneralDark: '#6B6B6B',
        AriseTheme1UpdatesUpdatesAchievementLight: '#FFEADA',
        AriseTheme1UpdatesUpdatesAchievementMid: '#FF6A00',
        AriseTheme1UpdatesUpdatesAchievementDark: '#A44400',
        AriseTheme1UpdatesUpdatesNegativeLight: '#FC3232',
        AriseTheme1UpdatesUpdatesNegativeMid: '#7F0B10',
        AriseTheme1UpdatesUpdatesNegativeDark: '#200506',
        AriseTheme1StateStateErrorLight: '#FFFFFF',
        AriseTheme1StateStateErrorMid: '#909090',
        AriseTheme1StateStateErrorDark: '#6B6B6B',
        AriseTheme1StateStateSuccessLight: '#CCCCCC',
        AriseTheme1StateStateSuccessMid: '#0E0E0E',
        AriseTheme1StateStateSuccessDark: '#0E0E0E'
    }
};
const $752dabd2bb034630$export$619f3429ba3f527d = {
    ...$752dabd2bb034630$export$164de7ab8df77ef0,
    themeId: "rana"
};
const $752dabd2bb034630$export$51184b5f01eae579 = {
    ...$752dabd2bb034630$export$164de7ab8df77ef0,
    themeId: "deimos"
};
const $752dabd2bb034630$export$3e0b756d8b9d706e = {
    ...$752dabd2bb034630$export$164de7ab8df77ef0,
    themeId: "umbra",
    tokens: {
        ...$752dabd2bb034630$export$164de7ab8df77ef0.tokens,
        AccentTheme1InterfaceBrandInterfaceForeground: '#223757ff',
        AccentTheme1InterfaceBrandInterfaceMidground: '#0D2322',
        AccentTheme1InterfaceBrandInterfaceBackground: '#001614',
        AccentTheme1InterfaceMonoInterfaceMonoBackground: '#0D2322',
        AccentTheme1InterfaceMonoInterfaceMonoMidground: '#0D2322',
        AccentTheme1ButtonButtonDefault: '#194543ff',
        AccentTheme1ButtonButtonHighlight: '#0D2322',
        AccentTheme1TextTextDefault: '#ffffffff',
        AccentTheme1BrandPaletteBrandAccent1: '#79DBD6',
        AccentTheme1BrandPaletteBrandColour: '#0D2322',
        AriseTheme1UpdatesUpdatesPositiveLight: '#4390C0',
        AriseTheme1UpdatesUpdatesPositiveMid: '#20394C',
        AriseTheme1UpdatesUpdatesPositiveDark: '#0F1922',
        AriseTheme1UpdatesUpdatesGeneralLight: '#4FA5A2',
        AriseTheme1UpdatesUpdatesGeneralMid: '#274B4C',
        AriseTheme1UpdatesUpdatesGeneralDark: '#0D2322',
        AriseTheme1UpdatesUpdatesAchievementLight: '#79DBD6',
        AriseTheme1UpdatesUpdatesAchievementMid: '#274B4C',
        AriseTheme1UpdatesUpdatesAchievementDark: '#0D2322',
        AriseTheme1UpdatesUpdatesNegativeLight: '#FC3232',
        AriseTheme1UpdatesUpdatesNegativeMid: '#7F0B10',
        AriseTheme1UpdatesUpdatesNegativeDark: '#200506',
        AriseTheme1StateStateErrorLight: '#B55E5D',
        AriseTheme1StateStateErrorMid: '#351D1D',
        AriseTheme1StateStateErrorDark: '#180F0F',
        AriseTheme1StateStateSuccessLight: '#81CFCE',
        AriseTheme1StateStateSuccessMid: '#274B4C',
        AriseTheme1StateStateSuccessDark: '#0D2322',
        AriseTheme1StateStateDefaultLight: '#4390C0',
        AriseTheme1StateStateDefaultMid: '#20394C',
        AriseTheme1StateStateDefaultDark: '#0F1922'
    }
};
const $752dabd2bb034630$export$2bfc74427d664a08 = {
    ...$752dabd2bb034630$export$164de7ab8df77ef0,
    themeId: "brickhouse"
};
const $752dabd2bb034630$export$b5509123a248d3f3 = {
    ...$752dabd2bb034630$export$164de7ab8df77ef0,
    themeId: "dakota"
};

});

parcelRegister("9K8Jg", function(module, exports) {

$parcel$export(module.exports, "setAuthToken", function () { return $332d6765d8d9e7cf$export$3c4602e16d9ace38; });
$parcel$export(module.exports, "getAuthToken", function () { return $332d6765d8d9e7cf$export$38e1f53b76ec7fed; });
$parcel$export(module.exports, "setUniverseID", function () { return $332d6765d8d9e7cf$export$a40109d413fb54d2; });
$parcel$export(module.exports, "register", function () { return $332d6765d8d9e7cf$export$6503ec6e8aabbaf; });
$parcel$export(module.exports, "createProfile", function () { return $332d6765d8d9e7cf$export$6660b028f5be10a7; });
$parcel$export(module.exports, "editProfile", function () { return $332d6765d8d9e7cf$export$b48a0400035b8336; });
$parcel$export(module.exports, "setUserCurrentAsset", function () { return $332d6765d8d9e7cf$export$23b525d73e27f867; });
$parcel$export(module.exports, "unsetUserCurrentAsset", function () { return $332d6765d8d9e7cf$export$ca16a15978424500; });
$parcel$export(module.exports, "addProfileTitle", function () { return $332d6765d8d9e7cf$export$9dfcfbbdda3e8151; });
$parcel$export(module.exports, "addProfileBadge", function () { return $332d6765d8d9e7cf$export$9190de6d98541d88; });
$parcel$export(module.exports, "setProfileTitle", function () { return $332d6765d8d9e7cf$export$982894037bdd2b82; });
$parcel$export(module.exports, "setProfileFaction", function () { return $332d6765d8d9e7cf$export$63f1075dd6373efe; });
$parcel$export(module.exports, "login", function () { return $332d6765d8d9e7cf$export$596d806903d1f59e; });
$parcel$export(module.exports, "loginAsGuest", function () { return $332d6765d8d9e7cf$export$cac7a67f197c8403; });
$parcel$export(module.exports, "oAuthExchange", function () { return $332d6765d8d9e7cf$export$61e4f6c18a9ae3d3; });
$parcel$export(module.exports, "passwordChange", function () { return $332d6765d8d9e7cf$export$4f6a6a61ca2ea38; });
$parcel$export(module.exports, "me", function () { return $332d6765d8d9e7cf$export$3e32638432616b6; });
$parcel$export(module.exports, "getAreas", function () { return $332d6765d8d9e7cf$export$67b1a98bf17825a2; });
$parcel$export(module.exports, "getLocations", function () { return $332d6765d8d9e7cf$export$c07c686062478869; });
$parcel$export(module.exports, "getRegions", function () { return $332d6765d8d9e7cf$export$14682eeac6801e56; });
$parcel$export(module.exports, "getBackgrounds", function () { return $332d6765d8d9e7cf$export$4ca6af37edce589f; });
$parcel$export(module.exports, "getCharacters", function () { return $332d6765d8d9e7cf$export$1a274d8250f0d7c4; });
$parcel$export(module.exports, "getFactions", function () { return $332d6765d8d9e7cf$export$dc78d06890d2a1b4; });
$parcel$export(module.exports, "getFactionSettings", function () { return $332d6765d8d9e7cf$export$21f920853926909c; });
$parcel$export(module.exports, "getSceneSelectorSettings", function () { return $332d6765d8d9e7cf$export$1665209a71d448bd; });
$parcel$export(module.exports, "getProfiles", function () { return $332d6765d8d9e7cf$export$585c1c8d79d3e628; });
$parcel$export(module.exports, "getCurrentUserProfileV2", function () { return $332d6765d8d9e7cf$export$eb34882c86121926; });
$parcel$export(module.exports, "getAvailableTitles", function () { return $332d6765d8d9e7cf$export$1ad62c2a69d5bd2; });
$parcel$export(module.exports, "getAvailableBadges", function () { return $332d6765d8d9e7cf$export$4b8380d51d91c627; });
$parcel$export(module.exports, "setProfileMissionCompleted", function () { return $332d6765d8d9e7cf$export$b71e06acfb528d9e; });
$parcel$export(module.exports, "resetProfileMissionCompleted", function () { return $332d6765d8d9e7cf$export$3db22106dcbe396f; });
$parcel$export(module.exports, "resetProfileBadges", function () { return $332d6765d8d9e7cf$export$a4b2cc08ab31359a; });
$parcel$export(module.exports, "resetProfileTitles", function () { return $332d6765d8d9e7cf$export$4634c4b4f068f3e6; });
$parcel$export(module.exports, "logout", function () { return $332d6765d8d9e7cf$export$a0973bcfe11b05c9; });
$parcel$export(module.exports, "lastChats", function () { return $332d6765d8d9e7cf$export$cafaddd023065ca3; });
$parcel$export(module.exports, "sendMessage", function () { return $332d6765d8d9e7cf$export$465cb47180de50f0; });
$parcel$export(module.exports, "sendCommand", function () { return $332d6765d8d9e7cf$export$73568989eb8fa899; });
$parcel$export(module.exports, "getUniverseMetadata", function () { return $332d6765d8d9e7cf$export$ce7a1c7c49373e0f; });
$parcel$export(module.exports, "getInventory", function () { return $332d6765d8d9e7cf$export$49d4f2709aaa7675; });
$parcel$export(module.exports, "takeItem", function () { return $332d6765d8d9e7cf$export$6cf716400a40251e; });
$parcel$export(module.exports, "dropItem", function () { return $332d6765d8d9e7cf$export$c52897da6060f038; });
$parcel$export(module.exports, "toggleMessageReaction", function () { return $332d6765d8d9e7cf$export$374ea87e421dfcbd; });
$parcel$export(module.exports, "listReactionTypes", function () { return $332d6765d8d9e7cf$export$1d06f08a48d351a6; });
$parcel$export(module.exports, "getArisewareState", function () { return $332d6765d8d9e7cf$export$64134de32d67ad9c; });
$parcel$export(module.exports, "updateArisewareState", function () { return $332d6765d8d9e7cf$export$d09d18a35643cf7e; });
$parcel$export(module.exports, "failedAriseware", function () { return $332d6765d8d9e7cf$export$21f38724403a0b93; });
$parcel$export(module.exports, "submitArisewareScore", function () { return $332d6765d8d9e7cf$export$2ffd3871cec7b2d9; });
$parcel$export(module.exports, "submitFeedUpdate", function () { return $332d6765d8d9e7cf$export$e36b950b6d863b55; });
$parcel$export(module.exports, "getEventById", function () { return $332d6765d8d9e7cf$export$d89643108630328f; });
$parcel$export(module.exports, "tokenExchange", function () { return $332d6765d8d9e7cf$export$bbbf59fcba7cc7a5; });
$parcel$export(module.exports, "heartbeat", function () { return $332d6765d8d9e7cf$export$cae72505676c6ee7; });
$parcel$export(module.exports, "scrollV2", function () { return $332d6765d8d9e7cf$export$2e87daf0acb6f156; });
$parcel$export(module.exports, "getInstanceData", function () { return $332d6765d8d9e7cf$export$4fa9bff493b99b77; });
$parcel$export(module.exports, "getMyRewards", function () { return $332d6765d8d9e7cf$export$efe4bc025efd1f61; });
$parcel$export(module.exports, "claimReward", function () { return $332d6765d8d9e7cf$export$7937faec174ccea3; });
$parcel$export(module.exports, "getRewardStatus", function () { return $332d6765d8d9e7cf$export$893f7af4106507ab; });
$parcel$export(module.exports, "getNewsTickerData", function () { return $332d6765d8d9e7cf$export$589937ab777fd063; });
$parcel$export(module.exports, "getTranslations", function () { return $332d6765d8d9e7cf$export$a7e3aedd9ea505f2; });
$parcel$export(module.exports, "userEvent", function () { return $332d6765d8d9e7cf$export$654456eab607fa62; });
$parcel$export(module.exports, "getPollData", function () { return $332d6765d8d9e7cf$export$1bbe11425004cf13; });
$parcel$export(module.exports, "submitPollVote", function () { return $332d6765d8d9e7cf$export$6ce1780c266b47d2; });
$parcel$export(module.exports, "getGenericLeaderboardData", function () { return $332d6765d8d9e7cf$export$c32ea153aed7ef7c; });
$parcel$export(module.exports, "submitScore", function () { return $332d6765d8d9e7cf$export$22f3e7e7d561b982; });
$parcel$export(module.exports, "getLeaderboard", function () { return $332d6765d8d9e7cf$export$a432f328c781673f; });

var $lmedS = parcelRequire("lmedS");

var $k3RPz = parcelRequire("k3RPz");

var $dS0He = parcelRequire("dS0He");

var $f9UtO = parcelRequire("f9UtO");

var $2Yr2D = parcelRequire("2Yr2D");

var $cTs7K = parcelRequire("cTs7K");

var $2zDIY = parcelRequire("2zDIY");
const $332d6765d8d9e7cf$var$API_HOST = (0, $cTs7K.IS_DISCORD_ACTIVITY) ? '/.proxy/api' : "https://api.ariseworlds.com";
const $332d6765d8d9e7cf$var$STATIC_DATA_HOST = (0, $cTs7K.IS_DISCORD_ACTIVITY) ? '/.proxy/static-data' : "https://static-data.ariseworlds.com";
const $332d6765d8d9e7cf$var$LOCAL_FILE_PREFIX = (0, $cTs7K.IS_DISCORD_ACTIVITY) ? '/.proxy' : '';
const $332d6765d8d9e7cf$var$AUTHTOKEN_KEY = 'ARISEENGINE_AUTHTOKEN';
let $332d6765d8d9e7cf$var$authToken = '';
let $332d6765d8d9e7cf$var$currentUserId = '';
let $332d6765d8d9e7cf$var$universeID = window.localStorage.getItem('ARISE_UNIVERSEID') || "9097f2ba-ec9e-48b1-82af-0080acd3924e";
(0, $f9UtO.manageTokenExpiry)();
if (typeof window !== 'undefined') {
    $332d6765d8d9e7cf$var$authToken = window.localStorage.getItem($332d6765d8d9e7cf$var$AUTHTOKEN_KEY) || '';
    $332d6765d8d9e7cf$var$setCurrentUserId();
}
function $332d6765d8d9e7cf$export$3c4602e16d9ace38(token) {
    if (!token || !(0, $f9UtO.isJWTFormat)(token)) {
        console.warn('Tried to call setAuthToken with an invalid or incorrectly formatted token:', token);
        return;
    }
    $332d6765d8d9e7cf$var$authToken = token;
    window.localStorage.setItem($332d6765d8d9e7cf$var$AUTHTOKEN_KEY, token);
    // manageTokenExpiry();
    $332d6765d8d9e7cf$var$setCurrentUserId();
}
function $332d6765d8d9e7cf$var$setCurrentUserId() {
    try {
        const data = (0, $f9UtO.getTokenPayload)($332d6765d8d9e7cf$var$authToken);
        $332d6765d8d9e7cf$var$currentUserId = data.sub || '';
    } catch (error) {}
}
function $332d6765d8d9e7cf$export$38e1f53b76ec7fed() {
    return $332d6765d8d9e7cf$var$authToken;
}
function $332d6765d8d9e7cf$export$a40109d413fb54d2(id) {
    $332d6765d8d9e7cf$var$universeID = id;
}
async function $332d6765d8d9e7cf$export$6503ec6e8aabbaf(email, password, turnstileToken) {
    const body = {
        email: email,
        password: password,
        turnstileToken: turnstileToken
    };
    return await $332d6765d8d9e7cf$var$call('/register', 'POST', body);
}
async function $332d6765d8d9e7cf$export$6660b028f5be10a7(body) {
    return await $332d6765d8d9e7cf$var$call('/profile/new', 'POST', body);
}
async function $332d6765d8d9e7cf$export$b48a0400035b8336(profileId, body) {
    return await $332d6765d8d9e7cf$var$call(`/profile/${profileId}`, 'PUT', body);
}
async function $332d6765d8d9e7cf$export$23b525d73e27f867(assetType, assetID) {
    const body = {
        universeID: $332d6765d8d9e7cf$var$universeID,
        assetID: assetID,
        assetType: assetType
    };
    return await $332d6765d8d9e7cf$var$call(`/userCurrentAssets`, 'POST', body);
}
async function $332d6765d8d9e7cf$export$ca16a15978424500(assetType) {
    const body = {
        universeID: $332d6765d8d9e7cf$var$universeID,
        assetType: assetType
    };
    return await $332d6765d8d9e7cf$var$call(`/userCurrentAssets`, 'DELETE', body);
}
async function $332d6765d8d9e7cf$export$9dfcfbbdda3e8151(id) {
    const body = {
        id: id
    };
    if ($332d6765d8d9e7cf$var$authToken) return await $332d6765d8d9e7cf$var$call('/profileTitle/add', 'POST', body);
}
async function $332d6765d8d9e7cf$export$9190de6d98541d88(rank) {
    const body = {
        rank: rank
    };
    if ($332d6765d8d9e7cf$var$authToken) return await $332d6765d8d9e7cf$var$call('/profileBadge/add', 'POST', body);
}
async function $332d6765d8d9e7cf$export$982894037bdd2b82(id) {
    const body = {
        id: id
    };
    return await $332d6765d8d9e7cf$var$call('/profileTitle/set', 'PUT', body);
}
async function $332d6765d8d9e7cf$export$63f1075dd6373efe(factionID) {
    const body = {
        factionID: factionID
    };
    return await $332d6765d8d9e7cf$var$call('/userFaction', 'PUT', body);
}
async function $332d6765d8d9e7cf$export$596d806903d1f59e(email, password) {
    const body = {
        email: email,
        password: password
    };
    const res = await $332d6765d8d9e7cf$var$call('/login', 'POST', body);
    $332d6765d8d9e7cf$export$3c4602e16d9ace38(res.authToken);
}
async function $332d6765d8d9e7cf$export$cac7a67f197c8403() {
    const res = await $332d6765d8d9e7cf$var$call('/login/guest', 'POST');
    $332d6765d8d9e7cf$export$3c4602e16d9ace38(res.authToken);
}
async function $332d6765d8d9e7cf$export$61e4f6c18a9ae3d3(token) {
    const res = await $332d6765d8d9e7cf$var$call(`/auth/oauth/exchange`, 'POST', {
        token: token
    });
    $332d6765d8d9e7cf$export$3c4602e16d9ace38(res.authToken);
}
async function $332d6765d8d9e7cf$export$ee2fcf8e7aed6a8(email) {
    await $332d6765d8d9e7cf$var$call(`/auth/password-reset`, 'POST', {
        email: email
    });
}
async function $332d6765d8d9e7cf$export$4f6a6a61ca2ea38(email, token, password) {
    await $332d6765d8d9e7cf$var$call(`/auth/password-change`, 'POST', {
        email: email,
        token: token,
        password: password
    });
}
async function $332d6765d8d9e7cf$export$3e32638432616b6() {
    try {
        const res = await $332d6765d8d9e7cf$var$call('/me', 'GET');
        return res;
    } catch (error) {
        throw error;
    }
}
async function $332d6765d8d9e7cf$var$call(path, method, body, apiHostOverride) {
    const apiHost = apiHostOverride ?? $332d6765d8d9e7cf$var$API_HOST;
    const additionalHeaders = {};
    let response = await fetch(`${apiHost}${path}`, {
        method: method,
        body: body ? JSON.stringify(body) : undefined,
        headers: {
            'Content-Type': 'application/json',
            'X-Auth-Token': $332d6765d8d9e7cf$var$authToken,
            'X-Universe-ID': $332d6765d8d9e7cf$var$universeID,
            ...additionalHeaders
        }
    });
    if (!response.ok) {
        // Try to parse the error code from the response body
        let errorMessage = 'UNKNOWN_ERROR'; // Fallback
        try {
            const errorBody = await response.json();
            errorMessage = errorBody.errorCode ?? 'UNKNOWN_ERROR';
        } catch  {}
        throw new Error(errorMessage);
    }
    return await response.json();
}
async function $332d6765d8d9e7cf$var$callStatic(path) {
    try {
        let response = await fetch(`${$332d6765d8d9e7cf$var$STATIC_DATA_HOST}/${$332d6765d8d9e7cf$var$universeID}-${path}`, {
            method: 'GET'
        });
        if (!response.ok) throw new Error('UNKNOWN_ERROR');
        return await response.json();
    } catch (error) {
        console.log(`Static data missing or invalid: /staticData/${path}`);
        throw new Error('UNKNOWN_ERROR');
    }
}
async function $332d6765d8d9e7cf$var$callPath(path) {
    try {
        let response = await fetch(`${$332d6765d8d9e7cf$var$LOCAL_FILE_PREFIX}/${path}`, {
            method: 'GET'
        });
        if (!response.ok) throw new Error('UNKNOWN_ERROR');
        return await response.json();
    } catch (error) {
        console.error(`Could not call path ${path}`);
        throw new Error('UNKNOWN_ERROR');
    }
}
function $332d6765d8d9e7cf$var$sendBeaconWithFallback(path, data, apiHostOverride) {
    const apiHost = apiHostOverride ?? $332d6765d8d9e7cf$var$API_HOST;
    const url = `${apiHost}${path}`;
    const payload = JSON.stringify(data);
    try {
        if (!navigator?.sendBeacon) throw new Error('sendBeacon not supported');
        const ok = navigator.sendBeacon(url, payload);
        if (!ok) throw new Error('sendBeacon failed');
    } catch  {
        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'text/plain'
            },
            body: payload,
            keepalive: true
        }).catch(()=>{
        // Fail silently
        });
    }
}
// Make a request with a maximum timeout and default value
const $332d6765d8d9e7cf$var$withTimeout = async (request, timeoutMs, defaultValue)=>{
    const timeout = new Promise((resolve)=>setTimeout(()=>{
            resolve(defaultValue);
        }, timeoutMs));
    try {
        return await Promise.race([
            request,
            timeout
        ]);
    } catch  {
        return defaultValue;
    }
};
async function $332d6765d8d9e7cf$export$67b1a98bf17825a2(limit = 100) {
    return await $332d6765d8d9e7cf$var$call(`/area/list?universeID=${$332d6765d8d9e7cf$var$universeID}&limit=${limit}`, 'GET');
}
async function $332d6765d8d9e7cf$export$c07c686062478869() {
    let locations = await $332d6765d8d9e7cf$var$callStatic('locations.json');
    locations = (0, $lmedS.parsePayloadURLS)(locations);
    return locations.map((location)=>(0, $k3RPz.processLocationData)(location));
}
async function $332d6765d8d9e7cf$export$14682eeac6801e56(limit = 100) {
    return await $332d6765d8d9e7cf$var$call(`/region/list?universeID=${$332d6765d8d9e7cf$var$universeID}&limit=${limit}`, 'GET');
}
async function $332d6765d8d9e7cf$export$9f8fe36349548c9e() {
    return await $332d6765d8d9e7cf$var$call(`/userOwnedAssets`, 'GET');
}
async function $332d6765d8d9e7cf$export$4ca6af37edce589f() {
    return await $332d6765d8d9e7cf$var$call(`/background/list`, 'GET');
}
async function $332d6765d8d9e7cf$export$1a274d8250f0d7c4() {
    return await $332d6765d8d9e7cf$var$call(`/character/list`, 'GET');
}
async function $332d6765d8d9e7cf$export$f6d6ee07efc33b16() {
    return await $332d6765d8d9e7cf$var$call(`/avatarFrame/list`, 'GET');
}
async function $332d6765d8d9e7cf$export$dc78d06890d2a1b4() {
    return await $332d6765d8d9e7cf$var$call(`/faction/list`, 'GET');
}
async function $332d6765d8d9e7cf$export$21f920853926909c() {
    return await $332d6765d8d9e7cf$var$call(`/factionSettings/list`, 'GET');
}
async function $332d6765d8d9e7cf$export$1665209a71d448bd() {
    const res = await $332d6765d8d9e7cf$var$call(`/sceneSelectorSettings/list`, 'GET');
    return (0, $lmedS.parsePayloadURLS)(res);
}
async function $332d6765d8d9e7cf$export$585c1c8d79d3e628(userIds) {
    const params = userIds.map((userId)=>`id=${userId}`).join('&');
    const profiles = await $332d6765d8d9e7cf$var$call(`/profile/list?${params}`, 'GET');
    return profiles.map((profile)=>(0, $dS0He.processProfileData)(profile));
}
async function $332d6765d8d9e7cf$export$965b5fd3c89734c9(userId, forceUseRemoteData) {
    // Legacy
    const localTitles = await (0, $2Yr2D.getLocalUserTitles)();
    if (localTitles.length && !forceUseRemoteData) return localTitles;
    else {
        const id = userId || $332d6765d8d9e7cf$var$currentUserId; // If no user id passed in, try use local currentUserId
        if (!id) return localTitles;
        // If there are no local titles or forceUseRemoteData is true, try get remote titles
        const remoteTitles = await $332d6765d8d9e7cf$var$withTimeout($332d6765d8d9e7cf$var$call(`/profile/title/history/${id}`, 'GET'), 5000, []);
        if (Array.isArray(remoteTitles) && remoteTitles.length) {
            (0, $2Yr2D.setLocalUserTitles)(remoteTitles);
            return remoteTitles;
        }
        // If remote is empty or failed, return local
        return localTitles;
    }
}
async function $332d6765d8d9e7cf$export$eb34882c86121926() {
    // If localstorage version return that, otherwise return remote profile
    const localProfile = (0, $2zDIY.getProfileV2FromLocalStorage)();
    if (localProfile) return localProfile;
    if ($332d6765d8d9e7cf$var$currentUserId) {
        const remoteResponse = await $332d6765d8d9e7cf$var$withTimeout($332d6765d8d9e7cf$var$call(`/profiles/${$332d6765d8d9e7cf$var$currentUserId}`, 'GET'), 5000, null);
        return remoteResponse.profile;
    }
}
async function $332d6765d8d9e7cf$export$1ad62c2a69d5bd2() {
    const result = await $332d6765d8d9e7cf$var$callStatic('titleList.json');
    return (0, $dS0He.processTitles)(result);
}
async function $332d6765d8d9e7cf$export$4b8380d51d91c627() {
    return await $332d6765d8d9e7cf$var$callStatic('badges.json');
}
async function $332d6765d8d9e7cf$export$b71e06acfb528d9e() {
    return await $332d6765d8d9e7cf$var$call(`/profile/mission-completed`, 'POST');
}
async function $332d6765d8d9e7cf$export$3db22106dcbe396f() {
    return await $332d6765d8d9e7cf$var$call(`/profile/reset-mission-completed`, 'POST');
}
async function $332d6765d8d9e7cf$export$a4b2cc08ab31359a() {
    return await $332d6765d8d9e7cf$var$call(`/profile/reset-badges`, 'POST');
}
async function $332d6765d8d9e7cf$export$4634c4b4f068f3e6() {
    return await $332d6765d8d9e7cf$var$call(`/profile/reset-titles`, 'POST');
}
async function $332d6765d8d9e7cf$export$a0973bcfe11b05c9() {
    // TODO: call logout endpoint
    $332d6765d8d9e7cf$export$3c4602e16d9ace38('');
}
async function $332d6765d8d9e7cf$export$cafaddd023065ca3(locationId, from, num, isGlobalChat, isLatest) {
    // time is a unix timestamp in seconds, or 'latest' if first call
    const time = isLatest ? 'latest' : from || Math.ceil(Date.now() / 1000);
    num = num || (0, $cTs7K.FEED_MESSAGES_TO_LOAD);
    const messages = await $332d6765d8d9e7cf$var$call(`/chat/lastChats?locationID=${locationId}&time=${time}&num=${num}${isGlobalChat ? '&globalchat=true' : ''}`, 'GET');
    return messages.map((message)=>{
        if (message.data.profile) message.data.profile = (0, $dS0He.processProfileData)(message.data.profile);
        return message;
    });
}
async function $332d6765d8d9e7cf$export$465cb47180de50f0(locationId, message) {
    const body = {
        locationID: locationId,
        chatText: message
    };
    return await $332d6765d8d9e7cf$var$call(`/chat`, 'POST', body);
}
async function $332d6765d8d9e7cf$export$73568989eb8fa899(locationId, command) {
    const body = {
        environmentID: locationId,
        command: command
    };
    return await $332d6765d8d9e7cf$var$call(`/command`, 'POST', body);
}
async function $332d6765d8d9e7cf$export$ce7a1c7c49373e0f(universeId = $332d6765d8d9e7cf$var$universeID) {
    const res = await $332d6765d8d9e7cf$var$callStatic('universe.json');
    return (0, $lmedS.parsePayloadURLS)(res);
}
async function $332d6765d8d9e7cf$export$49d4f2709aaa7675() {
    const response = await $332d6765d8d9e7cf$var$call(`/inventory`, 'GET');
    const inventory = response.map((d)=>{
        return {
            id: d.id,
            itemId: d.item.id,
            name: d.item.name,
            description: d.item.description,
            inventoryThumbnailUrl: d.item.imagePath ? (0, $lmedS.pathToURL)(d.item.imagePath) : d.item.imageURL,
            customJson: d.item.customJson
        };
    });
    return inventory;
}
async function $332d6765d8d9e7cf$export$6cf716400a40251e(itemId) {
    return $332d6765d8d9e7cf$var$call(`/inventory`, 'POST', {
        universeID: $332d6765d8d9e7cf$var$universeID,
        itemID: itemId
    });
}
async function $332d6765d8d9e7cf$export$c52897da6060f038(inventoryItemId) {
    return $332d6765d8d9e7cf$var$call(`/inventory/${inventoryItemId}`, 'DELETE');
}
async function $332d6765d8d9e7cf$export$374ea87e421dfcbd(messageId, reaction, locationId) {
    return await $332d6765d8d9e7cf$var$call(`/reaction/toggle`, 'POST', {
        chatID: messageId,
        reaction: reaction,
        environmentID: locationId
    });
}
async function $332d6765d8d9e7cf$export$1d06f08a48d351a6() {
    return await $332d6765d8d9e7cf$var$call(`/reactions/list`, 'GET');
}
async function $332d6765d8d9e7cf$export$b7572a81e749f23f(messageId) {
    return await $332d6765d8d9e7cf$var$call(`/moderationActions/removeChat`, 'PUT', {
        ChatID: messageId
    });
}
async function $332d6765d8d9e7cf$export$79caefb11d80e008(userID, seconds, reason) {
    const bannedUntil = new Date(Date.now() + seconds * 1000).toISOString();
    return await $332d6765d8d9e7cf$var$call(`/moderationActions/ban`, 'POST', {
        userID: userID,
        bannedUntil: bannedUntil,
        reason: reason
    });
}
async function $332d6765d8d9e7cf$export$64134de32d67ad9c(projectId) {
    return await $332d6765d8d9e7cf$var$call(`/ariseware/state/${projectId}`, 'GET');
}
async function $332d6765d8d9e7cf$export$d09d18a35643cf7e(projectId, data) {
    return await $332d6765d8d9e7cf$var$call(`/ariseware/state/${projectId}`, 'PUT', data);
}
async function $332d6765d8d9e7cf$export$21f38724403a0b93(projectId) {
    // TODO: remove
    return new Promise((resolve)=>setTimeout(resolve, 1000));
// return await call<any>(`/ariseware/failed/${projectId}`, 'POST');
}
async function $332d6765d8d9e7cf$export$955dbe6c8b0c40c3(userId) {
    return await $332d6765d8d9e7cf$var$call(`/arisewareScore/${userId}`, 'GET');
}
async function $332d6765d8d9e7cf$export$2ffd3871cec7b2d9(data) {
    // Legacy
    return await $332d6765d8d9e7cf$var$call(`/arisewareScore`, 'PUT', data);
}
async function $332d6765d8d9e7cf$export$e36b950b6d863b55(locationId, id) {
    return await $332d6765d8d9e7cf$var$call(`/feedUpdate`, 'POST', {
        environmentID: locationId,
        id: id
    });
}
async function $332d6765d8d9e7cf$export$3c6a03b5f9aad8de(query) {
    return await $332d6765d8d9e7cf$var$call(`/profile/searchByDisplayName?query=${encodeURIComponent(query)}`, 'GET');
}
async function $332d6765d8d9e7cf$export$d89643108630328f(eventID) {
    return await $332d6765d8d9e7cf$var$call(`/chatEvent?eventID=${eventID}`, 'GET');
}
async function $332d6765d8d9e7cf$export$bbbf59fcba7cc7a5(token, source) {
    const res = await $332d6765d8d9e7cf$var$call(`/auth/tokenExchange`, 'POST', {
        token: token,
        source: source
    });
    $332d6765d8d9e7cf$export$3c4602e16d9ace38(res.ariseToken);
    return res;
}
let $332d6765d8d9e7cf$var$_heartbeat_has_joined = false;
async function $332d6765d8d9e7cf$export$cae72505676c6ee7(locationId) {
    if (!$332d6765d8d9e7cf$var$authToken) return;
    try {
        await $332d6765d8d9e7cf$var$call('/presence/heartbeat', 'POST', {
            environmentId: locationId,
            ...!$332d6765d8d9e7cf$var$_heartbeat_has_joined && {
                joinedLocation: true
            }
        });
        $332d6765d8d9e7cf$var$_heartbeat_has_joined = true;
    } catch (error) {
        console.warn('Failed to send heartbeat', error);
    }
}
async function $332d6765d8d9e7cf$export$209876d7b1ac8f3(data) {
    return await $332d6765d8d9e7cf$var$call(`/scroll`, 'POST', data);
}
async function $332d6765d8d9e7cf$export$2e87daf0acb6f156(data, useBeacon) {
    const PATH = '/scrollv2';
    if (useBeacon) $332d6765d8d9e7cf$var$sendBeaconWithFallback(PATH, data);
    else return await $332d6765d8d9e7cf$var$call(PATH, 'POST', data);
}
function $332d6765d8d9e7cf$export$4fa9bff493b99b77() {
    return {
        universeID: $332d6765d8d9e7cf$var$universeID,
        userAuthToken: $332d6765d8d9e7cf$var$authToken,
        apiHost: $332d6765d8d9e7cf$var$API_HOST
    };
}
async function $332d6765d8d9e7cf$export$bac712d3b6774391() {
    return await $332d6765d8d9e7cf$var$call(`/assetpack/list`, 'GET');
}
async function $332d6765d8d9e7cf$export$853594461ca82308() {
    return await $332d6765d8d9e7cf$var$call(`/shop/external`, 'GET');
}
async function $332d6765d8d9e7cf$export$f0d2d182751d3250(itemID, type) {
    let body = {
        items: [
            {
                type: type,
                id: itemID
            }
        ],
        redirectURL: window.location.href + '?checkout=true'
    };
    return await $332d6765d8d9e7cf$var$call('/shop/checkout', 'POST', body);
}
async function $332d6765d8d9e7cf$export$6f5cc5586c0c38b3(id) {
    return await $332d6765d8d9e7cf$var$call(`/shop/checkout/${id}`, 'GET');
}
async function $332d6765d8d9e7cf$export$efe4bc025efd1f61() {
    const response = await $332d6765d8d9e7cf$var$call(`/rewards`, 'GET');
    return response.rewards;
}
async function $332d6765d8d9e7cf$export$7937faec174ccea3(promotionId) {
    return await $332d6765d8d9e7cf$var$call(`/rewards/${promotionId}/claim`, 'POST');
}
async function $332d6765d8d9e7cf$export$893f7af4106507ab(promotionId) {
    return await $332d6765d8d9e7cf$var$call(`/rewards/${promotionId}/status`, 'GET');
}
async function $332d6765d8d9e7cf$export$46467cd6f4ed0eba() {
    return await $332d6765d8d9e7cf$var$call(`/modal/list`, 'GET');
}
// Supply run APIs
const $332d6765d8d9e7cf$var$SUPPLY_RUN_API_HOST = undefined;
async function $332d6765d8d9e7cf$export$2d40d82c3909ac8a() {
    return await $332d6765d8d9e7cf$var$call(`/supply-run/stats`, 'GET', null, $332d6765d8d9e7cf$var$SUPPLY_RUN_API_HOST);
}
async function $332d6765d8d9e7cf$export$1f95aa99543d6cd7(userID) {
    return await $332d6765d8d9e7cf$var$call(`/supply-run/user-profile-stats?userId=${userID}`, 'GET', null, $332d6765d8d9e7cf$var$SUPPLY_RUN_API_HOST);
}
async function $332d6765d8d9e7cf$export$589937ab777fd063() {
    return await $332d6765d8d9e7cf$var$callStatic('newsTicker.json');
}
async function $332d6765d8d9e7cf$export$a7e3aedd9ea505f2() {
    const response = (0, $lmedS.parsePayloadURLS)(await $332d6765d8d9e7cf$var$callStatic('translations.json'));
    return response;
}
async function $332d6765d8d9e7cf$export$654456eab607fa62(environmentID, eventType) {
    if ($332d6765d8d9e7cf$var$authToken) {
        const body = {
            environmentID: environmentID,
            eventType: eventType
        };
        return await $332d6765d8d9e7cf$var$call('/userEvents', 'POST', body);
    }
}
async function $332d6765d8d9e7cf$export$1bbe11425004cf13(id, numberOfResults = 5) {
    try {
        const res = await $332d6765d8d9e7cf$var$call(`/polls/${id}?numberOfResults=${numberOfResults}`, 'GET');
        return res;
    } catch (error) {
        console.error('Failed to fetch poll data', error);
        return $332d6765d8d9e7cf$var$fetchStaticData(`/${id}.json`);
    }
}
async function $332d6765d8d9e7cf$export$6ce1780c266b47d2(id, selectedOptionIds, numberOfResults = 5) {
    const body = {
        pollId: id,
        selectedOptionIds: selectedOptionIds
    };
    return await $332d6765d8d9e7cf$var$call(`/polls/${id}/votes?numberOfResults=${numberOfResults}`, 'POST', body);
}
async function $332d6765d8d9e7cf$var$fetchStaticData(path) {
    const data = await fetch($332d6765d8d9e7cf$var$STATIC_DATA_HOST + path).then((res)=>res.json()).catch(()=>null);
    return data;
}
async function $332d6765d8d9e7cf$export$c32ea153aed7ef7c() {
    return await $332d6765d8d9e7cf$var$call('/leaderboards', 'GET');
}
async function $332d6765d8d9e7cf$export$22f3e7e7d561b982(leaderboardId, score) {
    return await $332d6765d8d9e7cf$var$call(`/leaderboards/${leaderboardId}/submit`, 'POST', {
        score: score
    });
}
async function $332d6765d8d9e7cf$export$a432f328c781673f(leaderboardId) {
    return await $332d6765d8d9e7cf$var$call(`/leaderboards/${leaderboardId}`, 'GET');
}

});
parcelRegister("k3RPz", function(module, exports) {

$parcel$export(module.exports, "processLocationData", function () { return $a478ea3a8a1f6fb0$export$6bf8211c3d1a27a0; });
$parcel$export(module.exports, "isFeedOpen", function () { return $a478ea3a8a1f6fb0$export$258fc13dede33c6d; });

var $4r69E = parcelRequire("4r69E");
function $a478ea3a8a1f6fb0$export$6bf8211c3d1a27a0(location) {
    return {
        ...location,
        isOpen: $a478ea3a8a1f6fb0$export$1699291294853e2a(location),
        isFeedOpen: $a478ea3a8a1f6fb0$export$258fc13dede33c6d(location)
    };
}
function $a478ea3a8a1f6fb0$export$1699291294853e2a(location) {
    // Default to open if there is no opening time
    const isAfterOpeningTime = !location.opensTime || (0, $4r69E.msTimeDifferenceFromNow)(location.opensTime) <= 0;
    const isAfterClosingTime = location.closesTime && (0, $4r69E.msTimeDifferenceFromNow)(location.closesTime) <= 0;
    return isAfterOpeningTime && !isAfterClosingTime;
}
function $a478ea3a8a1f6fb0$export$258fc13dede33c6d(location) {
    // Default to open if there is no opening time
    const isAfterFeedOpeningTime = !location.feedOpensTime || (0, $4r69E.msTimeDifferenceFromNow)(location.feedOpensTime) <= 0;
    const isAfterFeedClosingTime = location.feedClosesTime && (0, $4r69E.msTimeDifferenceFromNow)(location.feedClosesTime) <= 0;
    return isAfterFeedOpeningTime && !isAfterFeedClosingTime;
}

});
parcelRegister("4r69E", function(module, exports) {

$parcel$export(module.exports, "msTimeDifferenceFromNow", function () { return $eb624fc41cd9f91c$export$f9df06a9562f6a5e; });
/**
 * Returns the time difference between an ISO date string and now
 * @param dateString example: 2023-12-27T15:05:00Z
 * @returns {number} number in ms
 */ function $eb624fc41cd9f91c$export$f9df06a9562f6a5e(dateString) {
    return new Date(dateString).getTime() - new Date().getTime();
}
function $eb624fc41cd9f91c$export$6e73a1cb7e512394(from, durationSeconds) {
    return Math.max(0, durationSeconds * 1000 - Math.floor(Date.now() - from));
}
function $eb624fc41cd9f91c$export$161d202e6e5e416c(dateString1, dateString2) {
    const time1 = new Date(dateString1).getTime();
    const time2 = new Date(dateString2).getTime();
    return Math.abs(time1 - time2);
}
const $eb624fc41cd9f91c$export$2e938eec3c826007 = 604800000;
function $eb624fc41cd9f91c$export$2728ca2f1217d22d(seconds) {
    if (seconds < 0) throw new Error('The number of seconds cannot be negative.');
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor(seconds % 3600 / 60);
    const secs = Math.floor(seconds % 60);
    const parts = [];
    if (hours > 0) parts.push(`${hours}h`);
    if (minutes > 0 || hours > 0 && secs > 0) parts.push(`${minutes}m`);
    if (secs > 0) parts.push(`${secs}s`);
    return parts.join(' ');
}

});


parcelRegister("dS0He", function(module, exports) {

$parcel$export(module.exports, "processProfileData", function () { return $1c9c8349850b32fc$export$4c7c5ef3bd60c5e1; });
$parcel$export(module.exports, "processTitles", function () { return $1c9c8349850b32fc$export$fbf4e217491106b1; });
$parcel$export(module.exports, "profileHasOnboarded", function () { return $1c9c8349850b32fc$export$93c3c111f074f9c1; });

var $9K8Jg = parcelRequire("9K8Jg");

var $4r69E = parcelRequire("4r69E");

var $lmedS = parcelRequire("lmedS");
function $1c9c8349850b32fc$export$4c7c5ef3bd60c5e1(profile) {
    return {
        ...profile,
        factionImageUrl: (0, $lmedS.pathToURL)(profile.faction.imagePath),
        faction: {
            ...profile.faction,
            iconImageUrl: (0, $lmedS.pathToURL)(profile.faction.iconPath)
        },
        isBanned: profile.bannedUntil && (0, $4r69E.msTimeDifferenceFromNow)(profile.bannedUntil) > 0
    };
}
function $1c9c8349850b32fc$export$fbf4e217491106b1(titles) {
    if (!titles.length) return [];
    // Remove duplicates based on the title property
    const uniqueTitlesMap = new Map();
    titles?.forEach((title)=>{
        uniqueTitlesMap.set(title.title, title);
    });
    // Convert the map back to an array
    const uniqueTitles = Array.from(uniqueTitlesMap.values());
    // Define the order of rarities
    const rarityOrder = {
        common: 1,
        uncommon: 2,
        rare: 3,
        epic: 4,
        legendary: 5
    };
    // Sort the unique titles based on the rarity order (case-insensitive)
    uniqueTitles.sort((a, b)=>{
        const rarityA = rarityOrder[a.rarity.toLowerCase()] || 0;
        const rarityB = rarityOrder[b.rarity.toLowerCase()] || 0;
        return rarityA - rarityB;
    });
    return uniqueTitles;
}
async function $1c9c8349850b32fc$export$dac150185429c35d(type, itemId) {
    let wasSuccessful = false;
    try {
        await $9K8Jg.setUserCurrentAsset(type, itemId);
        wasSuccessful = true;
    } catch (error) {
        console.warn(`Could not set user asset: ${type + ' ' + itemId}, ${error}`);
    }
    return wasSuccessful;
}
async function $1c9c8349850b32fc$export$68d8baec7d43174d(type) {
    try {
        await $9K8Jg.unsetUserCurrentAsset(type);
    } catch (error) {
        console.warn(`Could not unset user asset type: ${type}, ${error}`);
    }
}
async function $1c9c8349850b32fc$export$982894037bdd2b82(id) {
    let wasSuccessful = false;
    try {
        await $9K8Jg.setProfileTitle(id);
        wasSuccessful = true;
    } catch (error) {
        console.warn(`Could not set user title: ${id}, ${error}`);
    }
    return wasSuccessful;
}
function $1c9c8349850b32fc$export$93c3c111f074f9c1(profile) {
    return profile && profile?.background && profile?.character && profile?.faction;
}

});

parcelRegister("f9UtO", function(module, exports) {

$parcel$export(module.exports, "manageTokenExpiry", function () { return $17360464f85dab62$export$8769fd2af7f9fba0; });
$parcel$export(module.exports, "getTokenPayload", function () { return $17360464f85dab62$export$26ddc56bc995240a; });
$parcel$export(module.exports, "isJWTFormat", function () { return $17360464f85dab62$export$260587c9bdc229e; });
// Decode a JWT token.

var $cTs7K = parcelRequire("cTs7K");
function $17360464f85dab62$export$9a62e6c0a30e00bc(token) {
    // Split the token into parts
    const parts = token.split('.');
    if (parts.length !== 3) throw new Error('Invalid JWT: The token should consist of three parts.');
    // Decode the header and payload
    const header = JSON.parse(window.atob(parts[0].replace(/-/g, '+').replace(/_/g, '/')));
    const payload = JSON.parse(window.atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
    return {
        header: header,
        payload: payload
    };
}
let $17360464f85dab62$var$checkTokenInterval = null;
function $17360464f85dab62$export$8769fd2af7f9fba0() {
    const insidersToken = localStorage.getItem('ARISE_INSIDERS_TOKEN');
    const ariseToken = localStorage.getItem('ARISEENGINE_AUTHTOKEN');
    if (!insidersToken && !ariseToken) // If there are no tokens to check, return
    return;
    let expiry = null;
    if (insidersToken) expiry = $17360464f85dab62$var$getTokenExpiry(insidersToken);
    if (ariseToken) {
        const ariseTokenExpiry = $17360464f85dab62$var$getTokenExpiry(ariseToken);
        if (!expiry || ariseTokenExpiry < expiry) expiry = ariseTokenExpiry;
    }
    const hasExpired = ()=>{
        if (new Date() > expiry) {
            localStorage.removeItem('ARISE_INSIDERS_TOKEN');
            localStorage.removeItem('ARISEENGINE_AUTHTOKEN');
            if (!(0, $cTs7K.IS_DISCORD_ACTIVITY)) {
                console.log('Token has expired, refreshing page.');
                // TODO: add a toast or modal to notify the user that they have been logged out
                window.location.reload();
            }
        }
    };
    hasExpired();
// clearInterval(checkTokenInterval);
// checkTokenInterval = setInterval(hasExpired, 60 * 1000);
}
function $17360464f85dab62$var$getTokenExpiry(token) {
    try {
        const { payload: payload } = $17360464f85dab62$export$9a62e6c0a30e00bc(token);
        return new Date(payload.exp * 1000);
    } catch (error) {
        return new Date(0);
    }
}
function $17360464f85dab62$export$26ddc56bc995240a(token) {
    const { payload: payload } = $17360464f85dab62$export$9a62e6c0a30e00bc(token);
    return payload;
}
function $17360464f85dab62$export$260587c9bdc229e(token) {
    return typeof token === 'string' && token.split('.').length === 3;
}

});

parcelRegister("2Yr2D", function(module, exports) {

$parcel$export(module.exports, "setLocalUserTitles", function () { return $c807165952a81126$export$df2db7b6b4688d49; });
$parcel$export(module.exports, "getLocalUserTitles", function () { return $c807165952a81126$export$77b6f2d55599795; });

var $9K8Jg = parcelRequire("9K8Jg");
const $c807165952a81126$export$800da642f4d920ac = 'ARISE_TITLES';
function $c807165952a81126$export$c9b82301b675e7bb(id) {
    // Get the localstorage array of title IDs and add a new ID to it
    try {
        if (!id || typeof id !== 'string') return;
        const titles = $c807165952a81126$var$getLocalUserTitleIds();
        if (!titles.includes(id)) {
            titles.push(id);
            localStorage.setItem($c807165952a81126$export$800da642f4d920ac, JSON.stringify(titles));
        }
    } catch (error) {
        console.error('Could not add local title ', error);
    }
}
function $c807165952a81126$var$getLocalUserTitleIds() {
    // Get the localstorage array of title IDs and return it
    try {
        const storedTitles = localStorage.getItem($c807165952a81126$export$800da642f4d920ac);
        const titles = storedTitles ? JSON.parse(storedTitles) : [];
        return Array.isArray(titles) && titles.every((item)=>typeof item === 'string') ? titles : [];
    } catch  {
        return [];
    }
}
function $c807165952a81126$export$df2db7b6b4688d49(titles) {
    // Replace the local storage title IDs with a new array
    try {
        if (Array.isArray(titles) && titles.length) {
            // Convert array of titles to array of title IDs
            const ids = titles.map((title)=>title.id);
            localStorage.setItem($c807165952a81126$export$800da642f4d920ac, JSON.stringify(ids));
        }
    } catch (error) {
        console.error('Could not set local user titles ', error);
    }
}
async function $c807165952a81126$export$77b6f2d55599795() {
    // Get local title IDs, hydrate them into full Titles and return as array
    try {
        const localIds = $c807165952a81126$var$getLocalUserTitleIds();
        const availableTitles = await (0, $9K8Jg.getAvailableTitles)();
        return availableTitles.filter((title)=>localIds.includes(title.id));
    } catch (error) {
        return [];
    }
}

});

parcelRegister("2zDIY", function(module, exports) {

$parcel$export(module.exports, "storeProfileV2InLocalStorage", function () { return $7a1a51bc4bbbfb9a$export$dea18351651bc371; });
$parcel$export(module.exports, "getProfileV2FromLocalStorage", function () { return $7a1a51bc4bbbfb9a$export$2742d9445e1c1ec1; });
$parcel$export(module.exports, "clearProfileV2FromLocalStorage", function () { return $7a1a51bc4bbbfb9a$export$b8a28b9d2fdf374c; });
const $7a1a51bc4bbbfb9a$export$a60fc18650a0e1c7 = 'ARISE_PROFILE';
function $7a1a51bc4bbbfb9a$export$dea18351651bc371(profile) {
    try {
        localStorage.setItem($7a1a51bc4bbbfb9a$export$a60fc18650a0e1c7, JSON.stringify(profile));
    } catch (error) {
        console.error('storeProfileV2InLocalStorage error: Could not store local profile', error);
    }
}
function $7a1a51bc4bbbfb9a$export$2742d9445e1c1ec1() {
    try {
        const storedProfile = localStorage.getItem($7a1a51bc4bbbfb9a$export$a60fc18650a0e1c7);
        if (!storedProfile) return undefined;
        const parsed = JSON.parse(storedProfile);
        // Validate essential structure to ensure it's a real ProfileV2
        if (parsed && typeof parsed === 'object' && Array.isArray(parsed.titles) && Array.isArray(parsed.badges) && typeof parsed.displayName === 'string') return parsed;
        console.warn('getProfileV2FromLocalStorage: Invalid profile format in storage');
        return undefined;
    } catch (error) {
        console.error('getProfileV2FromLocalStorage error: Could not parse local profile', error);
        return undefined;
    }
}
function $7a1a51bc4bbbfb9a$export$b8a28b9d2fdf374c() {
    try {
        localStorage.removeItem($7a1a51bc4bbbfb9a$export$a60fc18650a0e1c7);
    } catch (error) {
        console.error('clearProfileV2FromLocalStorage error: Could not clear local profile', error);
    }
}

});


parcelRegister("24Y1Y", function(module, exports) {

$parcel$export(module.exports, "isMobileWidth", function () { return $7278beaaa6df6cd0$export$d0c5bde6e810b912; });
$parcel$export(module.exports, "isSmallMobileWidth", function () { return $7278beaaa6df6cd0$export$4a79c75b6bff951b; });
$parcel$export(module.exports, "getDeviceType", function () { return $7278beaaa6df6cd0$export$abfb0136cf8e916b; });

var $cTs7K = parcelRequire("cTs7K");
function $7278beaaa6df6cd0$export$a1d0d20ee9546562() {
    // @ts-ignore
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}
function $7278beaaa6df6cd0$export$d0c5bde6e810b912() {
    return window.innerWidth <= (0, $cTs7K.BP_MOBILE_CHAT);
}
function $7278beaaa6df6cd0$export$4a79c75b6bff951b() {
    return window.innerWidth <= 767;
}
function $7278beaaa6df6cd0$export$abfb0136cf8e916b() {
    const MOBILE_MAX_WIDTH = 767;
    const TABLET_MAX_WIDTH = 1024;
    const ua = navigator.userAgent || navigator.vendor || '';
    // Modern iPad detection (iPadOS 13+ reports as Mac)
    if (/Macintosh/.test(ua) && $7278beaaa6df6cd0$export$a1d0d20ee9546562()) return 'tablet';
    // Explicit device detection
    if (/iPhone|iPod/.test(ua)) return 'mobile';
    if (/iPad/.test(ua)) return 'tablet';
    if (/Android/.test(ua)) return /mobile/i.test(ua) ? 'mobile' : 'tablet';
    if (/Windows Phone|BlackBerry|webOS/.test(ua)) return 'mobile';
    if (/Kindle|Silk|PlayBook/.test(ua)) return 'tablet';
    // Fallback: use touch + screen size
    if ($7278beaaa6df6cd0$export$a1d0d20ee9546562()) {
        const smallestDimension = Math.min(window.innerWidth, window.innerHeight);
        if (smallestDimension <= MOBILE_MAX_WIDTH) return 'mobile';
        if (smallestDimension <= TABLET_MAX_WIDTH) return 'tablet';
    }
    return 'desktop';
}

});

parcelRegister("b3Ivu", function(module, exports) {

$parcel$export(module.exports, "getSavedLangIso", function () { return $567a83000685ccb9$export$c91a7002944fdc28; });
$parcel$export(module.exports, "saveLangIso", function () { return $567a83000685ccb9$export$d395c1d02af4bc2b; });
$parcel$export(module.exports, "clearSavedLangIso", function () { return $567a83000685ccb9$export$69ae409a05abb831; });
const $567a83000685ccb9$var$LS_LANG_KEY = 'ARISE_LANG_ISO';
function $567a83000685ccb9$export$c91a7002944fdc28() {
    try {
        console.log(`Not getting ${$567a83000685ccb9$var$LS_LANG_KEY} as translations are disabled`);
        return null;
        return window.localStorage.getItem($567a83000685ccb9$var$LS_LANG_KEY);
    } catch  {
        return null;
    }
}
function $567a83000685ccb9$export$d395c1d02af4bc2b(langISO) {
    try {
        window.localStorage.setItem($567a83000685ccb9$var$LS_LANG_KEY, langISO);
    } catch  {
    // Ignore localStorage errors
    }
}
function $567a83000685ccb9$export$69ae409a05abb831() {
    try {
        window.localStorage.removeItem($567a83000685ccb9$var$LS_LANG_KEY);
    } catch  {
    // Ignore localStorage errors
    }
}

});

parcelRegister("4QOJJ", function(module, exports) {

$parcel$export(module.exports, "cleanCDNUrls", function () { return $9362cd3813dbdfed$export$dd24a421a2d0451c; });
// Clean the references to old TWD CDN urls.
function $9362cd3813dbdfed$export$dd24a421a2d0451c(data) {
    // Only clean if the environment is not localhost and is a specific instance
    const shouldClean = window.location.hostname !== 'localhost' && [
        'rana'
    ].includes("skyhook");
    if (!shouldClean) return data;
    let stringData = JSON.stringify(data);
    stringData = stringData.replaceAll('twd.dev.arise-engine.com', window.location.host);
    return JSON.parse(stringData);
}

});


parcelRegister("6KpYp", function(module, exports) {

$parcel$export(module.exports, "awardBadge", function () { return $d5cd8d47176c3106$export$6a5f4639d5f54182; });
$parcel$export(module.exports, "awardTitle", function () { return $d5cd8d47176c3106$export$98e673d8352392d9; });
$parcel$export(module.exports, "setMissionComplete", function () { return $d5cd8d47176c3106$export$55aca55dfe74c941; });
$parcel$export(module.exports, "loadCurrentUserProfile", function () { return $d5cd8d47176c3106$export$7d774fa20a125bda; });
$parcel$export(module.exports, "loadCurrentUserProfileV2", function () { return $d5cd8d47176c3106$export$74ed0707f1b17d9a; });
$parcel$export(module.exports, "getAvailableBadges", function () { return $d5cd8d47176c3106$export$4b8380d51d91c627; });
$parcel$export(module.exports, "getAvailableTitles", function () { return $d5cd8d47176c3106$export$1ad62c2a69d5bd2; });
$parcel$export(module.exports, "loadUserProfiles", function () { return $d5cd8d47176c3106$export$7a8c9198471b4fff; });
$parcel$export(module.exports, "updateProfile", function () { return $d5cd8d47176c3106$export$5880729c5d131040; });
$parcel$export(module.exports, "resetProfileState", function () { return $d5cd8d47176c3106$export$c3b1dabb99da127e; });
$parcel$export(module.exports, "setProfileV2DisplayName", function () { return $d5cd8d47176c3106$export$1558266d2104261f; });
$parcel$export(module.exports, "default", function () { return $d5cd8d47176c3106$export$2e2bcd8739ae039; });

var $61p16 = parcelRequire("61p16");

var $9K8Jg = parcelRequire("9K8Jg");

var $ev4EW = parcelRequire("ev4EW");

var $9HMNu = parcelRequire("9HMNu");

var $dS0He = parcelRequire("dS0He");

var $kFQy0 = parcelRequire("kFQy0");

var $2zDIY = parcelRequire("2zDIY");

var $cTs7K = parcelRequire("cTs7K");

var $guTIo = parcelRequire("guTIo");
const $d5cd8d47176c3106$var$initialState = {
    currentUserProfileCheckInProgress: false,
    currentUserProfileCheckComplete: false,
    currentUserProfileV2: (0, $ev4EW.EMPTY_PROFILE_V2),
    availableBadges: [],
    availableTitles: [],
    profileByUserId: {},
    isFetchingProfileById: {}
};
const $d5cd8d47176c3106$export$1bdb4bb387fd9359 = $d5cd8d47176c3106$var$initialState;
const $d5cd8d47176c3106$export$6a5f4639d5f54182 = (badgeRank)=>async (dispatch, getState)=>{
        // Send to API
        $9K8Jg.addProfileBadge(badgeRank).catch(()=>{
            console.warn('Failed to send badge to API');
        });
        // Send stat
        (0, $kFQy0.sendEventV2)('badge_awarded', [
            badgeRank
        ]);
        const profileState = getState()?.profile;
        // Check if valid badge
        const availableBadges = profileState.availableBadges;
        if (!Array.isArray(availableBadges)) {
            console.warn('Cannot award badge - availableBadges not an array');
            return;
        }
        const hydratedBadge = availableBadges.find((availableBadge)=>availableBadge.rank === badgeRank);
        if (!hydratedBadge) {
            console.warn(`Cannot award badge - "${badgeRank}" is not a valid badge rank`);
            return;
        }
        // Check if already earned
        const profileBadges = profileState?.currentUserProfileV2?.badges ?? [];
        const alreadyEarned = profileBadges.find((b)=>b.rank === badgeRank);
        if (alreadyEarned) {
            console.log(`Badge already earned: ${alreadyEarned.name}`);
            return;
        }
        // Update local state
        dispatch($d5cd8d47176c3106$var$profile.actions.awardBadgeLocal(hydratedBadge));
        // Send achievement
        const translation_badgeActionPrefix = (0, $guTIo.getUITranslatedText)('notification_badgeActionPrefix', 'You earned the badge:');
        const translatedBadge = (0, $guTIo.getTranslatedBadge)(hydratedBadge);
        dispatch((0, $9HMNu.queueAchievement)({
            actionPrefix: `${translation_badgeActionPrefix} `,
            action: `${translatedBadge.name}`,
            type: 'success',
            icon: 'badge',
            onClickAction: 'open-profile'
        }));
    };
const $d5cd8d47176c3106$export$98e673d8352392d9 = (titleId)=>async (dispatch, getState)=>{
        // Send to API
        $9K8Jg.addProfileTitle(titleId).catch(()=>{
            console.warn('Failed to send title to API');
        });
        // Send stat
        (0, $kFQy0.sendEventV2)('title_awarded', [
            titleId
        ]);
        const profileState = getState()?.profile;
        const availableTitles = profileState.availableTitles;
        if (!Array.isArray(availableTitles)) {
            console.warn('Cannot award title - availableTitles not an array');
            return;
        }
        // Check if valid title
        const hydratedTitle = availableTitles.find((availableTitle)=>availableTitle.id === titleId);
        if (!hydratedTitle) {
            console.warn(`Cannot award title - "${titleId}" is not a valid title ID`);
            return;
        }
        // Check if already earned
        const profileTitles = profileState?.currentUserProfileV2?.titles ?? [];
        const alreadyEarned = profileTitles.find((b)=>b.id === titleId);
        if (alreadyEarned) {
            console.log(`Title already earned: ${alreadyEarned.title}`);
            return;
        }
        // Update local state
        dispatch($d5cd8d47176c3106$var$profile.actions.awardTitleLocal(hydratedTitle));
        const translation_titleActionPrefix = (0, $guTIo.getUITranslatedText)('notification_titleActionPrefix', 'You earned the title:');
        const translatedTitle = (0, $guTIo.getTranslatedTitle)(hydratedTitle);
        // Send achievement
        dispatch((0, $9HMNu.queueAchievement)({
            actionPrefix: `${translation_titleActionPrefix} `,
            action: `"${translatedTitle.title}"`,
            type: 'success',
            icon: 'title',
            onClickAction: 'open-profile'
        }));
    };
const $d5cd8d47176c3106$export$55aca55dfe74c941 = ()=>async (dispatch, getState)=>{
        // Send to API
        $9K8Jg.setProfileMissionCompleted().catch(()=>{
            console.warn('Failed to send mission complete to API');
        });
        // Check if already earned
        const isAlreadyComplete = getState()?.profile?.currentUserProfileV2.missionCompleted;
        if (isAlreadyComplete) {
            console.log('Mission is already complete');
            return;
        }
        // Update local state
        dispatch($d5cd8d47176c3106$var$profile.actions.setMissionCompletedLocal());
        // Send achievement
        const translation_questCompleteActionPrefix = (0, $guTIo.getUITranslatedText)('notification_questCompleteActionPrefix', 'You completed the Quest!');
        const translation_missionCompleteActionPrefix = (0, $guTIo.getUITranslatedText)('notification_missionCompleteActionPrefix', 'You completed the Mission!');
        dispatch((0, $9HMNu.queueAchievement)({
            actionPrefix: '',
            action: (0, $cTs7K.IS_DISCORD_ACTIVITY) ? translation_questCompleteActionPrefix : translation_missionCompleteActionPrefix,
            type: 'success',
            icon: (0, $cTs7K.IS_DISCORD_ACTIVITY) ? 'quest' : 'mission',
            onClickAction: 'open-profile'
        }));
    };
const $d5cd8d47176c3106$export$982894037bdd2b82 = (0, $61p16.createAsyncThunk)('profile/setProfileTitle', async (id)=>{
    const result = await $9K8Jg.setProfileTitle(id);
    return result.success;
});
const $d5cd8d47176c3106$export$63f1075dd6373efe = (0, $61p16.createAsyncThunk)('profile/setProfileFaction', async (id)=>{
    const result = await $9K8Jg.setProfileFaction(id);
    return result.success;
});
const $d5cd8d47176c3106$export$7d774fa20a125bda = (0, $61p16.createAsyncThunk)('profile/load', async (userId)=>{
    const profiles = await $9K8Jg.getProfiles(userId);
    return profiles[0] ?? undefined;
});
const $d5cd8d47176c3106$export$74ed0707f1b17d9a = (0, $61p16.createAsyncThunk)('profileV2/load', async ()=>{
    const profile = await $9K8Jg.getCurrentUserProfileV2();
    if (!profile) throw new Error('No profile found');
    return profile;
});
const $d5cd8d47176c3106$export$4b8380d51d91c627 = (0, $61p16.createAsyncThunk)('profile/getAvailableBadges', async ()=>{
    const result = await $9K8Jg.getAvailableBadges();
    if (!Array.isArray(result)) {
        console.warn('getAvailableBadges response not valid');
        return [];
    }
    return result;
});
const $d5cd8d47176c3106$export$1ad62c2a69d5bd2 = (0, $61p16.createAsyncThunk)('profile/getAvailableTitles', async ()=>{
    const result = await $9K8Jg.getAvailableTitles();
    if (!Array.isArray(result)) {
        console.warn('getAvailableTitles response not valid');
        return [];
    }
    return result;
});
const $d5cd8d47176c3106$export$7a8c9198471b4fff = (0, $61p16.createAsyncThunk)('profile/loadUserProfiles', async (userIds, thunkApi)=>{
    const state = thunkApi.getState();
    const ttl = Date.now() + 60000;
    const cleanedUserIds = userIds.filter((id)=>{
        return !state.profile.isFetchingProfileById[id] && (!state.profile.profileByUserId[id] || state.profile.profileByUserId[id] && state.profile.profileByUserId[id].fetchedAt > ttl);
    });
    if (cleanedUserIds.length === 0) return null;
    thunkApi.dispatch($d5cd8d47176c3106$var$profile.actions.markProfilesAsFetching(cleanedUserIds));
    return await $9K8Jg.getProfiles(cleanedUserIds);
});
const $d5cd8d47176c3106$var$profile = (0, $61p16.createSlice)({
    name: 'profile',
    initialState: $d5cd8d47176c3106$var$initialState,
    reducers: {
        markProfilesAsFetching: (state, action)=>{
            action.payload.forEach((id)=>{
                state.isFetchingProfileById[id] = true;
            });
        },
        updateProfile: (state, action)=>{
            const data = action.payload;
            const profile = (0, $dS0He.processProfileData)(data);
            const now = Date.now();
            profile.fetchedAt = now;
            // Not currenlty using the profile cache so commenting this out to avoid using unnecessary memory
            // state.profileByUserId[profile.userID] = profile;
            if (state.currentUserProfile?.id === profile.id) state.currentUserProfile = profile;
        },
        resetProfileState: (state)=>{
            const newState = {
                ...$d5cd8d47176c3106$var$initialState,
                profileByUserId: state.profileByUserId,
                isFetchingProfileById: state.isFetchingProfileById
            };
            Object.assign(state, newState);
        },
        setProfileV2DisplayName: (state, action)=>{
            if (state.currentUserProfileV2) state.currentUserProfileV2.displayName = action.payload;
        },
        awardBadgeLocal: (state, action)=>{
            if (Array.isArray(state?.currentUserProfileV2?.badges)) {
                state.currentUserProfileV2.badges.push(action.payload);
                (0, $2zDIY.storeProfileV2InLocalStorage)(state.currentUserProfileV2);
            } else console.log('awardBadgeLocal skipping as badges array not valid');
        },
        awardTitleLocal: (state, action)=>{
            if (Array.isArray(state?.currentUserProfileV2?.titles)) {
                state.currentUserProfileV2.titles.push(action.payload);
                (0, $2zDIY.storeProfileV2InLocalStorage)(state.currentUserProfileV2);
            } else console.log('awardTitleLocal skipping as titles array not valid');
        },
        setMissionCompletedLocal: (state)=>{
            if (state.currentUserProfileV2) {
                state.currentUserProfileV2.missionCompleted = true;
                (0, $2zDIY.storeProfileV2InLocalStorage)(state.currentUserProfileV2);
            } else console.log('setMissionCompleted skipping currentUserProfileV2 not loaded');
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($d5cd8d47176c3106$export$7d774fa20a125bda.pending, (state)=>{
            state.currentUserProfileCheckInProgress = true;
            state.currentUserProfileCheckComplete = false;
        });
        builder.addCase($d5cd8d47176c3106$export$7d774fa20a125bda.fulfilled, (state, action)=>{
            state.currentUserProfile = action.payload;
            state.currentUserProfileCheckInProgress = false;
            state.currentUserProfileCheckComplete = true;
        });
        builder.addCase($d5cd8d47176c3106$export$7d774fa20a125bda.rejected, (state, action)=>{
            console.error('Failed to load current user profile', action.error);
            state.currentUserProfileCheckInProgress = false;
            state.currentUserProfileCheckComplete = true;
        });
        builder.addCase($d5cd8d47176c3106$export$74ed0707f1b17d9a.fulfilled, (state, action)=>{
            state.currentUserProfileV2 = action.payload;
        });
        builder.addCase($d5cd8d47176c3106$export$7a8c9198471b4fff.fulfilled, (state, action)=>{
            action.meta.arg.forEach((id)=>{
                state.isFetchingProfileById[id] = false;
            });
            const now = Date.now();
            action.payload?.forEach((profile)=>{
                const p = profile;
                p.fetchedAt = now;
                state.profileByUserId[p.userID] = p;
            });
        });
        builder.addCase($d5cd8d47176c3106$export$7a8c9198471b4fff.rejected, (state, action)=>{
            console.error(action.error);
            action.meta.arg.forEach((id)=>{
                state.isFetchingProfileById[id] = false;
            });
        });
        builder.addCase($d5cd8d47176c3106$export$4b8380d51d91c627.fulfilled, (state, action)=>{
            state.availableBadges = action.payload;
        });
        builder.addCase($d5cd8d47176c3106$export$1ad62c2a69d5bd2.fulfilled, (state, action)=>{
            state.availableTitles = action.payload;
        });
    }
});
const { updateProfile: $d5cd8d47176c3106$export$5880729c5d131040, resetProfileState: $d5cd8d47176c3106$export$c3b1dabb99da127e, setProfileV2DisplayName: $d5cd8d47176c3106$export$1558266d2104261f } = $d5cd8d47176c3106$var$profile.actions;
const { actions: $d5cd8d47176c3106$export$13e13f83d4c0e6c7, reducer: $d5cd8d47176c3106$export$48f9ba8d956d63bb } = $d5cd8d47176c3106$var$profile;
var $d5cd8d47176c3106$export$2e2bcd8739ae039 = $d5cd8d47176c3106$export$48f9ba8d956d63bb;

});
parcelRegister("ev4EW", function(module, exports) {

$parcel$export(module.exports, "EMPTY_PROFILE_V2", function () { return $6aa505575a41c6c5$export$9b21b9392956745c; });
const $6aa505575a41c6c5$export$9b21b9392956745c = {
    displayName: 'Guest',
    titles: [],
    badges: [],
    missionCompleted: false,
    createdAt: '',
    updatedAt: '',
    userId: ''
};
function $6aa505575a41c6c5$export$56d9ca79edb967e7() {
    return {
        id: '',
        universeID: '',
        displayName: '',
        factionID: '',
        avatarFrame: {
            id: '',
            imagePath: '',
            name: '',
            price: 0
        },
        background: {
            id: '',
            colour: '',
            imagePath: '',
            name: '',
            price: 0,
            rivFileURL: '',
            thumbnailPath: ''
        },
        character: {
            id: '',
            imagePath: '',
            name: '',
            price: 0,
            rivFileURL: '',
            thumbnailPath: ''
        },
        createdAt: '',
        updatedAt: '',
        userID: '',
        faction: {
            id: '',
            name: '',
            imagePath: '',
            iconPath: '',
            iconImageUrl: '',
            rankImagePath: ''
        },
        supplyRunRank: null,
        title: {
            id: '',
            titleID: undefined,
            title: '',
            rarity: 'Common'
        },
        role: 'user',
        fetchedAt: 0,
        isBanned: false,
        bannedUntil: undefined,
        bannedReason: undefined,
        factionImageUrl: ''
    };
}

});

parcelRegister("kFQy0", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $362f833f66254b4c$export$2cd8252107eb640b; });
$parcel$export(module.exports, "sendEvent", function () { return $362f833f66254b4c$export$7329bcdc3edcd90e; });
$parcel$export(module.exports, "sendEventV2", function () { return $362f833f66254b4c$export$fe860283b770a141; });
$parcel$export(module.exports, "sendEventV2Once", function () { return $362f833f66254b4c$export$93a2a8ff75adccc8; });

var $2QyQO = parcelRequire("2QyQO");

var $a8TTP = parcelRequire("a8TTP");

var $ly8fr = parcelRequire("ly8fr");
let $362f833f66254b4c$var$initialised = false;
async function $362f833f66254b4c$export$2cd8252107eb640b(gaId) {
    // Amplitude removed
    // if (!initialised && gaId && amplitudeKey) {
    //     initaliseGA(gaId);
    //     setAmplitudeKey(amplitudeKey);
    //     initialised = true;
    // }
    try {
        if (!$362f833f66254b4c$var$initialised && gaId && await $362f833f66254b4c$export$7411ea8341c49b9f()) {
            (0, $a8TTP.initaliseGA)(gaId);
            $362f833f66254b4c$var$initialised = true;
        }
    } catch (error) {}
}
async function $362f833f66254b4c$export$7329bcdc3edcd90e(name, data) {
// Previously, this sent events to the old analytics system.
// Many old files still call this function.
// Any important analytics calling this should call sendEventV2 instead.
}
async function $362f833f66254b4c$export$fe860283b770a141(name, strings = [], numbers = [], isExternal, useBeacon) {
    try {
        (0, $ly8fr.sendEventV2)(name, strings, numbers, isExternal, useBeacon);
        if (await $362f833f66254b4c$export$7411ea8341c49b9f()) (0, $a8TTP.sendEvent)(name, {
            metadata: {
                strings: strings,
                numbers: numbers
            }
        });
    } catch (error) {}
}
const $362f833f66254b4c$var$sentEvents = {};
function $362f833f66254b4c$export$93a2a8ff75adccc8(...args) {
    const name = args[0];
    if ($362f833f66254b4c$var$sentEvents[name]) return;
    $362f833f66254b4c$var$sentEvents[name] = true;
    return $362f833f66254b4c$export$fe860283b770a141(...args);
}
async function $362f833f66254b4c$export$7411ea8341c49b9f() {
    // Only paramount instances have cbsoptanon script currently
    if (!(0, $2QyQO.isParamountInstance)) return true;
    try {
        return await window['cbsoptanon']?.ot?.getConsentPreferences(2);
    } catch (error) {
        console.log('areAnalyticsAllowed() - Could not getConsentPreferences so defaulting to false');
        return false;
    }
}

});
parcelRegister("2QyQO", function(module, exports) {

$parcel$export(module.exports, "homePath", function () { return $98c01eb7ad0ca7aa$export$5d5930b97498321d; });
$parcel$export(module.exports, "exitModalText", function () { return $98c01eb7ad0ca7aa$export$7e897824870b749a; });
$parcel$export(module.exports, "getInsidersLoginUrl", function () { return $98c01eb7ad0ca7aa$export$5f6bbcf3b38d23c9; });
$parcel$export(module.exports, "getInsidersRegisterUrl", function () { return $98c01eb7ad0ca7aa$export$e3192afa1eb299f2; });
$parcel$export(module.exports, "SUPPORT_EMAIL", function () { return $98c01eb7ad0ca7aa$export$fc5cbb021d0697ad; });
$parcel$export(module.exports, "isInsidersInstance", function () { return $98c01eb7ad0ca7aa$export$9bae8a72c0a0800e; });
$parcel$export(module.exports, "isParamountInstance", function () { return $98c01eb7ad0ca7aa$export$37d78445bafeaee9; });
const $98c01eb7ad0ca7aa$export$5d5930b97498321d = "/location/9df6f958-d53c-47ba-bb29-e1f641edc457" ?? '/selector';
const $98c01eb7ad0ca7aa$export$c6f795ee6cb9c0a5 = ()=>{
    const url = new URL(window.location.href);
    return url?.pathname === $98c01eb7ad0ca7aa$export$5d5930b97498321d;
};
const $98c01eb7ad0ca7aa$export$7e897824870b749a = 'Back to World';
const $98c01eb7ad0ca7aa$export$5f6bbcf3b38d23c9 = ()=>{
    const returnUrl = window.location.origin + '/auth/insiders';
    const base64Url = btoa(returnUrl);
    return `${undefined}?return_to=${base64Url}`;
};
const $98c01eb7ad0ca7aa$export$e3192afa1eb299f2 = ()=>{
    const returnUrl = window.location.origin + '/auth/insiders';
    const base64Url = btoa(returnUrl);
    return `${undefined}?return_to=${base64Url}`;
};
const $98c01eb7ad0ca7aa$export$fc5cbb021d0697ad = 'support@thosebeyond.io';
const $98c01eb7ad0ca7aa$export$9bae8a72c0a0800e = false;
const $98c01eb7ad0ca7aa$export$2c2e61be4a755d74 = !$98c01eb7ad0ca7aa$export$9bae8a72c0a0800e;
const $98c01eb7ad0ca7aa$export$37d78445bafeaee9 = false;

});

parcelRegister("a8TTP", function(module, exports) {

$parcel$export(module.exports, "initaliseGA", function () { return $37520e62eafd9d6b$export$e8c85dfc4a2555; });
$parcel$export(module.exports, "sendEvent", function () { return $37520e62eafd9d6b$export$7329bcdc3edcd90e; });
function $37520e62eafd9d6b$export$e8c85dfc4a2555(id) {
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    script.async = true;
    document.head.appendChild(script);
    // @ts-ignore
    window.dataLayer = window.dataLayer || [];
    function gtag(a, b) {
        // @ts-ignore
        window.dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('config', id);
    const additional_ids = undefined;
    if (additional_ids) {
        const ids = additional_ids.split(',');
        ids.forEach((additional_id)=>{
            gtag('config', additional_id);
        });
    }
    // @ts-ignore
    window.gtag = gtag;
}
function $37520e62eafd9d6b$export$7329bcdc3edcd90e(name, data) {
    // @ts-ignore
    if (window.gtag) // @ts-ignore
    window.gtag('event', name, data);
}

});

parcelRegister("ly8fr", function(module, exports) {

$parcel$export(module.exports, "setUserId", function () { return $90438eb8ae153cb2$export$7f5abdb7f5093137; });
$parcel$export(module.exports, "sendEventV2", function () { return $90438eb8ae153cb2$export$fe860283b770a141; });

var $9K8Jg = parcelRequire("9K8Jg");

var $cTs7K = parcelRequire("cTs7K");

var $24Y1Y = parcelRequire("24Y1Y");
let $90438eb8ae153cb2$var$userId = undefined;
let $90438eb8ae153cb2$var$deviceId = window.localStorage.getItem('ARISE_DEVICE_ID');
const $90438eb8ae153cb2$var$sessionId = $90438eb8ae153cb2$var$uuidv4();
const $90438eb8ae153cb2$var$sessionStartTime = Date.now();
const $90438eb8ae153cb2$var$deviceType = (0, $24Y1Y.getDeviceType)();
if (!$90438eb8ae153cb2$var$deviceId) {
    $90438eb8ae153cb2$var$deviceId = $90438eb8ae153cb2$var$uuidv4();
    window.localStorage.setItem('ARISE_DEVICE_ID', $90438eb8ae153cb2$var$deviceId);
}
function $90438eb8ae153cb2$export$7f5abdb7f5093137(id) {
    $90438eb8ae153cb2$var$userId = id;
}
function $90438eb8ae153cb2$export$fe860283b770a141(name, strings = [], numbers = [], isExternal, useBeacon) {
    return (0, $9K8Jg.scrollV2)({
        sessionId: $90438eb8ae153cb2$var$sessionId,
        deviceId: $90438eb8ae153cb2$var$deviceId,
        eventType: name,
        userId: $90438eb8ae153cb2$var$userId,
        universeId: "9097f2ba-ec9e-48b1-82af-0080acd3924e",
        deviceType: $90438eb8ae153cb2$var$deviceType,
        timestamp: Date.now(),
        sessionDuration: Date.now() - $90438eb8ae153cb2$var$sessionStartTime,
        platform: (0, $cTs7K.HOST_PLATFORM),
        metadata: {
            strings: strings,
            numbers: numbers
        },
        isExternal: isExternal ?? false
    }, useBeacon).catch((e)=>{
    // Silently fail
    });
}
function $90438eb8ae153cb2$var$uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}

});


parcelRegister("guTIo", function(module, exports) {

$parcel$export(module.exports, "useUITranslatedText", function () { return $dae26923e7a3e3fd$export$5392ebda159e4fc8; });
$parcel$export(module.exports, "getUITranslatedText", function () { return $dae26923e7a3e3fd$export$45826550b44673ec; });
$parcel$export(module.exports, "useLang", function () { return $dae26923e7a3e3fd$export$b24a004ee43dce44; });
$parcel$export(module.exports, "getTranslatedBadge", function () { return $dae26923e7a3e3fd$export$eb4d19b207ed39b8; });
$parcel$export(module.exports, "getTranslatedTitle", function () { return $dae26923e7a3e3fd$export$be0bbd8287b320cd; });
$parcel$export(module.exports, "getTranslatedNewsTickerItem", function () { return $dae26923e7a3e3fd$export$eb2d8d80f3237390; });

var $9h2J6 = parcelRequire("9h2J6");

var $7RNO0 = parcelRequire("7RNO0");
parcelRequire("9HMNu");

var $i2KZ1 = parcelRequire("i2KZ1");

var $cTs7K = parcelRequire("cTs7K");
function $dae26923e7a3e3fd$var$TranslatedText({ translationKey: translationKey, fallback: fallback }) {
    // Implementation will be added later
    return /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9h2J6.Fragment), {
        children: fallback || translationKey
    });
}
function $dae26923e7a3e3fd$export$840b86506f72c041({ translationKey: translationKey, fallback: fallback }) {
    const translation = $dae26923e7a3e3fd$export$5392ebda159e4fc8(translationKey, fallback);
    return /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9h2J6.Fragment), {
        children: translation
    });
}
var $dae26923e7a3e3fd$export$2e2bcd8739ae039 = $dae26923e7a3e3fd$var$TranslatedText;
// Core translation lookup logic
function $dae26923e7a3e3fd$var$getTranslation(translations, langIso, translationKey, fallback) {
    const translation = translations?.[langIso]?.[translationKey];
    if (translation) return translation;
    translations?.[langIso];
    return fallback || '';
}
function $dae26923e7a3e3fd$export$af1b123c30a7b260(translationKey, fallback) {
    const langIso = (0, $i2KZ1.useAppSelector)((state)=>state.app.langIso);
    const translations = (0, $i2KZ1.useAppSelector)((state)=>state.app.translations);
    return $dae26923e7a3e3fd$var$getTranslation(translations, langIso, translationKey, fallback);
}
function $dae26923e7a3e3fd$export$5392ebda159e4fc8(key, fallback) {
    const fullKey = `platform__ui__${key}`;
    return $dae26923e7a3e3fd$export$af1b123c30a7b260(fullKey, fallback);
}
function $dae26923e7a3e3fd$export$45826550b44673ec(key, fallback) {
    const state = (0, $i2KZ1.default).getState();
    const { langIso: langIso, translations: translations } = state.app;
    const fullKey = `platform__ui__${key}`;
    return $dae26923e7a3e3fd$var$getTranslation(translations, langIso, fullKey, fallback);
}
function $dae26923e7a3e3fd$export$b24a004ee43dce44() {
    const current = (0, $i2KZ1.useAppSelector)((state)=>state.app.langIso);
    const availableLangs = (0, $i2KZ1.useAppSelector)((state)=>state.app.availableLangs) ?? [];
    // Put default lang to the beginning if it exists
    const langs = (0, $7RNO0.useMemo)(()=>[
            ...availableLangs.filter((l)=>l.langISO?.toLowerCase() === (0, $cTs7K.DEFAULT_LANG).langISO),
            ...availableLangs.filter((l)=>l.langISO?.toLowerCase() !== (0, $cTs7K.DEFAULT_LANG).langISO)
        ], [
        availableLangs
    ]);
    const dispatch = (0, $i2KZ1.useAppDispatch)();
    (0, $7RNO0.useEffect)(()=>{
        if (current) document.documentElement.lang = current;
    }, [
        current
    ]);
    function setLang(langIso) {
        // setLang ignored as translations are disabled
        return;
    }
    return {
        current: current,
        langs: langs,
        setLang: setLang
    };
}
function $dae26923e7a3e3fd$export$54034eb0ae4c7f93(titleId, field, fallback) {
    const state = (0, $i2KZ1.default).getState();
    const { langIso: langIso, translations: translations } = state.app;
    const fullKey = `platform__title__${titleId}__${field}`;
    return $dae26923e7a3e3fd$var$getTranslation(translations, langIso, fullKey, fallback);
}
function $dae26923e7a3e3fd$export$179aedaa53e2c3ff(rank, field, fallback) {
    const state = (0, $i2KZ1.default).getState();
    const { langIso: langIso, translations: translations } = state.app;
    const fullKey = `platform__badge__${rank}__${field}`;
    return $dae26923e7a3e3fd$var$getTranslation(translations, langIso, fullKey, fallback);
}
function $dae26923e7a3e3fd$export$8852f52bb3d9a170(id, field, fallback) {
    const state = (0, $i2KZ1.default).getState();
    const { langIso: langIso, translations: translations } = state.app;
    const fullKey = `platform__newsticker__${id}__${field}`;
    return $dae26923e7a3e3fd$var$getTranslation(translations, langIso, fullKey, fallback);
}
function $dae26923e7a3e3fd$export$eb4d19b207ed39b8(badge) {
    if (!badge) return;
    const rank = badge?.rank;
    if (!rank) {
        console.log(`Cannot translate badge as rank missing: ${badge}`);
        return badge;
    }
    return {
        ...badge,
        name: $dae26923e7a3e3fd$export$179aedaa53e2c3ff(rank, 'name', badge.name),
        description: $dae26923e7a3e3fd$export$179aedaa53e2c3ff(rank, 'description', badge.description)
    };
}
function $dae26923e7a3e3fd$export$be0bbd8287b320cd(title) {
    if (!title) return;
    const key = title?.id;
    if (!key) {
        console.log(`Cannot translate title as id missing: ${title}`);
        return title;
    }
    return {
        ...title,
        title: $dae26923e7a3e3fd$export$54034eb0ae4c7f93(key, 'title', title.title),
        description: $dae26923e7a3e3fd$export$54034eb0ae4c7f93(key, 'description', title.description),
        hint: $dae26923e7a3e3fd$export$54034eb0ae4c7f93(key, 'hint', title.hint || title.description)
    };
}
function $dae26923e7a3e3fd$export$eb2d8d80f3237390(item, type) {
    if (!item) return;
    const id = item?.id;
    if (!id) {
        console.log(`Cannot translate newsTickerItem as id missing: ${item}`);
        return item;
    }
    const field = type === 'recent' ? 'recentEventsMessageTemplate' : 'userMessageTemplate';
    return {
        ...item,
        message: $dae26923e7a3e3fd$export$8852f52bb3d9a170(id, field, item.message)
    };
}

});



parcelRegister("3yrZE", function(module, exports) {

$parcel$export(module.exports, "queueNewsTickerItem", function () { return $894e9b3b77168f2f$export$2475777bb1976781; });
$parcel$export(module.exports, "removeFirstNewsTickerItemFromQueue", function () { return $894e9b3b77168f2f$export$a26bb05919391d5d; });
$parcel$export(module.exports, "setNewsTickerTag", function () { return $894e9b3b77168f2f$export$6bfb177ddaeee246; });
$parcel$export(module.exports, "feedReducer", function () { return $894e9b3b77168f2f$export$c4bc848778eef518; });

var $61p16 = parcelRequire("61p16");

var $9K8Jg = parcelRequire("9K8Jg");

var $6KpYp = parcelRequire("6KpYp");

var $lmedS = parcelRequire("lmedS");
const $894e9b3b77168f2f$var$initialState = {
    connected: false,
    isLoadingPastMessages: false,
    isMessageSubmitting: false,
    messages: [],
    isSubmittingToySuccess: false,
    moderationActionOpenOnMessageId: null,
    feedUpdateTicker: 0,
    availableReactions: {},
    storedEvents: {},
    newsTickerQueue: []
};
const $894e9b3b77168f2f$export$4b387b939f249d89 = $894e9b3b77168f2f$var$initialState;
const $894e9b3b77168f2f$export$165373646bd00c5b = (0, $61p16.createAsyncThunk)('feed/getPreviousMessages', async ({ id: id, globalChat: globalChat, isLatest: isLatest })=>{
    const messages = await $9K8Jg.lastChats(id, undefined, undefined, globalChat, isLatest);
    return [
        id,
        messages
    ];
});
const $894e9b3b77168f2f$export$8fd5706e716dbba = (0, $61p16.createAsyncThunk)('feed/submitMessage', async ([locationId, message])=>{
    await $9K8Jg.sendMessage(locationId, message);
});
const $894e9b3b77168f2f$export$da0e5c5d04f0c39d = (0, $61p16.createAsyncThunk)('feed/submitCommand', async ([locationId, message])=>{
    await $9K8Jg.sendCommand(locationId, message);
});
const $894e9b3b77168f2f$export$374ea87e421dfcbd = (0, $61p16.createAsyncThunk)('feed/toggleMessageReaction', async ([messageId, reaction, locationId])=>{
    await $9K8Jg.toggleMessageReaction(messageId, reaction, locationId);
});
const $894e9b3b77168f2f$export$abf5a3bc7da4a0e8 = (0, $61p16.createAsyncThunk)('feed/loadAvailableReactions', async ()=>{
    function convertArrayToObject(arrayOfReactions) {
        let reactionsAsObject = {};
        arrayOfReactions.forEach((reaction)=>{
            reactionsAsObject[reaction.type] = {
                ...reaction,
                imageUrl: (0, $lmedS.pathToURL)(reaction.imagePath)
            };
        });
        return reactionsAsObject;
    }
    const reactions = await $9K8Jg.listReactionTypes();
    return convertArrayToObject(reactions);
});
const $894e9b3b77168f2f$export$2c068985d74c0fcd = (0, $61p16.createAsyncThunk)('feed/getUserDataForChat', async (messages, thunkApi)=>{
    const userIds = new Set();
    messages.forEach((m)=>{
        switch(m.type){
            case 'chat-message':
                userIds.add(m.data.senderId);
                break;
            case 'feed-update':
                userIds.add(m.data.subjectId);
                break;
        }
    });
    thunkApi.dispatch((0, $6KpYp.loadUserProfiles)(Array.from(userIds)));
});
const $894e9b3b77168f2f$export$df4a6caaec0ed72 = (0, $61p16.createAsyncThunk)('feed/fetchEventById', async (eventID)=>{
    return await $9K8Jg.getEventById(eventID);
});
const $894e9b3b77168f2f$var$feed = (0, $61p16.createSlice)({
    name: 'feed',
    initialState: $894e9b3b77168f2f$var$initialState,
    reducers: {
        addItem: (state, action)=>{
            state.messages.push(action.payload);
        },
        updateItem: (state, action)=>{
            const index = state.messages.findIndex((m)=>m.id === action.payload.id);
            const previousItem = state.messages[index];
            if (index >= 0) {
                // Check if the number of reactions has changed.
                // This is used to trigger the autoscroll, as the height of the message element will change based on whether there are reactions or not.
                if (previousItem.type === 'chat-message' && action.payload.type === 'chat-message' || previousItem.type === 'feed-update' && action.payload.type === 'feed-update') {
                    const previousReactionCount = previousItem.data.reactions && previousItem.data.reactions.length ? previousItem.data.reactions.length : 0;
                    const newReactionCount = action.payload.data && action.payload.data.reactions ? action.payload.data.reactions.length : 0;
                    if (previousReactionCount !== newReactionCount && (previousReactionCount > 0 || newReactionCount > 0)) state.feedUpdateTicker++;
                }
                state.messages[index] = action.payload;
            }
        },
        updateMessageReaction: (state, action)=>{
            const indexOfMessage = state.messages.findIndex((m)=>m.id === action.payload.data.id);
            const messageData = state.messages[indexOfMessage]?.data;
            if (!messageData) return;
            if (!messageData.reactions) messageData.reactions = [];
            const messageReactions = messageData.reactions;
            const payload = action.payload.data.reaction;
            if (messageReactions) {
                state.feedUpdateTicker++;
                const indexOfReaction = messageReactions.findIndex((r)=>r.type === payload.type);
                const reactionToUpdate = messageReactions[indexOfReaction];
                if (payload.action === 'add') {
                    const newUserReactedBy = {
                        userID: action.payload.data.reaction.userID,
                        displayName: action.payload.data.reaction.displayName
                    };
                    if (reactionToUpdate) {
                        // Reaction type is already on this message
                        // So increase reaction count and add user to list
                        reactionToUpdate.count++;
                        reactionToUpdate.reactedBy.push(newUserReactedBy);
                    } else // Reaction type is not on this message yet
                    // So add the reaction
                    messageReactions.push({
                        type: payload.type,
                        count: 1,
                        reactedBy: [
                            newUserReactedBy
                        ]
                    });
                } else if (payload.action === 'remove') {
                    if (reactionToUpdate) {
                        // Reaction type is already on this message
                        if (reactionToUpdate.count === 1) // If only count of 1, remove this reaction completely
                        messageReactions.splice(indexOfReaction, 1);
                        else {
                            // Otherwise just decrease the count and remove user from list
                            reactionToUpdate.count--;
                            reactionToUpdate.reactedBy = reactionToUpdate.reactedBy.filter((r)=>r.userID !== payload.userID);
                        }
                    } else ;
                }
            }
        },
        removeItem: (state, action)=>{
            const index = state.messages.findIndex((m)=>m.id === action.payload);
            if (index >= 0) state.messages.splice(index, 1);
        },
        setConnectionStatus: (state, action)=>{
            state.connected = action.payload;
        },
        openModerationAction: (state, action)=>{
            state.moderationActionOpenOnMessageId = action.payload;
        },
        closeModerationAction: (state)=>{
            state.moderationActionOpenOnMessageId = null;
        },
        updateFeedProfile: (state, action)=>{
            const profile = action.payload;
            state.messages = state.messages.map((m)=>{
                if (m.type === 'chat-message') {
                    const message = m.data;
                    if (message.senderId === profile.userID) message.profile = profile;
                }
                if (m.type === 'feed-update') {
                    const update = m.data;
                    if (update.subjectId === profile.userID) update.profile = profile;
                }
                return m;
            });
        },
        addItemsToTop: (state, action)=>{
            state.messages = [
                ...action.payload,
                ...state.messages
            ];
        },
        setCurrentEvent: (state, action)=>{
            state.currentEvent = action.payload;
        },
        setCurrentEventIsActive: (state, action)=>{
            state.currentEvent.isActive = action.payload;
        },
        clearCurrentEvent: (state)=>{
            state.currentEvent = null;
        },
        updateEventParticipant: (state, action)=>{
            // Only update if is for current active event
            if (action.payload?.data?.eventID !== state.currentEvent?.eventID) return;
            const participant = {
                ...action.payload.data.participant,
                lastUpdated: action.payload.timestamp
            };
            state.currentEvent.participants = [
                participant
            ];
        },
        queueNewsTickerItem: (state, action)=>{
            state.newsTickerQueue.push(action.payload);
        },
        removeFirstNewsTickerItemFromQueue: (state)=>{
            state.newsTickerQueue.shift();
        },
        setNewsTickerTag: (state, action)=>{
            state.newsTickerTag = action.payload;
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($894e9b3b77168f2f$export$165373646bd00c5b.pending, (state)=>{
            state.isLoadingPastMessages = true;
            state.loadingPastMessagesError = undefined;
        });
        builder.addCase($894e9b3b77168f2f$export$165373646bd00c5b.fulfilled, (state, action)=>{
            state.isLoadingPastMessages = false;
            state.roomId = action.payload[0];
            state.messages = action.payload[1];
            state.loadingPastMessagesError = undefined;
        });
        builder.addCase($894e9b3b77168f2f$export$165373646bd00c5b.rejected, (state, action)=>{
            state.isLoadingPastMessages = false;
            state.loadingPastMessagesError = action.error.message;
        });
        builder.addCase($894e9b3b77168f2f$export$8fd5706e716dbba.pending, (state)=>{
            state.isMessageSubmitting = true;
            state.messageSubmittingError = undefined;
        });
        builder.addCase($894e9b3b77168f2f$export$8fd5706e716dbba.fulfilled, (state)=>{
            state.isMessageSubmitting = false;
            state.messageSubmittingError = undefined;
        });
        builder.addCase($894e9b3b77168f2f$export$8fd5706e716dbba.rejected, (state, action)=>{
            state.isMessageSubmitting = false;
            state.messageSubmittingError = action.error.message;
        });
        builder.addCase($894e9b3b77168f2f$export$374ea87e421dfcbd.rejected, (_, action)=>{
            console.error(action.error);
        });
        builder.addCase($894e9b3b77168f2f$export$abf5a3bc7da4a0e8.fulfilled, (state, action)=>{
            state.availableReactions = action.payload;
        });
        builder.addCase($894e9b3b77168f2f$export$df4a6caaec0ed72.pending, (state, action)=>{
            const id = action.meta.arg;
            state.storedEvents[id] = {
                lastFetched: Date.now(),
                data: null
            };
        });
        builder.addCase($894e9b3b77168f2f$export$df4a6caaec0ed72.fulfilled, (state, action)=>{
            // If data is for current event, update the participants to update event status UI
            if (state.currentEvent && state.currentEvent?.eventID === action.payload.eventData.eventID) {
                const event = {
                    ...state.currentEvent,
                    participants: action.payload.eventData.participants
                };
                state.currentEvent = event;
            }
            const id = action.meta.arg;
            state.storedEvents[id] = {
                lastFetched: state.storedEvents?.[id]?.lastFetched ?? Date.now(),
                data: action.payload
            };
        });
    }
});
const { addItem: $894e9b3b77168f2f$export$fb9705de59d96855, updateItem: $894e9b3b77168f2f$export$72b8c6d38aa6195b, updateMessageReaction: $894e9b3b77168f2f$export$8ef646fc7ce1e61a, removeItem: $894e9b3b77168f2f$export$fe2d9b4e03920b4c, openModerationAction: $894e9b3b77168f2f$export$15c5b98f35a1b493, closeModerationAction: $894e9b3b77168f2f$export$af5cffdacb983b8b, updateFeedProfile: $894e9b3b77168f2f$export$49016349ee22be52, addItemsToTop: $894e9b3b77168f2f$export$4af234c3811a0f9a, setCurrentEvent: $894e9b3b77168f2f$export$1823a1e5a4a9f912, clearCurrentEvent: $894e9b3b77168f2f$export$3d0654350350f0e1, updateEventParticipant: $894e9b3b77168f2f$export$3a83b7b6b9b90ee8, setCurrentEventIsActive: $894e9b3b77168f2f$export$f5becc12572fad3c, queueNewsTickerItem: $894e9b3b77168f2f$export$2475777bb1976781, removeFirstNewsTickerItemFromQueue: $894e9b3b77168f2f$export$a26bb05919391d5d, setNewsTickerTag: $894e9b3b77168f2f$export$6bfb177ddaeee246 } = $894e9b3b77168f2f$var$feed.actions;
const { reducer: $894e9b3b77168f2f$export$c4bc848778eef518 } = $894e9b3b77168f2f$var$feed;

});

parcelRegister("gxeM7", function(module, exports) {

$parcel$export(module.exports, "setQuestStatus", function () { return $ffc90010fd8a08f6$export$d9c581ded82a5d9d; });
$parcel$export(module.exports, "setWindowSize", function () { return $ffc90010fd8a08f6$export$1c6a7f8bbb9bfe58; });
$parcel$export(module.exports, "setDiscordLocale", function () { return $ffc90010fd8a08f6$export$3c430e1d7e112f9a; });
$parcel$export(module.exports, "setDiscordUser", function () { return $ffc90010fd8a08f6$export$d3f4f565c8728e6c; });
$parcel$export(module.exports, "setQuestFromSDK", function () { return $ffc90010fd8a08f6$export$5d60a177a7e401f0; });
$parcel$export(module.exports, "default", function () { return $ffc90010fd8a08f6$export$2e2bcd8739ae039; });

var $61p16 = parcelRequire("61p16");
const $ffc90010fd8a08f6$var$initialState = {
    questStatus: undefined,
    windowSize: 'maximized',
    locale: undefined
};
const $ffc90010fd8a08f6$export$170ce47b0e55421b = $ffc90010fd8a08f6$var$initialState;
const $ffc90010fd8a08f6$var$discord = (0, $61p16.createSlice)({
    name: 'discord',
    initialState: $ffc90010fd8a08f6$var$initialState,
    reducers: {
        setQuestFromSDK (state, action) {
            const payload = action.payload;
            state.questId = payload.quest_id;
            state.questCTAURL = payload.external_cta_url;
            state.questStatusChecked = true;
            if (payload.completed_at) state.questStatus = 'completed';
            else if (payload.enrolled_at) state.questStatus = 'enrolled';
            else state.questStatus = 'not_enrolled';
        },
        setQuestStatus (state, action) {
            state.questStatus = action.payload;
            state.questStatusChecked = true;
        },
        setWindowSize (state, action) {
            state.windowSize = action.payload;
        },
        setDiscordLocale (state, action) {
            state.locale = action.payload;
        },
        setDiscordUser (state, action) {
            state.user = action.payload;
        }
    },
    extraReducers: (builder)=>{}
});
const { setQuestStatus: $ffc90010fd8a08f6$export$d9c581ded82a5d9d, setWindowSize: $ffc90010fd8a08f6$export$1c6a7f8bbb9bfe58, setDiscordLocale: $ffc90010fd8a08f6$export$3c430e1d7e112f9a, setDiscordUser: $ffc90010fd8a08f6$export$d3f4f565c8728e6c, setQuestFromSDK: $ffc90010fd8a08f6$export$5d60a177a7e401f0 } = $ffc90010fd8a08f6$var$discord.actions;
const { actions: $ffc90010fd8a08f6$export$24ff1a8c3ea9d8d6, reducer: $ffc90010fd8a08f6$export$6aeaca12df723c2b } = $ffc90010fd8a08f6$var$discord;
var $ffc90010fd8a08f6$export$2e2bcd8739ae039 = $ffc90010fd8a08f6$export$6aeaca12df723c2b;

});


parcelRegister("7v5wN", function(module, exports) {

$parcel$export(module.exports, "useTheme", function () { return $44cbee537bb88b76$export$93d4e7f90805808f; });
$parcel$export(module.exports, "ThemeStylesProvider", function () { return $44cbee537bb88b76$export$933d196347d99b1f; });

var $9h2J6 = parcelRequire("9h2J6");

var $i2KZ1 = parcelRequire("i2KZ1");
const $44cbee537bb88b76$export$93d4e7f90805808f = ()=>{
    const theme = (0, $i2KZ1.useAppSelector)((state)=>state.app.theme);
    return theme;
};
function $44cbee537bb88b76$export$933d196347d99b1f() {
    const theme = $44cbee537bb88b76$export$93d4e7f90805808f();
    return /*#__PURE__*/ (0, $9h2J6.jsx)("style", {
        children: `
                :root {
                    color: ${theme.tokens.AccentTheme1TextTextDefault};

                    --font-primary: '${theme.fonts.primary}';
                    --font-secondary: '${theme.fonts.secondary}';
                    --font-tertiary: '${theme.fonts.tertiary}';
                    --font-quaternary: '${theme.fonts.quaternary}';
                    
                    --token-arise-theme-1-rarity-rarity-common-light: ${theme.tokens.AriseTheme1RarityRarityCommonLight};
                    --token-arise-theme-1-rarity-rarity-common-mid: ${theme.tokens.AriseTheme1RarityRarityCommonMid};
                    --token-arise-theme-1-rarity-rarity-common-dark: ${theme.tokens.AriseTheme1RarityRarityCommonDark};
                    --token-arise-theme-1-rarity-rarity-uncommon-light: ${theme.tokens.AriseTheme1RarityRarityUncommonLight};
                    --token-arise-theme-1-rarity-rarity-uncommon-mid: ${theme.tokens.AriseTheme1RarityRarityUncommonMid};
                    --token-arise-theme-1-rarity-rarity-uncommon-dark: ${theme.tokens.AriseTheme1RarityRarityUncommonDark};
                    --token-arise-theme-1-rarity-rarity-rare-light: ${theme.tokens.AriseTheme1RarityRarityRareLight};
                    --token-arise-theme-1-rarity-rarity-rare-mid: ${theme.tokens.AriseTheme1RarityRarityRareMid};
                    --token-arise-theme-1-rarity-rarity-rare-dark: ${theme.tokens.AriseTheme1RarityRarityRareDark};
                    --token-arise-theme-1-rarity-rarity-epic-light: ${theme.tokens.AriseTheme1RarityRarityEpicLight};
                    --token-arise-theme-1-rarity-rarity-epic-mid: ${theme.tokens.AriseTheme1RarityRarityEpicMid};
                    --token-arise-theme-1-rarity-rarity-epic-dark: ${theme.tokens.AriseTheme1RarityRarityEpicDark};
                    --token-arise-theme-1-rarity-rarity-legendary-light: ${theme.tokens.AriseTheme1RarityRarityLegendaryLight};
                    --token-arise-theme-1-rarity-rarity-legendary-mid: ${theme.tokens.AriseTheme1RarityRarityLegendaryMid};
                    --token-arise-theme-1-rarity-rarity-legendary-dark: ${theme.tokens.AriseTheme1RarityRarityLegendaryDark};
                    --token-arise-theme-1-state-state-error-light: ${theme.tokens.AriseTheme1StateStateErrorLight};
                    --token-arise-theme-1-state-state-error-mid: ${theme.tokens.AriseTheme1StateStateErrorMid};
                    --token-arise-theme-1-state-state-error-dark: ${theme.tokens.AriseTheme1StateStateErrorDark};
                    --token-arise-theme-1-state-state-success-light: ${theme.tokens.AriseTheme1StateStateSuccessLight};
                    --token-arise-theme-1-state-state-success-mid: ${theme.tokens.AriseTheme1StateStateSuccessMid};
                    --token-arise-theme-1-state-state-success-dark: ${theme.tokens.AriseTheme1StateStateSuccessDark};
                    --token-arise-theme-1-state-state-default-light: ${theme.tokens.AriseTheme1StateStateDefaultLight};
                    --token-arise-theme-1-state-state-default-mid: ${theme.tokens.AriseTheme1StateStateDefaultMid};
                    --token-arise-theme-1-state-state-default-dark: ${theme.tokens.AriseTheme1StateStateDefaultDark};
                    --token-arise-theme-1-updates-updates-positive-light: ${theme.tokens.AriseTheme1UpdatesUpdatesPositiveLight};
                    --token-arise-theme-1-updates-updates-positive-mid: ${theme.tokens.AriseTheme1UpdatesUpdatesPositiveMid};
                    --token-arise-theme-1-updates-updates-positive-dark: ${theme.tokens.AriseTheme1UpdatesUpdatesPositiveDark};
                    --token-arise-theme-1-updates-updates-general-light: ${theme.tokens.AriseTheme1UpdatesUpdatesGeneralLight};
                    --token-arise-theme-1-updates-updates-general-mid: ${theme.tokens.AriseTheme1UpdatesUpdatesGeneralMid};
                    --token-arise-theme-1-updates-updates-general-dark: ${theme.tokens.AriseTheme1UpdatesUpdatesGeneralDark};
                    --token-arise-theme-1-updates-updates-achievement-light: ${theme.tokens.AriseTheme1UpdatesUpdatesAchievementLight};
                    --token-arise-theme-1-updates-updates-achievement-mid: ${theme.tokens.AriseTheme1UpdatesUpdatesAchievementMid};
                    --token-arise-theme-1-updates-updates-achievement-dark: ${theme.tokens.AriseTheme1UpdatesUpdatesAchievementDark};
                    --token-arise-theme-1-updates-updates-negative-light: ${theme.tokens.AriseTheme1UpdatesUpdatesNegativeLight};
                    --token-arise-theme-1-updates-updates-negative-mid: ${theme.tokens.AriseTheme1UpdatesUpdatesNegativeMid};
                    --token-arise-theme-1-updates-updates-negative-dark: ${theme.tokens.AriseTheme1UpdatesUpdatesNegativeDark};
                    --token-accent-theme-1-interface-mono-interface-white: ${theme.tokens.AccentTheme1InterfaceMonoInterfaceMonoWhite};
                    --token-accent-theme-1-interface-mono-interface-active: ${theme.tokens.AccentTheme1InterfaceMonoInterfaceMonoActive};
                    --token-accent-theme-1-interface-mono-interface-foreground: ${theme.tokens.AccentTheme1InterfaceMonoInterfaceMonoForeground};
                    --token-accent-theme-1-interface-mono-interface-midground: ${theme.tokens.AccentTheme1InterfaceMonoInterfaceMonoMidground};
                    --token-accent-theme-1-interface-mono-interface-background: ${theme.tokens.AccentTheme1InterfaceMonoInterfaceMonoBackground};
                    --token-accent-theme-1-interface-mono-interface-black: ${theme.tokens.AccentTheme1InterfaceMonoInterfaceMonoBlack};
                    --token-accent-theme-1-interface-brand-interface-active: ${theme.tokens.AccentTheme1InterfaceBrandInterfaceActive};
                    --token-accent-theme-1-interface-brand-interface-foreground: ${theme.tokens.AccentTheme1InterfaceBrandInterfaceForeground};
                    --token-accent-theme-1-interface-brand-interface-midground: ${theme.tokens.AccentTheme1InterfaceBrandInterfaceMidground};
                    --token-accent-theme-1-interface-brand-interface-background: ${theme.tokens.AccentTheme1InterfaceBrandInterfaceBackground};
                    --token-accent-theme-1-border-border-default: ${theme.tokens.AccentTheme1BorderBorderDefault};
                    --token-accent-theme-1-border-border-highlight: ${theme.tokens.AccentTheme1BorderBorderHighlight};
                    --token-accent-theme-1-border-border-inactive: ${theme.tokens.AccentTheme1BorderBorderInactive};
                    --token-accent-theme-1-border-border-active: ${theme.tokens.AccentTheme1BorderBorderActive};
                    --token-accent-theme-1-brand-palette-brand-accent-1: ${theme.tokens.AccentTheme1BrandPaletteBrandAccent1};
                    --token-accent-theme-1-brand-palette-brand-accent-2: ${theme.tokens.AccentTheme1BrandPaletteBrandAccent2};
                    --token-accent-theme-1-brand-palette-brand-contrast-1: ${theme.tokens.AccentTheme1BrandPaletteBrandContrast1};
                    --token-accent-theme-1-brand-palette-brand-contrast-2: ${theme.tokens.AccentTheme1BrandPaletteBrandContrast2};
                    --token-accent-theme-1-brand-palette-brand-scale-1: ${theme.tokens.AccentTheme1BrandPaletteBrandScale1};
                    --token-accent-theme-1-brand-palette-brand-scale-2: ${theme.tokens.AccentTheme1BrandPaletteBrandScale2};
                    --token-accent-theme-1-brand-palette-brand-scale-3: ${theme.tokens.AccentTheme1BrandPaletteBrandScale3};
                    --token-accent-theme-1-brand-palette-brand-colour: ${theme.tokens.AccentTheme1BrandPaletteBrandColour};
                    --token-accent-theme-1-brand-palette-brand-colour-contrast: ${theme.tokens.AccentTheme1BrandPaletteBrandColourContrast};
                    --token-accent-theme-1-button-button-default: ${theme.tokens.AccentTheme1ButtonButtonDefault};
                    --token-accent-theme-1-button-button-highlight: ${theme.tokens.AccentTheme1ButtonButtonHighlight};
                    --token-accent-theme-1-button-button-active: ${theme.tokens.AccentTheme1ButtonButtonActive};
                    --token-accent-theme-1-button-button-inactive: ${theme.tokens.AccentTheme1ButtonButtonInactive};
                    --token-accent-theme-1-button-button-secondary-default: ${theme.tokens.AccentTheme1ButtonButtonSecondaryDefault};
                    --token-accent-theme-1-button-button-secondary-highlight: ${theme.tokens.AccentTheme1ButtonButtonSecondaryHighlight};
                    --token-accent-theme-1-button-button-secondary-active: ${theme.tokens.AccentTheme1ButtonButtonSecondaryActive};
                    --token-accent-theme-1-button-button-secondary-inactive: ${theme.tokens.AccentTheme1ButtonButtonSecondaryInactive};
                    --token-accent-theme-1-text-text-default: ${theme.tokens.AccentTheme1TextTextDefault};
                    --token-accent-theme-1-text-text-inactive: ${theme.tokens.AccentTheme1TextTextInactive};
                    --token-accent-theme-1-text-text-brand-2: ${theme.tokens.AccentTheme1TextTextBrand2};
                    --token-accent-theme-1-text-text-brand-1: ${theme.tokens.AccentTheme1TextTextBrand1};
                    --token-accent-theme-1-text-text-contrast-default: ${theme.tokens.AccentTheme1TextTextContrastDefault};
                    --token-accent-theme-1-text-text-link: ${theme.tokens.AccentTheme1TextTextLink};
                    --token-LEGACY-accent-theme-1-button-button-secondary: ${theme.tokens.LEGACYAccentTheme1ButtonButtonSecondary};
                    --token-LEGACY-accent-theme-1-text-text-active: ${theme.tokens.LEGACYAccentTheme1TextTextActive};
                    --token-LEGACY-accent-theme-1-text-text-secondary: ${theme.tokens.LEGACYAccentTheme1TextTextSecondary};
                    --token-LEGACY-accent-theme-1-interface-interface-active: ${theme.tokens.LEGACYAccentTheme1InterfaceInterfaceActive};
                    --token-LEGACY-accent-theme-1-interface-interface-foreground: ${theme.tokens.LEGACYAccentTheme1InterfaceInterfaceForeground};
                    --token-LEGACY-accent-theme-1-interface-interface-midground: ${theme.tokens.LEGACYAccentTheme1InterfaceInterfaceMidground};
                    --token-LEGACY-accent-theme-1-interface-interface-background: ${theme.tokens.LEGACYAccentTheme1InterfaceInterfaceBackground};
                    --token-LEGACY-accent-theme-1-interface-interface-white: ${theme.tokens.LEGACYAccentTheme1InterfaceInterfaceWhite};
                    --token-LEGACY-accent-theme-1-interface-interface-grey: ${theme.tokens.LEGACYAccentTheme1InterfaceInterfaceGrey};
                    --token-LEGACY-accent-theme-1-interface-interface-black: ${theme.tokens.LEGACYAccentTheme1InterfaceInterfaceBlack};
                    --token-LEGACY-accent-theme-1-brand-colour: ${theme.tokens.LEGACYAccentTheme1BrandColour};
                    --token-LEGACY-accent-theme-1-brand-colour-contrast: ${theme.tokens.LEGACYAccentTheme1BrandColourContrast};

                    --token-system-brand: #FF3319;
                    --token-system-brand-mono: #2E3035;
                    --token-system-text-default: #FFFFFF;
                    --token-system-text-alt: #ADADAD;
                    --token-system-interface-background: #141414;
                    --token-system-interface-midground: #282828;
                    --token-system-interface-foreground: #D9D9D9;
                    --token-system-interface-foreground-alt: #3A3A3A;
                    --token-system-state-error: #D81818;

                }
            `
    });
}

});

parcelRegister("9S5u4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5f1ad228668651f$export$2e2bcd8739ae039; });

var $9h2J6 = parcelRequire("9h2J6");

var $dSVwS = parcelRequire("dSVwS");
const $d5f1ad228668651f$export$6b94091403a35c61 = [
    'animated-spinner',
    'sound',
    'chat',
    'close',
    'send',
    'locked',
    'padlock',
    'play',
    'world',
    'inventory',
    'emoji',
    'arrow-downward',
    'arrow-left',
    'arrow-back',
    'menu',
    'settings',
    'profile',
    'challenge',
    'crown',
    'character',
    'backdrop',
    'faction',
    'avatar',
    'priority',
    'edit',
    'info',
    'shop',
    'box',
    'supplies',
    'bolt',
    'help',
    'pin',
    'action',
    'support',
    'life',
    'lock_open',
    'grade',
    'hand',
    'inspect',
    'fire',
    'share',
    'discord',
    'wreath',
    'shield',
    'checked-box',
    'leaderboard',
    'skull',
    'translation',
    'copy',
    'muted',
    'unmuted',
    'refresh'
];
function $d5f1ad228668651f$export$2e2bcd8739ae039({ type: type, size: size, style: style, ...props }) {
    const lowerCaseType = typeof type === 'string' ? type.toLowerCase() : '';
    function getIcon() {
        switch(lowerCaseType){
            case 'animated-spinner':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("circle", {
                    className: $dSVwS.spinner,
                    cx: "12",
                    cy: "12",
                    r: "9",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "2.5",
                    strokeLinecap: "round",
                    strokeDasharray: "42 14"
                });
            case 'sound':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M14 20.7246V18.6746C15.5 18.2413 16.7083 17.4079 17.625 16.1746C18.5417 14.9413 19 13.5413 19 11.9746C19 10.4079 18.5417 9.00794 17.625 7.77461C16.7083 6.54128 15.5 5.70794 14 5.27461V3.22461C16.0667 3.69128 17.75 4.73711 19.05 6.36211C20.35 7.98711 21 9.85794 21 11.9746C21 14.0913 20.35 15.9621 19.05 17.5871C17.75 19.2121 16.0667 20.2579 14 20.7246ZM3 14.9996V8.99961H7L12 3.99961V19.9996L7 14.9996H3ZM14 15.9996V7.94961C14.7833 8.31628 15.3958 8.86628 15.8375 9.59961C16.2792 10.3329 16.5 11.1329 16.5 11.9996C16.5 12.8496 16.2792 13.6371 15.8375 14.3621C15.3958 15.0871 14.7833 15.6329 14 15.9996ZM10 8.84961L7.85 10.9996H5V12.9996H7.85L10 15.1496V8.84961Z"
                });
            case 'chat':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M12 1.5C6.1993 1.5 1.5 5.16836 1.5 9.69165C1.5 12.1631 2.90979 14.3781 5.13462 15.8781C5.13462 17.5491 5.03182 19.632 4.62063 21.575C4.48846 22.2045 5.12727 22.7175 5.67063 22.4066C7.82937 21.1708 9.89266 19.6009 11.6182 17.8677C11.7503 17.8677 11.8752 17.8833 12 17.8833C17.8007 17.8833 22.5 14.2149 22.5 9.69165C22.5 5.16836 17.7934 1.5 12 1.5ZM8.16713 8.33155C8.87937 8.33155 9.45944 8.94554 9.45944 9.69942C9.45944 10.4533 8.87937 11.0673 8.16713 11.0673C7.4549 11.0673 6.87483 10.4533 6.87483 9.69942C6.87483 8.94554 7.4549 8.33155 8.16713 8.33155ZM12 11.0595C11.2878 11.0595 10.7077 10.4455 10.7077 9.69165C10.7077 8.93777 11.2878 8.32378 12 8.32378C12.7122 8.32378 13.2923 8.93777 13.2923 9.69165C13.2923 10.4455 12.7122 11.0595 12 11.0595ZM15.8329 11.0595C15.1206 11.0595 14.5406 10.4455 14.5406 9.69165C14.5406 8.93777 15.1206 8.32378 15.8329 8.32378C16.5451 8.32378 17.1252 8.93777 17.1252 9.69165C17.1252 10.4455 16.5451 11.0595 15.8329 11.0595Z"
                });
            case 'close':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M6.39984 19.1911L4.80859 17.5998L10.4086 11.9998L4.80859 6.39984L6.39984 4.80859L11.9998 10.4086L17.5998 4.80859L19.1911 6.39984L13.5911 11.9998L19.1911 17.5998L17.5998 19.1911L11.9998 13.5911L6.39984 19.1911Z"
                });
            case 'send':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M3 20V14L11 12L3 10V4L22 12L3 20Z"
                });
            case 'locked':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M5.49862 2.92828L6.55104 2L8.71794 5.49104L5.49862 2.92828ZM19.4766 11.2814L19.5262 12.4717H19.5235L19.5869 14.291L17.9511 15.5007L17.5938 16.9021L17.2324 18.2759L17.5207 18.8262L17.1718 20.2883L15.6559 20.6938L14.1649 21.1821L12.6393 21.5407L11.14 22L10.0614 21.6869L9.8007 21.6083L8.73449 21.2841L7.68346 20.1241L6.65173 18.9448L5.60207 17.7834L4.5 16.6607L4.98276 15.2289L5.56483 14.9421L5.95242 13.5627L6.39932 12.182L5.61587 10.2882L6.69863 8.80824L7.33173 7.7972C7.6807 7.66341 7.92484 7.56962 8.2738 7.43444L8.80898 7.58617L11.5083 8.411L13.4517 8.88824L13.7042 8.99583L15.6145 9.59307L15.9318 9.68273L16.2821 8.46479C16.3538 8.21376 16.3759 7.95169 16.3456 7.69238L16.238 6.77375C16.1966 6.41375 16.009 6.08823 15.7193 5.8703L15.1097 5.41237C14.8352 5.20547 14.4918 5.11306 14.1511 5.15444L13.4049 5.24409C13.0545 5.28547 12.7359 5.46616 12.5193 5.7434L11.9648 6.45513C11.9627 6.45831 11.9608 6.46149 11.9589 6.46459C11.9559 6.46956 11.9531 6.47433 11.9497 6.47858L9.86553 5.88134L10.5676 4.66064L11.8862 3.55857L13.518 3.01374L15.2297 3.18202L16.7621 3.95443L17.918 5.24271L18.4407 6.90065L18.3069 8.63445L17.8587 10.04L17.8035 10.211L18.8628 10.5062L19.17 10.8941L19.4766 11.2814ZM12.6283 17.7614L13.0352 14.502L14.4655 13.7089L12.9773 11.0234L10.2917 12.5117L11.0848 13.942L9.70277 16.9227L12.6283 17.7614ZM7.74138 6.2041L5.10965 6.01375L5.18413 7.04548L7.74138 6.2041ZM8.96348 3.15455L9.83244 2.99179L9.70279 4.54351L8.96348 3.15455Z"
                });
            case 'padlock':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V10C4 9.45 4.19583 8.97917 4.5875 8.5875C4.97917 8.19583 5.45 8 6 8H7V6C7 4.61667 7.4875 3.4375 8.4625 2.4625C9.4375 1.4875 10.6167 1 12 1C13.3833 1 14.5625 1.4875 15.5375 2.4625C16.5125 3.4375 17 4.61667 17 6V8H18C18.55 8 19.0208 8.19583 19.4125 8.5875C19.8042 8.97917 20 9.45 20 10V20C20 20.55 19.8042 21.0208 19.4125 21.4125C19.0208 21.8042 18.55 22 18 22H6ZM12 17C12.55 17 13.0208 16.8042 13.4125 16.4125C13.8042 16.0208 14 15.55 14 15C14 14.45 13.8042 13.9792 13.4125 13.5875C13.0208 13.1958 12.55 13 12 13C11.45 13 10.9792 13.1958 10.5875 13.5875C10.1958 13.9792 10 14.45 10 15C10 15.55 10.1958 16.0208 10.5875 16.4125C10.9792 16.8042 11.45 17 12 17ZM9 8H15V6C15 5.16667 14.7083 4.45833 14.125 3.875C13.5417 3.29167 12.8333 3 12 3C11.1667 3 10.4583 3.29167 9.875 3.875C9.29167 4.45833 9 5.16667 9 6V8Z"
                });
            case 'play':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M9.5 16.5L16.5 12L9.5 7.5V16.5ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z"
                });
            case 'world':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M19.2677 4.39586C19.2221 4.34094 19.1866 4.28602 19.141 4.2311L19.1157 4.26106C17.2411 2.55349 14.7434 1.5 11.9975 1.5C6.2117 1.5 1.5 6.14337 1.5 11.8452C1.5 17.5471 6.20157 22.5 11.9772 22.5C17.7782 22.5 22.5 17.7218 22.5 11.8452C22.5 8.9194 21.2587 6.27817 19.2677 4.39586ZM11.9721 20.413C10.0013 20.413 8.19771 19.704 6.769 18.5307L6.59168 17.4422L6.80953 15.2454L7.04258 13.3281L5.93305 13.1933L4.53981 12.9037L3.73426 13.1534C3.68359 12.8238 3.6532 12.4843 3.638 12.1448C3.82545 12.5442 3.98251 12.8638 3.98251 12.8638L4.29662 11.5007L5.37575 11.3609L7.42256 11.2011L8.63848 10.9615L9.00832 8.75464L8.16731 6.34807L7.62015 5.30956C7.29083 5.3495 6.97165 5.40942 6.64741 5.47932C8.09638 4.29601 9.9608 3.58203 11.9873 3.58203C14.0139 3.58203 15.8428 4.28602 17.2867 5.44936L13.4414 6.22825L13.0969 7.2418L13.9075 7.65621L13.8112 8.07061L11.0602 9.30884L11.4098 10.0728L11.9975 9.87803L12.9449 9.60342L13.8366 10.2126L14.5965 10.0877L15.8226 10.5621L14.1 11.9151L12.4889 11.1512L11.1615 11.6755L10.3104 13.2981L11.0703 14.6812L12.7372 15.0806L13.8112 17.3074L15.5034 18.2261L16.2329 16.913L16.5268 15.6198L17.003 13.7325C17.4489 13.6476 18.4571 13.4629 18.4571 13.418C18.4571 13.383 18.0112 12.5742 17.7072 12.0349L19.369 12.5442L20.2049 13.5278C19.4399 17.4572 16.0404 20.428 11.9721 20.428V20.413Z"
                });
            case 'inventory':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M21.969 14.2711C21.6312 13.2773 20.5632 13.0609 19.5797 13.115C19.4555 12.6181 19.3065 12.1311 19.1127 11.6686C19.1028 11.649 18.7253 10.7881 18.3825 10.2075C19.1724 8.67758 19.4456 6.04564 19.1227 5.67667C18.77 5.36182 18.1193 4.78132 15.417 4.51567C15.4269 4.47139 15.4319 4.42711 15.4418 4.38776C15.5462 3.82693 15.6852 3.05457 15.1438 2.41011C14.6222 1.79025 13.6089 1.5 11.9547 1.5C10.3006 1.5 9.31208 1.79517 8.81534 2.42487C8.28879 3.09392 8.48252 3.87121 8.62161 4.44187C8.62657 4.46155 8.63154 4.48615 8.63651 4.51075C5.88954 4.7764 5.23384 5.3569 4.87619 5.67667C4.55828 6.0358 4.81658 8.59887 5.58156 10.1338C5.23384 10.6995 4.81658 11.6391 4.80665 11.6637C4.61292 12.1262 4.4639 12.6132 4.34468 13.1051C3.381 13.0658 2.35772 13.3019 2.02987 14.2662C1.58281 15.5797 1.27979 17.272 1.70202 18.8511C1.92059 19.6629 2.924 20.0909 4.01186 20.3024C4.61789 22.7572 7.85166 22.4916 11.9597 22.4916C16.0677 22.4916 19.3512 22.7523 19.987 20.3024C21.0749 20.0909 22.0783 19.6629 22.2969 18.8511C22.7191 17.272 22.421 15.5797 21.969 14.2662V14.2711ZM9.85352 3.24151C9.933 3.14312 10.3155 2.82335 11.9498 2.82335C13.584 2.82335 14.0063 3.12836 14.1205 3.26119C14.2546 3.41861 14.2099 3.7187 14.1305 4.16146C14.1155 4.25001 14.0957 4.34348 14.0857 4.43203C13.4698 4.40252 12.7843 4.38284 12.0044 4.38284C11.2245 4.38284 10.5788 4.3976 9.98267 4.42711C9.96281 4.32872 9.93797 4.23033 9.91313 4.13686C9.82372 3.77774 9.7343 3.40877 9.85849 3.24151H9.85352ZM10.6831 13.4397C10.3552 13.4397 10.1118 13.1986 10.1118 12.9034V11.1275C10.1118 10.9455 10.2608 10.7979 10.4446 10.7979C10.6284 10.7979 10.7775 10.9455 10.7775 11.1275V12.4804H11.6666V12.2393C11.6666 12.0573 11.8156 11.9097 11.9994 11.9097C12.1832 11.9097 12.3323 12.0573 12.3323 12.2393V12.4804H13.2214V11.1275C13.2214 10.9455 13.3704 10.7979 13.5542 10.7979C13.738 10.7979 13.887 10.9455 13.887 11.1275V12.9034C13.887 13.1986 13.6436 13.4397 13.3158 13.4397H12.3323V13.5823C12.3323 13.7644 12.1832 13.9119 11.9994 13.9119C11.8156 13.9119 11.6666 13.7644 11.6666 13.5823V13.4397H10.6831ZM17.9752 18.5166C17.9752 19.5989 17.0861 20.4795 15.9932 20.4795H8.00565C6.91282 20.4795 6.02366 19.5989 6.02366 18.5166V12.3525H7.10655V18.5166C7.10655 19.0086 7.50891 19.407 8.00565 19.407H15.9932C16.49 19.407 16.8923 19.0086 16.8923 18.5166V12.3525H17.9752V18.5166Z"
                });
            case 'emoji':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M20 7V5H18V3H20V1H22V3H24V5H22V7H20ZM15.5 11C15.9167 11 16.2708 10.8542 16.5625 10.5625C16.8542 10.2708 17 9.91667 17 9.5C17 9.08333 16.8542 8.72917 16.5625 8.4375C16.2708 8.14583 15.9167 8 15.5 8C15.0833 8 14.7292 8.14583 14.4375 8.4375C14.1458 8.72917 14 9.08333 14 9.5C14 9.91667 14.1458 10.2708 14.4375 10.5625C14.7292 10.8542 15.0833 11 15.5 11ZM8.5 11C8.91667 11 9.27083 10.8542 9.5625 10.5625C9.85417 10.2708 10 9.91667 10 9.5C10 9.08333 9.85417 8.72917 9.5625 8.4375C9.27083 8.14583 8.91667 8 8.5 8C8.08333 8 7.72917 8.14583 7.4375 8.4375C7.14583 8.72917 7 9.08333 7 9.5C7 9.91667 7.14583 10.2708 7.4375 10.5625C7.72917 10.8542 8.08333 11 8.5 11ZM12 17.5C13.1333 17.5 14.1625 17.1792 15.0875 16.5375C16.0125 15.8958 16.6833 15.05 17.1 14H6.9C7.31667 15.05 7.9875 15.8958 8.9125 16.5375C9.8375 17.1792 10.8667 17.5 12 17.5ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C12.7167 2 13.4083 2.07083 14.075 2.2125C14.7417 2.35417 15.3833 2.55833 16 2.825V7H18V9H21.55C21.7 9.48333 21.8125 9.97083 21.8875 10.4625C21.9625 10.9542 22 11.4667 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z"
                });
            case 'arrow-downward':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M11 4V16.175L5.4 10.575L4 12L12 20L20 12L18.6 10.575L13 16.175V4H11Z"
                });
            case 'arrow-left':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M14 17L9 12L14 7V17Z"
                });
            case 'arrow-back':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M7.825 13L13.425 18.6L12 20L4 12L12 4L13.425 5.4L7.825 11H20V13H7.825Z"
                });
            case 'menu':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M3 18V16H21V18H3ZM3 13V11H21V13H3ZM3 8V6H21V8H3Z"
                });
            case 'settings':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M9.25 22L8.85 18.8C8.63333 18.7167 8.42916 18.6167 8.2375 18.5C8.04583 18.3833 7.85833 18.2583 7.675 18.125L4.7 19.375L1.95 14.625L4.525 12.675C4.50833 12.5583 4.5 12.4458 4.5 12.3375V11.6625C4.5 11.5542 4.50833 11.4417 4.525 11.325L1.95 9.375L4.7 4.625L7.675 5.875C7.85833 5.74167 8.05 5.61667 8.25 5.5C8.45 5.38333 8.65 5.28333 8.85 5.2L9.25 2H14.75L15.15 5.2C15.3667 5.28333 15.5708 5.38333 15.7625 5.5C15.9542 5.61667 16.1417 5.74167 16.325 5.875L19.3 4.625L22.05 9.375L19.475 11.325C19.4917 11.4417 19.5 11.5542 19.5 11.6625V12.3375C19.5 12.4458 19.4833 12.5583 19.45 12.675L22.025 14.625L19.275 19.375L16.325 18.125C16.1417 18.2583 15.95 18.3833 15.75 18.5C15.55 18.6167 15.35 18.7167 15.15 18.8L14.75 22H9.25ZM12.05 15.5C13.0167 15.5 13.8417 15.1583 14.525 14.475C15.2083 13.7917 15.55 12.9667 15.55 12C15.55 11.0333 15.2083 10.2083 14.525 9.525C13.8417 8.84167 13.0167 8.5 12.05 8.5C11.0667 8.5 10.2375 8.84167 9.5625 9.525C8.8875 10.2083 8.55 11.0333 8.55 12C8.55 12.9667 8.8875 13.7917 9.5625 14.475C10.2375 15.1583 11.0667 15.5 12.05 15.5Z"
                });
            case 'profile':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M16.2152 15.791C16.2152 15.791 16.1097 15.8112 15.9761 15.8985C15.9129 15.5022 15.8285 14.4344 15.8004 14.1591C15.9269 14.0449 16.1238 13.83 16.2503 13.6487C16.3768 13.4674 16.7564 12.2787 16.8619 11.7616C16.9252 11.775 17.0658 11.8892 17.2274 11.7952C17.3821 11.7079 17.5157 11.3251 17.6211 11.0699C17.7055 10.855 17.9375 10.0357 17.9867 9.7133C18.0359 9.38423 18.1554 8.96114 18.0218 8.83355C17.9234 8.74624 17.7547 8.53134 17.3329 8.71938C17.4102 8.11497 17.4032 6.2883 17.2204 5.12648C17.0376 3.97138 16.2784 3.27966 15.4419 2.55437C14.5983 1.82235 13.0236 1.5 12.2293 1.5C11.4349 1.5 9.86021 1.82907 9.01663 2.55437C8.17305 3.28638 7.42086 3.97138 7.23809 5.12648C7.05531 6.28158 7.04828 8.11497 7.12561 8.71938C6.70382 8.53134 6.53511 8.73953 6.43669 8.83355C6.30313 8.96114 6.42263 9.38423 6.47184 9.7133C6.52105 10.0424 6.75303 10.855 6.83739 11.0699C6.94284 11.3251 7.06937 11.7079 7.23106 11.7952C7.38572 11.8825 7.52631 11.7683 7.59661 11.7616C7.70206 12.2787 8.08167 13.4674 8.2082 13.6487C8.33474 13.83 8.53157 14.0516 8.65811 14.1591C8.62999 14.4344 8.54563 15.5022 8.48237 15.8985C8.3488 15.8112 8.23632 15.791 8.23632 15.791C8.23632 15.791 3.35061 17.5774 2.5 18.1079C4.80578 20.7875 8.30662 22.5 12.2222 22.5C16.1378 22.5 19.6387 20.7875 21.9444 18.1079C21.0938 17.5707 16.2081 15.791 16.2081 15.791H16.2152Z"
                });
            case 'challenge':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M19.723 12.3077L19.7263 12.3019L19.718 12.2991L19.723 12.3077ZM18.7885 13.9452L19.723 12.3077L20.0002 12.7888L19.9393 14.3464L18.0332 18.593L14.7853 14.706L14.1988 14.4127L12.9843 14.2827L12.7879 13.5026L12.3065 13.5662L11.9773 13.4472L12.7464 13.2453L13.2665 12.9742L13.676 11.6379L13.6013 10.6475C13.5819 10.3792 13.4657 10.1274 13.2776 9.93653L12.8571 9.51048L12.3342 9.33066C12.052 9.23383 11.7422 9.25597 11.4738 9.38876L10.8679 9.69031L10.6356 9.89226C10.3838 10.1081 10.2399 10.4234 10.2455 10.7554V11.6379L10.5858 12.9216L11.0616 13.2453L11.1363 13.2951L10.926 14.2606L10.7047 14.3685L9.74197 14.3242L9.03927 14.7198L7.08335 17.1073L6.05697 18.261L4.70138 16.6094L4.13978 14.8526L3.91016 11.1815L4.3113 9.36663L6.25616 6.57798L6.64901 6.37326L6.84266 9.47452L7.9133 10.5562L8.18995 10.5286L7.84691 8.76076L7.89947 6.96529L8.4832 5.29708L9.42382 3.78103L12.0437 1.24414L12.1405 1.43503L12.7464 4.39243L13.6234 5.57927L15.867 7.60989L17.621 10.1219L18.2186 13.1706L17.9917 14.7281L18.7885 13.9452ZM19.682 8.65296L19.5547 10.2326L18.7801 10.0667L18.2683 8.11626L18.3236 7.25034L19.682 8.65296ZM15.5295 17.8849L16.3788 18.6761L17.0815 19.2709L17.289 19.5282L14.2514 22.0983L12.052 23.2547L12.0714 22.765L14.0245 21.296L14.3067 17.3703L13.9886 16.5957L15.5295 17.8849ZM8.37254 18.0258L6.92565 19.1241L8.89817 21.08L9.77239 22.5877L9.65896 20.1643L9.50404 17.3812L9.82219 16.6536L8.37254 18.0258Z"
                });
            case 'crown':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M19.6458 8.94063L20.2658 8.06277L20.2629 8.07147L20.9003 7.2052L21.5 6.39397L21.4363 7.41669L21.2016 8.48287L21.1407 9.57223L20.8742 10.6326L20.7438 11.7104L20.6859 12.7997L20.512 13.8746L20.3585 14.9524L20.1586 15.9983L19.753 16.9978L19.0432 17.8206L18.116 18.3769L17.2324 18.9853L16.2531 19.4315L15.2101 19.7038L14.1526 19.8777L13.0923 20.0167L12.5765 19.8863L12.0956 20.1326L10.9512 20.0051L9.88792 19.8892L8.84202 19.6604L7.80192 19.3967L6.83715 18.9303L5.87816 18.4493L5.03507 17.783L4.35712 16.9515L3.89646 15.9925L3.70235 14.9466L3.55459 13.8688L3.3402 12.7997L3.31702 11.7046L3.1316 10.6326L2.9172 9.56354L2.83318 8.47708L2.64486 7.4051L2.5 6.29257L3.16926 7.17622L3.73422 8.09464L4.36871 8.96091L5.0032 9.80111L4.82357 11.102L4.76273 12.4318L4.80909 12.4057L5.24947 13.4458L5.9419 14.344L6.73864 15.1581L7.7208 15.7549L7.76715 14.2368L8.67978 13.9123L9.57213 13.4139L10.3022 12.6867L10.4819 11.693L10.3109 10.7224L9.63007 10.0184L8.69137 9.75765L7.76136 9.79821L8.35819 8.89718L8.91735 7.94978L9.61558 7.0951C9.61558 7.0951 10.1574 6.96183 10.2472 6.81407C10.3312 6.675 10.2008 6.16509 10.2008 6.16509L10.7745 5.22929L11.3684 4.30507L12.0145 3.40693V3.38955L12.0203 3.39824L12.0319 3.38086V3.41852L12.6171 4.34564L13.211 5.26985L13.8658 6.1535L14.4279 7.098L15.0826 7.98165L15.6534 8.92035L16.2647 9.80401L15.3521 9.78083L14.3931 9.98363L13.7036 10.7108L13.6572 11.0469C13.6572 11.0469 13.3327 11.1164 13.3009 11.2092C13.2574 11.3395 13.5703 11.6959 13.5703 11.6959L13.7992 12.6549L14.5148 13.3589L15.384 13.8688L16.3893 14.2078L16.3169 15.7578L17.299 15.1465L18.1334 14.37L18.8403 13.4719C18.8403 13.4719 19.0866 13.0373 19.133 12.9301C19.1434 12.9054 19.1922 12.9174 19.2437 12.9301C19.307 12.9457 19.3744 12.9623 19.3792 12.9127C19.3937 12.7099 19.2489 12.4347 19.2489 12.4347L19.1909 11.1049L18.962 9.78373L19.6458 8.94063ZM10.7455 16.2387L12.0753 18.5304L13.4023 16.2387L12.0753 13.7587L11.548 14.7438C11.522 14.793 11.5104 14.8452 11.5162 14.9002C11.5278 14.9987 11.5364 15.1668 11.5017 15.2247C11.4785 15.2624 11.4061 15.3029 11.3365 15.3348C11.2438 15.3783 11.1685 15.4478 11.1221 15.5376C11.1221 15.5376 11.1656 15.7607 11.1134 15.8013C11.0874 15.8186 10.9918 15.7781 10.9918 15.7781L10.7455 16.2387ZM7.58174 6.90981L6.165 4.9368L5.47256 7.50374L6.53874 8.62787L7.58174 6.90981ZM18.6231 7.54722L17.8147 5.00925L16.2328 6.90404L17.5018 8.6105L18.6231 7.54722Z"
                });
            case 'character':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M20.9792 18.246L19.9635 16.8458L18.1602 16.6116L15.225 16.8954L14.8864 16.79L17.2363 16.3232L14.8133 15.5696L14.5407 13.5289L12.6958 14.3647H11.9699V14.264L12.6958 14.1957L14.5106 13.2142L14.5192 13.2049L14.7243 13.0482C14.8664 12.9397 14.9596 12.7722 14.9826 12.5861L15.0156 12.3117L15.1461 11.6108L15.2853 11.2324L15.4029 10.6881L15.4201 10.1222L15.423 9.51895L15.5134 10.1004L15.6167 10.6525L15.7329 10.623C15.895 10.5827 16.0255 10.454 16.0786 10.2834L16.1733 9.98105L16.3483 9.39645L16.5865 8.83046L16.4401 8.33425C16.4401 8.33425 16.3397 7.95589 16.2393 7.90472C16.1245 7.8458 15.7429 8.02567 15.7429 8.02567L15.7486 7.53877L15.7458 7.03635L15.7372 6.37578L15.7271 5.87026L15.6497 5.37095L15.5234 4.8856L15.3269 4.43746L14.984 4.06685L14.5536 3.81875L14.1089 3.60476L13.6685 3.37991L13.2165 3.17833L12.7374 3.08374L12.2582 3.04342L11.7733 3L11.2827 3.01396L10.8294 3.22174L10.3631 3.37526L9.91551 3.58305L9.44783 3.75362L9.05618 4.0746L8.72191 4.44831L8.4852 4.87629L8.44216 5.38026L8.34604 5.87181L8.28435 6.37267L8.25423 7.03325L8.29009 7.53722V8.01482C8.29009 8.01482 7.89127 7.79307 7.7765 7.8644C7.67321 7.92643 7.64739 8.35596 7.64739 8.35596L7.45945 8.82891L7.64595 9.40886L7.88266 9.97019L7.93574 10.2307C7.98022 10.4431 8.14233 10.6044 8.34317 10.6308L8.45364 10.6463L8.48664 10.1454L8.5555 9.61975L8.58849 10.1702L8.71474 10.6726L8.75921 11.2278L8.92132 11.5999L8.99736 12.3148L9.10495 12.69C9.13221 12.7877 9.18099 12.8777 9.24554 12.9521L9.48799 13.2312L10.3086 13.9647L10.1766 14.0438L9.45787 13.5367L9.18673 15.5696L6.89565 16.2829L9.21111 16.79L8.91558 16.8815L5.83978 16.6116L4.03647 16.8458L3.02076 18.246L2.5 20.1688L11.9397 20.9891V21L12 20.9953L12.0603 21V20.9891L21.5 20.1688L20.9792 18.246Z"
                });
            case 'backdrop':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M18.5472 5.40563L15.0007 3.81341C15.0007 3.81341 10.6842 5.05517 9.46405 4.32829C9.42509 4.30524 9.21221 4.31539 8.97619 4.32664C8.59189 4.34497 8.14623 4.36621 8.29008 4.25185C8.9737 3.70669 10.4419 3.42257 10.4419 3.42257L10.7072 3.0101L9.33281 3C9.33281 3 7.34976 3.5293 6.48154 4.02542C6.16858 4.20425 5.43737 5.03497 5.43737 5.03497L4.33119 6.87958L3.35913 11.1385L3.75286 12.4869C3.75286 12.4869 4.01534 11.2697 4.26917 10.9639C4.35571 10.8587 4.77251 10.2962 4.77251 10.2962C4.77251 10.2962 4.07015 12.2893 4.54608 14.0287C4.56771 14.1065 4.39465 14.2969 4.39465 14.2969L4.10332 14.1859C4.10332 14.1859 3.00723 13.4431 2.81253 12.9138C2.64523 12.4595 2.28323 11.0303 2.28323 11.0303L1.78711 10.1967L1.81307 12.7566C1.81307 12.7566 2.47649 14.3935 2.95964 14.6459L5.3018 16.6564L5.61044 17.3357L7.89492 14.5464L8.91601 13.9695L10.3193 14.033L10.6423 13.8772L10.9481 12.4725L10.8399 12.4004L10.1477 11.9288L9.65443 10.0611L9.64866 8.77465C9.64722 8.29295 9.85634 7.83433 10.2212 7.51848L10.5616 7.22571L11.4428 6.78583C11.8322 6.59113 12.285 6.56084 12.6961 6.70362L13.4561 6.96467L14.0691 7.58482C14.3445 7.86317 14.5118 8.22949 14.5407 8.61889L14.6503 10.0611L14.0532 12.0052L13.2989 12.4004L12.1783 12.6932L12.6557 12.8648L13.3566 12.7725L13.6436 13.9104L15.4132 14.1022L16.267 14.5306L19.2394 18.0871L19.9879 16.3694C19.9879 16.3694 19.5279 15.3267 19.6476 14.9228C19.7666 14.5202 20.1692 14.1365 20.5317 13.7909C20.7536 13.5794 20.9605 13.3822 21.0783 13.2037C21.4446 12.6456 21.8787 10.6394 21.8787 10.6394L18.5486 5.4013L18.5472 5.40563ZM6.59548 7.82711L4.93548 9.8693L4.91961 9.8794L5.51381 8.24247L6.04599 6.80025L7.36129 5.92771L6.59692 7.82856L6.59548 7.82711ZM19.7456 12.1451L19.5654 11.9201L19.2986 10.9308C19.2986 10.9308 19.2207 10.5572 19.1731 10.4404C18.6827 9.26212 16.5252 6.0027 16.5252 6.0027L17.3155 6.23058L19.6692 8.35208L20.6398 9.98179L19.7485 12.1451H19.7456ZM15.0959 17.2838L15.5618 18.4087L15.4724 20.7321L16.668 20.4206L17.7756 19.5654L17.3386 19.1601L15.0959 17.2838ZM6.74402 19.5005L6.92286 19.3635L9.02994 17.3674L8.56699 18.4275L8.70256 20.8403L6.74402 19.5005Z"
                });
            case 'faction':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M20.5 6.34303L19.8069 5.47262L19.0069 5.48276L18.2435 5.25972L17.471 5.08883L16.7275 4.82669L16.0221 4.482L15.329 4.11848L14.6924 3.67097L14.0405 3.23938L13.5076 2.6789L12.929 2.16041L12.4802 1.5L11.6618 1.59993L11.1382 2.13579L10.6695 2.74986L10.0908 3.27124L9.45267 3.726L8.75649 4.09241L8.10458 4.524L7.38397 4.84262L6.62366 5.06131L5.87099 5.30317L5.08931 5.43786L4.29695 5.4929L3.5 6.34738L3.52748 7.13669L3.62824 7.92166L3.72595 8.70662L3.7 9.49738L3.70305 10.2867L3.84809 11.0702L3.88168 11.8581L3.92748 12.6459L3.97786 13.4338L4.0145 14.2231L4.10763 14.9661L4.24656 15.7047L4.45725 16.4332L4.83893 17.095L5.24504 17.741L5.77176 18.3014L6.27863 18.888L6.96565 19.2747L7.58092 19.7034L8.19313 20.1379L8.86794 20.4811L9.51069 20.8707L10.1626 21.2458L10.7687 21.6875L11.3931 22.1046L12.0511 22.5L12.6878 22.0742L13.3092 21.6557L13.9611 21.2791L14.5901 20.8692L15.2328 20.4811L15.9046 20.1335L16.5244 19.7092L17.1412 19.2819L17.7672 18.8257L18.3427 18.313L18.9061 17.7743L19.3305 17.1298L19.5962 16.4143L19.8496 15.7032L20.0802 14.9791L20.1748 14.2274L20.1244 13.4352L20.2435 12.6503L20.3015 11.8639L20.3458 11.076L20.3977 10.2881L20.4466 9.50028L20.4588 8.71097L20.4969 7.9231L20.4756 7.13234L20.4969 6.34303H20.5ZM5.82366 15.8032L5.74885 15.6743L5.57328 15.0718L5.45878 14.4592L5.38244 13.8437L5.35191 13.1905L5.31069 12.5373L5.27252 11.8841L5.24504 11.231L5.12443 10.5821V9.92752L5.14427 9.27145L5.06336 8.62117L4.97939 7.9709L4.95649 7.31772L5.61756 6.60952L6.27405 6.56462L6.92137 6.4531L7.54427 6.25179L8.17481 6.07076L8.77176 5.80572L9.31221 5.448L9.88931 5.14386L10.4176 4.76731L10.8969 4.33572L11.1473 4.00841V5.63048L11.0832 5.71448L10.6847 6.07366L10.245 6.38648L9.76565 6.63848L9.31679 6.93683L8.82061 7.15697L8.29695 7.30759L7.77939 7.47414L7.24046 7.56683L6.69542 7.60448L6.14733 8.19248L6.16565 8.73559L6.23435 9.27579L6.30153 9.816L6.28321 10.3606V10.9037L6.3855 11.4424L6.4084 11.9855L6.44046 12.5286L6.47557 13.0717L6.50153 13.6148L6.56565 14.1261L6.66183 14.6344L6.80687 15.1355L5.82519 15.8046L5.82366 15.8032ZM16.7779 17.657L16.2588 18.035L15.7473 18.3898L15.2344 18.7417L14.6771 19.0299L14.1443 19.3514L13.6237 19.6903L13.0832 20.0017L12.5672 20.3493L12.0405 20.7027L11.4939 20.3754L10.9763 20.0292L10.474 19.6628L9.93359 19.3514L9.40229 19.0285L8.84351 18.7446L8.33664 18.3854L7.82672 18.0292L7.25725 17.7091L6.8374 17.2239L6.7687 17.1501L7.75649 16.4781L8.05878 16.8271L8.53206 17.0936L8.95496 17.389L9.37634 17.6874L9.84046 17.9234L10.2832 18.1914L10.7321 18.4492L11.1504 18.7533L11.5809 19.0401L12.0344 19.3123L12.4725 19.0183L12.9 18.7301L13.3489 18.4709L13.7824 18.1885L14.2252 17.922L14.6878 17.683L15.1137 17.3905L15.5382 17.0965L15.9687 16.7822L16.1901 16.5852L17.2038 17.2746L16.7763 17.6555L16.7779 17.657ZM19.042 8.62407L19.0099 9.27724L19.0008 9.93186L18.9595 10.585L18.9168 11.2368L18.8802 11.8899L18.8313 12.5417L18.7321 13.1919L18.7733 13.848L18.6939 14.4708L18.5031 15.0703L18.2924 15.6598L18.184 15.9538L17.1763 15.2673L17.2298 15.1239L17.4038 14.6344L17.5626 14.1362L17.6282 13.6177L17.5931 13.0717L17.6756 12.5315L17.7153 11.9899L17.7458 11.4468L17.7824 10.9051L17.816 10.3634L17.8237 9.82035L17.8496 9.27724L17.8359 8.73269L17.8511 8.18814L17.3733 7.58855L16.8221 7.59579L16.2954 7.44228L15.7641 7.32497L15.2511 7.14393L14.7656 6.90641L14.2893 6.65586L13.8511 6.34738L13.4023 6.05048L13.0359 5.66379L12.8496 5.49724V3.92007L13.2466 4.27634L13.6878 4.74124L14.2282 5.09897L14.755 5.46972L15.329 5.77097L15.9137 6.05628L16.5305 6.27352L17.1702 6.414L17.8038 6.59793L18.4664 6.58924L19.0405 7.31048L19.0221 7.9651L19.0389 8.62117L19.042 8.62407Z"
                });
            case 'avatar':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M3.14639 10.8991L3.31817 10.2518L3.37646 9.99259L3.47769 9.74718L3.54671 9.48951L3.66175 9.25023L3.79212 9.02016L3.92709 8.79316L4.25993 8.3591L4.00225 9.00636L3.87801 9.6751L3.76758 10.3438L3.68782 10.9267L4.58356 10.9865L4.73694 10.261L4.99922 9.58307L5.2891 8.91587L5.67102 8.29775L6.10201 7.71491L6.56062 7.15047L7.12199 6.68726L7.68029 6.21945L8.31835 5.86821L8.97175 5.54919L9.64508 5.27157L10.3522 5.09211L11.0746 4.99395L11.8031 4.98782L12.5302 4.99395L13.2526 5.09211L13.9489 5.30838C13.9489 5.30838 14.6483 5.26543 14.8723 5.35746C15.0855 5.44642 15.3017 5.83907 15.3017 5.83907L15.9168 6.22866L16.4827 6.68419L17.0318 7.15967L17.5242 7.69497L17.9598 8.27934L18.3279 8.9082L18.6362 9.56773L18.8693 10.2579L19.0273 10.9727L19.9246 10.9359L19.8786 10.3377L19.7175 9.67663L19.5733 9.01403L19.3724 8.36984L19.6623 8.80237L19.8233 9.0125L19.9415 9.25023L20.0534 9.49104L20.1454 9.73952L20.2175 9.99566L20.3203 10.2426L20.4583 10.9006L21.0826 10.8699L21.7268 10.8592L21.5703 10.1812L21.443 9.50791L21.2007 8.86679L20.9584 8.22566L20.6654 7.60601L20.2896 7.03237L19.9215 6.45566L19.5151 5.90503C19.5151 5.90503 18.6837 5.95104 18.5227 5.75932C18.3908 5.60133 18.5488 4.9372 18.5488 4.9372L18.0426 4.47553L17.4828 4.08134L16.9137 3.70096L16.3079 3.38193L15.6867 3.09511L15.0502 2.84357L14.4014 2.62117L13.7219 2.5L9.8322 2.50307L9.12513 2.65645L8.43492 2.87425L7.76618 3.44175L7.11892 3.46936L6.487 3.81753L5.89802 4.23472L5.32745 4.67646L4.77988 5.14887L4.30901 5.69796L3.85194 6.25473L3.4056 6.82224L3.03442 7.44342L2.70466 8.08608L2.44698 8.76095L2.18163 9.43276L1.99911 10.1322L1.89941 10.8377L2.51907 10.9006L3.14332 10.896L3.14639 10.8991ZM20.4891 13.571L20.3173 14.2183L20.259 14.4775L20.1578 14.7229L20.0887 14.9805L19.9737 15.2198L19.8433 15.4499L19.7084 15.6769L19.3755 16.111L19.6332 15.4637L19.7574 14.795L19.8679 14.1262L19.9476 13.5434L19.0519 13.4836L18.8985 14.209L18.6362 14.887L18.3463 15.5542L17.9644 16.1723L17.5334 16.7552L17.0748 17.3196L16.5135 17.7828L15.9552 18.2506L15.3171 18.6018L14.6637 18.9209L13.9904 19.1985L13.2833 19.3779L12.5609 19.4761L11.8323 19.4822L11.1053 19.4761L10.3829 19.3779L9.68653 19.1617C9.68653 19.1617 8.98712 19.2046 8.76319 19.1126C8.54999 19.0236 8.33372 18.631 8.33372 18.631L7.71867 18.2414L7.1527 17.7859L6.6036 17.3104L6.11125 16.7751L5.67565 16.1907L5.30754 15.5619L4.99925 14.9023L4.76611 14.2121L4.60813 13.4974L3.71086 13.5342L3.75688 14.1324L3.91792 14.7934L4.0621 15.456L4.26303 16.1002L3.97314 15.6677L3.81209 15.4576L3.69399 15.2198L3.58202 14.979L3.49 14.7305L3.41791 14.4744L3.31514 14.2275L3.1771 13.5695L2.55285 13.6001L1.90865 13.6109L2.0651 14.2888L2.1924 14.9621L2.43474 15.6033L2.67708 16.2444L2.97004 16.864L3.34582 17.4377L3.71393 18.0144L4.12039 18.565C4.12039 18.565 4.9517 18.519 5.11275 18.7107C5.24466 18.8687 5.08668 19.5329 5.08668 19.5329L5.59283 19.9945L6.15266 20.3887L6.7217 20.7691L7.32755 21.0881L7.94874 21.3749L8.58527 21.6265L9.23406 21.8489L9.91353 21.9701L13.8032 21.967L14.5103 21.8136L15.2005 21.5958L15.8693 21.0283L16.5165 21.0007L17.1484 20.6525L17.7374 20.2353L18.308 19.7936L18.8556 19.3212L19.3264 18.7721L19.7835 18.2153L20.2298 17.6478L20.601 17.0266L20.9308 16.384L21.1885 15.7091L21.4538 15.0373L21.6363 14.3379L21.736 13.6323L21.1164 13.5695L20.4921 13.5741L20.4891 13.571ZM16.2487 15.1524L16.2496 15.1523H16.2481L16.2487 15.1524ZM14.1376 15.341L16.2487 15.1524L17.2788 15.2765C16.6607 16.3855 15.7143 17.2858 14.5716 17.8487C13.7403 18.2582 12.8062 18.4883 11.8169 18.4883C10.8276 18.4883 9.89356 18.2567 9.06225 17.8487C7.91957 17.2858 6.97322 16.3855 6.3551 15.2765L7.38581 15.1523L9.59907 15.3318L9.81227 15.2704L8.14657 14.933L9.7954 14.459L9.99019 13.1062L10.5071 13.4437L10.6022 13.3915L10.0117 12.9038L9.83681 12.7182C9.7908 12.6676 9.75552 12.6077 9.73558 12.5433L9.65889 12.2933L9.60368 11.8178L9.48711 11.5709L9.4549 11.2013L9.3644 10.8669L9.33986 10.5003L9.28925 10.85L9.26471 11.1844L9.18495 11.1752C9.04077 11.1568 8.92421 11.0494 8.892 10.9083L8.85365 10.735L8.6834 10.3623L8.54996 9.97575L8.68493 9.66132C8.68493 9.66132 8.70334 9.37604 8.77696 9.33462C8.85979 9.28708 9.14661 9.43432 9.14661 9.43432V9.11682L9.12053 8.78092L9.142 8.34072L9.18648 8.00789L9.25551 7.67966L9.28618 7.34529L9.45643 7.06L9.6957 6.81153L9.97792 6.5968L10.3138 6.4833L10.6359 6.34526L10.9703 6.24402L11.297 6.10598L11.6498 6.09678L11.9995 6.12592L12.3446 6.152L12.6897 6.21488L13.0148 6.34832L13.3323 6.4971L13.6514 6.63974L13.9612 6.80539L14.2081 7.05234L14.3492 7.35143L14.4397 7.67506L14.4949 8.00636L14.5026 8.34226L14.5088 8.78246L14.5118 9.11682L14.5088 9.44199C14.5088 9.44199 14.7833 9.32235 14.8661 9.3607C14.9382 9.39444 15.0103 9.64598 15.0103 9.64598L15.1161 9.97575L14.9444 10.3531L14.8186 10.7426L14.7511 10.9436C14.7143 11.0571 14.6192 11.143 14.5026 11.169L14.4183 11.189L14.3446 10.8209L14.2802 10.4344L14.2772 10.8362L14.2649 11.212L14.1805 11.574L14.0808 11.8255L13.9873 12.2918L13.9627 12.4743C13.9459 12.5985 13.8799 12.7105 13.7771 12.7826L13.6299 12.8869L13.6238 12.893L12.317 13.5464L11.7955 13.5924V13.6584H12.317L13.6452 13.1016L13.8416 14.459L15.5839 14.9606L13.8937 15.2704L14.1376 15.341Z"
                });
            case 'priority':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M9 21C7.33333 21 5.91667 20.4167 4.75 19.25C3.58333 18.0833 3 16.6667 3 15V9C3 7.33333 3.58333 5.91667 4.75 4.75C5.91667 3.58333 7.33333 3 9 3H15C16.6667 3 18.0833 3.58333 19.25 4.75C20.4167 5.91667 21 7.33333 21 9V15C21 16.6667 20.4167 18.0833 19.25 19.25C18.0833 20.4167 16.6667 21 15 21H9ZM11 16L17 10L15.6 8.6L11 13.2L8.8 11L7.4 12.4L11 16Z"
                });
            case 'edit':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M3 21V16.75L16.2 3.575C16.4 3.39167 16.6208 3.25 16.8625 3.15C17.1042 3.05 17.3583 3 17.625 3C17.8917 3 18.15 3.05 18.4 3.15C18.65 3.25 18.8667 3.4 19.05 3.6L20.425 5C20.625 5.18333 20.7708 5.4 20.8625 5.65C20.9542 5.9 21 6.15 21 6.4C21 6.66667 20.9542 6.92083 20.8625 7.1625C20.7708 7.40417 20.625 7.625 20.425 7.825L7.25 21H3ZM17.6 7.8L19 6.4L17.6 5L16.2 6.4L17.6 7.8Z"
                });
            case 'info':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M11 17H13V11H11V17ZM12 9C12.2833 9 12.5208 8.90417 12.7125 8.7125C12.9042 8.52083 13 8.28333 13 8C13 7.71667 12.9042 7.47917 12.7125 7.2875C12.5208 7.09583 12.2833 7 12 7C11.7167 7 11.4792 7.09583 11.2875 7.2875C11.0958 7.47917 11 7.71667 11 8C11 8.28333 11.0958 8.52083 11.2875 8.7125C11.4792 8.90417 11.7167 9 12 9ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
                });
            case 'shop':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M19.8247 7.82562L20.4112 8.9925L20.5 10.1151L20.072 11.1112L19.4125 12.0504L18.3409 12.5248L17.2091 12.3224L16.1501 11.9714L15.4368 11.1239L14.8915 10.1404V9.93486L14.3683 11.1903L13.3189 12.0061L12.0539 12.3793L10.7921 12.022L9.73629 11.2093L9.32096 9.92853L9.26389 10.1689L8.62663 11.3168L7.62477 12.1168L6.36292 12.6133L5.03767 12.2149L4.1658 11.1998L3.5 10.0297L3.69023 9.37197L4.35285 8.09442L4.76818 6.70934L5.52592 5.47289L6.0649 4.14158L7.60257 3.00632L8.88344 3.25931L10.1675 3.06957L11.4483 3.06008L12.7292 3L14.0132 3.23085L15.2656 3.07589L16.5211 3.10435L17.4595 3.54707L18.2712 4.2238L18.585 5.51084L19.2635 6.64293L19.8247 7.82562ZM19.5964 14.5867L19.644 15.8832L19.8405 17.1766L19.5869 18.4731L19.7771 19.7696L19.1272 20.44L17.7036 20.5001L16.2801 20.2724L14.8597 20.4274L14.5681 20.38L14.7456 20.0701L14.5205 18.802L14.7393 17.5371L14.5649 16.269L14.5205 15.0041L14.0513 14.574L12.7292 14.457L11.4071 14.4064L10.085 14.5804L9.68555 14.9883L9.46679 16.2564L9.53654 17.5213L9.43826 18.7893L9.58093 20.0574L9.54288 20.3515L9.29876 20.1966L7.86254 20.4274L6.42632 20.4748L4.98693 20.2977L4.45747 19.8266L4.5399 18.5111L4.2926 17.1924L4.29577 15.8769L4.47966 14.5582L4.58111 13.2427L4.44478 13.1194L5.67175 13.6095L7.00017 13.5463L8.26202 13.17L9.27022 12.2466L10.5004 13.3028L12.0634 13.6443L13.5408 13.1067L14.8629 12.1865L15.8775 13.1763L17.1678 13.4198L18.4455 13.4609L19.7074 13.1099L19.7961 13.2902L19.5964 14.5867Z"
                });
            case 'box':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M11 21.9581V12.5448L2.79675 7.82434V15.9331C2.79675 16.3476 2.89717 16.7268 3.098 17.0706C3.299 17.4144 3.57775 17.6899 3.93425 17.8971L11 21.9581ZM13 21.9581L20.0658 17.8971C20.4223 17.6899 20.701 17.4144 20.902 17.0706C21.1028 16.7268 21.2032 16.3476 21.2032 15.9331V7.81234L13 12.5391V21.9581ZM17.0647 7.89709L20.1102 6.12434L13.1375 2.11935C12.781 1.91218 12.4018 1.80859 12 1.80859C11.5982 1.80859 11.219 1.91218 10.8625 2.11935L8.93525 3.22059L17.0647 7.89709ZM11.994 10.8198L15.0527 9.07209L6.94825 4.37059L3.85875 6.14934L11.994 10.8198Z"
                });
            case 'supplies':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M17.9951 3.02625L17.9973 3.02628L17.9885 3.01752L17.9951 3.02625ZM17.9951 3.02625L17.1563 3.0146L16.3211 3.02628L15.4859 3.04088L14.6507 3.04672L13.8156 3.03796L12.9804 3.0438L12.1452 3.05256L11.3071 3L10.472 3.04088L10.0865 3.74173L9.67475 4.43381L9.32141 5.15801L8.91842 5.8647L8.2497 6.28228L7.62186 6.74659L7.00862 7.22842L6.3399 7.63433L5.71498 8.10448L5.06086 8.56003L5.07838 9.40688L5.07254 10.2391V11.0714L5.07838 11.9036L5.1105 12.7359L5.07254 13.5681L5.06086 14.4004L5.1105 15.2326L5.0959 16.0649L5.0667 16.8971L5.0959 17.7294V18.5646L5.07838 19.4027L5.62154 19.9429L6.17637 20.4656L6.75749 20.9416L7.5839 20.9708H8.42199L9.26008 20.9679L10.0982 20.9737L10.9363 20.9971L11.7744 20.9912L12.6125 20.9737L13.4535 21L14.2916 20.9883L15.1296 20.9591L15.9707 20.9445L16.8117 20.9883L17.6556 20.9825L18.1871 20.4276L18.774 19.9341L19.3172 19.3997L19.2909 18.5792L19.3201 17.7557L19.3464 16.9322L19.3522 16.1087L19.3084 15.2852L19.3347 14.4617L19.3055 13.6382L19.2938 12.8147L19.323 11.9912L19.3435 11.1677L19.3259 10.3443L19.2938 9.52077L19.3552 8.69727L19.3318 7.87378L19.2938 7.05029L19.3084 6.2268L19.3201 5.40039L19.2938 4.58566L18.8821 4.05711L18.4032 3.56944L17.9951 3.02625ZM16.1137 13.6177L16.105 14.3595L15.7925 14.6836L15.1676 14.6982L14.5427 14.7041L13.7309 14.9143L13.141 15.513L12.9337 16.3219L12.8811 16.9468L12.922 17.5717L12.5803 17.9192L11.8357 17.8988L11.4648 17.5717L11.4707 16.9468L11.5203 16.3219L11.2896 15.5042L10.6734 14.9348L9.87332 14.6632L9.2484 14.6807L8.62348 14.6661L8.29934 14.3624L8.30518 13.6178L8.62348 13.2995L9.2484 13.2907L9.87332 13.2586L10.6939 13.0775L11.3071 12.4818L11.4794 11.6554L11.494 11.0305L11.5232 10.4056L11.8386 10.061H12.5832L12.9074 10.4056L12.8899 11.0305V11.6554L13.1644 12.4526L13.7309 13.0629L14.5427 13.279H15.1676L15.7925 13.282L16.1137 13.6177ZM15.3049 6.43121L16.0641 6.44289L16.0699 6.43997L16.4963 5.65737L16.9343 4.87184L17.349 4.10383L16.6073 4.10967L15.8363 4.12719L15.0654 4.06879L14.2945 4.10091L13.5235 4.11259L12.7526 4.06295L11.9817 4.05711L11.2166 4.10091L10.7727 4.87476L10.3493 5.66321L9.96093 6.43705L10.6968 6.46918L11.4648 6.46042L12.2328 6.45458L13.0008 6.46334L13.7688 6.4575L14.5369 6.44289L15.3049 6.43121ZM7.44665 5.0993L7.99272 5.87899L7.32984 6.33454L6.66696 6.79593L6.00408 7.2544L5.34412 7.71287L4.80097 6.93026L4.25781 6.15057L4.92069 5.68626L5.5865 5.22779L6.24938 4.77516L6.90934 4.31961L7.44665 5.0993Z"
                });
            case 'bolt':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M18.3539 11.6461L18.1038 11.3233L17.5603 10.3523L17.0577 9.3566L16.5864 8.22785L16.2641 9.2802L16.1391 10.2931L15.1627 11.0547L14.4701 12.0676L13.5395 12.9918L13.8473 11.6634L14.4268 10.5272L14.7178 9.29992L15.004 8.07258L15.2974 6.84525L15.7399 5.66475L16.0693 4.44974L16.4252 3.24212L16.9327 2L15.7375 2.52987L14.7275 3.26923L13.5178 3.57976L12.4285 4.14906L11.3367 4.71098L10.2569 5.30493L9.20361 5.95309L8.09499 6.48543L7.72705 6.62344C7.22685 6.81075 6.83727 7.21986 6.66894 7.73741L6.58236 8.00111L6.18798 9.06332L5.82485 10.1354L5.49299 11.2173L5.17074 12.3042L5 13.4305L5.81283 14.4853L6.8012 15.4538L8.47976 15.3996L9.23246 14.5346L9.85771 13.5956L10.3146 12.5334L10.9471 11.5969L11.6156 10.8575L11.3367 11.8901L10.9014 13.009L10.6874 14.1994L10.2545 15.3183L9.98757 16.4914L9.61723 17.6325L9.14108 18.739L8.79719 19.8875L8.46773 21.0409L8.31142 21.8246C8.28497 21.9552 8.43166 22.0514 8.53747 21.97L9.17956 21.4771L10.0068 20.5924L10.8749 19.752L11.6974 18.8623L14.309 16.3509L15.2757 15.6214L16.0717 14.7022L17.7647 12.9721L18.1856 12.6886C18.527 12.4594 18.604 11.9789 18.3491 11.6486L18.3539 11.6461Z"
                });
            case 'help':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M11.9321 18.0001C12.2981 18.0001 12.609 17.8723 12.8646 17.6166C13.1201 17.3611 13.2479 17.0501 13.2479 16.6836C13.2479 16.3171 13.1201 16.0073 12.8646 15.7541C12.609 15.5011 12.2981 15.3746 11.9321 15.3746C11.5663 15.3746 11.2555 15.5011 10.9999 15.7541C10.7442 16.0073 10.6164 16.3171 10.6164 16.6836C10.6164 17.0501 10.7442 17.3611 10.9999 17.6166C11.2555 17.8723 11.5663 18.0001 11.9321 18.0001ZM10.9664 14.1501H12.9359C12.9359 13.6161 12.9994 13.1888 13.1264 12.8681C13.2534 12.5475 13.5986 12.12 14.1621 11.5859C14.5835 11.1685 14.9181 10.761 15.1661 10.3631C15.4141 9.96529 15.5381 9.48704 15.5381 8.92838C15.5381 7.98021 15.2005 7.25313 14.5251 6.74713C13.8498 6.24113 13.0455 5.98813 12.1121 5.98813C11.1461 5.98813 10.3574 6.24812 9.74587 6.76812C9.13421 7.28796 8.70771 7.90987 8.46637 8.63387L10.2479 9.32563C10.3392 9.01763 10.5257 8.69063 10.8074 8.34463C11.0892 7.99863 11.5141 7.82563 12.0821 7.82563C12.5676 7.82563 12.9338 7.96154 13.1806 8.23338C13.4273 8.50504 13.5506 8.80396 13.5506 9.13013C13.5506 9.44346 13.4536 9.74296 13.2596 10.0286C13.0656 10.3143 12.8325 10.5702 12.5604 10.7964C11.843 11.4384 11.398 11.933 11.2254 12.2804C11.0527 12.6275 10.9664 13.2508 10.9664 14.1501ZM12.0001 22.2034C10.585 22.2034 9.25713 21.9357 8.01663 21.4004C6.77596 20.865 5.69679 20.1386 4.77912 19.2211C3.86162 18.3035 3.13521 17.2243 2.59987 15.9836C2.06454 14.7431 1.79688 13.4153 1.79688 12.0001C1.79688 10.585 2.06454 9.25712 2.59987 8.01662C3.13521 6.77596 3.86162 5.69679 4.77912 4.77912C5.69679 3.86162 6.77596 3.13521 8.01663 2.59987C9.25713 2.06454 10.585 1.79688 12.0001 1.79688C13.4153 1.79688 14.7431 2.06454 15.9836 2.59987C17.2243 3.13521 18.3035 3.86162 19.2211 4.77912C20.1386 5.69679 20.865 6.77596 21.4004 8.01662C21.9357 9.25712 22.2034 10.585 22.2034 12.0001C22.2034 13.4153 21.9357 14.7431 21.4004 15.9836C20.865 17.2243 20.1386 18.3035 19.2211 19.2211C18.3035 20.1386 17.2243 20.865 15.9836 21.4004C14.7431 21.9357 13.4153 22.2034 12.0001 22.2034Z"
                });
            case 'pin':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M16 12L18 14V16H13V22L12 23L11 22V16H6V14L8 12V5H7V3H17V5H16V12Z"
                });
            case 'action':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M16.8367 13.2808L18.0772 13.1784L18.0717 13.1811C18.1217 13.2016 18.168 13.2184 18.2167 13.236L18.2489 13.2476L19.9131 14.9256C19.8475 15.0673 19.8304 15.1056 19.789 15.1984L19.7889 15.1986L19.7888 15.1987L19.7888 15.1988L19.7887 15.1991L19.7414 15.305L15.8066 15.0779C15.7685 15.1227 15.739 15.1566 15.7112 15.1887L15.7111 15.1888L15.7111 15.1888C15.6702 15.2359 15.6328 15.279 15.5768 15.3465L16.1167 17.894C15.9967 17.9679 15.8767 18.0408 15.7568 18.1128L14.5605 17.1187C14.4923 17.1517 14.4482 17.1733 14.4088 17.1926C14.349 17.2219 14.3002 17.2458 14.195 17.2959L14.2975 22.1832C14.1089 22.2196 14.1011 22.2213 13.9943 22.2432L13.9943 22.2432L13.9942 22.2432L13.994 22.2433L13.9939 22.2433L13.8683 22.2691L11.4316 16.1634C11.3165 16.1859 11.269 16.1957 11.2243 16.205C11.1753 16.2151 11.1297 16.2246 11.0024 16.2492L11.019 17.3291C10.9968 17.3873 10.9774 17.4371 10.9525 17.4925L9.62338 18.7967L9.54842 18.7667L9.54841 18.7667C9.43317 18.7205 9.39539 18.7054 9.24403 18.6472L9.14988 16.5704C9.09034 16.5289 9.04811 16.4991 9.00588 16.4693C8.96366 16.4396 8.92143 16.4098 8.8619 16.3683L5.7606 17.3264C5.69831 17.2364 5.66923 17.1935 5.64016 17.1505C5.61108 17.1076 5.58201 17.0647 5.5197 16.9747L7.2531 14.7678C7.22107 14.7026 7.19932 14.6589 7.1801 14.6202L7.17998 14.62C7.14941 14.5585 7.12516 14.5098 7.07589 14.4078L0.203188 14.3967C0.172704 14.231 0.167128 14.2029 0.151282 14.123L0.151258 14.1229C0.144077 14.0867 0.134786 14.0398 0.120117 13.9648L5.65538 11.7717L5.69553 11.7634L5.73568 11.7551H7.30849C7.3335 11.6586 7.34622 11.6088 7.35722 11.5656L7.35723 11.5656L7.35727 11.5654C7.37181 11.5084 7.38338 11.4631 7.41648 11.337L5.44217 10.246C5.47726 10.1056 5.48789 10.0653 5.50577 9.99754L5.50578 9.99749L5.50579 9.99747C5.51612 9.95831 5.52887 9.90997 5.55016 9.82786H7.38048C7.42201 9.74758 7.44693 9.69981 7.47184 9.65206C7.49677 9.60428 7.52169 9.55651 7.56323 9.4762L4.28472 4.76056C4.39711 4.64264 4.42001 4.61913 4.47251 4.56519L4.47252 4.56518L4.47259 4.56511L4.47287 4.56482L4.4731 4.56459C4.49941 4.53755 4.53322 4.50283 4.58931 4.4449L8.68469 7.04777C8.69207 7.05516 8.69915 7.06254 8.70622 7.06993C8.72038 7.08469 8.73453 7.09946 8.75114 7.11423L9.44063 8.17476C9.56242 8.12872 9.60614 8.11136 9.65511 8.09191L9.65513 8.0919C9.69745 8.07509 9.7437 8.05672 9.84767 8.01693L9.54308 6.19491L9.57914 6.17558C9.73429 6.09237 9.74148 6.08852 9.91967 5.99555L10.9331 6.98132L11.0346 6.94416L11.0346 6.94416C11.1284 6.90979 11.1758 6.8924 11.3097 6.84563L11.8718 1.77279C12.0593 1.76681 12.0715 1.76657 12.161 1.76484L12.3149 1.76172L13.1068 6.9287C13.2093 6.964 13.2629 6.98297 13.3263 7.00543L13.3263 7.00545C13.3674 7.01999 13.4126 7.036 13.4779 7.05885L15.9506 4.82702C16.0326 4.88209 16.0755 4.91039 16.1121 4.93457L16.1122 4.93464L16.1122 4.93467L16.1122 4.93468L16.1123 4.93471C16.1621 4.9676 16.2005 4.99296 16.3106 5.06792L14.7433 9.3599C14.8291 9.42632 14.8699 9.45816 14.9107 9.48998L14.9109 9.49008L14.9109 9.49013L14.911 9.49017C14.9518 9.52197 14.9926 9.55382 15.0783 9.62019L18.1215 7.57389C18.2311 7.69411 18.2527 7.71725 18.2986 7.76657L18.2986 7.76658L18.2987 7.76665C18.3247 7.79456 18.3585 7.83086 18.4205 7.89786L16.8505 9.9137L16.8998 10.0037L16.8999 10.0038C16.952 10.0991 16.9732 10.1379 17.0499 10.2737L23.8921 9.53989C23.9165 9.63615 23.9291 9.68473 23.9388 9.72205L23.9388 9.72225L23.9388 9.72234C23.9545 9.78253 23.9625 9.81361 24.0001 9.96908L16.7342 12.8516L16.7694 12.9966C16.7916 13.0881 16.7941 13.0982 16.8367 13.2808ZM13.4585 13.2421C13.4779 13.2116 13.4972 13.1811 13.5166 13.1479H13.5139L14.9814 11.7856C14.9554 11.6903 14.9436 11.6416 14.9288 11.5812L14.9287 11.581C14.9199 11.5449 14.9101 11.5046 14.8956 11.4477L12.9545 10.9493C12.9393 10.941 12.9234 10.9313 12.9074 10.9216C12.8915 10.9119 12.8756 10.9022 12.8604 10.8939L11.498 9.42636C11.4388 9.44143 11.3971 9.4519 11.3596 9.46135C11.3005 9.47619 11.2516 9.48851 11.1602 9.5122L10.6618 11.4505C10.6521 11.4671 10.6424 11.483 10.6327 11.4989L10.6327 11.499C10.623 11.5149 10.6133 11.5308 10.6036 11.5474L9.13881 12.9098L9.22464 13.2476L11.163 13.746C11.1962 13.7626 11.2266 13.782 11.2571 13.8014L12.6222 15.269L12.96 15.1831L13.4585 13.2421ZM3.12451 15.6816L3.9469 15.6428L3.94967 15.6401L4.11858 16.0194L3.57586 16.576L3.45679 16.6397L1.80368 16.9498L1.64862 16.54L3.01928 15.7121L3.12451 15.6816ZM17.4874 6.30018L17.8141 5.5387L17.8834 5.45009L19.9269 3.88283L20.2426 4.19296L19.0713 5.78514L19.0076 5.84329L17.8086 6.57985L17.4874 6.30295V6.30018ZM10.3433 21.4217L10.4762 21.6847H10.479L10.8999 21.5934L10.9276 20.807L10.4901 20.7322L10.3295 21.2555L10.3433 21.4217ZM18.5978 16.3212H19.1156L19.2485 16.3655L19.9214 16.8667C19.8469 17.0428 19.8423 17.0533 19.7921 17.1681L19.7497 17.2655L18.7085 17.0882L18.5424 16.9609L18.3929 16.6369L18.595 16.3212H18.5978ZM8.13088 3.63347L7.7626 2.18804L8.1558 1.99698L9.08065 3.18765L9.12495 3.34826L9.05573 3.97406L8.69852 4.12635L8.21118 3.7553L8.13088 3.63347Z"
                });
            case 'support':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M15.6222 4.11252L15.982 5.29622L14.6143 8.05635L12.1178 10.6819L8.17948 7.10884L6.9848 4.03562L7.45992 2.39602L8.59419 1.87695L9.8026 2.00329L11.7525 4.0933L13.7684 3.00298L15.6222 4.11252ZM11.1374 15.7135L10.6788 14.6946L10.5579 14.1371L10.2586 13.6509L8.86342 9.97077L8.59153 9.72359L8.01753 9.79225L7.89669 10.4431L8.05872 10.9787L8.17957 12.0827L8.07795 13.1841L7.76486 13.5356L5.99618 12.4837L4.92508 11.3742L4.70812 10.9018L4.39228 10.4843L3.68646 8.53989L3.35689 8.05653L2.80761 8.16638L2.71973 8.74313L3.81005 12.5414L5.13106 14.2826L5.53478 14.6506L7.81429 17.7074L7.99281 18.7565L7.43804 21.6622L7.75387 22.1758L10.1103 22.4971L11.0056 21.643L11.1676 17.9051L11.0935 17.3558L11.2088 16.2628L11.1374 15.7135ZM20.824 8.21296L20.412 8.13881L20.1017 8.57548L18.4978 11.8107L18.1435 12.1897L17.6903 12.4589L17.3003 12.7967L15.9573 13.5657L15.5454 13.2004L15.669 10.9813L15.8035 10.443L15.625 9.83333L15.1224 9.72897L14.8341 9.96516L13.7657 12.566L13.6504 13.1263L12.799 15.2135L12.4914 16.8119L12.5985 17.3557L12.6507 21.6428L13.5048 22.3899L16.0178 21.9092L16.2045 21.4616L16.1331 21.2776L16.0974 20.7613L15.7926 19.7808L15.7239 19.27L15.9271 17.721L16.7593 16.3121L19.5826 12.9917L20.4861 10.9511L20.9997 8.74301L20.824 8.21296Z"
                });
            case 'life':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M20.8045 7.81774C20.6924 7.38043 20.3879 7.00607 20.1764 6.62177C19.9585 6.23416 19.6573 5.91943 19.3529 5.6047C19.0485 5.28997 18.8113 4.85597 18.4364 4.63069C18.0679 4.40872 17.6385 4.20663 17.2155 4.09068C16.8085 3.97804 15.9305 4.86591 15.5139 4.90567C15.3024 4.92554 16.0875 4.3259 15.8792 4.28283C15.187 4.13706 15.1133 4.29277 14.716 4.39547C14.3154 4.49817 13.8155 4.33253 13.4502 4.5313C13.0881 4.72677 12.8381 5.13426 12.5273 5.41917C12.4536 5.48543 12.3991 5.53512 12.3575 5.57157C12.2966 5.62457 12.2902 5.71734 12.3414 5.78028C12.8574 6.38986 12.8125 7.20485 12.4824 6.84374C11.7005 5.98568 11.3096 5.63783 10.9923 5.3496C10.6815 5.068 10.2842 4.90898 9.91884 4.71351C9.55353 4.51805 9.21385 4.20995 8.81329 4.10725C8.41914 4.00786 7.56354 4.00454 7.56354 4.00454C7.12131 4.00454 6.65025 3.97142 6.24328 4.08406C5.82029 4.20001 5.471 4.54455 5.09928 4.76652C4.72435 4.9918 4.29815 5.17401 3.99372 5.48543C3.6893 5.80016 3.4778 6.2209 3.25989 6.60852C3.04519 6.98951 3.07724 7.46657 2.96508 7.90388C2.85613 8.32462 2.9779 8.91433 3.0484 9.3682C3.1958 10.3157 2.78242 9.68293 2.58695 9.34832C2.56131 9.30525 2.49402 9.32844 2.50043 9.37814C2.53888 9.84858 2.70552 10.319 2.87535 10.7464C3.07083 11.2334 3.28873 11.78 3.65405 12.1577C4.1187 12.6381 4.28854 12.4625 4.75319 12.9429C5.21784 13.4232 5.07364 13.5723 5.53829 14.0527C6.00294 14.5331 6.12792 14.4039 6.59257 14.8842C7.05723 15.3646 6.90982 15.517 7.37447 15.9974C7.83912 16.4778 7.92244 16.3916 8.38709 16.872C8.88058 17.3855 9.78105 18.5583 10.4444 19.1016C10.6815 19.2938 10.877 19.529 11.0628 19.7742C11.3416 20.1419 11.9217 20.0193 12.2293 19.7013C12.6939 19.2209 12.742 19.2706 13.2067 18.7902C13.6713 18.3098 13.7803 18.4225 14.2417 17.9388C14.7064 17.4584 14.5686 17.316 15.0332 16.8356C15.4979 16.3552 15.3889 16.2426 15.8536 15.7622C15.9433 15.6694 16.0138 15.5932 16.0747 15.5303C16.1804 15.4176 15.86 14.7319 15.9369 14.6523C16.0074 14.5761 16.4785 15.1029 16.581 14.9936C16.6355 14.9373 16.6996 14.871 16.7733 14.7915C17.0969 14.4536 17.0264 14.5695 17.2443 14.4039C17.3373 14.3343 16.3086 12.9263 16.4464 12.7838C16.5874 12.6381 18.0326 13.675 18.1063 13.5823C18.2698 13.3669 18.3339 13.2278 18.6543 12.8932C19.119 12.4128 19.2888 12.5884 19.7534 12.108C20.1188 11.727 20.2341 11.1638 20.4296 10.6768C20.6251 10.1898 21 9.70943 21 9.17274H20.9808C20.9808 8.71555 20.9103 8.23517 20.8013 7.81443L20.8045 7.81774Z"
                });
            case 'lock_open':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M6 8H15V6C15 5.16667 14.7083 4.45833 14.125 3.875C13.5417 3.29167 12.8333 3 12 3C11.1667 3 10.4583 3.29167 9.875 3.875C9.29167 4.45833 9 5.16667 9 6H7C7 4.61667 7.4875 3.4375 8.4625 2.4625C9.4375 1.4875 10.6167 1 12 1C13.3833 1 14.5625 1.4875 15.5375 2.4625C16.5125 3.4375 17 4.61667 17 6V8H18C18.55 8 19.0208 8.19583 19.4125 8.5875C19.8042 8.97917 20 9.45 20 10V20C20 20.55 19.8042 21.0208 19.4125 21.4125C19.0208 21.8042 18.55 22 18 22H6C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V10C4 9.45 4.19583 8.97917 4.5875 8.5875C4.97917 8.19583 5.45 8 6 8ZM12 17C12.55 17 13.0208 16.8042 13.4125 16.4125C13.8042 16.0208 14 15.55 14 15C14 14.45 13.8042 13.9792 13.4125 13.5875C13.0208 13.1958 12.55 13 12 13C11.45 13 10.9792 13.1958 10.5875 13.5875C10.1958 13.9792 10 14.45 10 15C10 15.55 10.1958 16.0208 10.5875 16.4125C10.9792 16.8042 11.45 17 12 17Z"
                });
            case 'grade':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M5.825 21L7.45 13.975L2 9.25L9.2 8.625L12 2L14.8 8.625L22 9.25L16.55 13.975L18.175 21L12 17.275L5.825 21Z"
                });
            case 'hand':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M14.7853 6.75878C13.9818 8.88838 13.1583 11.0707 14.4257 13.1882H14.423C14.7081 13.4849 15.08 13.7327 15.4542 13.9821C16.2027 14.4809 16.9607 14.986 17.053 15.9008C16.9278 17.3318 15.806 19.9618 14.7214 20.8891C13.1306 22.3467 10.4606 20.9797 12.4085 19.0585C12.4538 16.8921 11.1454 17.8221 10.8603 18.0939C10.7341 18.2153 10.7698 18.3998 10.8065 18.5902C10.831 18.7174 10.8561 18.8473 10.8337 18.9626C10.1622 21.4008 7.7 20.8012 6.55418 19.0745C6.41562 18.872 6.1225 18.4243 5.89867 17.7368C5.25491 16.8973 6.0685 16.759 6.76315 16.6409C6.91959 16.6143 7.07 16.5887 7.19637 16.5564C8.29879 16.4488 8.38377 15.2692 8.45261 14.3134C8.46564 14.1326 8.47808 13.9598 8.49674 13.8037C8.62324 13.4936 8.66368 13.1728 8.70373 12.8553C8.75141 12.4771 8.79853 12.1034 8.98971 11.7573C8.9317 11.2717 8.91286 10.7768 8.89409 10.2835C8.88268 9.98371 8.87129 9.6845 8.85114 9.38835C8.84312 9.26535 8.93036 9.30133 9.01625 9.33675C9.10154 9.37194 9.18552 9.40657 9.17357 9.28442C8.75326 8.64642 8.73221 8.2682 8.69862 7.66462C8.69069 7.52201 8.68205 7.36682 8.66728 7.19265C8.52605 6.72366 8.45677 6.25468 8.48608 5.76437C8.31288 5.26608 8.30488 4.82907 8.51006 4.33877C8.41147 2.43085 10.4793 2.0578 10.4686 4.14957C10.4398 4.60723 10.4214 5.08125 10.403 5.55401C10.389 5.91255 10.3751 6.27036 10.3567 6.61974C10.3487 6.74402 10.2924 6.74096 10.237 6.73796C10.1818 6.73497 10.1275 6.73202 10.1222 6.85423C10.1167 6.98173 10.1825 7.11417 10.248 7.2461C10.3098 7.3706 10.3714 7.49465 10.3727 7.61367C10.3434 8.63424 11.0282 12.7912 12.0274 9.90263C12.1446 9.47517 12.2053 9.038 12.2656 8.60261C12.3536 7.96864 12.441 7.33848 12.7016 6.74764C12.7679 6.44288 12.812 6.0937 12.858 5.72926C13.0191 4.45264 13.2038 2.98873 14.4496 2.59073C15.6328 2.10842 15.9046 3.66727 15.5475 4.48266C15.3619 5.23086 15.0749 5.9914 14.7853 6.75878ZM16.8307 11.4678C16.6122 11.7935 16.3917 12.1222 16.0512 12.4021L16.0539 12.4048C15.4516 12.9058 14.8414 12.3409 15.2704 11.5255C15.3996 11.0821 15.6445 10.7059 15.8833 10.3389L15.8833 10.3389C16.078 10.0397 16.2688 9.74666 16.3896 9.42836C16.5642 9.04272 16.7701 8.68019 16.9752 8.31894C17.2959 7.75413 17.6149 7.19246 17.8099 6.5505C17.8677 6.43615 17.9385 6.41581 18.0104 6.39513C18.0843 6.37389 18.1594 6.35231 18.2229 6.22807C18.2694 6.13516 18.2706 6.03959 18.2717 5.94682C18.2732 5.83208 18.2745 5.72163 18.3615 5.62585C19.6272 3.91779 20.4346 5.69513 19.7498 7.00616C19.4506 7.73458 19.0099 8.37816 18.5698 9.02097C18.2339 9.51159 17.8982 10.0018 17.626 10.5289C17.2777 10.8016 17.0552 11.1332 16.8307 11.4678ZM18.8135 11.395C19.4655 10.5435 20.1994 9.58495 20.9862 10.1239H20.9888C21.3202 10.5611 20.9203 11.1075 20.6163 11.5231C20.5682 11.5888 20.5225 11.6512 20.4825 11.7094C20.3773 11.8161 20.3338 11.7175 20.2944 11.6284C20.262 11.555 20.2324 11.4879 20.1734 11.5468C20.0003 12.3108 19.3525 12.9307 18.7584 13.4992L18.7583 13.4992L18.7583 13.4993C18.621 13.6307 18.4865 13.7594 18.3614 13.8864C16.6933 14.8804 16.9785 13.175 17.9457 12.3622C18.2146 12.1773 18.5049 11.7982 18.8135 11.395ZM6.3277 14.3232C6.25576 13.9288 6.06124 13.5744 5.76812 13.2653C5.70439 12.7027 5.45402 12.4088 5.16751 12.0725C5.03473 11.9166 4.89419 11.7517 4.76087 11.5466C4.68524 11.5126 4.60156 11.4707 4.51289 11.4264C3.98305 11.1612 3.27536 10.807 3.04481 11.5146C2.85562 11.9197 3.00218 12.4659 3.16472 12.8656C3.27792 13.1765 3.45861 13.2121 3.59675 13.2393C3.67648 13.255 3.74204 13.2679 3.77227 13.3293C3.8138 13.4148 3.76407 13.4404 3.70956 13.4684C3.64516 13.5016 3.57409 13.5382 3.63904 13.681C3.8229 14.3818 4.2306 15.3918 4.94473 15.6263C5.57093 15.6716 6.54354 15.0427 6.3277 14.3232Z"
                });
            case 'inspect':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M12.92 13.9287L12.9955 13.4848L13.0504 13.1646C13.103 12.858 13.3204 12.6087 13.6155 12.5149L13.8374 12.444L14.471 12.2404C14.757 12.1489 15.0727 12.2175 15.2946 12.4257L15.4021 12.5263L16.292 9.02853C16.4476 8.41544 15.9145 7.03371 15.4204 6.63566C15.3655 6.57847 15.3083 6.52357 15.2443 6.47095L12.3275 4.11926C11.8975 3.77383 11.2592 3.66173 10.6438 3.82415L6.65648 4.86961C6.33621 4.95425 6.03424 5.10294 5.77802 5.29968C5.51952 5.49871 5.30677 5.74577 5.16723 6.02029L3.22273 9.84522C3.04201 10.2021 2.96881 10.5727 3.00083 10.9135V10.9181C2.93907 11.3619 3.54758 12.3136 3.81752 12.6384L6.60157 15.9784C7.07969 16.5503 7.87808 16.7539 8.68561 16.5L13.4874 14.9924L13.1534 14.6584C12.9635 14.4685 12.8766 14.194 12.9223 13.9287H12.92ZM4.56329 10.1426L6.41628 6.26506C6.45059 6.19186 6.50549 6.12552 6.57641 6.06833C6.64504 6.01342 6.72739 5.97225 6.81204 5.94937L10.9 4.85588C11.067 4.81013 11.2409 4.84215 11.3553 4.93823L14.2697 7.38601C14.4001 7.49581 14.4505 7.66281 14.4047 7.82295L13.19 12.0574C13.1625 12.1534 13.1099 12.2404 13.039 12.3136C12.9681 12.3868 12.8789 12.4394 12.7828 12.4691L7.95814 13.947C7.75226 14.011 7.54637 13.9607 7.42055 13.8166L4.60447 10.6276C4.49466 10.5041 4.48093 10.3165 4.56558 10.1403L4.56329 10.1426ZM11.4491 5.48046L7.68138 6.40009C7.30163 6.49159 6.99052 6.7501 6.83038 7.10468L5.20845 10.662C5.22598 10.678 5.24378 10.6937 5.26157 10.7095C5.29715 10.741 5.33274 10.7725 5.36629 10.8061L7.01568 7.18932C7.15294 6.89193 7.41144 6.67461 7.73171 6.59683L8.63874 6.37513L8.09768 13.5509L9.29183 13.1872L9.65248 6.12735L10.7388 5.86183L10.4952 12.8557L10.8909 12.7573L11.14 5.76378L11.6253 5.64517C11.5658 5.59255 11.5086 5.53536 11.4514 5.47817L11.4491 5.48046ZM18.5796 15.7522L20.5722 17.6052L20.5699 17.6097L20.9999 18.9228L20.1672 20.0072H18.7215L16.6809 17.9506L16.6489 17.5869L14.1187 15.0544L13.4118 14.3453C13.3112 14.2446 13.2677 14.1005 13.2952 13.961L13.4462 13.2243C13.4759 13.0733 13.5857 12.9521 13.7321 12.9041L14.5968 12.625C14.7433 12.5769 14.9057 12.6135 15.0178 12.7188L15.5485 13.2152L18.2182 15.7133L18.5796 15.7522Z"
                });
            case 'fire':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M16.3337 5.91796L17.7969 4.73808L18.2647 3.03843L16.5702 1.61426L16.3337 5.91796ZM17.1678 19.2681L19 11.9601L14.3117 7.37833L14.3715 3.70875L9.59477 8.119L9.65974 14.4134L6.84778 11.3598L4.57898 15.3308L6.44756 19.3019L8.85669 20.1387L11.3386 22.3867L10.954 17.9479L13.4281 16.7472L13.4697 12.6488L15.6423 14.7227L15.1303 20.6481L17.1678 19.2681Z"
                });
            case 'share':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M6.07175 23.2392C5.44209 23.2392 4.9055 23.0175 4.462 22.574C4.0185 22.1305 3.79675 21.5939 3.79675 20.9642V10.3707C3.79675 9.74091 4.0185 9.20424 4.462 8.76074C4.9055 8.31741 5.44209 8.09574 6.07175 8.09574H8.8625V10.3707H6.07175V20.9642H17.9283V10.3707H15.1375V8.09574H17.9283C18.5579 8.09574 19.0945 8.31741 19.538 8.76074C19.9815 9.20424 20.2033 9.74091 20.2033 10.3707V20.9642C20.2033 21.5939 19.9815 22.1305 19.538 22.574C19.0945 23.0175 18.5579 23.2392 17.9283 23.2392H6.07175ZM10.8625 16.2092V5.10599L9.2625 6.70599L7.67125 5.09574L12 0.760742L16.3288 5.09574L14.7375 6.70599L13.1375 5.10599V16.2092H10.8625Z"
                });
            case 'discord':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "m15.07532,4c-0.208,0.36667 -0.3986,0.75 -0.5892,1.13333c-1.6637,-0.23333 -3.362,-0.23333 -5.02565,0c-0.17329,-0.38333 -0.36392,-0.76666 -0.58921,-1.13333c-1.55968,0.25 -3.0847,0.7 -4.52307,1.35c-2.85941,4.06667 -3.63925,8.05 -3.25799,11.9667c1.68098,1.1833 3.5526,2.1 5.56285,2.6833c0.45057,-0.5833 0.84916,-1.2 1.19575,-1.85c-0.6412,-0.2333 -1.26507,-0.5167 -1.87161,-0.8667c0.15597,-0.1166 0.31194,-0.2166 0.4679,-0.3333c3.51795,1.5833 7.59043,1.5833 11.10843,0c0.1559,0.1167 0.2946,0.2333 0.4679,0.3333c-0.6066,0.3334 -1.2305,0.6334 -1.8717,0.8667c0.3466,0.65 0.7452,1.2667 1.1958,1.85c1.9929,-0.5833 3.8819,-1.4833 5.5628,-2.6833c0.4506,-4.55003 -0.7798,-8.48337 -3.2579,-11.98337c-1.4904,-0.61666 -3.0154,-1.06666 -4.5751,-1.33333zm-6.74128,10.9c-1.07445,0 -1.97559,-0.95 -1.97559,-2.11667c0,-1.16666 0.86648,-2.11666 1.97559,-2.11666c1.1091,0 1.99292,0.95 1.97559,2.11666c-0.01733,1.16667 -0.88382,2.11667 -1.97559,2.11667zm7.29578,0c-1.0917,0 -1.9755,-0.95 -1.9755,-2.11667c0,-1.16666 0.8664,-2.11666 1.9755,-2.11666c1.1092,0 1.993,0.95 1.9756,2.11666c-0.0346,1.16667 -0.8838,2.11667 -1.9756,2.11667z"
                });
            case 'wreath':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "m4.14426,10.22003c-0.47333,-0.03567 -0.83993,-0.08636 -1.20653,-0.08546c-0.58749,0.00192 -0.85479,0.31074 -0.80745,0.91425c0.0956,1.20518 0.61997,2.16725 1.61675,2.85437c0.21903,0.15112 0.4325,0.30972 0.65432,0.46838c-0.53552,0.22431 -1.03855,0.37352 -1.47754,0.63356c-0.5745,0.33976 -0.58192,0.60537 -0.27194,1.19111c0.65895,1.24366 2.59404,2.17383 3.85625,1.62101c0.98101,-0.42989 1.5323,0.10324 2.20426,0.75278c-0.40745,0.20085 -0.76385,0.3576 -1.10167,0.54816c-0.23666,0.13328 -0.47425,0.28721 -0.66452,0.47963c-0.25986,0.26094 -0.24038,0.60447 -0.10673,0.92173c0.12251,0.29003 0.38795,0.40452 0.6803,0.36322c0.29143,-0.04034 0.59492,-0.09666 0.85759,-0.22342c2.43717,-1.17232 4.8632,-1.20799 7.29115,0.02161c0.20043,0.10138 0.41116,0.18775 0.62644,0.25154c0.4427,0.13239 0.81023,-0.03375 0.99589,-0.42798c0.17727,-0.37639 0.10114,-0.70586 -0.29607,-0.98278c-0.32671,-0.22808 -0.69054,-0.40266 -1.04323,-0.59226c-0.21713,-0.11635 -0.4427,-0.21683 -0.76379,-0.37166c0.4594,-0.31726 0.82412,-0.62045 1.23624,-0.8307c0.18745,-0.09576 0.48166,-0.05913 0.70071,0.00754c0.65618,0.19894 1.29375,0.30876 1.98519,0.12856c1.06178,-0.27686 1.82,-0.90198 2.35457,-1.84718c0.18194,-0.32103 0.12251,-0.60639 -0.1568,-0.80066c-0.30535,-0.21216 -0.64505,-0.3783 -0.98194,-0.5369c-0.21623,-0.10138 -0.45569,-0.15297 -0.70999,-0.23562c0.47143,-0.40637 0.91605,-0.76026 1.32715,-1.15071c0.68216,-0.6505 0.85201,-1.52339 0.92903,-2.41323c0.03621,-0.41954 -0.24131,-0.70209 -0.6979,-0.72651c-0.39165,-0.02155 -0.78707,0.03663 -1.26874,0.06482c0.1346,-0.21312 0.23946,-0.39141 0.3564,-0.56228c0.7304,-1.0747 0.9188,-2.21701 0.43157,-3.44661c-0.03711,-0.09386 -0.0696,-0.19054 -0.11509,-0.27971c-0.43253,-0.84757 -0.81676,-0.95646 -1.5824,-0.38859c-0.37495,0.27783 -0.69425,0.63169 -1.10631,1.01465c-0.06775,-0.2309 -0.14388,-0.42989 -0.18469,-0.63639c-0.33599,-1.71862 -1.59354,-2.722 -3.39684,-2.8919c-0.24041,-0.02253 -0.49375,0.06195 -0.73692,0.11639c-0.46868,0.10606 -0.66821,0.3839 -0.61441,0.87386c0.20696,1.87255 1.27987,3.06367 2.86131,3.34619c0.30164,0.05444 0.4752,0.2018 0.63392,0.45993c1.37449,2.24615 1.48311,5.6364 -0.51231,7.93514c-0.93831,1.08129 -2.14947,1.70264 -3.59548,1.81623c-2.50958,0.19804 -4.53097,-1.35258 -5.39596,-3.74139c-0.74805,-2.06682 -0.47333,-4.08301 0.56336,-5.99215c0.11323,-0.20932 0.39815,-0.40549 0.63295,-0.45054c1.33463,-0.25343 2.1922,-1.0522 2.64418,-2.30432c0.15034,-0.41862 0.2051,-0.88418 0.23018,-1.33285c0.01855,-0.3304 -0.20325,-0.51249 -0.54295,-0.61668c-1.35504,-0.41111 -3.00335,0.45523 -3.5203,1.30563c-0.25801,0.42426 -0.43621,0.90014 -0.63018,1.361c-0.09466,0.22527 -0.14293,0.47025 -0.21903,0.73025c-0.38424,-0.35949 -0.69793,-0.71898 -1.07381,-0.98931c-0.83158,-0.59884 -1.26593,-0.45711 -1.65851,0.50686c-0.49932,1.22678 -0.46962,2.41226 0.32669,3.5217c0.12994,0.18212 0.25338,0.36891 0.44364,0.64673l0,0.00096z"
                });
            case 'shield':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "m10.89177,2.04575c-0.01437,0.02058 -1.41581,2.02268 -2.13491,2.23376c-0.87453,0.25764 -4.5557,-0.76873 -4.59351,-0.77929c-1.056,0.75822 -1.56822,1.12567 -1.65062,1.18515l-0.0347,0.67292l-0.13428,1.84827c0,0 2.04434,1.18094 2.31448,1.84903c0.17509,0.43167 -0.26413,1.82472 -0.27158,1.84828l0.14711,1.84898c0,0 0.45892,0.19282 0.46622,0.35535c0.00711,0.16014 -0.40166,0.75883 -0.40738,0.76725l0.03772,0.72723l-0.04979,0.76192c-0.04375,0.68042 0.27479,1.34315 0.86906,1.79768l0.51374,0.39382l1.59629,0.98447l1.52765,1.05315l1.37073,1.21082l1.50274,1.14971l1.49672,-1.15805l1.56686,-1.01537l1.46883,-1.11201l1.5314,-1.04936l0.29502,-0.23306c0.71101,-0.5606 1.08529,-1.36879 1.01236,-2.19382l-0.05276,-0.59143l0.16215,-1.84828l-0.10637,-1.84898c-0.00147,-0.02202 -0.09641,-1.43955 0.12522,-1.84828c0.31248,-0.57723 2.11518,-1.64297 2.13195,-1.65288c0.00587,-0.1102 -0.10104,-0.20822 -0.25724,-0.2399c-0.1898,-0.03858 -0.41313,-0.10199 -0.42627,-0.1901c-0.02881,-0.1948 0.71595,-0.75685 0.72275,-0.76194l0.02487,-0.85398l-0.02039,-0.6269c-0.77667,-0.47515 -1.19135,-0.7287 -1.96671,-1.2025c0,0 -3.63222,1.10172 -4.50445,0.84718c-0.71263,-0.20854 -2.12515,-2.16597 -2.13643,-2.1817l-2.1365,-0.14711zm1.30815,3.57583l0.32136,0.32741l0.28892,0.37645l0.35682,0.31986l0.39235,0.27761l0.4292,0.22481l0.40209,0.26479l0.44357,0.19539l0.46852,0.13353l0.46319,0.14862l0.48204,0.08298l0.48737,0.03319l0.49108,0.52279l-0.01808,0.48281l-0.0611,0.48053l-0.05964,0.48057l0.01437,0.48505l0,0.48359l-0.08899,0.47903l-0.02039,0.48204l-0.02789,0.48212l-0.03098,0.48204l-0.02263,0.48359l-0.05732,0.45485l-0.08598,0.45191l-0.12978,0.44511l-0.23538,0.40433l-0.24967,0.39529l-0.32437,0.3433l-0.31232,0.35829l-0.42325,0.23693l-0.37868,0.26327l-0.37644,0.26551l-0.41491,0.20973l-0.39537,0.23839l-0.40209,0.22936l-0.37343,0.27007l-0.38393,0.255l-0.40587,0.24141l-0.39158,-0.2618l-0.38246,-0.25647l-0.40131,-0.23013l-0.38702,-0.25044l-0.39605,-0.23685l-0.41341,-0.21197l-0.38097,-0.26103l-0.37947,-0.26103l-0.38549,-0.27988l-0.35532,-0.31387l-0.34702,-0.32963l-0.26178,-0.39382l-0.16294,-0.43832l-0.15692,-0.4353l-0.14107,-0.44357l-0.05884,-0.46018l0.03093,-0.48428l-0.07469,-0.48134l-0.03621,-0.48204l-0.0264,-0.48204l-0.03244,-0.48212l-0.03018,-0.48204l-0.00754,-0.48359l-0.02339,-0.47671l0.01283,-0.48436l-0.01283,-0.48357l0.42623,-0.53335l0.49262,0.00678l0.46998,-0.13654l0.47603,-0.10411l0.45867,-0.16144l0.43377,-0.21048l0.42623,-0.22331l0.39075,-0.27384l0.40209,-0.26479l0.32669,-0.34325l0.35682,-0.31684l0.27532,-0.40511l0.50398,0.0611zm-1.88675,6.48631l1.67625,2.73009l1.67625,-2.73009l-0.31078,-0.5477c-0.00626,0.00263 -0.12175,0.0499 -0.15164,0.02711c-0.06311,-0.04867 -0.01244,-0.3046 -0.01058,-0.31379c-0.05987,-0.10606 -0.15465,-0.19042 -0.27007,-0.24141c-0.08752,-0.03855 -0.17968,-0.08783 -0.20742,-0.13055c-0.0438,-0.07014 -0.03198,-0.26844 -0.01885,-0.38695c0.00726,-0.06335 -0.00711,-0.12839 -0.03924,-0.18486l-0.00155,-0.00301l-0.66613,-1.17233l-1.67625,2.95348z"
                });
            case 'checked-box':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "m10.53681,16.38958l7.36823,-7.36823l-1.46319,-1.46319l-5.90503,5.90503l-2.97865,-2.97865l-1.46319,1.46319l4.44184,4.44184zm-5.85278,5.01667c-0.57483,0 -1.06691,-0.20464 -1.47626,-0.61402c-0.40935,-0.40938 -0.61402,-0.90143 -0.61402,-1.47626l0,-14.63194c0,-0.57483 0.20467,-1.06691 0.61402,-1.47626c0.40935,-0.40935 0.90143,-0.61402 1.47626,-0.61402l14.63194,0c0.57483,0 1.06688,0.20467 1.47626,0.61402c0.40938,0.40935 0.61402,0.90143 0.61402,1.47626l0,14.63194c0,0.57483 -0.20464,1.06688 -0.61402,1.47626c-0.40938,0.40938 -0.90143,0.61402 -1.47626,0.61402l-14.63194,0z"
                });
            case 'leaderboard':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "m19.40725,2.81635l-2.14509,4.49127c-1.34068,-1.13958 -3.08356,-1.87695 -4.82644,-2.01102l1.40771,-2.94949c0.06703,-0.26814 0.26814,-0.4022 0.53627,-0.4022l4.62534,0c0.13407,0 0.26814,0.06703 0.4022,0.13407c0.06703,0.13407 0.13407,0.26814 0.13407,0.4022c0,0.13407 -0.06703,0.26814 -0.13407,0.33517zm0.13407,11.73094c0,4.1561 -3.3517,7.5078 -7.5078,7.5078c-4.1561,0 -7.5078,-3.3517 -7.5078,-7.5078s3.3517,-7.5078 7.5078,-7.5078c4.1561,-0.06703 7.5078,3.3517 7.5078,7.5078zm-4.02204,-2.07805l-2.01102,-0.33517l-0.87144,-1.94398c-0.33517,-0.67034 -0.80441,-0.67034 -1.07254,0l-0.87144,1.94398l-2.01102,0.33517c-0.67034,0.13407 -0.80441,0.60331 -0.33517,1.13958l1.47475,1.47475l-0.33517,2.14509c-0.13407,0.73737 0.26814,1.00551 0.87144,0.67034l1.80992,-1.00551l1.80992,1.00551c0.60331,0.33517 1.00551,0 0.87144,-0.67034l-0.33517,-2.14509l1.54178,-1.47475c0.33517,-0.53627 0.13407,-1.07254 -0.53627,-1.13958zm-10.92653,-9.65289c-0.06703,-0.06703 -0.13407,-0.2011 -0.13407,-0.33517s0.06703,-0.26814 0.13407,-0.4022c0.06703,-0.13407 0.26814,-0.13407 0.4022,-0.13407l4.62534,0c0.26814,0 0.46924,0.2011 0.53627,0.4022l1.40771,2.94949c-1.80992,0.13407 -3.48576,0.87144 -4.82644,2.01102l-2.14509,-4.49127zm0,0"
                });
            case 'skull':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "m8.7777,21.67267c0.78968,0.73043 2.03297,0.43623 3.07466,0.1894c0.59146,-0.13865 1.27024,-0.23335 1.75748,0.12849c0.24528,0.18261 0.47376,0.48692 0.7762,0.42944c0.26549,-0.04732 0.3965,-0.35169 0.62167,-0.50045c0.1579,-0.10486 0.34276,-0.12176 0.5343,-0.1116c0.04032,-0.0947 0.08064,-0.1894 0.11759,-0.28405c0.20833,-0.54446 0.4604,-1.08549 0.35286,-1.64684c0.30239,-0.49708 0.73589,-0.70332 0.92406,-1.16324c0.13443,-0.32463 0.65525,-0.4396 1.00138,-0.33137c0.10416,0.03043 0.20833,0.06764 0.31249,0.08791c0.79979,0.15555 1.4584,-0.2333 2.10692,-0.60531c0.23522,-0.13523 0.41666,-0.35506 0.38981,-0.71348c-0.0269,-0.36858 -0.15796,-0.72701 -0.16469,-1.07196c-0.01679,-0.97047 -0.3965,-1.82603 -0.64851,-2.72885c-0.10753,-0.38554 -0.37634,-0.75412 -0.21507,-1.17003c0.34613,0.34832 0.68888,0.69322 0.98122,0.98742c0.89721,0.00674 0.93079,0.00674 0.89721,-0.71353c-0.04369,-0.94341 0.16801,-1.89704 -0.15796,-2.83034c-0.11759,-0.33811 0.15796,-0.76417 -0.16801,-1.07191c-0.28228,-0.26715 -0.2117,-0.66616 -0.42003,-0.97052c-0.41334,-0.61204 -0.57798,-1.37964 -1.16602,-1.88351c-0.35623,-1.0043 -1.21981,-1.59606 -1.9557,-2.24194c-0.57461,-0.50385 -1.19965,-1.00093 -2.01281,-1.23764c-1.43488,-0.41593 -1.41472,-0.4768 -2.87981,-0.28743c-0.25202,0.03382 -0.57461,0.08115 -0.75941,-0.04058c-0.22849,-0.15217 -0.4335,-0.09806 -0.65188,-0.12849c-0.24196,-0.0372 -0.47382,0.01691 -0.73594,-0.1285c-0.22512,-0.1285 -0.55782,-0.03382 -0.87705,0.10145c-1.48525,0.6222 -2.80249,1.54197 -4.19362,2.32987c-0.21843,0.12511 -0.36965,0.45988 -0.57798,0.48694c-0.44355,0.06086 -0.59813,0.32124 -0.77286,0.66956c-0.14786,0.29415 -0.39316,0.54103 -0.60822,0.80139c-0.34275,0.41933 -0.53428,0.90625 -0.55781,1.43375c-0.02689,0.56814 -0.31251,1.10239 -0.18482,1.684c-0.31923,0.35848 -0.05041,0.83866 -0.2453,1.21735c-0.2285,0.44639 -0.04032,0.91304 -0.10417,1.3628c-0.0168,0.11497 0.03024,0.26036 -0.02352,0.34153c-0.28899,0.42944 -0.11761,0.86903 -0.13105,1.37964c0.23186,-0.08454 0.39316,-0.12176 0.53428,-0.19951c0.53765,-0.29084 0.91737,-0.76423 1.3542,-1.1734c0.07728,-0.07101 0.22176,-0.06764 0.46035,-0.13186c-0.50404,0.9671 -0.86023,1.83956 -1.16265,2.74238c-0.20162,0.6121 -0.33267,1.00432 -0.34611,1.44055c-0.01008,0.30436 0.12433,0.55798 0.28227,0.76086c0.4402,0.55793 0.92744,1.07533 1.38782,1.59946c0.38639,-0.06085 0.74931,0.06422 1.10886,-0.16571c0.17475,-0.1116 0.47719,-0.05411 0.68888,0.19277c0.3965,0.45986 0.85016,0.8724 1.1257,1.14971c0.16801,0.66279 0.23522,1.20719 0.41334,1.67384c0.01342,0 0.03021,0 0.04363,0c0.19154,0.03379 0.32597,0.20287 0.47045,0.33479l0.00337,0.00674zm4.59017,-8.35575c0.05711,-0.1217 0.15459,-0.22993 0.19828,-0.35506c0.23186,-0.67969 0.83337,-0.91641 1.40793,-1.1565c0.1479,-0.06085 0.30244,-0.1217 0.45029,-0.16903c0.17138,-0.05748 0.38308,-0.16571 0.52087,-0.15218c0.33939,0.03379 0.66867,0.18261 0.99464,0.3111c0.24865,0.09807 0.51414,0.19271 0.7191,0.35843c0.20496,0.16908 0.3965,0.34153 0.4805,0.66953c0.12438,0.48697 0.42345,0.92994 0.66199,1.41686c-0.23854,0.58504 -0.47376,1.12944 -0.68215,1.68743c-0.12769,0.33811 -0.27886,0.64247 -0.6922,0.60868c-0.37971,-0.03385 -0.70231,0.14202 -1.02827,0.25699c-0.3696,0.13186 -0.68209,0.15555 -1.02154,-0.06764c-0.15117,-0.10144 -0.35281,-0.12513 -0.53093,-0.18261c-0.31918,-0.10481 -0.63172,-0.24009 -0.82663,-0.52414c-0.32255,-0.47339 -0.66193,-0.94683 -0.914,-1.45744c-0.21501,-0.4396 0.08401,-0.8454 0.26212,-1.24104l0,-0.00337zm-1.87838,4.08828c0.04363,-0.30436 0.27217,-0.57825 0.42003,-0.86566l0.37971,0c0.30575,0.70332 0.58467,1.43712 0.94421,2.12697c0.24533,0.47339 0.1378,0.91978 0.14454,1.52166c-0.25207,-0.19951 -0.39655,-0.32121 -0.5444,-0.43281c-0.19822,-0.14881 -0.41329,-0.27394 -0.59814,-0.43623c-0.14448,-0.12849 -0.25538,-0.21303 -0.42676,-0.04059c-0.20833,0.21303 -0.58804,-0.08454 -0.7661,0.24688c-0.08401,-0.0778 -0.16469,-0.15555 -0.21843,-0.2063c0.20833,-0.65263 0.57125,-1.22409 0.66867,-1.91057l-0.00332,-0.00337zm-4.3449,-0.8623c-0.19491,-0.03722 -0.42339,0.04732 -0.60483,-0.0169c-0.22517,-0.08117 -0.4335,-0.23672 -0.6183,-0.39564c-0.21843,-0.18598 -0.73257,-1.5014 -0.73931,-1.79223c-0.00668,-0.20624 -0.02016,-0.40917 0.18822,-0.53766c0.047,-0.03043 0.09069,-0.07438 0.12432,-0.1217c0.29233,-0.45312 0.43008,-1.02801 0.88374,-1.34585c0.44018,-0.30773 0.9409,-0.53093 1.41472,-0.79128c0.047,-0.02706 0.09069,-0.06764 0.17469,-0.13186c0.51751,0.35163 1.06185,0.53766 1.5323,0.88256c0.21843,0.15892 0.34276,0.30773 0.46371,0.52077c0.18817,0.33474 0.3226,0.68979 0.59477,0.98737c0.17138,0.18603 0.26886,0.47008 0.06048,0.80481c-0.22175,0.35843 -0.29233,0.80818 -0.44355,1.21398c-0.12095,0.328 -0.32255,0.47339 -0.70899,0.57483c-1.21307,0.32463 -1.19965,0.36864 -2.32198,0.14881z"
                });
            case 'translation':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "m12,2.00001c-1.97785,0 -3.9112,0.58649 -5.55569,1.6853c-1.64449,1.09882 -2.92621,2.6606 -3.6831,4.48786c-0.75687,1.82726 -0.9549,3.83793 -0.56906,5.77772c0.38586,1.93979 1.33827,3.72164 2.73679,5.1202c1.39852,1.39846 3.18035,2.35087 5.12018,2.73672c1.93979,0.38585 3.95046,0.1879 5.77774,-0.56903c1.82728,-0.75682 3.38902,-2.03856 4.48779,-3.68307c1.09887,-1.64451 1.68533,-3.57795 1.68533,-5.55569c-0.00308,-2.65128 -1.05764,-5.19301 -2.93231,-7.06771c-1.87467,-1.87471 -4.41641,-2.92925 -7.06769,-2.93231zm8.46153,10.00002c0.00072,0.78031 -0.10708,1.55702 -0.3202,2.30769l-3.70287,0c0.2359,-1.52944 0.2359,-3.08595 0,-4.61538l3.70287,0c0.21313,0.75067 0.32092,1.52728 0.3202,2.30769zm-10.96152,3.84615l4.99999,0c-0.49262,1.61405 -1.34769,3.09405 -2.5,4.32687c-1.15179,-1.23313 -2.00687,-2.71313 -2.49999,-4.32687zm-0.375,-1.53846c-0.26409,-1.52718 -0.26409,-3.08831 0,-4.61538l5.75766,0c0.2641,1.52708 0.2641,3.0882 0,4.61538l-5.75766,0zm-5.58653,-2.30769c-0.00067,-0.78041 0.10709,-1.55702 0.32019,-2.30769l3.70288,0c-0.2359,1.52944 -0.2359,3.08595 0,4.61538l-3.70288,0c-0.21311,-0.75067 -0.32086,-1.52738 -0.32019,-2.30769zm10.96152,-3.84617l-4.99999,0c0.4926,-1.61403 1.34768,-3.09405 2.49999,-4.32692c1.1519,1.23319 2.00697,2.71311 2.5,4.32692zm5.03169,0l-3.42492,0c-0.43169,-1.58374 -1.15928,-3.07147 -2.14431,-4.38461c1.19015,0.2859 2.30441,0.82574 3.26636,1.58255c0.96185,0.75681 1.74882,1.71267 2.30677,2.80206l-0.0039,0zm-9.49415,-4.38461c-0.98503,1.31315 -1.71257,2.80087 -2.14426,4.38461l-3.42885,0c0.55796,-1.08939 1.34487,-2.04525 2.30682,-2.80206c0.96194,-0.75681 2.07615,-1.29666 3.26629,-1.58255zm-5.5731,12.07694l3.42885,0c0.43168,1.58369 1.15923,3.07149 2.14426,4.38461c-1.19013,-0.28595 -2.30435,-0.82574 -3.26629,-1.58256c-0.96195,-0.75682 -1.74886,-1.71272 -2.30682,-2.80205zm9.49803,4.38461c0.98503,-1.31313 1.71261,-2.80092 2.14431,-4.38461l3.42882,0c-0.55795,1.08933 -1.34492,2.04523 -2.30677,2.80205c-0.96195,0.75682 -2.0762,1.29661 -3.26636,1.58256z"
                });
            case 'copy':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M15 1H3c-1.1 0-2 .9-2 2v12h2V3h12V1zm6 6H9c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 14H9V9h12v12z"
                });
            case 'muted':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "m14.13465,21.23742l0,-2.17402q2.35362,-0.68933 3.79193,-2.65125t1.43832,-4.45409q0,-2.49217 -1.43832,-4.45409t-3.79193,-2.65125l0,-2.17402q3.24276,0.74235 5.28255,3.32731t2.0398,5.95204q0,3.36709 -2.0398,5.95204t-5.28255,3.32731l0,0.00002zm-11.50656,-6.07136l0,-6.36299l4.1842,0l5.23025,-5.30249l0,16.96798l-5.23025,-5.30249l-4.1842,0l0,-0.00001zm11.50656,1.0605l0,-8.53701q1.22911,0.58327 1.92212,1.74982t0.69301,2.54519q0,1.35213 -0.69301,2.50543t-1.92212,1.73657zm-4.1842,-7.58257l-2.24901,2.28007l-2.98124,0l0,2.121l2.98124,0l2.24901,2.28007l0,-6.68114zm-2.61513,3.34057zm12.88426,11.15287l-19.38483,-19.38483l1.47493,-1.47493l19.38483,19.38483l-1.47493,1.47493z"
                });
            case 'unmuted':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "m14.13465,21.23742l0,-2.17402q2.35362,-0.68933 3.79193,-2.65125t1.43832,-4.45409q0,-2.49217 -1.43832,-4.45409t-3.79193,-2.65125l0,-2.17402q3.24276,0.74235 5.28255,3.32731t2.0398,5.95204q0,3.36709 -2.0398,5.95204t-5.28255,3.32731l0,0.00002zm-11.50656,-6.07136l0,-6.36299l4.1842,0l5.23025,-5.30249l0,16.96798l-5.23025,-5.30249l-4.1842,0l0,-0.00001zm11.50656,1.0605l0,-8.53701q1.22911,0.58327 1.92212,1.74982t0.69301,2.54519q0,1.35213 -0.69301,2.50543t-1.92212,1.73657zm-4.1842,-7.58257l-2.24901,2.28007l-2.98124,0l0,2.121l2.98124,0l2.24901,2.28007l0,-6.68114zm-2.61513,3.34057z"
                });
            case 'refresh':
                return /*#__PURE__*/ (0, $9h2J6.jsx)("g", {
                    transform: "translate(2 2)",
                    children: /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                        d: "M18.75 1.69315V6.19315C18.75 6.49152 18.6315 6.77767 18.4205 6.98865C18.2095 7.19963 17.9234 7.31815 17.625 7.31815H13.125C12.8266 7.31815 12.5405 7.19963 12.3295 6.98865C12.1185 6.77767 12 6.49152 12 6.19315C12 5.89478 12.1185 5.60864 12.3295 5.39766C12.5405 5.18668 12.8266 5.06815 13.125 5.06815H14.9062L14.175 4.3369C12.8511 3.00642 11.0532 2.25584 9.17625 2.25003H9.13594C7.27575 2.24596 5.48875 2.97443 4.16156 4.27784C3.94823 4.48645 3.66076 4.60177 3.3624 4.59843C3.06405 4.59509 2.77923 4.47336 2.57062 4.26003C2.36202 4.04669 2.2467 3.75923 2.25004 3.46087C2.25338 3.16251 2.3751 2.8777 2.58844 2.66909C4.33614 0.952953 6.68935 -0.00591244 9.13875 2.74329e-05H9.1875C11.6585 0.00676464 14.0257 0.994451 15.7687 2.74596L16.5 3.4744V1.69315C16.5 1.39478 16.6185 1.10864 16.8295 0.897657C17.0405 0.686679 17.3266 0.568152 17.625 0.568152C17.9234 0.568152 18.2095 0.686679 18.4205 0.897657C18.6315 1.10864 18.75 1.39478 18.75 1.69315ZM14.5884 14.1085C13.2606 15.4126 11.4724 16.1411 9.61125 16.1363H9.57094C7.694 16.1305 5.89611 15.3799 4.57219 14.0494L3.84375 13.3182H5.625C5.92337 13.3182 6.20952 13.1996 6.4205 12.9886C6.63147 12.7777 6.75 12.4915 6.75 12.1932C6.75 11.8948 6.63147 11.6086 6.4205 11.3977C6.20952 11.1867 5.92337 11.0682 5.625 11.0682H1.125C0.826631 11.0682 0.540483 11.1867 0.329505 11.3977C0.118526 11.6086 0 11.8948 0 12.1932V16.6932C0 16.9915 0.118526 17.2777 0.329505 17.4886C0.540483 17.6996 0.826631 17.8182 1.125 17.8182C1.42337 17.8182 1.70952 17.6996 1.9205 17.4886C2.13147 17.2777 2.25 16.9915 2.25 16.6932V14.9119L2.98125 15.6432C4.72474 17.3936 7.09189 18.3803 9.5625 18.3863H9.615C12.0644 18.3922 14.4176 17.4333 16.1653 15.7172C16.2709 15.6139 16.3552 15.4908 16.4133 15.355C16.4713 15.2191 16.5021 15.0732 16.5037 14.9254C16.5054 14.7777 16.4779 14.6311 16.4229 14.494C16.3679 14.3568 16.2864 14.2319 16.1831 14.1263C16.0798 14.0206 15.9567 13.9364 15.8209 13.8783C15.685 13.8203 15.5391 13.7895 15.3913 13.7879C15.2436 13.7862 15.097 13.8137 14.9599 13.8687C14.8228 13.9237 14.6978 14.0052 14.5922 14.1085H14.5884Z"
                    })
                });
            default:
                return null;
        }
    }
    return /*#__PURE__*/ (0, $9h2J6.jsx)("svg", {
        className: $dSVwS.Icon,
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            display: 'inline-block',
            ...style
        },
        ...props,
        children: getIcon()
    });
}

});
parcelRegister("dSVwS", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $a1bcf19f7486d5c0$export$f04a61298a47a40f; }, function (v) { return $a1bcf19f7486d5c0$export$f04a61298a47a40f = v; });
$parcel$export(module.exports, "spin", function () { return $a1bcf19f7486d5c0$export$c82e186cf428d56d; }, function (v) { return $a1bcf19f7486d5c0$export$c82e186cf428d56d = v; });
$parcel$export(module.exports, "spinner", function () { return $a1bcf19f7486d5c0$export$641374ffb95bc399; }, function (v) { return $a1bcf19f7486d5c0$export$641374ffb95bc399 = v; });
var $a1bcf19f7486d5c0$export$f04a61298a47a40f;
var $a1bcf19f7486d5c0$export$c82e186cf428d56d;
var $a1bcf19f7486d5c0$export$641374ffb95bc399;
$a1bcf19f7486d5c0$export$f04a61298a47a40f = `q4ybRG_Icon`;
$a1bcf19f7486d5c0$export$c82e186cf428d56d = `q4ybRG_spin`;
$a1bcf19f7486d5c0$export$c82e186cf428d56d;
$a1bcf19f7486d5c0$export$641374ffb95bc399 = `q4ybRG_spinner`;

});


parcelRegister("1afSf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08aba753e0078e61$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "setQuestCompleted", function () { return $08aba753e0078e61$export$1ae8fa5f3e29b54b; });
$parcel$export(module.exports, "setQuestProgress", function () { return $08aba753e0078e61$export$4cfc0f2a1731c39b; });
$parcel$export(module.exports, "openExternalLinkDiscord", function () { return $08aba753e0078e61$export$5b17b3e1f2afc156; });
$parcel$export(module.exports, "isDiscordOnMobile", function () { return $08aba753e0078e61$export$b49c70d05fdcc765; });
$parcel$export(module.exports, "discordPlatform", function () { return $08aba753e0078e61$export$787fabc8927c959b; });
$parcel$export(module.exports, "triggerDiscordShare", function () { return $08aba753e0078e61$export$6cd85e0372786ce6; });
$parcel$export(module.exports, "shareImageInDiscordDesktop", function () { return $08aba753e0078e61$export$48dd506b03a6eff7; });
parcelRequire("4exxJ");
var $b5027 = parcelRequire("b5027");
var $cOfbu = parcelRequire("cOfbu");

var $7jzTX = parcelRequire("7jzTX");

var $7RNO0 = parcelRequire("7RNO0");

var $cTs7K = parcelRequire("cTs7K");

var $9K8Jg = parcelRequire("9K8Jg");

var $i2KZ1 = parcelRequire("i2KZ1");

var $gxeM7 = parcelRequire("gxeM7");

var $6Jwum = parcelRequire("6Jwum");

var $6KpYp = parcelRequire("6KpYp");

var $9HMNu = parcelRequire("9HMNu");

var $f9UtO = parcelRequire("f9UtO");

var $ly8fr = parcelRequire("ly8fr");

var $kFQy0 = parcelRequire("kFQy0");

var $7v5wN = parcelRequire("7v5wN");

var $guTIo = parcelRequire("guTIo");

var $b3Ivu = parcelRequire("b3Ivu");
const $08aba753e0078e61$var$CLIENT_ID = "1526628598549708880";
let $08aba753e0078e61$var$QUEST_ID = "1526631789316276374";
let $08aba753e0078e61$var$DISCORD_LOCALE_FOR_ANALYTICS = '';
const $08aba753e0078e61$var$url = new URL(window.location.href);
const $08aba753e0078e61$var$ARISE_SESSION_ID = $08aba753e0078e61$var$url.searchParams.get('arise_session_id');
const $08aba753e0078e61$var$ARISE_SESSION_DATA = $08aba753e0078e61$var$url.searchParams.get('arise_session_data');
const $08aba753e0078e61$var$activityStartTime = Date.now();
// remove the session parameters from the URL and update the URL without reloading the page
if ($08aba753e0078e61$var$ARISE_SESSION_ID) {
    console.log('[Arise] Removing session ID from URL');
    $08aba753e0078e61$var$url.searchParams.delete('arise_session_id');
}
if ($08aba753e0078e61$var$ARISE_SESSION_DATA) {
    console.log('[Arise] Removing session data from URL');
    $08aba753e0078e61$var$url.searchParams.delete('arise_session_data');
}
window.history.replaceState({}, '', $08aba753e0078e61$var$url.toString());
let $08aba753e0078e61$var$userDiscordAccessToken = null;
let $08aba753e0078e61$var$discordSDK = null;
let $08aba753e0078e61$var$discordReadyPromise = null;
let $08aba753e0078e61$var$discordReadyStartedAt = 0;
let $08aba753e0078e61$var$discordHookMountSeq = 0;
try {
    // We need to instatiate this here on pageload so that the arise frontend does not change the query params in the URL that the discord sdk uses
    $08aba753e0078e61$var$discordSDK = new (0, $b5027.DiscordSDK)($08aba753e0078e61$var$CLIENT_ID, {
        disableAutoHandshake: true
    });
} catch (error) {
    if (0, $cTs7K.IS_DISCORD_ACTIVITY) console.error('[Arise] Discord SDK not instatiated', error);
}
let $08aba753e0078e61$var$firstLayoutUpdateReceived = false;
// Module-level auth state — persists across hook remounts so a second mount
// picks up the already-resolved values immediately via useState initialisers.
let $08aba753e0078e61$var$moduleUser = null;
let $08aba753e0078e61$var$moduleAuthData = null;
let $08aba753e0078e61$var$moduleAuthLoading = false;
let $08aba753e0078e61$var$moduleAuthError = '';
let $08aba753e0078e61$var$moduleAuthDenied = false;
// Single init promise — guarantees SDK auth runs only once per page load.
let $08aba753e0078e61$var$discordInitPromise = null;
function $08aba753e0078e61$export$2e2bcd8739ae039() {
    const discord = (0, $7RNO0.useRef)();
    const [user, _setUser] = (0, $7RNO0.useState)($08aba753e0078e61$var$moduleUser);
    const [authLoading, _setAuthLoading] = (0, $7RNO0.useState)($08aba753e0078e61$var$moduleAuthLoading);
    const [authError, _setAuthError] = (0, $7RNO0.useState)($08aba753e0078e61$var$moduleAuthError);
    const [authDenied, _setAuthDenied] = (0, $7RNO0.useState)($08aba753e0078e61$var$moduleAuthDenied);
    const theme = (0, $7v5wN.useTheme)();
    const dispatch = (0, $i2KZ1.useAppDispatch)();
    // not sure if we need this
    const [authData, _setAuthData] = (0, $7RNO0.useState)($08aba753e0078e61$var$moduleAuthData);
    // Wrapper setters keep module-level mirrors in sync so remounted instances
    // initialise their useState from the already-resolved values above.
    function setUser(val) {
        $08aba753e0078e61$var$moduleUser = val;
        _setUser(val);
    }
    function setAuthLoading(val) {
        $08aba753e0078e61$var$moduleAuthLoading = val;
        _setAuthLoading(val);
    }
    function setAuthError(val) {
        $08aba753e0078e61$var$moduleAuthError = val;
        _setAuthError(val);
    }
    function setAuthDenied(val) {
        $08aba753e0078e61$var$moduleAuthDenied = val;
        _setAuthDenied(val);
    }
    function setAuthData(val) {
        $08aba753e0078e61$var$moduleAuthData = val ?? null;
        _setAuthData(val);
    }
    const ariseRegister = $08aba753e0078e61$var$useAriseRegister();
    const quest = $08aba753e0078e61$var$useDiscordQuest();
    const { setLang: setLang } = (0, $guTIo.useLang)();
    (0, $7RNO0.useEffect)(()=>{
        const mountId = ++$08aba753e0078e61$var$discordHookMountSeq;
        console.log(`[Arise] useDiscord mounted (#${mountId})`);
        // Always point the ref at the singleton SDK instance.
        discord.current = $08aba753e0078e61$var$discordSDK;
        // @ts-ignore
        window.discordSDK = discord.current;
        if (!$08aba753e0078e61$var$discordInitPromise) // First mount — kick off auth. Capture authorize / authoriseFromSession
        // from this closure; they already use the module-aware setters above.
        $08aba753e0078e61$var$discordInitPromise = (async ()=>{
            try {
                if (!$08aba753e0078e61$var$CLIENT_ID) {
                    console.error('[Arise] No PUBLIC_DISCORD_CLIENT_ID set');
                    return;
                }
                let ok = false;
                if (!$08aba753e0078e61$var$ARISE_SESSION_ID) {
                    await $08aba753e0078e61$var$ensureDiscordSdkReady(discord.current);
                    // authorise immediately
                    ok = await authorize();
                } else {
                    console.log('[Arise] Forcing Discord SDK to be ready');
                    discord.current['isReady'] = true;
                    await $08aba753e0078e61$var$ensureDiscordSdkReady(discord.current);
                    authoriseFromSession();
                }
                if (ok) (0, $kFQy0.sendEventV2Once)('discord_authenticated');
                await questCheckUsingSDK();
                console.log('[Arise] Discord authorized');
            } catch (error) {
                // Allow a retry on the next mount if init failed.
                $08aba753e0078e61$var$discordInitPromise = null;
                console.log('[Arise] Could not get discord sdk ready', error);
            }
        })();
        else console.log(`[Arise] useDiscord already initialised (#${mountId}), reusing state`);
        return ()=>{
            console.log(`[Arise] useDiscord unmounted (#${mountId})`);
        };
    }, []);
    async function questCheckUsingSDK() {
        try {
            const res = await discord.current?.commands.getQuest();
            console.log('[Arise] quest data from sdk:', JSON.stringify(res));
            if (res) {
                $08aba753e0078e61$var$QUEST_ID = res.quest_id;
                $7jzTX.setQuestId($08aba753e0078e61$var$QUEST_ID);
                dispatch((0, $gxeM7.setQuestFromSDK)(res));
            }
        } catch (error) {
            console.error('[Arise] could not get quest info from sdk');
            quest.check();
        }
    }
    async function setLanguageFromDiscordLocale() {
        try {
            const { locale: locale } = await discord.current.commands.userSettingsGetLocale();
            $08aba753e0078e61$var$DISCORD_LOCALE_FOR_ANALYTICS = locale;
            (0, $kFQy0.sendEventV2Once)('discord_locale', [
                locale
            ]);
            dispatch((0, $gxeM7.setDiscordLocale)(locale));
            const savedUserPreference = (0, $b3Ivu.getSavedLangIso)();
            if (!savedUserPreference) // Do not overwrite manually selected language
            setLang(locale);
        } catch (error) {
            console.warn('[Arise] Could not set discord locale:', error);
        }
    }
    async function authoriseFromSession() {
        console.log('[Arise] Authorizing from session');
        if (!$08aba753e0078e61$var$ARISE_SESSION_DATA) {
            console.error('[Arise] No session data found in URL');
            return;
        }
        const data = JSON.parse($08aba753e0078e61$var$ARISE_SESSION_DATA);
        console.log('[Arise] Session data from URL', data);
        if ($08aba753e0078e61$var$ARISE_SESSION_DATA) {
            if (data.auth && data.authData) {
                setUser(data.auth.user);
                setLanguageFromDiscordLocale();
                dispatch((0, $6KpYp.setProfileV2DisplayName)(data.auth.user.global_name || data.auth.user.username));
                $08aba753e0078e61$var$userDiscordAccessToken = data.authData.access_token;
                $7jzTX.setAuthToken(data.authData.token);
                setAuthData(data.authData);
                dispatch((0, $gxeM7.setDiscordUser)(data.authData.user));
                console.log('[Arise] Restored Discord session from localStorage');
            } else console.error('[Arise] invalid session data in localStorage', $08aba753e0078e61$var$ARISE_SESSION_DATA);
        } else console.error('[Arise] No session data found in localStorage');
    }
    async function authorize() {
        if (authLoading) return;
        setAuthLoading(true);
        setAuthDenied(false);
        setAuthError('');
        let discordUser = null;
        const scope = [
            'identify'
        ];
        const additionalScopes = undefined;
        if (additionalScopes) {
            additionalScopes.split(',').forEach((d)=>scope.push(d));
            console.log('[Arise] added additional scopes. ', scope);
        }
        try {
            console.log('[Arise] No auth code found in URL, requesting authorization from Discord');
            const authRes = await discord.current.commands.authorize({
                client_id: $08aba753e0078e61$var$CLIENT_ID,
                response_type: 'code',
                state: '',
                prompt: 'none',
                scope: scope
            });
            const code = authRes.code;
            (0, $kFQy0.sendEventV2)('discordlogin__prompt_accepted');
            let authData;
            try {
                authData = await $08aba753e0078e61$var$tryXTimes(async ()=>{
                    const res = await $7jzTX.authorize(code);
                    if (!res.access_token) {
                        (0, $kFQy0.sendEventV2)('discordlogin__authexchange_no_token');
                        throw new Error('No auth data');
                    }
                    return res;
                }, 3);
            } catch (error) {
                console.error('[Arise] Error exchanging auth code for access token', error);
                (0, $kFQy0.sendEventV2)('discordlogin__authexchange_failed');
                const fallbackDisplayName = theme?.customJSON?.settings?.guestUsernamePrefix ?? 'Guest';
                dispatch((0, $6KpYp.setProfileV2DisplayName)(fallbackDisplayName));
                // @ts-ignore
                setUser({
                    username: fallbackDisplayName
                });
                setAuthLoading(false);
                return false;
            }
            const auth = await discord.current.commands.authenticate({
                access_token: authData.access_token
            });
            // Setup listeners
            // note: layout listerners do not work on password protected activities
            setupLayoutListeners();
            setUser(auth.user);
            dispatch((0, $6KpYp.setProfileV2DisplayName)(auth.user.global_name || auth.user.username));
            setLanguageFromDiscordLocale();
            $08aba753e0078e61$var$userDiscordAccessToken = authData.access_token;
            setAuthLoading(false);
            setAuthData(authData);
            $7jzTX.setAuthToken(authData.token);
            dispatch((0, $gxeM7.setDiscordUser)(authData.user));
            discordUser = authData.user;
            encourageHardwareAcceleration();
        } catch (error) {
            // User denied authorization
            if (error.code === 5000) {
                (0, $kFQy0.sendEventV2)('discordlogin__prompt_denied');
                setAuthDenied(true);
            } else if (error.code === 4002) ;
            else {
                (0, $kFQy0.sendEventV2)('discordlogin__error', [
                    error instanceof Error ? error.message : typeof error === 'string' ? error : JSON.stringify(error)
                ]);
                console.log('[Arise] Authorizing Error', error);
                setAuthError('Error authorizing with Discord');
            }
        } finally{
            setAuthLoading(false);
        }
        // Register with Arise
        // This is an async call that doesn't return anything so we don't need to await it
        ariseRegisterFlow(discordUser);
        return true;
    }
    async function ariseRegisterFlow(discordUser) {
        try {
            await ariseRegister.register();
        } catch (e) {
            console.error('[Arise] Error registering with Arise', e);
        }
        if (discordUser) // Defer discord premium type until we have user_id.
        $08aba753e0078e61$var$sendEventDiscordPremiumType(discordUser.premium_type);
    }
    function openExternalLink(url) {
        if (discord.current) discord.current.commands.openExternalLink({
            url: url
        });
    }
    function onMinimise() {
        console.log('[Arise] Minimise');
        dispatch((0, $gxeM7.setWindowSize)('minimized'));
        dispatch((0, $9HMNu.setShouldHideUI)(true));
    }
    function onMaximise() {
        console.log('[Arise] Maximise');
        dispatch((0, $gxeM7.setWindowSize)('maximized'));
        dispatch((0, $9HMNu.setShouldHideUI)(false));
        setTimeout(()=>{
            quest.recheckEnrollment();
        }, 1000);
    }
    async function setupLayoutListeners() {
        const onActivityLayoutModeUpdate = (e)=>{
            console.log('[Arise] Activity layout mode update', e);
            if (!$08aba753e0078e61$var$firstLayoutUpdateReceived) {
                $08aba753e0078e61$var$firstLayoutUpdateReceived = true;
                return;
            }
            if (e.layout_mode === 1) onMinimise();
            else if (e.layout_mode === 0) onMaximise();
            else {
                console.log('[Arise] Unhandled layout mode', e.layout_mode);
                onMaximise();
            }
        };
        async function onQuestStatusUpdate(e) {
            console.log('[Arise] Quest status update from sdk', e);
        }
        if (discord.current) try {
            await discord.current.subscribe((0, $cOfbu.Events).ACTIVITY_LAYOUT_MODE_UPDATE, onActivityLayoutModeUpdate);
            await discord.current.subscribe((0, $cOfbu.Events).QUEST_ENROLLMENT_STATUS_UPDATE, onQuestStatusUpdate);
        } catch (error) {
            console.error('[Arise] sdk subscribe error: ', error);
        }
        else console.error('[Arise] Unable to setup listener');
        return ()=>{
            if (discord.current) try {
                discord.current.unsubscribe((0, $cOfbu.Events).ACTIVITY_LAYOUT_MODE_UPDATE, onActivityLayoutModeUpdate);
                discord.current.unsubscribe((0, $cOfbu.Events).QUEST_ENROLLMENT_STATUS_UPDATE, onQuestStatusUpdate);
            } catch (error) {
                console.error('[Arise] sdk UNsubscribe error: ', error);
            }
        };
    }
    async function encourageHardwareAcceleration() {
        try {
            const res = await discord.current.commands.encourageHardwareAcceleration();
            (0, $kFQy0.sendEventV2)('encourage_hardware_acceleration', [
                res.enabled ? 'enabled' : 'disabled'
            ]);
        } catch (error) {
            console.error('[Arise] Error encouraging hardware acceleration', error);
        }
    }
    return {
        authorize: authorize,
        openExternalLink: openExternalLink,
        user: user,
        authError: authError,
        ariseRegister: ariseRegister,
        authDenied: authDenied,
        quest: quest,
        authLoading: authLoading
    };
}
async function $08aba753e0078e61$var$ensureDiscordSdkReady(sdk) {
    if (!sdk) throw new Error('Discord SDK not instantiated');
    // Important: multiple mounts can happen (routing, HMR, parent remount). We only want *one*
    // handshake/ready wait for the lifetime of the page.
    if (!$08aba753e0078e61$var$discordReadyPromise) {
        $08aba753e0078e61$var$discordReadyStartedAt = Date.now();
        console.log('[Arise] Waiting for Discord SDK to be ready');
        $08aba753e0078e61$var$discordReadyPromise = (async ()=>{
            try {
                try {
                    // `handshake()` is not part of the public typings, but it exists at runtime for this SDK.
                    // If the SDK already handshook, calling again should be harmless; if it throws, we still
                    // want to continue waiting for `ready()`.
                    // @ts-ignore
                    sdk.handshake?.();
                } catch (e) {
                    console.warn('[Arise] Discord SDK handshake threw (continuing)', e);
                }
                // Add a soft timeout so we can surface better diagnostics if READY never arrives.
                await Promise.race([
                    sdk.ready(),
                    new Promise((_, reject)=>setTimeout(()=>reject(new Error('Timed out waiting for Discord SDK ready()')), 15000))
                ]);
                console.log('[Arise] Discord SDK is ready');
            } catch (e) {
                // Allow a later retry after transient failures.
                $08aba753e0078e61$var$discordReadyPromise = null;
                throw e;
            }
        })();
    } else {
        const elapsedMs = Date.now() - $08aba753e0078e61$var$discordReadyStartedAt;
        console.log(`[Arise] Reusing existing Discord SDK ready() wait (elapsed ${elapsedMs}ms)`);
    }
    return $08aba753e0078e61$var$discordReadyPromise;
}
function $08aba753e0078e61$var$useAriseRegister() {
    const dispatch = (0, $i2KZ1.useAppDispatch)();
    const [trying, setTrying] = (0, $7RNO0.useState)(false);
    const [failed, setFailed] = (0, $7RNO0.useState)(false);
    async function register() {
        const totalAttempts = 3;
        let attempts = 0;
        let success = false;
        setTrying(true);
        while(!success && attempts < totalAttempts)try {
            const res = await $7jzTX.register();
            $9K8Jg.setAuthToken(res.authToken);
            dispatch((0, $6Jwum.updateIsLoggedIn)(true));
            try {
                const payload = (0, $f9UtO.getTokenPayload)(res.authToken);
                (0, $ly8fr.setUserId)(payload.sub);
            } catch (error) {}
            success = true;
            break;
        } catch (error) {
            console.log('[Arise] Error registering with Arise', error);
            attempts++;
        }
        setTrying(false);
        if (!success) setFailed(true);
    }
    return {
        register: register,
        trying: trying,
        failed: failed
    };
}
function $08aba753e0078e61$var$useDiscordQuest() {
    const id = $08aba753e0078e61$var$QUEST_ID;
    const dispatch = (0, $i2KZ1.useAppDispatch)();
    const status = (0, $i2KZ1.useAppSelector)((state)=>state.discord.questStatus);
    const checked = (0, $i2KZ1.useAppSelector)((state)=>state.discord.questStatusChecked);
    const check = (0, $7RNO0.useCallback)(async ()=>{
        try {
            let status = 'not_enrolled';
            try {
                const res = await $08aba753e0078e61$var$discordSDK?.commands.getQuest();
                console.log('[Arise] quest data from sdk2:', JSON.stringify(res));
                if (res) {
                    $08aba753e0078e61$var$QUEST_ID = res.quest_id;
                    console.log('[Arise] Quest id:', res.quest_id);
                    $7jzTX.setQuestId($08aba753e0078e61$var$QUEST_ID);
                    dispatch((0, $gxeM7.setQuestFromSDK)(res));
                    if (res.completed_at) status = 'completed';
                    else if (res.enrolled_at) status = 'enrolled';
                }
            } catch (error) {
                const data = await $7jzTX.checkQuest();
                if (data.completed_at) status = 'completed';
                else if (data.enrolled_at) status = 'enrolled';
                dispatch((0, $gxeM7.setQuestStatus)(status));
            }
            return {
                status: status,
                checked: true
            };
        } catch (error) {
            console.log('[Arise] Error checking quest status', error);
        }
        return {
            status: 'not_enrolled',
            checked: false
        };
    }, []);
    const complete = (0, $7RNO0.useCallback)(async ()=>{
        await $08aba753e0078e61$export$1ae8fa5f3e29b54b();
        dispatch((0, $gxeM7.setQuestStatus)('completed'));
    }, []);
    const progress = (0, $7RNO0.useCallback)(async (val)=>{
        await $08aba753e0078e61$export$4cfc0f2a1731c39b(val);
    }, []);
    const recheckEnrollment = (0, $7RNO0.useCallback)(async ()=>{
        console.log('[Arise] Rechecking enrollment');
        if (status === 'not_enrolled' || !status) await check();
    }, []);
    return {
        check: check,
        checked: checked,
        status: status,
        complete: complete,
        recheckEnrollment: recheckEnrollment,
        progress: progress
    };
}
function $08aba753e0078e61$export$30668231c031c47c() {
    if ($08aba753e0078e61$var$discordSDK) $08aba753e0078e61$var$discordSDK.commands.openExternalLink({
        url: `https://discord.com/quests/${$08aba753e0078e61$var$QUEST_ID}`
    });
}
function $08aba753e0078e61$export$5b17b3e1f2afc156(url) {
    if ($08aba753e0078e61$var$discordSDK && url) $08aba753e0078e61$var$discordSDK.commands.openExternalLink({
        url: url
    });
}
function $08aba753e0078e61$export$60ee035e6a733fa1() {
    // Some quests are 0-1 and some 0-100
    return Number("10") || 1;
}
function $08aba753e0078e61$var$shouldSendQuestProgress() {
    try {
        const discordSettings = (0, $i2KZ1.default).getState().app.theme.metadata?.customJSON?.discord;
        // ISO date string e.g. "2026-02-04T18:30:00Z"
        const stopAtTime = discordSettings?.discordProgressCallsStopAt;
        if (!stopAtTime) return true;
        const stopAtTimeMs = Date.parse(stopAtTime);
        if (Number.isNaN(stopAtTimeMs)) {
            console.log('[Arise] Invalid discordProgressCallsStopAt date', stopAtTime);
            return true;
        }
        return Date.now() < stopAtTimeMs;
    } catch (error) {
        console.log('[Arise] shouldSendQuestProgress error caught', error);
        return true;
    }
}
async function $08aba753e0078e61$export$4cfc0f2a1731c39b(val) {
    try {
        if (!$08aba753e0078e61$var$shouldSendQuestProgress()) {
            console.log('[Arise] Not sending Quest progress - disabled by discordSettings.discordProgressCallsStopAt');
            return;
        }
        const maxProgress = $08aba753e0078e61$export$60ee035e6a733fa1();
        if (val >= maxProgress) {
            console.log(`[Arise] Cannot set quest progress (${val}) - value is equal to or greater than max progress (${maxProgress}). Use quest-completed instead.`);
            return;
        }
        const { wasSuccessful: wasSuccessful, message: message } = await $7jzTX.questProgress(val);
        const successInfo = wasSuccessful ? 'quest-progress-successful' : 'quest-progress-unsuccessful';
        const strings = [
            successInfo,
            ...message ? [
                message
            ] : [],
            (0, $7jzTX.getQuestIdForAnalytics)(),
            $08aba753e0078e61$var$DISCORD_LOCALE_FOR_ANALYTICS
        ];
        (0, $kFQy0.sendEventV2)('quest_progress', strings, [
            Date.now() - $08aba753e0078e61$var$activityStartTime,
            val
        ]);
    } catch (error) {
        console.log('[Arise] Error progressing quest', error);
    }
}
async function $08aba753e0078e61$export$1ae8fa5f3e29b54b() {
    try {
        if (!$08aba753e0078e61$var$shouldSendQuestProgress()) {
            console.log('[Arise] Not sending Quest complete - disabled by discordSettings.discordProgressCallsStopAt');
            return;
        }
        const maxProgress = $08aba753e0078e61$export$60ee035e6a733fa1();
        const { wasSuccessful: wasSuccessful, message: message } = await $7jzTX.questProgress(maxProgress);
        const successInfo = wasSuccessful ? 'quest-complete-successful' : 'quest-complete-unsuccessful';
        const strings = [
            successInfo,
            ...message ? [
                message
            ] : [],
            (0, $7jzTX.getQuestIdForAnalytics)(),
            $08aba753e0078e61$var$DISCORD_LOCALE_FOR_ANALYTICS
        ];
        (0, $kFQy0.sendEventV2)('quest_complete', strings, [
            Date.now() - $08aba753e0078e61$var$activityStartTime
        ]);
    } catch (error) {
        console.log('[Arise] Error completing quest', error);
    }
}
function $08aba753e0078e61$export$b49c70d05fdcc765() {
    return $08aba753e0078e61$var$discordSDK?.platform === 'mobile';
}
function $08aba753e0078e61$export$787fabc8927c959b() {
    return $08aba753e0078e61$var$discordSDK?.platform;
}
async function $08aba753e0078e61$export$6cd85e0372786ce6(text = '', disableAutoLink, linkId) {
    if ($08aba753e0078e61$var$discordSDK) try {
        // Send text with link added to end automatically, unless disableAutoLink is true
        const shouldLinkToQuest = !!$08aba753e0078e61$var$QUEST_ID;
        const url = shouldLinkToQuest ? `https://discord.com/quests/${$08aba753e0078e61$var$QUEST_ID}` : `https://discord.com/activities/${"1526628598549708880"}`;
        const message = disableAutoLink ? text : `${text} ${url}`;
        (0, $kFQy0.sendEventV2)('share', [
            'discord_internal',
            message,
            linkId
        ]);
        await $08aba753e0078e61$var$discordSDK.commands.shareLink({
            message: message,
            ...linkId && {
                link_id: linkId
            }
        });
    } catch (error) {
        console.error('[Arise] Share Dialogue Error: ', JSON.stringify(error));
    }
    else console.error('[Arise] Discord SDK not available');
}
async function $08aba753e0078e61$export$e6472d92d4dedd21(imageUrl, filename) {
    const mediaUrl = await $08aba753e0078e61$var$uploadImageToDiscordCDN(imageUrl, filename);
    await $08aba753e0078e61$var$discordSDK.commands.openExternalLink({
        url: mediaUrl
    });
}
async function $08aba753e0078e61$var$uploadImageToDiscordCDN(imageURL, filename) {
    const response = await fetch(imageURL);
    const blob = await response.blob();
    const mimeType = 'image/jpeg';
    const buf = await blob.arrayBuffer();
    const imageFile = new File([
        buf
    ], filename, {
        type: mimeType
    });
    const body = new FormData();
    body.append('file', imageFile);
    const attachmentResponse = await fetch(`https://discord.com/api/v10/applications/${$08aba753e0078e61$var$CLIENT_ID}/attachment`, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${$08aba753e0078e61$var$userDiscordAccessToken}`
        },
        body: body
    });
    const attachmentJson = await attachmentResponse.json();
    const mediaUrl = attachmentJson.attachment.url;
    return mediaUrl;
}
async function $08aba753e0078e61$export$48dd506b03a6eff7(imageUrl, filename) {
    try {
        const mediaUrl = await $08aba753e0078e61$var$uploadImageToDiscordCDN(imageUrl, filename);
        await $08aba753e0078e61$var$discordSDK.commands.openShareMomentDialog({
            mediaUrl: mediaUrl
        });
    } catch (error) {
        console.log('[Arise] Could not openShareMomentDialog', error);
    }
}
function $08aba753e0078e61$var$tryXTimes(fn, times) {
    return new Promise((resolve, reject)=>{
        let attempts = 0;
        const tryFn = async ()=>{
            try {
                const res = await fn();
                resolve(res);
            } catch (error) {
                console.log(`[Arise] Attempt ${attempts + 1} failed`, error);
                if (attempts < times) {
                    attempts++;
                    setTimeout(tryFn, 1000);
                } else {
                    console.error(`[Arise] All ${times} attempts failed`, error);
                    reject(error);
                }
            }
        };
        tryFn();
    });
}
function $08aba753e0078e61$var$sendEventDiscordPremiumType(type) {
    const map = {
        0: 'None',
        1: 'Nitro Classic',
        2: 'Nitro',
        3: 'Nitro Basic'
    };
    const val = map[type] || type.toString();
    (0, $kFQy0.sendEventV2)('discord_nitro', [
        val
    ]);
}

});
parcelRegister("4exxJ", function(module, exports) {

$parcel$export(module.exports, "DiscordSDK", function () { return (parcelRequire("b5027")).DiscordSDK; });
$parcel$export(module.exports, "Events", function () { return (parcelRequire("cOfbu")).Events; });

var $b5027 = parcelRequire("b5027");

var $cOfbu = parcelRequire("cOfbu");

var $a99sA = parcelRequire("a99sA");

var $02MKI = parcelRequire("02MKI");

var $7IqZ6 = parcelRequire("7IqZ6");

var $4Ko9T = parcelRequire("4Ko9T");

var $jyNFz = parcelRequire("jyNFz");

var $6FshM = parcelRequire("6FshM");

var $hRhOK = parcelRequire("hRhOK");
const { Commands: $65f8d5d130275114$export$ba30f7724cb0e54e } = $a99sA;

});
parcelRegister("b5027", function(module, exports) {

$parcel$export(module.exports, "DiscordSDK", function () { return $7cff0f94da67390d$export$7cb9b6936cca2046; });

var $4OTKi = parcelRequire("4OTKi");

var $3zpaE = parcelRequire("3zpaE");

var $7EnVF = parcelRequire("7EnVF");

var $kXIns = parcelRequire("kXIns");

var $cOfbu = parcelRequire("cOfbu");

var $7IqZ6 = parcelRequire("7IqZ6");

var $8AQXA = parcelRequire("8AQXA");

var $jVQNH = parcelRequire("jVQNH");

var $2qWFj = parcelRequire("2qWFj");

var $a99sA = parcelRequire("a99sA");

var $vy6aC = parcelRequire("vy6aC");
var $7cff0f94da67390d$export$6354ae5022ad3977;
(function(Opcodes) {
    Opcodes[Opcodes["HANDSHAKE"] = 0] = "HANDSHAKE";
    Opcodes[Opcodes["FRAME"] = 1] = "FRAME";
    Opcodes[Opcodes["CLOSE"] = 2] = "CLOSE";
    Opcodes[Opcodes["HELLO"] = 3] = "HELLO";
})($7cff0f94da67390d$export$6354ae5022ad3977 || ($7cff0f94da67390d$export$6354ae5022ad3977 = {}));
const $7cff0f94da67390d$var$ALLOWED_ORIGINS = new Set($7cff0f94da67390d$var$getAllowedOrigins());
function $7cff0f94da67390d$var$getAllowedOrigins() {
    if (typeof window === 'undefined') return [];
    return [
        window.location.origin,
        'https://discord.com',
        'https://discordapp.com',
        'https://ptb.discord.com',
        'https://ptb.discordapp.com',
        'https://canary.discord.com',
        'https://canary.discordapp.com',
        'https://staging.discord.co',
        'http://localhost:3333',
        'https://pax.discord.com',
        'null'
    ];
}
/**
 * The embedded application is running in an IFrame either within the main Discord client window or in a popout. The RPC server is always running in the main Discord client window. In either case, the referrer is the correct origin.
 */ function $7cff0f94da67390d$var$getRPCServerSource() {
    var _a;
    return [
        (_a = window.parent.opener) !== null && _a !== void 0 ? _a : window.parent,
        '*'
    ];
}
class $7cff0f94da67390d$export$7cb9b6936cca2046 {
    getTransfer(payload) {
        var _a;
        switch(payload.cmd){
            case (0, $a99sA.Commands).SUBSCRIBE:
            case (0, $a99sA.Commands).UNSUBSCRIBE:
                return undefined;
            default:
                return (_a = payload.transfer) !== null && _a !== void 0 ? _a : undefined;
        }
    }
    constructor(clientId, configuration){
        this.sdkVersion = (0, $2qWFj.version);
        this.mobileAppVersion = null;
        this.source = null;
        this.sourceOrigin = '';
        this.eventBus = new (0, $4OTKi.default)();
        this.onReadyCallback = ()=>{
            this.overrideConsoleLogging();
            this.isReady = true;
        };
        this.pendingCommands = new Map();
        this.sendCommand = (payload)=>{
            var _a;
            if (this.source == null) throw new Error('Attempting to send message before initialization');
            const nonce = (0, $vy6aC.default)();
            (_a = this.source) === null || _a === void 0 || _a.postMessage([
                $7cff0f94da67390d$export$6354ae5022ad3977.FRAME,
                Object.assign(Object.assign({}, payload), {
                    nonce: nonce
                })
            ], this.sourceOrigin, this.getTransfer(payload));
            const promise = new Promise((resolve, reject)=>{
                this.pendingCommands.set(nonce, {
                    resolve: resolve,
                    reject: reject
                });
            });
            return promise;
        };
        this.commands = (0, $7EnVF.default)(this.sendCommand);
        /**
         * WARNING - All "console" logs are emitted as messages to the Discord client
         *  If you write "console.log" anywhere in handleMessage or subsequent message handling
         * there is a good chance you will cause an infinite loop where you receive a message
         * which causes "console.log" which sends a message, which causes the discord client to
         * send a reply which causes handleMessage to fire again, and again to inifinity
         *
         * If you need to log within handleMessage, consider setting
         * config.disableConsoleLogOverride to true when initializing the SDK
         */ this.handleMessage = (event)=>{
            if (!$7cff0f94da67390d$var$ALLOWED_ORIGINS.has(event.origin)) return;
            const tuple = event.data;
            if (!Array.isArray(tuple)) return;
            const [opcode, data] = tuple;
            switch(opcode){
                case $7cff0f94da67390d$export$6354ae5022ad3977.HELLO:
                    // backwards compat; the Discord client will still send HELLOs for old applications.
                    //
                    // TODO: figure out compatibility approach; it would be easier to maintain compatibility at the SDK level, not the underlying RPC protocol level...
                    return;
                case $7cff0f94da67390d$export$6354ae5022ad3977.CLOSE:
                    return this.handleClose(data);
                case $7cff0f94da67390d$export$6354ae5022ad3977.HANDSHAKE:
                    return this.handleHandshake();
                case $7cff0f94da67390d$export$6354ae5022ad3977.FRAME:
                    return this.handleFrame(data);
                default:
                    throw new Error('Invalid message format');
            }
        };
        this.isReady = false;
        this.clientId = clientId;
        this.configuration = configuration !== null && configuration !== void 0 ? configuration : (0, $8AQXA.default)();
        if (typeof window !== 'undefined') window.addEventListener('message', this.handleMessage);
        if (typeof window === 'undefined') {
            this.frameId = '';
            this.instanceId = '';
            this.customId = null;
            this.referrerId = null;
            this.platform = (0, $7IqZ6.Platform).DESKTOP;
            this.guildId = null;
            this.channelId = null;
            this.locationId = null;
            return;
        }
        // START Capture URL Query Params
        const urlParams = new URLSearchParams(this._getSearch());
        const frameId = urlParams.get('frame_id');
        if (!frameId) throw new Error('frame_id query param is not defined');
        this.frameId = frameId;
        const instanceId = urlParams.get('instance_id');
        if (!instanceId) throw new Error('instance_id query param is not defined');
        this.instanceId = instanceId;
        const platform = urlParams.get('platform');
        if (!platform) throw new Error('platform query param is not defined');
        else if (platform !== (0, $7IqZ6.Platform).DESKTOP && platform !== (0, $7IqZ6.Platform).MOBILE) throw new Error(`Invalid query param "platform" of "${platform}". Valid values are "${(0, $7IqZ6.Platform).DESKTOP}" or "${(0, $7IqZ6.Platform).MOBILE}"`);
        this.platform = platform;
        this.customId = urlParams.get('custom_id');
        this.referrerId = urlParams.get('referrer_id');
        this.guildId = urlParams.get('guild_id');
        this.channelId = urlParams.get('channel_id');
        this.locationId = urlParams.get('location_id');
        this.mobileAppVersion = urlParams.get('mobile_app_version');
        // END Capture URL Query Params
        [this.source, this.sourceOrigin] = $7cff0f94da67390d$var$getRPCServerSource();
        if (!this.configuration.disableAutoHandshake) this.handshake();
    }
    close(code, message) {
        var _a;
        window.removeEventListener('message', this.handleMessage);
        const nonce = (0, $vy6aC.default)();
        (_a = this.source) === null || _a === void 0 || _a.postMessage([
            $7cff0f94da67390d$export$6354ae5022ad3977.CLOSE,
            {
                code: code,
                message: message,
                nonce: nonce
            }
        ], this.sourceOrigin);
    }
    async subscribe(event, listener, ...rest) {
        const [subscribeArgs] = rest;
        const listenerCount = this.eventBus.listenerCount(event);
        const emitter = this.eventBus.on(event, listener);
        // If first subscription, subscribe via RPC
        if (Object.values((0, $cOfbu.Events)).includes(event) && event !== (0, $cOfbu.Events).READY && listenerCount === 0) await this.sendCommand({
            cmd: (0, $a99sA.Commands).SUBSCRIBE,
            args: subscribeArgs,
            evt: event
        });
        return emitter;
    }
    async unsubscribe(event, listener, ...rest) {
        const [unsubscribeArgs] = rest;
        if (event !== (0, $cOfbu.Events).READY && this.eventBus.listenerCount(event) === 1) await this.sendCommand({
            cmd: (0, $a99sA.Commands).UNSUBSCRIBE,
            evt: event,
            args: unsubscribeArgs
        });
        return this.eventBus.off(event, listener);
    }
    async ready() {
        if (this.isReady) return;
        await new Promise((resolve)=>{
            this.eventBus.once((0, $cOfbu.Events).READY, resolve);
        });
    }
    parseMajorMobileVersion() {
        if (this.mobileAppVersion && this.mobileAppVersion.includes('.')) try {
            return parseInt(this.mobileAppVersion.split('.')[0]);
        } catch (_a) {
            return 0, $7IqZ6.UNKNOWN_VERSION_NUMBER;
        }
        return 0, $7IqZ6.UNKNOWN_VERSION_NUMBER;
    }
    handshake() {
        var _a;
        this.isReady = false;
        this.addOnReadyListener();
        const handshakePayload = {
            v: 1,
            encoding: 'json',
            client_id: this.clientId,
            frame_id: this.frameId
        };
        const majorMobileVersion = this.parseMajorMobileVersion();
        if (this.platform === (0, $7IqZ6.Platform).DESKTOP || majorMobileVersion >= (0, $7IqZ6.HANDSHAKE_SDK_VERSION_MINIMUM_MOBILE_VERSION)) handshakePayload['sdk_version'] = this.sdkVersion;
        (_a = this.source) === null || _a === void 0 || _a.postMessage([
            $7cff0f94da67390d$export$6354ae5022ad3977.HANDSHAKE,
            handshakePayload
        ], this.sourceOrigin);
    }
    addOnReadyListener() {
        this.eventBus.off((0, $cOfbu.Events).READY, this.onReadyCallback);
        this.eventBus.once((0, $cOfbu.Events).READY, this.onReadyCallback);
    }
    overrideConsoleLogging() {
        if (this.configuration.disableConsoleLogOverride) return;
        const sendCaptureLogCommand = (level, message)=>{
            this.commands.captureLog({
                level: level,
                message: message
            });
        };
        (0, $jVQNH.consoleLevels).forEach((level)=>{
            (0, $jVQNH.wrapConsoleMethod)(console, level, sendCaptureLogCommand);
        });
    }
    handleClose(data) {
        (0, $3zpaE.ClosePayload).parse(data);
    }
    handleHandshake() {}
    handleFrame(payload) {
        var _a, _b;
        let parsed;
        try {
            parsed = (0, $3zpaE.parseIncomingPayload)(payload);
        } catch (e) {
            console.error('Failed to parse', payload);
            console.error(e);
            return;
        }
        if (parsed.cmd === 'DISPATCH') this.eventBus.emit(parsed.evt, parsed.data);
        else {
            if (parsed.evt === (0, $cOfbu.ERROR)) {
                // In response to a command
                if (parsed.nonce != null) {
                    (_a = this.pendingCommands.get(parsed.nonce)) === null || _a === void 0 || _a.reject(parsed.data);
                    this.pendingCommands.delete(parsed.nonce);
                    return;
                }
                // General error
                this.eventBus.emit('error', new (0, $kXIns.SDKError)(parsed.data.code, parsed.data.message));
            }
            if (parsed.nonce == null) {
                console.error('Missing nonce', payload);
                return;
            }
            (_b = this.pendingCommands.get(parsed.nonce)) === null || _b === void 0 || _b.resolve(parsed);
            this.pendingCommands.delete(parsed.nonce);
        }
    }
    _getSearch() {
        return typeof window === 'undefined' ? '' : window.location.search;
    }
}

});
parcelRegister("4OTKi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $660f59e6e30d9669$export$2e2bcd8739ae039; });

var $4kOSS = parcelRequire("4kOSS");

var $gruoj = parcelRequire("gruoj");
var $660f59e6e30d9669$var$eventemitter3Exports = (0, $gruoj.__require)();
var $660f59e6e30d9669$export$2e2bcd8739ae039 = /*@__PURE__*/ (0, $4kOSS.getDefaultExportFromCjs)($660f59e6e30d9669$var$eventemitter3Exports);

});
parcelRegister("4kOSS", function(module, exports) {

$parcel$export(module.exports, "commonjsGlobal", function () { return $2124ae950fc7d559$export$a441d440b06e3168; });
$parcel$export(module.exports, "getDefaultExportFromCjs", function () { return $2124ae950fc7d559$export$22b09f878622677a; });
var $2124ae950fc7d559$export$a441d440b06e3168 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
function $2124ae950fc7d559$export$22b09f878622677a(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

});

parcelRegister("gruoj", function(module, exports) {

$parcel$export(module.exports, "__require", function () { return $f2f1b4709d721e54$export$b88c30a9414655a0; });

var $bBs9c = parcelRequire("bBs9c");
var $f2f1b4709d721e54$var$hasRequiredEventemitter3;
function $f2f1b4709d721e54$export$b88c30a9414655a0() {
    if ($f2f1b4709d721e54$var$hasRequiredEventemitter3) return (0, $bBs9c.__module).exports;
    $f2f1b4709d721e54$var$hasRequiredEventemitter3 = 1;
    (function(module) {
        var has = Object.prototype.hasOwnProperty, prefix = '~';
        /**
		 * Constructor to create a storage for our `EE` objects.
		 * An `Events` instance is a plain object whose properties are event names.
		 *
		 * @constructor
		 * @private
		 */ function Events() {}
        //
        // We try to not inherit from `Object.prototype`. In some engines creating an
        // instance in this way is faster than calling `Object.create(null)` directly.
        // If `Object.create(null)` is not supported we prefix the event names with a
        // character to make sure that the built-in object properties are not
        // overridden or used as an attack vector.
        //
        if (Object.create) {
            Events.prototype = Object.create(null);
            //
            // This hack is needed because the `__proto__` property is still inherited in
            // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
            //
            if (!new Events().__proto__) prefix = false;
        }
        /**
		 * Representation of a single event listener.
		 *
		 * @param {Function} fn The listener function.
		 * @param {*} context The context to invoke the listener with.
		 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
		 * @constructor
		 * @private
		 */ function EE(fn, context, once) {
            this.fn = fn;
            this.context = context;
            this.once = once || false;
        }
        /**
		 * Add a listener for a given event.
		 *
		 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
		 * @param {(String|Symbol)} event The event name.
		 * @param {Function} fn The listener function.
		 * @param {*} context The context to invoke the listener with.
		 * @param {Boolean} once Specify if the listener is a one-time listener.
		 * @returns {EventEmitter}
		 * @private
		 */ function addListener(emitter, event, fn, context, once) {
            if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
            var listener = new EE(fn, context || emitter, once), evt = prefix ? prefix + event : event;
            if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
            else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
            else emitter._events[evt] = [
                emitter._events[evt],
                listener
            ];
            return emitter;
        }
        /**
		 * Clear event by name.
		 *
		 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
		 * @param {(String|Symbol)} evt The Event name.
		 * @private
		 */ function clearEvent(emitter, evt) {
            if (--emitter._eventsCount === 0) emitter._events = new Events();
            else delete emitter._events[evt];
        }
        /**
		 * Minimal `EventEmitter` interface that is molded against the Node.js
		 * `EventEmitter` interface.
		 *
		 * @constructor
		 * @public
		 */ function EventEmitter() {
            this._events = new Events();
            this._eventsCount = 0;
        }
        /**
		 * Return an array listing the events for which the emitter has registered
		 * listeners.
		 *
		 * @returns {Array}
		 * @public
		 */ EventEmitter.prototype.eventNames = function eventNames() {
            var names = [], events, name;
            if (this._eventsCount === 0) return names;
            for(name in events = this._events)if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
            if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
            return names;
        };
        /**
		 * Return the listeners registered for a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @returns {Array} The registered listeners.
		 * @public
		 */ EventEmitter.prototype.listeners = function listeners(event) {
            var evt = prefix ? prefix + event : event, handlers = this._events[evt];
            if (!handlers) return [];
            if (handlers.fn) return [
                handlers.fn
            ];
            for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
            return ee;
        };
        /**
		 * Return the number of listeners listening to a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @returns {Number} The number of listeners.
		 * @public
		 */ EventEmitter.prototype.listenerCount = function listenerCount(event) {
            var evt = prefix ? prefix + event : event, listeners = this._events[evt];
            if (!listeners) return 0;
            if (listeners.fn) return 1;
            return listeners.length;
        };
        /**
		 * Calls each of the listeners registered for a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @returns {Boolean} `true` if the event had listeners, else `false`.
		 * @public
		 */ EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
            var evt = prefix ? prefix + event : event;
            if (!this._events[evt]) return false;
            var listeners = this._events[evt], len = arguments.length, args, i;
            if (listeners.fn) {
                if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
                switch(len){
                    case 1:
                        return listeners.fn.call(listeners.context), true;
                    case 2:
                        return listeners.fn.call(listeners.context, a1), true;
                    case 3:
                        return listeners.fn.call(listeners.context, a1, a2), true;
                    case 4:
                        return listeners.fn.call(listeners.context, a1, a2, a3), true;
                    case 5:
                        return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
                    case 6:
                        return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
                }
                for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
                listeners.fn.apply(listeners.context, args);
            } else {
                var length = listeners.length, j;
                for(i = 0; i < length; i++){
                    if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
                    switch(len){
                        case 1:
                            listeners[i].fn.call(listeners[i].context);
                            break;
                        case 2:
                            listeners[i].fn.call(listeners[i].context, a1);
                            break;
                        case 3:
                            listeners[i].fn.call(listeners[i].context, a1, a2);
                            break;
                        case 4:
                            listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                            break;
                        default:
                            if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                            listeners[i].fn.apply(listeners[i].context, args);
                    }
                }
            }
            return true;
        };
        /**
		 * Add a listener for a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @param {Function} fn The listener function.
		 * @param {*} [context=this] The context to invoke the listener with.
		 * @returns {EventEmitter} `this`.
		 * @public
		 */ EventEmitter.prototype.on = function on(event, fn, context) {
            return addListener(this, event, fn, context, false);
        };
        /**
		 * Add a one-time listener for a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @param {Function} fn The listener function.
		 * @param {*} [context=this] The context to invoke the listener with.
		 * @returns {EventEmitter} `this`.
		 * @public
		 */ EventEmitter.prototype.once = function once(event, fn, context) {
            return addListener(this, event, fn, context, true);
        };
        /**
		 * Remove the listeners of a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @param {Function} fn Only remove the listeners that match this function.
		 * @param {*} context Only remove the listeners that have this context.
		 * @param {Boolean} once Only remove one-time listeners.
		 * @returns {EventEmitter} `this`.
		 * @public
		 */ EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
            var evt = prefix ? prefix + event : event;
            if (!this._events[evt]) return this;
            if (!fn) {
                clearEvent(this, evt);
                return this;
            }
            var listeners = this._events[evt];
            if (listeners.fn) {
                if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) clearEvent(this, evt);
            } else {
                for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
                //
                // Reset the array, or remove it completely if we have no more listeners.
                //
                if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
                else clearEvent(this, evt);
            }
            return this;
        };
        /**
		 * Remove all listeners, or those of the specified event.
		 *
		 * @param {(String|Symbol)} [event] The event name.
		 * @returns {EventEmitter} `this`.
		 * @public
		 */ EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
            var evt;
            if (event) {
                evt = prefix ? prefix + event : event;
                if (this._events[evt]) clearEvent(this, evt);
            } else {
                this._events = new Events();
                this._eventsCount = 0;
            }
            return this;
        };
        //
        // Alias methods names because people roll like that.
        //
        EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
        EventEmitter.prototype.addListener = EventEmitter.prototype.on;
        //
        // Expose the prefix.
        //
        EventEmitter.prefixed = prefix;
        //
        // Allow `EventEmitter` to be imported as module namespace.
        //
        EventEmitter.EventEmitter = EventEmitter;
        module.exports = EventEmitter;
    })((0, $bBs9c.__module));
    return (0, $bBs9c.__module).exports;
}

});
parcelRegister("bBs9c", function(module, exports) {

$parcel$export(module.exports, "__module", function () { return $fe1dc8c4eab740d1$export$5edeffb658f039f4; });
var $fe1dc8c4eab740d1$export$5edeffb658f039f4 = {
    exports: {}
};

});



parcelRegister("3zpaE", function(module, exports) {

$parcel$export(module.exports, "ClosePayload", function () { return $3b36dbefc816c390$export$46b1619f8b73becb; });
$parcel$export(module.exports, "parseIncomingPayload", function () { return $3b36dbefc816c390$export$97b1c66ab98393bd; });

var $39moO = parcelRequire("39moO");

var $cOfbu = parcelRequire("cOfbu");

var $02MKI = parcelRequire("02MKI");

var $a99sA = parcelRequire("a99sA");

var $7IqZ6 = parcelRequire("7IqZ6");
(0, $39moO.object)({
    frame_id: (0, $39moO.string)(),
    platform: (0, $39moO.nativeEnum)((0, $7IqZ6.Platform)).optional().nullable()
});
(0, $39moO.object)({
    v: (0, $39moO.literal)(1),
    encoding: (0, $39moO.literal)('json').optional(),
    client_id: (0, $39moO.string)(),
    frame_id: (0, $39moO.string)()
});
const $3b36dbefc816c390$export$46b1619f8b73becb = (0, $39moO.object)({
    code: (0, $39moO.number)(),
    message: (0, $39moO.string)().optional()
});
const $3b36dbefc816c390$export$d3f475fe77824935 = (0, $39moO.object)({
    evt: (0, $39moO.string)().nullable(),
    nonce: (0, $39moO.string)().nullable(),
    data: (0, $39moO.unknown)().nullable(),
    cmd: (0, $39moO.string)()
}).passthrough();
function $3b36dbefc816c390$export$97b1c66ab98393bd(payload) {
    const incoming = $3b36dbefc816c390$export$d3f475fe77824935.parse(payload);
    if (incoming.evt != null) {
        if (incoming.evt === (0, $cOfbu.ERROR)) return (0, $cOfbu.ErrorEvent).parse(incoming);
        return (0, $cOfbu.parseEventPayload)((0, $cOfbu.EventFrame).parse(incoming));
    } else return (0, $02MKI.parseResponsePayload)((0, $02MKI.ResponseFrame).passthrough().parse(incoming));
}

});
parcelRegister("39moO", function(module, exports) {

$parcel$export(module.exports, "custom", function () { return $f64921518d4a6bc8$export$4c00f665f0d4b443; });
$parcel$export(module.exports, "string", function () { return $f64921518d4a6bc8$export$22b082955e083ec3; });
$parcel$export(module.exports, "number", function () { return $f64921518d4a6bc8$export$98e628dec113755e; });
$parcel$export(module.exports, "bigint", function () { return $f64921518d4a6bc8$export$a0f65b52274bcc00; });
$parcel$export(module.exports, "boolean", function () { return $f64921518d4a6bc8$export$4a21f16c33752377; });
$parcel$export(module.exports, "null", function () { return $f64921518d4a6bc8$export$7b1b591b262c240; });
$parcel$export(module.exports, "unknown", function () { return $f64921518d4a6bc8$export$19282c40b967aec6; });
$parcel$export(module.exports, "array", function () { return $f64921518d4a6bc8$export$2f23118c22fb2630; });
$parcel$export(module.exports, "object", function () { return $f64921518d4a6bc8$export$be5493f9613cbbe; });
$parcel$export(module.exports, "union", function () { return $f64921518d4a6bc8$export$971dd5b0dfd021b6; });
$parcel$export(module.exports, "literal", function () { return $f64921518d4a6bc8$export$c8ec6e1ec9fefcb0; });
$parcel$export(module.exports, "nativeEnum", function () { return $f64921518d4a6bc8$export$6fe7eca19ebe5199; });
$parcel$export(module.exports, "optional", function () { return $f64921518d4a6bc8$export$516e28dec6a4b6d4; });
$parcel$export(module.exports, "preprocess", function () { return $f64921518d4a6bc8$export$fc37fe19dfda43ee; });
$parcel$export(module.exports, "default", function () { return $f64921518d4a6bc8$export$2e2bcd8739ae039; });
var $f64921518d4a6bc8$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($f64921518d4a6bc8$export$7debb50ef11d5e0b || ($f64921518d4a6bc8$export$7debb50ef11d5e0b = {}));
var $f64921518d4a6bc8$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($f64921518d4a6bc8$export$4aa2142c225fd5c7 || ($f64921518d4a6bc8$export$4aa2142c225fd5c7 = {}));
const $f64921518d4a6bc8$export$5716da67bfaa244d = $f64921518d4a6bc8$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $f64921518d4a6bc8$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $f64921518d4a6bc8$export$5716da67bfaa244d.undefined;
        case "string":
            return $f64921518d4a6bc8$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $f64921518d4a6bc8$export$5716da67bfaa244d.nan : $f64921518d4a6bc8$export$5716da67bfaa244d.number;
        case "boolean":
            return $f64921518d4a6bc8$export$5716da67bfaa244d.boolean;
        case "function":
            return $f64921518d4a6bc8$export$5716da67bfaa244d.function;
        case "bigint":
            return $f64921518d4a6bc8$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $f64921518d4a6bc8$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $f64921518d4a6bc8$export$5716da67bfaa244d.array;
            if (data === null) return $f64921518d4a6bc8$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $f64921518d4a6bc8$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $f64921518d4a6bc8$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $f64921518d4a6bc8$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $f64921518d4a6bc8$export$5716da67bfaa244d.date;
            return $f64921518d4a6bc8$export$5716da67bfaa244d.object;
        default:
            return $f64921518d4a6bc8$export$5716da67bfaa244d.unknown;
    }
};
const $f64921518d4a6bc8$export$5ba560653e4a1035 = $f64921518d4a6bc8$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $f64921518d4a6bc8$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $f64921518d4a6bc8$export$f98dac4b251ab333 extends Error {
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof $f64921518d4a6bc8$export$f98dac4b251ab333)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $f64921518d4a6bc8$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
$f64921518d4a6bc8$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $f64921518d4a6bc8$export$f98dac4b251ab333(issues);
    return error;
};
const $f64921518d4a6bc8$export$341b0b6e0a6f5099 = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $f64921518d4a6bc8$export$5716da67bfaa244d.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $f64921518d4a6bc8$export$7debb50ef11d5e0b.jsonStringifyReplacer)}`;
            break;
        case $f64921518d4a6bc8$export$5ba560653e4a1035.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$f64921518d4a6bc8$export$7debb50ef11d5e0b.joinValues(issue.keys, ", ")}`;
            break;
        case $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_union:
            message = `Invalid input`;
            break;
        case $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$f64921518d4a6bc8$export$7debb50ef11d5e0b.joinValues(issue.options)}`;
            break;
        case $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_enum_value:
            message = `Invalid enum value. Expected ${$f64921518d4a6bc8$export$7debb50ef11d5e0b.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_date:
            message = `Invalid date`;
            break;
        case $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $f64921518d4a6bc8$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $f64921518d4a6bc8$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $f64921518d4a6bc8$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $f64921518d4a6bc8$export$5ba560653e4a1035.custom:
            message = `Invalid input`;
            break;
        case $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $f64921518d4a6bc8$export$5ba560653e4a1035.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $f64921518d4a6bc8$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $f64921518d4a6bc8$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
let $f64921518d4a6bc8$var$overrideErrorMap = $f64921518d4a6bc8$export$341b0b6e0a6f5099;
function $f64921518d4a6bc8$export$1097a8289cfd22d7(map) {
    $f64921518d4a6bc8$var$overrideErrorMap = map;
}
function $f64921518d4a6bc8$export$32f27c719778d4c4() {
    return $f64921518d4a6bc8$var$overrideErrorMap;
}
const $f64921518d4a6bc8$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    if (issueData.message !== undefined) return {
        ...issueData,
        path: fullPath,
        message: issueData.message
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: errorMessage
    };
};
const $f64921518d4a6bc8$export$1526d2e05f74572 = [];
function $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, issueData) {
    const overrideMap = $f64921518d4a6bc8$export$32f27c719778d4c4();
    const issue = $f64921518d4a6bc8$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === $f64921518d4a6bc8$export$341b0b6e0a6f5099 ? undefined : $f64921518d4a6bc8$export$341b0b6e0a6f5099
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $f64921518d4a6bc8$export$5b20a5c3d05c1f6f {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $f64921518d4a6bc8$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key: key,
                value: value
            });
        }
        return $f64921518d4a6bc8$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $f64921518d4a6bc8$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $f64921518d4a6bc8$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const $f64921518d4a6bc8$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $f64921518d4a6bc8$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $f64921518d4a6bc8$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $f64921518d4a6bc8$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $f64921518d4a6bc8$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $f64921518d4a6bc8$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $f64921518d4a6bc8$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $f64921518d4a6bc8$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return state.get(receiver);
}
function $f64921518d4a6bc8$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return state.set(receiver, value), value;
}
typeof SuppressedError === "function" && SuppressedError;
var $f64921518d4a6bc8$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($f64921518d4a6bc8$var$errorUtil || ($f64921518d4a6bc8$var$errorUtil = {}));
var $f64921518d4a6bc8$var$_ZodEnum_cache, $f64921518d4a6bc8$var$_ZodNativeEnum_cache;
class $f64921518d4a6bc8$var$ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const $f64921518d4a6bc8$var$handleResult = (ctx, result)=>{
    if ($f64921518d4a6bc8$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $f64921518d4a6bc8$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $f64921518d4a6bc8$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        var _a, _b;
        const { message: message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message !== null && message !== void 0 ? message : ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: (_a = message !== null && message !== void 0 ? message : required_error) !== null && _a !== void 0 ? _a : ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: (_b = message !== null && message !== void 0 ? message : invalid_type_error) !== null && _b !== void 0 ? _b : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $f64921518d4a6bc8$export$19342e026b58ebb7 {
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return $f64921518d4a6bc8$export$3e9057828ebd5c7a(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: $f64921518d4a6bc8$export$3e9057828ebd5c7a(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $f64921518d4a6bc8$export$5b20a5c3d05c1f6f(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: $f64921518d4a6bc8$export$3e9057828ebd5c7a(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ($f64921518d4a6bc8$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $f64921518d4a6bc8$export$3e9057828ebd5c7a(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $f64921518d4a6bc8$var$handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $f64921518d4a6bc8$export$3e9057828ebd5c7a(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ($f64921518d4a6bc8$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $f64921518d4a6bc8$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: $f64921518d4a6bc8$export$5ba560653e4a1035.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $f64921518d4a6bc8$export$a60af00cc0ce2582({
            schema: this,
            typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return $f64921518d4a6bc8$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $f64921518d4a6bc8$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $f64921518d4a6bc8$export$7acfc3e64785411.create(this, this._def);
    }
    promise() {
        return $f64921518d4a6bc8$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $f64921518d4a6bc8$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $f64921518d4a6bc8$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $f64921518d4a6bc8$export$a60af00cc0ce2582({
            ...$f64921518d4a6bc8$var$processCreateParams(this._def),
            schema: this,
            typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $f64921518d4a6bc8$export$bb19b37874861e7e({
            ...$f64921518d4a6bc8$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $f64921518d4a6bc8$export$66b0c798a395271f({
            typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$f64921518d4a6bc8$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $f64921518d4a6bc8$export$75a44ec6249ac76b({
            ...$f64921518d4a6bc8$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $f64921518d4a6bc8$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $f64921518d4a6bc8$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const $f64921518d4a6bc8$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $f64921518d4a6bc8$var$cuid2Regex = /^[0-9a-z]+$/;
const $f64921518d4a6bc8$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $f64921518d4a6bc8$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const $f64921518d4a6bc8$var$nanoidRegex = /^[a-z0-9_-]{21}$/i;
const $f64921518d4a6bc8$var$durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $f64921518d4a6bc8$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $f64921518d4a6bc8$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $f64921518d4a6bc8$var$emojiRegex;
// faster, simpler, safer
const $f64921518d4a6bc8$var$ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const $f64921518d4a6bc8$var$ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const $f64921518d4a6bc8$var$base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const $f64921518d4a6bc8$var$dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const $f64921518d4a6bc8$var$dateRegex = new RegExp(`^${$f64921518d4a6bc8$var$dateRegexSource}$`);
function $f64921518d4a6bc8$var$timeRegexSource(args) {
    // let regex = `\\d{2}:\\d{2}:\\d{2}`;
    let regex = `([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d`;
    if (args.precision) regex = `${regex}\\.\\d{${args.precision}}`;
    else if (args.precision == null) regex = `${regex}(\\.\\d+)?`;
    return regex;
}
function $f64921518d4a6bc8$var$timeRegex(args) {
    return new RegExp(`^${$f64921518d4a6bc8$var$timeRegexSource(args)}$`);
}
// Adapted from https://stackoverflow.com/a/3143231
function $f64921518d4a6bc8$export$a4b563879add27a(args) {
    let regex = `${$f64921518d4a6bc8$var$dateRegexSource}T${$f64921518d4a6bc8$var$timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function $f64921518d4a6bc8$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $f64921518d4a6bc8$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $f64921518d4a6bc8$var$ipv6Regex.test(ip)) return true;
    return false;
}
class $f64921518d4a6bc8$export$1230eb29b8d3b502 extends $f64921518d4a6bc8$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $f64921518d4a6bc8$export$5716da67bfaa244d.string) {
            const ctx = this._getOrReturnCtx(input);
            $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_type,
                expected: $f64921518d4a6bc8$export$5716da67bfaa244d.string,
                received: ctx.parsedType
            });
            return $f64921518d4a6bc8$export$9a105a556e65c2c0;
        }
        const status = new $f64921518d4a6bc8$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                        code: $f64921518d4a6bc8$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                        code: $f64921518d4a6bc8$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                        code: $f64921518d4a6bc8$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                        code: $f64921518d4a6bc8$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$f64921518d4a6bc8$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                        validation: "email",
                        code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$f64921518d4a6bc8$var$emojiRegex) $f64921518d4a6bc8$var$emojiRegex = new RegExp($f64921518d4a6bc8$var$_emojiRegex, "u");
                if (!$f64921518d4a6bc8$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                        validation: "emoji",
                        code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$f64921518d4a6bc8$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                        validation: "uuid",
                        code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!$f64921518d4a6bc8$var$nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                        validation: "nanoid",
                        code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$f64921518d4a6bc8$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                        validation: "cuid",
                        code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$f64921518d4a6bc8$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                        validation: "cuid2",
                        code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$f64921518d4a6bc8$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                        validation: "ulid",
                        code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                    validation: "url",
                    code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                        validation: "regex",
                        code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                        code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                        code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                        code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $f64921518d4a6bc8$export$a4b563879add27a(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                        code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = $f64921518d4a6bc8$var$dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                        code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = $f64921518d4a6bc8$var$timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                        code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!$f64921518d4a6bc8$var$durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                        validation: "duration",
                        code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$f64921518d4a6bc8$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                        validation: "ip",
                        code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!$f64921518d4a6bc8$var$base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                        validation: "base64",
                        code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $f64921518d4a6bc8$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_string,
            ...$f64921518d4a6bc8$var$errorUtil.errToObj(message)
        });
    }
    _addCheck(check) {
        return new $f64921518d4a6bc8$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...$f64921518d4a6bc8$var$errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...$f64921518d4a6bc8$var$errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...$f64921518d4a6bc8$var$errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...$f64921518d4a6bc8$var$errorUtil.errToObj(message)
        });
    }
    nanoid(message) {
        return this._addCheck({
            kind: "nanoid",
            ...$f64921518d4a6bc8$var$errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...$f64921518d4a6bc8$var$errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...$f64921518d4a6bc8$var$errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...$f64921518d4a6bc8$var$errorUtil.errToObj(message)
        });
    }
    base64(message) {
        return this._addCheck({
            kind: "base64",
            ...$f64921518d4a6bc8$var$errorUtil.errToObj(message)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...$f64921518d4a6bc8$var$errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        var _a, _b;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            local: (_b = options === null || options === void 0 ? void 0 : options.local) !== null && _b !== void 0 ? _b : false,
            ...$f64921518d4a6bc8$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message: message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck({
            kind: "time",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            ...$f64921518d4a6bc8$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    duration(message) {
        return this._addCheck({
            kind: "duration",
            ...$f64921518d4a6bc8$var$errorUtil.errToObj(message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...$f64921518d4a6bc8$var$errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...$f64921518d4a6bc8$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...$f64921518d4a6bc8$var$errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...$f64921518d4a6bc8$var$errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...$f64921518d4a6bc8$var$errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...$f64921518d4a6bc8$var$errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...$f64921518d4a6bc8$var$errorUtil.errToObj(message)
        });
    }
    /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */ nonempty(message) {
        return this.min(1, $f64921518d4a6bc8$var$errorUtil.errToObj(message));
    }
    trim() {
        return new $f64921518d4a6bc8$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $f64921518d4a6bc8$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $f64921518d4a6bc8$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$f64921518d4a6bc8$export$1230eb29b8d3b502.create = (params)=>{
    var _a;
    return new $f64921518d4a6bc8$export$1230eb29b8d3b502({
        checks: [],
        typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$f64921518d4a6bc8$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $f64921518d4a6bc8$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $f64921518d4a6bc8$export$5b070a55c0c43e09 extends $f64921518d4a6bc8$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $f64921518d4a6bc8$export$5716da67bfaa244d.number) {
            const ctx = this._getOrReturnCtx(input);
            $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_type,
                expected: $f64921518d4a6bc8$export$5716da67bfaa244d.number,
                received: ctx.parsedType
            });
            return $f64921518d4a6bc8$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $f64921518d4a6bc8$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$f64921518d4a6bc8$export$7debb50ef11d5e0b.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                        code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                        code: $f64921518d4a6bc8$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                        code: $f64921518d4a6bc8$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($f64921518d4a6bc8$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                        code: $f64921518d4a6bc8$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                        code: $f64921518d4a6bc8$export$5ba560653e4a1035.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $f64921518d4a6bc8$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $f64921518d4a6bc8$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $f64921518d4a6bc8$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $f64921518d4a6bc8$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $f64921518d4a6bc8$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $f64921518d4a6bc8$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $f64921518d4a6bc8$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $f64921518d4a6bc8$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $f64921518d4a6bc8$var$errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $f64921518d4a6bc8$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $f64921518d4a6bc8$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $f64921518d4a6bc8$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $f64921518d4a6bc8$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $f64921518d4a6bc8$var$errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $f64921518d4a6bc8$var$errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $f64921518d4a6bc8$var$errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $f64921518d4a6bc8$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $f64921518d4a6bc8$export$7debb50ef11d5e0b.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
$f64921518d4a6bc8$export$5b070a55c0c43e09.create = (params)=>{
    return new $f64921518d4a6bc8$export$5b070a55c0c43e09({
        checks: [],
        typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$f64921518d4a6bc8$var$processCreateParams(params)
    });
};
class $f64921518d4a6bc8$export$67d741fd70ff98f4 extends $f64921518d4a6bc8$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) input.data = BigInt(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $f64921518d4a6bc8$export$5716da67bfaa244d.bigint) {
            const ctx = this._getOrReturnCtx(input);
            $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_type,
                expected: $f64921518d4a6bc8$export$5716da67bfaa244d.bigint,
                received: ctx.parsedType
            });
            return $f64921518d4a6bc8$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $f64921518d4a6bc8$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                        code: $f64921518d4a6bc8$export$5ba560653e4a1035.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                        code: $f64921518d4a6bc8$export$5ba560653e4a1035.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                        code: $f64921518d4a6bc8$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $f64921518d4a6bc8$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $f64921518d4a6bc8$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $f64921518d4a6bc8$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $f64921518d4a6bc8$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $f64921518d4a6bc8$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $f64921518d4a6bc8$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $f64921518d4a6bc8$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $f64921518d4a6bc8$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $f64921518d4a6bc8$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $f64921518d4a6bc8$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $f64921518d4a6bc8$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $f64921518d4a6bc8$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $f64921518d4a6bc8$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$f64921518d4a6bc8$export$67d741fd70ff98f4.create = (params)=>{
    var _a;
    return new $f64921518d4a6bc8$export$67d741fd70ff98f4({
        checks: [],
        typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$f64921518d4a6bc8$var$processCreateParams(params)
    });
};
class $f64921518d4a6bc8$export$723d146f80596191 extends $f64921518d4a6bc8$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $f64921518d4a6bc8$export$5716da67bfaa244d.boolean) {
            const ctx = this._getOrReturnCtx(input);
            $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_type,
                expected: $f64921518d4a6bc8$export$5716da67bfaa244d.boolean,
                received: ctx.parsedType
            });
            return $f64921518d4a6bc8$export$9a105a556e65c2c0;
        }
        return $f64921518d4a6bc8$export$c6813a8d51f77eaf(input.data);
    }
}
$f64921518d4a6bc8$export$723d146f80596191.create = (params)=>{
    return new $f64921518d4a6bc8$export$723d146f80596191({
        typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$f64921518d4a6bc8$var$processCreateParams(params)
    });
};
class $f64921518d4a6bc8$export$e974be33bdc55521 extends $f64921518d4a6bc8$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $f64921518d4a6bc8$export$5716da67bfaa244d.date) {
            const ctx = this._getOrReturnCtx(input);
            $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_type,
                expected: $f64921518d4a6bc8$export$5716da67bfaa244d.date,
                received: ctx.parsedType
            });
            return $f64921518d4a6bc8$export$9a105a556e65c2c0;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_date
            });
            return $f64921518d4a6bc8$export$9a105a556e65c2c0;
        }
        const status = new $f64921518d4a6bc8$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                        code: $f64921518d4a6bc8$export$5ba560653e4a1035.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                        code: $f64921518d4a6bc8$export$5ba560653e4a1035.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $f64921518d4a6bc8$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $f64921518d4a6bc8$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $f64921518d4a6bc8$var$errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $f64921518d4a6bc8$var$errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$f64921518d4a6bc8$export$e974be33bdc55521.create = (params)=>{
    return new $f64921518d4a6bc8$export$e974be33bdc55521({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodDate,
        ...$f64921518d4a6bc8$var$processCreateParams(params)
    });
};
class $f64921518d4a6bc8$export$bcc3b40f6b638044 extends $f64921518d4a6bc8$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $f64921518d4a6bc8$export$5716da67bfaa244d.symbol) {
            const ctx = this._getOrReturnCtx(input);
            $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_type,
                expected: $f64921518d4a6bc8$export$5716da67bfaa244d.symbol,
                received: ctx.parsedType
            });
            return $f64921518d4a6bc8$export$9a105a556e65c2c0;
        }
        return $f64921518d4a6bc8$export$c6813a8d51f77eaf(input.data);
    }
}
$f64921518d4a6bc8$export$bcc3b40f6b638044.create = (params)=>{
    return new $f64921518d4a6bc8$export$bcc3b40f6b638044({
        typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodSymbol,
        ...$f64921518d4a6bc8$var$processCreateParams(params)
    });
};
class $f64921518d4a6bc8$export$4e780e961c30340d extends $f64921518d4a6bc8$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $f64921518d4a6bc8$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_type,
                expected: $f64921518d4a6bc8$export$5716da67bfaa244d.undefined,
                received: ctx.parsedType
            });
            return $f64921518d4a6bc8$export$9a105a556e65c2c0;
        }
        return $f64921518d4a6bc8$export$c6813a8d51f77eaf(input.data);
    }
}
$f64921518d4a6bc8$export$4e780e961c30340d.create = (params)=>{
    return new $f64921518d4a6bc8$export$4e780e961c30340d({
        typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodUndefined,
        ...$f64921518d4a6bc8$var$processCreateParams(params)
    });
};
class $f64921518d4a6bc8$export$a96281f914484f2d extends $f64921518d4a6bc8$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $f64921518d4a6bc8$export$5716da67bfaa244d.null) {
            const ctx = this._getOrReturnCtx(input);
            $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_type,
                expected: $f64921518d4a6bc8$export$5716da67bfaa244d.null,
                received: ctx.parsedType
            });
            return $f64921518d4a6bc8$export$9a105a556e65c2c0;
        }
        return $f64921518d4a6bc8$export$c6813a8d51f77eaf(input.data);
    }
}
$f64921518d4a6bc8$export$a96281f914484f2d.create = (params)=>{
    return new $f64921518d4a6bc8$export$a96281f914484f2d({
        typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodNull,
        ...$f64921518d4a6bc8$var$processCreateParams(params)
    });
};
class $f64921518d4a6bc8$export$b9d1edb536b4e4eb extends $f64921518d4a6bc8$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return $f64921518d4a6bc8$export$c6813a8d51f77eaf(input.data);
    }
}
$f64921518d4a6bc8$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $f64921518d4a6bc8$export$b9d1edb536b4e4eb({
        typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodAny,
        ...$f64921518d4a6bc8$var$processCreateParams(params)
    });
};
class $f64921518d4a6bc8$export$ef3b1bb1630977ae extends $f64921518d4a6bc8$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return $f64921518d4a6bc8$export$c6813a8d51f77eaf(input.data);
    }
}
$f64921518d4a6bc8$export$ef3b1bb1630977ae.create = (params)=>{
    return new $f64921518d4a6bc8$export$ef3b1bb1630977ae({
        typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodUnknown,
        ...$f64921518d4a6bc8$var$processCreateParams(params)
    });
};
class $f64921518d4a6bc8$export$1e576a20c3ce9fb5 extends $f64921518d4a6bc8$export$19342e026b58ebb7 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
            code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_type,
            expected: $f64921518d4a6bc8$export$5716da67bfaa244d.never,
            received: ctx.parsedType
        });
        return $f64921518d4a6bc8$export$9a105a556e65c2c0;
    }
}
$f64921518d4a6bc8$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $f64921518d4a6bc8$export$1e576a20c3ce9fb5({
        typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodNever,
        ...$f64921518d4a6bc8$var$processCreateParams(params)
    });
};
class $f64921518d4a6bc8$export$7d39f5df85f21031 extends $f64921518d4a6bc8$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $f64921518d4a6bc8$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_type,
                expected: $f64921518d4a6bc8$export$5716da67bfaa244d.void,
                received: ctx.parsedType
            });
            return $f64921518d4a6bc8$export$9a105a556e65c2c0;
        }
        return $f64921518d4a6bc8$export$c6813a8d51f77eaf(input.data);
    }
}
$f64921518d4a6bc8$export$7d39f5df85f21031.create = (params)=>{
    return new $f64921518d4a6bc8$export$7d39f5df85f21031({
        typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodVoid,
        ...$f64921518d4a6bc8$var$processCreateParams(params)
    });
};
class $f64921518d4a6bc8$export$7acfc3e64785411 extends $f64921518d4a6bc8$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $f64921518d4a6bc8$export$5716da67bfaa244d.array) {
            $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_type,
                expected: $f64921518d4a6bc8$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $f64921518d4a6bc8$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                    code: tooBig ? $f64921518d4a6bc8$export$5ba560653e4a1035.too_big : $f64921518d4a6bc8$export$5ba560653e4a1035.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                    code: $f64921518d4a6bc8$export$5ba560653e4a1035.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                    code: $f64921518d4a6bc8$export$5ba560653e4a1035.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $f64921518d4a6bc8$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $f64921518d4a6bc8$export$5b20a5c3d05c1f6f.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $f64921518d4a6bc8$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $f64921518d4a6bc8$export$5b20a5c3d05c1f6f.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $f64921518d4a6bc8$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: $f64921518d4a6bc8$var$errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $f64921518d4a6bc8$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: $f64921518d4a6bc8$var$errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new $f64921518d4a6bc8$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: $f64921518d4a6bc8$var$errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$f64921518d4a6bc8$export$7acfc3e64785411.create = (schema, params)=>{
    return new $f64921518d4a6bc8$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodArray,
        ...$f64921518d4a6bc8$var$processCreateParams(params)
    });
};
function $f64921518d4a6bc8$var$deepPartialify(schema) {
    if (schema instanceof $f64921518d4a6bc8$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $f64921518d4a6bc8$export$aa56fec1e9d629b8.create($f64921518d4a6bc8$var$deepPartialify(fieldSchema));
        }
        return new $f64921518d4a6bc8$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $f64921518d4a6bc8$export$7acfc3e64785411) return new $f64921518d4a6bc8$export$7acfc3e64785411({
        ...schema._def,
        type: $f64921518d4a6bc8$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $f64921518d4a6bc8$export$aa56fec1e9d629b8) return $f64921518d4a6bc8$export$aa56fec1e9d629b8.create($f64921518d4a6bc8$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $f64921518d4a6bc8$export$aaac0b8b429cef5) return $f64921518d4a6bc8$export$aaac0b8b429cef5.create($f64921518d4a6bc8$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $f64921518d4a6bc8$export$e2a18bb771d8e6a3) return $f64921518d4a6bc8$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$f64921518d4a6bc8$var$deepPartialify(item)));
    else return schema;
}
class $f64921518d4a6bc8$export$736315c5b55efbad extends $f64921518d4a6bc8$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $f64921518d4a6bc8$export$7debb50ef11d5e0b.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $f64921518d4a6bc8$export$5716da67bfaa244d.object) {
            const ctx = this._getOrReturnCtx(input);
            $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_type,
                expected: $f64921518d4a6bc8$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $f64921518d4a6bc8$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $f64921518d4a6bc8$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $f64921518d4a6bc8$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $f64921518d4a6bc8$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                        code: $f64921518d4a6bc8$export$5ba560653e4a1035.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $f64921518d4a6bc8$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key: key,
                    value: value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return $f64921518d4a6bc8$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
        });
        else return $f64921518d4a6bc8$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $f64921518d4a6bc8$var$errorUtil.errToObj;
        return new $f64921518d4a6bc8$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    var _a, _b, _c, _d;
                    const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (_d = $f64921518d4a6bc8$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $f64921518d4a6bc8$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $f64921518d4a6bc8$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $f64921518d4a6bc8$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $f64921518d4a6bc8$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $f64921518d4a6bc8$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        $f64921518d4a6bc8$export$7debb50ef11d5e0b.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $f64921518d4a6bc8$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        $f64921518d4a6bc8$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $f64921518d4a6bc8$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $f64921518d4a6bc8$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $f64921518d4a6bc8$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $f64921518d4a6bc8$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        $f64921518d4a6bc8$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $f64921518d4a6bc8$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $f64921518d4a6bc8$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $f64921518d4a6bc8$var$createZodEnum($f64921518d4a6bc8$export$7debb50ef11d5e0b.objectKeys(this.shape));
    }
}
$f64921518d4a6bc8$export$736315c5b55efbad.create = (shape, params)=>{
    return new $f64921518d4a6bc8$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $f64921518d4a6bc8$export$1e576a20c3ce9fb5.create(),
        typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodObject,
        ...$f64921518d4a6bc8$var$processCreateParams(params)
    });
};
$f64921518d4a6bc8$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $f64921518d4a6bc8$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $f64921518d4a6bc8$export$1e576a20c3ce9fb5.create(),
        typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodObject,
        ...$f64921518d4a6bc8$var$processCreateParams(params)
    });
};
$f64921518d4a6bc8$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $f64921518d4a6bc8$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $f64921518d4a6bc8$export$1e576a20c3ce9fb5.create(),
        typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodObject,
        ...$f64921518d4a6bc8$var$processCreateParams(params)
    });
};
class $f64921518d4a6bc8$export$a8b236cb5070a311 extends $f64921518d4a6bc8$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $f64921518d4a6bc8$export$f98dac4b251ab333(result.ctx.common.issues));
            $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $f64921518d4a6bc8$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $f64921518d4a6bc8$export$f98dac4b251ab333(issues));
            $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $f64921518d4a6bc8$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$f64921518d4a6bc8$export$a8b236cb5070a311.create = (types, params)=>{
    return new $f64921518d4a6bc8$export$a8b236cb5070a311({
        options: types,
        typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodUnion,
        ...$f64921518d4a6bc8$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $f64921518d4a6bc8$var$getDiscriminator = (type)=>{
    if (type instanceof $f64921518d4a6bc8$export$378d0cfce37406e6) return $f64921518d4a6bc8$var$getDiscriminator(type.schema);
    else if (type instanceof $f64921518d4a6bc8$export$a60af00cc0ce2582) return $f64921518d4a6bc8$var$getDiscriminator(type.innerType());
    else if (type instanceof $f64921518d4a6bc8$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $f64921518d4a6bc8$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $f64921518d4a6bc8$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return $f64921518d4a6bc8$export$7debb50ef11d5e0b.objectValues(type.enum);
    else if (type instanceof $f64921518d4a6bc8$export$bb19b37874861e7e) return $f64921518d4a6bc8$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $f64921518d4a6bc8$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $f64921518d4a6bc8$export$a96281f914484f2d) return [
        null
    ];
    else if (type instanceof $f64921518d4a6bc8$export$aa56fec1e9d629b8) return [
        undefined,
        ...$f64921518d4a6bc8$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $f64921518d4a6bc8$export$aaac0b8b429cef5) return [
        null,
        ...$f64921518d4a6bc8$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $f64921518d4a6bc8$export$66b0c798a395271f) return $f64921518d4a6bc8$var$getDiscriminator(type.unwrap());
    else if (type instanceof $f64921518d4a6bc8$export$5d1f7ef05c4e493a) return $f64921518d4a6bc8$var$getDiscriminator(type.unwrap());
    else if (type instanceof $f64921518d4a6bc8$export$75a44ec6249ac76b) return $f64921518d4a6bc8$var$getDiscriminator(type._def.innerType);
    else return [];
};
class $f64921518d4a6bc8$export$5ef2424805ac76a3 extends $f64921518d4a6bc8$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $f64921518d4a6bc8$export$5716da67bfaa244d.object) {
            $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_type,
                expected: $f64921518d4a6bc8$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $f64921518d4a6bc8$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $f64921518d4a6bc8$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $f64921518d4a6bc8$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $f64921518d4a6bc8$export$5ef2424805ac76a3({
            typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$f64921518d4a6bc8$var$processCreateParams(params)
        });
    }
}
function $f64921518d4a6bc8$var$mergeValues(a, b) {
    const aType = $f64921518d4a6bc8$export$3e9057828ebd5c7a(a);
    const bType = $f64921518d4a6bc8$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $f64921518d4a6bc8$export$5716da67bfaa244d.object && bType === $f64921518d4a6bc8$export$5716da67bfaa244d.object) {
        const bKeys = $f64921518d4a6bc8$export$7debb50ef11d5e0b.objectKeys(b);
        const sharedKeys = $f64921518d4a6bc8$export$7debb50ef11d5e0b.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $f64921518d4a6bc8$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $f64921518d4a6bc8$export$5716da67bfaa244d.array && bType === $f64921518d4a6bc8$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $f64921518d4a6bc8$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $f64921518d4a6bc8$export$5716da67bfaa244d.date && bType === $f64921518d4a6bc8$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $f64921518d4a6bc8$export$c02deaf0bb5203d4 extends $f64921518d4a6bc8$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ($f64921518d4a6bc8$export$afa861e3c5730743(parsedLeft) || $f64921518d4a6bc8$export$afa861e3c5730743(parsedRight)) return $f64921518d4a6bc8$export$9a105a556e65c2c0;
            const merged = $f64921518d4a6bc8$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                    code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_intersection_types
                });
                return $f64921518d4a6bc8$export$9a105a556e65c2c0;
            }
            if ($f64921518d4a6bc8$export$910b6cdd390341b3(parsedLeft) || $f64921518d4a6bc8$export$910b6cdd390341b3(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$f64921518d4a6bc8$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $f64921518d4a6bc8$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodIntersection,
        ...$f64921518d4a6bc8$var$processCreateParams(params)
    });
};
class $f64921518d4a6bc8$export$e2a18bb771d8e6a3 extends $f64921518d4a6bc8$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $f64921518d4a6bc8$export$5716da67bfaa244d.array) {
            $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_type,
                expected: $f64921518d4a6bc8$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $f64921518d4a6bc8$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                code: $f64921518d4a6bc8$export$5ba560653e4a1035.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $f64921518d4a6bc8$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                code: $f64921518d4a6bc8$export$5ba560653e4a1035.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $f64921518d4a6bc8$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $f64921518d4a6bc8$export$5b20a5c3d05c1f6f.mergeArray(status, results);
        });
        else return $f64921518d4a6bc8$export$5b20a5c3d05c1f6f.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $f64921518d4a6bc8$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$f64921518d4a6bc8$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $f64921518d4a6bc8$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$f64921518d4a6bc8$var$processCreateParams(params)
    });
};
class $f64921518d4a6bc8$export$a2acc09968cb4b7f extends $f64921518d4a6bc8$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $f64921518d4a6bc8$export$5716da67bfaa244d.object) {
            $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_type,
                expected: $f64921518d4a6bc8$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $f64921518d4a6bc8$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $f64921518d4a6bc8$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $f64921518d4a6bc8$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return $f64921518d4a6bc8$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
        else return $f64921518d4a6bc8$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $f64921518d4a6bc8$export$19342e026b58ebb7) return new $f64921518d4a6bc8$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodRecord,
            ...$f64921518d4a6bc8$var$processCreateParams(third)
        });
        return new $f64921518d4a6bc8$export$a2acc09968cb4b7f({
            keyType: $f64921518d4a6bc8$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodRecord,
            ...$f64921518d4a6bc8$var$processCreateParams(second)
        });
    }
}
class $f64921518d4a6bc8$export$163b6a2b712d9542 extends $f64921518d4a6bc8$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $f64921518d4a6bc8$export$5716da67bfaa244d.map) {
            $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_type,
                expected: $f64921518d4a6bc8$export$5716da67bfaa244d.map,
                received: ctx.parsedType
            });
            return $f64921518d4a6bc8$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $f64921518d4a6bc8$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $f64921518d4a6bc8$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $f64921518d4a6bc8$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $f64921518d4a6bc8$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$f64921518d4a6bc8$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $f64921518d4a6bc8$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodMap,
        ...$f64921518d4a6bc8$var$processCreateParams(params)
    });
};
class $f64921518d4a6bc8$export$977057706f816712 extends $f64921518d4a6bc8$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $f64921518d4a6bc8$export$5716da67bfaa244d.set) {
            $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_type,
                expected: $f64921518d4a6bc8$export$5716da67bfaa244d.set,
                received: ctx.parsedType
            });
            return $f64921518d4a6bc8$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                    code: $f64921518d4a6bc8$export$5ba560653e4a1035.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                    code: $f64921518d4a6bc8$export$5ba560653e4a1035.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $f64921518d4a6bc8$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $f64921518d4a6bc8$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $f64921518d4a6bc8$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: $f64921518d4a6bc8$var$errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $f64921518d4a6bc8$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: $f64921518d4a6bc8$var$errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$f64921518d4a6bc8$export$977057706f816712.create = (valueType, params)=>{
    return new $f64921518d4a6bc8$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodSet,
        ...$f64921518d4a6bc8$var$processCreateParams(params)
    });
};
class $f64921518d4a6bc8$export$d4602ba55673f53c extends $f64921518d4a6bc8$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $f64921518d4a6bc8$export$5716da67bfaa244d.function) {
            $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_type,
                expected: $f64921518d4a6bc8$export$5716da67bfaa244d.function,
                received: ctx.parsedType
            });
            return $f64921518d4a6bc8$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return $f64921518d4a6bc8$export$244a85fde9c419ed({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $f64921518d4a6bc8$export$32f27c719778d4c4(),
                    $f64921518d4a6bc8$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return $f64921518d4a6bc8$export$244a85fde9c419ed({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $f64921518d4a6bc8$export$32f27c719778d4c4(),
                    $f64921518d4a6bc8$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $f64921518d4a6bc8$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $f64921518d4a6bc8$export$c6813a8d51f77eaf(async function(...args) {
                const error = new $f64921518d4a6bc8$export$f98dac4b251ab333([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $f64921518d4a6bc8$export$c6813a8d51f77eaf(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new $f64921518d4a6bc8$export$f98dac4b251ab333([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new $f64921518d4a6bc8$export$f98dac4b251ab333([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $f64921518d4a6bc8$export$d4602ba55673f53c({
            ...this._def,
            args: $f64921518d4a6bc8$export$e2a18bb771d8e6a3.create(items).rest($f64921518d4a6bc8$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $f64921518d4a6bc8$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $f64921518d4a6bc8$export$d4602ba55673f53c({
            args: args ? args : $f64921518d4a6bc8$export$e2a18bb771d8e6a3.create([]).rest($f64921518d4a6bc8$export$ef3b1bb1630977ae.create()),
            returns: returns || $f64921518d4a6bc8$export$ef3b1bb1630977ae.create(),
            typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodFunction,
            ...$f64921518d4a6bc8$var$processCreateParams(params)
        });
    }
}
class $f64921518d4a6bc8$export$378d0cfce37406e6 extends $f64921518d4a6bc8$export$19342e026b58ebb7 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$f64921518d4a6bc8$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $f64921518d4a6bc8$export$378d0cfce37406e6({
        getter: getter,
        typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodLazy,
        ...$f64921518d4a6bc8$var$processCreateParams(params)
    });
};
class $f64921518d4a6bc8$export$7e44096782a165d3 extends $f64921518d4a6bc8$export$19342e026b58ebb7 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_literal,
                expected: this._def.value
            });
            return $f64921518d4a6bc8$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$f64921518d4a6bc8$export$7e44096782a165d3.create = (value, params)=>{
    return new $f64921518d4a6bc8$export$7e44096782a165d3({
        value: value,
        typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodLiteral,
        ...$f64921518d4a6bc8$var$processCreateParams(params)
    });
};
function $f64921518d4a6bc8$var$createZodEnum(values, params) {
    return new $f64921518d4a6bc8$export$d325d1f0e1c20179({
        values: values,
        typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodEnum,
        ...$f64921518d4a6bc8$var$processCreateParams(params)
    });
}
class $f64921518d4a6bc8$export$d325d1f0e1c20179 extends $f64921518d4a6bc8$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        $f64921518d4a6bc8$var$_ZodEnum_cache.set(this, void 0);
    }
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                expected: $f64921518d4a6bc8$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_type
            });
            return $f64921518d4a6bc8$export$9a105a556e65c2c0;
        }
        if (!$f64921518d4a6bc8$var$__classPrivateFieldGet(this, $f64921518d4a6bc8$var$_ZodEnum_cache)) $f64921518d4a6bc8$var$__classPrivateFieldSet(this, $f64921518d4a6bc8$var$_ZodEnum_cache, new Set(this._def.values));
        if (!$f64921518d4a6bc8$var$__classPrivateFieldGet(this, $f64921518d4a6bc8$var$_ZodEnum_cache).has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $f64921518d4a6bc8$export$9a105a556e65c2c0;
        }
        return $f64921518d4a6bc8$export$c6813a8d51f77eaf(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return $f64921518d4a6bc8$export$d325d1f0e1c20179.create(values, {
            ...this._def,
            ...newDef
        });
    }
    exclude(values, newDef = this._def) {
        return $f64921518d4a6bc8$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)), {
            ...this._def,
            ...newDef
        });
    }
}
$f64921518d4a6bc8$var$_ZodEnum_cache = new WeakMap();
$f64921518d4a6bc8$export$d325d1f0e1c20179.create = $f64921518d4a6bc8$var$createZodEnum;
class $f64921518d4a6bc8$export$370b2e8d6d6f5c56 extends $f64921518d4a6bc8$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        $f64921518d4a6bc8$var$_ZodNativeEnum_cache.set(this, void 0);
    }
    _parse(input) {
        const nativeEnumValues = $f64921518d4a6bc8$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $f64921518d4a6bc8$export$5716da67bfaa244d.string && ctx.parsedType !== $f64921518d4a6bc8$export$5716da67bfaa244d.number) {
            const expectedValues = $f64921518d4a6bc8$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                expected: $f64921518d4a6bc8$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_type
            });
            return $f64921518d4a6bc8$export$9a105a556e65c2c0;
        }
        if (!$f64921518d4a6bc8$var$__classPrivateFieldGet(this, $f64921518d4a6bc8$var$_ZodNativeEnum_cache)) $f64921518d4a6bc8$var$__classPrivateFieldSet(this, $f64921518d4a6bc8$var$_ZodNativeEnum_cache, new Set($f64921518d4a6bc8$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values)));
        if (!$f64921518d4a6bc8$var$__classPrivateFieldGet(this, $f64921518d4a6bc8$var$_ZodNativeEnum_cache).has(input.data)) {
            const expectedValues = $f64921518d4a6bc8$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $f64921518d4a6bc8$export$9a105a556e65c2c0;
        }
        return $f64921518d4a6bc8$export$c6813a8d51f77eaf(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
$f64921518d4a6bc8$var$_ZodNativeEnum_cache = new WeakMap();
$f64921518d4a6bc8$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $f64921518d4a6bc8$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodNativeEnum,
        ...$f64921518d4a6bc8$var$processCreateParams(params)
    });
};
class $f64921518d4a6bc8$export$3f196b0127d6e50a extends $f64921518d4a6bc8$export$19342e026b58ebb7 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $f64921518d4a6bc8$export$5716da67bfaa244d.promise && ctx.common.async === false) {
            $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_type,
                expected: $f64921518d4a6bc8$export$5716da67bfaa244d.promise,
                received: ctx.parsedType
            });
            return $f64921518d4a6bc8$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === $f64921518d4a6bc8$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
        return $f64921518d4a6bc8$export$c6813a8d51f77eaf(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$f64921518d4a6bc8$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $f64921518d4a6bc8$export$3f196b0127d6e50a({
        type: schema,
        typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodPromise,
        ...$f64921518d4a6bc8$var$processCreateParams(params)
    });
};
class $f64921518d4a6bc8$export$a60af00cc0ce2582 extends $f64921518d4a6bc8$export$19342e026b58ebb7 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $f64921518d4a6bc8$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return $f64921518d4a6bc8$export$9a105a556e65c2c0;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $f64921518d4a6bc8$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $f64921518d4a6bc8$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $f64921518d4a6bc8$export$325a211da9693fcf(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return $f64921518d4a6bc8$export$9a105a556e65c2c0;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $f64921518d4a6bc8$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $f64921518d4a6bc8$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $f64921518d4a6bc8$export$325a211da9693fcf(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $f64921518d4a6bc8$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $f64921518d4a6bc8$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!$f64921518d4a6bc8$export$1ea939691cdc45b8(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!$f64921518d4a6bc8$export$1ea939691cdc45b8(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $f64921518d4a6bc8$export$7debb50ef11d5e0b.assertNever(effect);
    }
}
$f64921518d4a6bc8$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $f64921518d4a6bc8$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$f64921518d4a6bc8$var$processCreateParams(params)
    });
};
$f64921518d4a6bc8$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $f64921518d4a6bc8$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodEffects,
        ...$f64921518d4a6bc8$var$processCreateParams(params)
    });
};
class $f64921518d4a6bc8$export$aa56fec1e9d629b8 extends $f64921518d4a6bc8$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $f64921518d4a6bc8$export$5716da67bfaa244d.undefined) return $f64921518d4a6bc8$export$c6813a8d51f77eaf(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$f64921518d4a6bc8$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $f64921518d4a6bc8$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodOptional,
        ...$f64921518d4a6bc8$var$processCreateParams(params)
    });
};
class $f64921518d4a6bc8$export$aaac0b8b429cef5 extends $f64921518d4a6bc8$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $f64921518d4a6bc8$export$5716da67bfaa244d.null) return $f64921518d4a6bc8$export$c6813a8d51f77eaf(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$f64921518d4a6bc8$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $f64921518d4a6bc8$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodNullable,
        ...$f64921518d4a6bc8$var$processCreateParams(params)
    });
};
class $f64921518d4a6bc8$export$bb19b37874861e7e extends $f64921518d4a6bc8$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $f64921518d4a6bc8$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$f64921518d4a6bc8$export$bb19b37874861e7e.create = (type, params)=>{
    return new $f64921518d4a6bc8$export$bb19b37874861e7e({
        innerType: type,
        typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$f64921518d4a6bc8$var$processCreateParams(params)
    });
};
class $f64921518d4a6bc8$export$75a44ec6249ac76b extends $f64921518d4a6bc8$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ($f64921518d4a6bc8$export$aefee5ebe1dcfd9e(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $f64921518d4a6bc8$export$f98dac4b251ab333(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $f64921518d4a6bc8$export$f98dac4b251ab333(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$f64921518d4a6bc8$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $f64921518d4a6bc8$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$f64921518d4a6bc8$var$processCreateParams(params)
    });
};
class $f64921518d4a6bc8$export$26ccfa0145e8511f extends $f64921518d4a6bc8$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $f64921518d4a6bc8$export$5716da67bfaa244d.nan) {
            const ctx = this._getOrReturnCtx(input);
            $f64921518d4a6bc8$export$db7caee60e5d514d(ctx, {
                code: $f64921518d4a6bc8$export$5ba560653e4a1035.invalid_type,
                expected: $f64921518d4a6bc8$export$5716da67bfaa244d.nan,
                received: ctx.parsedType
            });
            return $f64921518d4a6bc8$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$f64921518d4a6bc8$export$26ccfa0145e8511f.create = (params)=>{
    return new $f64921518d4a6bc8$export$26ccfa0145e8511f({
        typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodNaN,
        ...$f64921518d4a6bc8$var$processCreateParams(params)
    });
};
const $f64921518d4a6bc8$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $f64921518d4a6bc8$export$66b0c798a395271f extends $f64921518d4a6bc8$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $f64921518d4a6bc8$export$a3c3ef8a0e95c6da extends $f64921518d4a6bc8$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return $f64921518d4a6bc8$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return $f64921518d4a6bc8$export$325a211da9693fcf(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $f64921518d4a6bc8$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $f64921518d4a6bc8$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $f64921518d4a6bc8$export$5d1f7ef05c4e493a extends $f64921518d4a6bc8$export$19342e026b58ebb7 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if ($f64921518d4a6bc8$export$1ea939691cdc45b8(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return $f64921518d4a6bc8$export$aefee5ebe1dcfd9e(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$f64921518d4a6bc8$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $f64921518d4a6bc8$export$5d1f7ef05c4e493a({
        innerType: type,
        typeName: $f64921518d4a6bc8$export$558106ce543bd011.ZodReadonly,
        ...$f64921518d4a6bc8$var$processCreateParams(params)
    });
};
function $f64921518d4a6bc8$export$4c00f665f0d4b443(check, params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return $f64921518d4a6bc8$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        var _a, _b;
        if (!check(data)) {
            const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            const p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue({
                code: "custom",
                ...p2,
                fatal: _fatal
            });
        }
    });
    return $f64921518d4a6bc8$export$b9d1edb536b4e4eb.create();
}
const $f64921518d4a6bc8$export$1ee8ee30835eab8b = {
    object: $f64921518d4a6bc8$export$736315c5b55efbad.lazycreate
};
var $f64921518d4a6bc8$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($f64921518d4a6bc8$export$558106ce543bd011 || ($f64921518d4a6bc8$export$558106ce543bd011 = {}));
const $f64921518d4a6bc8$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$f64921518d4a6bc8$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $f64921518d4a6bc8$export$22b082955e083ec3 = $f64921518d4a6bc8$export$1230eb29b8d3b502.create;
const $f64921518d4a6bc8$export$98e628dec113755e = $f64921518d4a6bc8$export$5b070a55c0c43e09.create;
const $f64921518d4a6bc8$export$9e06de0973666692 = $f64921518d4a6bc8$export$26ccfa0145e8511f.create;
const $f64921518d4a6bc8$export$a0f65b52274bcc00 = $f64921518d4a6bc8$export$67d741fd70ff98f4.create;
const $f64921518d4a6bc8$export$4a21f16c33752377 = $f64921518d4a6bc8$export$723d146f80596191.create;
const $f64921518d4a6bc8$export$324d90190a8b822a = $f64921518d4a6bc8$export$e974be33bdc55521.create;
const $f64921518d4a6bc8$export$8f701197936bc2a6 = $f64921518d4a6bc8$export$bcc3b40f6b638044.create;
const $f64921518d4a6bc8$export$1db45310990710a5 = $f64921518d4a6bc8$export$4e780e961c30340d.create;
const $f64921518d4a6bc8$export$7b1b591b262c240 = $f64921518d4a6bc8$export$a96281f914484f2d.create;
const $f64921518d4a6bc8$export$4154a199d7d90455 = $f64921518d4a6bc8$export$b9d1edb536b4e4eb.create;
const $f64921518d4a6bc8$export$19282c40b967aec6 = $f64921518d4a6bc8$export$ef3b1bb1630977ae.create;
const $f64921518d4a6bc8$export$b3e22bcfd64c1022 = $f64921518d4a6bc8$export$1e576a20c3ce9fb5.create;
const $f64921518d4a6bc8$export$490e536ee7389aeb = $f64921518d4a6bc8$export$7d39f5df85f21031.create;
const $f64921518d4a6bc8$export$2f23118c22fb2630 = $f64921518d4a6bc8$export$7acfc3e64785411.create;
const $f64921518d4a6bc8$export$be5493f9613cbbe = $f64921518d4a6bc8$export$736315c5b55efbad.create;
const $f64921518d4a6bc8$export$8fb0df5f40d0b477 = $f64921518d4a6bc8$export$736315c5b55efbad.strictCreate;
const $f64921518d4a6bc8$export$971dd5b0dfd021b6 = $f64921518d4a6bc8$export$a8b236cb5070a311.create;
const $f64921518d4a6bc8$export$4b888e40c4ee26dd = $f64921518d4a6bc8$export$5ef2424805ac76a3.create;
const $f64921518d4a6bc8$export$bc86dfbf7795668c = $f64921518d4a6bc8$export$c02deaf0bb5203d4.create;
const $f64921518d4a6bc8$export$65e3907585753458 = $f64921518d4a6bc8$export$e2a18bb771d8e6a3.create;
const $f64921518d4a6bc8$export$e5185e241753e543 = $f64921518d4a6bc8$export$a2acc09968cb4b7f.create;
const $f64921518d4a6bc8$export$871de8747c9eaa88 = $f64921518d4a6bc8$export$163b6a2b712d9542.create;
const $f64921518d4a6bc8$export$adaa4cf7ef1b65be = $f64921518d4a6bc8$export$977057706f816712.create;
const $f64921518d4a6bc8$export$44e51c8aac7c2deb = $f64921518d4a6bc8$export$d4602ba55673f53c.create;
const $f64921518d4a6bc8$export$488013bae63b21da = $f64921518d4a6bc8$export$378d0cfce37406e6.create;
const $f64921518d4a6bc8$export$c8ec6e1ec9fefcb0 = $f64921518d4a6bc8$export$7e44096782a165d3.create;
const $f64921518d4a6bc8$export$78a99c8d44d72635 = $f64921518d4a6bc8$export$d325d1f0e1c20179.create;
const $f64921518d4a6bc8$export$6fe7eca19ebe5199 = $f64921518d4a6bc8$export$370b2e8d6d6f5c56.create;
const $f64921518d4a6bc8$export$c957ef27a0ebfd4 = $f64921518d4a6bc8$export$3f196b0127d6e50a.create;
const $f64921518d4a6bc8$export$dc573d8a6576cdb3 = $f64921518d4a6bc8$export$a60af00cc0ce2582.create;
const $f64921518d4a6bc8$export$516e28dec6a4b6d4 = $f64921518d4a6bc8$export$aa56fec1e9d629b8.create;
const $f64921518d4a6bc8$export$133fc36489ac9add = $f64921518d4a6bc8$export$aaac0b8b429cef5.create;
const $f64921518d4a6bc8$export$fc37fe19dfda43ee = $f64921518d4a6bc8$export$a60af00cc0ce2582.createWithPreprocess;
const $f64921518d4a6bc8$export$43f28b24e1eb8181 = $f64921518d4a6bc8$export$a3c3ef8a0e95c6da.create;
const $f64921518d4a6bc8$export$3b3d07727c5b702c = ()=>$f64921518d4a6bc8$export$22b082955e083ec3().optional();
const $f64921518d4a6bc8$export$eb150471a61fced6 = ()=>$f64921518d4a6bc8$export$98e628dec113755e().optional();
const $f64921518d4a6bc8$export$269251733cdcbbf1 = ()=>$f64921518d4a6bc8$export$4a21f16c33752377().optional();
const $f64921518d4a6bc8$export$8c14e57e778d3873 = {
    string: (arg)=>$f64921518d4a6bc8$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$f64921518d4a6bc8$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$f64921518d4a6bc8$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$f64921518d4a6bc8$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$f64921518d4a6bc8$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $f64921518d4a6bc8$export$96c94437c95d7862 = $f64921518d4a6bc8$export$9a105a556e65c2c0;
var $f64921518d4a6bc8$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $f64921518d4a6bc8$export$341b0b6e0a6f5099,
    setErrorMap: $f64921518d4a6bc8$export$1097a8289cfd22d7,
    getErrorMap: $f64921518d4a6bc8$export$32f27c719778d4c4,
    makeIssue: $f64921518d4a6bc8$export$244a85fde9c419ed,
    EMPTY_PATH: $f64921518d4a6bc8$export$1526d2e05f74572,
    addIssueToContext: $f64921518d4a6bc8$export$db7caee60e5d514d,
    ParseStatus: $f64921518d4a6bc8$export$5b20a5c3d05c1f6f,
    INVALID: $f64921518d4a6bc8$export$9a105a556e65c2c0,
    DIRTY: $f64921518d4a6bc8$export$325a211da9693fcf,
    OK: $f64921518d4a6bc8$export$c6813a8d51f77eaf,
    isAborted: $f64921518d4a6bc8$export$afa861e3c5730743,
    isDirty: $f64921518d4a6bc8$export$910b6cdd390341b3,
    isValid: $f64921518d4a6bc8$export$1ea939691cdc45b8,
    isAsync: $f64921518d4a6bc8$export$aefee5ebe1dcfd9e,
    get util () {
        return $f64921518d4a6bc8$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $f64921518d4a6bc8$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $f64921518d4a6bc8$export$5716da67bfaa244d,
    getParsedType: $f64921518d4a6bc8$export$3e9057828ebd5c7a,
    ZodType: $f64921518d4a6bc8$export$19342e026b58ebb7,
    datetimeRegex: $f64921518d4a6bc8$export$a4b563879add27a,
    ZodString: $f64921518d4a6bc8$export$1230eb29b8d3b502,
    ZodNumber: $f64921518d4a6bc8$export$5b070a55c0c43e09,
    ZodBigInt: $f64921518d4a6bc8$export$67d741fd70ff98f4,
    ZodBoolean: $f64921518d4a6bc8$export$723d146f80596191,
    ZodDate: $f64921518d4a6bc8$export$e974be33bdc55521,
    ZodSymbol: $f64921518d4a6bc8$export$bcc3b40f6b638044,
    ZodUndefined: $f64921518d4a6bc8$export$4e780e961c30340d,
    ZodNull: $f64921518d4a6bc8$export$a96281f914484f2d,
    ZodAny: $f64921518d4a6bc8$export$b9d1edb536b4e4eb,
    ZodUnknown: $f64921518d4a6bc8$export$ef3b1bb1630977ae,
    ZodNever: $f64921518d4a6bc8$export$1e576a20c3ce9fb5,
    ZodVoid: $f64921518d4a6bc8$export$7d39f5df85f21031,
    ZodArray: $f64921518d4a6bc8$export$7acfc3e64785411,
    ZodObject: $f64921518d4a6bc8$export$736315c5b55efbad,
    ZodUnion: $f64921518d4a6bc8$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $f64921518d4a6bc8$export$5ef2424805ac76a3,
    ZodIntersection: $f64921518d4a6bc8$export$c02deaf0bb5203d4,
    ZodTuple: $f64921518d4a6bc8$export$e2a18bb771d8e6a3,
    ZodRecord: $f64921518d4a6bc8$export$a2acc09968cb4b7f,
    ZodMap: $f64921518d4a6bc8$export$163b6a2b712d9542,
    ZodSet: $f64921518d4a6bc8$export$977057706f816712,
    ZodFunction: $f64921518d4a6bc8$export$d4602ba55673f53c,
    ZodLazy: $f64921518d4a6bc8$export$378d0cfce37406e6,
    ZodLiteral: $f64921518d4a6bc8$export$7e44096782a165d3,
    ZodEnum: $f64921518d4a6bc8$export$d325d1f0e1c20179,
    ZodNativeEnum: $f64921518d4a6bc8$export$370b2e8d6d6f5c56,
    ZodPromise: $f64921518d4a6bc8$export$3f196b0127d6e50a,
    ZodEffects: $f64921518d4a6bc8$export$a60af00cc0ce2582,
    ZodTransformer: $f64921518d4a6bc8$export$a60af00cc0ce2582,
    ZodOptional: $f64921518d4a6bc8$export$aa56fec1e9d629b8,
    ZodNullable: $f64921518d4a6bc8$export$aaac0b8b429cef5,
    ZodDefault: $f64921518d4a6bc8$export$bb19b37874861e7e,
    ZodCatch: $f64921518d4a6bc8$export$75a44ec6249ac76b,
    ZodNaN: $f64921518d4a6bc8$export$26ccfa0145e8511f,
    BRAND: $f64921518d4a6bc8$export$cf2deea74cde46b4,
    ZodBranded: $f64921518d4a6bc8$export$66b0c798a395271f,
    ZodPipeline: $f64921518d4a6bc8$export$a3c3ef8a0e95c6da,
    ZodReadonly: $f64921518d4a6bc8$export$5d1f7ef05c4e493a,
    custom: $f64921518d4a6bc8$export$4c00f665f0d4b443,
    Schema: $f64921518d4a6bc8$export$19342e026b58ebb7,
    ZodSchema: $f64921518d4a6bc8$export$19342e026b58ebb7,
    late: $f64921518d4a6bc8$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $f64921518d4a6bc8$export$558106ce543bd011;
    },
    coerce: $f64921518d4a6bc8$export$8c14e57e778d3873,
    any: $f64921518d4a6bc8$export$4154a199d7d90455,
    array: $f64921518d4a6bc8$export$2f23118c22fb2630,
    bigint: $f64921518d4a6bc8$export$a0f65b52274bcc00,
    boolean: $f64921518d4a6bc8$export$4a21f16c33752377,
    date: $f64921518d4a6bc8$export$324d90190a8b822a,
    discriminatedUnion: $f64921518d4a6bc8$export$4b888e40c4ee26dd,
    effect: $f64921518d4a6bc8$export$dc573d8a6576cdb3,
    'enum': $f64921518d4a6bc8$export$78a99c8d44d72635,
    'function': $f64921518d4a6bc8$export$44e51c8aac7c2deb,
    'instanceof': $f64921518d4a6bc8$export$3d916e7c22dbd8b5,
    intersection: $f64921518d4a6bc8$export$bc86dfbf7795668c,
    lazy: $f64921518d4a6bc8$export$488013bae63b21da,
    literal: $f64921518d4a6bc8$export$c8ec6e1ec9fefcb0,
    map: $f64921518d4a6bc8$export$871de8747c9eaa88,
    nan: $f64921518d4a6bc8$export$9e06de0973666692,
    nativeEnum: $f64921518d4a6bc8$export$6fe7eca19ebe5199,
    never: $f64921518d4a6bc8$export$b3e22bcfd64c1022,
    'null': $f64921518d4a6bc8$export$7b1b591b262c240,
    nullable: $f64921518d4a6bc8$export$133fc36489ac9add,
    number: $f64921518d4a6bc8$export$98e628dec113755e,
    object: $f64921518d4a6bc8$export$be5493f9613cbbe,
    oboolean: $f64921518d4a6bc8$export$269251733cdcbbf1,
    onumber: $f64921518d4a6bc8$export$eb150471a61fced6,
    optional: $f64921518d4a6bc8$export$516e28dec6a4b6d4,
    ostring: $f64921518d4a6bc8$export$3b3d07727c5b702c,
    pipeline: $f64921518d4a6bc8$export$43f28b24e1eb8181,
    preprocess: $f64921518d4a6bc8$export$fc37fe19dfda43ee,
    promise: $f64921518d4a6bc8$export$c957ef27a0ebfd4,
    record: $f64921518d4a6bc8$export$e5185e241753e543,
    set: $f64921518d4a6bc8$export$adaa4cf7ef1b65be,
    strictObject: $f64921518d4a6bc8$export$8fb0df5f40d0b477,
    string: $f64921518d4a6bc8$export$22b082955e083ec3,
    symbol: $f64921518d4a6bc8$export$8f701197936bc2a6,
    transformer: $f64921518d4a6bc8$export$dc573d8a6576cdb3,
    tuple: $f64921518d4a6bc8$export$65e3907585753458,
    'undefined': $f64921518d4a6bc8$export$1db45310990710a5,
    union: $f64921518d4a6bc8$export$971dd5b0dfd021b6,
    unknown: $f64921518d4a6bc8$export$19282c40b967aec6,
    'void': $f64921518d4a6bc8$export$490e536ee7389aeb,
    NEVER: $f64921518d4a6bc8$export$96c94437c95d7862,
    ZodIssueCode: $f64921518d4a6bc8$export$5ba560653e4a1035,
    quotelessJson: $f64921518d4a6bc8$export$913eddeaf297cfea,
    ZodError: $f64921518d4a6bc8$export$f98dac4b251ab333
});

});

parcelRegister("cOfbu", function(module, exports) {

$parcel$export(module.exports, "ERROR", function () { return $d8f4b482c646da62$export$103bedf43ba882db; });
$parcel$export(module.exports, "Events", function () { return $d8f4b482c646da62$export$ada873a34909da65; });
$parcel$export(module.exports, "ErrorEvent", function () { return $d8f4b482c646da62$export$4c6f5e6e10fb9fd0; });
$parcel$export(module.exports, "EventFrame", function () { return $d8f4b482c646da62$export$f344a15bf52574b2; });
$parcel$export(module.exports, "parseEventPayload", function () { return $d8f4b482c646da62$export$a46bc76e895063f4; });

var $39moO = parcelRequire("39moO");

var $7IqZ6 = parcelRequire("7IqZ6");

var $a99sA = parcelRequire("a99sA");

var $3BSyG = parcelRequire("3BSyG");

var $3VyrS = parcelRequire("3VyrS");
// ERROR is sent as evt but is a special case, so is excluded from Events enum
const $d8f4b482c646da62$export$103bedf43ba882db = 'ERROR';
var $d8f4b482c646da62$export$ada873a34909da65;
(function(Events) {
    Events["READY"] = "READY";
    Events["VOICE_STATE_UPDATE"] = "VOICE_STATE_UPDATE";
    Events["SPEAKING_START"] = "SPEAKING_START";
    Events["SPEAKING_STOP"] = "SPEAKING_STOP";
    Events["ACTIVITY_LAYOUT_MODE_UPDATE"] = "ACTIVITY_LAYOUT_MODE_UPDATE";
    Events["ORIENTATION_UPDATE"] = "ORIENTATION_UPDATE";
    Events["CURRENT_USER_UPDATE"] = "CURRENT_USER_UPDATE";
    Events["CURRENT_GUILD_MEMBER_UPDATE"] = "CURRENT_GUILD_MEMBER_UPDATE";
    Events["ENTITLEMENT_CREATE"] = "ENTITLEMENT_CREATE";
    Events["THERMAL_STATE_UPDATE"] = "THERMAL_STATE_UPDATE";
    Events["ACTIVITY_INSTANCE_PARTICIPANTS_UPDATE"] = "ACTIVITY_INSTANCE_PARTICIPANTS_UPDATE";
    Events["RELATIONSHIP_UPDATE"] = "RELATIONSHIP_UPDATE";
    Events["ACTIVITY_JOIN"] = "ACTIVITY_JOIN";
    Events["QUEST_ENROLLMENT_STATUS_UPDATE"] = "QUEST_ENROLLMENT_STATUS_UPDATE";
})($d8f4b482c646da62$export$ada873a34909da65 || ($d8f4b482c646da62$export$ada873a34909da65 = {}));
const $d8f4b482c646da62$export$326fa0fd43fb9e9c = (0, $a99sA.ReceiveFramePayload).extend({
    evt: (0, $39moO.nativeEnum)($d8f4b482c646da62$export$ada873a34909da65),
    nonce: (0, $39moO.string)().nullable(),
    cmd: (0, $39moO.literal)((0, $a99sA.DISPATCH)),
    data: (0, $39moO.object)({}).passthrough()
});
const $d8f4b482c646da62$export$4c6f5e6e10fb9fd0 = (0, $a99sA.ReceiveFramePayload).extend({
    evt: (0, $39moO.literal)($d8f4b482c646da62$export$103bedf43ba882db),
    data: (0, $39moO.object)({
        code: (0, $39moO.number)(),
        message: (0, $39moO.string)().optional()
    }).passthrough(),
    cmd: (0, $39moO.nativeEnum)((0, $a99sA.Commands)),
    nonce: (0, $39moO.string)().nullable()
});
const $d8f4b482c646da62$export$a242e5821d539c8e = $d8f4b482c646da62$export$326fa0fd43fb9e9c.extend({
    evt: (0, $39moO.string)()
});
const $d8f4b482c646da62$export$f344a15bf52574b2 = (0, $39moO.union)([
    $d8f4b482c646da62$export$326fa0fd43fb9e9c,
    $d8f4b482c646da62$export$a242e5821d539c8e,
    $d8f4b482c646da62$export$4c6f5e6e10fb9fd0
]);
function $d8f4b482c646da62$export$a46bc76e895063f4(data) {
    const event = data.evt;
    if (!(event in $d8f4b482c646da62$export$ada873a34909da65)) throw new Error(`Unrecognized event type ${data.evt}`);
    const eventSchema = $d8f4b482c646da62$export$769a4ec051ed522c[event];
    return eventSchema.payload.parse(data);
}
const $d8f4b482c646da62$export$769a4ec051ed522c = {
    /**
     * @description
     * The READY event is emitted by Discord's RPC server in reply to a client
     * initiating the RPC handshake. The event includes information about
     * - the rpc server version
     * - the discord client configuration
     * - the (basic) user object
     *
     * Unlike other events, READY will only be omitted once, immediately after the
     * Embedded App SDK is initialized
     *
     * # Supported Platforms
     * | Web | iOS | Android |
     * |-----|-----|---------|
     * | ✅  | ✅  | ✅      |
     *
     * Required scopes: []
     *
     */ [$d8f4b482c646da62$export$ada873a34909da65.READY]: {
        payload: $d8f4b482c646da62$export$326fa0fd43fb9e9c.extend({
            evt: (0, $39moO.literal)($d8f4b482c646da62$export$ada873a34909da65.READY),
            data: (0, $39moO.object)({
                v: (0, $39moO.number)(),
                config: (0, $39moO.object)({
                    cdn_host: (0, $39moO.string)().optional(),
                    api_endpoint: (0, $39moO.string)(),
                    environment: (0, $39moO.string)()
                }),
                user: (0, $39moO.object)({
                    id: (0, $39moO.string)(),
                    username: (0, $39moO.string)(),
                    discriminator: (0, $39moO.string)(),
                    avatar: (0, $39moO.string)().optional()
                }).optional()
            })
        })
    },
    [$d8f4b482c646da62$export$ada873a34909da65.VOICE_STATE_UPDATE]: {
        payload: $d8f4b482c646da62$export$326fa0fd43fb9e9c.extend({
            evt: (0, $39moO.literal)($d8f4b482c646da62$export$ada873a34909da65.VOICE_STATE_UPDATE),
            data: (0, $a99sA.UserVoiceState)
        }),
        subscribeArgs: (0, $39moO.object)({
            channel_id: (0, $39moO.string)()
        })
    },
    [$d8f4b482c646da62$export$ada873a34909da65.SPEAKING_START]: {
        payload: $d8f4b482c646da62$export$326fa0fd43fb9e9c.extend({
            evt: (0, $39moO.literal)($d8f4b482c646da62$export$ada873a34909da65.SPEAKING_START),
            data: (0, $39moO.object)({
                lobby_id: (0, $39moO.string)().optional(),
                channel_id: (0, $39moO.string)().optional(),
                user_id: (0, $39moO.string)()
            })
        }),
        subscribeArgs: (0, $39moO.object)({
            lobby_id: (0, $39moO.string)().nullable().optional(),
            channel_id: (0, $39moO.string)().nullable().optional()
        })
    },
    [$d8f4b482c646da62$export$ada873a34909da65.SPEAKING_STOP]: {
        payload: $d8f4b482c646da62$export$326fa0fd43fb9e9c.extend({
            evt: (0, $39moO.literal)($d8f4b482c646da62$export$ada873a34909da65.SPEAKING_STOP),
            data: (0, $39moO.object)({
                lobby_id: (0, $39moO.string)().optional(),
                channel_id: (0, $39moO.string)().optional(),
                user_id: (0, $39moO.string)()
            })
        }),
        subscribeArgs: (0, $39moO.object)({
            lobby_id: (0, $39moO.string)().nullable().optional(),
            channel_id: (0, $39moO.string)().nullable().optional()
        })
    },
    [$d8f4b482c646da62$export$ada873a34909da65.ACTIVITY_LAYOUT_MODE_UPDATE]: {
        payload: $d8f4b482c646da62$export$326fa0fd43fb9e9c.extend({
            evt: (0, $39moO.literal)($d8f4b482c646da62$export$ada873a34909da65.ACTIVITY_LAYOUT_MODE_UPDATE),
            data: (0, $39moO.object)({
                layout_mode: (0, $3BSyG.zodCoerceUnhandledValue)((0, $a99sA.LayoutModeTypeObject))
            })
        })
    },
    [$d8f4b482c646da62$export$ada873a34909da65.ORIENTATION_UPDATE]: {
        payload: $d8f4b482c646da62$export$326fa0fd43fb9e9c.extend({
            evt: (0, $39moO.literal)($d8f4b482c646da62$export$ada873a34909da65.ORIENTATION_UPDATE),
            data: (0, $39moO.object)({
                screen_orientation: (0, $3BSyG.zodCoerceUnhandledValue)((0, $a99sA.OrientationTypeObject)),
                /**
                 * @deprecated use screen_orientation instead
                 */ orientation: (0, $39moO.nativeEnum)((0, $7IqZ6.Orientation))
            })
        })
    },
    [$d8f4b482c646da62$export$ada873a34909da65.CURRENT_USER_UPDATE]: {
        payload: $d8f4b482c646da62$export$326fa0fd43fb9e9c.extend({
            evt: (0, $39moO.literal)($d8f4b482c646da62$export$ada873a34909da65.CURRENT_USER_UPDATE),
            data: (0, $a99sA.User)
        })
    },
    [$d8f4b482c646da62$export$ada873a34909da65.CURRENT_GUILD_MEMBER_UPDATE]: {
        payload: $d8f4b482c646da62$export$326fa0fd43fb9e9c.extend({
            evt: (0, $39moO.literal)($d8f4b482c646da62$export$ada873a34909da65.CURRENT_GUILD_MEMBER_UPDATE),
            data: (0, $a99sA.GuildMemberRPC)
        }),
        subscribeArgs: (0, $39moO.object)({
            guild_id: (0, $39moO.string)()
        })
    },
    [$d8f4b482c646da62$export$ada873a34909da65.ENTITLEMENT_CREATE]: {
        payload: $d8f4b482c646da62$export$326fa0fd43fb9e9c.extend({
            evt: (0, $39moO.literal)($d8f4b482c646da62$export$ada873a34909da65.ENTITLEMENT_CREATE),
            data: (0, $39moO.object)({
                entitlement: (0, $a99sA.Entitlement)
            })
        })
    },
    [$d8f4b482c646da62$export$ada873a34909da65.THERMAL_STATE_UPDATE]: {
        payload: $d8f4b482c646da62$export$326fa0fd43fb9e9c.extend({
            evt: (0, $39moO.literal)($d8f4b482c646da62$export$ada873a34909da65.THERMAL_STATE_UPDATE),
            data: (0, $39moO.object)({
                thermal_state: (0, $a99sA.ThermalState)
            })
        })
    },
    [$d8f4b482c646da62$export$ada873a34909da65.ACTIVITY_INSTANCE_PARTICIPANTS_UPDATE]: {
        payload: $d8f4b482c646da62$export$326fa0fd43fb9e9c.extend({
            evt: (0, $39moO.literal)($d8f4b482c646da62$export$ada873a34909da65.ACTIVITY_INSTANCE_PARTICIPANTS_UPDATE),
            data: (0, $39moO.object)({
                participants: (0, $3VyrS.GetActivityInstanceConnectedParticipantsResponseSchema).shape.participants
            })
        })
    },
    [$d8f4b482c646da62$export$ada873a34909da65.RELATIONSHIP_UPDATE]: {
        payload: $d8f4b482c646da62$export$326fa0fd43fb9e9c.extend({
            evt: (0, $39moO.literal)($d8f4b482c646da62$export$ada873a34909da65.RELATIONSHIP_UPDATE),
            data: (0, $a99sA.Relationship)
        })
    },
    [$d8f4b482c646da62$export$ada873a34909da65.ACTIVITY_JOIN]: {
        payload: $d8f4b482c646da62$export$326fa0fd43fb9e9c.extend({
            evt: (0, $39moO.literal)($d8f4b482c646da62$export$ada873a34909da65.ACTIVITY_JOIN),
            data: (0, $39moO.object)({
                applicationId: (0, $39moO.string)(),
                secret: (0, $39moO.string)()
            })
        })
    },
    [$d8f4b482c646da62$export$ada873a34909da65.QUEST_ENROLLMENT_STATUS_UPDATE]: {
        payload: $d8f4b482c646da62$export$326fa0fd43fb9e9c.extend({
            evt: (0, $39moO.literal)($d8f4b482c646da62$export$ada873a34909da65.QUEST_ENROLLMENT_STATUS_UPDATE),
            data: (0, $39moO.object)({
                quest_id: (0, $39moO.string)(),
                is_enrolled: (0, $39moO.boolean)(),
                enrolled_at: (0, $39moO.string)().date()
            })
        })
    }
};

});
parcelRegister("7IqZ6", function(module, exports) {

$parcel$export(module.exports, "RPCErrorCodes", function () { return $673cd345ce7def3a$export$9ebb08d40ecbafd9; });
$parcel$export(module.exports, "Orientation", function () { return $673cd345ce7def3a$export$df54d73aa0ec5e82; });
$parcel$export(module.exports, "Platform", function () { return $673cd345ce7def3a$export$2dffd0b5373a4389; });
$parcel$export(module.exports, "UNKNOWN_VERSION_NUMBER", function () { return $673cd345ce7def3a$export$6d0e4238fc52b7e2; });
$parcel$export(module.exports, "HANDSHAKE_SDK_VERSION_MINIMUM_MOBILE_VERSION", function () { return $673cd345ce7def3a$export$e124ef0815aed2db; });

var $cl2KK = parcelRequire("cl2KK");
var $673cd345ce7def3a$export$b87f1ea3076d6f58;
(function(RPCCloseCodes) {
    RPCCloseCodes[RPCCloseCodes["CLOSE_NORMAL"] = 1000] = "CLOSE_NORMAL";
    RPCCloseCodes[RPCCloseCodes["CLOSE_UNSUPPORTED"] = 1003] = "CLOSE_UNSUPPORTED";
    RPCCloseCodes[RPCCloseCodes["CLOSE_ABNORMAL"] = 1006] = "CLOSE_ABNORMAL";
    RPCCloseCodes[RPCCloseCodes["INVALID_CLIENTID"] = 4000] = "INVALID_CLIENTID";
    RPCCloseCodes[RPCCloseCodes["INVALID_ORIGIN"] = 4001] = "INVALID_ORIGIN";
    RPCCloseCodes[RPCCloseCodes["RATELIMITED"] = 4002] = "RATELIMITED";
    RPCCloseCodes[RPCCloseCodes["TOKEN_REVOKED"] = 4003] = "TOKEN_REVOKED";
    RPCCloseCodes[RPCCloseCodes["INVALID_VERSION"] = 4004] = "INVALID_VERSION";
    RPCCloseCodes[RPCCloseCodes["INVALID_ENCODING"] = 4005] = "INVALID_ENCODING";
})($673cd345ce7def3a$export$b87f1ea3076d6f58 || ($673cd345ce7def3a$export$b87f1ea3076d6f58 = {}));
var $673cd345ce7def3a$export$9ebb08d40ecbafd9;
(function(RPCErrorCodes) {
    RPCErrorCodes[RPCErrorCodes["INVALID_PAYLOAD"] = 4000] = "INVALID_PAYLOAD";
    RPCErrorCodes[RPCErrorCodes["INVALID_COMMAND"] = 4002] = "INVALID_COMMAND";
    RPCErrorCodes[RPCErrorCodes["INVALID_GUILD"] = 4003] = "INVALID_GUILD";
    RPCErrorCodes[RPCErrorCodes["INVALID_EVENT"] = 4004] = "INVALID_EVENT";
    RPCErrorCodes[RPCErrorCodes["INVALID_CHANNEL"] = 4005] = "INVALID_CHANNEL";
    RPCErrorCodes[RPCErrorCodes["INVALID_PERMISSIONS"] = 4006] = "INVALID_PERMISSIONS";
    RPCErrorCodes[RPCErrorCodes["INVALID_CLIENTID"] = 4007] = "INVALID_CLIENTID";
    RPCErrorCodes[RPCErrorCodes["INVALID_ORIGIN"] = 4008] = "INVALID_ORIGIN";
    RPCErrorCodes[RPCErrorCodes["INVALID_TOKEN"] = 4009] = "INVALID_TOKEN";
    RPCErrorCodes[RPCErrorCodes["INVALID_USER"] = 4010] = "INVALID_USER";
})($673cd345ce7def3a$export$9ebb08d40ecbafd9 || ($673cd345ce7def3a$export$9ebb08d40ecbafd9 = {}));
/**
 * @deprecated use OrientationTypeObject instead
 */ var $673cd345ce7def3a$export$df54d73aa0ec5e82;
(function(Orientation) {
    Orientation["LANDSCAPE"] = "landscape";
    Orientation["PORTRAIT"] = "portrait";
})($673cd345ce7def3a$export$df54d73aa0ec5e82 || ($673cd345ce7def3a$export$df54d73aa0ec5e82 = {}));
var $673cd345ce7def3a$export$2dffd0b5373a4389;
(function(Platform) {
    Platform["MOBILE"] = "mobile";
    Platform["DESKTOP"] = "desktop";
})($673cd345ce7def3a$export$2dffd0b5373a4389 || ($673cd345ce7def3a$export$2dffd0b5373a4389 = {}));
/** See https://discord.com/developers/docs/topics/permissions#permissions-bitwise-permission-flags for more Permissions details */ const $673cd345ce7def3a$export$2d41982586bbb6be = Object.freeze({
    CREATE_INSTANT_INVITE: (0, $cl2KK.default).getFlag(0),
    KICK_MEMBERS: (0, $cl2KK.default).getFlag(1),
    BAN_MEMBERS: (0, $cl2KK.default).getFlag(2),
    ADMINISTRATOR: (0, $cl2KK.default).getFlag(3),
    MANAGE_CHANNELS: (0, $cl2KK.default).getFlag(4),
    MANAGE_GUILD: (0, $cl2KK.default).getFlag(5),
    ADD_REACTIONS: (0, $cl2KK.default).getFlag(6),
    VIEW_AUDIT_LOG: (0, $cl2KK.default).getFlag(7),
    PRIORITY_SPEAKER: (0, $cl2KK.default).getFlag(8),
    STREAM: (0, $cl2KK.default).getFlag(9),
    VIEW_CHANNEL: (0, $cl2KK.default).getFlag(10),
    SEND_MESSAGES: (0, $cl2KK.default).getFlag(11),
    SEND_TTS_MESSAGES: (0, $cl2KK.default).getFlag(12),
    MANAGE_MESSAGES: (0, $cl2KK.default).getFlag(13),
    EMBED_LINKS: (0, $cl2KK.default).getFlag(14),
    ATTACH_FILES: (0, $cl2KK.default).getFlag(15),
    READ_MESSAGE_HISTORY: (0, $cl2KK.default).getFlag(16),
    MENTION_EVERYONE: (0, $cl2KK.default).getFlag(17),
    USE_EXTERNAL_EMOJIS: (0, $cl2KK.default).getFlag(18),
    VIEW_GUILD_INSIGHTS: (0, $cl2KK.default).getFlag(19),
    CONNECT: (0, $cl2KK.default).getFlag(20),
    SPEAK: (0, $cl2KK.default).getFlag(21),
    MUTE_MEMBERS: (0, $cl2KK.default).getFlag(22),
    DEAFEN_MEMBERS: (0, $cl2KK.default).getFlag(23),
    MOVE_MEMBERS: (0, $cl2KK.default).getFlag(24),
    USE_VAD: (0, $cl2KK.default).getFlag(25),
    CHANGE_NICKNAME: (0, $cl2KK.default).getFlag(26),
    MANAGE_NICKNAMES: (0, $cl2KK.default).getFlag(27),
    MANAGE_ROLES: (0, $cl2KK.default).getFlag(28),
    MANAGE_WEBHOOKS: (0, $cl2KK.default).getFlag(29),
    MANAGE_GUILD_EXPRESSIONS: (0, $cl2KK.default).getFlag(30),
    USE_APPLICATION_COMMANDS: (0, $cl2KK.default).getFlag(31),
    REQUEST_TO_SPEAK: (0, $cl2KK.default).getFlag(32),
    MANAGE_EVENTS: (0, $cl2KK.default).getFlag(33),
    MANAGE_THREADS: (0, $cl2KK.default).getFlag(34),
    CREATE_PUBLIC_THREADS: (0, $cl2KK.default).getFlag(35),
    CREATE_PRIVATE_THREADS: (0, $cl2KK.default).getFlag(36),
    USE_EXTERNAL_STICKERS: (0, $cl2KK.default).getFlag(37),
    SEND_MESSAGES_IN_THREADS: (0, $cl2KK.default).getFlag(38),
    USE_EMBEDDED_ACTIVITIES: (0, $cl2KK.default).getFlag(39),
    MODERATE_MEMBERS: (0, $cl2KK.default).getFlag(40),
    VIEW_CREATOR_MONETIZATION_ANALYTICS: (0, $cl2KK.default).getFlag(41),
    USE_SOUNDBOARD: (0, $cl2KK.default).getFlag(42),
    CREATE_GUILD_EXPRESSIONS: (0, $cl2KK.default).getFlag(43),
    CREATE_EVENTS: (0, $cl2KK.default).getFlag(44),
    USE_EXTERNAL_SOUNDS: (0, $cl2KK.default).getFlag(45),
    SEND_VOICE_MESSAGES: (0, $cl2KK.default).getFlag(46),
    SEND_POLLS: (0, $cl2KK.default).getFlag(49),
    USE_EXTERNAL_APPS: (0, $cl2KK.default).getFlag(50)
});
const $673cd345ce7def3a$export$6d0e4238fc52b7e2 = -1;
const $673cd345ce7def3a$export$e124ef0815aed2db = 250;

});
parcelRegister("cl2KK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $006ba5e033ab931f$export$2e2bcd8739ae039; });

var $hOcGE = parcelRequire("hOcGE");
/**
 * Context: Due to Discord supporting more than 32 permissions, permission calculation has become more complicated than naive
 * bit operations on `number`s. To support this generically, we have created BigFlagUtils to work with bit-flags greater
 * than 32-bits in size.
 *
 * Ideally, we would like to use BigInt, which is pretty efficient, but some JavaScript engines do not support it.
 *
 * This file is intended to be a set of lower-level operators that act directly on "BigFlags".
 *
 * If you're working with permissions, in most cases you can probably use PermissionUtils.
 */ const $006ba5e033ab931f$var$MAX_BIG_INT = 64;
const $006ba5e033ab931f$var$SMALL_INT = 16;
const $006ba5e033ab931f$var$PARTS = $006ba5e033ab931f$var$MAX_BIG_INT / $006ba5e033ab931f$var$SMALL_INT;
function $006ba5e033ab931f$var$checkBrowserSupportsBigInt() {
    try {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        BigInt;
        return true;
    } catch (_a) {
        return false;
    }
}
/**
 * Takes the sliced output of `toHexReverseArray` and converts hex to decimal.
 */ function $006ba5e033ab931f$var$fromHexReverseArray(hexValues, start, size) {
    let value = 0;
    for(let i = 0; i < size; i++){
        const byte = hexValues[start + i];
        if (byte === undefined) break;
        value += byte * 16 ** i;
    }
    return value;
}
/**
 * Converts a number string to array of hex bytes based on the implementation found at
 * https://stackoverflow.com/questions/18626844/convert-a-large-integer-to-a-hex-string-in-javascript
 *
 * To avoid extra allocations it returns the values in reverse.
 */ function $006ba5e033ab931f$var$toHexReverseArray(value) {
    const sum = [];
    for(let i = 0; i < value.length; i++){
        let s = Number(value[i]);
        for(let j = 0; s || j < sum.length; j++){
            s += (sum[j] || 0) * 10;
            sum[j] = s % 16;
            s = (s - sum[j]) / 16;
        }
    }
    return sum;
}
/**
 * Splits a big integers into array of small integers to perform fast bitwise operations.
 */ function $006ba5e033ab931f$var$splitBigInt(value) {
    const sum = $006ba5e033ab931f$var$toHexReverseArray(value);
    const parts = Array($006ba5e033ab931f$var$PARTS);
    for(let i = 0; i < $006ba5e033ab931f$var$PARTS; i++)// Highest bits to lowest bits.
    parts[$006ba5e033ab931f$var$PARTS - 1 - i] = $006ba5e033ab931f$var$fromHexReverseArray(sum, i * $006ba5e033ab931f$var$PARTS, $006ba5e033ab931f$var$PARTS);
    return parts;
}
class $006ba5e033ab931f$var$HighLow {
    static fromString(value) {
        return new $006ba5e033ab931f$var$HighLow($006ba5e033ab931f$var$splitBigInt(value), value);
    }
    static fromBit(index) {
        const parts = Array($006ba5e033ab931f$var$PARTS);
        const offset = Math.floor(index / $006ba5e033ab931f$var$SMALL_INT);
        for(let i = 0; i < $006ba5e033ab931f$var$PARTS; i++)// Highest bits to lowest bits.
        parts[$006ba5e033ab931f$var$PARTS - 1 - i] = i === offset ? 1 << index - offset * $006ba5e033ab931f$var$SMALL_INT : 0;
        return new $006ba5e033ab931f$var$HighLow(parts);
    }
    constructor(parts, str){
        this.parts = parts;
        this.str = str;
    }
    and({ parts: parts }) {
        return new $006ba5e033ab931f$var$HighLow(this.parts.map((v, i)=>v & parts[i]));
    }
    or({ parts: parts }) {
        return new $006ba5e033ab931f$var$HighLow(this.parts.map((v, i)=>v | parts[i]));
    }
    xor({ parts: parts }) {
        return new $006ba5e033ab931f$var$HighLow(this.parts.map((v, i)=>v ^ parts[i]));
    }
    not() {
        return new $006ba5e033ab931f$var$HighLow(this.parts.map((v)=>~v));
    }
    equals({ parts: parts }) {
        return this.parts.every((v, i)=>v === parts[i]);
    }
    /**
     * For the average case the string representation is provided, but
     * when we need to convert high and low to string we just let the
     * slower big-integer library do it.
     */ toString() {
        if (this.str != null) return this.str;
        const array = new Array($006ba5e033ab931f$var$MAX_BIG_INT / 4);
        this.parts.forEach((value, offset)=>{
            const hex = $006ba5e033ab931f$var$toHexReverseArray(value.toString());
            for(let i = 0; i < 4; i++)array[i + offset * 4] = hex[3 - i] || 0;
        });
        return this.str = (0, $hOcGE.default).fromArray(array, 16).toString();
    }
    toJSON() {
        return this.toString();
    }
}
const $006ba5e033ab931f$var$SUPPORTS_BIGINT = $006ba5e033ab931f$var$checkBrowserSupportsBigInt();
// Polyfill toJSON on BigInt if necessary.
if ($006ba5e033ab931f$var$SUPPORTS_BIGINT && BigInt.prototype.toJSON == null) BigInt.prototype.toJSON = function() {
    return this.toString();
};
const $006ba5e033ab931f$var$HIGH_LOW_CACHE = {};
const $006ba5e033ab931f$var$convertToBigFlag = $006ba5e033ab931f$var$SUPPORTS_BIGINT ? function convertToBigFlagBigInt(value) {
    return BigInt(value);
} : function convertToBigFlagHighLow(value) {
    if (value instanceof $006ba5e033ab931f$var$HighLow) return value;
    if (typeof value === 'number') value = value.toString();
    // These type assertions are ugly, but there doesn't seem to be a
    // runtime costless way to do a type assertion above.
    if ($006ba5e033ab931f$var$HIGH_LOW_CACHE[value] != null) return $006ba5e033ab931f$var$HIGH_LOW_CACHE[value];
    $006ba5e033ab931f$var$HIGH_LOW_CACHE[value] = $006ba5e033ab931f$var$HighLow.fromString(value);
    return $006ba5e033ab931f$var$HIGH_LOW_CACHE[value];
};
const $006ba5e033ab931f$var$EMPTY_FLAG = $006ba5e033ab931f$var$convertToBigFlag(0);
const $006ba5e033ab931f$var$flagAnd = $006ba5e033ab931f$var$SUPPORTS_BIGINT ? function flagAndBigInt(first = $006ba5e033ab931f$var$EMPTY_FLAG, second = $006ba5e033ab931f$var$EMPTY_FLAG) {
    return first & second;
} : function flagAndHighLow(first = $006ba5e033ab931f$var$EMPTY_FLAG, second = $006ba5e033ab931f$var$EMPTY_FLAG) {
    return first.and(second);
};
const $006ba5e033ab931f$var$flagOr = $006ba5e033ab931f$var$SUPPORTS_BIGINT ? function flagOrBigInt(first = $006ba5e033ab931f$var$EMPTY_FLAG, second = $006ba5e033ab931f$var$EMPTY_FLAG) {
    return first | second;
} : function flagOrHighLow(first = $006ba5e033ab931f$var$EMPTY_FLAG, second = $006ba5e033ab931f$var$EMPTY_FLAG) {
    return first.or(second);
};
const $006ba5e033ab931f$var$flagXor = $006ba5e033ab931f$var$SUPPORTS_BIGINT ? function flagXorBigInt(first = $006ba5e033ab931f$var$EMPTY_FLAG, second = $006ba5e033ab931f$var$EMPTY_FLAG) {
    return first ^ second;
} : function flagXorHighLow(first = $006ba5e033ab931f$var$EMPTY_FLAG, second = $006ba5e033ab931f$var$EMPTY_FLAG) {
    return first.xor(second);
};
const $006ba5e033ab931f$var$flagNot = $006ba5e033ab931f$var$SUPPORTS_BIGINT ? function flagNotBigInt(first = $006ba5e033ab931f$var$EMPTY_FLAG) {
    return ~first;
} : function flagNotHighLow(first = $006ba5e033ab931f$var$EMPTY_FLAG) {
    return first.not();
};
const $006ba5e033ab931f$var$flagEquals = $006ba5e033ab931f$var$SUPPORTS_BIGINT ? function flagEqualsBigInt(first, second) {
    return first === second;
} : function flagEqualsHighLow(first, second) {
    if (first == null || second == null) // eslint-disable-next-line eqeqeq
    return first == second;
    return first.equals(second);
};
function $006ba5e033ab931f$var$flagOrMultiple(...flags) {
    let result = flags[0];
    for(let i = 1; i < flags.length; i++)result = $006ba5e033ab931f$var$flagOr(result, flags[i]);
    return result;
}
function $006ba5e033ab931f$var$flagHas(base, flag) {
    return $006ba5e033ab931f$var$flagEquals($006ba5e033ab931f$var$flagAnd(base, flag), flag);
}
function $006ba5e033ab931f$var$flagHasAny(base, flag) {
    return !$006ba5e033ab931f$var$flagEquals($006ba5e033ab931f$var$flagAnd(base, flag), $006ba5e033ab931f$var$EMPTY_FLAG);
}
function $006ba5e033ab931f$var$flagAdd(base, flag) {
    return flag === $006ba5e033ab931f$var$EMPTY_FLAG ? base : $006ba5e033ab931f$var$flagOr(base, flag);
}
function $006ba5e033ab931f$var$flagRemove(base, flag) {
    return flag === $006ba5e033ab931f$var$EMPTY_FLAG ? base : $006ba5e033ab931f$var$flagXor(base, $006ba5e033ab931f$var$flagAnd(base, flag));
}
const $006ba5e033ab931f$var$getFlag = $006ba5e033ab931f$var$SUPPORTS_BIGINT ? function getFlagBigInt(index) {
    return BigInt(1) << BigInt(index);
} : function getFlagHighLow(index) {
    return $006ba5e033ab931f$var$HighLow.fromBit(index);
};
var $006ba5e033ab931f$export$2e2bcd8739ae039 = {
    combine: $006ba5e033ab931f$var$flagOrMultiple,
    add: $006ba5e033ab931f$var$flagAdd,
    remove: $006ba5e033ab931f$var$flagRemove,
    filter: $006ba5e033ab931f$var$flagAnd,
    invert: $006ba5e033ab931f$var$flagNot,
    has: $006ba5e033ab931f$var$flagHas,
    hasAny: $006ba5e033ab931f$var$flagHasAny,
    equals: $006ba5e033ab931f$var$flagEquals,
    deserialize: $006ba5e033ab931f$var$convertToBigFlag,
    getFlag: $006ba5e033ab931f$var$getFlag
};

});
parcelRegister("hOcGE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0d084ae4a881f55$export$2e2bcd8739ae039; });

var $4kOSS = parcelRequire("4kOSS");

var $dOvCL = parcelRequire("dOvCL");
var $e0d084ae4a881f55$var$BigIntegerExports = (0, $dOvCL.__require)();
var $e0d084ae4a881f55$export$2e2bcd8739ae039 = /*@__PURE__*/ (0, $4kOSS.getDefaultExportFromCjs)($e0d084ae4a881f55$var$BigIntegerExports);

});
parcelRegister("dOvCL", function(module, exports) {

$parcel$export(module.exports, "__require", function () { return $5fa5d9397aec0aa6$export$b88c30a9414655a0; });

var $7eavH = parcelRequire("7eavH");
var $5fa5d9397aec0aa6$var$hasRequiredBigInteger;
function $5fa5d9397aec0aa6$export$b88c30a9414655a0() {
    if ($5fa5d9397aec0aa6$var$hasRequiredBigInteger) return (0, $7eavH.__module).exports;
    $5fa5d9397aec0aa6$var$hasRequiredBigInteger = 1;
    (function(module) {
        var bigInt = function(undefined$1) {
            var BASE = 1e7, LOG_BASE = 7, MAX_INT = 9007199254740992, MAX_INT_ARR = smallToArray(MAX_INT), DEFAULT_ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz";
            var supportsNativeBigInt = typeof BigInt === "function";
            function Integer(v, radix, alphabet, caseSensitive) {
                if (typeof v === "undefined") return Integer[0];
                if (typeof radix !== "undefined") return +radix === 10 && !alphabet ? parseValue(v) : parseBase(v, radix, alphabet, caseSensitive);
                return parseValue(v);
            }
            function BigInteger(value, sign) {
                this.value = value;
                this.sign = sign;
                this.isSmall = false;
            }
            BigInteger.prototype = Object.create(Integer.prototype);
            function SmallInteger(value) {
                this.value = value;
                this.sign = value < 0;
                this.isSmall = true;
            }
            SmallInteger.prototype = Object.create(Integer.prototype);
            function NativeBigInt(value) {
                this.value = value;
            }
            NativeBigInt.prototype = Object.create(Integer.prototype);
            function isPrecise(n) {
                return -MAX_INT < n && n < MAX_INT;
            }
            function smallToArray(n) {
                if (n < 1e7) return [
                    n
                ];
                if (n < 1e14) return [
                    n % 1e7,
                    Math.floor(n / 1e7)
                ];
                return [
                    n % 1e7,
                    Math.floor(n / 1e7) % 1e7,
                    Math.floor(n / 1e14)
                ];
            }
            function arrayToSmall(arr) {
                trim(arr);
                var length = arr.length;
                if (length < 4 && compareAbs(arr, MAX_INT_ARR) < 0) switch(length){
                    case 0:
                        return 0;
                    case 1:
                        return arr[0];
                    case 2:
                        return arr[0] + arr[1] * BASE;
                    default:
                        return arr[0] + (arr[1] + arr[2] * BASE) * BASE;
                }
                return arr;
            }
            function trim(v) {
                var i = v.length;
                while(v[--i] === 0);
                v.length = i + 1;
            }
            function createArray(length) {
                var x = new Array(length);
                var i = -1;
                while(++i < length)x[i] = 0;
                return x;
            }
            function truncate(n) {
                if (n > 0) return Math.floor(n);
                return Math.ceil(n);
            }
            function add(a, b) {
                var l_a = a.length, l_b = b.length, r = new Array(l_a), carry = 0, base = BASE, sum, i;
                for(i = 0; i < l_b; i++){
                    sum = a[i] + b[i] + carry;
                    carry = sum >= base ? 1 : 0;
                    r[i] = sum - carry * base;
                }
                while(i < l_a){
                    sum = a[i] + carry;
                    carry = sum === base ? 1 : 0;
                    r[i++] = sum - carry * base;
                }
                if (carry > 0) r.push(carry);
                return r;
            }
            function addAny(a, b) {
                if (a.length >= b.length) return add(a, b);
                return add(b, a);
            }
            function addSmall(a, carry) {
                var l = a.length, r = new Array(l), base = BASE, sum, i;
                for(i = 0; i < l; i++){
                    sum = a[i] - base + carry;
                    carry = Math.floor(sum / base);
                    r[i] = sum - carry * base;
                    carry += 1;
                }
                while(carry > 0){
                    r[i++] = carry % base;
                    carry = Math.floor(carry / base);
                }
                return r;
            }
            BigInteger.prototype.add = function(v) {
                var n = parseValue(v);
                if (this.sign !== n.sign) return this.subtract(n.negate());
                var a = this.value, b = n.value;
                if (n.isSmall) return new BigInteger(addSmall(a, Math.abs(b)), this.sign);
                return new BigInteger(addAny(a, b), this.sign);
            };
            BigInteger.prototype.plus = BigInteger.prototype.add;
            SmallInteger.prototype.add = function(v) {
                var n = parseValue(v);
                var a = this.value;
                if (a < 0 !== n.sign) return this.subtract(n.negate());
                var b = n.value;
                if (n.isSmall) {
                    if (isPrecise(a + b)) return new SmallInteger(a + b);
                    b = smallToArray(Math.abs(b));
                }
                return new BigInteger(addSmall(b, Math.abs(a)), a < 0);
            };
            SmallInteger.prototype.plus = SmallInteger.prototype.add;
            NativeBigInt.prototype.add = function(v) {
                return new NativeBigInt(this.value + parseValue(v).value);
            };
            NativeBigInt.prototype.plus = NativeBigInt.prototype.add;
            function subtract(a, b) {
                var a_l = a.length, b_l = b.length, r = new Array(a_l), borrow = 0, base = BASE, i, difference;
                for(i = 0; i < b_l; i++){
                    difference = a[i] - borrow - b[i];
                    if (difference < 0) {
                        difference += base;
                        borrow = 1;
                    } else borrow = 0;
                    r[i] = difference;
                }
                for(i = b_l; i < a_l; i++){
                    difference = a[i] - borrow;
                    if (difference < 0) difference += base;
                    else {
                        r[i++] = difference;
                        break;
                    }
                    r[i] = difference;
                }
                for(; i < a_l; i++)r[i] = a[i];
                trim(r);
                return r;
            }
            function subtractAny(a, b, sign) {
                var value;
                if (compareAbs(a, b) >= 0) value = subtract(a, b);
                else {
                    value = subtract(b, a);
                    sign = !sign;
                }
                value = arrayToSmall(value);
                if (typeof value === "number") {
                    if (sign) value = -value;
                    return new SmallInteger(value);
                }
                return new BigInteger(value, sign);
            }
            function subtractSmall(a, b, sign) {
                var l = a.length, r = new Array(l), carry = -b, base = BASE, i, difference;
                for(i = 0; i < l; i++){
                    difference = a[i] + carry;
                    carry = Math.floor(difference / base);
                    difference %= base;
                    r[i] = difference < 0 ? difference + base : difference;
                }
                r = arrayToSmall(r);
                if (typeof r === "number") {
                    if (sign) r = -r;
                    return new SmallInteger(r);
                }
                return new BigInteger(r, sign);
            }
            BigInteger.prototype.subtract = function(v) {
                var n = parseValue(v);
                if (this.sign !== n.sign) return this.add(n.negate());
                var a = this.value, b = n.value;
                if (n.isSmall) return subtractSmall(a, Math.abs(b), this.sign);
                return subtractAny(a, b, this.sign);
            };
            BigInteger.prototype.minus = BigInteger.prototype.subtract;
            SmallInteger.prototype.subtract = function(v) {
                var n = parseValue(v);
                var a = this.value;
                if (a < 0 !== n.sign) return this.add(n.negate());
                var b = n.value;
                if (n.isSmall) return new SmallInteger(a - b);
                return subtractSmall(b, Math.abs(a), a >= 0);
            };
            SmallInteger.prototype.minus = SmallInteger.prototype.subtract;
            NativeBigInt.prototype.subtract = function(v) {
                return new NativeBigInt(this.value - parseValue(v).value);
            };
            NativeBigInt.prototype.minus = NativeBigInt.prototype.subtract;
            BigInteger.prototype.negate = function() {
                return new BigInteger(this.value, !this.sign);
            };
            SmallInteger.prototype.negate = function() {
                var sign = this.sign;
                var small = new SmallInteger(-this.value);
                small.sign = !sign;
                return small;
            };
            NativeBigInt.prototype.negate = function() {
                return new NativeBigInt(-this.value);
            };
            BigInteger.prototype.abs = function() {
                return new BigInteger(this.value, false);
            };
            SmallInteger.prototype.abs = function() {
                return new SmallInteger(Math.abs(this.value));
            };
            NativeBigInt.prototype.abs = function() {
                return new NativeBigInt(this.value >= 0 ? this.value : -this.value);
            };
            function multiplyLong(a, b) {
                var a_l = a.length, b_l = b.length, l = a_l + b_l, r = createArray(l), base = BASE, product, carry, i, a_i, b_j;
                for(i = 0; i < a_l; ++i){
                    a_i = a[i];
                    for(var j = 0; j < b_l; ++j){
                        b_j = b[j];
                        product = a_i * b_j + r[i + j];
                        carry = Math.floor(product / base);
                        r[i + j] = product - carry * base;
                        r[i + j + 1] += carry;
                    }
                }
                trim(r);
                return r;
            }
            function multiplySmall(a, b) {
                var l = a.length, r = new Array(l), base = BASE, carry = 0, product, i;
                for(i = 0; i < l; i++){
                    product = a[i] * b + carry;
                    carry = Math.floor(product / base);
                    r[i] = product - carry * base;
                }
                while(carry > 0){
                    r[i++] = carry % base;
                    carry = Math.floor(carry / base);
                }
                return r;
            }
            function shiftLeft(x, n) {
                var r = [];
                while(n-- > 0)r.push(0);
                return r.concat(x);
            }
            function multiplyKaratsuba(x, y) {
                var n = Math.max(x.length, y.length);
                if (n <= 30) return multiplyLong(x, y);
                n = Math.ceil(n / 2);
                var b = x.slice(n), a = x.slice(0, n), d = y.slice(n), c = y.slice(0, n);
                var ac = multiplyKaratsuba(a, c), bd = multiplyKaratsuba(b, d), abcd = multiplyKaratsuba(addAny(a, b), addAny(c, d));
                var product = addAny(addAny(ac, shiftLeft(subtract(subtract(abcd, ac), bd), n)), shiftLeft(bd, 2 * n));
                trim(product);
                return product;
            }
            // The following function is derived from a surface fit of a graph plotting the performance difference
            // between long multiplication and karatsuba multiplication versus the lengths of the two arrays.
            function useKaratsuba(l1, l2) {
                return -0.012 * l1 - 0.012 * l2 + 0.000015 * l1 * l2 > 0;
            }
            BigInteger.prototype.multiply = function(v) {
                var n = parseValue(v), a = this.value, b = n.value, sign = this.sign !== n.sign, abs;
                if (n.isSmall) {
                    if (b === 0) return Integer[0];
                    if (b === 1) return this;
                    if (b === -1) return this.negate();
                    abs = Math.abs(b);
                    if (abs < BASE) return new BigInteger(multiplySmall(a, abs), sign);
                    b = smallToArray(abs);
                }
                if (useKaratsuba(a.length, b.length)) return new BigInteger(multiplyKaratsuba(a, b), sign);
                return new BigInteger(multiplyLong(a, b), sign);
            };
            BigInteger.prototype.times = BigInteger.prototype.multiply;
            function multiplySmallAndArray(a, b, sign) {
                if (a < BASE) return new BigInteger(multiplySmall(b, a), sign);
                return new BigInteger(multiplyLong(b, smallToArray(a)), sign);
            }
            SmallInteger.prototype._multiplyBySmall = function(a) {
                if (isPrecise(a.value * this.value)) return new SmallInteger(a.value * this.value);
                return multiplySmallAndArray(Math.abs(a.value), smallToArray(Math.abs(this.value)), this.sign !== a.sign);
            };
            BigInteger.prototype._multiplyBySmall = function(a) {
                if (a.value === 0) return Integer[0];
                if (a.value === 1) return this;
                if (a.value === -1) return this.negate();
                return multiplySmallAndArray(Math.abs(a.value), this.value, this.sign !== a.sign);
            };
            SmallInteger.prototype.multiply = function(v) {
                return parseValue(v)._multiplyBySmall(this);
            };
            SmallInteger.prototype.times = SmallInteger.prototype.multiply;
            NativeBigInt.prototype.multiply = function(v) {
                return new NativeBigInt(this.value * parseValue(v).value);
            };
            NativeBigInt.prototype.times = NativeBigInt.prototype.multiply;
            function square(a) {
                //console.assert(2 * BASE * BASE < MAX_INT);
                var l = a.length, r = createArray(l + l), base = BASE, product, carry, i, a_i, a_j;
                for(i = 0; i < l; i++){
                    a_i = a[i];
                    carry = 0 - a_i * a_i;
                    for(var j = i; j < l; j++){
                        a_j = a[j];
                        product = 2 * (a_i * a_j) + r[i + j] + carry;
                        carry = Math.floor(product / base);
                        r[i + j] = product - carry * base;
                    }
                    r[i + l] = carry;
                }
                trim(r);
                return r;
            }
            BigInteger.prototype.square = function() {
                return new BigInteger(square(this.value), false);
            };
            SmallInteger.prototype.square = function() {
                var value = this.value * this.value;
                if (isPrecise(value)) return new SmallInteger(value);
                return new BigInteger(square(smallToArray(Math.abs(this.value))), false);
            };
            NativeBigInt.prototype.square = function(v) {
                return new NativeBigInt(this.value * this.value);
            };
            function divMod1(a, b) {
                var a_l = a.length, b_l = b.length, base = BASE, result = createArray(b.length), divisorMostSignificantDigit = b[b_l - 1], // normalization
                lambda = Math.ceil(base / (2 * divisorMostSignificantDigit)), remainder = multiplySmall(a, lambda), divisor = multiplySmall(b, lambda), quotientDigit, shift, carry, borrow, i, l, q;
                if (remainder.length <= a_l) remainder.push(0);
                divisor.push(0);
                divisorMostSignificantDigit = divisor[b_l - 1];
                for(shift = a_l - b_l; shift >= 0; shift--){
                    quotientDigit = base - 1;
                    if (remainder[shift + b_l] !== divisorMostSignificantDigit) quotientDigit = Math.floor((remainder[shift + b_l] * base + remainder[shift + b_l - 1]) / divisorMostSignificantDigit);
                    // quotientDigit <= base - 1
                    carry = 0;
                    borrow = 0;
                    l = divisor.length;
                    for(i = 0; i < l; i++){
                        carry += quotientDigit * divisor[i];
                        q = Math.floor(carry / base);
                        borrow += remainder[shift + i] - (carry - q * base);
                        carry = q;
                        if (borrow < 0) {
                            remainder[shift + i] = borrow + base;
                            borrow = -1;
                        } else {
                            remainder[shift + i] = borrow;
                            borrow = 0;
                        }
                    }
                    while(borrow !== 0){
                        quotientDigit -= 1;
                        carry = 0;
                        for(i = 0; i < l; i++){
                            carry += remainder[shift + i] - base + divisor[i];
                            if (carry < 0) {
                                remainder[shift + i] = carry + base;
                                carry = 0;
                            } else {
                                remainder[shift + i] = carry;
                                carry = 1;
                            }
                        }
                        borrow += carry;
                    }
                    result[shift] = quotientDigit;
                }
                // denormalization
                remainder = divModSmall(remainder, lambda)[0];
                return [
                    arrayToSmall(result),
                    arrayToSmall(remainder)
                ];
            }
            function divMod2(a, b) {
                // Performs faster than divMod1 on larger input sizes.
                var a_l = a.length, b_l = b.length, result = [], part = [], base = BASE, guess, xlen, highx, highy, check;
                while(a_l){
                    part.unshift(a[--a_l]);
                    trim(part);
                    if (compareAbs(part, b) < 0) {
                        result.push(0);
                        continue;
                    }
                    xlen = part.length;
                    highx = part[xlen - 1] * base + part[xlen - 2];
                    highy = b[b_l - 1] * base + b[b_l - 2];
                    if (xlen > b_l) highx = (highx + 1) * base;
                    guess = Math.ceil(highx / highy);
                    do {
                        check = multiplySmall(b, guess);
                        if (compareAbs(check, part) <= 0) break;
                        guess--;
                    }while (guess);
                    result.push(guess);
                    part = subtract(part, check);
                }
                result.reverse();
                return [
                    arrayToSmall(result),
                    arrayToSmall(part)
                ];
            }
            function divModSmall(value, lambda) {
                var length = value.length, quotient = createArray(length), base = BASE, i, q, remainder, divisor;
                remainder = 0;
                for(i = length - 1; i >= 0; --i){
                    divisor = remainder * base + value[i];
                    q = truncate(divisor / lambda);
                    remainder = divisor - q * lambda;
                    quotient[i] = q | 0;
                }
                return [
                    quotient,
                    remainder | 0
                ];
            }
            function divModAny(self, v) {
                var value, n = parseValue(v);
                if (supportsNativeBigInt) return [
                    new NativeBigInt(self.value / n.value),
                    new NativeBigInt(self.value % n.value)
                ];
                var a = self.value, b = n.value;
                var quotient;
                if (b === 0) throw new Error("Cannot divide by zero");
                if (self.isSmall) {
                    if (n.isSmall) return [
                        new SmallInteger(truncate(a / b)),
                        new SmallInteger(a % b)
                    ];
                    return [
                        Integer[0],
                        self
                    ];
                }
                if (n.isSmall) {
                    if (b === 1) return [
                        self,
                        Integer[0]
                    ];
                    if (b == -1) return [
                        self.negate(),
                        Integer[0]
                    ];
                    var abs = Math.abs(b);
                    if (abs < BASE) {
                        value = divModSmall(a, abs);
                        quotient = arrayToSmall(value[0]);
                        var remainder = value[1];
                        if (self.sign) remainder = -remainder;
                        if (typeof quotient === "number") {
                            if (self.sign !== n.sign) quotient = -quotient;
                            return [
                                new SmallInteger(quotient),
                                new SmallInteger(remainder)
                            ];
                        }
                        return [
                            new BigInteger(quotient, self.sign !== n.sign),
                            new SmallInteger(remainder)
                        ];
                    }
                    b = smallToArray(abs);
                }
                var comparison = compareAbs(a, b);
                if (comparison === -1) return [
                    Integer[0],
                    self
                ];
                if (comparison === 0) return [
                    Integer[self.sign === n.sign ? 1 : -1],
                    Integer[0]
                ];
                // divMod1 is faster on smaller input sizes
                if (a.length + b.length <= 200) value = divMod1(a, b);
                else value = divMod2(a, b);
                quotient = value[0];
                var qSign = self.sign !== n.sign, mod = value[1], mSign = self.sign;
                if (typeof quotient === "number") {
                    if (qSign) quotient = -quotient;
                    quotient = new SmallInteger(quotient);
                } else quotient = new BigInteger(quotient, qSign);
                if (typeof mod === "number") {
                    if (mSign) mod = -mod;
                    mod = new SmallInteger(mod);
                } else mod = new BigInteger(mod, mSign);
                return [
                    quotient,
                    mod
                ];
            }
            BigInteger.prototype.divmod = function(v) {
                var result = divModAny(this, v);
                return {
                    quotient: result[0],
                    remainder: result[1]
                };
            };
            NativeBigInt.prototype.divmod = SmallInteger.prototype.divmod = BigInteger.prototype.divmod;
            BigInteger.prototype.divide = function(v) {
                return divModAny(this, v)[0];
            };
            NativeBigInt.prototype.over = NativeBigInt.prototype.divide = function(v) {
                return new NativeBigInt(this.value / parseValue(v).value);
            };
            SmallInteger.prototype.over = SmallInteger.prototype.divide = BigInteger.prototype.over = BigInteger.prototype.divide;
            BigInteger.prototype.mod = function(v) {
                return divModAny(this, v)[1];
            };
            NativeBigInt.prototype.mod = NativeBigInt.prototype.remainder = function(v) {
                return new NativeBigInt(this.value % parseValue(v).value);
            };
            SmallInteger.prototype.remainder = SmallInteger.prototype.mod = BigInteger.prototype.remainder = BigInteger.prototype.mod;
            BigInteger.prototype.pow = function(v) {
                var n = parseValue(v), a = this.value, b = n.value, value, x, y;
                if (b === 0) return Integer[1];
                if (a === 0) return Integer[0];
                if (a === 1) return Integer[1];
                if (a === -1) return n.isEven() ? Integer[1] : Integer[-1];
                if (n.sign) return Integer[0];
                if (!n.isSmall) throw new Error("The exponent " + n.toString() + " is too large.");
                if (this.isSmall) {
                    if (isPrecise(value = Math.pow(a, b))) return new SmallInteger(truncate(value));
                }
                x = this;
                y = Integer[1];
                while(true){
                    if (b & true) {
                        y = y.times(x);
                        --b;
                    }
                    if (b === 0) break;
                    b /= 2;
                    x = x.square();
                }
                return y;
            };
            SmallInteger.prototype.pow = BigInteger.prototype.pow;
            NativeBigInt.prototype.pow = function(v) {
                var n = parseValue(v);
                var a = this.value, b = n.value;
                var _0 = BigInt(0), _1 = BigInt(1), _2 = BigInt(2);
                if (b === _0) return Integer[1];
                if (a === _0) return Integer[0];
                if (a === _1) return Integer[1];
                if (a === BigInt(-1)) return n.isEven() ? Integer[1] : Integer[-1];
                if (n.isNegative()) return new NativeBigInt(_0);
                var x = this;
                var y = Integer[1];
                while(true){
                    if ((b & _1) === _1) {
                        y = y.times(x);
                        --b;
                    }
                    if (b === _0) break;
                    b /= _2;
                    x = x.square();
                }
                return y;
            };
            BigInteger.prototype.modPow = function(exp, mod) {
                exp = parseValue(exp);
                mod = parseValue(mod);
                if (mod.isZero()) throw new Error("Cannot take modPow with modulus 0");
                var r = Integer[1], base = this.mod(mod);
                if (exp.isNegative()) {
                    exp = exp.multiply(Integer[-1]);
                    base = base.modInv(mod);
                }
                while(exp.isPositive()){
                    if (base.isZero()) return Integer[0];
                    if (exp.isOdd()) r = r.multiply(base).mod(mod);
                    exp = exp.divide(2);
                    base = base.square().mod(mod);
                }
                return r;
            };
            NativeBigInt.prototype.modPow = SmallInteger.prototype.modPow = BigInteger.prototype.modPow;
            function compareAbs(a, b) {
                if (a.length !== b.length) return a.length > b.length ? 1 : -1;
                for(var i = a.length - 1; i >= 0; i--){
                    if (a[i] !== b[i]) return a[i] > b[i] ? 1 : -1;
                }
                return 0;
            }
            BigInteger.prototype.compareAbs = function(v) {
                var n = parseValue(v), a = this.value, b = n.value;
                if (n.isSmall) return 1;
                return compareAbs(a, b);
            };
            SmallInteger.prototype.compareAbs = function(v) {
                var n = parseValue(v), a = Math.abs(this.value), b = n.value;
                if (n.isSmall) {
                    b = Math.abs(b);
                    return a === b ? 0 : a > b ? 1 : -1;
                }
                return -1;
            };
            NativeBigInt.prototype.compareAbs = function(v) {
                var a = this.value;
                var b = parseValue(v).value;
                a = a >= 0 ? a : -a;
                b = b >= 0 ? b : -b;
                return a === b ? 0 : a > b ? 1 : -1;
            };
            BigInteger.prototype.compare = function(v) {
                // See discussion about comparison with Infinity:
                // https://github.com/peterolson/BigInteger.js/issues/61
                if (v === Infinity) return -1;
                if (v === -Infinity) return 1;
                var n = parseValue(v), a = this.value, b = n.value;
                if (this.sign !== n.sign) return n.sign ? 1 : -1;
                if (n.isSmall) return this.sign ? -1 : 1;
                return compareAbs(a, b) * (this.sign ? -1 : 1);
            };
            BigInteger.prototype.compareTo = BigInteger.prototype.compare;
            SmallInteger.prototype.compare = function(v) {
                if (v === Infinity) return -1;
                if (v === -Infinity) return 1;
                var n = parseValue(v), a = this.value, b = n.value;
                if (n.isSmall) return a == b ? 0 : a > b ? 1 : -1;
                if (a < 0 !== n.sign) return a < 0 ? -1 : 1;
                return a < 0 ? 1 : -1;
            };
            SmallInteger.prototype.compareTo = SmallInteger.prototype.compare;
            NativeBigInt.prototype.compare = function(v) {
                if (v === Infinity) return -1;
                if (v === -Infinity) return 1;
                var a = this.value;
                var b = parseValue(v).value;
                return a === b ? 0 : a > b ? 1 : -1;
            };
            NativeBigInt.prototype.compareTo = NativeBigInt.prototype.compare;
            BigInteger.prototype.equals = function(v) {
                return this.compare(v) === 0;
            };
            NativeBigInt.prototype.eq = NativeBigInt.prototype.equals = SmallInteger.prototype.eq = SmallInteger.prototype.equals = BigInteger.prototype.eq = BigInteger.prototype.equals;
            BigInteger.prototype.notEquals = function(v) {
                return this.compare(v) !== 0;
            };
            NativeBigInt.prototype.neq = NativeBigInt.prototype.notEquals = SmallInteger.prototype.neq = SmallInteger.prototype.notEquals = BigInteger.prototype.neq = BigInteger.prototype.notEquals;
            BigInteger.prototype.greater = function(v) {
                return this.compare(v) > 0;
            };
            NativeBigInt.prototype.gt = NativeBigInt.prototype.greater = SmallInteger.prototype.gt = SmallInteger.prototype.greater = BigInteger.prototype.gt = BigInteger.prototype.greater;
            BigInteger.prototype.lesser = function(v) {
                return this.compare(v) < 0;
            };
            NativeBigInt.prototype.lt = NativeBigInt.prototype.lesser = SmallInteger.prototype.lt = SmallInteger.prototype.lesser = BigInteger.prototype.lt = BigInteger.prototype.lesser;
            BigInteger.prototype.greaterOrEquals = function(v) {
                return this.compare(v) >= 0;
            };
            NativeBigInt.prototype.geq = NativeBigInt.prototype.greaterOrEquals = SmallInteger.prototype.geq = SmallInteger.prototype.greaterOrEquals = BigInteger.prototype.geq = BigInteger.prototype.greaterOrEquals;
            BigInteger.prototype.lesserOrEquals = function(v) {
                return this.compare(v) <= 0;
            };
            NativeBigInt.prototype.leq = NativeBigInt.prototype.lesserOrEquals = SmallInteger.prototype.leq = SmallInteger.prototype.lesserOrEquals = BigInteger.prototype.leq = BigInteger.prototype.lesserOrEquals;
            BigInteger.prototype.isEven = function() {
                return (this.value[0] & 1) === 0;
            };
            SmallInteger.prototype.isEven = function() {
                return (this.value & 1) === 0;
            };
            NativeBigInt.prototype.isEven = function() {
                return (this.value & BigInt(1)) === BigInt(0);
            };
            BigInteger.prototype.isOdd = function() {
                return (this.value[0] & 1) === 1;
            };
            SmallInteger.prototype.isOdd = function() {
                return (this.value & 1) === 1;
            };
            NativeBigInt.prototype.isOdd = function() {
                return (this.value & BigInt(1)) === BigInt(1);
            };
            BigInteger.prototype.isPositive = function() {
                return !this.sign;
            };
            SmallInteger.prototype.isPositive = function() {
                return this.value > 0;
            };
            NativeBigInt.prototype.isPositive = SmallInteger.prototype.isPositive;
            BigInteger.prototype.isNegative = function() {
                return this.sign;
            };
            SmallInteger.prototype.isNegative = function() {
                return this.value < 0;
            };
            NativeBigInt.prototype.isNegative = SmallInteger.prototype.isNegative;
            BigInteger.prototype.isUnit = function() {
                return false;
            };
            SmallInteger.prototype.isUnit = function() {
                return Math.abs(this.value) === 1;
            };
            NativeBigInt.prototype.isUnit = function() {
                return this.abs().value === BigInt(1);
            };
            BigInteger.prototype.isZero = function() {
                return false;
            };
            SmallInteger.prototype.isZero = function() {
                return this.value === 0;
            };
            NativeBigInt.prototype.isZero = function() {
                return this.value === BigInt(0);
            };
            BigInteger.prototype.isDivisibleBy = function(v) {
                var n = parseValue(v);
                if (n.isZero()) return false;
                if (n.isUnit()) return true;
                if (n.compareAbs(2) === 0) return this.isEven();
                return this.mod(n).isZero();
            };
            NativeBigInt.prototype.isDivisibleBy = SmallInteger.prototype.isDivisibleBy = BigInteger.prototype.isDivisibleBy;
            function isBasicPrime(v) {
                var n = v.abs();
                if (n.isUnit()) return false;
                if (n.equals(2) || n.equals(3) || n.equals(5)) return true;
                if (n.isEven() || n.isDivisibleBy(3) || n.isDivisibleBy(5)) return false;
                if (n.lesser(49)) return true;
            // we don't know if it's prime: let the other functions figure it out
            }
            function millerRabinTest(n, a) {
                var nPrev = n.prev(), b = nPrev, r = 0, d, i, x;
                while(b.isEven())b = b.divide(2), r++;
                next: for(i = 0; i < a.length; i++){
                    if (n.lesser(a[i])) continue;
                    x = bigInt(a[i]).modPow(b, n);
                    if (x.isUnit() || x.equals(nPrev)) continue;
                    for(d = r - 1; d != 0; d--){
                        x = x.square().mod(n);
                        if (x.isUnit()) return false;
                        if (x.equals(nPrev)) continue next;
                    }
                    return false;
                }
                return true;
            }
            // Set "strict" to true to force GRH-supported lower bound of 2*log(N)^2
            BigInteger.prototype.isPrime = function(strict) {
                var isPrime = isBasicPrime(this);
                if (isPrime !== undefined$1) return isPrime;
                var n = this.abs();
                var bits = n.bitLength();
                if (bits <= 64) return millerRabinTest(n, [
                    2,
                    3,
                    5,
                    7,
                    11,
                    13,
                    17,
                    19,
                    23,
                    29,
                    31,
                    37
                ]);
                var logN = Math.log(2) * bits.toJSNumber();
                var t = Math.ceil(strict === true ? 2 * Math.pow(logN, 2) : logN);
                for(var a = [], i = 0; i < t; i++)a.push(bigInt(i + 2));
                return millerRabinTest(n, a);
            };
            NativeBigInt.prototype.isPrime = SmallInteger.prototype.isPrime = BigInteger.prototype.isPrime;
            BigInteger.prototype.isProbablePrime = function(iterations, rng) {
                var isPrime = isBasicPrime(this);
                if (isPrime !== undefined$1) return isPrime;
                var n = this.abs();
                var t = iterations === undefined$1 ? 5 : iterations;
                for(var a = [], i = 0; i < t; i++)a.push(bigInt.randBetween(2, n.minus(2), rng));
                return millerRabinTest(n, a);
            };
            NativeBigInt.prototype.isProbablePrime = SmallInteger.prototype.isProbablePrime = BigInteger.prototype.isProbablePrime;
            BigInteger.prototype.modInv = function(n) {
                var t = bigInt.zero, newT = bigInt.one, r = parseValue(n), newR = this.abs(), q, lastT, lastR;
                while(!newR.isZero()){
                    q = r.divide(newR);
                    lastT = t;
                    lastR = r;
                    t = newT;
                    r = newR;
                    newT = lastT.subtract(q.multiply(newT));
                    newR = lastR.subtract(q.multiply(newR));
                }
                if (!r.isUnit()) throw new Error(this.toString() + " and " + n.toString() + " are not co-prime");
                if (t.compare(0) === -1) t = t.add(n);
                if (this.isNegative()) return t.negate();
                return t;
            };
            NativeBigInt.prototype.modInv = SmallInteger.prototype.modInv = BigInteger.prototype.modInv;
            BigInteger.prototype.next = function() {
                var value = this.value;
                if (this.sign) return subtractSmall(value, 1, this.sign);
                return new BigInteger(addSmall(value, 1), this.sign);
            };
            SmallInteger.prototype.next = function() {
                var value = this.value;
                if (value + 1 < MAX_INT) return new SmallInteger(value + 1);
                return new BigInteger(MAX_INT_ARR, false);
            };
            NativeBigInt.prototype.next = function() {
                return new NativeBigInt(this.value + BigInt(1));
            };
            BigInteger.prototype.prev = function() {
                var value = this.value;
                if (this.sign) return new BigInteger(addSmall(value, 1), true);
                return subtractSmall(value, 1, this.sign);
            };
            SmallInteger.prototype.prev = function() {
                var value = this.value;
                if (value - 1 > -MAX_INT) return new SmallInteger(value - 1);
                return new BigInteger(MAX_INT_ARR, true);
            };
            NativeBigInt.prototype.prev = function() {
                return new NativeBigInt(this.value - BigInt(1));
            };
            var powersOfTwo = [
                1
            ];
            while(2 * powersOfTwo[powersOfTwo.length - 1] <= BASE)powersOfTwo.push(2 * powersOfTwo[powersOfTwo.length - 1]);
            var powers2Length = powersOfTwo.length, highestPower2 = powersOfTwo[powers2Length - 1];
            function shift_isSmall(n) {
                return Math.abs(n) <= BASE;
            }
            BigInteger.prototype.shiftLeft = function(v) {
                var n = parseValue(v).toJSNumber();
                if (!shift_isSmall(n)) throw new Error(String(n) + " is too large for shifting.");
                if (n < 0) return this.shiftRight(-n);
                var result = this;
                if (result.isZero()) return result;
                while(n >= powers2Length){
                    result = result.multiply(highestPower2);
                    n -= powers2Length - 1;
                }
                return result.multiply(powersOfTwo[n]);
            };
            NativeBigInt.prototype.shiftLeft = SmallInteger.prototype.shiftLeft = BigInteger.prototype.shiftLeft;
            BigInteger.prototype.shiftRight = function(v) {
                var remQuo;
                var n = parseValue(v).toJSNumber();
                if (!shift_isSmall(n)) throw new Error(String(n) + " is too large for shifting.");
                if (n < 0) return this.shiftLeft(-n);
                var result = this;
                while(n >= powers2Length){
                    if (result.isZero() || result.isNegative() && result.isUnit()) return result;
                    remQuo = divModAny(result, highestPower2);
                    result = remQuo[1].isNegative() ? remQuo[0].prev() : remQuo[0];
                    n -= powers2Length - 1;
                }
                remQuo = divModAny(result, powersOfTwo[n]);
                return remQuo[1].isNegative() ? remQuo[0].prev() : remQuo[0];
            };
            NativeBigInt.prototype.shiftRight = SmallInteger.prototype.shiftRight = BigInteger.prototype.shiftRight;
            function bitwise(x, y, fn) {
                y = parseValue(y);
                var xSign = x.isNegative(), ySign = y.isNegative();
                var xRem = xSign ? x.not() : x, yRem = ySign ? y.not() : y;
                var xDigit = 0, yDigit = 0;
                var xDivMod = null, yDivMod = null;
                var result = [];
                while(!xRem.isZero() || !yRem.isZero()){
                    xDivMod = divModAny(xRem, highestPower2);
                    xDigit = xDivMod[1].toJSNumber();
                    if (xSign) xDigit = highestPower2 - 1 - xDigit; // two's complement for negative numbers
                    yDivMod = divModAny(yRem, highestPower2);
                    yDigit = yDivMod[1].toJSNumber();
                    if (ySign) yDigit = highestPower2 - 1 - yDigit; // two's complement for negative numbers
                    xRem = xDivMod[0];
                    yRem = yDivMod[0];
                    result.push(fn(xDigit, yDigit));
                }
                var sum = fn(xSign ? 1 : 0, ySign ? 1 : 0) !== 0 ? bigInt(-1) : bigInt(0);
                for(var i = result.length - 1; i >= 0; i -= 1)sum = sum.multiply(highestPower2).add(bigInt(result[i]));
                return sum;
            }
            BigInteger.prototype.not = function() {
                return this.negate().prev();
            };
            NativeBigInt.prototype.not = SmallInteger.prototype.not = BigInteger.prototype.not;
            BigInteger.prototype.and = function(n) {
                return bitwise(this, n, function(a, b) {
                    return a & b;
                });
            };
            NativeBigInt.prototype.and = SmallInteger.prototype.and = BigInteger.prototype.and;
            BigInteger.prototype.or = function(n) {
                return bitwise(this, n, function(a, b) {
                    return a | b;
                });
            };
            NativeBigInt.prototype.or = SmallInteger.prototype.or = BigInteger.prototype.or;
            BigInteger.prototype.xor = function(n) {
                return bitwise(this, n, function(a, b) {
                    return a ^ b;
                });
            };
            NativeBigInt.prototype.xor = SmallInteger.prototype.xor = BigInteger.prototype.xor;
            var LOBMASK_I = 1073741824, LOBMASK_BI = (BASE & -BASE) * (BASE & -BASE) | LOBMASK_I;
            function roughLOB(n) {
                // SmallInteger: return Min(lowestOneBit(n), 1 << 30)
                // BigInteger: return Min(lowestOneBit(n), 1 << 14) [BASE=1e7]
                var v = n.value, x = typeof v === "number" ? v | LOBMASK_I : typeof v === "bigint" ? v | BigInt(LOBMASK_I) : v[0] + v[1] * BASE | LOBMASK_BI;
                return x & -x;
            }
            function integerLogarithm(value, base) {
                if (base.compareTo(value) <= 0) {
                    var tmp = integerLogarithm(value, base.square(base));
                    var p = tmp.p;
                    var e = tmp.e;
                    var t = p.multiply(base);
                    return t.compareTo(value) <= 0 ? {
                        p: t,
                        e: e * 2 + 1
                    } : {
                        p: p,
                        e: e * 2
                    };
                }
                return {
                    p: bigInt(1),
                    e: 0
                };
            }
            BigInteger.prototype.bitLength = function() {
                var n = this;
                if (n.compareTo(bigInt(0)) < 0) n = n.negate().subtract(bigInt(1));
                if (n.compareTo(bigInt(0)) === 0) return bigInt(0);
                return bigInt(integerLogarithm(n, bigInt(2)).e).add(bigInt(1));
            };
            NativeBigInt.prototype.bitLength = SmallInteger.prototype.bitLength = BigInteger.prototype.bitLength;
            function max(a, b) {
                a = parseValue(a);
                b = parseValue(b);
                return a.greater(b) ? a : b;
            }
            function min(a, b) {
                a = parseValue(a);
                b = parseValue(b);
                return a.lesser(b) ? a : b;
            }
            function gcd(a, b) {
                a = parseValue(a).abs();
                b = parseValue(b).abs();
                if (a.equals(b)) return a;
                if (a.isZero()) return b;
                if (b.isZero()) return a;
                var c = Integer[1], d, t;
                while(a.isEven() && b.isEven()){
                    d = min(roughLOB(a), roughLOB(b));
                    a = a.divide(d);
                    b = b.divide(d);
                    c = c.multiply(d);
                }
                while(a.isEven())a = a.divide(roughLOB(a));
                do {
                    while(b.isEven())b = b.divide(roughLOB(b));
                    if (a.greater(b)) {
                        t = b;
                        b = a;
                        a = t;
                    }
                    b = b.subtract(a);
                }while (!b.isZero());
                return c.isUnit() ? a : a.multiply(c);
            }
            function lcm(a, b) {
                a = parseValue(a).abs();
                b = parseValue(b).abs();
                return a.divide(gcd(a, b)).multiply(b);
            }
            function randBetween(a, b, rng) {
                a = parseValue(a);
                b = parseValue(b);
                var usedRNG = rng || Math.random;
                var low = min(a, b), high = max(a, b);
                var range = high.subtract(low).add(1);
                if (range.isSmall) return low.add(Math.floor(usedRNG() * range));
                var digits = toBase(range, BASE).value;
                var result = [], restricted = true;
                for(var i = 0; i < digits.length; i++){
                    var top = restricted ? digits[i] + (i + 1 < digits.length ? digits[i + 1] / BASE : 0) : BASE;
                    var digit = truncate(usedRNG() * top);
                    result.push(digit);
                    if (digit < digits[i]) restricted = false;
                }
                return low.add(Integer.fromArray(result, BASE, false));
            }
            var parseBase = function(text, base, alphabet, caseSensitive) {
                alphabet = alphabet || DEFAULT_ALPHABET;
                text = String(text);
                if (!caseSensitive) {
                    text = text.toLowerCase();
                    alphabet = alphabet.toLowerCase();
                }
                var length = text.length;
                var i;
                var absBase = Math.abs(base);
                var alphabetValues = {};
                for(i = 0; i < alphabet.length; i++)alphabetValues[alphabet[i]] = i;
                for(i = 0; i < length; i++){
                    var c = text[i];
                    if (c === "-") continue;
                    if (c in alphabetValues) {
                        if (alphabetValues[c] >= absBase) {
                            if (c === "1" && absBase === 1) continue;
                            throw new Error(c + " is not a valid digit in base " + base + ".");
                        }
                    }
                }
                base = parseValue(base);
                var digits = [];
                var isNegative = text[0] === "-";
                for(i = isNegative ? 1 : 0; i < text.length; i++){
                    var c = text[i];
                    if (c in alphabetValues) digits.push(parseValue(alphabetValues[c]));
                    else if (c === "<") {
                        var start = i;
                        do i++;
                        while (text[i] !== ">" && i < text.length);
                        digits.push(parseValue(text.slice(start + 1, i)));
                    } else throw new Error(c + " is not a valid character");
                }
                return parseBaseFromArray(digits, base, isNegative);
            };
            function parseBaseFromArray(digits, base, isNegative) {
                var val = Integer[0], pow = Integer[1], i;
                for(i = digits.length - 1; i >= 0; i--){
                    val = val.add(digits[i].times(pow));
                    pow = pow.times(base);
                }
                return isNegative ? val.negate() : val;
            }
            function stringify(digit, alphabet) {
                alphabet = alphabet || DEFAULT_ALPHABET;
                if (digit < alphabet.length) return alphabet[digit];
                return "<" + digit + ">";
            }
            function toBase(n, base) {
                base = bigInt(base);
                if (base.isZero()) {
                    if (n.isZero()) return {
                        value: [
                            0
                        ],
                        isNegative: false
                    };
                    throw new Error("Cannot convert nonzero numbers to base 0.");
                }
                if (base.equals(-1)) {
                    if (n.isZero()) return {
                        value: [
                            0
                        ],
                        isNegative: false
                    };
                    if (n.isNegative()) return {
                        value: [].concat.apply([], Array.apply(null, Array(-n.toJSNumber())).map(Array.prototype.valueOf, [
                            1,
                            0
                        ])),
                        isNegative: false
                    };
                    var arr = Array.apply(null, Array(n.toJSNumber() - 1)).map(Array.prototype.valueOf, [
                        0,
                        1
                    ]);
                    arr.unshift([
                        1
                    ]);
                    return {
                        value: [].concat.apply([], arr),
                        isNegative: false
                    };
                }
                var neg = false;
                if (n.isNegative() && base.isPositive()) {
                    neg = true;
                    n = n.abs();
                }
                if (base.isUnit()) {
                    if (n.isZero()) return {
                        value: [
                            0
                        ],
                        isNegative: false
                    };
                    return {
                        value: Array.apply(null, Array(n.toJSNumber())).map(Number.prototype.valueOf, 1),
                        isNegative: neg
                    };
                }
                var out = [];
                var left = n, divmod;
                while(left.isNegative() || left.compareAbs(base) >= 0){
                    divmod = left.divmod(base);
                    left = divmod.quotient;
                    var digit = divmod.remainder;
                    if (digit.isNegative()) {
                        digit = base.minus(digit).abs();
                        left = left.next();
                    }
                    out.push(digit.toJSNumber());
                }
                out.push(left.toJSNumber());
                return {
                    value: out.reverse(),
                    isNegative: neg
                };
            }
            function toBaseString(n, base, alphabet) {
                var arr = toBase(n, base);
                return (arr.isNegative ? "-" : "") + arr.value.map(function(x) {
                    return stringify(x, alphabet);
                }).join('');
            }
            BigInteger.prototype.toArray = function(radix) {
                return toBase(this, radix);
            };
            SmallInteger.prototype.toArray = function(radix) {
                return toBase(this, radix);
            };
            NativeBigInt.prototype.toArray = function(radix) {
                return toBase(this, radix);
            };
            BigInteger.prototype.toString = function(radix, alphabet) {
                if (radix === undefined$1) radix = 10;
                if (radix !== 10 || alphabet) return toBaseString(this, radix, alphabet);
                var v = this.value, l = v.length, str = String(v[--l]), zeros = "0000000", digit;
                while(--l >= 0){
                    digit = String(v[l]);
                    str += zeros.slice(digit.length) + digit;
                }
                var sign = this.sign ? "-" : "";
                return sign + str;
            };
            SmallInteger.prototype.toString = function(radix, alphabet) {
                if (radix === undefined$1) radix = 10;
                if (radix != 10 || alphabet) return toBaseString(this, radix, alphabet);
                return String(this.value);
            };
            NativeBigInt.prototype.toString = SmallInteger.prototype.toString;
            NativeBigInt.prototype.toJSON = BigInteger.prototype.toJSON = SmallInteger.prototype.toJSON = function() {
                return this.toString();
            };
            BigInteger.prototype.valueOf = function() {
                return parseInt(this.toString(), 10);
            };
            BigInteger.prototype.toJSNumber = BigInteger.prototype.valueOf;
            SmallInteger.prototype.valueOf = function() {
                return this.value;
            };
            SmallInteger.prototype.toJSNumber = SmallInteger.prototype.valueOf;
            NativeBigInt.prototype.valueOf = NativeBigInt.prototype.toJSNumber = function() {
                return parseInt(this.toString(), 10);
            };
            function parseStringValue(v) {
                if (isPrecise(+v)) {
                    var x = +v;
                    if (x === truncate(x)) return supportsNativeBigInt ? new NativeBigInt(BigInt(x)) : new SmallInteger(x);
                    throw new Error("Invalid integer: " + v);
                }
                var sign = v[0] === "-";
                if (sign) v = v.slice(1);
                var split = v.split(/e/i);
                if (split.length > 2) throw new Error("Invalid integer: " + split.join("e"));
                if (split.length === 2) {
                    var exp = split[1];
                    if (exp[0] === "+") exp = exp.slice(1);
                    exp = +exp;
                    if (exp !== truncate(exp) || !isPrecise(exp)) throw new Error("Invalid integer: " + exp + " is not a valid exponent.");
                    var text = split[0];
                    var decimalPlace = text.indexOf(".");
                    if (decimalPlace >= 0) {
                        exp -= text.length - decimalPlace - 1;
                        text = text.slice(0, decimalPlace) + text.slice(decimalPlace + 1);
                    }
                    if (exp < 0) throw new Error("Cannot include negative exponent part for integers");
                    text += new Array(exp + 1).join("0");
                    v = text;
                }
                var isValid = /^([0-9][0-9]*)$/.test(v);
                if (!isValid) throw new Error("Invalid integer: " + v);
                if (supportsNativeBigInt) return new NativeBigInt(BigInt(sign ? "-" + v : v));
                var r = [], max = v.length, l = LOG_BASE, min = max - l;
                while(max > 0){
                    r.push(+v.slice(min, max));
                    min -= l;
                    if (min < 0) min = 0;
                    max -= l;
                }
                trim(r);
                return new BigInteger(r, sign);
            }
            function parseNumberValue(v) {
                if (supportsNativeBigInt) return new NativeBigInt(BigInt(v));
                if (isPrecise(v)) {
                    if (v !== truncate(v)) throw new Error(v + " is not an integer.");
                    return new SmallInteger(v);
                }
                return parseStringValue(v.toString());
            }
            function parseValue(v) {
                if (typeof v === "number") return parseNumberValue(v);
                if (typeof v === "string") return parseStringValue(v);
                if (typeof v === "bigint") return new NativeBigInt(v);
                return v;
            }
            // Pre-define numbers in range [-999,999]
            for(var i = 0; i < 1000; i++){
                Integer[i] = parseValue(i);
                if (i > 0) Integer[-i] = parseValue(-i);
            }
            // Backwards compatibility
            Integer.one = Integer[1];
            Integer.zero = Integer[0];
            Integer.minusOne = Integer[-1];
            Integer.max = max;
            Integer.min = min;
            Integer.gcd = gcd;
            Integer.lcm = lcm;
            Integer.isInstance = function(x) {
                return x instanceof BigInteger || x instanceof SmallInteger || x instanceof NativeBigInt;
            };
            Integer.randBetween = randBetween;
            Integer.fromArray = function(digits, base, isNegative) {
                return parseBaseFromArray(digits.map(parseValue), parseValue(base || 10), isNegative);
            };
            return Integer;
        }();
        // Node.js check
        if (module.hasOwnProperty("exports")) module.exports = bigInt;
    })((0, $7eavH.__module));
    return (0, $7eavH.__module).exports;
}

});
parcelRegister("7eavH", function(module, exports) {

$parcel$export(module.exports, "__module", function () { return $f2926f46e729df5d$export$5edeffb658f039f4; });
var $f2926f46e729df5d$export$5edeffb658f039f4 = {
    exports: {}
};

});





parcelRegister("a99sA", function(module, exports) {

$parcel$export(module.exports, "DISPATCH", function () { return $308c6503d5ebc81f$export$efd7770b5da84f9e; });
$parcel$export(module.exports, "Commands", function () { return $308c6503d5ebc81f$export$ba30f7724cb0e54e; });
$parcel$export(module.exports, "ReceiveFramePayload", function () { return $308c6503d5ebc81f$export$7a3470becaa040fa; });
$parcel$export(module.exports, "ScopesObject", function () { return $308c6503d5ebc81f$export$75435f4e5bc6ddd7; });
$parcel$export(module.exports, "Scopes", function () { return $308c6503d5ebc81f$export$8546186883d6ff3e; });
$parcel$export(module.exports, "Relationship", function () { return $308c6503d5ebc81f$export$69a0e7946cf616df; });
$parcel$export(module.exports, "User", function () { return $308c6503d5ebc81f$export$1f44aaf2ec115b54; });
$parcel$export(module.exports, "GuildMember", function () { return $308c6503d5ebc81f$export$6ba76af5c834ff81; });
$parcel$export(module.exports, "GuildMemberRPC", function () { return $308c6503d5ebc81f$export$8fbf13c8b5cc978c; });
$parcel$export(module.exports, "Emoji", function () { return $308c6503d5ebc81f$export$56cc48506ff790a; });
$parcel$export(module.exports, "VoiceState", function () { return $308c6503d5ebc81f$export$e40a3aa7b507330e; });
$parcel$export(module.exports, "UserVoiceState", function () { return $308c6503d5ebc81f$export$4b86a4e430ccb511; });
$parcel$export(module.exports, "StatusObject", function () { return $308c6503d5ebc81f$export$39054e8696850518; });
$parcel$export(module.exports, "Status", function () { return $308c6503d5ebc81f$export$96e9906d6d93a972; });
$parcel$export(module.exports, "Activity", function () { return $308c6503d5ebc81f$export$9c16c1426311996d; });
$parcel$export(module.exports, "PermissionOverwriteTypeObject", function () { return $308c6503d5ebc81f$export$fab33d7660c6e6d6; });
$parcel$export(module.exports, "PermissionOverwrite", function () { return $308c6503d5ebc81f$export$3700bd144328e1a6; });
$parcel$export(module.exports, "ChannelTypesObject", function () { return $308c6503d5ebc81f$export$2f4cb441f3eded01; });
$parcel$export(module.exports, "Channel", function () { return $308c6503d5ebc81f$export$cfdacaa37f9b4dd7; });
$parcel$export(module.exports, "PresenceUpdate", function () { return $308c6503d5ebc81f$export$24da275c271e8208; });
$parcel$export(module.exports, "Role", function () { return $308c6503d5ebc81f$export$46919bad18fb2f76; });
$parcel$export(module.exports, "Guild", function () { return $308c6503d5ebc81f$export$85e439e10eca0e6b; });
$parcel$export(module.exports, "ChannelMention", function () { return $308c6503d5ebc81f$export$8ce7ab97167fc310; });
$parcel$export(module.exports, "Attachment", function () { return $308c6503d5ebc81f$export$71e4db985cfcf9e3; });
$parcel$export(module.exports, "EmbedFooter", function () { return $308c6503d5ebc81f$export$8c9fffced316d89b; });
$parcel$export(module.exports, "Image", function () { return $308c6503d5ebc81f$export$3e431a229df88919; });
$parcel$export(module.exports, "Video", function () { return $308c6503d5ebc81f$export$ae01dedf5c052bb; });
$parcel$export(module.exports, "EmbedProvider", function () { return $308c6503d5ebc81f$export$e4790b418e6d5a4d; });
$parcel$export(module.exports, "EmbedAuthor", function () { return $308c6503d5ebc81f$export$632a034bda2c67e4; });
$parcel$export(module.exports, "EmbedField", function () { return $308c6503d5ebc81f$export$8f305b092204e542; });
$parcel$export(module.exports, "Embed", function () { return $308c6503d5ebc81f$export$a84540bc8b694b2d; });
$parcel$export(module.exports, "Reaction", function () { return $308c6503d5ebc81f$export$d2ae4167a30cf6bb; });
$parcel$export(module.exports, "MessageActivity", function () { return $308c6503d5ebc81f$export$465ad97f4d04cf9a; });
$parcel$export(module.exports, "MessageApplication", function () { return $308c6503d5ebc81f$export$56f5e744391a955c; });
$parcel$export(module.exports, "MessageReference", function () { return $308c6503d5ebc81f$export$bcebdc029e694ee6; });
$parcel$export(module.exports, "Message", function () { return $308c6503d5ebc81f$export$f69c19e57285b83a; });
$parcel$export(module.exports, "VoiceDevice", function () { return $308c6503d5ebc81f$export$624aa0dd60bb35db; });
$parcel$export(module.exports, "KeyTypesObject", function () { return $308c6503d5ebc81f$export$2ede097136cc13e4; });
$parcel$export(module.exports, "ShortcutKey", function () { return $308c6503d5ebc81f$export$f20a7ed0751474c1; });
$parcel$export(module.exports, "VoiceSettingModeTypeObject", function () { return $308c6503d5ebc81f$export$9d6f8c8df913ee9d; });
$parcel$export(module.exports, "VoiceSettingsMode", function () { return $308c6503d5ebc81f$export$c99e7704e60373e9; });
$parcel$export(module.exports, "VoiceSettingsIO", function () { return $308c6503d5ebc81f$export$cb1d6465ddfebcf0; });
$parcel$export(module.exports, "CertifiedDeviceTypeObject", function () { return $308c6503d5ebc81f$export$8320da8c452e87fc; });
$parcel$export(module.exports, "CertifiedDevice", function () { return $308c6503d5ebc81f$export$4f2f4bd3c787de21; });
$parcel$export(module.exports, "SkuTypeObject", function () { return $308c6503d5ebc81f$export$439ecd4335b15be4; });
$parcel$export(module.exports, "Sku", function () { return $308c6503d5ebc81f$export$ccf658062b0f9f7a; });
$parcel$export(module.exports, "EntitlementTypesObject", function () { return $308c6503d5ebc81f$export$6259f37857107b12; });
$parcel$export(module.exports, "Entitlement", function () { return $308c6503d5ebc81f$export$7b20d168ba04011b; });
$parcel$export(module.exports, "OrientationLockStateTypeObject", function () { return $308c6503d5ebc81f$export$7e8bb741497f2d3; });
$parcel$export(module.exports, "OrientationLockState", function () { return $308c6503d5ebc81f$export$76765004a89b60c4; });
$parcel$export(module.exports, "ThermalStateTypeObject", function () { return $308c6503d5ebc81f$export$6b5ef5fbc271f145; });
$parcel$export(module.exports, "ThermalState", function () { return $308c6503d5ebc81f$export$8065eea9d621a18; });
$parcel$export(module.exports, "OrientationTypeObject", function () { return $308c6503d5ebc81f$export$6998f50a089a6f29; });
$parcel$export(module.exports, "Orientation", function () { return $308c6503d5ebc81f$export$df54d73aa0ec5e82; });
$parcel$export(module.exports, "LayoutModeTypeObject", function () { return $308c6503d5ebc81f$export$94c8fa8df0efcb28; });
$parcel$export(module.exports, "LayoutMode", function () { return $308c6503d5ebc81f$export$8f9fafd62f4ed4cc; });

var $39moO = parcelRequire("39moO");

var $3BSyG = parcelRequire("3BSyG");

var $3VyrS = parcelRequire("3VyrS");
// DISPATCH is sent as cmd but is a special case, so is excluded from Commands enum
const $308c6503d5ebc81f$export$efd7770b5da84f9e = 'DISPATCH';
var $308c6503d5ebc81f$export$ba30f7724cb0e54e;
(function(Commands) {
    Commands["AUTHORIZE"] = "AUTHORIZE";
    Commands["GET_GUILDS"] = "GET_GUILDS";
    Commands["GET_GUILD"] = "GET_GUILD";
    Commands["GET_CHANNEL"] = "GET_CHANNEL";
    Commands["GET_CHANNELS"] = "GET_CHANNELS";
    Commands["SELECT_VOICE_CHANNEL"] = "SELECT_VOICE_CHANNEL";
    Commands["SELECT_TEXT_CHANNEL"] = "SELECT_TEXT_CHANNEL";
    Commands["SUBSCRIBE"] = "SUBSCRIBE";
    Commands["UNSUBSCRIBE"] = "UNSUBSCRIBE";
    Commands["CAPTURE_SHORTCUT"] = "CAPTURE_SHORTCUT";
    Commands["SET_CERTIFIED_DEVICES"] = "SET_CERTIFIED_DEVICES";
    Commands["SET_ACTIVITY"] = "SET_ACTIVITY";
    Commands["GET_SKUS"] = "GET_SKUS";
    Commands["GET_ENTITLEMENTS"] = "GET_ENTITLEMENTS";
    Commands["GET_SKUS_EMBEDDED"] = "GET_SKUS_EMBEDDED";
    Commands["GET_ENTITLEMENTS_EMBEDDED"] = "GET_ENTITLEMENTS_EMBEDDED";
    Commands["START_PURCHASE"] = "START_PURCHASE";
    Commands["SET_CONFIG"] = "SET_CONFIG";
    Commands["SEND_ANALYTICS_EVENT"] = "SEND_ANALYTICS_EVENT";
    Commands["USER_SETTINGS_GET_LOCALE"] = "USER_SETTINGS_GET_LOCALE";
    Commands["OPEN_EXTERNAL_LINK"] = "OPEN_EXTERNAL_LINK";
    Commands["ENCOURAGE_HW_ACCELERATION"] = "ENCOURAGE_HW_ACCELERATION";
    Commands["CAPTURE_LOG"] = "CAPTURE_LOG";
    Commands["SET_ORIENTATION_LOCK_STATE"] = "SET_ORIENTATION_LOCK_STATE";
    Commands["OPEN_INVITE_DIALOG"] = "OPEN_INVITE_DIALOG";
    Commands["GET_PLATFORM_BEHAVIORS"] = "GET_PLATFORM_BEHAVIORS";
    Commands["GET_CHANNEL_PERMISSIONS"] = "GET_CHANNEL_PERMISSIONS";
    // START-GENERATED-SECTION
    Commands["AUTHENTICATE"] = "AUTHENTICATE";
    Commands["GET_ACTIVITY_INSTANCE_CONNECTED_PARTICIPANTS"] = "GET_ACTIVITY_INSTANCE_CONNECTED_PARTICIPANTS";
    Commands["GET_QUEST"] = "GET_QUEST";
    Commands["GET_QUEST_ENROLLMENT_STATUS"] = "GET_QUEST_ENROLLMENT_STATUS";
    Commands["GET_RELATIONSHIPS"] = "GET_RELATIONSHIPS";
    Commands["GET_USER"] = "GET_USER";
    Commands["INITIATE_IMAGE_UPLOAD"] = "INITIATE_IMAGE_UPLOAD";
    Commands["INVITE_USER_EMBEDDED"] = "INVITE_USER_EMBEDDED";
    Commands["OPEN_SHARE_MOMENT_DIALOG"] = "OPEN_SHARE_MOMENT_DIALOG";
    Commands["QUEST_START_TIMER"] = "QUEST_START_TIMER";
    Commands["REQUEST_PROXY_TICKET_REFRESH"] = "REQUEST_PROXY_TICKET_REFRESH";
    Commands["SHARE_INTERACTION"] = "SHARE_INTERACTION";
    Commands["SHARE_LINK"] = "SHARE_LINK";
// END-GENERATED-SECTION
})($308c6503d5ebc81f$export$ba30f7724cb0e54e || ($308c6503d5ebc81f$export$ba30f7724cb0e54e = {}));
const $308c6503d5ebc81f$export$7a3470becaa040fa = (0, $39moO.object)({
    cmd: (0, $39moO.string)(),
    data: (0, $39moO.unknown)(),
    evt: (0, $39moO.null)(),
    nonce: (0, $39moO.string)()
}).passthrough();
// TODO afgiel -- next breaking change release
// remove Scopes and ScopesObject in favor of Types.OAuthScopes
const $308c6503d5ebc81f$export$75435f4e5bc6ddd7 = Object.assign(Object.assign({}, (0, $3VyrS.AuthenticateResponseSchema).shape.scopes.element.overlayType._def.innerType.options[0].Values), {
    UNHANDLED: -1
});
const $308c6503d5ebc81f$export$8546186883d6ff3e = (0, $3BSyG.zodCoerceUnhandledValue)($308c6503d5ebc81f$export$75435f4e5bc6ddd7);
const $308c6503d5ebc81f$export$69a0e7946cf616df = (0, $3VyrS.GetRelationshipsResponseSchema).shape.relationships.element;
const $308c6503d5ebc81f$export$1f44aaf2ec115b54 = (0, $39moO.object)({
    id: (0, $39moO.string)(),
    username: (0, $39moO.string)(),
    discriminator: (0, $39moO.string)(),
    global_name: (0, $39moO.string)().optional().nullable(),
    avatar: (0, $39moO.string)().optional().nullable(),
    avatar_decoration_data: (0, $39moO.object)({
        asset: (0, $39moO.string)(),
        sku_id: (0, $39moO.string)().optional()
    }).nullable(),
    bot: (0, $39moO.boolean)(),
    flags: (0, $39moO.number)().optional().nullable(),
    premium_type: (0, $39moO.number)().optional().nullable()
});
const $308c6503d5ebc81f$export$6ba76af5c834ff81 = (0, $39moO.object)({
    user: $308c6503d5ebc81f$export$1f44aaf2ec115b54,
    nick: (0, $39moO.string)().optional().nullable(),
    roles: (0, $39moO.array)((0, $39moO.string)()),
    joined_at: (0, $39moO.string)(),
    deaf: (0, $39moO.boolean)(),
    mute: (0, $39moO.boolean)()
});
const $308c6503d5ebc81f$export$8fbf13c8b5cc978c = (0, $39moO.object)({
    user_id: (0, $39moO.string)(),
    nick: (0, $39moO.string)().optional().nullable(),
    guild_id: (0, $39moO.string)(),
    avatar: (0, $39moO.string)().optional().nullable(),
    avatar_decoration_data: (0, $39moO.object)({
        asset: (0, $39moO.string)(),
        sku_id: (0, $39moO.string)().optional().nullable()
    }).optional().nullable(),
    color_string: (0, $39moO.string)().optional().nullable()
});
const $308c6503d5ebc81f$export$56cc48506ff790a = (0, $39moO.object)({
    id: (0, $39moO.string)(),
    name: (0, $39moO.string)().optional().nullable(),
    roles: (0, $39moO.array)((0, $39moO.string)()).optional().nullable(),
    user: $308c6503d5ebc81f$export$1f44aaf2ec115b54.optional().nullable(),
    require_colons: (0, $39moO.boolean)().optional().nullable(),
    managed: (0, $39moO.boolean)().optional().nullable(),
    animated: (0, $39moO.boolean)().optional().nullable(),
    available: (0, $39moO.boolean)().optional().nullable()
});
const $308c6503d5ebc81f$export$e40a3aa7b507330e = (0, $39moO.object)({
    mute: (0, $39moO.boolean)(),
    deaf: (0, $39moO.boolean)(),
    self_mute: (0, $39moO.boolean)(),
    self_deaf: (0, $39moO.boolean)(),
    suppress: (0, $39moO.boolean)()
});
const $308c6503d5ebc81f$export$4b86a4e430ccb511 = (0, $39moO.object)({
    mute: (0, $39moO.boolean)(),
    nick: (0, $39moO.string)(),
    user: $308c6503d5ebc81f$export$1f44aaf2ec115b54,
    voice_state: $308c6503d5ebc81f$export$e40a3aa7b507330e,
    volume: (0, $39moO.number)()
});
const $308c6503d5ebc81f$export$39054e8696850518 = {
    UNHANDLED: -1,
    IDLE: 'idle',
    DND: 'dnd',
    ONLINE: 'online',
    OFFLINE: 'offline'
};
const $308c6503d5ebc81f$export$96e9906d6d93a972 = (0, $3BSyG.zodCoerceUnhandledValue)($308c6503d5ebc81f$export$39054e8696850518);
const $308c6503d5ebc81f$export$9c16c1426311996d = (0, $39moO.object)({
    name: (0, $39moO.string)(),
    type: (0, $39moO.number)(),
    url: (0, $39moO.string)().optional().nullable(),
    created_at: (0, $39moO.number)().optional().nullable(),
    timestamps: (0, $39moO.object)({
        start: (0, $39moO.number)(),
        end: (0, $39moO.number)()
    }).partial().optional().nullable(),
    application_id: (0, $39moO.string)().optional().nullable(),
    details: (0, $39moO.string)().optional().nullable(),
    details_url: (0, $39moO.string)().url().optional().nullable(),
    state: (0, $39moO.string)().optional().nullable(),
    state_url: (0, $39moO.string)().url().optional().nullable(),
    emoji: $308c6503d5ebc81f$export$56cc48506ff790a.optional().nullable(),
    party: (0, $39moO.object)({
        id: (0, $39moO.string)().optional().nullable(),
        size: (0, $39moO.array)((0, $39moO.number)()).optional().nullable()
    }).optional().nullable(),
    assets: (0, $39moO.object)({
        large_image: (0, $39moO.string)().nullable(),
        large_text: (0, $39moO.string)().nullable(),
        large_url: (0, $39moO.string)().url().optional().nullable(),
        small_image: (0, $39moO.string)().nullable(),
        small_text: (0, $39moO.string)().nullable(),
        small_url: (0, $39moO.string)().url().optional().nullable()
    }).partial().optional().nullable(),
    secrets: (0, $39moO.object)({
        join: (0, $39moO.string)(),
        match: (0, $39moO.string)()
    }).partial().optional().nullable(),
    instance: (0, $39moO.boolean)().optional().nullable(),
    flags: (0, $39moO.number)().optional().nullable()
});
const $308c6503d5ebc81f$export$fab33d7660c6e6d6 = {
    UNHANDLED: -1,
    ROLE: 0,
    MEMBER: 1
};
const $308c6503d5ebc81f$export$3700bd144328e1a6 = (0, $39moO.object)({
    id: (0, $39moO.string)(),
    type: (0, $3BSyG.zodCoerceUnhandledValue)($308c6503d5ebc81f$export$fab33d7660c6e6d6),
    allow: (0, $39moO.string)(),
    deny: (0, $39moO.string)()
});
const $308c6503d5ebc81f$export$2f4cb441f3eded01 = {
    UNHANDLED: -1,
    DM: 1,
    GROUP_DM: 3,
    GUILD_TEXT: 0,
    GUILD_VOICE: 2,
    GUILD_CATEGORY: 4,
    GUILD_ANNOUNCEMENT: 5,
    GUILD_STORE: 6,
    ANNOUNCEMENT_THREAD: 10,
    PUBLIC_THREAD: 11,
    PRIVATE_THREAD: 12,
    GUILD_STAGE_VOICE: 13,
    GUILD_DIRECTORY: 14,
    GUILD_FORUM: 15
};
const $308c6503d5ebc81f$export$cfdacaa37f9b4dd7 = (0, $39moO.object)({
    id: (0, $39moO.string)(),
    type: (0, $3BSyG.zodCoerceUnhandledValue)($308c6503d5ebc81f$export$2f4cb441f3eded01),
    guild_id: (0, $39moO.string)().optional().nullable(),
    position: (0, $39moO.number)().optional().nullable(),
    permission_overwrites: (0, $39moO.array)($308c6503d5ebc81f$export$3700bd144328e1a6).optional().nullable(),
    name: (0, $39moO.string)().optional().nullable(),
    topic: (0, $39moO.string)().optional().nullable(),
    nsfw: (0, $39moO.boolean)().optional().nullable(),
    last_message_id: (0, $39moO.string)().optional().nullable(),
    bitrate: (0, $39moO.number)().optional().nullable(),
    user_limit: (0, $39moO.number)().optional().nullable(),
    rate_limit_per_user: (0, $39moO.number)().optional().nullable(),
    recipients: (0, $39moO.array)($308c6503d5ebc81f$export$1f44aaf2ec115b54).optional().nullable(),
    icon: (0, $39moO.string)().optional().nullable(),
    owner_id: (0, $39moO.string)().optional().nullable(),
    application_id: (0, $39moO.string)().optional().nullable(),
    parent_id: (0, $39moO.string)().optional().nullable(),
    last_pin_timestamp: (0, $39moO.string)().optional().nullable()
});
const $308c6503d5ebc81f$export$24da275c271e8208 = (0, $39moO.object)({
    user: $308c6503d5ebc81f$export$1f44aaf2ec115b54,
    guild_id: (0, $39moO.string)(),
    status: $308c6503d5ebc81f$export$96e9906d6d93a972,
    activities: (0, $39moO.array)($308c6503d5ebc81f$export$9c16c1426311996d),
    client_status: (0, $39moO.object)({
        desktop: $308c6503d5ebc81f$export$96e9906d6d93a972,
        mobile: $308c6503d5ebc81f$export$96e9906d6d93a972,
        web: $308c6503d5ebc81f$export$96e9906d6d93a972
    }).partial()
});
const $308c6503d5ebc81f$export$46919bad18fb2f76 = (0, $39moO.object)({
    id: (0, $39moO.string)(),
    name: (0, $39moO.string)(),
    color: (0, $39moO.number)(),
    hoist: (0, $39moO.boolean)(),
    position: (0, $39moO.number)(),
    permissions: (0, $39moO.string)(),
    managed: (0, $39moO.boolean)(),
    mentionable: (0, $39moO.boolean)()
});
const $308c6503d5ebc81f$export$85e439e10eca0e6b = (0, $39moO.object)({
    id: (0, $39moO.string)(),
    name: (0, $39moO.string)(),
    owner_id: (0, $39moO.string)(),
    icon: (0, $39moO.string)().nullable(),
    icon_hash: (0, $39moO.string)().optional().nullable(),
    splash: (0, $39moO.string)().nullable(),
    discovery_splash: (0, $39moO.string)().nullable(),
    owner: (0, $39moO.boolean)().optional().nullable(),
    permissions: (0, $39moO.string)().optional().nullable(),
    region: (0, $39moO.string)(),
    afk_channel_id: (0, $39moO.string)().nullable(),
    afk_timeout: (0, $39moO.number)(),
    widget_enabled: (0, $39moO.boolean)().optional().nullable(),
    widget_channel_id: (0, $39moO.string)().optional().nullable(),
    verification_level: (0, $39moO.number)(),
    default_message_notifications: (0, $39moO.number)(),
    explicit_content_filter: (0, $39moO.number)(),
    roles: (0, $39moO.array)($308c6503d5ebc81f$export$46919bad18fb2f76),
    emojis: (0, $39moO.array)($308c6503d5ebc81f$export$56cc48506ff790a),
    features: (0, $39moO.array)((0, $39moO.string)()),
    mfa_level: (0, $39moO.number)(),
    application_id: (0, $39moO.string)().nullable(),
    system_channel_id: (0, $39moO.string)().nullable(),
    system_channel_flags: (0, $39moO.number)(),
    rules_channel_id: (0, $39moO.string)().nullable(),
    joined_at: (0, $39moO.string)().optional().nullable(),
    large: (0, $39moO.boolean)().optional().nullable(),
    unavailable: (0, $39moO.boolean)().optional().nullable(),
    member_count: (0, $39moO.number)().optional().nullable(),
    voice_states: (0, $39moO.array)($308c6503d5ebc81f$export$e40a3aa7b507330e).optional().nullable(),
    members: (0, $39moO.array)($308c6503d5ebc81f$export$6ba76af5c834ff81).optional().nullable(),
    channels: (0, $39moO.array)($308c6503d5ebc81f$export$cfdacaa37f9b4dd7).optional().nullable(),
    presences: (0, $39moO.array)($308c6503d5ebc81f$export$24da275c271e8208).optional().nullable(),
    max_presences: (0, $39moO.number)().optional().nullable(),
    max_members: (0, $39moO.number)().optional().nullable(),
    vanity_url_code: (0, $39moO.string)().nullable(),
    description: (0, $39moO.string)().nullable(),
    banner: (0, $39moO.string)().nullable(),
    premium_tier: (0, $39moO.number)(),
    premium_subscription_count: (0, $39moO.number)().optional().nullable(),
    preferred_locale: (0, $39moO.string)(),
    public_updates_channel_id: (0, $39moO.string)().nullable(),
    max_video_channel_users: (0, $39moO.number)().optional().nullable(),
    approximate_member_count: (0, $39moO.number)().optional().nullable(),
    approximate_presence_count: (0, $39moO.number)().optional().nullable()
});
const $308c6503d5ebc81f$export$8ce7ab97167fc310 = (0, $39moO.object)({
    id: (0, $39moO.string)(),
    guild_id: (0, $39moO.string)(),
    type: (0, $39moO.number)(),
    name: (0, $39moO.string)()
});
const $308c6503d5ebc81f$export$71e4db985cfcf9e3 = (0, $39moO.object)({
    id: (0, $39moO.string)(),
    filename: (0, $39moO.string)(),
    size: (0, $39moO.number)(),
    url: (0, $39moO.string)(),
    proxy_url: (0, $39moO.string)(),
    height: (0, $39moO.number)().optional().nullable(),
    width: (0, $39moO.number)().optional().nullable()
});
const $308c6503d5ebc81f$export$8c9fffced316d89b = (0, $39moO.object)({
    text: (0, $39moO.string)(),
    icon_url: (0, $39moO.string)().optional().nullable(),
    proxy_icon_url: (0, $39moO.string)().optional().nullable()
});
const $308c6503d5ebc81f$export$3e431a229df88919 = (0, $39moO.object)({
    url: (0, $39moO.string)().optional().nullable(),
    proxy_url: (0, $39moO.string)().optional().nullable(),
    height: (0, $39moO.number)().optional().nullable(),
    width: (0, $39moO.number)().optional().nullable()
});
const $308c6503d5ebc81f$export$ae01dedf5c052bb = $308c6503d5ebc81f$export$3e431a229df88919.omit({
    proxy_url: true
});
const $308c6503d5ebc81f$export$e4790b418e6d5a4d = (0, $39moO.object)({
    name: (0, $39moO.string)().optional().nullable(),
    url: (0, $39moO.string)().optional().nullable()
});
const $308c6503d5ebc81f$export$632a034bda2c67e4 = (0, $39moO.object)({
    name: (0, $39moO.string)().optional().nullable(),
    url: (0, $39moO.string)().optional().nullable(),
    icon_url: (0, $39moO.string)().optional().nullable(),
    proxy_icon_url: (0, $39moO.string)().optional().nullable()
});
const $308c6503d5ebc81f$export$8f305b092204e542 = (0, $39moO.object)({
    name: (0, $39moO.string)(),
    value: (0, $39moO.string)(),
    inline: (0, $39moO.boolean)()
});
const $308c6503d5ebc81f$export$a84540bc8b694b2d = (0, $39moO.object)({
    title: (0, $39moO.string)().optional().nullable(),
    type: (0, $39moO.string)().optional().nullable(),
    description: (0, $39moO.string)().optional().nullable(),
    url: (0, $39moO.string)().optional().nullable(),
    timestamp: (0, $39moO.string)().optional().nullable(),
    color: (0, $39moO.number)().optional().nullable(),
    footer: $308c6503d5ebc81f$export$8c9fffced316d89b.optional().nullable(),
    image: $308c6503d5ebc81f$export$3e431a229df88919.optional().nullable(),
    thumbnail: $308c6503d5ebc81f$export$3e431a229df88919.optional().nullable(),
    video: $308c6503d5ebc81f$export$ae01dedf5c052bb.optional().nullable(),
    provider: $308c6503d5ebc81f$export$e4790b418e6d5a4d.optional().nullable(),
    author: $308c6503d5ebc81f$export$632a034bda2c67e4.optional().nullable(),
    fields: (0, $39moO.array)($308c6503d5ebc81f$export$8f305b092204e542).optional().nullable()
});
const $308c6503d5ebc81f$export$d2ae4167a30cf6bb = (0, $39moO.object)({
    count: (0, $39moO.number)(),
    me: (0, $39moO.boolean)(),
    emoji: $308c6503d5ebc81f$export$56cc48506ff790a
});
const $308c6503d5ebc81f$export$465ad97f4d04cf9a = (0, $39moO.object)({
    type: (0, $39moO.number)(),
    party_id: (0, $39moO.string)().optional().nullable()
});
const $308c6503d5ebc81f$export$56f5e744391a955c = (0, $39moO.object)({
    id: (0, $39moO.string)(),
    cover_image: (0, $39moO.string)().optional().nullable(),
    description: (0, $39moO.string)(),
    icon: (0, $39moO.string)().optional().nullable(),
    name: (0, $39moO.string)()
});
const $308c6503d5ebc81f$export$bcebdc029e694ee6 = (0, $39moO.object)({
    message_id: (0, $39moO.string)().optional().nullable(),
    channel_id: (0, $39moO.string)().optional().nullable(),
    guild_id: (0, $39moO.string)().optional().nullable()
});
const $308c6503d5ebc81f$export$f69c19e57285b83a = (0, $39moO.object)({
    id: (0, $39moO.string)(),
    channel_id: (0, $39moO.string)(),
    guild_id: (0, $39moO.string)().optional().nullable(),
    author: $308c6503d5ebc81f$export$1f44aaf2ec115b54.optional().nullable(),
    member: $308c6503d5ebc81f$export$6ba76af5c834ff81.optional().nullable(),
    content: (0, $39moO.string)(),
    timestamp: (0, $39moO.string)(),
    edited_timestamp: (0, $39moO.string)().optional().nullable(),
    tts: (0, $39moO.boolean)(),
    mention_everyone: (0, $39moO.boolean)(),
    mentions: (0, $39moO.array)($308c6503d5ebc81f$export$1f44aaf2ec115b54),
    mention_roles: (0, $39moO.array)((0, $39moO.string)()),
    mention_channels: (0, $39moO.array)($308c6503d5ebc81f$export$8ce7ab97167fc310),
    attachments: (0, $39moO.array)($308c6503d5ebc81f$export$71e4db985cfcf9e3),
    embeds: (0, $39moO.array)($308c6503d5ebc81f$export$a84540bc8b694b2d),
    reactions: (0, $39moO.array)($308c6503d5ebc81f$export$d2ae4167a30cf6bb).optional().nullable(),
    nonce: (0, $39moO.union)([
        (0, $39moO.string)(),
        (0, $39moO.number)()
    ]).optional().nullable(),
    pinned: (0, $39moO.boolean)(),
    webhook_id: (0, $39moO.string)().optional().nullable(),
    type: (0, $39moO.number)(),
    activity: $308c6503d5ebc81f$export$465ad97f4d04cf9a.optional().nullable(),
    application: $308c6503d5ebc81f$export$56f5e744391a955c.optional().nullable(),
    message_reference: $308c6503d5ebc81f$export$bcebdc029e694ee6.optional().nullable(),
    flags: (0, $39moO.number)().optional().nullable(),
    stickers: (0, $39moO.array)((0, $39moO.unknown)()).optional().nullable(),
    // Cannot self reference, but this is possibly a Message
    referenced_message: (0, $39moO.unknown)().optional().nullable()
});
const $308c6503d5ebc81f$export$624aa0dd60bb35db = (0, $39moO.object)({
    id: (0, $39moO.string)(),
    name: (0, $39moO.string)()
});
const $308c6503d5ebc81f$export$2ede097136cc13e4 = {
    UNHANDLED: -1,
    KEYBOARD_KEY: 0,
    MOUSE_BUTTON: 1,
    KEYBOARD_MODIFIER_KEY: 2,
    GAMEPAD_BUTTON: 3
};
const $308c6503d5ebc81f$export$f20a7ed0751474c1 = (0, $39moO.object)({
    type: (0, $3BSyG.zodCoerceUnhandledValue)($308c6503d5ebc81f$export$2ede097136cc13e4),
    code: (0, $39moO.number)(),
    name: (0, $39moO.string)()
});
const $308c6503d5ebc81f$export$9d6f8c8df913ee9d = {
    UNHANDLED: -1,
    PUSH_TO_TALK: 'PUSH_TO_TALK',
    VOICE_ACTIVITY: 'VOICE_ACTIVITY'
};
const $308c6503d5ebc81f$export$c99e7704e60373e9 = (0, $39moO.object)({
    type: (0, $3BSyG.zodCoerceUnhandledValue)($308c6503d5ebc81f$export$9d6f8c8df913ee9d),
    auto_threshold: (0, $39moO.boolean)(),
    threshold: (0, $39moO.number)(),
    shortcut: (0, $39moO.array)($308c6503d5ebc81f$export$f20a7ed0751474c1),
    delay: (0, $39moO.number)()
});
const $308c6503d5ebc81f$export$cb1d6465ddfebcf0 = (0, $39moO.object)({
    device_id: (0, $39moO.string)(),
    volume: (0, $39moO.number)(),
    available_devices: (0, $39moO.array)($308c6503d5ebc81f$export$624aa0dd60bb35db)
});
const $308c6503d5ebc81f$export$8320da8c452e87fc = {
    UNHANDLED: -1,
    AUDIO_INPUT: 'AUDIO_INPUT',
    AUDIO_OUTPUT: 'AUDIO_OUTPUT',
    VIDEO_INPUT: 'VIDEO_INPUT'
};
const $308c6503d5ebc81f$export$4f2f4bd3c787de21 = (0, $39moO.object)({
    type: (0, $3BSyG.zodCoerceUnhandledValue)($308c6503d5ebc81f$export$8320da8c452e87fc),
    id: (0, $39moO.string)(),
    vendor: (0, $39moO.object)({
        name: (0, $39moO.string)(),
        url: (0, $39moO.string)()
    }),
    model: (0, $39moO.object)({
        name: (0, $39moO.string)(),
        url: (0, $39moO.string)()
    }),
    related: (0, $39moO.array)((0, $39moO.string)()),
    echo_cancellation: (0, $39moO.boolean)().optional().nullable(),
    noise_suppression: (0, $39moO.boolean)().optional().nullable(),
    automatic_gain_control: (0, $39moO.boolean)().optional().nullable(),
    hardware_mute: (0, $39moO.boolean)().optional().nullable()
});
const $308c6503d5ebc81f$export$439ecd4335b15be4 = {
    UNHANDLED: -1,
    APPLICATION: 1,
    DLC: 2,
    CONSUMABLE: 3,
    BUNDLE: 4,
    SUBSCRIPTION: 5
};
const $308c6503d5ebc81f$export$ccf658062b0f9f7a = (0, $39moO.object)({
    id: (0, $39moO.string)(),
    name: (0, $39moO.string)(),
    type: (0, $3BSyG.zodCoerceUnhandledValue)($308c6503d5ebc81f$export$439ecd4335b15be4),
    price: (0, $39moO.object)({
        amount: (0, $39moO.number)(),
        currency: (0, $39moO.string)()
    }),
    application_id: (0, $39moO.string)(),
    flags: (0, $39moO.number)(),
    release_date: (0, $39moO.string)().nullable()
});
const $308c6503d5ebc81f$export$6259f37857107b12 = {
    UNHANDLED: -1,
    PURCHASE: 1,
    PREMIUM_SUBSCRIPTION: 2,
    DEVELOPER_GIFT: 3,
    TEST_MODE_PURCHASE: 4,
    FREE_PURCHASE: 5,
    USER_GIFT: 6,
    PREMIUM_PURCHASE: 7
};
const $308c6503d5ebc81f$export$7b20d168ba04011b = (0, $39moO.object)({
    id: (0, $39moO.string)(),
    sku_id: (0, $39moO.string)(),
    application_id: (0, $39moO.string)(),
    user_id: (0, $39moO.string)(),
    gift_code_flags: (0, $39moO.number)(),
    type: (0, $3BSyG.zodCoerceUnhandledValue)($308c6503d5ebc81f$export$6259f37857107b12),
    gifter_user_id: (0, $39moO.string)().optional().nullable(),
    branches: (0, $39moO.array)((0, $39moO.string)()).optional().nullable(),
    starts_at: (0, $39moO.string)().optional().nullable(),
    ends_at: (0, $39moO.string)().optional().nullable(),
    parent_id: (0, $39moO.string)().optional().nullable(),
    consumed: (0, $39moO.boolean)().optional().nullable(),
    deleted: (0, $39moO.boolean)().optional().nullable(),
    gift_code_batch_id: (0, $39moO.string)().optional().nullable()
});
const $308c6503d5ebc81f$export$7e8bb741497f2d3 = {
    UNHANDLED: -1,
    UNLOCKED: 1,
    PORTRAIT: 2,
    LANDSCAPE: 3
};
const $308c6503d5ebc81f$export$76765004a89b60c4 = (0, $3BSyG.zodCoerceUnhandledValue)($308c6503d5ebc81f$export$7e8bb741497f2d3);
const $308c6503d5ebc81f$export$6b5ef5fbc271f145 = {
    UNHANDLED: -1,
    NOMINAL: 0,
    FAIR: 1,
    SERIOUS: 2,
    CRITICAL: 3
};
const $308c6503d5ebc81f$export$8065eea9d621a18 = (0, $3BSyG.zodCoerceUnhandledValue)($308c6503d5ebc81f$export$6b5ef5fbc271f145);
const $308c6503d5ebc81f$export$6998f50a089a6f29 = {
    UNHANDLED: -1,
    PORTRAIT: 0,
    LANDSCAPE: 1
};
const $308c6503d5ebc81f$export$df54d73aa0ec5e82 = (0, $3BSyG.zodCoerceUnhandledValue)($308c6503d5ebc81f$export$6998f50a089a6f29);
const $308c6503d5ebc81f$export$94c8fa8df0efcb28 = {
    UNHANDLED: -1,
    FOCUSED: 0,
    PIP: 1,
    GRID: 2
};
const $308c6503d5ebc81f$export$8f9fafd62f4ed4cc = (0, $3BSyG.zodCoerceUnhandledValue)($308c6503d5ebc81f$export$94c8fa8df0efcb28);

});
parcelRegister("3BSyG", function(module, exports) {

$parcel$export(module.exports, "zodCoerceUnhandledValue", function () { return $901500f0ec163215$export$5989705faed03747; });
$parcel$export(module.exports, "fallbackToDefault", function () { return $901500f0ec163215$export$b70693e61e1d03ea; });

var $39moO = parcelRequire("39moO");
/**
 * This is a helper function which coerces an unsupported arg value to the key/value UNHANDLED: -1
 * This is necessary to handle a scenario where a new enum value is added in the Discord Client,
 * so that the sdk will not throw an error when given a (newly) valid enum value.
 *
 * To remove the requirement for consumers of this sdk to import an enum when parsing data,
 * we instead use an object cast as const (readonly). This maintains parity with the previous
 * schema (which used zod.enum), and behaves more like a union type, i.e. 'foo' | 'bar' | -1
 *
 * @param inputObject This object must include the key/value pair UNHANDLED = -1
 */ function $901500f0ec163215$export$5989705faed03747(inputObject) {
    return (0, $39moO.preprocess)((arg)=>{
        var _a;
        const [objectKey] = (_a = Object.entries(inputObject).find(([, value])=>value === arg)) !== null && _a !== void 0 ? _a : [];
        if (arg != null && objectKey === undefined) return inputObject.UNHANDLED;
        return arg;
    }, (0, $39moO.string)().or((0, $39moO.number)()));
}
/**
 * Fallback to the default zod value if parsing fails.
 */ function $901500f0ec163215$export$b70693e61e1d03ea(schema) {
    const transform = (0, $39moO.custom)().transform((data)=>{
        const res = schema.safeParse(data);
        if (res.success) return res.data;
        return schema._def.defaultValue();
    });
    // Must set this inner schema so inspection works correctly
    transform.overlayType = schema;
    // transform._def.schema = schema;
    return transform;
}

});

parcelRegister("3VyrS", function(module, exports) {

$parcel$export(module.exports, "AuthenticateResponseSchema", function () { return $1ab3cecf647fcfcc$export$abba1635e36ab43f; });
$parcel$export(module.exports, "GetActivityInstanceConnectedParticipantsResponseSchema", function () { return $1ab3cecf647fcfcc$export$55c4c3c25fd5c28e; });
$parcel$export(module.exports, "GetRelationshipsResponseSchema", function () { return $1ab3cecf647fcfcc$export$cf3ad725da54e6ab; });
$parcel$export(module.exports, "Command", function () { return $1ab3cecf647fcfcc$export$cc7e12c76513e857; });
$parcel$export(module.exports, "Schemas", function () { return $1ab3cecf647fcfcc$export$e49b768f28ad1b60; });

var $39moO = parcelRequire("39moO");

var $3BSyG = parcelRequire("3BSyG");
/**
 * This file is generated.
 * Run "npm run sync" to regenerate file.
 * @generated
 */ // INITIATE_IMAGE_UPLOAD
const $1ab3cecf647fcfcc$export$599108c66632c238 = (0, $39moO.default).object({
    image_url: (0, $39moO.default).string()
}).describe('Response for "INITIATE_IMAGE_UPLOAD" Command');
// OPEN_SHARE_MOMENT_DIALOG
const $1ab3cecf647fcfcc$export$b7048850f4d41d23 = (0, $39moO.default).object({
    mediaUrl: (0, $39moO.default).string().max(1024)
}).describe('Request for "OPEN_SHARE_MOMENT_DIALOG" Command');
// AUTHENTICATE
const $1ab3cecf647fcfcc$export$21449d5881a7a118 = (0, $39moO.default).object({
    access_token: (0, $39moO.default).union([
        (0, $39moO.default).string(),
        (0, $39moO.default).null()
    ]).optional()
}).describe('Request for "AUTHENTICATE" Command');
const $1ab3cecf647fcfcc$export$abba1635e36ab43f = (0, $39moO.default).object({
    access_token: (0, $39moO.default).string(),
    user: (0, $39moO.default).object({
        username: (0, $39moO.default).string(),
        discriminator: (0, $39moO.default).string(),
        id: (0, $39moO.default).string(),
        avatar: (0, $39moO.default).union([
            (0, $39moO.default).string(),
            (0, $39moO.default).null()
        ]).optional(),
        public_flags: (0, $39moO.default).number(),
        global_name: (0, $39moO.default).union([
            (0, $39moO.default).string(),
            (0, $39moO.default).null()
        ]).optional()
    }),
    scopes: (0, $39moO.default).array((0, $3BSyG.fallbackToDefault)((0, $39moO.default).enum([
        'identify',
        'identify.premium',
        'email',
        'connections',
        'guilds',
        'guilds.join',
        'guilds.members.read',
        'guilds.channels.read',
        'gdm.join',
        'bot',
        'rpc',
        'rpc.notifications.read',
        'rpc.voice.read',
        'rpc.voice.write',
        'rpc.video.read',
        'rpc.video.write',
        'rpc.screenshare.read',
        'rpc.screenshare.write',
        'rpc.activities.write',
        'webhook.incoming',
        'messages.read',
        'applications.builds.upload',
        'applications.builds.read',
        'applications.commands',
        'applications.commands.permissions.update',
        'applications.commands.update',
        'applications.store.update',
        'applications.entitlements',
        'activities.read',
        'activities.write',
        'activities.invites.write',
        'relationships.read',
        'relationships.write',
        'voice',
        'dm_channels.read',
        'role_connections.write',
        'presences.read',
        'presences.write',
        'openid',
        'dm_channels.messages.read',
        'dm_channels.messages.write',
        'gateway.connect',
        'account.global_name.update',
        'payment_sources.country_code',
        'sdk.social_layer_presence',
        'sdk.social_layer',
        'lobbies.write',
        'application_identities.write'
    ]).or((0, $39moO.default).literal(-1)).default(-1))),
    expires: (0, $39moO.default).string(),
    application: (0, $39moO.default).object({
        description: (0, $39moO.default).string(),
        icon: (0, $39moO.default).union([
            (0, $39moO.default).string(),
            (0, $39moO.default).null()
        ]).optional(),
        id: (0, $39moO.default).string(),
        rpc_origins: (0, $39moO.default).array((0, $39moO.default).string()).optional(),
        name: (0, $39moO.default).string()
    })
}).describe('Response for "AUTHENTICATE" Command');
// GET_ACTIVITY_INSTANCE_CONNECTED_PARTICIPANTS
const $1ab3cecf647fcfcc$export$55c4c3c25fd5c28e = (0, $39moO.default).object({
    participants: (0, $39moO.default).array((0, $39moO.default).object({
        id: (0, $39moO.default).string(),
        username: (0, $39moO.default).string(),
        global_name: (0, $39moO.default).union([
            (0, $39moO.default).string(),
            (0, $39moO.default).null()
        ]).optional(),
        discriminator: (0, $39moO.default).string(),
        avatar: (0, $39moO.default).union([
            (0, $39moO.default).string(),
            (0, $39moO.default).null()
        ]).optional(),
        flags: (0, $39moO.default).number(),
        bot: (0, $39moO.default).boolean(),
        avatar_decoration_data: (0, $39moO.default).union([
            (0, $39moO.default).object({
                asset: (0, $39moO.default).union([
                    (0, $39moO.default).string(),
                    (0, $39moO.default).null()
                ]).optional(),
                skuId: (0, $39moO.default).string().optional(),
                expiresAt: (0, $39moO.default).number().optional()
            }),
            (0, $39moO.default).null()
        ]).optional(),
        premium_type: (0, $39moO.default).union([
            (0, $39moO.default).number(),
            (0, $39moO.default).null()
        ]).optional(),
        nickname: (0, $39moO.default).string().optional()
    }))
}).describe('Response for "GET_ACTIVITY_INSTANCE_CONNECTED_PARTICIPANTS" Command');
// SHARE_INTERACTION
const $1ab3cecf647fcfcc$export$34bdde5b85891d77 = (0, $39moO.default).object({
    command: (0, $39moO.default).string(),
    options: (0, $39moO.default).array((0, $39moO.default).object({
        name: (0, $39moO.default).string(),
        value: (0, $39moO.default).string()
    })).optional(),
    content: (0, $39moO.default).string().max(2000).optional(),
    require_launch_channel: (0, $39moO.default).boolean().optional(),
    preview_image: (0, $39moO.default).object({
        height: (0, $39moO.default).number(),
        url: (0, $39moO.default).string(),
        width: (0, $39moO.default).number()
    }).optional(),
    components: (0, $39moO.default).array((0, $39moO.default).object({
        type: (0, $39moO.default).literal(1),
        components: (0, $39moO.default).array((0, $39moO.default).object({
            type: (0, $39moO.default).literal(2),
            style: (0, $39moO.default).number().gte(1).lte(5),
            label: (0, $39moO.default).string().max(80).optional(),
            custom_id: (0, $39moO.default).string().max(100).describe('Developer-defined identifier for the button; max 100 characters').optional()
        })).max(5).optional()
    })).optional(),
    pid: (0, $39moO.default).number().optional()
}).describe('Request for "SHARE_INTERACTION" Command');
const $1ab3cecf647fcfcc$export$81e529541e4eaa5a = (0, $39moO.default).object({
    success: (0, $39moO.default).boolean()
}).describe('Response for "SHARE_INTERACTION" Command');
// SHARE_LINK
const $1ab3cecf647fcfcc$export$3c9e2aaf9c667aad = (0, $39moO.default).object({
    custom_id: (0, $39moO.default).string().max(64).optional(),
    message: (0, $39moO.default).string().max(1000),
    link_id: (0, $39moO.default).string().max(64).optional()
}).describe('Request for "SHARE_LINK" Command');
const $1ab3cecf647fcfcc$export$8b31f86466a5b2c7 = (0, $39moO.default).object({
    success: (0, $39moO.default).boolean(),
    didCopyLink: (0, $39moO.default).boolean(),
    didSendMessage: (0, $39moO.default).boolean()
}).describe('Response for "SHARE_LINK" Command');
// GET_RELATIONSHIPS
const $1ab3cecf647fcfcc$export$cf3ad725da54e6ab = (0, $39moO.default).object({
    relationships: (0, $39moO.default).array((0, $39moO.default).object({
        type: (0, $39moO.default).number(),
        user: (0, $39moO.default).object({
            id: (0, $39moO.default).string(),
            username: (0, $39moO.default).string(),
            global_name: (0, $39moO.default).union([
                (0, $39moO.default).string(),
                (0, $39moO.default).null()
            ]).optional(),
            discriminator: (0, $39moO.default).string(),
            avatar: (0, $39moO.default).union([
                (0, $39moO.default).string(),
                (0, $39moO.default).null()
            ]).optional(),
            flags: (0, $39moO.default).number(),
            bot: (0, $39moO.default).boolean(),
            avatar_decoration_data: (0, $39moO.default).union([
                (0, $39moO.default).object({
                    asset: (0, $39moO.default).union([
                        (0, $39moO.default).string(),
                        (0, $39moO.default).null()
                    ]).optional(),
                    skuId: (0, $39moO.default).string().optional(),
                    expiresAt: (0, $39moO.default).number().optional()
                }),
                (0, $39moO.default).null()
            ]).optional(),
            premium_type: (0, $39moO.default).union([
                (0, $39moO.default).number(),
                (0, $39moO.default).null()
            ]).optional()
        }),
        presence: (0, $39moO.default).object({
            status: (0, $39moO.default).string(),
            activity: (0, $39moO.default).union([
                (0, $39moO.default).object({
                    session_id: (0, $39moO.default).string().optional(),
                    type: (0, $39moO.default).number().optional(),
                    name: (0, $39moO.default).string(),
                    url: (0, $39moO.default).union([
                        (0, $39moO.default).string(),
                        (0, $39moO.default).null()
                    ]).optional(),
                    application_id: (0, $39moO.default).string().optional(),
                    status_display_type: (0, $39moO.default).number().optional(),
                    state: (0, $39moO.default).string().optional(),
                    state_url: (0, $39moO.default).string().optional(),
                    details: (0, $39moO.default).string().optional(),
                    details_url: (0, $39moO.default).string().optional(),
                    emoji: (0, $39moO.default).union([
                        (0, $39moO.default).object({
                            name: (0, $39moO.default).string(),
                            id: (0, $39moO.default).union([
                                (0, $39moO.default).string(),
                                (0, $39moO.default).null()
                            ]).optional(),
                            animated: (0, $39moO.default).union([
                                (0, $39moO.default).boolean(),
                                (0, $39moO.default).null()
                            ]).optional()
                        }),
                        (0, $39moO.default).null()
                    ]).optional(),
                    assets: (0, $39moO.default).object({
                        large_image: (0, $39moO.default).string().optional(),
                        large_text: (0, $39moO.default).string().optional(),
                        large_url: (0, $39moO.default).string().optional(),
                        small_image: (0, $39moO.default).string().optional(),
                        small_text: (0, $39moO.default).string().optional(),
                        small_url: (0, $39moO.default).string().optional()
                    }).optional(),
                    timestamps: (0, $39moO.default).object({
                        start: (0, $39moO.default).number().optional(),
                        end: (0, $39moO.default).number().optional()
                    }).optional(),
                    party: (0, $39moO.default).object({
                        id: (0, $39moO.default).string().optional(),
                        size: (0, $39moO.default).array((0, $39moO.default).number()).min(2).max(2).optional(),
                        privacy: (0, $39moO.default).number().optional()
                    }).optional(),
                    secrets: (0, $39moO.default).object({
                        match: (0, $39moO.default).string().optional(),
                        join: (0, $39moO.default).string().optional()
                    }).optional(),
                    sync_id: (0, $39moO.default).string().optional(),
                    created_at: (0, $39moO.default).number().optional(),
                    instance: (0, $39moO.default).boolean().optional(),
                    flags: (0, $39moO.default).number().optional(),
                    metadata: (0, $39moO.default).object({}).optional(),
                    platform: (0, $39moO.default).string().optional(),
                    supported_platforms: (0, $39moO.default).array((0, $39moO.default).string()).optional(),
                    buttons: (0, $39moO.default).array((0, $39moO.default).string()).optional(),
                    hangStatus: (0, $39moO.default).string().optional()
                }),
                (0, $39moO.default).null()
            ]).optional()
        }).optional()
    }))
}).describe('Response for "GET_RELATIONSHIPS" Command');
// INVITE_USER_EMBEDDED
const $1ab3cecf647fcfcc$export$b4435c365c69d3f9 = (0, $39moO.default).object({
    user_id: (0, $39moO.default).string(),
    content: (0, $39moO.default).string().min(0).max(1024).optional()
}).describe('Request for "INVITE_USER_EMBEDDED" Command');
// GET_USER
const $1ab3cecf647fcfcc$export$af08b40b856b65e9 = (0, $39moO.default).object({
    id: (0, $39moO.default).string().max(64)
}).describe('Request for "GET_USER" Command');
const $1ab3cecf647fcfcc$export$efae7d0364e4f628 = (0, $39moO.default).union([
    (0, $39moO.default).object({
        id: (0, $39moO.default).string(),
        username: (0, $39moO.default).string(),
        global_name: (0, $39moO.default).union([
            (0, $39moO.default).string(),
            (0, $39moO.default).null()
        ]).optional(),
        discriminator: (0, $39moO.default).string(),
        avatar: (0, $39moO.default).union([
            (0, $39moO.default).string(),
            (0, $39moO.default).null()
        ]).optional(),
        flags: (0, $39moO.default).number(),
        bot: (0, $39moO.default).boolean(),
        avatar_decoration_data: (0, $39moO.default).union([
            (0, $39moO.default).object({
                asset: (0, $39moO.default).union([
                    (0, $39moO.default).string(),
                    (0, $39moO.default).null()
                ]).optional(),
                skuId: (0, $39moO.default).string().optional(),
                expiresAt: (0, $39moO.default).number().optional()
            }),
            (0, $39moO.default).null()
        ]).optional(),
        premium_type: (0, $39moO.default).union([
            (0, $39moO.default).number(),
            (0, $39moO.default).null()
        ]).optional()
    }),
    (0, $39moO.default).null()
]);
// GET_QUEST_ENROLLMENT_STATUS
const $1ab3cecf647fcfcc$export$1576667503dc7922 = (0, $39moO.default).object({
    quest_id: (0, $39moO.default).string()
}).describe('Request for "GET_QUEST_ENROLLMENT_STATUS" Command');
const $1ab3cecf647fcfcc$export$d0f6ddcb78f2b9e6 = (0, $39moO.default).object({
    quest_id: (0, $39moO.default).string(),
    is_enrolled: (0, $39moO.default).boolean(),
    enrolled_at: (0, $39moO.default).union([
        (0, $39moO.default).string(),
        (0, $39moO.default).null()
    ]).optional()
}).describe('Response for "GET_QUEST_ENROLLMENT_STATUS" Command');
// QUEST_START_TIMER
const $1ab3cecf647fcfcc$export$781354905a4676b4 = (0, $39moO.default).object({
    quest_id: (0, $39moO.default).string()
}).describe('Request for "QUEST_START_TIMER" Command');
const $1ab3cecf647fcfcc$export$b20fb8e5626c7518 = (0, $39moO.default).object({
    success: (0, $39moO.default).boolean()
}).describe('Response for "QUEST_START_TIMER" Command');
// GET_QUEST
const $1ab3cecf647fcfcc$export$579593816d97a196 = (0, $39moO.default).object({
    quest_id: (0, $39moO.default).string(),
    enrolled_at: (0, $39moO.default).union([
        (0, $39moO.default).string(),
        (0, $39moO.default).null()
    ]).optional(),
    completed_at: (0, $39moO.default).union([
        (0, $39moO.default).string(),
        (0, $39moO.default).null()
    ]).optional(),
    external_cta_url: (0, $39moO.default).string()
}).describe('Response for "GET_QUEST" Command');
// REQUEST_PROXY_TICKET_REFRESH
const $1ab3cecf647fcfcc$export$f81f8a7ace4e7dd5 = (0, $39moO.default).object({
    ticket: (0, $39moO.default).string()
}).describe('Response for "REQUEST_PROXY_TICKET_REFRESH" Command');
/**
 * RPC Commands which support schemas.
 */ var $1ab3cecf647fcfcc$export$cc7e12c76513e857;
(function(Command) {
    Command["INITIATE_IMAGE_UPLOAD"] = "INITIATE_IMAGE_UPLOAD";
    Command["OPEN_SHARE_MOMENT_DIALOG"] = "OPEN_SHARE_MOMENT_DIALOG";
    Command["AUTHENTICATE"] = "AUTHENTICATE";
    Command["GET_ACTIVITY_INSTANCE_CONNECTED_PARTICIPANTS"] = "GET_ACTIVITY_INSTANCE_CONNECTED_PARTICIPANTS";
    Command["SHARE_INTERACTION"] = "SHARE_INTERACTION";
    Command["SHARE_LINK"] = "SHARE_LINK";
    Command["GET_RELATIONSHIPS"] = "GET_RELATIONSHIPS";
    Command["INVITE_USER_EMBEDDED"] = "INVITE_USER_EMBEDDED";
    Command["GET_USER"] = "GET_USER";
    Command["GET_QUEST_ENROLLMENT_STATUS"] = "GET_QUEST_ENROLLMENT_STATUS";
    Command["QUEST_START_TIMER"] = "QUEST_START_TIMER";
    Command["GET_QUEST"] = "GET_QUEST";
    Command["REQUEST_PROXY_TICKET_REFRESH"] = "REQUEST_PROXY_TICKET_REFRESH";
})($1ab3cecf647fcfcc$export$cc7e12c76513e857 || ($1ab3cecf647fcfcc$export$cc7e12c76513e857 = {}));
const $1ab3cecf647fcfcc$var$emptyResponseSchema = (0, $39moO.default).object({}).optional().nullable();
const $1ab3cecf647fcfcc$var$emptyRequestSchema = (0, $39moO.default).void();
/**
 * Request & Response schemas for each supported RPC Command.
 */ const $1ab3cecf647fcfcc$export$e49b768f28ad1b60 = {
    [$1ab3cecf647fcfcc$export$cc7e12c76513e857.INITIATE_IMAGE_UPLOAD]: {
        request: $1ab3cecf647fcfcc$var$emptyRequestSchema,
        response: $1ab3cecf647fcfcc$export$599108c66632c238
    },
    [$1ab3cecf647fcfcc$export$cc7e12c76513e857.OPEN_SHARE_MOMENT_DIALOG]: {
        request: $1ab3cecf647fcfcc$export$b7048850f4d41d23,
        response: $1ab3cecf647fcfcc$var$emptyResponseSchema
    },
    [$1ab3cecf647fcfcc$export$cc7e12c76513e857.AUTHENTICATE]: {
        request: $1ab3cecf647fcfcc$export$21449d5881a7a118,
        response: $1ab3cecf647fcfcc$export$abba1635e36ab43f
    },
    [$1ab3cecf647fcfcc$export$cc7e12c76513e857.GET_ACTIVITY_INSTANCE_CONNECTED_PARTICIPANTS]: {
        request: $1ab3cecf647fcfcc$var$emptyRequestSchema,
        response: $1ab3cecf647fcfcc$export$55c4c3c25fd5c28e
    },
    [$1ab3cecf647fcfcc$export$cc7e12c76513e857.SHARE_INTERACTION]: {
        request: $1ab3cecf647fcfcc$export$34bdde5b85891d77,
        response: $1ab3cecf647fcfcc$export$81e529541e4eaa5a
    },
    [$1ab3cecf647fcfcc$export$cc7e12c76513e857.SHARE_LINK]: {
        request: $1ab3cecf647fcfcc$export$3c9e2aaf9c667aad,
        response: $1ab3cecf647fcfcc$export$8b31f86466a5b2c7
    },
    [$1ab3cecf647fcfcc$export$cc7e12c76513e857.GET_RELATIONSHIPS]: {
        request: $1ab3cecf647fcfcc$var$emptyRequestSchema,
        response: $1ab3cecf647fcfcc$export$cf3ad725da54e6ab
    },
    [$1ab3cecf647fcfcc$export$cc7e12c76513e857.INVITE_USER_EMBEDDED]: {
        request: $1ab3cecf647fcfcc$export$b4435c365c69d3f9,
        response: $1ab3cecf647fcfcc$var$emptyResponseSchema
    },
    [$1ab3cecf647fcfcc$export$cc7e12c76513e857.GET_USER]: {
        request: $1ab3cecf647fcfcc$export$af08b40b856b65e9,
        response: $1ab3cecf647fcfcc$export$efae7d0364e4f628
    },
    [$1ab3cecf647fcfcc$export$cc7e12c76513e857.GET_QUEST_ENROLLMENT_STATUS]: {
        request: $1ab3cecf647fcfcc$export$1576667503dc7922,
        response: $1ab3cecf647fcfcc$export$d0f6ddcb78f2b9e6
    },
    [$1ab3cecf647fcfcc$export$cc7e12c76513e857.QUEST_START_TIMER]: {
        request: $1ab3cecf647fcfcc$export$781354905a4676b4,
        response: $1ab3cecf647fcfcc$export$b20fb8e5626c7518
    },
    [$1ab3cecf647fcfcc$export$cc7e12c76513e857.GET_QUEST]: {
        request: $1ab3cecf647fcfcc$var$emptyRequestSchema,
        response: $1ab3cecf647fcfcc$export$579593816d97a196
    },
    [$1ab3cecf647fcfcc$export$cc7e12c76513e857.REQUEST_PROXY_TICKET_REFRESH]: {
        request: $1ab3cecf647fcfcc$var$emptyRequestSchema,
        response: $1ab3cecf647fcfcc$export$f81f8a7ace4e7dd5
    }
};

});



parcelRegister("02MKI", function(module, exports) {

$parcel$export(module.exports, "EmptyResponse", function () { return $e961c2ca9d22237b$export$2663ce359599a39a; });
$parcel$export(module.exports, "AuthorizeResponse", function () { return $e961c2ca9d22237b$export$a20dff0010f153a4; });
$parcel$export(module.exports, "GetChannelResponse", function () { return $e961c2ca9d22237b$export$116d844d40ad5f3c; });
$parcel$export(module.exports, "SetActivityResponse", function () { return $e961c2ca9d22237b$export$6441b328b684708a; });
$parcel$export(module.exports, "GetSkusResponse", function () { return $e961c2ca9d22237b$export$c5585ad29c8f7bd0; });
$parcel$export(module.exports, "GetEntitlementsResponse", function () { return $e961c2ca9d22237b$export$4232197b78e8b524; });
$parcel$export(module.exports, "StartPurchaseResponse", function () { return $e961c2ca9d22237b$export$17177c7243ab05e; });
$parcel$export(module.exports, "SetConfigResponse", function () { return $e961c2ca9d22237b$export$d92a181530f7d8d5; });
$parcel$export(module.exports, "UserSettingsGetLocaleResponse", function () { return $e961c2ca9d22237b$export$b462b396db5f92a0; });
$parcel$export(module.exports, "EncourageHardwareAccelerationResponse", function () { return $e961c2ca9d22237b$export$15549cbd10945eeb; });
$parcel$export(module.exports, "GetChannelPermissionsResponse", function () { return $e961c2ca9d22237b$export$67379dca9f34c2b9; });
$parcel$export(module.exports, "OpenExternalLinkResponse", function () { return $e961c2ca9d22237b$export$5e5d1b8668e0d4d5; });
$parcel$export(module.exports, "GetPlatformBehaviorsResponse", function () { return $e961c2ca9d22237b$export$ea78864ca3ab3f3c; });
$parcel$export(module.exports, "ResponseFrame", function () { return $e961c2ca9d22237b$export$8ffc8c4280411e44; });
$parcel$export(module.exports, "parseResponsePayload", function () { return $e961c2ca9d22237b$export$4890fc55aa463c4c; });

var $39moO = parcelRequire("39moO");

var $a99sA = parcelRequire("a99sA");

var $3BSyG = parcelRequire("3BSyG");

var $3VyrS = parcelRequire("3VyrS");

var $8MDgb = parcelRequire("8MDgb");
const $e961c2ca9d22237b$export$2663ce359599a39a = (0, $39moO.object)({}).nullable();
const $e961c2ca9d22237b$export$a20dff0010f153a4 = (0, $39moO.object)({
    code: (0, $39moO.string)()
});
const $e961c2ca9d22237b$export$c72c401de381626f = (0, $39moO.object)({
    guilds: (0, $39moO.array)((0, $39moO.object)({
        id: (0, $39moO.string)(),
        name: (0, $39moO.string)()
    }))
});
const $e961c2ca9d22237b$export$5845be03a3ebb99a = (0, $39moO.object)({
    id: (0, $39moO.string)(),
    name: (0, $39moO.string)(),
    icon_url: (0, $39moO.string)().optional(),
    members: (0, $39moO.array)((0, $a99sA.GuildMember))
});
const $e961c2ca9d22237b$export$116d844d40ad5f3c = (0, $39moO.object)({
    id: (0, $39moO.string)(),
    type: (0, $3BSyG.zodCoerceUnhandledValue)((0, $a99sA.ChannelTypesObject)),
    guild_id: (0, $39moO.string)().optional().nullable(),
    name: (0, $39moO.string)().optional().nullable(),
    topic: (0, $39moO.string)().optional().nullable(),
    bitrate: (0, $39moO.number)().optional().nullable(),
    user_limit: (0, $39moO.number)().optional().nullable(),
    position: (0, $39moO.number)().optional().nullable(),
    voice_states: (0, $39moO.array)((0, $a99sA.UserVoiceState)),
    messages: (0, $39moO.array)((0, $a99sA.Message))
});
const $e961c2ca9d22237b$export$1f3b23c28c30c42c = (0, $39moO.object)({
    channels: (0, $39moO.array)((0, $a99sA.Channel))
});
const $e961c2ca9d22237b$export$8ff9fe3ffde6290d = $e961c2ca9d22237b$export$116d844d40ad5f3c.nullable();
const $e961c2ca9d22237b$export$c74d4aa0f66fc05e = $e961c2ca9d22237b$export$116d844d40ad5f3c.nullable();
const $e961c2ca9d22237b$export$e114312640cd43d8 = $e961c2ca9d22237b$export$116d844d40ad5f3c.nullable();
const $e961c2ca9d22237b$export$f3dffed82766df8f = (0, $39moO.object)({
    input: (0, $a99sA.VoiceSettingsIO),
    output: (0, $a99sA.VoiceSettingsIO),
    mode: (0, $a99sA.VoiceSettingsMode),
    automatic_gain_control: (0, $39moO.boolean)(),
    echo_cancellation: (0, $39moO.boolean)(),
    noise_suppression: (0, $39moO.boolean)(),
    qos: (0, $39moO.boolean)(),
    silence_warning: (0, $39moO.boolean)(),
    deaf: (0, $39moO.boolean)(),
    mute: (0, $39moO.boolean)()
});
const $e961c2ca9d22237b$export$89425a92d6d4fba3 = (0, $39moO.object)({
    evt: (0, $39moO.string)()
});
const $e961c2ca9d22237b$export$49ab8a39ea910965 = (0, $39moO.object)({
    shortcut: (0, $a99sA.ShortcutKey)
});
const $e961c2ca9d22237b$export$6441b328b684708a = (0, $a99sA.Activity);
const $e961c2ca9d22237b$export$c5585ad29c8f7bd0 = (0, $39moO.object)({
    skus: (0, $39moO.array)((0, $a99sA.Sku))
});
const $e961c2ca9d22237b$export$4232197b78e8b524 = (0, $39moO.object)({
    entitlements: (0, $39moO.array)((0, $a99sA.Entitlement))
});
const $e961c2ca9d22237b$export$17177c7243ab05e = (0, $39moO.array)((0, $a99sA.Entitlement)).nullable();
const $e961c2ca9d22237b$export$d92a181530f7d8d5 = (0, $39moO.object)({
    use_interactive_pip: (0, $39moO.boolean)()
});
const $e961c2ca9d22237b$export$b462b396db5f92a0 = (0, $39moO.object)({
    locale: (0, $39moO.string)()
});
const $e961c2ca9d22237b$export$15549cbd10945eeb = (0, $39moO.object)({
    enabled: (0, $39moO.boolean)()
});
const $e961c2ca9d22237b$export$67379dca9f34c2b9 = (0, $39moO.object)({
    permissions: (0, $39moO.bigint)().or((0, $39moO.string)())
});
const $e961c2ca9d22237b$export$5e5d1b8668e0d4d5 = (0, $3BSyG.fallbackToDefault)((0, $39moO.object)({
    opened: (0, $39moO.boolean)().or((0, $39moO.null)())
}).default({
    opened: null
}));
/**
 * Because of the nature of Platform Behavior changes
 * every key/value is optional and may eventually be removed
 */ const $e961c2ca9d22237b$export$ea78864ca3ab3f3c = (0, $39moO.object)({
    iosKeyboardResizesView: (0, $39moO.optional)((0, $39moO.boolean)())
});
const $e961c2ca9d22237b$export$8ffc8c4280411e44 = (0, $a99sA.ReceiveFramePayload).extend({
    cmd: (0, $39moO.nativeEnum)((0, $a99sA.Commands)),
    evt: (0, $39moO.null)()
});
function $e961c2ca9d22237b$var$parseResponseData({ cmd: cmd, data: data }) {
    switch(cmd){
        case (0, $a99sA.Commands).AUTHORIZE:
            return $e961c2ca9d22237b$export$a20dff0010f153a4.parse(data);
        case (0, $a99sA.Commands).CAPTURE_SHORTCUT:
            return $e961c2ca9d22237b$export$49ab8a39ea910965.parse(data);
        case (0, $a99sA.Commands).ENCOURAGE_HW_ACCELERATION:
            return $e961c2ca9d22237b$export$15549cbd10945eeb.parse(data);
        case (0, $a99sA.Commands).GET_CHANNEL:
            return $e961c2ca9d22237b$export$116d844d40ad5f3c.parse(data);
        case (0, $a99sA.Commands).GET_CHANNELS:
            return $e961c2ca9d22237b$export$1f3b23c28c30c42c.parse(data);
        case (0, $a99sA.Commands).GET_CHANNEL_PERMISSIONS:
            return $e961c2ca9d22237b$export$67379dca9f34c2b9.parse(data);
        case (0, $a99sA.Commands).GET_GUILD:
            return $e961c2ca9d22237b$export$5845be03a3ebb99a.parse(data);
        case (0, $a99sA.Commands).GET_GUILDS:
            return $e961c2ca9d22237b$export$c72c401de381626f.parse(data);
        case (0, $a99sA.Commands).GET_PLATFORM_BEHAVIORS:
            return $e961c2ca9d22237b$export$ea78864ca3ab3f3c.parse(data);
        case (0, $a99sA.Commands).GET_CHANNEL:
            return $e961c2ca9d22237b$export$116d844d40ad5f3c.parse(data);
        case (0, $a99sA.Commands).SELECT_TEXT_CHANNEL:
            return $e961c2ca9d22237b$export$e114312640cd43d8.parse(data);
        case (0, $a99sA.Commands).SELECT_VOICE_CHANNEL:
            return $e961c2ca9d22237b$export$c74d4aa0f66fc05e.parse(data);
        case (0, $a99sA.Commands).SET_ACTIVITY:
            return $e961c2ca9d22237b$export$6441b328b684708a.parse(data);
        case (0, $a99sA.Commands).GET_SKUS_EMBEDDED:
            return $e961c2ca9d22237b$export$c5585ad29c8f7bd0.parse(data);
        case (0, $a99sA.Commands).GET_ENTITLEMENTS_EMBEDDED:
            return $e961c2ca9d22237b$export$4232197b78e8b524.parse(data);
        case (0, $a99sA.Commands).SET_CONFIG:
            return $e961c2ca9d22237b$export$d92a181530f7d8d5.parse(data);
        case (0, $a99sA.Commands).START_PURCHASE:
            return $e961c2ca9d22237b$export$17177c7243ab05e.parse(data);
        case (0, $a99sA.Commands).SUBSCRIBE:
        case (0, $a99sA.Commands).UNSUBSCRIBE:
            return $e961c2ca9d22237b$export$89425a92d6d4fba3.parse(data);
        case (0, $a99sA.Commands).USER_SETTINGS_GET_LOCALE:
            return $e961c2ca9d22237b$export$b462b396db5f92a0.parse(data);
        case (0, $a99sA.Commands).OPEN_EXTERNAL_LINK:
            return $e961c2ca9d22237b$export$5e5d1b8668e0d4d5.parse(data);
        // Empty Responses
        case (0, $a99sA.Commands).SET_ORIENTATION_LOCK_STATE:
        case (0, $a99sA.Commands).SET_CERTIFIED_DEVICES:
        case (0, $a99sA.Commands).SEND_ANALYTICS_EVENT:
        case (0, $a99sA.Commands).OPEN_INVITE_DIALOG:
        case (0, $a99sA.Commands).CAPTURE_LOG:
        case (0, $a99sA.Commands).GET_SKUS:
        case (0, $a99sA.Commands).GET_ENTITLEMENTS:
            return $e961c2ca9d22237b$export$2663ce359599a39a.parse(data);
        // START-GENERATED-SECTION
        case (0, $a99sA.Commands).AUTHENTICATE:
        case (0, $a99sA.Commands).GET_ACTIVITY_INSTANCE_CONNECTED_PARTICIPANTS:
        case (0, $a99sA.Commands).GET_QUEST:
        case (0, $a99sA.Commands).GET_QUEST_ENROLLMENT_STATUS:
        case (0, $a99sA.Commands).GET_RELATIONSHIPS:
        case (0, $a99sA.Commands).GET_USER:
        case (0, $a99sA.Commands).INITIATE_IMAGE_UPLOAD:
        case (0, $a99sA.Commands).INVITE_USER_EMBEDDED:
        case (0, $a99sA.Commands).OPEN_SHARE_MOMENT_DIALOG:
        case (0, $a99sA.Commands).QUEST_START_TIMER:
        case (0, $a99sA.Commands).REQUEST_PROXY_TICKET_REFRESH:
        case (0, $a99sA.Commands).SHARE_INTERACTION:
        case (0, $a99sA.Commands).SHARE_LINK:
            // END-GENERATED-SECTION
            const { response: response } = (0, $3VyrS.Schemas)[cmd];
            return response.parse(data);
        default:
            (0, $8MDgb.default)(cmd, new Error(`Unrecognized command ${cmd}`));
    }
}
function $e961c2ca9d22237b$export$4890fc55aa463c4c(payload) {
    return Object.assign(Object.assign({}, payload), {
        data: $e961c2ca9d22237b$var$parseResponseData(payload)
    });
}

});
parcelRegister("8MDgb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c3ea65d0f5c175b$export$2e2bcd8739ae039; });
/**
 * Assets x is statically unreachable at build-time,
 * and throws at runtime if data is dynamic.
 */ function $2c3ea65d0f5c175b$export$2e2bcd8739ae039(_x, runtimeError) {
    throw runtimeError;
}

});



parcelRegister("7EnVF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9a3509c8fde6941$export$2e2bcd8739ae039; });

var $a99sA = parcelRequire("a99sA");

var $lAABy = parcelRequire("lAABy");

var $h9bNo = parcelRequire("h9bNo");

var $hhTsT = parcelRequire("hhTsT");

var $k7vzO = parcelRequire("k7vzO");

var $Lobjx = parcelRequire("Lobjx");

var $1tqnv = parcelRequire("1tqnv");

var $aahu0 = parcelRequire("aahu0");

var $3BXmj = parcelRequire("3BXmj");

var $lRgu1 = parcelRequire("lRgu1");

var $dsVkN = parcelRequire("dsVkN");

var $fudde = parcelRequire("fudde");

var $4SYET = parcelRequire("4SYET");

var $lnoMU = parcelRequire("lnoMU");

var $ctCvC = parcelRequire("ctCvC");

var $4ynTm = parcelRequire("4ynTm");

var $gA2tE = parcelRequire("gA2tE");

var $azRPY = parcelRequire("azRPY");

var $dO6w9 = parcelRequire("dO6w9");

var $hnTwy = parcelRequire("hnTwy");

var $l8jWz = parcelRequire("l8jWz");

var $gLGY2 = parcelRequire("gLGY2");

var $16h9r = parcelRequire("16h9r");

var $2sNCD = parcelRequire("2sNCD");

var $ezPpT = parcelRequire("ezPpT");

var $egS30 = parcelRequire("egS30");

var $jcc6V = parcelRequire("jcc6V");

var $apPpK = parcelRequire("apPpK");

var $hNvfJ = parcelRequire("hNvfJ");
function $c9a3509c8fde6941$export$2e2bcd8739ae039(sendCommand) {
    return {
        authorize: (0, $lAABy.authorize)(sendCommand),
        captureLog: (0, $h9bNo.captureLog)(sendCommand),
        encourageHardwareAcceleration: (0, $hhTsT.encourageHardwareAcceleration)(sendCommand),
        getChannel: (0, $k7vzO.getChannel)(sendCommand),
        getChannelPermissions: (0, $aahu0.getChannelPermissions)(sendCommand),
        getEntitlements: (0, $Lobjx.getEntitlements)(sendCommand),
        getPlatformBehaviors: (0, $3BXmj.getPlatformBehaviors)(sendCommand),
        getSkus: (0, $1tqnv.getSkus)(sendCommand),
        openExternalLink: (0, $lRgu1.openExternalLink)(sendCommand),
        openInviteDialog: (0, $dsVkN.openInviteDialog)(sendCommand),
        setActivity: (0, $fudde.setActivity)(sendCommand),
        setConfig: (0, $4SYET.setConfig)(sendCommand),
        setOrientationLockState: (0, $lnoMU.setOrientationLockState)(sendCommand),
        startPurchase: (0, $ctCvC.startPurchase)(sendCommand),
        userSettingsGetLocale: (0, $4ynTm.userSettingsGetLocale)(sendCommand),
        // Backward compatibility - getInstanceConnectedParticipants is an alias for getActivityInstanceConnectedParticipants
        getInstanceConnectedParticipants: (0, $azRPY.getActivityInstanceConnectedParticipants)(sendCommand),
        // START-GENERATED-SECTION
        authenticate: (0, $gA2tE.authenticate)(sendCommand),
        getActivityInstanceConnectedParticipants: (0, $azRPY.getActivityInstanceConnectedParticipants)(sendCommand),
        getQuest: (0, $dO6w9.getQuest)(sendCommand),
        getQuestEnrollmentStatus: (0, $hnTwy.getQuestEnrollmentStatus)(sendCommand),
        getRelationships: (0, $l8jWz.getRelationships)(sendCommand),
        getUser: (0, $gLGY2.getUser)(sendCommand),
        initiateImageUpload: (0, $16h9r.initiateImageUpload)(sendCommand),
        inviteUserEmbedded: (0, $2sNCD.inviteUserEmbedded)(sendCommand),
        openShareMomentDialog: (0, $ezPpT.openShareMomentDialog)(sendCommand),
        questStartTimer: (0, $egS30.questStartTimer)(sendCommand),
        requestProxyTicketRefresh: (0, $jcc6V.requestProxyTicketRefresh)(sendCommand),
        shareInteraction: (0, $apPpK.shareInteraction)(sendCommand),
        shareLink: (0, $hNvfJ.shareLink)(sendCommand)
    };
}

});
parcelRegister("lAABy", function(module, exports) {

$parcel$export(module.exports, "authorize", function () { return $683ace9592741663$export$be1f35f80d3e29cc; });

var $a99sA = parcelRequire("a99sA");

var $02MKI = parcelRequire("02MKI");

var $fZMIr = parcelRequire("fZMIr");
/**
 * Should be called directly after a `ready` payload is received from the
 * Discord client. It includes a list of all scopes that your activity would
 * like to be authorized to use. If the user does not yet have a valid token
 * for all scopes requested, this command will open an OAuth modal. Once an
 * authorized token is available, it will be returned in the command response.
 */ const $683ace9592741663$export$be1f35f80d3e29cc = (sendCommand)=>(0, $fZMIr.commandFactory)(sendCommand, (0, $a99sA.Commands).AUTHORIZE, (0, $02MKI.AuthorizeResponse));

});
parcelRegister("fZMIr", function(module, exports) {

$parcel$export(module.exports, "commandFactory", function () { return $3cec6e912f777bf4$export$df09d935d625c3d3; });
$parcel$export(module.exports, "schemaCommandFactory", function () { return $3cec6e912f777bf4$export$3c2dac6e8a4c05f8; });

var $39moO = parcelRequire("39moO");

var $a99sA = parcelRequire("a99sA");

var $3VyrS = parcelRequire("3VyrS");
function $3cec6e912f777bf4$export$df09d935d625c3d3(sendCommand, cmd, response, transferTransform = ()=>undefined) {
    const payload = (0, $a99sA.ReceiveFramePayload).extend({
        cmd: (0, $39moO.literal)(cmd),
        data: response
    });
    return async (args)=>{
        const reply = await sendCommand({
            cmd: cmd,
            args: args,
            transfer: transferTransform(args)
        });
        const parsed = payload.parse(reply);
        return parsed.data;
    };
}
function $3cec6e912f777bf4$export$3c2dac6e8a4c05f8(cmd, transferTransform = ()=>undefined) {
    const response = (0, $3VyrS.Schemas)[cmd].response;
    const payload = (0, $a99sA.ReceiveFramePayload).extend({
        cmd: (0, $39moO.literal)(cmd),
        data: response
    });
    return (sendCommand)=>async (args)=>{
            const reply = await sendCommand({
                // @ts-expect-error - Merge commands
                cmd: cmd,
                args: args,
                transfer: transferTransform(args)
            });
            const parsed = payload.parse(reply);
            return parsed.data;
        };
}

});


parcelRegister("h9bNo", function(module, exports) {

$parcel$export(module.exports, "captureLog", function () { return $b08828a7b9677f2b$export$bd13a7db1bc707cf; });

var $a99sA = parcelRequire("a99sA");

var $02MKI = parcelRequire("02MKI");

var $fZMIr = parcelRequire("fZMIr");
/**
 *
 */ const $b08828a7b9677f2b$export$bd13a7db1bc707cf = (sendCommand)=>(0, $fZMIr.commandFactory)(sendCommand, (0, $a99sA.Commands).CAPTURE_LOG, (0, $02MKI.EmptyResponse));

});

parcelRegister("hhTsT", function(module, exports) {

$parcel$export(module.exports, "encourageHardwareAcceleration", function () { return $d77dedcb2473811a$export$18896ba25f701706; });

var $a99sA = parcelRequire("a99sA");

var $02MKI = parcelRequire("02MKI");

var $fZMIr = parcelRequire("fZMIr");
/**
 *
 */ const $d77dedcb2473811a$export$18896ba25f701706 = (sendCommand)=>(0, $fZMIr.commandFactory)(sendCommand, (0, $a99sA.Commands).ENCOURAGE_HW_ACCELERATION, (0, $02MKI.EncourageHardwareAccelerationResponse));

});

parcelRegister("k7vzO", function(module, exports) {

$parcel$export(module.exports, "getChannel", function () { return $c1e86237264a8579$export$98c37618398a9832; });

var $a99sA = parcelRequire("a99sA");

var $02MKI = parcelRequire("02MKI");

var $fZMIr = parcelRequire("fZMIr");
/**
 *
 * @description
 * RPC documentation here: https://discord.com/developers/docs/topics/rpc#getchannel
 * Calling getChannel gets info about the requested channel such as the channel name.
 *
 * Supported Platforms
 * | Web | iOS | Android |
 * |-----|-----|---------|
 * | ✅  | ✅  | ✅      |
 *
 * Required scopes:
 * - [guilds] for guild channels
 * - [guilds, dm_channels.read] for GDM channels. dm_channels.read requires approval from Discord.
 *
 * @example
 * await discordSdk.commands.getActivity({
 *   channel_id: discordSdk.channelId,
 * });
 */ const $c1e86237264a8579$export$98c37618398a9832 = (sendCommand)=>(0, $fZMIr.commandFactory)(sendCommand, (0, $a99sA.Commands).GET_CHANNEL, (0, $02MKI.GetChannelResponse));

});

parcelRegister("Lobjx", function(module, exports) {

$parcel$export(module.exports, "getEntitlements", function () { return $3e9cbdbb54135027$export$6fb7719f7ba7d022; });

var $a99sA = parcelRequire("a99sA");

var $02MKI = parcelRequire("02MKI");

var $fZMIr = parcelRequire("fZMIr");
/**
 *
 */ const $3e9cbdbb54135027$export$6fb7719f7ba7d022 = (sendCommand)=>(0, $fZMIr.commandFactory)(sendCommand, (0, $a99sA.Commands).GET_ENTITLEMENTS_EMBEDDED, (0, $02MKI.GetEntitlementsResponse));

});

parcelRegister("1tqnv", function(module, exports) {

$parcel$export(module.exports, "getSkus", function () { return $1786eeb9902c03c0$export$dcbcde0b5cdb27ed; });

var $a99sA = parcelRequire("a99sA");

var $02MKI = parcelRequire("02MKI");

var $fZMIr = parcelRequire("fZMIr");
/*
 *
 */ const $1786eeb9902c03c0$export$dcbcde0b5cdb27ed = (sendCommand)=>(0, $fZMIr.commandFactory)(sendCommand, (0, $a99sA.Commands).GET_SKUS_EMBEDDED, (0, $02MKI.GetSkusResponse));

});

parcelRegister("aahu0", function(module, exports) {

$parcel$export(module.exports, "getChannelPermissions", function () { return $50efc7d4f44d1b3d$export$e660ed046f465777; });

var $a99sA = parcelRequire("a99sA");

var $02MKI = parcelRequire("02MKI");

var $fZMIr = parcelRequire("fZMIr");
/**
 * Returns a bigint representing Permissions for the current user in the currently connected channel. Use PermissionsUtils to calculate if a user has a particular permission.
 * Always returns `0n` (no valid permissions) in a (G)DM context, so is unnecessary to call when discordSdk.guildId == null.
 */ const $50efc7d4f44d1b3d$export$e660ed046f465777 = (sendCommand)=>(0, $fZMIr.commandFactory)(sendCommand, (0, $a99sA.Commands).GET_CHANNEL_PERMISSIONS, (0, $02MKI.GetChannelPermissionsResponse));

});

parcelRegister("3BXmj", function(module, exports) {

$parcel$export(module.exports, "getPlatformBehaviors", function () { return $498c4b4c476a474b$export$efbfaabbffdc43d1; });

var $a99sA = parcelRequire("a99sA");

var $02MKI = parcelRequire("02MKI");

var $fZMIr = parcelRequire("fZMIr");
/**
 * Returns an object with information about platform behaviors
 * This command can be utilized to inform and react to a breaking change in platform behavior
 *
 * @returns {GetPlatformBehaviorsPayload} payload - The command return value
 * @returns {boolean} payload.data.iosKeyboardResizesView - If on iOS the webview is resized when the keyboard is opened
 */ const $498c4b4c476a474b$export$efbfaabbffdc43d1 = (sendCommand)=>(0, $fZMIr.commandFactory)(sendCommand, (0, $a99sA.Commands).GET_PLATFORM_BEHAVIORS, (0, $02MKI.GetPlatformBehaviorsResponse));

});

parcelRegister("lRgu1", function(module, exports) {

$parcel$export(module.exports, "openExternalLink", function () { return $0439436af6fcc6d4$export$ade3ab3891e57f44; });

var $a99sA = parcelRequire("a99sA");

var $02MKI = parcelRequire("02MKI");

var $fZMIr = parcelRequire("fZMIr");
/**
 *
 */ const $0439436af6fcc6d4$export$ade3ab3891e57f44 = (sendCommand)=>(0, $fZMIr.commandFactory)(sendCommand, (0, $a99sA.Commands).OPEN_EXTERNAL_LINK, (0, $02MKI.OpenExternalLinkResponse));

});

parcelRegister("dsVkN", function(module, exports) {

$parcel$export(module.exports, "openInviteDialog", function () { return $dbfac2c3e5c14cea$export$d02b38bee2b2489b; });

var $a99sA = parcelRequire("a99sA");

var $02MKI = parcelRequire("02MKI");

var $fZMIr = parcelRequire("fZMIr");
/**
 * Opens the invite dialog within the discord client, allowing users to share invite links to friends.
 * Does not work in (G)DM contexts (throws RPCError.INVALID_CHANNEL), so should not be called if discordSdk.guildId == null
 * Similarly, if the user does not have Permissions.CREATE_INSTANT_INVITE this command throws RPCErrors.INVALID_PERMISSIONS, so checking the user's permissions via getChannelPermissions is highly recommended.
 */ const $dbfac2c3e5c14cea$export$d02b38bee2b2489b = (sendCommand)=>(0, $fZMIr.commandFactory)(sendCommand, (0, $a99sA.Commands).OPEN_INVITE_DIALOG, (0, $02MKI.EmptyResponse));

});

parcelRegister("fudde", function(module, exports) {

$parcel$export(module.exports, "setActivity", function () { return $f1befedb7a1d70a8$export$5e61ed4454e4dc1b; });

var $a99sA = parcelRequire("a99sA");

var $02MKI = parcelRequire("02MKI");

var $fZMIr = parcelRequire("fZMIr");
(0, $a99sA.Activity).pick({
    state: true,
    state_url: true,
    details: true,
    details_url: true,
    timestamps: true,
    assets: true,
    party: true,
    secrets: true,
    instance: true,
    type: true
}).extend({
    type: (0, $a99sA.Activity).shape.type.optional(),
    instance: (0, $a99sA.Activity).shape.instance.optional()
}).nullable();
/**
 *
 * @description
 * RPC documentation here: https://discord.com/developers/docs/topics/rpc#setactivity
 * Calling setActivity allows modifying how your activity's rich presence is displayed in the Discord App
 *
 * Supported Platforms
 * | Web | iOS | Android |
 * |-----|-----|---------|
 * | ✅  | ✅  | ✅      |
 *
 * Required scopes: [rpc.activities.write]
 *
 * @example
 * await discordSdk.commands.setActivity({
 *   activity: {
 *     type: 0,
 *     details: 'Details',
 *     state: 'Playing',
 *   },
 * });
 */ const $f1befedb7a1d70a8$export$5e61ed4454e4dc1b = (sendCommand)=>(0, $fZMIr.commandFactory)(sendCommand, (0, $a99sA.Commands).SET_ACTIVITY, (0, $02MKI.SetActivityResponse));

});

parcelRegister("4SYET", function(module, exports) {

$parcel$export(module.exports, "setConfig", function () { return $a6eb3712f1882c05$export$940a7873bb071df8; });

var $a99sA = parcelRequire("a99sA");

var $02MKI = parcelRequire("02MKI");

var $fZMIr = parcelRequire("fZMIr");
/**
 *
 */ const $a6eb3712f1882c05$export$940a7873bb071df8 = (sendCommand)=>(0, $fZMIr.commandFactory)(sendCommand, (0, $a99sA.Commands).SET_CONFIG, (0, $02MKI.SetConfigResponse));

});

parcelRegister("lnoMU", function(module, exports) {

$parcel$export(module.exports, "setOrientationLockState", function () { return $3dc639fb6bec531a$export$970bc058b4f43d8a; });

var $a99sA = parcelRequire("a99sA");

var $02MKI = parcelRequire("02MKI");

var $es0q5 = parcelRequire("es0q5");
const $3dc639fb6bec531a$var$fallbackTransform = (args)=>{
    return {
        lock_state: args.lock_state,
        picture_in_picture_lock_state: args.picture_in_picture_lock_state
    };
};
const $3dc639fb6bec531a$export$970bc058b4f43d8a = (sendCommand)=>(0, $es0q5.default)({
        sendCommand: sendCommand,
        cmd: (0, $a99sA.Commands).SET_ORIENTATION_LOCK_STATE,
        response: (0, $02MKI.EmptyResponse),
        fallbackTransform: $3dc639fb6bec531a$var$fallbackTransform
    });

});
parcelRegister("es0q5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b1ecd03a48a5e3b$export$2e2bcd8739ae039; });

var $39moO = parcelRequire("39moO");

var $7IqZ6 = parcelRequire("7IqZ6");

var $a99sA = parcelRequire("a99sA");
/**
 * @args - the primary args to send with the command.
 * @fallbackArgs - the args to try the command with in the case where an old Discord
 *  client doesn't support one of the new args.
 */ function $0b1ecd03a48a5e3b$export$2e2bcd8739ae039({ sendCommand: sendCommand, cmd: cmd, response: response, fallbackTransform: fallbackTransform, transferTransform: transferTransform = ()=>undefined }) {
    const payload = (0, $a99sA.ReceiveFramePayload).extend({
        cmd: (0, $39moO.literal)(cmd),
        data: response
    });
    return async (args)=>{
        try {
            const reply = await sendCommand({
                cmd: cmd,
                args: args,
                transfer: transferTransform(args)
            });
            const parsed = payload.parse(reply);
            return parsed.data;
        } catch (error) {
            if (error.code === (0, $7IqZ6.RPCErrorCodes).INVALID_PAYLOAD) {
                const fallbackArgs = fallbackTransform(args);
                const reply = await sendCommand({
                    cmd: cmd,
                    args: fallbackArgs,
                    transfer: transferTransform(fallbackArgs)
                });
                const parsed = payload.parse(reply);
                return parsed.data;
            } else throw error;
        }
    };
}

});


parcelRegister("ctCvC", function(module, exports) {

$parcel$export(module.exports, "startPurchase", function () { return $c522c7222e966fd7$export$fb512c02b6232086; });

var $a99sA = parcelRequire("a99sA");

var $02MKI = parcelRequire("02MKI");

var $fZMIr = parcelRequire("fZMIr");
/**
 *
 */ const $c522c7222e966fd7$export$fb512c02b6232086 = (sendCommand)=>(0, $fZMIr.commandFactory)(sendCommand, (0, $a99sA.Commands).START_PURCHASE, (0, $02MKI.StartPurchaseResponse));

});

parcelRegister("4ynTm", function(module, exports) {

$parcel$export(module.exports, "userSettingsGetLocale", function () { return $716077c0c0d14c51$export$8358d3ac583ae3cc; });

var $a99sA = parcelRequire("a99sA");

var $02MKI = parcelRequire("02MKI");

var $fZMIr = parcelRequire("fZMIr");
/**
 *
 */ const $716077c0c0d14c51$export$8358d3ac583ae3cc = (sendCommand)=>(0, $fZMIr.commandFactory)(sendCommand, (0, $a99sA.Commands).USER_SETTINGS_GET_LOCALE, (0, $02MKI.UserSettingsGetLocaleResponse));

});

parcelRegister("gA2tE", function(module, exports) {

$parcel$export(module.exports, "authenticate", function () { return $92c0bca9e00f2cc3$export$61bb00ddedae72e4; });

var $3VyrS = parcelRequire("3VyrS");

var $fZMIr = parcelRequire("fZMIr");
/**
 * Authenticate Activity
 */ const $92c0bca9e00f2cc3$export$61bb00ddedae72e4 = (0, $fZMIr.schemaCommandFactory)((0, $3VyrS.Command).AUTHENTICATE);

});

parcelRegister("azRPY", function(module, exports) {

$parcel$export(module.exports, "getActivityInstanceConnectedParticipants", function () { return $b0aed4248e9b0a98$export$b446055c1c3a2811; });

var $3VyrS = parcelRequire("3VyrS");

var $fZMIr = parcelRequire("fZMIr");
const $b0aed4248e9b0a98$export$b446055c1c3a2811 = (0, $fZMIr.schemaCommandFactory)((0, $3VyrS.Command).GET_ACTIVITY_INSTANCE_CONNECTED_PARTICIPANTS);

});

parcelRegister("dO6w9", function(module, exports) {

$parcel$export(module.exports, "getQuest", function () { return $225a67209b751049$export$18ef6c6a6928379f; });

var $3VyrS = parcelRequire("3VyrS");

var $fZMIr = parcelRequire("fZMIr");
const $225a67209b751049$export$18ef6c6a6928379f = (0, $fZMIr.schemaCommandFactory)((0, $3VyrS.Command).GET_QUEST);

});

parcelRegister("hnTwy", function(module, exports) {

$parcel$export(module.exports, "getQuestEnrollmentStatus", function () { return $0b66388c2f8434c0$export$12ffbf39da29c43e; });

var $3VyrS = parcelRequire("3VyrS");

var $fZMIr = parcelRequire("fZMIr");
const $0b66388c2f8434c0$export$12ffbf39da29c43e = (0, $fZMIr.schemaCommandFactory)((0, $3VyrS.Command).GET_QUEST_ENROLLMENT_STATUS);

});

parcelRegister("l8jWz", function(module, exports) {

$parcel$export(module.exports, "getRelationships", function () { return $7b83cf94c58466a6$export$ece9beb28e4eb24; });

var $3VyrS = parcelRequire("3VyrS");

var $fZMIr = parcelRequire("fZMIr");
const $7b83cf94c58466a6$export$ece9beb28e4eb24 = (0, $fZMIr.schemaCommandFactory)((0, $3VyrS.Command).GET_RELATIONSHIPS);

});

parcelRegister("gLGY2", function(module, exports) {

$parcel$export(module.exports, "getUser", function () { return $bf8bbbfc039642c9$export$7cbf767827cd68ba; });

var $3VyrS = parcelRequire("3VyrS");

var $fZMIr = parcelRequire("fZMIr");
const $bf8bbbfc039642c9$export$7cbf767827cd68ba = (0, $fZMIr.schemaCommandFactory)((0, $3VyrS.Command).GET_USER);

});

parcelRegister("16h9r", function(module, exports) {

$parcel$export(module.exports, "initiateImageUpload", function () { return $27542a0fa12e980a$export$1870764d8cf96241; });

var $3VyrS = parcelRequire("3VyrS");

var $fZMIr = parcelRequire("fZMIr");
/**
 * Triggers the file upload flow in the Discord app. The user will be prompted to select a valid image file
 * and then it will be uploaded on the app side to the Discord CDN.
 *
 * NOTE: The URL provided by the API is an ephemeral attachment URL, so the image will not be permanently
 * accessible at the link provided.
 *
 * @returns {Promise<{image_url: string}>}
 */ const $27542a0fa12e980a$export$1870764d8cf96241 = (0, $fZMIr.schemaCommandFactory)((0, $3VyrS.Command).INITIATE_IMAGE_UPLOAD);

});

parcelRegister("2sNCD", function(module, exports) {

$parcel$export(module.exports, "inviteUserEmbedded", function () { return $05a2d0e76451276e$export$6ebf76884107f3b0; });

var $3VyrS = parcelRequire("3VyrS");

var $fZMIr = parcelRequire("fZMIr");
const $05a2d0e76451276e$export$6ebf76884107f3b0 = (0, $fZMIr.schemaCommandFactory)((0, $3VyrS.Command).INVITE_USER_EMBEDDED);

});

parcelRegister("ezPpT", function(module, exports) {

$parcel$export(module.exports, "openShareMomentDialog", function () { return $60eeac9fdd22e048$export$de3eb37c8ceccf16; });

var $3VyrS = parcelRequire("3VyrS");

var $fZMIr = parcelRequire("fZMIr");
/**
 * Opens the Share Moment Dialog in the user's client, allowing them to share the media at mediaUrl as a message.
 *
 * @param {string} mediaUrl - a Discord CDN URL for the piece of media to be shared.
 * @returns {Promise<void>}
 */ const $60eeac9fdd22e048$export$de3eb37c8ceccf16 = (0, $fZMIr.schemaCommandFactory)((0, $3VyrS.Command).OPEN_SHARE_MOMENT_DIALOG);

});

parcelRegister("egS30", function(module, exports) {

$parcel$export(module.exports, "questStartTimer", function () { return $2109c3382cf9a1c4$export$128e47a361e01b46; });

var $3VyrS = parcelRequire("3VyrS");

var $fZMIr = parcelRequire("fZMIr");
const $2109c3382cf9a1c4$export$128e47a361e01b46 = (0, $fZMIr.schemaCommandFactory)((0, $3VyrS.Command).QUEST_START_TIMER);

});

parcelRegister("jcc6V", function(module, exports) {

$parcel$export(module.exports, "requestProxyTicketRefresh", function () { return $4e16e7662d1a0bbf$export$49c29e4e2fbf91be; });

var $3VyrS = parcelRequire("3VyrS");

var $fZMIr = parcelRequire("fZMIr");
const $4e16e7662d1a0bbf$export$49c29e4e2fbf91be = (0, $fZMIr.schemaCommandFactory)((0, $3VyrS.Command).REQUEST_PROXY_TICKET_REFRESH);

});

parcelRegister("apPpK", function(module, exports) {

$parcel$export(module.exports, "shareInteraction", function () { return $a1471feae3105863$export$c69b0fe8e5e669dc; });

var $3VyrS = parcelRequire("3VyrS");

var $fZMIr = parcelRequire("fZMIr");
const $a1471feae3105863$export$c69b0fe8e5e669dc = (0, $fZMIr.schemaCommandFactory)((0, $3VyrS.Command).SHARE_INTERACTION);

});

parcelRegister("hNvfJ", function(module, exports) {

$parcel$export(module.exports, "shareLink", function () { return $eec070eed0de30af$export$125499b12b97cddb; });

var $3VyrS = parcelRequire("3VyrS");

var $fZMIr = parcelRequire("fZMIr");
/**
 * Opens a modal in the user's client to share the Activity link.
 *
 * @param {string} referrer_id
 * @param {string} custom_id
 * @param {string} message - message sent alongside link when shared.
 * @returns {Promise<{success: boolean>} whether or not the user shared the link to someone
 */ const $eec070eed0de30af$export$125499b12b97cddb = (0, $fZMIr.schemaCommandFactory)((0, $3VyrS.Command).SHARE_LINK);

});


parcelRegister("kXIns", function(module, exports) {

$parcel$export(module.exports, "SDKError", function () { return $5612559e990a1540$export$e1d52e4f0c7557a1; });
class $5612559e990a1540$export$e1d52e4f0c7557a1 extends Error {
    constructor(code, message = ''){
        super(message);
        this.code = code;
        this.message = message;
        this.name = 'Discord SDK Error';
    }
}

});

parcelRegister("8AQXA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebb1b78e9046950a$export$2e2bcd8739ae039; });
function $ebb1b78e9046950a$export$2e2bcd8739ae039() {
    return {
        disableConsoleLogOverride: false,
        disableAutoHandshake: false
    };
}

});

parcelRegister("jVQNH", function(module, exports) {

$parcel$export(module.exports, "consoleLevels", function () { return $8e3ddc22e5f59cc4$export$a3647e951d1937a9; });
$parcel$export(module.exports, "wrapConsoleMethod", function () { return $8e3ddc22e5f59cc4$export$46a03bf5755ffc4c; });
const $8e3ddc22e5f59cc4$export$a3647e951d1937a9 = [
    'log',
    'warn',
    'debug',
    'info',
    'error'
];
function $8e3ddc22e5f59cc4$export$46a03bf5755ffc4c(console, level, callback) {
    const _consoleMethod = console[level];
    const _console = console;
    if (!_consoleMethod) return;
    console[level] = function() {
        const args = [].slice.call(arguments);
        const message = '' + args.join(' ');
        callback(level, message);
        _consoleMethod.apply(_console, args);
    };
}

});

parcelRegister("2qWFj", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $4c4a612705110c19$export$83d89fbfd8236492; });
var $4c4a612705110c19$export$83d89fbfd8236492 = "2.5.0";

});

parcelRegister("vy6aC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6467ce9014120e92$export$2e2bcd8739ae039; });

var $4czSs = parcelRequire("4czSs");

var $1vFb5 = parcelRequire("1vFb5");

var $34kmr = parcelRequire("34kmr");
function $6467ce9014120e92$export$2e2bcd8739ae039(options, buf, offset) {
    if ((0, $4czSs.default).randomUUID && !buf && !options) return (0, $4czSs.default).randomUUID();
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? (0, $1vFb5.default)();
    if (rnds.length < 16) throw new Error('Random bytes length must be >= 16');
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    return (0, $34kmr.unsafeStringify)(rnds);
}

});
parcelRegister("4czSs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49760d4115687b2d$export$2e2bcd8739ae039; });
const $49760d4115687b2d$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $49760d4115687b2d$export$2e2bcd8739ae039 = {
    randomUUID: $49760d4115687b2d$var$randomUUID
};

});

parcelRegister("1vFb5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61601f2fb311726a$export$2e2bcd8739ae039; });
let $61601f2fb311726a$var$getRandomValues;
const $61601f2fb311726a$var$rnds8 = new Uint8Array(16);
function $61601f2fb311726a$export$2e2bcd8739ae039() {
    if (!$61601f2fb311726a$var$getRandomValues) {
        if (typeof crypto === 'undefined' || !crypto.getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
        $61601f2fb311726a$var$getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return $61601f2fb311726a$var$getRandomValues($61601f2fb311726a$var$rnds8);
}

});

parcelRegister("34kmr", function(module, exports) {

$parcel$export(module.exports, "unsafeStringify", function () { return $2425158a05be4714$export$8fb373d660548968; });
const $2425158a05be4714$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$2425158a05be4714$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $2425158a05be4714$export$8fb373d660548968(arr, offset = 0) {
    return ($2425158a05be4714$var$byteToHex[arr[offset + 0]] + $2425158a05be4714$var$byteToHex[arr[offset + 1]] + $2425158a05be4714$var$byteToHex[arr[offset + 2]] + $2425158a05be4714$var$byteToHex[arr[offset + 3]] + '-' + $2425158a05be4714$var$byteToHex[arr[offset + 4]] + $2425158a05be4714$var$byteToHex[arr[offset + 5]] + '-' + $2425158a05be4714$var$byteToHex[arr[offset + 6]] + $2425158a05be4714$var$byteToHex[arr[offset + 7]] + '-' + $2425158a05be4714$var$byteToHex[arr[offset + 8]] + $2425158a05be4714$var$byteToHex[arr[offset + 9]] + '-' + $2425158a05be4714$var$byteToHex[arr[offset + 10]] + $2425158a05be4714$var$byteToHex[arr[offset + 11]] + $2425158a05be4714$var$byteToHex[arr[offset + 12]] + $2425158a05be4714$var$byteToHex[arr[offset + 13]] + $2425158a05be4714$var$byteToHex[arr[offset + 14]] + $2425158a05be4714$var$byteToHex[arr[offset + 15]]).toLowerCase();
}

});



parcelRegister("4Ko9T", function(module, exports) {

var $cl2KK = parcelRequire("cl2KK");
function $4bb2e0be4390f299$var$can(permission, permissions) {
    return (0, $cl2KK.default).has((0, $cl2KK.default).deserialize(permissions), permission);
}
var $4bb2e0be4390f299$export$2e2bcd8739ae039 = {
    can: $4bb2e0be4390f299$var$can
};

});

parcelRegister("jyNFz", function(module, exports) {

var $k8DwL = parcelRequire("k8DwL");

var $cLQjy = parcelRequire("cLQjy");
function $079ac8d8ce02615f$var$formatPrice(price, locale = 'en-US') {
    const { amount: amount, currency: currency } = price;
    const formatter = Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency
    });
    return formatter.format($079ac8d8ce02615f$var$convertToMajorCurrencyUnits(amount, currency));
}
function $079ac8d8ce02615f$var$convertToMajorCurrencyUnits(minorUnitValue, currency) {
    const exponent = (0, $cLQjy.CurrencyExponents)[currency];
    if (exponent == null) {
        console.warn(`Unexpected currency ${currency}`);
        return minorUnitValue;
    }
    const minorUnit = new (0, $k8DwL.default)(minorUnitValue);
    return minorUnit.dividedBy(10 ** exponent).toNumber();
}
var $079ac8d8ce02615f$export$2e2bcd8739ae039 = {
    formatPrice: $079ac8d8ce02615f$var$formatPrice
};

});
parcelRegister("k8DwL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e1f7b44e116c77f$export$2e2bcd8739ae039; });
/*
 *  decimal.js-light v2.5.1
 *  An arbitrary-precision Decimal type for JavaScript.
 *  https://github.com/MikeMcl/decimal.js-light
 *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
 *  MIT Expat Licence
 */ // ------------------------------------  EDITABLE DEFAULTS  ------------------------------------- //
// The limit on the value of `precision`, and on the value of the first argument to
// `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
var $1e1f7b44e116c77f$var$MAX_DIGITS = 1e9, // The initial configuration properties of the Decimal constructor.
$1e1f7b44e116c77f$var$defaults = {
    // These values must be integers within the stated ranges (inclusive).
    // Most of these values can be changed during run-time using `Decimal.config`.
    // The maximum number of significant digits of the result of a calculation or base conversion.
    // E.g. `Decimal.config({ precision: 20 });`
    precision: 20,
    // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
    // `toFixed`, `toPrecision` and `toSignificantDigits`.
    //
    // ROUND_UP         0 Away from zero.
    // ROUND_DOWN       1 Towards zero.
    // ROUND_CEIL       2 Towards +Infinity.
    // ROUND_FLOOR      3 Towards -Infinity.
    // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
    // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
    // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
    // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
    // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
    //
    // E.g.
    // `Decimal.rounding = 4;`
    // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
    rounding: 4,
    // The exponent value at and beneath which `toString` returns exponential notation.
    // JavaScript numbers: -7
    toExpNeg: -7,
    // The exponent value at and above which `toString` returns exponential notation.
    // JavaScript numbers: 21
    toExpPos: 21,
    // The natural logarithm of 10.
    // 115 digits
    LN10: '2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286'
}, // ------------------------------------ END OF EDITABLE DEFAULTS -------------------------------- //
$1e1f7b44e116c77f$export$95c991896bef8714, $1e1f7b44e116c77f$var$external = true, $1e1f7b44e116c77f$var$decimalError = '[DecimalError] ', $1e1f7b44e116c77f$var$invalidArgument = $1e1f7b44e116c77f$var$decimalError + 'Invalid argument: ', $1e1f7b44e116c77f$var$exponentOutOfRange = $1e1f7b44e116c77f$var$decimalError + 'Exponent out of range: ', $1e1f7b44e116c77f$var$mathfloor = Math.floor, $1e1f7b44e116c77f$var$mathpow = Math.pow, $1e1f7b44e116c77f$var$isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, $1e1f7b44e116c77f$var$ONE, $1e1f7b44e116c77f$var$BASE = 1e7, $1e1f7b44e116c77f$var$LOG_BASE = 7, $1e1f7b44e116c77f$var$MAX_SAFE_INTEGER = 9007199254740991, $1e1f7b44e116c77f$var$MAX_E = $1e1f7b44e116c77f$var$mathfloor($1e1f7b44e116c77f$var$MAX_SAFE_INTEGER / $1e1f7b44e116c77f$var$LOG_BASE), // Decimal.prototype object
$1e1f7b44e116c77f$var$P = {};
// Decimal prototype methods
/*
 *  absoluteValue                       abs
 *  comparedTo                          cmp
 *  decimalPlaces                       dp
 *  dividedBy                           div
 *  dividedToIntegerBy                  idiv
 *  equals                              eq
 *  exponent
 *  greaterThan                         gt
 *  greaterThanOrEqualTo                gte
 *  isInteger                           isint
 *  isNegative                          isneg
 *  isPositive                          ispos
 *  isZero
 *  lessThan                            lt
 *  lessThanOrEqualTo                   lte
 *  logarithm                           log
 *  minus                               sub
 *  modulo                              mod
 *  naturalExponential                  exp
 *  naturalLogarithm                    ln
 *  negated                             neg
 *  plus                                add
 *  precision                           sd
 *  squareRoot                          sqrt
 *  times                               mul
 *  toDecimalPlaces                     todp
 *  toExponential
 *  toFixed
 *  toInteger                           toint
 *  toNumber
 *  toPower                             pow
 *  toPrecision
 *  toSignificantDigits                 tosd
 *  toString
 *  valueOf                             val
 */ /*
 * Return a new Decimal whose value is the absolute value of this Decimal.
 *
 */ $1e1f7b44e116c77f$var$P.absoluteValue = $1e1f7b44e116c77f$var$P.abs = function() {
    var x = new this.constructor(this);
    if (x.s) x.s = 1;
    return x;
};
/*
 * Return
 *   1    if the value of this Decimal is greater than the value of `y`,
 *  -1    if the value of this Decimal is less than the value of `y`,
 *   0    if they have the same value
 *
 */ $1e1f7b44e116c77f$var$P.comparedTo = $1e1f7b44e116c77f$var$P.cmp = function(y) {
    var i, j, xdL, ydL, x = this;
    y = new x.constructor(y);
    // Signs differ?
    if (x.s !== y.s) return x.s || -y.s;
    // Compare exponents.
    if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;
    xdL = x.d.length;
    ydL = y.d.length;
    // Compare digit by digit.
    for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
        if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
    }
    // Compare lengths.
    return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
};
/*
 * Return the number of decimal places of the value of this Decimal.
 *
 */ $1e1f7b44e116c77f$var$P.decimalPlaces = $1e1f7b44e116c77f$var$P.dp = function() {
    var x = this, w = x.d.length - 1, dp = (w - x.e) * $1e1f7b44e116c77f$var$LOG_BASE;
    // Subtract the number of trailing zeros of the last word.
    w = x.d[w];
    if (w) for(; w % 10 == 0; w /= 10)dp--;
    return dp < 0 ? 0 : dp;
};
/*
 * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
 * `precision` significant digits.
 *
 */ $1e1f7b44e116c77f$var$P.dividedBy = $1e1f7b44e116c77f$var$P.div = function(y) {
    return $1e1f7b44e116c77f$var$divide(this, new this.constructor(y));
};
/*
 * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
 * by the value of `y`, truncated to `precision` significant digits.
 *
 */ $1e1f7b44e116c77f$var$P.dividedToIntegerBy = $1e1f7b44e116c77f$var$P.idiv = function(y) {
    var x = this, Ctor = x.constructor;
    return $1e1f7b44e116c77f$var$round($1e1f7b44e116c77f$var$divide(x, new Ctor(y), 0, 1), Ctor.precision);
};
/*
 * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
 *
 */ $1e1f7b44e116c77f$var$P.equals = $1e1f7b44e116c77f$var$P.eq = function(y) {
    return !this.cmp(y);
};
/*
 * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
 *
 */ $1e1f7b44e116c77f$var$P.exponent = function() {
    return $1e1f7b44e116c77f$var$getBase10Exponent(this);
};
/*
 * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
 * false.
 *
 */ $1e1f7b44e116c77f$var$P.greaterThan = $1e1f7b44e116c77f$var$P.gt = function(y) {
    return this.cmp(y) > 0;
};
/*
 * Return true if the value of this Decimal is greater than or equal to the value of `y`,
 * otherwise return false.
 *
 */ $1e1f7b44e116c77f$var$P.greaterThanOrEqualTo = $1e1f7b44e116c77f$var$P.gte = function(y) {
    return this.cmp(y) >= 0;
};
/*
 * Return true if the value of this Decimal is an integer, otherwise return false.
 *
 */ $1e1f7b44e116c77f$var$P.isInteger = $1e1f7b44e116c77f$var$P.isint = function() {
    return this.e > this.d.length - 2;
};
/*
 * Return true if the value of this Decimal is negative, otherwise return false.
 *
 */ $1e1f7b44e116c77f$var$P.isNegative = $1e1f7b44e116c77f$var$P.isneg = function() {
    return this.s < 0;
};
/*
 * Return true if the value of this Decimal is positive, otherwise return false.
 *
 */ $1e1f7b44e116c77f$var$P.isPositive = $1e1f7b44e116c77f$var$P.ispos = function() {
    return this.s > 0;
};
/*
 * Return true if the value of this Decimal is 0, otherwise return false.
 *
 */ $1e1f7b44e116c77f$var$P.isZero = function() {
    return this.s === 0;
};
/*
 * Return true if the value of this Decimal is less than `y`, otherwise return false.
 *
 */ $1e1f7b44e116c77f$var$P.lessThan = $1e1f7b44e116c77f$var$P.lt = function(y) {
    return this.cmp(y) < 0;
};
/*
 * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
 *
 */ $1e1f7b44e116c77f$var$P.lessThanOrEqualTo = $1e1f7b44e116c77f$var$P.lte = function(y) {
    return this.cmp(y) < 1;
};
/*
 * Return the logarithm of the value of this Decimal to the specified base, truncated to
 * `precision` significant digits.
 *
 * If no base is specified, return log[10](x).
 *
 * log[base](x) = ln(x) / ln(base)
 *
 * The maximum error of the result is 1 ulp (unit in the last place).
 *
 * [base] {number|string|Decimal} The base of the logarithm.
 *
 */ $1e1f7b44e116c77f$var$P.logarithm = $1e1f7b44e116c77f$var$P.log = function(base) {
    var r, x = this, Ctor = x.constructor, pr = Ctor.precision, wpr = pr + 5;
    // Default base is 10.
    if (base === void 0) base = new Ctor(10);
    else {
        base = new Ctor(base);
        // log[-b](x) = NaN
        // log[0](x)  = NaN
        // log[1](x)  = NaN
        if (base.s < 1 || base.eq($1e1f7b44e116c77f$var$ONE)) throw Error($1e1f7b44e116c77f$var$decimalError + 'NaN');
    }
    // log[b](-x) = NaN
    // log[b](0) = -Infinity
    if (x.s < 1) throw Error($1e1f7b44e116c77f$var$decimalError + (x.s ? 'NaN' : '-Infinity'));
    // log[b](1) = 0
    if (x.eq($1e1f7b44e116c77f$var$ONE)) return new Ctor(0);
    $1e1f7b44e116c77f$var$external = false;
    r = $1e1f7b44e116c77f$var$divide($1e1f7b44e116c77f$var$ln(x, wpr), $1e1f7b44e116c77f$var$ln(base, wpr), wpr);
    $1e1f7b44e116c77f$var$external = true;
    return $1e1f7b44e116c77f$var$round(r, pr);
};
/*
 * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
 * `precision` significant digits.
 *
 */ $1e1f7b44e116c77f$var$P.minus = $1e1f7b44e116c77f$var$P.sub = function(y) {
    var x = this;
    y = new x.constructor(y);
    return x.s == y.s ? $1e1f7b44e116c77f$var$subtract(x, y) : $1e1f7b44e116c77f$var$add(x, (y.s = -y.s, y));
};
/*
 * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
 * `precision` significant digits.
 *
 */ $1e1f7b44e116c77f$var$P.modulo = $1e1f7b44e116c77f$var$P.mod = function(y) {
    var q, x = this, Ctor = x.constructor, pr = Ctor.precision;
    y = new Ctor(y);
    // x % 0 = NaN
    if (!y.s) throw Error($1e1f7b44e116c77f$var$decimalError + 'NaN');
    // Return x if x is 0.
    if (!x.s) return $1e1f7b44e116c77f$var$round(new Ctor(x), pr);
    // Prevent rounding of intermediate calculations.
    $1e1f7b44e116c77f$var$external = false;
    q = $1e1f7b44e116c77f$var$divide(x, y, 0, 1).times(y);
    $1e1f7b44e116c77f$var$external = true;
    return x.minus(q);
};
/*
 * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
 * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
 * significant digits.
 *
 */ $1e1f7b44e116c77f$var$P.naturalExponential = $1e1f7b44e116c77f$var$P.exp = function() {
    return $1e1f7b44e116c77f$var$exp(this);
};
/*
 * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
 * truncated to `precision` significant digits.
 *
 */ $1e1f7b44e116c77f$var$P.naturalLogarithm = $1e1f7b44e116c77f$var$P.ln = function() {
    return $1e1f7b44e116c77f$var$ln(this);
};
/*
 * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
 * -1.
 *
 */ $1e1f7b44e116c77f$var$P.negated = $1e1f7b44e116c77f$var$P.neg = function() {
    var x = new this.constructor(this);
    x.s = -x.s || 0;
    return x;
};
/*
 * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
 * `precision` significant digits.
 *
 */ $1e1f7b44e116c77f$var$P.plus = $1e1f7b44e116c77f$var$P.add = function(y) {
    var x = this;
    y = new x.constructor(y);
    return x.s == y.s ? $1e1f7b44e116c77f$var$add(x, y) : $1e1f7b44e116c77f$var$subtract(x, (y.s = -y.s, y));
};
/*
 * Return the number of significant digits of the value of this Decimal.
 *
 * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
 *
 */ $1e1f7b44e116c77f$var$P.precision = $1e1f7b44e116c77f$var$P.sd = function(z) {
    var e, sd, w, x = this;
    if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error($1e1f7b44e116c77f$var$invalidArgument + z);
    e = $1e1f7b44e116c77f$var$getBase10Exponent(x) + 1;
    w = x.d.length - 1;
    sd = w * $1e1f7b44e116c77f$var$LOG_BASE + 1;
    w = x.d[w];
    // If non-zero...
    if (w) {
        // Subtract the number of trailing zeros of the last word.
        for(; w % 10 == 0; w /= 10)sd--;
        // Add the number of digits of the first word.
        for(w = x.d[0]; w >= 10; w /= 10)sd++;
    }
    return z && e > sd ? e : sd;
};
/*
 * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
 * significant digits.
 *
 */ $1e1f7b44e116c77f$var$P.squareRoot = $1e1f7b44e116c77f$var$P.sqrt = function() {
    var e, n, pr, r, s, t, wpr, x = this, Ctor = x.constructor;
    // Negative or zero?
    if (x.s < 1) {
        if (!x.s) return new Ctor(0);
        // sqrt(-x) = NaN
        throw Error($1e1f7b44e116c77f$var$decimalError + 'NaN');
    }
    e = $1e1f7b44e116c77f$var$getBase10Exponent(x);
    $1e1f7b44e116c77f$var$external = false;
    // Initial estimate.
    s = Math.sqrt(+x);
    // Math.sqrt underflow/overflow?
    // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
    if (s == 0 || s == 1 / 0) {
        n = $1e1f7b44e116c77f$var$digitsToString(x.d);
        if ((n.length + e) % 2 == 0) n += '0';
        s = Math.sqrt(n);
        e = $1e1f7b44e116c77f$var$mathfloor((e + 1) / 2) - (e < 0 || e % 2);
        if (s == 1 / 0) n = '5e' + e;
        else {
            n = s.toExponential();
            n = n.slice(0, n.indexOf('e') + 1) + e;
        }
        r = new Ctor(n);
    } else r = new Ctor(s.toString());
    pr = Ctor.precision;
    s = wpr = pr + 3;
    // Newton-Raphson iteration.
    for(;;){
        t = r;
        r = t.plus($1e1f7b44e116c77f$var$divide(x, t, wpr + 2)).times(0.5);
        if ($1e1f7b44e116c77f$var$digitsToString(t.d).slice(0, wpr) === (n = $1e1f7b44e116c77f$var$digitsToString(r.d)).slice(0, wpr)) {
            n = n.slice(wpr - 3, wpr + 1);
            // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
            // 4999, i.e. approaching a rounding boundary, continue the iteration.
            if (s == wpr && n == '4999') {
                // On the first iteration only, check to see if rounding up gives the exact result as the
                // nines may infinitely repeat.
                $1e1f7b44e116c77f$var$round(t, pr + 1, 0);
                if (t.times(t).eq(x)) {
                    r = t;
                    break;
                }
            } else if (n != '9999') break;
            wpr += 4;
        }
    }
    $1e1f7b44e116c77f$var$external = true;
    return $1e1f7b44e116c77f$var$round(r, pr);
};
/*
 * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
 * `precision` significant digits.
 *
 */ $1e1f7b44e116c77f$var$P.times = $1e1f7b44e116c77f$var$P.mul = function(y) {
    var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
    // Return 0 if either is 0.
    if (!x.s || !y.s) return new Ctor(0);
    y.s *= x.s;
    e = x.e + y.e;
    xdL = xd.length;
    ydL = yd.length;
    // Ensure xd points to the longer array.
    if (xdL < ydL) {
        r = xd;
        xd = yd;
        yd = r;
        rL = xdL;
        xdL = ydL;
        ydL = rL;
    }
    // Initialise the result array with zeros.
    r = [];
    rL = xdL + ydL;
    for(i = rL; i--;)r.push(0);
    // Multiply!
    for(i = ydL; --i >= 0;){
        carry = 0;
        for(k = xdL + i; k > i;){
            t = r[k] + yd[i] * xd[k - i - 1] + carry;
            r[k--] = t % $1e1f7b44e116c77f$var$BASE | 0;
            carry = t / $1e1f7b44e116c77f$var$BASE | 0;
        }
        r[k] = (r[k] + carry) % $1e1f7b44e116c77f$var$BASE | 0;
    }
    // Remove trailing zeros.
    for(; !r[--rL];)r.pop();
    if (carry) ++e;
    else r.shift();
    y.d = r;
    y.e = e;
    return $1e1f7b44e116c77f$var$external ? $1e1f7b44e116c77f$var$round(y, Ctor.precision) : y;
};
/*
 * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
 * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
 *
 * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
 *
 * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 */ $1e1f7b44e116c77f$var$P.toDecimalPlaces = $1e1f7b44e116c77f$var$P.todp = function(dp, rm) {
    var x = this, Ctor = x.constructor;
    x = new Ctor(x);
    if (dp === void 0) return x;
    $1e1f7b44e116c77f$var$checkInt32(dp, 0, $1e1f7b44e116c77f$var$MAX_DIGITS);
    if (rm === void 0) rm = Ctor.rounding;
    else $1e1f7b44e116c77f$var$checkInt32(rm, 0, 8);
    return $1e1f7b44e116c77f$var$round(x, dp + $1e1f7b44e116c77f$var$getBase10Exponent(x) + 1, rm);
};
/*
 * Return a string representing the value of this Decimal in exponential notation rounded to
 * `dp` fixed decimal places using rounding mode `rounding`.
 *
 * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 */ $1e1f7b44e116c77f$var$P.toExponential = function(dp, rm) {
    var str, x = this, Ctor = x.constructor;
    if (dp === void 0) str = $1e1f7b44e116c77f$var$toString(x, true);
    else {
        $1e1f7b44e116c77f$var$checkInt32(dp, 0, $1e1f7b44e116c77f$var$MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else $1e1f7b44e116c77f$var$checkInt32(rm, 0, 8);
        x = $1e1f7b44e116c77f$var$round(new Ctor(x), dp + 1, rm);
        str = $1e1f7b44e116c77f$var$toString(x, true, dp + 1);
    }
    return str;
};
/*
 * Return a string representing the value of this Decimal in normal (fixed-point) notation to
 * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
 * omitted.
 *
 * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
 *
 * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
 * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
 * (-0).toFixed(3) is '0.000'.
 * (-0.5).toFixed(0) is '-0'.
 *
 */ $1e1f7b44e116c77f$var$P.toFixed = function(dp, rm) {
    var str, y, x = this, Ctor = x.constructor;
    if (dp === void 0) return $1e1f7b44e116c77f$var$toString(x);
    $1e1f7b44e116c77f$var$checkInt32(dp, 0, $1e1f7b44e116c77f$var$MAX_DIGITS);
    if (rm === void 0) rm = Ctor.rounding;
    else $1e1f7b44e116c77f$var$checkInt32(rm, 0, 8);
    y = $1e1f7b44e116c77f$var$round(new Ctor(x), dp + $1e1f7b44e116c77f$var$getBase10Exponent(x) + 1, rm);
    str = $1e1f7b44e116c77f$var$toString(y.abs(), false, dp + $1e1f7b44e116c77f$var$getBase10Exponent(y) + 1);
    // To determine whether to add the minus sign look at the value before it was rounded,
    // i.e. look at `x` rather than `y`.
    return x.isneg() && !x.isZero() ? '-' + str : str;
};
/*
 * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
 * rounding mode `rounding`.
 *
 */ $1e1f7b44e116c77f$var$P.toInteger = $1e1f7b44e116c77f$var$P.toint = function() {
    var x = this, Ctor = x.constructor;
    return $1e1f7b44e116c77f$var$round(new Ctor(x), $1e1f7b44e116c77f$var$getBase10Exponent(x) + 1, Ctor.rounding);
};
/*
 * Return the value of this Decimal converted to a number primitive.
 *
 */ $1e1f7b44e116c77f$var$P.toNumber = function() {
    return +this;
};
/*
 * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
 * truncated to `precision` significant digits.
 *
 * For non-integer or very large exponents pow(x, y) is calculated using
 *
 *   x^y = exp(y*ln(x))
 *
 * The maximum error is 1 ulp (unit in last place).
 *
 * y {number|string|Decimal} The power to which to raise this Decimal.
 *
 */ $1e1f7b44e116c77f$var$P.toPower = $1e1f7b44e116c77f$var$P.pow = function(y) {
    var e, k, pr, r, sign, yIsInt, x = this, Ctor = x.constructor, guard = 12, yn = +(y = new Ctor(y));
    // pow(x, 0) = 1
    if (!y.s) return new Ctor($1e1f7b44e116c77f$var$ONE);
    x = new Ctor(x);
    // pow(0, y > 0) = 0
    // pow(0, y < 0) = Infinity
    if (!x.s) {
        if (y.s < 1) throw Error($1e1f7b44e116c77f$var$decimalError + 'Infinity');
        return x;
    }
    // pow(1, y) = 1
    if (x.eq($1e1f7b44e116c77f$var$ONE)) return x;
    pr = Ctor.precision;
    // pow(x, 1) = x
    if (y.eq($1e1f7b44e116c77f$var$ONE)) return $1e1f7b44e116c77f$var$round(x, pr);
    e = y.e;
    k = y.d.length - 1;
    yIsInt = e >= k;
    sign = x.s;
    if (!yIsInt) {
        // pow(x < 0, y non-integer) = NaN
        if (sign < 0) throw Error($1e1f7b44e116c77f$var$decimalError + 'NaN');
    // If y is a small integer use the 'exponentiation by squaring' algorithm.
    } else if ((k = yn < 0 ? -yn : yn) <= $1e1f7b44e116c77f$var$MAX_SAFE_INTEGER) {
        r = new Ctor($1e1f7b44e116c77f$var$ONE);
        // Max k of 9007199254740991 takes 53 loop iterations.
        // Maximum digits array length; leaves [28, 34] guard digits.
        e = Math.ceil(pr / $1e1f7b44e116c77f$var$LOG_BASE + 4);
        $1e1f7b44e116c77f$var$external = false;
        for(;;){
            if (k % 2) {
                r = r.times(x);
                $1e1f7b44e116c77f$var$truncate(r.d, e);
            }
            k = $1e1f7b44e116c77f$var$mathfloor(k / 2);
            if (k === 0) break;
            x = x.times(x);
            $1e1f7b44e116c77f$var$truncate(x.d, e);
        }
        $1e1f7b44e116c77f$var$external = true;
        return y.s < 0 ? new Ctor($1e1f7b44e116c77f$var$ONE).div(r) : $1e1f7b44e116c77f$var$round(r, pr);
    }
    // Result is negative if x is negative and the last digit of integer y is odd.
    sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;
    x.s = 1;
    $1e1f7b44e116c77f$var$external = false;
    r = y.times($1e1f7b44e116c77f$var$ln(x, pr + guard));
    $1e1f7b44e116c77f$var$external = true;
    r = $1e1f7b44e116c77f$var$exp(r);
    r.s = sign;
    return r;
};
/*
 * Return a string representing the value of this Decimal rounded to `sd` significant digits
 * using rounding mode `rounding`.
 *
 * Return exponential notation if `sd` is less than the number of digits necessary to represent
 * the integer part of the value in normal notation.
 *
 * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 */ $1e1f7b44e116c77f$var$P.toPrecision = function(sd, rm) {
    var e, str, x = this, Ctor = x.constructor;
    if (sd === void 0) {
        e = $1e1f7b44e116c77f$var$getBase10Exponent(x);
        str = $1e1f7b44e116c77f$var$toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
    } else {
        $1e1f7b44e116c77f$var$checkInt32(sd, 1, $1e1f7b44e116c77f$var$MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else $1e1f7b44e116c77f$var$checkInt32(rm, 0, 8);
        x = $1e1f7b44e116c77f$var$round(new Ctor(x), sd, rm);
        e = $1e1f7b44e116c77f$var$getBase10Exponent(x);
        str = $1e1f7b44e116c77f$var$toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
    }
    return str;
};
/*
 * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
 * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
 * omitted.
 *
 * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 */ $1e1f7b44e116c77f$var$P.toSignificantDigits = $1e1f7b44e116c77f$var$P.tosd = function(sd, rm) {
    var x = this, Ctor = x.constructor;
    if (sd === void 0) {
        sd = Ctor.precision;
        rm = Ctor.rounding;
    } else {
        $1e1f7b44e116c77f$var$checkInt32(sd, 1, $1e1f7b44e116c77f$var$MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else $1e1f7b44e116c77f$var$checkInt32(rm, 0, 8);
    }
    return $1e1f7b44e116c77f$var$round(new Ctor(x), sd, rm);
};
/*
 * Return a string representing the value of this Decimal.
 *
 * Return exponential notation if this Decimal has a positive exponent equal to or greater than
 * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
 *
 */ $1e1f7b44e116c77f$var$P.toString = $1e1f7b44e116c77f$var$P.valueOf = $1e1f7b44e116c77f$var$P.val = $1e1f7b44e116c77f$var$P.toJSON = $1e1f7b44e116c77f$var$P[Symbol.for('nodejs.util.inspect.custom')] = function() {
    var x = this, e = $1e1f7b44e116c77f$var$getBase10Exponent(x), Ctor = x.constructor;
    return $1e1f7b44e116c77f$var$toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
};
// Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
/*
 *  add                 P.minus, P.plus
 *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
 *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
 *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
 *  exp                 P.exp, P.pow
 *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
 *                      P.toString, divide, round, toString, exp, ln
 *  getLn10             P.log, ln
 *  getZeroString       digitsToString, toString
 *  ln                  P.log, P.ln, P.pow, exp
 *  parseDecimal        Decimal
 *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
 *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
 *                      divide, getLn10, exp, ln
 *  subtract            P.minus, P.plus
 *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
 *  truncate            P.pow
 *
 *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
 *                      getLn10, exp, ln, parseDecimal, Decimal, config
 */ function $1e1f7b44e116c77f$var$add(x, y) {
    var carry, d, e, i, k, len, xd, yd, Ctor = x.constructor, pr = Ctor.precision;
    // If either is zero...
    if (!x.s || !y.s) {
        // Return x if y is zero.
        // Return y if y is non-zero.
        if (!y.s) y = new Ctor(x);
        return $1e1f7b44e116c77f$var$external ? $1e1f7b44e116c77f$var$round(y, pr) : y;
    }
    xd = x.d;
    yd = y.d;
    // x and y are finite, non-zero numbers with the same sign.
    k = x.e;
    e = y.e;
    xd = xd.slice();
    i = k - e;
    // If base 1e7 exponents differ...
    if (i) {
        if (i < 0) {
            d = xd;
            i = -i;
            len = yd.length;
        } else {
            d = yd;
            e = k;
            len = xd.length;
        }
        // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
        k = Math.ceil(pr / $1e1f7b44e116c77f$var$LOG_BASE);
        len = k > len ? k + 1 : len + 1;
        if (i > len) {
            i = len;
            d.length = 1;
        }
        // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
        d.reverse();
        for(; i--;)d.push(0);
        d.reverse();
    }
    len = xd.length;
    i = yd.length;
    // If yd is longer than xd, swap xd and yd so xd points to the longer array.
    if (len - i < 0) {
        i = len;
        d = yd;
        yd = xd;
        xd = d;
    }
    // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
    for(carry = 0; i;){
        carry = (xd[--i] = xd[i] + yd[i] + carry) / $1e1f7b44e116c77f$var$BASE | 0;
        xd[i] %= $1e1f7b44e116c77f$var$BASE;
    }
    if (carry) {
        xd.unshift(carry);
        ++e;
    }
    // Remove trailing zeros.
    // No need to check for zero, as +x + +y != 0 && -x + -y != 0
    for(len = xd.length; xd[--len] == 0;)xd.pop();
    y.d = xd;
    y.e = e;
    return $1e1f7b44e116c77f$var$external ? $1e1f7b44e116c77f$var$round(y, pr) : y;
}
function $1e1f7b44e116c77f$var$checkInt32(i, min, max) {
    if (i !== ~~i || i < min || i > max) throw Error($1e1f7b44e116c77f$var$invalidArgument + i);
}
function $1e1f7b44e116c77f$var$digitsToString(d) {
    var i, k, ws, indexOfLastWord = d.length - 1, str = '', w = d[0];
    if (indexOfLastWord > 0) {
        str += w;
        for(i = 1; i < indexOfLastWord; i++){
            ws = d[i] + '';
            k = $1e1f7b44e116c77f$var$LOG_BASE - ws.length;
            if (k) str += $1e1f7b44e116c77f$var$getZeroString(k);
            str += ws;
        }
        w = d[i];
        ws = w + '';
        k = $1e1f7b44e116c77f$var$LOG_BASE - ws.length;
        if (k) str += $1e1f7b44e116c77f$var$getZeroString(k);
    } else if (w === 0) return '0';
    // Remove trailing zeros of last w.
    for(; w % 10 === 0;)w /= 10;
    return str + w;
}
var $1e1f7b44e116c77f$var$divide = function() {
    // Assumes non-zero x and k, and hence non-zero result.
    function multiplyInteger(x, k) {
        var temp, carry = 0, i = x.length;
        for(x = x.slice(); i--;){
            temp = x[i] * k + carry;
            x[i] = temp % $1e1f7b44e116c77f$var$BASE | 0;
            carry = temp / $1e1f7b44e116c77f$var$BASE | 0;
        }
        if (carry) x.unshift(carry);
        return x;
    }
    function compare(a, b, aL, bL) {
        var i, r;
        if (aL != bL) r = aL > bL ? 1 : -1;
        else {
            for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                r = a[i] > b[i] ? 1 : -1;
                break;
            }
        }
        return r;
    }
    function subtract(a, b, aL) {
        var i = 0;
        // Subtract b from a.
        for(; aL--;){
            a[aL] -= i;
            i = a[aL] < b[aL] ? 1 : 0;
            a[aL] = i * $1e1f7b44e116c77f$var$BASE + a[aL] - b[aL];
        }
        // Remove leading zeros.
        for(; !a[0] && a.length > 1;)a.shift();
    }
    return function(x, y, pr, dp) {
        var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
        // Either 0?
        if (!x.s) return new Ctor(x);
        if (!y.s) throw Error($1e1f7b44e116c77f$var$decimalError + 'Division by zero');
        e = x.e - y.e;
        yL = yd.length;
        xL = xd.length;
        q = new Ctor(sign);
        qd = q.d = [];
        // Result exponent may be one less than e.
        for(i = 0; yd[i] == (xd[i] || 0);)++i;
        if (yd[i] > (xd[i] || 0)) --e;
        if (pr == null) sd = pr = Ctor.precision;
        else if (dp) sd = pr + ($1e1f7b44e116c77f$var$getBase10Exponent(x) - $1e1f7b44e116c77f$var$getBase10Exponent(y)) + 1;
        else sd = pr;
        if (sd < 0) return new Ctor(0);
        // Convert precision in number of base 10 digits to base 1e7 digits.
        sd = sd / $1e1f7b44e116c77f$var$LOG_BASE + 2 | 0;
        i = 0;
        // divisor < 1e7
        if (yL == 1) {
            k = 0;
            yd = yd[0];
            sd++;
            // k is the carry.
            for(; (i < xL || k) && sd--; i++){
                t = k * $1e1f7b44e116c77f$var$BASE + (xd[i] || 0);
                qd[i] = t / yd | 0;
                k = t % yd | 0;
            }
        // divisor >= 1e7
        } else {
            // Normalise xd and yd so highest order digit of yd is >= BASE/2
            k = $1e1f7b44e116c77f$var$BASE / (yd[0] + 1) | 0;
            if (k > 1) {
                yd = multiplyInteger(yd, k);
                xd = multiplyInteger(xd, k);
                yL = yd.length;
                xL = xd.length;
            }
            xi = yL;
            rem = xd.slice(0, yL);
            remL = rem.length;
            // Add zeros to make remainder as long as divisor.
            for(; remL < yL;)rem[remL++] = 0;
            yz = yd.slice();
            yz.unshift(0);
            yd0 = yd[0];
            if (yd[1] >= $1e1f7b44e116c77f$var$BASE / 2) ++yd0;
            do {
                k = 0;
                // Compare divisor and remainder.
                cmp = compare(yd, rem, yL, remL);
                // If divisor < remainder.
                if (cmp < 0) {
                    // Calculate trial digit, k.
                    rem0 = rem[0];
                    if (yL != remL) rem0 = rem0 * $1e1f7b44e116c77f$var$BASE + (rem[1] || 0);
                    // k will be how many times the divisor goes into the current remainder.
                    k = rem0 / yd0 | 0;
                    //  Algorithm:
                    //  1. product = divisor * trial digit (k)
                    //  2. if product > remainder: product -= divisor, k--
                    //  3. remainder -= product
                    //  4. if product was < remainder at 2:
                    //    5. compare new remainder and divisor
                    //    6. If remainder > divisor: remainder -= divisor, k++
                    if (k > 1) {
                        if (k >= $1e1f7b44e116c77f$var$BASE) k = $1e1f7b44e116c77f$var$BASE - 1;
                        // product = divisor * trial digit.
                        prod = multiplyInteger(yd, k);
                        prodL = prod.length;
                        remL = rem.length;
                        // Compare product and remainder.
                        cmp = compare(prod, rem, prodL, remL);
                        // product > remainder.
                        if (cmp == 1) {
                            k--;
                            // Subtract divisor from product.
                            subtract(prod, yL < prodL ? yz : yd, prodL);
                        }
                    } else {
                        // cmp is -1.
                        // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                        // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                        if (k == 0) cmp = k = 1;
                        prod = yd.slice();
                    }
                    prodL = prod.length;
                    if (prodL < remL) prod.unshift(0);
                    // Subtract product from remainder.
                    subtract(rem, prod, remL);
                    // If product was < previous remainder.
                    if (cmp == -1) {
                        remL = rem.length;
                        // Compare divisor and new remainder.
                        cmp = compare(yd, rem, yL, remL);
                        // If divisor < new remainder, subtract divisor from remainder.
                        if (cmp < 1) {
                            k++;
                            // Subtract divisor from remainder.
                            subtract(rem, yL < remL ? yz : yd, remL);
                        }
                    }
                    remL = rem.length;
                } else if (cmp === 0) {
                    k++;
                    rem = [
                        0
                    ];
                } // if cmp === 1, k will be 0
                // Add the next digit, k, to the result array.
                qd[i++] = k;
                // Update the remainder.
                if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                else {
                    rem = [
                        xd[xi]
                    ];
                    remL = 1;
                }
            }while ((xi++ < xL || rem[0] !== void 0) && sd--);
        }
        // Leading zero?
        if (!qd[0]) qd.shift();
        q.e = e;
        return $1e1f7b44e116c77f$var$round(q, dp ? pr + $1e1f7b44e116c77f$var$getBase10Exponent(q) + 1 : pr);
    };
}();
/*
 * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
 * significant digits.
 *
 * Taylor/Maclaurin series.
 *
 * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
 *
 * Argument reduction:
 *   Repeat x = x / 32, k += 5, until |x| < 0.1
 *   exp(x) = exp(x / 2^k)^(2^k)
 *
 * Previously, the argument was initially reduced by
 * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
 * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
 * found to be slower than just dividing repeatedly by 32 as above.
 *
 * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
 *
 *  exp(x) is non-terminating for any finite, non-zero x.
 *
 */ function $1e1f7b44e116c77f$var$exp(x, sd) {
    var denominator, guard, pow, sum, t, wpr, i = 0, k = 0, Ctor = x.constructor, pr = Ctor.precision;
    if ($1e1f7b44e116c77f$var$getBase10Exponent(x) > 16) throw Error($1e1f7b44e116c77f$var$exponentOutOfRange + $1e1f7b44e116c77f$var$getBase10Exponent(x));
    // exp(0) = 1
    if (!x.s) return new Ctor($1e1f7b44e116c77f$var$ONE);
    if (sd == null) {
        $1e1f7b44e116c77f$var$external = false;
        wpr = pr;
    } else wpr = sd;
    t = new Ctor(0.03125);
    while(x.abs().gte(0.1)){
        x = x.times(t); // x = x / 2^5
        k += 5;
    }
    // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
    guard = Math.log($1e1f7b44e116c77f$var$mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
    wpr += guard;
    denominator = pow = sum = new Ctor($1e1f7b44e116c77f$var$ONE);
    Ctor.precision = wpr;
    for(;;){
        pow = $1e1f7b44e116c77f$var$round(pow.times(x), wpr);
        denominator = denominator.times(++i);
        t = sum.plus($1e1f7b44e116c77f$var$divide(pow, denominator, wpr));
        if ($1e1f7b44e116c77f$var$digitsToString(t.d).slice(0, wpr) === $1e1f7b44e116c77f$var$digitsToString(sum.d).slice(0, wpr)) {
            while(k--)sum = $1e1f7b44e116c77f$var$round(sum.times(sum), wpr);
            Ctor.precision = pr;
            return sd == null ? ($1e1f7b44e116c77f$var$external = true, $1e1f7b44e116c77f$var$round(sum, pr)) : sum;
        }
        sum = t;
    }
}
// Calculate the base 10 exponent from the base 1e7 exponent.
function $1e1f7b44e116c77f$var$getBase10Exponent(x) {
    var e = x.e * $1e1f7b44e116c77f$var$LOG_BASE, w = x.d[0];
    // Add the number of digits of the first word of the digits array.
    for(; w >= 10; w /= 10)e++;
    return e;
}
function $1e1f7b44e116c77f$var$getLn10(Ctor, sd, pr) {
    if (sd > Ctor.LN10.sd()) {
        // Reset global state in case the exception is caught.
        $1e1f7b44e116c77f$var$external = true;
        if (pr) Ctor.precision = pr;
        throw Error($1e1f7b44e116c77f$var$decimalError + 'LN10 precision limit exceeded');
    }
    return $1e1f7b44e116c77f$var$round(new Ctor(Ctor.LN10), sd);
}
function $1e1f7b44e116c77f$var$getZeroString(k) {
    var zs = '';
    for(; k--;)zs += '0';
    return zs;
}
/*
 * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
 * digits.
 *
 *  ln(n) is non-terminating (n != 1)
 *
 */ function $1e1f7b44e116c77f$var$ln(y, sd) {
    var c, c0, denominator, e, numerator, sum, t, wpr, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, pr = Ctor.precision;
    // ln(-x) = NaN
    // ln(0) = -Infinity
    if (x.s < 1) throw Error($1e1f7b44e116c77f$var$decimalError + (x.s ? 'NaN' : '-Infinity'));
    // ln(1) = 0
    if (x.eq($1e1f7b44e116c77f$var$ONE)) return new Ctor(0);
    if (sd == null) {
        $1e1f7b44e116c77f$var$external = false;
        wpr = pr;
    } else wpr = sd;
    if (x.eq(10)) {
        if (sd == null) $1e1f7b44e116c77f$var$external = true;
        return $1e1f7b44e116c77f$var$getLn10(Ctor, wpr);
    }
    wpr += guard;
    Ctor.precision = wpr;
    c = $1e1f7b44e116c77f$var$digitsToString(xd);
    c0 = c.charAt(0);
    e = $1e1f7b44e116c77f$var$getBase10Exponent(x);
    if (Math.abs(e) < 1.5e15) {
        // Argument reduction.
        // The series converges faster the closer the argument is to 1, so using
        // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
        // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
        // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
        // later be divided by this number, then separate out the power of 10 using
        // ln(a*10^b) = ln(a) + b*ln(10).
        // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
        //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
        // max n is 6 (gives 0.7 - 1.3)
        while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
            x = x.times(y);
            c = $1e1f7b44e116c77f$var$digitsToString(x.d);
            c0 = c.charAt(0);
            n++;
        }
        e = $1e1f7b44e116c77f$var$getBase10Exponent(x);
        if (c0 > 1) {
            x = new Ctor('0.' + c);
            e++;
        } else x = new Ctor(c0 + '.' + c.slice(1));
    } else {
        // The argument reduction method above may result in overflow if the argument y is a massive
        // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
        // function using ln(x*10^e) = ln(x) + e*ln(10).
        t = $1e1f7b44e116c77f$var$getLn10(Ctor, wpr + 2, pr).times(e + '');
        x = $1e1f7b44e116c77f$var$ln(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);
        Ctor.precision = pr;
        return sd == null ? ($1e1f7b44e116c77f$var$external = true, $1e1f7b44e116c77f$var$round(x, pr)) : x;
    }
    // x is reduced to a value near 1.
    // Taylor series.
    // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
    // where x = (y - 1)/(y + 1)    (|x| < 1)
    sum = numerator = x = $1e1f7b44e116c77f$var$divide(x.minus($1e1f7b44e116c77f$var$ONE), x.plus($1e1f7b44e116c77f$var$ONE), wpr);
    x2 = $1e1f7b44e116c77f$var$round(x.times(x), wpr);
    denominator = 3;
    for(;;){
        numerator = $1e1f7b44e116c77f$var$round(numerator.times(x2), wpr);
        t = sum.plus($1e1f7b44e116c77f$var$divide(numerator, new Ctor(denominator), wpr));
        if ($1e1f7b44e116c77f$var$digitsToString(t.d).slice(0, wpr) === $1e1f7b44e116c77f$var$digitsToString(sum.d).slice(0, wpr)) {
            sum = sum.times(2);
            // Reverse the argument reduction.
            if (e !== 0) sum = sum.plus($1e1f7b44e116c77f$var$getLn10(Ctor, wpr + 2, pr).times(e + ''));
            sum = $1e1f7b44e116c77f$var$divide(sum, new Ctor(n), wpr);
            Ctor.precision = pr;
            return sd == null ? ($1e1f7b44e116c77f$var$external = true, $1e1f7b44e116c77f$var$round(sum, pr)) : sum;
        }
        sum = t;
        denominator += 2;
    }
}
/*
 * Parse the value of a new Decimal `x` from string `str`.
 */ function $1e1f7b44e116c77f$var$parseDecimal(x, str) {
    var e, i, len;
    // Decimal point?
    if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
    // Exponential form?
    if ((i = str.search(/e/i)) > 0) {
        // Determine exponent.
        if (e < 0) e = i;
        e += +str.slice(i + 1);
        str = str.substring(0, i);
    } else if (e < 0) // Integer.
    e = str.length;
    // Determine leading zeros.
    for(i = 0; str.charCodeAt(i) === 48;)++i;
    // Determine trailing zeros.
    for(len = str.length; str.charCodeAt(len - 1) === 48;)--len;
    str = str.slice(i, len);
    if (str) {
        len -= i;
        e = e - i - 1;
        x.e = $1e1f7b44e116c77f$var$mathfloor(e / $1e1f7b44e116c77f$var$LOG_BASE);
        x.d = [];
        // Transform base
        // e is the base 10 exponent.
        // i is where to slice str to get the first word of the digits array.
        i = (e + 1) % $1e1f7b44e116c77f$var$LOG_BASE;
        if (e < 0) i += $1e1f7b44e116c77f$var$LOG_BASE;
        if (i < len) {
            if (i) x.d.push(+str.slice(0, i));
            for(len -= $1e1f7b44e116c77f$var$LOG_BASE; i < len;)x.d.push(+str.slice(i, i += $1e1f7b44e116c77f$var$LOG_BASE));
            str = str.slice(i);
            i = $1e1f7b44e116c77f$var$LOG_BASE - str.length;
        } else i -= len;
        for(; i--;)str += '0';
        x.d.push(+str);
        if ($1e1f7b44e116c77f$var$external && (x.e > $1e1f7b44e116c77f$var$MAX_E || x.e < -$1e1f7b44e116c77f$var$MAX_E)) throw Error($1e1f7b44e116c77f$var$exponentOutOfRange + e);
    } else {
        // Zero.
        x.s = 0;
        x.e = 0;
        x.d = [
            0
        ];
    }
    return x;
}
/*
 * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
 */ function $1e1f7b44e116c77f$var$round(x, sd, rm) {
    var i, j, k, n, rd, doRound, w, xdi, xd = x.d;
    // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
    // w: the word of xd which contains the rounding digit, a base 1e7 number.
    // xdi: the index of w within xd.
    // n: the number of digits of w.
    // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
    // they had leading zeros)
    // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
    // Get the length of the first word of the digits array xd.
    for(n = 1, k = xd[0]; k >= 10; k /= 10)n++;
    i = sd - n;
    // Is the rounding digit in the first word of xd?
    if (i < 0) {
        i += $1e1f7b44e116c77f$var$LOG_BASE;
        j = sd;
        w = xd[xdi = 0];
    } else {
        xdi = Math.ceil((i + 1) / $1e1f7b44e116c77f$var$LOG_BASE);
        k = xd.length;
        if (xdi >= k) return x;
        w = k = xd[xdi];
        // Get the number of digits of w.
        for(n = 1; k >= 10; k /= 10)n++;
        // Get the index of rd within w.
        i %= $1e1f7b44e116c77f$var$LOG_BASE;
        // Get the index of rd within w, adjusted for leading zeros.
        // The number of leading zeros of w is given by LOG_BASE - n.
        j = i - $1e1f7b44e116c77f$var$LOG_BASE + n;
    }
    if (rm !== void 0) {
        k = $1e1f7b44e116c77f$var$mathpow(10, n - j - 1);
        // Get the rounding digit at index j of w.
        rd = w / k % 10 | 0;
        // Are there any non-zero digits after the rounding digit?
        doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;
        // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
        // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
        // 714.
        doRound = rm < 4 ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 && (i > 0 ? j > 0 ? w / $1e1f7b44e116c77f$var$mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
    }
    if (sd < 1 || !xd[0]) {
        if (doRound) {
            k = $1e1f7b44e116c77f$var$getBase10Exponent(x);
            xd.length = 1;
            // Convert sd to decimal places.
            sd = sd - k - 1;
            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
            xd[0] = $1e1f7b44e116c77f$var$mathpow(10, ($1e1f7b44e116c77f$var$LOG_BASE - sd % $1e1f7b44e116c77f$var$LOG_BASE) % $1e1f7b44e116c77f$var$LOG_BASE);
            x.e = $1e1f7b44e116c77f$var$mathfloor(-sd / $1e1f7b44e116c77f$var$LOG_BASE) || 0;
        } else {
            xd.length = 1;
            // Zero.
            xd[0] = x.e = x.s = 0;
        }
        return x;
    }
    // Remove excess digits.
    if (i == 0) {
        xd.length = xdi;
        k = 1;
        xdi--;
    } else {
        xd.length = xdi + 1;
        k = $1e1f7b44e116c77f$var$mathpow(10, $1e1f7b44e116c77f$var$LOG_BASE - i);
        // E.g. 56700 becomes 56000 if 7 is the rounding digit.
        // j > 0 means i > number of leading zeros of w.
        xd[xdi] = j > 0 ? (w / $1e1f7b44e116c77f$var$mathpow(10, n - j) % $1e1f7b44e116c77f$var$mathpow(10, j) | 0) * k : 0;
    }
    if (doRound) {
        for(;;)// Is the digit to be rounded up in the first word of xd?
        if (xdi == 0) {
            if ((xd[0] += k) == $1e1f7b44e116c77f$var$BASE) {
                xd[0] = 1;
                ++x.e;
            }
            break;
        } else {
            xd[xdi] += k;
            if (xd[xdi] != $1e1f7b44e116c77f$var$BASE) break;
            xd[xdi--] = 0;
            k = 1;
        }
    }
    // Remove trailing zeros.
    for(i = xd.length; xd[--i] === 0;)xd.pop();
    if ($1e1f7b44e116c77f$var$external && (x.e > $1e1f7b44e116c77f$var$MAX_E || x.e < -$1e1f7b44e116c77f$var$MAX_E)) throw Error($1e1f7b44e116c77f$var$exponentOutOfRange + $1e1f7b44e116c77f$var$getBase10Exponent(x));
    return x;
}
function $1e1f7b44e116c77f$var$subtract(x, y) {
    var d, e, i, j, k, len, xd, xe, xLTy, yd, Ctor = x.constructor, pr = Ctor.precision;
    // Return y negated if x is zero.
    // Return x if y is zero and x is non-zero.
    if (!x.s || !y.s) {
        if (y.s) y.s = -y.s;
        else y = new Ctor(x);
        return $1e1f7b44e116c77f$var$external ? $1e1f7b44e116c77f$var$round(y, pr) : y;
    }
    xd = x.d;
    yd = y.d;
    // x and y are non-zero numbers with the same sign.
    e = y.e;
    xe = x.e;
    xd = xd.slice();
    k = xe - e;
    // If exponents differ...
    if (k) {
        xLTy = k < 0;
        if (xLTy) {
            d = xd;
            k = -k;
            len = yd.length;
        } else {
            d = yd;
            e = xe;
            len = xd.length;
        }
        // Numbers with massively different exponents would result in a very high number of zeros
        // needing to be prepended, but this can be avoided while still ensuring correct rounding by
        // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
        i = Math.max(Math.ceil(pr / $1e1f7b44e116c77f$var$LOG_BASE), len) + 2;
        if (k > i) {
            k = i;
            d.length = 1;
        }
        // Prepend zeros to equalise exponents.
        d.reverse();
        for(i = k; i--;)d.push(0);
        d.reverse();
    // Base 1e7 exponents equal.
    } else {
        // Check digits to determine which is the bigger number.
        i = xd.length;
        len = yd.length;
        xLTy = i < len;
        if (xLTy) len = i;
        for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
            xLTy = xd[i] < yd[i];
            break;
        }
        k = 0;
    }
    if (xLTy) {
        d = xd;
        xd = yd;
        yd = d;
        y.s = -y.s;
    }
    len = xd.length;
    // Append zeros to xd if shorter.
    // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
    for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
    // Subtract yd from xd.
    for(i = yd.length; i > k;){
        if (xd[--i] < yd[i]) {
            for(j = i; j && xd[--j] === 0;)xd[j] = $1e1f7b44e116c77f$var$BASE - 1;
            --xd[j];
            xd[i] += $1e1f7b44e116c77f$var$BASE;
        }
        xd[i] -= yd[i];
    }
    // Remove trailing zeros.
    for(; xd[--len] === 0;)xd.pop();
    // Remove leading zeros and adjust exponent accordingly.
    for(; xd[0] === 0; xd.shift())--e;
    // Zero?
    if (!xd[0]) return new Ctor(0);
    y.d = xd;
    y.e = e;
    //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
    return $1e1f7b44e116c77f$var$external ? $1e1f7b44e116c77f$var$round(y, pr) : y;
}
function $1e1f7b44e116c77f$var$toString(x, isExp, sd) {
    var k, e = $1e1f7b44e116c77f$var$getBase10Exponent(x), str = $1e1f7b44e116c77f$var$digitsToString(x.d), len = str.length;
    if (isExp) {
        if (sd && (k = sd - len) > 0) str = str.charAt(0) + '.' + str.slice(1) + $1e1f7b44e116c77f$var$getZeroString(k);
        else if (len > 1) str = str.charAt(0) + '.' + str.slice(1);
        str = str + (e < 0 ? 'e' : 'e+') + e;
    } else if (e < 0) {
        str = '0.' + $1e1f7b44e116c77f$var$getZeroString(-e - 1) + str;
        if (sd && (k = sd - len) > 0) str += $1e1f7b44e116c77f$var$getZeroString(k);
    } else if (e >= len) {
        str += $1e1f7b44e116c77f$var$getZeroString(e + 1 - len);
        if (sd && (k = sd - e - 1) > 0) str = str + '.' + $1e1f7b44e116c77f$var$getZeroString(k);
    } else {
        if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
        if (sd && (k = sd - len) > 0) {
            if (e + 1 === len) str += '.';
            str += $1e1f7b44e116c77f$var$getZeroString(k);
        }
    }
    return x.s < 0 ? '-' + str : str;
}
// Does not strip trailing zeros.
function $1e1f7b44e116c77f$var$truncate(arr, len) {
    if (arr.length > len) {
        arr.length = len;
        return true;
    }
}
// Decimal methods
/*
 *  clone
 *  config/set
 */ /*
 * Create and return a Decimal constructor with the same configuration properties as this Decimal
 * constructor.
 *
 */ function $1e1f7b44e116c77f$var$clone(obj) {
    var i, p, ps;
    /*
   * The Decimal constructor and exported function.
   * Return a new Decimal instance.
   *
   * value {number|string|Decimal} A numeric value.
   *
   */ function Decimal(value) {
        var x = this;
        // Decimal called without new.
        if (!(x instanceof Decimal)) return new Decimal(value);
        // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
        // which points to Object.
        x.constructor = Decimal;
        // Duplicate.
        if (value instanceof Decimal) {
            x.s = value.s;
            x.e = value.e;
            x.d = (value = value.d) ? value.slice() : value;
            return;
        }
        if (typeof value === 'number') {
            // Reject Infinity/NaN.
            if (value * 0 !== 0) throw Error($1e1f7b44e116c77f$var$invalidArgument + value);
            if (value > 0) x.s = 1;
            else if (value < 0) {
                value = -value;
                x.s = -1;
            } else {
                x.s = 0;
                x.e = 0;
                x.d = [
                    0
                ];
                return;
            }
            // Fast path for small integers.
            if (value === ~~value && value < 1e7) {
                x.e = 0;
                x.d = [
                    value
                ];
                return;
            }
            return $1e1f7b44e116c77f$var$parseDecimal(x, value.toString());
        } else if (typeof value !== 'string') throw Error($1e1f7b44e116c77f$var$invalidArgument + value);
        // Minus sign?
        if (value.charCodeAt(0) === 45) {
            value = value.slice(1);
            x.s = -1;
        } else x.s = 1;
        if ($1e1f7b44e116c77f$var$isDecimal.test(value)) $1e1f7b44e116c77f$var$parseDecimal(x, value);
        else throw Error($1e1f7b44e116c77f$var$invalidArgument + value);
    }
    Decimal.prototype = $1e1f7b44e116c77f$var$P;
    Decimal.ROUND_UP = 0;
    Decimal.ROUND_DOWN = 1;
    Decimal.ROUND_CEIL = 2;
    Decimal.ROUND_FLOOR = 3;
    Decimal.ROUND_HALF_UP = 4;
    Decimal.ROUND_HALF_DOWN = 5;
    Decimal.ROUND_HALF_EVEN = 6;
    Decimal.ROUND_HALF_CEIL = 7;
    Decimal.ROUND_HALF_FLOOR = 8;
    Decimal.clone = $1e1f7b44e116c77f$var$clone;
    Decimal.config = Decimal.set = $1e1f7b44e116c77f$var$config;
    if (obj === void 0) obj = {};
    if (obj) {
        ps = [
            'precision',
            'rounding',
            'toExpNeg',
            'toExpPos',
            'LN10'
        ];
        for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
    }
    Decimal.config(obj);
    return Decimal;
}
/*
 * Configure global settings for a Decimal constructor.
 *
 * `obj` is an object with one or more of the following properties,
 *
 *   precision  {number}
 *   rounding   {number}
 *   toExpNeg   {number}
 *   toExpPos   {number}
 *
 * E.g. Decimal.config({ precision: 20, rounding: 4 })
 *
 */ function $1e1f7b44e116c77f$var$config(obj) {
    if (!obj || typeof obj !== 'object') throw Error($1e1f7b44e116c77f$var$decimalError + 'Object expected');
    var i, p, v, ps = [
        'precision',
        1,
        $1e1f7b44e116c77f$var$MAX_DIGITS,
        'rounding',
        0,
        8,
        'toExpNeg',
        -1 / 0,
        0,
        'toExpPos',
        0,
        1 / 0
    ];
    for(i = 0; i < ps.length; i += 3)if ((v = obj[p = ps[i]]) !== void 0) {
        if ($1e1f7b44e116c77f$var$mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
        else throw Error($1e1f7b44e116c77f$var$invalidArgument + p + ': ' + v);
    }
    if ((v = obj[p = 'LN10']) !== void 0) {
        if (v == Math.LN10) this[p] = new this(v);
        else throw Error($1e1f7b44e116c77f$var$invalidArgument + p + ': ' + v);
    }
    return this;
}
// Create and configure initial Decimal constructor.
var $1e1f7b44e116c77f$export$95c991896bef8714 = $1e1f7b44e116c77f$var$clone($1e1f7b44e116c77f$var$defaults);
// Internal constant.
$1e1f7b44e116c77f$var$ONE = new $1e1f7b44e116c77f$export$95c991896bef8714(1);
var $1e1f7b44e116c77f$export$2e2bcd8739ae039 = $1e1f7b44e116c77f$export$95c991896bef8714;

});

parcelRegister("cLQjy", function(module, exports) {

$parcel$export(module.exports, "CurrencyExponents", function () { return $8cee574e9852cd99$export$610339706cd0bc07; });
var $8cee574e9852cd99$export$82cf6e3d4c009fa7;
(function(CurrencyCodes) {
    CurrencyCodes["AED"] = "aed";
    CurrencyCodes["AFN"] = "afn";
    CurrencyCodes["ALL"] = "all";
    CurrencyCodes["AMD"] = "amd";
    CurrencyCodes["ANG"] = "ang";
    CurrencyCodes["AOA"] = "aoa";
    CurrencyCodes["ARS"] = "ars";
    CurrencyCodes["AUD"] = "aud";
    CurrencyCodes["AWG"] = "awg";
    CurrencyCodes["AZN"] = "azn";
    CurrencyCodes["BAM"] = "bam";
    CurrencyCodes["BBD"] = "bbd";
    CurrencyCodes["BDT"] = "bdt";
    CurrencyCodes["BGN"] = "bgn";
    CurrencyCodes["BHD"] = "bhd";
    CurrencyCodes["BIF"] = "bif";
    CurrencyCodes["BMD"] = "bmd";
    CurrencyCodes["BND"] = "bnd";
    CurrencyCodes["BOB"] = "bob";
    CurrencyCodes["BOV"] = "bov";
    CurrencyCodes["BRL"] = "brl";
    CurrencyCodes["BSD"] = "bsd";
    CurrencyCodes["BTN"] = "btn";
    CurrencyCodes["BWP"] = "bwp";
    CurrencyCodes["BYN"] = "byn";
    CurrencyCodes["BYR"] = "byr";
    CurrencyCodes["BZD"] = "bzd";
    CurrencyCodes["CAD"] = "cad";
    CurrencyCodes["CDF"] = "cdf";
    CurrencyCodes["CHE"] = "che";
    CurrencyCodes["CHF"] = "chf";
    CurrencyCodes["CHW"] = "chw";
    CurrencyCodes["CLF"] = "clf";
    CurrencyCodes["CLP"] = "clp";
    CurrencyCodes["CNY"] = "cny";
    CurrencyCodes["COP"] = "cop";
    CurrencyCodes["COU"] = "cou";
    CurrencyCodes["CRC"] = "crc";
    CurrencyCodes["CUC"] = "cuc";
    CurrencyCodes["CUP"] = "cup";
    CurrencyCodes["CVE"] = "cve";
    CurrencyCodes["CZK"] = "czk";
    CurrencyCodes["DJF"] = "djf";
    CurrencyCodes["DKK"] = "dkk";
    CurrencyCodes["DOP"] = "dop";
    CurrencyCodes["DZD"] = "dzd";
    CurrencyCodes["EGP"] = "egp";
    CurrencyCodes["ERN"] = "ern";
    CurrencyCodes["ETB"] = "etb";
    CurrencyCodes["EUR"] = "eur";
    CurrencyCodes["FJD"] = "fjd";
    CurrencyCodes["FKP"] = "fkp";
    CurrencyCodes["GBP"] = "gbp";
    CurrencyCodes["GEL"] = "gel";
    CurrencyCodes["GHS"] = "ghs";
    CurrencyCodes["GIP"] = "gip";
    CurrencyCodes["GMD"] = "gmd";
    CurrencyCodes["GNF"] = "gnf";
    CurrencyCodes["GTQ"] = "gtq";
    CurrencyCodes["GYD"] = "gyd";
    CurrencyCodes["HKD"] = "hkd";
    CurrencyCodes["HNL"] = "hnl";
    CurrencyCodes["HRK"] = "hrk";
    CurrencyCodes["HTG"] = "htg";
    CurrencyCodes["HUF"] = "huf";
    CurrencyCodes["IDR"] = "idr";
    CurrencyCodes["ILS"] = "ils";
    CurrencyCodes["INR"] = "inr";
    CurrencyCodes["IQD"] = "iqd";
    CurrencyCodes["IRR"] = "irr";
    CurrencyCodes["ISK"] = "isk";
    CurrencyCodes["JMD"] = "jmd";
    CurrencyCodes["JOD"] = "jod";
    CurrencyCodes["JPY"] = "jpy";
    CurrencyCodes["KES"] = "kes";
    CurrencyCodes["KGS"] = "kgs";
    CurrencyCodes["KHR"] = "khr";
    CurrencyCodes["KMF"] = "kmf";
    CurrencyCodes["KPW"] = "kpw";
    CurrencyCodes["KRW"] = "krw";
    CurrencyCodes["KWD"] = "kwd";
    CurrencyCodes["KYD"] = "kyd";
    CurrencyCodes["KZT"] = "kzt";
    CurrencyCodes["LAK"] = "lak";
    CurrencyCodes["LBP"] = "lbp";
    CurrencyCodes["LKR"] = "lkr";
    CurrencyCodes["LRD"] = "lrd";
    CurrencyCodes["LSL"] = "lsl";
    CurrencyCodes["LTL"] = "ltl";
    CurrencyCodes["LVL"] = "lvl";
    CurrencyCodes["LYD"] = "lyd";
    CurrencyCodes["MAD"] = "mad";
    CurrencyCodes["MDL"] = "mdl";
    CurrencyCodes["MGA"] = "mga";
    CurrencyCodes["MKD"] = "mkd";
    CurrencyCodes["MMK"] = "mmk";
    CurrencyCodes["MNT"] = "mnt";
    CurrencyCodes["MOP"] = "mop";
    CurrencyCodes["MRO"] = "mro";
    CurrencyCodes["MUR"] = "mur";
    CurrencyCodes["MVR"] = "mvr";
    CurrencyCodes["MWK"] = "mwk";
    CurrencyCodes["MXN"] = "mxn";
    CurrencyCodes["MXV"] = "mxv";
    CurrencyCodes["MYR"] = "myr";
    CurrencyCodes["MZN"] = "mzn";
    CurrencyCodes["NAD"] = "nad";
    CurrencyCodes["NGN"] = "ngn";
    CurrencyCodes["NIO"] = "nio";
    CurrencyCodes["NOK"] = "nok";
    CurrencyCodes["NPR"] = "npr";
    CurrencyCodes["NZD"] = "nzd";
    CurrencyCodes["OMR"] = "omr";
    CurrencyCodes["PAB"] = "pab";
    CurrencyCodes["PEN"] = "pen";
    CurrencyCodes["PGK"] = "pgk";
    CurrencyCodes["PHP"] = "php";
    CurrencyCodes["PKR"] = "pkr";
    CurrencyCodes["PLN"] = "pln";
    CurrencyCodes["PYG"] = "pyg";
    CurrencyCodes["QAR"] = "qar";
    CurrencyCodes["RON"] = "ron";
    CurrencyCodes["RSD"] = "rsd";
    CurrencyCodes["RUB"] = "rub";
    CurrencyCodes["RWF"] = "rwf";
    CurrencyCodes["SAR"] = "sar";
    CurrencyCodes["SBD"] = "sbd";
    CurrencyCodes["SCR"] = "scr";
    CurrencyCodes["SDG"] = "sdg";
    CurrencyCodes["SEK"] = "sek";
    CurrencyCodes["SGD"] = "sgd";
    CurrencyCodes["SHP"] = "shp";
    CurrencyCodes["SLL"] = "sll";
    CurrencyCodes["SOS"] = "sos";
    CurrencyCodes["SRD"] = "srd";
    CurrencyCodes["SSP"] = "ssp";
    CurrencyCodes["STD"] = "std";
    CurrencyCodes["SVC"] = "svc";
    CurrencyCodes["SYP"] = "syp";
    CurrencyCodes["SZL"] = "szl";
    CurrencyCodes["THB"] = "thb";
    CurrencyCodes["TJS"] = "tjs";
    CurrencyCodes["TMT"] = "tmt";
    CurrencyCodes["TND"] = "tnd";
    CurrencyCodes["TOP"] = "top";
    CurrencyCodes["TRY"] = "try";
    CurrencyCodes["TTD"] = "ttd";
    CurrencyCodes["TWD"] = "twd";
    CurrencyCodes["TZS"] = "tzs";
    CurrencyCodes["UAH"] = "uah";
    CurrencyCodes["UGX"] = "ugx";
    CurrencyCodes["USD"] = "usd";
    CurrencyCodes["USN"] = "usn";
    CurrencyCodes["USS"] = "uss";
    CurrencyCodes["UYI"] = "uyi";
    CurrencyCodes["UYU"] = "uyu";
    CurrencyCodes["UZS"] = "uzs";
    CurrencyCodes["VEF"] = "vef";
    CurrencyCodes["VND"] = "vnd";
    CurrencyCodes["VUV"] = "vuv";
    CurrencyCodes["WST"] = "wst";
    CurrencyCodes["XAF"] = "xaf";
    CurrencyCodes["XAG"] = "xag";
    CurrencyCodes["XAU"] = "xau";
    CurrencyCodes["XBA"] = "xba";
    CurrencyCodes["XBB"] = "xbb";
    CurrencyCodes["XBC"] = "xbc";
    CurrencyCodes["XBD"] = "xbd";
    CurrencyCodes["XCD"] = "xcd";
    CurrencyCodes["XDR"] = "xdr";
    CurrencyCodes["XFU"] = "xfu";
    CurrencyCodes["XOF"] = "xof";
    CurrencyCodes["XPD"] = "xpd";
    CurrencyCodes["XPF"] = "xpf";
    CurrencyCodes["XPT"] = "xpt";
    CurrencyCodes["XSU"] = "xsu";
    CurrencyCodes["XTS"] = "xts";
    CurrencyCodes["XUA"] = "xua";
    CurrencyCodes["YER"] = "yer";
    CurrencyCodes["ZAR"] = "zar";
    CurrencyCodes["ZMW"] = "zmw";
    CurrencyCodes["ZWL"] = "zwl";
})($8cee574e9852cd99$export$82cf6e3d4c009fa7 || ($8cee574e9852cd99$export$82cf6e3d4c009fa7 = {}));
const $8cee574e9852cd99$export$610339706cd0bc07 = {
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.AED]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.AFN]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.ALL]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.AMD]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.ANG]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.AOA]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.ARS]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.AUD]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.AWG]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.AZN]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.BAM]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.BBD]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.BDT]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.BGN]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.BHD]: 3,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.BIF]: 0,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.BMD]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.BND]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.BOB]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.BOV]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.BRL]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.BSD]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.BTN]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.BWP]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.BYR]: 0,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.BYN]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.BZD]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.CAD]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.CDF]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.CHE]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.CHF]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.CHW]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.CLF]: 0,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.CLP]: 0,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.CNY]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.COP]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.COU]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.CRC]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.CUC]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.CUP]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.CVE]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.CZK]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.DJF]: 0,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.DKK]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.DOP]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.DZD]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.EGP]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.ERN]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.ETB]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.EUR]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.FJD]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.FKP]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.GBP]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.GEL]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.GHS]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.GIP]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.GMD]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.GNF]: 0,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.GTQ]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.GYD]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.HKD]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.HNL]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.HRK]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.HTG]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.HUF]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.IDR]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.ILS]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.INR]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.IQD]: 3,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.IRR]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.ISK]: 0,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.JMD]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.JOD]: 3,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.JPY]: 0,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.KES]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.KGS]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.KHR]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.KMF]: 0,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.KPW]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.KRW]: 0,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.KWD]: 3,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.KYD]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.KZT]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.LAK]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.LBP]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.LKR]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.LRD]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.LSL]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.LTL]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.LVL]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.LYD]: 3,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.MAD]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.MDL]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.MGA]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.MKD]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.MMK]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.MNT]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.MOP]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.MRO]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.MUR]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.MVR]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.MWK]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.MXN]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.MXV]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.MYR]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.MZN]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.NAD]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.NGN]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.NIO]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.NOK]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.NPR]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.NZD]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.OMR]: 3,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.PAB]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.PEN]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.PGK]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.PHP]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.PKR]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.PLN]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.PYG]: 0,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.QAR]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.RON]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.RSD]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.RUB]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.RWF]: 0,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.SAR]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.SBD]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.SCR]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.SDG]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.SEK]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.SGD]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.SHP]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.SLL]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.SOS]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.SRD]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.SSP]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.STD]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.SVC]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.SYP]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.SZL]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.THB]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.TJS]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.TMT]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.TND]: 3,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.TOP]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.TRY]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.TTD]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.TWD]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.TZS]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.UAH]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.UGX]: 0,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.USD]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.USN]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.USS]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.UYI]: 0,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.UYU]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.UZS]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.VEF]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.VND]: 0,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.VUV]: 0,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.WST]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.XAF]: 0,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.XAG]: 0,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.XAU]: 0,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.XBA]: 0,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.XBB]: 0,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.XBC]: 0,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.XBD]: 0,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.XCD]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.XDR]: 0,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.XFU]: 0,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.XOF]: 0,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.XPD]: 0,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.XPF]: 0,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.XPT]: 0,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.XSU]: 0,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.XTS]: 0,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.XUA]: 0,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.YER]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.ZAR]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.ZMW]: 2,
    [$8cee574e9852cd99$export$82cf6e3d4c009fa7.ZWL]: 2
};

});


parcelRegister("6FshM", function(module, exports) {

var $4OTKi = parcelRequire("4OTKi");

var $hOcGE = parcelRequire("hOcGE");

var $6h0kA = parcelRequire("6h0kA");

var $7IqZ6 = parcelRequire("7IqZ6");

var $8AQXA = parcelRequire("8AQXA");

var $a99sA = parcelRequire("a99sA");
class $8cdbcf080968577d$export$112ebc686c39e9ae {
    constructor(clientId, guildId, channelId, locationId){
        this.platform = (0, $7IqZ6.Platform).DESKTOP;
        this.instanceId = '123456789012345678';
        this.configuration = (0, $8AQXA.default)();
        this.source = null;
        this.sourceOrigin = '';
        this.sdkVersion = 'mock';
        this.mobileAppVersion = 'unknown';
        this.frameId = 'aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa';
        this.eventBus = new (0, $4OTKi.default)();
        this.clientId = clientId;
        this.commands = this._updateCommandMocks({});
        this.guildId = guildId;
        this.channelId = channelId;
        this.locationId = locationId;
        this.customId = null;
        this.referrerId = null;
    }
    _updateCommandMocks(newCommands) {
        // Wrap all the command functions with logging
        this.commands = (0, $6h0kA.default)(Object.assign({}, $8cdbcf080968577d$export$df10d8e5927d39a4, newCommands), (mock, func, name)=>{
            mock[name] = async (...args)=>{
                console.info(`DiscordSDKMock: ${String(name)}(${JSON.stringify(args)})`);
                return await func(...args);
            };
        });
        // redundant return here to satisfy the constructor defining commands
        return this.commands;
    }
    emitReady() {
        this.emitEvent('READY', undefined);
    }
    handshake() {
        this.emitReady();
    }
    close(...args) {
        console.info(`DiscordSDKMock: close(${JSON.stringify(args)})`);
    }
    ready() {
        return Promise.resolve();
    }
    async subscribe(event, listener, ..._subscribeArgs) {
        return await this.eventBus.on(event, listener);
    }
    async unsubscribe(event, listener, ..._unsubscribeArgs) {
        return await this.eventBus.off(event, listener);
    }
    emitEvent(event, data) {
        this.eventBus.emit(event, data);
    }
}
/** Default return values for all discord SDK commands */ const $8cdbcf080968577d$export$df10d8e5927d39a4 = {
    authorize: ()=>Promise.resolve({
            code: 'mock_code'
        }),
    setActivity: ()=>Promise.resolve({
            name: 'mock_activity_name',
            type: 0
        }),
    getChannel: ()=>Promise.resolve({
            id: 'mock_channel_id',
            name: 'mock_channel_name',
            type: (0, $a99sA.ChannelTypesObject).GUILD_TEXT,
            voice_states: [],
            messages: []
        }),
    getSkus: ()=>Promise.resolve({
            skus: []
        }),
    getEntitlements: ()=>Promise.resolve({
            entitlements: []
        }),
    startPurchase: ()=>Promise.resolve([]),
    setConfig: ()=>Promise.resolve({
            use_interactive_pip: false
        }),
    userSettingsGetLocale: ()=>Promise.resolve({
            locale: ''
        }),
    openExternalLink: ()=>Promise.resolve({
            opened: false
        }),
    encourageHardwareAcceleration: ()=>Promise.resolve({
            enabled: true
        }),
    captureLog: ()=>Promise.resolve(null),
    setOrientationLockState: ()=>Promise.resolve(null),
    openInviteDialog: ()=>Promise.resolve(null),
    getPlatformBehaviors: ()=>Promise.resolve({
            iosKeyboardResizesView: true
        }),
    getChannelPermissions: ()=>Promise.resolve({
            permissions: (0, $hOcGE.default)(1234567890)
        }),
    getInstanceConnectedParticipants: ()=>Promise.resolve({
            participants: []
        }),
    // START-GENERATED-SECTION
    openShareMomentDialog: ()=>Promise.resolve(null),
    authenticate: ()=>Promise.resolve({
            access_token: 'mock_token',
            user: {
                username: 'mock_user_username',
                discriminator: 'mock_user_discriminator',
                id: 'mock_user_id',
                avatar: null,
                public_flags: 1
            },
            scopes: [],
            expires: new Date(2121, 1, 1).toString(),
            application: {
                description: 'mock_app_description',
                icon: 'mock_app_icon',
                id: 'mock_app_id',
                name: 'mock_app_name'
            }
        }),
    shareLink: ()=>Promise.resolve({
            success: false,
            didSendMessage: false,
            didCopyLink: false
        }),
    initiateImageUpload: ()=>Promise.resolve({
            image_url: 'https://assets-global.website-files.com/6257adef93867e50d84d30e2/636e0b52aa9e99b832574a53_full_logo_blurple_RGB.png'
        }),
    getRelationships: ()=>Promise.resolve({
            relationships: [
                {
                    type: 1,
                    user: {
                        username: 'mock_friend_username',
                        flags: 0,
                        bot: false,
                        discriminator: 'mock_friend_discriminator',
                        id: 'mock_friend_id_1',
                        avatar: null
                    }
                },
                {
                    type: 1,
                    user: {
                        username: 'mock_friend_username_with_nickname',
                        flags: 0,
                        bot: false,
                        discriminator: 'mock_friend_discriminator_with_nickname',
                        id: 'mock_friend_id_2',
                        avatar: null
                    },
                    nickname: 'mock_friend_nickname_for_user'
                },
                {
                    type: 1,
                    user: {
                        username: 'mock_friend_username_with_since',
                        flags: 0,
                        bot: false,
                        discriminator: 'mock_friend_discriminator_with_since',
                        id: 'mock_friend_id_3',
                        avatar: null
                    },
                    since: '2021-06-29T00:32:37.180813+00:00'
                }
            ]
        }),
    inviteUserEmbedded: ()=>Promise.resolve(null),
    getUser: ()=>{
        return Promise.resolve({
            username: 'mock_friend_username',
            flags: 0,
            bot: false,
            discriminator: 'mock_friend_discriminator',
            id: 'mock_friend_id_1',
            avatar: null
        });
    },
    getQuestEnrollmentStatus: ()=>Promise.resolve({
            quest_id: 'mock_quest_id',
            is_enrolled: false,
            enrolled_at: null
        }),
    questStartTimer: ()=>Promise.resolve({
            success: true
        }),
    getActivityInstanceConnectedParticipants: ()=>Promise.resolve({
            participants: []
        }),
    shareInteraction: ()=>Promise.resolve({
            success: false
        }),
    requestProxyTicketRefresh: ()=>Promise.resolve({
            ticket: 'mock_ticket'
        }),
    getQuest: ()=>Promise.resolve({
            quest_id: 'mock_quest_id',
            external_cta_url: 'mock_external_cta_url',
            enrolled_at: null,
            completed_at: null
        })
};

});
parcelRegister("6h0kA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5e8c9abb85ad3be$export$2e2bcd8739ae039; });

var $4kOSS = parcelRequire("4kOSS");

var $bnaKm = parcelRequire("bnaKm");
var $c5e8c9abb85ad3be$var$lodash_transformExports = (0, $bnaKm.__require)();
var $c5e8c9abb85ad3be$export$2e2bcd8739ae039 = /*@__PURE__*/ (0, $4kOSS.getDefaultExportFromCjs)($c5e8c9abb85ad3be$var$lodash_transformExports);

});
parcelRegister("bnaKm", function(module, exports) {

$parcel$export(module.exports, "__require", function () { return $6843efa577175e2c$export$b88c30a9414655a0; });

var $4kOSS = parcelRequire("4kOSS");

var $3AeS2 = parcelRequire("3AeS2");
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (0, $3AeS2.__module).exports;
var $6843efa577175e2c$var$hasRequiredLodash_transform;
function $6843efa577175e2c$export$b88c30a9414655a0() {
    if ($6843efa577175e2c$var$hasRequiredLodash_transform) return (0, $3AeS2.__module).exports;
    $6843efa577175e2c$var$hasRequiredLodash_transform = 1;
    (function(module, exports) {
        /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
        /** Used as the `TypeError` message for "Functions" methods. */ var FUNC_ERROR_TEXT = 'Expected a function';
        /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
        /** Used to compose bitmasks for comparison styles. */ var UNORDERED_COMPARE_FLAG = 1, PARTIAL_COMPARE_FLAG = 2;
        /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991;
        /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', promiseTag = '[object Promise]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
        var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
        /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, reLeadingDot = /^\./, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
        /**
		 * Used to match `RegExp`
		 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
		 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
        /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
        /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
        /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
        /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
        typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
        typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
        /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof (0, $4kOSS.commonjsGlobal) == 'object' && (0, $4kOSS.commonjsGlobal) && (0, $4kOSS.commonjsGlobal).Object === Object && (0, $4kOSS.commonjsGlobal);
        /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
        /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
        /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
        /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
        /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
        /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
        /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
            try {
                return freeProcess && freeProcess.binding('util');
            } catch (e) {}
        }();
        /* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
        /**
		 * A specialized version of `_.forEach` for arrays without support for
		 * iteratee shorthands.
		 *
		 * @private
		 * @param {Array} [array] The array to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Array} Returns `array`.
		 */ function arrayEach(array, iteratee) {
            var index = -1, length = array ? array.length : 0;
            while(++index < length){
                if (iteratee(array[index], index, array) === false) break;
            }
            return array;
        }
        /**
		 * A specialized version of `_.some` for arrays without support for iteratee
		 * shorthands.
		 *
		 * @private
		 * @param {Array} [array] The array to iterate over.
		 * @param {Function} predicate The function invoked per iteration.
		 * @returns {boolean} Returns `true` if any element passes the predicate check,
		 *  else `false`.
		 */ function arraySome(array, predicate) {
            var index = -1, length = array ? array.length : 0;
            while(++index < length){
                if (predicate(array[index], index, array)) return true;
            }
            return false;
        }
        /**
		 * The base implementation of `_.property` without support for deep paths.
		 *
		 * @private
		 * @param {string} key The key of the property to get.
		 * @returns {Function} Returns the new accessor function.
		 */ function baseProperty(key) {
            return function(object) {
                return object == null ? undefined : object[key];
            };
        }
        /**
		 * The base implementation of `_.times` without support for iteratee shorthands
		 * or max array length checks.
		 *
		 * @private
		 * @param {number} n The number of times to invoke `iteratee`.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Array} Returns the array of results.
		 */ function baseTimes(n, iteratee) {
            var index = -1, result = Array(n);
            while(++index < n)result[index] = iteratee(index);
            return result;
        }
        /**
		 * The base implementation of `_.unary` without support for storing metadata.
		 *
		 * @private
		 * @param {Function} func The function to cap arguments for.
		 * @returns {Function} Returns the new capped function.
		 */ function baseUnary(func) {
            return function(value) {
                return func(value);
            };
        }
        /**
		 * Gets the value at `key` of `object`.
		 *
		 * @private
		 * @param {Object} [object] The object to query.
		 * @param {string} key The key of the property to get.
		 * @returns {*} Returns the property value.
		 */ function getValue(object, key) {
            return object == null ? undefined : object[key];
        }
        /**
		 * Checks if `value` is a host object in IE < 9.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
		 */ function isHostObject(value) {
            // Many host objects are `Object` objects that can coerce to strings
            // despite having improperly defined `toString` methods.
            var result = false;
            if (value != null && typeof value.toString != 'function') try {
                result = !!(value + '');
            } catch (e) {}
            return result;
        }
        /**
		 * Converts `map` to its key-value pairs.
		 *
		 * @private
		 * @param {Object} map The map to convert.
		 * @returns {Array} Returns the key-value pairs.
		 */ function mapToArray(map) {
            var index = -1, result = Array(map.size);
            map.forEach(function(value, key) {
                result[++index] = [
                    key,
                    value
                ];
            });
            return result;
        }
        /**
		 * Creates a unary function that invokes `func` with its argument transformed.
		 *
		 * @private
		 * @param {Function} func The function to wrap.
		 * @param {Function} transform The argument transform.
		 * @returns {Function} Returns the new function.
		 */ function overArg(func, transform) {
            return function(arg) {
                return func(transform(arg));
            };
        }
        /**
		 * Converts `set` to an array of its values.
		 *
		 * @private
		 * @param {Object} set The set to convert.
		 * @returns {Array} Returns the values.
		 */ function setToArray(set) {
            var index = -1, result = Array(set.size);
            set.forEach(function(value) {
                result[++index] = value;
            });
            return result;
        }
        /** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /**
		 * Used to resolve the
		 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
		 * of values.
		 */ var objectToString = objectProto.toString;
        /** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Symbol = root.Symbol, Uint8Array = root.Uint8Array, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
        /* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /**
		 * Creates a hash object.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */ function Hash(entries) {
            var index = -1, length = entries ? entries.length : 0;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
		 * Removes all key-value entries from the hash.
		 *
		 * @private
		 * @name clear
		 * @memberOf Hash
		 */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
        }
        /**
		 * Removes `key` and its value from the hash.
		 *
		 * @private
		 * @name delete
		 * @memberOf Hash
		 * @param {Object} hash The hash to modify.
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */ function hashDelete(key) {
            return this.has(key) && delete this.__data__[key];
        }
        /**
		 * Gets the hash value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf Hash
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
		 * Checks if a hash value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf Hash
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
		 * Sets the hash `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf Hash
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the hash instance.
		 */ function hashSet(key, value) {
            var data = this.__data__;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /**
		 * Creates an list cache object.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */ function ListCache(entries) {
            var index = -1, length = entries ? entries.length : 0;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
		 * Removes all key-value entries from the list cache.
		 *
		 * @private
		 * @name clear
		 * @memberOf ListCache
		 */ function listCacheClear() {
            this.__data__ = [];
        }
        /**
		 * Removes `key` and its value from the list cache.
		 *
		 * @private
		 * @name delete
		 * @memberOf ListCache
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            return true;
        }
        /**
		 * Gets the list cache value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf ListCache
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
		 * Checks if a list cache value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf ListCache
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
		 * Sets the list cache `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf ListCache
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the list cache instance.
		 */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) data.push([
                key,
                value
            ]);
            else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /**
		 * Creates a map cache object to store key-value pairs.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */ function MapCache(entries) {
            var index = -1, length = entries ? entries.length : 0;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
		 * Removes all key-value entries from the map.
		 *
		 * @private
		 * @name clear
		 * @memberOf MapCache
		 */ function mapCacheClear() {
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
		 * Removes `key` and its value from the map.
		 *
		 * @private
		 * @name delete
		 * @memberOf MapCache
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */ function mapCacheDelete(key) {
            return getMapData(this, key)['delete'](key);
        }
        /**
		 * Gets the map value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf MapCache
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
		 * Checks if a map value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf MapCache
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
		 * Sets the map `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf MapCache
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the map cache instance.
		 */ function mapCacheSet(key, value) {
            getMapData(this, key).set(key, value);
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /**
		 *
		 * Creates an array cache object to store unique values.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [values] The values to cache.
		 */ function SetCache(values) {
            var index = -1, length = values ? values.length : 0;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
		 * Adds `value` to the array cache.
		 *
		 * @private
		 * @name add
		 * @memberOf SetCache
		 * @alias push
		 * @param {*} value The value to cache.
		 * @returns {Object} Returns the cache instance.
		 */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
		 * Checks if `value` is in the array cache.
		 *
		 * @private
		 * @name has
		 * @memberOf SetCache
		 * @param {*} value The value to search for.
		 * @returns {number} Returns `true` if `value` is found, else `false`.
		 */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /**
		 * Creates a stack cache object to store key-value pairs.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */ function Stack(entries) {
            this.__data__ = new ListCache(entries);
        }
        /**
		 * Removes all key-value entries from the stack.
		 *
		 * @private
		 * @name clear
		 * @memberOf Stack
		 */ function stackClear() {
            this.__data__ = new ListCache;
        }
        /**
		 * Removes `key` and its value from the stack.
		 *
		 * @private
		 * @name delete
		 * @memberOf Stack
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */ function stackDelete(key) {
            return this.__data__['delete'](key);
        }
        /**
		 * Gets the stack value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf Stack
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
		 * Checks if a stack value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf Stack
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
		 * Sets the stack `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf Stack
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the stack cache instance.
		 */ function stackSet(key, value) {
            var cache = this.__data__;
            if (cache instanceof ListCache) {
                var pairs = cache.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    return this;
                }
                cache = this.__data__ = new MapCache(pairs);
            }
            cache.set(key, value);
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /**
		 * Creates an array of the enumerable property names of the array-like `value`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @param {boolean} inherited Specify returning inherited property names.
		 * @returns {Array} Returns the array of property names.
		 */ function arrayLikeKeys(value, inherited) {
            // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
            // Safari 9 makes `arguments.length` enumerable in strict mode.
            var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
            var length = result.length, skipIndexes = !!length;
            for(var key in value)if (hasOwnProperty.call(value, key) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
		 * Gets the index at which the `key` is found in `array` of key-value pairs.
		 *
		 * @private
		 * @param {Array} array The array to inspect.
		 * @param {*} key The key to search for.
		 * @returns {number} Returns the index of the matched value, else `-1`.
		 */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
		 * The base implementation of `_.create` without support for assigning
		 * properties to the created object.
		 *
		 * @private
		 * @param {Object} prototype The object to inherit from.
		 * @returns {Object} Returns the new object.
		 */ function baseCreate(proto) {
            return isObject(proto) ? objectCreate(proto) : {};
        }
        /**
		 * The base implementation of `baseForOwn` which iterates over `object`
		 * properties returned by `keysFunc` and invokes `iteratee` for each property.
		 * Iteratee functions may exit iteration early by explicitly returning `false`.
		 *
		 * @private
		 * @param {Object} object The object to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @param {Function} keysFunc The function to get the keys of `object`.
		 * @returns {Object} Returns `object`.
		 */ var baseFor = createBaseFor();
        /**
		 * The base implementation of `_.forOwn` without support for iteratee shorthands.
		 *
		 * @private
		 * @param {Object} object The object to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Object} Returns `object`.
		 */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
		 * The base implementation of `_.get` without support for default values.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {Array|string} path The path of the property to get.
		 * @returns {*} Returns the resolved value.
		 */ function baseGet(object, path) {
            path = isKey(path, object) ? [
                path
            ] : castPath(path);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
		 * The base implementation of `getTag`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {string} Returns the `toStringTag`.
		 */ function baseGetTag(value) {
            return objectToString.call(value);
        }
        /**
		 * The base implementation of `_.hasIn` without support for deep paths.
		 *
		 * @private
		 * @param {Object} [object] The object to query.
		 * @param {Array|string} key The key to check.
		 * @returns {boolean} Returns `true` if `key` exists, else `false`.
		 */ function baseHasIn(object, key) {
            return object != null && key in Object(object);
        }
        /**
		 * The base implementation of `_.isEqual` which supports partial comparisons
		 * and tracks traversed objects.
		 *
		 * @private
		 * @param {*} value The value to compare.
		 * @param {*} other The other value to compare.
		 * @param {Function} [customizer] The function to customize comparisons.
		 * @param {boolean} [bitmask] The bitmask of comparison flags.
		 *  The bitmask may be composed of the following flags:
		 *     1 - Unordered comparison
		 *     2 - Partial comparison
		 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
		 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
		 */ function baseIsEqual(value, other, customizer, bitmask, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObject(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
        }
        /**
		 * A specialized version of `baseIsEqual` for arrays and objects which performs
		 * deep comparisons and tracks traversed objects enabling objects with circular
		 * references to be compared.
		 *
		 * @private
		 * @param {Object} object The object to compare.
		 * @param {Object} other The other object to compare.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Function} [customizer] The function to customize comparisons.
		 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
		 *  for more details.
		 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
		 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
		 */ function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = arrayTag, othTag = arrayTag;
            if (!objIsArr) {
                objTag = getTag(object);
                objTag = objTag == argsTag ? objectTag : objTag;
            }
            if (!othIsArr) {
                othTag = getTag(other);
                othTag = othTag == argsTag ? objectTag : othTag;
            }
            var objIsObj = objTag == objectTag && !isHostObject(object), othIsObj = othTag == objectTag && !isHostObject(other), isSameTag = objTag == othTag;
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
            }
            if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
        }
        /**
		 * The base implementation of `_.isMatch` without support for iteratee shorthands.
		 *
		 * @private
		 * @param {Object} object The object to inspect.
		 * @param {Object} source The object of property values to match.
		 * @param {Array} matchData The property names, values, and compare flags to match.
		 * @param {Function} [customizer] The function to customize comparisons.
		 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
		 */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index;
            if (object == null) return !length;
            object = Object(object);
            while(index--){
                var data = matchData[index];
                if (data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    var result;
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
		 * The base implementation of `_.isNative` without bad shim checks.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a native function,
		 *  else `false`.
		 */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
		 * The base implementation of `_.isTypedArray` without Node.js optimizations.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
		 */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
        }
        /**
		 * The base implementation of `_.iteratee`.
		 *
		 * @private
		 * @param {*} [value=_.identity] The value to convert to an iteratee.
		 * @returns {Function} Returns the iteratee.
		 */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
		 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
		 * The base implementation of `_.matches` which doesn't clone `source`.
		 *
		 * @private
		 * @param {Object} source The object of property values to match.
		 * @returns {Function} Returns the new spec function.
		 */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
		 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
		 *
		 * @private
		 * @param {string} path The path of the property to get.
		 * @param {*} srcValue The value to match.
		 * @returns {Function} Returns the new spec function.
		 */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
            };
        }
        /**
		 * A specialized version of `baseProperty` which supports deep paths.
		 *
		 * @private
		 * @param {Array|string} path The path of the property to get.
		 * @returns {Function} Returns the new accessor function.
		 */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
		 * The base implementation of `_.toString` which doesn't convert nullish
		 * values to empty strings.
		 *
		 * @private
		 * @param {*} value The value to process.
		 * @returns {string} Returns the string.
		 */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
		 * Casts `value` to a path array if it's not one.
		 *
		 * @private
		 * @param {*} value The value to inspect.
		 * @returns {Array} Returns the cast property path array.
		 */ function castPath(value) {
            return isArray(value) ? value : stringToPath(value);
        }
        /**
		 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
		 *
		 * @private
		 * @param {boolean} [fromRight] Specify iterating from right to left.
		 * @returns {Function} Returns the new base function.
		 */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
		 * A specialized version of `baseIsEqualDeep` for arrays with support for
		 * partial deep comparisons.
		 *
		 * @private
		 * @param {Array} array The array to compare.
		 * @param {Array} other The other array to compare.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
		 *  for more details.
		 * @param {Object} stack Tracks traversed `array` and `other` objects.
		 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
		 */ function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
            var isPartial = bitmask & PARTIAL_COMPARE_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(array);
            if (stacked && stack.get(other)) return stacked == other;
            var index = -1, result = true, seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!seen.has(othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) return seen.add(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
		 * A specialized version of `baseIsEqualDeep` for comparing objects of
		 * the same `toStringTag`.
		 *
		 * **Note:** This function only supports comparing values with tags of
		 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
		 *
		 * @private
		 * @param {Object} object The object to compare.
		 * @param {Object} other The other object to compare.
		 * @param {string} tag The `toStringTag` of the objects to compare.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
		 *  for more details.
		 * @param {Object} stack Tracks traversed `object` and `other` objects.
		 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
		 */ function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= UNORDERED_COMPARE_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
		 * A specialized version of `baseIsEqualDeep` for objects with support for
		 * partial deep comparisons.
		 *
		 * @private
		 * @param {Object} object The object to compare.
		 * @param {Object} other The other object to compare.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
		 *  for more details.
		 * @param {Object} stack Tracks traversed `object` and `other` objects.
		 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
		 */ function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
            var isPartial = bitmask & PARTIAL_COMPARE_FLAG, objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked && stack.get(other)) return stacked == other;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
		 * Gets the data for `map`.
		 *
		 * @private
		 * @param {Object} map The map to query.
		 * @param {string} key The reference key.
		 * @returns {*} Returns the map data.
		 */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
		 * Gets the property names, values, and compare flags of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the match data of `object`.
		 */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
		 * Gets the native function at `key` of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {string} key The key of the method to get.
		 * @returns {*} Returns the function if it's native, else `undefined`.
		 */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
		 * Gets the `toStringTag` of `value`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {string} Returns the `toStringTag`.
		 */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11,
        // for data views in Edge < 14, and promises in Node.js.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
		 * Checks if `path` exists on `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {Array|string} path The path to check.
		 * @param {Function} hasFunc The function to check properties.
		 * @returns {boolean} Returns `true` if `path` exists, else `false`.
		 */ function hasPath(object, path, hasFunc) {
            path = isKey(path, object) ? [
                path
            ] : castPath(path);
            var result, index = -1, length = path.length;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result) return result;
            var length = object ? object.length : 0;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
		 * Checks if `value` is a valid array-like index.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
		 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
		 */ function isIndex(value, length) {
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
		 * Checks if `value` is a property name and not a property path.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @param {Object} [object] The object to query keys on.
		 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
		 */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
        }
        /**
		 * Checks if `value` is suitable for use as unique object key.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
		 */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
		 * Checks if `func` has its source masked.
		 *
		 * @private
		 * @param {Function} func The function to check.
		 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
		 */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
		 * Checks if `value` is likely a prototype object.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
		 */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
		 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` if suitable for strict
		 *  equality comparisons, else `false`.
		 */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
		 * A specialized version of `matchesProperty` for source values suitable
		 * for strict equality comparisons, i.e. `===`.
		 *
		 * @private
		 * @param {string} key The key of the property to get.
		 * @param {*} srcValue The value to match.
		 * @returns {Function} Returns the new spec function.
		 */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
            };
        }
        /**
		 * Converts `string` to a property path array.
		 *
		 * @private
		 * @param {string} string The string to convert.
		 * @returns {Array} Returns the property path array.
		 */ var stringToPath = memoize(function(string) {
            string = toString(string);
            var result = [];
            if (reLeadingDot.test(string)) result.push('');
            string.replace(rePropName, function(match, number, quote, string) {
                result.push(quote ? string.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
		 * Converts `value` to a string key if it's not a string or symbol.
		 *
		 * @private
		 * @param {*} value The value to inspect.
		 * @returns {string|symbol} Returns the key.
		 */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
		 * Converts `func` to its source code.
		 *
		 * @private
		 * @param {Function} func The function to process.
		 * @returns {string} Returns the source code.
		 */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
		 * Creates a function that memoizes the result of `func`. If `resolver` is
		 * provided, it determines the cache key for storing the result based on the
		 * arguments provided to the memoized function. By default, the first argument
		 * provided to the memoized function is used as the map cache key. The `func`
		 * is invoked with the `this` binding of the memoized function.
		 *
		 * **Note:** The cache is exposed as the `cache` property on the memoized
		 * function. Its creation may be customized by replacing the `_.memoize.Cache`
		 * constructor with one whose instances implement the
		 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
		 * method interface of `delete`, `get`, `has`, and `set`.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Function
		 * @param {Function} func The function to have its output memoized.
		 * @param {Function} [resolver] The function to resolve the cache key.
		 * @returns {Function} Returns the new memoized function.
		 * @example
		 *
		 * var object = { 'a': 1, 'b': 2 };
		 * var other = { 'c': 3, 'd': 4 };
		 *
		 * var values = _.memoize(_.values);
		 * values(object);
		 * // => [1, 2]
		 *
		 * values(other);
		 * // => [3, 4]
		 *
		 * object.a = 2;
		 * values(object);
		 * // => [1, 2]
		 *
		 * // Modify the result cache.
		 * values.cache.set(object, ['a', 'b']);
		 * values(object);
		 * // => ['a', 'b']
		 *
		 * // Replace `_.memoize.Cache`.
		 * _.memoize.Cache = WeakMap;
		 */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result);
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Assign cache to `_.memoize`.
        memoize.Cache = MapCache;
        /**
		 * Performs a
		 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
		 * comparison between two values to determine if they are equivalent.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to compare.
		 * @param {*} other The other value to compare.
		 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
		 * @example
		 *
		 * var object = { 'a': 1 };
		 * var other = { 'a': 1 };
		 *
		 * _.eq(object, object);
		 * // => true
		 *
		 * _.eq(object, other);
		 * // => false
		 *
		 * _.eq('a', 'a');
		 * // => true
		 *
		 * _.eq('a', Object('a'));
		 * // => false
		 *
		 * _.eq(NaN, NaN);
		 * // => true
		 */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
		 * Checks if `value` is likely an `arguments` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
		 *  else `false`.
		 * @example
		 *
		 * _.isArguments(function() { return arguments; }());
		 * // => true
		 *
		 * _.isArguments([1, 2, 3]);
		 * // => false
		 */ function isArguments(value) {
            // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
            return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
        }
        /**
		 * Checks if `value` is classified as an `Array` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
		 * @example
		 *
		 * _.isArray([1, 2, 3]);
		 * // => true
		 *
		 * _.isArray(document.body.children);
		 * // => false
		 *
		 * _.isArray('abc');
		 * // => false
		 *
		 * _.isArray(_.noop);
		 * // => false
		 */ var isArray = Array.isArray;
        /**
		 * Checks if `value` is array-like. A value is considered array-like if it's
		 * not a function and has a `value.length` that's an integer greater than or
		 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
		 * @example
		 *
		 * _.isArrayLike([1, 2, 3]);
		 * // => true
		 *
		 * _.isArrayLike(document.body.children);
		 * // => true
		 *
		 * _.isArrayLike('abc');
		 * // => true
		 *
		 * _.isArrayLike(_.noop);
		 * // => false
		 */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
		 * This method is like `_.isArrayLike` except that it also checks if `value`
		 * is an object.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an array-like object,
		 *  else `false`.
		 * @example
		 *
		 * _.isArrayLikeObject([1, 2, 3]);
		 * // => true
		 *
		 * _.isArrayLikeObject(document.body.children);
		 * // => true
		 *
		 * _.isArrayLikeObject('abc');
		 * // => false
		 *
		 * _.isArrayLikeObject(_.noop);
		 * // => false
		 */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
		 * Checks if `value` is classified as a `Function` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
		 * @example
		 *
		 * _.isFunction(_);
		 * // => true
		 *
		 * _.isFunction(/abc/);
		 * // => false
		 */ function isFunction(value) {
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 8-9 which returns 'object' for typed array and other constructors.
            var tag = isObject(value) ? objectToString.call(value) : '';
            return tag == funcTag || tag == genTag;
        }
        /**
		 * Checks if `value` is a valid array-like length.
		 *
		 * **Note:** This method is loosely based on
		 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
		 * @example
		 *
		 * _.isLength(3);
		 * // => true
		 *
		 * _.isLength(Number.MIN_VALUE);
		 * // => false
		 *
		 * _.isLength(Infinity);
		 * // => false
		 *
		 * _.isLength('3');
		 * // => false
		 */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
		 * Checks if `value` is the
		 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
		 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
		 * @example
		 *
		 * _.isObject({});
		 * // => true
		 *
		 * _.isObject([1, 2, 3]);
		 * // => true
		 *
		 * _.isObject(_.noop);
		 * // => true
		 *
		 * _.isObject(null);
		 * // => false
		 */ function isObject(value) {
            var type = typeof value;
            return !!value && (type == 'object' || type == 'function');
        }
        /**
		 * Checks if `value` is object-like. A value is object-like if it's not `null`
		 * and has a `typeof` result of "object".
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
		 * @example
		 *
		 * _.isObjectLike({});
		 * // => true
		 *
		 * _.isObjectLike([1, 2, 3]);
		 * // => true
		 *
		 * _.isObjectLike(_.noop);
		 * // => false
		 *
		 * _.isObjectLike(null);
		 * // => false
		 */ function isObjectLike(value) {
            return !!value && typeof value == 'object';
        }
        /**
		 * Checks if `value` is classified as a `Symbol` primitive or object.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
		 * @example
		 *
		 * _.isSymbol(Symbol.iterator);
		 * // => true
		 *
		 * _.isSymbol('abc');
		 * // => false
		 */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
        }
        /**
		 * Checks if `value` is classified as a typed array.
		 *
		 * @static
		 * @memberOf _
		 * @since 3.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
		 * @example
		 *
		 * _.isTypedArray(new Uint8Array);
		 * // => true
		 *
		 * _.isTypedArray([]);
		 * // => false
		 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
		 * Converts `value` to a string. An empty string is returned for `null`
		 * and `undefined` values. The sign of `-0` is preserved.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to process.
		 * @returns {string} Returns the string.
		 * @example
		 *
		 * _.toString(null);
		 * // => ''
		 *
		 * _.toString(-0);
		 * // => '-0'
		 *
		 * _.toString([1, 2, 3]);
		 * // => '1,2,3'
		 */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /**
		 * Gets the value at `path` of `object`. If the resolved value is
		 * `undefined`, the `defaultValue` is returned in its place.
		 *
		 * @static
		 * @memberOf _
		 * @since 3.7.0
		 * @category Object
		 * @param {Object} object The object to query.
		 * @param {Array|string} path The path of the property to get.
		 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
		 * @returns {*} Returns the resolved value.
		 * @example
		 *
		 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
		 *
		 * _.get(object, 'a[0].b.c');
		 * // => 3
		 *
		 * _.get(object, ['a', '0', 'b', 'c']);
		 * // => 3
		 *
		 * _.get(object, 'a.b.c', 'default');
		 * // => 'default'
		 */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
		 * Checks if `path` is a direct or inherited property of `object`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Object
		 * @param {Object} object The object to query.
		 * @param {Array|string} path The path to check.
		 * @returns {boolean} Returns `true` if `path` exists, else `false`.
		 * @example
		 *
		 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
		 *
		 * _.hasIn(object, 'a');
		 * // => true
		 *
		 * _.hasIn(object, 'a.b');
		 * // => true
		 *
		 * _.hasIn(object, ['a', 'b']);
		 * // => true
		 *
		 * _.hasIn(object, 'b');
		 * // => false
		 */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
		 * Creates an array of the own enumerable property names of `object`.
		 *
		 * **Note:** Non-object values are coerced to objects. See the
		 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
		 * for more details.
		 *
		 * @static
		 * @since 0.1.0
		 * @memberOf _
		 * @category Object
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 * @example
		 *
		 * function Foo() {
		 *   this.a = 1;
		 *   this.b = 2;
		 * }
		 *
		 * Foo.prototype.c = 3;
		 *
		 * _.keys(new Foo);
		 * // => ['a', 'b'] (iteration order is not guaranteed)
		 *
		 * _.keys('hi');
		 * // => ['0', '1']
		 */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
		 * An alternative to `_.reduce`; this method transforms `object` to a new
		 * `accumulator` object which is the result of running each of its own
		 * enumerable string keyed properties thru `iteratee`, with each invocation
		 * potentially mutating the `accumulator` object. If `accumulator` is not
		 * provided, a new object with the same `[[Prototype]]` will be used. The
		 * iteratee is invoked with four arguments: (accumulator, value, key, object).
		 * Iteratee functions may exit iteration early by explicitly returning `false`.
		 *
		 * @static
		 * @memberOf _
		 * @since 1.3.0
		 * @category Object
		 * @param {Object} object The object to iterate over.
		 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
		 * @param {*} [accumulator] The custom accumulator value.
		 * @returns {*} Returns the accumulated value.
		 * @example
		 *
		 * _.transform([2, 3, 4], function(result, n) {
		 *   result.push(n *= n);
		 *   return n % 2 == 0;
		 * }, []);
		 * // => [4, 9]
		 *
		 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
		 *   (result[value] || (result[value] = [])).push(key);
		 * }, {});
		 * // => { '1': ['a', 'c'], '2': ['b'] }
		 */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object) || isTypedArray(object);
            iteratee = baseIteratee(iteratee);
            if (accumulator == null) {
                if (isArr || isObject(object)) {
                    var Ctor = object.constructor;
                    if (isArr) accumulator = isArray(object) ? new Ctor : [];
                    else accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                } else accumulator = {};
            }
            (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
		 * This method returns the first argument it receives.
		 *
		 * @static
		 * @since 0.1.0
		 * @memberOf _
		 * @category Util
		 * @param {*} value Any value.
		 * @returns {*} Returns `value`.
		 * @example
		 *
		 * var object = { 'a': 1 };
		 *
		 * console.log(_.identity(object) === object);
		 * // => true
		 */ function identity(value) {
            return value;
        }
        /**
		 * Creates a function that returns the value at `path` of a given object.
		 *
		 * @static
		 * @memberOf _
		 * @since 2.4.0
		 * @category Util
		 * @param {Array|string} path The path of the property to get.
		 * @returns {Function} Returns the new accessor function.
		 * @example
		 *
		 * var objects = [
		 *   { 'a': { 'b': 2 } },
		 *   { 'a': { 'b': 1 } }
		 * ];
		 *
		 * _.map(objects, _.property('a.b'));
		 * // => [2, 1]
		 *
		 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
		 * // => [1, 2]
		 */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        module.exports = transform;
    })((0, $3AeS2.__module), (0, $3AeS2.__module).exports);
    return (0, $3AeS2.__module).exports;
}

});
parcelRegister("3AeS2", function(module, exports) {

$parcel$export(module.exports, "__module", function () { return $ee7440e6eed4d104$export$5edeffb658f039f4; });
var $ee7440e6eed4d104$export$5edeffb658f039f4 = {
    exports: {}
};

});




parcelRegister("hRhOK", function(module, exports) {

var $l8mTf = parcelRequire("l8mTf");

var $7BCXD = parcelRequire("7BCXD");
function $ef30d3c2c045d7d5$export$8cf746fdd009b78f(mappings, { patchFetch: patchFetch = true, patchWebSocket: patchWebSocket = true, patchXhr: patchXhr = true, patchSrcAttributes: patchSrcAttributes = false } = {}) {
    // Bail out if we're not in a browser
    if (typeof window === 'undefined') return;
    if (patchFetch) {
        const fetchImpl = window.fetch;
        // fetch is a duplex, but this is consistent
        window.fetch = function(input, init) {
            // If fetch has Request as input, we need to resolve any stream
            // before we create a new request with the mapped url
            if (input instanceof Request) {
                const newUrl = $ef30d3c2c045d7d5$export$e84bab733853880b({
                    url: (0, $7BCXD.absoluteURL)(input.url),
                    mappings: mappings
                });
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const _a = init !== null && init !== void 0 ? init : {}, newInit = (0, $l8mTf.__rest)(_a, [
                    "url"
                ]);
                Object.keys(Request.prototype).forEach((value)=>{
                    if (value === 'url') return;
                    try {
                        // @ts-expect-error
                        newInit[value] = input[value];
                    } catch (ex) {
                        console.warn(`Remapping fetch request key "${value}" failed`, ex);
                    }
                });
                return new Promise((resolve, reject)=>{
                    try {
                        input.blob().then((blob)=>{
                            if (input.method.toUpperCase() !== 'HEAD' && input.method.toUpperCase() !== 'GET' && blob.size > 0) newInit.body = blob;
                            resolve(fetchImpl(new Request(newUrl, newInit)));
                        });
                    } catch (ex) {
                        reject(ex);
                    }
                });
            }
            // Assuming a generic url or string
            const remapped = $ef30d3c2c045d7d5$export$e84bab733853880b({
                url: input instanceof URL ? input : (0, $7BCXD.absoluteURL)(input),
                mappings: mappings
            });
            return fetchImpl(remapped, init);
        };
    }
    if (patchWebSocket) {
        class WebSocketProxy extends WebSocket {
            constructor(url, protocols){
                const remapped = $ef30d3c2c045d7d5$export$e84bab733853880b({
                    url: url instanceof URL ? url : (0, $7BCXD.absoluteURL)(url),
                    mappings: mappings
                });
                super(remapped, protocols);
            }
        }
        window.WebSocket = WebSocketProxy;
    }
    if (patchXhr) {
        const openImpl = XMLHttpRequest.prototype.open;
        // @ts-expect-error - the ts interface exports two 'open' methods
        XMLHttpRequest.prototype.open = function(method, url, async, username, password) {
            const remapped = $ef30d3c2c045d7d5$export$e84bab733853880b({
                url: (0, $7BCXD.absoluteURL)(url),
                mappings: mappings
            });
            openImpl.apply(this, [
                method,
                remapped,
                async,
                username,
                password
            ]);
        };
    }
    if (patchSrcAttributes) {
        const callback = function(mutationsList) {
            for (const mutation of mutationsList){
                if (mutation.type === 'attributes' && mutation.attributeName === 'src') $ef30d3c2c045d7d5$var$attemptSetNodeSrc(mutation.target, mappings);
                else if (mutation.type === 'childList') mutation.addedNodes.forEach((node)=>{
                    $ef30d3c2c045d7d5$var$attemptSetNodeSrc(node, mappings);
                    $ef30d3c2c045d7d5$var$recursivelyRemapChildNodes(node, mappings);
                });
            }
        };
        const observer = new MutationObserver(callback);
        const config = {
            attributeFilter: [
                'src'
            ],
            childList: true,
            subtree: true
        };
        observer.observe(window.document, config);
        window.document.querySelectorAll('[src]').forEach((node)=>{
            $ef30d3c2c045d7d5$var$attemptSetNodeSrc(node, mappings);
        });
    }
}
function $ef30d3c2c045d7d5$var$recursivelyRemapChildNodes(node, mappings) {
    if (node.hasChildNodes()) node.childNodes.forEach((child)=>{
        $ef30d3c2c045d7d5$var$attemptSetNodeSrc(child, mappings);
        $ef30d3c2c045d7d5$var$recursivelyRemapChildNodes(child, mappings);
    });
}
function $ef30d3c2c045d7d5$var$attemptSetNodeSrc(node, mappings) {
    if (node instanceof HTMLElement && node.hasAttribute('src')) {
        const rawSrc = node.getAttribute('src');
        const url = (0, $7BCXD.absoluteURL)(rawSrc !== null && rawSrc !== void 0 ? rawSrc : '');
        if (url.host === window.location.host) return;
        if (node.tagName.toLowerCase() === 'script') // Scripts are a special case, and need to be wholly recreated since
        // modifying a script tag doesn't refetch.
        $ef30d3c2c045d7d5$var$attemptRecreateScriptNode(node, {
            url: url,
            mappings: mappings
        });
        else {
            const newSrc = $ef30d3c2c045d7d5$export$e84bab733853880b({
                url: url,
                mappings: mappings
            }).toString();
            // Only apply the remapping if we actually remapped the value
            if (newSrc !== rawSrc) node.setAttribute('src', newSrc);
        }
    }
}
function $ef30d3c2c045d7d5$var$attemptRecreateScriptNode(node, { url: url, mappings: mappings }) {
    const newUrl = $ef30d3c2c045d7d5$export$e84bab733853880b({
        url: url,
        mappings: mappings
    });
    if (url.toString() !== newUrl.toString()) {
        // Note: Script tags cannot be duplicated via `node.clone()` because their internal 'already started'
        // state prevents the new one from being fetched. We must manually recreate the duplicate tag instead.
        const newNode = document.createElement(node.tagName);
        newNode.innerHTML = node.innerHTML;
        for (const attr of node.attributes)newNode.setAttribute(attr.name, attr.value);
        newNode.setAttribute('src', $ef30d3c2c045d7d5$export$e84bab733853880b({
            url: url,
            mappings: mappings
        }).toString());
        node.after(newNode);
        node.remove();
    }
}
function $ef30d3c2c045d7d5$export$e84bab733853880b({ url: url, mappings: mappings }) {
    const newURL = new URL(url.toString());
    for (const mapping of mappings){
        const mapped = (0, $7BCXD.matchAndRewriteURL)({
            originalURL: newURL,
            prefix: mapping.prefix,
            target: mapping.target,
            prefixHost: window.location.host
        });
        if (mapped != null && (mapped === null || mapped === void 0 ? void 0 : mapped.toString()) !== url.toString()) return mapped;
    }
    return newURL;
}

});
parcelRegister("l8mTf", function(module, exports) {

$parcel$export(module.exports, "__rest", function () { return $068664c083350ad5$export$3c9a16f847548506; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ function $068664c083350ad5$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
typeof SuppressedError === "function" && SuppressedError;

});

parcelRegister("7BCXD", function(module, exports) {

$parcel$export(module.exports, "matchAndRewriteURL", function () { return $f87501f99a98bbbe$export$a79199ba3137e3aa; });
$parcel$export(module.exports, "absoluteURL", function () { return $f87501f99a98bbbe$export$11fe587afbb5d544; });
/**
 * Creates a regular expression from a target string. The target string
 * may contain `{name}` tokens which will end up being translated to
 * a named group match for a series of word characters with the group named `name`
 * The substitution pattern is {a-z} because the named groups must be valid JS identifiers,
 * making items like {0} invalid.
 *
 * @returns a RegExp object
 **/ const $f87501f99a98bbbe$var$SUBSTITUTION_REGEX = /\{([a-z]+)\}/g;
function $f87501f99a98bbbe$var$regexFromTarget(target) {
    const regexString = target.replace($f87501f99a98bbbe$var$SUBSTITUTION_REGEX, (match, name)=>`(?<${name}>[\\w-]+)`);
    return new RegExp(`${regexString}(/|$)`);
}
/**
 *
 * Attempts to map the actual url (i.e. google.com) to a url path, per the url
 * mappings set up in the embedded application. If the target contains `{foo}`
 * tokens, they will be replace with the values contained in the original URL,
 * via the pattern described in the prefix
 *
 * @returns  null if URL doesn't match prefix, otherwise return rewritten URL
 */ function $f87501f99a98bbbe$export$a79199ba3137e3aa({ originalURL: originalURL, prefix: prefix, prefixHost: prefixHost, target: target }) {
    // coerce url with filler https protocol so we can retrieve host and pathname from target
    const targetURL = new URL(`https://${target}`);
    // Depending on the environment, the URL constructor may turn `{` and `}` into `%7B` and `%7D`, respectively
    const targetRegEx = $f87501f99a98bbbe$var$regexFromTarget(targetURL.host.replace(/%7B/g, '{').replace(/%7D/g, '}'));
    const match = originalURL.toString().match(targetRegEx);
    // Null match indicates that this target is not relevant
    if (match == null) return originalURL;
    const newURL = new URL(originalURL.toString());
    newURL.host = prefixHost;
    newURL.pathname = prefix.replace($f87501f99a98bbbe$var$SUBSTITUTION_REGEX, (_, matchName)=>{
        var _a;
        const replaceValue = (_a = match.groups) === null || _a === void 0 ? void 0 : _a[matchName];
        if (replaceValue == null) throw new Error('Misconfigured route.');
        return replaceValue;
    });
    // Append the original path
    const pathToAppend = originalURL.pathname.startsWith('/') ? originalURL.pathname.slice(1) : originalURL.pathname;
    newURL.pathname += newURL.pathname.endsWith('/') ? pathToAppend : '/' + pathToAppend;
    // Remove the target's path from the new url path
    newURL.pathname = newURL.pathname.replace(targetURL.pathname, '');
    // Add a trailing slash if original url had it, and if it doesn't already have one or if matches filename regex
    if (originalURL.pathname.endsWith('/') && !newURL.pathname.endsWith('/')) newURL.pathname += '/';
    return newURL;
}
function $f87501f99a98bbbe$export$11fe587afbb5d544(url, protocol = window.location.protocol, host = window.location.host) {
    // If the first arg is a complete url, it will ignore the second arg
    // This call structure lets us set relative urls to have a full url with the proper protocol and host
    return new URL(url, `${protocol}//${host}`);
}

});



parcelRegister("7jzTX", function(module, exports) {

$parcel$export(module.exports, "setAuthToken", function () { return $b54d2ffd7e422449$export$3c4602e16d9ace38; });
$parcel$export(module.exports, "setQuestId", function () { return $b54d2ffd7e422449$export$3dc3970ed858a67f; });
$parcel$export(module.exports, "getQuestIdForAnalytics", function () { return $b54d2ffd7e422449$export$8f50b0e067d13aee; });
$parcel$export(module.exports, "authorize", function () { return $b54d2ffd7e422449$export$be1f35f80d3e29cc; });
$parcel$export(module.exports, "register", function () { return $b54d2ffd7e422449$export$6503ec6e8aabbaf; });
$parcel$export(module.exports, "checkQuest", function () { return $b54d2ffd7e422449$export$67771538c8648e68; });
$parcel$export(module.exports, "questProgress", function () { return $b54d2ffd7e422449$export$209f6b8fdd3e9ee1; });
$parcel$export(module.exports, "botRegister", function () { return $b54d2ffd7e422449$export$a7e62641be3c3b05; });

var $kFQy0 = parcelRequire("kFQy0");

var $hUeP2 = parcelRequire("hUeP2");
const $b54d2ffd7e422449$var$API_BASE = '/.proxy/acf';
let $b54d2ffd7e422449$var$QUEST_ID = "1526631789316276374"; // this is overwriten by the quest id value provided by the discord sdk.
let $b54d2ffd7e422449$var$auth_token = '';
function $b54d2ffd7e422449$export$3c4602e16d9ace38(token) {
    $b54d2ffd7e422449$var$auth_token = token;
}
function $b54d2ffd7e422449$export$3dc3970ed858a67f(id) {
    console.log('[Arise] quest id:', id);
    $b54d2ffd7e422449$var$QUEST_ID = id;
}
function $b54d2ffd7e422449$export$8f50b0e067d13aee() {
    return $b54d2ffd7e422449$var$QUEST_ID || 'unknown';
}
async function $b54d2ffd7e422449$export$be1f35f80d3e29cc(code) {
    const data = await $b54d2ffd7e422449$var$call('POST', '/authorize', {
        code: code,
        activityId: $b54d2ffd7e422449$var$getActivityId()
    });
    return data;
}
async function $b54d2ffd7e422449$export$6503ec6e8aabbaf() {
    return await $b54d2ffd7e422449$var$call('POST', '/arise/register');
}
async function $b54d2ffd7e422449$export$67771538c8648e68() {
    if (!$b54d2ffd7e422449$var$auth_token) throw new Error('No auth token set');
    const data = await $b54d2ffd7e422449$var$call('GET', '/quest/status');
    return data;
}
async function $b54d2ffd7e422449$export$209f6b8fdd3e9ee1(progress) {
    const response = await $b54d2ffd7e422449$var$call('POST', '/quest/progress', {
        progress: progress
    });
    const wasSuccessful = response?.status === 'ok';
    const message = wasSuccessful ? undefined : response?.message;
    return {
        wasSuccessful: wasSuccessful,
        message: message
    };
}
async function $b54d2ffd7e422449$export$a7e62641be3c3b05(locale) {
    await $b54d2ffd7e422449$var$call('POST', '/bot/register', {
        locale: locale
    });
}
async function $b54d2ffd7e422449$var$call(method, endpoint, body, timeout = 10000) {
    const abort = new AbortController();
    setTimeout(()=>abort.abort(), timeout);
    const activityId = $b54d2ffd7e422449$var$getActivityId();
    const res = await fetch($b54d2ffd7e422449$var$API_BASE + endpoint, {
        method: method,
        headers: {
            'Content-Type': 'application/json',
            'X-Auth-Token': $b54d2ffd7e422449$var$auth_token || '',
            'X-Universe-ID': "9097f2ba-ec9e-48b1-82af-0080acd3924e",
            'X-Discord-Quest-ID': $b54d2ffd7e422449$var$QUEST_ID,
            'X-Discord-Activity-Id': activityId,
            'X-Discord-Hostname': window.location.hostname,
            'X-Arise-Client': (0, $hUeP2.appVersion)
        },
        body: body ? JSON.stringify(body) : undefined,
        signal: abort.signal
    });
    if (!res.ok) {
        const text = await res.text();
        if (endpoint == '/authorize') (0, $kFQy0.sendEventV2)('discord-authorize-error', [
            res.status.toString(),
            text,
            window.location.hostname
        ]);
        console.error(`[AriseDiscordAPI] ${method} ${endpoint} failed (${res.status}):`, text, window.location.hostname);
        throw new Error(`${method} ${endpoint} failed with status ${res.status}`);
    }
    return res.json();
}
function $b54d2ffd7e422449$var$getActivityId() {
    return window.location.hostname.split('.')[0];
}

});
parcelRegister("hUeP2", function(module, exports) {

$parcel$export(module.exports, "appVersion", function () { return $a7ccb9ef47fd069b$export$82ae485178b37419; });
const $a7ccb9ef47fd069b$var$instance = "skyhook";
const $a7ccb9ef47fd069b$var$env = "prod";
const $a7ccb9ef47fd069b$var$gitRef = "main";
const $a7ccb9ef47fd069b$var$commitSha = "dc0bb756";
const $a7ccb9ef47fd069b$var$ref = $a7ccb9ef47fd069b$var$gitRef && $a7ccb9ef47fd069b$var$gitRef !== 'main' ? $a7ccb9ef47fd069b$var$gitRef : `${$a7ccb9ef47fd069b$var$instance}-${$a7ccb9ef47fd069b$var$env}-main`;
const $a7ccb9ef47fd069b$export$82ae485178b37419 = $a7ccb9ef47fd069b$var$commitSha ? `${$a7ccb9ef47fd069b$var$ref}-${$a7ccb9ef47fd069b$var$commitSha}` : $a7ccb9ef47fd069b$var$ref;

});



parcelRegister("2YFnD", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("j3cWo"))($parcel$resolve("cMtxv")),
    $parcel$import("laPnj")
]).then(()=>parcelRequire('cui4b'));

});
parcelRegister("j3cWo", function(module, exports) {
"use strict";

var $jM2Sh = parcelRequire("jM2Sh");
module.exports = $jM2Sh(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("jM2Sh", function(module, exports) {
"use strict";
var $e654bad3fbea63cc$var$cachedBundles = {};
var $e654bad3fbea63cc$var$cachedPreloads = {};
var $e654bad3fbea63cc$var$cachedPrefetches = {};
function $e654bad3fbea63cc$var$getCache(type) {
    switch(type){
        case 'preload':
            return $e654bad3fbea63cc$var$cachedPreloads;
        case 'prefetch':
            return $e654bad3fbea63cc$var$cachedPrefetches;
        default:
            return $e654bad3fbea63cc$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $e654bad3fbea63cc$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("47BRk", function(module, exports) {
/*!
 * Platform.js v1.3.6
 * Copyright 2014-2020 Benjamin Tan
 * Copyright 2011-2013 John-David Dalton
 * Available under MIT license
 */ (function() {
    'use strict';
    /** Used to determine if values are of the language type `Object`. */ var objectTypes = {
        'function': true,
        'object': true
    };
    /** Used as a reference to the global object. */ var root = objectTypes[typeof window] && window || this;
    /** Backup possible global object. */ var oldRoot = root;
    /** Detect free variable `exports`. */ var freeExports = objectTypes["object"] && exports;
    /** Detect free variable `module`. */ var freeModule = objectTypes["object"] && module && !module.nodeType && module;
    /** Detect free variable `global` from Node.js or Browserified code and use it as `root`. */ var freeGlobal = freeExports && freeModule && typeof $parcel$global == 'object' && $parcel$global;
    if (freeGlobal && (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal)) root = freeGlobal;
    /**
   * Used as the maximum length of an array-like object.
   * See the [ES6 spec](http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength)
   * for more details.
   */ var maxSafeInteger = Math.pow(2, 53) - 1;
    /** Regular expression to detect Opera. */ var reOpera = /\bOpera/;
    /** Possible global object. */ var thisBinding = this;
    /** Used for native method references. */ var objectProto = Object.prototype;
    /** Used to check for own properties of an object. */ var hasOwnProperty = objectProto.hasOwnProperty;
    /** Used to resolve the internal `[[Class]]` of values. */ var toString = objectProto.toString;
    /*--------------------------------------------------------------------------*/ /**
   * Capitalizes a string value.
   *
   * @private
   * @param {string} string The string to capitalize.
   * @returns {string} The capitalized string.
   */ function capitalize(string) {
        string = String(string);
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    /**
   * A utility function to clean up the OS name.
   *
   * @private
   * @param {string} os The OS name to clean up.
   * @param {string} [pattern] A `RegExp` pattern matching the OS name.
   * @param {string} [label] A label for the OS.
   */ function cleanupOS(os, pattern, label) {
        // Platform tokens are defined at:
        // http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
        // http://web.archive.org/web/20081122053950/http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
        var data = {
            '10.0': '10',
            '6.4': '10 Technical Preview',
            '6.3': '8.1',
            '6.2': '8',
            '6.1': 'Server 2008 R2 / 7',
            '6.0': 'Server 2008 / Vista',
            '5.2': 'Server 2003 / XP 64-bit',
            '5.1': 'XP',
            '5.01': '2000 SP1',
            '5.0': '2000',
            '4.0': 'NT',
            '4.90': 'ME'
        };
        // Detect Windows version from platform tokens.
        if (pattern && label && /^Win/i.test(os) && !/^Windows Phone /i.test(os) && (data = data[/[\d.]+$/.exec(os)])) os = 'Windows ' + data;
        // Correct character case and cleanup string.
        os = String(os);
        if (pattern && label) os = os.replace(RegExp(pattern, 'i'), label);
        os = format(os.replace(/ ce$/i, ' CE').replace(/\bhpw/i, 'web').replace(/\bMacintosh\b/, 'Mac OS').replace(/_PowerPC\b/i, ' OS').replace(/\b(OS X) [^ \d]+/i, '$1').replace(/\bMac (OS X)\b/, '$1').replace(/\/(\d)/, ' $1').replace(/_/g, '.').replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, '').replace(/\bx86\.64\b/gi, 'x86_64').replace(/\b(Windows Phone) OS\b/, '$1').replace(/\b(Chrome OS \w+) [\d.]+\b/, '$1').split(' on ')[0]);
        return os;
    }
    /**
   * An iteration utility for arrays and objects.
   *
   * @private
   * @param {Array|Object} object The object to iterate over.
   * @param {Function} callback The function called per iteration.
   */ function each(object, callback) {
        var index = -1, length = object ? object.length : 0;
        if (typeof length == 'number' && length > -1 && length <= maxSafeInteger) while(++index < length)callback(object[index], index, object);
        else forOwn(object, callback);
    }
    /**
   * Trim and conditionally capitalize string values.
   *
   * @private
   * @param {string} string The string to format.
   * @returns {string} The formatted string.
   */ function format(string) {
        string = trim(string);
        return /^(?:webOS|i(?:OS|P))/.test(string) ? string : capitalize(string);
    }
    /**
   * Iterates over an object's own properties, executing the `callback` for each.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} callback The function executed per own property.
   */ function forOwn(object, callback) {
        for(var key in object)if (hasOwnProperty.call(object, key)) callback(object[key], key, object);
    }
    /**
   * Gets the internal `[[Class]]` of a value.
   *
   * @private
   * @param {*} value The value.
   * @returns {string} The `[[Class]]`.
   */ function getClassOf(value) {
        return value == null ? capitalize(value) : toString.call(value).slice(8, -1);
    }
    /**
   * Host objects can return type values that are different from their actual
   * data type. The objects we are concerned with usually return non-primitive
   * types of "object", "function", or "unknown".
   *
   * @private
   * @param {*} object The owner of the property.
   * @param {string} property The property to check.
   * @returns {boolean} Returns `true` if the property value is a non-primitive, else `false`.
   */ function isHostType(object, property) {
        var type = object != null ? typeof object[property] : 'number';
        return !/^(?:boolean|number|string|undefined)$/.test(type) && (type == 'object' ? !!object[property] : true);
    }
    /**
   * Prepares a string for use in a `RegExp` by making hyphens and spaces optional.
   *
   * @private
   * @param {string} string The string to qualify.
   * @returns {string} The qualified string.
   */ function qualify(string) {
        return String(string).replace(/([ -])(?!$)/g, '$1?');
    }
    /**
   * A bare-bones `Array#reduce` like utility function.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} callback The function called per iteration.
   * @returns {*} The accumulated result.
   */ function reduce(array, callback) {
        var accumulator = null;
        each(array, function(value, index) {
            accumulator = callback(accumulator, value, index, array);
        });
        return accumulator;
    }
    /**
   * Removes leading and trailing whitespace from a string.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} The trimmed string.
   */ function trim(string) {
        return String(string).replace(/^ +| +$/g, '');
    }
    /*--------------------------------------------------------------------------*/ /**
   * Creates a new platform object.
   *
   * @memberOf platform
   * @param {Object|string} [ua=navigator.userAgent] The user agent string or
   *  context object.
   * @returns {Object} A platform object.
   */ function parse(ua) {
        /** The environment context object. */ var context = root;
        /** Used to flag when a custom context is provided. */ var isCustomContext = ua && typeof ua == 'object' && getClassOf(ua) != 'String';
        // Juggle arguments.
        if (isCustomContext) {
            context = ua;
            ua = null;
        }
        /** Browser navigator object. */ var nav = context.navigator || {};
        /** Browser user agent string. */ var userAgent = nav.userAgent || '';
        ua || (ua = userAgent);
        /** Used to flag when `thisBinding` is the [ModuleScope]. */ var isModuleScope = isCustomContext || thisBinding == oldRoot;
        /** Used to detect if browser is like Chrome. */ var likeChrome = isCustomContext ? !!nav.likeChrome : /\bChrome\b/.test(ua) && !/internal|\n/i.test(toString.toString());
        /** Internal `[[Class]]` value shortcuts. */ var objectClass = 'Object', airRuntimeClass = isCustomContext ? objectClass : 'ScriptBridgingProxyObject', enviroClass = isCustomContext ? objectClass : 'Environment', javaClass = isCustomContext && context.java ? 'JavaPackage' : getClassOf(context.java), phantomClass = isCustomContext ? objectClass : 'RuntimeObject';
        /** Detect Java environments. */ var java = /\bJava/.test(javaClass) && context.java;
        /** Detect Rhino. */ var rhino = java && getClassOf(context.environment) == enviroClass;
        /** A character to represent alpha. */ var alpha = java ? 'a' : '\u03b1';
        /** A character to represent beta. */ var beta = java ? 'b' : '\u03b2';
        /** Browser document object. */ var doc = context.document || {};
        /**
     * Detect Opera browser (Presto-based).
     * http://www.howtocreate.co.uk/operaStuff/operaObject.html
     * http://dev.opera.com/articles/view/opera-mini-web-content-authoring-guidelines/#operamini
     */ var opera = context.operamini || context.opera;
        /** Opera `[[Class]]`. */ var operaClass = reOpera.test(operaClass = isCustomContext && opera ? opera['[[Class]]'] : getClassOf(opera)) ? operaClass : opera = null;
        /*------------------------------------------------------------------------*/ /** Temporary variable used over the script's lifetime. */ var data;
        /** The CPU architecture. */ var arch = ua;
        /** Platform description array. */ var description = [];
        /** Platform alpha/beta indicator. */ var prerelease = null;
        /** A flag to indicate that environment features should be used to resolve the platform. */ var useFeatures = ua == userAgent;
        /** The browser/environment version. */ var version = useFeatures && opera && typeof opera.version == 'function' && opera.version();
        /** A flag to indicate if the OS ends with "/ Version" */ var isSpecialCasedOS;
        /* Detectable layout engines (order is important). */ var layout = getLayout([
            {
                'label': 'EdgeHTML',
                'pattern': 'Edge'
            },
            'Trident',
            {
                'label': 'WebKit',
                'pattern': 'AppleWebKit'
            },
            'iCab',
            'Presto',
            'NetFront',
            'Tasman',
            'KHTML',
            'Gecko'
        ]);
        /* Detectable browser names (order is important). */ var name = getName([
            'Adobe AIR',
            'Arora',
            'Avant Browser',
            'Breach',
            'Camino',
            'Electron',
            'Epiphany',
            'Fennec',
            'Flock',
            'Galeon',
            'GreenBrowser',
            'iCab',
            'Iceweasel',
            'K-Meleon',
            'Konqueror',
            'Lunascape',
            'Maxthon',
            {
                'label': 'Microsoft Edge',
                'pattern': '(?:Edge|Edg|EdgA|EdgiOS)'
            },
            'Midori',
            'Nook Browser',
            'PaleMoon',
            'PhantomJS',
            'Raven',
            'Rekonq',
            'RockMelt',
            {
                'label': 'Samsung Internet',
                'pattern': 'SamsungBrowser'
            },
            'SeaMonkey',
            {
                'label': 'Silk',
                'pattern': '(?:Cloud9|Silk-Accelerated)'
            },
            'Sleipnir',
            'SlimBrowser',
            {
                'label': 'SRWare Iron',
                'pattern': 'Iron'
            },
            'Sunrise',
            'Swiftfox',
            'Vivaldi',
            'Waterfox',
            'WebPositive',
            {
                'label': 'Yandex Browser',
                'pattern': 'YaBrowser'
            },
            {
                'label': 'UC Browser',
                'pattern': 'UCBrowser'
            },
            'Opera Mini',
            {
                'label': 'Opera Mini',
                'pattern': 'OPiOS'
            },
            'Opera',
            {
                'label': 'Opera',
                'pattern': 'OPR'
            },
            'Chromium',
            'Chrome',
            {
                'label': 'Chrome',
                'pattern': '(?:HeadlessChrome)'
            },
            {
                'label': 'Chrome Mobile',
                'pattern': '(?:CriOS|CrMo)'
            },
            {
                'label': 'Firefox',
                'pattern': '(?:Firefox|Minefield)'
            },
            {
                'label': 'Firefox for iOS',
                'pattern': 'FxiOS'
            },
            {
                'label': 'IE',
                'pattern': 'IEMobile'
            },
            {
                'label': 'IE',
                'pattern': 'MSIE'
            },
            'Safari'
        ]);
        /* Detectable products (order is important). */ var product = getProduct([
            {
                'label': 'BlackBerry',
                'pattern': 'BB10'
            },
            'BlackBerry',
            {
                'label': 'Galaxy S',
                'pattern': 'GT-I9000'
            },
            {
                'label': 'Galaxy S2',
                'pattern': 'GT-I9100'
            },
            {
                'label': 'Galaxy S3',
                'pattern': 'GT-I9300'
            },
            {
                'label': 'Galaxy S4',
                'pattern': 'GT-I9500'
            },
            {
                'label': 'Galaxy S5',
                'pattern': 'SM-G900'
            },
            {
                'label': 'Galaxy S6',
                'pattern': 'SM-G920'
            },
            {
                'label': 'Galaxy S6 Edge',
                'pattern': 'SM-G925'
            },
            {
                'label': 'Galaxy S7',
                'pattern': 'SM-G930'
            },
            {
                'label': 'Galaxy S7 Edge',
                'pattern': 'SM-G935'
            },
            'Google TV',
            'Lumia',
            'iPad',
            'iPod',
            'iPhone',
            'Kindle',
            {
                'label': 'Kindle Fire',
                'pattern': '(?:Cloud9|Silk-Accelerated)'
            },
            'Nexus',
            'Nook',
            'PlayBook',
            'PlayStation Vita',
            'PlayStation',
            'TouchPad',
            'Transformer',
            {
                'label': 'Wii U',
                'pattern': 'WiiU'
            },
            'Wii',
            'Xbox One',
            {
                'label': 'Xbox 360',
                'pattern': 'Xbox'
            },
            'Xoom'
        ]);
        /* Detectable manufacturers. */ var manufacturer = getManufacturer({
            'Apple': {
                'iPad': 1,
                'iPhone': 1,
                'iPod': 1
            },
            'Alcatel': {},
            'Archos': {},
            'Amazon': {
                'Kindle': 1,
                'Kindle Fire': 1
            },
            'Asus': {
                'Transformer': 1
            },
            'Barnes & Noble': {
                'Nook': 1
            },
            'BlackBerry': {
                'PlayBook': 1
            },
            'Google': {
                'Google TV': 1,
                'Nexus': 1
            },
            'HP': {
                'TouchPad': 1
            },
            'HTC': {},
            'Huawei': {},
            'Lenovo': {},
            'LG': {},
            'Microsoft': {
                'Xbox': 1,
                'Xbox One': 1
            },
            'Motorola': {
                'Xoom': 1
            },
            'Nintendo': {
                'Wii U': 1,
                'Wii': 1
            },
            'Nokia': {
                'Lumia': 1
            },
            'Oppo': {},
            'Samsung': {
                'Galaxy S': 1,
                'Galaxy S2': 1,
                'Galaxy S3': 1,
                'Galaxy S4': 1
            },
            'Sony': {
                'PlayStation': 1,
                'PlayStation Vita': 1
            },
            'Xiaomi': {
                'Mi': 1,
                'Redmi': 1
            }
        });
        /* Detectable operating systems (order is important). */ var os = getOS([
            'Windows Phone',
            'KaiOS',
            'Android',
            'CentOS',
            {
                'label': 'Chrome OS',
                'pattern': 'CrOS'
            },
            'Debian',
            {
                'label': 'DragonFly BSD',
                'pattern': 'DragonFly'
            },
            'Fedora',
            'FreeBSD',
            'Gentoo',
            'Haiku',
            'Kubuntu',
            'Linux Mint',
            'OpenBSD',
            'Red Hat',
            'SuSE',
            'Ubuntu',
            'Xubuntu',
            'Cygwin',
            'Symbian OS',
            'hpwOS',
            'webOS ',
            'webOS',
            'Tablet OS',
            'Tizen',
            'Linux',
            'Mac OS X',
            'Macintosh',
            'Mac',
            'Windows 98;',
            'Windows '
        ]);
        /*------------------------------------------------------------------------*/ /**
     * Picks the layout engine from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected layout engine.
     */ function getLayout(guesses) {
            return reduce(guesses, function(result, guess) {
                return result || RegExp('\\b' + (guess.pattern || qualify(guess)) + '\\b', 'i').exec(ua) && (guess.label || guess);
            });
        }
        /**
     * Picks the manufacturer from an array of guesses.
     *
     * @private
     * @param {Array} guesses An object of guesses.
     * @returns {null|string} The detected manufacturer.
     */ function getManufacturer(guesses) {
            return reduce(guesses, function(result, value, key) {
                // Lookup the manufacturer by product or scan the UA for the manufacturer.
                return result || (value[product] || value[/^[a-z]+(?: +[a-z]+\b)*/i.exec(product)] || RegExp('\\b' + qualify(key) + '(?:\\b|\\w*\\d)', 'i').exec(ua)) && key;
            });
        }
        /**
     * Picks the browser name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected browser name.
     */ function getName(guesses) {
            return reduce(guesses, function(result, guess) {
                return result || RegExp('\\b' + (guess.pattern || qualify(guess)) + '\\b', 'i').exec(ua) && (guess.label || guess);
            });
        }
        /**
     * Picks the OS name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected OS name.
     */ function getOS(guesses) {
            return reduce(guesses, function(result, guess) {
                var pattern = guess.pattern || qualify(guess);
                if (!result && (result = RegExp('\\b' + pattern + '(?:/[\\d.]+|[ \\w.]*)', 'i').exec(ua))) result = cleanupOS(result, pattern, guess.label || guess);
                return result;
            });
        }
        /**
     * Picks the product name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected product name.
     */ function getProduct(guesses) {
            return reduce(guesses, function(result, guess) {
                var pattern = guess.pattern || qualify(guess);
                if (!result && (result = RegExp('\\b' + pattern + ' *\\d+[.\\w_]*', 'i').exec(ua) || RegExp('\\b' + pattern + ' *\\w+-[\\w]*', 'i').exec(ua) || RegExp('\\b' + pattern + '(?:; *(?:[a-z]+[_-])?[a-z]+\\d+|[^ ();-]*)', 'i').exec(ua))) {
                    // Split by forward slash and append product version if needed.
                    if ((result = String(guess.label && !RegExp(pattern, 'i').test(guess.label) ? guess.label : result).split('/'))[1] && !/[\d.]+/.test(result[0])) result[0] += ' ' + result[1];
                    // Correct character case and cleanup string.
                    guess = guess.label || guess;
                    result = format(result[0].replace(RegExp(pattern, 'i'), guess).replace(RegExp('; *(?:' + guess + '[_-])?', 'i'), ' ').replace(RegExp('(' + guess + ')[-_.]?(\\w)', 'i'), '$1 $2'));
                }
                return result;
            });
        }
        /**
     * Resolves the version using an array of UA patterns.
     *
     * @private
     * @param {Array} patterns An array of UA patterns.
     * @returns {null|string} The detected version.
     */ function getVersion(patterns) {
            return reduce(patterns, function(result, pattern) {
                return result || (RegExp(pattern + '(?:-[\\d.]+/|(?: for [\\w-]+)?[ /-])([\\d.]+[^ ();/_-]*)', 'i').exec(ua) || 0)[1] || null;
            });
        }
        /**
     * Returns `platform.description` when the platform object is coerced to a string.
     *
     * @name toString
     * @memberOf platform
     * @returns {string} Returns `platform.description` if available, else an empty string.
     */ function toStringPlatform() {
            return this.description || '';
        }
        /*------------------------------------------------------------------------*/ // Convert layout to an array so we can add extra details.
        layout && (layout = [
            layout
        ]);
        // Detect Android products.
        // Browsers on Android devices typically provide their product IDS after "Android;"
        // up to "Build" or ") AppleWebKit".
        // Example:
        // "Mozilla/5.0 (Linux; Android 8.1.0; Moto G (5) Plus) AppleWebKit/537.36
        // (KHTML, like Gecko) Chrome/70.0.3538.80 Mobile Safari/537.36"
        if (/\bAndroid\b/.test(os) && !product && (data = /\bAndroid[^;]*;(.*?)(?:Build|\) AppleWebKit)\b/i.exec(ua))) product = trim(data[1])// Replace any language codes (eg. "en-US").
        .replace(/^[a-z]{2}-[a-z]{2};\s*/i, '') || null;
        // Detect product names that contain their manufacturer's name.
        if (manufacturer && !product) product = getProduct([
            manufacturer
        ]);
        else if (manufacturer && product) product = product.replace(RegExp('^(' + qualify(manufacturer) + ')[-_.\\s]', 'i'), manufacturer + ' ').replace(RegExp('^(' + qualify(manufacturer) + ')[-_.]?(\\w)', 'i'), manufacturer + ' $2');
        // Clean up Google TV.
        if (data = /\bGoogle TV\b/.exec(product)) product = data[0];
        // Detect simulators.
        if (/\bSimulator\b/i.test(ua)) product = (product ? product + ' ' : '') + 'Simulator';
        // Detect Opera Mini 8+ running in Turbo/Uncompressed mode on iOS.
        if (name == 'Opera Mini' && /\bOPiOS\b/.test(ua)) description.push('running in Turbo/Uncompressed mode');
        // Detect IE Mobile 11.
        if (name == 'IE' && /\blike iPhone OS\b/.test(ua)) {
            data = parse(ua.replace(/like iPhone OS/, ''));
            manufacturer = data.manufacturer;
            product = data.product;
        } else if (/^iP/.test(product)) {
            name || (name = 'Safari');
            os = 'iOS' + ((data = / OS ([\d_]+)/i.exec(ua)) ? ' ' + data[1].replace(/_/g, '.') : '');
        } else if (name == 'Konqueror' && /^Linux\b/i.test(os)) os = 'Kubuntu';
        else if (manufacturer && manufacturer != 'Google' && (/Chrome/.test(name) && !/\bMobile Safari\b/i.test(ua) || /\bVita\b/.test(product)) || /\bAndroid\b/.test(os) && /^Chrome/.test(name) && /\bVersion\//i.test(ua)) {
            name = 'Android Browser';
            os = /\bAndroid\b/.test(os) ? os : 'Android';
        } else if (name == 'Silk') {
            if (!/\bMobi/i.test(ua)) {
                os = 'Android';
                description.unshift('desktop mode');
            }
            if (/Accelerated *= *true/i.test(ua)) description.unshift('accelerated');
        } else if (name == 'UC Browser' && /\bUCWEB\b/.test(ua)) description.push('speed mode');
        else if (name == 'PaleMoon' && (data = /\bFirefox\/([\d.]+)\b/.exec(ua))) description.push('identifying as Firefox ' + data[1]);
        else if (name == 'Firefox' && (data = /\b(Mobile|Tablet|TV)\b/i.exec(ua))) {
            os || (os = 'Firefox OS');
            product || (product = data[1]);
        } else if (!name || (data = !/\bMinefield\b/i.test(ua) && /\b(?:Firefox|Safari)\b/.exec(name))) {
            // Escape the `/` for Firefox 1.
            if (name && !product && /[\/,]|^[^(]+?\)/.test(ua.slice(ua.indexOf(data + '/') + 8))) // Clear name of false positives.
            name = null;
            // Reassign a generic name.
            if ((data = product || manufacturer || os) && (product || manufacturer || /\b(?:Android|Symbian OS|Tablet OS|webOS)\b/.test(os))) name = /[a-z]+(?: Hat)?/i.exec(/\bAndroid\b/.test(os) ? os : data) + ' Browser';
        } else if (name == 'Electron' && (data = (/\bChrome\/([\d.]+)\b/.exec(ua) || 0)[1])) description.push('Chromium ' + data);
        // Detect non-Opera (Presto-based) versions (order is important).
        if (!version) version = getVersion([
            '(?:Cloud9|CriOS|CrMo|Edge|Edg|EdgA|EdgiOS|FxiOS|HeadlessChrome|IEMobile|Iron|Opera ?Mini|OPiOS|OPR|Raven|SamsungBrowser|Silk(?!/[\\d.]+$)|UCBrowser|YaBrowser)',
            'Version',
            qualify(name),
            '(?:Firefox|Minefield|NetFront)'
        ]);
        // Detect stubborn layout engines.
        if (data = layout == 'iCab' && parseFloat(version) > 3 && 'WebKit' || /\bOpera\b/.test(name) && (/\bOPR\b/.test(ua) ? 'Blink' : 'Presto') || /\b(?:Midori|Nook|Safari)\b/i.test(ua) && !/^(?:Trident|EdgeHTML)$/.test(layout) && 'WebKit' || !layout && /\bMSIE\b/i.test(ua) && (os == 'Mac OS' ? 'Tasman' : 'Trident') || layout == 'WebKit' && /\bPlayStation\b(?! Vita\b)/i.test(name) && 'NetFront') layout = [
            data
        ];
        // Detect Windows Phone 7 desktop mode.
        if (name == 'IE' && (data = (/; *(?:XBLWP|ZuneWP)(\d+)/i.exec(ua) || 0)[1])) {
            name += ' Mobile';
            os = 'Windows Phone ' + (/\+$/.test(data) ? data : data + '.x');
            description.unshift('desktop mode');
        } else if (/\bWPDesktop\b/i.test(ua)) {
            name = 'IE Mobile';
            os = 'Windows Phone 8.x';
            description.unshift('desktop mode');
            version || (version = (/\brv:([\d.]+)/.exec(ua) || 0)[1]);
        } else if (name != 'IE' && layout == 'Trident' && (data = /\brv:([\d.]+)/.exec(ua))) {
            if (name) description.push('identifying as ' + name + (version ? ' ' + version : ''));
            name = 'IE';
            version = data[1];
        }
        // Leverage environment features.
        if (useFeatures) {
            // Detect server-side environments.
            // Rhino has a global function while others have a global object.
            if (isHostType(context, 'global')) {
                if (java) {
                    data = java.lang.System;
                    arch = data.getProperty('os.arch');
                    os = os || data.getProperty('os.name') + ' ' + data.getProperty('os.version');
                }
                if (rhino) {
                    try {
                        version = context.require('ringo/engine').version.join('.');
                        name = 'RingoJS';
                    } catch (e) {
                        if ((data = context.system) && data.global.system == context.system) {
                            name = 'Narwhal';
                            os || (os = data[0].os || null);
                        }
                    }
                    if (!name) name = 'Rhino';
                } else if (typeof context.process == 'object' && !context.process.browser && (data = context.process)) {
                    if (typeof data.versions == 'object') {
                        if (typeof data.versions.electron == 'string') {
                            description.push('Node ' + data.versions.node);
                            name = 'Electron';
                            version = data.versions.electron;
                        } else if (typeof data.versions.nw == 'string') {
                            description.push('Chromium ' + version, 'Node ' + data.versions.node);
                            name = 'NW.js';
                            version = data.versions.nw;
                        }
                    }
                    if (!name) {
                        name = 'Node.js';
                        arch = data.arch;
                        os = data.platform;
                        version = /[\d.]+/.exec(data.version);
                        version = version ? version[0] : null;
                    }
                }
            } else if (getClassOf(data = context.runtime) == airRuntimeClass) {
                name = 'Adobe AIR';
                os = data.flash.system.Capabilities.os;
            } else if (getClassOf(data = context.phantom) == phantomClass) {
                name = 'PhantomJS';
                version = (data = data.version || null) && data.major + '.' + data.minor + '.' + data.patch;
            } else if (typeof doc.documentMode == 'number' && (data = /\bTrident\/(\d+)/i.exec(ua))) {
                // We're in compatibility mode when the Trident version + 4 doesn't
                // equal the document mode.
                version = [
                    version,
                    doc.documentMode
                ];
                if ((data = +data[1] + 4) != version[1]) {
                    description.push('IE ' + version[1] + ' mode');
                    layout && (layout[1] = '');
                    version[1] = data;
                }
                version = name == 'IE' ? String(version[1].toFixed(1)) : version[0];
            } else if (typeof doc.documentMode == 'number' && /^(?:Chrome|Firefox)\b/.test(name)) {
                description.push('masking as ' + name + ' ' + version);
                name = 'IE';
                version = '11.0';
                layout = [
                    'Trident'
                ];
                os = 'Windows';
            }
            os = os && format(os);
        }
        // Detect prerelease phases.
        if (version && (data = /(?:[ab]|dp|pre|[ab]\d+pre)(?:\d+\+?)?$/i.exec(version) || /(?:alpha|beta)(?: ?\d)?/i.exec(ua + ';' + (useFeatures && nav.appMinorVersion)) || /\bMinefield\b/i.test(ua) && 'a')) {
            prerelease = /b/i.test(data) ? 'beta' : 'alpha';
            version = version.replace(RegExp(data + '\\+?$'), '') + (prerelease == 'beta' ? beta : alpha) + (/\d+\+?/.exec(data) || '');
        }
        // Detect Firefox Mobile.
        if (name == 'Fennec' || name == 'Firefox' && /\b(?:Android|Firefox OS|KaiOS)\b/.test(os)) name = 'Firefox Mobile';
        else if (name == 'Maxthon' && version) version = version.replace(/\.[\d.]+/, '.x');
        else if (/\bXbox\b/i.test(product)) {
            if (product == 'Xbox 360') os = null;
            if (product == 'Xbox 360' && /\bIEMobile\b/.test(ua)) description.unshift('mobile mode');
        } else if ((/^(?:Chrome|IE|Opera)$/.test(name) || name && !product && !/Browser|Mobi/.test(name)) && (os == 'Windows CE' || /Mobi/i.test(ua))) name += ' Mobile';
        else if (name == 'IE' && useFeatures) try {
            if (context.external === null) description.unshift('platform preview');
        } catch (e) {
            description.unshift('embedded');
        }
        else if ((/\bBlackBerry\b/.test(product) || /\bBB10\b/.test(ua)) && (data = (RegExp(product.replace(/ +/g, ' *') + '/([.\\d]+)', 'i').exec(ua) || 0)[1] || version)) {
            data = [
                data,
                /BB10/.test(ua)
            ];
            os = (data[1] ? (product = null, manufacturer = 'BlackBerry') : 'Device Software') + ' ' + data[0];
            version = null;
        } else if (this != forOwn && product != 'Wii' && (useFeatures && opera || /Opera/.test(name) && /\b(?:MSIE|Firefox)\b/i.test(ua) || name == 'Firefox' && /\bOS X (?:\d+\.){2,}/.test(os) || name == 'IE' && (os && !/^Win/.test(os) && version > 5.5 || /\bWindows XP\b/.test(os) && version > 8 || version == 8 && !/\bTrident\b/.test(ua))) && !reOpera.test(data = parse.call(forOwn, ua.replace(reOpera, '') + ';')) && data.name) {
            // When "identifying", the UA contains both Opera and the other browser's name.
            data = 'ing as ' + data.name + ((data = data.version) ? ' ' + data : '');
            if (reOpera.test(name)) {
                if (/\bIE\b/.test(data) && os == 'Mac OS') os = null;
                data = 'identify' + data;
            } else {
                data = 'mask' + data;
                if (operaClass) name = format(operaClass.replace(/([a-z])([A-Z])/g, '$1 $2'));
                else name = 'Opera';
                if (/\bIE\b/.test(data)) os = null;
                if (!useFeatures) version = null;
            }
            layout = [
                'Presto'
            ];
            description.push(data);
        }
        // Detect WebKit Nightly and approximate Chrome/Safari versions.
        if (data = (/\bAppleWebKit\/([\d.]+\+?)/i.exec(ua) || 0)[1]) {
            // Correct build number for numeric comparison.
            // (e.g. "532.5" becomes "532.05")
            data = [
                parseFloat(data.replace(/\.(\d)$/, '.0$1')),
                data
            ];
            // Nightly builds are postfixed with a "+".
            if (name == 'Safari' && data[1].slice(-1) == '+') {
                name = 'WebKit Nightly';
                prerelease = 'alpha';
                version = data[1].slice(0, -1);
            } else if (version == data[1] || version == (data[2] = (/\bSafari\/([\d.]+\+?)/i.exec(ua) || 0)[1])) version = null;
            // Use the full Chrome version when available.
            data[1] = (/\b(?:Headless)?Chrome\/([\d.]+)/i.exec(ua) || 0)[1];
            // Detect Blink layout engine.
            if (data[0] == 537.36 && data[2] == 537.36 && parseFloat(data[1]) >= 28 && layout == 'WebKit') layout = [
                'Blink'
            ];
            // Detect JavaScriptCore.
            // http://stackoverflow.com/questions/6768474/how-can-i-detect-which-javascript-engine-v8-or-jsc-is-used-at-runtime-in-androi
            if (!useFeatures || !likeChrome && !data[1]) {
                layout && (layout[1] = 'like Safari');
                data = (data = data[0], data < 400 ? 1 : data < 500 ? 2 : data < 526 ? 3 : data < 533 ? 4 : data < 534 ? '4+' : data < 535 ? 5 : data < 537 ? 6 : data < 538 ? 7 : data < 601 ? 8 : data < 602 ? 9 : data < 604 ? 10 : data < 606 ? 11 : data < 608 ? 12 : '12');
            } else {
                layout && (layout[1] = 'like Chrome');
                data = data[1] || (data = data[0], data < 530 ? 1 : data < 532 ? 2 : data < 532.05 ? 3 : data < 533 ? 4 : data < 534.03 ? 5 : data < 534.07 ? 6 : data < 534.10 ? 7 : data < 534.13 ? 8 : data < 534.16 ? 9 : data < 534.24 ? 10 : data < 534.30 ? 11 : data < 535.01 ? 12 : data < 535.02 ? '13+' : data < 535.07 ? 15 : data < 535.11 ? 16 : data < 535.19 ? 17 : data < 536.05 ? 18 : data < 536.10 ? 19 : data < 537.01 ? 20 : data < 537.11 ? '21+' : data < 537.13 ? 23 : data < 537.18 ? 24 : data < 537.24 ? 25 : data < 537.36 ? 26 : layout != 'Blink' ? '27' : '28');
            }
            // Add the postfix of ".x" or "+" for approximate versions.
            layout && (layout[1] += ' ' + (data += typeof data == 'number' ? '.x' : /[.+]/.test(data) ? '' : '+'));
            // Obscure version for some Safari 1-2 releases.
            if (name == 'Safari' && (!version || parseInt(version) > 45)) version = data;
            else if (name == 'Chrome' && /\bHeadlessChrome/i.test(ua)) description.unshift('headless');
        }
        // Detect Opera desktop modes.
        if (name == 'Opera' && (data = /\bzbov|zvav$/.exec(os))) {
            name += ' ';
            description.unshift('desktop mode');
            if (data == 'zvav') {
                name += 'Mini';
                version = null;
            } else name += 'Mobile';
            os = os.replace(RegExp(' *' + data + '$'), '');
        } else if (name == 'Safari' && /\bChrome\b/.exec(layout && layout[1])) {
            description.unshift('desktop mode');
            name = 'Chrome Mobile';
            version = null;
            if (/\bOS X\b/.test(os)) {
                manufacturer = 'Apple';
                os = 'iOS 4.3+';
            } else os = null;
        } else if (/\bSRWare Iron\b/.test(name) && !version) version = getVersion('Chrome');
        // Strip incorrect OS versions.
        if (version && version.indexOf(data = /[\d.]+$/.exec(os)) == 0 && ua.indexOf('/' + data + '-') > -1) os = trim(os.replace(data, ''));
        // Ensure OS does not include the browser name.
        if (os && os.indexOf(name) != -1 && !RegExp(name + ' OS').test(os)) os = os.replace(RegExp(' *' + qualify(name) + ' *'), '');
        // Add layout engine.
        if (layout && !/\b(?:Avant|Nook)\b/.test(name) && (/Browser|Lunascape|Maxthon/.test(name) || name != 'Safari' && /^iOS/.test(os) && /\bSafari\b/.test(layout[1]) || /^(?:Adobe|Arora|Breach|Midori|Opera|Phantom|Rekonq|Rock|Samsung Internet|Sleipnir|SRWare Iron|Vivaldi|Web)/.test(name) && layout[1])) // Don't add layout details to description if they are falsey.
        (data = layout[layout.length - 1]) && description.push(data);
        // Combine contextual information.
        if (description.length) description = [
            '(' + description.join('; ') + ')'
        ];
        // Append manufacturer to description.
        if (manufacturer && product && product.indexOf(manufacturer) < 0) description.push('on ' + manufacturer);
        // Append product to description.
        if (product) description.push((/^on /.test(description[description.length - 1]) ? '' : 'on ') + product);
        // Parse the OS into an object.
        if (os) {
            data = / ([\d.+]+)$/.exec(os);
            isSpecialCasedOS = data && os.charAt(os.length - data[0].length - 1) == '/';
            os = {
                'architecture': 32,
                'family': data && !isSpecialCasedOS ? os.replace(data[0], '') : os,
                'version': data ? data[1] : null,
                'toString': function() {
                    var version = this.version;
                    return this.family + (version && !isSpecialCasedOS ? ' ' + version : '') + (this.architecture == 64 ? ' 64-bit' : '');
                }
            };
        }
        // Add browser/OS architecture.
        if ((data = /\b(?:AMD|IA|Win|WOW|x86_|x)64\b/i.exec(arch)) && !/\bi686\b/i.test(arch)) {
            if (os) {
                os.architecture = 64;
                os.family = os.family.replace(RegExp(' *' + data), '');
            }
            if (name && (/\bWOW64\b/i.test(ua) || useFeatures && /\w(?:86|32)$/.test(nav.cpuClass || nav.platform) && !/\bWin64; x64\b/i.test(ua))) description.unshift('32-bit');
        } else if (os && /^OS X/.test(os.family) && name == 'Chrome' && parseFloat(version) >= 39) os.architecture = 64;
        ua || (ua = null);
        /*------------------------------------------------------------------------*/ /**
     * The platform object.
     *
     * @name platform
     * @type Object
     */ var platform = {};
        /**
     * The platform description.
     *
     * @memberOf platform
     * @type string|null
     */ platform.description = ua;
        /**
     * The name of the browser's layout engine.
     *
     * The list of common layout engines include:
     * "Blink", "EdgeHTML", "Gecko", "Trident" and "WebKit"
     *
     * @memberOf platform
     * @type string|null
     */ platform.layout = layout && layout[0];
        /**
     * The name of the product's manufacturer.
     *
     * The list of manufacturers include:
     * "Apple", "Archos", "Amazon", "Asus", "Barnes & Noble", "BlackBerry",
     * "Google", "HP", "HTC", "LG", "Microsoft", "Motorola", "Nintendo",
     * "Nokia", "Samsung" and "Sony"
     *
     * @memberOf platform
     * @type string|null
     */ platform.manufacturer = manufacturer;
        /**
     * The name of the browser/environment.
     *
     * The list of common browser names include:
     * "Chrome", "Electron", "Firefox", "Firefox for iOS", "IE",
     * "Microsoft Edge", "PhantomJS", "Safari", "SeaMonkey", "Silk",
     * "Opera Mini" and "Opera"
     *
     * Mobile versions of some browsers have "Mobile" appended to their name:
     * eg. "Chrome Mobile", "Firefox Mobile", "IE Mobile" and "Opera Mobile"
     *
     * @memberOf platform
     * @type string|null
     */ platform.name = name;
        /**
     * The alpha/beta release indicator.
     *
     * @memberOf platform
     * @type string|null
     */ platform.prerelease = prerelease;
        /**
     * The name of the product hosting the browser.
     *
     * The list of common products include:
     *
     * "BlackBerry", "Galaxy S4", "Lumia", "iPad", "iPod", "iPhone", "Kindle",
     * "Kindle Fire", "Nexus", "Nook", "PlayBook", "TouchPad" and "Transformer"
     *
     * @memberOf platform
     * @type string|null
     */ platform.product = product;
        /**
     * The browser's user agent string.
     *
     * @memberOf platform
     * @type string|null
     */ platform.ua = ua;
        /**
     * The browser/environment version.
     *
     * @memberOf platform
     * @type string|null
     */ platform.version = name && version;
        /**
     * The name of the operating system.
     *
     * @memberOf platform
     * @type Object
     */ platform.os = os || {
            /**
       * The CPU architecture the OS is built for.
       *
       * @memberOf platform.os
       * @type number|null
       */ 'architecture': null,
            /**
       * The family of the OS.
       *
       * Common values include:
       * "Windows", "Windows Server 2008 R2 / 7", "Windows Server 2008 / Vista",
       * "Windows XP", "OS X", "Linux", "Ubuntu", "Debian", "Fedora", "Red Hat",
       * "SuSE", "Android", "iOS" and "Windows Phone"
       *
       * @memberOf platform.os
       * @type string|null
       */ 'family': null,
            /**
       * The version of the OS.
       *
       * @memberOf platform.os
       * @type string|null
       */ 'version': null,
            /**
       * Returns the OS string.
       *
       * @memberOf platform.os
       * @returns {string} The OS string.
       */ 'toString': function() {
                return 'null';
            }
        };
        platform.parse = parse;
        platform.toString = toStringPlatform;
        if (platform.version) description.unshift(version);
        if (platform.name) description.unshift(name);
        if (os && name && !(os == String(os).split(' ')[0] && (os == name.split(' ')[0] || product))) description.push(product ? '(' + os + ')' : 'on ' + os);
        if (description.length) platform.description = description.join(' ');
        return platform;
    }
    /*--------------------------------------------------------------------------*/ // Export platform.
    var platform = parse();
    // Some AMD build optimizers, like r.js, check for condition patterns like the following:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose platform on the global object to prevent errors when platform is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        root.platform = platform;
        // Define as an anonymous module so platform can be aliased through path mapping.
        define(function() {
            return platform;
        });
    } else if (freeExports && freeModule) // Export for CommonJS support.
    forOwn(platform, function(value, key) {
        freeExports[key] = value;
    });
    else // Export to the global object.
    root.platform = platform;
}).call(this);

});

var $0887857d5dc8fa07$exports = {};
$parcel$extendImportMap({
    "laPnj": "information-drawer-content-generic.8d2883c6.js",
    "cMtxv": "information-drawer-content-generic.8d0a6a81.css"
});


var $9h2J6 = parcelRequire("9h2J6");
parcelRequire("7RNO0");
var $184b34fb482779c0$export$882461b6382ed46c;
var $184b34fb482779c0$export$757ceba2d55c277e;
'use strict';

var $7WYFd = parcelRequire("7WYFd");
var $184b34fb482779c0$var$i;
$184b34fb482779c0$export$882461b6382ed46c = $7WYFd.createRoot;
$184b34fb482779c0$export$757ceba2d55c277e = $7WYFd.hydrateRoot;


/**
 * React Router DOM v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7RNO0 = parcelRequire("7RNO0");

var $7WYFd = parcelRequire("7WYFd");
/**
 * @remix-run/router v1.23.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $7f1a18ee472fa989$var$_extends() {
    $7f1a18ee472fa989$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7f1a18ee472fa989$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $7f1a18ee472fa989$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($7f1a18ee472fa989$export$e19cd5f9376f8cee || ($7f1a18ee472fa989$export$e19cd5f9376f8cee = {}));
const $7f1a18ee472fa989$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $7f1a18ee472fa989$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $7f1a18ee472fa989$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $7f1a18ee472fa989$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $7f1a18ee472fa989$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $7f1a18ee472fa989$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $7f1a18ee472fa989$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $7f1a18ee472fa989$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $7f1a18ee472fa989$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $7f1a18ee472fa989$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $7f1a18ee472fa989$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $7f1a18ee472fa989$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $7f1a18ee472fa989$export$fe53371bee54353d(to);
    }
    return $7f1a18ee472fa989$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $7f1a18ee472fa989$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $7f1a18ee472fa989$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $7f1a18ee472fa989$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $7f1a18ee472fa989$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $7f1a18ee472fa989$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $7f1a18ee472fa989$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $7f1a18ee472fa989$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $7f1a18ee472fa989$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $7f1a18ee472fa989$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $7f1a18ee472fa989$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $7f1a18ee472fa989$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $7f1a18ee472fa989$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $7f1a18ee472fa989$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $7f1a18ee472fa989$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $7f1a18ee472fa989$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $7f1a18ee472fa989$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $7f1a18ee472fa989$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $7f1a18ee472fa989$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($7f1a18ee472fa989$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $7f1a18ee472fa989$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $7f1a18ee472fa989$export$e19cd5f9376f8cee.Push;
        let location = $7f1a18ee472fa989$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $7f1a18ee472fa989$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $7f1a18ee472fa989$export$e19cd5f9376f8cee.Replace;
        let location = $7f1a18ee472fa989$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $7f1a18ee472fa989$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $7f1a18ee472fa989$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $7f1a18ee472fa989$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($7f1a18ee472fa989$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($7f1a18ee472fa989$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $7f1a18ee472fa989$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($7f1a18ee472fa989$var$ResultType || ($7f1a18ee472fa989$var$ResultType = {}));
const $7f1a18ee472fa989$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $7f1a18ee472fa989$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $7f1a18ee472fa989$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $7f1a18ee472fa989$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $7f1a18ee472fa989$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($7f1a18ee472fa989$var$isIndexRoute(route)) {
            let indexRoute = $7f1a18ee472fa989$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $7f1a18ee472fa989$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $7f1a18ee472fa989$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $7f1a18ee472fa989$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $7f1a18ee472fa989$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $7f1a18ee472fa989$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $7f1a18ee472fa989$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $7f1a18ee472fa989$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $7f1a18ee472fa989$var$flattenRoutes(routes);
    $7f1a18ee472fa989$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $7f1a18ee472fa989$export$30d21fd6d7295f52(pathname);
        matches = $7f1a18ee472fa989$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $7f1a18ee472fa989$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $7f1a18ee472fa989$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $7f1a18ee472fa989$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $7f1a18ee472fa989$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $7f1a18ee472fa989$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $7f1a18ee472fa989$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $7f1a18ee472fa989$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $7f1a18ee472fa989$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $7f1a18ee472fa989$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $7f1a18ee472fa989$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $7f1a18ee472fa989$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $7f1a18ee472fa989$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $7f1a18ee472fa989$var$paramRe = /^:[\w-]+$/;
const $7f1a18ee472fa989$var$dynamicSegmentValue = 3;
const $7f1a18ee472fa989$var$indexRouteValue = 2;
const $7f1a18ee472fa989$var$emptySegmentValue = 1;
const $7f1a18ee472fa989$var$staticSegmentValue = 10;
const $7f1a18ee472fa989$var$splatPenalty = -2;
const $7f1a18ee472fa989$var$isSplat = (s)=>s === "*";
function $7f1a18ee472fa989$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($7f1a18ee472fa989$var$isSplat)) initialScore += $7f1a18ee472fa989$var$splatPenalty;
    if (index) initialScore += $7f1a18ee472fa989$var$indexRouteValue;
    return segments.filter((s)=>!$7f1a18ee472fa989$var$isSplat(s)).reduce((score, segment)=>score + ($7f1a18ee472fa989$var$paramRe.test(segment) ? $7f1a18ee472fa989$var$dynamicSegmentValue : segment === "" ? $7f1a18ee472fa989$var$emptySegmentValue : $7f1a18ee472fa989$var$staticSegmentValue), initialScore);
}
function $7f1a18ee472fa989$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $7f1a18ee472fa989$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $7f1a18ee472fa989$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $7f1a18ee472fa989$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $7f1a18ee472fa989$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $7f1a18ee472fa989$export$a5c6d149b50c1d86($7f1a18ee472fa989$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $7f1a18ee472fa989$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $7f1a18ee472fa989$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $7f1a18ee472fa989$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $7f1a18ee472fa989$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $7f1a18ee472fa989$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $7f1a18ee472fa989$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $7f1a18ee472fa989$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $7f1a18ee472fa989$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $7f1a18ee472fa989$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $7f1a18ee472fa989$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $7f1a18ee472fa989$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
const $7f1a18ee472fa989$var$ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $7f1a18ee472fa989$var$isAbsoluteUrl = (url)=>$7f1a18ee472fa989$var$ABSOLUTE_URL_REGEX$1.test(url);
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $7f1a18ee472fa989$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $7f1a18ee472fa989$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($7f1a18ee472fa989$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                $7f1a18ee472fa989$export$c0e02632e14916fd(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = $7f1a18ee472fa989$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $7f1a18ee472fa989$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $7f1a18ee472fa989$var$normalizeSearch(search),
        hash: $7f1a18ee472fa989$var$normalizeHash(hash)
    };
}
function $7f1a18ee472fa989$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $7f1a18ee472fa989$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $7f1a18ee472fa989$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $7f1a18ee472fa989$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $7f1a18ee472fa989$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $7f1a18ee472fa989$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $7f1a18ee472fa989$export$8ccf933b0513f8d0(toArg);
    else {
        to = $7f1a18ee472fa989$var$_extends({}, toArg);
        $7f1a18ee472fa989$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $7f1a18ee472fa989$var$getInvalidPathError("?", "pathname", "search", to));
        $7f1a18ee472fa989$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $7f1a18ee472fa989$var$getInvalidPathError("#", "pathname", "hash", to));
        $7f1a18ee472fa989$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $7f1a18ee472fa989$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $7f1a18ee472fa989$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $7f1a18ee472fa989$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $7f1a18ee472fa989$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $7f1a18ee472fa989$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $7f1a18ee472fa989$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $7f1a18ee472fa989$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $7f1a18ee472fa989$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $7f1a18ee472fa989$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $7f1a18ee472fa989$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $7f1a18ee472fa989$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $7f1a18ee472fa989$export$4051a07651545597(data, init) {
    return new $7f1a18ee472fa989$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $7f1a18ee472fa989$export$42a99a7a4bc0e76a extends Error {
}
class $7f1a18ee472fa989$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $7f1a18ee472fa989$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $7f1a18ee472fa989$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $7f1a18ee472fa989$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $7f1a18ee472fa989$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $7f1a18ee472fa989$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $7f1a18ee472fa989$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $7f1a18ee472fa989$var$unwrapTrackedPromise(value) {
    if (!$7f1a18ee472fa989$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $7f1a18ee472fa989$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $7f1a18ee472fa989$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $7f1a18ee472fa989$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $7f1a18ee472fa989$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $7f1a18ee472fa989$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $7f1a18ee472fa989$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $7f1a18ee472fa989$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $7f1a18ee472fa989$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $7f1a18ee472fa989$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $7f1a18ee472fa989$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $7f1a18ee472fa989$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $7f1a18ee472fa989$var$validMutationMethods = new Set($7f1a18ee472fa989$var$validMutationMethodsArr);
const $7f1a18ee472fa989$var$validRequestMethodsArr = [
    "get",
    ...$7f1a18ee472fa989$var$validMutationMethodsArr
];
const $7f1a18ee472fa989$var$validRequestMethods = new Set($7f1a18ee472fa989$var$validRequestMethodsArr);
const $7f1a18ee472fa989$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $7f1a18ee472fa989$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $7f1a18ee472fa989$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $7f1a18ee472fa989$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $7f1a18ee472fa989$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $7f1a18ee472fa989$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $7f1a18ee472fa989$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $7f1a18ee472fa989$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $7f1a18ee472fa989$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $7f1a18ee472fa989$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $7f1a18ee472fa989$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $7f1a18ee472fa989$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $7f1a18ee472fa989$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $7f1a18ee472fa989$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $7f1a18ee472fa989$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $7f1a18ee472fa989$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $7f1a18ee472fa989$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$7f1a18ee472fa989$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$7f1a18ee472fa989$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $7f1a18ee472fa989$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $7f1a18ee472fa989$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $7f1a18ee472fa989$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $7f1a18ee472fa989$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $7f1a18ee472fa989$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$7f1a18ee472fa989$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($7f1a18ee472fa989$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $7f1a18ee472fa989$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $7f1a18ee472fa989$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $7f1a18ee472fa989$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $7f1a18ee472fa989$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $7f1a18ee472fa989$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $7f1a18ee472fa989$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $7f1a18ee472fa989$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $7f1a18ee472fa989$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $7f1a18ee472fa989$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($7f1a18ee472fa989$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $7f1a18ee472fa989$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $7f1a18ee472fa989$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $7f1a18ee472fa989$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $7f1a18ee472fa989$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $7f1a18ee472fa989$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $7f1a18ee472fa989$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $7f1a18ee472fa989$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $7f1a18ee472fa989$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $7f1a18ee472fa989$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $7f1a18ee472fa989$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $7f1a18ee472fa989$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $7f1a18ee472fa989$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $7f1a18ee472fa989$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $7f1a18ee472fa989$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $7f1a18ee472fa989$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $7f1a18ee472fa989$var$findNearestBoundary(matches).route.id,
            {
                type: $7f1a18ee472fa989$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $7f1a18ee472fa989$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($7f1a18ee472fa989$var$isErrorResult(result) && $7f1a18ee472fa989$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $7f1a18ee472fa989$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $7f1a18ee472fa989$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $7f1a18ee472fa989$var$_extends({
            matches: updatedMatches || matches
        }, $7f1a18ee472fa989$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $7f1a18ee472fa989$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $7f1a18ee472fa989$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $7f1a18ee472fa989$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $7f1a18ee472fa989$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $7f1a18ee472fa989$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $7f1a18ee472fa989$var$ResultType.error,
            error: $7f1a18ee472fa989$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($7f1a18ee472fa989$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $7f1a18ee472fa989$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($7f1a18ee472fa989$var$isDeferredResult(result)) throw $7f1a18ee472fa989$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($7f1a18ee472fa989$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $7f1a18ee472fa989$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $7f1a18ee472fa989$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $7f1a18ee472fa989$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $7f1a18ee472fa989$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($7f1a18ee472fa989$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $7f1a18ee472fa989$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $7f1a18ee472fa989$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $7f1a18ee472fa989$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $7f1a18ee472fa989$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $7f1a18ee472fa989$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $7f1a18ee472fa989$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $7f1a18ee472fa989$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $7f1a18ee472fa989$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $7f1a18ee472fa989$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $7f1a18ee472fa989$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$7f1a18ee472fa989$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $7f1a18ee472fa989$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $7f1a18ee472fa989$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $7f1a18ee472fa989$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $7f1a18ee472fa989$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $7f1a18ee472fa989$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $7f1a18ee472fa989$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $7f1a18ee472fa989$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $7f1a18ee472fa989$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $7f1a18ee472fa989$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $7f1a18ee472fa989$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $7f1a18ee472fa989$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $7f1a18ee472fa989$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($7f1a18ee472fa989$var$isRedirectResult(actionResult) || $7f1a18ee472fa989$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $7f1a18ee472fa989$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($7f1a18ee472fa989$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $7f1a18ee472fa989$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $7f1a18ee472fa989$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($7f1a18ee472fa989$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($7f1a18ee472fa989$var$isDeferredResult(actionResult)) throw $7f1a18ee472fa989$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $7f1a18ee472fa989$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $7f1a18ee472fa989$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $7f1a18ee472fa989$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $7f1a18ee472fa989$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $7f1a18ee472fa989$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $7f1a18ee472fa989$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $7f1a18ee472fa989$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $7f1a18ee472fa989$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $7f1a18ee472fa989$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $7f1a18ee472fa989$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $7f1a18ee472fa989$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $7f1a18ee472fa989$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $7f1a18ee472fa989$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $7f1a18ee472fa989$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $7f1a18ee472fa989$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $7f1a18ee472fa989$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($7f1a18ee472fa989$var$isDeferredResult(result)) result = await $7f1a18ee472fa989$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $7f1a18ee472fa989$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($7f1a18ee472fa989$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $7f1a18ee472fa989$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($7f1a18ee472fa989$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $7f1a18ee472fa989$export$3e9cee6b33872309(!$7f1a18ee472fa989$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $7f1a18ee472fa989$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $7f1a18ee472fa989$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $7f1a18ee472fa989$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $7f1a18ee472fa989$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($7f1a18ee472fa989$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $7f1a18ee472fa989$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $7f1a18ee472fa989$export$e19cd5f9376f8cee.Replace : $7f1a18ee472fa989$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $7f1a18ee472fa989$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($7f1a18ee472fa989$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $7f1a18ee472fa989$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $7f1a18ee472fa989$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $7f1a18ee472fa989$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $7f1a18ee472fa989$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $7f1a18ee472fa989$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($7f1a18ee472fa989$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $7f1a18ee472fa989$var$ResultType.redirect,
                response: $7f1a18ee472fa989$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $7f1a18ee472fa989$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $7f1a18ee472fa989$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $7f1a18ee472fa989$var$ResultType.error,
                    error: $7f1a18ee472fa989$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $7f1a18ee472fa989$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $7f1a18ee472fa989$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $7f1a18ee472fa989$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $7f1a18ee472fa989$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $7f1a18ee472fa989$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $7f1a18ee472fa989$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $7f1a18ee472fa989$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $7f1a18ee472fa989$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $7f1a18ee472fa989$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $7f1a18ee472fa989$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $7f1a18ee472fa989$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $7f1a18ee472fa989$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $7f1a18ee472fa989$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $7f1a18ee472fa989$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$7f1a18ee472fa989$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $7f1a18ee472fa989$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $7f1a18ee472fa989$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $7f1a18ee472fa989$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $7f1a18ee472fa989$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $7f1a18ee472fa989$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $7f1a18ee472fa989$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $7f1a18ee472fa989$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $7f1a18ee472fa989$export$4d0306f8f6a4585b = Symbol("deferred");
function $7f1a18ee472fa989$export$3336b097a6fbc59a(routes, opts) {
    $7f1a18ee472fa989$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $7f1a18ee472fa989$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $7f1a18ee472fa989$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $7f1a18ee472fa989$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $7f1a18ee472fa989$var$createLocation("", $7f1a18ee472fa989$export$fe53371bee54353d(url), null, "default");
        let matches = $7f1a18ee472fa989$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$7f1a18ee472fa989$var$isValidMethod(method) && method !== "HEAD") {
            let error = $7f1a18ee472fa989$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $7f1a18ee472fa989$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $7f1a18ee472fa989$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $7f1a18ee472fa989$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($7f1a18ee472fa989$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $7f1a18ee472fa989$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $7f1a18ee472fa989$var$createLocation("", $7f1a18ee472fa989$export$fe53371bee54353d(url), null, "default");
        let matches = $7f1a18ee472fa989$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$7f1a18ee472fa989$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $7f1a18ee472fa989$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $7f1a18ee472fa989$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $7f1a18ee472fa989$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $7f1a18ee472fa989$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $7f1a18ee472fa989$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($7f1a18ee472fa989$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$7f1a18ee472fa989$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $7f1a18ee472fa989$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($7f1a18ee472fa989$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $7f1a18ee472fa989$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $7f1a18ee472fa989$var$isResponse(result) ? result : $7f1a18ee472fa989$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($7f1a18ee472fa989$var$isDataStrategyResult(e) && $7f1a18ee472fa989$var$isResponse(e.result)) {
                if (e.type === $7f1a18ee472fa989$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($7f1a18ee472fa989$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $7f1a18ee472fa989$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $7f1a18ee472fa989$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $7f1a18ee472fa989$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($7f1a18ee472fa989$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($7f1a18ee472fa989$var$isDeferredResult(result)) {
            let error = $7f1a18ee472fa989$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $7f1a18ee472fa989$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($7f1a18ee472fa989$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($7f1a18ee472fa989$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $7f1a18ee472fa989$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $7f1a18ee472fa989$var$_extends({}, context, {
                statusCode: $7f1a18ee472fa989$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $7f1a18ee472fa989$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $7f1a18ee472fa989$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $7f1a18ee472fa989$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $7f1a18ee472fa989$var$isErrorResult(pendingActionResult[1]) ? $7f1a18ee472fa989$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $7f1a18ee472fa989$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $7f1a18ee472fa989$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $7f1a18ee472fa989$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $7f1a18ee472fa989$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $7f1a18ee472fa989$var$callDataStrategyImpl(dataStrategy || $7f1a18ee472fa989$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($7f1a18ee472fa989$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $7f1a18ee472fa989$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($7f1a18ee472fa989$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $7f1a18ee472fa989$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $7f1a18ee472fa989$export$fec11da027c70692(routes, context, error) {
    let newContext = $7f1a18ee472fa989$var$_extends({}, context, {
        statusCode: $7f1a18ee472fa989$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $7f1a18ee472fa989$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $7f1a18ee472fa989$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $7f1a18ee472fa989$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $7f1a18ee472fa989$export$cae722b0cc860f13(to ? to : ".", $7f1a18ee472fa989$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $7f1a18ee472fa989$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $7f1a18ee472fa989$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $7f1a18ee472fa989$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $7f1a18ee472fa989$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $7f1a18ee472fa989$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$7f1a18ee472fa989$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$7f1a18ee472fa989$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $7f1a18ee472fa989$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $7f1a18ee472fa989$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $7f1a18ee472fa989$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$7f1a18ee472fa989$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$7f1a18ee472fa989$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $7f1a18ee472fa989$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $7f1a18ee472fa989$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $7f1a18ee472fa989$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $7f1a18ee472fa989$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $7f1a18ee472fa989$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($7f1a18ee472fa989$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $7f1a18ee472fa989$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $7f1a18ee472fa989$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $7f1a18ee472fa989$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $7f1a18ee472fa989$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $7f1a18ee472fa989$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $7f1a18ee472fa989$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $7f1a18ee472fa989$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $7f1a18ee472fa989$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $7f1a18ee472fa989$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $7f1a18ee472fa989$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($7f1a18ee472fa989$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $7f1a18ee472fa989$var$shouldRevalidateLoader(match, $7f1a18ee472fa989$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $7f1a18ee472fa989$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $7f1a18ee472fa989$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $7f1a18ee472fa989$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $7f1a18ee472fa989$var$shouldRevalidateLoader(fetcherMatch, $7f1a18ee472fa989$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $7f1a18ee472fa989$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $7f1a18ee472fa989$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $7f1a18ee472fa989$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $7f1a18ee472fa989$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $7f1a18ee472fa989$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $7f1a18ee472fa989$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$7f1a18ee472fa989$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $7f1a18ee472fa989$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $7f1a18ee472fa989$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$7f1a18ee472fa989$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $7f1a18ee472fa989$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $7f1a18ee472fa989$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $7f1a18ee472fa989$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$7f1a18ee472fa989$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $7f1a18ee472fa989$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $7f1a18ee472fa989$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $7f1a18ee472fa989$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $7f1a18ee472fa989$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $7f1a18ee472fa989$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $7f1a18ee472fa989$var$ResultType.data,
                result: undefined
            });
        };
        return $7f1a18ee472fa989$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $7f1a18ee472fa989$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $7f1a18ee472fa989$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $7f1a18ee472fa989$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $7f1a18ee472fa989$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $7f1a18ee472fa989$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $7f1a18ee472fa989$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $7f1a18ee472fa989$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($7f1a18ee472fa989$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $7f1a18ee472fa989$var$ResultType.error,
                error: e
            };
        }
        if (type === $7f1a18ee472fa989$var$ResultType.error) return {
            type: $7f1a18ee472fa989$var$ResultType.error,
            error: new $7f1a18ee472fa989$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $7f1a18ee472fa989$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $7f1a18ee472fa989$var$ResultType.error) {
        if ($7f1a18ee472fa989$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $7f1a18ee472fa989$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $7f1a18ee472fa989$var$ResultType.error,
                error: new $7f1a18ee472fa989$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $7f1a18ee472fa989$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $7f1a18ee472fa989$var$ResultType.error,
            error: result,
            statusCode: $7f1a18ee472fa989$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($7f1a18ee472fa989$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $7f1a18ee472fa989$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($7f1a18ee472fa989$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $7f1a18ee472fa989$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $7f1a18ee472fa989$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $7f1a18ee472fa989$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $7f1a18ee472fa989$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$7f1a18ee472fa989$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $7f1a18ee472fa989$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $7f1a18ee472fa989$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($7f1a18ee472fa989$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $7f1a18ee472fa989$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $7f1a18ee472fa989$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($7f1a18ee472fa989$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $7f1a18ee472fa989$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $7f1a18ee472fa989$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $7f1a18ee472fa989$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $7f1a18ee472fa989$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $7f1a18ee472fa989$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $7f1a18ee472fa989$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $7f1a18ee472fa989$export$3e9cee6b33872309(!$7f1a18ee472fa989$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($7f1a18ee472fa989$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $7f1a18ee472fa989$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $7f1a18ee472fa989$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($7f1a18ee472fa989$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $7f1a18ee472fa989$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $7f1a18ee472fa989$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $7f1a18ee472fa989$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($7f1a18ee472fa989$var$isErrorResult(result)) {
            let boundaryMatch = $7f1a18ee472fa989$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $7f1a18ee472fa989$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($7f1a18ee472fa989$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $7f1a18ee472fa989$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($7f1a18ee472fa989$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $7f1a18ee472fa989$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $7f1a18ee472fa989$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $7f1a18ee472fa989$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $7f1a18ee472fa989$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $7f1a18ee472fa989$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $7f1a18ee472fa989$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $7f1a18ee472fa989$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $7f1a18ee472fa989$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $7f1a18ee472fa989$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $7f1a18ee472fa989$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $7f1a18ee472fa989$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($7f1a18ee472fa989$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $7f1a18ee472fa989$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $7f1a18ee472fa989$export$8ccf933b0513f8d0(path) : path;
    return $7f1a18ee472fa989$export$fe53371bee54353d($7f1a18ee472fa989$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $7f1a18ee472fa989$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $7f1a18ee472fa989$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $7f1a18ee472fa989$var$ResultType.data || result.type === $7f1a18ee472fa989$var$ResultType.error);
}
function $7f1a18ee472fa989$var$isRedirectDataStrategyResultResult(result) {
    return $7f1a18ee472fa989$var$isResponse(result.result) && $7f1a18ee472fa989$var$redirectStatusCodes.has(result.result.status);
}
function $7f1a18ee472fa989$var$isDeferredResult(result) {
    return result.type === $7f1a18ee472fa989$var$ResultType.deferred;
}
function $7f1a18ee472fa989$var$isErrorResult(result) {
    return result.type === $7f1a18ee472fa989$var$ResultType.error;
}
function $7f1a18ee472fa989$var$isRedirectResult(result) {
    return (result && result.type) === $7f1a18ee472fa989$var$ResultType.redirect;
}
function $7f1a18ee472fa989$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $7f1a18ee472fa989$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $7f1a18ee472fa989$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $7f1a18ee472fa989$var$isRedirectResponse(result) {
    if (!$7f1a18ee472fa989$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $7f1a18ee472fa989$var$isValidMethod(method) {
    return $7f1a18ee472fa989$var$validRequestMethods.has(method.toLowerCase());
}
function $7f1a18ee472fa989$var$isMutationMethod(method) {
    return $7f1a18ee472fa989$var$validMutationMethods.has(method.toLowerCase());
}
async function $7f1a18ee472fa989$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$7f1a18ee472fa989$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($7f1a18ee472fa989$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $7f1a18ee472fa989$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $7f1a18ee472fa989$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($7f1a18ee472fa989$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $7f1a18ee472fa989$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $7f1a18ee472fa989$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $7f1a18ee472fa989$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $7f1a18ee472fa989$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $7f1a18ee472fa989$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $7f1a18ee472fa989$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $7f1a18ee472fa989$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $7f1a18ee472fa989$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $7f1a18ee472fa989$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $7f1a18ee472fa989$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $7f1a18ee472fa989$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $7f1a18ee472fa989$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $7f1a18ee472fa989$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $7f1a18ee472fa989$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $7f1a18ee472fa989$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $7f1a18ee472fa989$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $7f1a18ee472fa989$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $7f1a18ee472fa989$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($7f1a18ee472fa989$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $7f1a18ee472fa989$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($7f1a18ee472fa989$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $7f1a18ee472fa989$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7RNO0 = parcelRequire("7RNO0");

function $0e3dfb59695be15b$var$_extends() {
    $0e3dfb59695be15b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0e3dfb59695be15b$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $0e3dfb59695be15b$export$3add0d5dce533e2e = /*#__PURE__*/ $7RNO0.createContext(null);
const $0e3dfb59695be15b$export$145dfa71566a64dc = /*#__PURE__*/ $7RNO0.createContext(null);
const $0e3dfb59695be15b$var$AwaitContext = /*#__PURE__*/ $7RNO0.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $0e3dfb59695be15b$export$26749e8557646306 = /*#__PURE__*/ $7RNO0.createContext(null);
const $0e3dfb59695be15b$export$c7914228fb69b0f5 = /*#__PURE__*/ $7RNO0.createContext(null);
const $0e3dfb59695be15b$export$9072aa6dd1f93057 = /*#__PURE__*/ $7RNO0.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $0e3dfb59695be15b$var$RouteErrorContext = /*#__PURE__*/ $7RNO0.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $0e3dfb59695be15b$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$0e3dfb59695be15b$export$9c954a9d03d32f4a() && (0, $7f1a18ee472fa989$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $7RNO0.useContext($0e3dfb59695be15b$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $0e3dfb59695be15b$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $7f1a18ee472fa989$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $0e3dfb59695be15b$export$9c954a9d03d32f4a() {
    return $7RNO0.useContext($0e3dfb59695be15b$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $0e3dfb59695be15b$export$45d76561a5302f2b() {
    !$0e3dfb59695be15b$export$9c954a9d03d32f4a() && (0, $7f1a18ee472fa989$export$3e9cee6b33872309)(false);
    return $7RNO0.useContext($0e3dfb59695be15b$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $0e3dfb59695be15b$export$1b3f31771c5d07c() {
    return $7RNO0.useContext($0e3dfb59695be15b$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $0e3dfb59695be15b$export$6c330e8992e8a295(pattern) {
    !$0e3dfb59695be15b$export$9c954a9d03d32f4a() && (0, $7f1a18ee472fa989$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $0e3dfb59695be15b$export$45d76561a5302f2b();
    return $7RNO0.useMemo(()=>(0, $7f1a18ee472fa989$export$81336c211d5ff295)(pattern, (0, $7f1a18ee472fa989$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $0e3dfb59695be15b$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $0e3dfb59695be15b$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $7RNO0.useContext($0e3dfb59695be15b$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $7RNO0.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $0e3dfb59695be15b$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $7RNO0.useContext($0e3dfb59695be15b$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $0e3dfb59695be15b$var$useNavigateStable() : $0e3dfb59695be15b$var$useNavigateUnstable();
}
function $0e3dfb59695be15b$var$useNavigateUnstable() {
    !$0e3dfb59695be15b$export$9c954a9d03d32f4a() && (0, $7f1a18ee472fa989$export$3e9cee6b33872309)(false);
    let dataRouterContext = $7RNO0.useContext($0e3dfb59695be15b$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $7RNO0.useContext($0e3dfb59695be15b$export$26749e8557646306);
    let { matches: matches } = $7RNO0.useContext($0e3dfb59695be15b$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $0e3dfb59695be15b$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $7f1a18ee472fa989$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $7RNO0.useRef(false);
    $0e3dfb59695be15b$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7RNO0.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $7f1a18ee472fa989$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $7f1a18ee472fa989$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $0e3dfb59695be15b$var$OutletContext = /*#__PURE__*/ $7RNO0.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $0e3dfb59695be15b$export$4138103a3ae699cc() {
    return $7RNO0.useContext($0e3dfb59695be15b$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $0e3dfb59695be15b$export$a3be3530d8e40d0b(context) {
    let outlet = $7RNO0.useContext($0e3dfb59695be15b$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $7RNO0.createElement($0e3dfb59695be15b$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $0e3dfb59695be15b$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $7RNO0.useContext($0e3dfb59695be15b$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $0e3dfb59695be15b$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $7RNO0.useContext($0e3dfb59695be15b$export$26749e8557646306);
    let { matches: matches } = $7RNO0.useContext($0e3dfb59695be15b$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $0e3dfb59695be15b$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $7f1a18ee472fa989$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $7RNO0.useMemo(()=>(0, $7f1a18ee472fa989$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $0e3dfb59695be15b$export$5d3fca4a98652595(routes, locationArg) {
    return $0e3dfb59695be15b$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $0e3dfb59695be15b$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$0e3dfb59695be15b$export$9c954a9d03d32f4a() && (0, $7f1a18ee472fa989$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $7RNO0.useContext($0e3dfb59695be15b$export$26749e8557646306);
    let { matches: parentMatches } = $7RNO0.useContext($0e3dfb59695be15b$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $0e3dfb59695be15b$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $7f1a18ee472fa989$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $7f1a18ee472fa989$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $7f1a18ee472fa989$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $0e3dfb59695be15b$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $7f1a18ee472fa989$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $7f1a18ee472fa989$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $7RNO0.createElement($0e3dfb59695be15b$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $0e3dfb59695be15b$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $7f1a18ee472fa989$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $0e3dfb59695be15b$var$DefaultErrorComponent() {
    let error = $0e3dfb59695be15b$export$ed527bf60f6e05f2();
    let message = (0, $7f1a18ee472fa989$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $7RNO0.createElement($7RNO0.Fragment, null, /*#__PURE__*/ $7RNO0.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $7RNO0.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $7RNO0.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $0e3dfb59695be15b$var$defaultErrorElement = /*#__PURE__*/ $7RNO0.createElement($0e3dfb59695be15b$var$DefaultErrorComponent, null);
class $0e3dfb59695be15b$var$RenderErrorBoundary extends $7RNO0.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $7RNO0.createElement($0e3dfb59695be15b$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $7RNO0.createElement($0e3dfb59695be15b$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $0e3dfb59695be15b$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $7RNO0.useContext($0e3dfb59695be15b$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $7RNO0.createElement($0e3dfb59695be15b$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $0e3dfb59695be15b$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $7f1a18ee472fa989$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $0e3dfb59695be15b$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $0e3dfb59695be15b$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $7RNO0.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $7RNO0.createElement($0e3dfb59695be15b$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $7RNO0.createElement($0e3dfb59695be15b$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $0e3dfb59695be15b$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($0e3dfb59695be15b$var$DataRouterHook || {});
var $0e3dfb59695be15b$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($0e3dfb59695be15b$var$DataRouterStateHook || {});
function $0e3dfb59695be15b$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $0e3dfb59695be15b$var$useDataRouterContext(hookName) {
    let ctx = $7RNO0.useContext($0e3dfb59695be15b$export$3add0d5dce533e2e);
    !ctx && (0, $7f1a18ee472fa989$export$3e9cee6b33872309)(false);
    return ctx;
}
function $0e3dfb59695be15b$var$useDataRouterState(hookName) {
    let state = $7RNO0.useContext($0e3dfb59695be15b$export$145dfa71566a64dc);
    !state && (0, $7f1a18ee472fa989$export$3e9cee6b33872309)(false);
    return state;
}
function $0e3dfb59695be15b$var$useRouteContext(hookName) {
    let route = $7RNO0.useContext($0e3dfb59695be15b$export$9072aa6dd1f93057);
    !route && (0, $7f1a18ee472fa989$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $0e3dfb59695be15b$var$useCurrentRouteId(hookName) {
    let route = $0e3dfb59695be15b$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $7f1a18ee472fa989$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $0e3dfb59695be15b$export$5fc8298006ad9e58() {
    return $0e3dfb59695be15b$var$useCurrentRouteId($0e3dfb59695be15b$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $0e3dfb59695be15b$export$d0fd4b7106de2769() {
    let state = $0e3dfb59695be15b$var$useDataRouterState($0e3dfb59695be15b$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $0e3dfb59695be15b$export$600dc272ed516c15() {
    let dataRouterContext = $0e3dfb59695be15b$var$useDataRouterContext($0e3dfb59695be15b$var$DataRouterHook.UseRevalidator);
    let state = $0e3dfb59695be15b$var$useDataRouterState($0e3dfb59695be15b$var$DataRouterStateHook.UseRevalidator);
    return $7RNO0.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $0e3dfb59695be15b$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $0e3dfb59695be15b$var$useDataRouterState($0e3dfb59695be15b$var$DataRouterStateHook.UseMatches);
    return $7RNO0.useMemo(()=>matches.map((m)=>(0, $7f1a18ee472fa989$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $0e3dfb59695be15b$export$1448a5050d252c4d() {
    let state = $0e3dfb59695be15b$var$useDataRouterState($0e3dfb59695be15b$var$DataRouterStateHook.UseLoaderData);
    let routeId = $0e3dfb59695be15b$var$useCurrentRouteId($0e3dfb59695be15b$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $0e3dfb59695be15b$export$fd5d37484eab868d(routeId) {
    let state = $0e3dfb59695be15b$var$useDataRouterState($0e3dfb59695be15b$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $0e3dfb59695be15b$export$fdc00f3f26066d5e() {
    let state = $0e3dfb59695be15b$var$useDataRouterState($0e3dfb59695be15b$var$DataRouterStateHook.UseActionData);
    let routeId = $0e3dfb59695be15b$var$useCurrentRouteId($0e3dfb59695be15b$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $0e3dfb59695be15b$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $7RNO0.useContext($0e3dfb59695be15b$var$RouteErrorContext);
    let state = $0e3dfb59695be15b$var$useDataRouterState($0e3dfb59695be15b$var$DataRouterStateHook.UseRouteError);
    let routeId = $0e3dfb59695be15b$var$useCurrentRouteId($0e3dfb59695be15b$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $0e3dfb59695be15b$export$78a72ddb39bdd145() {
    let value = $7RNO0.useContext($0e3dfb59695be15b$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $0e3dfb59695be15b$export$17f53340677d5831() {
    let value = $7RNO0.useContext($0e3dfb59695be15b$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $0e3dfb59695be15b$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $0e3dfb59695be15b$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $0e3dfb59695be15b$var$useDataRouterContext($0e3dfb59695be15b$var$DataRouterHook.UseBlocker);
    let state = $0e3dfb59695be15b$var$useDataRouterState($0e3dfb59695be15b$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $7RNO0.useState("");
    let blockerFunction = $7RNO0.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $0e3dfb59695be15b$var$_extends({}, currentLocation, {
                pathname: (0, $7f1a18ee472fa989$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $0e3dfb59695be15b$var$_extends({}, nextLocation, {
                pathname: (0, $7f1a18ee472fa989$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $7RNO0.useEffect(()=>{
        let key = String(++$0e3dfb59695be15b$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $7RNO0.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $7f1a18ee472fa989$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $0e3dfb59695be15b$var$useNavigateStable() {
    let { router: router } = $0e3dfb59695be15b$var$useDataRouterContext($0e3dfb59695be15b$var$DataRouterHook.UseNavigateStable);
    let id = $0e3dfb59695be15b$var$useCurrentRouteId($0e3dfb59695be15b$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $7RNO0.useRef(false);
    $0e3dfb59695be15b$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7RNO0.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $0e3dfb59695be15b$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $0e3dfb59695be15b$var$alreadyWarned$1 = {};
function $0e3dfb59695be15b$var$warningOnce(key, cond, message) {
    if (!cond && !$0e3dfb59695be15b$var$alreadyWarned$1[key]) $0e3dfb59695be15b$var$alreadyWarned$1[key] = true;
}
const $0e3dfb59695be15b$var$alreadyWarned = {};
function $0e3dfb59695be15b$var$warnOnce(key, message) {}
const $0e3dfb59695be15b$var$logDeprecation = (flag, msg, link)=>$0e3dfb59695be15b$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $0e3dfb59695be15b$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $0e3dfb59695be15b$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $0e3dfb59695be15b$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $0e3dfb59695be15b$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $0e3dfb59695be15b$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $0e3dfb59695be15b$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $0e3dfb59695be15b$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $0e3dfb59695be15b$var$START_TRANSITION = "startTransition";
const $0e3dfb59695be15b$var$startTransitionImpl = $7RNO0[$0e3dfb59695be15b$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $0e3dfb59695be15b$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $7RNO0.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7RNO0.useCallback((newState)=>{
        if (v7_startTransition && $0e3dfb59695be15b$var$startTransitionImpl) $0e3dfb59695be15b$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $7RNO0.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $7RNO0.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $7RNO0.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $7RNO0.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $7RNO0.useEffect(()=>$0e3dfb59695be15b$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $7RNO0.createElement($7RNO0.Fragment, null, /*#__PURE__*/ $7RNO0.createElement($0e3dfb59695be15b$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $7RNO0.createElement($0e3dfb59695be15b$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $7RNO0.createElement($0e3dfb59695be15b$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $7RNO0.createElement($0e3dfb59695be15b$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $0e3dfb59695be15b$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $0e3dfb59695be15b$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $0e3dfb59695be15b$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $7RNO0.useRef();
    if (historyRef.current == null) historyRef.current = (0, $7f1a18ee472fa989$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7RNO0.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7RNO0.useCallback((newState)=>{
        v7_startTransition && $0e3dfb59695be15b$var$startTransitionImpl ? $0e3dfb59695be15b$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7RNO0.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7RNO0.useEffect(()=>$0e3dfb59695be15b$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $7RNO0.createElement($0e3dfb59695be15b$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $0e3dfb59695be15b$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$0e3dfb59695be15b$export$9c954a9d03d32f4a() && (0, $7f1a18ee472fa989$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $7RNO0.useContext($0e3dfb59695be15b$export$26749e8557646306);
    let { matches: matches } = $7RNO0.useContext($0e3dfb59695be15b$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $0e3dfb59695be15b$export$45d76561a5302f2b();
    let navigate = $0e3dfb59695be15b$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $7f1a18ee472fa989$export$cae722b0cc860f13)(to, (0, $7f1a18ee472fa989$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $7RNO0.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $0e3dfb59695be15b$export$910ae8079b2c2852(props) {
    return $0e3dfb59695be15b$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $0e3dfb59695be15b$export$e7b0ac011bb776c6(_props) {
    (0, $7f1a18ee472fa989$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $0e3dfb59695be15b$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $7f1a18ee472fa989$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$0e3dfb59695be15b$export$9c954a9d03d32f4a() && (0, $7f1a18ee472fa989$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $7RNO0.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $0e3dfb59695be15b$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $7f1a18ee472fa989$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $7RNO0.useMemo(()=>{
        let trailingPathname = (0, $7f1a18ee472fa989$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $7RNO0.createElement($0e3dfb59695be15b$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $7RNO0.createElement($0e3dfb59695be15b$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $0e3dfb59695be15b$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $0e3dfb59695be15b$export$5d3fca4a98652595($0e3dfb59695be15b$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $0e3dfb59695be15b$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $7RNO0.createElement($0e3dfb59695be15b$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $7RNO0.createElement($0e3dfb59695be15b$var$ResolveAwait, null, children));
}
var $0e3dfb59695be15b$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($0e3dfb59695be15b$var$AwaitRenderStatus || {});
const $0e3dfb59695be15b$var$neverSettledPromise = new Promise(()=>{});
class $0e3dfb59695be15b$var$AwaitErrorBoundary extends $7RNO0.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $0e3dfb59695be15b$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $0e3dfb59695be15b$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $0e3dfb59695be15b$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $0e3dfb59695be15b$var$AwaitRenderStatus.error : "_data" in promise ? $0e3dfb59695be15b$var$AwaitRenderStatus.success : $0e3dfb59695be15b$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $0e3dfb59695be15b$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $0e3dfb59695be15b$var$AwaitRenderStatus.error && promise._error instanceof (0, $7f1a18ee472fa989$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $0e3dfb59695be15b$var$neverSettledPromise;
        if (status === $0e3dfb59695be15b$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $0e3dfb59695be15b$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $7RNO0.createElement($0e3dfb59695be15b$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $0e3dfb59695be15b$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $7RNO0.createElement($0e3dfb59695be15b$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $0e3dfb59695be15b$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $0e3dfb59695be15b$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $7RNO0.createElement($7RNO0.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $0e3dfb59695be15b$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $7RNO0.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $7RNO0.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $7RNO0.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $0e3dfb59695be15b$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $0e3dfb59695be15b$export$e7b0ac011bb776c6) && (0, $7f1a18ee472fa989$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $7f1a18ee472fa989$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $0e3dfb59695be15b$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $0e3dfb59695be15b$export$daf73786167a7f72(matches) {
    return $0e3dfb59695be15b$var$_renderMatches(matches);
}
function $0e3dfb59695be15b$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $7RNO0.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $7RNO0.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $7RNO0.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $0e3dfb59695be15b$export$f30f7e456d254e83(routes, opts) {
    return (0, $7f1a18ee472fa989$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0e3dfb59695be15b$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $7f1a18ee472fa989$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $0e3dfb59695be15b$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $0c7bbce72352c6a2$var$_extends() {
    $0c7bbce72352c6a2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0c7bbce72352c6a2$var$_extends.apply(this, arguments);
}
function $0c7bbce72352c6a2$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $0c7bbce72352c6a2$var$defaultMethod = "get";
const $0c7bbce72352c6a2$var$defaultEncType = "application/x-www-form-urlencoded";
function $0c7bbce72352c6a2$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $0c7bbce72352c6a2$var$isButtonElement(object) {
    return $0c7bbce72352c6a2$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $0c7bbce72352c6a2$var$isFormElement(object) {
    return $0c7bbce72352c6a2$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $0c7bbce72352c6a2$var$isInputElement(object) {
    return $0c7bbce72352c6a2$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $0c7bbce72352c6a2$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $0c7bbce72352c6a2$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$0c7bbce72352c6a2$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $0c7bbce72352c6a2$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $0c7bbce72352c6a2$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $0c7bbce72352c6a2$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $0c7bbce72352c6a2$var$_formDataSupportsSubmitter = null;
function $0c7bbce72352c6a2$var$isFormDataSubmitterSupported() {
    if ($0c7bbce72352c6a2$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $0c7bbce72352c6a2$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $0c7bbce72352c6a2$var$_formDataSupportsSubmitter = true;
    }
    return $0c7bbce72352c6a2$var$_formDataSupportsSubmitter;
}
const $0c7bbce72352c6a2$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $0c7bbce72352c6a2$var$getFormEncType(encType) {
    if (encType != null && !$0c7bbce72352c6a2$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $0c7bbce72352c6a2$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($0c7bbce72352c6a2$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $7f1a18ee472fa989$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $0c7bbce72352c6a2$var$defaultMethod;
        encType = $0c7bbce72352c6a2$var$getFormEncType(target.getAttribute("enctype")) || $0c7bbce72352c6a2$var$defaultEncType;
        formData = new FormData(target);
    } else if ($0c7bbce72352c6a2$var$isButtonElement(target) || $0c7bbce72352c6a2$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $7f1a18ee472fa989$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $0c7bbce72352c6a2$var$defaultMethod;
        encType = $0c7bbce72352c6a2$var$getFormEncType(target.getAttribute("formenctype")) || $0c7bbce72352c6a2$var$getFormEncType(form.getAttribute("enctype")) || $0c7bbce72352c6a2$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$0c7bbce72352c6a2$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($0c7bbce72352c6a2$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $0c7bbce72352c6a2$var$defaultMethod;
        action = null;
        encType = $0c7bbce72352c6a2$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $0c7bbce72352c6a2$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $0c7bbce72352c6a2$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $0c7bbce72352c6a2$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $0c7bbce72352c6a2$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $0c7bbce72352c6a2$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $0c7bbce72352c6a2$export$1f3f55432a00e06d(routes, opts) {
    return (0, $7f1a18ee472fa989$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0c7bbce72352c6a2$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $7f1a18ee472fa989$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $0c7bbce72352c6a2$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $0e3dfb59695be15b$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $0c7bbce72352c6a2$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $7f1a18ee472fa989$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0c7bbce72352c6a2$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $7f1a18ee472fa989$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $0c7bbce72352c6a2$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $0e3dfb59695be15b$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $0c7bbce72352c6a2$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $0c7bbce72352c6a2$var$_extends({}, state, {
        errors: $0c7bbce72352c6a2$var$deserializeErrors(state.errors)
    });
    return state;
}
function $0c7bbce72352c6a2$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $7f1a18ee472fa989$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $0c7bbce72352c6a2$export$7ad602f0e94e62d1 = /*#__PURE__*/ $7RNO0.createContext({
    isTransitioning: false
});
const $0c7bbce72352c6a2$export$148fd98d095596d4 = /*#__PURE__*/ $7RNO0.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $0c7bbce72352c6a2$var$START_TRANSITION = "startTransition";
const $0c7bbce72352c6a2$var$startTransitionImpl = $7RNO0[$0c7bbce72352c6a2$var$START_TRANSITION];
const $0c7bbce72352c6a2$var$FLUSH_SYNC = "flushSync";
const $0c7bbce72352c6a2$var$flushSyncImpl = $7WYFd[$0c7bbce72352c6a2$var$FLUSH_SYNC];
const $0c7bbce72352c6a2$var$USE_ID = "useId";
const $0c7bbce72352c6a2$var$useIdImpl = $7RNO0[$0c7bbce72352c6a2$var$USE_ID];
function $0c7bbce72352c6a2$var$startTransitionSafe(cb) {
    if ($0c7bbce72352c6a2$var$startTransitionImpl) $0c7bbce72352c6a2$var$startTransitionImpl(cb);
    else cb();
}
function $0c7bbce72352c6a2$var$flushSyncSafe(cb) {
    if ($0c7bbce72352c6a2$var$flushSyncImpl) $0c7bbce72352c6a2$var$flushSyncImpl(cb);
    else cb();
}
class $0c7bbce72352c6a2$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $0c7bbce72352c6a2$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $7RNO0.useState(router.state);
    let [pendingState, setPendingState] = $7RNO0.useState();
    let [vtContext, setVtContext] = $7RNO0.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $7RNO0.useState();
    let [transition, setTransition] = $7RNO0.useState();
    let [interruption, setInterruption] = $7RNO0.useState();
    let fetcherData = $7RNO0.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $7RNO0.useCallback((cb)=>{
        if (v7_startTransition) $0c7bbce72352c6a2$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $7RNO0.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $0c7bbce72352c6a2$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $0c7bbce72352c6a2$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $0c7bbce72352c6a2$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $0c7bbce72352c6a2$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $0c7bbce72352c6a2$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $7RNO0.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $7RNO0.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $0c7bbce72352c6a2$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $7RNO0.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $7RNO0.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $7RNO0.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $7RNO0.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $7RNO0.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $7RNO0.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $7RNO0.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $7RNO0.useEffect(()=>(0, $0e3dfb59695be15b$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $7RNO0.createElement($7RNO0.Fragment, null, /*#__PURE__*/ $7RNO0.createElement((0, $0e3dfb59695be15b$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $7RNO0.createElement((0, $0e3dfb59695be15b$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $7RNO0.createElement($0c7bbce72352c6a2$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $7RNO0.createElement($0c7bbce72352c6a2$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $7RNO0.createElement((0, $0e3dfb59695be15b$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $7RNO0.createElement($0c7bbce72352c6a2$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $0c7bbce72352c6a2$var$MemoizedDataRoutes = /*#__PURE__*/ $7RNO0.memo($0c7bbce72352c6a2$var$DataRoutes);
function $0c7bbce72352c6a2$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $0e3dfb59695be15b$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $0c7bbce72352c6a2$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $7RNO0.useRef();
    if (historyRef.current == null) historyRef.current = (0, $7f1a18ee472fa989$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7RNO0.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7RNO0.useCallback((newState)=>{
        v7_startTransition && $0c7bbce72352c6a2$var$startTransitionImpl ? $0c7bbce72352c6a2$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7RNO0.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7RNO0.useEffect(()=>(0, $0e3dfb59695be15b$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $7RNO0.createElement((0, $0e3dfb59695be15b$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $0c7bbce72352c6a2$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $7RNO0.useRef();
    if (historyRef.current == null) historyRef.current = (0, $7f1a18ee472fa989$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7RNO0.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7RNO0.useCallback((newState)=>{
        v7_startTransition && $0c7bbce72352c6a2$var$startTransitionImpl ? $0c7bbce72352c6a2$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7RNO0.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7RNO0.useEffect(()=>(0, $0e3dfb59695be15b$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $7RNO0.createElement((0, $0e3dfb59695be15b$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $0c7bbce72352c6a2$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $7RNO0.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7RNO0.useCallback((newState)=>{
        v7_startTransition && $0c7bbce72352c6a2$var$startTransitionImpl ? $0c7bbce72352c6a2$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7RNO0.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7RNO0.useEffect(()=>(0, $0e3dfb59695be15b$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $7RNO0.createElement((0, $0e3dfb59695be15b$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $0c7bbce72352c6a2$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $0c7bbce72352c6a2$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $0c7bbce72352c6a2$export$a6c7ac8248d6e38a = /*#__PURE__*/ $7RNO0.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $0c7bbce72352c6a2$var$_objectWithoutPropertiesLoose(_ref7, $0c7bbce72352c6a2$var$_excluded);
    let { basename: basename } = $7RNO0.useContext((0, $0e3dfb59695be15b$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $0c7bbce72352c6a2$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($0c7bbce72352c6a2$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $7f1a18ee472fa989$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $0e3dfb59695be15b$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $0c7bbce72352c6a2$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $7RNO0.createElement("a", $0c7bbce72352c6a2$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $0c7bbce72352c6a2$export$b0d92dbee9b5b60d = /*#__PURE__*/ $7RNO0.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $0c7bbce72352c6a2$var$_objectWithoutPropertiesLoose(_ref8, $0c7bbce72352c6a2$var$_excluded2);
    let path = (0, $0e3dfb59695be15b$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $0e3dfb59695be15b$export$45d76561a5302f2b)();
    let routerState = $7RNO0.useContext((0, $0e3dfb59695be15b$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $7RNO0.useContext((0, $0e3dfb59695be15b$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $0c7bbce72352c6a2$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $7f1a18ee472fa989$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $7RNO0.createElement($0c7bbce72352c6a2$export$a6c7ac8248d6e38a, $0c7bbce72352c6a2$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $0c7bbce72352c6a2$export$a7fed597f4b8afd8 = /*#__PURE__*/ $7RNO0.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $0c7bbce72352c6a2$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $0c7bbce72352c6a2$var$_objectWithoutPropertiesLoose(_ref9, $0c7bbce72352c6a2$var$_excluded3);
    let submit = $0c7bbce72352c6a2$export$47c85c6e3a081d3();
    let formAction = $0c7bbce72352c6a2$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $7RNO0.createElement("form", $0c7bbce72352c6a2$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $0c7bbce72352c6a2$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $0c7bbce72352c6a2$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $0c7bbce72352c6a2$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($0c7bbce72352c6a2$var$DataRouterHook || ($0c7bbce72352c6a2$var$DataRouterHook = {}));
var $0c7bbce72352c6a2$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($0c7bbce72352c6a2$var$DataRouterStateHook || ($0c7bbce72352c6a2$var$DataRouterStateHook = {}));
// Internal hooks
function $0c7bbce72352c6a2$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $0c7bbce72352c6a2$var$useDataRouterContext(hookName) {
    let ctx = $7RNO0.useContext((0, $0e3dfb59695be15b$export$3add0d5dce533e2e));
    !ctx && (0, $7f1a18ee472fa989$export$3e9cee6b33872309)(false);
    return ctx;
}
function $0c7bbce72352c6a2$var$useDataRouterState(hookName) {
    let state = $7RNO0.useContext((0, $0e3dfb59695be15b$export$145dfa71566a64dc));
    !state && (0, $7f1a18ee472fa989$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $0c7bbce72352c6a2$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $0e3dfb59695be15b$export$9770f232ac06a008)();
    let location = (0, $0e3dfb59695be15b$export$45d76561a5302f2b)();
    let path = (0, $0e3dfb59695be15b$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $7RNO0.useCallback((event)=>{
        if ($0c7bbce72352c6a2$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $7f1a18ee472fa989$export$fe53371bee54353d)(location) === (0, $7f1a18ee472fa989$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $0c7bbce72352c6a2$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $7RNO0.useRef($0c7bbce72352c6a2$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $7RNO0.useRef(false);
    let location = (0, $0e3dfb59695be15b$export$45d76561a5302f2b)();
    let searchParams = $7RNO0.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $0c7bbce72352c6a2$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $0e3dfb59695be15b$export$9770f232ac06a008)();
    let setSearchParams = $7RNO0.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $0c7bbce72352c6a2$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $0c7bbce72352c6a2$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $0c7bbce72352c6a2$var$fetcherId = 0;
let $0c7bbce72352c6a2$var$getUniqueFetcherId = ()=>"__" + String(++$0c7bbce72352c6a2$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $0c7bbce72352c6a2$export$47c85c6e3a081d3() {
    let { router: router } = $0c7bbce72352c6a2$var$useDataRouterContext($0c7bbce72352c6a2$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $7RNO0.useContext((0, $0e3dfb59695be15b$export$26749e8557646306));
    let currentRouteId = (0, $0e3dfb59695be15b$export$5fc8298006ad9e58)();
    return $7RNO0.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $0c7bbce72352c6a2$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $0c7bbce72352c6a2$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $0c7bbce72352c6a2$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $0c7bbce72352c6a2$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $7RNO0.useContext((0, $0e3dfb59695be15b$export$26749e8557646306));
    let routeContext = $7RNO0.useContext((0, $0e3dfb59695be15b$export$9072aa6dd1f93057));
    !routeContext && (0, $7f1a18ee472fa989$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $0c7bbce72352c6a2$var$_extends({}, (0, $0e3dfb59695be15b$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $0e3dfb59695be15b$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $7f1a18ee472fa989$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $7f1a18ee472fa989$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $0c7bbce72352c6a2$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $0c7bbce72352c6a2$var$useDataRouterContext($0c7bbce72352c6a2$var$DataRouterHook.UseFetcher);
    let state = $0c7bbce72352c6a2$var$useDataRouterState($0c7bbce72352c6a2$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $7RNO0.useContext($0c7bbce72352c6a2$export$148fd98d095596d4);
    let route = $7RNO0.useContext((0, $0e3dfb59695be15b$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $7f1a18ee472fa989$export$3e9cee6b33872309)(false);
    !route && (0, $7f1a18ee472fa989$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $7f1a18ee472fa989$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $0c7bbce72352c6a2$var$useIdImpl ? $0c7bbce72352c6a2$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $7RNO0.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($0c7bbce72352c6a2$var$getUniqueFetcherId());
    // Registration/cleanup
    $7RNO0.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $7RNO0.useCallback((href, opts)=>{
        !routeId && (0, $7f1a18ee472fa989$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $0c7bbce72352c6a2$export$47c85c6e3a081d3();
    let submit = $7RNO0.useCallback((target, opts)=>{
        submitImpl(target, $0c7bbce72352c6a2$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $7RNO0.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $7RNO0.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $7RNO0.createElement($0c7bbce72352c6a2$export$a7fed597f4b8afd8, $0c7bbce72352c6a2$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $7f1a18ee472fa989$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $7RNO0.useMemo(()=>$0c7bbce72352c6a2$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $0c7bbce72352c6a2$export$fa996778a3a31087() {
    let state = $0c7bbce72352c6a2$var$useDataRouterState($0c7bbce72352c6a2$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $0c7bbce72352c6a2$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $0c7bbce72352c6a2$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $0c7bbce72352c6a2$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $0c7bbce72352c6a2$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $0c7bbce72352c6a2$var$useDataRouterContext($0c7bbce72352c6a2$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $0c7bbce72352c6a2$var$useDataRouterState($0c7bbce72352c6a2$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $7RNO0.useContext((0, $0e3dfb59695be15b$export$26749e8557646306));
    let location = (0, $0e3dfb59695be15b$export$45d76561a5302f2b)();
    let matches = (0, $0e3dfb59695be15b$export$2378eb7f5ff86053)();
    let navigation = (0, $0e3dfb59695be15b$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $7RNO0.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $0c7bbce72352c6a2$var$usePageHide($7RNO0.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $0c7bbce72352c6a2$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $0c7bbce72352c6a2$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($0c7bbce72352c6a2$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7RNO0.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $0c7bbce72352c6a2$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $0c7bbce72352c6a2$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7RNO0.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($0c7bbce72352c6a2$var$_extends({}, location, {
                    pathname: (0, $7f1a18ee472fa989$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($0c7bbce72352c6a2$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7RNO0.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $0c7bbce72352c6a2$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $7RNO0.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $0c7bbce72352c6a2$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $7RNO0.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $0c7bbce72352c6a2$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $0e3dfb59695be15b$export$b273b3273281a049)(when);
    $7RNO0.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $7RNO0.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $0c7bbce72352c6a2$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $7RNO0.useContext($0c7bbce72352c6a2$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $7f1a18ee472fa989$export$3e9cee6b33872309)(false);
    let { basename: basename } = $0c7bbce72352c6a2$var$useDataRouterContext($0c7bbce72352c6a2$var$DataRouterHook.useViewTransitionState);
    let path = (0, $0e3dfb59695be15b$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $7f1a18ee472fa989$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $7f1a18ee472fa989$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $7f1a18ee472fa989$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $7f1a18ee472fa989$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $9h2J6 = parcelRequire("9h2J6");

var $6dpjF = parcelRequire("6dpjF");

var $7RNO0 = parcelRequire("7RNO0");


var $9K8Jg = parcelRequire("9K8Jg");

var $i2KZ1 = parcelRequire("i2KZ1");

var $6KpYp = parcelRequire("6KpYp");

var $6Jwum = parcelRequire("6Jwum");

var $7v5wN = parcelRequire("7v5wN");
var $f6defc7795a4c638$export$f36897288fd2d497 = /*#__PURE__*/ function(transitionStates) {
    transitionStates["preVisible"] = "page-transition-preVisible";
    transitionStates["visible"] = "page-transition-visible";
    transitionStates["postVisible"] = "page-transition-postVisible";
    return transitionStates;
}({});
const $f6defc7795a4c638$export$b88b8034d859c8af = 1000;



var $lmedS = parcelRequire("lmedS");

var $9h2J6 = parcelRequire("9h2J6");

var $6dpjF = parcelRequire("6dpjF");

var $c46bdc8649c04f65$export$353f5b6fc5456de1;
var $c46bdc8649c04f65$export$745c6f71a1e0e6f7;
$c46bdc8649c04f65$export$353f5b6fc5456de1 = `_1Yw81G_Button`;
$c46bdc8649c04f65$export$745c6f71a1e0e6f7 = `_1Yw81G_secondary`;


function $bc232447c96f1a4a$export$2e2bcd8739ae039({ children: children, onClick: onClick, style: style, className: className, isSecondary: isSecondary, ...props }) {
    return /*#__PURE__*/ (0, $9h2J6.jsx)("button", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))(className, $c46bdc8649c04f65$export$353f5b6fc5456de1, {
            [$c46bdc8649c04f65$export$745c6f71a1e0e6f7]: isSecondary
        }),
        style: style,
        onClick: onClick,
        ...props,
        children: children
    });
}
function $bc232447c96f1a4a$export$29d11c0fe2fc51d8({ children: children, style: style, className: className, href: href, isSecondary: isSecondary, ...props }) {
    return /*#__PURE__*/ (0, $9h2J6.jsx)((0, $0c7bbce72352c6a2$export$a6c7ac8248d6e38a), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))(className, $c46bdc8649c04f65$export$353f5b6fc5456de1, {
            [$c46bdc8649c04f65$export$745c6f71a1e0e6f7]: isSecondary
        }),
        style: style,
        to: href,
        ...props,
        children: children
    });
}



var $9h2J6 = parcelRequire("9h2J6");
var $769354fd3774d467$exports = {};

$parcel$export($769354fd3774d467$exports, "FactionPicker", function () { return $769354fd3774d467$export$a91b66465f43df99; }, function (v) { return $769354fd3774d467$export$a91b66465f43df99 = v; });
$parcel$export($769354fd3774d467$exports, "FactionPickerFaction", function () { return $769354fd3774d467$export$ac79a59df2833a40; }, function (v) { return $769354fd3774d467$export$ac79a59df2833a40 = v; });
$parcel$export($769354fd3774d467$exports, "FactionPickerFaction__BackgroundContainer", function () { return $769354fd3774d467$export$3cf33c27d73c3bbc; }, function (v) { return $769354fd3774d467$export$3cf33c27d73c3bbc = v; });
$parcel$export($769354fd3774d467$exports, "FactionPickerFaction__Border", function () { return $769354fd3774d467$export$da97f03000bb123f; }, function (v) { return $769354fd3774d467$export$da97f03000bb123f = v; });
$parcel$export($769354fd3774d467$exports, "FactionPickerFaction__Button", function () { return $769354fd3774d467$export$4f5a5b7dfbf8564d; }, function (v) { return $769354fd3774d467$export$4f5a5b7dfbf8564d = v; });
$parcel$export($769354fd3774d467$exports, "FactionPickerFaction__Button--selected", function () { return $769354fd3774d467$export$9f5564532def7cd4; }, function (v) { return $769354fd3774d467$export$9f5564532def7cd4 = v; });
$parcel$export($769354fd3774d467$exports, "FactionPickerFaction__HighlightImage", function () { return $769354fd3774d467$export$5b6e9e886522f398; }, function (v) { return $769354fd3774d467$export$5b6e9e886522f398 = v; });
$parcel$export($769354fd3774d467$exports, "FactionPickerFaction__Image", function () { return $769354fd3774d467$export$50cf43a25317801e; }, function (v) { return $769354fd3774d467$export$50cf43a25317801e = v; });
$parcel$export($769354fd3774d467$exports, "FactionPickerFaction__Subtitle", function () { return $769354fd3774d467$export$3a11177fc3010a17; }, function (v) { return $769354fd3774d467$export$3a11177fc3010a17 = v; });
$parcel$export($769354fd3774d467$exports, "FactionPickerFaction__Text", function () { return $769354fd3774d467$export$63ec812f7d2c0793; }, function (v) { return $769354fd3774d467$export$63ec812f7d2c0793 = v; });
$parcel$export($769354fd3774d467$exports, "FactionPickerFaction__Title", function () { return $769354fd3774d467$export$958b7e4b6a3d1c9; }, function (v) { return $769354fd3774d467$export$958b7e4b6a3d1c9 = v; });
$parcel$export($769354fd3774d467$exports, "fade-in", function () { return $769354fd3774d467$export$c95979b960f4acea; }, function (v) { return $769354fd3774d467$export$c95979b960f4acea = v; });
$parcel$export($769354fd3774d467$exports, "page-transition-postVisible", function () { return $769354fd3774d467$export$635eb3172be88cc1; }, function (v) { return $769354fd3774d467$export$635eb3172be88cc1 = v; });
$parcel$export($769354fd3774d467$exports, "page-transition-preVisible", function () { return $769354fd3774d467$export$d0da582c244d7927; }, function (v) { return $769354fd3774d467$export$d0da582c244d7927 = v; });
$parcel$export($769354fd3774d467$exports, "page-transition-visible", function () { return $769354fd3774d467$export$110dabf6daad8b9a; }, function (v) { return $769354fd3774d467$export$110dabf6daad8b9a = v; });
$parcel$export($769354fd3774d467$exports, "slide-in", function () { return $769354fd3774d467$export$1c220dee9e4dbe34; }, function (v) { return $769354fd3774d467$export$1c220dee9e4dbe34 = v; });
$parcel$export($769354fd3774d467$exports, "slide-out", function () { return $769354fd3774d467$export$ec7246eb5d3e2aa3; }, function (v) { return $769354fd3774d467$export$ec7246eb5d3e2aa3 = v; });
var $769354fd3774d467$export$a91b66465f43df99;
var $769354fd3774d467$export$ac79a59df2833a40;
var $769354fd3774d467$export$3cf33c27d73c3bbc;
var $769354fd3774d467$export$da97f03000bb123f;
var $769354fd3774d467$export$4f5a5b7dfbf8564d;
var $769354fd3774d467$export$9f5564532def7cd4;
var $769354fd3774d467$export$5b6e9e886522f398;
var $769354fd3774d467$export$50cf43a25317801e;
var $769354fd3774d467$export$3a11177fc3010a17;
var $769354fd3774d467$export$63ec812f7d2c0793;
var $769354fd3774d467$export$958b7e4b6a3d1c9;
var $769354fd3774d467$export$c95979b960f4acea;
var $769354fd3774d467$export$635eb3172be88cc1;
var $769354fd3774d467$export$d0da582c244d7927;
var $769354fd3774d467$export$110dabf6daad8b9a;
var $769354fd3774d467$export$1c220dee9e4dbe34;
var $769354fd3774d467$export$ec7246eb5d3e2aa3;
$769354fd3774d467$export$a91b66465f43df99 = `_2j5PMq_FactionPicker`;
$769354fd3774d467$export$ac79a59df2833a40 = `_2j5PMq_FactionPickerFaction`;
$769354fd3774d467$export$3cf33c27d73c3bbc = `_2j5PMq_FactionPickerFaction__BackgroundContainer`;
$769354fd3774d467$export$da97f03000bb123f = `_2j5PMq_FactionPickerFaction__Border`;
$769354fd3774d467$export$4f5a5b7dfbf8564d = `_2j5PMq_FactionPickerFaction__Button`;
$769354fd3774d467$export$9f5564532def7cd4 = `_2j5PMq_FactionPickerFaction__Button--selected`;
$769354fd3774d467$export$5b6e9e886522f398 = `_2j5PMq_FactionPickerFaction__HighlightImage`;
$769354fd3774d467$export$50cf43a25317801e = `_2j5PMq_FactionPickerFaction__Image`;
$769354fd3774d467$export$3a11177fc3010a17 = `_2j5PMq_FactionPickerFaction__Subtitle`;
$769354fd3774d467$export$63ec812f7d2c0793 = `_2j5PMq_FactionPickerFaction__Text`;
$769354fd3774d467$export$958b7e4b6a3d1c9 = `_2j5PMq_FactionPickerFaction__Title`;
$769354fd3774d467$export$c95979b960f4acea = `_2j5PMq_fade-in`;
$769354fd3774d467$export$c95979b960f4acea;
$769354fd3774d467$export$635eb3172be88cc1 = `_2j5PMq_page-transition-postVisible`;
$769354fd3774d467$export$d0da582c244d7927 = `_2j5PMq_page-transition-preVisible`;
$769354fd3774d467$export$110dabf6daad8b9a = `_2j5PMq_page-transition-visible`;
$769354fd3774d467$export$1c220dee9e4dbe34 = `_2j5PMq_slide-in`;
$769354fd3774d467$export$1c220dee9e4dbe34;
$769354fd3774d467$export$ec7246eb5d3e2aa3 = `_2j5PMq_slide-out`;
$769354fd3774d467$export$ec7246eb5d3e2aa3;



var $6dpjF = parcelRequire("6dpjF");

var $lmedS = parcelRequire("lmedS");

function $f13fae8264ef7698$export$2e2bcd8739ae039({ factions: factions, factionSubtitle: factionSubtitle, backgroundImagePath: backgroundImagePath, textBackgroundImagePath: textBackgroundImagePath, highlightImagePath: highlightImagePath, selectedFactionId: selectedFactionId, onFactionSelected: onFactionSelected, onFactionMouseEnter: onFactionMouseEnter, transitionState: transitionState = (0, $f6defc7795a4c638$export$f36897288fd2d497).visible }) {
    const renderFactions = ()=>{
        if (factions && factions.length) return factions.map((faction)=>/*#__PURE__*/ (0, $9h2J6.jsx)($f13fae8264ef7698$var$FactionPickerFaction, {
                imagePath: (0, $lmedS.pathToURL)(faction.imagePath),
                backgroundImagePath: backgroundImagePath,
                textBackgroundImagePath: textBackgroundImagePath,
                highlightImagePath: highlightImagePath,
                title: faction.name,
                subtitle: factionSubtitle,
                isSelected: faction.id === selectedFactionId,
                onSelected: ()=>onFactionSelected && onFactionSelected(faction.id),
                onMouseEnter: onFactionMouseEnter,
                transitionState: transitionState
            }, faction.id));
        else return 'No factions available';
    };
    return /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
        className: $769354fd3774d467$exports.FactionPicker,
        children: /*#__PURE__*/ (0, $9h2J6.jsx)("ul", {
            children: renderFactions()
        })
    });
}
function $f13fae8264ef7698$var$FactionPickerFaction({ imagePath: imagePath, backgroundImagePath: backgroundImagePath, textBackgroundImagePath: textBackgroundImagePath, highlightImagePath: highlightImagePath, title: title, subtitle: subtitle, isSelected: isSelected, onSelected: onSelected, onMouseEnter: onMouseEnter, transitionState: transitionState }) {
    const factionButtonClasses = (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))({
        [$769354fd3774d467$exports.FactionPickerFaction__Button]: true,
        [$769354fd3774d467$exports['FactionPickerFaction__Button--selected']]: isSelected
    });
    const titleFontSize = title.length < 12 ? '15px' : '10px'; // TODO - Update when font changes and also find a better method
    const highlightImageStyle = highlightImagePath ? {
        backgroundImage: `url(${highlightImagePath})`
    } : {};
    return /*#__PURE__*/ (0, $9h2J6.jsxs)("li", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($769354fd3774d467$exports.FactionPickerFaction, $769354fd3774d467$exports[transitionState]),
        onMouseEnter: onMouseEnter,
        children: [
            /*#__PURE__*/ (0, $9h2J6.jsxs)("button", {
                className: factionButtonClasses,
                onClick: ()=>onSelected && onSelected(),
                children: [
                    /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                        className: $769354fd3774d467$exports.FactionPickerFaction__BackgroundContainer,
                        style: {
                            backgroundImage: `url(${backgroundImagePath})`
                        }
                    }),
                    /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                        className: $769354fd3774d467$exports.FactionPickerFaction__Border
                    }),
                    /*#__PURE__*/ (0, $9h2J6.jsx)("img", {
                        src: imagePath,
                        className: $769354fd3774d467$exports.FactionPickerFaction__Image,
                        alt: "faction logo"
                    }),
                    /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                        className: $769354fd3774d467$exports.FactionPickerFaction__Text,
                        style: {
                            backgroundImage: `url(${textBackgroundImagePath})`
                        },
                        children: [
                            /*#__PURE__*/ (0, $9h2J6.jsx)("p", {
                                className: $769354fd3774d467$exports.FactionPickerFaction__Title,
                                style: {
                                    fontSize: titleFontSize
                                },
                                children: title
                            }),
                            /*#__PURE__*/ (0, $9h2J6.jsx)("p", {
                                className: $769354fd3774d467$exports.FactionPickerFaction__Subtitle,
                                children: subtitle
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                className: $769354fd3774d467$exports.FactionPickerFaction__HighlightImage,
                style: highlightImageStyle
            })
        ]
    });
}



var $9h2J6 = parcelRequire("9h2J6");
var $02215f3799ad9cda$export$ee388a16b6680f12;
var $02215f3799ad9cda$export$ab2a351788ae0f99;
var $02215f3799ad9cda$export$e7f5b41f28d56e7;
$02215f3799ad9cda$export$ee388a16b6680f12 = `PpN9jq_AuthInput`;
$02215f3799ad9cda$export$ab2a351788ae0f99 = `PpN9jq_AuthInput--invalid`;
$02215f3799ad9cda$export$e7f5b41f28d56e7 = `PpN9jq_invalid-input-shake`;
$02215f3799ad9cda$export$e7f5b41f28d56e7;



var $6dpjF = parcelRequire("6dpjF");

var $9h2J6 = parcelRequire("9h2J6");
var $97f52ebc4646933e$export$f5b8910cec6cf069;
$97f52ebc4646933e$export$f5b8910cec6cf069 = `MsuNTa_Input`;


function $97de157f1d7f5149$export$2e2bcd8739ae039({ value: value, onChange: onChange, placeholder: placeholder, style: style, onSubmit: onSubmit, className: className, type: type = 'text', tabIndex: tabIndex, passedRef: passedRef, autoComplete: autoComplete, id: id, ...props }) {
    function handleKeyDown(e) {
        if (!props.disabled) {
            if (e.key === 'Enter' && onSubmit) onSubmit(e);
        }
    }
    const classname = className ? $97f52ebc4646933e$export$f5b8910cec6cf069 + ' ' + className : $97f52ebc4646933e$export$f5b8910cec6cf069;
    return /*#__PURE__*/ (0, $9h2J6.jsx)("input", {
        type: type,
        value: value,
        onChange: onChange,
        placeholder: placeholder,
        className: classname,
        style: style,
        onKeyDown: handleKeyDown,
        tabIndex: tabIndex,
        ref: passedRef,
        autoComplete: autoComplete,
        id: id,
        ...props
    });
}


function $b7b30cc111a5a67e$export$2e2bcd8739ae039({ isInvalid: isInvalid, errorAnimationDurationMs: errorAnimationDurationMs = 500, style: style, ...props }) {
    const authInputClasses = (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))({
        [$02215f3799ad9cda$export$ee388a16b6680f12]: true,
        [$02215f3799ad9cda$export$ab2a351788ae0f99]: isInvalid,
        [props.className]: true
    });
    return /*#__PURE__*/ (0, $9h2J6.jsx)((0, $97de157f1d7f5149$export$2e2bcd8739ae039), {
        ...props,
        className: authInputClasses,
        style: {
            ...style,
            animationDuration: errorAnimationDurationMs + 'ms'
        }
    });
}



var $7RNO0 = parcelRequire("7RNO0");
var $a72b5ec3d712344d$export$c9d39ca3bcd93abb;
var $a72b5ec3d712344d$export$b791fe48eec8032a;
/*!
 *  howler.js v2.2.4
 *  howlerjs.com
 *
 *  (c) 2013-2020, James Simpson of GoldFire Studios
 *  goldfirestudios.com
 *
 *  MIT License
 */ (function() {
    'use strict';
    /** Global Methods **/ /***************************************************************************/ /**
   * Create the global controller. All contained methods and properties apply
   * to all sounds that are currently playing or will be in the future.
   */ var HowlerGlobal1 = function() {
        this.init();
    };
    HowlerGlobal1.prototype = {
        /**
     * Initialize the global Howler object.
     * @return {Howler}
     */ init: function() {
            var self = this || Howler1;
            // Create a global ID counter.
            self._counter = 1000;
            // Pool of unlocked HTML5 Audio objects.
            self._html5AudioPool = [];
            self.html5PoolSize = 10;
            // Internal properties.
            self._codecs = {};
            self._howls = [];
            self._muted = false;
            self._volume = 1;
            self._canPlayEvent = 'canplaythrough';
            self._navigator = typeof window !== 'undefined' && window.navigator ? window.navigator : null;
            // Public properties.
            self.masterGain = null;
            self.noAudio = false;
            self.usingWebAudio = true;
            self.autoSuspend = true;
            self.ctx = null;
            // Set to false to disable the auto audio unlocker.
            self.autoUnlock = true;
            // Setup the various state values for global tracking.
            self._setup();
            return self;
        },
        /**
     * Get/set the global volume for all sounds.
     * @param  {Float} vol Volume from 0.0 to 1.0.
     * @return {Howler/Float}     Returns self or current volume.
     */ volume: function(vol) {
            var self = this || Howler1;
            vol = parseFloat(vol);
            // If we don't have an AudioContext created yet, run the setup.
            if (!self.ctx) setupAudioContext();
            if (typeof vol !== 'undefined' && vol >= 0 && vol <= 1) {
                self._volume = vol;
                // Don't update any of the nodes if we are muted.
                if (self._muted) return self;
                // When using Web Audio, we just need to adjust the master gain.
                if (self.usingWebAudio) self.masterGain.gain.setValueAtTime(vol, Howler1.ctx.currentTime);
                // Loop through and change volume for all HTML5 audio nodes.
                for(var i = 0; i < self._howls.length; i++)if (!self._howls[i]._webAudio) {
                    // Get all of the sounds in this Howl group.
                    var ids = self._howls[i]._getSoundIds();
                    // Loop through all sounds and change the volumes.
                    for(var j = 0; j < ids.length; j++){
                        var sound = self._howls[i]._soundById(ids[j]);
                        if (sound && sound._node) sound._node.volume = sound._volume * vol;
                    }
                }
                return self;
            }
            return self._volume;
        },
        /**
     * Handle muting and unmuting globally.
     * @param  {Boolean} muted Is muted or not.
     */ mute: function(muted) {
            var self = this || Howler1;
            // If we don't have an AudioContext created yet, run the setup.
            if (!self.ctx) setupAudioContext();
            self._muted = muted;
            // With Web Audio, we just need to mute the master gain.
            if (self.usingWebAudio) self.masterGain.gain.setValueAtTime(muted ? 0 : self._volume, Howler1.ctx.currentTime);
            // Loop through and mute all HTML5 Audio nodes.
            for(var i = 0; i < self._howls.length; i++)if (!self._howls[i]._webAudio) {
                // Get all of the sounds in this Howl group.
                var ids = self._howls[i]._getSoundIds();
                // Loop through all sounds and mark the audio node as muted.
                for(var j = 0; j < ids.length; j++){
                    var sound = self._howls[i]._soundById(ids[j]);
                    if (sound && sound._node) sound._node.muted = muted ? true : sound._muted;
                }
            }
            return self;
        },
        /**
     * Handle stopping all sounds globally.
     */ stop: function() {
            var self = this || Howler1;
            // Loop through all Howls and stop them.
            for(var i = 0; i < self._howls.length; i++)self._howls[i].stop();
            return self;
        },
        /**
     * Unload and destroy all currently loaded Howl objects.
     * @return {Howler}
     */ unload: function() {
            var self = this || Howler1;
            for(var i = self._howls.length - 1; i >= 0; i--)self._howls[i].unload();
            // Create a new AudioContext to make sure it is fully reset.
            if (self.usingWebAudio && self.ctx && typeof self.ctx.close !== 'undefined') {
                self.ctx.close();
                self.ctx = null;
                setupAudioContext();
            }
            return self;
        },
        /**
     * Check for codec support of specific extension.
     * @param  {String} ext Audio file extention.
     * @return {Boolean}
     */ codecs: function(ext) {
            return (this || Howler1)._codecs[ext.replace(/^x-/, '')];
        },
        /**
     * Setup various state values for global tracking.
     * @return {Howler}
     */ _setup: function() {
            var self = this || Howler1;
            // Keeps track of the suspend/resume state of the AudioContext.
            self.state = self.ctx ? self.ctx.state || 'suspended' : 'suspended';
            // Automatically begin the 30-second suspend process
            self._autoSuspend();
            // Check if audio is available.
            if (!self.usingWebAudio) {
                // No audio is available on this system if noAudio is set to true.
                if (typeof Audio !== 'undefined') try {
                    var test = new Audio();
                    // Check if the canplaythrough event is available.
                    if (typeof test.oncanplaythrough === 'undefined') self._canPlayEvent = 'canplay';
                } catch (e) {
                    self.noAudio = true;
                }
                else self.noAudio = true;
            }
            // Test to make sure audio isn't disabled in Internet Explorer.
            try {
                var test = new Audio();
                if (test.muted) self.noAudio = true;
            } catch (e) {}
            // Check for supported codecs.
            if (!self.noAudio) self._setupCodecs();
            return self;
        },
        /**
     * Check for browser support for various codecs and cache the results.
     * @return {Howler}
     */ _setupCodecs: function() {
            var self = this || Howler1;
            var audioTest = null;
            // Must wrap in a try/catch because IE11 in server mode throws an error.
            try {
                audioTest = typeof Audio !== 'undefined' ? new Audio() : null;
            } catch (err) {
                return self;
            }
            if (!audioTest || typeof audioTest.canPlayType !== 'function') return self;
            var mpegTest = audioTest.canPlayType('audio/mpeg;').replace(/^no$/, '');
            // Opera version <33 has mixed MP3 support, so we need to check for and block it.
            var ua = self._navigator ? self._navigator.userAgent : '';
            var checkOpera = ua.match(/OPR\/(\d+)/g);
            var isOldOpera = checkOpera && parseInt(checkOpera[0].split('/')[1], 10) < 33;
            var checkSafari = ua.indexOf('Safari') !== -1 && ua.indexOf('Chrome') === -1;
            var safariVersion = ua.match(/Version\/(.*?) /);
            var isOldSafari = checkSafari && safariVersion && parseInt(safariVersion[1], 10) < 15;
            self._codecs = {
                mp3: !!(!isOldOpera && (mpegTest || audioTest.canPlayType('audio/mp3;').replace(/^no$/, ''))),
                mpeg: !!mpegTest,
                opus: !!audioTest.canPlayType('audio/ogg; codecs="opus"').replace(/^no$/, ''),
                ogg: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ''),
                oga: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ''),
                wav: !!(audioTest.canPlayType('audio/wav; codecs="1"') || audioTest.canPlayType('audio/wav')).replace(/^no$/, ''),
                aac: !!audioTest.canPlayType('audio/aac;').replace(/^no$/, ''),
                caf: !!audioTest.canPlayType('audio/x-caf;').replace(/^no$/, ''),
                m4a: !!(audioTest.canPlayType('audio/x-m4a;') || audioTest.canPlayType('audio/m4a;') || audioTest.canPlayType('audio/aac;')).replace(/^no$/, ''),
                m4b: !!(audioTest.canPlayType('audio/x-m4b;') || audioTest.canPlayType('audio/m4b;') || audioTest.canPlayType('audio/aac;')).replace(/^no$/, ''),
                mp4: !!(audioTest.canPlayType('audio/x-mp4;') || audioTest.canPlayType('audio/mp4;') || audioTest.canPlayType('audio/aac;')).replace(/^no$/, ''),
                weba: !!(!isOldSafari && audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, '')),
                webm: !!(!isOldSafari && audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, '')),
                dolby: !!audioTest.canPlayType('audio/mp4; codecs="ec-3"').replace(/^no$/, ''),
                flac: !!(audioTest.canPlayType('audio/x-flac;') || audioTest.canPlayType('audio/flac;')).replace(/^no$/, '')
            };
            return self;
        },
        /**
     * Some browsers/devices will only allow audio to be played after a user interaction.
     * Attempt to automatically unlock audio on the first user interaction.
     * Concept from: http://paulbakaus.com/tutorials/html5/web-audio-on-ios/
     * @return {Howler}
     */ _unlockAudio: function() {
            var self = this || Howler1;
            // Only run this if Web Audio is supported and it hasn't already been unlocked.
            if (self._audioUnlocked || !self.ctx) return;
            self._audioUnlocked = false;
            self.autoUnlock = false;
            // Some mobile devices/platforms have distortion issues when opening/closing tabs and/or web views.
            // Bugs in the browser (especially Mobile Safari) can cause the sampleRate to change from 44100 to 48000.
            // By calling Howler.unload(), we create a new AudioContext with the correct sampleRate.
            if (!self._mobileUnloaded && self.ctx.sampleRate !== 44100) {
                self._mobileUnloaded = true;
                self.unload();
            }
            // Scratch buffer for enabling iOS to dispose of web audio buffers correctly, as per:
            // http://stackoverflow.com/questions/24119684
            self._scratchBuffer = self.ctx.createBuffer(1, 1, 22050);
            // Call this method on touch start to create and play a buffer,
            // then check if the audio actually played to determine if
            // audio has now been unlocked on iOS, Android, etc.
            var unlock = function(e) {
                // Create a pool of unlocked HTML5 Audio objects that can
                // be used for playing sounds without user interaction. HTML5
                // Audio objects must be individually unlocked, as opposed
                // to the WebAudio API which only needs a single activation.
                // This must occur before WebAudio setup or the source.onended
                // event will not fire.
                while(self._html5AudioPool.length < self.html5PoolSize)try {
                    var audioNode = new Audio();
                    // Mark this Audio object as unlocked to ensure it can get returned
                    // to the unlocked pool when released.
                    audioNode._unlocked = true;
                    // Add the audio node to the pool.
                    self._releaseHtml5Audio(audioNode);
                } catch (e) {
                    self.noAudio = true;
                    break;
                }
                // Loop through any assigned audio nodes and unlock them.
                for(var i = 0; i < self._howls.length; i++)if (!self._howls[i]._webAudio) {
                    // Get all of the sounds in this Howl group.
                    var ids = self._howls[i]._getSoundIds();
                    // Loop through all sounds and unlock the audio nodes.
                    for(var j = 0; j < ids.length; j++){
                        var sound = self._howls[i]._soundById(ids[j]);
                        if (sound && sound._node && !sound._node._unlocked) {
                            sound._node._unlocked = true;
                            sound._node.load();
                        }
                    }
                }
                // Fix Android can not play in suspend state.
                self._autoResume();
                // Create an empty buffer.
                var source = self.ctx.createBufferSource();
                source.buffer = self._scratchBuffer;
                source.connect(self.ctx.destination);
                // Play the empty buffer.
                if (typeof source.start === 'undefined') source.noteOn(0);
                else source.start(0);
                // Calling resume() on a stack initiated by user gesture is what actually unlocks the audio on Android Chrome >= 55.
                if (typeof self.ctx.resume === 'function') self.ctx.resume();
                // Setup a timeout to check that we are unlocked on the next event loop.
                source.onended = function() {
                    source.disconnect(0);
                    // Update the unlocked state and prevent this check from happening again.
                    self._audioUnlocked = true;
                    // Remove the touch start listener.
                    document.removeEventListener('touchstart', unlock, true);
                    document.removeEventListener('touchend', unlock, true);
                    document.removeEventListener('click', unlock, true);
                    document.removeEventListener('keydown', unlock, true);
                    // Let all sounds know that audio has been unlocked.
                    for(var i = 0; i < self._howls.length; i++)self._howls[i]._emit('unlock');
                };
            };
            // Setup a touch start listener to attempt an unlock in.
            document.addEventListener('touchstart', unlock, true);
            document.addEventListener('touchend', unlock, true);
            document.addEventListener('click', unlock, true);
            document.addEventListener('keydown', unlock, true);
            return self;
        },
        /**
     * Get an unlocked HTML5 Audio object from the pool. If none are left,
     * return a new Audio object and throw a warning.
     * @return {Audio} HTML5 Audio object.
     */ _obtainHtml5Audio: function() {
            var self = this || Howler1;
            // Return the next object from the pool if one exists.
            if (self._html5AudioPool.length) return self._html5AudioPool.pop();
            //.Check if the audio is locked and throw a warning.
            var testPlay = new Audio().play();
            if (testPlay && typeof Promise !== 'undefined' && (testPlay instanceof Promise || typeof testPlay.then === 'function')) testPlay.catch(function() {
                console.warn('HTML5 Audio pool exhausted, returning potentially locked audio object.');
            });
            return new Audio();
        },
        /**
     * Return an activated HTML5 Audio object to the pool.
     * @return {Howler}
     */ _releaseHtml5Audio: function(audio) {
            var self = this || Howler1;
            // Don't add audio to the pool if we don't know if it has been unlocked.
            if (audio._unlocked) self._html5AudioPool.push(audio);
            return self;
        },
        /**
     * Automatically suspend the Web Audio AudioContext after no sound has played for 30 seconds.
     * This saves processing/energy and fixes various browser-specific bugs with audio getting stuck.
     * @return {Howler}
     */ _autoSuspend: function() {
            var self = this;
            if (!self.autoSuspend || !self.ctx || typeof self.ctx.suspend === 'undefined' || !Howler1.usingWebAudio) return;
            // Check if any sounds are playing.
            for(var i = 0; i < self._howls.length; i++){
                if (self._howls[i]._webAudio) for(var j = 0; j < self._howls[i]._sounds.length; j++){
                    if (!self._howls[i]._sounds[j]._paused) return self;
                }
            }
            if (self._suspendTimer) clearTimeout(self._suspendTimer);
            // If no sound has played after 30 seconds, suspend the context.
            self._suspendTimer = setTimeout(function() {
                if (!self.autoSuspend) return;
                self._suspendTimer = null;
                self.state = 'suspending';
                // Handle updating the state of the audio context after suspending.
                var handleSuspension = function() {
                    self.state = 'suspended';
                    if (self._resumeAfterSuspend) {
                        delete self._resumeAfterSuspend;
                        self._autoResume();
                    }
                };
                // Either the state gets suspended or it is interrupted.
                // Either way, we need to update the state to suspended.
                self.ctx.suspend().then(handleSuspension, handleSuspension);
            }, 30000);
            return self;
        },
        /**
     * Automatically resume the Web Audio AudioContext when a new sound is played.
     * @return {Howler}
     */ _autoResume: function() {
            var self = this;
            if (!self.ctx || typeof self.ctx.resume === 'undefined' || !Howler1.usingWebAudio) return;
            if (self.state === 'running' && self.ctx.state !== 'interrupted' && self._suspendTimer) {
                clearTimeout(self._suspendTimer);
                self._suspendTimer = null;
            } else if (self.state === 'suspended' || self.state === 'running' && self.ctx.state === 'interrupted') {
                self.ctx.resume().then(function() {
                    self.state = 'running';
                    // Emit to all Howls that the audio has resumed.
                    for(var i = 0; i < self._howls.length; i++)self._howls[i]._emit('resume');
                });
                if (self._suspendTimer) {
                    clearTimeout(self._suspendTimer);
                    self._suspendTimer = null;
                }
            } else if (self.state === 'suspending') self._resumeAfterSuspend = true;
            return self;
        }
    };
    // Setup the global audio controller.
    var Howler1 = new HowlerGlobal1();
    /** Group Methods **/ /***************************************************************************/ /**
   * Create an audio group controller.
   * @param {Object} o Passed in properties for this group.
   */ var Howl1 = function(o) {
        var self = this;
        // Throw an error if no source is provided.
        if (!o.src || o.src.length === 0) {
            console.error('An array of source files must be passed with any new Howl.');
            return;
        }
        self.init(o);
    };
    Howl1.prototype = {
        /**
     * Initialize a new Howl group object.
     * @param  {Object} o Passed in properties for this group.
     * @return {Howl}
     */ init: function(o) {
            var self = this;
            // If we don't have an AudioContext created yet, run the setup.
            if (!Howler1.ctx) setupAudioContext();
            // Setup user-defined default properties.
            self._autoplay = o.autoplay || false;
            self._format = typeof o.format !== 'string' ? o.format : [
                o.format
            ];
            self._html5 = o.html5 || false;
            self._muted = o.mute || false;
            self._loop = o.loop || false;
            self._pool = o.pool || 5;
            self._preload = typeof o.preload === 'boolean' || o.preload === 'metadata' ? o.preload : true;
            self._rate = o.rate || 1;
            self._sprite = o.sprite || {};
            self._src = typeof o.src !== 'string' ? o.src : [
                o.src
            ];
            self._volume = o.volume !== undefined ? o.volume : 1;
            self._xhr = {
                method: o.xhr && o.xhr.method ? o.xhr.method : 'GET',
                headers: o.xhr && o.xhr.headers ? o.xhr.headers : null,
                withCredentials: o.xhr && o.xhr.withCredentials ? o.xhr.withCredentials : false
            };
            // Setup all other default properties.
            self._duration = 0;
            self._state = 'unloaded';
            self._sounds = [];
            self._endTimers = {};
            self._queue = [];
            self._playLock = false;
            // Setup event listeners.
            self._onend = o.onend ? [
                {
                    fn: o.onend
                }
            ] : [];
            self._onfade = o.onfade ? [
                {
                    fn: o.onfade
                }
            ] : [];
            self._onload = o.onload ? [
                {
                    fn: o.onload
                }
            ] : [];
            self._onloaderror = o.onloaderror ? [
                {
                    fn: o.onloaderror
                }
            ] : [];
            self._onplayerror = o.onplayerror ? [
                {
                    fn: o.onplayerror
                }
            ] : [];
            self._onpause = o.onpause ? [
                {
                    fn: o.onpause
                }
            ] : [];
            self._onplay = o.onplay ? [
                {
                    fn: o.onplay
                }
            ] : [];
            self._onstop = o.onstop ? [
                {
                    fn: o.onstop
                }
            ] : [];
            self._onmute = o.onmute ? [
                {
                    fn: o.onmute
                }
            ] : [];
            self._onvolume = o.onvolume ? [
                {
                    fn: o.onvolume
                }
            ] : [];
            self._onrate = o.onrate ? [
                {
                    fn: o.onrate
                }
            ] : [];
            self._onseek = o.onseek ? [
                {
                    fn: o.onseek
                }
            ] : [];
            self._onunlock = o.onunlock ? [
                {
                    fn: o.onunlock
                }
            ] : [];
            self._onresume = [];
            // Web Audio or HTML5 Audio?
            self._webAudio = Howler1.usingWebAudio && !self._html5;
            // Automatically try to enable audio.
            if (typeof Howler1.ctx !== 'undefined' && Howler1.ctx && Howler1.autoUnlock) Howler1._unlockAudio();
            // Keep track of this Howl group in the global controller.
            Howler1._howls.push(self);
            // If they selected autoplay, add a play event to the load queue.
            if (self._autoplay) self._queue.push({
                event: 'play',
                action: function() {
                    self.play();
                }
            });
            // Load the source file unless otherwise specified.
            if (self._preload && self._preload !== 'none') self.load();
            return self;
        },
        /**
     * Load the audio file.
     * @return {Howler}
     */ load: function() {
            var self = this;
            var url = null;
            // If no audio is available, quit immediately.
            if (Howler1.noAudio) {
                self._emit('loaderror', null, 'No audio support.');
                return;
            }
            // Make sure our source is in an array.
            if (typeof self._src === 'string') self._src = [
                self._src
            ];
            // Loop through the sources and pick the first one that is compatible.
            for(var i = 0; i < self._src.length; i++){
                var ext, str;
                if (self._format && self._format[i]) // If an extension was specified, use that instead.
                ext = self._format[i];
                else {
                    // Make sure the source is a string.
                    str = self._src[i];
                    if (typeof str !== 'string') {
                        self._emit('loaderror', null, 'Non-string found in selected audio sources - ignoring.');
                        continue;
                    }
                    // Extract the file extension from the URL or base64 data URI.
                    ext = /^data:audio\/([^;,]+);/i.exec(str);
                    if (!ext) ext = /\.([^.]+)$/.exec(str.split('?', 1)[0]);
                    if (ext) ext = ext[1].toLowerCase();
                }
                // Log a warning if no extension was found.
                if (!ext) console.warn('No file extension was found. Consider using the "format" property or specify an extension.');
                // Check if this extension is available.
                if (ext && Howler1.codecs(ext)) {
                    url = self._src[i];
                    break;
                }
            }
            if (!url) {
                self._emit('loaderror', null, 'No codec support for selected audio sources.');
                return;
            }
            self._src = url;
            self._state = 'loading';
            // If the hosting page is HTTPS and the source isn't,
            // drop down to HTML5 Audio to avoid Mixed Content errors.
            if (window.location.protocol === 'https:' && url.slice(0, 5) === 'http:') {
                self._html5 = true;
                self._webAudio = false;
            }
            // Create a new sound object and add it to the pool.
            new Sound1(self);
            // Load and decode the audio data for playback.
            if (self._webAudio) loadBuffer(self);
            return self;
        },
        /**
     * Play a sound or resume previous playback.
     * @param  {String/Number} sprite   Sprite name for sprite playback or sound id to continue previous.
     * @param  {Boolean} internal Internal Use: true prevents event firing.
     * @return {Number}          Sound ID.
     */ play: function(sprite, internal) {
            var self = this;
            var id = null;
            // Determine if a sprite, sound id or nothing was passed
            if (typeof sprite === 'number') {
                id = sprite;
                sprite = null;
            } else if (typeof sprite === 'string' && self._state === 'loaded' && !self._sprite[sprite]) // If the passed sprite doesn't exist, do nothing.
            return null;
            else if (typeof sprite === 'undefined') {
                // Use the default sound sprite (plays the full audio length).
                sprite = '__default';
                // Check if there is a single paused sound that isn't ended.
                // If there is, play that sound. If not, continue as usual.
                if (!self._playLock) {
                    var num = 0;
                    for(var i = 0; i < self._sounds.length; i++)if (self._sounds[i]._paused && !self._sounds[i]._ended) {
                        num++;
                        id = self._sounds[i]._id;
                    }
                    if (num === 1) sprite = null;
                    else id = null;
                }
            }
            // Get the selected node, or get one from the pool.
            var sound = id ? self._soundById(id) : self._inactiveSound();
            // If the sound doesn't exist, do nothing.
            if (!sound) return null;
            // Select the sprite definition.
            if (id && !sprite) sprite = sound._sprite || '__default';
            // If the sound hasn't loaded, we must wait to get the audio's duration.
            // We also need to wait to make sure we don't run into race conditions with
            // the order of function calls.
            if (self._state !== 'loaded') {
                // Set the sprite value on this sound.
                sound._sprite = sprite;
                // Mark this sound as not ended in case another sound is played before this one loads.
                sound._ended = false;
                // Add the sound to the queue to be played on load.
                var soundId = sound._id;
                self._queue.push({
                    event: 'play',
                    action: function() {
                        self.play(soundId);
                    }
                });
                return soundId;
            }
            // Don't play the sound if an id was passed and it is already playing.
            if (id && !sound._paused) {
                // Trigger the play event, in order to keep iterating through queue.
                if (!internal) self._loadQueue('play');
                return sound._id;
            }
            // Make sure the AudioContext isn't suspended, and resume it if it is.
            if (self._webAudio) Howler1._autoResume();
            // Determine how long to play for and where to start playing.
            var seek = Math.max(0, sound._seek > 0 ? sound._seek : self._sprite[sprite][0] / 1000);
            var duration = Math.max(0, (self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000 - seek);
            var timeout = duration * 1000 / Math.abs(sound._rate);
            var start = self._sprite[sprite][0] / 1000;
            var stop = (self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000;
            sound._sprite = sprite;
            // Mark the sound as ended instantly so that this async playback
            // doesn't get grabbed by another call to play while this one waits to start.
            sound._ended = false;
            // Update the parameters of the sound.
            var setParams = function() {
                sound._paused = false;
                sound._seek = seek;
                sound._start = start;
                sound._stop = stop;
                sound._loop = !!(sound._loop || self._sprite[sprite][2]);
            };
            // End the sound instantly if seek is at the end.
            if (seek >= stop) {
                self._ended(sound);
                return;
            }
            // Begin the actual playback.
            var node = sound._node;
            if (self._webAudio) {
                // Fire this when the sound is ready to play to begin Web Audio playback.
                var playWebAudio = function() {
                    self._playLock = false;
                    setParams();
                    self._refreshBuffer(sound);
                    // Setup the playback params.
                    var vol = sound._muted || self._muted ? 0 : sound._volume;
                    node.gain.setValueAtTime(vol, Howler1.ctx.currentTime);
                    sound._playStart = Howler1.ctx.currentTime;
                    // Play the sound using the supported method.
                    if (typeof node.bufferSource.start === 'undefined') sound._loop ? node.bufferSource.noteGrainOn(0, seek, 86400) : node.bufferSource.noteGrainOn(0, seek, duration);
                    else sound._loop ? node.bufferSource.start(0, seek, 86400) : node.bufferSource.start(0, seek, duration);
                    // Start a new timer if none is present.
                    if (timeout !== Infinity) self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
                    if (!internal) setTimeout(function() {
                        self._emit('play', sound._id);
                        self._loadQueue();
                    }, 0);
                };
                if (Howler1.state === 'running' && Howler1.ctx.state !== 'interrupted') playWebAudio();
                else {
                    self._playLock = true;
                    // Wait for the audio context to resume before playing.
                    self.once('resume', playWebAudio);
                    // Cancel the end timer.
                    self._clearTimer(sound._id);
                }
            } else {
                // Fire this when the sound is ready to play to begin HTML5 Audio playback.
                var playHtml5 = function() {
                    node.currentTime = seek;
                    node.muted = sound._muted || self._muted || Howler1._muted || node.muted;
                    node.volume = sound._volume * Howler1.volume();
                    node.playbackRate = sound._rate;
                    // Some browsers will throw an error if this is called without user interaction.
                    try {
                        var play = node.play();
                        // Support older browsers that don't support promises, and thus don't have this issue.
                        if (play && typeof Promise !== 'undefined' && (play instanceof Promise || typeof play.then === 'function')) {
                            // Implements a lock to prevent DOMException: The play() request was interrupted by a call to pause().
                            self._playLock = true;
                            // Set param values immediately.
                            setParams();
                            // Releases the lock and executes queued actions.
                            play.then(function() {
                                self._playLock = false;
                                node._unlocked = true;
                                if (!internal) self._emit('play', sound._id);
                                else self._loadQueue();
                            }).catch(function() {
                                self._playLock = false;
                                self._emit('playerror', sound._id, "Playback was unable to start. This is most commonly an issue on mobile devices and Chrome where playback was not within a user interaction.");
                                // Reset the ended and paused values.
                                sound._ended = true;
                                sound._paused = true;
                            });
                        } else if (!internal) {
                            self._playLock = false;
                            setParams();
                            self._emit('play', sound._id);
                        }
                        // Setting rate before playing won't work in IE, so we set it again here.
                        node.playbackRate = sound._rate;
                        // If the node is still paused, then we can assume there was a playback issue.
                        if (node.paused) {
                            self._emit('playerror', sound._id, "Playback was unable to start. This is most commonly an issue on mobile devices and Chrome where playback was not within a user interaction.");
                            return;
                        }
                        // Setup the end timer on sprites or listen for the ended event.
                        if (sprite !== '__default' || sound._loop) self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
                        else {
                            self._endTimers[sound._id] = function() {
                                // Fire ended on this audio node.
                                self._ended(sound);
                                // Clear this listener.
                                node.removeEventListener('ended', self._endTimers[sound._id], false);
                            };
                            node.addEventListener('ended', self._endTimers[sound._id], false);
                        }
                    } catch (err) {
                        self._emit('playerror', sound._id, err);
                    }
                };
                // If this is streaming audio, make sure the src is set and load again.
                if (node.src === 'data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA') {
                    node.src = self._src;
                    node.load();
                }
                // Play immediately if ready, or wait for the 'canplaythrough'e vent.
                var loadedNoReadyState = window && window.ejecta || !node.readyState && Howler1._navigator.isCocoonJS;
                if (node.readyState >= 3 || loadedNoReadyState) playHtml5();
                else {
                    self._playLock = true;
                    self._state = 'loading';
                    var listener = function() {
                        self._state = 'loaded';
                        // Begin playback.
                        playHtml5();
                        // Clear this listener.
                        node.removeEventListener(Howler1._canPlayEvent, listener, false);
                    };
                    node.addEventListener(Howler1._canPlayEvent, listener, false);
                    // Cancel the end timer.
                    self._clearTimer(sound._id);
                }
            }
            return sound._id;
        },
        /**
     * Pause playback and save current position.
     * @param  {Number} id The sound ID (empty to pause all in group).
     * @return {Howl}
     */ pause: function(id) {
            var self = this;
            // If the sound hasn't loaded or a play() promise is pending, add it to the load queue to pause when capable.
            if (self._state !== 'loaded' || self._playLock) {
                self._queue.push({
                    event: 'pause',
                    action: function() {
                        self.pause(id);
                    }
                });
                return self;
            }
            // If no id is passed, get all ID's to be paused.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Clear the end timer.
                self._clearTimer(ids[i]);
                // Get the sound.
                var sound = self._soundById(ids[i]);
                if (sound && !sound._paused) {
                    // Reset the seek position.
                    sound._seek = self.seek(ids[i]);
                    sound._rateSeek = 0;
                    sound._paused = true;
                    // Stop currently running fades.
                    self._stopFade(ids[i]);
                    if (sound._node) {
                        if (self._webAudio) {
                            // Make sure the sound has been created.
                            if (!sound._node.bufferSource) continue;
                            if (typeof sound._node.bufferSource.stop === 'undefined') sound._node.bufferSource.noteOff(0);
                            else sound._node.bufferSource.stop(0);
                            // Clean up the buffer source.
                            self._cleanBuffer(sound._node);
                        } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) sound._node.pause();
                    }
                }
                // Fire the pause event, unless `true` is passed as the 2nd argument.
                if (!arguments[1]) self._emit('pause', sound ? sound._id : null);
            }
            return self;
        },
        /**
     * Stop playback and reset to start.
     * @param  {Number} id The sound ID (empty to stop all in group).
     * @param  {Boolean} internal Internal Use: true prevents event firing.
     * @return {Howl}
     */ stop: function(id, internal) {
            var self = this;
            // If the sound hasn't loaded, add it to the load queue to stop when capable.
            if (self._state !== 'loaded' || self._playLock) {
                self._queue.push({
                    event: 'stop',
                    action: function() {
                        self.stop(id);
                    }
                });
                return self;
            }
            // If no id is passed, get all ID's to be stopped.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Clear the end timer.
                self._clearTimer(ids[i]);
                // Get the sound.
                var sound = self._soundById(ids[i]);
                if (sound) {
                    // Reset the seek position.
                    sound._seek = sound._start || 0;
                    sound._rateSeek = 0;
                    sound._paused = true;
                    sound._ended = true;
                    // Stop currently running fades.
                    self._stopFade(ids[i]);
                    if (sound._node) {
                        if (self._webAudio) // Make sure the sound's AudioBufferSourceNode has been created.
                        {
                            if (sound._node.bufferSource) {
                                if (typeof sound._node.bufferSource.stop === 'undefined') sound._node.bufferSource.noteOff(0);
                                else sound._node.bufferSource.stop(0);
                                // Clean up the buffer source.
                                self._cleanBuffer(sound._node);
                            }
                        } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) {
                            sound._node.currentTime = sound._start || 0;
                            sound._node.pause();
                            // If this is a live stream, stop download once the audio is stopped.
                            if (sound._node.duration === Infinity) self._clearSound(sound._node);
                        }
                    }
                    if (!internal) self._emit('stop', sound._id);
                }
            }
            return self;
        },
        /**
     * Mute/unmute a single sound or all sounds in this Howl group.
     * @param  {Boolean} muted Set to true to mute and false to unmute.
     * @param  {Number} id    The sound ID to update (omit to mute/unmute all).
     * @return {Howl}
     */ mute: function(muted, id) {
            var self = this;
            // If the sound hasn't loaded, add it to the load queue to mute when capable.
            if (self._state !== 'loaded' || self._playLock) {
                self._queue.push({
                    event: 'mute',
                    action: function() {
                        self.mute(muted, id);
                    }
                });
                return self;
            }
            // If applying mute/unmute to all sounds, update the group's value.
            if (typeof id === 'undefined') {
                if (typeof muted === 'boolean') self._muted = muted;
                else return self._muted;
            }
            // If no id is passed, get all ID's to be muted.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Get the sound.
                var sound = self._soundById(ids[i]);
                if (sound) {
                    sound._muted = muted;
                    // Cancel active fade and set the volume to the end value.
                    if (sound._interval) self._stopFade(sound._id);
                    if (self._webAudio && sound._node) sound._node.gain.setValueAtTime(muted ? 0 : sound._volume, Howler1.ctx.currentTime);
                    else if (sound._node) sound._node.muted = Howler1._muted ? true : muted;
                    self._emit('mute', sound._id);
                }
            }
            return self;
        },
        /**
     * Get/set the volume of this sound or of the Howl group. This method can optionally take 0, 1 or 2 arguments.
     *   volume() -> Returns the group's volume value.
     *   volume(id) -> Returns the sound id's current volume.
     *   volume(vol) -> Sets the volume of all sounds in this Howl group.
     *   volume(vol, id) -> Sets the volume of passed sound id.
     * @return {Howl/Number} Returns self or current volume.
     */ volume: function() {
            var self = this;
            var args = arguments;
            var vol, id;
            // Determine the values based on arguments.
            if (args.length === 0) // Return the value of the groups' volume.
            return self._volume;
            else if (args.length === 1 || args.length === 2 && typeof args[1] === 'undefined') {
                // First check if this is an ID, and if not, assume it is a new volume.
                var ids = self._getSoundIds();
                var index = ids.indexOf(args[0]);
                if (index >= 0) id = parseInt(args[0], 10);
                else vol = parseFloat(args[0]);
            } else if (args.length >= 2) {
                vol = parseFloat(args[0]);
                id = parseInt(args[1], 10);
            }
            // Update the volume or return the current volume.
            var sound;
            if (typeof vol !== 'undefined' && vol >= 0 && vol <= 1) {
                // If the sound hasn't loaded, add it to the load queue to change volume when capable.
                if (self._state !== 'loaded' || self._playLock) {
                    self._queue.push({
                        event: 'volume',
                        action: function() {
                            self.volume.apply(self, args);
                        }
                    });
                    return self;
                }
                // Set the group volume.
                if (typeof id === 'undefined') self._volume = vol;
                // Update one or all volumes.
                id = self._getSoundIds(id);
                for(var i = 0; i < id.length; i++){
                    // Get the sound.
                    sound = self._soundById(id[i]);
                    if (sound) {
                        sound._volume = vol;
                        // Stop currently running fades.
                        if (!args[2]) self._stopFade(id[i]);
                        if (self._webAudio && sound._node && !sound._muted) sound._node.gain.setValueAtTime(vol, Howler1.ctx.currentTime);
                        else if (sound._node && !sound._muted) sound._node.volume = vol * Howler1.volume();
                        self._emit('volume', sound._id);
                    }
                }
            } else {
                sound = id ? self._soundById(id) : self._sounds[0];
                return sound ? sound._volume : 0;
            }
            return self;
        },
        /**
     * Fade a currently playing sound between two volumes (if no id is passed, all sounds will fade).
     * @param  {Number} from The value to fade from (0.0 to 1.0).
     * @param  {Number} to   The volume to fade to (0.0 to 1.0).
     * @param  {Number} len  Time in milliseconds to fade.
     * @param  {Number} id   The sound id (omit to fade all sounds).
     * @return {Howl}
     */ fade: function(from, to, len, id) {
            var self = this;
            // If the sound hasn't loaded, add it to the load queue to fade when capable.
            if (self._state !== 'loaded' || self._playLock) {
                self._queue.push({
                    event: 'fade',
                    action: function() {
                        self.fade(from, to, len, id);
                    }
                });
                return self;
            }
            // Make sure the to/from/len values are numbers.
            from = Math.min(Math.max(0, parseFloat(from)), 1);
            to = Math.min(Math.max(0, parseFloat(to)), 1);
            len = parseFloat(len);
            // Set the volume to the start position.
            self.volume(from, id);
            // Fade the volume of one or all sounds.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Get the sound.
                var sound = self._soundById(ids[i]);
                // Create a linear fade or fall back to timeouts with HTML5 Audio.
                if (sound) {
                    // Stop the previous fade if no sprite is being used (otherwise, volume handles this).
                    if (!id) self._stopFade(ids[i]);
                    // If we are using Web Audio, let the native methods do the actual fade.
                    if (self._webAudio && !sound._muted) {
                        var currentTime = Howler1.ctx.currentTime;
                        var end = currentTime + len / 1000;
                        sound._volume = from;
                        sound._node.gain.setValueAtTime(from, currentTime);
                        sound._node.gain.linearRampToValueAtTime(to, end);
                    }
                    self._startFadeInterval(sound, from, to, len, ids[i], typeof id === 'undefined');
                }
            }
            return self;
        },
        /**
     * Starts the internal interval to fade a sound.
     * @param  {Object} sound Reference to sound to fade.
     * @param  {Number} from The value to fade from (0.0 to 1.0).
     * @param  {Number} to   The volume to fade to (0.0 to 1.0).
     * @param  {Number} len  Time in milliseconds to fade.
     * @param  {Number} id   The sound id to fade.
     * @param  {Boolean} isGroup   If true, set the volume on the group.
     */ _startFadeInterval: function(sound, from, to, len, id, isGroup) {
            var self = this;
            var vol = from;
            var diff = to - from;
            var steps = Math.abs(diff / 0.01);
            var stepLen = Math.max(4, steps > 0 ? len / steps : len);
            var lastTick = Date.now();
            // Store the value being faded to.
            sound._fadeTo = to;
            // Update the volume value on each interval tick.
            sound._interval = setInterval(function() {
                // Update the volume based on the time since the last tick.
                var tick = (Date.now() - lastTick) / len;
                lastTick = Date.now();
                vol += diff * tick;
                // Round to within 2 decimal points.
                vol = Math.round(vol * 100) / 100;
                // Make sure the volume is in the right bounds.
                if (diff < 0) vol = Math.max(to, vol);
                else vol = Math.min(to, vol);
                // Change the volume.
                if (self._webAudio) sound._volume = vol;
                else self.volume(vol, sound._id, true);
                // Set the group's volume.
                if (isGroup) self._volume = vol;
                // When the fade is complete, stop it and fire event.
                if (to < from && vol <= to || to > from && vol >= to) {
                    clearInterval(sound._interval);
                    sound._interval = null;
                    sound._fadeTo = null;
                    self.volume(to, sound._id);
                    self._emit('fade', sound._id);
                }
            }, stepLen);
        },
        /**
     * Internal method that stops the currently playing fade when
     * a new fade starts, volume is changed or the sound is stopped.
     * @param  {Number} id The sound id.
     * @return {Howl}
     */ _stopFade: function(id) {
            var self = this;
            var sound = self._soundById(id);
            if (sound && sound._interval) {
                if (self._webAudio) sound._node.gain.cancelScheduledValues(Howler1.ctx.currentTime);
                clearInterval(sound._interval);
                sound._interval = null;
                self.volume(sound._fadeTo, id);
                sound._fadeTo = null;
                self._emit('fade', id);
            }
            return self;
        },
        /**
     * Get/set the loop parameter on a sound. This method can optionally take 0, 1 or 2 arguments.
     *   loop() -> Returns the group's loop value.
     *   loop(id) -> Returns the sound id's loop value.
     *   loop(loop) -> Sets the loop value for all sounds in this Howl group.
     *   loop(loop, id) -> Sets the loop value of passed sound id.
     * @return {Howl/Boolean} Returns self or current loop value.
     */ loop: function() {
            var self = this;
            var args = arguments;
            var loop, id, sound;
            // Determine the values for loop and id.
            if (args.length === 0) // Return the grou's loop value.
            return self._loop;
            else if (args.length === 1) {
                if (typeof args[0] === 'boolean') {
                    loop = args[0];
                    self._loop = loop;
                } else {
                    // Return this sound's loop value.
                    sound = self._soundById(parseInt(args[0], 10));
                    return sound ? sound._loop : false;
                }
            } else if (args.length === 2) {
                loop = args[0];
                id = parseInt(args[1], 10);
            }
            // If no id is passed, get all ID's to be looped.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                sound = self._soundById(ids[i]);
                if (sound) {
                    sound._loop = loop;
                    if (self._webAudio && sound._node && sound._node.bufferSource) {
                        sound._node.bufferSource.loop = loop;
                        if (loop) {
                            sound._node.bufferSource.loopStart = sound._start || 0;
                            sound._node.bufferSource.loopEnd = sound._stop;
                            // If playing, restart playback to ensure looping updates.
                            if (self.playing(ids[i])) {
                                self.pause(ids[i], true);
                                self.play(ids[i], true);
                            }
                        }
                    }
                }
            }
            return self;
        },
        /**
     * Get/set the playback rate of a sound. This method can optionally take 0, 1 or 2 arguments.
     *   rate() -> Returns the first sound node's current playback rate.
     *   rate(id) -> Returns the sound id's current playback rate.
     *   rate(rate) -> Sets the playback rate of all sounds in this Howl group.
     *   rate(rate, id) -> Sets the playback rate of passed sound id.
     * @return {Howl/Number} Returns self or the current playback rate.
     */ rate: function() {
            var self = this;
            var args = arguments;
            var rate, id;
            // Determine the values based on arguments.
            if (args.length === 0) // We will simply return the current rate of the first node.
            id = self._sounds[0]._id;
            else if (args.length === 1) {
                // First check if this is an ID, and if not, assume it is a new rate value.
                var ids = self._getSoundIds();
                var index = ids.indexOf(args[0]);
                if (index >= 0) id = parseInt(args[0], 10);
                else rate = parseFloat(args[0]);
            } else if (args.length === 2) {
                rate = parseFloat(args[0]);
                id = parseInt(args[1], 10);
            }
            // Update the playback rate or return the current value.
            var sound;
            if (typeof rate === 'number') {
                // If the sound hasn't loaded, add it to the load queue to change playback rate when capable.
                if (self._state !== 'loaded' || self._playLock) {
                    self._queue.push({
                        event: 'rate',
                        action: function() {
                            self.rate.apply(self, args);
                        }
                    });
                    return self;
                }
                // Set the group rate.
                if (typeof id === 'undefined') self._rate = rate;
                // Update one or all volumes.
                id = self._getSoundIds(id);
                for(var i = 0; i < id.length; i++){
                    // Get the sound.
                    sound = self._soundById(id[i]);
                    if (sound) {
                        // Keep track of our position when the rate changed and update the playback
                        // start position so we can properly adjust the seek position for time elapsed.
                        if (self.playing(id[i])) {
                            sound._rateSeek = self.seek(id[i]);
                            sound._playStart = self._webAudio ? Howler1.ctx.currentTime : sound._playStart;
                        }
                        sound._rate = rate;
                        // Change the playback rate.
                        if (self._webAudio && sound._node && sound._node.bufferSource) sound._node.bufferSource.playbackRate.setValueAtTime(rate, Howler1.ctx.currentTime);
                        else if (sound._node) sound._node.playbackRate = rate;
                        // Reset the timers.
                        var seek = self.seek(id[i]);
                        var duration = (self._sprite[sound._sprite][0] + self._sprite[sound._sprite][1]) / 1000 - seek;
                        var timeout = duration * 1000 / Math.abs(sound._rate);
                        // Start a new end timer if sound is already playing.
                        if (self._endTimers[id[i]] || !sound._paused) {
                            self._clearTimer(id[i]);
                            self._endTimers[id[i]] = setTimeout(self._ended.bind(self, sound), timeout);
                        }
                        self._emit('rate', sound._id);
                    }
                }
            } else {
                sound = self._soundById(id);
                return sound ? sound._rate : self._rate;
            }
            return self;
        },
        /**
     * Get/set the seek position of a sound. This method can optionally take 0, 1 or 2 arguments.
     *   seek() -> Returns the first sound node's current seek position.
     *   seek(id) -> Returns the sound id's current seek position.
     *   seek(seek) -> Sets the seek position of the first sound node.
     *   seek(seek, id) -> Sets the seek position of passed sound id.
     * @return {Howl/Number} Returns self or the current seek position.
     */ seek: function() {
            var self = this;
            var args = arguments;
            var seek, id;
            // Determine the values based on arguments.
            if (args.length === 0) // We will simply return the current position of the first node.
            {
                if (self._sounds.length) id = self._sounds[0]._id;
            } else if (args.length === 1) {
                // First check if this is an ID, and if not, assume it is a new seek position.
                var ids = self._getSoundIds();
                var index = ids.indexOf(args[0]);
                if (index >= 0) id = parseInt(args[0], 10);
                else if (self._sounds.length) {
                    id = self._sounds[0]._id;
                    seek = parseFloat(args[0]);
                }
            } else if (args.length === 2) {
                seek = parseFloat(args[0]);
                id = parseInt(args[1], 10);
            }
            // If there is no ID, bail out.
            if (typeof id === 'undefined') return 0;
            // If the sound hasn't loaded, add it to the load queue to seek when capable.
            if (typeof seek === 'number' && (self._state !== 'loaded' || self._playLock)) {
                self._queue.push({
                    event: 'seek',
                    action: function() {
                        self.seek.apply(self, args);
                    }
                });
                return self;
            }
            // Get the sound.
            var sound = self._soundById(id);
            if (sound) {
                if (typeof seek === 'number' && seek >= 0) {
                    // Pause the sound and update position for restarting playback.
                    var playing = self.playing(id);
                    if (playing) self.pause(id, true);
                    // Move the position of the track and cancel timer.
                    sound._seek = seek;
                    sound._ended = false;
                    self._clearTimer(id);
                    // Update the seek position for HTML5 Audio.
                    if (!self._webAudio && sound._node && !isNaN(sound._node.duration)) sound._node.currentTime = seek;
                    // Seek and emit when ready.
                    var seekAndEmit = function() {
                        // Restart the playback if the sound was playing.
                        if (playing) self.play(id, true);
                        self._emit('seek', id);
                    };
                    // Wait for the play lock to be unset before emitting (HTML5 Audio).
                    if (playing && !self._webAudio) {
                        var emitSeek = function() {
                            if (!self._playLock) seekAndEmit();
                            else setTimeout(emitSeek, 0);
                        };
                        setTimeout(emitSeek, 0);
                    } else seekAndEmit();
                } else {
                    if (self._webAudio) {
                        var realTime = self.playing(id) ? Howler1.ctx.currentTime - sound._playStart : 0;
                        var rateSeek = sound._rateSeek ? sound._rateSeek - sound._seek : 0;
                        return sound._seek + (rateSeek + realTime * Math.abs(sound._rate));
                    } else return sound._node.currentTime;
                }
            }
            return self;
        },
        /**
     * Check if a specific sound is currently playing or not (if id is provided), or check if at least one of the sounds in the group is playing or not.
     * @param  {Number}  id The sound id to check. If none is passed, the whole sound group is checked.
     * @return {Boolean} True if playing and false if not.
     */ playing: function(id) {
            var self = this;
            // Check the passed sound ID (if any).
            if (typeof id === 'number') {
                var sound = self._soundById(id);
                return sound ? !sound._paused : false;
            }
            // Otherwise, loop through all sounds and check if any are playing.
            for(var i = 0; i < self._sounds.length; i++){
                if (!self._sounds[i]._paused) return true;
            }
            return false;
        },
        /**
     * Get the duration of this sound. Passing a sound id will return the sprite duration.
     * @param  {Number} id The sound id to check. If none is passed, return full source duration.
     * @return {Number} Audio duration in seconds.
     */ duration: function(id) {
            var self = this;
            var duration = self._duration;
            // If we pass an ID, get the sound and return the sprite length.
            var sound = self._soundById(id);
            if (sound) duration = self._sprite[sound._sprite][1] / 1000;
            return duration;
        },
        /**
     * Returns the current loaded state of this Howl.
     * @return {String} 'unloaded', 'loading', 'loaded'
     */ state: function() {
            return this._state;
        },
        /**
     * Unload and destroy the current Howl object.
     * This will immediately stop all sound instances attached to this group.
     */ unload: function() {
            var self = this;
            // Stop playing any active sounds.
            var sounds = self._sounds;
            for(var i = 0; i < sounds.length; i++){
                // Stop the sound if it is currently playing.
                if (!sounds[i]._paused) self.stop(sounds[i]._id);
                // Remove the source or disconnect.
                if (!self._webAudio) {
                    // Set the source to 0-second silence to stop any downloading (except in IE).
                    self._clearSound(sounds[i]._node);
                    // Remove any event listeners.
                    sounds[i]._node.removeEventListener('error', sounds[i]._errorFn, false);
                    sounds[i]._node.removeEventListener(Howler1._canPlayEvent, sounds[i]._loadFn, false);
                    sounds[i]._node.removeEventListener('ended', sounds[i]._endFn, false);
                    // Release the Audio object back to the pool.
                    Howler1._releaseHtml5Audio(sounds[i]._node);
                }
                // Empty out all of the nodes.
                delete sounds[i]._node;
                // Make sure all timers are cleared out.
                self._clearTimer(sounds[i]._id);
            }
            // Remove the references in the global Howler object.
            var index = Howler1._howls.indexOf(self);
            if (index >= 0) Howler1._howls.splice(index, 1);
            // Delete this sound from the cache (if no other Howl is using it).
            var remCache = true;
            for(i = 0; i < Howler1._howls.length; i++)if (Howler1._howls[i]._src === self._src || self._src.indexOf(Howler1._howls[i]._src) >= 0) {
                remCache = false;
                break;
            }
            if (cache && remCache) delete cache[self._src];
            // Clear global errors.
            Howler1.noAudio = false;
            // Clear out `self`.
            self._state = 'unloaded';
            self._sounds = [];
            self = null;
            return null;
        },
        /**
     * Listen to a custom event.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to call.
     * @param  {Number}   id    (optional) Only listen to events for this sound.
     * @param  {Number}   once  (INTERNAL) Marks event to fire only once.
     * @return {Howl}
     */ on: function(event, fn, id, once) {
            var self = this;
            var events = self['_on' + event];
            if (typeof fn === 'function') events.push(once ? {
                id: id,
                fn: fn,
                once: once
            } : {
                id: id,
                fn: fn
            });
            return self;
        },
        /**
     * Remove a custom event. Call without parameters to remove all events.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to remove. Leave empty to remove all.
     * @param  {Number}   id    (optional) Only remove events for this sound.
     * @return {Howl}
     */ off: function(event, fn, id) {
            var self = this;
            var events = self['_on' + event];
            var i = 0;
            // Allow passing just an event and ID.
            if (typeof fn === 'number') {
                id = fn;
                fn = null;
            }
            if (fn || id) // Loop through event store and remove the passed function.
            for(i = 0; i < events.length; i++){
                var isId = id === events[i].id;
                if (fn === events[i].fn && isId || !fn && isId) {
                    events.splice(i, 1);
                    break;
                }
            }
            else if (event) // Clear out all events of this type.
            self['_on' + event] = [];
            else {
                // Clear out all events of every type.
                var keys = Object.keys(self);
                for(i = 0; i < keys.length; i++)if (keys[i].indexOf('_on') === 0 && Array.isArray(self[keys[i]])) self[keys[i]] = [];
            }
            return self;
        },
        /**
     * Listen to a custom event and remove it once fired.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to call.
     * @param  {Number}   id    (optional) Only listen to events for this sound.
     * @return {Howl}
     */ once: function(event, fn, id) {
            var self = this;
            // Setup the event listener.
            self.on(event, fn, id, 1);
            return self;
        },
        /**
     * Emit all events of a specific type and pass the sound id.
     * @param  {String} event Event name.
     * @param  {Number} id    Sound ID.
     * @param  {Number} msg   Message to go with event.
     * @return {Howl}
     */ _emit: function(event, id, msg) {
            var self = this;
            var events = self['_on' + event];
            // Loop through event store and fire all functions.
            for(var i = events.length - 1; i >= 0; i--)// Only fire the listener if the correct ID is used.
            if (!events[i].id || events[i].id === id || event === 'load') {
                setTimeout((function(fn) {
                    fn.call(this, id, msg);
                }).bind(self, events[i].fn), 0);
                // If this event was setup with `once`, remove it.
                if (events[i].once) self.off(event, events[i].fn, events[i].id);
            }
            // Pass the event type into load queue so that it can continue stepping.
            self._loadQueue(event);
            return self;
        },
        /**
     * Queue of actions initiated before the sound has loaded.
     * These will be called in sequence, with the next only firing
     * after the previous has finished executing (even if async like play).
     * @return {Howl}
     */ _loadQueue: function(event) {
            var self = this;
            if (self._queue.length > 0) {
                var task = self._queue[0];
                // Remove this task if a matching event was passed.
                if (task.event === event) {
                    self._queue.shift();
                    self._loadQueue();
                }
                // Run the task if no event type is passed.
                if (!event) task.action();
            }
            return self;
        },
        /**
     * Fired when playback ends at the end of the duration.
     * @param  {Sound} sound The sound object to work with.
     * @return {Howl}
     */ _ended: function(sound) {
            var self = this;
            var sprite = sound._sprite;
            // If we are using IE and there was network latency we may be clipping
            // audio before it completes playing. Lets check the node to make sure it
            // believes it has completed, before ending the playback.
            if (!self._webAudio && sound._node && !sound._node.paused && !sound._node.ended && sound._node.currentTime < sound._stop) {
                setTimeout(self._ended.bind(self, sound), 100);
                return self;
            }
            // Should this sound loop?
            var loop = !!(sound._loop || self._sprite[sprite][2]);
            // Fire the ended event.
            self._emit('end', sound._id);
            // Restart the playback for HTML5 Audio loop.
            if (!self._webAudio && loop) self.stop(sound._id, true).play(sound._id);
            // Restart this timer if on a Web Audio loop.
            if (self._webAudio && loop) {
                self._emit('play', sound._id);
                sound._seek = sound._start || 0;
                sound._rateSeek = 0;
                sound._playStart = Howler1.ctx.currentTime;
                var timeout = (sound._stop - sound._start) * 1000 / Math.abs(sound._rate);
                self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
            }
            // Mark the node as paused.
            if (self._webAudio && !loop) {
                sound._paused = true;
                sound._ended = true;
                sound._seek = sound._start || 0;
                sound._rateSeek = 0;
                self._clearTimer(sound._id);
                // Clean up the buffer source.
                self._cleanBuffer(sound._node);
                // Attempt to auto-suspend AudioContext if no sounds are still playing.
                Howler1._autoSuspend();
            }
            // When using a sprite, end the track.
            if (!self._webAudio && !loop) self.stop(sound._id, true);
            return self;
        },
        /**
     * Clear the end timer for a sound playback.
     * @param  {Number} id The sound ID.
     * @return {Howl}
     */ _clearTimer: function(id) {
            var self = this;
            if (self._endTimers[id]) {
                // Clear the timeout or remove the ended listener.
                if (typeof self._endTimers[id] !== 'function') clearTimeout(self._endTimers[id]);
                else {
                    var sound = self._soundById(id);
                    if (sound && sound._node) sound._node.removeEventListener('ended', self._endTimers[id], false);
                }
                delete self._endTimers[id];
            }
            return self;
        },
        /**
     * Return the sound identified by this ID, or return null.
     * @param  {Number} id Sound ID
     * @return {Object}    Sound object or null.
     */ _soundById: function(id) {
            var self = this;
            // Loop through all sounds and find the one with this ID.
            for(var i = 0; i < self._sounds.length; i++){
                if (id === self._sounds[i]._id) return self._sounds[i];
            }
            return null;
        },
        /**
     * Return an inactive sound from the pool or create a new one.
     * @return {Sound} Sound playback object.
     */ _inactiveSound: function() {
            var self = this;
            self._drain();
            // Find the first inactive node to recycle.
            for(var i = 0; i < self._sounds.length; i++){
                if (self._sounds[i]._ended) return self._sounds[i].reset();
            }
            // If no inactive node was found, create a new one.
            return new Sound1(self);
        },
        /**
     * Drain excess inactive sounds from the pool.
     */ _drain: function() {
            var self = this;
            var limit = self._pool;
            var cnt = 0;
            var i = 0;
            // If there are less sounds than the max pool size, we are done.
            if (self._sounds.length < limit) return;
            // Count the number of inactive sounds.
            for(i = 0; i < self._sounds.length; i++)if (self._sounds[i]._ended) cnt++;
            // Remove excess inactive sounds, going in reverse order.
            for(i = self._sounds.length - 1; i >= 0; i--){
                if (cnt <= limit) return;
                if (self._sounds[i]._ended) {
                    // Disconnect the audio source when using Web Audio.
                    if (self._webAudio && self._sounds[i]._node) self._sounds[i]._node.disconnect(0);
                    // Remove sounds until we have the pool size.
                    self._sounds.splice(i, 1);
                    cnt--;
                }
            }
        },
        /**
     * Get all ID's from the sounds pool.
     * @param  {Number} id Only return one ID if one is passed.
     * @return {Array}    Array of IDs.
     */ _getSoundIds: function(id) {
            var self = this;
            if (typeof id === 'undefined') {
                var ids = [];
                for(var i = 0; i < self._sounds.length; i++)ids.push(self._sounds[i]._id);
                return ids;
            } else return [
                id
            ];
        },
        /**
     * Load the sound back into the buffer source.
     * @param  {Sound} sound The sound object to work with.
     * @return {Howl}
     */ _refreshBuffer: function(sound) {
            var self = this;
            // Setup the buffer source for playback.
            sound._node.bufferSource = Howler1.ctx.createBufferSource();
            sound._node.bufferSource.buffer = cache[self._src];
            // Connect to the correct node.
            if (sound._panner) sound._node.bufferSource.connect(sound._panner);
            else sound._node.bufferSource.connect(sound._node);
            // Setup looping and playback rate.
            sound._node.bufferSource.loop = sound._loop;
            if (sound._loop) {
                sound._node.bufferSource.loopStart = sound._start || 0;
                sound._node.bufferSource.loopEnd = sound._stop || 0;
            }
            sound._node.bufferSource.playbackRate.setValueAtTime(sound._rate, Howler1.ctx.currentTime);
            return self;
        },
        /**
     * Prevent memory leaks by cleaning up the buffer source after playback.
     * @param  {Object} node Sound's audio node containing the buffer source.
     * @return {Howl}
     */ _cleanBuffer: function(node) {
            var self = this;
            var isIOS = Howler1._navigator && Howler1._navigator.vendor.indexOf('Apple') >= 0;
            if (!node.bufferSource) return self;
            if (Howler1._scratchBuffer && node.bufferSource) {
                node.bufferSource.onended = null;
                node.bufferSource.disconnect(0);
                if (isIOS) try {
                    node.bufferSource.buffer = Howler1._scratchBuffer;
                } catch (e) {}
            }
            node.bufferSource = null;
            return self;
        },
        /**
     * Set the source to a 0-second silence to stop any downloading (except in IE).
     * @param  {Object} node Audio node to clear.
     */ _clearSound: function(node) {
            var checkIE = /MSIE |Trident\//.test(Howler1._navigator && Howler1._navigator.userAgent);
            if (!checkIE) node.src = 'data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA';
        }
    };
    /** Single Sound Methods **/ /***************************************************************************/ /**
   * Setup the sound object, which each node attached to a Howl group is contained in.
   * @param {Object} howl The Howl parent group.
   */ var Sound1 = function(howl) {
        this._parent = howl;
        this.init();
    };
    Sound1.prototype = {
        /**
     * Initialize a new Sound object.
     * @return {Sound}
     */ init: function() {
            var self = this;
            var parent = self._parent;
            // Setup the default parameters.
            self._muted = parent._muted;
            self._loop = parent._loop;
            self._volume = parent._volume;
            self._rate = parent._rate;
            self._seek = 0;
            self._paused = true;
            self._ended = true;
            self._sprite = '__default';
            // Generate a unique ID for this sound.
            self._id = ++Howler1._counter;
            // Add itself to the parent's pool.
            parent._sounds.push(self);
            // Create the new node.
            self.create();
            return self;
        },
        /**
     * Create and setup a new sound object, whether HTML5 Audio or Web Audio.
     * @return {Sound}
     */ create: function() {
            var self = this;
            var parent = self._parent;
            var volume = Howler1._muted || self._muted || self._parent._muted ? 0 : self._volume;
            if (parent._webAudio) {
                // Create the gain node for controlling volume (the source will connect to this).
                self._node = typeof Howler1.ctx.createGain === 'undefined' ? Howler1.ctx.createGainNode() : Howler1.ctx.createGain();
                self._node.gain.setValueAtTime(volume, Howler1.ctx.currentTime);
                self._node.paused = true;
                self._node.connect(Howler1.masterGain);
            } else if (!Howler1.noAudio) {
                // Get an unlocked Audio object from the pool.
                self._node = Howler1._obtainHtml5Audio();
                // Listen for errors (http://dev.w3.org/html5/spec-author-view/spec.html#mediaerror).
                self._errorFn = self._errorListener.bind(self);
                self._node.addEventListener('error', self._errorFn, false);
                // Listen for 'canplaythrough' event to let us know the sound is ready.
                self._loadFn = self._loadListener.bind(self);
                self._node.addEventListener(Howler1._canPlayEvent, self._loadFn, false);
                // Listen for the 'ended' event on the sound to account for edge-case where
                // a finite sound has a duration of Infinity.
                self._endFn = self._endListener.bind(self);
                self._node.addEventListener('ended', self._endFn, false);
                // Setup the new audio node.
                self._node.src = parent._src;
                self._node.preload = parent._preload === true ? 'auto' : parent._preload;
                self._node.volume = volume * Howler1.volume();
                // Begin loading the source.
                self._node.load();
            }
            return self;
        },
        /**
     * Reset the parameters of this sound to the original state (for recycle).
     * @return {Sound}
     */ reset: function() {
            var self = this;
            var parent = self._parent;
            // Reset all of the parameters of this sound.
            self._muted = parent._muted;
            self._loop = parent._loop;
            self._volume = parent._volume;
            self._rate = parent._rate;
            self._seek = 0;
            self._rateSeek = 0;
            self._paused = true;
            self._ended = true;
            self._sprite = '__default';
            // Generate a new ID so that it isn't confused with the previous sound.
            self._id = ++Howler1._counter;
            return self;
        },
        /**
     * HTML5 Audio error listener callback.
     */ _errorListener: function() {
            var self = this;
            // Fire an error event and pass back the code.
            self._parent._emit('loaderror', self._id, self._node.error ? self._node.error.code : 0);
            // Clear the event listener.
            self._node.removeEventListener('error', self._errorFn, false);
        },
        /**
     * HTML5 Audio canplaythrough listener callback.
     */ _loadListener: function() {
            var self = this;
            var parent = self._parent;
            // Round up the duration to account for the lower precision in HTML5 Audio.
            parent._duration = Math.ceil(self._node.duration * 10) / 10;
            // Setup a sprite if none is defined.
            if (Object.keys(parent._sprite).length === 0) parent._sprite = {
                __default: [
                    0,
                    parent._duration * 1000
                ]
            };
            if (parent._state !== 'loaded') {
                parent._state = 'loaded';
                parent._emit('load');
                parent._loadQueue();
            }
            // Clear the event listener.
            self._node.removeEventListener(Howler1._canPlayEvent, self._loadFn, false);
        },
        /**
     * HTML5 Audio ended listener callback.
     */ _endListener: function() {
            var self = this;
            var parent = self._parent;
            // Only handle the `ended`` event if the duration is Infinity.
            if (parent._duration === Infinity) {
                // Update the parent duration to match the real audio duration.
                // Round up the duration to account for the lower precision in HTML5 Audio.
                parent._duration = Math.ceil(self._node.duration * 10) / 10;
                // Update the sprite that corresponds to the real duration.
                if (parent._sprite.__default[1] === Infinity) parent._sprite.__default[1] = parent._duration * 1000;
                // Run the regular ended method.
                parent._ended(self);
            }
            // Clear the event listener since the duration is now correct.
            self._node.removeEventListener('ended', self._endFn, false);
        }
    };
    /** Helper Methods **/ /***************************************************************************/ var cache = {};
    /**
   * Buffer a sound from URL, Data URI or cache and decode to audio source (Web Audio API).
   * @param  {Howl} self
   */ var loadBuffer = function(self) {
        var url = self._src;
        // Check if the buffer has already been cached and use it instead.
        if (cache[url]) {
            // Set the duration from the cache.
            self._duration = cache[url].duration;
            // Load the sound into this Howl.
            loadSound(self);
            return;
        }
        if (/^data:[^;]+;base64,/.test(url)) {
            // Decode the base64 data URI without XHR, since some browsers don't support it.
            var data = atob(url.split(',')[1]);
            var dataView = new Uint8Array(data.length);
            for(var i = 0; i < data.length; ++i)dataView[i] = data.charCodeAt(i);
            decodeAudioData(dataView.buffer, self);
        } else {
            // Load the buffer from the URL.
            var xhr = new XMLHttpRequest();
            xhr.open(self._xhr.method, url, true);
            xhr.withCredentials = self._xhr.withCredentials;
            xhr.responseType = 'arraybuffer';
            // Apply any custom headers to the request.
            if (self._xhr.headers) Object.keys(self._xhr.headers).forEach(function(key) {
                xhr.setRequestHeader(key, self._xhr.headers[key]);
            });
            xhr.onload = function() {
                // Make sure we get a successful response back.
                var code = (xhr.status + '')[0];
                if (code !== '0' && code !== '2' && code !== '3') {
                    self._emit('loaderror', null, 'Failed loading audio file with status: ' + xhr.status + '.');
                    return;
                }
                decodeAudioData(xhr.response, self);
            };
            xhr.onerror = function() {
                // If there is an error, switch to HTML5 Audio.
                if (self._webAudio) {
                    self._html5 = true;
                    self._webAudio = false;
                    self._sounds = [];
                    delete cache[url];
                    self.load();
                }
            };
            safeXhrSend(xhr);
        }
    };
    /**
   * Send the XHR request wrapped in a try/catch.
   * @param  {Object} xhr XHR to send.
   */ var safeXhrSend = function(xhr) {
        try {
            xhr.send();
        } catch (e) {
            xhr.onerror();
        }
    };
    /**
   * Decode audio data from an array buffer.
   * @param  {ArrayBuffer} arraybuffer The audio data.
   * @param  {Howl}        self
   */ var decodeAudioData = function(arraybuffer, self) {
        // Fire a load error if something broke.
        var error = function() {
            self._emit('loaderror', null, 'Decoding audio data failed.');
        };
        // Load the sound on success.
        var success = function(buffer) {
            if (buffer && self._sounds.length > 0) {
                cache[self._src] = buffer;
                loadSound(self, buffer);
            } else error();
        };
        // Decode the buffer into an audio source.
        if (typeof Promise !== 'undefined' && Howler1.ctx.decodeAudioData.length === 1) Howler1.ctx.decodeAudioData(arraybuffer).then(success).catch(error);
        else Howler1.ctx.decodeAudioData(arraybuffer, success, error);
    };
    /**
   * Sound is now loaded, so finish setting everything up and fire the loaded event.
   * @param  {Howl} self
   * @param  {Object} buffer The decoded buffer sound source.
   */ var loadSound = function(self, buffer) {
        // Set the duration.
        if (buffer && !self._duration) self._duration = buffer.duration;
        // Setup a sprite if none is defined.
        if (Object.keys(self._sprite).length === 0) self._sprite = {
            __default: [
                0,
                self._duration * 1000
            ]
        };
        // Fire the loaded event.
        if (self._state !== 'loaded') {
            self._state = 'loaded';
            self._emit('load');
            self._loadQueue();
        }
    };
    /**
   * Setup the audio context when available, or switch to HTML5 Audio mode.
   */ var setupAudioContext = function() {
        // If we have already detected that Web Audio isn't supported, don't run this step again.
        if (!Howler1.usingWebAudio) return;
        // Check if we are using Web Audio and setup the AudioContext if we are.
        try {
            if (typeof AudioContext !== 'undefined') Howler1.ctx = new AudioContext();
            else if (typeof webkitAudioContext !== 'undefined') Howler1.ctx = new webkitAudioContext();
            else Howler1.usingWebAudio = false;
        } catch (e) {
            Howler1.usingWebAudio = false;
        }
        // If the audio context creation still failed, set using web audio to false.
        if (!Howler1.ctx) Howler1.usingWebAudio = false;
        // Check if a webview is being used on iOS8 or earlier (rather than the browser).
        // If it is, disable Web Audio as it causes crashing.
        var iOS = /iP(hone|od|ad)/.test(Howler1._navigator && Howler1._navigator.platform);
        var appVersion = Howler1._navigator && Howler1._navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
        var version = appVersion ? parseInt(appVersion[1], 10) : null;
        if (iOS && version && version < 9) {
            var safari = /safari/.test(Howler1._navigator && Howler1._navigator.userAgent.toLowerCase());
            if (Howler1._navigator && !safari) Howler1.usingWebAudio = false;
        }
        // Create and expose the master GainNode when using Web Audio (useful for plugins or advanced usage).
        if (Howler1.usingWebAudio) {
            Howler1.masterGain = typeof Howler1.ctx.createGain === 'undefined' ? Howler1.ctx.createGainNode() : Howler1.ctx.createGain();
            Howler1.masterGain.gain.setValueAtTime(Howler1._muted ? 0 : Howler1._volume, Howler1.ctx.currentTime);
            Howler1.masterGain.connect(Howler1.ctx.destination);
        }
        // Re-run the setup on Howler.
        Howler1._setup();
    };
    // Add support for AMD (Asynchronous Module Definition) libraries such as require.js.
    if (typeof define === 'function' && define.amd) define([], function() {
        return {
            Howler: Howler1,
            Howl: Howl1
        };
    });
    $a72b5ec3d712344d$export$c9d39ca3bcd93abb = Howler1;
    $a72b5ec3d712344d$export$b791fe48eec8032a = Howl1;
    // Add to global in Node.js (for testing, etc).
    if (typeof $parcel$global !== 'undefined') {
        $parcel$global.HowlerGlobal = HowlerGlobal1;
        $parcel$global.Howler = Howler1;
        $parcel$global.Howl = Howl1;
        $parcel$global.Sound = Sound1;
    } else if (typeof window !== 'undefined') {
        window.HowlerGlobal = HowlerGlobal1;
        window.Howler = Howler1;
        window.Howl = Howl1;
        window.Sound = Sound1;
    }
})();
/*!
 *  Spatial Plugin - Adds support for stereo and 3D audio where Web Audio is supported.
 *  
 *  howler.js v2.2.4
 *  howlerjs.com
 *
 *  (c) 2013-2020, James Simpson of GoldFire Studios
 *  goldfirestudios.com
 *
 *  MIT License
 */ (function() {
    'use strict';
    // Setup default properties.
    HowlerGlobal.prototype._pos = [
        0,
        0,
        0
    ];
    HowlerGlobal.prototype._orientation = [
        0,
        0,
        -1,
        0,
        1,
        0
    ];
    /** Global Methods **/ /***************************************************************************/ /**
   * Helper method to update the stereo panning position of all current Howls.
   * Future Howls will not use this value unless explicitly set.
   * @param  {Number} pan A value of -1.0 is all the way left and 1.0 is all the way right.
   * @return {Howler/Number}     Self or current stereo panning value.
   */ HowlerGlobal.prototype.stereo = function(pan) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self.ctx || !self.ctx.listener) return self;
        // Loop through all Howls and update their stereo panning.
        for(var i = self._howls.length - 1; i >= 0; i--)self._howls[i].stereo(pan);
        return self;
    };
    /**
   * Get/set the position of the listener in 3D cartesian space. Sounds using
   * 3D position will be relative to the listener's position.
   * @param  {Number} x The x-position of the listener.
   * @param  {Number} y The y-position of the listener.
   * @param  {Number} z The z-position of the listener.
   * @return {Howler/Array}   Self or current listener position.
   */ HowlerGlobal.prototype.pos = function(x, y, z) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self.ctx || !self.ctx.listener) return self;
        // Set the defaults for optional 'y' & 'z'.
        y = typeof y !== 'number' ? self._pos[1] : y;
        z = typeof z !== 'number' ? self._pos[2] : z;
        if (typeof x === 'number') {
            self._pos = [
                x,
                y,
                z
            ];
            if (typeof self.ctx.listener.positionX !== 'undefined') {
                self.ctx.listener.positionX.setTargetAtTime(self._pos[0], Howler.ctx.currentTime, 0.1);
                self.ctx.listener.positionY.setTargetAtTime(self._pos[1], Howler.ctx.currentTime, 0.1);
                self.ctx.listener.positionZ.setTargetAtTime(self._pos[2], Howler.ctx.currentTime, 0.1);
            } else self.ctx.listener.setPosition(self._pos[0], self._pos[1], self._pos[2]);
        } else return self._pos;
        return self;
    };
    /**
   * Get/set the direction the listener is pointing in the 3D cartesian space.
   * A front and up vector must be provided. The front is the direction the
   * face of the listener is pointing, and up is the direction the top of the
   * listener is pointing. Thus, these values are expected to be at right angles
   * from each other.
   * @param  {Number} x   The x-orientation of the listener.
   * @param  {Number} y   The y-orientation of the listener.
   * @param  {Number} z   The z-orientation of the listener.
   * @param  {Number} xUp The x-orientation of the top of the listener.
   * @param  {Number} yUp The y-orientation of the top of the listener.
   * @param  {Number} zUp The z-orientation of the top of the listener.
   * @return {Howler/Array}     Returns self or the current orientation vectors.
   */ HowlerGlobal.prototype.orientation = function(x, y, z, xUp, yUp, zUp) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self.ctx || !self.ctx.listener) return self;
        // Set the defaults for optional 'y' & 'z'.
        var or = self._orientation;
        y = typeof y !== 'number' ? or[1] : y;
        z = typeof z !== 'number' ? or[2] : z;
        xUp = typeof xUp !== 'number' ? or[3] : xUp;
        yUp = typeof yUp !== 'number' ? or[4] : yUp;
        zUp = typeof zUp !== 'number' ? or[5] : zUp;
        if (typeof x === 'number') {
            self._orientation = [
                x,
                y,
                z,
                xUp,
                yUp,
                zUp
            ];
            if (typeof self.ctx.listener.forwardX !== 'undefined') {
                self.ctx.listener.forwardX.setTargetAtTime(x, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.forwardY.setTargetAtTime(y, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.forwardZ.setTargetAtTime(z, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.upX.setTargetAtTime(xUp, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.upY.setTargetAtTime(yUp, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.upZ.setTargetAtTime(zUp, Howler.ctx.currentTime, 0.1);
            } else self.ctx.listener.setOrientation(x, y, z, xUp, yUp, zUp);
        } else return or;
        return self;
    };
    /** Group Methods **/ /***************************************************************************/ /**
   * Add new properties to the core init.
   * @param  {Function} _super Core init method.
   * @return {Howl}
   */ Howl.prototype.init = function(_super) {
        return function(o) {
            var self = this;
            // Setup user-defined default properties.
            self._orientation = o.orientation || [
                1,
                0,
                0
            ];
            self._stereo = o.stereo || null;
            self._pos = o.pos || null;
            self._pannerAttr = {
                coneInnerAngle: typeof o.coneInnerAngle !== 'undefined' ? o.coneInnerAngle : 360,
                coneOuterAngle: typeof o.coneOuterAngle !== 'undefined' ? o.coneOuterAngle : 360,
                coneOuterGain: typeof o.coneOuterGain !== 'undefined' ? o.coneOuterGain : 0,
                distanceModel: typeof o.distanceModel !== 'undefined' ? o.distanceModel : 'inverse',
                maxDistance: typeof o.maxDistance !== 'undefined' ? o.maxDistance : 10000,
                panningModel: typeof o.panningModel !== 'undefined' ? o.panningModel : 'HRTF',
                refDistance: typeof o.refDistance !== 'undefined' ? o.refDistance : 1,
                rolloffFactor: typeof o.rolloffFactor !== 'undefined' ? o.rolloffFactor : 1
            };
            // Setup event listeners.
            self._onstereo = o.onstereo ? [
                {
                    fn: o.onstereo
                }
            ] : [];
            self._onpos = o.onpos ? [
                {
                    fn: o.onpos
                }
            ] : [];
            self._onorientation = o.onorientation ? [
                {
                    fn: o.onorientation
                }
            ] : [];
            // Complete initilization with howler.js core's init function.
            return _super.call(this, o);
        };
    }(Howl.prototype.init);
    /**
   * Get/set the stereo panning of the audio source for this sound or all in the group.
   * @param  {Number} pan  A value of -1.0 is all the way left and 1.0 is all the way right.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Number}    Returns self or the current stereo panning value.
   */ Howl.prototype.stereo = function(pan, id) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // If the sound hasn't loaded, add it to the load queue to change stereo pan when capable.
        if (self._state !== 'loaded') {
            self._queue.push({
                event: 'stereo',
                action: function() {
                    self.stereo(pan, id);
                }
            });
            return self;
        }
        // Check for PannerStereoNode support and fallback to PannerNode if it doesn't exist.
        var pannerType = typeof Howler.ctx.createStereoPanner === 'undefined' ? 'spatial' : 'stereo';
        // Setup the group's stereo panning if no ID is passed.
        if (typeof id === 'undefined') {
            // Return the group's stereo panning if no parameters are passed.
            if (typeof pan === 'number') {
                self._stereo = pan;
                self._pos = [
                    pan,
                    0,
                    0
                ];
            } else return self._stereo;
        }
        // Change the streo panning of one or all sounds in group.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            // Get the sound.
            var sound = self._soundById(ids[i]);
            if (sound) {
                if (typeof pan === 'number') {
                    sound._stereo = pan;
                    sound._pos = [
                        pan,
                        0,
                        0
                    ];
                    if (sound._node) {
                        // If we are falling back, make sure the panningModel is equalpower.
                        sound._pannerAttr.panningModel = 'equalpower';
                        // Check if there is a panner setup and create a new one if not.
                        if (!sound._panner || !sound._panner.pan) setupPanner(sound, pannerType);
                        if (pannerType === 'spatial') {
                            if (typeof sound._panner.positionX !== 'undefined') {
                                sound._panner.positionX.setValueAtTime(pan, Howler.ctx.currentTime);
                                sound._panner.positionY.setValueAtTime(0, Howler.ctx.currentTime);
                                sound._panner.positionZ.setValueAtTime(0, Howler.ctx.currentTime);
                            } else sound._panner.setPosition(pan, 0, 0);
                        } else sound._panner.pan.setValueAtTime(pan, Howler.ctx.currentTime);
                    }
                    self._emit('stereo', sound._id);
                } else return sound._stereo;
            }
        }
        return self;
    };
    /**
   * Get/set the 3D spatial position of the audio source for this sound or group relative to the global listener.
   * @param  {Number} x  The x-position of the audio source.
   * @param  {Number} y  The y-position of the audio source.
   * @param  {Number} z  The z-position of the audio source.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Array}    Returns self or the current 3D spatial position: [x, y, z].
   */ Howl.prototype.pos = function(x, y, z, id) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // If the sound hasn't loaded, add it to the load queue to change position when capable.
        if (self._state !== 'loaded') {
            self._queue.push({
                event: 'pos',
                action: function() {
                    self.pos(x, y, z, id);
                }
            });
            return self;
        }
        // Set the defaults for optional 'y' & 'z'.
        y = typeof y !== 'number' ? 0 : y;
        z = typeof z !== 'number' ? -0.5 : z;
        // Setup the group's spatial position if no ID is passed.
        if (typeof id === 'undefined') {
            // Return the group's spatial position if no parameters are passed.
            if (typeof x === 'number') self._pos = [
                x,
                y,
                z
            ];
            else return self._pos;
        }
        // Change the spatial position of one or all sounds in group.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            // Get the sound.
            var sound = self._soundById(ids[i]);
            if (sound) {
                if (typeof x === 'number') {
                    sound._pos = [
                        x,
                        y,
                        z
                    ];
                    if (sound._node) {
                        // Check if there is a panner setup and create a new one if not.
                        if (!sound._panner || sound._panner.pan) setupPanner(sound, 'spatial');
                        if (typeof sound._panner.positionX !== 'undefined') {
                            sound._panner.positionX.setValueAtTime(x, Howler.ctx.currentTime);
                            sound._panner.positionY.setValueAtTime(y, Howler.ctx.currentTime);
                            sound._panner.positionZ.setValueAtTime(z, Howler.ctx.currentTime);
                        } else sound._panner.setPosition(x, y, z);
                    }
                    self._emit('pos', sound._id);
                } else return sound._pos;
            }
        }
        return self;
    };
    /**
   * Get/set the direction the audio source is pointing in the 3D cartesian coordinate
   * space. Depending on how direction the sound is, based on the `cone` attributes,
   * a sound pointing away from the listener can be quiet or silent.
   * @param  {Number} x  The x-orientation of the source.
   * @param  {Number} y  The y-orientation of the source.
   * @param  {Number} z  The z-orientation of the source.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Array}    Returns self or the current 3D spatial orientation: [x, y, z].
   */ Howl.prototype.orientation = function(x, y, z, id) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // If the sound hasn't loaded, add it to the load queue to change orientation when capable.
        if (self._state !== 'loaded') {
            self._queue.push({
                event: 'orientation',
                action: function() {
                    self.orientation(x, y, z, id);
                }
            });
            return self;
        }
        // Set the defaults for optional 'y' & 'z'.
        y = typeof y !== 'number' ? self._orientation[1] : y;
        z = typeof z !== 'number' ? self._orientation[2] : z;
        // Setup the group's spatial orientation if no ID is passed.
        if (typeof id === 'undefined') {
            // Return the group's spatial orientation if no parameters are passed.
            if (typeof x === 'number') self._orientation = [
                x,
                y,
                z
            ];
            else return self._orientation;
        }
        // Change the spatial orientation of one or all sounds in group.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            // Get the sound.
            var sound = self._soundById(ids[i]);
            if (sound) {
                if (typeof x === 'number') {
                    sound._orientation = [
                        x,
                        y,
                        z
                    ];
                    if (sound._node) {
                        // Check if there is a panner setup and create a new one if not.
                        if (!sound._panner) {
                            // Make sure we have a position to setup the node with.
                            if (!sound._pos) sound._pos = self._pos || [
                                0,
                                0,
                                -0.5
                            ];
                            setupPanner(sound, 'spatial');
                        }
                        if (typeof sound._panner.orientationX !== 'undefined') {
                            sound._panner.orientationX.setValueAtTime(x, Howler.ctx.currentTime);
                            sound._panner.orientationY.setValueAtTime(y, Howler.ctx.currentTime);
                            sound._panner.orientationZ.setValueAtTime(z, Howler.ctx.currentTime);
                        } else sound._panner.setOrientation(x, y, z);
                    }
                    self._emit('orientation', sound._id);
                } else return sound._orientation;
            }
        }
        return self;
    };
    /**
   * Get/set the panner node's attributes for a sound or group of sounds.
   * This method can optionall take 0, 1 or 2 arguments.
   *   pannerAttr() -> Returns the group's values.
   *   pannerAttr(id) -> Returns the sound id's values.
   *   pannerAttr(o) -> Set's the values of all sounds in this Howl group.
   *   pannerAttr(o, id) -> Set's the values of passed sound id.
   *
   *   Attributes:
   *     coneInnerAngle - (360 by default) A parameter for directional audio sources, this is an angle, in degrees,
   *                      inside of which there will be no volume reduction.
   *     coneOuterAngle - (360 by default) A parameter for directional audio sources, this is an angle, in degrees,
   *                      outside of which the volume will be reduced to a constant value of `coneOuterGain`.
   *     coneOuterGain - (0 by default) A parameter for directional audio sources, this is the gain outside of the
   *                     `coneOuterAngle`. It is a linear value in the range `[0, 1]`.
   *     distanceModel - ('inverse' by default) Determines algorithm used to reduce volume as audio moves away from
   *                     listener. Can be `linear`, `inverse` or `exponential.
   *     maxDistance - (10000 by default) The maximum distance between source and listener, after which the volume
   *                   will not be reduced any further.
   *     refDistance - (1 by default) A reference distance for reducing volume as source moves further from the listener.
   *                   This is simply a variable of the distance model and has a different effect depending on which model
   *                   is used and the scale of your coordinates. Generally, volume will be equal to 1 at this distance.
   *     rolloffFactor - (1 by default) How quickly the volume reduces as source moves from listener. This is simply a
   *                     variable of the distance model and can be in the range of `[0, 1]` with `linear` and `[0, ∞]`
   *                     with `inverse` and `exponential`.
   *     panningModel - ('HRTF' by default) Determines which spatialization algorithm is used to position audio.
   *                     Can be `HRTF` or `equalpower`.
   *
   * @return {Howl/Object} Returns self or current panner attributes.
   */ Howl.prototype.pannerAttr = function() {
        var self = this;
        var args = arguments;
        var o, id, sound;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // Determine the values based on arguments.
        if (args.length === 0) // Return the group's panner attribute values.
        return self._pannerAttr;
        else if (args.length === 1) {
            if (typeof args[0] === 'object') {
                o = args[0];
                // Set the grou's panner attribute values.
                if (typeof id === 'undefined') {
                    if (!o.pannerAttr) o.pannerAttr = {
                        coneInnerAngle: o.coneInnerAngle,
                        coneOuterAngle: o.coneOuterAngle,
                        coneOuterGain: o.coneOuterGain,
                        distanceModel: o.distanceModel,
                        maxDistance: o.maxDistance,
                        refDistance: o.refDistance,
                        rolloffFactor: o.rolloffFactor,
                        panningModel: o.panningModel
                    };
                    self._pannerAttr = {
                        coneInnerAngle: typeof o.pannerAttr.coneInnerAngle !== 'undefined' ? o.pannerAttr.coneInnerAngle : self._coneInnerAngle,
                        coneOuterAngle: typeof o.pannerAttr.coneOuterAngle !== 'undefined' ? o.pannerAttr.coneOuterAngle : self._coneOuterAngle,
                        coneOuterGain: typeof o.pannerAttr.coneOuterGain !== 'undefined' ? o.pannerAttr.coneOuterGain : self._coneOuterGain,
                        distanceModel: typeof o.pannerAttr.distanceModel !== 'undefined' ? o.pannerAttr.distanceModel : self._distanceModel,
                        maxDistance: typeof o.pannerAttr.maxDistance !== 'undefined' ? o.pannerAttr.maxDistance : self._maxDistance,
                        refDistance: typeof o.pannerAttr.refDistance !== 'undefined' ? o.pannerAttr.refDistance : self._refDistance,
                        rolloffFactor: typeof o.pannerAttr.rolloffFactor !== 'undefined' ? o.pannerAttr.rolloffFactor : self._rolloffFactor,
                        panningModel: typeof o.pannerAttr.panningModel !== 'undefined' ? o.pannerAttr.panningModel : self._panningModel
                    };
                }
            } else {
                // Return this sound's panner attribute values.
                sound = self._soundById(parseInt(args[0], 10));
                return sound ? sound._pannerAttr : self._pannerAttr;
            }
        } else if (args.length === 2) {
            o = args[0];
            id = parseInt(args[1], 10);
        }
        // Update the values of the specified sounds.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            sound = self._soundById(ids[i]);
            if (sound) {
                // Merge the new values into the sound.
                var pa = sound._pannerAttr;
                pa = {
                    coneInnerAngle: typeof o.coneInnerAngle !== 'undefined' ? o.coneInnerAngle : pa.coneInnerAngle,
                    coneOuterAngle: typeof o.coneOuterAngle !== 'undefined' ? o.coneOuterAngle : pa.coneOuterAngle,
                    coneOuterGain: typeof o.coneOuterGain !== 'undefined' ? o.coneOuterGain : pa.coneOuterGain,
                    distanceModel: typeof o.distanceModel !== 'undefined' ? o.distanceModel : pa.distanceModel,
                    maxDistance: typeof o.maxDistance !== 'undefined' ? o.maxDistance : pa.maxDistance,
                    refDistance: typeof o.refDistance !== 'undefined' ? o.refDistance : pa.refDistance,
                    rolloffFactor: typeof o.rolloffFactor !== 'undefined' ? o.rolloffFactor : pa.rolloffFactor,
                    panningModel: typeof o.panningModel !== 'undefined' ? o.panningModel : pa.panningModel
                };
                // Create a new panner node if one doesn't already exist.
                var panner = sound._panner;
                if (!panner) {
                    // Make sure we have a position to setup the node with.
                    if (!sound._pos) sound._pos = self._pos || [
                        0,
                        0,
                        -0.5
                    ];
                    // Create a new panner node.
                    setupPanner(sound, 'spatial');
                    panner = sound._panner;
                }
                // Update the panner values or create a new panner if none exists.
                panner.coneInnerAngle = pa.coneInnerAngle;
                panner.coneOuterAngle = pa.coneOuterAngle;
                panner.coneOuterGain = pa.coneOuterGain;
                panner.distanceModel = pa.distanceModel;
                panner.maxDistance = pa.maxDistance;
                panner.refDistance = pa.refDistance;
                panner.rolloffFactor = pa.rolloffFactor;
                panner.panningModel = pa.panningModel;
            }
        }
        return self;
    };
    /** Single Sound Methods **/ /***************************************************************************/ /**
   * Add new properties to the core Sound init.
   * @param  {Function} _super Core Sound init method.
   * @return {Sound}
   */ Sound.prototype.init = function(_super) {
        return function() {
            var self = this;
            var parent = self._parent;
            // Setup user-defined default properties.
            self._orientation = parent._orientation;
            self._stereo = parent._stereo;
            self._pos = parent._pos;
            self._pannerAttr = parent._pannerAttr;
            // Complete initilization with howler.js core Sound's init function.
            _super.call(this);
            // If a stereo or position was specified, set it up.
            if (self._stereo) parent.stereo(self._stereo);
            else if (self._pos) parent.pos(self._pos[0], self._pos[1], self._pos[2], self._id);
        };
    }(Sound.prototype.init);
    /**
   * Override the Sound.reset method to clean up properties from the spatial plugin.
   * @param  {Function} _super Sound reset method.
   * @return {Sound}
   */ Sound.prototype.reset = function(_super) {
        return function() {
            var self = this;
            var parent = self._parent;
            // Reset all spatial plugin properties on this sound.
            self._orientation = parent._orientation;
            self._stereo = parent._stereo;
            self._pos = parent._pos;
            self._pannerAttr = parent._pannerAttr;
            // If a stereo or position was specified, set it up.
            if (self._stereo) parent.stereo(self._stereo);
            else if (self._pos) parent.pos(self._pos[0], self._pos[1], self._pos[2], self._id);
            else if (self._panner) {
                // Disconnect the panner.
                self._panner.disconnect(0);
                self._panner = undefined;
                parent._refreshBuffer(self);
            }
            // Complete resetting of the sound.
            return _super.call(this);
        };
    }(Sound.prototype.reset);
    /** Helper Methods **/ /***************************************************************************/ /**
   * Create a new panner node and save it on the sound.
   * @param  {Sound} sound Specific sound to setup panning on.
   * @param {String} type Type of panner to create: 'stereo' or 'spatial'.
   */ var setupPanner = function(sound, type) {
        type = type || 'spatial';
        // Create the new panner node.
        if (type === 'spatial') {
            sound._panner = Howler.ctx.createPanner();
            sound._panner.coneInnerAngle = sound._pannerAttr.coneInnerAngle;
            sound._panner.coneOuterAngle = sound._pannerAttr.coneOuterAngle;
            sound._panner.coneOuterGain = sound._pannerAttr.coneOuterGain;
            sound._panner.distanceModel = sound._pannerAttr.distanceModel;
            sound._panner.maxDistance = sound._pannerAttr.maxDistance;
            sound._panner.refDistance = sound._pannerAttr.refDistance;
            sound._panner.rolloffFactor = sound._pannerAttr.rolloffFactor;
            sound._panner.panningModel = sound._pannerAttr.panningModel;
            if (typeof sound._panner.positionX !== 'undefined') {
                sound._panner.positionX.setValueAtTime(sound._pos[0], Howler.ctx.currentTime);
                sound._panner.positionY.setValueAtTime(sound._pos[1], Howler.ctx.currentTime);
                sound._panner.positionZ.setValueAtTime(sound._pos[2], Howler.ctx.currentTime);
            } else sound._panner.setPosition(sound._pos[0], sound._pos[1], sound._pos[2]);
            if (typeof sound._panner.orientationX !== 'undefined') {
                sound._panner.orientationX.setValueAtTime(sound._orientation[0], Howler.ctx.currentTime);
                sound._panner.orientationY.setValueAtTime(sound._orientation[1], Howler.ctx.currentTime);
                sound._panner.orientationZ.setValueAtTime(sound._orientation[2], Howler.ctx.currentTime);
            } else sound._panner.setOrientation(sound._orientation[0], sound._orientation[1], sound._orientation[2]);
        } else {
            sound._panner = Howler.ctx.createStereoPanner();
            sound._panner.pan.setValueAtTime(sound._stereo, Howler.ctx.currentTime);
        }
        sound._panner.connect(sound._node);
        // Update the connections.
        if (!sound._paused) sound._parent.pause(sound._id, true).play(sound._id, true);
    };
})();


class $48d506356be1a82b$export$2e2bcd8739ae039 {
    constructor(files){
        this.files = {};
        this.tracks = {};
        this.trackLoadedStates = {};
        this.ambientTracks = {};
        // @ts-ignore
        window.audioController = this;
        this._loadFiles(files);
    }
    _loadFiles(files) {
        files.forEach((file)=>{
            this.files[file.id] = file;
            this.trackLoadedStates[file.id] = false;
            this.tracks[file.id] = new (0, $a72b5ec3d712344d$export$b791fe48eec8032a)({
                src: [
                    file.src
                ],
                loop: file.ambient,
                volume: file.volume || 1
            });
            this.tracks[file.id].on('load', ()=>{
                this.trackLoadedStates[file.id] = true;
            });
            this.tracks[file.id].on('loaderror', ()=>{
                console.error('error loading', file);
            });
        });
    }
    addTrack(file) {
        this._loadFiles([
            file
        ]);
    }
    hasTrack(trackId) {
        return !!this.ambientTracks[trackId];
    }
    /*
     * Play a track. If it's an ambient track, it will only play if it's not already playing.
     * If it's a non-ambient track, it will play multiple instances.
     */ play(trackId) {
        const file = this.files[trackId];
        const track = this.tracks[trackId];
        if (!track) // console.error('No track found for', trackId);
        return;
        if (file.ambient) {
            if (this.ambientTracks[trackId] === undefined) this.ambientTracks[trackId] = track.play();
            else if (!track.playing(this.ambientTracks[trackId])) track.play(this.ambientTracks[trackId]);
            return;
        }
        track.play();
    }
    stop(trackId) {
        const file = this.files[trackId];
        const track = this.tracks[trackId];
        if (!track) // console.error('No track found for', trackId);
        return;
        if (file.ambient) {
            if (this.ambientTracks[trackId] !== undefined) track.stop(this.ambientTracks[trackId]);
            return;
        }
        track.stop();
    }
    fadeIn(ambientTrackId, duration = 2000) {
        const file = this.files[ambientTrackId];
        const track = this.tracks[ambientTrackId];
        track.volume(0);
        if (!track.playing()) this.ambientTracks[ambientTrackId] = track.play();
        else track.seek(0);
        track.fade(0, file.volume || 1, duration);
    }
    fadeOut(ambientTrackId, duration = 2000) {
        const track = this.tracks[ambientTrackId];
        const volume = track.volume();
        track.fade(volume, 0, duration);
    }
    /*
     * Stop all ambient tracks and play only the specified track. Non-ambient tracks are not affected since they are usully short sfx and not looped.
     */ stopAll() {
        Object.keys(this.ambientTracks).forEach((ambientTrackId)=>{
            this.stop(ambientTrackId);
        });
    }
    /*
     * Stop all ambient tracks and play only the specified track.
     */ playOnly(trackId) {
        if (!Array.isArray(trackId)) trackId = [
            trackId
        ];
        Object.keys(this.ambientTracks).forEach((ambientTrackId)=>{
            if (!trackId.includes(ambientTrackId)) this.stop(ambientTrackId);
        });
        trackId.forEach((id)=>{
            this.play(id);
        });
    }
    mute(shouldMute) {
        (0, $a72b5ec3d712344d$export$c9d39ca3bcd93abb).mute(shouldMute);
    }
    toggleMute() {
        (0, $a72b5ec3d712344d$export$c9d39ca3bcd93abb).mute(// @ts-ignore
        !(0, $a72b5ec3d712344d$export$c9d39ca3bcd93abb)._muted);
        // @ts-ignore
        return (0, $a72b5ec3d712344d$export$c9d39ca3bcd93abb)._muted;
    }
}


let $f58c71b201a1c7d8$var$mutedLSKey = 'ARISE_SOUNDS_MUTED';
let $f58c71b201a1c7d8$var$audioController = null;
let $f58c71b201a1c7d8$var$emptyAudioController = new (0, $48d506356be1a82b$export$2e2bcd8739ae039)([]);
function $f58c71b201a1c7d8$export$91047320af7bf70b(tracks) {
    const [isMuted, setIsMuted] = (0, $7RNO0.useState)(localStorage.getItem($f58c71b201a1c7d8$var$mutedLSKey) === '1');
    if (!$f58c71b201a1c7d8$var$audioController && tracks && tracks.length > 0) {
        $f58c71b201a1c7d8$var$audioController = new (0, $48d506356be1a82b$export$2e2bcd8739ae039)(tracks);
        $f58c71b201a1c7d8$var$audioController.mute(isMuted);
    }
    const toggleMute = ()=>{
        const isHowlerMuted = $f58c71b201a1c7d8$var$audioController.toggleMute();
        localStorage.setItem($f58c71b201a1c7d8$var$mutedLSKey, isHowlerMuted ? '1' : '0');
        setIsMuted(isHowlerMuted);
    };
    return {
        isMuted: isMuted,
        toggleMute: toggleMute,
        audio: $f58c71b201a1c7d8$var$audioController || $f58c71b201a1c7d8$var$emptyAudioController
    };
}



var $kFQy0 = parcelRequire("kFQy0");

var $2QyQO = parcelRequire("2QyQO");

var $9h2J6 = parcelRequire("9h2J6");

var $6dpjF = parcelRequire("6dpjF");


var $9h2J6 = parcelRequire("9h2J6");

var $6dpjF = parcelRequire("6dpjF");

var $7v5wN = parcelRequire("7v5wN");

var $lmedS = parcelRequire("lmedS");
var $3be65d8420d30739$export$4cea6426d1265163;
var $3be65d8420d30739$export$8ce1fd94bee2f412;
var $3be65d8420d30739$export$c0306caf338ac095;
var $3be65d8420d30739$export$2cef06c20297c17d;
var $3be65d8420d30739$export$6811ecb90b1fb169;
var $3be65d8420d30739$export$f34cc12b3c5f18d0;
$3be65d8420d30739$export$4cea6426d1265163 = `oUJM5a_AvatarLayered`;
$3be65d8420d30739$export$8ce1fd94bee2f412 = `oUJM5a_background`;
$3be65d8420d30739$export$c0306caf338ac095 = `oUJM5a_character`;
$3be65d8420d30739$export$2cef06c20297c17d = `oUJM5a_frame`;
$3be65d8420d30739$export$6811ecb90b1fb169 = `oUJM5a_hasHover`;
$3be65d8420d30739$export$f34cc12b3c5f18d0 = `oUJM5a_masked`;


function $abebfe190420d491$export$2e2bcd8739ae039({ backgroundImagePath: backgroundImagePath, characterImagePath: characterImagePath, frameImagePath: frameImagePath, onClick: onClick, onMouseEnter: onMouseEnter, title: title, classname: classname, imageHeightDimension: imageHeightDimension = 120 }) {
    const theme = (0, $7v5wN.useTheme)();
    const characterImageUrl = characterImagePath ? (0, $lmedS.pathToURL)(characterImagePath) : null;
    const backgroundImageUrl = backgroundImagePath ? (0, $lmedS.pathToURL)(backgroundImagePath) : null;
    const characterImage = characterImageUrl ?? theme.customJSON.fallbackCharacterImageUrl;
    const backgroundImage = backgroundImageUrl ?? theme.customJSON.fallbackBackgroundImageUrl;
    const props = {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($3be65d8420d30739$export$4cea6426d1265163, classname, {
            [$3be65d8420d30739$export$6811ecb90b1fb169]: onClick
        }),
        title: title
    };
    const size = `?h=${imageHeightDimension}`;
    const content = /*#__PURE__*/ (0, $9h2J6.jsxs)((0, $9h2J6.Fragment), {
        children: [
            frameImagePath && /*#__PURE__*/ (0, $9h2J6.jsx)("img", {
                className: $3be65d8420d30739$export$2cef06c20297c17d,
                src: (0, $lmedS.pathToURL)(frameImagePath) + size,
                alt: " ",
                "aria-hidden": true
            }),
            /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                className: $3be65d8420d30739$export$f34cc12b3c5f18d0,
                children: [
                    backgroundImage && /*#__PURE__*/ (0, $9h2J6.jsx)("img", {
                        className: $3be65d8420d30739$export$8ce1fd94bee2f412,
                        src: backgroundImage + size,
                        alt: " ",
                        "aria-hidden": true
                    }),
                    characterImage && /*#__PURE__*/ (0, $9h2J6.jsx)("img", {
                        className: $3be65d8420d30739$export$c0306caf338ac095,
                        src: characterImage + size,
                        alt: " ",
                        "aria-hidden": true
                    })
                ]
            })
        ]
    });
    if (onClick) return /*#__PURE__*/ (0, $9h2J6.jsx)("button", {
        ...props,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        "aria-label": title ? title : 'Avatar',
        children: content
    });
    else return /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
        ...props,
        "aria-label": title ? title : 'Avatar',
        onMouseEnter: onMouseEnter,
        children: content
    });
}


var $c4625dce5a7014b7$exports = {};

$parcel$export($c4625dce5a7014b7$exports, "AvatarPicker", function () { return $c4625dce5a7014b7$export$6278dd89819af78; }, function (v) { return $c4625dce5a7014b7$export$6278dd89819af78 = v; });
$parcel$export($c4625dce5a7014b7$exports, "AvatarPickerAvatar", function () { return $c4625dce5a7014b7$export$6f8e3f8185b51c88; }, function (v) { return $c4625dce5a7014b7$export$6f8e3f8185b51c88 = v; });
$parcel$export($c4625dce5a7014b7$exports, "AvatarPickerAvatar--selected", function () { return $c4625dce5a7014b7$export$22ff2ab6c1ebf4b0; }, function (v) { return $c4625dce5a7014b7$export$22ff2ab6c1ebf4b0 = v; });
$parcel$export($c4625dce5a7014b7$exports, "AvatarPickerAvatar__Button", function () { return $c4625dce5a7014b7$export$4d15aea4ffa404a9; }, function (v) { return $c4625dce5a7014b7$export$4d15aea4ffa404a9 = v; });
$parcel$export($c4625dce5a7014b7$exports, "AvatarPickerAvatar__Image", function () { return $c4625dce5a7014b7$export$960c50e14a2ded22; }, function (v) { return $c4625dce5a7014b7$export$960c50e14a2ded22 = v; });
$parcel$export($c4625dce5a7014b7$exports, "page-transition-postVisible", function () { return $c4625dce5a7014b7$export$635eb3172be88cc1; }, function (v) { return $c4625dce5a7014b7$export$635eb3172be88cc1 = v; });
$parcel$export($c4625dce5a7014b7$exports, "page-transition-preVisible", function () { return $c4625dce5a7014b7$export$d0da582c244d7927; }, function (v) { return $c4625dce5a7014b7$export$d0da582c244d7927 = v; });
$parcel$export($c4625dce5a7014b7$exports, "page-transition-visible", function () { return $c4625dce5a7014b7$export$110dabf6daad8b9a; }, function (v) { return $c4625dce5a7014b7$export$110dabf6daad8b9a = v; });
$parcel$export($c4625dce5a7014b7$exports, "slide-in", function () { return $c4625dce5a7014b7$export$1c220dee9e4dbe34; }, function (v) { return $c4625dce5a7014b7$export$1c220dee9e4dbe34 = v; });
$parcel$export($c4625dce5a7014b7$exports, "slide-out", function () { return $c4625dce5a7014b7$export$ec7246eb5d3e2aa3; }, function (v) { return $c4625dce5a7014b7$export$ec7246eb5d3e2aa3 = v; });
var $c4625dce5a7014b7$export$6278dd89819af78;
var $c4625dce5a7014b7$export$6f8e3f8185b51c88;
var $c4625dce5a7014b7$export$22ff2ab6c1ebf4b0;
var $c4625dce5a7014b7$export$4d15aea4ffa404a9;
var $c4625dce5a7014b7$export$960c50e14a2ded22;
var $c4625dce5a7014b7$export$635eb3172be88cc1;
var $c4625dce5a7014b7$export$d0da582c244d7927;
var $c4625dce5a7014b7$export$110dabf6daad8b9a;
var $c4625dce5a7014b7$export$1c220dee9e4dbe34;
var $c4625dce5a7014b7$export$ec7246eb5d3e2aa3;
$c4625dce5a7014b7$export$6278dd89819af78 = `v1I5QG_AvatarPicker`;
$c4625dce5a7014b7$export$6f8e3f8185b51c88 = `v1I5QG_AvatarPickerAvatar`;
$c4625dce5a7014b7$export$22ff2ab6c1ebf4b0 = `v1I5QG_AvatarPickerAvatar--selected`;
$c4625dce5a7014b7$export$4d15aea4ffa404a9 = `v1I5QG_AvatarPickerAvatar__Button`;
$c4625dce5a7014b7$export$960c50e14a2ded22 = `v1I5QG_AvatarPickerAvatar__Image`;
$c4625dce5a7014b7$export$635eb3172be88cc1 = `v1I5QG_page-transition-postVisible`;
$c4625dce5a7014b7$export$d0da582c244d7927 = `v1I5QG_page-transition-preVisible`;
$c4625dce5a7014b7$export$110dabf6daad8b9a = `v1I5QG_page-transition-visible`;
$c4625dce5a7014b7$export$1c220dee9e4dbe34 = `v1I5QG_slide-in`;
$c4625dce5a7014b7$export$1c220dee9e4dbe34;
$c4625dce5a7014b7$export$ec7246eb5d3e2aa3 = `v1I5QG_slide-out`;
$c4625dce5a7014b7$export$ec7246eb5d3e2aa3;


function $d82f8213d7415fdc$export$2e2bcd8739ae039({ backgrounds: backgrounds, characters: characters, selectedCharacterId: selectedCharacterId, selectedBackgroundId: selectedBackgroundId, onBackgroundSelected: onBackgroundSelected, onCharacterSelected: onCharacterSelected, onAvatarMouseEnter: onAvatarMouseEnter, transitionState: transitionState = (0, $f6defc7795a4c638$export$f36897288fd2d497).visible }) {
    const renderAvatars = ()=>{
        if (!backgrounds?.length || !characters?.length) {
            console.warn('Not enough backgrounds or characters provided for onboarding');
            return 'No avatars available';
        }
        const NUMBER_OF_CHARACTERS = 2;
        const NUMBER_OF_BACKGROUNDS = 4;
        return characters.slice(0, NUMBER_OF_CHARACTERS).flatMap((character)=>backgrounds.slice(0, NUMBER_OF_BACKGROUNDS).map((background)=>/*#__PURE__*/ (0, $9h2J6.jsx)("li", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($c4625dce5a7014b7$exports.AvatarPickerAvatar, $c4625dce5a7014b7$exports[transitionState], {
                        [$c4625dce5a7014b7$exports['AvatarPickerAvatar--selected']]: selectedCharacterId === character.id && selectedBackgroundId === background.id
                    }),
                    children: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $abebfe190420d491$export$2e2bcd8739ae039), {
                        classname: $c4625dce5a7014b7$exports.AvatarPickerAvatar__Button,
                        title: `Avatar with ${character.name} and ${background.name}`,
                        onClick: ()=>{
                            onBackgroundSelected && onBackgroundSelected(background.id);
                            onCharacterSelected && onCharacterSelected(character.id);
                        },
                        onMouseEnter: onAvatarMouseEnter && onAvatarMouseEnter,
                        characterImagePath: character.thumbnailPath,
                        backgroundImagePath: background.imagePath,
                        imageHeightDimension: 200
                    })
                }, `${character.id}-${background.id}`)));
    };
    return /*#__PURE__*/ (0, $9h2J6.jsx)("ul", {
        className: $c4625dce5a7014b7$exports.AvatarPicker,
        children: renderAvatars()
    });
}



var $i2KZ1 = parcelRequire("i2KZ1");
function $ebb541bfb8cf4470$export$c8308480b6dfe6db(userId) {
    const profile = (0, $i2KZ1.useAppSelector)((state)=>state.profile.profileByUserId[userId]);
    return profile;
}
function $ebb541bfb8cf4470$export$c3ab02d49994a165() {
    const role = (0, $i2KZ1.useAppSelector)((state)=>state.profile.currentUserProfile?.role);
    return role === 'guest';
}


// Each rule string should match each function, and the rule in the backend
const $9a318c0adac33f72$export$aa8c7e6540925da0 = 'Please enter a valid email address.';
function $9a318c0adac33f72$export$371e338370561054(email) {
    return email && /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
}
const $9a318c0adac33f72$export$22f782bed1cafd3f = 'Your password must be at least 8 characters long.';
function $9a318c0adac33f72$export$1cf356d314abea16(password) {
    return password.length >= 8;
}
const $9a318c0adac33f72$export$45024f2ca55f9de6 = 'Your display name must be between 2 and 32 characters, start with a letter or number, and can only contain letters, numbers, underscores, and periods.';
function $9a318c0adac33f72$export$13abd87bc9b14090(name) {
    const displayNameRegex = /^[a-zA-Z0-9][a-zA-Z0-9_.]{1,31}$/;
    return displayNameRegex.test(name);
}


var $1f0153f72c0b16c4$exports = {};

$parcel$export($1f0153f72c0b16c4$exports, "authNextStepButton", function () { return $1f0153f72c0b16c4$export$a031258490b3ecf8; }, function (v) { return $1f0153f72c0b16c4$export$a031258490b3ecf8 = v; });
$parcel$export($1f0153f72c0b16c4$exports, "catastrophicError", function () { return $1f0153f72c0b16c4$export$5e5c4219124c8653; }, function (v) { return $1f0153f72c0b16c4$export$5e5c4219124c8653 = v; });
$parcel$export($1f0153f72c0b16c4$exports, "editProfilePage", function () { return $1f0153f72c0b16c4$export$eef05664aefcecd; }, function (v) { return $1f0153f72c0b16c4$export$eef05664aefcecd = v; });
$parcel$export($1f0153f72c0b16c4$exports, "editProfilePage__bottom", function () { return $1f0153f72c0b16c4$export$e023265c9eb0c587; }, function (v) { return $1f0153f72c0b16c4$export$e023265c9eb0c587 = v; });
$parcel$export($1f0153f72c0b16c4$exports, "editProfilePage__content", function () { return $1f0153f72c0b16c4$export$ba8f9cc34e4a8b1d; }, function (v) { return $1f0153f72c0b16c4$export$ba8f9cc34e4a8b1d = v; });
$parcel$export($1f0153f72c0b16c4$exports, "editProfilePage__errorMessage", function () { return $1f0153f72c0b16c4$export$6dfa81abbfc506c9; }, function (v) { return $1f0153f72c0b16c4$export$6dfa81abbfc506c9 = v; });
$parcel$export($1f0153f72c0b16c4$exports, "editProfilePage__formContent", function () { return $1f0153f72c0b16c4$export$eb7a272dc28528b2; }, function (v) { return $1f0153f72c0b16c4$export$eb7a272dc28528b2 = v; });
$parcel$export($1f0153f72c0b16c4$exports, "editProfilePage__pickerContainer", function () { return $1f0153f72c0b16c4$export$552081e1013dd9ae; }, function (v) { return $1f0153f72c0b16c4$export$552081e1013dd9ae = v; });
$parcel$export($1f0153f72c0b16c4$exports, "editProfilePage__pickerContainerTitle", function () { return $1f0153f72c0b16c4$export$7cd1476e0c0afdaf; }, function (v) { return $1f0153f72c0b16c4$export$7cd1476e0c0afdaf = v; });
$parcel$export($1f0153f72c0b16c4$exports, "loaded", function () { return $1f0153f72c0b16c4$export$b40fc69c4a2927a1; }, function (v) { return $1f0153f72c0b16c4$export$b40fc69c4a2927a1 = v; });
$parcel$export($1f0153f72c0b16c4$exports, "page-transition-postVisible", function () { return $1f0153f72c0b16c4$export$635eb3172be88cc1; }, function (v) { return $1f0153f72c0b16c4$export$635eb3172be88cc1 = v; });
$parcel$export($1f0153f72c0b16c4$exports, "page-transition-preVisible", function () { return $1f0153f72c0b16c4$export$d0da582c244d7927; }, function (v) { return $1f0153f72c0b16c4$export$d0da582c244d7927 = v; });
$parcel$export($1f0153f72c0b16c4$exports, "page-transition-visible", function () { return $1f0153f72c0b16c4$export$110dabf6daad8b9a; }, function (v) { return $1f0153f72c0b16c4$export$110dabf6daad8b9a = v; });
$parcel$export($1f0153f72c0b16c4$exports, "step1", function () { return $1f0153f72c0b16c4$export$1788037590f456a4; }, function (v) { return $1f0153f72c0b16c4$export$1788037590f456a4 = v; });
$parcel$export($1f0153f72c0b16c4$exports, "step2", function () { return $1f0153f72c0b16c4$export$30c608c84dc34af7; }, function (v) { return $1f0153f72c0b16c4$export$30c608c84dc34af7 = v; });
var $1f0153f72c0b16c4$export$a031258490b3ecf8;
var $1f0153f72c0b16c4$export$5e5c4219124c8653;
var $1f0153f72c0b16c4$export$eef05664aefcecd;
var $1f0153f72c0b16c4$export$e023265c9eb0c587;
var $1f0153f72c0b16c4$export$ba8f9cc34e4a8b1d;
var $1f0153f72c0b16c4$export$6dfa81abbfc506c9;
var $1f0153f72c0b16c4$export$eb7a272dc28528b2;
var $1f0153f72c0b16c4$export$552081e1013dd9ae;
var $1f0153f72c0b16c4$export$7cd1476e0c0afdaf;
var $1f0153f72c0b16c4$export$b40fc69c4a2927a1;
var $1f0153f72c0b16c4$export$635eb3172be88cc1;
var $1f0153f72c0b16c4$export$d0da582c244d7927;
var $1f0153f72c0b16c4$export$110dabf6daad8b9a;
var $1f0153f72c0b16c4$export$1788037590f456a4;
var $1f0153f72c0b16c4$export$30c608c84dc34af7;
$1f0153f72c0b16c4$export$a031258490b3ecf8 = `nhLJVW_authNextStepButton`;
$1f0153f72c0b16c4$export$5e5c4219124c8653 = `nhLJVW_catastrophicError`;
$1f0153f72c0b16c4$export$eef05664aefcecd = `nhLJVW_editProfilePage`;
$1f0153f72c0b16c4$export$e023265c9eb0c587 = `nhLJVW_editProfilePage__bottom`;
$1f0153f72c0b16c4$export$ba8f9cc34e4a8b1d = `nhLJVW_editProfilePage__content`;
$1f0153f72c0b16c4$export$6dfa81abbfc506c9 = `nhLJVW_editProfilePage__errorMessage`;
$1f0153f72c0b16c4$export$eb7a272dc28528b2 = `nhLJVW_editProfilePage__formContent`;
$1f0153f72c0b16c4$export$552081e1013dd9ae = `nhLJVW_editProfilePage__pickerContainer`;
$1f0153f72c0b16c4$export$7cd1476e0c0afdaf = `nhLJVW_editProfilePage__pickerContainerTitle`;
$1f0153f72c0b16c4$export$b40fc69c4a2927a1 = `nhLJVW_loaded`;
$1f0153f72c0b16c4$export$635eb3172be88cc1 = `nhLJVW_page-transition-postVisible`;
$1f0153f72c0b16c4$export$d0da582c244d7927 = `nhLJVW_page-transition-preVisible`;
$1f0153f72c0b16c4$export$110dabf6daad8b9a = `nhLJVW_page-transition-visible`;
$1f0153f72c0b16c4$export$1788037590f456a4 = `nhLJVW_step1`;
$1f0153f72c0b16c4$export$30c608c84dc34af7 = `nhLJVW_step2`;


function $26e69c1fbe45adbe$export$2e2bcd8739ae039() {
    const [selectedFactionId, setSelectedFactionId] = (0, $7RNO0.useState)('');
    const [selectedBackgroundId, setSelectedBackgroundId] = (0, $7RNO0.useState)('');
    const [selectedCharacterId, setSelectedCharacterId] = (0, $7RNO0.useState)('');
    const [displayName, setDisplayName] = (0, $7RNO0.useState)('');
    const [errorCode, setErrorCode] = (0, $7RNO0.useState)();
    const [currentStep, setCurrentStep] = (0, $7RNO0.useState)(0);
    const [pageTransitionState, setPageTransitionState] = (0, $7RNO0.useState)((0, $f6defc7795a4c638$export$f36897288fd2d497).preVisible);
    const [factionPickerTransitionState, setFactionPickerTransitionState] = (0, $7RNO0.useState)((0, $f6defc7795a4c638$export$f36897288fd2d497).preVisible);
    const [avatarPickerTransitionState, setAvatarPickerTransitionState] = (0, $7RNO0.useState)((0, $f6defc7795a4c638$export$f36897288fd2d497).preVisible);
    const [assetsAreLoaded, setAssetsAreLoaded] = (0, $7RNO0.useState)(false);
    const [isSendingData, setIsSendingData] = (0, $7RNO0.useState)(false);
    const [isProfileCreationComplete, setIsProfileCreationComplete] = (0, $7RNO0.useState)(false);
    const [isLoaded, setIsLoaded] = (0, $7RNO0.useState)(false);
    const [hasCatastrophicError, setHasCatastrophicError] = (0, $7RNO0.useState)(false);
    const dispatch = (0, $i2KZ1.useAppDispatch)();
    const navigate = (0, $0e3dfb59695be15b$export$9770f232ac06a008)();
    const theme = (0, $7v5wN.useTheme)();
    const profile = (0, $i2KZ1.useAppSelector)((state)=>state.profile);
    const { user: user, loggedIn: loggedIn } = (0, $i2KZ1.useAppSelector)((state)=>state.auth);
    const allowUserToSetDisplayName = !(0, $2QyQO.isInsidersInstance);
    const { audio: audio } = (0, $f58c71b201a1c7d8$export$91047320af7bf70b)();
    const isGuest = (0, $ebb541bfb8cf4470$export$c3ab02d49994a165)();
    (0, $7RNO0.useEffect)(()=>{
        if (isGuest) navigate((0, $2QyQO.homePath));
    }, [
        isGuest
    ]);
    (0, $7RNO0.useEffect)(()=>{
        audio.playOnly([
            'faction-selector-bg',
            'drone-bg'
        ]);
    }, []);
    const [factions, setFactions] = (0, $7RNO0.useState)();
    const [factionSettings, setFactionSettings] = (0, $7RNO0.useState)();
    const [characters, setCharacters] = (0, $7RNO0.useState)([]);
    const [backgrounds, setBackgrounds] = (0, $7RNO0.useState)();
    const loadElements = ()=>{
        const promises = [
            $9K8Jg.getFactions(),
            $9K8Jg.getFactionSettings(),
            $9K8Jg.getBackgrounds(),
            $9K8Jg.getCharacters()
        ];
        const assetIsDefault = (asset)=>asset.price === 0;
        Promise.all(promises).then(([factionsData, factionSettingsData, backgroundData, characterData])=>{
            const defaultBackgrounds = backgroundData.filter(assetIsDefault);
            const defaultCharacters = characterData.filter(assetIsDefault);
            if (!factionsData || !factionSettingsData) {
                setHasCatastrophicError(true);
                console.error('Onboarding - Factions data or factions settings not available');
            }
            if (!defaultBackgrounds?.length || !defaultCharacters?.length) {
                setHasCatastrophicError(true);
                console.error('Onboarding - Not enough default backgrounds or characters provided');
            }
            setFactions(factionsData);
            setFactionSettings(factionSettingsData);
            setBackgrounds(defaultBackgrounds);
            setCharacters(defaultCharacters);
            setAssetsAreLoaded(true);
        }).catch((error)=>{
            setAssetsAreLoaded(true);
            setHasCatastrophicError(true);
            console.error('Onboarding - Error loading onboarding data', error);
        });
    };
    function playRandomDrum() {
        const random = Math.random();
        if (random < 0.5) audio?.play('drum');
        else audio?.play('drum2');
    }
    function goToFactionPicker() {
        setCurrentStep(1);
        setTimeout(()=>{
            setFactionPickerTransitionState((0, $f6defc7795a4c638$export$f36897288fd2d497).visible);
        }, 10);
    }
    function goToAvatarPicker() {
        setCurrentStep(2);
        setTimeout(()=>{
            setAvatarPickerTransitionState((0, $f6defc7795a4c638$export$f36897288fd2d497).visible);
        }, 10);
    }
    function onContinue() {
        audio?.play('button-click');
        audio?.play('gust-open');
        setErrorCode(null);
        setFactionPickerTransitionState((0, $f6defc7795a4c638$export$f36897288fd2d497).postVisible);
        setTimeout(goToAvatarPicker, 1200);
    }
    function onSubmit() {
        audio?.play('button-click');
        if (!user || !selectedBackgroundId || !selectedCharacterId || !selectedFactionId) return;
        if (allowUserToSetDisplayName && !displayName) return;
        audio?.play('slam');
        submitData();
    }
    (0, $7RNO0.useEffect)(()=>{
        if (currentStep !== 2 || !allowUserToSetDisplayName) return;
        const DEBOUNCE_DELAY = 500;
        // Check display name validity locally once user stops typing for DEBOUNCE_DELAY
        const handler = setTimeout(()=>{
            if (!displayName || (0, $9a318c0adac33f72$export$13abd87bc9b14090)(displayName)) {
                if (errorCode === 'DISPLAYNAME_INVALID') setErrorCode(null);
            } else setErrorCode('DISPLAYNAME_INVALID');
        }, DEBOUNCE_DELAY);
        return ()=>clearTimeout(handler);
    }, [
        displayName,
        currentStep
    ]);
    async function submitData() {
        setIsSendingData(true);
        setErrorCode(null);
        if (profile.currentUserProfile) {
            (0, $kFQy0.sendEvent)('profile_update', {
                faction: selectedFactionId
            });
            try {
                const body = {
                    factionID: selectedFactionId,
                    backgroundID: selectedBackgroundId,
                    characterID: selectedCharacterId,
                    ...allowUserToSetDisplayName && {
                        displayName: displayName
                    }
                };
                const updatedUser = await $9K8Jg.editProfile(profile.currentUserProfile.id, body);
                dispatch((0, $6Jwum.updateUser)(updatedUser));
                navigateToHome();
            } catch (error) {
                setErrorCode(error?.message ?? 'UNKNOWN_ERROR');
                setIsSendingData(false);
            }
        } else {
            (0, $kFQy0.sendEvent)('profile_create', {
                faction: selectedFactionId
            });
            try {
                const body = {
                    displayName: allowUserToSetDisplayName ? displayName : user.username,
                    factionID: selectedFactionId,
                    backgroundID: selectedBackgroundId,
                    characterID: selectedCharacterId
                };
                const updatedUser = await $9K8Jg.createProfile(body);
                setIsProfileCreationComplete(true);
                dispatch((0, $6Jwum.updateUser)(updatedUser));
                dispatch((0, $6KpYp.updateProfile)(updatedUser.profile));
            } catch (error) {
                setErrorCode(error?.message ?? 'UNKNOWN_ERROR');
                setIsSendingData(false);
            }
        }
    }
    (0, $7RNO0.useEffect)(()=>{
        if (isProfileCreationComplete && profile.currentUserProfile) navigateToHome();
    }, [
        isProfileCreationComplete,
        profile.currentUserProfile
    ]);
    function onHover() {
        audio?.play('hover');
    }
    function navigateToHome() {
        setAvatarPickerTransitionState((0, $f6defc7795a4c638$export$f36897288fd2d497).postVisible);
        setPageTransitionState((0, $f6defc7795a4c638$export$f36897288fd2d497).postVisible);
        setTimeout(()=>{
            navigate((0, $2QyQO.homePath));
            audio.play('wipe-dark1');
        }, 1200);
    }
    (0, $7RNO0.useEffect)(()=>{
        loadElements();
    }, []);
    (0, $7RNO0.useEffect)(()=>{
        if (!isLoaded && loggedIn && user && assetsAreLoaded) {
            setIsLoaded(true);
            setTimeout(()=>{
                if (factions?.length === 1) {
                    // Only 1 faction to pick from, so skip this step
                    goToAvatarPicker();
                    setSelectedFactionId(factions[0].id);
                } else goToFactionPicker();
                setPageTransitionState((0, $f6defc7795a4c638$export$f36897288fd2d497).visible);
            }, 100);
        }
    }, [
        loggedIn,
        user,
        profile,
        assetsAreLoaded
    ]);
    (0, $7RNO0.useEffect)(()=>{
        if (user && !profile.currentUserProfileCheckInProgress) dispatch((0, $6KpYp.loadCurrentUserProfile)([
            user.id
        ]));
    }, [
        user
    ]);
    (0, $7RNO0.useEffect)(()=>{
        if (profile.currentUserProfile) {
            setSelectedFactionId(profile.currentUserProfile.factionID);
            setDisplayName(profile.currentUserProfile.displayName);
        }
    }, [
        profile.currentUserProfile
    ]);
    // TODO: loading
    if (!isLoaded) return /*#__PURE__*/ (0, $9h2J6.jsx)("div", {});
    function renderPicker() {
        switch(currentStep){
            case 1:
                return /*#__PURE__*/ (0, $9h2J6.jsx)((0, $f13fae8264ef7698$export$2e2bcd8739ae039), {
                    factions: factions,
                    factionSubtitle: factionSettings.factionCardSubtitle,
                    backgroundImagePath: (0, $lmedS.pathToURL)(factionSettings.factionCardBackgroundImagePath),
                    textBackgroundImagePath: (0, $lmedS.pathToURL)(factionSettings.factionCardTextBackgroundImagePath),
                    highlightImagePath: (0, $lmedS.pathToURL)(factionSettings.factionCardHighlightImagePath),
                    selectedFactionId: selectedFactionId,
                    onFactionSelected: (factionId)=>{
                        playRandomDrum();
                        setSelectedFactionId(factionId);
                        setErrorCode(null);
                    },
                    onFactionMouseEnter: onHover,
                    transitionState: factionPickerTransitionState
                });
            case 2:
                return /*#__PURE__*/ (0, $9h2J6.jsxs)((0, $9h2J6.Fragment), {
                    children: [
                        allowUserToSetDisplayName && /*#__PURE__*/ (0, $9h2J6.jsx)((0, $b7b30cc111a5a67e$export$2e2bcd8739ae039), {
                            value: displayName,
                            onChange: (e)=>setDisplayName(e.target.value),
                            placeholder: "Display Name",
                            type: "text",
                            id: "displayName",
                            name: "Display Name",
                            style: {
                                width: 350
                            }
                        }),
                        /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                            children: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $d82f8213d7415fdc$export$2e2bcd8739ae039), {
                                characters: characters,
                                backgrounds: backgrounds,
                                selectedCharacterId: selectedCharacterId,
                                selectedBackgroundId: selectedBackgroundId,
                                onBackgroundSelected: (id)=>{
                                    playRandomDrum();
                                    setSelectedBackgroundId(id);
                                },
                                onCharacterSelected: (id)=>{
                                    setSelectedCharacterId(id);
                                },
                                onAvatarMouseEnter: onHover,
                                transitionState: avatarPickerTransitionState
                            })
                        })
                    ]
                });
            default:
                return /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9h2J6.Fragment), {});
        }
    }
    function renderButton() {
        switch(currentStep){
            case 1:
                return /*#__PURE__*/ (0, $9h2J6.jsx)((0, $bc232447c96f1a4a$export$2e2bcd8739ae039), {
                    className: $1f0153f72c0b16c4$exports.authNextStepButton,
                    onClick: onContinue,
                    onSubmit: onContinue,
                    disabled: !selectedFactionId,
                    children: "Continue"
                });
            case 2:
                return /*#__PURE__*/ (0, $9h2J6.jsx)((0, $bc232447c96f1a4a$export$2e2bcd8739ae039), {
                    className: $1f0153f72c0b16c4$exports.authNextStepButton,
                    onClick: onSubmit,
                    onSubmit: onSubmit,
                    disabled: !selectedCharacterId || !selectedBackgroundId || allowUserToSetDisplayName && (!displayName || !(0, $9a318c0adac33f72$export$13abd87bc9b14090)(displayName)) || isSendingData,
                    children: "Continue"
                });
            default:
                return /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9h2J6.Fragment), {});
        }
    }
    const step2Title = allowUserToSetDisplayName ? 'Choose your avatar and display name' : 'Choose your avatar';
    return /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($1f0153f72c0b16c4$exports.editProfilePage, $1f0153f72c0b16c4$exports['step' + currentStep], $1f0153f72c0b16c4$exports[pageTransitionState], {
            [$1f0153f72c0b16c4$exports.loaded]: isLoaded
        }),
        style: {
            backgroundImage: `url(${theme.customJSON.editProfileBackgroundImage})`
        },
        children: [
            hasCatastrophicError && /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                className: $1f0153f72c0b16c4$exports.catastrophicError,
                children: /*#__PURE__*/ (0, $9h2J6.jsxs)("h2", {
                    children: [
                        "Something has gone wrong. ",
                        /*#__PURE__*/ (0, $9h2J6.jsx)("br", {}),
                        "Please try again later."
                    ]
                })
            }),
            !hasCatastrophicError && /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                className: $1f0153f72c0b16c4$exports.editProfilePage__pickerContainer,
                children: [
                    /*#__PURE__*/ (0, $9h2J6.jsx)("h2", {
                        className: $1f0153f72c0b16c4$exports.editProfilePage__pickerContainerTitle,
                        children: currentStep === 1 ? factionSettings.factionPickerTitle : step2Title
                    }),
                    renderPicker(),
                    /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                        className: $1f0153f72c0b16c4$exports.editProfilePage__bottom,
                        children: [
                            renderButton(),
                            /*#__PURE__*/ (0, $9h2J6.jsx)("p", {
                                className: $1f0153f72c0b16c4$exports.editProfilePage__errorMessage,
                                children: $26e69c1fbe45adbe$var$getEditProfileErrorMessage(errorCode)
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function $26e69c1fbe45adbe$var$getEditProfileErrorMessage(errorCode) {
    if (!errorCode) return '';
    switch(errorCode){
        case 'DISPLAYNAME_INVALID':
            return 0, $9a318c0adac33f72$export$45024f2ca55f9de6;
        case 'DISPLAYNAME_VIOLATES_POLICY':
            return 'Your display name contains inappropriate content.';
        default:
            return `Could not edit your profile, please try again or contact ${0, $2QyQO.SUPPORT_EMAIL}`;
    }
}



var $9h2J6 = parcelRequire("9h2J6");

var $7v5wN = parcelRequire("7v5wN");
function $0ec7c6ee785a0a8f$export$2e2bcd8739ae039({ children: children }) {
    const theme = (0, $7v5wN.useTheme)();
    if (!theme.loaded) return /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9h2J6.Fragment), {});
    return /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
        className: "absolute top-0 left-0 w-full h-full overflow-hidden",
        children: /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
            children: /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                children: children
            })
        })
    });
}



var $9h2J6 = parcelRequire("9h2J6");

var $9h2J6 = parcelRequire("9h2J6");

var $7RNO0 = parcelRequire("7RNO0");


var $9K8Jg = parcelRequire("9K8Jg");


var $9h2J6 = parcelRequire("9h2J6");

var $7RNO0 = parcelRequire("7RNO0");

var $6dpjF = parcelRequire("6dpjF");

var $7v5wN = parcelRequire("7v5wN");

var $9h2J6 = parcelRequire("9h2J6");

var $6dpjF = parcelRequire("6dpjF");

var $7v5wN = parcelRequire("7v5wN");

var $9S5u4 = parcelRequire("9S5u4");

var $9h2J6 = parcelRequire("9h2J6");

var $6dpjF = parcelRequire("6dpjF");
var $2454ee66659a29db$export$28c660c63b792dea;
var $2454ee66659a29db$export$a499844466ba329d;
var $2454ee66659a29db$export$795910f5f15a9633;
$2454ee66659a29db$export$28c660c63b792dea = `PrFOVW_Tooltip`;
$2454ee66659a29db$export$a499844466ba329d = `PrFOVW_autoPosition`;
$2454ee66659a29db$export$795910f5f15a9633 = `PrFOVW_isVisible`;


function $2975a004343627b9$export$2e2bcd8739ae039({ children: children, isVisible: isVisible, classname: classname, autoPosition: autoPosition = true }) {
    return /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($2454ee66659a29db$export$28c660c63b792dea, classname, {
            [$2454ee66659a29db$export$795910f5f15a9633]: isVisible,
            [$2454ee66659a29db$export$a499844466ba329d]: autoPosition
        }),
        children: children
    });
}


var $638666d11cea3768$export$c25acd513dcc8062;
var $638666d11cea3768$export$2a2d9e1569525b99;
var $638666d11cea3768$export$f62cea146a68a217;
var $638666d11cea3768$export$a9b0f2aa57c57690;
var $638666d11cea3768$export$e6515df4abc5dad;
$638666d11cea3768$export$c25acd513dcc8062 = `sBhBqW_IconButton`;
$638666d11cea3768$export$2a2d9e1569525b99 = `sBhBqW_hasDot`;
$638666d11cea3768$export$f62cea146a68a217 = `sBhBqW_isDiamondStyle`;
$638666d11cea3768$export$a9b0f2aa57c57690 = `sBhBqW_isIconStyle`;
$638666d11cea3768$export$e6515df4abc5dad = `sBhBqW_isRoundStyle`;


function $032b472fd8d5e329$export$2e2bcd8739ae039({ iconType: iconType, ariaLabel: ariaLabel, buttonStyle: buttonStyle = 'round', className: className, buttonRef: buttonRef, tooltipContent: tooltipContent, tooltipIsVisible: tooltipIsVisible, hasDot: hasDot, ...props }) {
    const theme = (0, $7v5wN.useTheme)();
    return /*#__PURE__*/ (0, $9h2J6.jsxs)("button", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($638666d11cea3768$export$c25acd513dcc8062, className, {
            [$638666d11cea3768$export$e6515df4abc5dad]: buttonStyle === 'round',
            [$638666d11cea3768$export$a9b0f2aa57c57690]: buttonStyle === 'icon',
            [$638666d11cea3768$export$f62cea146a68a217]: buttonStyle === 'diamond',
            [$638666d11cea3768$export$2a2d9e1569525b99]: hasDot
        }),
        "aria-label": ariaLabel,
        ref: buttonRef,
        ...props,
        style: buttonStyle === 'diamond' && theme.customJSON.diamondButtonMask ? {
            maskImage: `url("${theme.customJSON.diamondButtonMask}")`
        } : {},
        children: [
            /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9S5u4.default), {
                type: iconType,
                size: 24
            }),
            tooltipContent && /*#__PURE__*/ (0, $9h2J6.jsx)((0, $2975a004343627b9$export$2e2bcd8739ae039), {
                isVisible: tooltipIsVisible,
                children: tooltipContent
            })
        ]
    });
}



var $9h2J6 = parcelRequire("9h2J6");

var $6dpjF = parcelRequire("6dpjF");
var $96d0371ed53a5bc0$export$586b24dc092f3131;
var $96d0371ed53a5bc0$export$c95979b960f4acea;
var $96d0371ed53a5bc0$export$e239d3a0f2b98af4;
var $96d0371ed53a5bc0$export$73920f18ca706874;
var $96d0371ed53a5bc0$export$337c2b438c93a763;
var $96d0371ed53a5bc0$export$deaa9e6d912ce6c6;
var $96d0371ed53a5bc0$export$5f3730550ffb2e4;
var $96d0371ed53a5bc0$export$c96745152eb2740f;
var $96d0371ed53a5bc0$export$6f093cfa640b7166;
var $96d0371ed53a5bc0$export$a3457c10a8789d73;
var $96d0371ed53a5bc0$export$fb184b623420d9be;
$96d0371ed53a5bc0$export$586b24dc092f3131 = `eE_5DW_backgroundImage`;
$96d0371ed53a5bc0$export$c95979b960f4acea = `eE_5DW_fade-in`;
$96d0371ed53a5bc0$export$e239d3a0f2b98af4 = `eE_5DW_fade-in-out`;
$96d0371ed53a5bc0$export$e239d3a0f2b98af4;
$96d0371ed53a5bc0$export$73920f18ca706874 = `eE_5DW_hidden`;
$96d0371ed53a5bc0$export$337c2b438c93a763 = `eE_5DW_loadingScreen`;
$96d0371ed53a5bc0$export$deaa9e6d912ce6c6 = `eE_5DW_loadingSpinner`;
$96d0371ed53a5bc0$export$5f3730550ffb2e4 = `eE_5DW_rotate-and-back`;
$96d0371ed53a5bc0$export$5f3730550ffb2e4;
$96d0371ed53a5bc0$export$c96745152eb2740f = `eE_5DW_subtitle`;
$96d0371ed53a5bc0$export$6f093cfa640b7166 = `eE_5DW_text`;
$96d0371ed53a5bc0$export$a3457c10a8789d73 = `eE_5DW_textItem`;
$96d0371ed53a5bc0$export$fb184b623420d9be = `eE_5DW_title`;


function $712b328b756bc954$export$2e2bcd8739ae039({ show: show, classname: classname = '', hasBackground: hasBackground = true, backgroundImageUrl: backgroundImageUrl, logoImageUrl: logoImageUrl, loadingText: loadingText, style: style }) {
    const backgroundImageStyle = backgroundImageUrl ? {
        backgroundImage: `url("${backgroundImageUrl}")`
    } : {};
    return /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
        "aria-label": "Loading",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))('absolute left-0 w-full h-full', $96d0371ed53a5bc0$export$337c2b438c93a763, classname, {
            [$96d0371ed53a5bc0$export$73920f18ca706874]: !show
        }),
        style: style,
        children: [
            /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))('absolute top-0 left-0 w-full h-full', $96d0371ed53a5bc0$export$586b24dc092f3131, {
                    'bg-black bg-opacity-50 backdrop-blur-md': hasBackground
                }),
                style: backgroundImageStyle
            }),
            /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                className: "absolute top-0 left-0 w-full h-full flex items-center justify-center",
                children: [
                    /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                        className: "relative w-[150px] h-[150px]",
                        children: [
                            /*#__PURE__*/ (0, $9h2J6.jsx)("img", {
                                src: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUyIiBoZWlnaHQ9IjE1MiIgdmlld0JveD0iMCAwIDE1MiAxNTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8ZyBpZD0iTG9hZGVyQW5pbWF0aW9uIj4KICAgICAgICA8Y2lyY2xlIGlkPSJFbGxpcHNlIDMiIGN4PSI3NiIgY3k9Ijc2IiByPSI3NSIgc3Ryb2tlPSJ1cmwoI3BhaW50MF9saW5lYXJfNDE5XzEzNTIpIiAvPgogICAgPC9nPgogICAgPGRlZnM+CiAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzQxOV8xMzUyIiB4MT0iNzYiIHkxPSIxIiB4Mj0iNzYiIHkyPSI3NiIKICAgICAgICAgICAgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgogICAgICAgICAgICA8c3RvcCBzdG9wLWNvbG9yPSJ3aGl0ZSIgLz4KICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSJ3aGl0ZSIgc3RvcC1vcGFjaXR5PSIwIiAvPgogICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICA8L2RlZnM+Cjwvc3ZnPg==",
                                alt: " ",
                                className: 'absolute top-0 left-0 w-full h-full ' + $96d0371ed53a5bc0$export$deaa9e6d912ce6c6
                            }),
                            logoImageUrl && /*#__PURE__*/ (0, $9h2J6.jsx)("img", {
                                src: logoImageUrl,
                                alt: " ",
                                className: "absolute top-0 left-0 w-full h-full scale-[.6]"
                            })
                        ]
                    }),
                    loadingText && /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                        className: $96d0371ed53a5bc0$export$6f093cfa640b7166,
                        children: [
                            /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                                className: $96d0371ed53a5bc0$export$a3457c10a8789d73,
                                children: [
                                    /*#__PURE__*/ (0, $9h2J6.jsx)("span", {
                                        className: $96d0371ed53a5bc0$export$fb184b623420d9be,
                                        children: loadingText[0]?.title
                                    }),
                                    /*#__PURE__*/ (0, $9h2J6.jsx)("span", {
                                        className: $96d0371ed53a5bc0$export$c96745152eb2740f,
                                        children: loadingText[0]?.subtitle
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                                className: $96d0371ed53a5bc0$export$a3457c10a8789d73,
                                children: [
                                    /*#__PURE__*/ (0, $9h2J6.jsx)("span", {
                                        className: $96d0371ed53a5bc0$export$fb184b623420d9be,
                                        children: loadingText[1]?.title
                                    }),
                                    /*#__PURE__*/ (0, $9h2J6.jsx)("span", {
                                        className: $96d0371ed53a5bc0$export$c96745152eb2740f,
                                        children: loadingText[1]?.subtitle
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                                className: $96d0371ed53a5bc0$export$a3457c10a8789d73,
                                children: [
                                    /*#__PURE__*/ (0, $9h2J6.jsx)("span", {
                                        className: $96d0371ed53a5bc0$export$fb184b623420d9be,
                                        children: loadingText[2]?.title
                                    }),
                                    /*#__PURE__*/ (0, $9h2J6.jsx)("span", {
                                        className: $96d0371ed53a5bc0$export$c96745152eb2740f,
                                        children: loadingText[2]?.subtitle
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


var $0f42d0c6186fa24d$export$2b77a92f1a5ad772;
var $0f42d0c6186fa24d$export$2cc7ff91bcacba5e;
var $0f42d0c6186fa24d$export$49f2cecc68ed63a1;
var $0f42d0c6186fa24d$export$efe229eab43a9869;
var $0f42d0c6186fa24d$export$8f981dffec84ba52;
var $0f42d0c6186fa24d$export$1ca1ec8b29a4ce27;
var $0f42d0c6186fa24d$export$e5e9dfb795e86842;
var $0f42d0c6186fa24d$export$48c6aa3abf943eb9;
var $0f42d0c6186fa24d$export$4f081f07c0fd24b0;
var $0f42d0c6186fa24d$export$c80d57c51a11eb0a;
var $0f42d0c6186fa24d$export$2077e0241d6afd3c;
var $0f42d0c6186fa24d$export$664c6d24e3175067;
$0f42d0c6186fa24d$export$2b77a92f1a5ad772 = `kdx_FG_Modal`;
$0f42d0c6186fa24d$export$2cc7ff91bcacba5e = `kdx_FG_blur`;
$0f42d0c6186fa24d$export$49f2cecc68ed63a1 = `kdx_FG_canScroll`;
$0f42d0c6186fa24d$export$efe229eab43a9869 = `kdx_FG_closeButton`;
$0f42d0c6186fa24d$export$8f981dffec84ba52 = `kdx_FG_contentContainer`;
$0f42d0c6186fa24d$export$1ca1ec8b29a4ce27 = `kdx_FG_icon`;
$0f42d0c6186fa24d$export$e5e9dfb795e86842 = `kdx_FG_leaveSpaceAboveAndBelow`;
$0f42d0c6186fa24d$export$48c6aa3abf943eb9 = `kdx_FG_modalDrawer`;
$0f42d0c6186fa24d$export$4f081f07c0fd24b0 = `kdx_FG_modalTitle`;
$0f42d0c6186fa24d$export$c80d57c51a11eb0a = `kdx_FG_noBackgroundImage`;
$0f42d0c6186fa24d$export$2077e0241d6afd3c = `kdx_FG_round`;
$0f42d0c6186fa24d$export$664c6d24e3175067 = `kdx_FG_visible`;


function $5aad52fabd29c6cf$export$2e2bcd8739ae039({ title: title, onClose: onClose, isVisible: isVisible, modalClassname: modalClassname, contentClassname: contentClassname, closeButtonClassname: closeButtonClassname, classname: classname, canScroll: canScroll, isLoading: isLoading, children: children, zIndex: zIndex = 'auto', leaveSpaceAboveAndBelow: leaveSpaceAboveAndBelow = true, backgroundImageOverride: backgroundImageOverride, closeButtonStyle: closeButtonStyle = 'round', shouldCloseOnExternalClick: shouldCloseOnExternalClick = true, hasCloseButton: hasCloseButton = true }) {
    const theme = (0, $7v5wN.useTheme)();
    const backgroundImage = backgroundImageOverride ?? theme.customJSON.modalBackgroundImage;
    const containerRef = (0, $7RNO0.useRef)(null);
    const modalContentRef = (0, $7RNO0.useRef)(null);
    const modalRef = (0, $7RNO0.useRef)(null);
    function close() {
        if (onClose) onClose();
    }
    // Close modal when user presses escape
    function onKeyUp(e) {
        if (e.key === 'Escape') close();
    }
    // Hide modal when the user clicks outside of it
    function clickHandler(e) {
        if (shouldCloseOnExternalClick && modalContentRef.current && !modalContentRef.current.contains(e.target)) close();
    }
    // Move focus to modal when opened
    function onTransitionEnd(e) {
        if (isVisible && e.target === e.currentTarget) setTimeout(()=>{
            modalRef.current?.focus();
        }, 200);
    }
    return /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
        onClick: clickHandler,
        onKeyUp: onKeyUp,
        inert: isVisible ? undefined : '',
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))(classname, 'overflow-hidden'),
        ref: containerRef,
        onScroll: ()=>{
            // Stop scroll jumping to items which become focussed off screen
            containerRef.current?.scrollTo(0, 0);
        },
        children: [
            /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))('absolute top-0 left-0 w-full h-full', $0f42d0c6186fa24d$export$2cc7ff91bcacba5e, {
                    [$0f42d0c6186fa24d$export$664c6d24e3175067]: isVisible
                }),
                style: {
                    transition: 'backdrop-filter 300ms, visibility 300ms',
                    visibility: isVisible ? 'visible' : 'hidden',
                    backdropFilter: isVisible ? 'blur(10px)' : 'blur(0px)',
                    zIndex: zIndex
                }
            }),
            /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                onTransitionEnd: onTransitionEnd,
                role: "dialog",
                "aria-hidden": !isVisible,
                ...title && {
                    'aria-labelledby': 'modalTitle'
                },
                ref: modalRef,
                tabIndex: -1,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($0f42d0c6186fa24d$export$48c6aa3abf943eb9, {
                    [$0f42d0c6186fa24d$export$664c6d24e3175067]: isVisible
                }),
                style: {
                    zIndex: zIndex
                },
                children: [
                    /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                        onClick: clickHandler,
                        ref: modalContentRef,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($0f42d0c6186fa24d$export$2b77a92f1a5ad772, modalClassname, {
                            [$0f42d0c6186fa24d$export$c80d57c51a11eb0a]: !backgroundImage,
                            [$0f42d0c6186fa24d$export$49f2cecc68ed63a1]: canScroll,
                            [$0f42d0c6186fa24d$export$e5e9dfb795e86842]: leaveSpaceAboveAndBelow
                        }),
                        style: backgroundImage ? {
                            backgroundImage: `url("${backgroundImage}")`
                        } : {},
                        children: [
                            hasCloseButton && /*#__PURE__*/ (0, $9h2J6.jsx)((0, $032b472fd8d5e329$export$2e2bcd8739ae039), {
                                iconType: "close",
                                buttonStyle: closeButtonStyle,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($0f42d0c6186fa24d$export$efe229eab43a9869, closeButtonClassname, {
                                    [$0f42d0c6186fa24d$export$2077e0241d6afd3c]: closeButtonStyle === 'round',
                                    [$0f42d0c6186fa24d$export$1ca1ec8b29a4ce27]: closeButtonStyle === 'icon'
                                }),
                                ariaLabel: "Close modal",
                                onClick: close,
                                disabled: !isVisible
                            }),
                            /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($0f42d0c6186fa24d$export$8f981dffec84ba52, contentClassname),
                                children: [
                                    title && /*#__PURE__*/ (0, $9h2J6.jsx)("h2", {
                                        id: "modalTitle",
                                        className: $0f42d0c6186fa24d$export$4f081f07c0fd24b0,
                                        children: title
                                    }),
                                    children
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9h2J6.jsx)((0, $712b328b756bc954$export$2e2bcd8739ae039), {
                        show: isLoading,
                        hasBackground: false
                    })
                ]
            })
        ]
    });
}



var $kFQy0 = parcelRequire("kFQy0");

var $i2KZ1 = parcelRequire("i2KZ1");

var $2QyQO = parcelRequire("2QyQO");

var $6Jwum = parcelRequire("6Jwum");



var $9h2J6 = parcelRequire("9h2J6");

var $6dpjF = parcelRequire("6dpjF");
var $9829c164e290772a$export$c43bfb5198aa7b21;
var $9829c164e290772a$export$cb4d80803776d6ac;
var $9829c164e290772a$export$972cea82bfe1355a;
var $9829c164e290772a$export$879158938acd5cc;
var $9829c164e290772a$export$ec85da0fcf356258;
var $9829c164e290772a$export$db7bc7284c4dde8f;
var $9829c164e290772a$export$24c09d9bceb0c15d;
var $9829c164e290772a$export$3b2eaf4f83e09fef;
$9829c164e290772a$export$c43bfb5198aa7b21 = `savgpW_AuthButton`;
$9829c164e290772a$export$cb4d80803776d6ac = `savgpW_externalLoginButtons`;
$9829c164e290772a$export$972cea82bfe1355a = `savgpW_gsi-material-button`;
$9829c164e290772a$export$879158938acd5cc = `savgpW_gsi-material-button-content-wrapper`;
$9829c164e290772a$export$ec85da0fcf356258 = `savgpW_gsi-material-button-contents`;
$9829c164e290772a$export$db7bc7284c4dde8f = `savgpW_gsi-material-button-icon`;
$9829c164e290772a$export$24c09d9bceb0c15d = `savgpW_gsi-material-button-state`;
$9829c164e290772a$export$3b2eaf4f83e09fef = `savgpW_isHighlighted`;


const $e94781751f5e34af$var$icons = {
    google: /*#__PURE__*/ (0, $9h2J6.jsxs)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48",
        style: {
            display: 'block'
        },
        children: [
            /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                fill: "#EA4335",
                d: "M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                fill: "#4285F4",
                d: "M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                fill: "#FBBC05",
                d: "M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                fill: "#34A853",
                d: "M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                fill: "none",
                d: "M0 0h48v48H0z"
            })
        ]
    }),
    apple: /*#__PURE__*/ (0, $9h2J6.jsx)("svg", {
        width: "18",
        height: "21",
        viewBox: "0 0 18 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
            d: "M8.84024 4.84615C9.7832 4.84615 10.9652 4.20534 11.6691 3.35092C12.3066 2.57661 12.7715 1.49523 12.7715 0.413859C12.7715 0.267006 12.7582 0.120153 12.7316 0C11.6824 0.0400509 10.4207 0.707566 9.66367 1.60203C9.06602 2.2829 8.52148 3.35092 8.52148 4.44565C8.52148 4.60585 8.54805 4.76605 8.56133 4.81945C8.62774 4.8328 8.73398 4.84615 8.84024 4.84615ZM5.51992 21C6.8082 21 7.3793 20.1322 8.98633 20.1322C10.6199 20.1322 10.9785 20.9733 12.4129 20.9733C13.8207 20.9733 14.7637 19.665 15.6535 18.3833C16.6496 16.9148 17.0613 15.473 17.0879 15.4062C16.9949 15.3795 14.2988 14.2715 14.2988 11.1608C14.2988 8.46408 16.4238 7.24921 16.5434 7.15575C15.1355 5.12651 12.9973 5.07311 12.4129 5.07311C10.8324 5.07311 9.54414 6.03433 8.73398 6.03433C7.85742 6.03433 6.70195 5.12651 5.33398 5.12651C2.73086 5.12651 0.0878906 7.28926 0.0878906 11.3744C0.0878906 13.911 1.0707 16.5944 2.2793 18.3299C3.31523 19.7985 4.21836 21 5.51992 21Z",
            fill: "black"
        })
    })
};
function $e94781751f5e34af$var$ExternalLoginButton({ provider: provider, text: text }) {
    const PROVIDER_URLS = {
        google: "https://api.ariseworlds.com/auth/oauth/google/begin?state=",
        apple: "https://api.ariseworlds.com/auth/oauth/apple/begin?state="
    };
    function getUrl() {
        if (!crypto?.randomUUID) return;
        const key = crypto.randomUUID();
        const state = encodeURIComponent(btoa(window.location.origin + '?key=' + key));
        return PROVIDER_URLS[provider] + state;
    }
    const onClick = ()=>{
        window.location.href = getUrl();
    };
    if (!PROVIDER_URLS[provider]) {
        console.warn(`oAuth provider not supported: ${provider}`);
        return null;
    }
    return /*#__PURE__*/ (0, $9h2J6.jsxs)("button", {
        className: $9829c164e290772a$export$972cea82bfe1355a,
        onClick: onClick,
        disabled: !crypto?.randomUUID,
        children: [
            /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                className: $9829c164e290772a$export$24c09d9bceb0c15d
            }),
            /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                className: $9829c164e290772a$export$879158938acd5cc,
                children: [
                    /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                        className: $9829c164e290772a$export$db7bc7284c4dde8f,
                        children: $e94781751f5e34af$var$icons[provider]
                    }),
                    /*#__PURE__*/ (0, $9h2J6.jsx)("span", {
                        className: $9829c164e290772a$export$ec85da0fcf356258,
                        children: text
                    })
                ]
            })
        ]
    });
}
function $e94781751f5e34af$export$b109b9c2518624d5({ authProviders: authProviders }) {
    if (!authProviders || !authProviders.length) return null;
    const getButton = (provider, key)=>{
        switch(provider){
            case 'google':
                return /*#__PURE__*/ (0, $9h2J6.jsx)($e94781751f5e34af$var$ExternalLoginButton, {
                    provider: "google",
                    text: "Continue with Google"
                }, key);
            case 'apple':
                return /*#__PURE__*/ (0, $9h2J6.jsx)($e94781751f5e34af$var$ExternalLoginButton, {
                    provider: "apple",
                    text: "Continue with Apple"
                }, key);
            default:
                console.warn('Unsupported oAuth:', provider);
                break;
        }
    };
    return /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
        className: $9829c164e290772a$export$cb4d80803776d6ac,
        children: authProviders.map((provider, index)=>getButton(provider, index))
    });
}
function $e94781751f5e34af$export$c43bfb5198aa7b21({ text: text, onClick: onClick, isHighlighted: isHighlighted = true, ...props }) {
    return /*#__PURE__*/ (0, $9h2J6.jsx)("button", {
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($9829c164e290772a$export$c43bfb5198aa7b21, {
            [$9829c164e290772a$export$3b2eaf4f83e09fef]: isHighlighted
        }),
        onClick: onClick,
        children: text
    });
}


var $a2e351ff115d2f57$export$4adafe2b4f22b75f;
var $a2e351ff115d2f57$export$8d6d009d1f06226e;
var $a2e351ff115d2f57$export$5cfd5c18b591b2db;
var $a2e351ff115d2f57$export$be69ea624d82a314;
var $a2e351ff115d2f57$export$efe229eab43a9869;
var $a2e351ff115d2f57$export$4f70dd1570ce06b2;
var $a2e351ff115d2f57$export$493b5823483d2c4e;
var $a2e351ff115d2f57$export$66791fb2cfeec3e;
var $a2e351ff115d2f57$export$b7e3ae3d7c15e42e;
var $a2e351ff115d2f57$export$affaf52642033041;
var $a2e351ff115d2f57$export$56f1fed55afb58d9;
var $a2e351ff115d2f57$export$db3c28d99448dcff;
var $a2e351ff115d2f57$export$3e523c77c1f23f8c;
var $a2e351ff115d2f57$export$60877daf335d779;
var $a2e351ff115d2f57$export$457806cff9fed328;
$a2e351ff115d2f57$export$4adafe2b4f22b75f = `XwDFiW_AriseLoginModal`;
$a2e351ff115d2f57$export$8d6d009d1f06226e = `XwDFiW_backButton`;
$a2e351ff115d2f57$export$5cfd5c18b591b2db = `XwDFiW_bottomText`;
$a2e351ff115d2f57$export$be69ea624d82a314 = `XwDFiW_checkboxContainer`;
$a2e351ff115d2f57$export$efe229eab43a9869 = `XwDFiW_closeButton`;
$a2e351ff115d2f57$export$4f70dd1570ce06b2 = `XwDFiW_emailInfo`;
$a2e351ff115d2f57$export$493b5823483d2c4e = `XwDFiW_errorMessage`;
$a2e351ff115d2f57$export$66791fb2cfeec3e = `XwDFiW_forgotPassword`;
$a2e351ff115d2f57$export$b7e3ae3d7c15e42e = `XwDFiW_input`;
$a2e351ff115d2f57$export$affaf52642033041 = `XwDFiW_intro`;
$a2e351ff115d2f57$export$56f1fed55afb58d9 = `XwDFiW_loginLink`;
$a2e351ff115d2f57$export$db3c28d99448dcff = `XwDFiW_logo`;
$a2e351ff115d2f57$export$3e523c77c1f23f8c = `XwDFiW_separator`;
$a2e351ff115d2f57$export$60877daf335d779 = `XwDFiW_smallText`;
$a2e351ff115d2f57$export$457806cff9fed328 = `XwDFiW_turnStyle`;


function $305f209161d05cae$export$2e2bcd8739ae039() {
    const [displayName, setDisplayName] = (0, $7RNO0.useState)('');
    const [errorCode, setErrorCode] = (0, $7RNO0.useState)();
    const [isSendingData, setIsSendingData] = (0, $7RNO0.useState)(false);
    const currentUserProfile = (0, $i2KZ1.useAppSelector)((state)=>state.profile.currentUserProfile);
    const navigate = (0, $0e3dfb59695be15b$export$9770f232ac06a008)();
    const dispatch = (0, $i2KZ1.useAppDispatch)();
    const isGuest = (0, $ebb541bfb8cf4470$export$c3ab02d49994a165)();
    (0, $7RNO0.useEffect)(()=>{
        if (isGuest || (0, $2QyQO.isInsidersInstance)) navigate((0, $2QyQO.homePath));
    }, [
        isGuest,
        (0, $2QyQO.isInsidersInstance)
    ]);
    (0, $7RNO0.useEffect)(()=>{
        const DEBOUNCE_DELAY = 500;
        // Check display name validity locally once user stops typing for DEBOUNCE_DELAY
        const handler = setTimeout(()=>{
            if (!displayName || (0, $9a318c0adac33f72$export$13abd87bc9b14090)(displayName)) {
                if (errorCode === 'DISPLAYNAME_INVALID') setErrorCode(null);
            } else setErrorCode('DISPLAYNAME_INVALID');
        }, DEBOUNCE_DELAY);
        return ()=>clearTimeout(handler);
    }, [
        displayName
    ]);
    async function onSubmit() {
        if (!(0, $9a318c0adac33f72$export$13abd87bc9b14090)(displayName)) {
            setErrorCode('DISPLAYNAME_INVALID');
            return;
        }
        if (isSendingData) return;
        setIsSendingData(true);
        try {
            const body = {
                displayName: displayName
            };
            const updatedUser = await $9K8Jg.editProfile(currentUserProfile.id, body);
            (0, $kFQy0.sendEvent)('set_display_name_fullscreen', displayName);
            dispatch((0, $6Jwum.updateUser)(updatedUser));
            setTimeout(()=>navigate((0, $2QyQO.homePath)), 500);
        } catch (error) {
            setErrorCode(error.message ?? 'UNKNOWN_ERROR');
            console.error('Could not update display name', error);
            setIsSendingData(false);
        }
    }
    return /*#__PURE__*/ (0, $9h2J6.jsxs)((0, $5aad52fabd29c6cf$export$2e2bcd8739ae039), {
        canScroll: true,
        isVisible: true,
        modalClassname: $a2e351ff115d2f57$export$4adafe2b4f22b75f,
        shouldCloseOnExternalClick: false,
        zIndex: 1000,
        hasCloseButton: false,
        children: [
            /*#__PURE__*/ (0, $9h2J6.jsx)("img", {
                className: $a2e351ff115d2f57$export$db3c28d99448dcff,
                alt: "Those Beyond Logo",
                src: "/assets/global/those-beyond-icon.svg"
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)("h2", {
                children: "Choose your display name"
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)("label", {
                htmlFor: "arise-set-display-name",
                children: "Display Name"
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)((0, $97de157f1d7f5149$export$2e2bcd8739ae039), {
                className: $a2e351ff115d2f57$export$b7e3ae3d7c15e42e,
                id: "arise-set-display-name",
                value: displayName,
                onChange: (e)=>setDisplayName(e.target.value)
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)("p", {
                children: "This is how others see you in the chat."
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)("br", {}),
            /*#__PURE__*/ (0, $9h2J6.jsx)((0, $e94781751f5e34af$export$c43bfb5198aa7b21), {
                disabled: !displayName || isSendingData || !currentUserProfile || !(0, $9a318c0adac33f72$export$13abd87bc9b14090)(displayName),
                text: "Continue",
                onClick: onSubmit,
                style: {
                    marginTop: 20
                }
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)("p", {
                className: $a2e351ff115d2f57$export$493b5823483d2c4e,
                children: $305f209161d05cae$var$getEditProfileErrorMessage(errorCode)
            })
        ]
    });
}
function $305f209161d05cae$var$getEditProfileErrorMessage(errorCode) {
    if (!errorCode) return '';
    switch(errorCode){
        case 'DISPLAYNAME_INVALID':
            return 0, $9a318c0adac33f72$export$45024f2ca55f9de6;
        case 'DISPLAYNAME_VIOLATES_POLICY':
            return 'Your display name contains inappropriate content.';
        default:
            return `Could not set your display name, please try again or contact ${0, $2QyQO.SUPPORT_EMAIL}`;
    }
}


function $86431114d96a35fc$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $9h2J6.jsx)((0, $305f209161d05cae$export$2e2bcd8739ae039), {});
}



var $9h2J6 = parcelRequire("9h2J6");

var $7v5wN = parcelRequire("7v5wN");

var $i2KZ1 = parcelRequire("i2KZ1");

var $9h2J6 = parcelRequire("9h2J6");


var $i2KZ1 = parcelRequire("i2KZ1");

var $hfW7f = parcelRequire("hfW7f");

var $lmedS = parcelRequire("lmedS");
const $7870ac54519e2be3$var$defaultAudio = [
    {
        id: 'gust-open',
        src: '/assets/global/audio/ui/[SCENE-Gust-01].mp3',
        volume: 0.05
    },
    {
        id: 'gust-close',
        src: '/assets/global/audio/ui/[SCENE-Gust-02].mp3',
        volume: 0.05
    },
    {
        id: 'positive-achievement',
        src: '/assets/global/audio/ui/[UI-Positive-Achievement-01].mp3',
        volume: 0.5
    },
    {
        id: 'negative-achievement',
        src: '/assets/global/audio/ui/[UI-Negative-Achievement-01].mp3',
        volume: 0.5
    }
];
const $7870ac54519e2be3$var$customAudio = {
    [(0, $hfW7f.ThemeIds).Titan]: [
        ...$7870ac54519e2be3$var$defaultAudio,
        {
            id: 'event__start',
            src: '/assets/themes/titan/audio/events/[EVENT-Start].mp3',
            volume: 0.4
        },
        {
            id: 'event__success',
            src: '/assets/themes/titan/audio/events/[EVENT-Success].mp3',
            volume: 0.4
        },
        {
            id: 'event__fail',
            src: '/assets/themes/titan/audio/events/[EVENT-Fail].mp3',
            volume: 0.4
        },
        {
            id: 'event__countdown',
            src: '/assets/themes/titan/audio/events/[EVENT-Countdown-3s].mp3',
            volume: 0.4
        },
        {
            id: 'faction-selector-bg',
            src: '/assets/themes/titan/audio/music/[MUSIC-STEM-01].mp3',
            ambient: true,
            volume: 0.5
        },
        {
            id: 'drone-bg',
            src: '/assets/themes/titan/audio/ui/[SCENE-DroneDark-01].mp3',
            ambient: true,
            volume: 0.5
        }
    ],
    [(0, $hfW7f.ThemeIds).Hyperion]: [
        ...$7870ac54519e2be3$var$defaultAudio,
        {
            id: 'event__start',
            src: '/assets/themes/hyperion/audio/events/[EVENT-Start].mp3',
            volume: 0.4
        },
        {
            id: 'event__success',
            src: '/assets/themes/hyperion/audio/events/[EVENT-Success].mp3',
            volume: 0.4
        },
        {
            id: 'event__fail',
            src: '/assets/themes/hyperion/audio/events/[EVENT-Fail].mp3',
            volume: 0.4
        },
        {
            id: 'event__countdown',
            src: '/assets/themes/hyperion/audio/events/[EVENT-Countdown-3s].mp3',
            volume: 0.4
        }
    ],
    [(0, $hfW7f.ThemeIds).Deimos]: []
};
function $7870ac54519e2be3$export$2e2bcd8739ae039(themeId) {
    return $7870ac54519e2be3$var$customAudio[themeId] ? (0, $lmedS.parsePayloadURLS)($7870ac54519e2be3$var$customAudio[themeId]) : (0, $lmedS.parsePayloadURLS)($7870ac54519e2be3$var$defaultAudio);
}


const $d6e190b79dfaa4d3$export$93d4e7f90805808f = ()=>{
    const theme = (0, $i2KZ1.useAppSelector)((state)=>state.app.theme);
    return theme;
};
function $d6e190b79dfaa4d3$export$82270779c4a788ac() {
    const theme = $d6e190b79dfaa4d3$export$93d4e7f90805808f();
    (0, $f58c71b201a1c7d8$export$91047320af7bf70b)((0, $7870ac54519e2be3$export$2e2bcd8739ae039)(theme.themeId));
    return /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9h2J6.Fragment), {});
}



var $9h2J6 = parcelRequire("9h2J6");

var $7RNO0 = parcelRequire("7RNO0");

var $kFQy0 = parcelRequire("kFQy0");

var $7v5wN = parcelRequire("7v5wN");
function $138b494650f40c68$export$2e2bcd8739ae039() {
    const theme = (0, $7v5wN.useTheme)();
    function initAnalytics() {
        (0, $kFQy0.init)(undefined);
    }
    (0, $7RNO0.useEffect)(()=>{
        try {
            window['ariseInitAnalytics'] = initAnalytics;
            initAnalytics();
            // Listen for analytics consent changes
            window['cbsoptanon']?.ot?.addOnConsentChangedHandler(initAnalytics);
        } catch  {}
    }, [
        theme
    ]);
    return /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9h2J6.Fragment), {});
}



var $9h2J6 = parcelRequire("9h2J6");

var $hfW7f = parcelRequire("hfW7f");

var $7RNO0 = parcelRequire("7RNO0");
const $663d587c2dd244f2$var$fonts = {
    [(0, $hfW7f.ThemeIds).Titan]: [
        {
            family: 'Inter',
            source: `url('/assets/themes/titan/typography/inter/Inter-Regular.ttf') format('truetype')`,
            descriptors: {
                weight: '400',
                style: 'normal'
            }
        },
        {
            family: 'Inter',
            source: `url('/assets/themes/titan/typography/inter/Inter-SemiBold.ttf') format('truetype')`,
            descriptors: {
                weight: '500',
                style: 'normal'
            }
        },
        {
            family: 'Inter',
            source: `url('/assets/themes/titan/typography/inter/Inter-Bold.ttf') format('truetype')`,
            descriptors: {
                weight: 'bold',
                style: 'normal'
            }
        },
        {
            family: 'CheapSignage',
            source: `url('/assets/themes/titan/typography/cheapSignage/CheapSignage-Standard.ttf')`,
            descriptors: {
                weight: '400',
                style: 'normal'
            }
        },
        {
            family: 'Alexandria',
            source: `url('/assets/themes/titan/typography/alexandria/Alexandria-Regular.ttf') format('truetype')`,
            descriptors: {
                weight: '300',
                style: 'normal'
            }
        },
        {
            family: 'Alexandria',
            source: `url('/assets/themes/titan/typography/alexandria/Alexandria-Medium.ttf') format('truetype')`,
            descriptors: {
                weight: '400',
                style: 'normal'
            }
        },
        {
            family: 'Alexandria',
            source: `url('/assets/themes/titan/typography/alexandria/Alexandria-Bold.ttf') format('truetype')`,
            descriptors: {
                weight: 'bold',
                style: 'normal'
            }
        },
        {
            family: 'Oswald',
            source: `url('/assets/themes/titan/typography/oswald/Oswald-Medium.ttf') format('truetype')`,
            descriptors: {
                weight: '500',
                style: 'normal'
            }
        },
        {
            family: 'Oswald',
            source: `url('/assets/themes/titan/typography/oswald/Oswald-SemiBold.ttf') format('truetype')`,
            descriptors: {
                weight: '600',
                style: 'normal'
            }
        }
    ],
    [(0, $hfW7f.ThemeIds).Hyperion]: [
        {
            family: 'HomePlanetBB',
            source: `url('/assets/themes/hyperion/typography/HomePlanetBB/HomePlanetBB-Bold.otf') format('opentype')`,
            descriptors: {
                weight: '500',
                style: 'normal'
            }
        }
    ]
};
const $663d587c2dd244f2$var$globalFonts = [
    {
        family: 'ChakraPetchTitle',
        source: `url('/assets/global/typography/chakraPetch/ChakraPetch-Bold.ttf') format('truetype')`,
        descriptors: {
            weight: 'bold',
            style: 'normal'
        }
    },
    {
        family: 'ChakraPetch',
        source: `url('/assets/global/typography/chakraPetch/ChakraPetch-Light.ttf') format('truetype')`,
        descriptors: {
            weight: '300',
            style: 'normal'
        }
    },
    {
        family: 'ChakraPetch',
        source: `url('/assets/global/typography/chakraPetch/ChakraPetch-Regular.ttf') format('truetype')`,
        descriptors: {
            weight: 'normal',
            style: 'normal'
        }
    },
    {
        family: 'ChakraPetch',
        source: `url('/assets/global/typography/chakraPetch/ChakraPetch-Bold.ttf') format('truetype')`,
        descriptors: {
            weight: '500',
            style: 'normal'
        }
    },
    {
        family: 'Inter',
        source: `url('/assets/global/typography/inter/Inter-Regular.ttf') format('truetype')`,
        descriptors: {
            weight: '400',
            style: 'normal'
        }
    },
    {
        family: 'Inter',
        source: `url('/assets/global/typography/inter/Inter-SemiBold.ttf') format('truetype')`,
        descriptors: {
            weight: '500',
            style: 'normal'
        }
    },
    {
        family: 'Inter',
        source: `url('/assets/global/typography/inter/Inter-Bold.ttf') format('truetype')`,
        descriptors: {
            weight: 'bold',
            style: 'normal'
        }
    }
];
function $663d587c2dd244f2$export$2e2bcd8739ae039() {
    const [ready, setReady] = (0, $7RNO0.useState)(false);
    (0, $7RNO0.useEffect)(()=>{
        const fontlist = [
            ...$663d587c2dd244f2$var$fonts["skyhook"] || [],
            ...$663d587c2dd244f2$var$globalFonts
        ];
        if (!fontlist) {
            console.error('No fonts found for instance');
            setReady(true);
            return;
        }
        const fontPromises = fontlist.map((font)=>{
            return new Promise((resolve)=>{
                const newFont = new FontFace(font.family, font.source, font.descriptors);
                newFont.load().then((loadedFont)=>{
                    document.fonts.add(loadedFont);
                    resolve();
                }).catch((error)=>{
                    console.error('Failed to load font', error);
                    resolve();
                });
            });
        });
        Promise.all(fontPromises).then(()=>{
            setReady(true);
        });
    }, []);
    return {
        ready: ready
    };
}



var $9HMNu = parcelRequire("9HMNu");

var $i2KZ1 = parcelRequire("i2KZ1");

var $7v5wN = parcelRequire("7v5wN");

var $7RNO0 = parcelRequire("7RNO0");
function $6fd621eb7e86818d$export$2e2bcd8739ae039() {
    const [themeLoaded, setThemeLoaded] = (0, $7RNO0.useState)(false);
    const [imagesLoaded, setImagesLoaded] = (0, $7RNO0.useState)(false);
    const [imageProgress, setImageProgress] = (0, $7RNO0.useState)({
        loaded: 0,
        total: 0
    });
    const [error, setError] = (0, $7RNO0.useState)(false);
    const theme = (0, $7v5wN.useTheme)();
    const hasInitiatedLoad = (0, $7RNO0.useRef)(false);
    const dispatch = (0, $i2KZ1.useAppDispatch)();
    const isInstanceLoading = (0, $i2KZ1.useAppSelector)((state)=>state.app.isInstanceLoading);
    const instanceLoaded = (0, $i2KZ1.useAppSelector)((state)=>state.app.instanceLoaded);
    async function loadImages(theme) {
        // const images = [
        //     theme.files.logo,
        //     // theme.files.splash_bg,
        //     theme.files.inventory_backdrop,
        //     theme.files.instance_mark,
        // ];
        const images = [];
        setImageProgress({
            loaded: 0,
            total: images.length
        });
        await Promise.all(images.map(async (url)=>{
            try {
                await $6fd621eb7e86818d$var$loadImage(url);
            } catch (error) {
                setError(true);
            }
            setImageProgress((prev)=>({
                    loaded: prev.loaded + 1,
                    total: prev.total
                }));
        }));
        setImagesLoaded(true);
    }
    (0, $7RNO0.useEffect)(()=>{
        // Only initiate loading if it hasn't been started yet and isn't already in progress
        if (!hasInitiatedLoad.current && !isInstanceLoading && !instanceLoaded) {
            hasInitiatedLoad.current = true;
            const universeId = "9097f2ba-ec9e-48b1-82af-0080acd3924e";
            dispatch((0, $9HMNu.setInstanceLoadTimestamp)()); // Update timestamp before loading
            dispatch((0, $9HMNu.loadInstance)(universeId));
        }
    }, [
        dispatch,
        isInstanceLoading,
        instanceLoaded
    ]);
    (0, $7RNO0.useEffect)(()=>{
        if (theme.loaded) loadImages(theme).then(()=>{
            setThemeLoaded(true);
        });
    }, [
        theme
    ]);
    return {
        themeLoaded: themeLoaded,
        imagesLoaded: imagesLoaded,
        imageProgress: imageProgress,
        ready: themeLoaded && imagesLoaded,
        error: error
    };
}
async function $6fd621eb7e86818d$var$loadImage(url) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.onload = ()=>{
            resolve();
        };
        img.onerror = ()=>{
            // console.error('Failed to load image', url);
            reject();
        };
        img.src = url;
    });
}



var $7RNO0 = parcelRequire("7RNO0");
const $5fce49e23b2a0330$var$startTime = Date.now();
function $5fce49e23b2a0330$export$2e2bcd8739ae039({ children: children }) {
    const [ready, setReady] = (0, $7RNO0.useState)(false);
    const fonts = (0, $663d587c2dd244f2$export$2e2bcd8739ae039)();
    const { ready: themeReady, error: error } = (0, $6fd621eb7e86818d$export$2e2bcd8739ae039)();
    (0, $7RNO0.useEffect)(()=>{
        if (fonts.ready && themeReady) {
            const endTime = Date.now();
            const loadTime = endTime - $5fce49e23b2a0330$var$startTime;
            console.log(`Asset load time: ${loadTime / 1000}s`);
            setReady(true);
        }
    }, [
        fonts.ready,
        themeReady
    ]);
    // TODO: handle error state
    if (!ready) // Loading screen is inside index.html
    return /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9h2J6.Fragment), {});
    return /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9h2J6.Fragment), {
        children: children
    });
}



var $9h2J6 = parcelRequire("9h2J6");

var $7RNO0 = parcelRequire("7RNO0");

var $i2KZ1 = parcelRequire("i2KZ1");

var $6Jwum = parcelRequire("6Jwum");

var $cTs7K = parcelRequire("cTs7K");
function $1218a107e290b15a$export$2e2bcd8739ae039({ children: children }) {
    const dispatch = (0, $i2KZ1.useAppDispatch)();
    // Disable login for discord activity since discord uses it's own auth mechanism.
    const disable_login = (0, $cTs7K.IS_DISCORD_ACTIVITY);
    // Do not run if autoGuestMode is disabled or on /auth routes
    // const theme = useTheme();
    // const autoGuestModeEnabled = theme.metadata?.authConfig?.autoGuestMode || isInsidersInstance; // Insiders cannot access logged out page
    const autoGuestModeEnabled = true;
    const isOnAuthRoute = window.location.pathname.startsWith('/auth');
    const checkedDefault = isOnAuthRoute || !autoGuestModeEnabled;
    const [checked, setChecked] = (0, $7RNO0.useState)(checkedDefault);
    // If true, render content even if logged out
    const alwaysAllowContentRendering = true;
    (0, $7RNO0.useEffect)(()=>{
        if (disable_login) {
            setChecked(true);
            return;
        }
        (async ()=>{
            if (!checked) try {
                // TODO: in theory this auth gate should redirect users to the login page if required. but since we currently don't use this type of flow, we just log them in as a guest.
                await dispatch((0, $6Jwum.initialAuthFlow)());
                setChecked(true);
            } catch (e) {
                console.error(e);
                setChecked(true);
            }
            else setChecked(true);
        })();
    }, []);
    return alwaysAllowContentRendering || checked ? /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9h2J6.Fragment), {
        children: children
    }) : null;
}



var $9h2J6 = parcelRequire("9h2J6");

var $7RNO0 = parcelRequire("7RNO0");

var $6dpjF = parcelRequire("6dpjF");

var $i2KZ1 = parcelRequire("i2KZ1");

var $9HMNu = parcelRequire("9HMNu");

var $cTs7K = parcelRequire("cTs7K");

var $1afSf = parcelRequire("1afSf");

var $lmedS = parcelRequire("lmedS");
function $d22b0730c33191cb$export$5cb7ee7391b69347(point, rect) {
    return point.x >= rect.left && point.x <= rect.right && point.y >= rect.top && point.y <= rect.bottom;
}
async function $d22b0730c33191cb$export$2cdf1b96a9f86d16(text) {
    try {
        await navigator.clipboard.writeText(text);
        return true;
    } catch  {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        // eslint-disable-next-line deprecation/deprecation
        const success = document.execCommand('copy');
        document.body.removeChild(textarea);
        if (!success) console.log('[Arise] copyToClipboard: execCommand failed');
        return success;
    }
}
function $d22b0730c33191cb$export$56831a8b9cb27763(error) {
    try {
        return String(error);
    } catch  {
        return 'Unknown error';
    }
}



var $kFQy0 = parcelRequire("kFQy0");



var $9S5u4 = parcelRequire("9S5u4");
var $78c726a9dc932a94$export$1ed83bfb2697df6c;
var $78c726a9dc932a94$export$2c5ed8abe9930549;
var $78c726a9dc932a94$export$1ab3e7a36d9ff4ba;
var $78c726a9dc932a94$export$83a0a36fb07d6071;
var $78c726a9dc932a94$export$b261bd0f43566856;
var $78c726a9dc932a94$export$a7db06668cad9adb;
var $78c726a9dc932a94$export$82c3bb3cf4f0e46;
var $78c726a9dc932a94$export$9624302a33c1c6cb;
var $78c726a9dc932a94$export$d9665997544fb782;
var $78c726a9dc932a94$export$6d59db4903f20f7d;
var $78c726a9dc932a94$export$e3438235005104d6;
var $78c726a9dc932a94$export$96e4b36520c26a2c;
var $78c726a9dc932a94$export$4f081f07c0fd24b0;
var $78c726a9dc932a94$export$fb01f828cfd8f622;
var $78c726a9dc932a94$export$57841ddfb90e6e95;
var $78c726a9dc932a94$export$c663339d28b2854c;
var $78c726a9dc932a94$export$9a98d57f9f523c8d;
var $78c726a9dc932a94$export$5c2acd9dffc4cdb4;
var $78c726a9dc932a94$export$4702583d761c86f2;
var $78c726a9dc932a94$export$462aa410b3854ccd;
var $78c726a9dc932a94$export$913d32bdc6c52fd7;
var $78c726a9dc932a94$export$e0e0794250e9118f;
var $78c726a9dc932a94$export$fb184b623420d9be;
$78c726a9dc932a94$export$1ed83bfb2697df6c = `NtbGiG_RedeemRewardModal`;
$78c726a9dc932a94$export$2c5ed8abe9930549 = `NtbGiG_barcodeContainer`;
$78c726a9dc932a94$export$1ab3e7a36d9ff4ba = `NtbGiG_barcodeImage`;
$78c726a9dc932a94$export$83a0a36fb07d6071 = `NtbGiG_codeRow`;
$78c726a9dc932a94$export$b261bd0f43566856 = `NtbGiG_codeValue`;
$78c726a9dc932a94$export$a7db06668cad9adb = `NtbGiG_content`;
$78c726a9dc932a94$export$82c3bb3cf4f0e46 = `NtbGiG_copyButton`;
$78c726a9dc932a94$export$9624302a33c1c6cb = `NtbGiG_ctaButton`;
$78c726a9dc932a94$export$d9665997544fb782 = `NtbGiG_ctaContainer`;
$78c726a9dc932a94$export$6d59db4903f20f7d = `NtbGiG_description`;
$78c726a9dc932a94$export$e3438235005104d6 = `NtbGiG_longCode`;
$78c726a9dc932a94$export$96e4b36520c26a2c = `NtbGiG_modal`;
$78c726a9dc932a94$export$4f081f07c0fd24b0 = `NtbGiG_modalTitle`;
$78c726a9dc932a94$export$fb01f828cfd8f622 = `NtbGiG_qrContainer`;
$78c726a9dc932a94$export$57841ddfb90e6e95 = `NtbGiG_qrImage`;
$78c726a9dc932a94$export$c663339d28b2854c = `NtbGiG_readMoreLink`;
$78c726a9dc932a94$export$9a98d57f9f523c8d = `NtbGiG_readMoreText`;
$78c726a9dc932a94$export$5c2acd9dffc4cdb4 = `NtbGiG_redemptionInstructions`;
$78c726a9dc932a94$export$4702583d761c86f2 = `NtbGiG_rewardContainer`;
$78c726a9dc932a94$export$462aa410b3854ccd = `NtbGiG_rewardImage`;
$78c726a9dc932a94$export$913d32bdc6c52fd7 = `NtbGiG_rewardImageContainer`;
$78c726a9dc932a94$export$e0e0794250e9118f = `NtbGiG_textContent`;
$78c726a9dc932a94$export$fb184b623420d9be = `NtbGiG_title`;


const $358ef4eaec781d83$export$1ed83bfb2697df6c = ()=>{
    const dispatch = (0, $i2KZ1.useAppDispatch)();
    const currentlyViewingReward = (0, $i2KZ1.useAppSelector)((state)=>state.app.currentlyViewingReward);
    const [isVisible, setIsVisible] = (0, $7RNO0.useState)(false);
    const [copied, setCopied] = (0, $7RNO0.useState)(false);
    const rewardRef = (0, $7RNO0.useRef)(null);
    if (currentlyViewingReward) rewardRef.current = currentlyViewingReward;
    const reward = rewardRef.current;
    (0, $7RNO0.useEffect)(()=>{
        if (currentlyViewingReward) {
            setCopied(false);
            (0, $kFQy0.sendEventV2)('reward__modal_opened', [
                currentlyViewingReward.name
            ]);
            requestAnimationFrame(()=>setIsVisible(true));
        }
    }, [
        currentlyViewingReward?.id
    ]);
    if (!reward) return;
    const closeModal = ()=>{
        (0, $kFQy0.sendEventV2)('reward__modal_closed', [
            reward.name
        ]);
        setIsVisible(false);
        dispatch((0, $9HMNu.setCurrentlyViewingReward)(null));
    };
    const copyCode = async (code)=>{
        const success = await (0, $d22b0730c33191cb$export$2cdf1b96a9f86d16)(code);
        if (success) {
            setCopied(true);
            setTimeout(()=>setCopied(false), 2000);
            (0, $kFQy0.sendEventV2)('reward__modal_code_copied', [
                reward.name
            ]);
        }
    };
    const handleCta = async ()=>{
        if (reward.ctaMethod === 'open_link') {
            (0, $kFQy0.sendEventV2)('reward__modal_cta_clicked', [
                reward.name,
                reward.ctaMethod,
                reward.externalUrl
            ]);
            if (0, $cTs7K.IS_DISCORD_ACTIVITY) (0, $1afSf.openExternalLinkDiscord)(reward.externalUrl);
            else window.open(reward.externalUrl, '_blank', 'noopener,noreferrer');
        } else if (reward.ctaMethod === 'send_dm') {
            (0, $kFQy0.sendEventV2)('reward__modal_cta_clicked', [
                reward.name,
                reward.ctaMethod,
                reward.messageText
            ]);
            if (0, $cTs7K.IS_DISCORD_ACTIVITY) await (0, $1afSf.triggerDiscordShare)(reward.messageText);
            else dispatch((0, $9HMNu.setStartShare)({
                message: reward.messageText
            }));
        }
    };
    const renderReward = ()=>{
        if (reward.redemptionType === 'code' && reward.redemptionValue) return /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
            className: $78c726a9dc932a94$export$83a0a36fb07d6071,
            children: [
                /*#__PURE__*/ (0, $9h2J6.jsx)("span", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($78c726a9dc932a94$export$b261bd0f43566856, {
                        [$78c726a9dc932a94$export$e3438235005104d6]: reward.redemptionValue?.length > 12
                    }),
                    children: reward.redemptionValue
                }),
                /*#__PURE__*/ (0, $9h2J6.jsxs)("button", {
                    className: $78c726a9dc932a94$export$82c3bb3cf4f0e46,
                    onClick: ()=>copyCode(reward.redemptionValue),
                    children: [
                        copied ? 'Copied!' : 'Copy',
                        /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9S5u4.default), {
                            type: "copy",
                            size: 16
                        })
                    ]
                })
            ]
        });
        if (reward.redemptionType === 'qr_code' && reward.redemptionImagePath) return /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
            className: $78c726a9dc932a94$export$fb01f828cfd8f622,
            children: /*#__PURE__*/ (0, $9h2J6.jsx)("img", {
                className: $78c726a9dc932a94$export$57841ddfb90e6e95,
                src: (0, $lmedS.pathToURL)(reward.redemptionImagePath),
                alt: "QR Code"
            })
        });
        if (reward.redemptionType === 'barcode' && reward.redemptionImagePath) return /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
            className: $78c726a9dc932a94$export$2c5ed8abe9930549,
            children: /*#__PURE__*/ (0, $9h2J6.jsx)("img", {
                className: $78c726a9dc932a94$export$1ab3e7a36d9ff4ba,
                src: (0, $lmedS.pathToURL)(reward.redemptionImagePath),
                alt: "Barcode"
            })
        });
        return null;
    };
    return /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
        className: $78c726a9dc932a94$export$1ed83bfb2697df6c,
        children: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $5aad52fabd29c6cf$export$2e2bcd8739ae039), {
            isVisible: isVisible,
            onClose: closeModal,
            hasCloseButton: true,
            canScroll: true,
            shouldCloseOnExternalClick: false,
            leaveSpaceAboveAndBelow: false,
            modalClassname: $78c726a9dc932a94$export$96e4b36520c26a2c,
            contentClassname: $78c726a9dc932a94$export$a7db06668cad9adb,
            zIndex: 150,
            children: /*#__PURE__*/ (0, $9h2J6.jsxs)((0, $9h2J6.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $9h2J6.jsx)("h2", {
                        className: $78c726a9dc932a94$export$4f081f07c0fd24b0,
                        children: reward.modalTitle
                    }),
                    reward.mainImagePath && /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                        className: $78c726a9dc932a94$export$913d32bdc6c52fd7,
                        children: /*#__PURE__*/ (0, $9h2J6.jsx)("img", {
                            className: $78c726a9dc932a94$export$462aa410b3854ccd,
                            src: (0, $lmedS.pathToURL)(reward.mainImagePath),
                            alt: reward.name
                        })
                    }),
                    /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                        className: $78c726a9dc932a94$export$e0e0794250e9118f,
                        children: [
                            /*#__PURE__*/ (0, $9h2J6.jsx)("h3", {
                                className: $78c726a9dc932a94$export$fb184b623420d9be,
                                children: reward.name
                            }),
                            reward.description && /*#__PURE__*/ (0, $9h2J6.jsx)("p", {
                                className: $78c726a9dc932a94$export$6d59db4903f20f7d,
                                children: reward.description
                            }),
                            reward.redemptionInstructions && /*#__PURE__*/ (0, $9h2J6.jsx)("p", {
                                className: $78c726a9dc932a94$export$5c2acd9dffc4cdb4,
                                children: reward.redemptionInstructions
                            }),
                            reward.readMoreUrl ? /*#__PURE__*/ (0, $9h2J6.jsx)("a", {
                                className: $78c726a9dc932a94$export$c663339d28b2854c,
                                href: reward.readMoreUrl,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                onClick: ()=>{
                                    (0, $kFQy0.sendEventV2)('reward__modal_read_more_clicked', [
                                        reward.name,
                                        reward.readMoreUrl
                                    ]);
                                    if (0, $cTs7K.IS_DISCORD_ACTIVITY) (0, $1afSf.openExternalLinkDiscord)(reward.readMoreUrl);
                                },
                                children: reward.readMoreText ?? reward.readMoreUrl
                            }) : reward.readMoreText ? /*#__PURE__*/ (0, $9h2J6.jsx)("span", {
                                className: $78c726a9dc932a94$export$9a98d57f9f523c8d,
                                children: reward.readMoreText
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                        className: $78c726a9dc932a94$export$4702583d761c86f2,
                        children: renderReward()
                    }),
                    reward.ctaText && /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                        className: $78c726a9dc932a94$export$d9665997544fb782,
                        children: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $bc232447c96f1a4a$export$2e2bcd8739ae039), {
                            className: $78c726a9dc932a94$export$9624302a33c1c6cb,
                            onClick: handleCta,
                            children: reward.ctaText
                        })
                    })
                ]
            })
        })
    });
};
var $358ef4eaec781d83$export$2e2bcd8739ae039 /* Example
{
    "id": "c0ffee00-1a2b-4c3d-9e8f-001122334455",
    "createdAt": "2026-05-18T08:16:50.693Z",
    "universeId": "97cab966-aa05-4e90-8b0b-f1448c318de5",
    "modalTitle": "Congrats!",
    "name": "Example Reward",
    "description": "A short description of the reward.",
    "mainImagePath": "rewards/example-main.png",
    "secondaryImagePath": "rewards/example-thumb.png",
    "redemptionInstructions": "Show this screen at the till before paying.",
    "sfxUrl": "",
    "externalUrl": "https://example.com/redeem",
    "ctaText": "Claim reward",
    "ctaMethod": "open_link",
    "readMoreUrl": "https://example.com/terms",
    "readMoreText": "Read terms",
    "isFiniteSupply": true,
    "oneCodeForAll": false,
    "messageText": "Here is your reward code: ABC123",
    "redemptionType": "code",
    "redemptionValue": "ABC123",
    "redemptionImagePath": ""
}
*/  = $358ef4eaec781d83$export$1ed83bfb2697df6c;



var $9h2J6 = parcelRequire("9h2J6");

var $7RNO0 = parcelRequire("7RNO0");

var $i2KZ1 = parcelRequire("i2KZ1");

var $9HMNu = parcelRequire("9HMNu");


var $7v5wN = parcelRequire("7v5wN");

var $9K8Jg = parcelRequire("9K8Jg");

var $2zDIY = parcelRequire("2zDIY");
/**
 * Stores per-video progress in localStorage as:
 * {
 *   "dQw4w9WgXcQ": { "progress": 42, "completed": false },
 *   "9bZkp7q19f0": { "progress": 0, "completed": true }
 * }
 *
 * `progress` is in seconds.
 */ const $e30dfa0f8f3999e3$export$14bdfb192272be33 = 'ARISE_VIDEO_PROGRESS';
function $e30dfa0f8f3999e3$export$e20713ec10f02e66(videoId, seconds) {
    try {
        if (!videoId || seconds < 0) return;
        const map = $e30dfa0f8f3999e3$var$getLSMap();
        // No need to save progress if completed
        if (map[videoId]?.completed === true) return;
        map[videoId] = {
            progress: seconds,
            completed: false
        };
        localStorage.setItem($e30dfa0f8f3999e3$export$14bdfb192272be33, JSON.stringify(map));
    } catch (error) {
        console.log('Warning: Could not save local video progress', error);
    }
}
function $e30dfa0f8f3999e3$export$f56a20f73da3ee39(videoId) {
    try {
        if (!videoId) return;
        const map = $e30dfa0f8f3999e3$var$getLSMap();
        map[videoId] = {
            progress: 0,
            completed: true
        };
        localStorage.setItem($e30dfa0f8f3999e3$export$14bdfb192272be33, JSON.stringify(map));
    } catch (error) {
        console.log('Warning: Could not mark video as completed', error);
    }
}
function $e30dfa0f8f3999e3$export$34250dbee1b3714(videoId) {
    try {
        const map = $e30dfa0f8f3999e3$var$getLSMap();
        const entry = map[videoId];
        if (typeof entry?.progress === 'number' && typeof entry?.completed === 'boolean') return entry;
        return {
            progress: 0,
            completed: false
        };
    } catch (error) {
        console.log('Warning: Could not get local video progress, defaulting to 0', error);
        return {
            progress: 0,
            completed: false
        };
    }
}
function $e30dfa0f8f3999e3$var$getLSMap() {
    const raw = localStorage.getItem($e30dfa0f8f3999e3$export$14bdfb192272be33);
    return raw ? JSON.parse(raw) : {};
}
function $e30dfa0f8f3999e3$export$14c90d4be2a904a9() {
    localStorage.removeItem($e30dfa0f8f3999e3$export$14bdfb192272be33);
}



var $b3Ivu = parcelRequire("b3Ivu");

var $hUeP2 = parcelRequire("hUeP2");

var $9h2J6 = parcelRequire("9h2J6");

var $7RNO0 = parcelRequire("7RNO0");

var $guTIo = parcelRequire("guTIo");

var $i2KZ1 = parcelRequire("i2KZ1");

var $9HMNu = parcelRequire("9HMNu");
function $0e36dcd0169f6759$export$2e2bcd8739ae039() {
    const dispatch = (0, $i2KZ1.useAppDispatch)();
    const { langs: langs, setLang: setLang } = (0, $guTIo.useLang)();
    const [isCycling, setIsCycling] = (0, $7RNO0.useState)(false);
    const [isPlusEnabled, setIsPlusEnabled] = (0, $7RNO0.useState)(false);
    const intervalRef = (0, $7RNO0.useRef)(null);
    const indexRef = (0, $7RNO0.useRef)(0);
    const manualIndexRef = (0, $7RNO0.useRef)(0);
    const handleStop = ()=>{
        if (intervalRef.current) clearInterval(intervalRef.current);
        setIsCycling(false);
    };
    const handleStart = (seconds)=>{
        if (!langs.length) return;
        handleStop();
        indexRef.current = 0;
        setIsCycling(true);
        dispatch((0, $9HMNu.toggleDebugMenu)());
        intervalRef.current = setInterval(()=>{
            const lang = langs[indexRef.current];
            console.log(`[LanguageCycler] Setting language: ${lang.langISO} (${lang.displayName})`);
            setLang(lang.langISO);
            indexRef.current++;
            if (indexRef.current >= langs.length) {
                console.log('[LanguageCycler] Finished cycling through all languages');
                handleStop();
            }
        }, seconds * 1000);
    };
    const langsRef = (0, $7RNO0.useRef)(langs);
    (0, $7RNO0.useEffect)(()=>{
        langsRef.current = langs;
    }, [
        langs
    ]);
    const setLangRef = (0, $7RNO0.useRef)(setLang);
    (0, $7RNO0.useEffect)(()=>{
        setLangRef.current = setLang;
    }, [
        setLang
    ]);
    (0, $7RNO0.useEffect)(()=>{
        if (!isPlusEnabled) return;
        const handleKeyDown = (e)=>{
            if (e.key !== '+' && e.key !== '-') return;
            if (!langsRef.current.length) return;
            if (e.key === '+') manualIndexRef.current++;
            if (e.key === '-') manualIndexRef.current--;
            const index = (manualIndexRef.current % langsRef.current.length + langsRef.current.length) % langsRef.current.length;
            const lang = langsRef.current[index];
            console.log(`[LanguageCycler] Manual: ${lang.langISO} (${lang.displayName})`);
            setLangRef.current(lang.langISO);
        };
        window.addEventListener('keydown', handleKeyDown);
        return ()=>window.removeEventListener('keydown', handleKeyDown);
    }, [
        isPlusEnabled
    ]);
    return /*#__PURE__*/ (0, $9h2J6.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0, $9h2J6.jsx)("h3", {
                children: "Auto cycle languages"
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)("button", {
                onClick: ()=>handleStart(1),
                disabled: !langs.length,
                children: "1s"
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)("button", {
                onClick: ()=>handleStart(5),
                disabled: !langs.length,
                children: "5s"
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)("button", {
                onClick: ()=>handleStart(10),
                disabled: !langs.length,
                children: "10s"
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)("button", {
                onClick: ()=>handleStart(30),
                disabled: !langs.length,
                children: "30s"
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)("button", {
                onClick: handleStop,
                disabled: !isCycling,
                children: "Stop"
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                children: /*#__PURE__*/ (0, $9h2J6.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, $9h2J6.jsx)("input", {
                            type: "checkbox",
                            checked: isPlusEnabled,
                            onChange: (e)=>{
                                manualIndexRef.current = 0;
                                setIsPlusEnabled(e.target.checked);
                            }
                        }),
                        ' ',
                        "+/- keys step through languages"
                    ]
                })
            })
        ]
    });
}


var $38abaea8c7a03681$export$bb1d7b1055124ded;
var $38abaea8c7a03681$export$493b5823483d2c4e;
var $38abaea8c7a03681$export$d2297815c52203ee;
$38abaea8c7a03681$export$bb1d7b1055124ded = `rNEqRG_AriseDebugMenu`;
$38abaea8c7a03681$export$493b5823483d2c4e = `rNEqRG_errorMessage`;
$38abaea8c7a03681$export$d2297815c52203ee = `rNEqRG_formGroup`;


function $c692c7afb508f389$export$2e2bcd8739ae039() {
    const dispatch = (0, $i2KZ1.useAppDispatch)();
    const isDebugMenuOpen = (0, $i2KZ1.useAppSelector)((state)=>state.app.isDebugMenuOpen);
    const currentUserProfileV2 = (0, $i2KZ1.useAppSelector)((state)=>state.profile.currentUserProfileV2);
    const location = (0, $i2KZ1.useAppSelector)((state)=>state.app.location);
    const theme = (0, $7v5wN.useTheme)();
    const [error, setError] = (0, $7RNO0.useState)();
    const enableHiddenDebugMenuAccess = theme.metadata?.customJSON?.informationDrawer?.enableHiddenDebugMenuAccess;
    (0, $7RNO0.useEffect)(()=>{
        if (!enableHiddenDebugMenuAccess) return;
        window.__tbdb = ()=>dispatch((0, $9HMNu.toggleDebugMenu)());
        return ()=>{
            delete window.__tbdb;
        };
    }, [
        enableHiddenDebugMenuAccess,
        dispatch
    ]);
    const [iframeEventName, setIframeEventName] = (0, $7RNO0.useState)('');
    const [iframeEventPayload, setIframeEventPayload] = (0, $7RNO0.useState)('');
    const handleSimulateIframeEvent = ()=>{
        setError(null);
        try {
            // Parse payload if it's JSON, otherwise use as string
            let parsedPayload = iframeEventPayload;
            try {
                parsedPayload = JSON.parse(iframeEventPayload);
            } catch  {
            // Keep as string if not valid JSON
            }
            console.log('Simulating iFrame message event:', {
                type: iframeEventName,
                payload: parsedPayload
            });
            // Simulate a message event from an iframe (handled by AriseBridgeHost)
            const messageEvent = new MessageEvent('message', {
                data: {
                    type: iframeEventName,
                    payload: parsedPayload
                },
                origin: window.location.origin
            });
            window.dispatchEvent(messageEvent);
            console.log(`MessageEvent "${iframeEventName}" dispatched with payload:`, parsedPayload);
        } catch (err) {
            setError('Failed to simulate event: ' + (err instanceof Error ? err.message : String(err)));
        }
    };
    const handleSimulateIframeEventAfterDelay = ()=>{
        dispatch((0, $9HMNu.toggleDebugMenu)());
        setTimeout(()=>{
            handleSimulateIframeEvent();
        }, 2000);
    };
    const handleClearLocalProfile = ()=>{
        setError(null);
        try {
            (0, $2zDIY.clearProfileV2FromLocalStorage)();
        } catch (err) {
            setError('Failed to clear local profile');
        }
    };
    const handleClearRemoteProfile = async ()=>{
        setError(null);
        try {
            await Promise.all([
                $9K8Jg.resetProfileBadges(),
                $9K8Jg.resetProfileTitles(),
                $9K8Jg.resetProfileMissionCompleted()
            ]);
        } catch (err) {
            setError('Failed to clear remote profile');
        }
    };
    const handleClearProfile = async ()=>{
        setError(null);
        try {
            (0, $2zDIY.clearProfileV2FromLocalStorage)();
            await Promise.all([
                $9K8Jg.resetProfileBadges(),
                $9K8Jg.resetProfileTitles(),
                $9K8Jg.resetProfileMissionCompleted()
            ]);
        } catch (err) {
            setError('Failed to clear profile');
        }
    };
    const handleClearLocalVideoData = async ()=>{
        setError(null);
        try {
            (0, $e30dfa0f8f3999e3$export$14c90d4be2a904a9)();
        } catch (err) {
            setError('Failed to clear local video data');
        }
    };
    const handleClearSavedLang = ()=>{
        setError(null);
        try {
            (0, $b3Ivu.clearSavedLangIso)();
        } catch (err) {
            setError('Failed to clear saved language');
        }
    };
    const handleClearLocalAuthToken = ()=>{
        setError(null);
        try {
            window.localStorage.removeItem('ARISEENGINE_AUTHTOKEN');
        } catch (err) {
            setError('Failed to clear auth token');
        }
    };
    const handleClearAllLocalStorage = ()=>{
        setError(null);
        try {
            window.localStorage.clear();
        } catch (err) {
            setError('Failed to clear local storage');
        }
    };
    const getArisewareData = ()=>{
        const iframeURL = location?.iframeURL || location?.latestArisewareBuildURL;
        if (!iframeURL) return 'No Ariseware';
        try {
            const arisewareVersionDateTime = iframeURL.match(/\/(\d+)\//)[1];
            const dateVersion = new Date(parseInt(arisewareVersionDateTime)).toLocaleString();
            return `${dateVersion} (${arisewareVersionDateTime})`;
        } catch (error) {
            return iframeURL || 'No Ariseware';
        }
    };
    return /*#__PURE__*/ (0, $9h2J6.jsxs)((0, $5aad52fabd29c6cf$export$2e2bcd8739ae039), {
        title: "Debug Menu",
        isVisible: isDebugMenuOpen,
        onClose: ()=>dispatch((0, $9HMNu.toggleDebugMenu)()),
        hasCloseButton: true,
        modalClassname: $38abaea8c7a03681$export$bb1d7b1055124ded,
        zIndex: 2000,
        canScroll: true,
        leaveSpaceAboveAndBelow: false,
        shouldCloseOnExternalClick: false,
        children: [
            error && /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                className: $38abaea8c7a03681$export$493b5823483d2c4e,
                children: [
                    /*#__PURE__*/ (0, $9h2J6.jsx)("strong", {
                        children: "Error:"
                    }),
                    " ",
                    error
                ]
            }),
            /*#__PURE__*/ (0, $9h2J6.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, $9h2J6.jsx)("h3", {
                        children: "System Info"
                    }),
                    /*#__PURE__*/ (0, $9h2J6.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0, $9h2J6.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $9h2J6.jsx)("strong", {
                                        children: "Arise Frontend version: "
                                    }),
                                    (0, $hUeP2.appVersion)
                                ]
                            }),
                            /*#__PURE__*/ (0, $9h2J6.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $9h2J6.jsx)("strong", {
                                        children: "Ariseware version:"
                                    }),
                                    " ",
                                    getArisewareData()
                                ]
                            }),
                            /*#__PURE__*/ (0, $9h2J6.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $9h2J6.jsx)("strong", {
                                        children: "User ID:"
                                    }),
                                    " ",
                                    currentUserProfileV2?.userId
                                ]
                            }),
                            /*#__PURE__*/ (0, $9h2J6.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $9h2J6.jsx)("strong", {
                                        children: "Auth token:"
                                    }),
                                    " ",
                                    window.localStorage.getItem('ARISEENGINE_AUTHTOKEN') || ''
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9h2J6.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, $9h2J6.jsx)("h3", {
                        children: "Profile Actions"
                    }),
                    /*#__PURE__*/ (0, $9h2J6.jsx)("p", {
                        children: "Please reload after clearing"
                    }),
                    /*#__PURE__*/ (0, $9h2J6.jsx)("button", {
                        onClick: handleClearLocalProfile,
                        children: "Clear Local Profile"
                    }),
                    /*#__PURE__*/ (0, $9h2J6.jsx)("button", {
                        onClick: handleClearRemoteProfile,
                        children: "Clear Remote Profile"
                    }),
                    /*#__PURE__*/ (0, $9h2J6.jsx)("button", {
                        onClick: handleClearProfile,
                        children: "Clear All Profile Data"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9h2J6.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, $9h2J6.jsx)("h3", {
                        children: "Features"
                    }),
                    /*#__PURE__*/ (0, $9h2J6.jsx)("p", {
                        children: "Please reload after clearing video data"
                    }),
                    /*#__PURE__*/ (0, $9h2J6.jsx)("button", {
                        onClick: handleClearLocalVideoData,
                        children: "Clear Local Video Data"
                    }),
                    /*#__PURE__*/ (0, $9h2J6.jsx)("button", {
                        onClick: ()=>{
                            dispatch((0, $9HMNu.toggleDebugMenu)());
                            setTimeout(()=>{
                                dispatch((0, $9HMNu.setCurrentlyViewingReward)({
                                    id: '123',
                                    createdAt: '2026-05-18T08:16:50.693Z',
                                    universeId: '456',
                                    modalTitle: 'Congrats!',
                                    name: 'Prize',
                                    description: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco.',
                                    mainImagePath: 'uploads/97cab966-aa05-4e90-8b0b-f1448c318de5/16x9.webp',
                                    secondaryImagePath: 'uploads/97cab966-aa05-4e90-8b0b-f1448c318de5/16x9.webp',
                                    redemptionInstructions: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
                                    sfxUrl: null,
                                    externalUrl: 'https://thosebeyond.io',
                                    readMoreUrl: 'https://thosebeyond.io',
                                    readMoreText: 'Read more',
                                    isFiniteSupply: true,
                                    oneCodeForAll: false,
                                    messageText: "Here's your code!",
                                    redemptionType: 'code',
                                    redemptionValue: 'code-1234',
                                    ctaText: 'CTA',
                                    ctaMethod: 'open_link'
                                }));
                            }, 2000);
                        },
                        children: "View Code Reward Modal"
                    })
                ]
            }),
            false,
            /*#__PURE__*/ (0, $9h2J6.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, $9h2J6.jsx)("h3", {
                        children: "User"
                    }),
                    /*#__PURE__*/ (0, $9h2J6.jsx)("p", {
                        children: "Please reload after clearing"
                    }),
                    /*#__PURE__*/ (0, $9h2J6.jsx)("button", {
                        onClick: handleClearLocalAuthToken,
                        children: "Clear Local Auth Token"
                    }),
                    /*#__PURE__*/ (0, $9h2J6.jsx)("button", {
                        onClick: handleClearSavedLang,
                        children: "Clear Saved Language"
                    }),
                    /*#__PURE__*/ (0, $9h2J6.jsx)("button", {
                        onClick: handleClearAllLocalStorage,
                        children: "Clear All Local Storage Data"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9h2J6.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, $9h2J6.jsx)("h3", {
                        children: "Simulate event from iFrame"
                    }),
                    /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                        className: $38abaea8c7a03681$export$d2297815c52203ee,
                        children: [
                            /*#__PURE__*/ (0, $9h2J6.jsx)("label", {
                                children: "Event name:"
                            }),
                            /*#__PURE__*/ (0, $9h2J6.jsx)("input", {
                                type: "text",
                                placeholder: "e.g. open-url",
                                value: iframeEventName,
                                onChange: (e)=>setIframeEventName(e.target.value)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                        className: $38abaea8c7a03681$export$d2297815c52203ee,
                        children: [
                            /*#__PURE__*/ (0, $9h2J6.jsx)("label", {
                                children: "Payload detail (JSON or string):"
                            }),
                            /*#__PURE__*/ (0, $9h2J6.jsx)("textarea", {
                                placeholder: "e.g. https://www.google.com",
                                value: iframeEventPayload,
                                onChange: (e)=>setIframeEventPayload(e.target.value),
                                rows: 3
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9h2J6.jsx)("button", {
                        onClick: handleSimulateIframeEvent,
                        children: "Send"
                    }),
                    /*#__PURE__*/ (0, $9h2J6.jsx)("button", {
                        onClick: handleSimulateIframeEventAfterDelay,
                        children: "Close Debug, wait 5 seconds and then Send"
                    })
                ]
            })
        ]
    });
}



var $7RNO0 = parcelRequire("7RNO0");

var $7v5wN = parcelRequire("7v5wN");

var $guTIo = parcelRequire("guTIo");
function $038426fce23bcdde$export$2e2bcd8739ae039() {
    const theme = (0, $7v5wN.useTheme)();
    const defaultTitle = theme.metadata?.title ?? 'Those Beyond';
    const translation_pageTitle = (0, $guTIo.useUITranslatedText)('title', defaultTitle);
    (0, $7RNO0.useEffect)(()=>{
        document.title = translation_pageTitle;
    }, [
        translation_pageTitle
    ]);
    return null;
}



function $3aa191d86886e969$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $9h2J6.jsx)((0, $i2KZ1.Provider), {
        children: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $5fce49e23b2a0330$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $9h2J6.jsxs)((0, $1218a107e290b15a$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $9h2J6.jsx)((0, $038426fce23bcdde$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $9h2J6.jsx)((0, $138b494650f40c68$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $9h2J6.jsx)((0, $d6e190b79dfaa4d3$export$82270779c4a788ac), {}),
                    /*#__PURE__*/ (0, $9h2J6.jsx)((0, $7v5wN.ThemeStylesProvider), {}),
                    children,
                    /*#__PURE__*/ (0, $9h2J6.jsx)((0, $358ef4eaec781d83$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $9h2J6.jsx)((0, $c692c7afb508f389$export$2e2bcd8739ae039), {})
                ]
            })
        })
    });
}



var $9h2J6 = parcelRequire("9h2J6");

var $7RNO0 = parcelRequire("7RNO0");


var $6dpjF = parcelRequire("6dpjF");

var $9h2J6 = parcelRequire("9h2J6");

var $7RNO0 = parcelRequire("7RNO0");

var $i2KZ1 = parcelRequire("i2KZ1");

var $24Y1Y = parcelRequire("24Y1Y");

var $9h2J6 = parcelRequire("9h2J6");

var $7RNO0 = parcelRequire("7RNO0");

var $6dpjF = parcelRequire("6dpjF");

var $i2KZ1 = parcelRequire("i2KZ1");

var $9HMNu = parcelRequire("9HMNu");

var $guTIo = parcelRequire("guTIo");

var $9h2J6 = parcelRequire("9h2J6");

var $6dpjF = parcelRequire("6dpjF");

var $lmedS = parcelRequire("lmedS");
var $397f5e00daa398a7$export$42405f212471e8a2;
$397f5e00daa398a7$export$42405f212471e8a2 = `YGbQeW_flag`;


function $cbe5a971199226dc$export$c268312841a117(langISO) {
    // Extract country from the ISO code (e.g., 'en-US' -> 'us', 'fr-FR' -> 'fr')
    const parts = langISO.split('-');
    if (parts.length > 1) return parts[1].toLowerCase();
    // Fallback to the language code itself
    return parts[0].toLowerCase();
}
function $cbe5a971199226dc$export$2e2bcd8739ae039({ countryCode: countryCode, className: className }) {
    if (!countryCode) return null;
    const code = $cbe5a971199226dc$export$c268312841a117(countryCode);
    return /*#__PURE__*/ (0, $9h2J6.jsx)("img", {
        src: (0, $lmedS.pathToURL)(`flags/1x1/${code}.svg`),
        alt: code,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($397f5e00daa398a7$export$42405f212471e8a2, className)
    });
}



var $b3Ivu = parcelRequire("b3Ivu");

var $cTs7K = parcelRequire("cTs7K");

var $kFQy0 = parcelRequire("kFQy0");

var $24Y1Y = parcelRequire("24Y1Y");
var $900f9ea3a8c22304$export$92814d77b55c174e;
var $900f9ea3a8c22304$export$42405f212471e8a2;
var $900f9ea3a8c22304$export$a63ced91f3a681c9;
var $900f9ea3a8c22304$export$d879859fc1684421;
var $900f9ea3a8c22304$export$99c46f812f833697;
var $900f9ea3a8c22304$export$e4d153b3e021fb47;
$900f9ea3a8c22304$export$92814d77b55c174e = `ajAiza_LocalePickerPanel`;
$900f9ea3a8c22304$export$42405f212471e8a2 = `ajAiza_flag`;
$900f9ea3a8c22304$export$a63ced91f3a681c9 = `ajAiza_flagButton`;
$900f9ea3a8c22304$export$d879859fc1684421 = `ajAiza_flagLabel`;
$900f9ea3a8c22304$export$99c46f812f833697 = `ajAiza_flagsContainer`;
$900f9ea3a8c22304$export$e4d153b3e021fb47 = `ajAiza_isSelected`;


const $3d39ce24c1258ed3$export$300fe569c454f986 = 70;
const $3d39ce24c1258ed3$export$ffaba59c7c1db317 = 300;
function $3d39ce24c1258ed3$export$2e2bcd8739ae039() {
    const dispatch = (0, $i2KZ1.useAppDispatch)();
    const isVisible = (0, $i2KZ1.useAppSelector)((state)=>state.app.isLocalePickerPanelVisible);
    const { langs: langs, current: current, setLang: setLang } = (0, $guTIo.useLang)();
    const [hasCheckedInitial, setHasCheckedInitial] = (0, $7RNO0.useState)(false);
    const [sortCurrent, setSortCurrent] = (0, $7RNO0.useState)(current);
    (0, $7RNO0.useEffect)(()=>{
        if (isVisible) // Set the current lang (used for sorting) only after picker has animated closed
        setSortCurrent(current);
        else {
            const t = setTimeout(()=>setSortCurrent(current), $3d39ce24c1258ed3$export$ffaba59c7c1db317 + 100);
            return ()=>clearTimeout(t);
        }
    }, [
        isVisible,
        current
    ]);
    // Show picker automatically on first visit if translations enabled and no saved preference
    (0, $7RNO0.useEffect)(()=>{
        if (hasCheckedInitial) return;
        return;
    }, [
        hasCheckedInitial
    ]);
    function handleLocaleClick(langISO) {
        setLang(langISO);
        (0, $b3Ivu.saveLangIso)(langISO);
        dispatch((0, $9HMNu.setIsLocalePickerPanelVisible)(false));
    }
    (0, $7RNO0.useEffect)(()=>{
        if (current && langs?.length) {
            // If recieve locale not in supported langs (e.g from discord), set locale to default
            const matchingLang = langs.some((lang)=>lang.langISO === current);
            if (!matchingLang && current !== (0, $cTs7K.DEFAULT_LANG).langISO) {
                console.warn(`${current} not found in list of languages. Setting language to default: ${(0, $cTs7K.DEFAULT_LANG).langISO}`);
                setLang((0, $cTs7K.DEFAULT_LANG).langISO);
                return;
            }
            (0, $kFQy0.sendEventV2)('arise_locale', [
                current
            ]);
        }
    }, [
        current,
        langs
    ]);
    // If no languages, show default lang in picker
    // Sort alphabetically, with current one at front
    const flags = (langs?.length ? langs : [
        (0, $cTs7K.DEFAULT_LANG)
    ]).slice().sort((a, b)=>{
        if (a.langISO === sortCurrent) return -1;
        if (b.langISO === sortCurrent) return 1;
        return $3d39ce24c1258ed3$var$getNativeDisplayName(a.langISO, a.displayName).localeCompare($3d39ce24c1258ed3$var$getNativeDisplayName(b.langISO, b.displayName));
    });
    // Disable transition on mobiles to prevent performance issues when animating iFrame height
    return /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
        className: $900f9ea3a8c22304$export$92814d77b55c174e,
        inert: !isVisible ? '' : undefined,
        style: {
            height: $3d39ce24c1258ed3$export$300fe569c454f986,
            transform: isVisible ? 'translateY(0)' : 'translateY(100%)',
            transition: (0, $24Y1Y.isSmallMobileWidth)() ? undefined : `transform ${$3d39ce24c1258ed3$export$ffaba59c7c1db317}ms ease`
        },
        children: /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
            className: $900f9ea3a8c22304$export$99c46f812f833697,
            role: "radiogroup",
            "aria-label": "Select Language",
            children: flags.map(({ langISO: langISO, displayName: displayName })=>{
                const nativeName = $3d39ce24c1258ed3$var$getNativeDisplayName(langISO, displayName);
                const isSelected = langs?.length ? langISO === current : true;
                return /*#__PURE__*/ (0, $9h2J6.jsxs)("button", {
                    role: "radio",
                    "aria-checked": isSelected,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($900f9ea3a8c22304$export$a63ced91f3a681c9, {
                        [$900f9ea3a8c22304$export$e4d153b3e021fb47]: isSelected
                    }),
                    onClick: ()=>handleLocaleClick(langISO),
                    "aria-label": nativeName,
                    children: [
                        /*#__PURE__*/ (0, $9h2J6.jsx)((0, $cbe5a971199226dc$export$2e2bcd8739ae039), {
                            countryCode: langISO,
                            className: $900f9ea3a8c22304$export$42405f212471e8a2
                        }),
                        /*#__PURE__*/ (0, $9h2J6.jsx)("span", {
                            className: $900f9ea3a8c22304$export$d879859fc1684421,
                            children: nativeName
                        })
                    ]
                }, langISO);
            })
        })
    });
}
function $3d39ce24c1258ed3$var$getNativeDisplayName(langISO, fallback) {
    try {
        const name = new Intl.DisplayNames([
            langISO
        ], {
            type: 'language',
            languageDisplay: 'standard'
        }).of(langISO);
        if (name) return name;
    } catch  {
        console.log('[Arise] Could not translate display name');
    }
    return fallback;
}


function $937d42beb4fc805a$export$2e2bcd8739ae039({ children: children }) {
    const isLocalePickerVisible = (0, $i2KZ1.useAppSelector)((state)=>state.app.isLocalePickerPanelVisible);
    const container = (0, $7RNO0.useRef)(null);
    const canShowLocalePicker = false;
    const contentHeight = canShowLocalePicker && isLocalePickerVisible ? `calc(100% - ${0, $3d39ce24c1258ed3$export$300fe569c454f986}px)` : '100%';
    // Disable content transition on mobiles to prevent performance issues when animating iFrame height
    const contentTransition = canShowLocalePicker && !(0, $24Y1Y.isSmallMobileWidth)() ? `height ${0, $3d39ce24c1258ed3$export$ffaba59c7c1db317}ms ease` : undefined;
    return /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                className: "absolute top-0 left-0 w-full h-full overflow-hidden",
                style: {
                    touchAction: 'none',
                    height: contentHeight,
                    transition: contentTransition,
                    backgroundColor: 'black'
                },
                ref: container,
                onScroll: ()=>{
                    // Stop scroll jumping to items which become focussed off screen
                    container.current.scrollTo(0, 0);
                },
                children: /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                    className: "absolute top-0 left-0 w-full h-full",
                    children: children
                })
            }),
            canShowLocalePicker && /*#__PURE__*/ (0, $9h2J6.jsx)((0, $3d39ce24c1258ed3$export$2e2bcd8739ae039), {})
        ]
    });
}



var $9h2J6 = parcelRequire("9h2J6");

var $7RNO0 = parcelRequire("7RNO0");


var $i2KZ1 = parcelRequire("i2KZ1");

var $9HMNu = parcelRequire("9HMNu");

var $6KpYp = parcelRequire("6KpYp");

var $3yrZE = parcelRequire("3yrZE");

var $7RNO0 = parcelRequire("7RNO0");

var $9K8Jg = parcelRequire("9K8Jg");
// TODO: use from env variable (set at build time?)
let $07920574289b7936$var$API_HOST = 'https://api-partner.skybound-online.com/online/api/v1';
let $07920574289b7936$var$token = localStorage.getItem('ARISE_INSIDERS_TOKEN') || '';
function $07920574289b7936$export$57e714f81a2c3d86(t) {
    $07920574289b7936$var$token = t;
    localStorage.setItem('ARISE_INSIDERS_TOKEN', t);
}
function $07920574289b7936$export$257b2d10b709d8ef() {
    return $07920574289b7936$var$token;
}
async function $07920574289b7936$var$call(path, method, body) {
    let response = await fetch(`${$07920574289b7936$var$API_HOST}${path}`, {
        method: method,
        body: body ? JSON.stringify(body) : undefined,
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${$07920574289b7936$var$token}`
        }
    });
    if (!response.ok) throw new Error(response.statusText);
    return await response.json();
}
async function $07920574289b7936$export$3e32638432616b6() {
    try {
        const res = await $07920574289b7936$var$call('/users/info', 'GET');
        return res;
    } catch (error) {
        throw error;
    }
}


class $78f1a481199f706c$export$ddf66c513cd0060c extends EventTarget {
    constructor(iFrameElement, allowedOrigins, arisewareProjectId){
        super(), this.internalEvents = [
            'inventory_list_request',
            'inventory_takeItem_request',
            'inventory_dropItem_request',
            'ariseware_state_request',
            'ariseware_state_update_request',
            'profile_setTitle_request',
            'insiders_token_request',
            'instance_data_request',
            'supply_run_host_request',
            'poll_data_request',
            'poll_vote_request'
        ];
        this.iframeRef = iFrameElement;
        this.allowedOrigins = allowedOrigins || [
            '*'
        ];
        this.arisewareProjectId = arisewareProjectId;
        this.initialiseEvents();
        console.log('AriseBridgeHost created');
    }
    setArisewareProjectId(id) {
        this.arisewareProjectId = id;
    }
    initialiseEvents() {
        window.addEventListener('message', this.handleReceivedMessage.bind(this));
    }
    handleReceivedMessage(event) {
        if (this.allowedOrigins[0] !== '*' && this.allowedOrigins.indexOf(event.origin) === -1) {
            console.error('[Host] received message from unknown origin', event, this.allowedOrigins);
            return;
        }
        const data = event.data;
        if (this.internalEvents.indexOf(data.type) !== -1) {
            this.handleInternalEvent(data);
            return;
        }
        this.dispatchEvent(// TODO: proper types
        new CustomEvent(data.type, {
            detail: data.payload
        }));
    }
    // TODO: proper types
    sendEvent(event, payload) {
        if (!this.iframeRef.current?.contentWindow) {
            console.warn('[AriseBridge] sendEvent called before iframe ready:', event);
            return;
        }
        this.iframeRef.current.contentWindow.postMessage({
            type: event,
            payload: payload
        }, '*');
    }
    on(event, callback) {
        this.addEventListener(event, callback);
        return ()=>{
            this.removeEventListener(event, callback);
        };
    }
    off(event, callback) {
        this.removeEventListener(event, callback);
    }
    async handleInternalEvent(data) {
        try {
            const result = await this.internalEventSwitch(data);
            let payload = null;
            let event = null;
            if (result) {
                [event, payload] = result;
                this.sendEvent(event, payload);
            }
            this.dispatchEvent(new CustomEvent(data.type + '__success', {
                detail: {
                    requestData: data.payload,
                    responseData: payload
                }
            }));
        } catch (error) {
            this.dispatchEvent(new CustomEvent(data.type + '__error', {
                detail: {
                    requestData: data.payload
                }
            }));
            console.error(error);
        }
    }
    async internalEventSwitch(data) {
        let res;
        switch(data.type){
            case 'inventory_list_request':
                res = await $9K8Jg.getInventory();
                return [
                    'inventory_list_response',
                    res
                ];
            case 'inventory_takeItem_request':
                res = await $9K8Jg.takeItem(data.payload);
                return [
                    'inventory_takeItem_response',
                    res
                ];
            case 'inventory_dropItem_request':
                res = await $9K8Jg.dropItem(data.payload);
                return [
                    'inventory_dropItem_response',
                    res
                ];
            case 'ariseware_state_request':
                if (!this.arisewareProjectId) {
                    console.error('No arisewareProjectId set');
                    return;
                }
                res = await $9K8Jg.getArisewareState(this.arisewareProjectId);
                return [
                    'ariseware_state_response',
                    res
                ];
            case 'ariseware_state_update_request':
                if (!this.arisewareProjectId) {
                    console.error('No arisewareProjectId set');
                    return;
                }
                res = await $9K8Jg.updateArisewareState(this.arisewareProjectId, {
                    state: data.payload
                });
                return [
                    'ariseware_state_update_response',
                    res
                ];
            case 'profile_setTitle_request':
                // Legacy
                const titleId = data?.payload?.id;
                res = await $9K8Jg.addProfileTitle(titleId);
                return [
                    'profile_setTitle_response',
                    res
                ];
            case 'insiders_token_request':
                res = $07920574289b7936$export$257b2d10b709d8ef();
                return [
                    'insiders_token_response',
                    res
                ];
            case 'instance_data_request':
                res = await $9K8Jg.getInstanceData();
                return [
                    'instance_data_response',
                    res
                ];
            case 'supply_run_host_request':
                const supplyRunHost = undefined;
                return [
                    'supply_run_host_response',
                    supplyRunHost
                ];
            case 'poll_data_request':
                {
                    const { id: id, numberOfResults: numberOfResults } = data?.payload ?? {};
                    res = await $9K8Jg.getPollData(id, numberOfResults);
                    return [
                        'poll_data_response',
                        res
                    ];
                }
            case 'poll_vote_request':
                {
                    const { id: id, selectedOptionIds: selectedOptionIds, numberOfResults: numberOfResults } = data?.payload ?? {};
                    res = await $9K8Jg.submitPollVote(id, selectedOptionIds, numberOfResults);
                    return [
                        'poll_data_response',
                        res
                    ];
                }
            default:
                console.error('Unknown internal event', data);
                return;
        }
    }
}


class $d3dc05890c38dd4b$export$d5347260c4eca75c extends EventTarget {
    static #_ = this.eventListeners = [];
    constructor(ref, allowedOrigins, setArisewareProjectId){
        super();
        this.bridge = new (0, $78f1a481199f706c$export$ddf66c513cd0060c)(ref, allowedOrigins, setArisewareProjectId);
    }
    static initialise(ref, allowedOrigins, setArisewareProjectId) {
        if (!$d3dc05890c38dd4b$export$d5347260c4eca75c.instance) {
            $d3dc05890c38dd4b$export$d5347260c4eca75c.instance = new $d3dc05890c38dd4b$export$d5347260c4eca75c(ref, allowedOrigins, setArisewareProjectId);
            this.applyEventListeners();
        } else {
            $d3dc05890c38dd4b$export$d5347260c4eca75c.instance.bridge.iframeRef = ref;
            $d3dc05890c38dd4b$export$d5347260c4eca75c.instance.bridge.setArisewareProjectId(setArisewareProjectId);
        }
        return $d3dc05890c38dd4b$export$d5347260c4eca75c.instance;
    }
    static getInstance() {
        return $d3dc05890c38dd4b$export$d5347260c4eca75c.instance;
    }
    getBridge() {
        return this.bridge;
    }
    static sendEvent(event, payload) {
        if ($d3dc05890c38dd4b$export$d5347260c4eca75c.instance) $d3dc05890c38dd4b$export$d5347260c4eca75c.instance.bridge.sendEvent(event, payload);
        else console.error('AriseBridgeService not initialised. Is there an iframe?');
    }
    static on(event, callback) {
        this.eventListeners.push({
            event: event,
            callback: callback
        });
        if ($d3dc05890c38dd4b$export$d5347260c4eca75c.instance) $d3dc05890c38dd4b$export$d5347260c4eca75c.instance.bridge.on(event, callback);
        // Return a function to remove the event listener
        return ()=>{
            const index = this.eventListeners.findIndex((listener)=>listener.event === event && listener.callback === callback);
            if (index > -1) this.eventListeners.splice(index, 1);
            if ($d3dc05890c38dd4b$export$d5347260c4eca75c.instance) $d3dc05890c38dd4b$export$d5347260c4eca75c.instance.bridge.removeEventListener(event, callback);
        };
    }
    static applyEventListeners() {
        if ($d3dc05890c38dd4b$export$d5347260c4eca75c.instance) this.eventListeners.forEach((listener)=>{
            $d3dc05890c38dd4b$export$d5347260c4eca75c.instance.bridge.on(listener.event, listener.callback);
        });
    }
}


const $0997c0146d436032$export$e8c0cceb0fbfc44c = {
    current: null
};
function $0997c0146d436032$export$b3dfa3d70263abe6(iframeRef, options = {}) {
    const [ariseBridge, setAriseBridge] = (0, $7RNO0.useState)(null);
    (0, $7RNO0.useEffect)(()=>{
        const allowedOrigins = options.allowedOrigins || [
            '*'
        ];
        const abs = (0, $d3dc05890c38dd4b$export$d5347260c4eca75c).initialise(iframeRef, allowedOrigins, options.arisewareProjectID);
        const bridge = abs.getBridge();
        setAriseBridge(bridge);
        $0997c0146d436032$export$e8c0cceb0fbfc44c.current = bridge;
        return ()=>{
            $0997c0146d436032$export$e8c0cceb0fbfc44c.current = null;
        };
    }, [
        iframeRef
    ]);
    return ariseBridge;
}




var $kFQy0 = parcelRequire("kFQy0");


var $9K8Jg = parcelRequire("9K8Jg");

var $2QyQO = parcelRequire("2QyQO");

var $7RNO0 = parcelRequire("7RNO0");


var $6Jwum = parcelRequire("6Jwum");

var $6KpYp = parcelRequire("6KpYp");

var $i2KZ1 = parcelRequire("i2KZ1");

var $dS0He = parcelRequire("dS0He");


var $2QyQO = parcelRequire("2QyQO");

var $9HMNu = parcelRequire("9HMNu");
const $9f96f67c93658cb1$var$loginpath = '/auth/landing';
function $9f96f67c93658cb1$export$c39969323984c2e2() {
    const auth = (0, $i2KZ1.useAppSelector)((state)=>state.auth);
    const navigate = (0, $0e3dfb59695be15b$export$9770f232ac06a008)();
    (0, $7RNO0.useEffect)(()=>{
        if (!auth.loggedIn) navigate($9f96f67c93658cb1$var$loginpath);
    }, []);
}
function $9f96f67c93658cb1$export$78b61f95a37eeb97({ loggedInRedirect: loggedInRedirect, loggedOutRedirect: loggedOutRedirect = $9f96f67c93658cb1$var$loginpath } = {}) {
    const dispatch = (0, $i2KZ1.useAppDispatch)();
    (0, $7RNO0.useEffect)(()=>{
        dispatch((0, $6Jwum.initialAuthFlow)());
    }, []);
}
function $9f96f67c93658cb1$export$1e4259488407aa44({ loggedInRedirect: loggedInRedirect, loggedOutRedirect: loggedOutRedirect = $9f96f67c93658cb1$var$loginpath } = {}) {
    const { intialAuthCheckComplete: intialAuthCheckComplete, isInitialAuthCheckInProgress: isInitialAuthCheckInProgress, loggedIn: loggedIn, user: user, hasLoggedOut: hasLoggedOut } = (0, $i2KZ1.useAppSelector)((state)=>state.auth);
    const { currentUserProfileCheckComplete: currentUserProfileCheckComplete, currentUserProfileCheckInProgress: currentUserProfileCheckInProgress, currentUserProfile: currentUserProfile } = (0, $i2KZ1.useAppSelector)((state)=>state.profile);
    const navigate = (0, $0e3dfb59695be15b$export$9770f232ac06a008)();
    const dispatch = (0, $i2KZ1.useAppDispatch)();
    const isGuest = (0, $ebb541bfb8cf4470$export$c3ab02d49994a165)();
    (0, $7RNO0.useEffect)(()=>{
        if (intialAuthCheckComplete || isInitialAuthCheckInProgress) return;
        dispatch((0, $6Jwum.initialAuthCheck)());
    }, []);
    (0, $7RNO0.useEffect)(()=>{
        if (!user || currentUserProfileCheckComplete || currentUserProfileCheckInProgress) return;
        dispatch((0, $6KpYp.loadCurrentUserProfile)([
            user.id
        ]));
    }, [
        user
    ]);
    (0, $7RNO0.useEffect)(()=>{
        if (!intialAuthCheckComplete) return;
        if (loggedIn) {
            if (!currentUserProfileCheckComplete) return;
            // Send to either edit profile page, edit display name page, or just log them in depending on their data
            if (isGuest) {
                if (loggedInRedirect) navigate(loggedInRedirect);
                return;
            }
            if ((0, $dS0He.profileHasOnboarded)(currentUserProfile)) {
                if (user.hasSetUsername) {
                    if (loggedInRedirect) navigate(loggedInRedirect);
                    return;
                } else {
                    navigate('/edit-display-name');
                    return;
                }
            } else {
                navigate('/edit-profile');
                return;
            }
        } else // Not logged in
        if (hasLoggedOut) navigate(loggedOutRedirect);
        else // Arriving at site, and we could not or did not log you in automatically
        // Do nothing
        console.info('Logged out mode');
    }, [
        intialAuthCheckComplete,
        loggedIn,
        currentUserProfileCheckComplete,
        currentUserProfile
    ]);
    return {
        isInProgress: isInitialAuthCheckInProgress
    };
}
function $9f96f67c93658cb1$export$23bbbc4533528f03() {
    const user = (0, $i2KZ1.useAppSelector)((state)=>state.auth.user);
    return user;
}
function $9f96f67c93658cb1$export$c9c1802ef9b13040() {
    const dispatch = (0, $i2KZ1.useAppDispatch)();
    return ()=>{
        if (0, $2QyQO.isInsidersInstance) window.location.href = (0, $2QyQO.getInsidersRegisterUrl)();
        else dispatch((0, $9HMNu.setAuthModalScreen)('signupLanding'));
    };
}
function $9f96f67c93658cb1$export$932dac77da3ee9c3() {
    const dispatch = (0, $i2KZ1.useAppDispatch)();
    return ()=>{
        if (0, $2QyQO.isInsidersInstance) window.location.href = (0, $2QyQO.getInsidersLoginUrl)();
        else dispatch((0, $9HMNu.setAuthModalScreen)('login'));
    };
}



var $cTs7K = parcelRequire("cTs7K");

var $1afSf = parcelRequire("1afSf");

var $cTs7K = parcelRequire("cTs7K");

var $i2KZ1 = parcelRequire("i2KZ1");

var $7RNO0 = parcelRequire("7RNO0");
function $7509b5588312ec87$export$2e2bcd8739ae039(bridge) {
    const userDataRef = (0, $7RNO0.useRef)({});
    const currentUserProfileV2 = (0, $i2KZ1.useAppSelector)((state)=>state.profile.currentUserProfileV2);
    const availableBadges = (0, $i2KZ1.useAppSelector)((state)=>state.profile.availableBadges);
    const availableTitles = (0, $i2KZ1.useAppSelector)((state)=>state.profile.availableTitles);
    const langIso = (0, $i2KZ1.useAppSelector)((state)=>state.app.langIso);
    const translations = (0, $i2KZ1.useAppSelector)((state)=>state.app.translations);
    const discordLocale = (0, $i2KZ1.useAppSelector)((state)=>state.discord.locale);
    const discordPremiumType = (0, $i2KZ1.useAppSelector)((state)=>state.discord.user?.premium_type);
    const questId = (0, $i2KZ1.useAppSelector)((state)=>state.discord.questId);
    const questStatus = (0, $i2KZ1.useAppSelector)((state)=>state.discord.questStatus);
    const questCTAURL = (0, $i2KZ1.useAppSelector)((state)=>state.discord.questCTAURL);
    const shouldArisewareBeMuted = (0, $i2KZ1.useAppSelector)((state)=>state.app.shouldArisewareBeMuted);
    userDataRef.current = {
        langIso: langIso,
        currentUserProfileV2: currentUserProfileV2,
        availableBadges: availableBadges,
        availableTitles: availableTitles,
        translations: translations,
        discordLocale: discordLocale,
        discordPremiumType: discordPremiumType,
        questId: questId,
        questStatus: questStatus,
        questCTAURL: questCTAURL
    };
    function pushUserProfile() {
        if (userDataRef.current.currentUserProfileV2) bridge?.sendEvent('user-data', userDataRef.current.currentUserProfileV2);
    }
    function pushAvailableBadgesData() {
        if (userDataRef.current.availableBadges) bridge?.sendEvent('available-badges-data', userDataRef.current.availableBadges);
    }
    function pushAvailableTitlesData() {
        if (userDataRef.current.availableTitles) bridge?.sendEvent('available-titles-data', userDataRef.current.availableTitles);
    }
    function pushLocale() {
        if (userDataRef.current.langIso) bridge?.sendEvent('locale', {
            locale: userDataRef.current.langIso
        });
    }
    function pushDiscordLocale() {
        if ((0, $cTs7K.IS_DISCORD_ACTIVITY) && userDataRef.current.discordLocale) bridge?.sendEvent('discord-locale', {
            locale: userDataRef.current.discordLocale
        });
    }
    function pushTranslations() {
        if (userDataRef.current.translations) bridge?.sendEvent('translations', {
            translations: userDataRef.current.translations
        });
    }
    function pushDiscordPremiumType() {
        if (userDataRef.current.discordPremiumType || userDataRef.current.discordPremiumType === 0) bridge?.sendEvent('discord-premium-type', userDataRef.current.discordPremiumType);
    }
    function pushQuestInfo() {
        if (userDataRef.current.questId) {
            const { questId: questId, questStatus: questStatus, questCTAURL: questCTAURL } = userDataRef.current;
            bridge?.sendEvent('quest-info', {
                questId: questId,
                questStatus: questStatus,
                questCTAURL: questCTAURL
            });
        }
    }
    function pushMuteState() {
        if (typeof shouldArisewareBeMuted === 'boolean') bridge?.sendEvent('mute', shouldArisewareBeMuted);
    }
    function pushUserData() {
        pushUserProfile();
        pushAvailableBadgesData();
        pushAvailableTitlesData();
        pushLocale();
        pushDiscordLocale();
        pushTranslations();
        pushDiscordPremiumType();
        pushQuestInfo();
        pushMuteState();
    }
    (0, $7RNO0.useEffect)(()=>{
        pushUserProfile();
    }, [
        currentUserProfileV2
    ]);
    (0, $7RNO0.useEffect)(()=>{
        pushAvailableBadgesData();
    }, [
        availableBadges
    ]);
    (0, $7RNO0.useEffect)(()=>{
        pushAvailableTitlesData();
    }, [
        availableTitles
    ]);
    (0, $7RNO0.useEffect)(()=>{
        pushLocale();
    }, [
        langIso
    ]);
    (0, $7RNO0.useEffect)(()=>{
        pushTranslations();
    }, [
        translations
    ]);
    (0, $7RNO0.useEffect)(()=>{
        pushDiscordLocale();
    }, [
        discordLocale
    ]);
    (0, $7RNO0.useEffect)(()=>{
        pushDiscordPremiumType();
    }, [
        discordPremiumType
    ]);
    (0, $7RNO0.useEffect)(()=>{
        pushQuestInfo();
    }, [
        questId,
        questStatus,
        questCTAURL
    ]);
    (0, $7RNO0.useEffect)(()=>{
        pushMuteState();
    }, [
        shouldArisewareBeMuted
    ]);
    return {
        pushUserData: pushUserData,
        pushLocale: pushLocale,
        pushTranslations: pushTranslations,
        pushDiscordLocale: pushDiscordLocale,
        pushDiscordPremiumType: pushDiscordPremiumType,
        pushQuestInfo: pushQuestInfo
    };
}



var $i2KZ1 = parcelRequire("i2KZ1");

var $7RNO0 = parcelRequire("7RNO0");
function $77ace9017d4e4785$export$8535247f55db5d21() {
    const { locations: locations, isFetchingLocations: isFetchingLocations, areas: areas, isFetchingAreas: isFetchingAreas, regions: regions, isFetchingRegions: isFetchingRegions } = (0, $i2KZ1.useAppSelector)((state)=>state.app);
    const isLoading = isFetchingLocations || isFetchingAreas || isFetchingRegions;
    return {
        locations: locations,
        areas: areas,
        regions: regions,
        isLoading: isLoading
    };
}
function $77ace9017d4e4785$export$45d76561a5302f2b(locationId) {
    const { locations: locations } = (0, $i2KZ1.useAppSelector)((state)=>state.app);
    const location = locations[locationId];
    return (0, $7RNO0.useMemo)(()=>location, [
        location
    ]);
}



var $7v5wN = parcelRequire("7v5wN");

var $guTIo = parcelRequire("guTIo");

var $9K8Jg = parcelRequire("9K8Jg");

var $9HMNu = parcelRequire("9HMNu");

var $i2KZ1 = parcelRequire("i2KZ1");

var $7RNO0 = parcelRequire("7RNO0");
function $7c2bf733a6cb2baa$export$2e2bcd8739ae039(bridge) {
    const dispatch = (0, $i2KZ1.useAppDispatch)();
    function onShowLeaderboard(event) {
        dispatch((0, $9HMNu.setIsLeaderboardOpen)(event.detail));
    }
    async function onSubmitScore(data) {
        try {
            const result = await (0, $9K8Jg.submitScore)(data.detail.leaderboardId, data.detail.score);
            bridge.sendEvent('submit-score-response', result);
        } catch (error) {
            console.log('Failed to submit score', error);
            bridge.sendEvent('submit-score-response', {
                accepted: false,
                reason: 'error'
            });
        }
    }
    async function onGetLeaderboard(data) {
        try {
            const result = await (0, $9K8Jg.getLeaderboard)(data.detail.leaderboardId);
            bridge.sendEvent('leaderboard-data', result);
        } catch (error) {
            console.log('Failed to get leaderboard', error);
        }
    }
    (0, $7RNO0.useEffect)(()=>{
        if (!bridge) return;
        bridge.on('show-leaderboard', onShowLeaderboard);
        bridge.on('submit-score', onSubmitScore);
        bridge.on('get-leaderboard', onGetLeaderboard);
        return ()=>{
            bridge.off('show-leaderboard', onShowLeaderboard);
            bridge.off('submit-score', onSubmitScore);
            bridge.off('get-leaderboard', onGetLeaderboard);
        };
    }, [
        bridge
    ]);
}


function $e06a211822b32e2c$export$2e2bcd8739ae039({ src: src, bridgeRef: bridgeRef, arisewareProjectID: arisewareProjectID, onReady: onReady, loadingBackgroundImageUrl: loadingBackgroundImageUrl, loadingLogoImageUrl: loadingLogoImageUrl, loadingText: loadingText, forceInFrontOfUi: forceInFrontOfUi, style: style, discordRef: discordRef }) {
    const navigate = (0, $0e3dfb59695be15b$export$9770f232ac06a008)();
    const { locationId: locationId } = (0, $0e3dfb59695be15b$export$99eaa27ddbbb95ef)();
    const [iframeReady, setIframeReady] = (0, $7RNO0.useState)(false);
    const reloadCount = (0, $i2KZ1.useAppSelector)((state)=>state.app.iframeReloadCount);
    const iframeRef = (0, $7RNO0.useRef)(null);
    const locationRef = (0, $7RNO0.useRef)(null);
    const claimedRewardsRef = (0, $7RNO0.useRef)({});
    const loggedIn = (0, $i2KZ1.useAppSelector)((state)=>state.auth.loggedIn);
    const theme = (0, $7v5wN.useTheme)();
    let iframeUrl = (0, $7RNO0.useMemo)(()=>{
        const url = new URL(window.location.href);
        const iframeUrlParam = url.searchParams.get('iframeUrl');
        if (iframeUrlParam) src = iframeUrlParam;
        const params = new URLSearchParams(window.location.search);
        params.delete('iframeUrl');
        const paramsString = params.toString();
        if (paramsString) src = `${src}?${paramsString}`;
        return src;
    }, [
        src
    ]);
    // If iframeUrl is passed as a query param, use that instead
    const dispatch = (0, $i2KZ1.useAppDispatch)();
    const bridge = (0, $0997c0146d436032$export$b3dfa3d70263abe6)(iframeRef, {
        arisewareProjectID: arisewareProjectID
    });
    // Expose bridge to parent
    if (bridgeRef) bridgeRef.current = bridge;
    // const titanEvents = useTitanEvents(arisewareProjectID);
    // const hyperionEvents = useHyperionEvents();
    // const mimasEvents = useMimasEvents(discordRef, bridge);
    const navigateToSignup = (0, $9f96f67c93658cb1$export$c9c1802ef9b13040)();
    const status = (0, $i2KZ1.useAppSelector)((state)=>state.discord.questStatus);
    const checked = (0, $i2KZ1.useAppSelector)((state)=>state.discord.questStatusChecked);
    const questCTAURL = (0, $i2KZ1.useAppSelector)((state)=>state.discord.questCTAURL);
    const questCTAURLRef = (0, $7RNO0.useRef)(questCTAURL);
    questCTAURLRef.current = questCTAURL;
    locationRef.current = (0, $77ace9017d4e4785$export$45d76561a5302f2b)(locationId || '');
    (0, $7RNO0.useEffect)(()=>{
        bridge?.sendEvent('quest-status-update', {
            status: status,
            checked: checked
        });
    }, [
        bridge,
        status,
        checked
    ]);
    const { pushUserData: pushUserData, pushLocale: pushLocale, pushTranslations: pushTranslations, pushDiscordLocale: pushDiscordLocale, pushDiscordPremiumType: pushDiscordPremiumType, pushQuestInfo: pushQuestInfo } = (0, $7509b5588312ec87$export$2e2bcd8739ae039)(bridge);
    function sendAuthToken() {
        const token = (0, $9K8Jg.getAuthToken)();
        bridge?.sendEvent('arise-token', token);
    }
    function sendCCSettings() {
        // Using ref here because this function is used in a useEffect with no location dependency
        const settings = locationRef.current?.arisewareSettings || undefined;
        bridge?.sendEvent('custom-content-settings', settings);
    }
    /*
     * Initialisation Events
     */ // Automatically send events when user is logged in
    (0, $7RNO0.useEffect)(()=>{
        if (loggedIn && bridge) sendAuthToken();
    }, [
        loggedIn,
        bridge
    ]);
    // Send location custom content settings when they are loaded
    (0, $7RNO0.useEffect)(()=>{
        if (locationRef.current && bridge) sendCCSettings();
    }, [
        location,
        bridge
    ]);
    (0, $7RNO0.useEffect)(()=>{
        if (!bridge) return;
        function onReadyHandler(data) {
            setIframeReady(data.detail);
            if (data.detail === true) onReady();
        }
        function onFailed() {
            dispatch((0, $9HMNu.failedGame)({
                arisewareProjectID: arisewareProjectID
            }));
        }
        function onFeedUpdate(data) {
            dispatch((0, $9HMNu.submitFeedUpdate)(data.detail));
        }
        function onQueueAchievement(data) {
            dispatch((0, $9HMNu.queueAchievement)(data.detail));
        }
        function onSetNewsTickerVisibility(data) {
            dispatch((0, $9HMNu.setIsNewsTickerVisible)(data.detail));
        }
        function onSetLocalePickerVisibility(data) {
            dispatch((0, $9HMNu.setIsLocalePickerPanelVisible)(data.detail));
        }
        function onSetInventoryIsOpen(data) {
            dispatch((0, $9HMNu.setIsInventoryOpen)(data.detail));
        }
        function onSelectInventoryItem() {
            dispatch((0, $9HMNu.selectInventoryItem)());
        }
        function onTrack(data) {
            const { eventType: eventType, metadata: metadata } = data.detail;
            if (typeof eventType !== 'string') {
                console.error('Cannot send event from iFrame - eventType is invalid or missing:', data.detail);
                return;
            }
            (0, $kFQy0.sendEventV2)(eventType, metadata?.strings, metadata?.numbers, true);
        }
        function onCheckpoint(data) {
            const { name: name, time: time, id: id } = data.detail;
            (0, $kFQy0.sendEventV2)('checkpoint', [
                name
            ], [
                time,
                id
            ]);
        }
        function onGotoHome() {
            navigate((0, $2QyQO.homePath));
        }
        function onGotoSignup() {
            navigateToSignup();
        }
        function onGoto(data) {
            navigate(`${data.detail}`);
        }
        function onViewMedia(data) {
            dispatch((0, $9HMNu.setCurrentlyViewingMedia)(data.detail));
        }
        function onViewReward(data) {
            if (!data.detail?.id) {
                console.log('[Arise] view-reward failed: missing id');
                return;
            }
            const reward = claimedRewardsRef.current[data.detail.id];
            if (reward) dispatch((0, $9HMNu.setCurrentlyViewingReward)(reward));
            else console.log('[Arise] view-reward: no claimed reward found for id', data.detail.id);
        }
        async function onClaimReward(data) {
            try {
                if (!data.detail?.promotionId) {
                    console.log('[Arise] claim-reward failed: missing promotionId');
                    return;
                }
                const result = await (0, $9K8Jg.claimReward)(data.detail.promotionId);
                if (result.reward) {
                    claimedRewardsRef.current[result.reward.id] = result.reward;
                    (0, $kFQy0.sendEventV2)('reward__claim_success', [
                        result.reward.name,
                        data.detail.promotionId
                    ]);
                } else (0, $kFQy0.sendEventV2)('reward__claim_failed', [
                    data.detail.promotionId,
                    result?.status
                ]);
                bridge?.sendEvent('claim-reward-response', result);
            } catch (error) {
                (0, $kFQy0.sendEventV2)('reward__claim_failed', [
                    data.detail.promotionId
                ]);
                console.log('[Arise] claim-reward failed', error);
            }
        }
        async function onGetRewardStatus(data) {
            try {
                if (!data.detail?.promotionId) {
                    console.log('[Arise] get-reward-status failed: missing promotionId');
                    return;
                }
                const result = await (0, $9K8Jg.getRewardStatus)(data.detail.promotionId);
                bridge?.sendEvent('get-reward-status-response', result);
            } catch (error) {
                console.log('[Arise] get-reward-status failed', error);
            }
        }
        function onCopyText(data) {
            (0, $d22b0730c33191cb$export$2cdf1b96a9f86d16)(data.detail);
        }
        function onOpenUrl(data) {
            (0, $kFQy0.sendEventV2)('external_link_opened', [
                data.detail
            ]);
            if ((0, $cTs7K.IS_DISCORD_ACTIVITY) && discordRef.current) discordRef.current.openExternalLink(data.detail);
            else window.open(data.detail, '_blank');
        }
        function onOpenQuestCTA(data) {
            const url = questCTAURLRef.current || data.detail;
            (0, $kFQy0.sendEventV2)('external_link_opened', [
                url
            ]);
            if ((0, $cTs7K.IS_DISCORD_ACTIVITY) && discordRef.current) discordRef.current.openExternalLink(url);
            else window.open(url, '_blank');
        }
        function onQuestCompleted() {
            if ((0, $cTs7K.IS_DISCORD_ACTIVITY) && discordRef.current) discordRef.current.completeQuest();
            dispatch((0, $6KpYp.setMissionComplete)());
        }
        function onQuestProgress(data) {
            if ((0, $cTs7K.IS_DISCORD_ACTIVITY) && discordRef.current) discordRef.current.setQuestProgress(data.detail);
        }
        async function onBotRegister() {
            if ((0, $cTs7K.IS_DISCORD_ACTIVITY) && discordRef.current) try {
                await discordRef.current.botRegister();
                (0, $kFQy0.sendEventV2Once)('bot-register');
                bridge?.sendEvent('bot-register-response', {
                    status: 'ok'
                });
            } catch (error) {
                console.log('[Arise] bot reg error', error);
                (0, $kFQy0.sendEventV2Once)('bot-register-failed', [
                    (0, $d22b0730c33191cb$export$56831a8b9cb27763)(error)
                ]);
                bridge?.sendEvent('bot-register-response', {
                    status: 'error'
                });
            }
        }
        async function onSendUserEvent(data) {
            const isNewsTickerDataIdOnlyItem = (item)=>{
                return 'id' in item;
            };
            const item = data?.detail;
            if (item) {
                dispatch((0, $3yrZE.queueNewsTickerItem)(item));
                if (isNewsTickerDataIdOnlyItem(item)) // If is ID only item, send to backend too
                try {
                    await (0, $9K8Jg.userEvent)(locationId, item.id);
                } catch (error) {
                    console.error('Bridge event sendUserEvent could not send event:', error);
                }
            }
        }
        function onSetNewsTickerTag(data) {
            dispatch((0, $3yrZE.setNewsTickerTag)(data.detail));
        }
        function onShare(data) {
            // If no custom message passed in, use the share text from the CMS
            const fallbackCmsShareText = theme.metadata?.customJSON?.share?.text;
            const translation_shareText = (0, $guTIo.getUITranslatedText)('informationScreen_shareText', fallbackCmsShareText);
            const { message: message = translation_shareText, disableAutoLink: disableAutoLink, linkId: linkId } = data.detail ?? {};
            if (0, $cTs7K.IS_DISCORD_ACTIVITY) (0, $1afSf.triggerDiscordShare)(message, disableAutoLink, linkId);
            else dispatch((0, $9HMNu.setStartShare)({
                message: message,
                disableAutoLink: disableAutoLink
            }));
        }
        function onAwardBadge(data) {
            const badgeRank = data.detail;
            dispatch((0, $6KpYp.awardBadge)(badgeRank));
        }
        function onAwardTitle(data) {
            const titleId = data.detail;
            dispatch((0, $6KpYp.awardTitle)(titleId));
        }
        async function onGetQuestStatus() {
            if ((0, $cTs7K.IS_DISCORD_ACTIVITY) && discordRef.current) {
                const status = await discordRef.current.getQuestStatus();
                bridge?.sendEvent('quest-status-update', status);
            }
        }
        async function onGetUniverseMetadata() {
            try {
                const json = await (0, $9K8Jg.getUniverseMetadata)();
                bridge?.sendEvent('universe-metadata', json);
            } catch (error) {
                console.log('[Arise] Error cannot getUniverseMetadata');
            }
        }
        function onGetTranslations() {
            pushTranslations();
        }
        function onRefreshTranslations() {
            dispatch((0, $9HMNu.loadTranslations)());
        }
        function onGetLocale() {
            pushLocale();
        }
        function onGetDiscordLocale() {
            pushDiscordLocale();
        }
        function onGetDiscordPremiumType() {
            pushDiscordPremiumType();
        }
        function onGetQuestInfo() {
            pushQuestInfo();
        }
        async function onGetNewsTickerData() {
            try {
                const json = await (0, $9K8Jg.getNewsTickerData)();
                bridge?.sendEvent('news-ticker-data', json);
            } catch (error) {
                console.log('[Arise] Error cannot getNewsTickerData');
            }
        }
        function pushDiscordPlatform() {
            if (0, $cTs7K.IS_DISCORD_ACTIVITY) {
                const platform = (0, $1afSf.discordPlatform)();
                bridge?.sendEvent('discord-platform', platform);
            }
        }
        function onGetAuthToken() {
            sendAuthToken();
        }
        function getGetCCSettings() {
            sendCCSettings();
        }
        function onGetHostPlatform() {
            bridge?.sendEvent('host-platform', (0, $cTs7K.HOST_PLATFORM));
        }
        function onArisewareReload() {
            dispatch((0, $9HMNu.incrementIframeReloadCount)());
        }
        bridge.on('ready', onReadyHandler);
        bridge.on('ready', pushUserData);
        bridge.on('ready', pushDiscordPlatform);
        bridge.on('failed', onFailed);
        bridge.on('feed-update', onFeedUpdate);
        bridge.on('queue-achievement', onQueueAchievement);
        bridge.on('set-news-ticker-visibility', onSetNewsTickerVisibility);
        bridge.on('set-locale-picker-visibility', onSetLocalePickerVisibility);
        bridge.on('set-inventory-is-open', onSetInventoryIsOpen);
        bridge.on('select-inventory-item', onSelectInventoryItem);
        bridge.on('track', onTrack);
        bridge.on('track:checkpoint', onCheckpoint);
        bridge.on('goto_home', onGotoHome);
        bridge.on('goto_signup', onGotoSignup);
        bridge.on('goto', onGoto);
        bridge.on('view-media', onViewMedia);
        bridge.on('view-reward', onViewReward);
        bridge.on('claim-reward', onClaimReward);
        bridge.on('get-reward-status', onGetRewardStatus);
        bridge.on('copy-text', onCopyText);
        bridge.on('send-user-event', onSendUserEvent);
        bridge.on('news-ticker-tag', onSetNewsTickerTag);
        bridge.on('share', onShare);
        bridge.on('open-url', onOpenUrl);
        bridge.on('open-quest-cta', onOpenQuestCTA);
        bridge.on('quest-completed', onQuestCompleted);
        bridge.on('quest-progress', onQuestProgress);
        bridge.on('get-quest-status', onGetQuestStatus);
        bridge.on('bot-register', onBotRegister);
        bridge.on('get-universe-metadata', onGetUniverseMetadata);
        bridge.on('get-news-ticker-data', onGetNewsTickerData);
        bridge.on('get-translations', onGetTranslations);
        bridge.on('refresh-translations', onRefreshTranslations);
        bridge.on('get-locale', onGetLocale);
        bridge.on('get-discord-locale', onGetDiscordLocale);
        bridge.on('get-discord-premium-type', onGetDiscordPremiumType);
        bridge.on('get-quest-info', onGetQuestInfo);
        bridge.on('award-badge', onAwardBadge);
        bridge.on('award-title', onAwardTitle);
        bridge.on('get-arise-token', onGetAuthToken);
        bridge.on('get-custom-content-settings', getGetCCSettings);
        bridge.on('get-host-platform', onGetHostPlatform);
        bridge.on('ariseware-reload', onArisewareReload);
        // if (process.env.PUBLIC_INSTANCE === 'titan') {
        //     bridge.on('goto_camp', titanEvents.onGotoCamp);
        //     bridge.on('goto', titanEvents.onGoto);
        //     bridge.on('submitresult', titanEvents.onSubmitResult);
        // }
        // if (process.env.PUBLIC_INSTANCE === 'hyperion') {
        //     bridge.on('goto', hyperionEvents.onGoto);
        // }
        // if (process.env.PUBLIC_INSTANCE === 'mimas') {
        //     bridge.on('ready', mimasEvents.pushCountryCode);
        //     bridge.on('ariseware-checkpoint-reached', mimasEvents.onCheckpointReached);
        // }
        return ()=>{
            dispatch((0, $9HMNu.setIsNewsTickerVisible)(true));
            bridge.off('ready', onReady);
            bridge.off('ready', pushUserData);
            bridge.off('failed', onFailed);
            bridge.off('feed-update', onFeedUpdate);
            bridge.off('queue-achievement', onQueueAchievement);
            bridge.off('set-news-ticker-visibility', onSetNewsTickerVisibility);
            bridge.off('set-inventory-is-open', onSetInventoryIsOpen);
            bridge.off('select-inventory-item', onSelectInventoryItem);
            bridge.off('track', onTrack);
            bridge.off('track:checkpoint', onCheckpoint);
            bridge.off('goto_home', onGotoHome);
            bridge.off('goto_signup', onGotoSignup);
            bridge.off('goto', onGoto);
            bridge.off('view-media', onViewMedia);
            bridge.off('view-reward', onViewReward);
            bridge.off('claim-reward', onClaimReward);
            bridge.off('get-reward-status', onGetRewardStatus);
            bridge.off('copy-text', onCopyText);
            bridge.off('send-user-event', onSendUserEvent);
            bridge.off('news-ticker-tag', onSetNewsTickerTag);
            bridge.off('share', onShare);
            bridge.off('open-url', onOpenUrl);
            bridge.off('open-quest-cta', onOpenQuestCTA);
            bridge.off('quest-completed', onQuestCompleted);
            bridge.off('quest-progress', onQuestProgress);
            bridge.off('get-quest-status', onGetQuestStatus);
            bridge.off('bot-register', onBotRegister);
            bridge.off('get-universe-metadata', onGetUniverseMetadata);
            bridge.off('get-news-ticker-data', onGetNewsTickerData);
            bridge.off('get-translations', onGetTranslations);
            bridge.off('refresh-translations', onRefreshTranslations);
            bridge.off('get-locale', onGetLocale);
            bridge.off('get-discord-locale', onGetDiscordLocale);
            bridge.off('get-discord-premium-type', onGetDiscordPremiumType);
            bridge.off('get-quest-info', onGetQuestInfo);
            bridge.off('award-badge', onAwardBadge);
            bridge.off('award-title', onAwardTitle);
            bridge.off('get-arise-token', onGetAuthToken);
            bridge.off('get-custom-content-settings', getGetCCSettings);
            bridge.off('get-host-platform', onGetHostPlatform);
            bridge.off('ariseware-reload', onArisewareReload);
            bridge.off('set-locale-picker-visibility', onSetLocalePickerVisibility);
        // if (process.env.PUBLIC_INSTANCE === 'titan') {
        //     bridge.off('goto_camp', titanEvents.onGotoCamp);
        //     bridge.off('goto', titanEvents.onGoto);
        //     bridge.off('submitresult', titanEvents.onSubmitResult);
        // }
        // if (process.env.PUBLIC_INSTANCE === 'hyperion') {
        //     bridge.off('goto', hyperionEvents.onGoto);
        // }
        // if (process.env.PUBLIC_INSTANCE === 'mimas') {
        //     bridge.off('ariseware-checkpoint-reached', mimasEvents.onCheckpointReached);
        //     bridge.off('ready', mimasEvents.pushCountryCode);
        // }
        };
    }, [
        bridge,
        iframeUrl
    ]);
    (0, $7RNO0.useEffect)(()=>{
        setIframeReady(false);
    }, [
        reloadCount
    ]);
    (0, $7c2bf733a6cb2baa$export$2e2bcd8739ae039)(bridge);
    const forceInFrontOfUIStyle = forceInFrontOfUi ? {
        position: 'absolute',
        zIndex: 100000
    } : {};
    return /*#__PURE__*/ (0, $9h2J6.jsxs)((0, $9h2J6.Fragment), {
        children: [
            iframeUrl?.startsWith('null') ? /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9h2J6.Fragment), {}) : /*#__PURE__*/ (0, $9h2J6.jsx)("iframe", {
                allow: "xr-spatial-tracking; autoplay; encrypted-media;",
                ref: iframeRef,
                src: iframeUrl,
                style: {
                    width: '100%',
                    height: '100%',
                    opacity: iframeReady ? 1 : 0,
                    ...style,
                    ...forceInFrontOfUIStyle
                }
            }, reloadCount),
            /*#__PURE__*/ (0, $9h2J6.jsx)((0, $712b328b756bc954$export$2e2bcd8739ae039), {
                show: !iframeReady,
                backgroundImageUrl: loadingBackgroundImageUrl,
                logoImageUrl: loadingLogoImageUrl,
                loadingText: loadingText,
                style: forceInFrontOfUIStyle
            })
        ]
    });
}



var $9HMNu = parcelRequire("9HMNu");

var $i2KZ1 = parcelRequire("i2KZ1");

var $9h2J6 = parcelRequire("9h2J6");

var $6dpjF = parcelRequire("6dpjF");

var $7RNO0 = parcelRequire("7RNO0");


var $i2KZ1 = parcelRequire("i2KZ1");

var $9HMNu = parcelRequire("9HMNu");

var $7v5wN = parcelRequire("7v5wN");
var $eb1380631b48ac41$export$11e33e7efe21f393;
var $eb1380631b48ac41$export$7e4bdd3a42fd53ce;
var $eb1380631b48ac41$export$664c6d24e3175067;
$eb1380631b48ac41$export$11e33e7efe21f393 = `Pn2q8W_AchievementFeed`;
$eb1380631b48ac41$export$7e4bdd3a42fd53ce = `Pn2q8W_achievementContainer`;
$eb1380631b48ac41$export$664c6d24e3175067 = `Pn2q8W_visible`;



var $9h2J6 = parcelRequire("9h2J6");

var $6dpjF = parcelRequire("6dpjF");

var $9h2J6 = parcelRequire("9h2J6");

var $7v5wN = parcelRequire("7v5wN");

var $7RNO0 = parcelRequire("7RNO0");
function $6cb1a99f9aa0be69$export$2e2bcd8739ae039({ icon: icon, onLoaded: onLoaded }) {
    const { themeId: themeId } = (0, $7v5wN.useTheme)();
    function getIcon() {
        if ($6cb1a99f9aa0be69$var$achievementIcon[themeId]?.[icon]) return $6cb1a99f9aa0be69$var$achievementIcon[themeId][icon];
        if ($6cb1a99f9aa0be69$var$defaultIcons[icon]) return $6cb1a99f9aa0be69$var$defaultIcons[icon];
        console.error('Showing fallback achievement icon');
        return '/assets/global/images/achievements/points.webp';
    }
    const src = getIcon();
    (0, $7RNO0.useEffect)(()=>{
        if (!onLoaded) return;
        const img = new Image();
        img.src = src;
        if (img.complete) setTimeout(onLoaded, 0);
        else img.onload = onLoaded;
    }, [
        icon,
        onLoaded
    ]);
    if (!src) return /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9h2J6.Fragment), {});
    // getTintFilterStyle('#8FFF97'))
    return /*#__PURE__*/ (0, $9h2J6.jsx)("img", {
        src: src,
        alt: " ",
        onError: (e)=>{
            e.target.style.display = 'none';
        }
    });
}
const $6cb1a99f9aa0be69$var$defaultIcons = {
    badge: '/assets/global/images/achievements/badge.webp',
    mission: '/assets/global/images/achievements/mission.webp',
    points: '/assets/global/images/achievements/points.webp',
    quest: '/assets/global/images/achievements/quest.webp',
    social: '/assets/global/images/achievements/social.webp',
    title: '/assets/global/images/achievements/title.webp',
    tb: '/assets/global/images/achievements/tb.webp'
};
const $6cb1a99f9aa0be69$var$achievementIcon = {
};


var $c2fb0b0d4fa0ad04$exports = {};

$parcel$export($c2fb0b0d4fa0ad04$exports, "Achievement", function () { return $c2fb0b0d4fa0ad04$export$27fdeeaa680fc644; }, function (v) { return $c2fb0b0d4fa0ad04$export$27fdeeaa680fc644 = v; });
$parcel$export($c2fb0b0d4fa0ad04$exports, "background", function () { return $c2fb0b0d4fa0ad04$export$8ce1fd94bee2f412; }, function (v) { return $c2fb0b0d4fa0ad04$export$8ce1fd94bee2f412 = v; });
$parcel$export($c2fb0b0d4fa0ad04$exports, "clickable", function () { return $c2fb0b0d4fa0ad04$export$60d5655c6babb2a0; }, function (v) { return $c2fb0b0d4fa0ad04$export$60d5655c6babb2a0 = v; });
$parcel$export($c2fb0b0d4fa0ad04$exports, "danger", function () { return $c2fb0b0d4fa0ad04$export$7c4df8d735fa2705; }, function (v) { return $c2fb0b0d4fa0ad04$export$7c4df8d735fa2705 = v; });
$parcel$export($c2fb0b0d4fa0ad04$exports, "hasLineBreak", function () { return $c2fb0b0d4fa0ad04$export$32e2daa08ede162f; }, function (v) { return $c2fb0b0d4fa0ad04$export$32e2daa08ede162f = v; });
$parcel$export($c2fb0b0d4fa0ad04$exports, "highlighted", function () { return $c2fb0b0d4fa0ad04$export$ba6acb6e4dfd83c2; }, function (v) { return $c2fb0b0d4fa0ad04$export$ba6acb6e4dfd83c2 = v; });
$parcel$export($c2fb0b0d4fa0ad04$exports, "icon", function () { return $c2fb0b0d4fa0ad04$export$1ca1ec8b29a4ce27; }, function (v) { return $c2fb0b0d4fa0ad04$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($c2fb0b0d4fa0ad04$exports, "label", function () { return $c2fb0b0d4fa0ad04$export$1237798dc640739a; }, function (v) { return $c2fb0b0d4fa0ad04$export$1237798dc640739a = v; });
$parcel$export($c2fb0b0d4fa0ad04$exports, "success", function () { return $c2fb0b0d4fa0ad04$export$fe7c49d056ea1d88; }, function (v) { return $c2fb0b0d4fa0ad04$export$fe7c49d056ea1d88 = v; });
$parcel$export($c2fb0b0d4fa0ad04$exports, "visible", function () { return $c2fb0b0d4fa0ad04$export$664c6d24e3175067; }, function (v) { return $c2fb0b0d4fa0ad04$export$664c6d24e3175067 = v; });
var $c2fb0b0d4fa0ad04$export$27fdeeaa680fc644;
var $c2fb0b0d4fa0ad04$export$8ce1fd94bee2f412;
var $c2fb0b0d4fa0ad04$export$60d5655c6babb2a0;
var $c2fb0b0d4fa0ad04$export$7c4df8d735fa2705;
var $c2fb0b0d4fa0ad04$export$32e2daa08ede162f;
var $c2fb0b0d4fa0ad04$export$ba6acb6e4dfd83c2;
var $c2fb0b0d4fa0ad04$export$1ca1ec8b29a4ce27;
var $c2fb0b0d4fa0ad04$export$1237798dc640739a;
var $c2fb0b0d4fa0ad04$export$fe7c49d056ea1d88;
var $c2fb0b0d4fa0ad04$export$664c6d24e3175067;
$c2fb0b0d4fa0ad04$export$27fdeeaa680fc644 = `MaV-MW_Achievement`;
$c2fb0b0d4fa0ad04$export$8ce1fd94bee2f412 = `MaV-MW_background`;
$c2fb0b0d4fa0ad04$export$60d5655c6babb2a0 = `MaV-MW_clickable`;
$c2fb0b0d4fa0ad04$export$7c4df8d735fa2705 = `MaV-MW_danger`;
$c2fb0b0d4fa0ad04$export$32e2daa08ede162f = `MaV-MW_hasLineBreak`;
$c2fb0b0d4fa0ad04$export$ba6acb6e4dfd83c2 = `MaV-MW_highlighted`;
$c2fb0b0d4fa0ad04$export$1ca1ec8b29a4ce27 = `MaV-MW_icon`;
$c2fb0b0d4fa0ad04$export$1237798dc640739a = `MaV-MW_label`;
$c2fb0b0d4fa0ad04$export$fe7c49d056ea1d88 = `MaV-MW_success`;
$c2fb0b0d4fa0ad04$export$664c6d24e3175067 = `MaV-MW_visible`;


function $cd4f58dea3f11543$export$2e2bcd8739ae039({ actionPrefix: actionPrefix, action: action, type: type, icon: icon, onLoaded: onLoaded, isVisible: isVisible = true, hasLineBreak: hasLineBreak, onClick: onClick }) {
    return /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
        onClick: onClick,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($c2fb0b0d4fa0ad04$exports.Achievement, $c2fb0b0d4fa0ad04$exports[type], {
            [$c2fb0b0d4fa0ad04$exports.visible]: isVisible,
            [$c2fb0b0d4fa0ad04$exports.clickable]: onClick
        }),
        "aria-label": `${actionPrefix} ${action}`,
        children: [
            /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                className: $c2fb0b0d4fa0ad04$exports.background
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                className: $c2fb0b0d4fa0ad04$exports.icon,
                children: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $6cb1a99f9aa0be69$export$2e2bcd8739ae039), {
                    icon: icon,
                    onLoaded: onLoaded
                })
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                className: $c2fb0b0d4fa0ad04$exports.label,
                children: /*#__PURE__*/ (0, $9h2J6.jsxs)("span", {
                    children: [
                        actionPrefix,
                        ' ',
                        /*#__PURE__*/ (0, $9h2J6.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($c2fb0b0d4fa0ad04$exports.highlighted, {
                                [$c2fb0b0d4fa0ad04$exports.hasLineBreak]: hasLineBreak
                            }),
                            children: action
                        })
                    ]
                })
            })
        ]
    });
}


const $85d3d15771e9730e$var$TRANSITION_IN_DURATION = 300; // Duplicated in scss
const $85d3d15771e9730e$var$ACHIEVEMENT_STATIC_DURATION = 4000;
const $85d3d15771e9730e$var$TRANSITION_OUT_DURATION = 120; // Duplicated in scss
const $85d3d15771e9730e$var$QUEUE_GAP_DURATION = 1000;
function $85d3d15771e9730e$export$2e2bcd8739ae039() {
    const dispatch = (0, $i2KZ1.useAppDispatch)();
    const { audio: audio } = (0, $f58c71b201a1c7d8$export$91047320af7bf70b)();
    const theme = (0, $7v5wN.useTheme)();
    const { achievementQueue: achievementQueue } = (0, $i2KZ1.useAppSelector)((state)=>state.app);
    const [isVisible, setIsVisible] = (0, $7RNO0.useState)(false); // Controls achievement CSS transition
    const isPlayingRef = (0, $7RNO0.useRef)(false); // If achievement animation is currently playing
    (0, $7RNO0.useEffect)(()=>{
        if (achievementQueue[0] && !isPlayingRef.current) {
            // Animate in
            isPlayingRef.current = true;
            setIsVisible(true);
            audio?.play($85d3d15771e9730e$var$getAudioNameByAchievementType(achievementQueue[0].type));
            setTimeout(()=>{
                // Animate out
                setIsVisible(false);
            }, $85d3d15771e9730e$var$TRANSITION_IN_DURATION + $85d3d15771e9730e$var$ACHIEVEMENT_STATIC_DURATION);
            setTimeout(()=>{
                // Delete achievement from queue
                dispatch((0, $9HMNu.removeFirstAchievementFromQueue)());
                isPlayingRef.current = false;
            }, $85d3d15771e9730e$var$TRANSITION_IN_DURATION + $85d3d15771e9730e$var$ACHIEVEMENT_STATIC_DURATION + $85d3d15771e9730e$var$TRANSITION_OUT_DURATION + $85d3d15771e9730e$var$QUEUE_GAP_DURATION);
        }
    }, [
        achievementQueue
    ]);
    const currentAchievement = achievementQueue[0];
    if (!currentAchievement) return /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9h2J6.Fragment), {});
    const hasProfileDrawer = theme.metadata?.customJSON?.profileDrawerV2?.enabled;
    const ON_CLICK_ACTIONS = {
        'open-profile': hasProfileDrawer ? ()=>dispatch((0, $9HMNu.openProfile)()) : undefined
    };
    return /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
        className: $eb1380631b48ac41$export$11e33e7efe21f393,
        children: /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
            role: "alert",
            "aria-live": "assertive",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($eb1380631b48ac41$export$7e4bdd3a42fd53ce, {
                [$eb1380631b48ac41$export$664c6d24e3175067]: isVisible
            }),
            children: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $cd4f58dea3f11543$export$2e2bcd8739ae039), {
                type: currentAchievement.type,
                icon: currentAchievement.icon,
                actionPrefix: currentAchievement.actionPrefix,
                action: currentAchievement.action,
                // onLoaded={() => setAchievementIsLoaded(true)}
                isVisible: isVisible,
                hasLineBreak: currentAchievement.hasLineBreak,
                onClick: ON_CLICK_ACTIONS[currentAchievement.onClickAction]
            })
        })
    });
}
function $85d3d15771e9730e$var$getAudioNameByAchievementType(type) {
    switch(type){
        case 'success':
            return 'positive-achievement';
        case 'danger':
            return 'negative-achievement';
        case 'default':
            return 'positive-achievement';
        default:
            return 'positive-achievement';
    }
}



var $9h2J6 = parcelRequire("9h2J6");

var $7RNO0 = parcelRequire("7RNO0");


var $6dpjF = parcelRequire("6dpjF");

var $7v5wN = parcelRequire("7v5wN");

var $i2KZ1 = parcelRequire("i2KZ1");

var $9HMNu = parcelRequire("9HMNu");

var $lmedS = parcelRequire("lmedS");


var $9S5u4 = parcelRequire("9S5u4");
var $3bb4b0bf77719dea$export$ba0edf94d39f51b8;
var $3bb4b0bf77719dea$export$2ba01fb71ed41cb6;
var $3bb4b0bf77719dea$export$d35c1ed5be9489b6;
var $3bb4b0bf77719dea$export$c4a068d767524312;
var $3bb4b0bf77719dea$export$b94e31e2de63b9f5;
var $3bb4b0bf77719dea$export$247e0fe57bb94f2;
var $3bb4b0bf77719dea$export$55ecc4b6d40d2156;
var $3bb4b0bf77719dea$export$9d5c241fe9ee2567;
var $3bb4b0bf77719dea$export$5eab89114764d15c;
$3bb4b0bf77719dea$export$ba0edf94d39f51b8 = `UAFalW_FloatingHeaderBar`;
$3bb4b0bf77719dea$export$2ba01fb71ed41cb6 = `UAFalW_button`;
$3bb4b0bf77719dea$export$d35c1ed5be9489b6 = `UAFalW_buttonStatus`;
$3bb4b0bf77719dea$export$c4a068d767524312 = `UAFalW_buttonsContainer`;
$3bb4b0bf77719dea$export$b94e31e2de63b9f5 = `UAFalW_expandButton`;
$3bb4b0bf77719dea$export$247e0fe57bb94f2 = `UAFalW_isExpanded`;
$3bb4b0bf77719dea$export$55ecc4b6d40d2156 = `UAFalW_isLeftAligned`;
$3bb4b0bf77719dea$export$9d5c241fe9ee2567 = `UAFalW_logoIcon`;
$3bb4b0bf77719dea$export$5eab89114764d15c = `UAFalW_noLogoIcon`;


function $a90a1d40555e811c$export$2e2bcd8739ae039({ classname: classname }) {
    const theme = (0, $7v5wN.useTheme)();
    const dispatch = (0, $i2KZ1.useAppDispatch)();
    const { isProfileOpen: isProfileOpen, isInformationOpen: isInformationOpen, isLocalePickerPanelVisible: isLocalePickerPanelVisible, isMyRewardsOpen: isMyRewardsOpen, isManuallyMuted: isManuallyMuted } = (0, $i2KZ1.useAppSelector)((state)=>state.app);
    const [isExpanded, setIsExpanded] = (0, $7RNO0.useState)(false);
    const { locationId: locationId } = (0, $0e3dfb59695be15b$export$99eaa27ddbbb95ef)();
    // Some buttons are only available inside locations
    const isInLocation = locationId;
    const hasInformationDrawer = theme.metadata?.customJSON?.informationDrawer?.enabled;
    const hasProfileDrawer = theme.metadata?.customJSON?.profileDrawerV2?.enabled;
    const hasDebugMenu = theme.metadata?.customJSON?.menu?.hasDebugMenuButton;
    const hasMuteButton = true;
    const logoImagePath = theme.metadata?.customJSON?.menu?.logoImagePath;
    const hasLocaleButton = false;
    const hasRewardsDrawer = theme.metadata?.customJSON?.rewardsDrawer?.enabled;
    const hasIframeRefresh = theme.metadata?.customJSON?.hasIframeRefresh?.enabled;
    return /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($3bb4b0bf77719dea$export$ba0edf94d39f51b8, classname, {
            [$3bb4b0bf77719dea$export$247e0fe57bb94f2]: isExpanded
        }),
        children: [
            /*#__PURE__*/ (0, $9h2J6.jsx)("button", {
                className: $3bb4b0bf77719dea$export$b94e31e2de63b9f5,
                onClick: ()=>setIsExpanded(!isExpanded),
                "aria-label": isExpanded ? 'Collapse menu' : 'Expand menu',
                children: logoImagePath ? /*#__PURE__*/ (0, $9h2J6.jsxs)((0, $9h2J6.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $9h2J6.jsx)("img", {
                            className: $3bb4b0bf77719dea$export$9d5c241fe9ee2567,
                            src: (0, $lmedS.pathToURL)(logoImagePath),
                            alt: "Logo Icon"
                        }),
                        /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                            className: $3bb4b0bf77719dea$export$d35c1ed5be9489b6,
                            children: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9S5u4.default), {
                                type: isExpanded ? 'close' : 'menu',
                                size: 12
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9S5u4.default), {
                    className: $3bb4b0bf77719dea$export$5eab89114764d15c,
                    type: isExpanded ? 'close' : 'menu',
                    size: 30
                })
            }),
            /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                className: $3bb4b0bf77719dea$export$c4a068d767524312,
                inert: !isExpanded ? '' : undefined,
                children: [
                    hasProfileDrawer && isInLocation && /*#__PURE__*/ (0, $9h2J6.jsx)((0, $032b472fd8d5e329$export$2e2bcd8739ae039), {
                        buttonStyle: "round",
                        iconType: "profile",
                        // title={isProfileOpen ? 'Close Profile' : 'Open Profile'}
                        ariaLabel: isProfileOpen ? 'Close Profile' : 'Open Profile',
                        onClick: ()=>{
                            isProfileOpen ? dispatch((0, $9HMNu.closeProfile)()) : dispatch((0, $9HMNu.openProfile)());
                        },
                        className: $3bb4b0bf77719dea$export$2ba01fb71ed41cb6
                    }),
                    hasInformationDrawer && /*#__PURE__*/ (0, $9h2J6.jsx)((0, $032b472fd8d5e329$export$2e2bcd8739ae039), {
                        buttonStyle: "round",
                        iconType: "info",
                        // title={isInformationOpen ? 'Close Information' : 'Open Information'}
                        ariaLabel: isInformationOpen ? 'Close Information' : 'Open Information',
                        onClick: ()=>{
                            dispatch((0, $9HMNu.setIsInformationOpen)(!isInformationOpen));
                        },
                        className: $3bb4b0bf77719dea$export$2ba01fb71ed41cb6
                    }),
                    hasRewardsDrawer && /*#__PURE__*/ (0, $9h2J6.jsx)((0, $032b472fd8d5e329$export$2e2bcd8739ae039), {
                        buttonStyle: "round",
                        iconType: "grade",
                        // title={isMyRewardsOpen ? 'Close My Rewards' : 'Open My Rewards'}
                        ariaLabel: isMyRewardsOpen ? 'Close My Rewards' : 'Open My Rewards',
                        onClick: ()=>dispatch((0, $9HMNu.setIsMyRewardsOpen)(!isMyRewardsOpen)),
                        className: $3bb4b0bf77719dea$export$2ba01fb71ed41cb6
                    }),
                    hasLocaleButton && /*#__PURE__*/ (0, $9h2J6.jsx)((0, $032b472fd8d5e329$export$2e2bcd8739ae039), {
                        buttonStyle: "round",
                        iconType: "translation",
                        // title={isLocalePickerPanelVisible ? 'Close Language Picker' : 'Change Language'}
                        ariaLabel: isLocalePickerPanelVisible ? 'Close Language Picker' : 'Change Language',
                        onClick: ()=>{
                            dispatch((0, $9HMNu.setIsLocalePickerPanelVisible)(!isLocalePickerPanelVisible));
                        },
                        className: $3bb4b0bf77719dea$export$2ba01fb71ed41cb6
                    }),
                    hasMuteButton && /*#__PURE__*/ (0, $9h2J6.jsx)((0, $032b472fd8d5e329$export$2e2bcd8739ae039), {
                        buttonStyle: "round",
                        iconType: isManuallyMuted ? 'muted' : 'unmuted',
                        // title={isManuallyMuted ? 'Unmute' : 'Mute'}
                        ariaLabel: isManuallyMuted ? 'Unmute' : 'Mute',
                        onClick: ()=>{
                            dispatch((0, $9HMNu.setIsManuallyMuted)(!isManuallyMuted));
                        },
                        className: $3bb4b0bf77719dea$export$2ba01fb71ed41cb6
                    }),
                    hasDebugMenu && /*#__PURE__*/ (0, $9h2J6.jsx)((0, $032b472fd8d5e329$export$2e2bcd8739ae039), {
                        ariaLabel: "debug",
                        buttonStyle: "round",
                        iconType: "help",
                        onClick: ()=>{
                            dispatch((0, $9HMNu.toggleDebugMenu)());
                        },
                        className: $3bb4b0bf77719dea$export$2ba01fb71ed41cb6
                    }),
                    hasIframeRefresh && /*#__PURE__*/ (0, $9h2J6.jsx)((0, $032b472fd8d5e329$export$2e2bcd8739ae039), {
                        ariaLabel: "Refresh",
                        buttonStyle: "round",
                        iconType: "refresh",
                        onClick: ()=>dispatch((0, $9HMNu.setIsRefreshModalOpen)(true)),
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($3bb4b0bf77719dea$export$2ba01fb71ed41cb6)
                    })
                ]
            })
        ]
    });
}



var $9h2J6 = parcelRequire("9h2J6");

var $7RNO0 = parcelRequire("7RNO0");

var $6dpjF = parcelRequire("6dpjF");

var $cTs7K = parcelRequire("cTs7K");

var $7v5wN = parcelRequire("7v5wN");

var $6KpYp = parcelRequire("6KpYp");

var $1afSf = parcelRequire("1afSf");

var $i2KZ1 = parcelRequire("i2KZ1");

var $9HMNu = parcelRequire("9HMNu");



var $9S5u4 = parcelRequire("9S5u4");

var $kFQy0 = parcelRequire("kFQy0");

var $lmedS = parcelRequire("lmedS");

var $guTIo = parcelRequire("guTIo");

var $9h2J6 = parcelRequire("9h2J6");

var $7RNO0 = parcelRequire("7RNO0");

var $6dpjF = parcelRequire("6dpjF");

var $lmedS = parcelRequire("lmedS");
var $6722765ebbf0f5d2$export$f8ab115d87e210a;
var $6722765ebbf0f5d2$export$73920f18ca706874;
var $6722765ebbf0f5d2$export$5c452ff88e35e47d;
var $6722765ebbf0f5d2$export$c7187bbd1a7a9244;
var $6722765ebbf0f5d2$export$4a6dd88bada4e7d2;
var $6722765ebbf0f5d2$export$e14a7373aa46b344;
$6722765ebbf0f5d2$export$f8ab115d87e210a = `oDT0tG_LevelBadge`;
$6722765ebbf0f5d2$export$73920f18ca706874 = `oDT0tG_hidden`;
$6722765ebbf0f5d2$export$5c452ff88e35e47d = `oDT0tG_image`;
$6722765ebbf0f5d2$export$c7187bbd1a7a9244 = `oDT0tG_placeholder`;
$6722765ebbf0f5d2$export$4a6dd88bada4e7d2 = `oDT0tG_shimmer`;
$6722765ebbf0f5d2$export$4a6dd88bada4e7d2;
$6722765ebbf0f5d2$export$e14a7373aa46b344 = `oDT0tG_shiny`;


function $0358faef824b4d47$export$2e2bcd8739ae039({ imagePath: imagePath, isLoading: isLoading, isLocked: isLocked, classname: classname, shimmerDelay: shimmerDelay = 0 }) {
    const [imageIsLoading, setImageIsLoading] = (0, $7RNO0.useState)(true);
    const shouldShowPlaceholder = isLoading || imageIsLoading;
    const imageUrl = imagePath ? (0, $lmedS.pathToURL)(imagePath) : '';
    const handleImageLoad = ()=>{
        setImageIsLoading(false);
    };
    // Once loaded, show padlock icon if locked
    if (!isLoading && isLocked) return /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($6722765ebbf0f5d2$export$f8ab115d87e210a, classname),
        children: /*#__PURE__*/ (0, $9h2J6.jsxs)("svg", {
            className: $6722765ebbf0f5d2$export$5c452ff88e35e47d,
            width: "127",
            height: "111",
            viewBox: "0 0 127 111",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M125.557 53C126.45 54.547 126.45 56.453 125.557 58L96.6934 107.993C95.8002 109.54 94.1496 110.493 92.3632 110.493L34.6368 110.493C32.8504 110.493 31.1998 109.54 30.3066 107.993L1.44338 58C0.550221 56.453 0.550214 54.547 1.44338 53L30.3066 3.00738C31.1998 1.46038 32.8504 0.507385 34.6368 0.507385L92.3632 0.507388C94.1496 0.507388 95.8002 1.46038 96.6934 3.00739L125.557 53Z",
                    fill: "#4E4E4E"
                }),
                /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M85.8068 55.3966L85.6556 51.8232C84.9669 50.9671 84.4713 50.355 83.7825 49.4989L80.5529 48.6097L80.7209 48.0969L82.0858 43.8783L82.4932 38.6754L80.8973 33.6959L77.3737 29.8289L72.6994 27.5087L67.4832 27L62.5065 28.6378L58.4874 31.9465L55.8499 36.471L54.6698 40.7475L54.5606 41.1321L51.499 40.2801C50.4364 40.6855 49.6931 40.9667 48.6263 41.372L46.6986 44.4077L43.3976 48.8496L45.7873 54.5322L44.4224 58.6763L43.2422 62.8163L41.4699 63.6765L40 67.9737L43.3598 71.3444L46.56 74.8309L49.7057 78.3711L52.9101 81.8535L56.1607 82.8254L56.9586 83.0612L60.2429 84L64.8122 82.6186L69.4655 81.5433L74.0097 80.0792L78.6294 78.8633L79.6962 74.4752L78.8184 72.8209L79.9187 68.6974L81.0107 64.4913L86 60.86L85.8068 55.4007V55.3966ZM66.0217 61.4928L64.7786 71.2782L55.8625 68.7595L60.0749 59.8137L57.6558 55.5165L65.8411 51.0457L70.3811 59.1064L66.0175 61.4887L66.0217 61.4928ZM75.908 43.3696L74.837 47.0257L73.8711 46.7569L68.0502 44.966L67.2775 44.6434L61.3558 43.2125L60.6166 42.985L61.7254 39.2958C61.9396 38.5886 62.2839 37.9269 62.7459 37.3437L64.4384 35.2096C65.0978 34.3742 66.0721 33.8365 67.1389 33.7083L69.4151 33.4395C70.4525 33.3154 71.4982 33.5925 72.334 34.2129L74.1903 35.5901C75.0722 36.2436 75.6434 37.2238 75.7736 38.2991L76.1012 41.0577C76.1936 41.8352 76.1264 42.6252 75.908 43.3779V43.3696Z",
                    fill: "#1D1D1D"
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($6722765ebbf0f5d2$export$f8ab115d87e210a, classname),
        children: [
            /*#__PURE__*/ (0, $9h2J6.jsx)("img", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($6722765ebbf0f5d2$export$5c452ff88e35e47d, {
                    [$6722765ebbf0f5d2$export$73920f18ca706874]: shouldShowPlaceholder
                }),
                src: imageUrl,
                alt: " ",
                crossOrigin: "anonymous",
                onLoad: handleImageLoad
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)("svg", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($6722765ebbf0f5d2$export$5c452ff88e35e47d, $6722765ebbf0f5d2$export$c7187bbd1a7a9244, {
                    [$6722765ebbf0f5d2$export$73920f18ca706874]: !shouldShowPlaceholder
                }),
                width: "127",
                height: "111",
                viewBox: "0 0 127 111",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
                    d: "M125.557 53C126.45 54.547 126.45 56.453 125.557 58L96.6934 107.993C95.8002 109.54 94.1496 110.493 92.3632 110.493L34.6368 110.493C32.8504 110.493 31.1998 109.54 30.3066 107.993L1.44338 58C0.550221 56.453 0.550214 54.547 1.44338 53L30.3066 3.00738C31.1998 1.46038 32.8504 0.507385 34.6368 0.507385L92.3632 0.507388C94.1496 0.507388 95.8002 1.46038 96.6934 3.00739L125.557 53Z",
                    fill: "#1B1B1B"
                })
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                className: $6722765ebbf0f5d2$export$e14a7373aa46b344,
                style: {
                    maskImage: `url(${imageUrl})`
                },
                children: /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                    style: {
                        animationDelay: `${shimmerDelay * 2}s`
                    }
                })
            })
        ]
    });
}



var $9h2J6 = parcelRequire("9h2J6");

var $6dpjF = parcelRequire("6dpjF");

var $9S5u4 = parcelRequire("9S5u4");
var $8a0b94acb74bc777$export$f33936b5e796863b;
var $8a0b94acb74bc777$export$5bb2c6667794e5f8;
var $8a0b94acb74bc777$export$1ca1ec8b29a4ce27;
var $8a0b94acb74bc777$export$acf4eaf431084f78;
var $8a0b94acb74bc777$export$4662439d93cf9393;
var $8a0b94acb74bc777$export$ff6b2b0d8ced9310;
$8a0b94acb74bc777$export$f33936b5e796863b = `_15WVcW_RoundProgressBar`;
$8a0b94acb74bc777$export$5bb2c6667794e5f8 = `_15WVcW_backgroundCircle`;
$8a0b94acb74bc777$export$1ca1ec8b29a4ce27 = `_15WVcW_icon`;
$8a0b94acb74bc777$export$acf4eaf431084f78 = `_15WVcW_iconContainer`;
$8a0b94acb74bc777$export$4662439d93cf9393 = `_15WVcW_progressCircle`;
$8a0b94acb74bc777$export$ff6b2b0d8ced9310 = `_15WVcW_progressSvg`;


function $7edc08a8d10e5d25$export$2e2bcd8739ae039({ percent: percent, className: className, icon: icon }) {
    const radius = 45;
    const circumference = 2 * Math.PI * radius;
    if (percent === 0) percent = 1; // Minimum is 1% as looks better
    const strokeDashoffset = percent ? circumference - percent / 100 * circumference : 0;
    return /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($8a0b94acb74bc777$export$f33936b5e796863b, className),
        "aria-label": `Progress: ${percent}%`,
        children: [
            /*#__PURE__*/ (0, $9h2J6.jsxs)("svg", {
                className: $8a0b94acb74bc777$export$ff6b2b0d8ced9310,
                viewBox: "0 0 100 100",
                children: [
                    /*#__PURE__*/ (0, $9h2J6.jsx)("circle", {
                        className: $8a0b94acb74bc777$export$5bb2c6667794e5f8,
                        cx: "50",
                        cy: "50",
                        r: radius,
                        strokeWidth: "8",
                        fill: "none"
                    }),
                    /*#__PURE__*/ (0, $9h2J6.jsx)("circle", {
                        className: $8a0b94acb74bc777$export$4662439d93cf9393,
                        cx: "50",
                        cy: "50",
                        r: radius,
                        strokeWidth: "8",
                        fill: "none",
                        strokeDasharray: circumference,
                        strokeDashoffset: strokeDashoffset
                    })
                ]
            }),
            icon && /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                className: $8a0b94acb74bc777$export$acf4eaf431084f78,
                children: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9S5u4.default), {
                    type: icon,
                    className: $8a0b94acb74bc777$export$1ca1ec8b29a4ce27
                })
            })
        ]
    });
}



var $9h2J6 = parcelRequire("9h2J6");

var $6dpjF = parcelRequire("6dpjF");
var $042c1372152d45f5$export$4901f5ee9fa34af9;
var $042c1372152d45f5$export$e141060ad697f932;
var $042c1372152d45f5$export$4a6dd88bada4e7d2;
$042c1372152d45f5$export$4901f5ee9fa34af9 = `KoX25a_ShinyLoader`;
$042c1372152d45f5$export$e141060ad697f932 = `KoX25a_isLoaded`;
$042c1372152d45f5$export$4a6dd88bada4e7d2 = `KoX25a_shimmer`;
$042c1372152d45f5$export$4a6dd88bada4e7d2;


function $07c52129b6fee7d3$export$2e2bcd8739ae039({ isLoaded: isLoaded, className: className }) {
    return /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($042c1372152d45f5$export$4901f5ee9fa34af9, {
            [$042c1372152d45f5$export$e141060ad697f932]: isLoaded
        }, className)
    });
}



var $9h2J6 = parcelRequire("9h2J6");

var $6dpjF = parcelRequire("6dpjF");
var $5a456a47225b9b37$exports = {};

$parcel$export($5a456a47225b9b37$exports, "Badge", function () { return $5a456a47225b9b37$export$37acb3580601e69a; }, function (v) { return $5a456a47225b9b37$export$37acb3580601e69a = v; });
$parcel$export($5a456a47225b9b37$exports, "common", function () { return $5a456a47225b9b37$export$919daad019702595; }, function (v) { return $5a456a47225b9b37$export$919daad019702595 = v; });
$parcel$export($5a456a47225b9b37$exports, "epic", function () { return $5a456a47225b9b37$export$8ec5145af6f76965; }, function (v) { return $5a456a47225b9b37$export$8ec5145af6f76965 = v; });
$parcel$export($5a456a47225b9b37$exports, "legendary", function () { return $5a456a47225b9b37$export$9738149b23403ba; }, function (v) { return $5a456a47225b9b37$export$9738149b23403ba = v; });
$parcel$export($5a456a47225b9b37$exports, "rare", function () { return $5a456a47225b9b37$export$b2e68d2f08b863d2; }, function (v) { return $5a456a47225b9b37$export$b2e68d2f08b863d2 = v; });
$parcel$export($5a456a47225b9b37$exports, "uncommon", function () { return $5a456a47225b9b37$export$76bf72d8613283e6; }, function (v) { return $5a456a47225b9b37$export$76bf72d8613283e6 = v; });
var $5a456a47225b9b37$export$37acb3580601e69a;
var $5a456a47225b9b37$export$919daad019702595;
var $5a456a47225b9b37$export$8ec5145af6f76965;
var $5a456a47225b9b37$export$9738149b23403ba;
var $5a456a47225b9b37$export$b2e68d2f08b863d2;
var $5a456a47225b9b37$export$76bf72d8613283e6;
$5a456a47225b9b37$export$37acb3580601e69a = `KzALYW_Badge`;
$5a456a47225b9b37$export$919daad019702595 = `KzALYW_common`;
$5a456a47225b9b37$export$8ec5145af6f76965 = `KzALYW_epic`;
$5a456a47225b9b37$export$9738149b23403ba = `KzALYW_legendary`;
$5a456a47225b9b37$export$b2e68d2f08b863d2 = `KzALYW_rare`;
$5a456a47225b9b37$export$76bf72d8613283e6 = `KzALYW_uncommon`;


function $8df794fe4c83106a$export$2e2bcd8739ae039({ text: text, rarity: rarity, classname: classname }) {
    return /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($5a456a47225b9b37$exports.Badge, $5a456a47225b9b37$exports[rarity?.toLowerCase()], classname),
        children: /*#__PURE__*/ (0, $9h2J6.jsxs)("p", {
            children: [
                "\u201C",
                text,
                "\u201C"
            ]
        })
    });
}


var $7e3da1a838642936$exports = {};
// shim for using process in browser
var $7e3da1a838642936$var$process = $7e3da1a838642936$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $7e3da1a838642936$var$cachedSetTimeout;
var $7e3da1a838642936$var$cachedClearTimeout;
function $7e3da1a838642936$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $7e3da1a838642936$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $7e3da1a838642936$var$cachedSetTimeout = setTimeout;
        else $7e3da1a838642936$var$cachedSetTimeout = $7e3da1a838642936$var$defaultSetTimout;
    } catch (e) {
        $7e3da1a838642936$var$cachedSetTimeout = $7e3da1a838642936$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $7e3da1a838642936$var$cachedClearTimeout = clearTimeout;
        else $7e3da1a838642936$var$cachedClearTimeout = $7e3da1a838642936$var$defaultClearTimeout;
    } catch (e) {
        $7e3da1a838642936$var$cachedClearTimeout = $7e3da1a838642936$var$defaultClearTimeout;
    }
})();
function $7e3da1a838642936$var$runTimeout(fun) {
    if ($7e3da1a838642936$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($7e3da1a838642936$var$cachedSetTimeout === $7e3da1a838642936$var$defaultSetTimout || !$7e3da1a838642936$var$cachedSetTimeout) && setTimeout) {
        $7e3da1a838642936$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $7e3da1a838642936$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $7e3da1a838642936$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $7e3da1a838642936$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $7e3da1a838642936$var$runClearTimeout(marker) {
    if ($7e3da1a838642936$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($7e3da1a838642936$var$cachedClearTimeout === $7e3da1a838642936$var$defaultClearTimeout || !$7e3da1a838642936$var$cachedClearTimeout) && clearTimeout) {
        $7e3da1a838642936$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $7e3da1a838642936$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $7e3da1a838642936$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $7e3da1a838642936$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $7e3da1a838642936$var$queue = [];
var $7e3da1a838642936$var$draining = false;
var $7e3da1a838642936$var$currentQueue;
var $7e3da1a838642936$var$queueIndex = -1;
function $7e3da1a838642936$var$cleanUpNextTick() {
    if (!$7e3da1a838642936$var$draining || !$7e3da1a838642936$var$currentQueue) return;
    $7e3da1a838642936$var$draining = false;
    if ($7e3da1a838642936$var$currentQueue.length) $7e3da1a838642936$var$queue = $7e3da1a838642936$var$currentQueue.concat($7e3da1a838642936$var$queue);
    else $7e3da1a838642936$var$queueIndex = -1;
    if ($7e3da1a838642936$var$queue.length) $7e3da1a838642936$var$drainQueue();
}
function $7e3da1a838642936$var$drainQueue() {
    if ($7e3da1a838642936$var$draining) return;
    var timeout = $7e3da1a838642936$var$runTimeout($7e3da1a838642936$var$cleanUpNextTick);
    $7e3da1a838642936$var$draining = true;
    var len = $7e3da1a838642936$var$queue.length;
    while(len){
        $7e3da1a838642936$var$currentQueue = $7e3da1a838642936$var$queue;
        $7e3da1a838642936$var$queue = [];
        while(++$7e3da1a838642936$var$queueIndex < len)if ($7e3da1a838642936$var$currentQueue) $7e3da1a838642936$var$currentQueue[$7e3da1a838642936$var$queueIndex].run();
        $7e3da1a838642936$var$queueIndex = -1;
        len = $7e3da1a838642936$var$queue.length;
    }
    $7e3da1a838642936$var$currentQueue = null;
    $7e3da1a838642936$var$draining = false;
    $7e3da1a838642936$var$runClearTimeout(timeout);
}
$7e3da1a838642936$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $7e3da1a838642936$var$queue.push(new $7e3da1a838642936$var$Item(fun, args));
    if ($7e3da1a838642936$var$queue.length === 1 && !$7e3da1a838642936$var$draining) $7e3da1a838642936$var$runTimeout($7e3da1a838642936$var$drainQueue);
};
// v8 likes predictible objects
function $7e3da1a838642936$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$7e3da1a838642936$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$7e3da1a838642936$var$process.title = 'browser';
$7e3da1a838642936$var$process.browser = true;
$7e3da1a838642936$var$process.env = {};
$7e3da1a838642936$var$process.argv = [];
$7e3da1a838642936$var$process.version = ''; // empty string to avoid regexp issues
$7e3da1a838642936$var$process.versions = {};
function $7e3da1a838642936$var$noop() {}
$7e3da1a838642936$var$process.on = $7e3da1a838642936$var$noop;
$7e3da1a838642936$var$process.addListener = $7e3da1a838642936$var$noop;
$7e3da1a838642936$var$process.once = $7e3da1a838642936$var$noop;
$7e3da1a838642936$var$process.off = $7e3da1a838642936$var$noop;
$7e3da1a838642936$var$process.removeListener = $7e3da1a838642936$var$noop;
$7e3da1a838642936$var$process.removeAllListeners = $7e3da1a838642936$var$noop;
$7e3da1a838642936$var$process.emit = $7e3da1a838642936$var$noop;
$7e3da1a838642936$var$process.prependListener = $7e3da1a838642936$var$noop;
$7e3da1a838642936$var$process.prependOnceListener = $7e3da1a838642936$var$noop;
$7e3da1a838642936$var$process.listeners = function(name) {
    return [];
};
$7e3da1a838642936$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$7e3da1a838642936$var$process.cwd = function() {
    return '/';
};
$7e3da1a838642936$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$7e3da1a838642936$var$process.umask = function() {
    return 0;
};


function $ff392f68f74a28fc$export$f85c16a6d62f7d63(url, baseUrl) {
    // url is absolute already
    if (url.match(/^[a-z]+:\/\//i)) return url;
    // url is absolute already, without protocol
    if (url.match(/^\/\//)) return window.location.protocol + url;
    // dataURI, mailto:, tel:, etc.
    if (url.match(/^[a-z]+:/i)) return url;
    const doc = document.implementation.createHTMLDocument();
    const base = doc.createElement('base');
    const a = doc.createElement('a');
    doc.head.appendChild(base);
    doc.body.appendChild(a);
    if (baseUrl) base.href = baseUrl;
    a.href = url;
    return a.href;
}
const $ff392f68f74a28fc$export$31b40729666a4ae0 = (()=>{
    // generate uuid for className of pseudo elements.
    // We should not use GUIDs, otherwise pseudo elements sometimes cannot be captured.
    let counter = 0;
    // ref: http://stackoverflow.com/a/6248722/2519373
    const random = ()=>// eslint-disable-next-line no-bitwise
        `0000${(Math.random() * 36 ** 4 << 0).toString(36)}`.slice(-4);
    return ()=>{
        counter += 1;
        return `u${random()}${counter}`;
    };
})();
function $ff392f68f74a28fc$export$1391212d75b2ee65(ms) {
    return (args)=>new Promise((resolve)=>{
            setTimeout(()=>resolve(args), ms);
        });
}
function $ff392f68f74a28fc$export$45b10814cc054894(arrayLike) {
    const arr = [];
    for(let i = 0, l = arrayLike.length; i < l; i++)arr.push(arrayLike[i]);
    return arr;
}
let $ff392f68f74a28fc$var$styleProps = null;
function $ff392f68f74a28fc$export$be6bf80faea8d5af(options = {}) {
    if ($ff392f68f74a28fc$var$styleProps) return $ff392f68f74a28fc$var$styleProps;
    if (options.includeStyleProperties) {
        $ff392f68f74a28fc$var$styleProps = options.includeStyleProperties;
        return $ff392f68f74a28fc$var$styleProps;
    }
    $ff392f68f74a28fc$var$styleProps = $ff392f68f74a28fc$export$45b10814cc054894(window.getComputedStyle(document.documentElement));
    return $ff392f68f74a28fc$var$styleProps;
}
function $ff392f68f74a28fc$var$px(node, styleProperty) {
    const win = node.ownerDocument.defaultView || window;
    const val = win.getComputedStyle(node).getPropertyValue(styleProperty);
    return val ? parseFloat(val.replace('px', '')) : 0;
}
function $ff392f68f74a28fc$var$getNodeWidth(node) {
    const leftBorder = $ff392f68f74a28fc$var$px(node, 'border-left-width');
    const rightBorder = $ff392f68f74a28fc$var$px(node, 'border-right-width');
    return node.clientWidth + leftBorder + rightBorder;
}
function $ff392f68f74a28fc$var$getNodeHeight(node) {
    const topBorder = $ff392f68f74a28fc$var$px(node, 'border-top-width');
    const bottomBorder = $ff392f68f74a28fc$var$px(node, 'border-bottom-width');
    return node.clientHeight + topBorder + bottomBorder;
}
function $ff392f68f74a28fc$export$ada5537b2c061996(targetNode, options = {}) {
    const width = options.width || $ff392f68f74a28fc$var$getNodeWidth(targetNode);
    const height = options.height || $ff392f68f74a28fc$var$getNodeHeight(targetNode);
    return {
        width: width,
        height: height
    };
}
function $ff392f68f74a28fc$export$d39ce20a37bba061() {
    let ratio;
    let FINAL_PROCESS;
    try {
        FINAL_PROCESS = $7e3da1a838642936$exports;
    } catch (e) {
    // pass
    }
    const val = FINAL_PROCESS && FINAL_PROCESS.env ? FINAL_PROCESS.env.devicePixelRatio : null;
    if (val) {
        ratio = parseInt(val, 10);
        if (Number.isNaN(ratio)) ratio = 1;
    }
    return ratio || window.devicePixelRatio || 1;
}
// @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/canvas#maximum_canvas_size
const $ff392f68f74a28fc$var$canvasDimensionLimit = 16384;
function $ff392f68f74a28fc$export$c2c809a2fe6b0f1a(canvas) {
    if (canvas.width > $ff392f68f74a28fc$var$canvasDimensionLimit || canvas.height > $ff392f68f74a28fc$var$canvasDimensionLimit) {
        if (canvas.width > $ff392f68f74a28fc$var$canvasDimensionLimit && canvas.height > $ff392f68f74a28fc$var$canvasDimensionLimit) {
            if (canvas.width > canvas.height) {
                canvas.height *= $ff392f68f74a28fc$var$canvasDimensionLimit / canvas.width;
                canvas.width = $ff392f68f74a28fc$var$canvasDimensionLimit;
            } else {
                canvas.width *= $ff392f68f74a28fc$var$canvasDimensionLimit / canvas.height;
                canvas.height = $ff392f68f74a28fc$var$canvasDimensionLimit;
            }
        } else if (canvas.width > $ff392f68f74a28fc$var$canvasDimensionLimit) {
            canvas.height *= $ff392f68f74a28fc$var$canvasDimensionLimit / canvas.width;
            canvas.width = $ff392f68f74a28fc$var$canvasDimensionLimit;
        } else {
            canvas.width *= $ff392f68f74a28fc$var$canvasDimensionLimit / canvas.height;
            canvas.height = $ff392f68f74a28fc$var$canvasDimensionLimit;
        }
    }
}
function $ff392f68f74a28fc$export$403d539f215df596(canvas, options = {}) {
    if (canvas.toBlob) return new Promise((resolve)=>{
        canvas.toBlob(resolve, options.type ? options.type : 'image/png', options.quality ? options.quality : 1);
    });
    return new Promise((resolve)=>{
        const binaryString = window.atob(canvas.toDataURL(options.type ? options.type : undefined, options.quality ? options.quality : undefined).split(',')[1]);
        const len = binaryString.length;
        const binaryArray = new Uint8Array(len);
        for(let i = 0; i < len; i += 1)binaryArray[i] = binaryString.charCodeAt(i);
        resolve(new Blob([
            binaryArray
        ], {
            type: options.type ? options.type : 'image/png'
        }));
    });
}
function $ff392f68f74a28fc$export$ec664d7487540b(url) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.onload = ()=>{
            img.decode().then(()=>{
                requestAnimationFrame(()=>resolve(img));
            });
        };
        img.onerror = reject;
        img.crossOrigin = 'anonymous';
        img.decoding = 'async';
        img.src = url;
    });
}
async function $ff392f68f74a28fc$export$fe77aa9c02de4599(svg) {
    return Promise.resolve().then(()=>new XMLSerializer().serializeToString(svg)).then(encodeURIComponent).then((html)=>`data:image/svg+xml;charset=utf-8,${html}`);
}
async function $ff392f68f74a28fc$export$b62810fb8ca515fa(node, width, height) {
    const xmlns = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(xmlns, 'svg');
    const foreignObject = document.createElementNS(xmlns, 'foreignObject');
    svg.setAttribute('width', `${width}`);
    svg.setAttribute('height', `${height}`);
    svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
    foreignObject.setAttribute('width', '100%');
    foreignObject.setAttribute('height', '100%');
    foreignObject.setAttribute('x', '0');
    foreignObject.setAttribute('y', '0');
    foreignObject.setAttribute('externalResourcesRequired', 'true');
    svg.appendChild(foreignObject);
    foreignObject.appendChild(node);
    return $ff392f68f74a28fc$export$fe77aa9c02de4599(svg);
}
const $ff392f68f74a28fc$export$3a92fc9ec83ef360 = (node, instance)=>{
    if (node instanceof instance) return true;
    const nodePrototype = Object.getPrototypeOf(node);
    if (nodePrototype === null) return false;
    return nodePrototype.constructor.name === instance.name || $ff392f68f74a28fc$export$3a92fc9ec83ef360(nodePrototype, instance);
};


function $09a15aacea48ef2a$var$formatCSSText(style) {
    const content = style.getPropertyValue('content');
    return `${style.cssText} content: '${content.replace(/'|"/g, '')}';`;
}
function $09a15aacea48ef2a$var$formatCSSProperties(style, options) {
    return (0, $ff392f68f74a28fc$export$be6bf80faea8d5af)(options).map((name)=>{
        const value = style.getPropertyValue(name);
        const priority = style.getPropertyPriority(name);
        return `${name}: ${value}${priority ? ' !important' : ''};`;
    }).join(' ');
}
function $09a15aacea48ef2a$var$getPseudoElementStyle(className, pseudo, style, options) {
    const selector = `.${className}:${pseudo}`;
    const cssText = style.cssText ? $09a15aacea48ef2a$var$formatCSSText(style) : $09a15aacea48ef2a$var$formatCSSProperties(style, options);
    return document.createTextNode(`${selector}{${cssText}}`);
}
function $09a15aacea48ef2a$var$clonePseudoElement(nativeNode, clonedNode, pseudo, options) {
    const style = window.getComputedStyle(nativeNode, pseudo);
    const content = style.getPropertyValue('content');
    if (content === '' || content === 'none') return;
    const className = (0, $ff392f68f74a28fc$export$31b40729666a4ae0)();
    try {
        clonedNode.className = `${clonedNode.className} ${className}`;
    } catch (err) {
        return;
    }
    const styleElement = document.createElement('style');
    styleElement.appendChild($09a15aacea48ef2a$var$getPseudoElementStyle(className, pseudo, style, options));
    clonedNode.appendChild(styleElement);
}
function $09a15aacea48ef2a$export$8df63687a708ed2e(nativeNode, clonedNode, options) {
    $09a15aacea48ef2a$var$clonePseudoElement(nativeNode, clonedNode, ':before', options);
    $09a15aacea48ef2a$var$clonePseudoElement(nativeNode, clonedNode, ':after', options);
}



const $dbf91f1ed0aeedef$var$WOFF = 'application/font-woff';
const $dbf91f1ed0aeedef$var$JPEG = 'image/jpeg';
const $dbf91f1ed0aeedef$var$mimes = {
    woff: $dbf91f1ed0aeedef$var$WOFF,
    woff2: $dbf91f1ed0aeedef$var$WOFF,
    ttf: 'application/font-truetype',
    eot: 'application/vnd.ms-fontobject',
    png: 'image/png',
    jpg: $dbf91f1ed0aeedef$var$JPEG,
    jpeg: $dbf91f1ed0aeedef$var$JPEG,
    gif: 'image/gif',
    tiff: 'image/tiff',
    svg: 'image/svg+xml',
    webp: 'image/webp'
};
function $dbf91f1ed0aeedef$var$getExtension(url) {
    const match = /\.([^./]*?)$/g.exec(url);
    return match ? match[1] : '';
}
function $dbf91f1ed0aeedef$export$200548c990602f61(url) {
    const extension = $dbf91f1ed0aeedef$var$getExtension(url).toLowerCase();
    return $dbf91f1ed0aeedef$var$mimes[extension] || '';
}


function $e0251253cf13f7b3$var$getContentFromDataUrl(dataURL) {
    return dataURL.split(/,/)[1];
}
function $e0251253cf13f7b3$export$f8a05efa20ffd5a(url) {
    return url.search(/^(data:)/) !== -1;
}
function $e0251253cf13f7b3$export$68336ea1617fa80a(content, mimeType) {
    return `data:${mimeType};base64,${content}`;
}
async function $e0251253cf13f7b3$export$c20a8b76c95b0d41(url, init, process) {
    const res = await fetch(url, init);
    if (res.status === 404) throw new Error(`Resource "${res.url}" not found`);
    const blob = await res.blob();
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onerror = reject;
        reader.onloadend = ()=>{
            try {
                resolve(process({
                    res: res,
                    result: reader.result
                }));
            } catch (error) {
                reject(error);
            }
        };
        reader.readAsDataURL(blob);
    });
}
const $e0251253cf13f7b3$var$cache = {};
function $e0251253cf13f7b3$var$getCacheKey(url, contentType, includeQueryParams) {
    let key = url.replace(/\?.*/, '');
    if (includeQueryParams) key = url;
    // font resource
    if (/ttf|otf|eot|woff2?/i.test(key)) key = key.replace(/.*\//, '');
    return contentType ? `[${contentType}]${key}` : key;
}
async function $e0251253cf13f7b3$export$bdf0422c029b202a(resourceUrl, contentType, options) {
    const cacheKey = $e0251253cf13f7b3$var$getCacheKey(resourceUrl, contentType, options.includeQueryParams);
    if ($e0251253cf13f7b3$var$cache[cacheKey] != null) return $e0251253cf13f7b3$var$cache[cacheKey];
    // ref: https://developer.mozilla.org/en/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest#Bypassing_the_cache
    if (options.cacheBust) // eslint-disable-next-line no-param-reassign
    resourceUrl += (/\?/.test(resourceUrl) ? '&' : '?') + new Date().getTime();
    let dataURL;
    try {
        const content = await $e0251253cf13f7b3$export$c20a8b76c95b0d41(resourceUrl, options.fetchRequestInit, ({ res: res, result: result })=>{
            if (!contentType) // eslint-disable-next-line no-param-reassign
            contentType = res.headers.get('Content-Type') || '';
            return $e0251253cf13f7b3$var$getContentFromDataUrl(result);
        });
        dataURL = $e0251253cf13f7b3$export$68336ea1617fa80a(content, contentType);
    } catch (error) {
        dataURL = options.imagePlaceholder || '';
        let msg = `Failed to fetch resource: ${resourceUrl}`;
        if (error) msg = typeof error === 'string' ? error : error.message;
        if (msg) console.warn(msg);
    }
    $e0251253cf13f7b3$var$cache[cacheKey] = dataURL;
    return dataURL;
}


async function $641234005fc562b8$var$cloneCanvasElement(canvas) {
    const dataURL = canvas.toDataURL();
    if (dataURL === 'data:,') return canvas.cloneNode(false);
    return (0, $ff392f68f74a28fc$export$ec664d7487540b)(dataURL);
}
async function $641234005fc562b8$var$cloneVideoElement(video, options) {
    if (video.currentSrc) {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = video.clientWidth;
        canvas.height = video.clientHeight;
        ctx === null || ctx === void 0 || ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const dataURL = canvas.toDataURL();
        return (0, $ff392f68f74a28fc$export$ec664d7487540b)(dataURL);
    }
    const poster = video.poster;
    const contentType = (0, $dbf91f1ed0aeedef$export$200548c990602f61)(poster);
    const dataURL = await (0, $e0251253cf13f7b3$export$bdf0422c029b202a)(poster, contentType, options);
    return (0, $ff392f68f74a28fc$export$ec664d7487540b)(dataURL);
}
async function $641234005fc562b8$var$cloneIFrameElement(iframe, options) {
    var _a;
    try {
        if ((_a = iframe === null || iframe === void 0 ? void 0 : iframe.contentDocument) === null || _a === void 0 ? void 0 : _a.body) return await $641234005fc562b8$export$ae8e35ea29ddac22(iframe.contentDocument.body, options, true);
    } catch (_b) {
    // Failed to clone iframe
    }
    return iframe.cloneNode(false);
}
async function $641234005fc562b8$var$cloneSingleNode(node, options) {
    if ((0, $ff392f68f74a28fc$export$3a92fc9ec83ef360)(node, HTMLCanvasElement)) return $641234005fc562b8$var$cloneCanvasElement(node);
    if ((0, $ff392f68f74a28fc$export$3a92fc9ec83ef360)(node, HTMLVideoElement)) return $641234005fc562b8$var$cloneVideoElement(node, options);
    if ((0, $ff392f68f74a28fc$export$3a92fc9ec83ef360)(node, HTMLIFrameElement)) return $641234005fc562b8$var$cloneIFrameElement(node, options);
    return node.cloneNode($641234005fc562b8$var$isSVGElement(node));
}
const $641234005fc562b8$var$isSlotElement = (node)=>node.tagName != null && node.tagName.toUpperCase() === 'SLOT';
const $641234005fc562b8$var$isSVGElement = (node)=>node.tagName != null && node.tagName.toUpperCase() === 'SVG';
async function $641234005fc562b8$var$cloneChildren(nativeNode, clonedNode, options) {
    var _a, _b;
    if ($641234005fc562b8$var$isSVGElement(clonedNode)) return clonedNode;
    let children = [];
    if ($641234005fc562b8$var$isSlotElement(nativeNode) && nativeNode.assignedNodes) children = (0, $ff392f68f74a28fc$export$45b10814cc054894)(nativeNode.assignedNodes());
    else if ((0, $ff392f68f74a28fc$export$3a92fc9ec83ef360)(nativeNode, HTMLIFrameElement) && ((_a = nativeNode.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) children = (0, $ff392f68f74a28fc$export$45b10814cc054894)(nativeNode.contentDocument.body.childNodes);
    else children = (0, $ff392f68f74a28fc$export$45b10814cc054894)(((_b = nativeNode.shadowRoot) !== null && _b !== void 0 ? _b : nativeNode).childNodes);
    if (children.length === 0 || (0, $ff392f68f74a28fc$export$3a92fc9ec83ef360)(nativeNode, HTMLVideoElement)) return clonedNode;
    await children.reduce((deferred, child)=>deferred.then(()=>$641234005fc562b8$export$ae8e35ea29ddac22(child, options)).then((clonedChild)=>{
            if (clonedChild) clonedNode.appendChild(clonedChild);
        }), Promise.resolve());
    return clonedNode;
}
function $641234005fc562b8$var$cloneCSSStyle(nativeNode, clonedNode, options) {
    const targetStyle = clonedNode.style;
    if (!targetStyle) return;
    const sourceStyle = window.getComputedStyle(nativeNode);
    if (sourceStyle.cssText) {
        targetStyle.cssText = sourceStyle.cssText;
        targetStyle.transformOrigin = sourceStyle.transformOrigin;
    } else (0, $ff392f68f74a28fc$export$be6bf80faea8d5af)(options).forEach((name)=>{
        let value = sourceStyle.getPropertyValue(name);
        if (name === 'font-size' && value.endsWith('px')) {
            const reducedFont = Math.floor(parseFloat(value.substring(0, value.length - 2))) - 0.1;
            value = `${reducedFont}px`;
        }
        if ((0, $ff392f68f74a28fc$export$3a92fc9ec83ef360)(nativeNode, HTMLIFrameElement) && name === 'display' && value === 'inline') value = 'block';
        if (name === 'd' && clonedNode.getAttribute('d')) value = `path(${clonedNode.getAttribute('d')})`;
        targetStyle.setProperty(name, value, sourceStyle.getPropertyPriority(name));
    });
}
function $641234005fc562b8$var$cloneInputValue(nativeNode, clonedNode) {
    if ((0, $ff392f68f74a28fc$export$3a92fc9ec83ef360)(nativeNode, HTMLTextAreaElement)) clonedNode.innerHTML = nativeNode.value;
    if ((0, $ff392f68f74a28fc$export$3a92fc9ec83ef360)(nativeNode, HTMLInputElement)) clonedNode.setAttribute('value', nativeNode.value);
}
function $641234005fc562b8$var$cloneSelectValue(nativeNode, clonedNode) {
    if ((0, $ff392f68f74a28fc$export$3a92fc9ec83ef360)(nativeNode, HTMLSelectElement)) {
        const clonedSelect = clonedNode;
        const selectedOption = Array.from(clonedSelect.children).find((child)=>nativeNode.value === child.getAttribute('value'));
        if (selectedOption) selectedOption.setAttribute('selected', '');
    }
}
function $641234005fc562b8$var$decorate(nativeNode, clonedNode, options) {
    if ((0, $ff392f68f74a28fc$export$3a92fc9ec83ef360)(clonedNode, Element)) {
        $641234005fc562b8$var$cloneCSSStyle(nativeNode, clonedNode, options);
        (0, $09a15aacea48ef2a$export$8df63687a708ed2e)(nativeNode, clonedNode, options);
        $641234005fc562b8$var$cloneInputValue(nativeNode, clonedNode);
        $641234005fc562b8$var$cloneSelectValue(nativeNode, clonedNode);
    }
    return clonedNode;
}
async function $641234005fc562b8$var$ensureSVGSymbols(clone, options) {
    const uses = clone.querySelectorAll ? clone.querySelectorAll('use') : [];
    if (uses.length === 0) return clone;
    const processedDefs = {};
    for(let i = 0; i < uses.length; i++){
        const use = uses[i];
        const id = use.getAttribute('xlink:href');
        if (id) {
            const exist = clone.querySelector(id);
            const definition = document.querySelector(id);
            if (!exist && definition && !processedDefs[id]) // eslint-disable-next-line no-await-in-loop
            processedDefs[id] = await $641234005fc562b8$export$ae8e35ea29ddac22(definition, options, true);
        }
    }
    const nodes = Object.values(processedDefs);
    if (nodes.length) {
        const ns = 'http://www.w3.org/1999/xhtml';
        const svg = document.createElementNS(ns, 'svg');
        svg.setAttribute('xmlns', ns);
        svg.style.position = 'absolute';
        svg.style.width = '0';
        svg.style.height = '0';
        svg.style.overflow = 'hidden';
        svg.style.display = 'none';
        const defs = document.createElementNS(ns, 'defs');
        svg.appendChild(defs);
        for(let i = 0; i < nodes.length; i++)defs.appendChild(nodes[i]);
        clone.appendChild(svg);
    }
    return clone;
}
async function $641234005fc562b8$export$ae8e35ea29ddac22(node, options, isRoot) {
    if (!isRoot && options.filter && !options.filter(node)) return null;
    return Promise.resolve(node).then((clonedNode)=>$641234005fc562b8$var$cloneSingleNode(clonedNode, options)).then((clonedNode)=>$641234005fc562b8$var$cloneChildren(node, clonedNode, options)).then((clonedNode)=>$641234005fc562b8$var$decorate(node, clonedNode, options)).then((clonedNode)=>$641234005fc562b8$var$ensureSVGSymbols(clonedNode, options));
}





const $10974646a9a718df$var$URL_REGEX = /url\((['"]?)([^'"]+?)\1\)/g;
const $10974646a9a718df$var$URL_WITH_FORMAT_REGEX = /url\([^)]+\)\s*format\((["']?)([^"']+)\1\)/g;
const $10974646a9a718df$var$FONT_SRC_REGEX = /src:\s*(?:url\([^)]+\)\s*format\([^)]+\)[,;]\s*)+/g;
function $10974646a9a718df$var$toRegex(url) {
    // eslint-disable-next-line no-useless-escape
    const escaped = url.replace(/([.*+?^${}()|\[\]\/\\])/g, '\\$1');
    return new RegExp(`(url\\(['"]?)(${escaped})(['"]?\\))`, 'g');
}
function $10974646a9a718df$export$d04549d631b8762d(cssText) {
    const urls = [];
    cssText.replace($10974646a9a718df$var$URL_REGEX, (raw, quotation, url)=>{
        urls.push(url);
        return raw;
    });
    return urls.filter((url)=>!(0, $e0251253cf13f7b3$export$f8a05efa20ffd5a)(url));
}
async function $10974646a9a718df$export$2be46bb7e96db87f(cssText, resourceURL, baseURL, options, getContentFromUrl) {
    try {
        const resolvedURL = baseURL ? (0, $ff392f68f74a28fc$export$f85c16a6d62f7d63)(resourceURL, baseURL) : resourceURL;
        const contentType = (0, $dbf91f1ed0aeedef$export$200548c990602f61)(resourceURL);
        let dataURL;
        if (getContentFromUrl) {
            const content = await getContentFromUrl(resolvedURL);
            dataURL = (0, $e0251253cf13f7b3$export$68336ea1617fa80a)(content, contentType);
        } else dataURL = await (0, $e0251253cf13f7b3$export$bdf0422c029b202a)(resolvedURL, contentType, options);
        return cssText.replace($10974646a9a718df$var$toRegex(resourceURL), `$1${dataURL}$3`);
    } catch (error) {
    // pass
    }
    return cssText;
}
function $10974646a9a718df$var$filterPreferredFontFormat(str, { preferredFontFormat: preferredFontFormat }) {
    return !preferredFontFormat ? str : str.replace($10974646a9a718df$var$FONT_SRC_REGEX, (match)=>{
        // eslint-disable-next-line no-constant-condition
        while(true){
            const [src, , format] = $10974646a9a718df$var$URL_WITH_FORMAT_REGEX.exec(match) || [];
            if (!format) return '';
            if (format === preferredFontFormat) return `src: ${src};`;
        }
    });
}
function $10974646a9a718df$export$7b668369e5eab853(url) {
    return url.search($10974646a9a718df$var$URL_REGEX) !== -1;
}
async function $10974646a9a718df$export$3d88803585cbbc21(cssText, baseUrl, options) {
    if (!$10974646a9a718df$export$7b668369e5eab853(cssText)) return cssText;
    const filteredCSSText = $10974646a9a718df$var$filterPreferredFontFormat(cssText, options);
    const urls = $10974646a9a718df$export$d04549d631b8762d(filteredCSSText);
    return urls.reduce((deferred, url)=>deferred.then((css)=>$10974646a9a718df$export$2be46bb7e96db87f(css, url, baseUrl, options)), Promise.resolve(filteredCSSText));
}





async function $7bb56b729ca49d81$var$embedProp(propName, node, options) {
    var _a;
    const propValue = (_a = node.style) === null || _a === void 0 ? void 0 : _a.getPropertyValue(propName);
    if (propValue) {
        const cssString = await (0, $10974646a9a718df$export$3d88803585cbbc21)(propValue, null, options);
        node.style.setProperty(propName, cssString, node.style.getPropertyPriority(propName));
        return true;
    }
    return false;
}
async function $7bb56b729ca49d81$var$embedBackground(clonedNode, options) {
    await $7bb56b729ca49d81$var$embedProp('background', clonedNode, options) || await $7bb56b729ca49d81$var$embedProp('background-image', clonedNode, options);
    await $7bb56b729ca49d81$var$embedProp('mask', clonedNode, options) || await $7bb56b729ca49d81$var$embedProp('-webkit-mask', clonedNode, options) || await $7bb56b729ca49d81$var$embedProp('mask-image', clonedNode, options) || await $7bb56b729ca49d81$var$embedProp('-webkit-mask-image', clonedNode, options);
}
async function $7bb56b729ca49d81$var$embedImageNode(clonedNode, options) {
    const isImageElement = (0, $ff392f68f74a28fc$export$3a92fc9ec83ef360)(clonedNode, HTMLImageElement);
    if (!(isImageElement && !(0, $e0251253cf13f7b3$export$f8a05efa20ffd5a)(clonedNode.src)) && !((0, $ff392f68f74a28fc$export$3a92fc9ec83ef360)(clonedNode, SVGImageElement) && !(0, $e0251253cf13f7b3$export$f8a05efa20ffd5a)(clonedNode.href.baseVal))) return;
    const url = isImageElement ? clonedNode.src : clonedNode.href.baseVal;
    const dataURL = await (0, $e0251253cf13f7b3$export$bdf0422c029b202a)(url, (0, $dbf91f1ed0aeedef$export$200548c990602f61)(url), options);
    await new Promise((resolve, reject)=>{
        clonedNode.onload = resolve;
        clonedNode.onerror = options.onImageErrorHandler ? (...attributes)=>{
            try {
                resolve(options.onImageErrorHandler(...attributes));
            } catch (error) {
                reject(error);
            }
        } : reject;
        const image = clonedNode;
        if (image.decode) image.decode = resolve;
        if (image.loading === 'lazy') image.loading = 'eager';
        if (isImageElement) {
            clonedNode.srcset = '';
            clonedNode.src = dataURL;
        } else clonedNode.href.baseVal = dataURL;
    });
}
async function $7bb56b729ca49d81$var$embedChildren(clonedNode, options) {
    const children = (0, $ff392f68f74a28fc$export$45b10814cc054894)(clonedNode.childNodes);
    const deferreds = children.map((child)=>$7bb56b729ca49d81$export$6660fa8dd20e53aa(child, options));
    await Promise.all(deferreds).then(()=>clonedNode);
}
async function $7bb56b729ca49d81$export$6660fa8dd20e53aa(clonedNode, options) {
    if ((0, $ff392f68f74a28fc$export$3a92fc9ec83ef360)(clonedNode, Element)) {
        await $7bb56b729ca49d81$var$embedBackground(clonedNode, options);
        await $7bb56b729ca49d81$var$embedImageNode(clonedNode, options);
        await $7bb56b729ca49d81$var$embedChildren(clonedNode, options);
    }
}


function $249ade978dd9bae5$export$d63a6b7859608045(node, options) {
    const { style: style } = node;
    if (options.backgroundColor) style.backgroundColor = options.backgroundColor;
    if (options.width) style.width = `${options.width}px`;
    if (options.height) style.height = `${options.height}px`;
    const manual = options.style;
    if (manual != null) Object.keys(manual).forEach((key)=>{
        style[key] = manual[key];
    });
    return node;
}





const $de43a63744e89887$var$cssFetchCache = {};
async function $de43a63744e89887$var$fetchCSS(url) {
    let cache = $de43a63744e89887$var$cssFetchCache[url];
    if (cache != null) return cache;
    const res = await fetch(url);
    const cssText = await res.text();
    cache = {
        url: url,
        cssText: cssText
    };
    $de43a63744e89887$var$cssFetchCache[url] = cache;
    return cache;
}
async function $de43a63744e89887$var$embedFonts(data, options) {
    let cssText = data.cssText;
    const regexUrl = /url\(["']?([^"')]+)["']?\)/g;
    const fontLocs = cssText.match(/url\([^)]+\)/g) || [];
    const loadFonts = fontLocs.map(async (loc)=>{
        let url = loc.replace(regexUrl, '$1');
        if (!url.startsWith('https://')) url = new URL(url, data.url).href;
        return (0, $e0251253cf13f7b3$export$c20a8b76c95b0d41)(url, options.fetchRequestInit, ({ result: result })=>{
            cssText = cssText.replace(loc, `url(${result})`);
            return [
                loc,
                result
            ];
        });
    });
    return Promise.all(loadFonts).then(()=>cssText);
}
function $de43a63744e89887$var$parseCSS(source) {
    if (source == null) return [];
    const result = [];
    const commentsRegex = /(\/\*[\s\S]*?\*\/)/gi;
    // strip out comments
    let cssText = source.replace(commentsRegex, '');
    // eslint-disable-next-line prefer-regex-literals
    const keyframesRegex = new RegExp('((@.*?keyframes [\\s\\S]*?){([\\s\\S]*?}\\s*?)})', 'gi');
    // eslint-disable-next-line no-constant-condition
    while(true){
        const matches = keyframesRegex.exec(cssText);
        if (matches === null) break;
        result.push(matches[0]);
    }
    cssText = cssText.replace(keyframesRegex, '');
    const importRegex = /@import[\s\S]*?url\([^)]*\)[\s\S]*?;/gi;
    // to match css & media queries together
    const combinedCSSRegex = "((\\s*?(?:\\/\\*[\\s\\S]*?\\*\\/)?\\s*?@media[\\s\\S]*?){([\\s\\S]*?)}\\s*?})|(([\\s\\S]*?){([\\s\\S]*?)})";
    // unified regex
    const unifiedRegex = new RegExp(combinedCSSRegex, 'gi');
    // eslint-disable-next-line no-constant-condition
    while(true){
        let matches = importRegex.exec(cssText);
        if (matches === null) {
            matches = unifiedRegex.exec(cssText);
            if (matches === null) break;
            else importRegex.lastIndex = unifiedRegex.lastIndex;
        } else unifiedRegex.lastIndex = importRegex.lastIndex;
        result.push(matches[0]);
    }
    return result;
}
async function $de43a63744e89887$var$getCSSRules(styleSheets, options) {
    const ret = [];
    const deferreds = [];
    // First loop inlines imports
    styleSheets.forEach((sheet)=>{
        if ('cssRules' in sheet) try {
            (0, $ff392f68f74a28fc$export$45b10814cc054894)(sheet.cssRules || []).forEach((item, index)=>{
                if (item.type === CSSRule.IMPORT_RULE) {
                    let importIndex = index + 1;
                    const url = item.href;
                    const deferred = $de43a63744e89887$var$fetchCSS(url).then((metadata)=>$de43a63744e89887$var$embedFonts(metadata, options)).then((cssText)=>$de43a63744e89887$var$parseCSS(cssText).forEach((rule)=>{
                            try {
                                sheet.insertRule(rule, rule.startsWith('@import') ? importIndex += 1 : sheet.cssRules.length);
                            } catch (error) {
                                console.error('Error inserting rule from remote css', {
                                    rule: rule,
                                    error: error
                                });
                            }
                        })).catch((e)=>{
                        console.error('Error loading remote css', e.toString());
                    });
                    deferreds.push(deferred);
                }
            });
        } catch (e) {
            const inline = styleSheets.find((a)=>a.href == null) || document.styleSheets[0];
            if (sheet.href != null) deferreds.push($de43a63744e89887$var$fetchCSS(sheet.href).then((metadata)=>$de43a63744e89887$var$embedFonts(metadata, options)).then((cssText)=>$de43a63744e89887$var$parseCSS(cssText).forEach((rule)=>{
                    inline.insertRule(rule, inline.cssRules.length);
                })).catch((err)=>{
                console.error('Error loading remote stylesheet', err);
            }));
            console.error('Error inlining remote css file', e);
        }
    });
    return Promise.all(deferreds).then(()=>{
        // Second loop parses rules
        styleSheets.forEach((sheet)=>{
            if ('cssRules' in sheet) try {
                (0, $ff392f68f74a28fc$export$45b10814cc054894)(sheet.cssRules || []).forEach((item)=>{
                    ret.push(item);
                });
            } catch (e) {
                console.error(`Error while reading CSS rules from ${sheet.href}`, e);
            }
        });
        return ret;
    });
}
function $de43a63744e89887$var$getWebFontRules(cssRules) {
    return cssRules.filter((rule)=>rule.type === CSSRule.FONT_FACE_RULE).filter((rule)=>(0, $10974646a9a718df$export$7b668369e5eab853)(rule.style.getPropertyValue('src')));
}
async function $de43a63744e89887$var$parseWebFontRules(node, options) {
    if (node.ownerDocument == null) throw new Error('Provided element is not within a Document');
    const styleSheets = (0, $ff392f68f74a28fc$export$45b10814cc054894)(node.ownerDocument.styleSheets);
    const cssRules = await $de43a63744e89887$var$getCSSRules(styleSheets, options);
    return $de43a63744e89887$var$getWebFontRules(cssRules);
}
function $de43a63744e89887$var$normalizeFontFamily(font) {
    return font.trim().replace(/["']/g, '');
}
function $de43a63744e89887$var$getUsedFonts(node) {
    const fonts = new Set();
    function traverse(node) {
        const fontFamily = node.style.fontFamily || getComputedStyle(node).fontFamily;
        fontFamily.split(',').forEach((font)=>{
            fonts.add($de43a63744e89887$var$normalizeFontFamily(font));
        });
        Array.from(node.children).forEach((child)=>{
            if (child instanceof HTMLElement) traverse(child);
        });
    }
    traverse(node);
    return fonts;
}
async function $de43a63744e89887$export$253c9aa3d83a57b6(node, options) {
    const rules = await $de43a63744e89887$var$parseWebFontRules(node, options);
    const usedFonts = $de43a63744e89887$var$getUsedFonts(node);
    const cssTexts = await Promise.all(rules.filter((rule)=>usedFonts.has($de43a63744e89887$var$normalizeFontFamily(rule.style.fontFamily))).map((rule)=>{
        const baseUrl = rule.parentStyleSheet ? rule.parentStyleSheet.href : null;
        return (0, $10974646a9a718df$export$3d88803585cbbc21)(rule.cssText, baseUrl, options);
    }));
    return cssTexts.join('\n');
}
async function $de43a63744e89887$export$2c2c83b77c8cb421(clonedNode, options) {
    const cssText = options.fontEmbedCSS != null ? options.fontEmbedCSS : options.skipFonts ? null : await $de43a63744e89887$export$253c9aa3d83a57b6(clonedNode, options);
    if (cssText) {
        const styleNode = document.createElement('style');
        const sytleContent = document.createTextNode(cssText);
        styleNode.appendChild(sytleContent);
        if (clonedNode.firstChild) clonedNode.insertBefore(styleNode, clonedNode.firstChild);
        else clonedNode.appendChild(styleNode);
    }
}



async function $c35c7896ea43b279$export$20d300cb2d558b7(node, options = {}) {
    const { width: width, height: height } = (0, $ff392f68f74a28fc$export$ada5537b2c061996)(node, options);
    const clonedNode = await (0, $641234005fc562b8$export$ae8e35ea29ddac22)(node, options, true);
    await (0, $de43a63744e89887$export$2c2c83b77c8cb421)(clonedNode, options);
    await (0, $7bb56b729ca49d81$export$6660fa8dd20e53aa)(clonedNode, options);
    (0, $249ade978dd9bae5$export$d63a6b7859608045)(clonedNode, options);
    const datauri = await (0, $ff392f68f74a28fc$export$b62810fb8ca515fa)(clonedNode, width, height);
    return datauri;
}
async function $c35c7896ea43b279$export$f87f6982d1fd4f81(node, options = {}) {
    const { width: width, height: height } = (0, $ff392f68f74a28fc$export$ada5537b2c061996)(node, options);
    const svg = await $c35c7896ea43b279$export$20d300cb2d558b7(node, options);
    const img = await (0, $ff392f68f74a28fc$export$ec664d7487540b)(svg);
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    const ratio = options.pixelRatio || (0, $ff392f68f74a28fc$export$d39ce20a37bba061)();
    const canvasWidth = options.canvasWidth || width;
    const canvasHeight = options.canvasHeight || height;
    canvas.width = canvasWidth * ratio;
    canvas.height = canvasHeight * ratio;
    if (!options.skipAutoScale) (0, $ff392f68f74a28fc$export$c2c809a2fe6b0f1a)(canvas);
    canvas.style.width = `${canvasWidth}`;
    canvas.style.height = `${canvasHeight}`;
    if (options.backgroundColor) {
        context.fillStyle = options.backgroundColor;
        context.fillRect(0, 0, canvas.width, canvas.height);
    }
    context.drawImage(img, 0, 0, canvas.width, canvas.height);
    return canvas;
}
async function $c35c7896ea43b279$export$6f9e32581c0cde11(node, options = {}) {
    const { width: width, height: height } = (0, $ff392f68f74a28fc$export$ada5537b2c061996)(node, options);
    const canvas = await $c35c7896ea43b279$export$f87f6982d1fd4f81(node, options);
    const ctx = canvas.getContext('2d');
    return ctx.getImageData(0, 0, width, height).data;
}
async function $c35c7896ea43b279$export$aba256f33615c92e(node, options = {}) {
    const canvas = await $c35c7896ea43b279$export$f87f6982d1fd4f81(node, options);
    return canvas.toDataURL();
}
async function $c35c7896ea43b279$export$ed218bd2440d33a5(node, options = {}) {
    const canvas = await $c35c7896ea43b279$export$f87f6982d1fd4f81(node, options);
    return canvas.toDataURL('image/jpeg', options.quality || 1);
}
async function $c35c7896ea43b279$export$b20f4ee19ffa0668(node, options = {}) {
    const canvas = await $c35c7896ea43b279$export$f87f6982d1fd4f81(node, options);
    const blob = await (0, $ff392f68f74a28fc$export$403d539f215df596)(canvas);
    return blob;
}
async function $c35c7896ea43b279$export$92678bad7eef403b(node, options = {}) {
    return (0, $de43a63744e89887$export$253c9aa3d83a57b6)(node, options);
}


async function $4169a997cc05c1f6$export$2e2bcd8739ae039(backgroundUrl) {
    const node = document.getElementById('arise-profile-scorecard');
    const BACKGROUND_WIDTH = 704; // 16:9
    const BACKGROUND_HEIGHT = 396;
    const OVERLAY_PIXEL_RATIO = 4;
    const OVERLAY_PADDING_OFFSET = 25;
    const EXPORT_SCALE = 2;
    // Stop shine animation so it's not captured
    node.classList.add('stop-all-animations');
    // Do it once first to ensure all assets load in and stop safari bug
    await $c35c7896ea43b279$export$aba256f33615c92e(node);
    const overlayDataUrl = await $c35c7896ea43b279$export$aba256f33615c92e(node, {
        pixelRatio: OVERLAY_PIXEL_RATIO,
        style: {
            filter: 'none'
        }
    });
    node.classList.remove('stop-all-animations');
    let backgroundImg = null;
    try {
        backgroundImg = await new Promise((resolve, reject)=>{
            const img = new Image();
            img.crossOrigin = 'anonymous';
            img.onload = ()=>resolve(img);
            img.onerror = reject;
            img.src = backgroundUrl;
        });
    } catch  {
        backgroundImg = null;
    }
    const overlayImg = await new Promise((resolve, reject)=>{
        const img = new Image();
        img.onload = ()=>resolve(img);
        img.onerror = reject;
        img.src = overlayDataUrl;
    });
    const canvas = document.createElement('canvas');
    canvas.width = BACKGROUND_WIDTH * EXPORT_SCALE;
    canvas.height = BACKGROUND_HEIGHT * EXPORT_SCALE;
    const ctx = canvas.getContext('2d');
    // Draw background at full size
    if (backgroundImg) ctx.drawImage(backgroundImg, 0, 0, canvas.width, canvas.height);
    else {
        ctx.fillStyle = '#181818'; // Fallback grey bg
        ctx.fillRect(0, 0, canvas.width, canvas.height);
    }
    // Scale overlay down to reverse pixelRatio = 4
    const scaledWidth = overlayImg.width / OVERLAY_PIXEL_RATIO * EXPORT_SCALE;
    const scaledHeight = overlayImg.height / OVERLAY_PIXEL_RATIO * EXPORT_SCALE;
    // Draw overlay at requested position with drop shadow
    ctx.save();
    ctx.filter = 'drop-shadow(5px 5px 8px rgba(0,0,0,0.8))';
    ctx.drawImage(overlayImg, canvas.width - scaledWidth - OVERLAY_PADDING_OFFSET * EXPORT_SCALE, OVERLAY_PADDING_OFFSET * EXPORT_SCALE, scaledWidth, scaledHeight);
    ctx.restore(); // Remove the filter state in case we want to draw more things
    const blob = await $4169a997cc05c1f6$var$getCanvasBlob(canvas);
    const url = URL.createObjectURL(blob);
    // (Optional) Append to DOM for testing
    // const testImg = new Image();
    // testImg.src = url;
    // testImg.style = `
    //     position: absolute;
    //     top: 0;
    //     left: 0;
    //     z-index: 10000;
    //     width: 50%;
    //     border: 1px solid red;
    // `;
    // document.body.appendChild(testImg);
    return url;
}
function $4169a997cc05c1f6$var$getCanvasBlob(canvas) {
    return new Promise((resolve)=>{
        canvas.toBlob((blob)=>resolve(blob), 'image/png');
    });
}


var $bd1843fbc4f3472c$exports = {};

$parcel$export($bd1843fbc4f3472c$exports, "ProfileDrawer", function () { return $bd1843fbc4f3472c$export$8d639674747a02b2; }, function (v) { return $bd1843fbc4f3472c$export$8d639674747a02b2 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "active", function () { return $bd1843fbc4f3472c$export$89da14300d534261; }, function (v) { return $bd1843fbc4f3472c$export$89da14300d534261 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "bgImage", function () { return $bd1843fbc4f3472c$export$b2345e0581a48a31; }, function (v) { return $bd1843fbc4f3472c$export$b2345e0581a48a31 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "box", function () { return $bd1843fbc4f3472c$export$827f4ee28efc37; }, function (v) { return $bd1843fbc4f3472c$export$827f4ee28efc37 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "brandLogo", function () { return $bd1843fbc4f3472c$export$392d16e71632d55b; }, function (v) { return $bd1843fbc4f3472c$export$392d16e71632d55b = v; });
$parcel$export($bd1843fbc4f3472c$exports, "closeButton", function () { return $bd1843fbc4f3472c$export$efe229eab43a9869; }, function (v) { return $bd1843fbc4f3472c$export$efe229eab43a9869 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "common", function () { return $bd1843fbc4f3472c$export$919daad019702595; }, function (v) { return $bd1843fbc4f3472c$export$919daad019702595 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "content", function () { return $bd1843fbc4f3472c$export$a7db06668cad9adb; }, function (v) { return $bd1843fbc4f3472c$export$a7db06668cad9adb = v; });
$parcel$export($bd1843fbc4f3472c$exports, "ctaButtonsContainer", function () { return $bd1843fbc4f3472c$export$712f96671067efb4; }, function (v) { return $bd1843fbc4f3472c$export$712f96671067efb4 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "divider", function () { return $bd1843fbc4f3472c$export$e8c9778bf415dd08; }, function (v) { return $bd1843fbc4f3472c$export$e8c9778bf415dd08 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "epic", function () { return $bd1843fbc4f3472c$export$8ec5145af6f76965; }, function (v) { return $bd1843fbc4f3472c$export$8ec5145af6f76965 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "gridContainer", function () { return $bd1843fbc4f3472c$export$711e2b273dbb00ac; }, function (v) { return $bd1843fbc4f3472c$export$711e2b273dbb00ac = v; });
$parcel$export($bd1843fbc4f3472c$exports, "hasLine", function () { return $bd1843fbc4f3472c$export$76ebae8949fce754; }, function (v) { return $bd1843fbc4f3472c$export$76ebae8949fce754 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "highlight", function () { return $bd1843fbc4f3472c$export$e4043f67d36cbb26; }, function (v) { return $bd1843fbc4f3472c$export$e4043f67d36cbb26 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "hintButton", function () { return $bd1843fbc4f3472c$export$fab3f91e652f07ba; }, function (v) { return $bd1843fbc4f3472c$export$fab3f91e652f07ba = v; });
$parcel$export($bd1843fbc4f3472c$exports, "icon", function () { return $bd1843fbc4f3472c$export$1ca1ec8b29a4ce27; }, function (v) { return $bd1843fbc4f3472c$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "isExtraLong", function () { return $bd1843fbc4f3472c$export$8c28b07653e8d9d2; }, function (v) { return $bd1843fbc4f3472c$export$8c28b07653e8d9d2 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "isLong", function () { return $bd1843fbc4f3472c$export$d8c61589c31c4718; }, function (v) { return $bd1843fbc4f3472c$export$d8c61589c31c4718 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "isOpen", function () { return $bd1843fbc4f3472c$export$ea0830439c7fc698; }, function (v) { return $bd1843fbc4f3472c$export$ea0830439c7fc698 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "largerText", function () { return $bd1843fbc4f3472c$export$56dd976d44607735; }, function (v) { return $bd1843fbc4f3472c$export$56dd976d44607735 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "left", function () { return $bd1843fbc4f3472c$export$eabcd2c8791e7bf4; }, function (v) { return $bd1843fbc4f3472c$export$eabcd2c8791e7bf4 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "legendary", function () { return $bd1843fbc4f3472c$export$9738149b23403ba; }, function (v) { return $bd1843fbc4f3472c$export$9738149b23403ba = v; });
$parcel$export($bd1843fbc4f3472c$exports, "level", function () { return $bd1843fbc4f3472c$export$617f828bbf323ba2; }, function (v) { return $bd1843fbc4f3472c$export$617f828bbf323ba2 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "levelBadge", function () { return $bd1843fbc4f3472c$export$fad0c4d9d422c6d3; }, function (v) { return $bd1843fbc4f3472c$export$fad0c4d9d422c6d3 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "levelInfoBox", function () { return $bd1843fbc4f3472c$export$d7a6b934f302e93f; }, function (v) { return $bd1843fbc4f3472c$export$d7a6b934f302e93f = v; });
$parcel$export($bd1843fbc4f3472c$exports, "levelInfoBoxes", function () { return $bd1843fbc4f3472c$export$9085649ded432365; }, function (v) { return $bd1843fbc4f3472c$export$9085649ded432365 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "lockedIcon", function () { return $bd1843fbc4f3472c$export$b6335e2e4852d2f8; }, function (v) { return $bd1843fbc4f3472c$export$b6335e2e4852d2f8 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "pageBgImage", function () { return $bd1843fbc4f3472c$export$ef8b3c650f0e5fb3; }, function (v) { return $bd1843fbc4f3472c$export$ef8b3c650f0e5fb3 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "platformLogo", function () { return $bd1843fbc4f3472c$export$3471600b91f1cae6; }, function (v) { return $bd1843fbc4f3472c$export$3471600b91f1cae6 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "progress", function () { return $bd1843fbc4f3472c$export$504d7abb21fa8c9; }, function (v) { return $bd1843fbc4f3472c$export$504d7abb21fa8c9 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "quest", function () { return $bd1843fbc4f3472c$export$cbc1416578dd3747; }, function (v) { return $bd1843fbc4f3472c$export$cbc1416578dd3747 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "rare", function () { return $bd1843fbc4f3472c$export$b2e68d2f08b863d2; }, function (v) { return $bd1843fbc4f3472c$export$b2e68d2f08b863d2 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "scorecard", function () { return $bd1843fbc4f3472c$export$97678cb1dc0e0fc0; }, function (v) { return $bd1843fbc4f3472c$export$97678cb1dc0e0fc0 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "scorecardContent", function () { return $bd1843fbc4f3472c$export$bc4b99392c7330b9; }, function (v) { return $bd1843fbc4f3472c$export$bc4b99392c7330b9 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "scrollContainer", function () { return $bd1843fbc4f3472c$export$fad3c8302a7540c6; }, function (v) { return $bd1843fbc4f3472c$export$fad3c8302a7540c6 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "shareError", function () { return $bd1843fbc4f3472c$export$5a3af59d4539c451; }, function (v) { return $bd1843fbc4f3472c$export$5a3af59d4539c451 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "statBox", function () { return $bd1843fbc4f3472c$export$5ebab997b8566089; }, function (v) { return $bd1843fbc4f3472c$export$5ebab997b8566089 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "statBoxContainer", function () { return $bd1843fbc4f3472c$export$a9366fbbda880794; }, function (v) { return $bd1843fbc4f3472c$export$a9366fbbda880794 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "statBoxLong", function () { return $bd1843fbc4f3472c$export$e0dc3265b8932732; }, function (v) { return $bd1843fbc4f3472c$export$e0dc3265b8932732 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "statTextContainer", function () { return $bd1843fbc4f3472c$export$197356bebb306e39; }, function (v) { return $bd1843fbc4f3472c$export$197356bebb306e39 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "statTitle", function () { return $bd1843fbc4f3472c$export$a19053e6a5f4b6a8; }, function (v) { return $bd1843fbc4f3472c$export$a19053e6a5f4b6a8 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "subtitle", function () { return $bd1843fbc4f3472c$export$c96745152eb2740f; }, function (v) { return $bd1843fbc4f3472c$export$c96745152eb2740f = v; });
$parcel$export($bd1843fbc4f3472c$exports, "tabButtons", function () { return $bd1843fbc4f3472c$export$d167761217acc355; }, function (v) { return $bd1843fbc4f3472c$export$d167761217acc355 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "tabGroup", function () { return $bd1843fbc4f3472c$export$e8251cd941786af1; }, function (v) { return $bd1843fbc4f3472c$export$e8251cd941786af1 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "tabGroupLoader", function () { return $bd1843fbc4f3472c$export$faecd7a64ed7d994; }, function (v) { return $bd1843fbc4f3472c$export$faecd7a64ed7d994 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "textContainer", function () { return $bd1843fbc4f3472c$export$2cedfd664bb3bd01; }, function (v) { return $bd1843fbc4f3472c$export$2cedfd664bb3bd01 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "titleBar", function () { return $bd1843fbc4f3472c$export$870b5cbff008e1ed; }, function (v) { return $bd1843fbc4f3472c$export$870b5cbff008e1ed = v; });
$parcel$export($bd1843fbc4f3472c$exports, "titles", function () { return $bd1843fbc4f3472c$export$1cbbc5990c2ee230; }, function (v) { return $bd1843fbc4f3472c$export$1cbbc5990c2ee230 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "titlesNumber", function () { return $bd1843fbc4f3472c$export$ad38ce7e9fa921f3; }, function (v) { return $bd1843fbc4f3472c$export$ad38ce7e9fa921f3 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "topBar", function () { return $bd1843fbc4f3472c$export$ac052f74bbc68e2d; }, function (v) { return $bd1843fbc4f3472c$export$ac052f74bbc68e2d = v; });
$parcel$export($bd1843fbc4f3472c$exports, "uncommon", function () { return $bd1843fbc4f3472c$export$76bf72d8613283e6; }, function (v) { return $bd1843fbc4f3472c$export$76bf72d8613283e6 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "username", function () { return $bd1843fbc4f3472c$export$5e1be761f603d585; }, function (v) { return $bd1843fbc4f3472c$export$5e1be761f603d585 = v; });
$parcel$export($bd1843fbc4f3472c$exports, "yourStats", function () { return $bd1843fbc4f3472c$export$ea0f4417b3a15bd9; }, function (v) { return $bd1843fbc4f3472c$export$ea0f4417b3a15bd9 = v; });
var $bd1843fbc4f3472c$export$8d639674747a02b2;
var $bd1843fbc4f3472c$export$89da14300d534261;
var $bd1843fbc4f3472c$export$b2345e0581a48a31;
var $bd1843fbc4f3472c$export$827f4ee28efc37;
var $bd1843fbc4f3472c$export$392d16e71632d55b;
var $bd1843fbc4f3472c$export$efe229eab43a9869;
var $bd1843fbc4f3472c$export$919daad019702595;
var $bd1843fbc4f3472c$export$a7db06668cad9adb;
var $bd1843fbc4f3472c$export$712f96671067efb4;
var $bd1843fbc4f3472c$export$e8c9778bf415dd08;
var $bd1843fbc4f3472c$export$8ec5145af6f76965;
var $bd1843fbc4f3472c$export$711e2b273dbb00ac;
var $bd1843fbc4f3472c$export$76ebae8949fce754;
var $bd1843fbc4f3472c$export$e4043f67d36cbb26;
var $bd1843fbc4f3472c$export$fab3f91e652f07ba;
var $bd1843fbc4f3472c$export$1ca1ec8b29a4ce27;
var $bd1843fbc4f3472c$export$8c28b07653e8d9d2;
var $bd1843fbc4f3472c$export$d8c61589c31c4718;
var $bd1843fbc4f3472c$export$ea0830439c7fc698;
var $bd1843fbc4f3472c$export$56dd976d44607735;
var $bd1843fbc4f3472c$export$eabcd2c8791e7bf4;
var $bd1843fbc4f3472c$export$9738149b23403ba;
var $bd1843fbc4f3472c$export$617f828bbf323ba2;
var $bd1843fbc4f3472c$export$fad0c4d9d422c6d3;
var $bd1843fbc4f3472c$export$d7a6b934f302e93f;
var $bd1843fbc4f3472c$export$9085649ded432365;
var $bd1843fbc4f3472c$export$b6335e2e4852d2f8;
var $bd1843fbc4f3472c$export$ef8b3c650f0e5fb3;
var $bd1843fbc4f3472c$export$3471600b91f1cae6;
var $bd1843fbc4f3472c$export$504d7abb21fa8c9;
var $bd1843fbc4f3472c$export$cbc1416578dd3747;
var $bd1843fbc4f3472c$export$b2e68d2f08b863d2;
var $bd1843fbc4f3472c$export$97678cb1dc0e0fc0;
var $bd1843fbc4f3472c$export$bc4b99392c7330b9;
var $bd1843fbc4f3472c$export$fad3c8302a7540c6;
var $bd1843fbc4f3472c$export$5a3af59d4539c451;
var $bd1843fbc4f3472c$export$5ebab997b8566089;
var $bd1843fbc4f3472c$export$a9366fbbda880794;
var $bd1843fbc4f3472c$export$e0dc3265b8932732;
var $bd1843fbc4f3472c$export$197356bebb306e39;
var $bd1843fbc4f3472c$export$a19053e6a5f4b6a8;
var $bd1843fbc4f3472c$export$c96745152eb2740f;
var $bd1843fbc4f3472c$export$d167761217acc355;
var $bd1843fbc4f3472c$export$e8251cd941786af1;
var $bd1843fbc4f3472c$export$faecd7a64ed7d994;
var $bd1843fbc4f3472c$export$2cedfd664bb3bd01;
var $bd1843fbc4f3472c$export$870b5cbff008e1ed;
var $bd1843fbc4f3472c$export$1cbbc5990c2ee230;
var $bd1843fbc4f3472c$export$ad38ce7e9fa921f3;
var $bd1843fbc4f3472c$export$ac052f74bbc68e2d;
var $bd1843fbc4f3472c$export$76bf72d8613283e6;
var $bd1843fbc4f3472c$export$5e1be761f603d585;
var $bd1843fbc4f3472c$export$ea0f4417b3a15bd9;
$bd1843fbc4f3472c$export$8d639674747a02b2 = `mjApAq_ProfileDrawer`;
$bd1843fbc4f3472c$export$89da14300d534261 = `mjApAq_active`;
$bd1843fbc4f3472c$export$b2345e0581a48a31 = `mjApAq_bgImage`;
$bd1843fbc4f3472c$export$827f4ee28efc37 = `mjApAq_box`;
$bd1843fbc4f3472c$export$392d16e71632d55b = `mjApAq_brandLogo`;
$bd1843fbc4f3472c$export$efe229eab43a9869 = `mjApAq_closeButton`;
$bd1843fbc4f3472c$export$919daad019702595 = `mjApAq_common`;
$bd1843fbc4f3472c$export$a7db06668cad9adb = `mjApAq_content`;
$bd1843fbc4f3472c$export$712f96671067efb4 = `mjApAq_ctaButtonsContainer`;
$bd1843fbc4f3472c$export$e8c9778bf415dd08 = `mjApAq_divider`;
$bd1843fbc4f3472c$export$8ec5145af6f76965 = `mjApAq_epic`;
$bd1843fbc4f3472c$export$711e2b273dbb00ac = `mjApAq_gridContainer`;
$bd1843fbc4f3472c$export$76ebae8949fce754 = `mjApAq_hasLine`;
$bd1843fbc4f3472c$export$e4043f67d36cbb26 = `mjApAq_highlight`;
$bd1843fbc4f3472c$export$fab3f91e652f07ba = `mjApAq_hintButton`;
$bd1843fbc4f3472c$export$1ca1ec8b29a4ce27 = `mjApAq_icon`;
$bd1843fbc4f3472c$export$8c28b07653e8d9d2 = `mjApAq_isExtraLong`;
$bd1843fbc4f3472c$export$d8c61589c31c4718 = `mjApAq_isLong`;
$bd1843fbc4f3472c$export$ea0830439c7fc698 = `mjApAq_isOpen`;
$bd1843fbc4f3472c$export$56dd976d44607735 = `mjApAq_largerText`;
$bd1843fbc4f3472c$export$eabcd2c8791e7bf4 = `mjApAq_left`;
$bd1843fbc4f3472c$export$9738149b23403ba = `mjApAq_legendary`;
$bd1843fbc4f3472c$export$617f828bbf323ba2 = `mjApAq_level`;
$bd1843fbc4f3472c$export$fad0c4d9d422c6d3 = `mjApAq_levelBadge`;
$bd1843fbc4f3472c$export$d7a6b934f302e93f = `mjApAq_levelInfoBox`;
$bd1843fbc4f3472c$export$9085649ded432365 = `mjApAq_levelInfoBoxes`;
$bd1843fbc4f3472c$export$b6335e2e4852d2f8 = `mjApAq_lockedIcon`;
$bd1843fbc4f3472c$export$ef8b3c650f0e5fb3 = `mjApAq_pageBgImage`;
$bd1843fbc4f3472c$export$3471600b91f1cae6 = `mjApAq_platformLogo`;
$bd1843fbc4f3472c$export$504d7abb21fa8c9 = `mjApAq_progress`;
$bd1843fbc4f3472c$export$cbc1416578dd3747 = `mjApAq_quest`;
$bd1843fbc4f3472c$export$b2e68d2f08b863d2 = `mjApAq_rare`;
$bd1843fbc4f3472c$export$97678cb1dc0e0fc0 = `mjApAq_scorecard`;
$bd1843fbc4f3472c$export$bc4b99392c7330b9 = `mjApAq_scorecardContent`;
$bd1843fbc4f3472c$export$fad3c8302a7540c6 = `mjApAq_scrollContainer`;
$bd1843fbc4f3472c$export$5a3af59d4539c451 = `mjApAq_shareError`;
$bd1843fbc4f3472c$export$5ebab997b8566089 = `mjApAq_statBox`;
$bd1843fbc4f3472c$export$a9366fbbda880794 = `mjApAq_statBoxContainer`;
$bd1843fbc4f3472c$export$e0dc3265b8932732 = `mjApAq_statBoxLong`;
$bd1843fbc4f3472c$export$197356bebb306e39 = `mjApAq_statTextContainer`;
$bd1843fbc4f3472c$export$a19053e6a5f4b6a8 = `mjApAq_statTitle`;
$bd1843fbc4f3472c$export$c96745152eb2740f = `mjApAq_subtitle`;
$bd1843fbc4f3472c$export$d167761217acc355 = `mjApAq_tabButtons`;
$bd1843fbc4f3472c$export$e8251cd941786af1 = `mjApAq_tabGroup`;
$bd1843fbc4f3472c$export$faecd7a64ed7d994 = `mjApAq_tabGroupLoader`;
$bd1843fbc4f3472c$export$2cedfd664bb3bd01 = `mjApAq_textContainer`;
$bd1843fbc4f3472c$export$870b5cbff008e1ed = `mjApAq_titleBar`;
$bd1843fbc4f3472c$export$1cbbc5990c2ee230 = `mjApAq_titles`;
$bd1843fbc4f3472c$export$ad38ce7e9fa921f3 = `mjApAq_titlesNumber`;
$bd1843fbc4f3472c$export$ac052f74bbc68e2d = `mjApAq_topBar`;
$bd1843fbc4f3472c$export$76bf72d8613283e6 = `mjApAq_uncommon`;
$bd1843fbc4f3472c$export$5e1be761f603d585 = `mjApAq_username`;
$bd1843fbc4f3472c$export$ea0f4417b3a15bd9 = `mjApAq_yourStats`;


function $9757c11e13e1e8ba$export$2e2bcd8739ae039() {
    const dispatch = (0, $i2KZ1.useAppDispatch)();
    const closeButtonRef = (0, $7RNO0.useRef)(null);
    const { audio: audio } = (0, $f58c71b201a1c7d8$export$91047320af7bf70b)();
    const theme = (0, $7v5wN.useTheme)();
    const isProfileOpen = (0, $i2KZ1.useAppSelector)((state)=>state.app.isProfileOpen);
    const langIso = (0, $i2KZ1.useAppSelector)((state)=>state.app.langIso);
    const { currentUserProfileV2: currentUserProfileV2, availableBadges: availableBadges, availableTitles: availableTitles } = (0, $i2KZ1.useAppSelector)((state)=>state.profile);
    const loggedIn = (0, $i2KZ1.useAppSelector)((state)=>state.auth.loggedIn);
    const brandingData = theme.metadata?.customJSON?.profileDrawerV2;
    const shareText = theme.metadata?.customJSON?.share?.text;
    const isDiscordBranded = (0, $cTs7K.IS_DISCORD_ACTIVITY);
    // Translations
    const translation_quest = (0, $guTIo.useUITranslatedText)('profileDrawer_quest', 'Quest');
    const translation_mission = (0, $guTIo.useUITranslatedText)('profileDrawer_mission', 'Mission');
    const translation_logoImageUrl = (0, $guTIo.useUITranslatedText)('profileDrawer_logoImage', (0, $lmedS.pathToURL)(brandingData?.logoImagePath));
    (0, $7RNO0.useEffect)(()=>{
        if (isProfileOpen) {
            audio?.play('gust-open');
            (0, $kFQy0.sendEventV2)('open_profile');
        }
    }, [
        isProfileOpen
    ]);
    // Move focus to drawer when opened
    function onTransitionEnd(e) {
        if (isProfileOpen && e.target === e.currentTarget) setTimeout(()=>{
            closeButtonRef.current?.focus();
        }, 200);
    }
    (0, $7RNO0.useEffect)(()=>{
        // Load data initially
        dispatch((0, $6KpYp.getAvailableBadges)());
        dispatch((0, $6KpYp.getAvailableTitles)());
    }, [
        loggedIn
    ]);
    (0, $7RNO0.useEffect)(()=>{
        // Load data initially, and then again once user is logged in
        dispatch((0, $6KpYp.loadCurrentUserProfileV2)());
    }, [
        loggedIn
    ]);
    return /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($bd1843fbc4f3472c$exports.ProfileDrawer, {
            [$bd1843fbc4f3472c$exports['isOpen']]: isProfileOpen
        }),
        inert: !isProfileOpen ? '' : undefined,
        onTransitionEnd: onTransitionEnd,
        children: [
            /*#__PURE__*/ (0, $9h2J6.jsx)((0, $032b472fd8d5e329$export$2e2bcd8739ae039), {
                buttonRef: closeButtonRef,
                iconType: "close",
                buttonStyle: "round",
                ariaLabel: "Close Profile",
                className: $bd1843fbc4f3472c$exports.closeButton,
                onClick: ()=>{
                    audio?.play('gust-close');
                    (0, $kFQy0.sendEventV2)('close_profile');
                    dispatch((0, $9HMNu.closeProfile)());
                }
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)($9757c11e13e1e8ba$var$ProfileDrawerV2Contents, {
                isVisible: isProfileOpen,
                availableTitles: availableTitles?.map((title)=>(0, $guTIo.getTranslatedTitle)(title)),
                usersTitles: currentUserProfileV2?.titles?.map((title)=>(0, $guTIo.getTranslatedTitle)(title)),
                availableBadges: availableBadges?.map((title)=>(0, $guTIo.getTranslatedBadge)(title)),
                usersBadges: currentUserProfileV2?.badges?.map((title)=>(0, $guTIo.getTranslatedBadge)(title)),
                hideGameCompletionUI: brandingData?.hideGameCompletionUI,
                isGameCompleted: currentUserProfileV2?.missionCompleted,
                username: currentUserProfileV2?.displayName,
                brandCardImageUrl: (0, $lmedS.pathToURL)(brandingData?.cardImagePath),
                brandLogoImageUrl: translation_logoImageUrl,
                brandBackgroundImageUrl: (0, $lmedS.pathToURL)(brandingData?.backgroundImagePath),
                platformIcon: isDiscordBranded ? 'discord' : 'profile',
                gameDescriptionWord: isDiscordBranded ? translation_quest : translation_mission,
                gameIcon: isDiscordBranded ? 'wreath' : 'action',
                hideBadgesLine: brandingData?.hideBadgesLine,
                shareText: shareText,
                langIso: langIso
            })
        ]
    });
}
function $9757c11e13e1e8ba$var$ProfileDrawerV2Contents({ isVisible: isVisible, availableTitles: availableTitles, usersTitles: usersTitles, availableBadges: availableBadges, usersBadges: usersBadges, username: username, brandCardImageUrl: brandCardImageUrl, brandLogoImageUrl: brandLogoImageUrl, brandBackgroundImageUrl: brandBackgroundImageUrl, hideGameCompletionUI: hideGameCompletionUI, isGameCompleted: isGameCompleted, platformIcon: platformIcon, gameDescriptionWord: gameDescriptionWord, gameIcon: gameIcon, hideBadgesLine: hideBadgesLine, shareText: shareText, langIso: langIso }) {
    const [currentTab, setCurrentTab] = (0, $7RNO0.useState)('levels');
    const [isShareError, setIsShareError] = (0, $7RNO0.useState)(false);
    const [isShareLoading, setIsShareLoading] = (0, $7RNO0.useState)(false);
    const [revealedHints, setRevealedHints] = (0, $7RNO0.useState)(new Set());
    const handleRevealHint = (id)=>{
        setRevealedHints((prev)=>new Set(prev).add(id));
        (0, $kFQy0.sendEventV2)('profile_view_hint', [
            id
        ]);
    };
    // Translations
    const translation_scorecard = (0, $guTIo.useUITranslatedText)('profileDrawer_scorecard', 'Scorecard');
    const translation_titles = (0, $guTIo.useUITranslatedText)('profileDrawer_titles', 'Titles');
    const translation_level = (0, $guTIo.useUITranslatedText)('profileDrawer_level', 'Level');
    const translation_yourLevel = (0, $guTIo.useUITranslatedText)('profileDrawer_yourLevel', 'Your Level');
    const translation_incomplete = (0, $guTIo.useUITranslatedText)('profileDrawer_incomplete', 'Incomplete');
    const translation_complete = (0, $guTIo.useUITranslatedText)('profileDrawer_complete', 'Complete');
    const translation_titlesUnlocked = (0, $guTIo.useUITranslatedText)('profileDrawer_titlesUnlocked', 'Titles Unlocked');
    const translation_yourStats = (0, $guTIo.useUITranslatedText)('profileDrawer_yourStats', 'Your stats');
    const translation_levels = (0, $guTIo.useUITranslatedText)('profileDrawer_levels', 'Levels');
    const translation_share = (0, $guTIo.useUITranslatedText)('share', 'Share');
    const translation_shareError = (0, $guTIo.useUITranslatedText)('profileDrawer_shareError', 'Unable to share, try again later');
    const translation_titleNotFound = (0, $guTIo.useUITranslatedText)('profileDrawer_titleNotFound', "You haven't found this Title yet!");
    const translation_hint = (0, $guTIo.useUITranslatedText)('profileDrawer_hint', 'Hint');
    // Rarity translations
    const translation_rarityCommon = (0, $guTIo.useUITranslatedText)('rarity_common', 'Common');
    const translation_rarityUncommon = (0, $guTIo.useUITranslatedText)('rarity_uncommon', 'Uncommon');
    const translation_rarityRare = (0, $guTIo.useUITranslatedText)('rarity_rare', 'Rare');
    const translation_rarityEpic = (0, $guTIo.useUITranslatedText)('rarity_epic', 'Epic');
    const translation_rarityLegendary = (0, $guTIo.useUITranslatedText)('rarity_legendary', 'Legendary');
    const rarityTranslations = {
        common: translation_rarityCommon,
        uncommon: translation_rarityUncommon,
        rare: translation_rarityRare,
        epic: translation_rarityEpic,
        legendary: translation_rarityLegendary
    };
    const COMPLETED_COLOR = '#7FBF5A';
    // Current badge is badge with highest order number (e.g. gold with order of 2 is shown over bronze with 0)
    const currentBadge = usersBadges.length ? usersBadges.reduce((a, b)=>b.order > a.order ? b : a) : null;
    const levelColor = currentBadge?.color ?? 'white';
    const gameStatusText = isGameCompleted ? translation_complete : translation_incomplete;
    const numberOfCompletedTitles = usersTitles?.length || 0;
    const numberOfAvailableTitles = availableTitles?.length || 0;
    const titlesPercent = numberOfCompletedTitles / numberOfAvailableTitles * 100 || 0;
    async function openProfileImage() {
        setIsShareLoading(true);
        setIsShareError(false);
        try {
            const filename = `${gameDescriptionWord} Scorecard.png`;
            // Give 2 extra seconds to allow device sharing functions to load
            const ADDITIONAL_LOADING_TIME_MS = 2000;
            if (0, $cTs7K.IS_DISCORD_ACTIVITY) {
                if ((0, $1afSf.isDiscordOnMobile)()) {
                    // Don't share the card on discord mobile as not supported
                    await (0, $1afSf.triggerDiscordShare)(shareText);
                    setTimeout(()=>{
                        setIsShareLoading(false);
                    }, ADDITIONAL_LOADING_TIME_MS);
                } else {
                    // Discord desktop
                    const imageUrl = await (0, $4169a997cc05c1f6$export$2e2bcd8739ae039)(brandBackgroundImageUrl);
                    await (0, $1afSf.shareImageInDiscordDesktop)(imageUrl, filename);
                    (0, $kFQy0.sendEventV2)('share_profile_image', [
                        'discord'
                    ]);
                    setTimeout(()=>{
                        setIsShareLoading(false);
                    }, ADDITIONAL_LOADING_TIME_MS);
                }
            } else {
                // Web
                const imageUrl = await (0, $4169a997cc05c1f6$export$2e2bcd8739ae039)(brandBackgroundImageUrl);
                (0, $kFQy0.sendEventV2)('share_profile_image', [
                    'web'
                ]);
                // Does not work in iPhone browser
                window.open(imageUrl, '_blank', 'noopener');
                setTimeout(()=>{
                    setIsShareLoading(false);
                }, ADDITIONAL_LOADING_TIME_MS);
            }
        } catch (error) {
            console.log('Error sharing profile:', error);
            setIsShareError(true);
            setIsShareLoading(false);
        }
    }
    return /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
        className: $bd1843fbc4f3472c$exports.scrollContainer,
        children: /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
            className: $bd1843fbc4f3472c$exports.content,
            children: [
                /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                    className: $bd1843fbc4f3472c$exports.pageBgImage,
                    style: {
                        backgroundImage: `url("${brandBackgroundImageUrl}")`
                    }
                }),
                /*#__PURE__*/ (0, $9h2J6.jsx)("section", {
                    className: $bd1843fbc4f3472c$exports.scorecard,
                    id: "arise-profile-scorecard",
                    children: /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                        className: $bd1843fbc4f3472c$exports.scorecardContent,
                        children: [
                            /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                                className: $bd1843fbc4f3472c$exports.bgImage,
                                style: {
                                    backgroundImage: `url("${brandCardImageUrl}")`
                                }
                            }),
                            /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                                className: $bd1843fbc4f3472c$exports.divider
                            }),
                            /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                                className: $bd1843fbc4f3472c$exports.topBar,
                                children: [
                                    brandLogoImageUrl && /*#__PURE__*/ (0, $9h2J6.jsx)("img", {
                                        src: brandLogoImageUrl,
                                        className: $bd1843fbc4f3472c$exports.brandLogo,
                                        crossOrigin: "anonymous"
                                    }),
                                    /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9S5u4.default), {
                                        className: $bd1843fbc4f3472c$exports.platformLogo,
                                        type: platformIcon
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                                className: $bd1843fbc4f3472c$exports.titleBar,
                                children: [
                                    /*#__PURE__*/ (0, $9h2J6.jsxs)("h2", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))({
                                            [$bd1843fbc4f3472c$exports.isLong]: `${gameDescriptionWord} ${translation_scorecard}`.length > 18,
                                            [$bd1843fbc4f3472c$exports.isExtraLong]: `${gameDescriptionWord} ${translation_scorecard}`.length > 25
                                        }),
                                        children: [
                                            gameDescriptionWord,
                                            /*#__PURE__*/ (0, $9h2J6.jsx)("br", {}),
                                            translation_scorecard
                                        ]
                                    }),
                                    username && /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                                        className: $bd1843fbc4f3472c$exports.username,
                                        children: [
                                            /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9S5u4.default), {
                                                className: $bd1843fbc4f3472c$exports.icon,
                                                type: platformIcon
                                            }),
                                            /*#__PURE__*/ (0, $9h2J6.jsx)("span", {
                                                children: username
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                                className: $bd1843fbc4f3472c$exports.divider
                            }),
                            /*#__PURE__*/ (0, $9h2J6.jsxs)("ul", {
                                className: $bd1843fbc4f3472c$exports.statBoxContainer,
                                children: [
                                    !hideGameCompletionUI && /*#__PURE__*/ (0, $9h2J6.jsxs)("li", {
                                        className: $bd1843fbc4f3472c$exports.statBox,
                                        children: [
                                            /*#__PURE__*/ (0, $9h2J6.jsx)((0, $07c52129b6fee7d3$export$2e2bcd8739ae039), {
                                                isLoaded: typeof isGameCompleted === 'boolean'
                                            }),
                                            /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9S5u4.default), {
                                                className: $bd1843fbc4f3472c$exports.icon,
                                                type: gameIcon
                                            }),
                                            /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                                                className: $bd1843fbc4f3472c$exports.statTextContainer,
                                                children: [
                                                    /*#__PURE__*/ (0, $9h2J6.jsx)("span", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($bd1843fbc4f3472c$exports.statTitle, {
                                                            [$bd1843fbc4f3472c$exports.isLong]: gameDescriptionWord?.length > 10
                                                        }),
                                                        children: gameDescriptionWord
                                                    }),
                                                    /*#__PURE__*/ (0, $9h2J6.jsx)("span", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($bd1843fbc4f3472c$exports.subtitle, {
                                                            [$bd1843fbc4f3472c$exports.isLong]: gameStatusText?.length > 10
                                                        }),
                                                        children: gameStatusText
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $9h2J6.jsxs)("li", {
                                        className: $bd1843fbc4f3472c$exports.statBox,
                                        children: [
                                            /*#__PURE__*/ (0, $9h2J6.jsx)((0, $07c52129b6fee7d3$export$2e2bcd8739ae039), {
                                                isLoaded: typeof numberOfCompletedTitles === 'number' && typeof numberOfAvailableTitles === 'number'
                                            }),
                                            /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9S5u4.default), {
                                                className: $bd1843fbc4f3472c$exports.icon,
                                                type: "crown"
                                            }),
                                            /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                                                className: $bd1843fbc4f3472c$exports.statTextContainer,
                                                children: [
                                                    /*#__PURE__*/ (0, $9h2J6.jsxs)("span", {
                                                        className: $bd1843fbc4f3472c$exports.statTitle,
                                                        children: [
                                                            numberOfCompletedTitles,
                                                            "/",
                                                            numberOfAvailableTitles
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $9h2J6.jsx)("span", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($bd1843fbc4f3472c$exports.subtitle, {
                                                            [$bd1843fbc4f3472c$exports.isLong]: translation_titles?.length > 10
                                                        }),
                                                        children: translation_titles
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $9h2J6.jsxs)("li", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($bd1843fbc4f3472c$exports.statBox, $bd1843fbc4f3472c$exports.statBoxLong),
                                        children: [
                                            /*#__PURE__*/ (0, $9h2J6.jsx)((0, $07c52129b6fee7d3$export$2e2bcd8739ae039), {
                                                isLoaded: !!usersBadges
                                            }),
                                            /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9S5u4.default), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($bd1843fbc4f3472c$exports.icon, $bd1843fbc4f3472c$exports.active),
                                                type: "shield",
                                                style: {
                                                    fill: levelColor
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                                                className: $bd1843fbc4f3472c$exports.statTextContainer,
                                                children: [
                                                    /*#__PURE__*/ (0, $9h2J6.jsx)("span", {
                                                        className: $bd1843fbc4f3472c$exports.subtitle,
                                                        children: translation_level
                                                    }),
                                                    /*#__PURE__*/ (0, $9h2J6.jsx)("span", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($bd1843fbc4f3472c$exports.statTitle, {
                                                            [$bd1843fbc4f3472c$exports.isLong]: (currentBadge?.name ?? translation_incomplete)?.length > 13
                                                        }),
                                                        style: {
                                                            color: levelColor
                                                        },
                                                        children: currentBadge?.name ?? translation_incomplete
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $9h2J6.jsx)((0, $0358faef824b4d47$export$2e2bcd8739ae039), {
                                        classname: $bd1843fbc4f3472c$exports.levelBadge,
                                        imagePath: currentBadge?.imagePath,
                                        isLocked: !currentBadge,
                                        isLoading: !usersBadges,
                                        shimmerDelay: 3
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                                className: $bd1843fbc4f3472c$exports.divider
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                    className: $bd1843fbc4f3472c$exports.ctaButtonsContainer,
                    children: [
                        /*#__PURE__*/ (0, $9h2J6.jsxs)("button", {
                            onClick: openProfileImage,
                            disabled: isShareLoading,
                            children: [
                                translation_share,
                                /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9S5u4.default), {
                                    type: isShareLoading ? 'animated-spinner' : 'share'
                                })
                            ]
                        }),
                        isShareError && /*#__PURE__*/ (0, $9h2J6.jsx)("p", {
                            className: $bd1843fbc4f3472c$exports.shareError,
                            children: translation_shareError
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9h2J6.jsxs)("section", {
                    className: $bd1843fbc4f3472c$exports.yourStats,
                    children: [
                        /*#__PURE__*/ (0, $9h2J6.jsxs)("h2", {
                            children: [
                                /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9S5u4.default), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($bd1843fbc4f3472c$exports.icon),
                                    type: "bolt"
                                }),
                                translation_yourStats
                            ]
                        }),
                        /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                            className: $bd1843fbc4f3472c$exports.gridContainer,
                            children: [
                                /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($bd1843fbc4f3472c$exports.level, $bd1843fbc4f3472c$exports.box),
                                    children: [
                                        /*#__PURE__*/ (0, $9h2J6.jsx)((0, $07c52129b6fee7d3$export$2e2bcd8739ae039), {
                                            isLoaded: !!usersBadges
                                        }),
                                        /*#__PURE__*/ (0, $9h2J6.jsx)((0, $0358faef824b4d47$export$2e2bcd8739ae039), {
                                            classname: $bd1843fbc4f3472c$exports.levelBadge,
                                            imagePath: currentBadge?.imagePath,
                                            isLoading: !usersBadges,
                                            shimmerDelay: 4,
                                            isLocked: !currentBadge
                                        }),
                                        /*#__PURE__*/ (0, $9h2J6.jsx)("span", {
                                            className: $bd1843fbc4f3472c$exports.statTitle,
                                            style: {
                                                color: levelColor
                                            },
                                            children: currentBadge?.name ?? translation_incomplete
                                        }),
                                        /*#__PURE__*/ (0, $9h2J6.jsx)("span", {
                                            className: $bd1843fbc4f3472c$exports.subtitle,
                                            children: translation_yourLevel
                                        })
                                    ]
                                }),
                                !hideGameCompletionUI && /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($bd1843fbc4f3472c$exports.statBox, $bd1843fbc4f3472c$exports.box),
                                    children: [
                                        /*#__PURE__*/ (0, $9h2J6.jsx)((0, $07c52129b6fee7d3$export$2e2bcd8739ae039), {
                                            isLoaded: typeof isGameCompleted === 'boolean'
                                        }),
                                        /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                                            className: $bd1843fbc4f3472c$exports.left,
                                            children: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9S5u4.default), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($bd1843fbc4f3472c$exports.icon, $bd1843fbc4f3472c$exports.active),
                                                type: gameIcon,
                                                style: {
                                                    fill: isGameCompleted ? COMPLETED_COLOR : '#BF5A5A'
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $9h2J6.jsx)("span", {
                                                    className: $bd1843fbc4f3472c$exports.statTitle,
                                                    children: gameDescriptionWord
                                                }),
                                                /*#__PURE__*/ (0, $9h2J6.jsx)("span", {
                                                    className: $bd1843fbc4f3472c$exports.subtitle,
                                                    children: gameStatusText
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($bd1843fbc4f3472c$exports.statBox, $bd1843fbc4f3472c$exports.box),
                                    children: [
                                        /*#__PURE__*/ (0, $9h2J6.jsx)((0, $07c52129b6fee7d3$export$2e2bcd8739ae039), {
                                            isLoaded: typeof numberOfCompletedTitles === 'number' && typeof numberOfAvailableTitles === 'number'
                                        }),
                                        /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                                            className: $bd1843fbc4f3472c$exports.left,
                                            children: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $7edc08a8d10e5d25$export$2e2bcd8739ae039), {
                                                percent: isVisible ? titlesPercent : 100,
                                                className: $bd1843fbc4f3472c$exports.progress,
                                                icon: "crown"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $9h2J6.jsxs)("span", {
                                                    className: $bd1843fbc4f3472c$exports.titlesNumber,
                                                    children: [
                                                        /*#__PURE__*/ (0, $9h2J6.jsx)("span", {
                                                            className: $bd1843fbc4f3472c$exports.highlight,
                                                            children: numberOfCompletedTitles
                                                        }),
                                                        /*#__PURE__*/ (0, $9h2J6.jsxs)("span", {
                                                            children: [
                                                                "/",
                                                                numberOfAvailableTitles
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $9h2J6.jsx)("span", {
                                                    className: $bd1843fbc4f3472c$exports.subtitle,
                                                    children: translation_titlesUnlocked
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9h2J6.jsxs)("section", {
                    className: $bd1843fbc4f3472c$exports.tabGroup,
                    children: [
                        /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                            className: $bd1843fbc4f3472c$exports.tabButtons,
                            role: "tablist",
                            "aria-label": "Stat Information Options",
                            children: [
                                /*#__PURE__*/ (0, $9h2J6.jsxs)("button", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))({
                                        [$bd1843fbc4f3472c$exports.active]: currentTab === 'levels'
                                    }),
                                    role: "tab",
                                    "aria-selected": currentTab === 'levels',
                                    disabled: currentTab === 'levels',
                                    "aria-controls": "panel-levels",
                                    id: "tab-levels",
                                    onClick: ()=>{
                                        setCurrentTab('levels');
                                        (0, $kFQy0.sendEventV2)('view_profile_section', [
                                            'levels'
                                        ]);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9S5u4.default), {
                                            type: "shield"
                                        }),
                                        translation_levels
                                    ]
                                }),
                                /*#__PURE__*/ (0, $9h2J6.jsxs)("button", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))({
                                        [$bd1843fbc4f3472c$exports.active]: currentTab === 'titles'
                                    }),
                                    role: "tab",
                                    "aria-selected": currentTab === 'titles',
                                    disabled: currentTab === 'titles',
                                    "aria-controls": "panel-titles",
                                    id: "tab-titles",
                                    onClick: ()=>{
                                        setCurrentTab('titles');
                                        (0, $kFQy0.sendEventV2)('view_profile_section', [
                                            'titles'
                                        ]);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9S5u4.default), {
                                            type: "crown"
                                        }),
                                        translation_titles
                                    ]
                                })
                            ]
                        }),
                        currentTab === 'levels' && /*#__PURE__*/ (0, $9h2J6.jsx)("section", {
                            id: "panel-levels",
                            role: "tabpanel",
                            "aria-labelledby": "tab-levels",
                            children: /*#__PURE__*/ (0, $9h2J6.jsxs)("ul", {
                                className: $bd1843fbc4f3472c$exports.levelInfoBoxes,
                                children: [
                                    /*#__PURE__*/ (0, $9h2J6.jsx)((0, $07c52129b6fee7d3$export$2e2bcd8739ae039), {
                                        isLoaded: availableBadges && !!usersBadges,
                                        className: $bd1843fbc4f3472c$exports.tabGroupLoader
                                    }),
                                    availableBadges && usersBadges && availableBadges?.map((badge, index)=>{
                                        const badgeIsCompleted = usersBadges?.some((userBadge)=>userBadge.id === badge.id);
                                        return /*#__PURE__*/ (0, $9h2J6.jsxs)("li", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($bd1843fbc4f3472c$exports.levelInfoBox, {
                                                [$bd1843fbc4f3472c$exports.hasLine]: !hideBadgesLine
                                            }),
                                            children: [
                                                /*#__PURE__*/ (0, $9h2J6.jsx)((0, $0358faef824b4d47$export$2e2bcd8739ae039), {
                                                    classname: $bd1843fbc4f3472c$exports.levelBadge,
                                                    imagePath: badge.imagePath,
                                                    isLoading: !usersBadges,
                                                    shimmerDelay: index,
                                                    isLocked: !badgeIsCompleted
                                                }),
                                                /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                                                    className: $bd1843fbc4f3472c$exports.textContainer,
                                                    children: [
                                                        /*#__PURE__*/ (0, $9h2J6.jsx)("span", {
                                                            className: $bd1843fbc4f3472c$exports.largerText,
                                                            style: {
                                                                color: badge.color
                                                            },
                                                            children: badge.name
                                                        }),
                                                        /*#__PURE__*/ (0, $9h2J6.jsx)("span", {
                                                            className: $bd1843fbc4f3472c$exports.subtitle,
                                                            children: badge.description
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9S5u4.default), {
                                                    className: $bd1843fbc4f3472c$exports.icon,
                                                    type: "checked-box",
                                                    style: {
                                                        fill: badgeIsCompleted ? COMPLETED_COLOR : '#4E4E4E'
                                                    }
                                                })
                                            ]
                                        }, badge.id);
                                    })
                                ]
                            })
                        }),
                        currentTab === 'titles' && /*#__PURE__*/ (0, $9h2J6.jsx)("section", {
                            id: "panel-titles",
                            role: "tabpanel",
                            "aria-labelledby": "tab-titles",
                            children: /*#__PURE__*/ (0, $9h2J6.jsxs)("ul", {
                                className: $bd1843fbc4f3472c$exports.titles,
                                children: [
                                    /*#__PURE__*/ (0, $9h2J6.jsx)((0, $07c52129b6fee7d3$export$2e2bcd8739ae039), {
                                        isLoaded: !!availableTitles,
                                        className: $bd1843fbc4f3472c$exports.tabGroupLoader
                                    }),
                                    availableTitles?.map((title)=>{
                                        const titleIsCompleted = usersTitles?.some((userBadge)=>userBadge.id === title.id);
                                        return /*#__PURE__*/ (0, $9h2J6.jsx)("li", {
                                            children: titleIsCompleted ? /*#__PURE__*/ (0, $9h2J6.jsxs)((0, $9h2J6.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                                                        className: $bd1843fbc4f3472c$exports.left,
                                                        children: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $8df794fe4c83106a$export$2e2bcd8739ae039), {
                                                            text: title.title,
                                                            rarity: title.rarity
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $9h2J6.jsxs)("span", {
                                                        className: $bd1843fbc4f3472c$exports.subtitle,
                                                        children: [
                                                            /*#__PURE__*/ (0, $9h2J6.jsxs)("span", {
                                                                className: $bd1843fbc4f3472c$exports[title.rarity?.toLowerCase()],
                                                                children: [
                                                                    rarityTranslations[title.rarity?.toLowerCase()] || title.rarity,
                                                                    langIso?.toLowerCase() === 'fr' ? "\xa0" : '',
                                                                    ":",
                                                                    ' '
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $9h2J6.jsx)("span", {
                                                                children: title.description
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, $9h2J6.jsxs)((0, $9h2J6.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                                                        className: $bd1843fbc4f3472c$exports.left,
                                                        children: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9S5u4.default), {
                                                            className: $bd1843fbc4f3472c$exports.lockedIcon,
                                                            type: "locked"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $9h2J6.jsx)("span", {
                                                        className: $bd1843fbc4f3472c$exports.subtitle,
                                                        children: revealedHints.has(title.id) ? title.hint : translation_titleNotFound
                                                    }),
                                                    !revealedHints.has(title.id) && /*#__PURE__*/ (0, $9h2J6.jsx)("button", {
                                                        onClick: ()=>handleRevealHint(title.id),
                                                        className: $bd1843fbc4f3472c$exports.hintButton,
                                                        children: translation_hint
                                                    })
                                                ]
                                            })
                                        }, title.id);
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}



var $9h2J6 = parcelRequire("9h2J6");

var $7RNO0 = parcelRequire("7RNO0");

var $7RNO0 = parcelRequire("7RNO0");
/**
 * Rounds number to given decimal
 * eg. roundNumber(2.34343, 1) => 2.3
 */ var $9f57700f268362ee$var$roundNumber = function(num, decimal) {
    return Number(num.toFixed(decimal));
};
/**
 * Checks if value is number, if not it returns default value
 * 1# eg. checkIsNumber(2, 30) => 2
 * 2# eg. checkIsNumber(null, 30) => 30
 */ var $9f57700f268362ee$var$checkIsNumber = function(num, defaultValue) {
    return typeof num === "number" ? num : defaultValue;
};
var $9f57700f268362ee$var$handleCallback = function(context, event, callback) {
    if (callback && typeof callback === "function") callback(context, event);
};
/* eslint-disable no-plusplus */ /* eslint-disable no-param-reassign */ /**
 * Functions should return denominator of the target value, which is the next animation step.
 * t is a value from 0 to 1, reflecting the percentage of animation status.
 */ var $9f57700f268362ee$var$easeOut = function(t) {
    return -Math.cos(t * Math.PI) / 2 + 0.5;
};
// linear
var $9f57700f268362ee$var$linear = function(t) {
    return t;
};
// accelerating from zero velocity
var $9f57700f268362ee$var$easeInQuad = function(t) {
    return t * t;
};
// decelerating to zero velocity
var $9f57700f268362ee$var$easeOutQuad = function(t) {
    return t * (2 - t);
};
// acceleration until halfway, then deceleration
var $9f57700f268362ee$var$easeInOutQuad = function(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
};
// accelerating from zero velocity
var $9f57700f268362ee$var$easeInCubic = function(t) {
    return t * t * t;
};
// decelerating to zero velocity
var $9f57700f268362ee$var$easeOutCubic = function(t) {
    return --t * t * t + 1;
};
// acceleration until halfway, then deceleration
var $9f57700f268362ee$var$easeInOutCubic = function(t) {
    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
};
// accelerating from zero velocity
var $9f57700f268362ee$var$easeInQuart = function(t) {
    return t * t * t * t;
};
// decelerating to zero velocity
var $9f57700f268362ee$var$easeOutQuart = function(t) {
    return 1 - --t * t * t * t;
};
// acceleration until halfway, then deceleration
var $9f57700f268362ee$var$easeInOutQuart = function(t) {
    return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
};
// accelerating from zero velocity
var $9f57700f268362ee$var$easeInQuint = function(t) {
    return t * t * t * t * t;
};
// decelerating to zero velocity
var $9f57700f268362ee$var$easeOutQuint = function(t) {
    return 1 + --t * t * t * t * t;
};
// acceleration until halfway, then deceleration
var $9f57700f268362ee$var$easeInOutQuint = function(t) {
    return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
};
var $9f57700f268362ee$var$animations = {
    easeOut: $9f57700f268362ee$var$easeOut,
    linear: $9f57700f268362ee$var$linear,
    easeInQuad: $9f57700f268362ee$var$easeInQuad,
    easeOutQuad: $9f57700f268362ee$var$easeOutQuad,
    easeInOutQuad: $9f57700f268362ee$var$easeInOutQuad,
    easeInCubic: $9f57700f268362ee$var$easeInCubic,
    easeOutCubic: $9f57700f268362ee$var$easeOutCubic,
    easeInOutCubic: $9f57700f268362ee$var$easeInOutCubic,
    easeInQuart: $9f57700f268362ee$var$easeInQuart,
    easeOutQuart: $9f57700f268362ee$var$easeOutQuart,
    easeInOutQuart: $9f57700f268362ee$var$easeInOutQuart,
    easeInQuint: $9f57700f268362ee$var$easeInQuint,
    easeOutQuint: $9f57700f268362ee$var$easeOutQuint,
    easeInOutQuint: $9f57700f268362ee$var$easeInOutQuint
};
/* eslint-disable no-param-reassign */ var $9f57700f268362ee$var$handleCancelAnimationFrame = function(animation) {
    if (typeof animation === "number") cancelAnimationFrame(animation);
};
var $9f57700f268362ee$var$handleCancelAnimation = function(contextInstance) {
    if (!contextInstance.mounted) return;
    $9f57700f268362ee$var$handleCancelAnimationFrame(contextInstance.animation);
    // Clear animation state
    contextInstance.animate = false;
    contextInstance.animation = null;
    contextInstance.velocity = null;
};
function $9f57700f268362ee$var$handleSetupAnimation(contextInstance, animationName, animationTime, callback) {
    if (!contextInstance.mounted) return;
    var startTime = new Date().getTime();
    var lastStep = 1;
    // if another animation is active
    $9f57700f268362ee$var$handleCancelAnimation(contextInstance);
    // new animation
    contextInstance.animation = function() {
        if (!contextInstance.mounted) return $9f57700f268362ee$var$handleCancelAnimationFrame(contextInstance.animation);
        var frameTime = new Date().getTime() - startTime;
        var animationProgress = frameTime / animationTime;
        var animationType = $9f57700f268362ee$var$animations[animationName];
        var step = animationType(animationProgress);
        if (frameTime >= animationTime) {
            callback(lastStep);
            contextInstance.animation = null;
        } else if (contextInstance.animation) {
            callback(step);
            requestAnimationFrame(contextInstance.animation);
        }
    };
    requestAnimationFrame(contextInstance.animation);
}
function $9f57700f268362ee$var$isValidTargetState(targetState) {
    var scale = targetState.scale, positionX = targetState.positionX, positionY = targetState.positionY;
    if (Number.isNaN(scale) || Number.isNaN(positionX) || Number.isNaN(positionY)) return false;
    return true;
}
function $9f57700f268362ee$var$animate(contextInstance, targetState, animationTime, animationName) {
    var isValid = $9f57700f268362ee$var$isValidTargetState(targetState);
    if (!contextInstance.mounted || !isValid) return;
    var setTransformState = contextInstance.setTransformState;
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    var scaleDiff = targetState.scale - scale;
    var positionXDiff = targetState.positionX - positionX;
    var positionYDiff = targetState.positionY - positionY;
    if (animationTime === 0) setTransformState(targetState.scale, targetState.positionX, targetState.positionY);
    else // animation start timestamp
    $9f57700f268362ee$var$handleSetupAnimation(contextInstance, animationName, animationTime, function(step) {
        var newScale = scale + scaleDiff * step;
        var newPositionX = positionX + positionXDiff * step;
        var newPositionY = positionY + positionYDiff * step;
        setTransformState(newScale, newPositionX, newPositionY);
    });
}
/* eslint-disable no-param-reassign */ function $9f57700f268362ee$var$getComponentsSizes(wrapperComponent, contentComponent, newScale) {
    var wrapperWidth = wrapperComponent.offsetWidth;
    var wrapperHeight = wrapperComponent.offsetHeight;
    var contentWidth = contentComponent.offsetWidth;
    var contentHeight = contentComponent.offsetHeight;
    var newContentWidth = contentWidth * newScale;
    var newContentHeight = contentHeight * newScale;
    var newDiffWidth = wrapperWidth - newContentWidth;
    var newDiffHeight = wrapperHeight - newContentHeight;
    return {
        wrapperWidth: wrapperWidth,
        wrapperHeight: wrapperHeight,
        newContentWidth: newContentWidth,
        newDiffWidth: newDiffWidth,
        newContentHeight: newContentHeight,
        newDiffHeight: newDiffHeight
    };
}
var $9f57700f268362ee$var$getBounds = function(wrapperWidth, newContentWidth, diffWidth, wrapperHeight, newContentHeight, diffHeight, centerZoomedOut) {
    var scaleWidthFactor = wrapperWidth > newContentWidth ? diffWidth * (centerZoomedOut ? 1 : 0.5) : 0;
    var scaleHeightFactor = wrapperHeight > newContentHeight ? diffHeight * (centerZoomedOut ? 1 : 0.5) : 0;
    var minPositionX = wrapperWidth - newContentWidth - scaleWidthFactor;
    var maxPositionX = scaleWidthFactor;
    var minPositionY = wrapperHeight - newContentHeight - scaleHeightFactor;
    var maxPositionY = scaleHeightFactor;
    return {
        minPositionX: minPositionX,
        maxPositionX: maxPositionX,
        minPositionY: minPositionY,
        maxPositionY: maxPositionY
    };
};
var $9f57700f268362ee$var$calculateBounds = function(contextInstance, newScale) {
    var wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
    var centerZoomedOut = contextInstance.setup.centerZoomedOut;
    if (!wrapperComponent || !contentComponent) throw new Error("Components are not mounted");
    var _a = $9f57700f268362ee$var$getComponentsSizes(wrapperComponent, contentComponent, newScale), wrapperWidth = _a.wrapperWidth, wrapperHeight = _a.wrapperHeight, newContentWidth = _a.newContentWidth, newDiffWidth = _a.newDiffWidth, newContentHeight = _a.newContentHeight, newDiffHeight = _a.newDiffHeight;
    var bounds = $9f57700f268362ee$var$getBounds(wrapperWidth, newContentWidth, newDiffWidth, wrapperHeight, newContentHeight, newDiffHeight, Boolean(centerZoomedOut));
    return bounds;
};
/**
 * Keeps value between given bounds, used for limiting view to given boundaries
 * 1# eg. boundLimiter(2, 0, 3, true) => 2
 * 2# eg. boundLimiter(4, 0, 3, true) => 3
 * 3# eg. boundLimiter(-2, 0, 3, true) => 0
 * 4# eg. boundLimiter(10, 0, 3, false) => 10
 */ var $9f57700f268362ee$var$boundLimiter = function(value, minBound, maxBound, isActive) {
    if (!isActive) return $9f57700f268362ee$var$roundNumber(value, 2);
    if (value < minBound) return $9f57700f268362ee$var$roundNumber(minBound, 2);
    if (value > maxBound) return $9f57700f268362ee$var$roundNumber(maxBound, 2);
    return $9f57700f268362ee$var$roundNumber(value, 2);
};
var $9f57700f268362ee$var$handleCalculateBounds = function(contextInstance, newScale) {
    var bounds = $9f57700f268362ee$var$calculateBounds(contextInstance, newScale);
    // Save bounds
    contextInstance.bounds = bounds;
    return bounds;
};
function $9f57700f268362ee$var$getMouseBoundedPosition(positionX, positionY, bounds, limitToBounds, paddingValueX, paddingValueY, wrapperComponent) {
    var minPositionX = bounds.minPositionX, minPositionY = bounds.minPositionY, maxPositionX = bounds.maxPositionX, maxPositionY = bounds.maxPositionY;
    var paddingX = 0;
    var paddingY = 0;
    if (wrapperComponent) {
        paddingX = paddingValueX;
        paddingY = paddingValueY;
    }
    var x = $9f57700f268362ee$var$boundLimiter(positionX, minPositionX - paddingX, maxPositionX + paddingX, limitToBounds);
    var y = $9f57700f268362ee$var$boundLimiter(positionY, minPositionY - paddingY, maxPositionY + paddingY, limitToBounds);
    return {
        x: x,
        y: y
    };
}
function $9f57700f268362ee$var$handleCalculateZoomPositions(contextInstance, mouseX, mouseY, newScale, bounds, limitToBounds) {
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    var scaleDifference = newScale - scale;
    if (typeof mouseX !== "number" || typeof mouseY !== "number") {
        console.error("Mouse X and Y position were not provided!");
        return {
            x: positionX,
            y: positionY
        };
    }
    var calculatedPositionX = positionX - mouseX * scaleDifference;
    var calculatedPositionY = positionY - mouseY * scaleDifference;
    // do not limit to bounds when there is padding animation,
    // it causes animation strange behaviour
    var newPositions = $9f57700f268362ee$var$getMouseBoundedPosition(calculatedPositionX, calculatedPositionY, bounds, limitToBounds, 0, 0, null);
    return newPositions;
}
function $9f57700f268362ee$var$checkZoomBounds(zoom, minScale, maxScale, zoomPadding, enablePadding) {
    var scalePadding = enablePadding ? zoomPadding : 0;
    var minScaleWithPadding = minScale - scalePadding;
    if (!Number.isNaN(maxScale) && zoom >= maxScale) return maxScale;
    if (!Number.isNaN(minScale) && zoom <= minScaleWithPadding) return minScaleWithPadding;
    return zoom;
}
var $9f57700f268362ee$var$isPanningStartAllowed = function(contextInstance, event) {
    var excluded = contextInstance.setup.panning.excluded;
    var isInitialized = contextInstance.isInitialized, wrapperComponent = contextInstance.wrapperComponent;
    var target = event.target;
    var targetIsShadowDom = "shadowRoot" in target && "composedPath" in event;
    var isWrapperChild = targetIsShadowDom ? event.composedPath().some(function(el) {
        if (!(el instanceof Element)) return false;
        return wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.contains(el);
    }) : wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.contains(target);
    var isAllowed = isInitialized && target && isWrapperChild;
    if (!isAllowed) return false;
    var isExcluded = $9f57700f268362ee$var$isExcludedNode(target, excluded);
    if (isExcluded) return false;
    return true;
};
var $9f57700f268362ee$var$isPanningAllowed = function(contextInstance) {
    var isInitialized = contextInstance.isInitialized, isPanning = contextInstance.isPanning, setup = contextInstance.setup;
    var disabled = setup.panning.disabled;
    var isAllowed = isInitialized && isPanning && !disabled;
    if (!isAllowed) return false;
    return true;
};
var $9f57700f268362ee$var$handlePanningSetup = function(contextInstance, event) {
    var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY;
    contextInstance.isPanning = true;
    // Panning with mouse
    var x = event.clientX;
    var y = event.clientY;
    contextInstance.startCoords = {
        x: x - positionX,
        y: y - positionY
    };
};
var $9f57700f268362ee$var$handleTouchPanningSetup = function(contextInstance, event) {
    var touches = event.touches;
    var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY;
    contextInstance.isPanning = true;
    // Panning with touch
    var oneFingerTouch = touches.length === 1;
    if (oneFingerTouch) {
        var x = touches[0].clientX;
        var y = touches[0].clientY;
        contextInstance.startCoords = {
            x: x - positionX,
            y: y - positionY
        };
    }
};
function $9f57700f268362ee$var$handlePanToBounds(contextInstance) {
    var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY, scale = _a.scale;
    var _b = contextInstance.setup, disabled = _b.disabled, limitToBounds = _b.limitToBounds, centerZoomedOut = _b.centerZoomedOut;
    var wrapperComponent = contextInstance.wrapperComponent;
    if (disabled || !wrapperComponent || !contextInstance.bounds) return;
    var _c = contextInstance.bounds, maxPositionX = _c.maxPositionX, minPositionX = _c.minPositionX, maxPositionY = _c.maxPositionY, minPositionY = _c.minPositionY;
    var xChanged = positionX > maxPositionX || positionX < minPositionX;
    var yChanged = positionY > maxPositionY || positionY < minPositionY;
    var mousePosX = positionX > maxPositionX ? wrapperComponent.offsetWidth : contextInstance.setup.minPositionX || 0;
    var mousePosY = positionY > maxPositionY ? wrapperComponent.offsetHeight : contextInstance.setup.minPositionY || 0;
    var _d = $9f57700f268362ee$var$handleCalculateZoomPositions(contextInstance, mousePosX, mousePosY, scale, contextInstance.bounds, limitToBounds || centerZoomedOut), x = _d.x, y = _d.y;
    return {
        scale: scale,
        positionX: xChanged ? x : positionX,
        positionY: yChanged ? y : positionY
    };
}
function $9f57700f268362ee$var$handleNewPosition(contextInstance, newPositionX, newPositionY, paddingValueX, paddingValueY) {
    var limitToBounds = contextInstance.setup.limitToBounds;
    var wrapperComponent = contextInstance.wrapperComponent, bounds = contextInstance.bounds;
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    if (wrapperComponent === null || bounds === null || newPositionX === positionX && newPositionY === positionY) return;
    var _b = $9f57700f268362ee$var$getMouseBoundedPosition(newPositionX, newPositionY, bounds, limitToBounds, paddingValueX, paddingValueY, wrapperComponent), x = _b.x, y = _b.y;
    contextInstance.setTransformState(scale, x, y);
}
var $9f57700f268362ee$var$getPanningClientPosition = function(contextInstance, clientX, clientY) {
    var startCoords = contextInstance.startCoords, transformState = contextInstance.transformState;
    var panning = contextInstance.setup.panning;
    var lockAxisX = panning.lockAxisX, lockAxisY = panning.lockAxisY;
    var positionX = transformState.positionX, positionY = transformState.positionY;
    if (!startCoords) return {
        x: positionX,
        y: positionY
    };
    var mouseX = clientX - startCoords.x;
    var mouseY = clientY - startCoords.y;
    var newPositionX = lockAxisX ? positionX : mouseX;
    var newPositionY = lockAxisY ? positionY : mouseY;
    return {
        x: newPositionX,
        y: newPositionY
    };
};
var $9f57700f268362ee$var$getPaddingValue = function(contextInstance, size) {
    var setup = contextInstance.setup, transformState = contextInstance.transformState;
    var scale = transformState.scale;
    var minScale = setup.minScale, disablePadding = setup.disablePadding;
    if (size > 0 && scale >= minScale && !disablePadding) return size;
    return 0;
};
var $9f57700f268362ee$var$isVelocityCalculationAllowed = function(contextInstance) {
    var mounted = contextInstance.mounted;
    var _a = contextInstance.setup, disabled = _a.disabled, velocityAnimation = _a.velocityAnimation;
    var scale = contextInstance.transformState.scale;
    var disabledVelocity = velocityAnimation.disabled;
    var isAllowed = !disabledVelocity || scale > 1 || !disabled || mounted;
    if (!isAllowed) return false;
    return true;
};
var $9f57700f268362ee$var$isVelocityAllowed = function(contextInstance) {
    var mounted = contextInstance.mounted, velocity = contextInstance.velocity, bounds = contextInstance.bounds;
    var _a = contextInstance.setup, disabled = _a.disabled, velocityAnimation = _a.velocityAnimation;
    var scale = contextInstance.transformState.scale;
    var disabledVelocity = velocityAnimation.disabled;
    var isAllowed = !disabledVelocity || scale > 1 || !disabled || mounted;
    if (!isAllowed) return false;
    if (!velocity || !bounds) return false;
    return true;
};
function $9f57700f268362ee$var$getVelocityMoveTime(contextInstance, velocity) {
    var velocityAnimation = contextInstance.setup.velocityAnimation;
    var equalToMove = velocityAnimation.equalToMove, animationTime = velocityAnimation.animationTime, sensitivity = velocityAnimation.sensitivity;
    if (equalToMove) return animationTime * velocity * sensitivity;
    return animationTime;
}
function $9f57700f268362ee$var$getVelocityPosition(newPosition, startPosition, currentPosition, isLocked, limitToBounds, minPosition, maxPosition, minTarget, maxTarget, step) {
    if (limitToBounds) {
        if (startPosition > maxPosition && currentPosition > maxPosition) {
            var calculatedPosition = maxPosition + (newPosition - maxPosition) * step;
            if (calculatedPosition > maxTarget) return maxTarget;
            if (calculatedPosition < maxPosition) return maxPosition;
            return calculatedPosition;
        }
        if (startPosition < minPosition && currentPosition < minPosition) {
            var calculatedPosition = minPosition + (newPosition - minPosition) * step;
            if (calculatedPosition < minTarget) return minTarget;
            if (calculatedPosition > minPosition) return minPosition;
            return calculatedPosition;
        }
    }
    if (isLocked) return startPosition;
    return $9f57700f268362ee$var$boundLimiter(newPosition, minPosition, maxPosition, limitToBounds);
}
function $9f57700f268362ee$var$getSizeMultiplier(wrapperComponent, equalToMove) {
    var defaultMultiplier = 1;
    if (equalToMove) return Math.min(defaultMultiplier, wrapperComponent.offsetWidth / window.innerWidth);
    return defaultMultiplier;
}
function $9f57700f268362ee$var$handleCalculateVelocity(contextInstance, position) {
    var isAllowed = $9f57700f268362ee$var$isVelocityCalculationAllowed(contextInstance);
    if (!isAllowed) return;
    var lastMousePosition = contextInstance.lastMousePosition, velocityTime = contextInstance.velocityTime, setup = contextInstance.setup;
    var wrapperComponent = contextInstance.wrapperComponent;
    var equalToMove = setup.velocityAnimation.equalToMove;
    var now = Date.now();
    if (lastMousePosition && velocityTime && wrapperComponent) {
        var sizeMultiplier = $9f57700f268362ee$var$getSizeMultiplier(wrapperComponent, equalToMove);
        var distanceX = position.x - lastMousePosition.x;
        var distanceY = position.y - lastMousePosition.y;
        var velocityX = distanceX / sizeMultiplier;
        var velocityY = distanceY / sizeMultiplier;
        var interval = now - velocityTime;
        var speed = distanceX * distanceX + distanceY * distanceY;
        var velocity = Math.sqrt(speed) / interval;
        contextInstance.velocity = {
            velocityX: velocityX,
            velocityY: velocityY,
            total: velocity
        };
    }
    contextInstance.lastMousePosition = position;
    contextInstance.velocityTime = now;
}
function $9f57700f268362ee$var$handleVelocityPanning(contextInstance) {
    var velocity = contextInstance.velocity, bounds = contextInstance.bounds, setup = contextInstance.setup, wrapperComponent = contextInstance.wrapperComponent;
    var isAllowed = $9f57700f268362ee$var$isVelocityAllowed(contextInstance);
    if (!isAllowed || !velocity || !bounds || !wrapperComponent) return;
    var velocityX = velocity.velocityX, velocityY = velocity.velocityY, total = velocity.total;
    var maxPositionX = bounds.maxPositionX, minPositionX = bounds.minPositionX, maxPositionY = bounds.maxPositionY, minPositionY = bounds.minPositionY;
    var limitToBounds = setup.limitToBounds, alignmentAnimation = setup.alignmentAnimation;
    var zoomAnimation = setup.zoomAnimation, panning = setup.panning;
    var lockAxisY = panning.lockAxisY, lockAxisX = panning.lockAxisX;
    var animationType = zoomAnimation.animationType;
    var sizeX = alignmentAnimation.sizeX, sizeY = alignmentAnimation.sizeY, velocityAlignmentTime = alignmentAnimation.velocityAlignmentTime;
    var alignAnimationTime = velocityAlignmentTime;
    var moveAnimationTime = $9f57700f268362ee$var$getVelocityMoveTime(contextInstance, total);
    var finalAnimationTime = Math.max(moveAnimationTime, alignAnimationTime);
    var paddingValueX = $9f57700f268362ee$var$getPaddingValue(contextInstance, sizeX);
    var paddingValueY = $9f57700f268362ee$var$getPaddingValue(contextInstance, sizeY);
    var paddingX = paddingValueX * wrapperComponent.offsetWidth / 100;
    var paddingY = paddingValueY * wrapperComponent.offsetHeight / 100;
    var maxTargetX = maxPositionX + paddingX;
    var minTargetX = minPositionX - paddingX;
    var maxTargetY = maxPositionY + paddingY;
    var minTargetY = minPositionY - paddingY;
    var startState = contextInstance.transformState;
    var startTime = new Date().getTime();
    $9f57700f268362ee$var$handleSetupAnimation(contextInstance, animationType, finalAnimationTime, function(step) {
        var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
        var frameTime = new Date().getTime() - startTime;
        var animationProgress = frameTime / alignAnimationTime;
        var alignAnimation = $9f57700f268362ee$var$animations[alignmentAnimation.animationType];
        var alignStep = 1 - alignAnimation(Math.min(1, animationProgress));
        var customStep = 1 - step;
        var newPositionX = positionX + velocityX * customStep;
        var newPositionY = positionY + velocityY * customStep;
        var currentPositionX = $9f57700f268362ee$var$getVelocityPosition(newPositionX, startState.positionX, positionX, lockAxisX, limitToBounds, minPositionX, maxPositionX, minTargetX, maxTargetX, alignStep);
        var currentPositionY = $9f57700f268362ee$var$getVelocityPosition(newPositionY, startState.positionY, positionY, lockAxisY, limitToBounds, minPositionY, maxPositionY, minTargetY, maxTargetY, alignStep);
        if (positionX !== newPositionX || positionY !== newPositionY) contextInstance.setTransformState(scale, currentPositionX, currentPositionY);
    });
}
function $9f57700f268362ee$var$handlePanningStart(contextInstance, event) {
    var scale = contextInstance.transformState.scale;
    $9f57700f268362ee$var$handleCancelAnimation(contextInstance);
    $9f57700f268362ee$var$handleCalculateBounds(contextInstance, scale);
    if (window.TouchEvent !== undefined && event instanceof TouchEvent) $9f57700f268362ee$var$handleTouchPanningSetup(contextInstance, event);
    else $9f57700f268362ee$var$handlePanningSetup(contextInstance, event);
}
function $9f57700f268362ee$var$handleAlignToBounds(contextInstance) {
    var scale = contextInstance.transformState.scale;
    var _a = contextInstance.setup, minScale = _a.minScale, alignmentAnimation = _a.alignmentAnimation;
    var disabled = alignmentAnimation.disabled, sizeX = alignmentAnimation.sizeX, sizeY = alignmentAnimation.sizeY, animationTime = alignmentAnimation.animationTime, animationType = alignmentAnimation.animationType;
    var isDisabled = disabled || scale < minScale || !sizeX && !sizeY;
    if (isDisabled) return;
    var targetState = $9f57700f268362ee$var$handlePanToBounds(contextInstance);
    if (targetState) $9f57700f268362ee$var$animate(contextInstance, targetState, animationTime, animationType);
}
function $9f57700f268362ee$var$handlePanning(contextInstance, clientX, clientY) {
    var startCoords = contextInstance.startCoords, setup = contextInstance.setup;
    var _a = setup.alignmentAnimation, sizeX = _a.sizeX, sizeY = _a.sizeY;
    if (!startCoords) return;
    var _b = $9f57700f268362ee$var$getPanningClientPosition(contextInstance, clientX, clientY), x = _b.x, y = _b.y;
    var paddingValueX = $9f57700f268362ee$var$getPaddingValue(contextInstance, sizeX);
    var paddingValueY = $9f57700f268362ee$var$getPaddingValue(contextInstance, sizeY);
    $9f57700f268362ee$var$handleCalculateVelocity(contextInstance, {
        x: x,
        y: y
    });
    $9f57700f268362ee$var$handleNewPosition(contextInstance, x, y, paddingValueX, paddingValueY);
}
function $9f57700f268362ee$var$handlePanningEnd(contextInstance) {
    if (contextInstance.isPanning) {
        var velocityDisabled = contextInstance.setup.panning.velocityDisabled;
        var velocity = contextInstance.velocity, wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
        contextInstance.isPanning = false;
        contextInstance.animate = false;
        contextInstance.animation = null;
        var wrapperRect = wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.getBoundingClientRect();
        var contentRect = contentComponent === null || contentComponent === void 0 ? void 0 : contentComponent.getBoundingClientRect();
        var wrapperWidth = (wrapperRect === null || wrapperRect === void 0 ? void 0 : wrapperRect.width) || 0;
        var wrapperHeight = (wrapperRect === null || wrapperRect === void 0 ? void 0 : wrapperRect.height) || 0;
        var contentWidth = (contentRect === null || contentRect === void 0 ? void 0 : contentRect.width) || 0;
        var contentHeight = (contentRect === null || contentRect === void 0 ? void 0 : contentRect.height) || 0;
        var isZoomed = wrapperWidth < contentWidth || wrapperHeight < contentHeight;
        var shouldAnimate = !velocityDisabled && velocity && (velocity === null || velocity === void 0 ? void 0 : velocity.total) > 0.1 && isZoomed;
        if (shouldAnimate) $9f57700f268362ee$var$handleVelocityPanning(contextInstance);
        else $9f57700f268362ee$var$handleAlignToBounds(contextInstance);
    }
}
function $9f57700f268362ee$var$handleZoomToPoint(contextInstance, scale, mouseX, mouseY) {
    var _a = contextInstance.setup, minScale = _a.minScale, maxScale = _a.maxScale, limitToBounds = _a.limitToBounds;
    var newScale = $9f57700f268362ee$var$checkZoomBounds($9f57700f268362ee$var$roundNumber(scale, 2), minScale, maxScale, 0, false);
    var bounds = $9f57700f268362ee$var$handleCalculateBounds(contextInstance, newScale);
    var _b = $9f57700f268362ee$var$handleCalculateZoomPositions(contextInstance, mouseX, mouseY, newScale, bounds, limitToBounds), x = _b.x, y = _b.y;
    return {
        scale: newScale,
        positionX: x,
        positionY: y
    };
}
function $9f57700f268362ee$var$handleAlignToScaleBounds(contextInstance, mousePositionX, mousePositionY) {
    var scale = contextInstance.transformState.scale;
    var wrapperComponent = contextInstance.wrapperComponent;
    var _a = contextInstance.setup, minScale = _a.minScale, limitToBounds = _a.limitToBounds, zoomAnimation = _a.zoomAnimation;
    var disabled = zoomAnimation.disabled, animationTime = zoomAnimation.animationTime, animationType = zoomAnimation.animationType;
    var isDisabled = disabled || scale >= minScale;
    if (scale >= 1 || limitToBounds) // fire fit to bounds animation
    $9f57700f268362ee$var$handleAlignToBounds(contextInstance);
    if (isDisabled || !wrapperComponent || !contextInstance.mounted) return;
    var mouseX = mousePositionX || wrapperComponent.offsetWidth / 2;
    var mouseY = mousePositionY || wrapperComponent.offsetHeight / 2;
    var targetState = $9f57700f268362ee$var$handleZoomToPoint(contextInstance, minScale, mouseX, mouseY);
    if (targetState) $9f57700f268362ee$var$animate(contextInstance, targetState, animationTime, animationType);
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $9f57700f268362ee$var$__assign = function() {
    $9f57700f268362ee$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9f57700f268362ee$var$__assign.apply(this, arguments);
};
function $9f57700f268362ee$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $9f57700f268362ee$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
var $9f57700f268362ee$var$initialState = {
    previousScale: 1,
    scale: 1,
    positionX: 0,
    positionY: 0
};
var $9f57700f268362ee$var$initialSetup = {
    disabled: false,
    minPositionX: null,
    maxPositionX: null,
    minPositionY: null,
    maxPositionY: null,
    minScale: 1,
    maxScale: 8,
    limitToBounds: true,
    centerZoomedOut: false,
    centerOnInit: false,
    disablePadding: false,
    smooth: true,
    wheel: {
        step: 0.2,
        disabled: false,
        smoothStep: 0.001,
        wheelDisabled: false,
        touchPadDisabled: false,
        activationKeys: [],
        excluded: []
    },
    panning: {
        disabled: false,
        velocityDisabled: false,
        lockAxisX: false,
        lockAxisY: false,
        allowLeftClickPan: true,
        allowMiddleClickPan: true,
        allowRightClickPan: true,
        wheelPanning: false,
        activationKeys: [],
        excluded: []
    },
    pinch: {
        step: 5,
        disabled: false,
        excluded: []
    },
    doubleClick: {
        disabled: false,
        step: 0.7,
        mode: "zoomIn",
        animationType: "easeOut",
        animationTime: 200,
        excluded: []
    },
    zoomAnimation: {
        disabled: false,
        size: 0.4,
        animationTime: 200,
        animationType: "easeOut"
    },
    alignmentAnimation: {
        disabled: false,
        sizeX: 100,
        sizeY: 100,
        animationTime: 200,
        velocityAlignmentTime: 400,
        animationType: "easeOut"
    },
    velocityAnimation: {
        disabled: false,
        sensitivity: 1,
        animationTime: 400,
        animationType: "easeOut",
        equalToMove: true
    }
};
var $9f57700f268362ee$var$baseClasses = {
    wrapperClass: "react-transform-wrapper",
    contentClass: "react-transform-component"
};
var $9f57700f268362ee$var$createState = function(props) {
    var _a, _b, _c, _d;
    return {
        previousScale: (_a = props.initialScale) !== null && _a !== void 0 ? _a : $9f57700f268362ee$var$initialState.scale,
        scale: (_b = props.initialScale) !== null && _b !== void 0 ? _b : $9f57700f268362ee$var$initialState.scale,
        positionX: (_c = props.initialPositionX) !== null && _c !== void 0 ? _c : $9f57700f268362ee$var$initialState.positionX,
        positionY: (_d = props.initialPositionY) !== null && _d !== void 0 ? _d : $9f57700f268362ee$var$initialState.positionY
    };
};
var $9f57700f268362ee$var$createSetup = function(props) {
    var newSetup = $9f57700f268362ee$var$__assign({}, $9f57700f268362ee$var$initialSetup);
    Object.keys(props).forEach(function(key) {
        var validValue = typeof props[key] !== "undefined";
        var validParameter = typeof $9f57700f268362ee$var$initialSetup[key] !== "undefined";
        if (validParameter && validValue) {
            var dataType = Object.prototype.toString.call($9f57700f268362ee$var$initialSetup[key]);
            var isObject = dataType === "[object Object]";
            var isArray = dataType === "[object Array]";
            if (isObject) newSetup[key] = $9f57700f268362ee$var$__assign($9f57700f268362ee$var$__assign({}, $9f57700f268362ee$var$initialSetup[key]), props[key]);
            else if (isArray) newSetup[key] = $9f57700f268362ee$var$__spreadArray($9f57700f268362ee$var$__spreadArray([], $9f57700f268362ee$var$initialSetup[key], true), props[key], true);
            else newSetup[key] = props[key];
        }
    });
    return newSetup;
};
var $9f57700f268362ee$var$handleCalculateButtonZoom = function(contextInstance, delta, step) {
    var scale = contextInstance.transformState.scale;
    var wrapperComponent = contextInstance.wrapperComponent, setup = contextInstance.setup;
    var maxScale = setup.maxScale, minScale = setup.minScale, zoomAnimation = setup.zoomAnimation, smooth = setup.smooth;
    var size = zoomAnimation.size;
    if (!wrapperComponent) throw new Error("Wrapper is not mounted");
    var targetScale = smooth ? scale * Math.exp(delta * step) : scale + delta * step;
    var newScale = $9f57700f268362ee$var$checkZoomBounds($9f57700f268362ee$var$roundNumber(targetScale, 3), minScale, maxScale, size, false);
    return newScale;
};
function $9f57700f268362ee$var$handleZoomToViewCenter(contextInstance, delta, step, animationTime, animationType) {
    var wrapperComponent = contextInstance.wrapperComponent;
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    if (!wrapperComponent) return console.error("No WrapperComponent found");
    var wrapperWidth = wrapperComponent.offsetWidth;
    var wrapperHeight = wrapperComponent.offsetHeight;
    var mouseX = (wrapperWidth / 2 - positionX) / scale;
    var mouseY = (wrapperHeight / 2 - positionY) / scale;
    var newScale = $9f57700f268362ee$var$handleCalculateButtonZoom(contextInstance, delta, step);
    var targetState = $9f57700f268362ee$var$handleZoomToPoint(contextInstance, newScale, mouseX, mouseY);
    if (!targetState) return console.error("Error during zoom event. New transformation state was not calculated.");
    $9f57700f268362ee$var$animate(contextInstance, targetState, animationTime, animationType);
}
function $9f57700f268362ee$var$resetTransformations(contextInstance, animationTime, animationType, onResetTransformation) {
    var setup = contextInstance.setup, wrapperComponent = contextInstance.wrapperComponent;
    var limitToBounds = setup.limitToBounds;
    var initialTransformation = $9f57700f268362ee$var$createState(contextInstance.props);
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    if (!wrapperComponent) return;
    var newBounds = $9f57700f268362ee$var$calculateBounds(contextInstance, initialTransformation.scale);
    var boundedPositions = $9f57700f268362ee$var$getMouseBoundedPosition(initialTransformation.positionX, initialTransformation.positionY, newBounds, limitToBounds, 0, 0, wrapperComponent);
    var newState = {
        scale: initialTransformation.scale,
        positionX: boundedPositions.x,
        positionY: boundedPositions.y
    };
    if (scale === initialTransformation.scale && positionX === initialTransformation.positionX && positionY === initialTransformation.positionY) return;
    onResetTransformation === null || onResetTransformation === void 0 || onResetTransformation();
    $9f57700f268362ee$var$animate(contextInstance, newState, animationTime, animationType);
}
function $9f57700f268362ee$var$getOffset(element, wrapper, content, state) {
    var offset = element.getBoundingClientRect();
    var wrapperOffset = wrapper.getBoundingClientRect();
    var contentOffset = content.getBoundingClientRect();
    var xOff = wrapperOffset.x * state.scale;
    var yOff = wrapperOffset.y * state.scale;
    return {
        x: (offset.x - contentOffset.x + xOff) / state.scale,
        y: (offset.y - contentOffset.y + yOff) / state.scale
    };
}
function $9f57700f268362ee$var$calculateZoomToNode(contextInstance, node, customZoom) {
    var wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent, transformState = contextInstance.transformState;
    var _a = contextInstance.setup, limitToBounds = _a.limitToBounds, minScale = _a.minScale, maxScale = _a.maxScale;
    if (!wrapperComponent || !contentComponent) return transformState;
    var wrapperRect = wrapperComponent.getBoundingClientRect();
    var nodeRect = node.getBoundingClientRect();
    var nodeOffset = $9f57700f268362ee$var$getOffset(node, wrapperComponent, contentComponent, transformState);
    var nodeLeft = nodeOffset.x;
    var nodeTop = nodeOffset.y;
    var nodeWidth = nodeRect.width / transformState.scale;
    var nodeHeight = nodeRect.height / transformState.scale;
    var scaleX = wrapperComponent.offsetWidth / nodeWidth;
    var scaleY = wrapperComponent.offsetHeight / nodeHeight;
    var newScale = $9f57700f268362ee$var$checkZoomBounds(customZoom || Math.min(scaleX, scaleY), minScale, maxScale, 0, false);
    var offsetX = (wrapperRect.width - nodeWidth * newScale) / 2;
    var offsetY = (wrapperRect.height - nodeHeight * newScale) / 2;
    var newPositionX = (wrapperRect.left - nodeLeft) * newScale + offsetX;
    var newPositionY = (wrapperRect.top - nodeTop) * newScale + offsetY;
    var bounds = $9f57700f268362ee$var$calculateBounds(contextInstance, newScale);
    var _b = $9f57700f268362ee$var$getMouseBoundedPosition(newPositionX, newPositionY, bounds, limitToBounds, 0, 0, wrapperComponent), x = _b.x, y = _b.y;
    return {
        positionX: x,
        positionY: y,
        scale: newScale
    };
}
var $9f57700f268362ee$var$zoomIn = function(contextInstance) {
    return function(step, animationTime, animationType) {
        if (step === void 0) step = 0.5;
        if (animationTime === void 0) animationTime = 300;
        if (animationType === void 0) animationType = "easeOut";
        $9f57700f268362ee$var$handleZoomToViewCenter(contextInstance, 1, step, animationTime, animationType);
    };
};
var $9f57700f268362ee$var$zoomOut = function(contextInstance) {
    return function(step, animationTime, animationType) {
        if (step === void 0) step = 0.5;
        if (animationTime === void 0) animationTime = 300;
        if (animationType === void 0) animationType = "easeOut";
        $9f57700f268362ee$var$handleZoomToViewCenter(contextInstance, -1, step, animationTime, animationType);
    };
};
var $9f57700f268362ee$var$setTransform = function(contextInstance) {
    return function(newPositionX, newPositionY, newScale, animationTime, animationType) {
        if (animationTime === void 0) animationTime = 300;
        if (animationType === void 0) animationType = "easeOut";
        var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY, scale = _a.scale;
        var wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
        var disabled = contextInstance.setup.disabled;
        if (disabled || !wrapperComponent || !contentComponent) return;
        var targetState = {
            positionX: Number.isNaN(newPositionX) ? positionX : newPositionX,
            positionY: Number.isNaN(newPositionY) ? positionY : newPositionY,
            scale: Number.isNaN(newScale) ? scale : newScale
        };
        $9f57700f268362ee$var$animate(contextInstance, targetState, animationTime, animationType);
    };
};
var $9f57700f268362ee$var$resetTransform = function(contextInstance) {
    return function(animationTime, animationType) {
        if (animationTime === void 0) animationTime = 200;
        if (animationType === void 0) animationType = "easeOut";
        $9f57700f268362ee$var$resetTransformations(contextInstance, animationTime, animationType);
    };
};
var $9f57700f268362ee$var$centerView = function(contextInstance) {
    return function(scale, animationTime, animationType) {
        if (animationTime === void 0) animationTime = 200;
        if (animationType === void 0) animationType = "easeOut";
        var transformState = contextInstance.transformState, wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
        if (wrapperComponent && contentComponent) {
            var targetState = $9f57700f268362ee$export$a51b33620579dad4(scale || transformState.scale, wrapperComponent, contentComponent);
            $9f57700f268362ee$var$animate(contextInstance, targetState, animationTime, animationType);
        }
    };
};
var $9f57700f268362ee$var$zoomToElement = function(contextInstance) {
    return function(node, scale, animationTime, animationType) {
        if (animationTime === void 0) animationTime = 600;
        if (animationType === void 0) animationType = "easeOut";
        $9f57700f268362ee$var$handleCancelAnimation(contextInstance);
        var wrapperComponent = contextInstance.wrapperComponent;
        var target = typeof node === "string" ? document.getElementById(node) : node;
        if (wrapperComponent && target && wrapperComponent.contains(target)) {
            var targetState = $9f57700f268362ee$var$calculateZoomToNode(contextInstance, target, scale);
            $9f57700f268362ee$var$animate(contextInstance, targetState, animationTime, animationType);
        }
    };
};
var $9f57700f268362ee$var$getControls = function(contextInstance) {
    return {
        instance: contextInstance,
        zoomIn: $9f57700f268362ee$var$zoomIn(contextInstance),
        zoomOut: $9f57700f268362ee$var$zoomOut(contextInstance),
        setTransform: $9f57700f268362ee$var$setTransform(contextInstance),
        resetTransform: $9f57700f268362ee$var$resetTransform(contextInstance),
        centerView: $9f57700f268362ee$var$centerView(contextInstance),
        zoomToElement: $9f57700f268362ee$var$zoomToElement(contextInstance)
    };
};
var $9f57700f268362ee$var$getState = function(contextInstance) {
    return {
        instance: contextInstance,
        state: contextInstance.transformState
    };
};
var $9f57700f268362ee$var$getContext = function(contextInstance) {
    var ref = {};
    Object.assign(ref, $9f57700f268362ee$var$getState(contextInstance));
    Object.assign(ref, $9f57700f268362ee$var$getControls(contextInstance));
    return ref;
};
// We want to make event listeners non-passive, and to do so have to check
// that browsers support EventListenerOptions in the first place.
// https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
var $9f57700f268362ee$var$passiveSupported = false;
function $9f57700f268362ee$var$makePassiveEventOption() {
    try {
        var options = {
            get passive () {
                // This function will be called when the browser
                //   attempts to access the passive property.
                $9f57700f268362ee$var$passiveSupported = true;
                return false;
            }
        };
        return options;
    } catch (err) {
        $9f57700f268362ee$var$passiveSupported = false;
        return $9f57700f268362ee$var$passiveSupported;
    }
}
var $9f57700f268362ee$var$matchPrefix = ".".concat($9f57700f268362ee$var$baseClasses.wrapperClass);
var $9f57700f268362ee$var$isExcludedNode = function(node, excluded) {
    return excluded.some(function(exclude) {
        return node.matches("".concat($9f57700f268362ee$var$matchPrefix, " ").concat(exclude, ", ").concat($9f57700f268362ee$var$matchPrefix, " .").concat(exclude, ", ").concat($9f57700f268362ee$var$matchPrefix, " ").concat(exclude, " *, ").concat($9f57700f268362ee$var$matchPrefix, " .").concat(exclude, " *"));
    });
};
var $9f57700f268362ee$var$cancelTimeout = function(timeout) {
    if (timeout) clearTimeout(timeout);
};
var $9f57700f268362ee$export$c15ec262effbd456 = function(x, y, scale) {
    // Standard translate prevents blurry svg on the safari
    return "translate(".concat(x, "px, ").concat(y, "px) scale(").concat(scale, ")");
};
var $9f57700f268362ee$export$3b94f66093db6f05 = function(x, y, scale) {
    // The shorthand for matrix does not work for Safari hence the need to explicitly use matrix3d
    // Refer to https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/matrix
    var a = scale;
    var b = 0;
    var c = 0;
    var d = scale;
    var tx = x;
    var ty = y;
    return "matrix3d(".concat(a, ", ").concat(b, ", 0, 0, ").concat(c, ", ").concat(d, ", 0, 0, 0, 0, 1, 0, ").concat(tx, ", ").concat(ty, ", 0, 1)");
};
var $9f57700f268362ee$export$a51b33620579dad4 = function(scale, wrapperComponent, contentComponent) {
    var contentWidth = contentComponent.offsetWidth * scale;
    var contentHeight = contentComponent.offsetHeight * scale;
    var centerPositionX = (wrapperComponent.offsetWidth - contentWidth) / 2;
    var centerPositionY = (wrapperComponent.offsetHeight - contentHeight) / 2;
    return {
        scale: scale,
        positionX: centerPositionX,
        positionY: centerPositionY
    };
};
function $9f57700f268362ee$var$mergeRefs(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
var $9f57700f268362ee$var$isWheelAllowed = function(contextInstance, event) {
    var _a = contextInstance.setup.wheel, disabled = _a.disabled, wheelDisabled = _a.wheelDisabled, touchPadDisabled = _a.touchPadDisabled, excluded = _a.excluded;
    var isInitialized = contextInstance.isInitialized, isPanning = contextInstance.isPanning;
    var target = event.target;
    var isAllowed = isInitialized && !isPanning && !disabled && target;
    if (!isAllowed) return false;
    // Event ctrlKey detects if touchpad action is executing wheel or pinch gesture
    if (wheelDisabled && !event.ctrlKey) return false;
    if (touchPadDisabled && event.ctrlKey) return false;
    var isExcluded = $9f57700f268362ee$var$isExcludedNode(target, excluded);
    if (isExcluded) return false;
    return true;
};
var $9f57700f268362ee$var$getDeltaY = function(event) {
    if (event) return event.deltaY < 0 ? 1 : -1;
    return 0;
};
function $9f57700f268362ee$var$getDelta(event, customDelta) {
    var deltaY = $9f57700f268362ee$var$getDeltaY(event);
    var delta = $9f57700f268362ee$var$checkIsNumber(customDelta, deltaY);
    return delta;
}
function $9f57700f268362ee$var$getMousePosition(event, contentComponent, scale) {
    var contentRect = contentComponent.getBoundingClientRect();
    var mouseX = 0;
    var mouseY = 0;
    if ("clientX" in event) {
        // mouse position x, y over wrapper component
        mouseX = (event.clientX - contentRect.left) / scale;
        mouseY = (event.clientY - contentRect.top) / scale;
    } else {
        var touch = event.touches[0];
        mouseX = (touch.clientX - contentRect.left) / scale;
        mouseY = (touch.clientY - contentRect.top) / scale;
    }
    if (Number.isNaN(mouseX) || Number.isNaN(mouseY)) console.error("No mouse or touch offset found");
    return {
        x: mouseX,
        y: mouseY
    };
}
var $9f57700f268362ee$var$handleCalculateWheelZoom = function(contextInstance, delta, step, disable, getTarget) {
    var scale = contextInstance.transformState.scale;
    var wrapperComponent = contextInstance.wrapperComponent, setup = contextInstance.setup;
    var maxScale = setup.maxScale, minScale = setup.minScale, zoomAnimation = setup.zoomAnimation, disablePadding = setup.disablePadding;
    var size = zoomAnimation.size, disabled = zoomAnimation.disabled;
    if (!wrapperComponent) throw new Error("Wrapper is not mounted");
    var targetScale = scale + delta * step;
    if (getTarget) return targetScale;
    var paddingEnabled = disable ? false : !disabled;
    var newScale = $9f57700f268362ee$var$checkZoomBounds($9f57700f268362ee$var$roundNumber(targetScale, 3), minScale, maxScale, size, paddingEnabled && !disablePadding);
    return newScale;
};
var $9f57700f268362ee$var$handleWheelZoomStop = function(contextInstance, event) {
    var previousWheelEvent = contextInstance.previousWheelEvent;
    var scale = contextInstance.transformState.scale;
    var _a = contextInstance.setup, maxScale = _a.maxScale, minScale = _a.minScale;
    if (!previousWheelEvent) return false;
    if (scale < maxScale || scale > minScale) return true;
    if (Math.sign(previousWheelEvent.deltaY) !== Math.sign(event.deltaY)) return true;
    if (previousWheelEvent.deltaY > 0 && previousWheelEvent.deltaY < event.deltaY) return true;
    if (previousWheelEvent.deltaY < 0 && previousWheelEvent.deltaY > event.deltaY) return true;
    if (Math.sign(previousWheelEvent.deltaY) !== Math.sign(event.deltaY)) return true;
    return false;
};
var $9f57700f268362ee$var$isPinchStartAllowed = function(contextInstance, event) {
    var _a = contextInstance.setup.pinch, disabled = _a.disabled, excluded = _a.excluded;
    var isInitialized = contextInstance.isInitialized;
    var target = event.target;
    var isAllowed = isInitialized && !disabled && target;
    if (!isAllowed) return false;
    var isExcluded = $9f57700f268362ee$var$isExcludedNode(target, excluded);
    if (isExcluded) return false;
    return true;
};
var $9f57700f268362ee$var$isPinchAllowed = function(contextInstance) {
    var disabled = contextInstance.setup.pinch.disabled;
    var isInitialized = contextInstance.isInitialized, pinchStartDistance = contextInstance.pinchStartDistance;
    var isAllowed = isInitialized && !disabled && pinchStartDistance;
    if (!isAllowed) return false;
    return true;
};
var $9f57700f268362ee$var$calculateTouchMidPoint = function(event, scale, contentComponent) {
    var contentRect = contentComponent.getBoundingClientRect();
    var touches = event.touches;
    var firstPointX = $9f57700f268362ee$var$roundNumber(touches[0].clientX - contentRect.left, 5);
    var firstPointY = $9f57700f268362ee$var$roundNumber(touches[0].clientY - contentRect.top, 5);
    var secondPointX = $9f57700f268362ee$var$roundNumber(touches[1].clientX - contentRect.left, 5);
    var secondPointY = $9f57700f268362ee$var$roundNumber(touches[1].clientY - contentRect.top, 5);
    return {
        x: (firstPointX + secondPointX) / 2 / scale,
        y: (firstPointY + secondPointY) / 2 / scale
    };
};
var $9f57700f268362ee$var$getTouchDistance = function(event) {
    return Math.sqrt(Math.pow(event.touches[0].pageX - event.touches[1].pageX, 2) + Math.pow(event.touches[0].pageY - event.touches[1].pageY, 2));
};
var $9f57700f268362ee$var$calculatePinchZoom = function(contextInstance, currentDistance) {
    var pinchStartScale = contextInstance.pinchStartScale, pinchStartDistance = contextInstance.pinchStartDistance, setup = contextInstance.setup;
    var maxScale = setup.maxScale, minScale = setup.minScale, zoomAnimation = setup.zoomAnimation, disablePadding = setup.disablePadding;
    var size = zoomAnimation.size, disabled = zoomAnimation.disabled;
    if (!pinchStartScale || pinchStartDistance === null || !currentDistance) throw new Error("Pinch touches distance was not provided");
    if (currentDistance < 0) return contextInstance.transformState.scale;
    var touchProportion = currentDistance / pinchStartDistance;
    var scaleDifference = touchProportion * pinchStartScale;
    return $9f57700f268362ee$var$checkZoomBounds($9f57700f268362ee$var$roundNumber(scaleDifference, 2), minScale, maxScale, size, !disabled && !disablePadding);
};
var $9f57700f268362ee$var$wheelStopEventTime = 160;
var $9f57700f268362ee$var$wheelAnimationTime = 100;
var $9f57700f268362ee$var$handleWheelStart = function(contextInstance, event) {
    var _a = contextInstance.props, onWheelStart = _a.onWheelStart, onZoomStart = _a.onZoomStart;
    if (!contextInstance.wheelStopEventTimer) {
        $9f57700f268362ee$var$handleCancelAnimation(contextInstance);
        $9f57700f268362ee$var$handleCallback($9f57700f268362ee$var$getContext(contextInstance), event, onWheelStart);
        $9f57700f268362ee$var$handleCallback($9f57700f268362ee$var$getContext(contextInstance), event, onZoomStart);
    }
};
var $9f57700f268362ee$var$handleWheelZoom = function(contextInstance, event) {
    var _a = contextInstance.props, onWheel = _a.onWheel, onZoom = _a.onZoom;
    var contentComponent = contextInstance.contentComponent, setup = contextInstance.setup, transformState = contextInstance.transformState;
    var scale = transformState.scale;
    var limitToBounds = setup.limitToBounds, centerZoomedOut = setup.centerZoomedOut, zoomAnimation = setup.zoomAnimation, wheel = setup.wheel, disablePadding = setup.disablePadding, smooth = setup.smooth;
    var size = zoomAnimation.size, disabled = zoomAnimation.disabled;
    var step = wheel.step, smoothStep = wheel.smoothStep;
    if (!contentComponent) throw new Error("Component not mounted");
    event.preventDefault();
    event.stopPropagation();
    var delta = $9f57700f268362ee$var$getDelta(event, null);
    var zoomStep = smooth ? smoothStep * Math.abs(event.deltaY) : step;
    var newScale = $9f57700f268362ee$var$handleCalculateWheelZoom(contextInstance, delta, zoomStep, !event.ctrlKey);
    // if scale not change
    if (scale === newScale) return;
    var bounds = $9f57700f268362ee$var$handleCalculateBounds(contextInstance, newScale);
    var mousePosition = $9f57700f268362ee$var$getMousePosition(event, contentComponent, scale);
    var isPaddingDisabled = disabled || size === 0 || centerZoomedOut || disablePadding;
    var isLimitedToBounds = limitToBounds && isPaddingDisabled;
    var _b = $9f57700f268362ee$var$handleCalculateZoomPositions(contextInstance, mousePosition.x, mousePosition.y, newScale, bounds, isLimitedToBounds), x = _b.x, y = _b.y;
    contextInstance.previousWheelEvent = event;
    contextInstance.setTransformState(newScale, x, y);
    $9f57700f268362ee$var$handleCallback($9f57700f268362ee$var$getContext(contextInstance), event, onWheel);
    $9f57700f268362ee$var$handleCallback($9f57700f268362ee$var$getContext(contextInstance), event, onZoom);
};
var $9f57700f268362ee$var$handleWheelStop = function(contextInstance, event) {
    var _a = contextInstance.props, onWheelStop = _a.onWheelStop, onZoomStop = _a.onZoomStop;
    // fire animation
    $9f57700f268362ee$var$cancelTimeout(contextInstance.wheelAnimationTimer);
    contextInstance.wheelAnimationTimer = setTimeout(function() {
        if (!contextInstance.mounted) return;
        $9f57700f268362ee$var$handleAlignToScaleBounds(contextInstance, event.x, event.y);
        contextInstance.wheelAnimationTimer = null;
    }, $9f57700f268362ee$var$wheelAnimationTime);
    // Wheel stop event
    var hasStoppedZooming = $9f57700f268362ee$var$handleWheelZoomStop(contextInstance, event);
    if (hasStoppedZooming) {
        $9f57700f268362ee$var$cancelTimeout(contextInstance.wheelStopEventTimer);
        contextInstance.wheelStopEventTimer = setTimeout(function() {
            if (!contextInstance.mounted) return;
            contextInstance.wheelStopEventTimer = null;
            $9f57700f268362ee$var$handleCallback($9f57700f268362ee$var$getContext(contextInstance), event, onWheelStop);
            $9f57700f268362ee$var$handleCallback($9f57700f268362ee$var$getContext(contextInstance), event, onZoomStop);
        }, $9f57700f268362ee$var$wheelStopEventTime);
    }
};
var $9f57700f268362ee$var$getTouchCenter = function(event) {
    var totalX = 0;
    var totalY = 0;
    // Sum up the positions of all touches
    for(var i = 0; i < 2; i += 1){
        totalX += event.touches[i].clientX;
        totalY += event.touches[i].clientY;
    }
    // Calculate the average position
    var x = totalX / 2;
    var y = totalY / 2;
    return {
        x: x,
        y: y
    };
};
var $9f57700f268362ee$var$handlePinchStart = function(contextInstance, event) {
    var distance = $9f57700f268362ee$var$getTouchDistance(event);
    contextInstance.pinchStartDistance = distance;
    contextInstance.lastDistance = distance;
    contextInstance.pinchStartScale = contextInstance.transformState.scale;
    contextInstance.isPanning = false;
    var center = $9f57700f268362ee$var$getTouchCenter(event);
    contextInstance.pinchLastCenterX = center.x;
    contextInstance.pinchLastCenterY = center.y;
    $9f57700f268362ee$var$handleCancelAnimation(contextInstance);
};
var $9f57700f268362ee$var$handlePinchZoom = function(contextInstance, event) {
    var contentComponent = contextInstance.contentComponent, pinchStartDistance = contextInstance.pinchStartDistance, wrapperComponent = contextInstance.wrapperComponent;
    var scale = contextInstance.transformState.scale;
    var _a = contextInstance.setup, limitToBounds = _a.limitToBounds, centerZoomedOut = _a.centerZoomedOut, zoomAnimation = _a.zoomAnimation, alignmentAnimation = _a.alignmentAnimation;
    var disabled = zoomAnimation.disabled, size = zoomAnimation.size;
    // if one finger starts from outside of wrapper
    if (pinchStartDistance === null || !contentComponent) return;
    var midPoint = $9f57700f268362ee$var$calculateTouchMidPoint(event, scale, contentComponent);
    // if touches goes off of the wrapper element
    if (!Number.isFinite(midPoint.x) || !Number.isFinite(midPoint.y)) return;
    var currentDistance = $9f57700f268362ee$var$getTouchDistance(event);
    var newScale = $9f57700f268362ee$var$calculatePinchZoom(contextInstance, currentDistance);
    var center = $9f57700f268362ee$var$getTouchCenter(event);
    // pan should be scale invariant.
    var panX = center.x - (contextInstance.pinchLastCenterX || 0);
    var panY = center.y - (contextInstance.pinchLastCenterY || 0);
    if (newScale === scale && panX === 0 && panY === 0) return;
    contextInstance.pinchLastCenterX = center.x;
    contextInstance.pinchLastCenterY = center.y;
    var bounds = $9f57700f268362ee$var$handleCalculateBounds(contextInstance, newScale);
    var isPaddingDisabled = disabled || size === 0 || centerZoomedOut;
    var isLimitedToBounds = limitToBounds && isPaddingDisabled;
    var _b = $9f57700f268362ee$var$handleCalculateZoomPositions(contextInstance, midPoint.x, midPoint.y, newScale, bounds, isLimitedToBounds), x = _b.x, y = _b.y;
    contextInstance.pinchMidpoint = midPoint;
    contextInstance.lastDistance = currentDistance;
    var sizeX = alignmentAnimation.sizeX, sizeY = alignmentAnimation.sizeY;
    var paddingValueX = $9f57700f268362ee$var$getPaddingValue(contextInstance, sizeX);
    var paddingValueY = $9f57700f268362ee$var$getPaddingValue(contextInstance, sizeY);
    var newPositionX = x + panX;
    var newPositionY = y + panY;
    var _c = $9f57700f268362ee$var$getMouseBoundedPosition(newPositionX, newPositionY, bounds, limitToBounds, paddingValueX, paddingValueY, wrapperComponent), finalX = _c.x, finalY = _c.y;
    contextInstance.setTransformState(newScale, finalX, finalY);
};
var $9f57700f268362ee$var$handlePinchStop = function(contextInstance) {
    var pinchMidpoint = contextInstance.pinchMidpoint;
    contextInstance.velocity = null;
    contextInstance.lastDistance = null;
    contextInstance.pinchMidpoint = null;
    contextInstance.pinchStartScale = null;
    contextInstance.pinchStartDistance = null;
    $9f57700f268362ee$var$handleAlignToScaleBounds(contextInstance, pinchMidpoint === null || pinchMidpoint === void 0 ? void 0 : pinchMidpoint.x, pinchMidpoint === null || pinchMidpoint === void 0 ? void 0 : pinchMidpoint.y);
};
var $9f57700f268362ee$var$handleDoubleClickStop = function(contextInstance, event) {
    var onZoomStop = contextInstance.props.onZoomStop;
    var animationTime = contextInstance.setup.doubleClick.animationTime;
    $9f57700f268362ee$var$cancelTimeout(contextInstance.doubleClickStopEventTimer);
    contextInstance.doubleClickStopEventTimer = setTimeout(function() {
        contextInstance.doubleClickStopEventTimer = null;
        $9f57700f268362ee$var$handleCallback($9f57700f268362ee$var$getContext(contextInstance), event, onZoomStop);
    }, animationTime);
};
var $9f57700f268362ee$var$handleDoubleClickResetMode = function(contextInstance, event) {
    var _a = contextInstance.props, onZoomStart = _a.onZoomStart, onZoom = _a.onZoom;
    var _b = contextInstance.setup.doubleClick, animationTime = _b.animationTime, animationType = _b.animationType;
    $9f57700f268362ee$var$handleCallback($9f57700f268362ee$var$getContext(contextInstance), event, onZoomStart);
    $9f57700f268362ee$var$resetTransformations(contextInstance, animationTime, animationType, function() {
        return $9f57700f268362ee$var$handleCallback($9f57700f268362ee$var$getContext(contextInstance), event, onZoom);
    });
    $9f57700f268362ee$var$handleDoubleClickStop(contextInstance, event);
};
function $9f57700f268362ee$var$getDoubleClickScale(mode, scale) {
    if (mode === "toggle") return scale === 1 ? 1 : -1;
    return mode === "zoomOut" ? -1 : 1;
}
function $9f57700f268362ee$var$handleDoubleClick(contextInstance, event) {
    var setup = contextInstance.setup, doubleClickStopEventTimer = contextInstance.doubleClickStopEventTimer, transformState = contextInstance.transformState, contentComponent = contextInstance.contentComponent;
    var scale = transformState.scale;
    var _a = contextInstance.props, onZoomStart = _a.onZoomStart, onZoom = _a.onZoom;
    var _b = setup.doubleClick, disabled = _b.disabled, mode = _b.mode, step = _b.step, animationTime = _b.animationTime, animationType = _b.animationType;
    if (disabled) return;
    if (doubleClickStopEventTimer) return;
    if (mode === "reset") return $9f57700f268362ee$var$handleDoubleClickResetMode(contextInstance, event);
    if (!contentComponent) return console.error("No ContentComponent found");
    var delta = $9f57700f268362ee$var$getDoubleClickScale(mode, contextInstance.transformState.scale);
    var newScale = $9f57700f268362ee$var$handleCalculateButtonZoom(contextInstance, delta, step);
    // stop execution when scale didn't change
    if (scale === newScale) return;
    $9f57700f268362ee$var$handleCallback($9f57700f268362ee$var$getContext(contextInstance), event, onZoomStart);
    var mousePosition = $9f57700f268362ee$var$getMousePosition(event, contentComponent, scale);
    var targetState = $9f57700f268362ee$var$handleZoomToPoint(contextInstance, newScale, mousePosition.x, mousePosition.y);
    if (!targetState) return console.error("Error during zoom event. New transformation state was not calculated.");
    $9f57700f268362ee$var$handleCallback($9f57700f268362ee$var$getContext(contextInstance), event, onZoom);
    $9f57700f268362ee$var$animate(contextInstance, targetState, animationTime, animationType);
    $9f57700f268362ee$var$handleDoubleClickStop(contextInstance, event);
}
var $9f57700f268362ee$var$isDoubleClickAllowed = function(contextInstance, event) {
    var isInitialized = contextInstance.isInitialized, setup = contextInstance.setup, wrapperComponent = contextInstance.wrapperComponent;
    var _a = setup.doubleClick, disabled = _a.disabled, excluded = _a.excluded;
    var target = event.target;
    var isWrapperChild = wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.contains(target);
    var isAllowed = isInitialized && target && isWrapperChild && !disabled;
    if (!isAllowed) return false;
    var isExcluded = $9f57700f268362ee$var$isExcludedNode(target, excluded);
    if (isExcluded) return false;
    return true;
};
var $9f57700f268362ee$var$ZoomPanPinch = /** @class */ function() {
    function ZoomPanPinch(props) {
        var _this = this;
        this.mounted = true;
        this.pinchLastCenterX = null;
        this.pinchLastCenterY = null;
        this.onChangeCallbacks = new Set();
        this.onInitCallbacks = new Set();
        // Components
        this.wrapperComponent = null;
        this.contentComponent = null;
        // Initialization
        this.isInitialized = false;
        this.bounds = null;
        // wheel helpers
        this.previousWheelEvent = null;
        this.wheelStopEventTimer = null;
        this.wheelAnimationTimer = null;
        // panning helpers
        this.isPanning = false;
        this.isWheelPanning = false;
        this.startCoords = null;
        this.lastTouch = null;
        // pinch helpers
        this.distance = null;
        this.lastDistance = null;
        this.pinchStartDistance = null;
        this.pinchStartScale = null;
        this.pinchMidpoint = null;
        // double click helpers
        this.doubleClickStopEventTimer = null;
        // velocity helpers
        this.velocity = null;
        this.velocityTime = null;
        this.lastMousePosition = null;
        // animations helpers
        this.animate = false;
        this.animation = null;
        this.maxBounds = null;
        // key press
        this.pressedKeys = {};
        this.mount = function() {
            _this.initializeWindowEvents();
        };
        this.unmount = function() {
            _this.cleanupWindowEvents();
        };
        this.update = function(newProps) {
            _this.props = newProps;
            $9f57700f268362ee$var$handleCalculateBounds(_this, _this.transformState.scale);
            _this.setup = $9f57700f268362ee$var$createSetup(newProps);
        };
        this.initializeWindowEvents = function() {
            var _a, _b;
            var passive = $9f57700f268362ee$var$makePassiveEventOption();
            var currentDocument = (_a = _this.wrapperComponent) === null || _a === void 0 ? void 0 : _a.ownerDocument;
            var currentWindow = currentDocument === null || currentDocument === void 0 ? void 0 : currentDocument.defaultView;
            (_b = _this.wrapperComponent) === null || _b === void 0 || _b.addEventListener("wheel", _this.onWheelPanning, passive);
            // Panning on window to allow panning when mouse is out of component wrapper
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("mousedown", _this.onPanningStart, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("mousemove", _this.onPanning, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("mouseup", _this.onPanningStop, passive);
            currentDocument === null || currentDocument === void 0 || currentDocument.addEventListener("mouseleave", _this.clearPanning, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("keyup", _this.setKeyUnPressed, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("keydown", _this.setKeyPressed, passive);
        };
        this.cleanupWindowEvents = function() {
            var _a, _b;
            var passive = $9f57700f268362ee$var$makePassiveEventOption();
            var currentDocument = (_a = _this.wrapperComponent) === null || _a === void 0 ? void 0 : _a.ownerDocument;
            var currentWindow = currentDocument === null || currentDocument === void 0 ? void 0 : currentDocument.defaultView;
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("mousedown", _this.onPanningStart, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("mousemove", _this.onPanning, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("mouseup", _this.onPanningStop, passive);
            currentDocument === null || currentDocument === void 0 || currentDocument.removeEventListener("mouseleave", _this.clearPanning, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("keyup", _this.setKeyUnPressed, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("keydown", _this.setKeyPressed, passive);
            document.removeEventListener("mouseleave", _this.clearPanning, passive);
            $9f57700f268362ee$var$handleCancelAnimation(_this);
            (_b = _this.observer) === null || _b === void 0 || _b.disconnect();
        };
        this.handleInitializeWrapperEvents = function(wrapper) {
            // Zooming events on wrapper
            var passive = $9f57700f268362ee$var$makePassiveEventOption();
            wrapper.addEventListener("wheel", _this.onWheelZoom, passive);
            wrapper.addEventListener("dblclick", _this.onDoubleClick, passive);
            wrapper.addEventListener("touchstart", _this.onTouchPanningStart, passive);
            wrapper.addEventListener("touchmove", _this.onTouchPanning, passive);
            wrapper.addEventListener("touchend", _this.onTouchPanningStop, passive);
        };
        this.handleInitialize = function(contentComponent) {
            var centerOnInit = _this.setup.centerOnInit;
            _this.applyTransformation();
            _this.onInitCallbacks.forEach(function(callback) {
                return callback($9f57700f268362ee$var$getContext(_this));
            });
            if (centerOnInit) {
                _this.setCenter();
                _this.observer = new ResizeObserver(function() {
                    var _a;
                    var currentWidth = contentComponent.offsetWidth;
                    var currentHeight = contentComponent.offsetHeight;
                    if (currentWidth > 0 || currentHeight > 0) {
                        _this.onInitCallbacks.forEach(function(callback) {
                            return callback($9f57700f268362ee$var$getContext(_this));
                        });
                        _this.setCenter();
                        (_a = _this.observer) === null || _a === void 0 || _a.disconnect();
                    }
                });
                // if nothing about the contentComponent has changed after 5 seconds, disconnect the observer
                setTimeout(function() {
                    var _a;
                    (_a = _this.observer) === null || _a === void 0 || _a.disconnect();
                }, 5000);
                // Start observing the target node for configured mutations
                _this.observer.observe(contentComponent);
            }
        };
        /// ///////
        // Zoom
        /// ///////
        this.onWheelZoom = function(event) {
            var disabled = _this.setup.disabled;
            if (disabled) return;
            var isAllowed = $9f57700f268362ee$var$isWheelAllowed(_this, event);
            if (!isAllowed) return;
            var keysPressed = _this.isPressingKeys(_this.setup.wheel.activationKeys);
            if (!keysPressed) return;
            $9f57700f268362ee$var$handleWheelStart(_this, event);
            $9f57700f268362ee$var$handleWheelZoom(_this, event);
            $9f57700f268362ee$var$handleWheelStop(_this, event);
        };
        /// ///////
        // Pan
        /// ///////
        this.onWheelPanning = function(event) {
            var _a = _this.setup, disabled = _a.disabled, wheel = _a.wheel, panning = _a.panning;
            if (!_this.wrapperComponent || !_this.contentComponent || disabled || !wheel.wheelDisabled || panning.disabled || !panning.wheelPanning || event.ctrlKey) return;
            event.preventDefault();
            event.stopPropagation();
            var _b = _this.transformState, positionX = _b.positionX, positionY = _b.positionY;
            var mouseX = positionX - event.deltaX;
            var mouseY = positionY - event.deltaY;
            var newPositionX = panning.lockAxisX ? positionX : mouseX;
            var newPositionY = panning.lockAxisY ? positionY : mouseY;
            var _c = _this.setup.alignmentAnimation, sizeX = _c.sizeX, sizeY = _c.sizeY;
            var paddingValueX = $9f57700f268362ee$var$getPaddingValue(_this, sizeX);
            var paddingValueY = $9f57700f268362ee$var$getPaddingValue(_this, sizeY);
            if (newPositionX === positionX && newPositionY === positionY) return;
            $9f57700f268362ee$var$handleNewPosition(_this, newPositionX, newPositionY, paddingValueX, paddingValueY);
        };
        this.onPanningStart = function(event) {
            var disabled = _this.setup.disabled;
            var onPanningStart = _this.props.onPanningStart;
            if (disabled) return;
            var isAllowed = $9f57700f268362ee$var$isPanningStartAllowed(_this, event);
            if (!isAllowed) return;
            var keysPressed = _this.isPressingKeys(_this.setup.panning.activationKeys);
            if (!keysPressed) return;
            if (event.button === 0 && !_this.setup.panning.allowLeftClickPan) return;
            if (event.button === 1 && !_this.setup.panning.allowMiddleClickPan) return;
            if (event.button === 2 && !_this.setup.panning.allowRightClickPan) return;
            event.preventDefault();
            event.stopPropagation();
            $9f57700f268362ee$var$handleCancelAnimation(_this);
            $9f57700f268362ee$var$handlePanningStart(_this, event);
            $9f57700f268362ee$var$handleCallback($9f57700f268362ee$var$getContext(_this), event, onPanningStart);
        };
        this.onPanning = function(event) {
            var disabled = _this.setup.disabled;
            var onPanning = _this.props.onPanning;
            if (disabled) return;
            var isAllowed = $9f57700f268362ee$var$isPanningAllowed(_this);
            if (!isAllowed) return;
            var keysPressed = _this.isPressingKeys(_this.setup.panning.activationKeys);
            if (!keysPressed) return;
            event.preventDefault();
            event.stopPropagation();
            $9f57700f268362ee$var$handlePanning(_this, event.clientX, event.clientY);
            $9f57700f268362ee$var$handleCallback($9f57700f268362ee$var$getContext(_this), event, onPanning);
        };
        this.onPanningStop = function(event) {
            var onPanningStop = _this.props.onPanningStop;
            if (_this.isPanning) {
                $9f57700f268362ee$var$handlePanningEnd(_this);
                $9f57700f268362ee$var$handleCallback($9f57700f268362ee$var$getContext(_this), event, onPanningStop);
            }
        };
        /// ///////
        // Pinch
        /// ///////
        this.onPinchStart = function(event) {
            var disabled = _this.setup.disabled;
            var _a = _this.props, onPinchingStart = _a.onPinchingStart, onZoomStart = _a.onZoomStart;
            if (disabled) return;
            var isAllowed = $9f57700f268362ee$var$isPinchStartAllowed(_this, event);
            if (!isAllowed) return;
            $9f57700f268362ee$var$handlePinchStart(_this, event);
            $9f57700f268362ee$var$handleCancelAnimation(_this);
            $9f57700f268362ee$var$handleCallback($9f57700f268362ee$var$getContext(_this), event, onPinchingStart);
            $9f57700f268362ee$var$handleCallback($9f57700f268362ee$var$getContext(_this), event, onZoomStart);
        };
        this.onPinch = function(event) {
            var disabled = _this.setup.disabled;
            var _a = _this.props, onPinching = _a.onPinching, onZoom = _a.onZoom;
            if (disabled) return;
            var isAllowed = $9f57700f268362ee$var$isPinchAllowed(_this);
            if (!isAllowed) return;
            event.preventDefault();
            event.stopPropagation();
            $9f57700f268362ee$var$handlePinchZoom(_this, event);
            $9f57700f268362ee$var$handleCallback($9f57700f268362ee$var$getContext(_this), event, onPinching);
            $9f57700f268362ee$var$handleCallback($9f57700f268362ee$var$getContext(_this), event, onZoom);
        };
        this.onPinchStop = function(event) {
            var _a = _this.props, onPinchingStop = _a.onPinchingStop, onZoomStop = _a.onZoomStop;
            if (_this.pinchStartScale) {
                $9f57700f268362ee$var$handlePinchStop(_this);
                $9f57700f268362ee$var$handleCallback($9f57700f268362ee$var$getContext(_this), event, onPinchingStop);
                $9f57700f268362ee$var$handleCallback($9f57700f268362ee$var$getContext(_this), event, onZoomStop);
            }
        };
        /// ///////
        // Touch
        /// ///////
        this.onTouchPanningStart = function(event) {
            var disabled = _this.setup.disabled;
            var onPanningStart = _this.props.onPanningStart;
            if (disabled) return;
            var isAllowed = $9f57700f268362ee$var$isPanningStartAllowed(_this, event);
            if (!isAllowed) return;
            var isDoubleTap = _this.lastTouch && +new Date() - _this.lastTouch < 200;
            if (isDoubleTap && event.touches.length === 1) _this.onDoubleClick(event);
            else {
                _this.lastTouch = +new Date();
                $9f57700f268362ee$var$handleCancelAnimation(_this);
                var touches = event.touches;
                var isPanningAction = touches.length === 1;
                var isPinchAction = touches.length === 2;
                if (isPanningAction) {
                    $9f57700f268362ee$var$handleCancelAnimation(_this);
                    $9f57700f268362ee$var$handlePanningStart(_this, event);
                    $9f57700f268362ee$var$handleCallback($9f57700f268362ee$var$getContext(_this), event, onPanningStart);
                }
                if (isPinchAction) _this.onPinchStart(event);
            }
        };
        this.onTouchPanning = function(event) {
            var disabled = _this.setup.disabled;
            var onPanning = _this.props.onPanning;
            if (_this.isPanning && event.touches.length === 1) {
                if (disabled) return;
                var isAllowed = $9f57700f268362ee$var$isPanningAllowed(_this);
                if (!isAllowed) return;
                event.preventDefault();
                event.stopPropagation();
                var touch = event.touches[0];
                $9f57700f268362ee$var$handlePanning(_this, touch.clientX, touch.clientY);
                $9f57700f268362ee$var$handleCallback($9f57700f268362ee$var$getContext(_this), event, onPanning);
            } else if (event.touches.length > 1) _this.onPinch(event);
        };
        this.onTouchPanningStop = function(event) {
            _this.onPanningStop(event);
            _this.onPinchStop(event);
        };
        /// ///////
        // Double Click
        /// ///////
        this.onDoubleClick = function(event) {
            var disabled = _this.setup.disabled;
            if (disabled) return;
            var isAllowed = $9f57700f268362ee$var$isDoubleClickAllowed(_this, event);
            if (!isAllowed) return;
            $9f57700f268362ee$var$handleDoubleClick(_this, event);
        };
        /// ///////
        // Helpers
        /// ///////
        this.clearPanning = function(event) {
            if (_this.isPanning) _this.onPanningStop(event);
        };
        this.setKeyPressed = function(e) {
            _this.pressedKeys[e.key] = true;
        };
        this.setKeyUnPressed = function(e) {
            _this.pressedKeys[e.key] = false;
        };
        this.isPressingKeys = function(keys) {
            if (!keys.length) return true;
            return Boolean(keys.find(function(key) {
                return _this.pressedKeys[key];
            }));
        };
        this.setTransformState = function(scale, positionX, positionY) {
            var onTransformed = _this.props.onTransformed;
            if (!Number.isNaN(scale) && !Number.isNaN(positionX) && !Number.isNaN(positionY)) {
                if (scale !== _this.transformState.scale) {
                    _this.transformState.previousScale = _this.transformState.scale;
                    _this.transformState.scale = scale;
                }
                _this.transformState.positionX = positionX;
                _this.transformState.positionY = positionY;
                _this.applyTransformation();
                var ctx_1 = $9f57700f268362ee$var$getContext(_this);
                _this.onChangeCallbacks.forEach(function(callback) {
                    return callback(ctx_1);
                });
                $9f57700f268362ee$var$handleCallback(ctx_1, {
                    scale: scale,
                    positionX: positionX,
                    positionY: positionY
                }, onTransformed);
            } else console.error("Detected NaN set state values");
        };
        this.setCenter = function() {
            if (_this.wrapperComponent && _this.contentComponent) {
                var targetState = $9f57700f268362ee$export$a51b33620579dad4(_this.transformState.scale, _this.wrapperComponent, _this.contentComponent);
                _this.setTransformState(targetState.scale, targetState.positionX, targetState.positionY);
            }
        };
        this.handleTransformStyles = function(x, y, scale) {
            if (_this.props.customTransform) return _this.props.customTransform(x, y, scale);
            return $9f57700f268362ee$export$c15ec262effbd456(x, y, scale);
        };
        this.applyTransformation = function() {
            if (!_this.mounted || !_this.contentComponent) return;
            var _a = _this.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
            var transform = _this.handleTransformStyles(positionX, positionY, scale);
            _this.contentComponent.style.transform = transform;
        };
        this.getContext = function() {
            return $9f57700f268362ee$var$getContext(_this);
        };
        /**
         * Hooks
         */ this.onChange = function(callback) {
            if (!_this.onChangeCallbacks.has(callback)) _this.onChangeCallbacks.add(callback);
            return function() {
                _this.onChangeCallbacks.delete(callback);
            };
        };
        this.onInit = function(callback) {
            if (!_this.onInitCallbacks.has(callback)) _this.onInitCallbacks.add(callback);
            return function() {
                _this.onInitCallbacks.delete(callback);
            };
        };
        /**
         * Initialization
         */ this.init = function(wrapperComponent, contentComponent) {
            _this.cleanupWindowEvents();
            _this.wrapperComponent = wrapperComponent;
            _this.contentComponent = contentComponent;
            $9f57700f268362ee$var$handleCalculateBounds(_this, _this.transformState.scale);
            _this.handleInitializeWrapperEvents(wrapperComponent);
            _this.handleInitialize(contentComponent);
            _this.initializeWindowEvents();
            _this.isInitialized = true;
            var ctx = $9f57700f268362ee$var$getContext(_this);
            $9f57700f268362ee$var$handleCallback(ctx, undefined, _this.props.onInit);
        };
        this.props = props;
        this.setup = $9f57700f268362ee$var$createSetup(this.props);
        this.transformState = $9f57700f268362ee$var$createState(this.props);
    }
    return ZoomPanPinch;
}();
var $9f57700f268362ee$export$841858b892ce1f4c = (0, (/*@__PURE__*/$parcel$interopDefault($7RNO0))).createContext(null);
var $9f57700f268362ee$var$getContent = function(children, ctx) {
    if (typeof children === "function") return children(ctx);
    return children;
};
var $9f57700f268362ee$export$51cb649375dcd655 = (0, (/*@__PURE__*/$parcel$interopDefault($7RNO0))).forwardRef(function(props, ref) {
    var instance = (0, $7RNO0.useRef)(new $9f57700f268362ee$var$ZoomPanPinch(props)).current;
    var content = $9f57700f268362ee$var$getContent(props.children, $9f57700f268362ee$var$getControls(instance));
    (0, $7RNO0.useImperativeHandle)(ref, function() {
        return $9f57700f268362ee$var$getControls(instance);
    }, [
        instance
    ]);
    (0, $7RNO0.useEffect)(function() {
        instance.update(props);
    }, [
        instance,
        props
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7RNO0))).createElement($9f57700f268362ee$export$841858b892ce1f4c.Provider, {
        value: instance
    }, content);
});
var $9f57700f268362ee$export$cbc53e226f857b23 = (0, (/*@__PURE__*/$parcel$interopDefault($7RNO0))).forwardRef(function(props, ref) {
    var localRef = (0, $7RNO0.useRef)(null);
    var instance = (0, $7RNO0.useContext)($9f57700f268362ee$export$841858b892ce1f4c);
    (0, $7RNO0.useEffect)(function() {
        return instance.onChange(function(ctx) {
            if (localRef.current) {
                var positionX = 0;
                var positionY = 0;
                localRef.current.style.transform = instance.handleTransformStyles(positionX, positionY, 1 / ctx.instance.transformState.scale);
            }
        });
    }, [
        instance
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7RNO0))).createElement("div", $9f57700f268362ee$var$__assign({}, props, {
        ref: $9f57700f268362ee$var$mergeRefs([
            localRef,
            ref
        ])
    }));
});
var $9f57700f268362ee$var$initialElementRect = {
    width: 0,
    height: 0,
    y: 0,
    x: 0,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
};
var $9f57700f268362ee$var$useResize = function(ref, onResize, dependencies) {
    var resizeObserverRef = (0, $7RNO0.useRef)();
    var rectRef = (0, $7RNO0.useRef)($9f57700f268362ee$var$initialElementRect);
    var didUnmount = (0, $7RNO0.useRef)(false);
    (0, $7RNO0.useLayoutEffect)(function() {
        var _a;
        didUnmount.current = false;
        if (!("ResizeObserver" in window)) return;
        if (ref) {
            resizeObserverRef.current = new ResizeObserver(function(entries) {
                var newSize = ref.getBoundingClientRect();
                if (!Array.isArray(entries) || !entries.length || didUnmount.current || newSize.width === rectRef.current.width && newSize.height === rectRef.current.height) return;
                onResize(newSize, ref);
                rectRef.current = newSize;
            });
            (_a = resizeObserverRef.current) === null || _a === void 0 || _a.observe(ref);
        }
        return function() {
            var _a;
            didUnmount.current = true;
            if (ref) (_a = resizeObserverRef.current) === null || _a === void 0 || _a.unobserve(ref);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $9f57700f268362ee$var$__spreadArray([
        onResize,
        ref
    ], dependencies, true));
};
var $9f57700f268362ee$var$previewStyles = {
    position: "absolute",
    zIndex: 2,
    top: "0px",
    left: "0px",
    boxSizing: "border-box",
    border: "3px solid red",
    transformOrigin: "0% 0%",
    boxShadow: "rgba(0,0,0,0.2) 0 0 0 10000000px"
};
var $9f57700f268362ee$export$a97dd8f3835953ef = function(_a) {
    var _b = _a.width, width = _b === void 0 ? 200 : _b, _c = _a.height, height = _c === void 0 ? 200 : _c, _d = _a.borderColor, borderColor = _d === void 0 ? "red" : _d, children = _a.children, rest = $9f57700f268362ee$var$__rest(_a, [
        "width",
        "height",
        "borderColor",
        "children"
    ]);
    var _e = (0, $7RNO0.useState)(false), initialized = _e[0], setInitialized = _e[1];
    var instance = $9f57700f268362ee$export$1708b11af87412f8();
    var miniMapInstance = (0, $7RNO0.useRef)(null);
    var mainRef = (0, $7RNO0.useRef)(null);
    var wrapperRef = (0, $7RNO0.useRef)(null);
    var previewRef = (0, $7RNO0.useRef)(null);
    var getViewportSize = (0, $7RNO0.useCallback)(function() {
        if (instance.wrapperComponent) {
            var rect = instance.wrapperComponent.getBoundingClientRect();
            return {
                width: rect.width,
                height: rect.height
            };
        }
        return {
            width: 0,
            height: 0
        };
    }, [
        instance.wrapperComponent
    ]);
    var getContentSize = (0, $7RNO0.useCallback)(function() {
        if (instance.contentComponent) {
            var rect = instance.contentComponent.getBoundingClientRect();
            return {
                width: rect.width / instance.transformState.scale,
                height: rect.height / instance.transformState.scale
            };
        }
        return {
            width: 0,
            height: 0
        };
    }, [
        instance.contentComponent,
        instance.transformState.scale
    ]);
    var computeMiniMapScale = (0, $7RNO0.useCallback)(function() {
        var contentSize = getContentSize();
        var scaleX = width / contentSize.width;
        var scaleY = height / contentSize.height;
        var scale = scaleY > scaleX ? scaleX : scaleY;
        return scale;
    }, [
        getContentSize,
        height,
        width
    ]);
    var computeMiniMapSize = function() {
        var contentSize = getContentSize();
        var scaleX = width / contentSize.width;
        var scaleY = height / contentSize.height;
        if (scaleY > scaleX) return {
            width: width,
            height: contentSize.height * scaleX
        };
        return {
            width: contentSize.width * scaleY,
            height: height
        };
    };
    var computeMiniMapStyle = function() {
        var scale = computeMiniMapScale();
        var style = {
            transform: "scale(".concat(scale || 1, ")"),
            transformOrigin: "0% 0%",
            position: "absolute",
            boxSizing: "border-box",
            zIndex: 1,
            overflow: "hidden"
        };
        Object.keys(style).forEach(function(key) {
            if (wrapperRef.current) wrapperRef.current.style[key] = style[key];
        });
    };
    var transformMiniMap = function() {
        computeMiniMapStyle();
        var miniSize = computeMiniMapSize();
        var wrapSize = getContentSize();
        if (wrapperRef.current) {
            wrapperRef.current.style.width = "".concat(wrapSize.width, "px");
            wrapperRef.current.style.height = "".concat(wrapSize.height, "px");
        }
        if (mainRef.current) {
            mainRef.current.style.width = "".concat(miniSize.width, "px");
            mainRef.current.style.height = "".concat(miniSize.height, "px");
        }
        if (previewRef.current) {
            var size = getViewportSize();
            var scale = computeMiniMapScale();
            var previewScale = scale * (1 / instance.transformState.scale);
            var transform = instance.handleTransformStyles(-instance.transformState.positionX * previewScale, -instance.transformState.positionY * previewScale, 1);
            previewRef.current.style.transform = transform;
            previewRef.current.style.width = "".concat(size.width * previewScale, "px");
            previewRef.current.style.height = "".concat(size.height * previewScale, "px");
        }
    };
    var initialize = function() {
        transformMiniMap();
    };
    $9f57700f268362ee$export$769cca75086a299c(function() {
        transformMiniMap();
    });
    $9f57700f268362ee$export$e14839139473133b(function() {
        initialize();
        setInitialized(true);
    });
    $9f57700f268362ee$var$useResize(instance.contentComponent, initialize, [
        initialized
    ]);
    (0, $7RNO0.useEffect)(function() {
        return instance.onChange(function(zpp) {
            var scale = computeMiniMapScale();
            if (miniMapInstance.current) {
                miniMapInstance.current.instance.transformState.scale = zpp.instance.transformState.scale;
                miniMapInstance.current.instance.transformState.positionX = zpp.instance.transformState.positionX * scale;
                miniMapInstance.current.instance.transformState.positionY = zpp.instance.transformState.positionY * scale;
            }
        });
    }, [
        computeMiniMapScale,
        instance,
        miniMapInstance
    ]);
    var wrapperStyle = (0, $7RNO0.useMemo)(function() {
        return {
            position: "relative",
            zIndex: 2,
            overflow: "hidden"
        };
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7RNO0))).createElement("div", $9f57700f268362ee$var$__assign({}, rest, {
        ref: mainRef,
        style: wrapperStyle,
        className: "rzpp-mini-map ".concat(rest.className || "")
    }), (0, (/*@__PURE__*/$parcel$interopDefault($7RNO0))).createElement("div", $9f57700f268362ee$var$__assign({}, rest, {
        ref: wrapperRef,
        className: "rzpp-wrapper"
    }), children), (0, (/*@__PURE__*/$parcel$interopDefault($7RNO0))).createElement("div", {
        className: "rzpp-preview",
        ref: previewRef,
        style: $9f57700f268362ee$var$__assign($9f57700f268362ee$var$__assign({}, $9f57700f268362ee$var$previewStyles), {
            borderColor: borderColor
        })
    }));
};
function $9f57700f268362ee$var$styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === 'undefined') return;
    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';
    if (insertAt === 'top') {
        if (head.firstChild) head.insertBefore(style, head.firstChild);
        else head.appendChild(style);
    } else head.appendChild(style);
    if (style.styleSheet) style.styleSheet.cssText = css;
    else style.appendChild(document.createTextNode(css));
}
var $9f57700f268362ee$var$css_248z = ".transform-component-module_wrapper__SPB86 {\n  position: relative;\n  width: -moz-fit-content;\n  width: fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  overflow: hidden;\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Safari */\n  -khtml-user-select: none; /* Konqueror HTML */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none;\n  margin: 0;\n  padding: 0;\n}\n.transform-component-module_content__FBWxo {\n  display: flex;\n  flex-wrap: wrap;\n  width: -moz-fit-content;\n  width: fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  margin: 0;\n  padding: 0;\n  transform-origin: 0% 0%;\n}\n.transform-component-module_content__FBWxo img {\n  pointer-events: none;\n}\n";
var $9f57700f268362ee$var$styles = {
    "wrapper": "transform-component-module_wrapper__SPB86",
    "content": "transform-component-module_content__FBWxo"
};
$9f57700f268362ee$var$styleInject($9f57700f268362ee$var$css_248z);
var $9f57700f268362ee$export$1def2aa75b7c7fe0 = function(_a) {
    var children = _a.children, _b = _a.wrapperClass, wrapperClass = _b === void 0 ? "" : _b, _c = _a.contentClass, contentClass = _c === void 0 ? "" : _c, wrapperStyle = _a.wrapperStyle, contentStyle = _a.contentStyle, _d = _a.wrapperProps, wrapperProps = _d === void 0 ? {} : _d, _e = _a.contentProps, contentProps = _e === void 0 ? {} : _e;
    var _f = (0, $7RNO0.useContext)($9f57700f268362ee$export$841858b892ce1f4c), init = _f.init, cleanupWindowEvents = _f.cleanupWindowEvents;
    var wrapperRef = (0, $7RNO0.useRef)(null);
    var contentRef = (0, $7RNO0.useRef)(null);
    (0, $7RNO0.useEffect)(function() {
        var wrapper = wrapperRef.current;
        var content = contentRef.current;
        if (wrapper !== null && content !== null && init) init === null || init === void 0 || init(wrapper, content);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        return function() {
            cleanupWindowEvents === null || cleanupWindowEvents === void 0 || cleanupWindowEvents();
        };
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7RNO0))).createElement("div", $9f57700f268362ee$var$__assign({}, wrapperProps, {
        ref: wrapperRef,
        className: "".concat($9f57700f268362ee$var$baseClasses.wrapperClass, " ").concat($9f57700f268362ee$var$styles.wrapper, " ").concat(wrapperClass),
        style: wrapperStyle
    }), (0, (/*@__PURE__*/$parcel$interopDefault($7RNO0))).createElement("div", $9f57700f268362ee$var$__assign({}, contentProps, {
        ref: contentRef,
        className: "".concat($9f57700f268362ee$var$baseClasses.contentClass, " ").concat($9f57700f268362ee$var$styles.content, " ").concat(contentClass),
        style: contentStyle
    }), children));
};
var $9f57700f268362ee$export$1708b11af87412f8 = function() {
    var libraryContext = (0, $7RNO0.useContext)($9f57700f268362ee$export$841858b892ce1f4c);
    if (!libraryContext) throw new Error("Transform context must be placed inside TransformWrapper");
    return libraryContext;
};
var $9f57700f268362ee$export$8a75c83865bcf9dd = function() {
    var libraryContext = $9f57700f268362ee$export$1708b11af87412f8();
    return $9f57700f268362ee$var$getControls(libraryContext);
};
var $9f57700f268362ee$export$e14839139473133b = function(callback) {
    var libraryContext = $9f57700f268362ee$export$1708b11af87412f8();
    (0, $7RNO0.useEffect)(function() {
        var unmountCallback;
        var unmount;
        if (libraryContext.contentComponent && libraryContext.wrapperComponent) unmountCallback = callback($9f57700f268362ee$var$getState(libraryContext));
        else unmount = libraryContext.onInit(function(ref) {
            unmountCallback = callback($9f57700f268362ee$var$getState(ref.instance));
        });
        return function() {
            unmount === null || unmount === void 0 || unmount();
            unmountCallback === null || unmountCallback === void 0 || unmountCallback();
        };
    }, []);
};
var $9f57700f268362ee$export$769cca75086a299c = function(callback) {
    var libraryContext = $9f57700f268362ee$export$1708b11af87412f8();
    (0, $7RNO0.useEffect)(function() {
        var unmountCallback;
        var unmount = libraryContext.onChange(function(ref) {
            unmountCallback = callback($9f57700f268362ee$var$getState(ref.instance));
        });
        return function() {
            unmount();
            unmountCallback === null || unmountCallback === void 0 || unmountCallback();
        };
    }, [
        callback,
        libraryContext
    ]);
};
function $9f57700f268362ee$export$4915c4f91c47b682(callback) {
    var libraryContext = $9f57700f268362ee$export$1708b11af87412f8();
    var _a = (0, $7RNO0.useState)(callback($9f57700f268362ee$var$getState(libraryContext))), transformRender = _a[0], setTransformRender = _a[1];
    (0, $7RNO0.useEffect)(function() {
        var mounted = true;
        var unmount = libraryContext.onChange(function(ref) {
            if (mounted) setTransformRender(callback($9f57700f268362ee$var$getState(ref.instance)));
        });
        return function() {
            unmount();
            mounted = false;
        };
    }, [
        callback,
        libraryContext
    ]);
    return transformRender;
}



var $6dpjF = parcelRequire("6dpjF");


var $kFQy0 = parcelRequire("kFQy0");

var $i2KZ1 = parcelRequire("i2KZ1");

var $9HMNu = parcelRequire("9HMNu");



var $6KpYp = parcelRequire("6KpYp");

var $7v5wN = parcelRequire("7v5wN");

var $1afSf = parcelRequire("1afSf");

var $gxeM7 = parcelRequire("gxeM7");

var $cTs7K = parcelRequire("cTs7K");

var $9h2J6 = parcelRequire("9h2J6");

var $7RNO0 = parcelRequire("7RNO0");

var $9h2J6 = parcelRequire("9h2J6");

var $7RNO0 = parcelRequire("7RNO0");
/**
 * RoundProgressBarRefDriven
 *
 * This component is intentionally *not* updated through React props or state.
 * Instead, it exposes refs (circleRef + textRef) that the parent updates
 * directly inside a requestAnimationFrame loop.
 *
 * Why?
 * - Avoids React re-renders at ~60fps (bad for performance, especially on mobile)
 * - Keeps React completely asleep during video playback
 * - Allows smooth, cheap DOM updates driven by the YouTube player
 *
 * TL;DR — Visual only. Logic lives in the parent. All animation happens via refs.
 */ function $070fbaf28debfea4$var$RoundProgressBarRefDriven({ circleRef: circleRef, textRef: textRef, radius: radius, circumference: circumference, className: className }) {
    return /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $9h2J6.jsxs)("svg", {
                viewBox: "0 0 120 120",
                style: {
                    transform: 'rotate(-90deg)'
                },
                children: [
                    /*#__PURE__*/ (0, $9h2J6.jsx)("circle", {
                        cx: "60",
                        cy: "60",
                        r: radius,
                        stroke: "#444",
                        strokeWidth: "8",
                        fill: "none"
                    }),
                    /*#__PURE__*/ (0, $9h2J6.jsx)("circle", {
                        ref: circleRef,
                        cx: "60",
                        cy: "60",
                        r: radius,
                        stroke: "#ffffffff",
                        strokeWidth: "8",
                        fill: "none",
                        strokeLinecap: "round",
                        strokeDasharray: circumference,
                        strokeDashoffset: circumference
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                ref: textRef,
                style: {
                    position: 'absolute',
                    inset: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                },
                children: "0%"
            })
        ]
    });
}
function $070fbaf28debfea4$export$d73074b7512a7248({ playerRef: playerRef, force100: force100, className: className }) {
    const rafRef = (0, $7RNO0.useRef)(null); // Request animation frame ref
    const circleRef = (0, $7RNO0.useRef)(null);
    const textRef = (0, $7RNO0.useRef)(null);
    const radius = 45;
    const circumference = 2 * Math.PI * radius;
    const lastPercent = (0, $7RNO0.useRef)(0);
    const setVisualPercent = (percent)=>{
        const clamped = Math.max(0, Math.min(100, percent));
        const offset = circumference * (1 - clamped / 100);
        // Always update the circle (smooth animation)
        if (circleRef.current) circleRef.current.style.strokeDashoffset = String(offset);
        // Only update text when it actually changes
        if (clamped !== lastPercent.current) {
            lastPercent.current = clamped;
            if (textRef.current) textRef.current.textContent = clamped + '%';
        }
    };
    (0, $7RNO0.useEffect)(()=>{
        // If forced to 100%, skip ticking entirely
        if (force100) {
            setVisualPercent(100);
            return; // Do not start RAF loop
        }
        const tick = ()=>{
            const player = playerRef.current;
            if (!player) {
                rafRef.current = requestAnimationFrame(tick);
                return;
            }
            const videoTime = player.getCurrentTime();
            const videoDuration = player.getDuration();
            if (!videoDuration) {
                rafRef.current = requestAnimationFrame(tick);
                return;
            }
            const percent = Math.floor(videoTime / videoDuration * 100);
            setVisualPercent(percent);
            rafRef.current = requestAnimationFrame(tick);
        };
        rafRef.current = requestAnimationFrame(tick);
        return ()=>cancelAnimationFrame(rafRef.current);
    }, [
        force100
    ]);
    return /*#__PURE__*/ (0, $9h2J6.jsx)($070fbaf28debfea4$var$RoundProgressBarRefDriven, {
        className: className,
        circleRef: circleRef,
        textRef: textRef,
        radius: radius,
        circumference: circumference
    });
}




var $kFQy0 = parcelRequire("kFQy0");
function $bd455a3dc86c9fbe$export$949cdc0afd1b6cf3(eventType, videoUrl, additionalStrings = [], numbers = []) {
    (0, $kFQy0.sendEventV2)('video_engagement', [
        eventType,
        videoUrl,
        ...additionalStrings
    ], numbers);
}
function $bd455a3dc86c9fbe$export$b618680f92f27e47(currentTime, duration, videoUrl, milestonesTracked, onComplete, onMilestone) {
    if (duration === 0) return;
    const percentage = currentTime / duration * 100;
    const milestones = [
        {
            threshold: 10,
            label: '10%'
        },
        {
            threshold: 20,
            label: '20%'
        },
        {
            threshold: 25,
            label: '25%'
        },
        {
            threshold: 30,
            label: '30%'
        },
        {
            threshold: 40,
            label: '40%'
        },
        {
            threshold: 50,
            label: '50%'
        },
        {
            threshold: 60,
            label: '60%'
        },
        {
            threshold: 70,
            label: '70%'
        },
        {
            threshold: 75,
            label: '75%'
        },
        {
            threshold: 80,
            label: '80%'
        },
        {
            threshold: 90,
            label: '90%'
        },
        {
            threshold: 100,
            label: '100%'
        }
    ];
    milestones.forEach((milestone)=>{
        if (percentage >= milestone.threshold && !milestonesTracked.has(milestone.label)) {
            milestonesTracked.add(milestone.label);
            $bd455a3dc86c9fbe$export$949cdc0afd1b6cf3('milestone', videoUrl, [
                milestone.label
            ], [
                currentTime,
                duration
            ]);
            if (onMilestone) onMilestone(milestone.threshold);
        }
    });
}
function $bd455a3dc86c9fbe$export$7aac5f8126fa4668(currentTime, duration, videoUrl, lastKnownTime) {
    const timeDiff = Math.abs(currentTime - lastKnownTime);
    if (timeDiff > 1 && lastKnownTime > 0) $bd455a3dc86c9fbe$export$949cdc0afd1b6cf3('seek', videoUrl, [], [
        lastKnownTime,
        currentTime,
        duration
    ]);
    return currentTime;
}



var $9h2J6 = parcelRequire("9h2J6");

var $7RNO0 = parcelRequire("7RNO0");


function $bcc51232a27734fb$export$d6f3e0479583ca37(onReady) {
    if (window.YT && window.YT.Player) {
        onReady();
        return;
    }
    const existingScript = document.querySelector('script[src="https://www.youtube.com/iframe_api"]');
    if (existingScript) {
        window.onYouTubeIframeAPIReady = onReady;
        return;
    }
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);
    window.onYouTubeIframeAPIReady = onReady;
}
function $bcc51232a27734fb$export$acf5185a61c48950(url) {
    // Handle formats https://youtu.be/YTYo_0MsV7O, https://www.youtube.com/watch?v=YTYo_0MsV7O, https://youtube.com/shorts/YTYo_0MsV7O
    try {
        const parsed = new URL(url);
        if (parsed.hostname.includes('youtube.com') && parsed.pathname === '/watch') return parsed.searchParams.get('v');
        if (parsed.hostname.includes('youtube.com') && parsed.pathname.startsWith('/shorts/')) return parsed.pathname.slice(8) || null;
        if (parsed.hostname === 'youtu.be') return parsed.pathname.slice(1) || null;
    } catch (e) {
        console.warn('Failed to parse YouTube URL:', e);
    }
    return null;
}
function $bcc51232a27734fb$export$9990abda26fec7fc(videoUrl) {
    return (event)=>{
        const rate = event.data;
        (0, $bd455a3dc86c9fbe$export$949cdc0afd1b6cf3)('playback_rate', videoUrl, [], [
            rate
        ]);
    };
}



var $cTs7K = parcelRequire("cTs7K");
function $9d15c61413fe6289$var$createYouTubePlayerWrapper(player) {
    return {
        getCurrentTime: ()=>{
            return typeof player?.getCurrentTime === 'function' ? player.getCurrentTime() : undefined;
        },
        getDuration: ()=>{
            return typeof player?.getDuration === 'function' ? player.getDuration() : undefined;
        },
        isEnded: ()=>{
            return typeof player?.getPlayerState === 'function' ? player.getPlayerState() === window.YT?.PlayerState.ENDED : undefined;
        }
    };
}
function $9d15c61413fe6289$export$50da724f0fa6e6a9({ videoUrl: videoUrl, videoId: videoId, className: className, hasControls: hasControls, shouldAutoplay: shouldAutoplay, playerRef: playerRef, onPlay: onPlay, onPause: onPause, onEnded: onEnded, onReady: onReady }) {
    const playerContainerRef = (0, $7RNO0.useRef)(null);
    const [isYouTubeAPIReady, setIsYouTubeAPIReady] = (0, (/*@__PURE__*/$parcel$interopDefault($7RNO0))).useState(false);
    const nativePlayerRef = (0, $7RNO0.useRef)(null);
    (0, $7RNO0.useEffect)(()=>{
        (0, $bcc51232a27734fb$export$d6f3e0479583ca37)(()=>setIsYouTubeAPIReady(true));
    }, []);
    const onPlaybackRateChange = (0, $bcc51232a27734fb$export$9990abda26fec7fc)(videoUrl);
    (0, $7RNO0.useEffect)(()=>{
        if (!isYouTubeAPIReady) return;
        if (!videoUrl) return;
        if (!videoUrl.includes('youtube.com/watch') && !videoUrl.includes('youtube.com/shorts/') && !videoUrl.includes('youtu.be/')) return;
        if (!videoId) {
            console.warn('Invalid YouTube video URL');
            return;
        }
        if (playerContainerRef.current && window.YT && window.YT.Player) {
            if (nativePlayerRef.current) nativePlayerRef.current.destroy();
            const usePrivacyEnhancedMode = !(0, $cTs7K.IS_DISCORD_ACTIVITY) && false;
            const player = new window.YT.Player(playerContainerRef.current, {
                ...usePrivacyEnhancedMode && {
                    host: 'https://www.youtube-nocookie.com'
                },
                videoId: videoId,
                width: '100%',
                height: '100%',
                playerVars: {
                    playsinline: 1,
                    enablejsapi: 1,
                    controls: hasControls ? 1 : 0,
                    disablekb: hasControls ? 0 : 1,
                    autoplay: shouldAutoplay ? 1 : 0
                },
                events: {
                    onReady: (event)=>{
                        const iframe = event.target.getIframe();
                        if (iframe) {
                            iframe.setAttribute('title', 'YouTube video player');
                            iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
                            iframe.setAttribute('referrerPolicy', 'strict-origin-when-cross-origin');
                            iframe.setAttribute('allowFullScreen', '');
                        }
                        onReady();
                    },
                    onStateChange: (event)=>{
                        const player = event.target;
                        const state = event.data;
                        const currentTime = player.getCurrentTime();
                        const duration = player.getDuration();
                        // Track video engagement events
                        switch(state){
                            case window.YT.PlayerState.PLAYING:
                                (0, $bd455a3dc86c9fbe$export$949cdc0afd1b6cf3)('play', videoUrl, [], [
                                    currentTime,
                                    duration
                                ]);
                                onPlay();
                                break;
                            case window.YT.PlayerState.PAUSED:
                                (0, $bd455a3dc86c9fbe$export$949cdc0afd1b6cf3)('pause', videoUrl, [], [
                                    currentTime,
                                    duration
                                ]);
                                onPause();
                                break;
                            case window.YT.PlayerState.ENDED:
                                (0, $bd455a3dc86c9fbe$export$949cdc0afd1b6cf3)('ended', videoUrl, [], [
                                    duration
                                ]);
                                onEnded();
                                break;
                            case window.YT.PlayerState.BUFFERING:
                                (0, $bd455a3dc86c9fbe$export$949cdc0afd1b6cf3)('buffering', videoUrl, [], [
                                    currentTime,
                                    duration
                                ]);
                                break;
                            default:
                                break;
                        }
                    },
                    onPlaybackRateChange: onPlaybackRateChange
                }
            });
            nativePlayerRef.current = player;
            playerRef.current = $9d15c61413fe6289$var$createYouTubePlayerWrapper(player);
        }
        return ()=>{
            if (nativePlayerRef.current) {
                nativePlayerRef.current.destroy();
                nativePlayerRef.current = null;
            }
            playerRef.current = null;
        };
    }, [
        isYouTubeAPIReady,
        videoUrl,
        hasControls,
        videoId
    ]);
    if (!videoUrl?.includes('youtube.com/watch') && !videoUrl?.includes('youtube.com/shorts/') && !videoUrl?.includes('youtu.be/')) {
        console.warn('Invalid YouTube video URL');
        return null;
    }
    if (!videoId) {
        console.warn('Invalid YouTube video URL');
        return null;
    }
    return /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
        ref: playerContainerRef,
        className: className
    });
}



var $9h2J6 = parcelRequire("9h2J6");

var $7RNO0 = parcelRequire("7RNO0");

var $9h2J6 = parcelRequire("9h2J6");
parcelRequire("7RNO0");
var $fe1c6287e27849cc$export$73e4574fc43cf3a2;
$fe1c6287e27849cc$export$73e4574fc43cf3a2 = `F4HaDa_playButton`;


function $3a677f6356e47bbd$export$fbed5f62d839a0cd() {
    return /*#__PURE__*/ (0, $9h2J6.jsx)("svg", {
        width: "130",
        height: "130",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: $fe1c6287e27849cc$export$73e4574fc43cf3a2,
        children: /*#__PURE__*/ (0, $9h2J6.jsx)("path", {
            d: "M14 15.06V33a2 2 0 0 0 2.93 1.77l17.09-8.97a2 2 0 0 0 0-3.54L16.93 13.3A2 2 0 0 0 14 15.06z"
        })
    });
}



function $08ea9d82851c667f$export$94e93caed8fbced4(onReady) {
    if (window.Stream) {
        onReady();
        return;
    }
    const existingScript = document.querySelector('script[src="https://embed.cloudflarestream.com/embed/sdk.latest.js"]');
    if (existingScript) {
        existingScript.addEventListener('load', onReady);
        return;
    }
    const script = document.createElement('script');
    script.src = 'https://embed.cloudflarestream.com/embed/sdk.latest.js';
    script.async = true;
    script.onload = onReady;
    document.head.appendChild(script);
}
function $08ea9d82851c667f$export$f3460e1f346f034d(url) {
    try {
        if (url.includes('cloudflarestream.com')) {
            const match = url.match(/cloudflarestream\.com\/([a-f0-9]+)\//);
            return match ? match[1] : null;
        }
    } catch (e) {
        console.warn('Failed to parse Cloudflare Stream URL:', e);
    }
    return null;
}


function $4d5684208115bd18$var$createCloudflarePlayerWrapper(player) {
    return {
        getCurrentTime: ()=>{
            return typeof player?.currentTime === 'number' ? player.currentTime : undefined;
        },
        getDuration: ()=>{
            return typeof player?.duration === 'number' ? player.duration : undefined;
        },
        isEnded: ()=>{
            return typeof player?.ended === 'boolean' ? player.ended === true : undefined;
        }
    };
}
function $4d5684208115bd18$export$359be76a4eee9a5({ videoUrl: videoUrl, videoId: videoId, className: className, hasControls: hasControls, shouldAutoplay: shouldAutoplay, playerRef: playerRef, onPlay: onPlay, onPause: onPause, onEnded: onEnded, onReady: onReady }) {
    const iframeRef = (0, $7RNO0.useRef)(null);
    const [isCloudflareAPIReady, setIsCloudflareAPIReady] = (0, (/*@__PURE__*/$parcel$interopDefault($7RNO0))).useState(false);
    const [isPlaying, setIsPlaying] = (0, (/*@__PURE__*/$parcel$interopDefault($7RNO0))).useState(false);
    const nativePlayerRef = (0, $7RNO0.useRef)(null);
    (0, $7RNO0.useEffect)(()=>{
        (0, $08ea9d82851c667f$export$94e93caed8fbced4)(()=>setIsCloudflareAPIReady(true));
    }, []);
    const handleIframeClick = ()=>{
        const player = nativePlayerRef.current;
        if (!player) return;
        if (hasControls) return; // Only handle clicks when controls are disabled
        try {
            if (isPlaying) player.pause();
            else player.play();
        } catch (error) {
            console.log('Warning: Error toggling play/pause', error);
        }
    };
    (0, $7RNO0.useEffect)(()=>{
        if (!isCloudflareAPIReady) return;
        if (!videoUrl) return;
        if (!videoUrl.includes('cloudflarestream.com')) return;
        if (!videoId) {
            console.warn('Invalid Cloudflare Stream video URL');
            return;
        }
        if (iframeRef.current && window.Stream) {
            const player = window.Stream(iframeRef.current);
            nativePlayerRef.current = player;
            playerRef.current = $4d5684208115bd18$var$createCloudflarePlayerWrapper(player);
            player.addEventListener('play', ()=>{
                (0, $bd455a3dc86c9fbe$export$949cdc0afd1b6cf3)('play', videoUrl, [], [
                    player.currentTime,
                    player.duration
                ]);
                setIsPlaying(true);
                onPlay();
            });
            player.addEventListener('pause', ()=>{
                (0, $bd455a3dc86c9fbe$export$949cdc0afd1b6cf3)('pause', videoUrl, [], [
                    player.currentTime,
                    player.duration
                ]);
                setIsPlaying(false);
                onPause();
            });
            player.addEventListener('ended', ()=>{
                (0, $bd455a3dc86c9fbe$export$949cdc0afd1b6cf3)('ended', videoUrl, [], [
                    player.duration
                ]);
                setIsPlaying(false);
                onEnded();
            });
            player.addEventListener('seeking', ()=>{
                (0, $bd455a3dc86c9fbe$export$949cdc0afd1b6cf3)('seeking', videoUrl, [], [
                    player.currentTime,
                    player.duration
                ]);
            });
            player.addEventListener('seeked', ()=>{
                (0, $bd455a3dc86c9fbe$export$949cdc0afd1b6cf3)('seeked', videoUrl, [], [
                    player.currentTime,
                    player.duration
                ]);
            });
            player.addEventListener('volumechange', ()=>{
                (0, $bd455a3dc86c9fbe$export$949cdc0afd1b6cf3)('volume_change', videoUrl, [], [
                    player.volume
                ]);
            });
            player.addEventListener('loadedmetadata', ()=>{
                (0, $bd455a3dc86c9fbe$export$949cdc0afd1b6cf3)('loaded_metadata', videoUrl, [], [
                    player.duration
                ]);
                onReady();
            });
            player.addEventListener('error', ()=>{
                (0, $bd455a3dc86c9fbe$export$949cdc0afd1b6cf3)('error', videoUrl, [], []);
            });
            player.controls = hasControls;
        }
        return ()=>{
            nativePlayerRef.current = null;
            playerRef.current = null;
        };
    }, [
        isCloudflareAPIReady,
        videoUrl,
        hasControls,
        videoId
    ]);
    if (!videoUrl?.includes('cloudflarestream.com')) {
        console.warn('Invalid Cloudflare Stream video URL');
        return null;
    }
    if (!videoId) {
        console.warn('Invalid Cloudflare Stream video URL');
        return null;
    }
    let iframeSrc = videoUrl;
    if (shouldAutoplay) {
        const url = new URL(videoUrl);
        url.searchParams.set('autoplay', 'true');
        iframeSrc = url.toString();
    }
    const currentTime = nativePlayerRef.current?.currentTime ?? 0;
    const showPlayButton = !hasControls && !isPlaying && currentTime === 0;
    return /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
        onClick: handleIframeClick,
        style: {
            width: '100%',
            height: '100%',
            position: 'relative',
            cursor: !hasControls ? 'pointer' : 'default'
        },
        children: [
            showPlayButton && /*#__PURE__*/ (0, $9h2J6.jsx)((0, $3a677f6356e47bbd$export$fbed5f62d839a0cd), {}),
            /*#__PURE__*/ (0, $9h2J6.jsx)("iframe", {
                ref: iframeRef,
                src: iframeSrc,
                className: className,
                style: {
                    border: 'none',
                    width: '100%',
                    height: '100%',
                    pointerEvents: hasControls ? 'auto' : 'none'
                },
                allow: "accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;",
                allowFullScreen: true,
                title: "Video player"
            })
        ]
    });
}


function $976118dde8fa9cff$export$f503bc85d719e8b0({ videoUrl: videoUrl, videoId: videoId, videoStorageKeyOverride: videoStorageKeyOverride, playerType: playerType, className: className, onComplete: onComplete, enforcedViewing: enforcedViewing, onMilestone: onMilestone, roundProgressBarClassName: roundProgressBarClassName, completionTextClassName: completionTextClassName, hasCompletionText: hasCompletionText, preCompletionText: preCompletionText, postCompletionText: postCompletionText }) {
    const playerRef = (0, $7RNO0.useRef)(null);
    const pollingIntervalRef = (0, $7RNO0.useRef)(null);
    const progressIntervalRef = (0, $7RNO0.useRef)(null);
    const stopPollingTimeoutRef = (0, $7RNO0.useRef)(null);
    const lastKnownTimeRef = (0, $7RNO0.useRef)(0);
    const lastKnownDurationRef = (0, $7RNO0.useRef)(0);
    const milestonesTrackedRef = (0, $7RNO0.useRef)(new Set());
    const onCompleteRef = (0, $7RNO0.useRef)(onComplete);
    const onVideoCompleteCallbackHasBeenCalledRef = (0, $7RNO0.useRef)(false);
    const onMilestoneRef = (0, $7RNO0.useRef)(onMilestone);
    const videoStorageKey = videoStorageKeyOverride ?? videoId;
    const savedData = (0, $7RNO0.useRef)((0, $e30dfa0f8f3999e3$export$34250dbee1b3714)(videoStorageKey));
    const [hasCompletedAtLeastOnce, setHasCompletedAtLeastOnce] = (0, $7RNO0.useState)(()=>{
        return savedData?.current?.completed === true;
    });
    // Component config
    const hasControls = !enforcedViewing || hasCompletedAtLeastOnce;
    const shouldAutoplay = true; // Previously was !hasControls but we think its useful to always autoplay
    const hasProgressCircle = enforcedViewing;
    const shouldPersistProgress = enforcedViewing && !hasCompletedAtLeastOnce;
    // Keep onComplete & onMilestone refs up to date
    (0, $7RNO0.useEffect)(()=>{
        onCompleteRef.current = onComplete;
    }, [
        onComplete
    ]);
    (0, $7RNO0.useEffect)(()=>{
        onMilestoneRef.current = onMilestone;
    }, [
        onMilestone
    ]);
    const onVideoComplete = ()=>{
        // Stop oncomplete being called multiple times
        if (!onVideoCompleteCallbackHasBeenCalledRef.current) {
            onCompleteRef.current?.(!hasCompletedAtLeastOnce);
            onVideoCompleteCallbackHasBeenCalledRef.current = true;
        }
        console.log('User has finished the video');
        stopPolling();
        stopProgressSaving();
        (0, $e30dfa0f8f3999e3$export$f56a20f73da3ee39)(videoStorageKey);
        setTimeout(()=>{
            setHasCompletedAtLeastOnce(true);
            milestonesTrackedRef.current?.clear();
        }, 100);
    };
    const onVideoMilestone = (val)=>{
        const getIsFirstTimeMilestoneReached = ()=>{
            if (hasCompletedAtLeastOnce) return false;
            if (!lastKnownDurationRef.current) return true;
            // If user has not completed the video for the first time yet...
            // Check the saved progress to see if we already reached milestone on previous session
            // (Can't just check milestonesTrackedRef as it gets cleared when component remounts)
            const savedProgress = savedData.current?.progress;
            const savedPercent = savedProgress / lastKnownDurationRef.current * 100 || 0;
            return val > savedPercent;
        };
        onMilestoneRef.current?.(val, getIsFirstTimeMilestoneReached());
    };
    const startProgressSaving = (player)=>{
        if (!shouldPersistProgress) return;
        if (progressIntervalRef.current) clearInterval(progressIntervalRef.current);
        progressIntervalRef.current = window.setInterval(()=>{
            try {
                const currentTime = player.getCurrentTime();
                if (currentTime) (0, $e30dfa0f8f3999e3$export$e20713ec10f02e66)(videoStorageKey, currentTime);
            } catch (error) {
                console.log('Warning: Video progress not saved', error);
            }
        }, 2000);
    };
    const stopProgressSaving = ()=>{
        if (progressIntervalRef.current) {
            clearInterval(progressIntervalRef.current);
            progressIntervalRef.current = null;
        }
    };
    const startPolling = ()=>{
        if (pollingIntervalRef.current) clearInterval(pollingIntervalRef.current);
        pollingIntervalRef.current = window.setInterval(()=>{
            const player = playerRef.current;
            if (!player) return;
            try {
                const currentTime = player.getCurrentTime();
                const duration = player.getDuration();
                if (typeof currentTime !== 'number' || typeof duration !== 'number') return;
                lastKnownTimeRef.current = (0, $bd455a3dc86c9fbe$export$7aac5f8126fa4668)(currentTime, duration, videoUrl, lastKnownTimeRef.current);
                lastKnownDurationRef.current = duration;
                (0, $bd455a3dc86c9fbe$export$b618680f92f27e47)(currentTime, duration, videoUrl, milestonesTrackedRef.current, onVideoComplete, onVideoMilestone);
                // Backup end detection which runs on poll
                if (player.isEnded()) onVideoComplete();
            } catch (error) {
                console.log('Warning: Polling error', error);
            }
        }, 500);
    };
    const stopPolling = ()=>{
        if (pollingIntervalRef.current) {
            clearInterval(pollingIntervalRef.current);
            pollingIntervalRef.current = null;
        }
    };
    const handlePlay = ()=>{
        clearTimeout(stopPollingTimeoutRef.current);
        startPolling();
    };
    const handlePause = ()=>{
        // Wait 1000ms before stopping to allow end events to send via poll if needed
        stopPollingTimeoutRef.current = setTimeout(stopPolling, 1000);
    };
    const handleEnded = ()=>{
        stopPolling();
        onVideoComplete();
    };
    const handleReady = ()=>{
        const player = playerRef.current;
        if (!player) return;
        if (shouldPersistProgress) startProgressSaving(player);
    };
    // Cleanup on unmount
    (0, $7RNO0.useEffect)(()=>{
        return ()=>{
            const currentTime = lastKnownTimeRef.current;
            const duration = lastKnownDurationRef.current;
            if (currentTime > 0 && duration > 0) {
                (0, $bd455a3dc86c9fbe$export$949cdc0afd1b6cf3)('closed', videoUrl, [], [
                    currentTime,
                    duration
                ]);
                if (shouldPersistProgress) (0, $e30dfa0f8f3999e3$export$e20713ec10f02e66)(videoStorageKey, currentTime);
            }
            stopPolling();
            stopProgressSaving();
            lastKnownTimeRef.current = 0;
            lastKnownDurationRef.current = 0;
            milestonesTrackedRef.current.clear();
        };
    }, [
        videoUrl,
        videoId,
        shouldPersistProgress
    ]);
    const coreProps = {
        videoUrl: videoUrl,
        videoId: videoId,
        className: className,
        hasControls: hasControls,
        shouldAutoplay: shouldAutoplay,
        playerRef: playerRef,
        onPlay: handlePlay,
        onPause: handlePause,
        onEnded: handleEnded,
        onReady: handleReady
    };
    return /*#__PURE__*/ (0, $9h2J6.jsxs)((0, $9h2J6.Fragment), {
        children: [
            hasCompletionText && preCompletionText && postCompletionText && /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                className: completionTextClassName,
                children: /*#__PURE__*/ (0, $9h2J6.jsx)("span", {
                    children: hasCompletedAtLeastOnce ? postCompletionText : preCompletionText
                })
            }),
            hasProgressCircle && /*#__PURE__*/ (0, $9h2J6.jsx)((0, $070fbaf28debfea4$export$d73074b7512a7248), {
                playerRef: playerRef,
                className: roundProgressBarClassName,
                force100: hasCompletedAtLeastOnce
            }),
            playerType === 'youtube' ? /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9d15c61413fe6289$export$50da724f0fa6e6a9), {
                ...coreProps
            }) : /*#__PURE__*/ (0, $9h2J6.jsx)((0, $4d5684208115bd18$export$359be76a4eee9a5), {
                ...coreProps
            })
        ]
    });
}




// Temp file for A/B testing, can be deleted after test
let $3c2a744f09fa5441$var$IS_IN_CLOUDFLARE_BUCKET = null;
function $3c2a744f09fa5441$export$b51241a728638e8b(youtubeUrl, cloudflareVideoPercent) {
    $3c2a744f09fa5441$var$bucketUser(cloudflareVideoPercent);
    console.log('[ARISE AB test] User is in cloudflare bucket:', $3c2a744f09fa5441$var$IS_IN_CLOUDFLARE_BUCKET);
    if ($3c2a744f09fa5441$var$IS_IN_CLOUDFLARE_BUCKET) {
        // Try to get Cloudflare version
        const cloudflareUrl = $3c2a744f09fa5441$var$getCloudflareVersionOfYoutubeVideo(youtubeUrl);
        if (cloudflareUrl) {
            console.log('[ARISE AB test] Returning cloudflare url');
            return cloudflareUrl;
        } else console.log('[ARISE AB test] No cloudflare version of url found, returning youtube');
    }
    // Return original YouTube URL if not in test bucket or no mapping exists
    console.log('[ARISE AB test] Returning Youtube url');
    return youtubeUrl;
}
function $3c2a744f09fa5441$var$bucketUser(cloudflareVideoPercent) {
    // Check if user has already been bucketed
    if ($3c2a744f09fa5441$var$IS_IN_CLOUDFLARE_BUCKET !== null) return;
    if (!$3c2a744f09fa5441$var$percentIsValid(cloudflareVideoPercent)) {
        console.log('[ARISE AB test] cloudflareVideoPercent invalid');
        $3c2a744f09fa5441$var$IS_IN_CLOUDFLARE_BUCKET = false;
        return;
    }
    // Generate random number and bucket user
    const randomValue = Math.random() * 100;
    $3c2a744f09fa5441$var$IS_IN_CLOUDFLARE_BUCKET = randomValue < cloudflareVideoPercent;
    console.log(`[ARISE AB test] Data: cloudflareVideoPercent: ${cloudflareVideoPercent}, randomValue: ${randomValue}`);
}
function $3c2a744f09fa5441$var$percentIsValid(percent) {
    return typeof percent === 'number' && percent >= 0 && percent <= 100;
}
function $3c2a744f09fa5441$var$getCloudflareVersionOfYoutubeVideo(youtubeUrl) {
    const videoMapping = {
        'https://www.youtube.com/watch?v=ECI3eCAxRGw': 'https://customer-c6kmyujkvesrdmhe.cloudflarestream.com/8fb776397ab99e0d4867875f8044d3e8/iframe'
    };
    return videoMapping[youtubeUrl] ?? null;
}


var $768f69f3453e1a2d$exports = {};

$parcel$export($768f69f3453e1a2d$exports, "MediaViewer", function () { return $768f69f3453e1a2d$export$fe6485e420d37282; }, function (v) { return $768f69f3453e1a2d$export$fe6485e420d37282 = v; });
$parcel$export($768f69f3453e1a2d$exports, "closeButton", function () { return $768f69f3453e1a2d$export$efe229eab43a9869; }, function (v) { return $768f69f3453e1a2d$export$efe229eab43a9869 = v; });
$parcel$export($768f69f3453e1a2d$exports, "completionText", function () { return $768f69f3453e1a2d$export$3ea4c15e263a0c0f; }, function (v) { return $768f69f3453e1a2d$export$3ea4c15e263a0c0f = v; });
$parcel$export($768f69f3453e1a2d$exports, "externalLinkButton", function () { return $768f69f3453e1a2d$export$f02cbb504f26b596; }, function (v) { return $768f69f3453e1a2d$export$f02cbb504f26b596 = v; });
$parcel$export($768f69f3453e1a2d$exports, "externalLinkImage", function () { return $768f69f3453e1a2d$export$e8043fb4712c8bde; }, function (v) { return $768f69f3453e1a2d$export$e8043fb4712c8bde = v; });
$parcel$export($768f69f3453e1a2d$exports, "imageContainer", function () { return $768f69f3453e1a2d$export$63e82393dc8977bf; }, function (v) { return $768f69f3453e1a2d$export$63e82393dc8977bf = v; });
$parcel$export($768f69f3453e1a2d$exports, "imageDescription", function () { return $768f69f3453e1a2d$export$1d1572c777d0d7ac; }, function (v) { return $768f69f3453e1a2d$export$1d1572c777d0d7ac = v; });
$parcel$export($768f69f3453e1a2d$exports, "imageViewerImage", function () { return $768f69f3453e1a2d$export$65303a24f2d95a8e; }, function (v) { return $768f69f3453e1a2d$export$65303a24f2d95a8e = v; });
$parcel$export($768f69f3453e1a2d$exports, "mediaContainer", function () { return $768f69f3453e1a2d$export$e91e3cc91e00b6bb; }, function (v) { return $768f69f3453e1a2d$export$e91e3cc91e00b6bb = v; });
$parcel$export($768f69f3453e1a2d$exports, "modalContent", function () { return $768f69f3453e1a2d$export$add244bda2f9423c; }, function (v) { return $768f69f3453e1a2d$export$add244bda2f9423c = v; });
$parcel$export($768f69f3453e1a2d$exports, "overlay", function () { return $768f69f3453e1a2d$export$29dd17c7f3c81c36; }, function (v) { return $768f69f3453e1a2d$export$29dd17c7f3c81c36 = v; });
$parcel$export($768f69f3453e1a2d$exports, "roundVideoProgressBar", function () { return $768f69f3453e1a2d$export$9a127c71011fa931; }, function (v) { return $768f69f3453e1a2d$export$9a127c71011fa931 = v; });
$parcel$export($768f69f3453e1a2d$exports, "scale-up", function () { return $768f69f3453e1a2d$export$369cc45c1d328fdd; }, function (v) { return $768f69f3453e1a2d$export$369cc45c1d328fdd = v; });
$parcel$export($768f69f3453e1a2d$exports, "transformContent", function () { return $768f69f3453e1a2d$export$b7cb80c25ebba28e; }, function (v) { return $768f69f3453e1a2d$export$b7cb80c25ebba28e = v; });
$parcel$export($768f69f3453e1a2d$exports, "transformWrapper", function () { return $768f69f3453e1a2d$export$c3bda81a5133bfa4; }, function (v) { return $768f69f3453e1a2d$export$c3bda81a5133bfa4 = v; });
$parcel$export($768f69f3453e1a2d$exports, "videoContainer", function () { return $768f69f3453e1a2d$export$1dd3a692e0000769; }, function (v) { return $768f69f3453e1a2d$export$1dd3a692e0000769 = v; });
$parcel$export($768f69f3453e1a2d$exports, "videoDescription", function () { return $768f69f3453e1a2d$export$816b859ef000f8ec; }, function (v) { return $768f69f3453e1a2d$export$816b859ef000f8ec = v; });
$parcel$export($768f69f3453e1a2d$exports, "videoIframe", function () { return $768f69f3453e1a2d$export$4e866d6d2e0629f8; }, function (v) { return $768f69f3453e1a2d$export$4e866d6d2e0629f8 = v; });
$parcel$export($768f69f3453e1a2d$exports, "videoWrapper", function () { return $768f69f3453e1a2d$export$b82b8842228620ec; }, function (v) { return $768f69f3453e1a2d$export$b82b8842228620ec = v; });
var $768f69f3453e1a2d$export$fe6485e420d37282;
var $768f69f3453e1a2d$export$efe229eab43a9869;
var $768f69f3453e1a2d$export$3ea4c15e263a0c0f;
var $768f69f3453e1a2d$export$f02cbb504f26b596;
var $768f69f3453e1a2d$export$e8043fb4712c8bde;
var $768f69f3453e1a2d$export$63e82393dc8977bf;
var $768f69f3453e1a2d$export$1d1572c777d0d7ac;
var $768f69f3453e1a2d$export$65303a24f2d95a8e;
var $768f69f3453e1a2d$export$e91e3cc91e00b6bb;
var $768f69f3453e1a2d$export$add244bda2f9423c;
var $768f69f3453e1a2d$export$29dd17c7f3c81c36;
var $768f69f3453e1a2d$export$9a127c71011fa931;
var $768f69f3453e1a2d$export$369cc45c1d328fdd;
var $768f69f3453e1a2d$export$b7cb80c25ebba28e;
var $768f69f3453e1a2d$export$c3bda81a5133bfa4;
var $768f69f3453e1a2d$export$1dd3a692e0000769;
var $768f69f3453e1a2d$export$816b859ef000f8ec;
var $768f69f3453e1a2d$export$4e866d6d2e0629f8;
var $768f69f3453e1a2d$export$b82b8842228620ec;
$768f69f3453e1a2d$export$fe6485e420d37282 = `xM81vW_MediaViewer`;
$768f69f3453e1a2d$export$efe229eab43a9869 = `xM81vW_closeButton`;
$768f69f3453e1a2d$export$3ea4c15e263a0c0f = `xM81vW_completionText`;
$768f69f3453e1a2d$export$f02cbb504f26b596 = `xM81vW_externalLinkButton`;
$768f69f3453e1a2d$export$e8043fb4712c8bde = `xM81vW_externalLinkImage`;
$768f69f3453e1a2d$export$63e82393dc8977bf = `xM81vW_imageContainer`;
$768f69f3453e1a2d$export$1d1572c777d0d7ac = `xM81vW_imageDescription`;
$768f69f3453e1a2d$export$65303a24f2d95a8e = `xM81vW_imageViewerImage`;
$768f69f3453e1a2d$export$e91e3cc91e00b6bb = `xM81vW_mediaContainer`;
$768f69f3453e1a2d$export$add244bda2f9423c = `xM81vW_modalContent`;
$768f69f3453e1a2d$export$29dd17c7f3c81c36 = `xM81vW_overlay`;
$768f69f3453e1a2d$export$9a127c71011fa931 = `xM81vW_roundVideoProgressBar`;
$768f69f3453e1a2d$export$369cc45c1d328fdd = `xM81vW_scale-up`;
$768f69f3453e1a2d$export$369cc45c1d328fdd;
$768f69f3453e1a2d$export$b7cb80c25ebba28e = `xM81vW_transformContent`;
$768f69f3453e1a2d$export$c3bda81a5133bfa4 = `xM81vW_transformWrapper`;
$768f69f3453e1a2d$export$1dd3a692e0000769 = `xM81vW_videoContainer`;
$768f69f3453e1a2d$export$816b859ef000f8ec = `xM81vW_videoDescription`;
$768f69f3453e1a2d$export$4e866d6d2e0629f8 = `xM81vW_videoIframe`;
$768f69f3453e1a2d$export$b82b8842228620ec = `xM81vW_videoWrapper`;


// Conditionally import theme-specific styles (which include base styles via @import)
const $4a1cc8d5cfe2a1d8$var$styles = (()=>{
    return $768f69f3453e1a2d$exports;
})();
function $4a1cc8d5cfe2a1d8$export$2e2bcd8739ae039() {
    const dispatch = (0, $i2KZ1.useAppDispatch)();
    const currentlyViewingMedia = (0, $i2KZ1.useAppSelector)((state)=>state.app.currentlyViewingMedia);
    const modalRef = (0, $7RNO0.useRef)(null);
    const theme = (0, $7v5wN.useTheme)();
    const videoBorderImageUrl = theme.customJSON?.mediaViewer?.videoBorderImageUrl;
    (0, $7RNO0.useEffect)(()=>{
        if (currentlyViewingMedia?.resourceUrl) {
            (0, $kFQy0.sendEventV2)('media_viewed', [
                currentlyViewingMedia.resourceType,
                currentlyViewingMedia.resourceUrl
            ]);
            setTimeout(()=>{
                modalRef.current?.focus();
            }, 200);
        }
    }, [
        currentlyViewingMedia?.resourceUrl
    ]);
    if (!currentlyViewingMedia?.resourceUrl || !currentlyViewingMedia?.resourceType) return null;
    const ImageContainer = ()=>/*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
            className: $4a1cc8d5cfe2a1d8$var$styles.imageContainer,
            children: [
                /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9f57700f268362ee$export$51cb649375dcd655), {
                    limitToBounds: true,
                    centerOnInit: true,
                    doubleClick: {
                        mode: 'toggle'
                    },
                    centerZoomedOut: true,
                    pinch: {
                        step: 10
                    },
                    panning: {
                        velocityDisabled: true
                    },
                    children: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9f57700f268362ee$export$1def2aa75b7c7fe0), {
                        wrapperClass: $4a1cc8d5cfe2a1d8$var$styles.transformWrapper,
                        contentClass: $4a1cc8d5cfe2a1d8$var$styles.transformContent,
                        children: /*#__PURE__*/ (0, $9h2J6.jsx)("img", {
                            className: $4a1cc8d5cfe2a1d8$var$styles.imageViewerImage,
                            src: currentlyViewingMedia?.resourceUrl || '',
                            alt: currentlyViewingMedia?.description ?? ' '
                        })
                    })
                }),
                currentlyViewingMedia?.description && /*#__PURE__*/ (0, $9h2J6.jsx)("p", {
                    className: $4a1cc8d5cfe2a1d8$var$styles.imageDescription,
                    children: currentlyViewingMedia.description
                })
            ]
        });
    const VideoContainer = ()=>{
        if (!currentlyViewingMedia?.resourceUrl) {
            console.warn('Cannot display content - no resource URL');
            return 'Cannot display content';
        }
        // ---- AB TEST CODE -----
        const originalUrl = currentlyViewingMedia.resourceUrl;
        const videoStorageKeyOverride = (0, $bcc51232a27734fb$export$acf5185a61c48950)(originalUrl);
        const cloudflareVideoPercent = theme.customJSON?.cloudflareVideoPercent;
        const url = (0, $3c2a744f09fa5441$export$b51241a728638e8b)(currentlyViewingMedia.resourceUrl, cloudflareVideoPercent);
        // ---- END OF AB TEST CODE -----
        let playerType = null;
        let videoId = null;
        // Determine player type and extract video ID
        if (url.includes('youtube.com/watch') || url.includes('youtube.com/shorts/') || url.includes('youtu.be/')) {
            playerType = 'youtube';
            videoId = (0, $bcc51232a27734fb$export$acf5185a61c48950)(url);
        } else if (url.includes('cloudflarestream.com')) {
            playerType = 'cloudflare';
            videoId = (0, $08ea9d82851c667f$export$f3460e1f346f034d)(url);
        }
        if (!playerType || !videoId) {
            console.warn('Unrecognised video type or invalid video URL');
            return 'Cannot display content';
        }
        return /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
            className: $4a1cc8d5cfe2a1d8$var$styles.videoContainer,
            children: [
                /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                    className: $4a1cc8d5cfe2a1d8$var$styles.videoWrapper,
                    children: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $976118dde8fa9cff$export$f503bc85d719e8b0), {
                        videoUrl: url,
                        videoId: videoId,
                        videoStorageKeyOverride: videoStorageKeyOverride,
                        playerType: playerType,
                        className: $4a1cc8d5cfe2a1d8$var$styles.videoIframe,
                        roundProgressBarClassName: $4a1cc8d5cfe2a1d8$var$styles.roundVideoProgressBar,
                        completionTextClassName: $4a1cc8d5cfe2a1d8$var$styles.completionText,
                        hasCompletionText: currentlyViewingMedia.requiredForMissionComplete,
                        preCompletionText: "Complete the video to unlock reward",
                        postCompletionText: "Video completed",
                        enforcedViewing: currentlyViewingMedia.enforcedViewing,
                        onMilestone: (val, isFirstTimeMilestoneReached)=>{
                            if (currentlyViewingMedia.requiredForMissionComplete) {
                                // After 90% we will wait for 100 to complete quest
                                if (val <= 90 && isFirstTimeMilestoneReached) {
                                    if (0, $cTs7K.IS_DISCORD_ACTIVITY) // Only send each quest progress once ever as not critical and to avoid progress api spam
                                    (0, $1afSf.setQuestProgress)(val);
                                }
                            }
                        },
                        onComplete: ()=>{
                            (0, $0997c0146d436032$export$e8c0cceb0fbfc44c).current?.sendEvent('video-completed', currentlyViewingMedia);
                            if (currentlyViewingMedia.requiredForMissionComplete) {
                                dispatch((0, $6KpYp.setMissionComplete)());
                                if (0, $cTs7K.IS_DISCORD_ACTIVITY) {
                                    // Send quest complete regardless of isFirstWatch in case previous completion failed
                                    (0, $1afSf.setQuestCompleted)();
                                    dispatch((0, $gxeM7.setQuestStatus)('completed'));
                                }
                            }
                        }
                    })
                }),
                currentlyViewingMedia?.description && /*#__PURE__*/ (0, $9h2J6.jsx)("p", {
                    className: $4a1cc8d5cfe2a1d8$var$styles.videoDescription,
                    children: currentlyViewingMedia.description
                })
            ]
        });
    };
    const LinkContainer = ()=>{
        if (currentlyViewingMedia?.additionalImageUrl && currentlyViewingMedia?.resourceUrl && currentlyViewingMedia?.description) return /*#__PURE__*/ (0, $9h2J6.jsxs)((0, $9h2J6.Fragment), {
            children: [
                /*#__PURE__*/ (0, $9h2J6.jsx)("img", {
                    className: $4a1cc8d5cfe2a1d8$var$styles.externalLinkImage,
                    src: currentlyViewingMedia.additionalImageUrl,
                    alt: " "
                }),
                /*#__PURE__*/ (0, $9h2J6.jsx)((0, $bc232447c96f1a4a$export$29d11c0fe2fc51d8), {
                    className: $4a1cc8d5cfe2a1d8$var$styles.externalLinkButton,
                    href: currentlyViewingMedia.resourceUrl,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: currentlyViewingMedia.description
                })
            ]
        });
        console.warn('Cannot display externalLink');
        return 'Cannot display content';
    };
    const getMedia = ()=>{
        switch(currentlyViewingMedia?.resourceType){
            case 'image':
                return ImageContainer();
            case 'video':
                return VideoContainer();
            case 'externalLink':
                return LinkContainer();
            default:
                console.warn('Cannot display content, unrecognised type: ' + currentlyViewingMedia?.resourceType);
                return 'Cannot display content';
        }
    };
    const onClose = ()=>{
        if (currentlyViewingMedia?.resourceType && currentlyViewingMedia?.resourceUrl) (0, $kFQy0.sendEventV2)('media_closed', [
            currentlyViewingMedia.resourceType,
            currentlyViewingMedia.resourceUrl
        ]);
        dispatch((0, $9HMNu.setCurrentlyViewingMedia)(null));
    };
    return /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($4a1cc8d5cfe2a1d8$var$styles.MediaViewer, $4a1cc8d5cfe2a1d8$var$styles[currentlyViewingMedia?.resourceType]),
        children: [
            /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                className: $4a1cc8d5cfe2a1d8$var$styles.overlay
            }),
            /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                className: $4a1cc8d5cfe2a1d8$var$styles.modalContent,
                role: "dialog",
                "aria-label": "Media viewer",
                ref: modalRef,
                tabIndex: -1,
                children: [
                    /*#__PURE__*/ (0, $9h2J6.jsx)((0, $032b472fd8d5e329$export$2e2bcd8739ae039), {
                        iconType: "close",
                        onClick: onClose,
                        className: $4a1cc8d5cfe2a1d8$var$styles.closeButton,
                        buttonStyle: "round",
                        ariaLabel: "Close Image"
                    }),
                    /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                        className: $4a1cc8d5cfe2a1d8$var$styles.mediaContainer,
                        style: videoBorderImageUrl ? {
                            backgroundImage: `url('${videoBorderImageUrl}')`
                        } : undefined,
                        children: getMedia()
                    })
                ]
            })
        ]
    });
} /* 
Can be activated using arise events such as:
arise.postMessage("view-media", {"resourceUrl": "http://www.link.com", "resourceType": "externalLink", "description": "Click me for stuff", "additionalImageUrl": "www.image.com/image.png" });
arise.postMessage("view-media", {"resourceUrl": "https://cdn.ariseworlds.com/uploads/97cab966-aa05-4e90-8b0b-f1448c318de5/16x9.webp", "resourceType": "image", "description": "Something"});
arise.postMessage("view-media", {"resourceUrl": "https://www.youtube.com/watch?v=vlxi3CwQd4Q", "resourceType": "video", "description": "Something"});
arise.postMessage("view-media", {"resourceUrl": "https://customer-c6kmyujkvesrdmhe.cloudflarestream.com/8518455b5c04c692392f39562eaf8fa2/iframe", "resourceType": "video", "enforcedViewing": true});
*/ 



var $9h2J6 = parcelRequire("9h2J6");

var $7RNO0 = parcelRequire("7RNO0");

var $6dpjF = parcelRequire("6dpjF");

var $7v5wN = parcelRequire("7v5wN");
class $de7d72a2327bf2b6$export$42a112c78ab9c376 {
    begin(callback, delay) {
        this.clear();
        this.remaining = delay;
        this.callback = callback;
        this.resume();
    }
    pause() {
        if (this.timerId !== null) {
            clearTimeout(this.timerId);
            this.timerId = null;
            this.remaining -= Date.now() - this.start;
        }
    }
    resume() {
        if (this.timerId !== null || !this.callback || this.remaining <= 0) return;
        this.start = Date.now();
        this.timerId = window.setTimeout(()=>{
            try {
                this.callback?.();
            } catch (e) {
                console.error('PauseableTimeout callback error:', e);
            }
            this.timerId = null;
        }, this.remaining);
    }
    clear() {
        if (this.timerId !== null) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
        this.callback = null;
    }
    constructor(){
        this.timerId = null;
        this.start = 0;
        this.remaining = 0;
        this.callback = null;
    }
}



var $i2KZ1 = parcelRequire("i2KZ1");

var $3yrZE = parcelRequire("3yrZE");

var $9K8Jg = parcelRequire("9K8Jg");

var $guTIo = parcelRequire("guTIo");

var $9h2J6 = parcelRequire("9h2J6");

var $7RNO0 = parcelRequire("7RNO0");

var $6dpjF = parcelRequire("6dpjF");

var $9S5u4 = parcelRequire("9S5u4");
var $68c42f677683f406$exports = {};

$parcel$export($68c42f677683f406$exports, "NewsTickerItem", function () { return $68c42f677683f406$export$1bfd873cb97abd02; }, function (v) { return $68c42f677683f406$export$1bfd873cb97abd02 = v; });
$parcel$export($68c42f677683f406$exports, "achievement", function () { return $68c42f677683f406$export$f8c0c7d510456e0; }, function (v) { return $68c42f677683f406$export$f8c0c7d510456e0 = v; });
$parcel$export($68c42f677683f406$exports, "general", function () { return $68c42f677683f406$export$78b80bc2f5d4953a; }, function (v) { return $68c42f677683f406$export$78b80bc2f5d4953a = v; });
$parcel$export($68c42f677683f406$exports, "hasLowerTransparency", function () { return $68c42f677683f406$export$8cc8c8a9ccbfef4c; }, function (v) { return $68c42f677683f406$export$8cc8c8a9ccbfef4c = v; });
$parcel$export($68c42f677683f406$exports, "icon", function () { return $68c42f677683f406$export$1ca1ec8b29a4ce27; }, function (v) { return $68c42f677683f406$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($68c42f677683f406$exports, "message", function () { return $68c42f677683f406$export$a8ecead220dd38a6; }, function (v) { return $68c42f677683f406$export$a8ecead220dd38a6 = v; });
$parcel$export($68c42f677683f406$exports, "negative", function () { return $68c42f677683f406$export$5f47f64d03acd206; }, function (v) { return $68c42f677683f406$export$5f47f64d03acd206 = v; });
$parcel$export($68c42f677683f406$exports, "notification", function () { return $68c42f677683f406$export$2adf6238a2d0dafa; }, function (v) { return $68c42f677683f406$export$2adf6238a2d0dafa = v; });
$parcel$export($68c42f677683f406$exports, "positive", function () { return $68c42f677683f406$export$aa5128ab863cd04; }, function (v) { return $68c42f677683f406$export$aa5128ab863cd04 = v; });
var $68c42f677683f406$export$1bfd873cb97abd02;
var $68c42f677683f406$export$f8c0c7d510456e0;
var $68c42f677683f406$export$78b80bc2f5d4953a;
var $68c42f677683f406$export$8cc8c8a9ccbfef4c;
var $68c42f677683f406$export$1ca1ec8b29a4ce27;
var $68c42f677683f406$export$a8ecead220dd38a6;
var $68c42f677683f406$export$5f47f64d03acd206;
var $68c42f677683f406$export$2adf6238a2d0dafa;
var $68c42f677683f406$export$aa5128ab863cd04;
$68c42f677683f406$export$1bfd873cb97abd02 = `VaAOEq_NewsTickerItem`;
$68c42f677683f406$export$f8c0c7d510456e0 = `VaAOEq_achievement`;
$68c42f677683f406$export$78b80bc2f5d4953a = `VaAOEq_general`;
$68c42f677683f406$export$8cc8c8a9ccbfef4c = `VaAOEq_hasLowerTransparency`;
$68c42f677683f406$export$1ca1ec8b29a4ce27 = `VaAOEq_icon`;
$68c42f677683f406$export$a8ecead220dd38a6 = `VaAOEq_message`;
$68c42f677683f406$export$5f47f64d03acd206 = `VaAOEq_negative`;
$68c42f677683f406$export$2adf6238a2d0dafa = `VaAOEq_notification`;
$68c42f677683f406$export$aa5128ab863cd04 = `VaAOEq_positive`;


const $d049f31aa215ec0b$var$TRANSITION_DURATION_MS = 600;
const $d049f31aa215ec0b$var$NewsTickerItem = ({ status: status, message: message, hasLowerTransparency: hasLowerTransparency })=>{
    const currentMessage = (0, $7RNO0.useRef)(message);
    if (status === 'middle') // Only update text when item is off screen
    currentMessage.current = message;
    const transitionDuration = status === 'bottom' ? 0 : $d049f31aa215ec0b$var$TRANSITION_DURATION_MS;
    const statusToY = {
        bottom: '100%',
        middle: '0',
        top: '-100%'
    };
    return /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($68c42f677683f406$exports.NewsTickerItem, {
            [$68c42f677683f406$exports.hasLowerTransparency]: hasLowerTransparency
        }),
        style: {
            transform: `translateY(${statusToY[status]})`,
            transitionDuration: transitionDuration + 'ms'
        },
        children: currentMessage.current && /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($68c42f677683f406$exports.message, $68c42f677683f406$exports[currentMessage.current.type]),
            children: [
                /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                    className: $68c42f677683f406$exports.icon,
                    children: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9S5u4.default), {
                        type: currentMessage.current.icon,
                        size: 12
                    })
                }),
                /*#__PURE__*/ (0, $9h2J6.jsx)("p", {
                    children: $d049f31aa215ec0b$var$formatMessage(currentMessage.current.message, currentMessage.current.data)
                })
            ]
        })
    });
};
function $d049f31aa215ec0b$var$formatMessage(message, data) {
    if (!data) return /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9h2J6.Fragment), {
        children: message
    });
    // Example message: [person] did the thing. So did [others].
    const PLACEHOLDER_REGEX = /(\[.*?\])/g;
    const SQUARE_BRACKETS_REGEX = /\[|\]/g;
    // Split into parts
    const parts = message.split(PLACEHOLDER_REGEX).map((part, index)=>{
        // If part is a placeholder...
        if (part.match(PLACEHOLDER_REGEX)) {
            // Remove the square brackets
            const key = part.replace(SQUARE_BRACKETS_REGEX, '');
            // If found inside the data, replace the key with the data and put inside a span.
            return data.hasOwnProperty(key) ? /*#__PURE__*/ (0, $9h2J6.jsx)("span", {
                children: data[key]
            }, `${key}-${index}`) : key;
        }
        return part;
    });
    return /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9h2J6.Fragment), {
        children: parts
    });
}
var $d049f31aa215ec0b$export$2e2bcd8739ae039 = $d049f31aa215ec0b$var$NewsTickerItem;


var $d0f0098388dd5a4b$export$22ab3915f81c0ba8;
var $d0f0098388dd5a4b$export$8cc8c8a9ccbfef4c;
var $d0f0098388dd5a4b$export$73920f18ca706874;
$d0f0098388dd5a4b$export$22ab3915f81c0ba8 = `Sg01jW_NewsTicker`;
$d0f0098388dd5a4b$export$8cc8c8a9ccbfef4c = `Sg01jW_hasLowerTransparency`;
$d0f0098388dd5a4b$export$73920f18ca706874 = `Sg01jW_hidden`;


const $0cb4fda1aa815dee$var$REMOTE_DATA_POLL_FREQUENCY_MIN = 5; // Remote data poll frequency in MINUTES
const $0cb4fda1aa815dee$var$MIN_MESSAGE_VISIBILITY_MS = 2000; // Minimum amount of time a message must be visible for, in milliseconds
const $0cb4fda1aa815dee$var$MAX_MESSAGE_VISIBILITY_MS = 10000; // Maximum amount of time a message must be visible for, in milliseconds
const $0cb4fda1aa815dee$var$NewsTickerContainer = ()=>{
    const theme = (0, $7v5wN.useTheme)();
    const dispatch = (0, $i2KZ1.useAppDispatch)();
    const newsTickerQueue = (0, $i2KZ1.useAppSelector)((state)=>state.feed.newsTickerQueue);
    const newsTickerTag = (0, $i2KZ1.useAppSelector)((state)=>state.feed.newsTickerTag);
    const isNewsTickerVisible = (0, $i2KZ1.useAppSelector)((state)=>state.app.isNewsTickerVisible);
    const customJsonData = theme.metadata?.customJSON?.newsTicker;
    const [messageToShow, setMessageToShow] = (0, $7RNO0.useState)();
    const remoteData = (0, $7RNO0.useRef)();
    const highPriorityMessages = (0, $7RNO0.useRef)([]);
    const filteredGenericEvents = (0, $7RNO0.useRef)([]);
    const genericEventsCurrentIndex = (0, $7RNO0.useRef)(0);
    const currentNewsTickerTag = (0, $7RNO0.useRef)('');
    const canShowMessage = (0, $7RNO0.useRef)(true); // e.g if MIN_MESSAGE_VISIBILITY_MS has elapsed
    const maxTimeout = (0, $7RNO0.useRef)(new (0, $de7d72a2327bf2b6$export$42a112c78ab9c376)());
    const minTimeout = (0, $7RNO0.useRef)(new (0, $de7d72a2327bf2b6$export$42a112c78ab9c376)());
    async function getRemoteData() {
        try {
            const response = await (0, $9K8Jg.getNewsTickerData)();
            const isValid = Array.isArray(response.genericEvents) && response.genericEvents?.length > 0 && response.hasOwnProperty('userSpecificEvents');
            if (!isValid) throw new Error('Data is invalid');
            remoteData.current = response;
            updateFilteredGenericEvents();
        } catch (error) {
            console.warn('Could not get news ticker data', error);
        }
    }
    function isFullNewsTickerItemData(item) {
        return 'type' in item;
    }
    function itemMatchesTag(item) {
        if (!currentNewsTickerTag?.current) return true;
        if (isFullNewsTickerItemData(item)) return !Array.isArray(item.tags) || item.tags.length === 0 || item.tags.includes(currentNewsTickerTag.current);
        return false;
    }
    function updateFilteredGenericEvents() {
        // Ensure only items which match current tag are shown
        const allGenericEvents = remoteData?.current?.genericEvents;
        if (allGenericEvents?.length) filteredGenericEvents.current = allGenericEvents.filter(itemMatchesTag);
        else filteredGenericEvents.current = [];
        genericEventsCurrentIndex.current = 0;
        // Show first low-priority message if nothing is showing and allowed
        if (!!customJsonData?.showImmediately && canShowMessage.current && !messageToShow) showLowPriorityMessage();
    }
    function addHighPriorityMessage(item) {
        if (isFullNewsTickerItemData(item)) highPriorityMessages.current?.push(item);
        else if ('id' in item) {
            // Find the message ID in the remote data and add it to the queue
            const message = remoteData.current?.userSpecificEvents?.[item.id];
            if (message) highPriorityMessages.current?.push(message);
        }
        showHighPriorityMessage();
    }
    (0, $7RNO0.useEffect)(()=>{
        // Whenever a message changes, time X seconds before showing a generic message
        if (messageToShow) maxTimeout.current?.begin(()=>{
            showLowPriorityMessage();
        }, $0cb4fda1aa815dee$var$MAX_MESSAGE_VISIBILITY_MS);
        return ()=>{
            maxTimeout.current?.clear();
        };
    }, [
        messageToShow
    ]);
    (0, $7RNO0.useEffect)(()=>{
        isNewsTickerVisible ? maxTimeout.current?.resume() : maxTimeout.current?.pause();
        isNewsTickerVisible ? minTimeout.current?.resume() : minTimeout.current?.pause();
        // If newsTicker becomes visible, but has no messages, start showing generic messages
        if (isNewsTickerVisible && canShowMessage.current && !messageToShow) showLowPriorityMessage();
    }, [
        isNewsTickerVisible
    ]);
    function showHighPriorityMessage() {
        // Remove message from start of queue and show it
        if (canShowMessage.current && highPriorityMessages.current[0]) {
            const message = highPriorityMessages.current?.shift();
            const translatedMessage = (0, $guTIo.getTranslatedNewsTickerItem)(message, 'personal');
            showMessage(translatedMessage);
        }
    }
    function showLowPriorityMessage() {
        // Get next message from generic array and show it
        if (filteredGenericEvents.current?.length) {
            // If index is too high, set back to 0
            if (genericEventsCurrentIndex.current >= filteredGenericEvents.current.length) genericEventsCurrentIndex.current = 0;
            const message = filteredGenericEvents.current[genericEventsCurrentIndex.current];
            const translatedMessage = (0, $guTIo.getTranslatedNewsTickerItem)(message, 'recent');
            showMessage(translatedMessage);
            genericEventsCurrentIndex.current++;
        }
    }
    function showMessage(message) {
        if (message && canShowMessage.current) {
            setMessageToShow(message);
            canShowMessage.current = false;
            // Stop new messages from showing for X seconds
            minTimeout.current?.begin(()=>{
                canShowMessage.current = true;
                showHighPriorityMessage();
            }, $0cb4fda1aa815dee$var$MIN_MESSAGE_VISIBILITY_MS);
        }
    }
    (0, $7RNO0.useEffect)(()=>{
        // When a news ticker message is added to state via the bridge...
        // Add it to the local array and remove it from the state.
        const newItem = newsTickerQueue[0];
        if (newItem) {
            addHighPriorityMessage(newItem);
            dispatch((0, $3yrZE.removeFirstNewsTickerItemFromQueue)());
        }
    }, [
        newsTickerQueue
    ]);
    (0, $7RNO0.useEffect)(()=>{
        currentNewsTickerTag.current = newsTickerTag;
        updateFilteredGenericEvents();
    }, [
        newsTickerTag
    ]);
    (0, $7RNO0.useEffect)(()=>{
        getRemoteData();
        // Get fresh remote data every n minutes
        const pollInterval = setInterval(getRemoteData, $0cb4fda1aa815dee$var$REMOTE_DATA_POLL_FREQUENCY_MIN * 60000);
        return ()=>{
            clearInterval(pollInterval);
        };
    }, []);
    return /*#__PURE__*/ (0, $9h2J6.jsx)($0cb4fda1aa815dee$var$NewsTicker, {
        messageToShow: messageToShow,
        isVisible: isNewsTickerVisible,
        hasLowerTransparency: customJsonData?.lowerTransparency
    });
};
// Dumb component only controlled via its own props
const $0cb4fda1aa815dee$var$NewsTicker = ({ messageToShow: messageToShow, isVisible: isVisible, hasLowerTransparency: hasLowerTransparency })=>{
    const [itemAState, setItemAState] = (0, $7RNO0.useState)('bottom');
    const [itemBState, setItemBState] = (0, $7RNO0.useState)('top');
    const [itemCState, setItemCState] = (0, $7RNO0.useState)('middle');
    const [itemAMessage, setItemAMessage] = (0, $7RNO0.useState)();
    const [itemBMessage, setItemBMessage] = (0, $7RNO0.useState)();
    const [itemCMessage, setItemCMessage] = (0, $7RNO0.useState)();
    const numberOfMessagesSeen = (0, $7RNO0.useRef)(0);
    (0, $7RNO0.useEffect)(()=>{
        if (messageToShow) showMessage(messageToShow);
    }, [
        messageToShow
    ]);
    function getNextState(currentState) {
        if (currentState === 'top') return 'bottom';
        if (currentState === 'middle') return 'top';
        if (currentState === 'bottom') return 'middle';
    }
    function animateTicker() {
        setItemAState((prev)=>getNextState(prev));
        setItemBState((prev)=>getNextState(prev));
        setItemCState((prev)=>getNextState(prev));
        numberOfMessagesSeen.current++;
    }
    function setBottomMessage(message) {
        const options = [
            setItemAMessage,
            setItemBMessage,
            setItemCMessage
        ];
        const functionToUse = options[numberOfMessagesSeen.current % 3];
        functionToUse(message);
    }
    function showMessage(message) {
        setBottomMessage(message);
        animateTicker();
    }
    return /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($d0f0098388dd5a4b$export$22ab3915f81c0ba8, {
            [$d0f0098388dd5a4b$export$73920f18ca706874]: !isVisible,
            [$d0f0098388dd5a4b$export$8cc8c8a9ccbfef4c]: hasLowerTransparency
        }),
        "aria-hidden": !isVisible,
        inert: !isVisible ? '' : undefined,
        children: /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $9h2J6.jsx)((0, $d049f31aa215ec0b$export$2e2bcd8739ae039), {
                    status: itemAState,
                    message: itemAMessage,
                    hasLowerTransparency: hasLowerTransparency
                }),
                /*#__PURE__*/ (0, $9h2J6.jsx)((0, $d049f31aa215ec0b$export$2e2bcd8739ae039), {
                    status: itemBState,
                    message: itemBMessage,
                    hasLowerTransparency: hasLowerTransparency
                }),
                /*#__PURE__*/ (0, $9h2J6.jsx)((0, $d049f31aa215ec0b$export$2e2bcd8739ae039), {
                    status: itemCState,
                    message: itemCMessage,
                    hasLowerTransparency: hasLowerTransparency
                })
            ]
        })
    });
};
var $0cb4fda1aa815dee$export$2e2bcd8739ae039 = $0cb4fda1aa815dee$var$NewsTickerContainer;



var $9h2J6 = parcelRequire("9h2J6");

var $7RNO0 = parcelRequire("7RNO0");

var $6dpjF = parcelRequire("6dpjF");

var $kFQy0 = parcelRequire("kFQy0");

var $lmedS = parcelRequire("lmedS");

var $i2KZ1 = parcelRequire("i2KZ1");


var $7v5wN = parcelRequire("7v5wN");

var $9HMNu = parcelRequire("9HMNu");

var $e8e17700ef3472ca$export$9e75746c9c02d3b5;
var $e8e17700ef3472ca$export$efe229eab43a9869;
var $e8e17700ef3472ca$export$8f981dffec84ba52;
var $e8e17700ef3472ca$export$ea0830439c7fc698;
var $e8e17700ef3472ca$export$fad3c8302a7540c6;
$e8e17700ef3472ca$export$9e75746c9c02d3b5 = `M5xZwa_InformationDrawer`;
$e8e17700ef3472ca$export$efe229eab43a9869 = `M5xZwa_closeButton`;
$e8e17700ef3472ca$export$8f981dffec84ba52 = `M5xZwa_contentContainer`;
$e8e17700ef3472ca$export$ea0830439c7fc698 = `M5xZwa_isOpen`;
$e8e17700ef3472ca$export$fad3c8302a7540c6 = `M5xZwa_scrollContainer`;



// Import custom content per instance if needed, otherwise use generic
const $be701869f927ca1b$var$InfoDrawerContent = /*#__PURE__*/ (0, $7RNO0.lazy)(()=>{
    return (parcelRequire("2YFnD"));
});
function $be701869f927ca1b$export$2e2bcd8739ae039() {
    const dispatch = (0, $i2KZ1.useAppDispatch)();
    const { audio: audio } = (0, $f58c71b201a1c7d8$export$91047320af7bf70b)();
    const theme = (0, $7v5wN.useTheme)();
    const isInformationOpen = (0, $i2KZ1.useAppSelector)((state)=>state.app.isInformationOpen);
    const drawerRef = (0, $7RNO0.useRef)(null);
    const drawerData = theme.metadata?.customJSON?.informationDrawer;
    (0, $7RNO0.useEffect)(()=>{
        if (isInformationOpen) {
            audio?.play('gust-open');
            (0, $kFQy0.sendEventV2)('information_drawer_viewed');
        }
    }, [
        isInformationOpen
    ]);
    // Move focus to drawer when opened
    function onTransitionEnd(e) {
        if (isInformationOpen && e.target === e.currentTarget) setTimeout(()=>{
            drawerRef.current?.focus();
        }, 200);
    }
    if (!drawerData?.enabled) return null;
    return /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
        role: "dialog",
        "aria-label": "Information",
        ref: drawerRef,
        tabIndex: -1,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($e8e17700ef3472ca$export$9e75746c9c02d3b5, {
            [$e8e17700ef3472ca$export$ea0830439c7fc698]: isInformationOpen
        }),
        inert: !isInformationOpen ? '' : undefined,
        onTransitionEnd: onTransitionEnd,
        children: /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
            className: $e8e17700ef3472ca$export$fad3c8302a7540c6,
            style: {
                backgroundImage: `url("${(0, $lmedS.pathToURL)(drawerData?.topBackgroundImage?.imagePath)}")`
            },
            children: [
                /*#__PURE__*/ (0, $9h2J6.jsx)((0, $032b472fd8d5e329$export$2e2bcd8739ae039), {
                    iconType: "close",
                    buttonStyle: "round",
                    ariaLabel: "Close Information",
                    className: $e8e17700ef3472ca$export$efe229eab43a9869,
                    onClick: ()=>{
                        audio?.play('gust-close');
                        dispatch((0, $9HMNu.setIsInformationOpen)(false));
                    }
                }),
                /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                    className: $e8e17700ef3472ca$export$8f981dffec84ba52,
                    children: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $7RNO0.Suspense), {
                        fallback: /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                            children: "Loading"
                        }),
                        children: /*#__PURE__*/ (0, $9h2J6.jsx)($be701869f927ca1b$var$InfoDrawerContent, {})
                    })
                })
            ]
        })
    });
}



var $9h2J6 = parcelRequire("9h2J6");

var $7RNO0 = parcelRequire("7RNO0");

var $6dpjF = parcelRequire("6dpjF");

var $9K8Jg = parcelRequire("9K8Jg");

var $kFQy0 = parcelRequire("kFQy0");

var $lmedS = parcelRequire("lmedS");

var $i2KZ1 = parcelRequire("i2KZ1");


var $9HMNu = parcelRequire("9HMNu");



var $9h2J6 = parcelRequire("9h2J6");

var $6dpjF = parcelRequire("6dpjF");

var $9h2J6 = parcelRequire("9h2J6");

var $6dpjF = parcelRequire("6dpjF");

var $9S5u4 = parcelRequire("9S5u4");
var $36dae6bb23f98ad6$exports = {};

$parcel$export($36dae6bb23f98ad6$exports, "CardDescription", function () { return $36dae6bb23f98ad6$export$16e0ed4cb97c00d4; }, function (v) { return $36dae6bb23f98ad6$export$16e0ed4cb97c00d4 = v; });
$parcel$export($36dae6bb23f98ad6$exports, "common", function () { return $36dae6bb23f98ad6$export$919daad019702595; }, function (v) { return $36dae6bb23f98ad6$export$919daad019702595 = v; });
$parcel$export($36dae6bb23f98ad6$exports, "epic", function () { return $36dae6bb23f98ad6$export$8ec5145af6f76965; }, function (v) { return $36dae6bb23f98ad6$export$8ec5145af6f76965 = v; });
$parcel$export($36dae6bb23f98ad6$exports, "icon", function () { return $36dae6bb23f98ad6$export$1ca1ec8b29a4ce27; }, function (v) { return $36dae6bb23f98ad6$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($36dae6bb23f98ad6$exports, "isButton", function () { return $36dae6bb23f98ad6$export$35a0171ee384c875; }, function (v) { return $36dae6bb23f98ad6$export$35a0171ee384c875 = v; });
$parcel$export($36dae6bb23f98ad6$exports, "legendary", function () { return $36dae6bb23f98ad6$export$9738149b23403ba; }, function (v) { return $36dae6bb23f98ad6$export$9738149b23403ba = v; });
$parcel$export($36dae6bb23f98ad6$exports, "longTitle", function () { return $36dae6bb23f98ad6$export$578fcbc4821dcd12; }, function (v) { return $36dae6bb23f98ad6$export$578fcbc4821dcd12 = v; });
$parcel$export($36dae6bb23f98ad6$exports, "rare", function () { return $36dae6bb23f98ad6$export$b2e68d2f08b863d2; }, function (v) { return $36dae6bb23f98ad6$export$b2e68d2f08b863d2 = v; });
$parcel$export($36dae6bb23f98ad6$exports, "subtitle", function () { return $36dae6bb23f98ad6$export$c96745152eb2740f; }, function (v) { return $36dae6bb23f98ad6$export$c96745152eb2740f = v; });
$parcel$export($36dae6bb23f98ad6$exports, "title", function () { return $36dae6bb23f98ad6$export$fb184b623420d9be; }, function (v) { return $36dae6bb23f98ad6$export$fb184b623420d9be = v; });
$parcel$export($36dae6bb23f98ad6$exports, "uncommon", function () { return $36dae6bb23f98ad6$export$76bf72d8613283e6; }, function (v) { return $36dae6bb23f98ad6$export$76bf72d8613283e6 = v; });
var $36dae6bb23f98ad6$export$16e0ed4cb97c00d4;
var $36dae6bb23f98ad6$export$919daad019702595;
var $36dae6bb23f98ad6$export$8ec5145af6f76965;
var $36dae6bb23f98ad6$export$1ca1ec8b29a4ce27;
var $36dae6bb23f98ad6$export$35a0171ee384c875;
var $36dae6bb23f98ad6$export$9738149b23403ba;
var $36dae6bb23f98ad6$export$578fcbc4821dcd12;
var $36dae6bb23f98ad6$export$b2e68d2f08b863d2;
var $36dae6bb23f98ad6$export$c96745152eb2740f;
var $36dae6bb23f98ad6$export$fb184b623420d9be;
var $36dae6bb23f98ad6$export$76bf72d8613283e6;
$36dae6bb23f98ad6$export$16e0ed4cb97c00d4 = `PPJVKG_CardDescription`;
$36dae6bb23f98ad6$export$919daad019702595 = `PPJVKG_common`;
$36dae6bb23f98ad6$export$8ec5145af6f76965 = `PPJVKG_epic`;
$36dae6bb23f98ad6$export$1ca1ec8b29a4ce27 = `PPJVKG_icon`;
$36dae6bb23f98ad6$export$35a0171ee384c875 = `PPJVKG_isButton`;
$36dae6bb23f98ad6$export$9738149b23403ba = `PPJVKG_legendary`;
$36dae6bb23f98ad6$export$578fcbc4821dcd12 = `PPJVKG_longTitle`;
$36dae6bb23f98ad6$export$b2e68d2f08b863d2 = `PPJVKG_rare`;
$36dae6bb23f98ad6$export$c96745152eb2740f = `PPJVKG_subtitle`;
$36dae6bb23f98ad6$export$fb184b623420d9be = `PPJVKG_title`;
$36dae6bb23f98ad6$export$76bf72d8613283e6 = `PPJVKG_uncommon`;


function $6037b609b9a0daed$export$2e2bcd8739ae039({ title: title, classname: classname, onClick: onClick, subtitle: subtitle, backgroundImage: backgroundImage, maskImage: maskImage, rarity: rarity, isSelected: isSelected, iconType: iconType, keepFontSize: keepFontSize }) {
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($36dae6bb23f98ad6$exports.CardDescription, classname, $36dae6bb23f98ad6$exports[rarity?.toLowerCase()], {
        [$36dae6bb23f98ad6$exports.isButton]: onClick
    });
    const style = {
        ...backgroundImage && {
            backgroundImage: `url("${backgroundImage}")`
        },
        ...maskImage && {
            maskImage: `url("${maskImage}")`
        }
    };
    const content = /*#__PURE__*/ (0, $9h2J6.jsxs)((0, $9h2J6.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9h2J6.jsx)("p", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($36dae6bb23f98ad6$exports.title, {
                    [$36dae6bb23f98ad6$exports.longTitle]: !keepFontSize && title?.length > 50
                }),
                children: title
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)("p", {
                className: $36dae6bb23f98ad6$exports.subtitle,
                children: subtitle
            }),
            iconType && /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9S5u4.default), {
                type: iconType,
                className: $36dae6bb23f98ad6$exports.icon
            })
        ]
    });
    if (onClick) return /*#__PURE__*/ (0, $9h2J6.jsx)("button", {
        onClick: onClick,
        className: classes,
        style: style,
        "aria-selected": isSelected,
        children: content
    });
    return /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
        className: classes,
        style: style,
        children: content
    });
}



var $9S5u4 = parcelRequire("9S5u4");
var $22fe875cfbb969b8$export$ed8671f612970784;
var $22fe875cfbb969b8$export$2d5d4e432b5a59e5;
var $22fe875cfbb969b8$export$7a501f3c3d80f448;
var $22fe875cfbb969b8$export$34ee7a0d3aa0c144;
var $22fe875cfbb969b8$export$e3df13a29829f609;
var $22fe875cfbb969b8$export$ea030c803b7ffdb8;
var $22fe875cfbb969b8$export$41e6a90a9191b826;
var $22fe875cfbb969b8$export$25ee1e0b9880f13c;
var $22fe875cfbb969b8$export$9d7ea1576ea93111;
var $22fe875cfbb969b8$export$a8ed354941b4b3a1;
var $22fe875cfbb969b8$export$c80d57c51a11eb0a;
var $22fe875cfbb969b8$export$1c220dee9e4dbe34;
$22fe875cfbb969b8$export$ed8671f612970784 = `MaULVa_ItemContainer`;
$22fe875cfbb969b8$export$2d5d4e432b5a59e5 = `MaULVa_ItemContainer__BackgroundContainer`;
$22fe875cfbb969b8$export$7a501f3c3d80f448 = `MaULVa_ItemContainer__BackgroundIcon`;
$22fe875cfbb969b8$export$34ee7a0d3aa0c144 = `MaULVa_ItemContainer__Border`;
$22fe875cfbb969b8$export$e3df13a29829f609 = `MaULVa_ItemContainer__Button`;
$22fe875cfbb969b8$export$ea030c803b7ffdb8 = `MaULVa_ItemContainer__Button--interactable`;
$22fe875cfbb969b8$export$41e6a90a9191b826 = `MaULVa_ItemContainer__Description`;
$22fe875cfbb969b8$export$25ee1e0b9880f13c = `MaULVa_ItemContainer__HighlightImage`;
$22fe875cfbb969b8$export$9d7ea1576ea93111 = `MaULVa_ItemContainer__Image`;
$22fe875cfbb969b8$export$a8ed354941b4b3a1 = `MaULVa_ItemContainer__ImageArea`;
$22fe875cfbb969b8$export$c80d57c51a11eb0a = `MaULVa_noBackgroundImage`;
$22fe875cfbb969b8$export$1c220dee9e4dbe34 = `MaULVa_slide-in`;


function $25e8ba98c5e2d290$export$2e2bcd8739ae039({ classname: classname, imagePath: imagePath, backgroundImagePath: backgroundImagePath, textBackgroundImagePath: textBackgroundImagePath, highlightImagePath: highlightImagePath, title: title, subtitle: subtitle, isSelected: isSelected, onSelected: onSelected, imageAlt: imageAlt, interactable: interactable, hasBorder: hasBorder = true, backgroundIconType: backgroundIconType, hideDescription: hideDescription }) {
    const highlightImageStyle = highlightImagePath ? {
        backgroundImage: `url(${highlightImagePath})`
    } : {};
    return /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($22fe875cfbb969b8$export$ed8671f612970784, classname),
        children: [
            /*#__PURE__*/ (0, $9h2J6.jsxs)("button", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($22fe875cfbb969b8$export$e3df13a29829f609, {
                    [$22fe875cfbb969b8$export$ea030c803b7ffdb8]: interactable
                }),
                onClick: ()=>onSelected && onSelected(),
                disabled: !interactable,
                "aria-selected": isSelected,
                children: [
                    /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                        className: $22fe875cfbb969b8$export$a8ed354941b4b3a1,
                        children: [
                            /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($22fe875cfbb969b8$export$2d5d4e432b5a59e5, {
                                    [$22fe875cfbb969b8$export$c80d57c51a11eb0a]: !backgroundImagePath
                                }),
                                style: backgroundImagePath ? {
                                    backgroundImage: `url("${backgroundImagePath}")`
                                } : {},
                                children: backgroundIconType && /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9S5u4.default), {
                                    className: $22fe875cfbb969b8$export$7a501f3c3d80f448,
                                    type: backgroundIconType
                                })
                            }),
                            hasBorder && /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                                className: $22fe875cfbb969b8$export$34ee7a0d3aa0c144
                            }),
                            /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                                className: $22fe875cfbb969b8$export$9d7ea1576ea93111,
                                style: imagePath ? {
                                    backgroundImage: `url(${imagePath})`
                                } : {},
                                role: "img",
                                "aria-label": imageAlt
                            })
                        ]
                    }),
                    !hideDescription && /*#__PURE__*/ (0, $9h2J6.jsx)((0, $6037b609b9a0daed$export$2e2bcd8739ae039), {
                        classname: $22fe875cfbb969b8$export$41e6a90a9191b826,
                        title: title,
                        subtitle: subtitle,
                        backgroundImage: textBackgroundImagePath
                    })
                ]
            }),
            highlightImagePath && /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                className: $22fe875cfbb969b8$export$25ee1e0b9880f13c,
                style: highlightImageStyle
            })
        ]
    });
}


var $e936bcce7368245c$export$a3023fff5111d5eb;
var $e936bcce7368245c$export$efe229eab43a9869;
var $e936bcce7368245c$export$a7db06668cad9adb;
var $e936bcce7368245c$export$da10a04ece02fcdc;
var $e936bcce7368245c$export$ea0830439c7fc698;
var $e936bcce7368245c$export$fad3c8302a7540c6;
var $e936bcce7368245c$export$fb184b623420d9be;
var $e936bcce7368245c$export$ac052f74bbc68e2d;
$e936bcce7368245c$export$a3023fff5111d5eb = `PrMA-W_MyRewardsDrawer`;
$e936bcce7368245c$export$efe229eab43a9869 = `PrMA-W_closeButton`;
$e936bcce7368245c$export$a7db06668cad9adb = `PrMA-W_content`;
$e936bcce7368245c$export$da10a04ece02fcdc = `PrMA-W_emptyText`;
$e936bcce7368245c$export$ea0830439c7fc698 = `PrMA-W_isOpen`;
$e936bcce7368245c$export$fad3c8302a7540c6 = `PrMA-W_scrollContainer`;
$e936bcce7368245c$export$fb184b623420d9be = `PrMA-W_title`;
$e936bcce7368245c$export$ac052f74bbc68e2d = `PrMA-W_topBar`;


function $794ba98c605414a9$export$2e2bcd8739ae039() {
    const dispatch = (0, $i2KZ1.useAppDispatch)();
    const { audio: audio } = (0, $f58c71b201a1c7d8$export$91047320af7bf70b)();
    const isMyRewardsOpen = (0, $i2KZ1.useAppSelector)((state)=>state.app.isMyRewardsOpen);
    const [rewardItems, setRewardItems] = (0, $7RNO0.useState)([]);
    const [rewardItemsAreLoading, setRewardItemsAreLoading] = (0, $7RNO0.useState)(true);
    const closeButtonRef = (0, $7RNO0.useRef)(null);
    const loadRewards = ()=>{
        (0, $9K8Jg.getMyRewards)().then((items)=>{
            if (Array.isArray(items)) setRewardItems(items);
            else console.error('Error loading rewards');
            setRewardItemsAreLoading(false);
        }).catch(()=>{
            setRewardItemsAreLoading(false);
            console.log('Error loading rewards');
        });
    };
    (0, $7RNO0.useEffect)(()=>{
        if (isMyRewardsOpen) {
            audio?.play('gust-open');
            // Reload data when opened
            setRewardItemsAreLoading(true);
            loadRewards();
            (0, $kFQy0.sendEventV2)('reward_drawer_viewed');
        }
    }, [
        isMyRewardsOpen
    ]);
    // Move focus to drawer when opened
    function onTransitionEnd(e) {
        if (isMyRewardsOpen && e.target === e.currentTarget) setTimeout(()=>{
            closeButtonRef.current?.focus();
        }, 200);
    }
    return /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($e936bcce7368245c$export$a3023fff5111d5eb, {
            [$e936bcce7368245c$export$ea0830439c7fc698]: isMyRewardsOpen
        }),
        inert: !isMyRewardsOpen ? '' : undefined,
        onTransitionEnd: onTransitionEnd,
        children: /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
            className: $e936bcce7368245c$export$fad3c8302a7540c6,
            children: [
                /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                    className: $e936bcce7368245c$export$ac052f74bbc68e2d,
                    children: [
                        /*#__PURE__*/ (0, $9h2J6.jsx)("h2", {
                            className: $e936bcce7368245c$export$fb184b623420d9be,
                            children: "Your Rewards!"
                        }),
                        /*#__PURE__*/ (0, $9h2J6.jsx)((0, $032b472fd8d5e329$export$2e2bcd8739ae039), {
                            buttonRef: closeButtonRef,
                            iconType: "close",
                            buttonStyle: "round",
                            ariaLabel: "Close My Rewards",
                            className: $e936bcce7368245c$export$efe229eab43a9869,
                            onClick: ()=>{
                                audio?.play('gust-close');
                                dispatch((0, $9HMNu.setIsMyRewardsOpen)(false));
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                    className: $e936bcce7368245c$export$a7db06668cad9adb,
                    children: [
                        rewardItems.length === 0 && !rewardItemsAreLoading && /*#__PURE__*/ (0, $9h2J6.jsx)("p", {
                            className: $e936bcce7368245c$export$da10a04ece02fcdc,
                            children: "No rewards earned yet"
                        }),
                        /*#__PURE__*/ (0, $9h2J6.jsx)("ul", {
                            children: rewardItems.map((item, index)=>{
                                return /*#__PURE__*/ (0, $9h2J6.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $25e8ba98c5e2d290$export$2e2bcd8739ae039), {
                                        title: item.name,
                                        imagePath: (0, $lmedS.pathToURL)(item.mainImagePath),
                                        backgroundImagePath: '',
                                        textBackgroundImagePath: '',
                                        imageAlt: item.description,
                                        interactable: true,
                                        onSelected: ()=>dispatch((0, $9HMNu.setCurrentlyViewingReward)(item))
                                    })
                                }, `my-reward-${index}`);
                            })
                        }),
                        /*#__PURE__*/ (0, $9h2J6.jsx)((0, $712b328b756bc954$export$2e2bcd8739ae039), {
                            hasBackground: false,
                            show: rewardItems.length === 0 && rewardItemsAreLoading
                        })
                    ]
                })
            ]
        })
    });
}



var $9h2J6 = parcelRequire("9h2J6");


var $2QyQO = parcelRequire("2QyQO");

var $9HMNu = parcelRequire("9HMNu");

var $i2KZ1 = parcelRequire("i2KZ1");



var $9h2J6 = parcelRequire("9h2J6");

var $6dpjF = parcelRequire("6dpjF");

var $7v5wN = parcelRequire("7v5wN");
var $05a724c90ef54e84$export$f67fb575035cc7d0;
$05a724c90ef54e84$export$f67fb575035cc7d0 = `WYBeTW_ThemedButton`;


function $9dd61ca7c286f0ea$export$2e2bcd8739ae039({ text: text, onClick: onClick, disabled: disabled, className: className }) {
    const theme = (0, $7v5wN.useTheme)();
    const maskImage = theme.customJSON.themedButtonBackgroundMaskImage;
    return /*#__PURE__*/ (0, $9h2J6.jsx)("button", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($05a724c90ef54e84$export$f67fb575035cc7d0, className),
        onClick: onClick,
        style: maskImage ? {
            maskImage: `url(${maskImage})`
        } : {},
        disabled: disabled,
        children: /*#__PURE__*/ (0, $9h2J6.jsx)("span", {
            children: text
        })
    });
}
function $9dd61ca7c286f0ea$export$b0b5aeed52623827({ text: text, href: href, className: className, onClick: onClick }) {
    const theme = (0, $7v5wN.useTheme)();
    const maskImage = theme.customJSON.themedButtonBackgroundMaskImage;
    return /*#__PURE__*/ (0, $9h2J6.jsx)("a", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($05a724c90ef54e84$export$f67fb575035cc7d0, className),
        href: href,
        style: maskImage ? {
            maskImage: `url(${maskImage})`
        } : {},
        onClick: onClick ? onClick : null,
        children: /*#__PURE__*/ (0, $9h2J6.jsx)("span", {
            children: text
        })
    });
}


function $a1818482afeb7963$export$2e2bcd8739ae039() {
    const { audio: audio } = (0, $f58c71b201a1c7d8$export$91047320af7bf70b)();
    const dispatch = (0, $i2KZ1.useAppDispatch)();
    const navigate = (0, $0e3dfb59695be15b$export$9770f232ac06a008)();
    const isExitLocationModalOpen = (0, $i2KZ1.useAppSelector)((state)=>state.app.isExitLocationModalOpen);
    return /*#__PURE__*/ (0, $9h2J6.jsx)((0, $5aad52fabd29c6cf$export$2e2bcd8739ae039), {
        title: "Head back?",
        onClose: ()=>{
            dispatch((0, $9HMNu.setIsExitLocationModalOpen)(false));
        },
        isVisible: isExitLocationModalOpen,
        children: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9dd61ca7c286f0ea$export$2e2bcd8739ae039), {
            text: (0, $2QyQO.exitModalText),
            onClick: ()=>{
                dispatch((0, $9HMNu.setIsExitLocationModalOpen)(false));
                dispatch((0, $9HMNu.setShouldShowGuestSignUpModal)(true));
                navigate((0, $2QyQO.homePath));
            },
            disabled: !isExitLocationModalOpen
        })
    });
}



var $9h2J6 = parcelRequire("9h2J6");

var $9HMNu = parcelRequire("9HMNu");

var $i2KZ1 = parcelRequire("i2KZ1");


function $6b66a004d39af9c2$export$2e2bcd8739ae039() {
    const dispatch = (0, $i2KZ1.useAppDispatch)();
    const isRefreshModalOpen = (0, $i2KZ1.useAppSelector)((state)=>state.app.isRefreshModalOpen);
    const handleRefresh = ()=>{
        dispatch((0, $9HMNu.incrementIframeReloadCount)());
        dispatch((0, $9HMNu.setIsRefreshModalOpen)(false));
    };
    return /*#__PURE__*/ (0, $9h2J6.jsx)((0, $5aad52fabd29c6cf$export$2e2bcd8739ae039), {
        title: "Are you sure you want to refresh?",
        onClose: ()=>{
            dispatch((0, $9HMNu.setIsRefreshModalOpen)(false));
        },
        isVisible: isRefreshModalOpen,
        children: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9dd61ca7c286f0ea$export$2e2bcd8739ae039), {
            text: "Refresh",
            onClick: handleRefresh,
            disabled: !isRefreshModalOpen
        })
    });
}



var $9h2J6 = parcelRequire("9h2J6");

var $7RNO0 = parcelRequire("7RNO0");


var $7v5wN = parcelRequire("7v5wN");

var $24Y1Y = parcelRequire("24Y1Y");
function $53eb8274e55810d6$var$getScreenAspectRatio() {
    const width = window.innerWidth;
    const height = window.innerHeight;
    return height ? width / height : 0;
}
// Accepts either a ratio ("16:9") or a decimal ("1.777")
function $53eb8274e55810d6$var$parseAspectRatio(value) {
    if (!value) return undefined;
    const [width, height] = value.split(':');
    const parsed = height === undefined ? Number(width) : Number(width) / Number(height);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : undefined;
}
function $53eb8274e55810d6$export$2e2bcd8739ae039() {
    const [aspectRatio, setAspectRatio] = (0, $7RNO0.useState)($53eb8274e55810d6$var$getScreenAspectRatio);
    const theme = (0, $7v5wN.useTheme)();
    const ar = theme.metadata?.customJSON?.aspectRatio;
    (0, $7RNO0.useEffect)(()=>{
        function onResize() {
            setAspectRatio($53eb8274e55810d6$var$getScreenAspectRatio());
        }
        window.addEventListener('resize', onResize);
        return ()=>window.removeEventListener('resize', onResize);
    }, []);
    const minAspectRatio = $53eb8274e55810d6$var$parseAspectRatio(ar?.min);
    const isTooNarrow = minAspectRatio !== undefined && aspectRatio < minAspectRatio;
    const isVisible = !!ar && ar.enabled !== false && isTooNarrow;
    const deviceType = (0, $24Y1Y.getDeviceType)();
    // const deviceType = 'mobile';
    let notice = ar?.desktopNotice;
    let imgUrl = '/assets/global/images/widen.svg';
    let imgWidth = 80;
    if (deviceType === 'mobile') {
        notice = ar?.mobileNotice;
        imgUrl = '/assets/global/images/rotate.svg';
        imgWidth = 40;
    }
    if (deviceType === 'tablet') {
        notice = ar?.tabletNotice;
        imgUrl = '/assets/global/images/rotate.svg';
        imgWidth = 40;
    }
    return /*#__PURE__*/ (0, $9h2J6.jsx)((0, $5aad52fabd29c6cf$export$2e2bcd8739ae039), {
        isVisible: isVisible,
        hasCloseButton: false,
        children: /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $9h2J6.jsx)("img", {
                    src: imgUrl,
                    alt: "",
                    style: {
                        width: imgWidth,
                        margin: 'auto',
                        paddingBottom: 20
                    }
                }),
                /*#__PURE__*/ (0, $9h2J6.jsx)("p", {
                    children: notice
                })
            ]
        })
    });
}



var $9h2J6 = parcelRequire("9h2J6");

var $7RNO0 = parcelRequire("7RNO0");


var $9h2J6 = parcelRequire("9h2J6");

var $6dpjF = parcelRequire("6dpjF");
var $2841d11b2484c676$export$d9c2d067feb61447;
var $2841d11b2484c676$export$d8c61589c31c4718;
$2841d11b2484c676$export$d9c2d067feb61447 = `_5b6GcW_ThemedIconButton`;
$2841d11b2484c676$export$d8c61589c31c4718 = `_5b6GcW_isLong`;


function $b3656ed98a6b206b$export$2e2bcd8739ae039({ text: text, onClick: onClick, disabled: disabled, icon: icon }) {
    const isLong = text?.length > 9;
    return /*#__PURE__*/ (0, $9h2J6.jsxs)("button", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($2841d11b2484c676$export$d9c2d067feb61447, {
            [$2841d11b2484c676$export$d8c61589c31c4718]: isLong
        }),
        onClick: onClick,
        disabled: disabled,
        children: [
            /*#__PURE__*/ (0, $9h2J6.jsx)("img", {
                src: $b3656ed98a6b206b$var$iconUrls[icon],
                alt: icon
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)("span", {
                children: text
            })
        ]
    });
}
const $b3656ed98a6b206b$var$iconUrls = {
    facebook: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5OC4zNiA5OCI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogI2ZmZjsKICAgICAgfQogICAgPC9zdHlsZT4KICA8L2RlZnM+CiAgPGcgaWQ9InN2ZzkiPgogICAgPGcgaWQ9ImcyMSI+CiAgICAgIDxnIGlkPSJnMjciPgogICAgICAgIDxwYXRoIGlkPSJwYXRoMjkiIGNsYXNzPSJjbHMtMSIgZD0ibTk4LjM2LDQ5LjE4Qzk4LjM2LDIyLjAyLDc2LjM0LDAsNDkuMTgsMFMwLDIyLjAyLDAsNDkuMThjMCwyMy4wNiwxNS44OCw0Mi40MiwzNy4zLDQ3Ljczdi0zMi43aC0xMC4xNHYtMTUuMDNoMTAuMTR2LTYuNDhjMC0xNi43NCw3LjU4LTI0LjUsMjQuMDEtMjQuNSwzLjEyLDAsOC40OS42MSwxMC42OSwxLjIydjEzLjYyYy0xLjE2LS4xMi0zLjE4LS4xOC01LjY4LS4xOC04LjA2LDAtMTEuMTgsMy4wNS0xMS4xOCwxMXY1LjMxaDE2LjA2bC0yLjc2LDE1LjAzaC0xMy4zdjMzLjc5YzI0LjM1LTIuOTQsNDMuMjItMjMuNjgsNDMuMjItNDguODIiLz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+',
    twitter: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5Ny45MiA5OCI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogI2ZmZjsKICAgICAgfQogICAgPC9zdHlsZT4KICA8L2RlZnM+CiAgPGcgaWQ9InN2ZzkiPgogICAgPHBhdGggY2xhc3M9ImNscy0xIiBkPSJtNTguMjgsNDEuNUw5NC43NCwwaC04LjY0bC0zMS42NywzNi4wM0wyOS4xNiwwSDBsMzguMjMsNTQuNDhMMCw5OGg4LjY0bDMzLjQyLTM4LjA1LDI2LjcsMzguMDVoMjkuMTZNMTEuNzUsNi4zOGgxMy4yN2w2MS4wOCw4NS41NmgtMTMuMjciLz4KICA8L2c+Cjwvc3ZnPg==',
    copy: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MC4yMSA5OC40NiI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogI2ZmZjsKICAgICAgfQogICAgPC9zdHlsZT4KICA8L2RlZnM+CiAgPGcgaWQ9InN2ZzkiPgogICAgPHBhdGggY2xhc3M9ImNscy0xIiBkPSJtMCw0My45N3YtMTguODdjMC02Ljk1LDIuNDUtMTIuODcsNy4zNC0xNy43NkMxMi4yNCwyLjQ1LDE4LjE2LDAsMjUuMSwwczEyLjg3LDIuNDUsMTcuNzYsNy4zNGM0LjksNC45LDcuMzQsMTAuODIsNy4zNCwxNy43NnYxOC44N2gtMTAuOTh2LTE4Ljg2YzAtMy45My0xLjM3LTcuMjctNC4xMi0xMC4wMi0yLjc1LTIuNzUtNi4wOC00LjEyLTEwLjAxLTQuMTJzLTcuMjYsMS4zNy0xMC4wMSw0LjEyYy0yLjc1LDIuNzUtNC4xMiw2LjA5LTQuMTIsMTAuMDJ2MTguODZIMFptMjAuMDUtMTQuNzFoMTAuMTF2MzkuOTNoLTEwLjExczAtMzkuOTMsMC0zOS45M1pNMCw1NC40OWgxMC45OHYxOC44NmMwLDMuOTMsMS4zNyw3LjI3LDQuMTIsMTAuMDIsMi43NSwyLjc1LDYuMDgsNC4xMiwxMC4wMSw0LjEyLDMuOTIsMCw3LjI2LTEuMzcsMTAuMDEtNC4xMiwyLjc1LTIuNzUsNC4xMi02LjA5LDQuMTItMTAuMDJ2LTE4Ljg2aDEwLjk4djE4Ljg3YzAsNi45NS0yLjQ1LDEyLjg3LTcuMzQsMTcuNzYtNC45LDQuOS0xMC44Miw3LjM0LTE3Ljc2LDcuMzQtNi45NSwwLTEyLjg3LTIuNDUtMTcuNzYtNy4zNC00LjktNC45LTcuMzQtMTAuODItNy4zNC0xNy43NnYtMTguODdaIi8+CiAgPC9nPgo8L3N2Zz4=',
    native: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3Ny4wMSAxMDUuNTEiPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGZpbGw6ICNmZmY7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDxnIGlkPSJzdmc5Ij4KICAgIDxwYXRoIGNsYXNzPSJjbHMtMSIgZD0ibTEwLjY4LDEwNS41MWMtMi45NiwwLTUuNDctMS4wNC03LjU2LTMuMTItMi4wOC0yLjA4LTMuMTItNC42LTMuMTItNy41NnYtNDkuNzJjMC0yLjk2LDEuMDQtNS40OCwzLjEyLTcuNTYsMi4wOC0yLjA4LDQuNi0zLjEyLDcuNTYtMy4xMmgxMy4xdjEwLjY4aC0xMy4xdjQ5LjcyaDU1LjY1di00OS43MmgtMTMuMXYtMTAuNjhoMTMuMWMyLjk2LDAsNS40NywxLjA0LDcuNTYsMy4xMiwyLjA4LDIuMDgsMy4xMiw0LjYsMy4xMiw3LjU2djQ5LjcyYzAsMi45Ni0xLjA0LDUuNDctMy4xMiw3LjU2LTIuMDgsMi4wOC00LjYsMy4xMi03LjU2LDMuMTIsMCwwLTU1LjY1LDAtNTUuNjUsMFptMjIuNDktMzNWMjAuNGwtNy41MSw3LjUxLTcuNDctNy41NkwzOC41LDBsMjAuMzIsMjAuMzUtNy40Nyw3LjU2LTcuNTEtNy41MXY1Mi4xMmgtMTAuNjhaIi8+CiAgPC9nPgo8L3N2Zz4='
};



var $9HMNu = parcelRequire("9HMNu");

var $i2KZ1 = parcelRequire("i2KZ1");

var $kFQy0 = parcelRequire("kFQy0");


var $1afSf = parcelRequire("1afSf");

var $cTs7K = parcelRequire("cTs7K");

var $guTIo = parcelRequire("guTIo");
var $fe2618d4311ece89$export$dc57ddd528b7443f;
$fe2618d4311ece89$export$dc57ddd528b7443f = `_84wVWW_buttonContainer`;


function $d127bd8aae3dc508$export$2e2bcd8739ae039() {
    const dispatch = (0, $i2KZ1.useAppDispatch)();
    const shareModalOpen = (0, $i2KZ1.useAppSelector)((state)=>state.app.shareModalOpen);
    const { message: shareMessage = '', disableAutoLink: disableAutoLink } = (0, $i2KZ1.useAppSelector)((state)=>state.app.shareData);
    // Translations
    const translation_share = (0, $guTIo.useUITranslatedText)('share', 'Share');
    const translation_copy = (0, $guTIo.useUITranslatedText)('copy', 'Copy');
    const translation_copied = (0, $guTIo.useUITranslatedText)('copied', 'Copied!');
    const [hasCopied, setHasCopied] = (0, $7RNO0.useState)(false);
    const copyTextTimeout = (0, $7RNO0.useRef)(0);
    const shareURL = disableAutoLink ? '' : window.location.origin;
    const url = encodeURIComponent(shareURL);
    const title = encodeURIComponent(shareMessage);
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}&title=${title}`;
    const twitterUrl = `https://twitter.com/intent/tweet?url=${url}&text=${title}`;
    function open(url) {
        window.open(url, '_blank', 'noopener,noreferrer');
    }
    // Track share button click
    function trackShare(target) {
        (0, $kFQy0.sendEventV2)('share', [
            target,
            shareMessage,
            shareURL
        ]);
    }
    (0, $7RNO0.useEffect)(()=>{
        if (shareModalOpen) (0, $kFQy0.sendEventV2)('arise_share_modal_open');
    }, [
        shareModalOpen
    ]);
    const isDiscordMobile = (0, $7RNO0.useMemo)(()=>{
        try {
            return (0, $cTs7K.IS_DISCORD_ACTIVITY) && (0, $1afSf.isDiscordOnMobile)();
        } catch (error) {
            return false;
        }
    }, []);
    return /*#__PURE__*/ (0, $9h2J6.jsx)((0, $5aad52fabd29c6cf$export$2e2bcd8739ae039), {
        title: translation_share,
        onClose: ()=>{
            dispatch((0, $9HMNu.setShareModalOpen)(false));
        },
        isVisible: shareModalOpen,
        zIndex: 130,
        children: /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
            className: $fe2618d4311ece89$export$dc57ddd528b7443f,
            children: [
                !isDiscordMobile && /*#__PURE__*/ (0, $9h2J6.jsxs)((0, $9h2J6.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $9h2J6.jsx)((0, $b3656ed98a6b206b$export$2e2bcd8739ae039), {
                            text: translation_share,
                            onClick: ()=>{
                                trackShare('facebook');
                                open(facebookUrl);
                            },
                            disabled: false,
                            icon: "facebook"
                        }),
                        /*#__PURE__*/ (0, $9h2J6.jsx)((0, $b3656ed98a6b206b$export$2e2bcd8739ae039), {
                            text: translation_share,
                            onClick: ()=>{
                                trackShare('twitter');
                                open(twitterUrl);
                            },
                            disabled: false,
                            icon: "twitter"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9h2J6.jsx)((0, $b3656ed98a6b206b$export$2e2bcd8739ae039), {
                    text: hasCopied ? translation_copied : translation_copy,
                    onClick: async ()=>{
                        const success = await (0, $d22b0730c33191cb$export$2cdf1b96a9f86d16)(`${shareMessage} ${shareURL}`);
                        if (success) {
                            setHasCopied(true);
                            clearTimeout(copyTextTimeout.current);
                            copyTextTimeout.current = setTimeout(()=>{
                                setHasCopied(false);
                            }, 2000);
                            trackShare('copy');
                        }
                    },
                    disabled: false,
                    icon: "copy"
                })
            ]
        })
    });
}



var $9h2J6 = parcelRequire("9h2J6");

var $7RNO0 = parcelRequire("7RNO0");

var $7v5wN = parcelRequire("7v5wN");

var $i2KZ1 = parcelRequire("i2KZ1");

var $9HMNu = parcelRequire("9HMNu");

var $9K8Jg = parcelRequire("9K8Jg");

var $kFQy0 = parcelRequire("kFQy0");
/**
 * Returns number converted to an oridinal string, or fallback if not a number
 * @param number example: 2
 * @param fallback example: 'N/A'
 * @returns {string} example '2nd'
 */ function $612136f052b1b451$export$9173b52dfbd534b4(number, fallback = '-') {
    if (typeof number !== 'number' || isNaN(number)) return `${fallback}`;
    let ordinalSuffix;
    if (number % 10 === 1 && number % 100 !== 11) ordinalSuffix = 'st';
    else if (number % 10 === 2 && number % 100 !== 12) ordinalSuffix = 'nd';
    else if (number % 10 === 3 && number % 100 !== 13) ordinalSuffix = 'rd';
    else ordinalSuffix = 'th';
    return `${number}${ordinalSuffix}`;
}
function $612136f052b1b451$export$a6283a56ed31c98a(number, fallback = 0) {
    if (typeof number !== 'number' || isNaN(number)) return `${fallback}`;
    return number.toLocaleString('en', {
        useGrouping: true
    });
}
function $612136f052b1b451$export$64c1a95e2185bc9a(base64) {
    try {
        return atob(base64);
    } catch (error) {
        console.warn('Error safeDecodeBase64');
        return ''; // Return "" for invalid Base64 strings.
    }
}
function $612136f052b1b451$export$1aa9ac0ef1c2d437(encodedURI) {
    try {
        return decodeURIComponent(encodedURI);
    } catch (error) {
        console.warn('Error safeDecodeURIComponent');
        return ''; // Return "" for invalid URI components.
    }
}



var $7f522e24ce92e72e$export$463872088a60c6cb;
var $7f522e24ce92e72e$export$2b77a92f1a5ad772;
$7f522e24ce92e72e$export$463872088a60c6cb = `GTxPVW_GenericLeaderboard`;
$7f522e24ce92e72e$export$2b77a92f1a5ad772 = `GTxPVW_Modal`;


function $81a9f87dfa48f9c3$export$2e2bcd8739ae039() {
    const dispatch = (0, $i2KZ1.useAppDispatch)();
    const theme = (0, $7v5wN.useTheme)();
    const isLeaderboardOpen = (0, $i2KZ1.useAppSelector)((state)=>state.app.isLeaderboardOpen);
    const [leaderboardData, setLeaderboardData] = (0, $7RNO0.useState)(null);
    const [isError, setIsError] = (0, $7RNO0.useState)(false);
    async function getData() {
        try {
            const response = await (0, $9K8Jg.getGenericLeaderboardData)();
            setLeaderboardData(response);
        } catch (error) {
            console.warn('Could not get leaderboard data:', error);
            setIsError(true);
        }
    }
    (0, $7RNO0.useEffect)(()=>{
        if (isLeaderboardOpen) {
            getData();
            (0, $kFQy0.sendEvent)('open_leaderboard');
        } else setTimeout(()=>{
            // Timeout to allow modal to move off screen
            setLeaderboardData(null);
            setIsError(false);
        }, 500);
    }, [
        isLeaderboardOpen
    ]);
    const hasLeaderboard = theme.customJSON?.leaderboard?.enabled;
    if (!hasLeaderboard) return null;
    return /*#__PURE__*/ (0, $9h2J6.jsx)((0, $5aad52fabd29c6cf$export$2e2bcd8739ae039), {
        modalClassname: $7f522e24ce92e72e$export$2b77a92f1a5ad772,
        title: "Leaderboard",
        isVisible: isLeaderboardOpen,
        onClose: ()=>{
            dispatch((0, $9HMNu.setIsLeaderboardOpen)(false));
        },
        canScroll: true,
        isLoading: !leaderboardData && !isError,
        leaveSpaceAboveAndBelow: false,
        zIndex: 1000,
        children: leaderboardData || isError ? /*#__PURE__*/ (0, $9h2J6.jsx)($81a9f87dfa48f9c3$var$Leaderboard, {
            entries: leaderboardData?.leaderboard,
            emptyMessage: "Once you complete the mission, your ranking will appear here!",
            errorMessage: "We\u2019re having trouble loading the leaderboard right now.",
            isError: isError
        }) : null
    });
}
const $81a9f87dfa48f9c3$var$Leaderboard = ({ entries: entries, emptyMessage: emptyMessage, errorMessage: errorMessage, isError: isError })=>{
    if (isError) return /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
        className: $7f522e24ce92e72e$export$463872088a60c6cb,
        children: /*#__PURE__*/ (0, $9h2J6.jsx)("h3", {
            children: errorMessage ?? 'Try again later'
        })
    });
    if (!entries?.length) return /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
        className: $7f522e24ce92e72e$export$463872088a60c6cb,
        children: /*#__PURE__*/ (0, $9h2J6.jsx)("h3", {
            children: emptyMessage
        })
    });
    return /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
        className: $7f522e24ce92e72e$export$463872088a60c6cb,
        children: /*#__PURE__*/ (0, $9h2J6.jsxs)("table", {
            children: [
                /*#__PURE__*/ (0, $9h2J6.jsx)("thead", {
                    children: /*#__PURE__*/ (0, $9h2J6.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $9h2J6.jsx)("th", {
                                children: "#"
                            }),
                            /*#__PURE__*/ (0, $9h2J6.jsx)("th", {
                                children: "User"
                            }),
                            /*#__PURE__*/ (0, $9h2J6.jsx)("th", {
                                children: "Score"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $9h2J6.jsx)("tbody", {
                    children: entries.map((entry, index)=>/*#__PURE__*/ (0, $9h2J6.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $9h2J6.jsx)("td", {
                                    children: (0, $612136f052b1b451$export$9173b52dfbd534b4)(entry.position)
                                }),
                                /*#__PURE__*/ (0, $9h2J6.jsx)("td", {
                                    children: /*#__PURE__*/ (0, $9h2J6.jsx)("span", {
                                        children: entry.displayName
                                    })
                                }),
                                /*#__PURE__*/ (0, $9h2J6.jsx)("td", {
                                    children: (0, $612136f052b1b451$export$a6283a56ed31c98a)(entry.score, 'N/A')
                                })
                            ]
                        }, index))
                })
            ]
        })
    });
};



var $47BRk = parcelRequire("47BRk");
function $abb45e976a99e294$export$2eb236097d011acd() {
    const data = {
        platform: (0, (/*@__PURE__*/$parcel$interopDefault($47BRk))).name,
        device: (0, (/*@__PURE__*/$parcel$interopDefault($47BRk))).product,
        device_manufacturer: (0, (/*@__PURE__*/$parcel$interopDefault($47BRk))).manufacturer,
        device_model: (0, (/*@__PURE__*/$parcel$interopDefault($47BRk))).product,
        os_name: (0, (/*@__PURE__*/$parcel$interopDefault($47BRk))).os.family,
        os_version: (0, (/*@__PURE__*/$parcel$interopDefault($47BRk))).os.version
    };
    if (!data.device_manufacturer) {
        if (data.os_name === 'OS X') data.device_manufacturer = 'Apple';
    }
    return data;
}
function $abb45e976a99e294$export$9fe8015f50ae7666() {
    const referrer = document.referrer || '';
    const browser = `${(0, (/*@__PURE__*/$parcel$interopDefault($47BRk))).name || 'Unknown'} ${(0, (/*@__PURE__*/$parcel$interopDefault($47BRk))).version || ''}`.trim();
    const os = (0, (/*@__PURE__*/$parcel$interopDefault($47BRk))).os?.family || 'Unknown';
    const page = window.location.href;
    const userAgent = navigator.userAgent;
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    return {
        strings: [
            referrer,
            browser,
            os,
            page,
            userAgent
        ],
        numbers: [
            screenWidth,
            screenHeight
        ]
    };
}



var $kFQy0 = parcelRequire("kFQy0");
function $8389467c9712cd41$export$a0769f17975cb672() {
    try {
        const { strings: strings, numbers: numbers } = (0, $abb45e976a99e294$export$9fe8015f50ae7666)();
        (0, $kFQy0.sendEventV2Once)('pageview', strings, numbers);
    } catch (err) {
        console.warn('Failed to send pageview event', err);
    }
}
function $8389467c9712cd41$var$isSoftwareRenderer(renderer) {
    const softwareRenderers = [
        'swiftshader',
        'llvmpipe',
        'softpipe',
        'lavapipe',
        'microsoft basic render',
        'direct3d11 warp',
        'warp',
        'gdi generic',
        'software rasterizer',
        'software renderer',
        'software adapter',
        'apple software renderer'
    ];
    return softwareRenderers.some((sw)=>renderer.toLowerCase().includes(sw));
}
function $8389467c9712cd41$export$b494c8ee88b3a008() {
    try {
        const canvas = document.createElement('canvas');
        const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
        let renderer = 'unknown';
        let type = 'software';
        if (gl) {
            const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
            if (debugInfo) {
                const r = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
                if (typeof r === 'string') {
                    renderer = r;
                    type = $8389467c9712cd41$var$isSoftwareRenderer(renderer) ? 'software' : 'hardware';
                }
            } else {
                console.log('[Arise] Graphics capability: No debug renderer info, defaulting to hardware');
                type = 'hardware';
            }
        }
        console.log('[Arise] Graphics capability:', [
            renderer,
            type
        ]);
        (0, $kFQy0.sendEventV2Once)('graphics_capability', [
            renderer,
            type
        ]);
    } catch (err) {
        console.log('[Arise] Graphics capability failed to send', err);
    }
}



var $2QyQO = parcelRequire("2QyQO");

var $7v5wN = parcelRequire("7v5wN");

var $9K8Jg = parcelRequire("9K8Jg");

var $lmedS = parcelRequire("lmedS");

var $guTIo = parcelRequire("guTIo");
var $c739d12d3639bf24$export$2a82ddc22e8c7fbb;
var $c739d12d3639bf24$export$fc6855fecb80bb3f;
var $c739d12d3639bf24$export$1a2a2e04fdf9f489;
var $c739d12d3639bf24$export$cc09b7862278318c;
$c739d12d3639bf24$export$2a82ddc22e8c7fbb = `iF1WSW_contentWrapper`;
$c739d12d3639bf24$export$fc6855fecb80bb3f = `iF1WSW_contentWrapper--sidebarOpen`;
$c739d12d3639bf24$export$1a2a2e04fdf9f489 = `iF1WSW_sidebarWrapper`;
$c739d12d3639bf24$export$cc09b7862278318c = `iF1WSW_sidebarWrapper--sidebarOpen`;



var $cTs7K = parcelRequire("cTs7K");

var $9h2J6 = parcelRequire("9h2J6");

var $7RNO0 = parcelRequire("7RNO0");

var $7jzTX = parcelRequire("7jzTX");


var $1afSf = parcelRequire("1afSf");


var $cTs7K = parcelRequire("cTs7K");

var $guTIo = parcelRequire("guTIo");
var $027d67ab6829562a$export$959e93f94089c33c;
var $027d67ab6829562a$export$27c57cc52d388509;
var $027d67ab6829562a$export$f1b86537d9af7faa;
var $027d67ab6829562a$export$a80b3bd66acc52ff;
var $027d67ab6829562a$export$7abe78e1eda562aa;
var $027d67ab6829562a$export$db3c28d99448dcff;
var $027d67ab6829562a$export$9d6d5e5a70faaa0e;
var $027d67ab6829562a$export$87e603b6a5b79fa;
var $027d67ab6829562a$export$2478bed8f91107f0;
var $027d67ab6829562a$export$b50954cb67afd718;
$027d67ab6829562a$export$959e93f94089c33c = `af8QtW_authCopy`;
$027d67ab6829562a$export$27c57cc52d388509 = `af8QtW_collapsed`;
$027d67ab6829562a$export$f1b86537d9af7faa = `af8QtW_enrolButton`;
$027d67ab6829562a$export$a80b3bd66acc52ff = `af8QtW_info`;
$027d67ab6829562a$export$7abe78e1eda562aa = `af8QtW_loginButton`;
$027d67ab6829562a$export$db3c28d99448dcff = `af8QtW_logo`;
$027d67ab6829562a$export$9d6d5e5a70faaa0e = `af8QtW_overlayContentWrapper`;
$027d67ab6829562a$export$87e603b6a5b79fa = `af8QtW_overlayWrapper`;
$027d67ab6829562a$export$2478bed8f91107f0 = `af8QtW_questUnenrolledNotice`;
$027d67ab6829562a$export$b50954cb67afd718 = `af8QtW_quickComplete`;


const $0d1bab4c79f1e50d$var$DiscordAuthFlow = /*#__PURE__*/ (0, $7RNO0.forwardRef)((props, ref)=>{
    const { authorize: authorize, openExternalLink: openExternalLink, user: user, authError: authError, authDenied: authDenied, quest: quest, authLoading: authLoading } = (0, $1afSf.default)();
    // Translated text
    const authenticatingText = (0, $guTIo.useUITranslatedText)('discord_authenticating', 'Authenticating...');
    const sdkLoadingText = (0, $guTIo.useUITranslatedText)('discord_sdkLoading', 'Discord Loading...');
    (0, $7RNO0.useImperativeHandle)(ref, ()=>({
            authorize: authorize,
            openExternalLink: openExternalLink,
            completeQuest: ()=>{
                if (quest) quest.complete();
            },
            setQuestProgress: (progress)=>{
                if (quest) quest.progress(progress);
            },
            getQuestStatus: async ()=>{
                if (quest) {
                    const d = await quest.check();
                    return d;
                }
                return false;
            },
            botRegister: async ()=>{
                let locale = 'en-us';
                try {
                    // @ts-ignore
                    const userLocale = await window.discordSDK.commands.userSettingsGetLocale();
                    if (userLocale.locale) locale = userLocale.locale;
                } catch (e) {
                    console.error('[Arise] Count not get user locale for bot registration', e);
                }
                try {
                    await $7jzTX.botRegister(locale);
                } catch (e) {
                    console.error('[Arise] Bot registration failed', e);
                }
            }
        }));
    if (!(0, $cTs7K.IS_DISCORD_ACTIVITY) && window.location.hostname !== 'localhost') return /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9h2J6.Fragment), {});
    if (!user || authError) {
        if (authLoading) return /*#__PURE__*/ (0, $9h2J6.jsx)($0d1bab4c79f1e50d$var$TextOverlay, {
            message: authenticatingText
        });
        if (authDenied) return /*#__PURE__*/ (0, $9h2J6.jsx)($0d1bab4c79f1e50d$var$AuthRequiredOverlay, {
            authorise: authorize
        });
        // Removing auth error messaging
        // if (authError) {
        //     console.log('[arise] auth error: ', authError)
        //     // return <AuthErrorOverlay authorise={authorize} />;
        // }
        // If there's no user and it's not in any of the other states, show the loader
        return /*#__PURE__*/ (0, $9h2J6.jsx)($0d1bab4c79f1e50d$var$TextOverlay, {
            message: sdkLoadingText
        });
    }
    // return (
    //     <>
    //         <div className={styles.info}>{JSON.stringify(d, null, 4)}</div>
    //     </>
    // );
    return /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9h2J6.Fragment), {});
});
function $0d1bab4c79f1e50d$var$OverlayWrapper({ children: children }) {
    return /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
        className: $027d67ab6829562a$export$87e603b6a5b79fa,
        children: /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
            className: $027d67ab6829562a$export$9d6d5e5a70faaa0e,
            children: [
                /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                    className: $027d67ab6829562a$export$db3c28d99448dcff,
                    children: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $712b328b756bc954$export$2e2bcd8739ae039), {
                        show: true,
                        hasBackground: false,
                        logoImageUrl: "/assets/global/preloader/logo.png"
                    })
                }),
                children
            ]
        })
    });
}
function $0d1bab4c79f1e50d$var$TextOverlay({ message: message }) {
    return /*#__PURE__*/ (0, $9h2J6.jsx)($0d1bab4c79f1e50d$var$OverlayWrapper, {
        children: /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
            children: message
        })
    });
}
function $0d1bab4c79f1e50d$var$AuthRequiredOverlay({ authorise: authorise }) {
    const authorizePrompt = (0, $guTIo.useUITranslatedText)('discord_authorizePrompt', "You\u2019ll need to authorize to continue.");
    const authorizeButton = (0, $guTIo.useUITranslatedText)('discord_authorizeButton', 'Try again');
    return /*#__PURE__*/ (0, $9h2J6.jsxs)($0d1bab4c79f1e50d$var$OverlayWrapper, {
        children: [
            /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                className: $027d67ab6829562a$export$959e93f94089c33c,
                children: authorizePrompt
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)((0, $bc232447c96f1a4a$export$2e2bcd8739ae039), {
                onClick: ()=>{
                    authorise();
                },
                className: $027d67ab6829562a$export$7abe78e1eda562aa,
                children: authorizeButton
            })
        ]
    });
}
function $0d1bab4c79f1e50d$var$AuthErrorOverlay({ authorise: authorise }) {
    return /*#__PURE__*/ (0, $9h2J6.jsxs)($0d1bab4c79f1e50d$var$OverlayWrapper, {
        children: [
            /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                className: $027d67ab6829562a$export$959e93f94089c33c,
                children: "Authorization error. Please try logging in again."
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)((0, $bc232447c96f1a4a$export$2e2bcd8739ae039), {
                onClick: ()=>{
                    authorise();
                },
                className: $027d67ab6829562a$export$7abe78e1eda562aa,
                children: "Try Again"
            })
        ]
    });
}
function $0d1bab4c79f1e50d$export$86908e3cbc015d52({ gotoEnroll: gotoEnroll }) {
    const [collapsed, setCollapsed] = (0, $7RNO0.useState)(false);
    function renderCollapsed() {
        return /*#__PURE__*/ (0, $9h2J6.jsx)("span", {
            className: $027d67ab6829562a$export$f1b86537d9af7faa,
            onClick: gotoEnroll,
            children: "Join Quest"
        });
    }
    function renderFull() {
        return /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $9h2J6.jsx)("span", {
                    children: "Join the quest to get your reward."
                }),
                /*#__PURE__*/ (0, $9h2J6.jsx)("span", {
                    className: $027d67ab6829562a$export$f1b86537d9af7faa,
                    onClick: gotoEnroll,
                    children: "Join Quest (TODO)"
                }),
                /*#__PURE__*/ (0, $9h2J6.jsx)("span", {
                    className: $027d67ab6829562a$export$f1b86537d9af7faa,
                    onClick: ()=>{
                        setCollapsed(!collapsed);
                    },
                    children: "<"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
        className: $027d67ab6829562a$export$2478bed8f91107f0 + ' ' + (collapsed ? $027d67ab6829562a$export$27c57cc52d388509 : ''),
        children: collapsed ? renderCollapsed() : renderFull()
    });
}
var $0d1bab4c79f1e50d$export$2e2bcd8739ae039 = $0d1bab4c79f1e50d$var$DiscordAuthFlow;


function $7f7e09a0cb9ba34c$export$2e2bcd8739ae039() {
    const navigate = (0, $0e3dfb59695be15b$export$9770f232ac06a008)();
    const dispatch = (0, $i2KZ1.useAppDispatch)();
    const discordRef = (0, $7RNO0.useRef)();
    const theme = (0, $7v5wN.useTheme)();
    const { location: location, isLocationLoading: isLocationLoading, isProfileOpen: isProfileOpen, isInformationOpen: isInformationOpen, isMyRewardsOpen: isMyRewardsOpen, locationLoadErrorId: locationLoadErrorId, shouldHideUi: shouldHideUi } = (0, $i2KZ1.useAppSelector)((state)=>state.app);
    const loggedIn = (0, $i2KZ1.useAppSelector)((state)=>state.auth.loggedIn);
    const { locationId: id } = (0, $0e3dfb59695be15b$export$99eaa27ddbbb95ef)();
    (0, $7RNO0.useEffect)(()=>{
        // Redirect if not found
        if (locationLoadErrorId === id) navigate((0, $2QyQO.homePath));
    }, [
        locationLoadErrorId
    ]);
    (0, $7RNO0.useEffect)(()=>{
        if ((!location || location.id !== id) && !isLocationLoading) dispatch((0, $9HMNu.loadLocation)(id));
        (0, $8389467c9712cd41$export$a0769f17975cb672)();
        (0, $8389467c9712cd41$export$b494c8ee88b3a008)();
        // Reset UI on load
        dispatch((0, $9HMNu.setIsNewsTickerVisible)(!!theme.metadata?.customJSON?.newsTicker?.showImmediately));
    }, [
        id
    ]);
    (0, $7RNO0.useEffect)(()=>{
        let interval;
        let timeout;
        if (id && loggedIn) // Begin heartbeat after 2 seconds
        timeout = setTimeout(()=>{
            (0, $9K8Jg.heartbeat)(id);
            interval = setInterval(()=>{
                (0, $9K8Jg.heartbeat)(id);
            }, 30000); // 30s
        }, 2000);
        return ()=>{
            if (timeout) clearTimeout(timeout);
            if (interval) clearInterval(interval);
        };
    }, [
        id,
        loggedIn
    ]);
    // Loading screen text translations
    const loadingScreenData = theme?.metadata?.customJSON?.loading;
    const translation_loading1Title = (0, $guTIo.useUITranslatedText)('loading_message1Title', loadingScreenData?.message1?.title);
    const translation_loading1Subtitle = (0, $guTIo.useUITranslatedText)('loading_message1Subtitle', loadingScreenData?.message1?.subtitle);
    const translation_loading2Title = (0, $guTIo.useUITranslatedText)('loading_message2Title', loadingScreenData?.message2?.title);
    const translation_loading2Subtitle = (0, $guTIo.useUITranslatedText)('loading_message2Subtitle', loadingScreenData?.message2?.subtitle);
    const translation_loading3Title = (0, $guTIo.useUITranslatedText)('loading_message3Title', loadingScreenData?.message3?.title);
    const translation_loading3Subtitle = (0, $guTIo.useUITranslatedText)('loading_message3Subtitle', loadingScreenData?.message3?.subtitle);
    if (!location || location.id !== id) return /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9h2J6.Fragment), {});
    const sidebarIsOpen = (isProfileOpen || isInformationOpen || isMyRewardsOpen) && !shouldHideUi;
    const hasProfileDrawer = theme.metadata?.customJSON?.profileDrawerV2?.enabled;
    const hasInformationDrawer = theme.metadata?.customJSON?.informationDrawer?.enabled;
    const hasNewsTicker = theme.metadata?.customJSON?.newsTicker?.enabled;
    const hasMenu = theme.metadata?.customJSON?.menu?.enabled;
    const hasRewardsDrawer = theme.metadata?.customJSON?.rewardsDrawer?.enabled;
    return /*#__PURE__*/ (0, $9h2J6.jsxs)((0, $937d42beb4fc805a$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($c739d12d3639bf24$export$2a82ddc22e8c7fbb, {
                    [$c739d12d3639bf24$export$fc6855fecb80bb3f]: sidebarIsOpen
                }),
                children: [
                    /*#__PURE__*/ (0, $9h2J6.jsx)((0, $e06a211822b32e2c$export$2e2bcd8739ae039), {
                        forceInFrontOfUi: shouldHideUi,
                        src: location.iframeURL || location.latestArisewareBuildURL,
                        arisewareProjectID: location.arisewareProjectID,
                        onReady: ()=>{},
                        loadingBackgroundImageUrl: (0, $lmedS.pathToURL)(loadingScreenData?.backgroundImagePath),
                        loadingLogoImageUrl: (0, $lmedS.pathToURL)(loadingScreenData?.logoImagePath),
                        loadingText: [
                            {
                                title: translation_loading1Title,
                                subtitle: translation_loading1Subtitle
                            },
                            {
                                title: translation_loading2Title,
                                subtitle: translation_loading2Subtitle
                            },
                            {
                                title: translation_loading3Title,
                                subtitle: translation_loading3Subtitle
                            }
                        ],
                        discordRef: discordRef
                    }),
                    hasNewsTicker && /*#__PURE__*/ (0, $9h2J6.jsx)((0, $0cb4fda1aa815dee$export$2e2bcd8739ae039), {}),
                    hasMenu && /*#__PURE__*/ (0, $9h2J6.jsx)((0, $a90a1d40555e811c$export$2e2bcd8739ae039), {})
                ]
            }),
            /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($c739d12d3639bf24$export$1a2a2e04fdf9f489, {
                    [$c739d12d3639bf24$export$cc09b7862278318c]: sidebarIsOpen
                }),
                children: [
                    hasProfileDrawer && /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9757c11e13e1e8ba$export$2e2bcd8739ae039), {}),
                    hasInformationDrawer && /*#__PURE__*/ (0, $9h2J6.jsx)((0, $be701869f927ca1b$export$2e2bcd8739ae039), {}),
                    hasRewardsDrawer && /*#__PURE__*/ (0, $9h2J6.jsx)((0, $794ba98c605414a9$export$2e2bcd8739ae039), {})
                ]
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)((0, $81a9f87dfa48f9c3$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $9h2J6.jsx)((0, $4a1cc8d5cfe2a1d8$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $9h2J6.jsx)((0, $85d3d15771e9730e$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $9h2J6.jsx)((0, $d127bd8aae3dc508$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $9h2J6.jsx)((0, $a1818482afeb7963$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $9h2J6.jsx)((0, $6b66a004d39af9c2$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $9h2J6.jsx)((0, $53eb8274e55810d6$export$2e2bcd8739ae039), {}),
            (0, $cTs7K.IS_DISCORD_ACTIVITY) && /*#__PURE__*/ (0, $9h2J6.jsx)((0, $0d1bab4c79f1e50d$export$2e2bcd8739ae039), {
                ref: discordRef
            })
        ]
    });
}



var $9h2J6 = parcelRequire("9h2J6");

var $9h2J6 = parcelRequire("9h2J6");

var $7RNO0 = parcelRequire("7RNO0");

var $7v5wN = parcelRequire("7v5wN");

var $cTs7K = parcelRequire("cTs7K");


var $i2KZ1 = parcelRequire("i2KZ1");

var $9HMNu = parcelRequire("9HMNu");

var $9h2J6 = parcelRequire("9h2J6");

var $6dpjF = parcelRequire("6dpjF");

var $7RNO0 = parcelRequire("7RNO0");
var $537592d4e5890f3e$exports = {};

$parcel$export($537592d4e5890f3e$exports, "AnimatedFullscreenText", function () { return $537592d4e5890f3e$export$176a62fda607b5a0; }, function (v) { return $537592d4e5890f3e$export$176a62fda607b5a0 = v; });
$parcel$export($537592d4e5890f3e$exports, "highlighted", function () { return $537592d4e5890f3e$export$ba6acb6e4dfd83c2; }, function (v) { return $537592d4e5890f3e$export$ba6acb6e4dfd83c2 = v; });
$parcel$export($537592d4e5890f3e$exports, "longTitle", function () { return $537592d4e5890f3e$export$578fcbc4821dcd12; }, function (v) { return $537592d4e5890f3e$export$578fcbc4821dcd12 = v; });
$parcel$export($537592d4e5890f3e$exports, "moveUp", function () { return $537592d4e5890f3e$export$44935f8a884b57b9; }, function (v) { return $537592d4e5890f3e$export$44935f8a884b57b9 = v; });
$parcel$export($537592d4e5890f3e$exports, "page-transition-postVisible", function () { return $537592d4e5890f3e$export$635eb3172be88cc1; }, function (v) { return $537592d4e5890f3e$export$635eb3172be88cc1 = v; });
$parcel$export($537592d4e5890f3e$exports, "page-transition-preVisible", function () { return $537592d4e5890f3e$export$d0da582c244d7927; }, function (v) { return $537592d4e5890f3e$export$d0da582c244d7927 = v; });
$parcel$export($537592d4e5890f3e$exports, "page-transition-visible", function () { return $537592d4e5890f3e$export$110dabf6daad8b9a; }, function (v) { return $537592d4e5890f3e$export$110dabf6daad8b9a = v; });
$parcel$export($537592d4e5890f3e$exports, "title", function () { return $537592d4e5890f3e$export$fb184b623420d9be; }, function (v) { return $537592d4e5890f3e$export$fb184b623420d9be = v; });
var $537592d4e5890f3e$export$176a62fda607b5a0;
var $537592d4e5890f3e$export$ba6acb6e4dfd83c2;
var $537592d4e5890f3e$export$578fcbc4821dcd12;
var $537592d4e5890f3e$export$44935f8a884b57b9;
var $537592d4e5890f3e$export$635eb3172be88cc1;
var $537592d4e5890f3e$export$d0da582c244d7927;
var $537592d4e5890f3e$export$110dabf6daad8b9a;
var $537592d4e5890f3e$export$fb184b623420d9be;
$537592d4e5890f3e$export$176a62fda607b5a0 = `TglI0W_AnimatedFullscreenText`;
$537592d4e5890f3e$export$ba6acb6e4dfd83c2 = `TglI0W_highlighted`;
$537592d4e5890f3e$export$578fcbc4821dcd12 = `TglI0W_longTitle`;
$537592d4e5890f3e$export$44935f8a884b57b9 = `TglI0W_moveUp`;
$537592d4e5890f3e$export$44935f8a884b57b9;
$537592d4e5890f3e$export$635eb3172be88cc1 = `TglI0W_page-transition-postVisible`;
$537592d4e5890f3e$export$d0da582c244d7927 = `TglI0W_page-transition-preVisible`;
$537592d4e5890f3e$export$110dabf6daad8b9a = `TglI0W_page-transition-visible`;
$537592d4e5890f3e$export$fb184b623420d9be = `TglI0W_title`;



function $0f22e7410cb9f775$export$2e2bcd8739ae039({ titles: titles, transitionState: transitionState, onComplete: onComplete }) {
    const [visibleTitleIndex, setVisibleTitleIndex] = (0, $7RNO0.useState)(-1);
    const getWords = (title)=>{
        const arrayOfWords = title.split(' ');
        const animateInDurationMs = 1000;
        const durationPerWord = animateInDurationMs / arrayOfWords.length;
        return arrayOfWords.map((word, index)=>/*#__PURE__*/ (0, $9h2J6.jsx)("span", {
                style: {
                    animationDelay: `-${durationPerWord * (arrayOfWords.length - 1 - index)}ms`
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))({
                    [$537592d4e5890f3e$exports.highlighted]: index === arrayOfWords.length - 1
                }),
                children: word + (index < arrayOfWords.length - 1 ? ' ' : '')
            }, index));
    };
    (0, $7RNO0.useEffect)(()=>{
        // Transition between titles
        if (!titles || transitionState !== (0, $f6defc7795a4c638$export$f36897288fd2d497).visible) return;
        const getAnimationDuration = (index)=>{
            switch(index){
                case -1:
                    return 0;
                case 0:
                    return 2000;
                default:
                    return 1000;
            }
        };
        let timeout;
        if (visibleTitleIndex < titles.length) timeout = setTimeout(()=>{
            setVisibleTitleIndex(visibleTitleIndex + 1);
        }, getAnimationDuration(visibleTitleIndex));
        else // No more titles to show
        onComplete();
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        visibleTitleIndex,
        titles,
        transitionState
    ]);
    return /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($537592d4e5890f3e$exports.AnimatedFullscreenText, $537592d4e5890f3e$exports[transitionState]),
        "aria-hidden": transitionState !== (0, $f6defc7795a4c638$export$f36897288fd2d497).visible,
        "aria-live": "assertive",
        "aria-label": titles && titles.join('. '),
        children: titles && titles.map((title, index)=>/*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($537592d4e5890f3e$exports.title, {
                    [$537592d4e5890f3e$exports[(0, $f6defc7795a4c638$export$f36897288fd2d497).preVisible]]: visibleTitleIndex < index,
                    [$537592d4e5890f3e$exports[(0, $f6defc7795a4c638$export$f36897288fd2d497).visible]]: visibleTitleIndex === index,
                    [$537592d4e5890f3e$exports[(0, $f6defc7795a4c638$export$f36897288fd2d497).postVisible]]: visibleTitleIndex > index && index !== titles.length - 1,
                    [$537592d4e5890f3e$exports.longTitle]: title.length > 16
                }),
                children: getWords(title)
            }, index))
    });
}


function $a128cf9cd188435f$export$2e2bcd8739ae039({ children: children }) {
    const dispatch = (0, $i2KZ1.useAppDispatch)();
    const theme = (0, $7v5wN.useTheme)();
    const hasWorldIntroPlayed = (0, $i2KZ1.useAppSelector)((state)=>state.app.hasWorldIntroPlayed);
    const isPurchaseInProgress = (0, $i2KZ1.useAppSelector)((state)=>state.app.isPurchaseInProgress);
    const [transitionState, setTransitionState] = (0, $7RNO0.useState)((0, $f6defc7795a4c638$export$f36897288fd2d497).preVisible);
    const titles = theme.customJSON?.worldIntroductionText;
    (0, $7RNO0.useEffect)(()=>{
        // Only show intro to user once
        const hasSeenWorldIntro = hasWorldIntroPlayed || window.localStorage.getItem((0, $cTs7K.LS_HASSEENWORLDINTRO_KEY)) || !titles?.length;
        if (hasSeenWorldIntro) dispatch((0, $9HMNu.setHasWorldIntroPlayed)(true));
        else setTransitionState((0, $f6defc7795a4c638$export$f36897288fd2d497).visible);
    }, [
        theme
    ]);
    (0, $7RNO0.useEffect)(()=>{
        if (isPurchaseInProgress) // If doing a purchase, don't show world intro
        onComplete();
    }, [
        isPurchaseInProgress
    ]);
    const onComplete = ()=>{
        setTransitionState((0, $f6defc7795a4c638$export$f36897288fd2d497).postVisible);
        window.localStorage.setItem((0, $cTs7K.LS_HASSEENWORLDINTRO_KEY), 'true');
        dispatch((0, $9HMNu.setHasWorldIntroPlayed)(true));
    };
    return /*#__PURE__*/ (0, $9h2J6.jsxs)((0, $9h2J6.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9h2J6.jsx)((0, $0f22e7410cb9f775$export$2e2bcd8739ae039), {
                titles: titles,
                transitionState: transitionState,
                onComplete: onComplete
            }),
            hasWorldIntroPlayed && children
        ]
    });
}


function $c86c308114b2a328$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $9h2J6.jsx)((0, $a128cf9cd188435f$export$2e2bcd8739ae039), {
        children: children
    });
}



var $9h2J6 = parcelRequire("9h2J6");

var $9K8Jg = parcelRequire("9K8Jg");

var $6Jwum = parcelRequire("6Jwum");

var $i2KZ1 = parcelRequire("i2KZ1");

var $7RNO0 = parcelRequire("7RNO0");
function $e00315c49eb28b87$export$2e2bcd8739ae039() {
    const dispatch = (0, $i2KZ1.useAppDispatch)();
    const auth = (0, $i2KZ1.useAppSelector)((state)=>state.auth);
    // todo - way of setting display name
    (0, $7RNO0.useEffect)(()=>{
        (async ()=>{
            const query = window.location.search;
            const token = new URLSearchParams(query).get('token');
            if (!token) {
                console.error('No token found');
                window.location.href = '/';
                return;
            }
            try {
                await (0, $9K8Jg.oAuthExchange)(token);
                dispatch((0, $6Jwum.postLogin)());
            } catch (err) {
                console.error(err);
                window.location.href = '/';
            }
        })();
    }, []);
    (0, $7RNO0.useEffect)(()=>{
        if (auth.loggedIn) window.location.href = '/';
    }, [
        auth.loggedIn
    ]);
    return /*#__PURE__*/ (0, $9h2J6.jsx)("div", {});
}



var $9h2J6 = parcelRequire("9h2J6");

var $9h2J6 = parcelRequire("9h2J6");

var $7RNO0 = parcelRequire("7RNO0");

var $2QyQO = parcelRequire("2QyQO");

var $9K8Jg = parcelRequire("9K8Jg");





function $01c9bfaaf46e46a4$export$2e2bcd8739ae039() {
    const [errorCode, setErrorCode] = (0, $7RNO0.useState)();
    const [token, setToken] = (0, $7RNO0.useState)('');
    const [email, setEmail] = (0, $7RNO0.useState)('');
    const [password, setPassword] = (0, $7RNO0.useState)('');
    const [passwordConfirmation, setPasswordConfirmation] = (0, $7RNO0.useState)('');
    const [uiStatus, setUiStatus] = (0, $7RNO0.useState)('enterDetails');
    async function onSubmit() {
        if (!(0, $9a318c0adac33f72$export$371e338370561054)(email)) {
            setErrorCode('EMAIL_INVALID');
            return;
        }
        if (password !== passwordConfirmation) {
            setErrorCode('PASSWORD_MISMATCH');
            return;
        }
        if (!(0, $9a318c0adac33f72$export$1cf356d314abea16)(password)) {
            setErrorCode('PASSWORD_TOO_SHORT');
            return;
        }
        try {
            await (0, $9K8Jg.passwordChange)(email, token, passwordConfirmation);
            setUiStatus('passwordChanged');
        } catch (error) {
            setErrorCode(error.message ?? 'UNKNOWN_ERROR');
            console.error('Could not reset password', error);
        }
    }
    (0, $7RNO0.useEffect)(()=>{
        const query = window.location.search;
        const urlToken = new URLSearchParams(query).get('token');
        if (!urlToken) {
            console.warn('No password reset url token found');
            window.location.href = '/';
        }
        setToken(urlToken);
    }, []);
    const EnterDetails = /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $9h2J6.jsx)("h2", {
                children: "Reset your password"
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)("p", {
                children: "Please enter your new password"
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)("br", {}),
            /*#__PURE__*/ (0, $9h2J6.jsx)("label", {
                htmlFor: "arise-password-reset-email",
                children: "Email"
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)((0, $97de157f1d7f5149$export$2e2bcd8739ae039), {
                className: $a2e351ff115d2f57$export$b7e3ae3d7c15e42e,
                id: "arise-password-reset-email",
                value: email,
                onChange: (e)=>setEmail(e.target.value),
                placeholder: "Email Address",
                autoComplete: "email"
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)("label", {
                htmlFor: "arise-password-reset-password",
                children: "New Password"
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)((0, $97de157f1d7f5149$export$2e2bcd8739ae039), {
                className: $a2e351ff115d2f57$export$b7e3ae3d7c15e42e,
                id: "arise-password-reset-password",
                value: password,
                onChange: (e)=>setPassword(e.target.value),
                placeholder: "Password",
                type: "password",
                autoComplete: "new-password"
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)("label", {
                htmlFor: "arise-password-reset-password-confirmation",
                children: "Confirm Password"
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)((0, $97de157f1d7f5149$export$2e2bcd8739ae039), {
                className: $a2e351ff115d2f57$export$b7e3ae3d7c15e42e,
                id: "arise-password-reset-password-confirmation",
                value: passwordConfirmation,
                onChange: (e)=>setPasswordConfirmation(e.target.value),
                placeholder: "Password",
                type: "password",
                autoComplete: "new-password"
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)((0, $e94781751f5e34af$export$c43bfb5198aa7b21), {
                disabled: !(token && email && password && passwordConfirmation),
                text: "Change Password",
                onClick: onSubmit
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)("p", {
                className: $a2e351ff115d2f57$export$493b5823483d2c4e,
                children: $01c9bfaaf46e46a4$var$getPasswordResetErrorMessage(errorCode)
            })
        ]
    });
    const PasswordChanged = /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $9h2J6.jsx)("h2", {
                children: "Password Changed"
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)("p", {
                children: "Your password has been changed successfully!"
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)("br", {}),
            /*#__PURE__*/ (0, $9h2J6.jsx)((0, $e94781751f5e34af$export$c43bfb5198aa7b21), {
                text: "Back to Home",
                onClick: ()=>window.location.href = '/'
            })
        ]
    });
    return /*#__PURE__*/ (0, $9h2J6.jsxs)((0, $5aad52fabd29c6cf$export$2e2bcd8739ae039), {
        canScroll: true,
        isVisible: true,
        onClose: ()=>{
            window.location.href = '/';
        },
        modalClassname: $a2e351ff115d2f57$export$4adafe2b4f22b75f,
        closeButtonClassname: $a2e351ff115d2f57$export$efe229eab43a9869,
        closeButtonStyle: "icon",
        shouldCloseOnExternalClick: false,
        zIndex: 1000,
        leaveSpaceAboveAndBelow: false,
        children: [
            /*#__PURE__*/ (0, $9h2J6.jsx)("img", {
                className: $a2e351ff115d2f57$export$db3c28d99448dcff,
                alt: "Those Beyond Logo",
                src: "/assets/global/those-beyond-icon.svg"
            }),
            uiStatus === 'enterDetails' ? EnterDetails : PasswordChanged
        ]
    });
}
function $01c9bfaaf46e46a4$var$getPasswordResetErrorMessage(errorCode) {
    if (!errorCode) return '';
    switch(errorCode){
        case 'EMAIL_INVALID':
            return 0, $9a318c0adac33f72$export$aa8c7e6540925da0;
        case 'INVALID_RESET_TOKEN':
            return 'Could not reset password, the link may be expired. Please try again.';
        case 'PASSWORD_MISMATCH':
            return 'The passwords do not match.';
        case 'PASSWORD_TOO_SHORT':
            return 0, $9a318c0adac33f72$export$22f782bed1cafd3f;
        default:
            return `Could not reset password. Check your details are correct, or contact ${0, $2QyQO.SUPPORT_EMAIL}`;
    }
}


function $1ac51b12d0562b16$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $9h2J6.jsx)((0, $01c9bfaaf46e46a4$export$2e2bcd8739ae039), {});
}



var $9h2J6 = parcelRequire("9h2J6");

var $7RNO0 = parcelRequire("7RNO0");


var $6dpjF = parcelRequire("6dpjF");

var $7v5wN = parcelRequire("7v5wN");

var $2QyQO = parcelRequire("2QyQO");

var $i2KZ1 = parcelRequire("i2KZ1");

var $9h2J6 = parcelRequire("9h2J6");


var $9h2J6 = parcelRequire("9h2J6");

var $6dpjF = parcelRequire("6dpjF");
var $5fb6b18859bcc5f6$export$d5992c1fec905475;
var $5fb6b18859bcc5f6$export$ba6acb6e4dfd83c2;
$5fb6b18859bcc5f6$export$d5992c1fec905475 = `yJ5yJW_ButtonLink`;
$5fb6b18859bcc5f6$export$ba6acb6e4dfd83c2 = `yJ5yJW_highlighted`;


function $238e8f65f8d27d18$export$d5992c1fec905475({ children: children, onClick: onClick, className: className, isHighlighted: isHighlighted, ...props }) {
    return /*#__PURE__*/ (0, $9h2J6.jsx)("button", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($5fb6b18859bcc5f6$export$d5992c1fec905475, className, {
            [$5fb6b18859bcc5f6$export$ba6acb6e4dfd83c2]: isHighlighted
        }),
        ...props,
        onClick: onClick,
        children: children
    });
}



var $6Jwum = parcelRequire("6Jwum");

var $kFQy0 = parcelRequire("kFQy0");

var $i2KZ1 = parcelRequire("i2KZ1");


function $302b4db5b5e5dde7$export$2e2bcd8739ae039() {
    const dispatch = (0, $i2KZ1.useAppDispatch)();
    const navigateToSignup = (0, $9f96f67c93658cb1$export$c9c1802ef9b13040)();
    const navigateToLogin = (0, $9f96f67c93658cb1$export$932dac77da3ee9c3)();
    return /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $9h2J6.jsx)("p", {
                className: $a2e351ff115d2f57$export$60877daf335d779,
                style: {
                    marginBottom: 20
                },
                children: "A place where fans can connect, explore, and participate together in the worlds they love."
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)((0, $e94781751f5e34af$export$c43bfb5198aa7b21), {
                text: "Sign up",
                onClick: ()=>{
                    (0, $kFQy0.sendEvent)('landing_page_sign_up_click');
                    navigateToSignup();
                }
            }),
            /*#__PURE__*/ (0, $9h2J6.jsx)((0, $e94781751f5e34af$export$c43bfb5198aa7b21), {
                isHighlighted: false,
                text: "Continue as Guest",
                onClick: ()=>{
                    dispatch((0, $6Jwum.loginAsGuest)());
                    (0, $kFQy0.sendEvent)('landing_page_continue_as_guest_click');
                },
                style: {
                    marginTop: 16
                }
            }),
            /*#__PURE__*/ (0, $9h2J6.jsxs)("span", {
                className: $a2e351ff115d2f57$export$5cfd5c18b591b2db,
                children: [
                    "Have an account?",
                    ' ',
                    /*#__PURE__*/ (0, $9h2J6.jsx)((0, $238e8f65f8d27d18$export$d5992c1fec905475), {
                        isHighlighted: true,
                        onClick: ()=>{
                            (0, $kFQy0.sendEvent)('landing_page_log_in_click');
                            navigateToLogin();
                        },
                        children: "Log in"
                    })
                ]
            })
        ]
    });
}


var $d0c92f03f648180e$export$355f3d6a1f8b250c;
var $d0c92f03f648180e$export$34e0f9847d4c02dd;
var $d0c92f03f648180e$export$a7db06668cad9adb;
var $d0c92f03f648180e$export$50e46ea94d9c038c;
var $d0c92f03f648180e$export$231ba5fc42c01d86;
var $d0c92f03f648180e$export$fcf916772c508c4a;
var $d0c92f03f648180e$export$db3c28d99448dcff;
$d0c92f03f648180e$export$355f3d6a1f8b250c = `EgaQbW_LandingPage`;
$d0c92f03f648180e$export$34e0f9847d4c02dd = `EgaQbW_container`;
$d0c92f03f648180e$export$a7db06668cad9adb = `EgaQbW_content`;
$d0c92f03f648180e$export$50e46ea94d9c038c = `EgaQbW_dividerLine`;
$d0c92f03f648180e$export$231ba5fc42c01d86 = `EgaQbW_formContainer`;
$d0c92f03f648180e$export$fcf916772c508c4a = `EgaQbW_landingText`;
$d0c92f03f648180e$export$db3c28d99448dcff = `EgaQbW_logo`;


function $3bd2b33fe0dc423d$export$2e2bcd8739ae039() {
    const loggedIn = (0, $i2KZ1.useAppSelector)((state)=>state.auth.loggedIn);
    const theme = (0, $7v5wN.useTheme)();
    const navigate = (0, $0e3dfb59695be15b$export$9770f232ac06a008)();
    (0, $7RNO0.useEffect)(()=>{
        if (loggedIn) navigate((0, $2QyQO.homePath));
    }, [
        loggedIn
    ]);
    const data = theme.customJSON?.login;
    return /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
        className: $d0c92f03f648180e$export$355f3d6a1f8b250c,
        style: {
            backgroundImage: `url("${data?.backgroundImageUrl}")`
        },
        children: /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
            className: $d0c92f03f648180e$export$34e0f9847d4c02dd,
            children: [
                data?.logoImageUrl && /*#__PURE__*/ (0, $9h2J6.jsx)("img", {
                    className: $d0c92f03f648180e$export$db3c28d99448dcff,
                    src: data?.logoImageUrl,
                    alt: "Logo"
                }),
                /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                    className: $d0c92f03f648180e$export$a7db06668cad9adb,
                    children: [
                        /*#__PURE__*/ (0, $9h2J6.jsxs)("div", {
                            className: $d0c92f03f648180e$export$fcf916772c508c4a,
                            children: [
                                data?.title && /*#__PURE__*/ (0, $9h2J6.jsx)("h2", {
                                    children: data?.title
                                }),
                                data?.subtitle && /*#__PURE__*/ (0, $9h2J6.jsx)("p", {
                                    children: data?.subtitle
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $9h2J6.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($6dpjF)))($d0c92f03f648180e$export$231ba5fc42c01d86, {
                                [$d0c92f03f648180e$export$50e46ea94d9c038c]: data?.title || data?.subtitle
                            }),
                            children: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $302b4db5b5e5dde7$export$2e2bcd8739ae039), {})
                        })
                    ]
                })
            ]
        })
    });
}



var $9h2J6 = parcelRequire("9h2J6");

var $9K8Jg = parcelRequire("9K8Jg");

var $6Jwum = parcelRequire("6Jwum");

var $i2KZ1 = parcelRequire("i2KZ1");

var $2QyQO = parcelRequire("2QyQO");


var $kFQy0 = parcelRequire("kFQy0");

var $7RNO0 = parcelRequire("7RNO0");

function $6946d83c30ddf99a$export$2e2bcd8739ae039() {
    const navigate = (0, $0e3dfb59695be15b$export$9770f232ac06a008)();
    const dispatch = (0, $i2KZ1.useAppDispatch)();
    (0, $7RNO0.useEffect)(()=>{
        (async ()=>{
            // get query params
            const urlParams = new URLSearchParams(window.location.search);
            const insidersJWT = urlParams.get('jwt');
            if (!insidersJWT) {
                console.error('No jwt found in query params');
                navigate('/');
                (0, $kFQy0.sendEvent)('login_return_from_insiders_error', {
                    message: 'No jwt found in query params'
                });
                return;
            }
            // remove jwt token from query params in url
            window.history.replaceState({}, document.title, window.location.pathname);
            $07920574289b7936$export$57e714f81a2c3d86(insidersJWT);
            try {
                // TODO: verify we can get user info from insiders once CORS is fixed
                // const insidersMe = await insiders.me();
                (0, $kFQy0.sendEvent)('login_return_from_insiders_success');
                const res = await (0, $9K8Jg.tokenExchange)(insidersJWT, 'insiders');
                await dispatch((0, $6Jwum.postLogin)());
                if (res.me.profile) navigate((0, $2QyQO.homePath));
                else navigate('/edit-profile');
            } catch (error) {
                // TODO: handle error better, message to user?
                console.error(error);
                (0, $kFQy0.sendEvent)('login_return_from_insiders_error', {
                    message: 'Token exchange or other error'
                });
                setTimeout(()=>{
                    // redirect to home page after 2 seconds (gives us a chance to see error in console)
                    navigate('/');
                }, 2000);
            }
        })();
    }, []);
    return /*#__PURE__*/ (0, $9h2J6.jsx)((0, $9h2J6.Fragment), {});
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $629ccdf7e61e6ac6$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;


// This is a magic string replaced by rollup
const $11f2dd347730754e$export$31499a9cd224b78c = "8.55.0";


/** Get's the global object for the current JavaScript runtime */ const $479da7ad9935be4f$export$f1a6cdb1459e81d1 = globalThis;
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $479da7ad9935be4f$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $479da7ad9935be4f$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const versionedCarrier = __SENTRY__[0, $11f2dd347730754e$export$31499a9cd224b78c] = __SENTRY__[0, $11f2dd347730754e$export$31499a9cd224b78c] || {};
    return versionedCarrier[name] || (versionedCarrier[name] = creator());
}


/** Prefix for logging strings */ const $a717d01b4a49411c$var$PREFIX = 'Sentry Logger ';
const $a717d01b4a49411c$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** This may be mutated by the console instrumentation. */ const $a717d01b4a49411c$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $a717d01b4a49411c$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $479da7ad9935be4f$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $479da7ad9935be4f$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($a717d01b4a49411c$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $a717d01b4a49411c$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $a717d01b4a49411c$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $629ccdf7e61e6ac6$export$16a28057038b10ef) $a717d01b4a49411c$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = (...args)=>{
            if (enabled) $a717d01b4a49411c$export$cda52e2a8927a2ca(()=>{
                (0, $479da7ad9935be4f$export$f1a6cdb1459e81d1).console[name](`${$a717d01b4a49411c$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $a717d01b4a49411c$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 * The logger is a singleton on the carrier, to ensure that a consistent logger is used throughout the SDK.
 */ const $a717d01b4a49411c$export$af88d00dbe7f521 = (0, $479da7ad9935be4f$export$7e223ec222791509)('logger', $a717d01b4a49411c$var$makeLogger);



/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $858edd1d0b71eb30$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $858edd1d0b71eb30$export$c8bfa33e4e8ae492((0, $479da7ad9935be4f$export$f1a6cdb1459e81d1));
    return 0, $479da7ad9935be4f$export$f1a6cdb1459e81d1;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $858edd1d0b71eb30$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $11f2dd347730754e$export$31499a9cd224b78c);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $11f2dd347730754e$export$31499a9cd224b78c] = __SENTRY__[0, $11f2dd347730754e$export$31499a9cd224b78c] || {};
}




// eslint-disable-next-line @typescript-eslint/unbound-method
const $4f37b84063716966$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4f37b84063716966$export$e6127cc7fe7395c3(wat) {
    switch($4f37b84063716966$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
        case '[object WebAssembly.Exception]':
            return true;
        default:
            return $4f37b84063716966$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $4f37b84063716966$var$isBuiltin(wat, className) {
    return $4f37b84063716966$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4f37b84063716966$export$9f9636d330b71954(wat) {
    return $4f37b84063716966$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4f37b84063716966$export$ef9e2056653f0c8e(wat) {
    return $4f37b84063716966$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4f37b84063716966$export$12e869b2a583f783(wat) {
    return $4f37b84063716966$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4f37b84063716966$export$844ec244b1367d54(wat) {
    return $4f37b84063716966$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4f37b84063716966$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4f37b84063716966$export$c3825b437cbdea5c(wat) {
    return wat === null || $4f37b84063716966$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4f37b84063716966$export$53b83ca8eaab0383(wat) {
    return $4f37b84063716966$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4f37b84063716966$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $4f37b84063716966$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4f37b84063716966$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $4f37b84063716966$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4f37b84063716966$export$49841c62b9eff15(wat) {
    return $4f37b84063716966$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $4f37b84063716966$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4f37b84063716966$export$bc2894c7158efbac(wat) {
    return $4f37b84063716966$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $4f37b84063716966$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4f37b84063716966$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}



const $449d8109962016df$var$WINDOW = (0, $479da7ad9935be4f$export$f1a6cdb1459e81d1);
const $449d8109962016df$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $449d8109962016df$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $449d8109962016df$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $449d8109962016df$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $449d8109962016df$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem || !elem.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($449d8109962016df$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
            if (elem.dataset['sentryElement']) return elem.dataset['sentryElement'];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $4f37b84063716966$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for (const k of allowedAttrs){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $449d8109962016df$export$1cfafeee2987818b() {
    try {
        return $449d8109962016df$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existence of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 *
 * @deprecated This method is deprecated and will be removed in the next major version.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $449d8109962016df$export$c660c1f3ab49225c(selector) {
    if ($449d8109962016df$var$WINDOW.document && $449d8109962016df$var$WINDOW.document.querySelector) return $449d8109962016df$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $449d8109962016df$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$449d8109962016df$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
            if (currentElem.dataset['sentryElement']) return currentElem.dataset['sentryElement'];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}






/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $14ff2826de9b0dc6$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $14ff2826de9b0dc6$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $14ff2826de9b0dc6$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $4f37b84063716966$export$7916fad0ebc23f48)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $14ff2826de9b0dc6$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $4f37b84063716966$export$844ec244b1367d54)(value)) return false;
    if ((0, $4f37b84063716966$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $4f37b84063716966$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $14ff2826de9b0dc6$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$14ff2826de9b0dc6$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $6a1d4624574f3aaa$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $6a1d4624574f3aaa$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch (e) {
        (0, $629ccdf7e61e6ac6$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $6a1d4624574f3aaa$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $629ccdf7e61e6ac6$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $6a1d4624574f3aaa$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $6a1d4624574f3aaa$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $6a1d4624574f3aaa$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 *
 * @deprecated This function is deprecated and will be removed in the next major version of the SDK.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $6a1d4624574f3aaa$export$9ef804feabbcbaf1(object) {
    return Object.entries(object).map(([key, value])=>`${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $6a1d4624574f3aaa$export$62ff257738bf57f5(value) {
    if ((0, $4f37b84063716966$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$6a1d4624574f3aaa$var$getOwnProperties(value)
    };
    else if ((0, $4f37b84063716966$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $6a1d4624574f3aaa$var$serializeEventTarget(value.target),
            currentTarget: $6a1d4624574f3aaa$var$serializeEventTarget(value.currentTarget),
            ...$6a1d4624574f3aaa$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $4f37b84063716966$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $6a1d4624574f3aaa$var$serializeEventTarget(target) {
    try {
        return (0, $4f37b84063716966$export$45a5e7f76e0caa8d)(target) ? (0, $449d8109962016df$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $6a1d4624574f3aaa$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $6a1d4624574f3aaa$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($6a1d4624574f3aaa$export$62ff257738bf57f5(exception));
    keys.sort();
    const firstKey = keys[0];
    if (!firstKey) return '[object has no keys]';
    if (firstKey.length >= maxLength) return (0, $14ff2826de9b0dc6$export$6a506b36fdea397d)(firstKey, maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $14ff2826de9b0dc6$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $6a1d4624574f3aaa$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $6a1d4624574f3aaa$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $6a1d4624574f3aaa$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($6a1d4624574f3aaa$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.getOwnPropertyNames(inputValue))if (typeof inputValue[key] !== 'undefined') returnValue[key] = $6a1d4624574f3aaa$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($6a1d4624574f3aaa$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $6a1d4624574f3aaa$var$isPojo(input) {
    if (!(0, $4f37b84063716966$export$53b83ca8eaab0383)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === 'Object';
    } catch (e2) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $6a1d4624574f3aaa$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $4f37b84063716966$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}



const $800d8b2e7e55c7a9$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $800d8b2e7e55c7a9$export$7740643b9eeaf0c4() {
    return Date.now() / $800d8b2e7e55c7a9$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $800d8b2e7e55c7a9$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $479da7ad9935be4f$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) return $800d8b2e7e55c7a9$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $800d8b2e7e55c7a9$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $800d8b2e7e55c7a9$export$ee52dced521e3e18 = $800d8b2e7e55c7a9$var$createUnixTimestampInSecondsFunc();
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 *
 * @deprecated This variable will be removed in the next major version.
 */ let $800d8b2e7e55c7a9$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $800d8b2e7e55c7a9$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $479da7ad9935be4f$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) {
        // eslint-disable-next-line deprecation/deprecation
        $800d8b2e7e55c7a9$export$f9f8cce55af5194c = 'none';
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            // eslint-disable-next-line deprecation/deprecation
            $800d8b2e7e55c7a9$export$f9f8cce55af5194c = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            // eslint-disable-next-line deprecation/deprecation
            $800d8b2e7e55c7a9$export$f9f8cce55af5194c = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    // eslint-disable-next-line deprecation/deprecation
    $800d8b2e7e55c7a9$export$f9f8cce55af5194c = 'dateNow';
    return dateNow;
})();





/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $2e9680120333188a$export$19f53698e68b2496() {
    const gbl = (0, $479da7ad9935be4f$export$f1a6cdb1459e81d1);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $2e9680120333188a$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $2e9680120333188a$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $2e9680120333188a$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $2e9680120333188a$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $2e9680120333188a$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $2e9680120333188a$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $2e9680120333188a$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $2e9680120333188a$var$_parseInt(input) {
    return parseInt(input || '', 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $2e9680120333188a$export$d364f2020ab30578(input) {
    const match = input.match($2e9680120333188a$var$SEMVER_REGEXP) || [];
    const major = $2e9680120333188a$var$_parseInt(match[1]);
    const minor = $2e9680120333188a$var$_parseInt(match[2]);
    const patch = $2e9680120333188a$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $2e9680120333188a$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $14ff2826de9b0dc6$export$4215662d762d6f9d)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $14ff2826de9b0dc6$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $14ff2826de9b0dc6$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $2e9680120333188a$export$6de4ffac6a2f1098(exception) {
    if ($2e9680120333188a$var$isAlreadyCaptured(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $6a1d4624574f3aaa$export$e73679ffaf56810e)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
function $2e9680120333188a$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch (e) {} // eslint-disable-line no-empty
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 *
 * @deprecated This function has been deprecated and will not be replaced.
 */ function $2e9680120333188a$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}



/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $0b5485d74943a693$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $800d8b2e7e55c7a9$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $2e9680120333188a$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$0b5485d74943a693$var$sessionToJSON(session)
    };
    if (context) $0b5485d74943a693$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $0b5485d74943a693$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $800d8b2e7e55c7a9$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $2e9680120333188a$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $0b5485d74943a693$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $0b5485d74943a693$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $0b5485d74943a693$var$sessionToJSON(session) {
    return (0, $6a1d4624574f3aaa$export$d25f2688db1bb433)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}






/**
 * Returns a new minimal propagation context.
 *
 * @deprecated Use `generateTraceId` and `generateSpanId` instead.
 */ function $3d269c2980f5f6b7$export$37f0f2f9cf343e5e() {
    return {
        traceId: $3d269c2980f5f6b7$export$dc6d7ea554bcce10(),
        spanId: $3d269c2980f5f6b7$export$295213bc4d0c54ad()
    };
}
/**
 * Generate a random, valid trace ID.
 */ function $3d269c2980f5f6b7$export$dc6d7ea554bcce10() {
    return (0, $2e9680120333188a$export$19f53698e68b2496)();
}
/**
 * Generate a random, valid span ID.
 */ function $3d269c2980f5f6b7$export$295213bc4d0c54ad() {
    return (0, $2e9680120333188a$export$19f53698e68b2496)().substring(16);
}



/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ function $ee161cc838b4bbe0$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== 'object' || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && mergeObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = {
        ...initialObj
    };
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $ee161cc838b4bbe0$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}



const $0320bd7b7e873b14$var$SCOPE_SPAN_FIELD = '_sentrySpan';
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $0320bd7b7e873b14$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $6a1d4624574f3aaa$export$e73679ffaf56810e)(scope, $0320bd7b7e873b14$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$0320bd7b7e873b14$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $0320bd7b7e873b14$export$91f063ebb8eff307(scope) {
    return scope[$0320bd7b7e873b14$var$SCOPE_SPAN_FIELD];
}


/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $ec5161046273a81e$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information.
 */ class $ec5161046273a81e$var$ScopeClass {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** Request Mode Session Status */ // eslint-disable-next-line deprecation/deprecation
    /** The client on this scope */ /** Contains the last event id of a captured event.  */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $3d269c2980f5f6b7$export$dc6d7ea554bcce10)(),
            spanId: (0, $3d269c2980f5f6b7$export$295213bc4d0c54ad)()
        };
    }
    /**
   * @inheritDoc
   */ clone() {
        const newScope = new $ec5161046273a81e$var$ScopeClass();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        (0, $0320bd7b7e873b14$export$3f25fa50c18e20ca)(newScope, (0, $0320bd7b7e873b14$export$91f063ebb8eff307)(this));
        return newScope;
    }
    /**
   * @inheritDoc
   */ setClient(client) {
        this._client = client;
    }
    /**
   * @inheritDoc
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * @inheritDoc
   */ getClient() {
        return this._client;
    }
    /**
   * @inheritDoc
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $0b5485d74943a693$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        const [scopeInstance, requestSession] = scopeToMerge instanceof $ec5161046273a81e$export$775b6bb06e53a214 ? [
            scopeToMerge.getScopeData(),
            scopeToMerge.getRequestSession()
        ] : (0, $4f37b84063716966$export$53b83ca8eaab0383)(scopeToMerge) ? [
            captureContext,
            captureContext.requestSession
        ] : [];
        const { tags: tags, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (requestSession) this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._session = undefined;
        (0, $0320bd7b7e873b14$export$3f25fa50c18e20ca)(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $3d269c2980f5f6b7$export$dc6d7ea554bcce10)()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $ec5161046273a81e$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $800d8b2e7e55c7a9$export$7740643b9eeaf0c4)(),
            ...breadcrumb
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            if (this._client) this._client.recordDroppedEvent('buffer_overflow', 'log_item');
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $0320bd7b7e873b14$export$91f063ebb8eff307)(this)
        };
    }
    /**
   * @inheritDoc
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $ee161cc838b4bbe0$export$4950aa0f605343fb)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = {
            // eslint-disable-next-line deprecation/deprecation
            spanId: (0, $3d269c2980f5f6b7$export$295213bc4d0c54ad)(),
            ...context
        };
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * @inheritDoc
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $2e9680120333188a$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $a717d01b4a49411c$export$af88d00dbe7f521).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $2e9680120333188a$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $a717d01b4a49411c$export$af88d00dbe7f521).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $2e9680120333188a$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $a717d01b4a49411c$export$af88d00dbe7f521).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Holds additional event information.
 */ const $ec5161046273a81e$export$775b6bb06e53a214 = $ec5161046273a81e$var$ScopeClass;



/** Get the default current scope. */ function $79c539d94267f22a$export$6f1b9191db9c4d5() {
    return (0, $479da7ad9935be4f$export$7e223ec222791509)('defaultCurrentScope', ()=>new (0, $ec5161046273a81e$export$775b6bb06e53a214)());
}
/** Get the default isolation scope. */ function $79c539d94267f22a$export$de9862929b76bf57() {
    return (0, $479da7ad9935be4f$export$7e223ec222791509)('defaultIsolationScope', ()=>new (0, $ec5161046273a81e$export$775b6bb06e53a214)());
}





/**
 * This is an object that holds a stack of scopes.
 */ class $752cf2744728f49e$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $ec5161046273a81e$export$775b6bb06e53a214)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $ec5161046273a81e$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $4f37b84063716966$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $752cf2744728f49e$var$getAsyncContextStack() {
    const registry = (0, $858edd1d0b71eb30$export$19eade501500c6c1)();
    const sentry = (0, $858edd1d0b71eb30$export$c8bfa33e4e8ae492)(registry);
    return sentry.stack = sentry.stack || new $752cf2744728f49e$export$d36ec451f120cfba((0, $79c539d94267f22a$export$6f1b9191db9c4d5)(), (0, $79c539d94267f22a$export$de9862929b76bf57)());
}
function $752cf2744728f49e$var$withScope(callback) {
    return $752cf2744728f49e$var$getAsyncContextStack().withScope(callback);
}
function $752cf2744728f49e$var$withSetScope(scope, callback) {
    const stack = $752cf2744728f49e$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $752cf2744728f49e$var$withIsolationScope(callback) {
    return $752cf2744728f49e$var$getAsyncContextStack().withScope(()=>{
        return callback($752cf2744728f49e$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $752cf2744728f49e$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $752cf2744728f49e$var$withIsolationScope,
        withScope: $752cf2744728f49e$var$withScope,
        withSetScope: $752cf2744728f49e$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $752cf2744728f49e$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$752cf2744728f49e$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$752cf2744728f49e$var$getAsyncContextStack().getIsolationScope()
    };
}


/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $b7a3cd1b6bb1c280$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $858edd1d0b71eb30$export$19eade501500c6c1)();
    const sentry = (0, $858edd1d0b71eb30$export$c8bfa33e4e8ae492)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $b7a3cd1b6bb1c280$export$f639b0c2752203be(carrier) {
    const sentry = (0, $858edd1d0b71eb30$export$c8bfa33e4e8ae492)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $752cf2744728f49e$export$329d4d4d54e42710)();
}






/**
 * Get the currently active scope.
 */ function $e9208597eafee0fc$export$c7be4b0125a10cba() {
    const carrier = (0, $858edd1d0b71eb30$export$19eade501500c6c1)();
    const acs = (0, $b7a3cd1b6bb1c280$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $e9208597eafee0fc$export$68f3af03034c9e90() {
    const carrier = (0, $858edd1d0b71eb30$export$19eade501500c6c1)();
    const acs = (0, $b7a3cd1b6bb1c280$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $e9208597eafee0fc$export$aa55d5ab8e05984f() {
    return (0, $479da7ad9935be4f$export$7e223ec222791509)('globalScope', ()=>new (0, $ec5161046273a81e$export$775b6bb06e53a214)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $e9208597eafee0fc$export$ec58d9285c204497(...rest) {
    const carrier = (0, $858edd1d0b71eb30$export$19eade501500c6c1)();
    const acs = (0, $b7a3cd1b6bb1c280$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $e9208597eafee0fc$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $858edd1d0b71eb30$export$19eade501500c6c1)();
    const acs = (0, $b7a3cd1b6bb1c280$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $e9208597eafee0fc$export$6bb76d6eba7e258c() {
    return $e9208597eafee0fc$export$c7be4b0125a10cba().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function $e9208597eafee0fc$export$1e83db7ee4876dc4(scope) {
    const propagationContext = scope.getPropagationContext();
    // TODO(v9): Use generateSpanId() instead of spanId
    // eslint-disable-next-line deprecation/deprecation
    const { traceId: traceId, spanId: spanId, parentSpanId: parentSpanId } = propagationContext;
    const traceContext = (0, $6a1d4624574f3aaa$export$d25f2688db1bb433)({
        trace_id: traceId,
        span_id: spanId,
        parent_span_id: parentSpanId
    });
    return traceContext;
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $ce80b1f862cc5805$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



const $1cda824cf12ebac7$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function $1cda824cf12ebac7$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function $1cda824cf12ebac7$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    const finalIntegrations = $1cda824cf12ebac7$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = finalIntegrations.findIndex((integration)=>integration.name === 'Debug');
    if (debugIndex > -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $1cda824cf12ebac7$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $1cda824cf12ebac7$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $1cda824cf12ebac7$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $1cda824cf12ebac7$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $ce80b1f862cc5805$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($1cda824cf12ebac7$export$b14a8888f80a0b3e.indexOf(integration.name) === -1 && typeof integration.setupOnce === 'function') {
        integration.setupOnce();
        $1cda824cf12ebac7$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $ce80b1f862cc5805$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function $1cda824cf12ebac7$export$2d8f5188773bcddd(integration) {
    const client = (0, $e9208597eafee0fc$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $ce80b1f862cc5805$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $1cda824cf12ebac7$export$2323046b9414659f(fn) {
    return fn;
}




const $63abfbfec5f1197b$var$STACKTRACE_FRAME_LIMIT = 50;
const $63abfbfec5f1197b$export$27c7e15d453fc0ac = '?';
// Used to sanitize webpack (error: *) wrapped stack errors
const $63abfbfec5f1197b$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $63abfbfec5f1197b$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $63abfbfec5f1197b$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirstLines; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $63abfbfec5f1197b$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($63abfbfec5f1197b$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $63abfbfec5f1197b$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $63abfbfec5f1197b$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $63abfbfec5f1197b$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $63abfbfec5f1197b$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $63abfbfec5f1197b$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($63abfbfec5f1197b$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($63abfbfec5f1197b$var$STRIP_FRAME_REGEXP.test($63abfbfec5f1197b$var$getLastStackFrame(localStack).function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($63abfbfec5f1197b$var$STRIP_FRAME_REGEXP.test($63abfbfec5f1197b$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    }
    return localStack.slice(0, $63abfbfec5f1197b$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $63abfbfec5f1197b$var$getLastStackFrame(localStack).filename,
            function: frame.function || $63abfbfec5f1197b$export$27c7e15d453fc0ac
        }));
}
function $63abfbfec5f1197b$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $63abfbfec5f1197b$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $63abfbfec5f1197b$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $63abfbfec5f1197b$var$defaultFunctionName;
        return fn.name || $63abfbfec5f1197b$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $63abfbfec5f1197b$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $63abfbfec5f1197b$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch (_oO) {
            return undefined;
        }
    }
    return undefined;
}


const $3a2f09745ac925e5$var$INTEGRATION_NAME = 'Dedupe';
const $3a2f09745ac925e5$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $3a2f09745ac925e5$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($3a2f09745ac925e5$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $ce80b1f862cc5805$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const $3a2f09745ac925e5$export$6d39aa44cd0c7567 = (0, $1cda824cf12ebac7$export$2323046b9414659f)($3a2f09745ac925e5$var$_dedupeIntegration);
/** only exported for tests. */ function $3a2f09745ac925e5$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($3a2f09745ac925e5$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($3a2f09745ac925e5$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $3a2f09745ac925e5$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$3a2f09745ac925e5$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$3a2f09745ac925e5$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $3a2f09745ac925e5$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $3a2f09745ac925e5$var$_getExceptionFromEvent(previousEvent);
    const currentException = $3a2f09745ac925e5$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$3a2f09745ac925e5$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$3a2f09745ac925e5$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $3a2f09745ac925e5$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = (0, $63abfbfec5f1197b$export$91d8ca51bd9f6a47)(currentEvent);
    let previousFrames = (0, $63abfbfec5f1197b$export$91d8ca51bd9f6a47)(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameA = previousFrames[i];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $3a2f09745ac925e5$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $3a2f09745ac925e5$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}




let $80abfbff819000c0$var$originalFunctionToString;
const $80abfbff819000c0$var$INTEGRATION_NAME = 'FunctionToString';
const $80abfbff819000c0$var$SETUP_CLIENTS = new WeakMap();
const $80abfbff819000c0$var$_functionToStringIntegration = ()=>{
    return {
        name: $80abfbff819000c0$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $80abfbff819000c0$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $6a1d4624574f3aaa$export$e6cc1e135e2092e5)(this);
                    const context = $80abfbff819000c0$var$SETUP_CLIENTS.has((0, $e9208597eafee0fc$export$6bb76d6eba7e258c)()) && originalFunction !== undefined ? originalFunction : this;
                    return $80abfbff819000c0$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $80abfbff819000c0$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $80abfbff819000c0$export$7918117e9202e4fb = (0, $1cda824cf12ebac7$export$2323046b9414659f)($80abfbff819000c0$var$_functionToStringIntegration);



/** Regular expression used to parse a Dsn. */ const $be5a9d1a1a0f71b0$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $be5a9d1a1a0f71b0$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $be5a9d1a1a0f71b0$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $be5a9d1a1a0f71b0$export$b892860177f70a30(str) {
    const match = $be5a9d1a1a0f71b0$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $a717d01b4a49411c$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host = '', port = '', lastPath = ''] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $be5a9d1a1a0f71b0$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $be5a9d1a1a0f71b0$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $be5a9d1a1a0f71b0$var$validateDsn(dsn) {
    if (!(0, $629ccdf7e61e6ac6$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $a717d01b4a49411c$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $a717d01b4a49411c$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$be5a9d1a1a0f71b0$var$isValidProtocol(protocol)) {
        (0, $a717d01b4a49411c$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $a717d01b4a49411c$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $be5a9d1a1a0f71b0$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $be5a9d1a1a0f71b0$export$b892860177f70a30(from) : $be5a9d1a1a0f71b0$var$dsnFromComponents(from);
    if (!components || !$be5a9d1a1a0f71b0$var$validateDsn(components)) return undefined;
    return components;
}


const $444ac48266b5fb79$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $444ac48266b5fb79$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $444ac48266b5fb79$var$_getIngestEndpoint(dsn) {
    return `${$444ac48266b5fb79$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $444ac48266b5fb79$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $444ac48266b5fb79$var$SENTRY_API_VERSION
    };
    if (dsn.publicKey) // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $444ac48266b5fb79$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$444ac48266b5fb79$var$_getIngestEndpoint(dsn)}?${$444ac48266b5fb79$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $444ac48266b5fb79$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $be5a9d1a1a0f71b0$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$444ac48266b5fb79$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $be5a9d1a1a0f71b0$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}






// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $6e75dbe0bd1dbd36$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    "undefined is not an object (evaluating 'a.L')",
    'can\'t redefine non-configurable property "solana"',
    "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
    "Can't find variable: _AutofillCallbackHandler",
    /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:simulateEvent, ParamCount:\d+$/
];
/** Options for the InboundFilters integration */ const $6e75dbe0bd1dbd36$var$INTEGRATION_NAME = 'InboundFilters';
const $6e75dbe0bd1dbd36$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $6e75dbe0bd1dbd36$var$INTEGRATION_NAME,
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $6e75dbe0bd1dbd36$var$_mergeOptions(options, clientOptions);
            return $6e75dbe0bd1dbd36$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $6e75dbe0bd1dbd36$export$cb3c5c2ceb9818ba = (0, $1cda824cf12ebac7$export$2323046b9414659f)($6e75dbe0bd1dbd36$var$_inboundFiltersIntegration);
function $6e75dbe0bd1dbd36$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $6e75dbe0bd1dbd36$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $6e75dbe0bd1dbd36$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $6e75dbe0bd1dbd36$var$_isSentryError(event)) {
        (0, $ce80b1f862cc5805$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $2e9680120333188a$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($6e75dbe0bd1dbd36$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $ce80b1f862cc5805$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $2e9680120333188a$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($6e75dbe0bd1dbd36$var$_isUselessError(event)) {
        (0, $ce80b1f862cc5805$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${(0, $2e9680120333188a$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($6e75dbe0bd1dbd36$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $ce80b1f862cc5805$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $2e9680120333188a$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($6e75dbe0bd1dbd36$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $ce80b1f862cc5805$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $2e9680120333188a$export$4157119e2b157127)(event)}.\nUrl: ${$6e75dbe0bd1dbd36$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$6e75dbe0bd1dbd36$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $ce80b1f862cc5805$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $2e9680120333188a$export$4157119e2b157127)(event)}.\nUrl: ${$6e75dbe0bd1dbd36$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $6e75dbe0bd1dbd36$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $6e75dbe0bd1dbd36$var$_getPossibleEventMessages(event).some((message)=>(0, $14ff2826de9b0dc6$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $6e75dbe0bd1dbd36$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== 'transaction' || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $14ff2826de9b0dc6$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $6e75dbe0bd1dbd36$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $6e75dbe0bd1dbd36$var$_getEventFilterUrl(event);
    return !url ? false : (0, $14ff2826de9b0dc6$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $6e75dbe0bd1dbd36$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $6e75dbe0bd1dbd36$var$_getEventFilterUrl(event);
    return !url ? true : (0, $14ff2826de9b0dc6$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $6e75dbe0bd1dbd36$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    return possibleMessages;
}
function $6e75dbe0bd1dbd36$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function $6e75dbe0bd1dbd36$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $6e75dbe0bd1dbd36$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $6e75dbe0bd1dbd36$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $ce80b1f862cc5805$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).error(`Cannot extract url for event ${(0, $2e9680120333188a$export$4157119e2b157127)(event)}`);
        return null;
    }
}
function $6e75dbe0bd1dbd36$var$_isUselessError(event) {
    if (event.type) // event is not an error
    return false;
    // We only want to consider events for dropping that actually have recorded exception values.
    if (!event.exception || !event.exception.values || event.exception.values.length === 0) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== 'Error' || value.value));
}




/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $ed55b58cd6a11d78$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $ce80b1f862cc5805$export$16a28057038b10ef) (0, $a717d01b4a49411c$export$af88d00dbe7f521).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $a717d01b4a49411c$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = (0, $e9208597eafee0fc$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $ed55b58cd6a11d78$export$ecb76f41d43c0e43(client);
    client.init();
    return client;
}
/**
 * Make the given client the current client.
 */ function $ed55b58cd6a11d78$export$ecb76f41d43c0e43(client) {
    (0, $e9208597eafee0fc$export$c7be4b0125a10cba)().setClient(client);
}

const $a7fce5c2b00b8746$export$849dbeeeda01ae98 = 'production';
















/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ var $c1726396ad9dcad4$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($c1726396ad9dcad4$var$States || ($c1726396ad9dcad4$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $c1726396ad9dcad4$export$1fda8aa4d135f8aa(value) {
    return new $c1726396ad9dcad4$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $c1726396ad9dcad4$export$78e43115b553f358(reason) {
    return new $c1726396ad9dcad4$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $c1726396ad9dcad4$export$6f292d4960313241 {
    constructor(executor){
        $c1726396ad9dcad4$export$6f292d4960313241.prototype.__init.call(this);
        $c1726396ad9dcad4$export$6f292d4960313241.prototype.__init2.call(this);
        $c1726396ad9dcad4$export$6f292d4960313241.prototype.__init3.call(this);
        $c1726396ad9dcad4$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $c1726396ad9dcad4$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $c1726396ad9dcad4$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $c1726396ad9dcad4$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($c1726396ad9dcad4$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($c1726396ad9dcad4$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $c1726396ad9dcad4$var$States.PENDING) return;
            if ((0, $4f37b84063716966$export$f5b060c2914b97c8)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $c1726396ad9dcad4$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $c1726396ad9dcad4$var$States.RESOLVED) handler[1](this._value);
                if (this._state === $c1726396ad9dcad4$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}


/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $3c1e9911c1f1a3a4$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $c1726396ad9dcad4$export$6f292d4960313241)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== 'function') resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $ce80b1f862cc5805$export$16a28057038b10ef) && processor.id && result === null && (0, $a717d01b4a49411c$export$af88d00dbe7f521).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $4f37b84063716966$export$f5b060c2914b97c8)(result)) result.then((final)=>$3c1e9911c1f1a3a4$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $3c1e9911c1f1a3a4$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}




let $d2507765ab92a6ae$var$parsedStackResults;
let $d2507765ab92a6ae$var$lastKeysCount;
let $d2507765ab92a6ae$var$cachedFilenameDebugIds;
/**
 * Returns a map of filenames to debug identifiers.
 */ function $d2507765ab92a6ae$export$e069fee9c632ed00(stackParser) {
    const debugIdMap = (0, $479da7ad9935be4f$export$f1a6cdb1459e81d1)._sentryDebugIds;
    if (!debugIdMap) return {};
    const debugIdKeys = Object.keys(debugIdMap);
    // If the count of registered globals hasn't changed since the last call, we
    // can just return the cached result.
    if ($d2507765ab92a6ae$var$cachedFilenameDebugIds && debugIdKeys.length === $d2507765ab92a6ae$var$lastKeysCount) return $d2507765ab92a6ae$var$cachedFilenameDebugIds;
    $d2507765ab92a6ae$var$lastKeysCount = debugIdKeys.length;
    // Build a map of filename -> debug_id.
    $d2507765ab92a6ae$var$cachedFilenameDebugIds = debugIdKeys.reduce((acc, stackKey)=>{
        if (!$d2507765ab92a6ae$var$parsedStackResults) $d2507765ab92a6ae$var$parsedStackResults = {};
        const result = $d2507765ab92a6ae$var$parsedStackResults[stackKey];
        if (result) acc[result[0]] = result[1];
        else {
            const parsedStack = stackParser(stackKey);
            for(let i = parsedStack.length - 1; i >= 0; i--){
                const stackFrame = parsedStack[i];
                const filename = stackFrame && stackFrame.filename;
                const debugId = debugIdMap[stackKey];
                if (filename && debugId) {
                    acc[filename] = debugId;
                    $d2507765ab92a6ae$var$parsedStackResults[stackKey] = [
                        filename,
                        debugId
                    ];
                    break;
                }
            }
        }
        return acc;
    }, {});
    return $d2507765ab92a6ae$var$cachedFilenameDebugIds;
}
/**
 * Returns a list of debug images for the given resources.
 */ function $d2507765ab92a6ae$export$5a7368330d9ee6e3(stackParser, resource_paths) {
    const filenameDebugIdMap = $d2507765ab92a6ae$export$e069fee9c632ed00(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths)if (path && filenameDebugIdMap[path]) images.push({
        type: 'sourcemap',
        code_file: path,
        debug_id: filenameDebugIdMap[path]
    });
    return images;
}




/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 *
 * @deprecated This function is deprecated and will be removed in the next major version.
 */ // TODO(v9): Move this function into normalize() directly
function $7d5d2a7aff2d9fb7$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === 'function';
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}




/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $825b10cb3ba5f098$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $825b10cb3ba5f098$var$visit('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $825b10cb3ba5f098$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $825b10cb3ba5f098$export$a3295358bff77e(object, depth);
    if ($825b10cb3ba5f098$var$jsonSize(normalized) > maxSize) return $825b10cb3ba5f098$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $825b10cb3ba5f098$var$visit(key, value, depth = Infinity, maxProperties = Infinity, // eslint-disable-next-line deprecation/deprecation
memo = (0, $7d5d2a7aff2d9fb7$export$8115b0b78e956ab3)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'boolean',
        'string'
    ].includes(typeof value) || typeof value === 'number' && Number.isFinite(value)) return value;
    const stringified = $825b10cb3ba5f098$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $825b10cb3ba5f098$var$visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $6a1d4624574f3aaa$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $825b10cb3ba5f098$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $825b10cb3ba5f098$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $4f37b84063716966$export$7916fad0ebc23f48)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, $4f37b84063716966$export$bc2894c7158efbac)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === 'function') return `[Function: ${(0, $63abfbfec5f1197b$export$aad197c7121a6651)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $825b10cb3ba5f098$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $825b10cb3ba5f098$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $825b10cb3ba5f098$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $825b10cb3ba5f098$var$jsonSize(value) {
    return $825b10cb3ba5f098$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $825b10cb3ba5f098$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}






/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $b2b254adfa66a790$export$d7a7d984b0791405 = 'sentry.source';
/**
 * Use this attribute to represent the sample rate used for a span.
 */ const $b2b254adfa66a790$export$ccfe0a40627cc34b = 'sentry.sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ const $b2b254adfa66a790$export$1a413bd9a88fdb09 = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ const $b2b254adfa66a790$export$cca8dd30f57f805e = 'sentry.origin';
/** The reason why an idle span finished. */ const $b2b254adfa66a790$export$ba73f34502b7a3b3 = 'sentry.idle_span_finish_reason';
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $b2b254adfa66a790$export$f5f95cff026507b5 = 'sentry.measurement_unit';
/** The value of a measurement, which may be stored as a TimedEvent. */ const $b2b254adfa66a790$export$69cd5c610c7bb96a = 'sentry.measurement_value';
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ const $b2b254adfa66a790$export$165ce9a229f6f050 = 'sentry.custom_span_name';
/**
 * The id of the profile that this span occurred in.
 */ const $b2b254adfa66a790$export$1efec95406bbe327 = 'sentry.profile_id';
const $b2b254adfa66a790$export$fea48ba9f4550879 = 'sentry.exclusive_time';
const $b2b254adfa66a790$export$b016f89ac1066ec = 'cache.hit';
const $b2b254adfa66a790$export$3110e4c3f4386399 = 'cache.key';
const $b2b254adfa66a790$export$86be76deee227ff2 = 'cache.item_size';
/** TODO: Remove these once we update to latest semantic conventions */ const $b2b254adfa66a790$export$be7a251980e7e946 = 'http.request.method';
const $b2b254adfa66a790$export$25dfd73e0e32c6e1 = 'url.full';





/**
 * @deprecated Use a `"baggage"` string directly
 */ const $ac51751ecc6d6e7a$export$9ca9946bd449ac06 = 'baggage';
const $ac51751ecc6d6e7a$export$6e69537d67fa20f = 'sentry-';
const $ac51751ecc6d6e7a$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $ac51751ecc6d6e7a$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $ac51751ecc6d6e7a$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $ac51751ecc6d6e7a$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($ac51751ecc6d6e7a$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($ac51751ecc6d6e7a$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $ac51751ecc6d6e7a$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$ac51751ecc6d6e7a$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $ac51751ecc6d6e7a$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $ac51751ecc6d6e7a$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $4f37b84063716966$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $ac51751ecc6d6e7a$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $ac51751ecc6d6e7a$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $ac51751ecc6d6e7a$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $ac51751ecc6d6e7a$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $ac51751ecc6d6e7a$export$bdd844ddb2def819) {
            (0, $629ccdf7e61e6ac6$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}




// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $1c3a01693c5c7a14$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const client = (0, $e9208597eafee0fc$export$6bb76d6eba7e258c)();
    const options = maybeOptions || client && client.getOptions();
    // eslint-disable-next-line deprecation/deprecation
    return !!options && (options.enableTracing || 'tracesSampleRate' in options || 'tracesSampler' in options);
}






/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ const $28b85bb9a51a37d7$var$METRICS_SPAN_FIELD = '_sentryMetrics';
/**
 * Fetches the metric summary if it exists for the passed span
 */ function $28b85bb9a51a37d7$export$2e7205e45c58797d(span) {
    const storage = span[$28b85bb9a51a37d7$var$METRICS_SPAN_FIELD];
    if (!storage) return undefined;
    const output = {};
    for (const [, [exportKey, summary]] of storage){
        const arr = output[exportKey] || (output[exportKey] = []);
        arr.push((0, $6a1d4624574f3aaa$export$d25f2688db1bb433)(summary));
    }
    return output;
}
/**
 * Updates the metric summary on a span.
 */ function $28b85bb9a51a37d7$export$102c7b059b14a4a(span, metricType, sanitizedName, value, unit, tags, bucketKey) {
    const existingStorage = span[$28b85bb9a51a37d7$var$METRICS_SPAN_FIELD];
    const storage = existingStorage || (span[$28b85bb9a51a37d7$var$METRICS_SPAN_FIELD] = new Map());
    const exportKey = `${metricType}:${sanitizedName}@${unit}`;
    const bucketItem = storage.get(bucketKey);
    if (bucketItem) {
        const [, summary] = bucketItem;
        storage.set(bucketKey, [
            exportKey,
            {
                min: Math.min(summary.min, value),
                max: Math.max(summary.max, value),
                count: summary.count += 1,
                sum: summary.sum += value,
                tags: summary.tags
            }
        ]);
    } else storage.set(bucketKey, [
        exportKey,
        {
            min: value,
            max: value,
            count: 1,
            sum: value,
            tags: tags
        }
    ]);
}



const $1fd73d894a0bc924$export$136e25984ba4a383 = 0;
const $1fd73d894a0bc924$export$58f7963109c806fc = 1;
const $1fd73d894a0bc924$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $1fd73d894a0bc924$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $1fd73d894a0bc924$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $1fd73d894a0bc924$export$f966a0446ece71e,
                message: 'unauthenticated'
            };
        case 403:
            return {
                code: $1fd73d894a0bc924$export$f966a0446ece71e,
                message: 'permission_denied'
            };
        case 404:
            return {
                code: $1fd73d894a0bc924$export$f966a0446ece71e,
                message: 'not_found'
            };
        case 409:
            return {
                code: $1fd73d894a0bc924$export$f966a0446ece71e,
                message: 'already_exists'
            };
        case 413:
            return {
                code: $1fd73d894a0bc924$export$f966a0446ece71e,
                message: 'failed_precondition'
            };
        case 429:
            return {
                code: $1fd73d894a0bc924$export$f966a0446ece71e,
                message: 'resource_exhausted'
            };
        case 499:
            return {
                code: $1fd73d894a0bc924$export$f966a0446ece71e,
                message: 'cancelled'
            };
        default:
            return {
                code: $1fd73d894a0bc924$export$f966a0446ece71e,
                message: 'invalid_argument'
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $1fd73d894a0bc924$export$f966a0446ece71e,
                message: 'unimplemented'
            };
        case 503:
            return {
                code: $1fd73d894a0bc924$export$f966a0446ece71e,
                message: 'unavailable'
            };
        case 504:
            return {
                code: $1fd73d894a0bc924$export$f966a0446ece71e,
                message: 'deadline_exceeded'
            };
        default:
            return {
                code: $1fd73d894a0bc924$export$f966a0446ece71e,
                message: 'internal_error'
            };
    }
    return {
        code: $1fd73d894a0bc924$export$f966a0446ece71e,
        message: 'unknown_error'
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $1fd73d894a0bc924$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute('http.response.status_code', httpStatus);
    const spanStatus = $1fd73d894a0bc924$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== 'unknown_error') span.setStatus(spanStatus);
}








// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $d35b410624e4af48$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $d35b410624e4af48$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($d35b410624e4af48$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $d35b410624e4af48$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $d35b410624e4af48$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $ac51751ecc6d6e7a$export$5b96ee2c8421f107)(baggage);
    if (!traceparentData || !traceparentData.traceId) return {
        traceId: (0, $3d269c2980f5f6b7$export$dc6d7ea554bcce10)(),
        spanId: (0, $3d269c2980f5f6b7$export$295213bc4d0c54ad)()
    };
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    const virtualSpanId = (0, $3d269c2980f5f6b7$export$295213bc4d0c54ad)();
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        spanId: virtualSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $d35b410624e4af48$export$f35d907436da45cf(traceId = (0, $3d269c2980f5f6b7$export$dc6d7ea554bcce10)(), spanId = (0, $3d269c2980f5f6b7$export$295213bc4d0c54ad)(), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}



// These are aligned with OpenTelemetry trace flags
const $b8c436eb80b0387f$export$208d5b368507fb8b = 0x0;
const $b8c436eb80b0387f$export$eb571cd9b5d98de8 = 0x1;
// todo(v9): Remove this once we've stopped dropping spans via `beforeSendSpan`
let $b8c436eb80b0387f$var$hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $b8c436eb80b0387f$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin } = $b8c436eb80b0387f$export$92d8c23565496537(span);
    return (0, $6a1d4624574f3aaa$export$d25f2688db1bb433)({
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin
    });
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $b8c436eb80b0387f$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    const parent_span_id = isRemote ? spanId : $b8c436eb80b0387f$export$92d8c23565496537(span).parent_span_id;
    const span_id = isRemote ? (0, $3d269c2980f5f6b7$export$295213bc4d0c54ad)() : spanId;
    return (0, $6a1d4624574f3aaa$export$d25f2688db1bb433)({
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $b8c436eb80b0387f$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $b8c436eb80b0387f$export$5caecac1caaf3a71(span);
    return (0, $d35b410624e4af48$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $b8c436eb80b0387f$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $b8c436eb80b0387f$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $b8c436eb80b0387f$var$ensureTimestampInSeconds(input.getTime());
    return (0, $800d8b2e7e55c7a9$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $b8c436eb80b0387f$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $b8c436eb80b0387f$export$92d8c23565496537(span) {
    if ($b8c436eb80b0387f$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    try {
        const { spanId: span_id, traceId: trace_id } = span.spanContext();
        // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
        if ($b8c436eb80b0387f$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
            const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, parentSpanId: parentSpanId, status: status } = span;
            return (0, $6a1d4624574f3aaa$export$d25f2688db1bb433)({
                span_id: span_id,
                trace_id: trace_id,
                data: attributes,
                description: name,
                parent_span_id: parentSpanId,
                start_timestamp: $b8c436eb80b0387f$export$3f7581298f56c6d7(startTime),
                // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
                timestamp: $b8c436eb80b0387f$export$3f7581298f56c6d7(endTime) || undefined,
                status: $b8c436eb80b0387f$export$e238a77ea3a8cd66(status),
                op: attributes[0, $b2b254adfa66a790$export$1a413bd9a88fdb09],
                origin: attributes[0, $b2b254adfa66a790$export$cca8dd30f57f805e],
                _metrics_summary: (0, $28b85bb9a51a37d7$export$2e7205e45c58797d)(span)
            });
        }
        // Finally, at least we have `spanContext()`....
        return {
            span_id: span_id,
            trace_id: trace_id
        };
    } catch (e) {
        return {};
    }
}
function $b8c436eb80b0387f$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $b8c436eb80b0387f$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $b8c436eb80b0387f$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $b8c436eb80b0387f$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $b8c436eb80b0387f$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $1fd73d894a0bc924$export$136e25984ba4a383)) return undefined;
    if (status.code === (0, $1fd73d894a0bc924$export$58f7963109c806fc)) return 'ok';
    return status.message || 'unknown_error';
}
const $b8c436eb80b0387f$var$CHILD_SPANS_FIELD = '_sentryChildSpans';
const $b8c436eb80b0387f$var$ROOT_SPAN_FIELD = '_sentryRootSpan';
/**
 * Adds an opaque child span reference to a span.
 */ function $b8c436eb80b0387f$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$b8c436eb80b0387f$var$ROOT_SPAN_FIELD] || span;
    (0, $6a1d4624574f3aaa$export$e73679ffaf56810e)(childSpan, $b8c436eb80b0387f$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$b8c436eb80b0387f$var$CHILD_SPANS_FIELD]) span[$b8c436eb80b0387f$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $6a1d4624574f3aaa$export$e73679ffaf56810e)(span, $b8c436eb80b0387f$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $b8c436eb80b0387f$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$b8c436eb80b0387f$var$CHILD_SPANS_FIELD]) span[$b8c436eb80b0387f$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $b8c436eb80b0387f$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($b8c436eb80b0387f$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$b8c436eb80b0387f$var$CHILD_SPANS_FIELD] ? Array.from(span[$b8c436eb80b0387f$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function $b8c436eb80b0387f$export$c4c6a79b1260ca1b(span) {
    return span[$b8c436eb80b0387f$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $b8c436eb80b0387f$export$1be426a8e585c83e() {
    const carrier = (0, $858edd1d0b71eb30$export$19eade501500c6c1)();
    const acs = (0, $b7a3cd1b6bb1c280$export$f639b0c2752203be)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $0320bd7b7e873b14$export$91f063ebb8eff307)((0, $e9208597eafee0fc$export$c7be4b0125a10cba)());
}
/**
 * Updates the metric summary on the currently active span
 */ function $b8c436eb80b0387f$export$aefd1a302602f922(metricType, sanitizedName, value, unit, tags, bucketKey) {
    const span = $b8c436eb80b0387f$export$1be426a8e585c83e();
    if (span) (0, $28b85bb9a51a37d7$export$102c7b059b14a4a)(span, metricType, sanitizedName, value, unit, tags, bucketKey);
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 *
 * todo(v9): Remove this once we've stopped dropping spans via `beforeSendSpan`.
 */ function $b8c436eb80b0387f$export$d11691ff45a3e535() {
    if (!$b8c436eb80b0387f$var$hasShownSpanDropWarning) {
        (0, $a717d01b4a49411c$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Deprecation warning: Returning null from `beforeSendSpan` will be disallowed from SDK version 9.0.0 onwards. The callback will only support mutating spans. To drop certain spans, configure the respective integrations directly.');
        });
        $b8c436eb80b0387f$var$hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function $b8c436eb80b0387f$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $b2b254adfa66a790$export$d7a7d984b0791405)]: 'custom',
        [(0, $b2b254adfa66a790$export$165ce9a229f6f050)]: name
    });
}


/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $95f32642ea8c4924$var$FROZEN_DSC_FIELD = '_frozenDsc';
/**
 * Freeze the given DSC on the given span.
 */ function $95f32642ea8c4924$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $6a1d4624574f3aaa$export$e73679ffaf56810e)(spanWithMaybeDsc, $95f32642ea8c4924$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $95f32642ea8c4924$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const dsc = (0, $6a1d4624574f3aaa$export$d25f2688db1bb433)({
        environment: options.environment || (0, $a7fce5c2b00b8746$export$849dbeeeda01ae98),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit('createDsc', dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function $95f32642ea8c4924$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $95f32642ea8c4924$export$366bad00d6815eed(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $95f32642ea8c4924$export$a117f995597e25df(span) {
    const client = (0, $e9208597eafee0fc$export$6bb76d6eba7e258c)();
    if (!client) return {};
    const rootSpan = (0, $b8c436eb80b0387f$export$c4c6a79b1260ca1b)(span);
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$95f32642ea8c4924$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return frozenDsc;
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceState = rootSpan.spanContext().traceState;
    const traceStateDsc = traceState && traceState.get('sentry.dsc');
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, $ac51751ecc6d6e7a$export$5b96ee2c8421f107)(traceStateDsc);
    if (dscOnTraceState) return dscOnTraceState;
    // Else, we generate it from the span
    const dsc = $95f32642ea8c4924$export$366bad00d6815eed(span.spanContext().traceId, client);
    const jsonSpan = (0, $b8c436eb80b0387f$export$92d8c23565496537)(rootSpan);
    const attributes = jsonSpan.data || {};
    const maybeSampleRate = attributes[0, $b2b254adfa66a790$export$ccfe0a40627cc34b];
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = attributes[0, $b2b254adfa66a790$export$d7a7d984b0791405];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = jsonSpan.description;
    if (source !== 'url' && name) dsc.transaction = name;
    // How can we even land here with hasTracingEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, $1c3a01693c5c7a14$export$5008da00b1b6dee6)()) dsc.sampled = String((0, $b8c436eb80b0387f$export$5caecac1caaf3a71)(rootSpan));
    client.emit('createDsc', dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $95f32642ea8c4924$export$95cf936fdacaff7b(span) {
    const dsc = $95f32642ea8c4924$export$a117f995597e25df(span);
    return (0, $ac51751ecc6d6e7a$export$56766feef403f365)(dsc);
}





/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $24384a9a2933490e$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $24384a9a2933490e$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $24384a9a2933490e$var$applySpanToEvent(event, span);
    $24384a9a2933490e$var$applyFingerprintToEvent(event, fingerprint);
    $24384a9a2933490e$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $24384a9a2933490e$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $24384a9a2933490e$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $24384a9a2933490e$export$b1a120a2871faa46(data, 'extra', extra);
    $24384a9a2933490e$export$b1a120a2871faa46(data, 'tags', tags);
    $24384a9a2933490e$export$b1a120a2871faa46(data, 'user', user);
    $24384a9a2933490e$export$b1a120a2871faa46(data, 'contexts', contexts);
    data.sdkProcessingMetadata = (0, $ee161cc838b4bbe0$export$4950aa0f605343fb)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $24384a9a2933490e$export$b1a120a2871faa46(data, prop, mergeVal) {
    data[prop] = (0, $ee161cc838b4bbe0$export$4950aa0f605343fb)(data[prop], mergeVal, 1);
}
function $24384a9a2933490e$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    const cleanedExtra = (0, $6a1d4624574f3aaa$export$d25f2688db1bb433)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $6a1d4624574f3aaa$export$d25f2688db1bb433)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $6a1d4624574f3aaa$export$d25f2688db1bb433)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $6a1d4624574f3aaa$export$d25f2688db1bb433)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== 'transaction') event.transaction = transactionName;
}
function $24384a9a2933490e$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $24384a9a2933490e$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $24384a9a2933490e$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $b8c436eb80b0387f$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, $95f32642ea8c4924$export$a117f995597e25df)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, $b8c436eb80b0387f$export$c4c6a79b1260ca1b)(span);
    const transactionName = (0, $b8c436eb80b0387f$export$92d8c23565496537)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === 'transaction') event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $24384a9a2933490e$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}


/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $5a74faf8234bd19b$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $2e9680120333188a$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $800d8b2e7e55c7a9$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $5a74faf8234bd19b$export$d7e04067a6fbc882(prepared, options);
    $5a74faf8234bd19b$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit('applyFrameMetadata', event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $5a74faf8234bd19b$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $5a74faf8234bd19b$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $2e9680120333188a$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $e9208597eafee0fc$export$aa55d5ab8e05984f)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $24384a9a2933490e$export$25ac7e259a513db4)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $24384a9a2933490e$export$25ac7e259a513db4)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $24384a9a2933490e$export$43988bc651a80216)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $3c1e9911c1f1a3a4$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $5a74faf8234bd19b$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $5a74faf8234bd19b$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 * Enhances event using the client configuration.
 * It takes care of all "static" values like environment, release and `dist`,
 * as well as truncating overly long values.
 *
 * Only exported for tests.
 *
 * @param event event instance to be enhanced
 */ function $5a74faf8234bd19b$export$d7e04067a6fbc882(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    // empty strings do not make sense for environment, release, and dist
    // so we handle them the same as if they were not provided
    event.environment = event.environment || environment || (0, $a7fce5c2b00b8746$export$849dbeeeda01ae98);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    if (event.message) event.message = (0, $14ff2826de9b0dc6$export$6a506b36fdea397d)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $14ff2826de9b0dc6$export$6a506b36fdea397d)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $14ff2826de9b0dc6$export$6a506b36fdea397d)(request.url, maxValueLength);
}
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $5a74faf8234bd19b$export$63042efc86f043e7(event, stackParser) {
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = (0, $d2507765ab92a6ae$export$e069fee9c632ed00)(stackParser);
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (filenameDebugIdMap && frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $5a74faf8234bd19b$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $5a74faf8234bd19b$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $5a74faf8234bd19b$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $825b10cb3ba5f098$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $825b10cb3ba5f098$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $825b10cb3ba5f098$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $825b10cb3ba5f098$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $825b10cb3ba5f098$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, $825b10cb3ba5f098$export$a3295358bff77e)(span.data, depth, maxBreadth)
            }
        };
    });
    // event.contexts.flags (FeatureFlagContext) stores context for our feature
    // flag integrations. It has a greater nesting depth than our other typed
    // Contexts, so we re-normalize with a fixed depth of 3 here. We do not want
    // to skip this in case of conflicting, user-provided context.
    if (event.contexts && event.contexts.flags && normalized.contexts) normalized.contexts.flags = (0, $825b10cb3ba5f098$export$a3295358bff77e)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $5a74faf8234bd19b$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $ec5161046273a81e$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $5a74faf8234bd19b$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($5a74faf8234bd19b$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($5a74faf8234bd19b$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $5a74faf8234bd19b$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $ec5161046273a81e$export$775b6bb06e53a214) || typeof hint === 'function';
}
const $5a74faf8234bd19b$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'requestSession',
    'propagationContext'
];
function $5a74faf8234bd19b$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$5a74faf8234bd19b$var$captureContextKeys.includes(key));
}


/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $43aeef54481eeaf4$export$f5282963edea4a68(exception, hint) {
    return (0, $e9208597eafee0fc$export$c7be4b0125a10cba)().captureException(exception, (0, $5a74faf8234bd19b$export$76b5f966996d1653)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $43aeef54481eeaf4$export$45654777c133ae80(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return (0, $e9208597eafee0fc$export$c7be4b0125a10cba)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $43aeef54481eeaf4$export$1462b974fdcf6ba2(event, hint) {
    return (0, $e9208597eafee0fc$export$c7be4b0125a10cba)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ function $43aeef54481eeaf4$export$2f04de43fe27971a(name, context) {
    (0, $e9208597eafee0fc$export$68f3af03034c9e90)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $43aeef54481eeaf4$export$bb4922da0dd51b92(extras) {
    (0, $e9208597eafee0fc$export$68f3af03034c9e90)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $43aeef54481eeaf4$export$8e8e7789d42ed61d(key, extra) {
    (0, $e9208597eafee0fc$export$68f3af03034c9e90)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $43aeef54481eeaf4$export$74a8fb34822092e6(tags) {
    (0, $e9208597eafee0fc$export$68f3af03034c9e90)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $43aeef54481eeaf4$export$a37d07ee78eb4569(key, value) {
    (0, $e9208597eafee0fc$export$68f3af03034c9e90)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $43aeef54481eeaf4$export$8b6bb3dd62a01be2(user) {
    (0, $e9208597eafee0fc$export$68f3af03034c9e90)().setUser(user);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $43aeef54481eeaf4$export$5d4e9fd7fac8e617() {
    return (0, $e9208597eafee0fc$export$68f3af03034c9e90)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $43aeef54481eeaf4$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $e9208597eafee0fc$export$c7be4b0125a10cba)();
    const client = (0, $e9208597eafee0fc$export$6bb76d6eba7e258c)();
    if (!client) (0, $ce80b1f862cc5805$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $ce80b1f862cc5805$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $2e9680120333188a$export$19f53698e68b2496)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $43aeef54481eeaf4$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $43aeef54481eeaf4$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    const now = (0, $800d8b2e7e55c7a9$export$ee52dced521e3e18)();
    function finishCheckIn(status) {
        $43aeef54481eeaf4$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $800d8b2e7e55c7a9$export$ee52dced521e3e18)() - now
        });
    }
    return (0, $e9208597eafee0fc$export$9a4fed82c350c2bd)(()=>{
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn('error');
            throw e;
        }
        if ((0, $4f37b84063716966$export$f5b060c2914b97c8)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
            finishCheckIn('ok');
        }, (e)=>{
            finishCheckIn('error');
            throw e;
        });
        else finishCheckIn('ok');
        return maybePromiseResult;
    });
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $43aeef54481eeaf4$export$4909b86c8034bf73(timeout) {
    const client = (0, $e9208597eafee0fc$export$6bb76d6eba7e258c)();
    if (client) return client.flush(timeout);
    (0, $ce80b1f862cc5805$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $43aeef54481eeaf4$export$8360e631d277ea4d(timeout) {
    const client = (0, $e9208597eafee0fc$export$6bb76d6eba7e258c)();
    if (client) return client.close(timeout);
    (0, $ce80b1f862cc5805$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $43aeef54481eeaf4$export$3f95c6f800b78024() {
    return !!(0, $e9208597eafee0fc$export$6bb76d6eba7e258c)();
}
/** If the SDK is initialized & enabled. */ function $43aeef54481eeaf4$export$3b029eb57ac4d562() {
    const client = (0, $e9208597eafee0fc$export$6bb76d6eba7e258c)();
    return !!client && client.getOptions().enabled !== false && !!client.getTransport();
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $43aeef54481eeaf4$export$9aac0b9f77928fbf(callback) {
    (0, $e9208597eafee0fc$export$68f3af03034c9e90)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $43aeef54481eeaf4$export$c0d84948cecf78d8(context) {
    const client = (0, $e9208597eafee0fc$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $e9208597eafee0fc$export$68f3af03034c9e90)();
    const currentScope = (0, $e9208597eafee0fc$export$c7be4b0125a10cba)();
    const { release: release, environment: environment = (0, $a7fce5c2b00b8746$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $479da7ad9935be4f$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $0b5485d74943a693$export$14a186326edbb264)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === 'ok') (0, $0b5485d74943a693$export$531818e825e774db)(currentSession, {
        status: 'exited'
    });
    $43aeef54481eeaf4$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $43aeef54481eeaf4$export$17a5be43989a0bc1() {
    const isolationScope = (0, $e9208597eafee0fc$export$68f3af03034c9e90)();
    const currentScope = (0, $e9208597eafee0fc$export$c7be4b0125a10cba)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $0b5485d74943a693$export$56521d9ba90f62ee)(session);
    $43aeef54481eeaf4$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $43aeef54481eeaf4$var$_sendSessionUpdate() {
    const isolationScope = (0, $e9208597eafee0fc$export$68f3af03034c9e90)();
    const currentScope = (0, $e9208597eafee0fc$export$c7be4b0125a10cba)();
    const client = (0, $e9208597eafee0fc$export$6bb76d6eba7e258c)();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $43aeef54481eeaf4$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $43aeef54481eeaf4$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $43aeef54481eeaf4$var$_sendSessionUpdate();
}




const $a84b06d600ba3b53$var$WINDOW = (0, $479da7ad9935be4f$export$f1a6cdb1459e81d1);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $a84b06d600ba3b53$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $a84b06d600ba3b53$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $a84b06d600ba3b53$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $a84b06d600ba3b53$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in $a84b06d600ba3b53$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $a84b06d600ba3b53$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $a84b06d600ba3b53$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$a84b06d600ba3b53$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($a84b06d600ba3b53$export$d5f608b368e73f38($a84b06d600ba3b53$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $a84b06d600ba3b53$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $a84b06d600ba3b53$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $629ccdf7e61e6ac6$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $a84b06d600ba3b53$export$531055a6c684a70a() {
    return 'ReportingObserver' in $a84b06d600ba3b53$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $a84b06d600ba3b53$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$a84b06d600ba3b53$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}



/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $3bec1e9292365c31$export$b9f95b027256052c(options, name, names = [
    name
], source = 'npm') {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $11f2dd347730754e$export$31499a9cd224b78c)
            })),
        version: (0, $11f2dd347730754e$export$31499a9cd224b78c)
    };
    options._metadata = metadata;
}










/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $26698d7fedb3cc5a$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $26698d7fedb3cc5a$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $26698d7fedb3cc5a$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $26698d7fedb3cc5a$export$604a45d95a155e2b(envelope, types) {
    return $26698d7fedb3cc5a$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $26698d7fedb3cc5a$var$encodeUTF8(input) {
    return (0, $479da7ad9935be4f$export$f1a6cdb1459e81d1).__SENTRY__ && (0, $479da7ad9935be4f$export$f1a6cdb1459e81d1).__SENTRY__.encodePolyfill ? (0, $479da7ad9935be4f$export$f1a6cdb1459e81d1).__SENTRY__.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $26698d7fedb3cc5a$var$decodeUTF8(input) {
    return (0, $479da7ad9935be4f$export$f1a6cdb1459e81d1).__SENTRY__ && (0, $479da7ad9935be4f$export$f1a6cdb1459e81d1).__SENTRY__.decodePolyfill ? (0, $479da7ad9935be4f$export$f1a6cdb1459e81d1).__SENTRY__.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $26698d7fedb3cc5a$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $26698d7fedb3cc5a$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === 'string' ? $26698d7fedb3cc5a$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $825b10cb3ba5f098$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $26698d7fedb3cc5a$var$concatBuffers(parts);
}
function $26698d7fedb3cc5a$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $26698d7fedb3cc5a$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === 'string' ? $26698d7fedb3cc5a$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($26698d7fedb3cc5a$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $26698d7fedb3cc5a$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $26698d7fedb3cc5a$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === 'string' ? $26698d7fedb3cc5a$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        (0, $6a1d4624574f3aaa$export$d25f2688db1bb433)({
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $26698d7fedb3cc5a$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    profile_chunk: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    statsd: 'metric_bucket',
    raw_security: 'security'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $26698d7fedb3cc5a$export$b11169581eeaf237(type) {
    return $26698d7fedb3cc5a$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $26698d7fedb3cc5a$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $26698d7fedb3cc5a$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $be5a9d1a1a0f71b0$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $6a1d4624574f3aaa$export$d25f2688db1bb433)({
                ...dynamicSamplingContext
            })
        }
    };
}





/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $0e5291ff1b955f5d$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $0e5291ff1b955f5d$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $26698d7fedb3cc5a$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $be5a9d1a1a0f71b0$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $26698d7fedb3cc5a$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $0e5291ff1b955f5d$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $26698d7fedb3cc5a$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $0e5291ff1b955f5d$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $26698d7fedb3cc5a$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $26698d7fedb3cc5a$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $0e5291ff1b955f5d$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $95f32642ea8c4924$export$a117f995597e25df)(spans[0]);
    const dsn = client && client.getDsn();
    const tunnel = client && client.getOptions().tunnel;
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $be5a9d1a1a0f71b0$export$44d472fbb931a776)(dsn)
        }
    };
    const beforeSendSpan = client && client.getOptions().beforeSendSpan;
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = beforeSendSpan((0, $b8c436eb80b0387f$export$92d8c23565496537)(span));
        if (!spanJson) (0, $b8c436eb80b0387f$export$d11691ff45a3e535)();
        return spanJson;
    } : (span)=>(0, $b8c436eb80b0387f$export$92d8c23565496537)(span);
    const items = [];
    for (const span of spans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $26698d7fedb3cc5a$export$655cf139bc8b8afd)(spanJson));
    }
    return (0, $26698d7fedb3cc5a$export$f93f7f385160c44e)(headers, items);
}







/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $8c2350c2676edaae$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $800d8b2e7e55c7a9$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $26698d7fedb3cc5a$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}




/** An error emitted by Sentry SDKs and related utilities. */ class $f7c45771658ede16$export$5949942ba2a7c0e2 extends Error {
    constructor(message, logLevel = 'warn'){
        super(message);
        this.message = message;
        this.logLevel = logLevel;
    }
}








/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $6cef5dd8e315efcf$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === 'boolean') return Number(sampleRate);
    const rate = typeof sampleRate === 'string' ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== 'number' || isNaN(rate) || rate < 0 || rate > 1) {
        (0, $ce80b1f862cc5805$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return undefined;
    }
    return rate;
}




const $f17118e6eed36725$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $f17118e6eed36725$export$4f22f74eddb7716a {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $be5a9d1a1a0f71b0$export$128827c3562ec0cb)(options.dsn);
        else (0, $ce80b1f862cc5805$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = (0, $444ac48266b5fb79$export$9964600bfe84e6a3)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
        // TODO(v9): Remove this deprecation warning
        const tracingOptions = [
            'enableTracing',
            'tracesSampleRate',
            'tracesSampler'
        ];
        const undefinedOption = tracingOptions.find((option)=>option in options && options[option] == undefined);
        if (undefinedOption) (0, $a717d01b4a49411c$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn(`[Sentry] Deprecation warning: \`${undefinedOption}\` is set to undefined, which leads to tracing being enabled. In v9, a value of \`undefined\` will result in tracing being disabled.`);
        });
    }
    /**
   * @inheritDoc
   */ captureException(exception, hint, scope) {
        const eventId = (0, $2e9680120333188a$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if ((0, $2e9680120333188a$export$6de4ffac6a2f1098)(exception)) {
            (0, $ce80b1f862cc5805$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).log($f17118e6eed36725$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: (0, $2e9680120333188a$export$19f53698e68b2496)(),
            ...hint
        };
        const eventMessage = (0, $4f37b84063716966$export$dbcbffa59149b824)(message) ? message : String(message);
        const promisedEvent = (0, $4f37b84063716966$export$c3825b437cbdea5c)(message) ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $2e9680120333188a$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $2e9680120333188a$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $ce80b1f862cc5805$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).log($f17118e6eed36725$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === 'string')) (0, $ce80b1f862cc5805$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).warn('Discarded session because of missing or non-string release');
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $0b5485d74943a693$export$531818e825e774db)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            this.emit('flush');
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $c1726396ad9dcad4$export$1fda8aa4d135f8aa)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            this.emit('close');
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith('Spotlight'))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $1cda824cf12ebac7$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $1cda824cf12ebac7$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        let env = (0, $0e5291ff1b955f5d$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $26698d7fedb3cc5a$export$d650323442802f6f)(env, (0, $26698d7fedb3cc5a$export$d8fc80952cc31fa4)(attachment));
        const promise = this.sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $0e5291ff1b955f5d$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, eventOrCount) {
        if (this._options.sendClientReports) {
            // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
            // If event is passed as third argument, we assume this is a count of 1
            const count = typeof eventOrCount === 'number' ? eventOrCount : 1;
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $ce80b1f862cc5805$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        const hooks = this._hooks[hook] = this._hooks[hook] || [];
        // @ts-expect-error We assume the types are correct
        hooks.push(callback);
        // This function returns a callback execution handler that, when invoked,
        // deregisters a callback. This is crucial for managing instances where callbacks
        // need to be unregistered to prevent self-referencing in callback closures,
        // ensuring proper garbage collection.
        return ()=>{
            // @ts-expect-error We assume the types are correct
            const cbIndex = hooks.indexOf(callback);
            if (cbIndex > -1) hooks.splice(cbIndex, 1);
        };
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * @inheritdoc
   */ sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $ce80b1f862cc5805$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).error('Error while sending envelope:', reason);
            return reason;
        });
        (0, $ce80b1f862cc5805$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).error('Transport disabled');
        return (0, $c1726396ad9dcad4$export$1fda8aa4d135f8aa)({});
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $1cda824cf12ebac7$export$51abed9797baa598)(this, integrations);
        (0, $1cda824cf12ebac7$export$35abcfd71227c6ca)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = event.level === 'fatal';
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $0b5485d74943a693$export$531818e825e774db)(session, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $c1726396ad9dcad4$export$6f292d4960313241)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope = (0, $e9208597eafee0fc$export$c7be4b0125a10cba)(), isolationScope = (0, $e9208597eafee0fc$export$68f3af03034c9e90)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $5a74faf8234bd19b$export$2d67fb380bd11267)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            evt.contexts = {
                trace: (0, $e9208597eafee0fc$export$1e83db7ee4876dc4)(currentScope),
                ...evt.contexts
            };
            const dynamicSamplingContext = (0, $95f32642ea8c4924$export$89ef1736f08c6b2b)(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $ce80b1f862cc5805$export$16a28057038b10ef) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                if (reason instanceof (0, $f7c45771658ede16$export$5949942ba2a7c0e2) && reason.logLevel === 'log') (0, $a717d01b4a49411c$export$af88d00dbe7f521).log(reason.message);
                else (0, $a717d01b4a49411c$export$af88d00dbe7f521).warn(reason);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $f17118e6eed36725$var$isTransactionEvent(event);
        const isError = $f17118e6eed36725$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === 'undefined' ? undefined : (0, $6cef5dd8e315efcf$export$a5bd2d81656d9546)(sampleRate);
        if (isError && typeof parsedSampleRate === 'number' && Math.random() > parsedSampleRate) {
            this.recordDroppedEvent('sample_rate', 'error', event);
            return (0, $c1726396ad9dcad4$export$78e43115b553f358)(new (0, $f7c45771658ede16$export$5949942ba2a7c0e2)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, 'log'));
        }
        const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, currentScope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory, event);
                throw new (0, $f7c45771658ede16$export$5949942ba2a7c0e2)('An event processor returned `null`, will not send event.', 'log');
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $f17118e6eed36725$var$processBeforeSend(this, options, prepared, hint);
            return $f17118e6eed36725$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory, event);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent('before_send', 'span', spanCount);
                }
                throw new (0, $f7c45771658ede16$export$5949942ba2a7c0e2)(`${beforeSendLabel} returned \`null\`, will not send event.`, 'log');
            }
            const session = currentScope && currentScope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $f7c45771658ede16$export$5949942ba2a7c0e2)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $f7c45771658ede16$export$5949942ba2a7c0e2)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        (0, $ce80b1f862cc5805$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).log('Flushing outcomes...');
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $ce80b1f862cc5805$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $ce80b1f862cc5805$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $ce80b1f862cc5805$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).log('Sending outcomes:', outcomes);
        const envelope = (0, $8c2350c2676edaae$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $be5a9d1a1a0f71b0$export$44d472fbb931a776)(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $f17118e6eed36725$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $4f37b84063716966$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $4f37b84063716966$export$53b83ca8eaab0383)(event) && event !== null) throw new (0, $f7c45771658ede16$export$5949942ba2a7c0e2)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $f7c45771658ede16$export$5949942ba2a7c0e2)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $4f37b84063716966$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw new (0, $f7c45771658ede16$export$5949942ba2a7c0e2)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $f17118e6eed36725$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, beforeSendSpan: beforeSendSpan } = options;
    if ($f17118e6eed36725$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($f17118e6eed36725$var$isTransactionEvent(event)) {
        if (event.spans && beforeSendSpan) {
            const processedSpans = [];
            for (const span of event.spans){
                const processedSpan = beforeSendSpan(span);
                if (processedSpan) processedSpans.push(processedSpan);
                else {
                    (0, $b8c436eb80b0387f$export$d11691ff45a3e535)();
                    client.recordDroppedEvent('before_send', 'span');
                }
            }
            event.spans = processedSpans;
        }
        if (beforeSendTransaction) {
            if (event.spans) {
                // We store the # of spans before processing in SDK metadata,
                // so we can compare it afterwards to determine how many spans were dropped
                const spanCountBefore = event.spans.length;
                event.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(event, hint);
        }
    }
    return event;
}
function $f17118e6eed36725$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $f17118e6eed36725$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}

/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $3f368c0f0643520e$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $3f368c0f0643520e$export$8ad33f488b1ab046() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return 'npm';
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $0e996bae691863ee$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



/**
 * This function creates an exception from a JavaScript Error
 */ function $1da8766e1b99c7cc$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $1da8766e1b99c7cc$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $1da8766e1b99c7cc$export$2e9ae379995d99e3(ex),
        value: $1da8766e1b99c7cc$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $1da8766e1b99c7cc$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $e9208597eafee0fc$export$6bb76d6eba7e258c)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    const errorFromProp = $1da8766e1b99c7cc$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $825b10cb3ba5f098$export$23fbbb20bed71033)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $1da8766e1b99c7cc$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $4f37b84063716966$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $1da8766e1b99c7cc$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $1da8766e1b99c7cc$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $1da8766e1b99c7cc$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $1da8766e1b99c7cc$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $1da8766e1b99c7cc$var$parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const skipLines = $1da8766e1b99c7cc$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $1da8766e1b99c7cc$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $1da8766e1b99c7cc$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function $1da8766e1b99c7cc$var$getSkipFirstStackStringLines(ex) {
    if (ex && $1da8766e1b99c7cc$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function $1da8766e1b99c7cc$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === 'number') return ex.framesToPop;
    return 0;
}
// https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Exception
// @ts-expect-error - WebAssembly.Exception is a valid class
function $1da8766e1b99c7cc$var$isWebAssemblyException(exception) {
    // Check for support
    // @ts-expect-error - WebAssembly.Exception is a valid class
    if (typeof WebAssembly !== 'undefined' && typeof WebAssembly.Exception !== 'undefined') // @ts-expect-error - WebAssembly.Exception is a valid class
    return exception instanceof WebAssembly.Exception;
    else return false;
}
/**
 * Extracts from errors what we use as the exception `type` in error events.
 *
 * Usually, this is the `name` property on Error objects but WASM errors need to be treated differently.
 */ function $1da8766e1b99c7cc$export$2e9ae379995d99e3(ex) {
    const name = ex && ex.name;
    // The name for WebAssembly.Exception Errors needs to be extracted differently.
    // Context: https://github.com/getsentry/sentry-javascript/issues/13787
    if (!name && $1da8766e1b99c7cc$var$isWebAssemblyException(ex)) {
        // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : 'WebAssembly.Exception';
    }
    return name;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $1da8766e1b99c7cc$export$86005d1b62804363(ex) {
    const message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
    if ($1da8766e1b99c7cc$var$isWebAssemblyException(ex) && Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $1da8766e1b99c7cc$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $1da8766e1b99c7cc$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $2e9680120333188a$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $c1726396ad9dcad4$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $1da8766e1b99c7cc$export$5425b53185d13d6c(stackParser, message, level = 'info', hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $1da8766e1b99c7cc$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $c1726396ad9dcad4$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $1da8766e1b99c7cc$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $4f37b84063716966$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $1da8766e1b99c7cc$var$eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $4f37b84063716966$export$ef9e2056653f0c8e)(exception) || (0, $4f37b84063716966$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $1da8766e1b99c7cc$var$eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, $4f37b84063716966$export$ef9e2056653f0c8e)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $1da8766e1b99c7cc$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $2e9680120333188a$export$f26508487bf83ee7)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $4f37b84063716966$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $1da8766e1b99c7cc$var$eventFromError(stackParser, exception);
    if ((0, $4f37b84063716966$export$53b83ca8eaab0383)(exception) || (0, $4f37b84063716966$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $1da8766e1b99c7cc$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $2e9680120333188a$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $1da8766e1b99c7cc$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $2e9680120333188a$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $2e9680120333188a$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
function $1da8766e1b99c7cc$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $1da8766e1b99c7cc$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $2e9680120333188a$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
    }
    if ((0, $4f37b84063716966$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $1da8766e1b99c7cc$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $6a1d4624574f3aaa$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $4f37b84063716966$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $4f37b84063716966$export$9671ea99bd126ace)(exception)) {
        const className = $1da8766e1b99c7cc$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $1da8766e1b99c7cc$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function $1da8766e1b99c7cc$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}



const $2b2d0a1c21fe7bdf$export$56d8a8a25bd48b81 = (0, $479da7ad9935be4f$export$f1a6cdb1459e81d1);
let $2b2d0a1c21fe7bdf$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $2b2d0a1c21fe7bdf$export$b79738ab10c590b2() {
    return $2b2d0a1c21fe7bdf$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $2b2d0a1c21fe7bdf$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $2b2d0a1c21fe7bdf$var$ignoreOnError++;
    setTimeout(()=>{
        $2b2d0a1c21fe7bdf$var$ignoreOnError--;
    });
}
// eslint-disable-next-line @typescript-eslint/ban-types
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $2b2d0a1c21fe7bdf$export$4997ffc0176396a6(fn, options = {}) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    function isFunction(fn) {
        return typeof fn === 'function';
    }
    if (!isFunction(fn)) return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $6a1d4624574f3aaa$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    // Wrap the function itself
    // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function(...args) {
        try {
            // Also wrap arguments that are themselves functions
            const wrappedArguments = args.map((arg)=>$2b2d0a1c21fe7bdf$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $2b2d0a1c21fe7bdf$export$1265a142ff5ba165();
            (0, $e9208597eafee0fc$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $2e9680120333188a$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $2e9680120333188a$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $43aeef54481eeaf4$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    // Wrap the wrapped function in a proxy, to ensure any other properties of the original function remain available
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (e2) {
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    }
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $6a1d4624574f3aaa$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $6a1d4624574f3aaa$export$e73679ffaf56810e)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    } catch (e3) {
    // This may throw if e.g. the descriptor does not exist, or a browser does not allow redefining `name`.
    // to save some bytes we simply try-catch this
    }
    return sentryWrapped;
}



/**
 * Creates an envelope from a user feedback.
 */ function $130fe7f65e6fda9e$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $be5a9d1a1a0f71b0$export$44d472fbb931a776)(dsn)
        }
    };
    const item = $130fe7f65e6fda9e$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $26698d7fedb3cc5a$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $130fe7f65e6fda9e$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: 'user_report'
    };
    return [
        feedbackHeaders,
        feedback
    ];
}


/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/core Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $b151be20c7fe4635$export$1df9218a526d318d extends (0, $f17118e6eed36725$export$4f22f74eddb7716a) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = {
            // We default this to true, as it is the safer scenario
            parentSpanIsAlwaysRootSpan: true,
            ...options
        };
        const sdkSource = (0, $2b2d0a1c21fe7bdf$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $3f368c0f0643520e$export$8ad33f488b1ab046)();
        (0, $3bec1e9292365c31$export$b9f95b027256052c)(opts, 'browser', [
            'browser'
        ], sdkSource);
        super(opts);
        if (opts.sendClientReports && (0, $2b2d0a1c21fe7bdf$export$56d8a8a25bd48b81).document) (0, $2b2d0a1c21fe7bdf$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
            if ((0, $2b2d0a1c21fe7bdf$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $1da8766e1b99c7cc$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = 'info', hint) {
        return (0, $1da8766e1b99c7cc$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   *
   * @deprecated Use `captureFeedback` instead.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $0e996bae691863ee$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).warn('SDK not enabled, will not capture user feedback.');
            return;
        }
        const envelope = (0, $130fe7f65e6fda9e$export$24a4dfcb686ee5bf)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, scope);
    }
}







// We keep the handlers globally
const $75bd5499c4f39959$var$handlers = {};
const $75bd5499c4f39959$var$instrumented = {};
/** Add a handler function. */ function $75bd5499c4f39959$export$a4e09611e30da72e(type, handler) {
    $75bd5499c4f39959$var$handlers[type] = $75bd5499c4f39959$var$handlers[type] || [];
    $75bd5499c4f39959$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $75bd5499c4f39959$export$b17eab759a1cb5fe() {
    Object.keys($75bd5499c4f39959$var$handlers).forEach((key)=>{
        $75bd5499c4f39959$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $75bd5499c4f39959$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$75bd5499c4f39959$var$instrumented[type]) {
        $75bd5499c4f39959$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $629ccdf7e61e6ac6$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $75bd5499c4f39959$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $75bd5499c4f39959$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $629ccdf7e61e6ac6$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $63abfbfec5f1197b$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}



const $54d853a2c181922c$export$56d8a8a25bd48b81 = (0, $479da7ad9935be4f$export$f1a6cdb1459e81d1);


const $af7baaa65e488145$var$DEBOUNCE_DURATION = 1000;
let $af7baaa65e488145$var$debounceTimerID;
let $af7baaa65e488145$var$lastCapturedEventType;
let $af7baaa65e488145$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $af7baaa65e488145$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $75bd5499c4f39959$export$a4e09611e30da72e)(type, handler);
    (0, $75bd5499c4f39959$export$e18d6c5462c01368)(type, $af7baaa65e488145$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $af7baaa65e488145$export$3014bbf0af0e1d4a() {
    if (!(0, $54d853a2c181922c$export$56d8a8a25bd48b81).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $75bd5499c4f39959$export$b18c893e424d3127).bind(null, 'dom');
    const globalDOMEventHandler = $af7baaa65e488145$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $54d853a2c181922c$export$56d8a8a25bd48b81).document.addEventListener('click', globalDOMEventHandler, false);
    (0, $54d853a2c181922c$export$56d8a8a25bd48b81).document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        const globalObject = (0, $54d853a2c181922c$export$56d8a8a25bd48b81);
        const targetObj = globalObject[target];
        const proto = targetObj && targetObj.prototype;
        // eslint-disable-next-line no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $6a1d4624574f3aaa$export$9563e054e6f787fb)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $af7baaa65e488145$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $6a1d4624574f3aaa$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $af7baaa65e488145$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $af7baaa65e488145$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $af7baaa65e488145$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $af7baaa65e488145$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $af7baaa65e488145$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $af7baaa65e488145$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($af7baaa65e488145$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $6a1d4624574f3aaa$export$e73679ffaf56810e)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $6a1d4624574f3aaa$export$e73679ffaf56810e)(target, '_sentryId', (0, $2e9680120333188a$export$19f53698e68b2496)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$af7baaa65e488145$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $af7baaa65e488145$var$lastCapturedEventType = event.type;
            $af7baaa65e488145$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($af7baaa65e488145$var$debounceTimerID);
        $af7baaa65e488145$var$debounceTimerID = (0, $54d853a2c181922c$export$56d8a8a25bd48b81).setTimeout(()=>{
            $af7baaa65e488145$var$lastCapturedEventTargetId = undefined;
            $af7baaa65e488145$var$lastCapturedEventType = undefined;
        }, $af7baaa65e488145$var$DEBOUNCE_DURATION);
    };
}
function $af7baaa65e488145$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}


// Based on https://github.com/angular/angular.js/pull/13945/files
// The MIT License
const $c0c2bd9ddc1cf8b9$var$WINDOW = (0, $479da7ad9935be4f$export$f1a6cdb1459e81d1);
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $c0c2bd9ddc1cf8b9$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    // TODO(v9): Remove this custom check, it is pretty old and likely not needed anymore
    const chromeVar = $c0c2bd9ddc1cf8b9$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    const hasHistoryApi = 'history' in $c0c2bd9ddc1cf8b9$var$WINDOW && !!$c0c2bd9ddc1cf8b9$var$WINDOW.history.pushState && !!$c0c2bd9ddc1cf8b9$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}



let $5bce4403790211f7$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $5bce4403790211f7$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $75bd5499c4f39959$export$a4e09611e30da72e)(type, handler);
    (0, $75bd5499c4f39959$export$e18d6c5462c01368)(type, $5bce4403790211f7$var$instrumentHistory);
}
function $5bce4403790211f7$var$instrumentHistory() {
    if (!(0, $c0c2bd9ddc1cf8b9$export$67fc34576016d6ec)()) return;
    const oldOnPopState = (0, $54d853a2c181922c$export$56d8a8a25bd48b81).onpopstate;
    (0, $54d853a2c181922c$export$56d8a8a25bd48b81).onpopstate = function(...args) {
        const to = (0, $54d853a2c181922c$export$56d8a8a25bd48b81).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $5bce4403790211f7$var$lastHref;
        $5bce4403790211f7$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $75bd5499c4f39959$export$b18c893e424d3127)('history', handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $5bce4403790211f7$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $5bce4403790211f7$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $75bd5499c4f39959$export$b18c893e424d3127)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $6a1d4624574f3aaa$export$9563e054e6f787fb)((0, $54d853a2c181922c$export$56d8a8a25bd48b81).history, 'pushState', historyReplacementFunction);
    (0, $6a1d4624574f3aaa$export$9563e054e6f787fb)((0, $54d853a2c181922c$export$56d8a8a25bd48b81).history, 'replaceState', historyReplacementFunction);
}



const $dc5e87ffed001ed6$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $dc5e87ffed001ed6$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $75bd5499c4f39959$export$a4e09611e30da72e)(type, handler);
    (0, $75bd5499c4f39959$export$e18d6c5462c01368)(type, $dc5e87ffed001ed6$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $dc5e87ffed001ed6$export$c67d533bf77cbf54() {
    if (!(0, $54d853a2c181922c$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your XHR call did not
            //       have a stack trace. If you are using HttpClient integration,
            //       this is the expected behavior, as we are using this virtual error to capture
            //       the location of your XHR call, and group your HttpClient events accordingly.
            const virtualError = new Error();
            const startTimestamp = (0, $800d8b2e7e55c7a9$export$ee52dced521e3e18)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $4f37b84063716966$export$844ec244b1367d54)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : undefined;
            const url = $dc5e87ffed001ed6$var$parseUrl(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$dc5e87ffed001ed6$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = xhrOpenThisArg[$dc5e87ffed001ed6$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        endTimestamp: (0, $800d8b2e7e55c7a9$export$ee52dced521e3e18)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $75bd5499c4f39959$export$b18c893e424d3127)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === 'function') xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$dc5e87ffed001ed6$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $4f37b84063716966$export$844ec244b1367d54)(header) && (0, $4f37b84063716966$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$dc5e87ffed001ed6$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== undefined) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $800d8b2e7e55c7a9$export$ee52dced521e3e18)() * 1000,
                xhr: sendThisArg
            };
            (0, $75bd5499c4f39959$export$b18c893e424d3127)('xhr', handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
function $dc5e87ffed001ed6$var$parseUrl(url) {
    if ((0, $4f37b84063716966$export$844ec244b1367d54)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}





/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $70ab6b058a71fdde$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $70ab6b058a71fdde$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $e9208597eafee0fc$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $e9208597eafee0fc$export$68f3af03034c9e90)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $70ab6b058a71fdde$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $800d8b2e7e55c7a9$export$7740643b9eeaf0c4)();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, $a717d01b4a49411c$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}





/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $c3697b37bad5f190$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $75bd5499c4f39959$export$a4e09611e30da72e)(type, handler);
    (0, $75bd5499c4f39959$export$e18d6c5462c01368)(type, $c3697b37bad5f190$var$instrumentConsole);
}
function $c3697b37bad5f190$var$instrumentConsole() {
    if (!('console' in (0, $479da7ad9935be4f$export$f1a6cdb1459e81d1))) return;
    (0, $a717d01b4a49411c$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $479da7ad9935be4f$export$f1a6cdb1459e81d1).console)) return;
        (0, $6a1d4624574f3aaa$export$9563e054e6f787fb)((0, $479da7ad9935be4f$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $a717d01b4a49411c$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $75bd5499c4f39959$export$b18c893e424d3127)('console', handlerData);
                const log = (0, $a717d01b4a49411c$export$77c4ce905194557b)[level];
                log && log.apply((0, $479da7ad9935be4f$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}







/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $9a45d58afcd77971$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = 'fetch';
    (0, $75bd5499c4f39959$export$a4e09611e30da72e)(type, handler);
    (0, $75bd5499c4f39959$export$e18d6c5462c01368)(type, ()=>$9a45d58afcd77971$var$instrumentFetch(undefined, skipNativeFetchCheck));
}
/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 *
 * Only used internally
 * @hidden
 */ function $9a45d58afcd77971$export$1a79663eb318fe6a(handler) {
    const type = 'fetch-body-resolved';
    (0, $75bd5499c4f39959$export$a4e09611e30da72e)(type, handler);
    (0, $75bd5499c4f39959$export$e18d6c5462c01368)(type, ()=>$9a45d58afcd77971$var$instrumentFetch($9a45d58afcd77971$var$streamHandler));
}
function $9a45d58afcd77971$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $a84b06d600ba3b53$export$c82d238e23c40b21)()) return;
    (0, $6a1d4624574f3aaa$export$9563e054e6f787fb)((0, $479da7ad9935be4f$export$f1a6cdb1459e81d1), 'fetch', function(originalFetch) {
        return function(...args) {
            // We capture the error right here and not in the Promise error callback because Safari (and probably other
            // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your fetch call did not
            //       have a stack trace, so the SDK backfilled the stack trace so
            //       you can see which fetch call failed.
            const virtualError = new Error();
            const { method: method, url: url } = $9a45d58afcd77971$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $800d8b2e7e55c7a9$export$ee52dced521e3e18)() * 1000,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError
            };
            // if there is no callback, fetch is instrumented directly
            if (!onFetchResolved) (0, $75bd5499c4f39959$export$b18c893e424d3127)('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $479da7ad9935be4f$export$f1a6cdb1459e81d1), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $75bd5499c4f39959$export$b18c893e424d3127)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $800d8b2e7e55c7a9$export$ee52dced521e3e18)() * 1000,
                    response: response
                });
                return response;
            }, (error)=>{
                (0, $75bd5499c4f39959$export$b18c893e424d3127)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $800d8b2e7e55c7a9$export$ee52dced521e3e18)() * 1000,
                    error: error
                });
                if ((0, $4f37b84063716966$export$e6127cc7fe7395c3)(error) && error.stack === undefined) {
                    // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                    //       it means the error, that was caused by your fetch call did not
                    //       have a stack trace, so the SDK backfilled the stack trace so
                    //       you can see which fetch call failed.
                    error.stack = virtualError.stack;
                    (0, $6a1d4624574f3aaa$export$e73679ffaf56810e)(error, 'framesToPop', 1);
                }
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
async function $9a45d58afcd77971$var$resolveResponse(res, onFinishedResolving) {
    if (res && res.body) {
        const body = res.body;
        const responseReader = body.getReader();
        // Define a maximum duration after which we just cancel
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{
            // noop
            });
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                // abort reading if read op takes more than 5s
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{
                    // noop on error
                    });
                }, 5000);
                // This .read() call will reject/throw when we abort due to timeouts through `body.cancel()`
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch (error) {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{
        // noop on error
        });
    }
}
function $9a45d58afcd77971$var$streamHandler(response) {
    // clone response for awaiting stream
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch (e) {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $9a45d58afcd77971$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $75bd5499c4f39959$export$b18c893e424d3127)('fetch-body-resolved', {
            endTimestamp: (0, $800d8b2e7e55c7a9$export$ee52dced521e3e18)() * 1000,
            response: response
        });
    });
}
function $9a45d58afcd77971$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $9a45d58afcd77971$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($9a45d58afcd77971$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $9a45d58afcd77971$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $9a45d58afcd77971$var$getUrlFromResource(url),
            method: $9a45d58afcd77971$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $9a45d58afcd77971$var$getUrlFromResource(arg),
        method: $9a45d58afcd77971$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}

/**
 * Determine a breadcrumb's log level (only `warning` or `error`) based on an HTTP status code.
 */ function $61b92dd0f3164af4$export$b8cfcc4175694bcc(statusCode) {
    // NOTE: undefined defaults to 'info' in Sentry
    if (statusCode === undefined) return undefined;
    else if (statusCode >= 400 && statusCode < 500) return 'warning';
    else if (statusCode >= 500) return 'error';
    else return undefined;
}

/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $8019e9a2471c088b$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $8019e9a2471c088b$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 *
 * @deprecated This function will be removed in the next major version.
 */ // TODO(v9): Hoist this function into the places where we use it. (as it stands only react router v6 instrumentation)
function $8019e9a2471c088b$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ',').length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $8019e9a2471c088b$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, '[filtered]:[filtered]@')// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}

/**
 * @deprecated This variable has been deprecated and will be removed in the next major version.
 */ const $b6a58e6263539a38$export$411d0ffdba845b6c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug'
];
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $b6a58e6263539a38$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : [
        'fatal',
        'error',
        'warning',
        'log',
        'info',
        'debug'
    ].includes(level) ? level : 'log';
}




/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $01402fe201124ce1$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $01402fe201124ce1$var$INTEGRATION_NAME = 'Breadcrumbs';
const $01402fe201124ce1$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $01402fe201124ce1$var$INTEGRATION_NAME,
        setup (client) {
            if (_options.console) (0, $c3697b37bad5f190$export$1d6e0d073f9e6723)($01402fe201124ce1$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $af7baaa65e488145$export$5aeffd3db2cf9df7)($01402fe201124ce1$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $dc5e87ffed001ed6$export$26ace48dd54c9aea)($01402fe201124ce1$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $9a45d58afcd77971$export$f75d3c772c923df0)($01402fe201124ce1$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $5bce4403790211f7$export$3f18c56c58114e75)($01402fe201124ce1$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on('beforeSendEvent', $01402fe201124ce1$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $01402fe201124ce1$export$c079d904b326663a = (0, $1cda824cf12ebac7$export$2323046b9414659f)($01402fe201124ce1$var$_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $01402fe201124ce1$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $e9208597eafee0fc$export$6bb76d6eba7e258c)() !== client) return;
        (0, $70ab6b058a71fdde$export$efda9a273d7a036d)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $2e9680120333188a$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creates a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $01402fe201124ce1$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $e9208597eafee0fc$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $01402fe201124ce1$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $0e996bae691863ee$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).warn(`\`dom.maxStringLength\` cannot exceed ${$01402fe201124ce1$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$01402fe201124ce1$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $01402fe201124ce1$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $01402fe201124ce1$var$_isEvent(event) ? event.target : event;
            target = (0, $449d8109962016df$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $449d8109962016df$export$26727cfcc4d7e0fc)(element);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $70ab6b058a71fdde$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $01402fe201124ce1$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $e9208597eafee0fc$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $b6a58e6263539a38$export$d771ef054122c30a)(handlerData.level),
            message: (0, $14ff2826de9b0dc6$export$465e9d514283d4fd)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $14ff2826de9b0dc6$export$465e9d514283d4fd)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $70ab6b058a71fdde$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $01402fe201124ce1$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $e9208597eafee0fc$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $dc5e87ffed001ed6$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const level = (0, $61b92dd0f3164af4$export$b8cfcc4175694bcc)(status_code);
        (0, $70ab6b058a71fdde$export$efda9a273d7a036d)({
            category: 'xhr',
            data: data,
            type: 'http',
            level: level
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $01402fe201124ce1$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $e9208597eafee0fc$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $70ab6b058a71fdde$export$efda9a273d7a036d)({
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const level = (0, $61b92dd0f3164af4$export$b8cfcc4175694bcc)(data.status_code);
            (0, $70ab6b058a71fdde$export$efda9a273d7a036d)({
                category: 'fetch',
                data: data,
                type: 'http',
                level: level
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $01402fe201124ce1$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $e9208597eafee0fc$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $8019e9a2471c088b$export$7a5253c0f62e0150)((0, $2b2d0a1c21fe7bdf$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $8019e9a2471c088b$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $8019e9a2471c088b$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $70ab6b058a71fdde$export$efda9a273d7a036d)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $01402fe201124ce1$var$_isEvent(event) {
    return !!event && !!event.target;
}




const $7d8b85f40086340c$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
const $7d8b85f40086340c$var$INTEGRATION_NAME = 'BrowserApiErrors';
const $7d8b85f40086340c$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $7d8b85f40086340c$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $6a1d4624574f3aaa$export$9563e054e6f787fb)((0, $2b2d0a1c21fe7bdf$export$56d8a8a25bd48b81), 'setTimeout', $7d8b85f40086340c$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $6a1d4624574f3aaa$export$9563e054e6f787fb)((0, $2b2d0a1c21fe7bdf$export$56d8a8a25bd48b81), 'setInterval', $7d8b85f40086340c$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $6a1d4624574f3aaa$export$9563e054e6f787fb)((0, $2b2d0a1c21fe7bdf$export$56d8a8a25bd48b81), 'requestAnimationFrame', $7d8b85f40086340c$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $2b2d0a1c21fe7bdf$export$56d8a8a25bd48b81)) (0, $6a1d4624574f3aaa$export$9563e054e6f787fb)(XMLHttpRequest.prototype, 'send', $7d8b85f40086340c$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $7d8b85f40086340c$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($7d8b85f40086340c$var$_wrapEventTarget);
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ const $7d8b85f40086340c$export$59bfe9f1c76150e = (0, $1cda824cf12ebac7$export$2323046b9414659f)($7d8b85f40086340c$var$_browserApiErrorsIntegration);
function $7d8b85f40086340c$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $2b2d0a1c21fe7bdf$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $63abfbfec5f1197b$export$aad197c7121a6651)(original)
                },
                handled: false,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
function $7d8b85f40086340c$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $2b2d0a1c21fe7bdf$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $63abfbfec5f1197b$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: 'instrument'
                }
            })
        ]);
    };
}
function $7d8b85f40086340c$var$_wrapXHR(originalSend) {
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') (0, $6a1d4624574f3aaa$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $63abfbfec5f1197b$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                const originalFunction = (0, $6a1d4624574f3aaa$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $63abfbfec5f1197b$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $2b2d0a1c21fe7bdf$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $7d8b85f40086340c$var$_wrapEventTarget(target) {
    const globalObject = (0, $2b2d0a1c21fe7bdf$export$56d8a8a25bd48b81);
    const targetObj = globalObject[target];
    const proto = targetObj && targetObj.prototype;
    // eslint-disable-next-line no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $6a1d4624574f3aaa$export$9563e054e6f787fb)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if ($7d8b85f40086340c$var$isEventListenerObject(fn)) // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $2b2d0a1c21fe7bdf$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $63abfbfec5f1197b$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                });
            } catch (e2) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                (0, $2b2d0a1c21fe7bdf$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $63abfbfec5f1197b$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $6a1d4624574f3aaa$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
       * There are 2 possible scenarios here:
       *
       * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
       * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
       * as a pass-through, and call original `removeEventListener` with it.
       *
       * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
       * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
       * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
       * in order for us to make a distinction between wrapped/non-wrapped functions possible.
       * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
       *
       * When someone adds a handler prior to initialization, and then do it again, but after,
       * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
       * to get rid of the initial handler and it'd stick there forever.
       */ try {
                const originalEventHandler = fn.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $7d8b85f40086340c$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === 'function';
}






/**
 * When added, automatically creates sessions which allow you to track adoption and crashes (crash free rate) in your Releases in Sentry.
 * More information: https://docs.sentry.io/product/releases/health/
 *
 * Note: In order for session tracking to work, you need to set up Releases: https://docs.sentry.io/product/releases/
 */ const $5107ce4c84efe64d$export$1baa7880e357371c = (0, $1cda824cf12ebac7$export$2323046b9414659f)(()=>{
    return {
        name: 'BrowserSession',
        setupOnce () {
            if (typeof (0, $2b2d0a1c21fe7bdf$export$56d8a8a25bd48b81).document === 'undefined') {
                (0, $0e996bae691863ee$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).warn('Using the `browserSessionIntegration` in non-browser environments is not supported.');
                return;
            }
            // The session duration for browser sessions does not track a meaningful
            // concept that can be used as a metric.
            // Automatically captured sessions are akin to page views, and thus we
            // discard their duration.
            (0, $43aeef54481eeaf4$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            (0, $43aeef54481eeaf4$export$667e7b4d445d566b)();
            // We want to create a session for every navigation as well
            (0, $5bce4403790211f7$export$3f18c56c58114e75)(({ from: from, to: to })=>{
                // Don't create an additional session for the initial route or if the location did not change
                if (from !== undefined && from !== to) {
                    (0, $43aeef54481eeaf4$export$c0d84948cecf78d8)({
                        ignoreDuration: true
                    });
                    (0, $43aeef54481eeaf4$export$667e7b4d445d566b)();
                }
            });
        }
    };
});




let $f97c5612e203a07e$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $f97c5612e203a07e$export$55b5c3ba2194f0c6(handler) {
    const type = 'error';
    (0, $75bd5499c4f39959$export$a4e09611e30da72e)(type, handler);
    (0, $75bd5499c4f39959$export$e18d6c5462c01368)(type, $f97c5612e203a07e$var$instrumentError);
}
function $f97c5612e203a07e$var$instrumentError() {
    $f97c5612e203a07e$var$_oldOnErrorHandler = (0, $479da7ad9935be4f$export$f1a6cdb1459e81d1).onerror;
    // Note: The reason we are doing window.onerror instead of window.addEventListener('error')
    // is that we are using this handler in the Loader Script, to handle buffered errors consistently
    (0, $479da7ad9935be4f$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $75bd5499c4f39959$export$b18c893e424d3127)('error', handlerData);
        if ($f97c5612e203a07e$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $f97c5612e203a07e$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $479da7ad9935be4f$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}



let $50a788584f759f5f$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $50a788584f759f5f$export$8bf4fc6858821a4e(handler) {
    const type = 'unhandledrejection';
    (0, $75bd5499c4f39959$export$a4e09611e30da72e)(type, handler);
    (0, $75bd5499c4f39959$export$e18d6c5462c01368)(type, $50a788584f759f5f$var$instrumentUnhandledRejection);
}
function $50a788584f759f5f$var$instrumentUnhandledRejection() {
    $50a788584f759f5f$var$_oldOnUnhandledRejectionHandler = (0, $479da7ad9935be4f$export$f1a6cdb1459e81d1).onunhandledrejection;
    // Note: The reason we are doing window.onunhandledrejection instead of window.addEventListener('unhandledrejection')
    // is that we are using this handler in the Loader Script, to handle buffered rejections consistently
    (0, $479da7ad9935be4f$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $75bd5499c4f39959$export$b18c893e424d3127)('unhandledrejection', handlerData);
        if ($50a788584f759f5f$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $50a788584f759f5f$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $479da7ad9935be4f$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





const $5c1262fe8641acb3$var$INTEGRATION_NAME = 'GlobalHandlers';
const $5c1262fe8641acb3$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $5c1262fe8641acb3$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $5c1262fe8641acb3$var$_installGlobalOnErrorHandler(client);
                $5c1262fe8641acb3$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $5c1262fe8641acb3$var$_installGlobalOnUnhandledRejectionHandler(client);
                $5c1262fe8641acb3$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $5c1262fe8641acb3$export$66acc70e8cf2b71a = (0, $1cda824cf12ebac7$export$2323046b9414659f)($5c1262fe8641acb3$var$_globalHandlersIntegration);
function $5c1262fe8641acb3$var$_installGlobalOnErrorHandler(client) {
    (0, $f97c5612e203a07e$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $5c1262fe8641acb3$var$getOptions();
        if ((0, $e9208597eafee0fc$export$6bb76d6eba7e258c)() !== client || (0, $2b2d0a1c21fe7bdf$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $5c1262fe8641acb3$var$_enhanceEventWithInitialFrame((0, $1da8766e1b99c7cc$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $43aeef54481eeaf4$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onerror'
            }
        });
    });
}
function $5c1262fe8641acb3$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $50a788584f759f5f$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $5c1262fe8641acb3$var$getOptions();
        if ((0, $e9208597eafee0fc$export$6bb76d6eba7e258c)() !== client || (0, $2b2d0a1c21fe7bdf$export$b79738ab10c590b2)()) return;
        const error = $5c1262fe8641acb3$var$_getUnhandledRejectionError(e);
        const event = (0, $4f37b84063716966$export$c3825b437cbdea5c)(error) ? $5c1262fe8641acb3$var$_eventFromRejectionWithPrimitive(error) : (0, $1da8766e1b99c7cc$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $43aeef54481eeaf4$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onunhandledrejection'
            }
        });
    });
}
function $5c1262fe8641acb3$var$_getUnhandledRejectionError(error) {
    if ((0, $4f37b84063716966$export$c3825b437cbdea5c)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ('detail' in error && 'reason' in error.detail) return error.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $5c1262fe8641acb3$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $5c1262fe8641acb3$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = column;
    const lineno = line;
    const filename = (0, $4f37b84063716966$export$844ec244b1367d54)(url) && url.length > 0 ? url : (0, $449d8109962016df$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: (0, $63abfbfec5f1197b$export$27c7e15d453fc0ac),
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $5c1262fe8641acb3$var$globalHandlerLog(type) {
    (0, $0e996bae691863ee$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).log(`Global Handler attached: ${type}`);
}
function $5c1262fe8641acb3$var$getOptions() {
    const client = (0, $e9208597eafee0fc$export$6bb76d6eba7e258c)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}




/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ const $5ec3105ecf7683d0$export$1378794447170364 = (0, $1cda824cf12ebac7$export$2323046b9414659f)(()=>{
    return {
        name: 'HttpContext',
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $2b2d0a1c21fe7bdf$export$56d8a8a25bd48b81).navigator && !(0, $2b2d0a1c21fe7bdf$export$56d8a8a25bd48b81).location && !(0, $2b2d0a1c21fe7bdf$export$56d8a8a25bd48b81).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $2b2d0a1c21fe7bdf$export$56d8a8a25bd48b81).location && (0, $2b2d0a1c21fe7bdf$export$56d8a8a25bd48b81).location.href;
            const { referrer: referrer } = (0, $2b2d0a1c21fe7bdf$export$56d8a8a25bd48b81).document || {};
            const { userAgent: userAgent } = (0, $2b2d0a1c21fe7bdf$export$56d8a8a25bd48b81).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    'User-Agent': userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
});




/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $9665c90a04150946$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $4f37b84063716966$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $9665c90a04150946$var$truncateAggregateExceptions($9665c90a04150946$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $9665c90a04150946$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $4f37b84063716966$export$49034edbe6b62415)(error[key], Error)) {
        $9665c90a04150946$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $9665c90a04150946$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $9665c90a04150946$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $4f37b84063716966$export$49034edbe6b62415)(childError, Error)) {
            $9665c90a04150946$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $9665c90a04150946$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $9665c90a04150946$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $9665c90a04150946$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === 'AggregateError' && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $9665c90a04150946$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $9665c90a04150946$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $14ff2826de9b0dc6$export$6a506b36fdea397d)(exception.value, maxValueLength);
        return exception;
    });
}



const $cc9ea6cd4201269f$var$DEFAULT_KEY = 'cause';
const $cc9ea6cd4201269f$var$DEFAULT_LIMIT = 5;
const $cc9ea6cd4201269f$var$INTEGRATION_NAME = 'LinkedErrors';
const $cc9ea6cd4201269f$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $cc9ea6cd4201269f$var$DEFAULT_LIMIT;
    const key = options.key || $cc9ea6cd4201269f$var$DEFAULT_KEY;
    return {
        name: $cc9ea6cd4201269f$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $9665c90a04150946$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $1da8766e1b99c7cc$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ const $cc9ea6cd4201269f$export$ebabb00eb7f3a395 = (0, $1cda824cf12ebac7$export$2323046b9414659f)($cc9ea6cd4201269f$var$_linkedErrorsIntegration);



// This was originally forked from https://github.com/csnover/TraceKit, and was largely
// re - written as part of raven - js.
//
// This code was later copied to the JavaScript mono - repo and further modified and
// refactored over the years.
const $1894cf0a33c4a780$var$OPERA10_PRIORITY = 10;
const $1894cf0a33c4a780$var$OPERA11_PRIORITY = 20;
const $1894cf0a33c4a780$var$CHROME_PRIORITY = 30;
const $1894cf0a33c4a780$var$WINJS_PRIORITY = 40;
const $1894cf0a33c4a780$var$GECKO_PRIORITY = 50;
function $1894cf0a33c4a780$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === '<anonymous>' ? (0, $63abfbfec5f1197b$export$27c7e15d453fc0ac) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// This regex matches frames that have no function name (ie. are at the top level of a module).
// For example "at http://localhost:5000//script.js:1:126"
// Frames _with_ function names usually look as follows: "at commitLayoutEffects (react-dom.development.js:23426:1)"
const $1894cf0a33c4a780$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
// This regex matches all the frames that have a function name.
const $1894cf0a33c4a780$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $1894cf0a33c4a780$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $1894cf0a33c4a780$var$chromeStackParserFn = (line)=>{
    // If the stack line has no function name, we need to parse it differently
    const noFnParts = $1894cf0a33c4a780$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line, col] = noFnParts;
        return $1894cf0a33c4a780$var$createFrame(filename, (0, $63abfbfec5f1197b$export$27c7e15d453fc0ac), +line, +col);
    }
    const parts = $1894cf0a33c4a780$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $1894cf0a33c4a780$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $1894cf0a33c4a780$var$extractSafariExtensionDetails(parts[1] || (0, $63abfbfec5f1197b$export$27c7e15d453fc0ac), parts[2]);
        return $1894cf0a33c4a780$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $1894cf0a33c4a780$export$263a749fff749872 = [
    $1894cf0a33c4a780$var$CHROME_PRIORITY,
    $1894cf0a33c4a780$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $1894cf0a33c4a780$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $1894cf0a33c4a780$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $1894cf0a33c4a780$var$gecko = (line)=>{
    const parts = $1894cf0a33c4a780$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $1894cf0a33c4a780$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $63abfbfec5f1197b$export$27c7e15d453fc0ac);
        [func, filename] = $1894cf0a33c4a780$var$extractSafariExtensionDetails(func, filename);
        return $1894cf0a33c4a780$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $1894cf0a33c4a780$export$cdba47a5dd2804d = [
    $1894cf0a33c4a780$var$GECKO_PRIORITY,
    $1894cf0a33c4a780$var$gecko
];
const $1894cf0a33c4a780$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $1894cf0a33c4a780$var$winjs = (line)=>{
    const parts = $1894cf0a33c4a780$var$winjsRegex.exec(line);
    return parts ? $1894cf0a33c4a780$var$createFrame(parts[2], parts[1] || (0, $63abfbfec5f1197b$export$27c7e15d453fc0ac), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $1894cf0a33c4a780$export$179460296da408e8 = [
    $1894cf0a33c4a780$var$WINJS_PRIORITY,
    $1894cf0a33c4a780$var$winjs
];
const $1894cf0a33c4a780$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $1894cf0a33c4a780$var$opera10 = (line)=>{
    const parts = $1894cf0a33c4a780$var$opera10Regex.exec(line);
    return parts ? $1894cf0a33c4a780$var$createFrame(parts[2], parts[3] || (0, $63abfbfec5f1197b$export$27c7e15d453fc0ac), +parts[1]) : undefined;
};
const $1894cf0a33c4a780$export$f892b52c880ffc7a = [
    $1894cf0a33c4a780$var$OPERA10_PRIORITY,
    $1894cf0a33c4a780$var$opera10
];
const $1894cf0a33c4a780$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $1894cf0a33c4a780$var$opera11 = (line)=>{
    const parts = $1894cf0a33c4a780$var$opera11Regex.exec(line);
    return parts ? $1894cf0a33c4a780$var$createFrame(parts[5], parts[3] || parts[4] || (0, $63abfbfec5f1197b$export$27c7e15d453fc0ac), +parts[1], +parts[2]) : undefined;
};
const $1894cf0a33c4a780$export$af11af13f09fb0dc = [
    $1894cf0a33c4a780$var$OPERA11_PRIORITY,
    $1894cf0a33c4a780$var$opera11
];
const $1894cf0a33c4a780$export$7197c0fe6554c079 = [
    $1894cf0a33c4a780$export$263a749fff749872,
    $1894cf0a33c4a780$export$cdba47a5dd2804d
];
const $1894cf0a33c4a780$export$2b2b997d81bf3907 = (0, $63abfbfec5f1197b$export$a5739666fb2d03d4)(...$1894cf0a33c4a780$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $1894cf0a33c4a780$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : (0, $63abfbfec5f1197b$export$27c7e15d453fc0ac),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};



/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $124498f1d043daf3$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */ const $fa36438d5f25b574$var$cachedImplementations = {};
/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */ function $fa36438d5f25b574$export$e464f4a514ac28a8(name) {
    const cached = $fa36438d5f25b574$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $54d853a2c181922c$export$56d8a8a25bd48b81)[name];
    // Fast path to avoid DOM I/O
    if ((0, $a84b06d600ba3b53$export$d5f608b368e73f38)(impl)) return $fa36438d5f25b574$var$cachedImplementations[name] = impl.bind((0, $54d853a2c181922c$export$56d8a8a25bd48b81));
    const document = (0, $54d853a2c181922c$export$56d8a8a25bd48b81).document;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        // Could not create sandbox iframe, just use window.xxx
        (0, $124498f1d043daf3$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    // Sanity check: This _should_ not happen, but if it does, we just skip caching...
    // This can happen e.g. in tests where fetch may not be available in the env, or similar.
    if (!impl) return impl;
    return $fa36438d5f25b574$var$cachedImplementations[name] = impl.bind((0, $54d853a2c181922c$export$56d8a8a25bd48b81));
}
/** Clear a cached implementation. */ function $fa36438d5f25b574$export$8aa36702e8c8978(name) {
    $fa36438d5f25b574$var$cachedImplementations[name] = undefined;
}
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $fa36438d5f25b574$export$e7aa7bc5c1b3cfb3(...rest) {
    return $fa36438d5f25b574$export$e464f4a514ac28a8('fetch')(...rest);
}
/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */ function $fa36438d5f25b574$export$831dc9f2ab0a617b(...rest) {
    return $fa36438d5f25b574$export$e464f4a514ac28a8('setTimeout')(...rest);
}








/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $51554a629cfaefb2$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0] || Promise.resolve(undefined);
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $c1726396ad9dcad4$export$78e43115b553f358)(new (0, $f7c45771658ede16$export$5949942ba2a7c0e2)('Not adding Promise because buffer limit was reached.'));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $c1726396ad9dcad4$export$6f292d4960313241)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $c1726396ad9dcad4$export$1fda8aa4d135f8aa)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $90fdfde846cf6afb$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $90fdfde846cf6afb$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $90fdfde846cf6afb$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $90fdfde846cf6afb$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $90fdfde846cf6afb$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $90fdfde846cf6afb$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $90fdfde846cf6afb$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers['x-sentry-rate-limits'];
    const retryAfterHeader = headers && headers['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $90fdfde846cf6afb$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}



const $50b1391b82cd6154$export$e515cf6dfd2f98b8 = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $50b1391b82cd6154$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $51554a629cfaefb2$export$85a4f67f852183e6)(options.bufferSize || $50b1391b82cd6154$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $26698d7fedb3cc5a$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $26698d7fedb3cc5a$export$b11169581eeaf237)(type);
            if ((0, $90fdfde846cf6afb$export$6c91fec22056810a)(rateLimits, dataCategory)) {
                const event = $50b1391b82cd6154$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent('ratelimit_backoff', dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $c1726396ad9dcad4$export$1fda8aa4d135f8aa)({});
        const filteredEnvelope = (0, $26698d7fedb3cc5a$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $26698d7fedb3cc5a$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                const event = $50b1391b82cd6154$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $26698d7fedb3cc5a$export$b11169581eeaf237)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $26698d7fedb3cc5a$export$32f9b428425aac85)(filteredEnvelope)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $ce80b1f862cc5805$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $90fdfde846cf6afb$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $f7c45771658ede16$export$5949942ba2a7c0e2)) {
                (0, $ce80b1f862cc5805$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return (0, $c1726396ad9dcad4$export$1fda8aa4d135f8aa)({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}
function $50b1391b82cd6154$var$getEventForEnvelopeItem(item, type) {
    if (type !== 'event' && type !== 'transaction') return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $38f9c3ba2f709ebd$export$b2311068c46d7cc8(options, nativeFetch = (0, $fa36438d5f25b574$export$e464f4a514ac28a8)('fetch')) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        if (!nativeFetch) {
            (0, $fa36438d5f25b574$export$8aa36702e8c8978)('fetch');
            return (0, $c1726396ad9dcad4$export$78e43115b553f358)('No fetch implementation available');
        }
        try {
            // TODO: This may need a `suppressTracing` call in the future when we switch the browser SDK to OTEL
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, $fa36438d5f25b574$export$8aa36702e8c8978)('fetch');
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $c1726396ad9dcad4$export$78e43115b553f358)(e);
        }
    }
    return (0, $50b1391b82cd6154$export$d09f50d9ab7f7b69)(options, makeRequest);
}


/** Get the default integrations for the browser SDK. */ function $d4e28daa9ba947bd$export$5783b2920b1d62b9(options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ const integrations = [
        (0, $6e75dbe0bd1dbd36$export$cb3c5c2ceb9818ba)(),
        (0, $80abfbff819000c0$export$7918117e9202e4fb)(),
        (0, $7d8b85f40086340c$export$59bfe9f1c76150e)(),
        (0, $01402fe201124ce1$export$c079d904b326663a)(),
        (0, $5c1262fe8641acb3$export$66acc70e8cf2b71a)(),
        (0, $cc9ea6cd4201269f$export$ebabb00eb7f3a395)(),
        (0, $3a2f09745ac925e5$export$6d39aa44cd0c7567)(),
        (0, $5ec3105ecf7683d0$export$1378794447170364)()
    ];
    // eslint-disable-next-line deprecation/deprecation
    if (options.autoSessionTracking !== false) integrations.push((0, $5107ce4c84efe64d$export$1baa7880e357371c)());
    return integrations;
}
function $d4e28daa9ba947bd$var$applyDefaultOptions(optionsArg = {}) {
    const defaultOptions = {
        defaultIntegrations: $d4e28daa9ba947bd$export$5783b2920b1d62b9(optionsArg),
        release: typeof __SENTRY_RELEASE__ === 'string' // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (0, $2b2d0a1c21fe7bdf$export$56d8a8a25bd48b81).SENTRY_RELEASE && (0, $2b2d0a1c21fe7bdf$export$56d8a8a25bd48b81).SENTRY_RELEASE.id // This supports the variable that sentry-webpack-plugin injects
         ? (0, $2b2d0a1c21fe7bdf$export$56d8a8a25bd48b81).SENTRY_RELEASE.id : undefined,
        autoSessionTracking: true,
        sendClientReports: true
    };
    // TODO: Instead of dropping just `defaultIntegrations`, we should simply
    // call `dropUndefinedKeys` on the entire `optionsArg`.
    // However, for this to work we need to adjust the `hasTracingEnabled()` logic
    // first as it differentiates between `undefined` and the key not being in the object.
    if (optionsArg.defaultIntegrations == null) delete optionsArg.defaultIntegrations;
    return {
        ...defaultOptions,
        ...optionsArg
    };
}
function $d4e28daa9ba947bd$var$shouldShowBrowserExtensionError() {
    const windowWithMaybeExtension = typeof (0, $2b2d0a1c21fe7bdf$export$56d8a8a25bd48b81).window !== 'undefined' && (0, $2b2d0a1c21fe7bdf$export$56d8a8a25bd48b81);
    if (!windowWithMaybeExtension) // No need to show the error if we're not in a browser window environment (e.g. service workers)
    return false;
    const extensionKey = windowWithMaybeExtension.chrome ? 'chrome' : 'browser';
    const extensionObject = windowWithMaybeExtension[extensionKey];
    const runtimeId = extensionObject && extensionObject.runtime && extensionObject.runtime.id;
    const href = (0, $2b2d0a1c21fe7bdf$export$56d8a8a25bd48b81).location && (0, $2b2d0a1c21fe7bdf$export$56d8a8a25bd48b81).location.href || '';
    const extensionProtocols = [
        'chrome-extension:',
        'moz-extension:',
        'ms-browser-extension:',
        'safari-web-extension:'
    ];
    // Running the SDK in a dedicated extension page and calling Sentry.init is fine; no risk of data leakage
    const isDedicatedExtensionPage = !!runtimeId && (0, $2b2d0a1c21fe7bdf$export$56d8a8a25bd48b81) === (0, $2b2d0a1c21fe7bdf$export$56d8a8a25bd48b81).top && extensionProtocols.some((protocol)=>href.startsWith(`${protocol}//`));
    // Running the SDK in NW.js, which appears like a browser extension but isn't, is also fine
    // see: https://github.com/getsentry/sentry-javascript/issues/12668
    const isNWjs = typeof windowWithMaybeExtension.nw !== 'undefined';
    return !!runtimeId && !isDedicatedExtensionPage && !isNWjs;
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $d4e28daa9ba947bd$export$2cd8252107eb640b(browserOptions = {}) {
    const options = $d4e28daa9ba947bd$var$applyDefaultOptions(browserOptions);
    if (!options.skipBrowserExtensionCheck && $d4e28daa9ba947bd$var$shouldShowBrowserExtensionError()) {
        (0, $a717d01b4a49411c$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error('[Sentry] You cannot run Sentry this way in a browser extension, check: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/');
        });
        return;
    }
    if (0, $0e996bae691863ee$export$16a28057038b10ef) {
        if (!(0, $a84b06d600ba3b53$export$edf3cb81fd7d2a3e)()) (0, $a717d01b4a49411c$export$af88d00dbe7f521).warn('No Fetch API detected. The Sentry SDK requires a Fetch API compatible environment to send events. Please add a Fetch API polyfill.');
    }
    const clientOptions = {
        ...options,
        stackParser: (0, $63abfbfec5f1197b$export$1d5cf88b347146d4)(options.stackParser || (0, $1894cf0a33c4a780$export$2b2b997d81bf3907)),
        integrations: (0, $1cda824cf12ebac7$export$68bc4c01ab8ae766)(options),
        transport: options.transport || (0, $38f9c3ba2f709ebd$export$b2311068c46d7cc8)
    };
    return (0, $ed55b58cd6a11d78$export$5333c3f1c58d9bc1)((0, $b151be20c7fe4635$export$1df9218a526d318d), clientOptions);
}
/**
 * All properties the report dialog supports
 */ /**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */ function $d4e28daa9ba947bd$export$3a8fd680da42627b(options = {}) {
    // doesn't work without a document (React Native)
    if (!(0, $2b2d0a1c21fe7bdf$export$56d8a8a25bd48b81).document) {
        (0, $0e996bae691863ee$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).error('Global document not defined in showReportDialog call');
        return;
    }
    const scope = (0, $e9208597eafee0fc$export$c7be4b0125a10cba)();
    const client = scope.getClient();
    const dsn = client && client.getDsn();
    if (!dsn) {
        (0, $0e996bae691863ee$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).error('DSN not configured for showReportDialog call');
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) {
        const eventId = (0, $43aeef54481eeaf4$export$5d4e9fd7fac8e617)();
        if (eventId) options.eventId = eventId;
    }
    const script = (0, $2b2d0a1c21fe7bdf$export$56d8a8a25bd48b81).document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = (0, $444ac48266b5fb79$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === '__sentry_reportdialog_closed__') try {
                onClose();
            } finally{
                (0, $2b2d0a1c21fe7bdf$export$56d8a8a25bd48b81).removeEventListener('message', reportDialogClosedMessageHandler);
            }
        };
        (0, $2b2d0a1c21fe7bdf$export$56d8a8a25bd48b81).addEventListener('message', reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $2b2d0a1c21fe7bdf$export$56d8a8a25bd48b81).document.head || (0, $2b2d0a1c21fe7bdf$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $0e996bae691863ee$export$16a28057038b10ef) && (0, $a717d01b4a49411c$export$af88d00dbe7f521).error('Not injecting report dialog. No injection point found in HTML');
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $d4e28daa9ba947bd$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $d4e28daa9ba947bd$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Captures user feedback and sends it to Sentry.
 *
 * @deprecated Use `captureFeedback` instead.
 */ function $d4e28daa9ba947bd$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $e9208597eafee0fc$export$6bb76d6eba7e258c)();
    if (client) // eslint-disable-next-line deprecation/deprecation
    client.captureUserFeedback(feedback);
}




var $7RNO0 = parcelRequire("7RNO0");
/**
 * Inits the React SDK
 */ function $a470b8ba5e554575$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $3bec1e9292365c31$export$b9f95b027256052c)(opts, 'react');
    (0, $43aeef54481eeaf4$export$2f04de43fe27971a)('react', {
        version: $7RNO0.version
    });
    return (0, $d4e28daa9ba947bd$export$2cd8252107eb640b)(opts);
}



var $cTs7K = parcelRequire("cTs7K");

var $hUeP2 = parcelRequire("hUeP2");
function $ac8608e87bd41782$export$f5ae3c4820871661() {
    if (0, $cTs7K.IS_DISCORD_ACTIVITY) return;
    try {
        const release = `arise-frontend@${(0, $hUeP2.appVersion)}`;
        console.info(`Version ${(0, $hUeP2.appVersion)}`);
        $a470b8ba5e554575$export$2cd8252107eb640b({
            dsn: undefined,
            integrations: [],
            environment: "prod",
            release: release,
            sampleRate: 1
        });
        $43aeef54481eeaf4$export$a37d07ee78eb4569('instance', "skyhook");
    } catch (err) {
        console.error('Failed to initialize Sentry', err);
    }
}



var $2QyQO = parcelRequire("2QyQO");

var $i2KZ1 = parcelRequire("i2KZ1");

var $cTs7K = parcelRequire("cTs7K");

var $7RNO0 = parcelRequire("7RNO0");
function $ed5bdfbac956f546$export$2e2bcd8739ae039({ to: to }) {
    (0, $7RNO0.useEffect)(()=>{
        window.location.href = to;
    }, [
        to
    ]);
    return null;
}


// e.g. not insiders
const $be909876f501bd41$var$authRoutesDefault = [
    {
        path: 'landing',
        element: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $3aa191d86886e969$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $i2KZ1.Provider), {
                children: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $3bd2b33fe0dc423d$export$2e2bcd8739ae039), {})
            })
        })
    },
    {
        path: 'reset-password',
        element: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $3aa191d86886e969$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $i2KZ1.Provider), {
                children: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $1ac51b12d0562b16$export$2e2bcd8739ae039), {})
            })
        })
    }
];
const $be909876f501bd41$var$getAuthRoutesInsiders = ()=>{
    // Prev used <InsidersExternalRedirect />
    const authRoutes = [
        {
            path: 'insiders',
            element: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $3aa191d86886e969$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $6946d83c30ddf99a$export$2e2bcd8739ae039), {})
            })
        }
    ];
    return authRoutes;
};
const $be909876f501bd41$var$defaultRouter = (0, $0c7bbce72352c6a2$export$1f3f55432a00e06d)([
    {
        path: '/',
        element: /*#__PURE__*/ (0, $9h2J6.jsx)($be909876f501bd41$var$NavigateToWithExistingQuery, {
            to: (0, $2QyQO.homePath)
        })
    },
    {
        path: '/auth',
        children: (0, $2QyQO.isInsidersInstance) ? $be909876f501bd41$var$getAuthRoutesInsiders() : $be909876f501bd41$var$authRoutesDefault
    },
    {
        path: '/edit-profile',
        element: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $3aa191d86886e969$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $0ec7c6ee785a0a8f$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $26e69c1fbe45adbe$export$2e2bcd8739ae039), {})
            })
        })
    },
    {
        path: '/edit-display-name',
        element: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $3aa191d86886e969$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $i2KZ1.Provider), {
                children: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $86431114d96a35fc$export$2e2bcd8739ae039), {})
            })
        })
    },
    {
        path: '/oauth/exchange',
        element: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $i2KZ1.Provider), {
            children: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $e00315c49eb28b87$export$2e2bcd8739ae039), {})
        })
    },
    // {
    //     path: '/map',
    //     element: (
    //         <RootLayout>
    //             <MapLayout>
    //                 <MapBasicPage />
    //             </MapLayout>
    //         </RootLayout>
    //     ),
    // },
    // {
    //     path: '/selector',
    //     element: (
    //         <RootLayout>
    //             <SceneSelectorLayout>
    //                 <SceneSelectorPage />
    //             </SceneSelectorLayout>
    //         </RootLayout>
    //     ),
    // },
    {
        path: '/location/:locationId',
        element: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $3aa191d86886e969$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $c86c308114b2a328$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $7f7e09a0cb9ba34c$export$2e2bcd8739ae039), {})
            })
        })
    },
    {
        path: '*',
        element: /*#__PURE__*/ (0, $9h2J6.jsx)($be909876f501bd41$var$NavigateToWithExistingQuery, {
            to: "/"
        })
    }
]);
// Router for soft disabling site, e.g. outside of discord
const $be909876f501bd41$var$disabledRouter = (0, $0c7bbce72352c6a2$export$1f3f55432a00e06d)([
    {
        path: '*',
        element: /*#__PURE__*/ (0, $9h2J6.jsx)((0, $ed5bdfbac956f546$export$2e2bcd8739ae039), {
            to: "https://www.thosebeyond.io/"
        })
    }
]);
const $be909876f501bd41$var$allowWebParam = new URLSearchParams(window.location.search).has('allowWeb');
const $be909876f501bd41$var$isDisabled = !(0, $cTs7K.IS_DISCORD_ACTIVITY) && !$be909876f501bd41$var$allowWebParam;
const $be909876f501bd41$var$router = $be909876f501bd41$var$isDisabled ? $be909876f501bd41$var$disabledRouter : $be909876f501bd41$var$defaultRouter;
(0, $ac8608e87bd41782$export$f5ae3c4820871661)();
const $be909876f501bd41$var$root = document.createElement('div');
document.body.appendChild($be909876f501bd41$var$root);
$184b34fb482779c0$export$882461b6382ed46c($be909876f501bd41$var$root).render(/*#__PURE__*/ (0, $9h2J6.jsx)((0, $0c7bbce72352c6a2$export$323e4fc2fa4753fb), {
    router: $be909876f501bd41$var$router
}));
function $be909876f501bd41$var$NavigateToWithExistingQuery({ to: to }) {
    const searchParams = new URLSearchParams(window.location.search);
    const navigateTo = searchParams ? `${to}?${searchParams}` : to;
    return /*#__PURE__*/ (0, $9h2J6.jsx)((0, $0e3dfb59695be15b$export$444b3ab0cb9aec40), {
        to: navigateTo
    });
}


//# sourceMappingURL=arise-frontend.279ce3d2.js.map
